/* tslint:disable */
/* eslint-disable */
/**
 * Vox.FrontendApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError, operationServerMap } from './base';

/**
 * 
 * @export
 * @interface AcceptOrderRequest
 */
export interface AcceptOrderRequest {
    /**
     * Идентификатор исполнителя
     * @type {string}
     * @memberof AcceptOrderRequest
     */
    'executorId'?: string;
    /**
     * Идентификатор заказа
     * @type {string}
     * @memberof AcceptOrderRequest
     */
    'orderId'?: string;
    /**
     * Идентификатор адреса
     * @type {string}
     * @memberof AcceptOrderRequest
     */
    'addressId'?: string | null;
}
/**
 * 
 * @export
 * @interface AcceptOrderResponse
 */
export interface AcceptOrderResponse {
    /**
     * Сообщение исполнителю
     * @type {string}
     * @memberof AcceptOrderResponse
     */
    'message'?: string | null;
    /**
     * Заголовок
     * @type {string}
     * @memberof AcceptOrderResponse
     */
    'title'?: string | null;
    /**
     * Ссылка на web-страницу для подписания договора Исполнителем
     * @type {string}
     * @memberof AcceptOrderResponse
     */
    'agreementSigningUri'?: string | null;
}
/**
 * Внутренний пользователь раздела управления доступом
 * @export
 * @interface AccessAppUserResponse
 */
export interface AccessAppUserResponse {
    /**
     * Идентификатор внутреннего пользователя
     * @type {string}
     * @memberof AccessAppUserResponse
     */
    'id'?: string;
    /**
     * Логин внутреннего пользователя
     * @type {string}
     * @memberof AccessAppUserResponse
     */
    'login'?: string | null;
    /**
     * 
     * @type {ApiUserRoleSimpleModel}
     * @memberof AccessAppUserResponse
     */
    'role'?: ApiUserRoleSimpleModel;
    /**
     * Признак блокировки пользователя
     * @type {boolean}
     * @memberof AccessAppUserResponse
     */
    'isBlocked'?: boolean;
    /**
     * Системная учётная запись
     * @type {boolean}
     * @memberof AccessAppUserResponse
     */
    'isSystem'?: boolean;
    /**
     * Признак доступности пользователя для управления
     * @type {boolean}
     * @memberof AccessAppUserResponse
     */
    'isManageable'?: boolean;
    /**
     * Дата создания пользователя
     * @type {string}
     * @memberof AccessAppUserResponse
     */
    'created'?: string;
}
/**
 * Настраиваемая внутренняя роль
 * @export
 * @interface AccessRoleResponse
 */
export interface AccessRoleResponse {
    /**
     * 
     * @type {ApiUserRoleSimpleModel}
     * @memberof AccessRoleResponse
     */
    'role'?: ApiUserRoleSimpleModel;
}
/**
 * 
 * @export
 * @interface AccrueBonusPointsRequest
 */
export interface AccrueBonusPointsRequest {
    /**
     * Идентификатор клиента
     * @type {string}
     * @memberof AccrueBonusPointsRequest
     */
    'clientId'?: string;
    /**
     * Идентификатор бизнес-операции для защиты от повторной обработки
     * @type {string}
     * @memberof AccrueBonusPointsRequest
     */
    'operationId'?: string;
    /**
     * Количество баллов
     * @type {number}
     * @memberof AccrueBonusPointsRequest
     */
    'amount'?: number;
    /**
     * Описание операции
     * @type {string}
     * @memberof AccrueBonusPointsRequest
     */
    'description'?: string | null;
}
/**
 * Активный заказ пользователя
 * @export
 * @interface ActiveOrderResponse
 */
export interface ActiveOrderResponse {
    /**
     * Тип заказа
     * @type {string}
     * @memberof ActiveOrderResponse
     */
    'orderType'?: string | null;
    /**
     * Статус заказа
     * @type {string}
     * @memberof ActiveOrderResponse
     */
    'status'?: string | null;
    /**
     * Идентификатор клиента
     * @type {string}
     * @memberof ActiveOrderResponse
     */
    'clientId'?: string | null;
    /**
     * Идентификатор исполнителя
     * @type {string}
     * @memberof ActiveOrderResponse
     */
    'executorId'?: string | null;
    /**
     * Имя исполнителя
     * @type {string}
     * @memberof ActiveOrderResponse
     */
    'executorName'?: string | null;
    /**
     * Номер телефона исполнителя
     * @type {string}
     * @memberof ActiveOrderResponse
     */
    'executorPhone'?: string | null;
    /**
     * Имя клиента
     * @type {string}
     * @memberof ActiveOrderResponse
     */
    'clientName'?: string | null;
    /**
     * Номер телефона клиента
     * @type {string}
     * @memberof ActiveOrderResponse
     */
    'clientPhone'?: string | null;
    /**
     * Дата заказа
     * @type {string}
     * @memberof ActiveOrderResponse
     */
    'orderDate'?: string;
    /**
     * Номер заказа
     * @type {string}
     * @memberof ActiveOrderResponse
     */
    'orderNumber': string | null;
    /**
     * Идентификатор заказа
     * @type {string}
     * @memberof ActiveOrderResponse
     */
    'orderId'?: string;
}
/**
 * 
 * @export
 * @interface AddOrRemoveOrderProductRequest
 */
export interface AddOrRemoveOrderProductRequest {
    /**
     * Идентификатор продукта
     * @type {string}
     * @memberof AddOrRemoveOrderProductRequest
     */
    'productId'?: string;
    /**
     * Базовый продукт?
     * @type {boolean}
     * @memberof AddOrRemoveOrderProductRequest
     */
    'isBase'?: boolean;
    /**
     * Абонементный продукт?
     * @type {boolean}
     * @memberof AddOrRemoveOrderProductRequest
     */
    'isSubscriptionProduct'?: boolean;
    /**
     * Идентификатор абонемента-клиента
     * @type {string}
     * @memberof AddOrRemoveOrderProductRequest
     */
    'clientSubscriptionId'?: string | null;
    /**
     * Идентификатор абонемента
     * @type {string}
     * @memberof AddOrRemoveOrderProductRequest
     */
    'subscriptionId'?: string | null;
    /**
     * 
     * @type {ApiProductType}
     * @memberof AddOrRemoveOrderProductRequest
     */
    'productType'?: ApiProductType;
    /**
     * 
     * @type {ApiProductSubType}
     * @memberof AddOrRemoveOrderProductRequest
     */
    'productSubType'?: ApiProductSubType;
    /**
     * Идентификатор заказа
     * @type {string}
     * @memberof AddOrRemoveOrderProductRequest
     */
    'orderId'?: string;
    /**
     * Если выбрали дополнительный продукт.
     * @type {boolean}
     * @memberof AddOrRemoveOrderProductRequest
     */
    'isSelected'?: boolean;
}


/**
 * Модель запроса для прикрепления питомца,  выбранного среди уже существующих у клиента
 * @export
 * @interface AddOrRemovePetRequest
 */
export interface AddOrRemovePetRequest {
    /**
     * Если выбрал питомца
     * @type {boolean}
     * @memberof AddOrRemovePetRequest
     */
    'isSelected'?: boolean;
    /**
     * Идентификатор заказа
     * @type {string}
     * @memberof AddOrRemovePetRequest
     */
    'orderId'?: string;
    /**
     * Идентификатор питомца
     * @type {string}
     * @memberof AddOrRemovePetRequest
     */
    'petId'?: string;
}
/**
 * 
 * @export
 * @interface AdditionalProductsForOrderResponse
 */
export interface AdditionalProductsForOrderResponse {
    /**
     * 
     * @type {Array<ProductForOrderResponse>}
     * @memberof AdditionalProductsForOrderResponse
     */
    'additionalOfferedProducts'?: Array<ProductForOrderResponse> | null;
}
/**
 * Результат проверки координат
 * @export
 * @interface AddressPointCorrectionResponse
 */
export interface AddressPointCorrectionResponse {
    /**
     * Идентификатор проверки
     * @type {string}
     * @memberof AddressPointCorrectionResponse
     */
    'id'?: string;
    /**
     * Предыдущая широта
     * @type {number}
     * @memberof AddressPointCorrectionResponse
     */
    'previousLatitude'?: number | null;
    /**
     * Предыдущая долгота
     * @type {number}
     * @memberof AddressPointCorrectionResponse
     */
    'previousLongitude'?: number | null;
    /**
     * Проверенная широта
     * @type {number}
     * @memberof AddressPointCorrectionResponse
     */
    'latitude'?: number;
    /**
     * Проверенная долгота
     * @type {number}
     * @memberof AddressPointCorrectionResponse
     */
    'longitude'?: number;
    /**
     * Дата проверки
     * @type {string}
     * @memberof AddressPointCorrectionResponse
     */
    'verifiedAt'?: string;
    /**
     * Идентификатор сотрудника
     * @type {string}
     * @memberof AddressPointCorrectionResponse
     */
    'operatorId'?: string | null;
}
/**
 * Базовая модель запроса связаная с адресом
 * @export
 * @interface AddressRequest
 */
export interface AddressRequest {
    /**
     * Идентификатор города
     * @type {number}
     * @memberof AddressRequest
     */
    'cityId'?: number | null;
    /**
     * Улица
     * @type {string}
     * @memberof AddressRequest
     */
    'street'?: string | null;
    /**
     * Номер дома
     * @type {string}
     * @memberof AddressRequest
     */
    'houseNumber'?: string | null;
    /**
     * Подъезд дома
     * @type {string}
     * @memberof AddressRequest
     */
    'entranceToHouse'?: string | null;
    /**
     * Домофон
     * @type {string}
     * @memberof AddressRequest
     */
    'domophone'?: string | null;
    /**
     * Этаж
     * @type {string}
     * @memberof AddressRequest
     */
    'floor'?: string | null;
    /**
     * Номер квартиры/апартаментов
     * @type {string}
     * @memberof AddressRequest
     */
    'apartmentNumber'?: string | null;
    /**
     * Дополнительный комментарий
     * @type {string}
     * @memberof AddressRequest
     */
    'additionalComments'?: string | null;
}
/**
 * Информация об Адресе
 * @export
 * @interface AddressResponse
 */
export interface AddressResponse {
    /**
     * Идентификатор
     * @type {string}
     * @memberof AddressResponse
     */
    'id'?: string;
    /**
     * Идентификатор город
     * @type {number}
     * @memberof AddressResponse
     */
    'cityId'?: number | null;
    /**
     * Название города
     * @type {string}
     * @memberof AddressResponse
     */
    'cityName'?: string | null;
    /**
     * Краткое название населённого пункта
     * @type {string}
     * @memberof AddressResponse
     */
    'cityShortName'?: string | null;
    /**
     * Идентификатор района города
     * @type {number}
     * @memberof AddressResponse
     */
    'cityDistrictId'?: number | null;
    /**
     * Название района города
     * @type {string}
     * @memberof AddressResponse
     */
    'cityDistrictName'?: string | null;
    /**
     * Название региона
     * @type {string}
     * @memberof AddressResponse
     */
    'regionName'?: string | null;
    /**
     * Улица
     * @type {string}
     * @memberof AddressResponse
     */
    'street'?: string | null;
    /**
     * Номер дома
     * @type {string}
     * @memberof AddressResponse
     */
    'houseNumber'?: string | null;
    /**
     * Подъезд
     * @type {string}
     * @memberof AddressResponse
     */
    'entranceToHouse'?: string | null;
    /**
     * Домофон
     * @type {string}
     * @memberof AddressResponse
     */
    'domophone'?: string | null;
    /**
     * Этаж
     * @type {string}
     * @memberof AddressResponse
     */
    'floor'?: string | null;
    /**
     * Номер квартиры
     * @type {string}
     * @memberof AddressResponse
     */
    'apartmentNumber'?: string | null;
    /**
     * Дополнительные комментарии
     * @type {string}
     * @memberof AddressResponse
     */
    'additionalComments'?: string | null;
    /**
     * Широта
     * @type {number}
     * @memberof AddressResponse
     */
    'latitude'?: number | null;
    /**
     * Долгота
     * @type {number}
     * @memberof AddressResponse
     */
    'longitude'?: number | null;
}
/**
 * Возможности текущего сотрудника в административном интерфейсе
 * @export
 * @interface AdminAccessResponse
 */
export interface AdminAccessResponse {
    /**
     * Идентификатор сотрудника текущего запроса
     * @type {string}
     * @memberof AdminAccessResponse
     */
    'appUserId'?: string | null;
    /**
     * Является ли пользователь действующим сотрудником
     * @type {boolean}
     * @memberof AdminAccessResponse
     */
    'isStaff'?: boolean;
    /**
     * Системный полный доступ
     * @type {boolean}
     * @memberof AdminAccessResponse
     */
    'hasFullAccess'?: boolean;
    /**
     * Решения по административным правам
     * @type {Array<AdminPermissionStateResponse>}
     * @memberof AdminAccessResponse
     */
    'permissions'?: Array<AdminPermissionStateResponse> | null;
}
/**
 * Итоговый доступ к действию или просмотру административного интерфейса
 * @export
 * @interface AdminPermissionStateResponse
 */
export interface AdminPermissionStateResponse {
    /**
     * Идентификатор права в базе данных
     * @type {string}
     * @memberof AdminPermissionStateResponse
     */
    'permissionId'?: string | null;
    /**
     * Стабильный код права
     * @type {string}
     * @memberof AdminPermissionStateResponse
     */
    'code'?: string | null;
    /**
     * Разрешено ли действие или просмотр
     * @type {boolean}
     * @memberof AdminPermissionStateResponse
     */
    'isAllowed'?: boolean;
    /**
     * Получен ли просмотр как зависимость разрешённого действия
     * @type {boolean}
     * @memberof AdminPermissionStateResponse
     */
    'isImplied'?: boolean;
    /**
     * Код права, которое блокирует действие
     * @type {string}
     * @memberof AdminPermissionStateResponse
     */
    'blockingPermissionCode'?: string | null;
    /**
     * Защищаемые маршруты интерфейса
     * @type {Array<string>}
     * @memberof AdminPermissionStateResponse
     */
    'uiRoutes'?: Array<string> | null;
}
/**
 * Тип AES-256 ключа
 * @export
 * @enum {string}
 */

export const AesKeyType = {
    Card: 'card',
    Phone: 'phone',
    Telegram: 'telegram',
    Email: 'email'
} as const;

export type AesKeyType = typeof AesKeyType[keyof typeof AesKeyType];


/**
 * 
 * @export
 * @interface AmmunitionResponse
 */
export interface AmmunitionResponse {
    /**
     * 
     * @type {string}
     * @memberof AmmunitionResponse
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof AmmunitionResponse
     */
    'title'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AmmunitionResponse
     */
    'subTitle'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AmmunitionResponse
     */
    'textContent'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AmmunitionResponse
     */
    'imageUrl'?: string | null;
}
/**
 * Целевая аудитория читателей поста блога
 * @export
 * @enum {string}
 */

export const ApiBlogPostAudience = {
    Undefined: 'undefined',
    Client: 'client',
    Executor: 'executor',
    All: 'all'
} as const;

export type ApiBlogPostAudience = typeof ApiBlogPostAudience[keyof typeof ApiBlogPostAudience];


/**
 * Простейшая модель
 * @export
 * @interface ApiBlogPostAudienceSimpleModel
 */
export interface ApiBlogPostAudienceSimpleModel {
    /**
     * 
     * @type {ApiBlogPostAudience}
     * @memberof ApiBlogPostAudienceSimpleModel
     */
    'id'?: ApiBlogPostAudience;
    /**
     * Наименование
     * @type {string}
     * @memberof ApiBlogPostAudienceSimpleModel
     */
    'name'?: string | null;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const ApiBonusAccountState = {
    Active: 'active',
    Blocked: 'blocked'
} as const;

export type ApiBonusAccountState = typeof ApiBonusAccountState[keyof typeof ApiBonusAccountState];


/**
 * Простейшая модель
 * @export
 * @interface ApiBonusAccountStateSimpleModel
 */
export interface ApiBonusAccountStateSimpleModel {
    /**
     * 
     * @type {ApiBonusAccountState}
     * @memberof ApiBonusAccountStateSimpleModel
     */
    'id'?: ApiBonusAccountState;
    /**
     * Наименование
     * @type {string}
     * @memberof ApiBonusAccountStateSimpleModel
     */
    'name'?: string | null;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const ApiBonusTransactionType = {
    Accrual: 'accrual',
    Spending: 'spending',
    Expiration: 'expiration',
    Hold: 'hold',
    HoldRelease: 'holdRelease',
    Refund: 'refund',
    CashbackReversal: 'cashbackReversal'
} as const;

export type ApiBonusTransactionType = typeof ApiBonusTransactionType[keyof typeof ApiBonusTransactionType];


/**
 * Простейшая модель
 * @export
 * @interface ApiBonusTransactionTypeSimpleModel
 */
export interface ApiBonusTransactionTypeSimpleModel {
    /**
     * 
     * @type {ApiBonusTransactionType}
     * @memberof ApiBonusTransactionTypeSimpleModel
     */
    'id'?: ApiBonusTransactionType;
    /**
     * Наименование
     * @type {string}
     * @memberof ApiBonusTransactionTypeSimpleModel
     */
    'name'?: string | null;
}


/**
 * Простейшая модель
 * @export
 * @interface ApiCanceledBySimpleModel
 */
export interface ApiCanceledBySimpleModel {
    /**
     * 
     * @type {number}
     * @memberof ApiCanceledBySimpleModel
     */
    'id'?: number;
    /**
     * Наименование
     * @type {string}
     * @memberof ApiCanceledBySimpleModel
     */
    'name'?: string | null;
}
/**
 * Причина отмены заказа в аналитике
 * @export
 * @enum {string}
 */

export const ApiCancellationReason = {
    Undefined: 'undefined',
    ChangedMyMind: 'changedMyMind',
    TooLongWait: 'tooLongWait',
    ExecutorStandsStill: 'executorStandsStill',
    ExecutorDidNotGetInContact: 'executorDidNotGetInContact',
    ExecutorAskedToCancel: 'executorAskedToCancel',
    Custom: 'custom',
    AutoCancelNoExecutor: 'autoCancelNoExecutor',
    AutoCancelNotCompleted: 'autoCancelNotCompleted',
    ClientCancelNoExecutor: 'clientCancelNoExecutor'
} as const;

export type ApiCancellationReason = typeof ApiCancellationReason[keyof typeof ApiCancellationReason];


/**
 * Тип занятости исполнителя
 * @export
 * @enum {string}
 */

export const ApiCardType = {
    Undefined: 'undefined',
    Big: 'big',
    Small: 'small'
} as const;

export type ApiCardType = typeof ApiCardType[keyof typeof ApiCardType];


/**
 * Простейшая модель
 * @export
 * @interface ApiCardTypeSimpleModel
 */
export interface ApiCardTypeSimpleModel {
    /**
     * 
     * @type {ApiCardType}
     * @memberof ApiCardTypeSimpleModel
     */
    'id'?: ApiCardType;
    /**
     * Наименование
     * @type {string}
     * @memberof ApiCardTypeSimpleModel
     */
    'name'?: string | null;
}


/**
 * Вид вложения
 * @export
 * @enum {string}
 */

export const ApiChatAttachmentKind = {
    Unknown: 'unknown',
    Image: 'image',
    Video: 'video',
    Audio: 'audio',
    File: 'file'
} as const;

export type ApiChatAttachmentKind = typeof ApiChatAttachmentKind[keyof typeof ApiChatAttachmentKind];


/**
 * Простейшая модель
 * @export
 * @interface ApiChatAttachmentKindSimpleModel
 */
export interface ApiChatAttachmentKindSimpleModel {
    /**
     * 
     * @type {ApiChatAttachmentKind}
     * @memberof ApiChatAttachmentKindSimpleModel
     */
    'id'?: ApiChatAttachmentKind;
    /**
     * Наименование
     * @type {string}
     * @memberof ApiChatAttachmentKindSimpleModel
     */
    'name'?: string | null;
}


/**
 * Канал переписки
 * @export
 * @enum {string}
 */

export const ApiChatChannelType = {
    Vox: 'vox',
    Telegram: 'telegram',
    Vk: 'vk',
    Avito: 'avito',
    Max: 'max'
} as const;

export type ApiChatChannelType = typeof ApiChatChannelType[keyof typeof ApiChatChannelType];


/**
 * Простейшая модель
 * @export
 * @interface ApiChatChannelTypeSimpleModel
 */
export interface ApiChatChannelTypeSimpleModel {
    /**
     * 
     * @type {ApiChatChannelType}
     * @memberof ApiChatChannelTypeSimpleModel
     */
    'id'?: ApiChatChannelType;
    /**
     * Наименование
     * @type {string}
     * @memberof ApiChatChannelTypeSimpleModel
     */
    'name'?: string | null;
}


/**
 * Вид сообщения
 * @export
 * @enum {string}
 */

export const ApiChatMessageKind = {
    Regular: 'regular',
    System: 'system'
} as const;

export type ApiChatMessageKind = typeof ApiChatMessageKind[keyof typeof ApiChatMessageKind];


/**
 * Простейшая модель
 * @export
 * @interface ApiChatMessageKindSimpleModel
 */
export interface ApiChatMessageKindSimpleModel {
    /**
     * 
     * @type {ApiChatMessageKind}
     * @memberof ApiChatMessageKindSimpleModel
     */
    'id'?: ApiChatMessageKind;
    /**
     * Наименование
     * @type {string}
     * @memberof ApiChatMessageKindSimpleModel
     */
    'name'?: string | null;
}


/**
 * Состояние отправки сообщения
 * @export
 * @enum {string}
 */

export const ApiChatMessageSendStatus = {
    Received: 'received',
    Pending: 'pending',
    Accepted: 'accepted',
    Failed: 'failed',
    Unknown: 'unknown'
} as const;

export type ApiChatMessageSendStatus = typeof ApiChatMessageSendStatus[keyof typeof ApiChatMessageSendStatus];


/**
 * Простейшая модель
 * @export
 * @interface ApiChatMessageSendStatusSimpleModel
 */
export interface ApiChatMessageSendStatusSimpleModel {
    /**
     * 
     * @type {ApiChatMessageSendStatus}
     * @memberof ApiChatMessageSendStatusSimpleModel
     */
    'id'?: ApiChatMessageSendStatus;
    /**
     * Наименование
     * @type {string}
     * @memberof ApiChatMessageSendStatusSimpleModel
     */
    'name'?: string | null;
}


/**
 * Этап переноса переписки
 * @export
 * @enum {string}
 */

export const ApiChatMigrationPhase = {
    Users: 'users',
    Dialogs: 'dialogs',
    Orphans: 'orphans',
    Finished: 'finished'
} as const;

export type ApiChatMigrationPhase = typeof ApiChatMigrationPhase[keyof typeof ApiChatMigrationPhase];


/**
 * Простейшая модель
 * @export
 * @interface ApiChatMigrationPhaseSimpleModel
 */
export interface ApiChatMigrationPhaseSimpleModel {
    /**
     * 
     * @type {ApiChatMigrationPhase}
     * @memberof ApiChatMigrationPhaseSimpleModel
     */
    'id'?: ApiChatMigrationPhase;
    /**
     * Наименование
     * @type {string}
     * @memberof ApiChatMigrationPhaseSimpleModel
     */
    'name'?: string | null;
}


/**
 * Состояние переноса переписки
 * @export
 * @enum {string}
 */

export const ApiChatMigrationStatus = {
    Pending: 'pending',
    Running: 'running',
    Paused: 'paused',
    Completed: 'completed',
    NeedsReview: 'needsReview',
    Cancelled: 'cancelled'
} as const;

export type ApiChatMigrationStatus = typeof ApiChatMigrationStatus[keyof typeof ApiChatMigrationStatus];


/**
 * Простейшая модель
 * @export
 * @interface ApiChatMigrationStatusSimpleModel
 */
export interface ApiChatMigrationStatusSimpleModel {
    /**
     * 
     * @type {ApiChatMigrationStatus}
     * @memberof ApiChatMigrationStatusSimpleModel
     */
    'id'?: ApiChatMigrationStatus;
    /**
     * Наименование
     * @type {string}
     * @memberof ApiChatMigrationStatusSimpleModel
     */
    'name'?: string | null;
}


/**
 * Состояние прочтения сообщения
 * @export
 * @enum {string}
 */

export const ApiChatReadState = {
    Unknown: 'unknown',
    Unread: 'unread',
    Read: 'read'
} as const;

export type ApiChatReadState = typeof ApiChatReadState[keyof typeof ApiChatReadState];


/**
 * Простейшая модель
 * @export
 * @interface ApiChatReadStateSimpleModel
 */
export interface ApiChatReadStateSimpleModel {
    /**
     * 
     * @type {ApiChatReadState}
     * @memberof ApiChatReadStateSimpleModel
     */
    'id'?: ApiChatReadState;
    /**
     * Наименование
     * @type {string}
     * @memberof ApiChatReadStateSimpleModel
     */
    'name'?: string | null;
}


/**
 * Действие при ответе на диалог
 * @export
 * @enum {string}
 */

export const ApiDialogActionType = {
    Undefined: 'undefined',
    Acknowledge: 'acknowledge',
    RecordAnswer: 'recordAnswer',
    OrderSearch: 'orderSearch',
    FavoriteOrderSearch: 'favoriteOrderSearch',
    CollectFeedback: 'collectFeedback'
} as const;

export type ApiDialogActionType = typeof ApiDialogActionType[keyof typeof ApiDialogActionType];


/**
 * Приложения получателей диалогового окна
 * @export
 * @enum {string}
 */

export const ApiDialogAudienceType = {
    Undefined: 'undefined',
    Clients: 'clients',
    Executors: 'executors',
    All: 'all'
} as const;

export type ApiDialogAudienceType = typeof ApiDialogAudienceType[keyof typeof ApiDialogAudienceType];


/**
 * Тип варианта ответа в диалоге
 * @export
 * @enum {string}
 */

export const ApiDialogOptionType = {
    Undefined: 'undefined',
    Continue: 'continue',
    Yes: 'yes',
    No: 'no',
    Cancel: 'cancel',
    Skip: 'skip'
} as const;

export type ApiDialogOptionType = typeof ApiDialogOptionType[keyof typeof ApiDialogOptionType];


/**
 * Статус диалога
 * @export
 * @enum {string}
 */

export const ApiDialogStatus = {
    Undefined: 'undefined',
    Pending: 'pending',
    Answered: 'answered',
    Expired: 'expired',
    Cancelled: 'cancelled',
    Read: 'read'
} as const;

export type ApiDialogStatus = typeof ApiDialogStatus[keyof typeof ApiDialogStatus];


/**
 * Тип скидки платежа в API
 * @export
 * @enum {string}
 */

export const ApiDiscountType = {
    Undefined: 'undefined',
    DiscountFromSubscription: 'discountFromSubscription',
    FullDiscountFromSubscription: 'fullDiscountFromSubscription',
    Promocode: 'promocode',
    Bonuses: 'bonuses',
    AdditionalPet: 'additionalPet',
    BulkBoarding: 'bulkBoarding'
} as const;

export type ApiDiscountType = typeof ApiDiscountType[keyof typeof ApiDiscountType];


/**
 * Простейшая модель
 * @export
 * @interface ApiDiscountTypeSimpleModel
 */
export interface ApiDiscountTypeSimpleModel {
    /**
     * 
     * @type {ApiDiscountType}
     * @memberof ApiDiscountTypeSimpleModel
     */
    'id'?: ApiDiscountType;
    /**
     * Наименование
     * @type {string}
     * @memberof ApiDiscountTypeSimpleModel
     */
    'name'?: string | null;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const ApiEmploymentKind = {
    Unknown: 'unknown',
    Selfemployed: 'selfemployed',
    CivilContract: 'civilContract',
    Entrepreneur: 'entrepreneur',
    Confidant: 'confidant',
    Self: 'self'
} as const;

export type ApiEmploymentKind = typeof ApiEmploymentKind[keyof typeof ApiEmploymentKind];


/**
 * Простейшая модель
 * @export
 * @interface ApiEmploymentKindSimpleModel
 */
export interface ApiEmploymentKindSimpleModel {
    /**
     * 
     * @type {ApiEmploymentKind}
     * @memberof ApiEmploymentKindSimpleModel
     */
    'id'?: ApiEmploymentKind;
    /**
     * Наименование
     * @type {string}
     * @memberof ApiEmploymentKindSimpleModel
     */
    'name'?: string | null;
}


/**
 * Тип сущности системы
 * @export
 * @enum {string}
 */

export const ApiEntityType = {
    Undefined: 'undefined',
    Order: 'order',
    Review: 'review',
    Chat: 'chat',
    Client: 'client',
    Executor: 'executor',
    Pet: 'pet',
    Dialog: 'dialog',
    Answer: 'answer',
    Product: 'product',
    Policy: 'policy',
    PriceList: 'priceList',
    ClientAddress: 'clientAddress',
    ClientSubscription: 'clientSubscription',
    ExecutorAddress: 'executorAddress',
    PromoCode: 'promoCode',
    Subscription: 'subscription',
    PayoutMethod: 'payoutMethod',
    City: 'city',
    Citizenship: 'citizenship',
    Payment: 'payment',
    Lesson: 'lesson',
    Question: 'question',
    Location: 'location',
    Track: 'track',
    TrackLocation: 'trackLocation',
    Notification: 'notification',
    OrderDetails: 'orderDetails',
    OrderPet: 'orderPet',
    OrderProduct: 'orderProduct',
    OrderReport: 'orderReport',
    OrderSchedulePeriod: 'orderSchedulePeriod',
    OrderTask: 'orderTask',
    NotificationTemplate: 'notificationTemplate',
    TotalResult: 'totalResult',
    Test: 'test',
    ExecutorTestProgress: 'executorTestProgress',
    ExecutorLessonProgress: 'executorLessonProgress',
    ExecutorAccessTest: 'executorAccessTest',
    AppUser: 'appUser',
    Ammunition: 'ammunition',
    AddressPoints: 'addressPoints',
    Address: 'address',
    PaymentPosition: 'paymentPosition',
    PaymentPositionDiscount: 'paymentPositionDiscount',
    AppUserTelegramLink: 'appUserTelegramLink',
    AuditEntry: 'auditEntry',
    AuthCode: 'authCode',
    Avatar: 'avatar',
    BlogPost: 'blogPost',
    Breed: 'breed',
    Content: 'content',
    Event: 'event',
    Experience: 'experience',
    Feedback: 'feedback',
    Habit: 'habit',
    LessonTask: 'lessonTask',
    PetHabit: 'petHabit',
    PromoCodeUsages: 'promoCodeUsages',
    RefreshToken: 'refreshToken',
    Street: 'street',
    Tag: 'tag',
    VoxService: 'voxService',
    VoxSettings: 'voxSettings',
    CashbackLevel: 'cashbackLevel',
    BonusAccount: 'bonusAccount',
    BonusTransaction: 'bonusTransaction',
    BonusAccrualBlock: 'bonusAccrualBlock',
    BonusTransactionAllocation: 'bonusTransactionAllocation',
    AppVersion: 'appVersion',
    BonusAccrualPositionAction: 'bonusAccrualPositionAction',
    Permission: 'permission',
    RolePermission: 'rolePermission',
    AppUserPermissionOverride: 'appUserPermissionOverride'
} as const;

export type ApiEntityType = typeof ApiEntityType[keyof typeof ApiEntityType];


/**
 * Простейшая модель
 * @export
 * @interface ApiEntityTypeSimpleModel
 */
export interface ApiEntityTypeSimpleModel {
    /**
     * 
     * @type {ApiEntityType}
     * @memberof ApiEntityTypeSimpleModel
     */
    'id'?: ApiEntityType;
    /**
     * Наименование
     * @type {string}
     * @memberof ApiEntityTypeSimpleModel
     */
    'name'?: string | null;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const ApiEventType = {
    Undefined: 'undefined',
    SubscriptionApplied: 'subscriptionApplied',
    SubscriptionActivated: 'subscriptionActivated',
    PromoCodeApplied: 'promoCodeApplied',
    OrderPaid: 'orderPaid',
    OrderCompleted: 'orderCompleted',
    OrderBecameSearchable: 'orderBecameSearchable',
    ExecutorAssigned: 'executorAssigned',
    OrderCancelled: 'orderCancelled',
    ExecutorAccepted: 'executorAccepted',
    ExecutorAssignedByAdmin: 'executorAssignedByAdmin',
    TaskCancelled: 'taskCancelled',
    ExecutorCreatedByAdmin: 'executorCreatedByAdmin',
    ClientCreatedByAdmin: 'clientCreatedByAdmin',
    PetCreatedByAdmin: 'petCreatedByAdmin',
    SubscriptionIssued: 'subscriptionIssued',
    OrderCreatedByAdmin: 'orderCreatedByAdmin',
    PaymentCreated: 'paymentCreated',
    ClientDeactivated: 'clientDeactivated',
    ExecutorDeactivated: 'executorDeactivated',
    ProductDeactivated: 'productDeactivated',
    PriceListDeactivated: 'priceListDeactivated',
    SubscriptionDeactivated: 'subscriptionDeactivated',
    PolicyDeactivated: 'policyDeactivated',
    BlogDeactivated: 'blogDeactivated',
    ClientAddressDeactivated: 'clientAddressDeactivated',
    ExecutorAddressDeactivated: 'executorAddressDeactivated',
    PetDeactivated: 'petDeactivated',
    PromoCodeCreated: 'promoCodeCreated',
    PromoCodeReady: 'promoCodeReady',
    PromoCodeActivated: 'promoCodeActivated',
    PromoCodeExhausted: 'promoCodeExhausted',
    PromoCodeBlocked: 'promoCodeBlocked',
    ReviewDeleted: 'reviewDeleted',
    OrderStarted: 'orderStarted',
    PaymentSentToExecutor: 'paymentSentToExecutor',
    ExecutorCreated: 'executorCreated',
    ExecutorRejectedOrder: 'executorRejectedOrder',
    ExecutorApprovedByClient: 'executorApprovedByClient',
    ExecutorApprovedByAdmin: 'executorApprovedByAdmin',
    PaymentManuallyConfirmed: 'paymentManuallyConfirmed',
    ReviewCreated: 'reviewCreated',
    ExecutorVerified: 'executorVerified',
    PromoCodeExpired: 'promoCodeExpired',
    ClientSubscriptionExpired: 'clientSubscriptionExpired',
    ClientSubscriptionExhausted: 'clientSubscriptionExhausted',
    ClientBlocked: 'clientBlocked',
    ClientUnblocked: 'clientUnblocked',
    ExecutorBlocked: 'executorBlocked',
    ExecutorUnblocked: 'executorUnblocked',
    AcceptanceActSigned: 'acceptanceActSigned',
    ExecutorSignedOrderTask: 'executorSignedOrderTask',
    OrderTaskExpired: 'orderTaskExpired',
    ExecutorSignedAcceptanceAct: 'executorSignedAcceptanceAct',
    ClientRefusedExecutor: 'clientRefusedExecutor',
    SubscriptionUsageReturned: 'subscriptionUsageReturned',
    BonusPointsAccruedByAdmin: 'bonusPointsAccruedByAdmin',
    BonusPointsSpentByAdmin: 'bonusPointsSpentByAdmin',
    BonusAccountBlockedByAdmin: 'bonusAccountBlockedByAdmin',
    BonusAccountUnblockedByAdmin: 'bonusAccountUnblockedByAdmin',
    CashbackLevelChangedAutomatically: 'cashbackLevelChangedAutomatically',
    CashbackAccruedForOrder: 'cashbackAccruedForOrder',
    BonusPointsHeldForOrder: 'bonusPointsHeldForOrder',
    BonusPointsHoldReleased: 'bonusPointsHoldReleased',
    BonusPointsSpentForOrder: 'bonusPointsSpentForOrder',
    BonusPointsRefundedForOrder: 'bonusPointsRefundedForOrder',
    CashbackReversedForOrder: 'cashbackReversedForOrder',
    OrderCompletedByAdmin: 'orderCompletedByAdmin',
    ExecutorRemovedByAdmin: 'executorRemovedByAdmin',
    ClientPhoneChanged: 'clientPhoneChanged',
    ExecutorPhoneChanged: 'executorPhoneChanged',
    OrderStartedByAdmin: 'orderStartedByAdmin',
    ExecutorPenaltyAssignedByAdmin: 'executorPenaltyAssignedByAdmin',
    ExecutorPenaltyRemovedByAdmin: 'executorPenaltyRemovedByAdmin',
    PromoCodePrintingCreated: 'promoCodePrintingCreated',
    PromoCodePrintingIssued: 'promoCodePrintingIssued',
    PromoCodePrintingActivated: 'promoCodePrintingActivated',
    PromoCodePrintingBlocked: 'promoCodePrintingBlocked',
    PromoCodePrintingNewBlocked: 'promoCodePrintingNewBlocked'
} as const;

export type ApiEventType = typeof ApiEventType[keyof typeof ApiEventType];


/**
 * Простейшая модель
 * @export
 * @interface ApiEventTypeSimpleModel
 */
export interface ApiEventTypeSimpleModel {
    /**
     * 
     * @type {ApiEventType}
     * @memberof ApiEventTypeSimpleModel
     */
    'id'?: ApiEventType;
    /**
     * Наименование
     * @type {string}
     * @memberof ApiEventTypeSimpleModel
     */
    'name'?: string | null;
}


/**
 * Тип занятости исполнителя
 * @export
 * @enum {string}
 */

export const ApiExecutorEmploymentKind = {
    Undefined: 'undefined',
    Selfemployed: 'selfemployed',
    Entrepreneur: 'entrepreneur'
} as const;

export type ApiExecutorEmploymentKind = typeof ApiExecutorEmploymentKind[keyof typeof ApiExecutorEmploymentKind];


/**
 * Простейшая модель
 * @export
 * @interface ApiExecutorEmploymentKindSimpleModel
 */
export interface ApiExecutorEmploymentKindSimpleModel {
    /**
     * 
     * @type {ApiExecutorEmploymentKind}
     * @memberof ApiExecutorEmploymentKindSimpleModel
     */
    'id'?: ApiExecutorEmploymentKind;
    /**
     * Наименование
     * @type {string}
     * @memberof ApiExecutorEmploymentKindSimpleModel
     */
    'name'?: string | null;
}


/**
 * Тип функционального переключателя
 * @export
 * @enum {string}
 */

export const ApiFeatureToggleType = {
    Undefined: 'undefined',
    IsClientAppInDevelopment: 'isClientAppInDevelopment',
    DisableCashbackAccrual: 'disableCashbackAccrual',
    DisableCashbackWriteOff: 'disableCashbackWriteOff',
    RocketWorkStub: 'rocketWorkStub',
    AppStoreReviewStub: 'appStoreReviewStub',
    VkEnabled: 'vkEnabled',
    TelegramEnabled: 'telegramEnabled',
    ClientCashbackEnabled: 'clientCashbackEnabled',
    ClientFavoriteExecutorsEnabled: 'clientFavoriteExecutorsEnabled',
    DisableCityDistrictFilter: 'disableCityDistrictFilter'
} as const;

export type ApiFeatureToggleType = typeof ApiFeatureToggleType[keyof typeof ApiFeatureToggleType];


/**
 * Простейшая модель
 * @export
 * @interface ApiFeatureToggleTypeSimpleModel
 */
export interface ApiFeatureToggleTypeSimpleModel {
    /**
     * 
     * @type {ApiFeatureToggleType}
     * @memberof ApiFeatureToggleTypeSimpleModel
     */
    'id'?: ApiFeatureToggleType;
    /**
     * Наименование
     * @type {string}
     * @memberof ApiFeatureToggleTypeSimpleModel
     */
    'name'?: string | null;
}


/**
 * Пол
 * @export
 * @enum {string}
 */

export const ApiGender = {
    Undefined: 'undefined',
    Male: 'male',
    Female: 'female'
} as const;

export type ApiGender = typeof ApiGender[keyof typeof ApiGender];


/**
 * Простейшая модель
 * @export
 * @interface ApiGenderSimpleModel
 */
export interface ApiGenderSimpleModel {
    /**
     * 
     * @type {ApiGender}
     * @memberof ApiGenderSimpleModel
     */
    'id'?: ApiGender;
    /**
     * Наименование
     * @type {string}
     * @memberof ApiGenderSimpleModel
     */
    'name'?: string | null;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const ApiHabitPlaceType = {
    Undefined: 'undefined',
    AtHome: 'atHome',
    OnTheStreet: 'onTheStreet'
} as const;

export type ApiHabitPlaceType = typeof ApiHabitPlaceType[keyof typeof ApiHabitPlaceType];


/**
 * Простейшая модель
 * @export
 * @interface ApiHabitPlaceTypeSimpleModel
 */
export interface ApiHabitPlaceTypeSimpleModel {
    /**
     * 
     * @type {ApiHabitPlaceType}
     * @memberof ApiHabitPlaceTypeSimpleModel
     */
    'id'?: ApiHabitPlaceType;
    /**
     * Наименование
     * @type {string}
     * @memberof ApiHabitPlaceTypeSimpleModel
     */
    'name'?: string | null;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const ApiHabitType = {
    Undefined: 'undefined',
    Normal: 'normal',
    Bad: 'bad'
} as const;

export type ApiHabitType = typeof ApiHabitType[keyof typeof ApiHabitType];


/**
 * Простейшая модель
 * @export
 * @interface ApiHabitTypeSimpleModel
 */
export interface ApiHabitTypeSimpleModel {
    /**
     * 
     * @type {ApiHabitType}
     * @memberof ApiHabitTypeSimpleModel
     */
    'id'?: ApiHabitType;
    /**
     * Наименование
     * @type {string}
     * @memberof ApiHabitTypeSimpleModel
     */
    'name'?: string | null;
}


/**
 * Статус ручного чека ФНС
 * @export
 * @enum {string}
 */

export const ApiManualFnsReceiptStatus = {
    Undefined: 'undefined',
    New: 'new',
    Checking: 'checking',
    Applied: 'applied',
    Rejected: 'rejected'
} as const;

export type ApiManualFnsReceiptStatus = typeof ApiManualFnsReceiptStatus[keyof typeof ApiManualFnsReceiptStatus];


/**
 * Простейшая модель
 * @export
 * @interface ApiManualFnsReceiptStatusSimpleModel
 */
export interface ApiManualFnsReceiptStatusSimpleModel {
    /**
     * 
     * @type {ApiManualFnsReceiptStatus}
     * @memberof ApiManualFnsReceiptStatusSimpleModel
     */
    'id'?: ApiManualFnsReceiptStatus;
    /**
     * Наименование
     * @type {string}
     * @memberof ApiManualFnsReceiptStatusSimpleModel
     */
    'name'?: string | null;
}


/**
 * Коды текстовок приложения
 * @export
 * @enum {string}
 */

export const ApiMessageCode = {
    Undefined: 'undefined',
    CancelOrderWithin5Minutes: 'cancelOrderWithin5Minutes',
    CancelOrderAfter5Minutes: 'cancelOrderAfter5Minutes',
    CancelOrderWithin2Days: 'cancelOrderWithin2Days',
    CancelOrderMoreThan2Days: 'cancelOrderMoreThan2Days',
    SignContractOnRocketWork: 'signContractOnRocketWork',
    CancelOrderWithin2Hours: 'cancelOrderWithin2Hours',
    CancelOrderMoreThan2Hours: 'cancelOrderMoreThan2Hours',
    SupportGreeting: 'supportGreeting',
    AiBotGreeting: 'aiBotGreeting',
    CompleteOrderBeforeWalkTimeEnds: 'completeOrderBeforeWalkTimeEnds',
    CompleteOrderBeforeBoardingTimeEnds: 'completeOrderBeforeBoardingTimeEnds',
    CompleteOrderBeforePetSittingTimeEnds: 'completeOrderBeforePetSittingTimeEnds',
    CompletionConditionsSatisfied: 'completionConditionsSatisfied',
    ContinueSearch30Min: 'continueSearch30Min',
    ContinueSearch24Hours: 'continueSearch24Hours',
    AutoCancelNoExecutor: 'autoCancelNoExecutor',
    AutoCancelNotCompleted: 'autoCancelNotCompleted',
    ClientCancelNoExecutor: 'clientCancelNoExecutor',
    SupportOutsideWorkingHours: 'supportOutsideWorkingHours',
    SpecialPricingPeriodWarning: 'specialPricingPeriodWarning',
    SpecialPricingPeriodApplied: 'specialPricingPeriodApplied',
    AccountLinkUseApplication: 'accountLinkUseApplication',
    AccountLinkSucceeded: 'accountLinkSucceeded',
    TelegramAccountLinkedNotice: 'telegramAccountLinkedNotice',
    TelegramAccountAlreadyLinked: 'telegramAccountAlreadyLinked',
    TelegramAssistantWelcome: 'telegramAssistantWelcome',
    TelegramAssistantLinkInstructions: 'telegramAssistantLinkInstructions',
    VkAccountLinkedNotice: 'vkAccountLinkedNotice',
    VkAccountAlreadyLinked: 'vkAccountAlreadyLinked',
    VkAssistantWelcome: 'vkAssistantWelcome',
    VkAssistantLinkInstructions: 'vkAssistantLinkInstructions',
    SmsAuthenticationCode: 'smsAuthenticationCode',
    VkAuthenticationCode: 'vkAuthenticationCode',
    EmailAuthenticationSubject: 'emailAuthenticationSubject',
    EmailVerificationSubject: 'emailVerificationSubject',
    InternalAuthenticationCode: 'internalAuthenticationCode',
    OrderAgreementSigningTitle: 'orderAgreementSigningTitle',
    UserRegisteredNotice: 'userRegisteredNotice',
    OrderSearchStartedNotice: 'orderSearchStartedNotice',
    OrderPaymentSucceededNotice: 'orderPaymentSucceededNotice',
    OrderAcceptancePaidNotice: 'orderAcceptancePaidNotice',
    OrderPositiveReviewNotice: 'orderPositiveReviewNotice',
    OrderLowRatingNotice: 'orderLowRatingNotice',
    OrderStartMissedNotice: 'orderStartMissedNotice',
    OrderReviewMissingNotice: 'orderReviewMissingNotice',
    SmsAeroBalanceNotice: 'smsAeroBalanceNotice',
    IDigitalBalanceNotice: 'iDigitalBalanceNotice',
    DaDataBalanceNotice: 'daDataBalanceNotice',
    RocketWorkCancellationTask: 'rocketWorkCancellationTask',
    RocketWorkCancellationNotice: 'rocketWorkCancellationNotice',
    OperatorNoticeOrderLink: 'operatorNoticeOrderLink',
    OperatorNoticeReason: 'operatorNoticeReason',
    OperatorNoticeOrderLabel: 'operatorNoticeOrderLabel',
    AcceptanceBeforeStartNotice: 'acceptanceBeforeStartNotice',
    AcceptanceBeforeEndNotice: 'acceptanceBeforeEndNotice',
    OrderAgreementExpiredReason: 'orderAgreementExpiredReason',
    ExecutorRefusedReason: 'executorRefusedReason',
    ExecutorRemovedByOperatorReason: 'executorRemovedByOperatorReason',
    ClientRefusedExecutorReason: 'clientRefusedExecutorReason',
    ExecutorOrderTypeLine: 'executorOrderTypeLine',
    ExecutorOrderPetTypeLine: 'executorOrderPetTypeLine',
    ExecutorOrderPetsHeading: 'executorOrderPetsHeading',
    ExecutorOrderPickupHeading: 'executorOrderPickupHeading',
    ExecutorOrderPlacementLine: 'executorOrderPlacementLine',
    ExecutorOrderPickupPersonLine: 'executorOrderPickupPersonLine',
    ExecutorOrderSpecialistLine: 'executorOrderSpecialistLine',
    ExecutorOrderSpecialistAddressHeading: 'executorOrderSpecialistAddressHeading',
    ExecutorOrderAcceptLink: 'executorOrderAcceptLink',
    ExecutorOrderAcceptFullLink: 'executorOrderAcceptFullLink',
    ExecutorOrderRewardLine: 'executorOrderRewardLine',
    ExecutorOrderAdditionalServicesHeading: 'executorOrderAdditionalServicesHeading',
    ExecutorOrderCityLine: 'executorOrderCityLine',
    ExecutorOrderDistrictLine: 'executorOrderDistrictLine',
    ExecutorOrderStreetLine: 'executorOrderStreetLine',
    ExecutorOrderPeriodLine: 'executorOrderPeriodLine',
    ExecutorOrderDateLine1: 'executorOrderDateLine1',
    ExecutorOrderDateLine2: 'executorOrderDateLine2',
    ExecutorOrderTitle: 'executorOrderTitle',
    NightEarlyPriceDescription: 'nightEarlyPriceDescription',
    NightLatePriceDescription: 'nightLatePriceDescription',
    ExecutorSpecialPriceDescription: 'executorSpecialPriceDescription',
    EmailLoginTitle: 'emailLoginTitle',
    EmailLoginPreview: 'emailLoginPreview',
    EmailLoginEyebrow: 'emailLoginEyebrow',
    EmailLoginHeading: 'emailLoginHeading',
    EmailLoginIntro: 'emailLoginIntro',
    EmailLoginCodeLabel: 'emailLoginCodeLabel',
    EmailLoginLifetimePrefix: 'emailLoginLifetimePrefix',
    EmailLoginPrivacy: 'emailLoginPrivacy',
    EmailLoginUnrequested: 'emailLoginUnrequested',
    EmailConfirmTitle: 'emailConfirmTitle',
    EmailConfirmPreview: 'emailConfirmPreview',
    EmailProfileEyebrow: 'emailProfileEyebrow',
    EmailConfirmHeading: 'emailConfirmHeading',
    EmailConfirmIntro: 'emailConfirmIntro',
    EmailConfirmAction: 'emailConfirmAction',
    EmailConfirmLifetimePrefix: 'emailConfirmLifetimePrefix',
    EmailConfirmLifetimeSuffix: 'emailConfirmLifetimeSuffix',
    EmailConfirmPrivacy: 'emailConfirmPrivacy',
    EmailSignatureLead: 'emailSignatureLead',
    EmailSignatureTeam: 'emailSignatureTeam',
    EmailAutomaticNotice: 'emailAutomaticNotice',
    EmailPageVerifiedTitle: 'emailPageVerifiedTitle',
    EmailPageConfirmTitle: 'emailPageConfirmTitle',
    EmailPageVerifiedDescription: 'emailPageVerifiedDescription',
    EmailPageConfirmDescription: 'emailPageConfirmDescription',
    EmailPageSubmitHint: 'emailPageSubmitHint',
    EmailPageCloseHint: 'emailPageCloseHint',
    AppOpeningTitle: 'appOpeningTitle',
    AppOpeningMessage: 'appOpeningMessage',
    AppOpeningManualHint: 'appOpeningManualHint',
    AppOpeningOrderAction: 'appOpeningOrderAction',
    PaymentWebSuccess: 'paymentWebSuccess',
    OperatorTaskOverdueTitle: 'operatorTaskOverdueTitle',
    OperatorTaskReminderTitle: 'operatorTaskReminderTitle',
    OperatorTaskDueLine: 'operatorTaskDueLine',
    OperatorTaskReminderLine: 'operatorTaskReminderLine',
    OperatorTaskOpenAction: 'operatorTaskOpenAction'
} as const;

export type ApiMessageCode = typeof ApiMessageCode[keyof typeof ApiMessageCode];


/**
 * Простейшая модель
 * @export
 * @interface ApiMessageCodeSimpleModel
 */
export interface ApiMessageCodeSimpleModel {
    /**
     * 
     * @type {ApiMessageCode}
     * @memberof ApiMessageCodeSimpleModel
     */
    'id'?: ApiMessageCode;
    /**
     * Наименование
     * @type {string}
     * @memberof ApiMessageCodeSimpleModel
     */
    'name'?: string | null;
}


/**
 * Группы текстовок приложения
 * @export
 * @enum {string}
 */

export const ApiMessageTemplateGroup = {
    Undefined: 'undefined',
    OrderCancellation: 'orderCancellation',
    OrderCompletion: 'orderCompletion',
    OrderSearch: 'orderSearch',
    Contracts: 'contracts',
    Support: 'support',
    Assistant: 'assistant',
    Pricing: 'pricing',
    AccountLinking: 'accountLinking',
    TelegramLinking: 'telegramLinking',
    VkLinking: 'vkLinking',
    SmsAuthentication: 'smsAuthentication',
    VkAuthentication: 'vkAuthentication',
    EmailAuthentication: 'emailAuthentication',
    InternalAuthentication: 'internalAuthentication',
    RegistrationNotices: 'registrationNotices',
    SearchNotices: 'searchNotices',
    PaymentNotices: 'paymentNotices',
    ReviewNotices: 'reviewNotices',
    OrderMonitoring: 'orderMonitoring',
    ProviderBalances: 'providerBalances',
    RocketCancellation: 'rocketCancellation',
    RocketAcceptance: 'rocketAcceptance',
    OrderAnnouncement: 'orderAnnouncement',
    OrderPets: 'orderPets',
    OrderAddresses: 'orderAddresses',
    OrderRewards: 'orderRewards',
    NightPricing: 'nightPricing',
    EmailLogin: 'emailLogin',
    EmailConfirmation: 'emailConfirmation',
    EmailCommon: 'emailCommon',
    EmailPages: 'emailPages',
    AppNavigation: 'appNavigation',
    OperatorTaskReminders: 'operatorTaskReminders',
    OrderSchedule: 'orderSchedule',
    PaymentPages: 'paymentPages'
} as const;

export type ApiMessageTemplateGroup = typeof ApiMessageTemplateGroup[keyof typeof ApiMessageTemplateGroup];


/**
 * Простейшая модель
 * @export
 * @interface ApiMessageTemplateGroupSimpleModel
 */
export interface ApiMessageTemplateGroupSimpleModel {
    /**
     * 
     * @type {ApiMessageTemplateGroup}
     * @memberof ApiMessageTemplateGroupSimpleModel
     */
    'id'?: ApiMessageTemplateGroup;
    /**
     * Наименование
     * @type {string}
     * @memberof ApiMessageTemplateGroupSimpleModel
     */
    'name'?: string | null;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const ApiMoneyDebitType = {
    Undefined: 'undefined',
    PerDay: 'perDay',
    PerService: 'perService',
    PerServiceWithAnimalCount: 'perServiceWithAnimalCount'
} as const;

export type ApiMoneyDebitType = typeof ApiMoneyDebitType[keyof typeof ApiMoneyDebitType];


/**
 * Простейшая модель
 * @export
 * @interface ApiMoneyDebitTypeSimpleModel
 */
export interface ApiMoneyDebitTypeSimpleModel {
    /**
     * 
     * @type {ApiMoneyDebitType}
     * @memberof ApiMoneyDebitTypeSimpleModel
     */
    'id'?: ApiMoneyDebitType;
    /**
     * Наименование
     * @type {string}
     * @memberof ApiMoneyDebitTypeSimpleModel
     */
    'name'?: string | null;
}


/**
 * Системный код шаблона пуш-уведомления
 * @export
 * @enum {string}
 */

export const ApiNotificationCode = {
    Undefined: 'undefined',
    OrderCreateNotCompleted: 'orderCreateNotCompleted',
    ExecutorHasBeenFound: 'executorHasBeenFound',
    ExecutorCancelledOrderToSearchable: 'executorCancelledOrderToSearchable',
    ExecutorAcceptedOrder: 'executorAcceptedOrder',
    ExecutorStartOrder: 'executorStartOrder',
    LeaveReview1H: 'leaveReview1H',
    LeaveReview24H: 'leaveReview24H',
    NewOrderNearby: 'newOrderNearby',
    ClientChosenExecutor: 'clientChosenExecutor',
    ClientCancelledOrder: 'clientCancelledOrder',
    OrderReminder2H: 'orderReminder2H',
    OrderReminder1H: 'orderReminder1H',
    OrderStart: 'orderStart',
    NewReview: 'newReview',
    ClientChangedConditions: 'clientChangedConditions',
    PaymentReceived: 'paymentReceived',
    PaymentIncreased: 'paymentIncreased',
    NewMessageInChat: 'newMessageInChat',
    SupportAnswered: 'supportAnswered',
    GiftDiscount: 'giftDiscount',
    NewAppVersion: 'newAppVersion',
    OrderReminder24H: 'orderReminder24H',
    ExecutorNotFound30Min: 'executorNotFound30Min',
    ExecutorNotFound24Hours: 'executorNotFound24Hours',
    ExecutorCancelledOrderToCanceled: 'executorCancelledOrderToCanceled',
    ExecutorNotFoundBeforeStart: 'executorNotFoundBeforeStart',
    OrderNotProcessedInTime: 'orderNotProcessedInTime',
    ExecutorOverlappingRequestsAutoCanceled: 'executorOverlappingRequestsAutoCanceled',
    NewOrderInPreferredDistrict: 'newOrderInPreferredDistrict',
    ExecutorVerificationApproved: 'executorVerificationApproved',
    BonusPointsAccrued: 'bonusPointsAccrued',
    BonusPointsExpireIn14Days: 'bonusPointsExpireIn14Days',
    BonusPointsExpireIn3Days: 'bonusPointsExpireIn3Days',
    OrderCompletionReminder: 'orderCompletionReminder',
    ManualFnsReceiptRequired: 'manualFnsReceiptRequired',
    PersonalOrderInvitation: 'personalOrderInvitation'
} as const;

export type ApiNotificationCode = typeof ApiNotificationCode[keyof typeof ApiNotificationCode];


/**
 * Простейшая модель
 * @export
 * @interface ApiNotificationCodeSimpleModel
 */
export interface ApiNotificationCodeSimpleModel {
    /**
     * 
     * @type {ApiNotificationCode}
     * @memberof ApiNotificationCodeSimpleModel
     */
    'id'?: ApiNotificationCode;
    /**
     * Наименование
     * @type {string}
     * @memberof ApiNotificationCodeSimpleModel
     */
    'name'?: string | null;
}


/**
 * Системное разрешение уведомлений мобильного приложения
 * @export
 * @enum {string}
 */

export const ApiNotificationPermissionStatus = {
    Undefined: 'undefined',
    Authorized: 'authorized',
    Denied: 'denied',
    NotDetermined: 'notDetermined',
    Provisional: 'provisional'
} as const;

export type ApiNotificationPermissionStatus = typeof ApiNotificationPermissionStatus[keyof typeof ApiNotificationPermissionStatus];


/**
 * Простейшая модель
 * @export
 * @interface ApiNotificationPermissionStatusSimpleModel
 */
export interface ApiNotificationPermissionStatusSimpleModel {
    /**
     * 
     * @type {ApiNotificationPermissionStatus}
     * @memberof ApiNotificationPermissionStatusSimpleModel
     */
    'id'?: ApiNotificationPermissionStatus;
    /**
     * Наименование
     * @type {string}
     * @memberof ApiNotificationPermissionStatusSimpleModel
     */
    'name'?: string | null;
}


/**
 * Аудитория шаблона пуш-уведомления
 * @export
 * @enum {string}
 */

export const ApiNotificationTemplateAudience = {
    All: 'all',
    Client: 'client',
    Executor: 'executor'
} as const;

export type ApiNotificationTemplateAudience = typeof ApiNotificationTemplateAudience[keyof typeof ApiNotificationTemplateAudience];


/**
 * Простейшая модель
 * @export
 * @interface ApiNotificationTemplateAudienceSimpleModel
 */
export interface ApiNotificationTemplateAudienceSimpleModel {
    /**
     * 
     * @type {ApiNotificationTemplateAudience}
     * @memberof ApiNotificationTemplateAudienceSimpleModel
     */
    'id'?: ApiNotificationTemplateAudience;
    /**
     * Наименование
     * @type {string}
     * @memberof ApiNotificationTemplateAudienceSimpleModel
     */
    'name'?: string | null;
}


/**
 * Причина включения задачи в очередь внимания
 * @export
 * @enum {string}
 */

export const ApiOperatorTaskAttentionReason = {
    Overdue: 'overdue',
    Reminder: 'reminder'
} as const;

export type ApiOperatorTaskAttentionReason = typeof ApiOperatorTaskAttentionReason[keyof typeof ApiOperatorTaskAttentionReason];


/**
 * Простейшая модель
 * @export
 * @interface ApiOperatorTaskAttentionReasonSimpleModel
 */
export interface ApiOperatorTaskAttentionReasonSimpleModel {
    /**
     * 
     * @type {ApiOperatorTaskAttentionReason}
     * @memberof ApiOperatorTaskAttentionReasonSimpleModel
     */
    'id'?: ApiOperatorTaskAttentionReason;
    /**
     * Наименование
     * @type {string}
     * @memberof ApiOperatorTaskAttentionReasonSimpleModel
     */
    'name'?: string | null;
}


/**
 * Способ напоминания перед сроком задачи
 * @export
 * @enum {string}
 */

export const ApiOperatorTaskBeforeDeadlineMode = {
    DeadlineDay: 'deadlineDay',
    Offset: 'offset'
} as const;

export type ApiOperatorTaskBeforeDeadlineMode = typeof ApiOperatorTaskBeforeDeadlineMode[keyof typeof ApiOperatorTaskBeforeDeadlineMode];


/**
 * Простейшая модель
 * @export
 * @interface ApiOperatorTaskBeforeDeadlineModeSimpleModel
 */
export interface ApiOperatorTaskBeforeDeadlineModeSimpleModel {
    /**
     * 
     * @type {ApiOperatorTaskBeforeDeadlineMode}
     * @memberof ApiOperatorTaskBeforeDeadlineModeSimpleModel
     */
    'id'?: ApiOperatorTaskBeforeDeadlineMode;
    /**
     * Наименование
     * @type {string}
     * @memberof ApiOperatorTaskBeforeDeadlineModeSimpleModel
     */
    'name'?: string | null;
}


/**
 * Действие сотрудника в истории задачи
 * @export
 * @enum {string}
 */

export const ApiOperatorTaskHistoryAction = {
    Created: 'created',
    Updated: 'updated',
    Rescheduled: 'rescheduled',
    Completed: 'completed',
    Reopened: 'reopened'
} as const;

export type ApiOperatorTaskHistoryAction = typeof ApiOperatorTaskHistoryAction[keyof typeof ApiOperatorTaskHistoryAction];


/**
 * Простейшая модель
 * @export
 * @interface ApiOperatorTaskHistoryActionSimpleModel
 */
export interface ApiOperatorTaskHistoryActionSimpleModel {
    /**
     * 
     * @type {ApiOperatorTaskHistoryAction}
     * @memberof ApiOperatorTaskHistoryActionSimpleModel
     */
    'id'?: ApiOperatorTaskHistoryAction;
    /**
     * Наименование
     * @type {string}
     * @memberof ApiOperatorTaskHistoryActionSimpleModel
     */
    'name'?: string | null;
}


/**
 * Периодичность напоминаний о просрочке задачи
 * @export
 * @enum {string}
 */

export const ApiOperatorTaskOverdueMode = {
    Hourly: 'hourly',
    Daily: 'daily'
} as const;

export type ApiOperatorTaskOverdueMode = typeof ApiOperatorTaskOverdueMode[keyof typeof ApiOperatorTaskOverdueMode];


/**
 * Простейшая модель
 * @export
 * @interface ApiOperatorTaskOverdueModeSimpleModel
 */
export interface ApiOperatorTaskOverdueModeSimpleModel {
    /**
     * 
     * @type {ApiOperatorTaskOverdueMode}
     * @memberof ApiOperatorTaskOverdueModeSimpleModel
     */
    'id'?: ApiOperatorTaskOverdueMode;
    /**
     * Наименование
     * @type {string}
     * @memberof ApiOperatorTaskOverdueModeSimpleModel
     */
    'name'?: string | null;
}


/**
 * Доступность связанного заказа или чата
 * @export
 * @enum {string}
 */

export const ApiOperatorTaskRelatedAvailability = {
    Available: 'available',
    Unavailable: 'unavailable'
} as const;

export type ApiOperatorTaskRelatedAvailability = typeof ApiOperatorTaskRelatedAvailability[keyof typeof ApiOperatorTaskRelatedAvailability];


/**
 * Простейшая модель
 * @export
 * @interface ApiOperatorTaskRelatedAvailabilitySimpleModel
 */
export interface ApiOperatorTaskRelatedAvailabilitySimpleModel {
    /**
     * 
     * @type {ApiOperatorTaskRelatedAvailability}
     * @memberof ApiOperatorTaskRelatedAvailabilitySimpleModel
     */
    'id'?: ApiOperatorTaskRelatedAvailability;
    /**
     * Наименование
     * @type {string}
     * @memberof ApiOperatorTaskRelatedAvailabilitySimpleModel
     */
    'name'?: string | null;
}


/**
 * Причина напоминания о задаче
 * @export
 * @enum {string}
 */

export const ApiOperatorTaskReminderReason = {
    AtDeadline: 'atDeadline',
    Daily: 'daily',
    BeforeDeadline: 'beforeDeadline',
    Overdue: 'overdue'
} as const;

export type ApiOperatorTaskReminderReason = typeof ApiOperatorTaskReminderReason[keyof typeof ApiOperatorTaskReminderReason];


/**
 * Простейшая модель
 * @export
 * @interface ApiOperatorTaskReminderReasonSimpleModel
 */
export interface ApiOperatorTaskReminderReasonSimpleModel {
    /**
     * 
     * @type {ApiOperatorTaskReminderReason}
     * @memberof ApiOperatorTaskReminderReasonSimpleModel
     */
    'id'?: ApiOperatorTaskReminderReason;
    /**
     * Наименование
     * @type {string}
     * @memberof ApiOperatorTaskReminderReasonSimpleModel
     */
    'name'?: string | null;
}


/**
 * Место создания задачи
 * @export
 * @enum {string}
 */

export const ApiOperatorTaskSource = {
    Section: 'section',
    Chat: 'chat',
    Order: 'order'
} as const;

export type ApiOperatorTaskSource = typeof ApiOperatorTaskSource[keyof typeof ApiOperatorTaskSource];


/**
 * Простейшая модель
 * @export
 * @interface ApiOperatorTaskSourceSimpleModel
 */
export interface ApiOperatorTaskSourceSimpleModel {
    /**
     * 
     * @type {ApiOperatorTaskSource}
     * @memberof ApiOperatorTaskSourceSimpleModel
     */
    'id'?: ApiOperatorTaskSource;
    /**
     * Наименование
     * @type {string}
     * @memberof ApiOperatorTaskSourceSimpleModel
     */
    'name'?: string | null;
}


/**
 * Состояние выполнения задачи
 * @export
 * @enum {string}
 */

export const ApiOperatorTaskStatus = {
    InProgress: 'inProgress',
    Completed: 'completed'
} as const;

export type ApiOperatorTaskStatus = typeof ApiOperatorTaskStatus[keyof typeof ApiOperatorTaskStatus];


/**
 * Простейшая модель
 * @export
 * @interface ApiOperatorTaskStatusSimpleModel
 */
export interface ApiOperatorTaskStatusSimpleModel {
    /**
     * 
     * @type {ApiOperatorTaskStatus}
     * @memberof ApiOperatorTaskStatusSimpleModel
     */
    'id'?: ApiOperatorTaskStatus;
    /**
     * Наименование
     * @type {string}
     * @memberof ApiOperatorTaskStatusSimpleModel
     */
    'name'?: string | null;
}


/**
 * Состояние доставки Telegram
 * @export
 * @enum {string}
 */

export const ApiOperatorTaskTelegramState = {
    Pending: 'pending',
    Sent: 'sent',
    Cancelled: 'cancelled'
} as const;

export type ApiOperatorTaskTelegramState = typeof ApiOperatorTaskTelegramState[keyof typeof ApiOperatorTaskTelegramState];


/**
 * Простейшая модель
 * @export
 * @interface ApiOperatorTaskTelegramStateSimpleModel
 */
export interface ApiOperatorTaskTelegramStateSimpleModel {
    /**
     * 
     * @type {ApiOperatorTaskTelegramState}
     * @memberof ApiOperatorTaskTelegramStateSimpleModel
     */
    'id'?: ApiOperatorTaskTelegramState;
    /**
     * Наименование
     * @type {string}
     * @memberof ApiOperatorTaskTelegramStateSimpleModel
     */
    'name'?: string | null;
}


/**
 * Тип задачи операторов
 * @export
 * @enum {string}
 */

export const ApiOperatorTaskType = {
    OneTime: 'oneTime',
    Deadline: 'deadline'
} as const;

export type ApiOperatorTaskType = typeof ApiOperatorTaskType[keyof typeof ApiOperatorTaskType];


/**
 * Простейшая модель
 * @export
 * @interface ApiOperatorTaskTypeSimpleModel
 */
export interface ApiOperatorTaskTypeSimpleModel {
    /**
     * 
     * @type {ApiOperatorTaskType}
     * @memberof ApiOperatorTaskTypeSimpleModel
     */
    'id'?: ApiOperatorTaskType;
    /**
     * Наименование
     * @type {string}
     * @memberof ApiOperatorTaskTypeSimpleModel
     */
    'name'?: string | null;
}


/**
 * Фильтр задач по состоянию
 * @export
 * @enum {string}
 */

export const ApiOperatorTaskView = {
    InProgress: 'inProgress',
    Completed: 'completed',
    Overdue: 'overdue',
    All: 'all'
} as const;

export type ApiOperatorTaskView = typeof ApiOperatorTaskView[keyof typeof ApiOperatorTaskView];


/**
 * 
 * @export
 * @enum {string}
 */

export const ApiOrderCancelType = {
    Undefined: 'undefined',
    ChangedMyMind: 'changedMyMind',
    TooLongWait: 'tooLongWait',
    ExecutorStandsStill: 'executorStandsStill',
    ExecutorDidNotGetInContact: 'executorDidNotGetInContact',
    ExecutorAskedToCancel: 'executorAskedToCancel',
    Custom: 'custom'
} as const;

export type ApiOrderCancelType = typeof ApiOrderCancelType[keyof typeof ApiOrderCancelType];


/**
 * Простейшая модель
 * @export
 * @interface ApiOrderCancelTypeSimpleModel
 */
export interface ApiOrderCancelTypeSimpleModel {
    /**
     * 
     * @type {ApiOrderCancelType}
     * @memberof ApiOrderCancelTypeSimpleModel
     */
    'id'?: ApiOrderCancelType;
    /**
     * Наименование
     * @type {string}
     * @memberof ApiOrderCancelTypeSimpleModel
     */
    'name'?: string | null;
}


/**
 * Инициатор отмены заказа
 * @export
 * @enum {string}
 */

export const ApiOrderCancellationActor = {
    Undefined: 'undefined',
    Client: 'client',
    Executor: 'executor',
    System: 'system'
} as const;

export type ApiOrderCancellationActor = typeof ApiOrderCancellationActor[keyof typeof ApiOrderCancellationActor];


/**
 * 
 * @export
 * @enum {string}
 */

export const ApiOrderCancellationInitiator = {
    Undefined: 'undefined',
    Client: 'client',
    Executor: 'executor',
    SystemNoExecutor: 'systemNoExecutor',
    SystemNotCompleted: 'systemNotCompleted'
} as const;

export type ApiOrderCancellationInitiator = typeof ApiOrderCancellationInitiator[keyof typeof ApiOrderCancellationInitiator];


/**
 * Простейшая модель
 * @export
 * @interface ApiOrderCancellationInitiatorSimpleModel
 */
export interface ApiOrderCancellationInitiatorSimpleModel {
    /**
     * 
     * @type {ApiOrderCancellationInitiator}
     * @memberof ApiOrderCancellationInitiatorSimpleModel
     */
    'id'?: ApiOrderCancellationInitiator;
    /**
     * Наименование
     * @type {string}
     * @memberof ApiOrderCancellationInitiatorSimpleModel
     */
    'name'?: string | null;
}


/**
 * Вид проблемы заказа
 * @export
 * @enum {string}
 */

export const ApiOrderProblemKind = {
    Confirmation: 'confirmation',
    Cashback: 'cashback',
    OrderOperation: 'orderOperation'
} as const;

export type ApiOrderProblemKind = typeof ApiOrderProblemKind[keyof typeof ApiOrderProblemKind];


/**
 * Простейшая модель
 * @export
 * @interface ApiOrderProblemKindSimpleModel
 */
export interface ApiOrderProblemKindSimpleModel {
    /**
     * 
     * @type {ApiOrderProblemKind}
     * @memberof ApiOrderProblemKindSimpleModel
     */
    'id'?: ApiOrderProblemKind;
    /**
     * Наименование
     * @type {string}
     * @memberof ApiOrderProblemKindSimpleModel
     */
    'name'?: string | null;
}


/**
 * Статус наличия отзыва у заказа.  Используется для фильтрации заказов при поиске.
 * @export
 * @enum {string}
 */

export const ApiOrderReviewStatus = {
    All: 'all',
    WithReview: 'withReview',
    WithoutReview: 'withoutReview'
} as const;

export type ApiOrderReviewStatus = typeof ApiOrderReviewStatus[keyof typeof ApiOrderReviewStatus];


/**
 * 
 * @export
 * @enum {string}
 */

export const ApiOrderStatus = {
    Undefined: 'undefined',
    Draft: 'draft',
    Assigned: 'assigned',
    InProgress: 'inProgress',
    Completed: 'completed',
    Cancelled: 'cancelled',
    RequestPending: 'requestPending',
    Searchable: 'searchable',
    SentToSignDocuments: 'sentToSignDocuments',
    ExecutorApproved: 'executorApproved'
} as const;

export type ApiOrderStatus = typeof ApiOrderStatus[keyof typeof ApiOrderStatus];


/**
 * Простейшая модель
 * @export
 * @interface ApiOrderStatusSimpleModel
 */
export interface ApiOrderStatusSimpleModel {
    /**
     * 
     * @type {ApiOrderStatus}
     * @memberof ApiOrderStatusSimpleModel
     */
    'id'?: ApiOrderStatus;
    /**
     * Наименование
     * @type {string}
     * @memberof ApiOrderStatusSimpleModel
     */
    'name'?: string | null;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const ApiOrderType = {
    Undefined: 'undefined',
    Subscription: 'subscription',
    DogWalking: 'dogWalking',
    PetBoarding: 'petBoarding',
    PetSitting: 'petSitting',
    ToSpecialist: 'toSpecialist'
} as const;

export type ApiOrderType = typeof ApiOrderType[keyof typeof ApiOrderType];


/**
 * Простейшая модель
 * @export
 * @interface ApiOrderTypeSimpleModel
 */
export interface ApiOrderTypeSimpleModel {
    /**
     * 
     * @type {ApiOrderType}
     * @memberof ApiOrderTypeSimpleModel
     */
    'id'?: ApiOrderType;
    /**
     * Наименование
     * @type {string}
     * @memberof ApiOrderTypeSimpleModel
     */
    'name'?: string | null;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const ApiPaymentReadiness = {
    Unknown: 'unknown',
    AllIsWell: 'allIsWell',
    NoTaxAccount: 'noTaxAccount',
    NoRequisites: 'noRequisites',
    NoTaxPayment: 'noTaxPayment',
    NoPayments: 'noPayments'
} as const;

export type ApiPaymentReadiness = typeof ApiPaymentReadiness[keyof typeof ApiPaymentReadiness];


/**
 * Простейшая модель
 * @export
 * @interface ApiPaymentReadinessSimpleModel
 */
export interface ApiPaymentReadinessSimpleModel {
    /**
     * 
     * @type {ApiPaymentReadiness}
     * @memberof ApiPaymentReadinessSimpleModel
     */
    'id'?: ApiPaymentReadiness;
    /**
     * Наименование
     * @type {string}
     * @memberof ApiPaymentReadinessSimpleModel
     */
    'name'?: string | null;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const ApiPaymentStatus = {
    Undefined: 'undefined',
    New: 'new',
    Pending: 'pending',
    Completed: 'completed',
    Failed: 'failed'
} as const;

export type ApiPaymentStatus = typeof ApiPaymentStatus[keyof typeof ApiPaymentStatus];


/**
 * Простейшая модель
 * @export
 * @interface ApiPaymentStatusSimpleModel
 */
export interface ApiPaymentStatusSimpleModel {
    /**
     * 
     * @type {ApiPaymentStatus}
     * @memberof ApiPaymentStatusSimpleModel
     */
    'id'?: ApiPaymentStatus;
    /**
     * Наименование
     * @type {string}
     * @memberof ApiPaymentStatusSimpleModel
     */
    'name'?: string | null;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const ApiPayoutMethodType = {
    Undefined: 'undefined',
    Sbp: 'sbp',
    Card: 'card',
    BankAccount: 'bankAccount'
} as const;

export type ApiPayoutMethodType = typeof ApiPayoutMethodType[keyof typeof ApiPayoutMethodType];


/**
 * Простейшая модель
 * @export
 * @interface ApiPayoutMethodTypeSimpleModel
 */
export interface ApiPayoutMethodTypeSimpleModel {
    /**
     * 
     * @type {ApiPayoutMethodType}
     * @memberof ApiPayoutMethodTypeSimpleModel
     */
    'id'?: ApiPayoutMethodType;
    /**
     * Наименование
     * @type {string}
     * @memberof ApiPayoutMethodTypeSimpleModel
     */
    'name'?: string | null;
}


/**
 * Место оказания услуги
 * @export
 * @enum {string}
 */

export const ApiPetPlacement = {
    Undefined: 'undefined',
    Owner: 'owner',
    Nanny: 'nanny'
} as const;

export type ApiPetPlacement = typeof ApiPetPlacement[keyof typeof ApiPetPlacement];


/**
 * Простейшая модель
 * @export
 * @interface ApiPetPlacementSimpleModel
 */
export interface ApiPetPlacementSimpleModel {
    /**
     * 
     * @type {ApiPetPlacement}
     * @memberof ApiPetPlacementSimpleModel
     */
    'id'?: ApiPetPlacement;
    /**
     * Наименование
     * @type {string}
     * @memberof ApiPetPlacementSimpleModel
     */
    'name'?: string | null;
}


/**
 * Виды питомцев и совместный тип заказа
 * @export
 * @enum {string}
 */

export const ApiPetType = {
    Undefined: 'undefined',
    Dog: 'dog',
    Cat: 'cat',
    Other: 'other',
    Mixed: 'mixed'
} as const;

export type ApiPetType = typeof ApiPetType[keyof typeof ApiPetType];


/**
 * Простейшая модель
 * @export
 * @interface ApiPetTypeSimpleModel
 */
export interface ApiPetTypeSimpleModel {
    /**
     * 
     * @type {ApiPetType}
     * @memberof ApiPetTypeSimpleModel
     */
    'id'?: ApiPetType;
    /**
     * Наименование
     * @type {string}
     * @memberof ApiPetTypeSimpleModel
     */
    'name'?: string | null;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const ApiPolicyAudience = {
    Undefined: 'undefined',
    Client: 'client',
    Executor: 'executor',
    All: 'all'
} as const;

export type ApiPolicyAudience = typeof ApiPolicyAudience[keyof typeof ApiPolicyAudience];


/**
 * Простейшая модель
 * @export
 * @interface ApiPolicyAudienceSimpleModel
 */
export interface ApiPolicyAudienceSimpleModel {
    /**
     * 
     * @type {ApiPolicyAudience}
     * @memberof ApiPolicyAudienceSimpleModel
     */
    'id'?: ApiPolicyAudience;
    /**
     * Наименование
     * @type {string}
     * @memberof ApiPolicyAudienceSimpleModel
     */
    'name'?: string | null;
}


/**
 * Тип политики сервиса в API
 * @export
 * @enum {string}
 */

export const ApiPolicyType = {
    Undefined: 'undefined',
    PrivacyPolicy: 'privacyPolicy',
    PersonalDataConsent: 'personalDataConsent',
    TermsOfService: 'termsOfService',
    LicenseAgreement: 'licenseAgreement',
    MarketingConsent: 'marketingConsent',
    LoyaltyProgram: 'loyaltyProgram'
} as const;

export type ApiPolicyType = typeof ApiPolicyType[keyof typeof ApiPolicyType];


/**
 * Простейшая модель
 * @export
 * @interface ApiPolicyTypeSimpleModel
 */
export interface ApiPolicyTypeSimpleModel {
    /**
     * 
     * @type {ApiPolicyType}
     * @memberof ApiPolicyTypeSimpleModel
     */
    'id'?: ApiPolicyType;
    /**
     * Наименование
     * @type {string}
     * @memberof ApiPolicyTypeSimpleModel
     */
    'name'?: string | null;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const ApiProductSubType = {
    Undefined: 'undefined',
    LongWalk: 'longWalk',
    ImNotHome: 'imNotHome',
    WashPaws: 'washPaws'
} as const;

export type ApiProductSubType = typeof ApiProductSubType[keyof typeof ApiProductSubType];


/**
 * Простейшая модель
 * @export
 * @interface ApiProductSubTypeSimpleModel
 */
export interface ApiProductSubTypeSimpleModel {
    /**
     * 
     * @type {ApiProductSubType}
     * @memberof ApiProductSubTypeSimpleModel
     */
    'id'?: ApiProductSubType;
    /**
     * Наименование
     * @type {string}
     * @memberof ApiProductSubTypeSimpleModel
     */
    'name'?: string | null;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const ApiProductType = {
    Undefined: 'undefined',
    Subscription: 'subscription',
    DogWalking: 'dogWalking',
    PetBoarding: 'petBoarding',
    PetSitting: 'petSitting',
    ToSpecialist: 'toSpecialist',
    AdditionalService: 'additionalService',
    AdditionalSubscriptionOption: 'additionalSubscriptionOption',
    CustomOperatorService: 'customOperatorService',
    Veterinarian: 'veterinarian',
    Groomer: 'groomer'
} as const;

export type ApiProductType = typeof ApiProductType[keyof typeof ApiProductType];


/**
 * Простейшая модель
 * @export
 * @interface ApiProductTypeSimpleModel
 */
export interface ApiProductTypeSimpleModel {
    /**
     * 
     * @type {ApiProductType}
     * @memberof ApiProductTypeSimpleModel
     */
    'id'?: ApiProductType;
    /**
     * Наименование
     * @type {string}
     * @memberof ApiProductTypeSimpleModel
     */
    'name'?: string | null;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const ApiPromoCodeStatus = {
    Undefined: 'undefined',
    New: 'new',
    Ready: 'ready',
    Active: 'active',
    Exhausted: 'exhausted',
    Blocked: 'blocked'
} as const;

export type ApiPromoCodeStatus = typeof ApiPromoCodeStatus[keyof typeof ApiPromoCodeStatus];


/**
 * Простейшая модель
 * @export
 * @interface ApiPromoCodeStatusSimpleModel
 */
export interface ApiPromoCodeStatusSimpleModel {
    /**
     * 
     * @type {ApiPromoCodeStatus}
     * @memberof ApiPromoCodeStatusSimpleModel
     */
    'id'?: ApiPromoCodeStatus;
    /**
     * Наименование
     * @type {string}
     * @memberof ApiPromoCodeStatusSimpleModel
     */
    'name'?: string | null;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const ApiPromoCodeType = {
    Undefined: 'undefined',
    Percentage: 'percentage',
    FixedAmount: 'fixedAmount'
} as const;

export type ApiPromoCodeType = typeof ApiPromoCodeType[keyof typeof ApiPromoCodeType];


/**
 * Простейшая модель
 * @export
 * @interface ApiPromoCodeTypeSimpleModel
 */
export interface ApiPromoCodeTypeSimpleModel {
    /**
     * 
     * @type {ApiPromoCodeType}
     * @memberof ApiPromoCodeTypeSimpleModel
     */
    'id'?: ApiPromoCodeType;
    /**
     * Наименование
     * @type {string}
     * @memberof ApiPromoCodeTypeSimpleModel
     */
    'name'?: string | null;
}


/**
 * Исходная точность координат дома
 * @export
 * @enum {string}
 */

export const ApiQcGeoStatus = {
    ExactHouse: 'exactHouse',
    NearestHouse: 'nearestHouse',
    Street: 'street',
    Locality: 'locality',
    City: 'city',
    Undefined: 'undefined'
} as const;

export type ApiQcGeoStatus = typeof ApiQcGeoStatus[keyof typeof ApiQcGeoStatus];


/**
 * Простейшая модель
 * @export
 * @interface ApiQcGeoStatusSimpleModel
 */
export interface ApiQcGeoStatusSimpleModel {
    /**
     * 
     * @type {ApiQcGeoStatus}
     * @memberof ApiQcGeoStatusSimpleModel
     */
    'id'?: ApiQcGeoStatus;
    /**
     * Наименование
     * @type {string}
     * @memberof ApiQcGeoStatusSimpleModel
     */
    'name'?: string | null;
}


/**
 * Тип отказа от исполнителя
 * @export
 * @enum {string}
 */

export const ApiRefusalFromExecutorType = {
    Undefined: 'undefined',
    LowExperience: 'lowExperience',
    InappropriateAge: 'inappropriateAge',
    DontLikeProfile: 'dontLikeProfile',
    Custom: 'custom'
} as const;

export type ApiRefusalFromExecutorType = typeof ApiRefusalFromExecutorType[keyof typeof ApiRefusalFromExecutorType];


/**
 * Простейшая модель
 * @export
 * @interface ApiRefusalFromExecutorTypeSimpleModel
 */
export interface ApiRefusalFromExecutorTypeSimpleModel {
    /**
     * 
     * @type {ApiRefusalFromExecutorType}
     * @memberof ApiRefusalFromExecutorTypeSimpleModel
     */
    'id'?: ApiRefusalFromExecutorType;
    /**
     * Наименование
     * @type {string}
     * @memberof ApiRefusalFromExecutorTypeSimpleModel
     */
    'name'?: string | null;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const ApiRocketTaskStatus = {
    Undefined: 'undefined',
    Draft: 'draft',
    Inwork: 'inwork',
    Accepting: 'accepting',
    Completed: 'completed',
    Paying: 'paying',
    Paid: 'paid',
    Error: 'error',
    Canceled: 'canceled'
} as const;

export type ApiRocketTaskStatus = typeof ApiRocketTaskStatus[keyof typeof ApiRocketTaskStatus];


/**
 * Простейшая модель
 * @export
 * @interface ApiRocketTaskStatusSimpleModel
 */
export interface ApiRocketTaskStatusSimpleModel {
    /**
     * 
     * @type {ApiRocketTaskStatus}
     * @memberof ApiRocketTaskStatusSimpleModel
     */
    'id'?: ApiRocketTaskStatus;
    /**
     * Наименование
     * @type {string}
     * @memberof ApiRocketTaskStatusSimpleModel
     */
    'name'?: string | null;
}


/**
 * Статус выдачи ФНС прав исполнителем платформе (для СМЗ). По умолчанию - unknown
 * @export
 * @enum {string}
 */

export const ApiSelfemployedStatus = {
    Unknown: 'unknown',
    Pending: 'pending',
    NotSelfemployed: 'notSelfemployed',
    NeedPermissions: 'needPermissions',
    Validated: 'validated'
} as const;

export type ApiSelfemployedStatus = typeof ApiSelfemployedStatus[keyof typeof ApiSelfemployedStatus];


/**
 * Простейшая модель
 * @export
 * @interface ApiSelfemployedStatusSimpleModel
 */
export interface ApiSelfemployedStatusSimpleModel {
    /**
     * 
     * @type {ApiSelfemployedStatus}
     * @memberof ApiSelfemployedStatusSimpleModel
     */
    'id'?: ApiSelfemployedStatus;
    /**
     * Наименование
     * @type {string}
     * @memberof ApiSelfemployedStatusSimpleModel
     */
    'name'?: string | null;
}


/**
 * Раздел прикладных настроек
 * @export
 * @enum {string}
 */

export const ApiSettingType = {
    Order: 'order',
    Cashback: 'cashback',
    Authentication: 'authentication',
    Email: 'email',
    Executor: 'executor',
    OperatorTask: 'operatorTask',
    Dialog: 'dialog',
    TechnicalSupport: 'technicalSupport'
} as const;

export type ApiSettingType = typeof ApiSettingType[keyof typeof ApiSettingType];


/**
 * Простейшая модель
 * @export
 * @interface ApiSettingTypeSimpleModel
 */
export interface ApiSettingTypeSimpleModel {
    /**
     * 
     * @type {ApiSettingType}
     * @memberof ApiSettingTypeSimpleModel
     */
    'id'?: ApiSettingType;
    /**
     * Наименование
     * @type {string}
     * @memberof ApiSettingTypeSimpleModel
     */
    'name'?: string | null;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const ApiSpecialistType = {
    Undefined: 'undefined',
    Groomer: 'groomer',
    Veterinarian: 'veterinarian',
    Other: 'other'
} as const;

export type ApiSpecialistType = typeof ApiSpecialistType[keyof typeof ApiSpecialistType];


/**
 * Простейшая модель
 * @export
 * @interface ApiSpecialistTypeSimpleModel
 */
export interface ApiSpecialistTypeSimpleModel {
    /**
     * 
     * @type {ApiSpecialistType}
     * @memberof ApiSpecialistTypeSimpleModel
     */
    'id'?: ApiSpecialistType;
    /**
     * Наименование
     * @type {string}
     * @memberof ApiSpecialistTypeSimpleModel
     */
    'name'?: string | null;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const ApiTagType = {
    Undefined: 'undefined',
    LinkToAmmunitionOnYandexMarket: 'linkToAmmunitionOnYandexMarket',
    ExecutorRecruiterTelegramLink: 'executorRecruiterTelegramLink'
} as const;

export type ApiTagType = typeof ApiTagType[keyof typeof ApiTagType];


/**
 * Простейшая модель
 * @export
 * @interface ApiTagTypeSimpleModel
 */
export interface ApiTagTypeSimpleModel {
    /**
     * 
     * @type {ApiTagType}
     * @memberof ApiTagTypeSimpleModel
     */
    'id'?: ApiTagType;
    /**
     * Наименование
     * @type {string}
     * @memberof ApiTagTypeSimpleModel
     */
    'name'?: string | null;
}


/**
 * Назначение бота Telegram
 * @export
 * @enum {string}
 */

export const ApiTelegramBot = {
    AlertBot: 'alertBot',
    AuthBot: 'authBot',
    VoxAssistantBot: 'voxAssistantBot',
    VoxInformationBot: 'voxInformationBot',
    VoxOperatorBot: 'voxOperatorBot',
    MemoryDiagnosticsBot: 'memoryDiagnosticsBot'
} as const;

export type ApiTelegramBot = typeof ApiTelegramBot[keyof typeof ApiTelegramBot];


/**
 * Простейшая модель
 * @export
 * @interface ApiTelegramBotSimpleModel
 */
export interface ApiTelegramBotSimpleModel {
    /**
     * 
     * @type {ApiTelegramBot}
     * @memberof ApiTelegramBotSimpleModel
     */
    'id'?: ApiTelegramBot;
    /**
     * Наименование
     * @type {string}
     * @memberof ApiTelegramBotSimpleModel
     */
    'name'?: string | null;
}


/**
 * Назначение чата Telegram
 * @export
 * @enum {string}
 */

export const ApiTelegramChat = {
    VoxOperator: 'voxOperator',
    Alerts: 'alerts',
    Auth: 'auth',
    Information: 'information',
    MemoryDiagnostics: 'memoryDiagnostics',
    OperatorQualityControl: 'operatorQualityControl'
} as const;

export type ApiTelegramChat = typeof ApiTelegramChat[keyof typeof ApiTelegramChat];


/**
 * Простейшая модель
 * @export
 * @interface ApiTelegramChatSimpleModel
 */
export interface ApiTelegramChatSimpleModel {
    /**
     * 
     * @type {ApiTelegramChat}
     * @memberof ApiTelegramChatSimpleModel
     */
    'id'?: ApiTelegramChat;
    /**
     * Наименование
     * @type {string}
     * @memberof ApiTelegramChatSimpleModel
     */
    'name'?: string | null;
}


/**
 * Роль пользователя
 * @export
 * @enum {string}
 */

export const ApiUserRole = {
    Undefined: 'undefined',
    Client: 'client',
    Executor: 'executor',
    Admin: 'admin',
    TechnicalSupport: 'technicalSupport',
    Marketer: 'marketer',
    Recruiter: 'recruiter',
    AiAssistant: 'aiAssistant',
    Developer: 'developer',
    RocketWork: 'rocketWork',
    SuperAdmin: 'superAdmin',
    Custom: 'custom'
} as const;

export type ApiUserRole = typeof ApiUserRole[keyof typeof ApiUserRole];


/**
 * Простейшая модель
 * @export
 * @interface ApiUserRoleSimpleModel
 */
export interface ApiUserRoleSimpleModel {
    /**
     * 
     * @type {ApiUserRole}
     * @memberof ApiUserRoleSimpleModel
     */
    'id'?: ApiUserRole;
    /**
     * Наименование
     * @type {string}
     * @memberof ApiUserRoleSimpleModel
     */
    'name'?: string | null;
}


/**
 * Доставка питомца к исполнителю
 * @export
 * @enum {string}
 */

export const ApiWhoWillBringPet = {
    Undefined: 'undefined',
    Im: 'im',
    Nanny: 'nanny'
} as const;

export type ApiWhoWillBringPet = typeof ApiWhoWillBringPet[keyof typeof ApiWhoWillBringPet];


/**
 * Простейшая модель
 * @export
 * @interface ApiWhoWillBringPetSimpleModel
 */
export interface ApiWhoWillBringPetSimpleModel {
    /**
     * 
     * @type {ApiWhoWillBringPet}
     * @memberof ApiWhoWillBringPetSimpleModel
     */
    'id'?: ApiWhoWillBringPet;
    /**
     * Наименование
     * @type {string}
     * @memberof ApiWhoWillBringPetSimpleModel
     */
    'name'?: string | null;
}


/**
 * Активность переписки пользователя
 * @export
 * @interface AppChatActivityResponse
 */
export interface AppChatActivityResponse {
    /**
     * Учётная запись
     * @type {string}
     * @memberof AppChatActivityResponse
     */
    'appUserId'?: string;
    /**
     * Последнее сообщение
     * @type {string}
     * @memberof AppChatActivityResponse
     */
    'lastActivityAt'?: string | null;
    /**
     * Количество переписок
     * @type {number}
     * @memberof AppChatActivityResponse
     */
    'dialogCount'?: number;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const AppType = {
    Undefined: 'undefined',
    VoxClub: 'voxClub',
    VoxWalkers: 'voxWalkers'
} as const;

export type AppType = typeof AppType[keyof typeof AppType];


/**
 * Ролевые, персональные и итоговые права пользователя
 * @export
 * @interface AppUserPermissionsResponse
 */
export interface AppUserPermissionsResponse {
    /**
     * Идентификатор внутреннего пользователя
     * @type {string}
     * @memberof AppUserPermissionsResponse
     */
    'appUserId'?: string;
    /**
     * 
     * @type {ApiUserRoleSimpleModel}
     * @memberof AppUserPermissionsResponse
     */
    'role'?: ApiUserRoleSimpleModel;
    /**
     * Признак доступности пользователя для управления
     * @type {boolean}
     * @memberof AppUserPermissionsResponse
     */
    'isManageable'?: boolean;
    /**
     * Права, назначенные роли
     * @type {Array<string>}
     * @memberof AppUserPermissionsResponse
     */
    'rolePermissionIds'?: Array<string> | null;
    /**
     * Права, разрешённые персонально
     * @type {Array<string>}
     * @memberof AppUserPermissionsResponse
     */
    'allowedPermissionIds'?: Array<string> | null;
    /**
     * Права, запрещённые персонально
     * @type {Array<string>}
     * @memberof AppUserPermissionsResponse
     */
    'deniedPermissionIds'?: Array<string> | null;
    /**
     * Итоговые права пользователя
     * @type {Array<string>}
     * @memberof AppUserPermissionsResponse
     */
    'effectivePermissionIds'?: Array<string> | null;
    /**
     * Итоговые административные права и причины конфликтов
     * @type {Array<AdminPermissionStateResponse>}
     * @memberof AppUserPermissionsResponse
     */
    'administrativePermissions'?: Array<AdminPermissionStateResponse> | null;
    /**
     * Версия набора прав пользователя
     * @type {string}
     * @memberof AppUserPermissionsResponse
     */
    'version'?: string | null;
}
/**
 * Текст оповещения о версии приложения
 * @export
 * @interface AppVersionNotificationTemplateResponse
 */
export interface AppVersionNotificationTemplateResponse {
    /**
     * Заголовок уведомления
     * @type {string}
     * @memberof AppVersionNotificationTemplateResponse
     */
    'title'?: string | null;
    /**
     * Текст уведомления
     * @type {string}
     * @memberof AppVersionNotificationTemplateResponse
     */
    'message'?: string | null;
}
/**
 * 
 * @export
 * @interface AppVersionResponse
 */
export interface AppVersionResponse {
    /**
     * Идентификатор версии приложения
     * @type {string}
     * @memberof AppVersionResponse
     */
    'id'?: string;
    /**
     * Идентификатор приложения в магазине
     * @type {string}
     * @memberof AppVersionResponse
     */
    'appName'?: string | null;
    /**
     * 
     * @type {AppType}
     * @memberof AppVersionResponse
     */
    'appType'?: AppType;
    /**
     * Минимально поддерживаемая версия
     * @type {string}
     * @memberof AppVersionResponse
     */
    'minimumVersion'?: string | null;
    /**
     * Последняя версия приложения
     * @type {string}
     * @memberof AppVersionResponse
     */
    'latestVersion'?: string | null;
    /**
     * Ссылка на приложение в App Store
     * @type {string}
     * @memberof AppVersionResponse
     */
    'appStoreUrl'?: string | null;
    /**
     * Ссылка на приложение в Google Play
     * @type {string}
     * @memberof AppVersionResponse
     */
    'playMarketUrl'?: string | null;
    /**
     * 
     * @type {PlatformType}
     * @memberof AppVersionResponse
     */
    'platform'?: PlatformType;
}


/**
 * Запрос на применение бонусных баллов
 * @export
 * @interface ApplyBonusPointsRequest
 */
export interface ApplyBonusPointsRequest {
    /**
     * Удалить применение бонусных баллов
     * @type {boolean}
     * @memberof ApplyBonusPointsRequest
     */
    'isRemove'?: boolean;
    /**
     * Количество бонусных баллов
     * @type {number}
     * @memberof ApplyBonusPointsRequest
     */
    'amount'?: number;
}
/**
 * 
 * @export
 * @interface ApplyCustomServiceRequest
 */
export interface ApplyCustomServiceRequest {
    /**
     * Наименование услуги
     * @type {string}
     * @memberof ApplyCustomServiceRequest
     */
    'name'?: string | null;
    /**
     * Цена за услугу
     * @type {number}
     * @memberof ApplyCustomServiceRequest
     */
    'price'?: number | null;
    /**
     * Вознаграждение исполнителю за услугу
     * @type {number}
     * @memberof ApplyCustomServiceRequest
     */
    'executorReward'?: number | null;
}
/**
 * Запрос на применение промокода
 * @export
 * @interface ApplyPromoCodeRequest
 */
export interface ApplyPromoCodeRequest {
    /**
     * Удалить использование промокода
     * @type {boolean}
     * @memberof ApplyPromoCodeRequest
     */
    'isRemove'?: boolean;
    /**
     * Номер промокода
     * @type {string}
     * @memberof ApplyPromoCodeRequest
     */
    'number'?: string | null;
}
/**
 * 
 * @export
 * @interface ApproveOrderExecutorRequest
 */
export interface ApproveOrderExecutorRequest {
    /**
     * Идентификатор заказа
     * @type {string}
     * @memberof ApproveOrderExecutorRequest
     */
    'orderId'?: string;
    /**
     * Комментарий
     * @type {string}
     * @memberof ApproveOrderExecutorRequest
     */
    'comment'?: string | null;
}
/**
 * Назначение настроенного диалога пользователю
 * @export
 * @interface AssignDialogTemplateRequest
 */
export interface AssignDialogTemplateRequest {
    /**
     * Получатель диалога
     * @type {string}
     * @memberof AssignDialogTemplateRequest
     */
    'appUserId'?: string;
    /**
     * Заказ диалога
     * @type {string}
     * @memberof AssignDialogTemplateRequest
     */
    'orderId'?: string | null;
    /**
     * Время доступности диалога
     * @type {string}
     * @memberof AssignDialogTemplateRequest
     */
    'activeFrom'?: string | null;
    /**
     * Срок действия диалога
     * @type {string}
     * @memberof AssignDialogTemplateRequest
     */
    'expiresAt'?: string | null;
}
/**
 * 
 * @export
 * @interface AssignExecutorToOrderRequest
 */
export interface AssignExecutorToOrderRequest {
    /**
     * Идентификатор заказа
     * @type {string}
     * @memberof AssignExecutorToOrderRequest
     */
    'orderId'?: string;
    /**
     * Идентификатор Исполнителя
     * @type {string}
     * @memberof AssignExecutorToOrderRequest
     */
    'executorId'?: string;
    /**
     * Идентификатор Адреса, который принадлежит Исполнителю
     * @type {string}
     * @memberof AssignExecutorToOrderRequest
     */
    'executorAddressId'?: string;
    /**
     * Комментарий
     * @type {string}
     * @memberof AssignExecutorToOrderRequest
     */
    'comment'?: string | null;
}
/**
 * 
 * @export
 * @interface AuditChangeResponse
 */
export interface AuditChangeResponse {
    /**
     * 
     * @type {string}
     * @memberof AuditChangeResponse
     */
    'field'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AuditChangeResponse
     */
    'oldValue'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AuditChangeResponse
     */
    'newValue'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof AuditChangeResponse
     */
    'added'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof AuditChangeResponse
     */
    'removed'?: Array<string> | null;
}
/**
 * Запись истории изменений
 * @export
 * @interface AuditEntryResponse
 */
export interface AuditEntryResponse {
    /**
     * Идентификатор записи
     * @type {string}
     * @memberof AuditEntryResponse
     */
    'id'?: string;
    /**
     * Время изменения
     * @type {string}
     * @memberof AuditEntryResponse
     */
    'created'?: string;
    /**
     * Действие над сущностью
     * @type {string}
     * @memberof AuditEntryResponse
     */
    'action'?: string | null;
    /**
     * Имя сотрудника
     * @type {string}
     * @memberof AuditEntryResponse
     */
    'userName'?: string | null;
    /**
     * Название связанной сущности
     * @type {string}
     * @memberof AuditEntryResponse
     */
    'subject'?: string | null;
    /**
     * Изменённые поля
     * @type {Array<AuditChangeResponse>}
     * @memberof AuditEntryResponse
     */
    'changesList'?: Array<AuditChangeResponse> | null;
}
/**
 * 
 * @export
 * @interface AuditGroupResponse
 */
export interface AuditGroupResponse {
    /**
     * 
     * @type {string}
     * @memberof AuditGroupResponse
     */
    'date'?: string | null;
    /**
     * 
     * @type {Array<AuditEntryResponse>}
     * @memberof AuditGroupResponse
     */
    'entries'?: Array<AuditEntryResponse> | null;
}
/**
 * Страница истории изменений
 * @export
 * @interface AuditHistoryResponse
 */
export interface AuditHistoryResponse {
    /**
     * Группы изменений по датам
     * @type {Array<AuditGroupResponse>}
     * @memberof AuditHistoryResponse
     */
    'groups'?: Array<AuditGroupResponse> | null;
    /**
     * Номер страницы
     * @type {number}
     * @memberof AuditHistoryResponse
     */
    'page'?: number;
    /**
     * Размер страницы
     * @type {number}
     * @memberof AuditHistoryResponse
     */
    'pageSize'?: number;
    /**
     * Общее число изменений
     * @type {number}
     * @memberof AuditHistoryResponse
     */
    'totalCount'?: number;
}
/**
 * 
 * @export
 * @interface AvatarResponse
 */
export interface AvatarResponse {
    /**
     * 
     * @type {string}
     * @memberof AvatarResponse
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof AvatarResponse
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AvatarResponse
     */
    'url'?: string | null;
}
/**
 * 
 * @export
 * @interface BankResponse
 */
export interface BankResponse {
    /**
     * 
     * @type {string}
     * @memberof BankResponse
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof BankResponse
     */
    'bik'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof BankResponse
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof BankResponse
     */
    'iconUrl'?: string | null;
}
/**
 * 
 * @export
 * @interface BaseMessageItem
 */
export interface BaseMessageItem {
    /**
     * 
     * @type {string}
     * @memberof BaseMessageItem
     */
    'messageUuid'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof BaseMessageItem
     */
    'code'?: number;
}
/**
 * 
 * @export
 * @interface BaseProductsForOrderResponse
 */
export interface BaseProductsForOrderResponse {
    /**
     * 
     * @type {Array<ProductForOrderResponse>}
     * @memberof BaseProductsForOrderResponse
     */
    'baseOfferedProducts'?: Array<ProductForOrderResponse> | null;
}
/**
 * Привязка существующей сделки RocketWork к заказу
 * @export
 * @interface BindOrderTaskRequest
 */
export interface BindOrderTaskRequest {
    /**
     * Идентификатор сделки RocketWork
     * @type {number}
     * @memberof BindOrderTaskRequest
     */
    'taskId'?: number;
    /**
     * Идентификатор заказа VOX
     * @type {string}
     * @memberof BindOrderTaskRequest
     */
    'orderId'?: string;
}
/**
 * 
 * @export
 * @interface BlockRequest
 */
export interface BlockRequest {
    /**
     * Причина
     * @type {string}
     * @memberof BlockRequest
     */
    'reason': string | null;
}
/**
 * 
 * @export
 * @interface BlogPostResponse
 */
export interface BlogPostResponse {
    /**
     * 
     * @type {string}
     * @memberof BlogPostResponse
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof BlogPostResponse
     */
    'created'?: string;
    /**
     * 
     * @type {string}
     * @memberof BlogPostResponse
     */
    'updated'?: string;
    /**
     * 
     * @type {string}
     * @memberof BlogPostResponse
     */
    'title'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof BlogPostResponse
     */
    'imageUrl'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof BlogPostResponse
     */
    'duration'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof BlogPostResponse
     */
    'content'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof BlogPostResponse
     */
    'author'?: string | null;
    /**
     * 
     * @type {ApiBlogPostAudienceSimpleModel}
     * @memberof BlogPostResponse
     */
    'audience'?: ApiBlogPostAudienceSimpleModel;
    /**
     * 
     * @type {boolean}
     * @memberof BlogPostResponse
     */
    'isShowServices'?: boolean;
}
/**
 * Данные бонусного счёта с уровнями и операциями
 * @export
 * @interface BonusAccountResponse
 */
export interface BonusAccountResponse {
    /**
     * Номер бонусного счёта
     * @type {number}
     * @memberof BonusAccountResponse
     */
    'bonusAccountNumber'?: number;
    /**
     * Идентификатор бонусного счёта
     * @type {string}
     * @memberof BonusAccountResponse
     */
    'id'?: string;
    /**
     * Идентификатор клиента
     * @type {string}
     * @memberof BonusAccountResponse
     */
    'clientId'?: string;
    /**
     * Имя клиента
     * @type {string}
     * @memberof BonusAccountResponse
     */
    'clientName'?: string | null;
    /**
     * 
     * @type {ApiBonusAccountStateSimpleModel}
     * @memberof BonusAccountResponse
     */
    'state'?: ApiBonusAccountStateSimpleModel;
    /**
     * Активный баланс
     * @type {number}
     * @memberof BonusAccountResponse
     */
    'activeBalance'?: number;
    /**
     * Сумма оплат в рублях за расчётный период текущего уровня
     * @type {number}
     * @memberof BonusAccountResponse
     */
    'currentLevelOrdersAmount'?: number | null;
    /**
     * Сумма заказов, учитываемая для следующего уровня
     * @type {number}
     * @memberof BonusAccountResponse
     */
    'qualifyingOrdersAmount'?: number | null;
    /**
     * Количество дней в периоде расчёта следующего уровня
     * @type {number}
     * @memberof BonusAccountResponse
     */
    'levelCalculationPeriodDays'?: number | null;
    /**
     * 
     * @type {CashbackLevelResponse}
     * @memberof BonusAccountResponse
     */
    'cashbackLevel'?: CashbackLevelResponse;
    /**
     * 
     * @type {CashbackLevelResponse}
     * @memberof BonusAccountResponse
     */
    'nextCashbackLevel'?: CashbackLevelResponse;
    /**
     * Транзакции счёта
     * @type {Array<BonusTransactionResponse>}
     * @memberof BonusAccountResponse
     */
    'transactions'?: Array<BonusTransactionResponse> | null;
}
/**
 * Краткие данные бонусного счёта
 * @export
 * @interface BonusAccountShortResponse
 */
export interface BonusAccountShortResponse {
    /**
     * Идентификатор бонусного счёта
     * @type {string}
     * @memberof BonusAccountShortResponse
     */
    'id'?: string;
    /**
     * Номер бонусного счёта
     * @type {number}
     * @memberof BonusAccountShortResponse
     */
    'bonusAccountNumber'?: number;
    /**
     * 
     * @type {ApiBonusAccountStateSimpleModel}
     * @memberof BonusAccountShortResponse
     */
    'state'?: ApiBonusAccountStateSimpleModel;
    /**
     * Активный баланс
     * @type {number}
     * @memberof BonusAccountShortResponse
     */
    'activeBalance'?: number;
    /**
     * 
     * @type {ClientResponse}
     * @memberof BonusAccountShortResponse
     */
    'client'?: ClientResponse;
    /**
     * 
     * @type {CashbackLevelResponse}
     * @memberof BonusAccountShortResponse
     */
    'cashbackLevel'?: CashbackLevelResponse;
}
/**
 * Поля сортировки бонусных счетов
 * @export
 * @enum {string}
 */

export const BonusAccountSortField = {
    BonusAccountNumber: 'bonusAccountNumber',
    State: 'state',
    ActiveBalance: 'activeBalance'
} as const;

export type BonusAccountSortField = typeof BonusAccountSortField[keyof typeof BonusAccountSortField];


/**
 * Детализация начисления бонусов и использования его остатка
 * @export
 * @interface BonusAccrualDetailsResponse
 */
export interface BonusAccrualDetailsResponse {
    /**
     * 
     * @type {BonusTransactionResponse}
     * @memberof BonusAccrualDetailsResponse
     */
    'transaction'?: BonusTransactionResponse;
    /**
     * 
     * @type {ApiOrderStatusSimpleModel}
     * @memberof BonusAccrualDetailsResponse
     */
    'orderStatus'?: ApiOrderStatusSimpleModel;
    /**
     * База начисления в рублях на момент оплаты
     * @type {number}
     * @memberof BonusAccrualDetailsResponse
     */
    'cashbackBaseAmount'?: number | null;
    /**
     * Процент начисления на момент оплаты
     * @type {number}
     * @memberof BonusAccrualDetailsResponse
     */
    'cashbackPercent'?: number | null;
    /**
     * Использовано из начисления без возвращённых списаний
     * @type {number}
     * @memberof BonusAccrualDetailsResponse
     */
    'usedAmount'?: number;
    /**
     * Зарезервировано из начисления
     * @type {number}
     * @memberof BonusAccrualDetailsResponse
     */
    'heldAmount'?: number;
    /**
     * Сгорело из начисления
     * @type {number}
     * @memberof BonusAccrualDetailsResponse
     */
    'expiredAmount'?: number;
    /**
     * Списано при отмене начисления или погашении долга
     * @type {number}
     * @memberof BonusAccrualDetailsResponse
     */
    'reversedAmount'?: number;
    /**
     * Операции с долей суммы, взятой из этого начисления
     * @type {Array<BonusTransactionResponse>}
     * @memberof BonusAccrualDetailsResponse
     */
    'relatedOperations'?: Array<BonusTransactionResponse> | null;
}
/**
 * 
 * @export
 * @interface BonusBalanceResponse
 */
export interface BonusBalanceResponse {
    /**
     * Номер бонусного счёта
     * @type {number}
     * @memberof BonusBalanceResponse
     */
    'bonusAccountNumber'?: number;
    /**
     * Идентификатор бонусного счёта
     * @type {string}
     * @memberof BonusBalanceResponse
     */
    'accountId'?: string;
    /**
     * Идентификатор клиента
     * @type {string}
     * @memberof BonusBalanceResponse
     */
    'clientId'?: string;
    /**
     * 
     * @type {ApiBonusAccountStateSimpleModel}
     * @memberof BonusBalanceResponse
     */
    'state'?: ApiBonusAccountStateSimpleModel;
    /**
     * Активный баланс
     * @type {number}
     * @memberof BonusBalanceResponse
     */
    'activeBalance'?: number;
}
/**
 * Детализация списания или сгорания бонусов
 * @export
 * @interface BonusDebitDetailsResponse
 */
export interface BonusDebitDetailsResponse {
    /**
     * 
     * @type {BonusTransactionResponse}
     * @memberof BonusDebitDetailsResponse
     */
    'transaction'?: BonusTransactionResponse;
    /**
     * 
     * @type {ApiOrderStatusSimpleModel}
     * @memberof BonusDebitDetailsResponse
     */
    'orderStatus'?: ApiOrderStatusSimpleModel;
    /**
     * Списание возвращено владельцу
     * @type {boolean}
     * @memberof BonusDebitDetailsResponse
     */
    'isRefunded'?: boolean;
    /**
     * Источники списанных бонусов
     * @type {Array<BonusDebitSourceResponse>}
     * @memberof BonusDebitDetailsResponse
     */
    'sources'?: Array<BonusDebitSourceResponse> | null;
}
/**
 * Доля списания из исходного начисления
 * @export
 * @interface BonusDebitSourceResponse
 */
export interface BonusDebitSourceResponse {
    /**
     * 
     * @type {BonusTransactionResponse}
     * @memberof BonusDebitSourceResponse
     */
    'accrual'?: BonusTransactionResponse;
    /**
     * Сумма операции из этого начисления
     * @type {number}
     * @memberof BonusDebitSourceResponse
     */
    'amount'?: number;
    /**
     * Дата сгорания использованных бонусов
     * @type {string}
     * @memberof BonusDebitSourceResponse
     */
    'expiresAt'?: string;
}
/**
 * 
 * @export
 * @interface BonusOperationResponse
 */
export interface BonusOperationResponse {
    /**
     * Баланс после операции
     * @type {number}
     * @memberof BonusOperationResponse
     */
    'activeBalance'?: number;
    /**
     * 
     * @type {BonusTransactionResponse}
     * @memberof BonusOperationResponse
     */
    'transaction'?: BonusTransactionResponse;
}
/**
 * 
 * @export
 * @interface BonusTransactionAllocationResponse
 */
export interface BonusTransactionAllocationResponse {
    /**
     * Идентификатор транзакции начисления
     * @type {string}
     * @memberof BonusTransactionAllocationResponse
     */
    'accrualTransactionId'?: string;
    /**
     * Сумма списания из начисления
     * @type {number}
     * @memberof BonusTransactionAllocationResponse
     */
    'amount'?: number;
}
/**
 * 
 * @export
 * @interface BonusTransactionResponse
 */
export interface BonusTransactionResponse {
    /**
     * Идентификатор транзакции
     * @type {string}
     * @memberof BonusTransactionResponse
     */
    'id'?: string;
    /**
     * Идентификатор бизнес-операции
     * @type {string}
     * @memberof BonusTransactionResponse
     */
    'operationId'?: string;
    /**
     * Идентификатор заказа
     * @type {string}
     * @memberof BonusTransactionResponse
     */
    'orderId'?: string | null;
    /**
     * Идентификатор платежа
     * @type {string}
     * @memberof BonusTransactionResponse
     */
    'paymentId'?: string | null;
    /**
     * Идентификатор связанной исходной транзакции
     * @type {string}
     * @memberof BonusTransactionResponse
     */
    'relatedTransactionId'?: string | null;
    /**
     * Признак действующего резерва бонусных баллов
     * @type {boolean}
     * @memberof BonusTransactionResponse
     */
    'isActiveHold'?: boolean;
    /**
     * 
     * @type {ApiBonusTransactionTypeSimpleModel}
     * @memberof BonusTransactionResponse
     */
    'type'?: ApiBonusTransactionTypeSimpleModel;
    /**
     * Наименование услуги или типа операции
     * @type {string}
     * @memberof BonusTransactionResponse
     */
    'serviceName'?: string | null;
    /**
     * Сумма транзакции
     * @type {number}
     * @memberof BonusTransactionResponse
     */
    'amount'?: number;
    /**
     * Дата транзакции
     * @type {string}
     * @memberof BonusTransactionResponse
     */
    'created'?: string;
    /**
     * Описание операции
     * @type {string}
     * @memberof BonusTransactionResponse
     */
    'description'?: string | null;
    /**
     * Дата сгорания начисления
     * @type {string}
     * @memberof BonusTransactionResponse
     */
    'expiresAt'?: string | null;
    /**
     * Дата, с которой начисленные бонусы можно использовать
     * @type {string}
     * @memberof BonusTransactionResponse
     */
    'activatesAt'?: string | null;
    /**
     * Остаток бонусов, ожидающих активации
     * @type {number}
     * @memberof BonusTransactionResponse
     */
    'pendingAmount'?: number;
    /**
     * Остаток начисленных баллов
     * @type {number}
     * @memberof BonusTransactionResponse
     */
    'remainingAmount'?: number | null;
    /**
     * Распределения списания по начислениям
     * @type {Array<BonusTransactionAllocationResponse>}
     * @memberof BonusTransactionResponse
     */
    'allocations'?: Array<BonusTransactionAllocationResponse> | null;
}
/**
 * Раздел управления кэшем
 * @export
 * @interface CacheResponse
 */
export interface CacheResponse {
    /**
     * Стабильное имя кэша
     * @type {string}
     * @memberof CacheResponse
     */
    'name'?: string | null;
    /**
     * Название раздела
     * @type {string}
     * @memberof CacheResponse
     */
    'displayName'?: string | null;
    /**
     * Тип идентификатора записи
     * @type {string}
     * @memberof CacheResponse
     */
    'idType'?: string | null;
}
/**
 * 
 * @export
 * @interface CancelOrderRequest
 */
export interface CancelOrderRequest {
    /**
     * Будет ли штраф за отмену заказа
     * @type {boolean}
     * @memberof CancelOrderRequest
     */
    'hasPenalty'?: boolean;
    /**
     * Идентификатор заказа
     * @type {string}
     * @memberof CancelOrderRequest
     */
    'orderId'?: string | null;
    /**
     * 
     * @type {ApiOrderCancelType}
     * @memberof CancelOrderRequest
     */
    'cancelType'?: ApiOrderCancelType;
    /**
     * Описание причины (только для Custom)
     * @type {string}
     * @memberof CancelOrderRequest
     */
    'description'?: string | null;
    /**
     * Исполнитель-инициатор отмены заказа
     * @type {string}
     * @memberof CancelOrderRequest
     */
    'executorId'?: string | null;
    /**
     * Клиент-инициатор отмены заказа
     * @type {string}
     * @memberof CancelOrderRequest
     */
    'clientId'?: string | null;
    /**
     * Отмена администратором
     * @type {boolean}
     * @memberof CancelOrderRequest
     */
    'isAdminCancel'?: boolean;
    /**
     * Комментарий (для администратора)
     * @type {string}
     * @memberof CancelOrderRequest
     */
    'comment'?: string | null;
}


/**
 * 
 * @export
 * @interface CancelTaskRequest
 */
export interface CancelTaskRequest {
    /**
     * Идентификатор сделки
     * @type {number}
     * @memberof CancelTaskRequest
     */
    'taskId'?: number;
    /**
     * Комментарий
     * @type {string}
     * @memberof CancelTaskRequest
     */
    'comment'?: string | null;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const CanceledBy = {
    Undefined: 'undefined',
    Customer: 'customer',
    Executor: 'executor'
} as const;

export type CanceledBy = typeof CanceledBy[keyof typeof CanceledBy];


/**
 * 
 * @export
 * @interface CashbackLevelResponse
 */
export interface CashbackLevelResponse {
    /**
     * Название уровня
     * @type {string}
     * @memberof CashbackLevelResponse
     */
    'name'?: string | null;
    /**
     * Идентификатор уровня
     * @type {string}
     * @memberof CashbackLevelResponse
     */
    'id'?: string;
    /**
     * Порядковый номер уровня
     * @type {number}
     * @memberof CashbackLevelResponse
     */
    'value'?: number;
    /**
     * Надбавка к базовому проценту
     * @type {number}
     * @memberof CashbackLevelResponse
     */
    'additionalCashbackPercent'?: number;
    /**
     * Итоговый процент кэшбэка
     * @type {number}
     * @memberof CashbackLevelResponse
     */
    'cashbackPercent'?: number;
    /**
     * Порог суммы заказов
     * @type {number}
     * @memberof CashbackLevelResponse
     */
    'requiredOrdersAmount'?: number;
    /**
     * Период расчёта суммы заказов в днях
     * @type {number}
     * @memberof CashbackLevelResponse
     */
    'calculationPeriodDays'?: number;
}
/**
 * Раздел правил бонусной программы
 * @export
 * @interface CashbackRuleSectionModel
 */
export interface CashbackRuleSectionModel {
    /**
     * Ключ раздела
     * @type {string}
     * @memberof CashbackRuleSectionModel
     */
    'key'?: string | null;
    /**
     * Заголовок раздела
     * @type {string}
     * @memberof CashbackRuleSectionModel
     */
    'title'?: string | null;
    /**
     * Текст раздела
     * @type {string}
     * @memberof CashbackRuleSectionModel
     */
    'description'?: string | null;
}
/**
 * Содержимое правил бонусной программы
 * @export
 * @interface CashbackRulesResponse
 */
export interface CashbackRulesResponse {
    /**
     * Идентификатор правил
     * @type {string}
     * @memberof CashbackRulesResponse
     */
    'id'?: string;
    /**
     * Дата изменения правил
     * @type {string}
     * @memberof CashbackRulesResponse
     */
    'updated'?: string;
    /**
     * Заголовок экрана
     * @type {string}
     * @memberof CashbackRulesResponse
     */
    'title'?: string | null;
    /**
     * Заголовок вступления
     * @type {string}
     * @memberof CashbackRulesResponse
     */
    'introTitle'?: string | null;
    /**
     * Текст вступления
     * @type {string}
     * @memberof CashbackRulesResponse
     */
    'introDescription'?: string | null;
    /**
     * Пояснение условий оплаты
     * @type {string}
     * @memberof CashbackRulesResponse
     */
    'paymentNotice'?: string | null;
    /**
     * Подпись перехода к уровням
     * @type {string}
     * @memberof CashbackRulesResponse
     */
    'allLevelsButtonText'?: string | null;
    /**
     * Подпись возврата к кэшбеку
     * @type {string}
     * @memberof CashbackRulesResponse
     */
    'returnButtonText'?: string | null;
    /**
     * Разделы правил в порядке показа
     * @type {Array<CashbackRuleSectionModel>}
     * @memberof CashbackRulesResponse
     */
    'sections'?: Array<CashbackRuleSectionModel> | null;
}
/**
 * Запрос смены внутренней роли пользователя
 * @export
 * @interface ChangeAccessAppUserRoleRequest
 */
export interface ChangeAccessAppUserRoleRequest {
    /**
     * 
     * @type {ApiUserRole}
     * @memberof ChangeAccessAppUserRoleRequest
     */
    'role'?: ApiUserRole;
    /**
     * Ожидаемая версия набора прав пользователя
     * @type {string}
     * @memberof ChangeAccessAppUserRoleRequest
     */
    'expectedVersion'?: string | null;
}


/**
 * Результат смены роли внутреннего пользователя
 * @export
 * @interface ChangeAccessAppUserRoleResponse
 */
export interface ChangeAccessAppUserRoleResponse {
    /**
     * 
     * @type {AccessAppUserResponse}
     * @memberof ChangeAccessAppUserRoleResponse
     */
    'appUser'?: AccessAppUserResponse;
    /**
     * 
     * @type {AppUserPermissionsResponse}
     * @memberof ChangeAccessAppUserRoleResponse
     */
    'permissions'?: AppUserPermissionsResponse;
    /**
     * Признак фактической смены роли
     * @type {boolean}
     * @memberof ChangeAccessAppUserRoleResponse
     */
    'roleChanged'?: boolean;
    /**
     * Количество удалённых персональных исключений
     * @type {number}
     * @memberof ChangeAccessAppUserRoleResponse
     */
    'clearedPermissionOverrideCount'?: number;
}
/**
 * 
 * @export
 * @interface ChangeBonusAccountRequest
 */
export interface ChangeBonusAccountRequest {
    /**
     * Комментарий администратора
     * @type {string}
     * @memberof ChangeBonusAccountRequest
     */
    'comment'?: string | null;
}
/**
 * Запрос изменения состояния задачи
 * @export
 * @interface ChangeOperatorTaskStatusRequest
 */
export interface ChangeOperatorTaskStatusRequest {
    /**
     * Версия задачи
     * @type {string}
     * @memberof ChangeOperatorTaskStatusRequest
     */
    'version'?: string;
}
/**
 * Вложение переписки
 * @export
 * @interface ChatDialogAttachmentResponse
 */
export interface ChatDialogAttachmentResponse {
    /**
     * Вложение
     * @type {string}
     * @memberof ChatDialogAttachmentResponse
     */
    'id'?: string;
    /**
     * Позиция в сообщении
     * @type {number}
     * @memberof ChatDialogAttachmentResponse
     */
    'position'?: number;
    /**
     * 
     * @type {ApiChatAttachmentKindSimpleModel}
     * @memberof ChatDialogAttachmentResponse
     */
    'kind'?: ApiChatAttachmentKindSimpleModel;
    /**
     * Адрес вложения
     * @type {string}
     * @memberof ChatDialogAttachmentResponse
     */
    'url'?: string | null;
    /**
     * Имя файла
     * @type {string}
     * @memberof ChatDialogAttachmentResponse
     */
    'fileName'?: string | null;
    /**
     * Тип содержимого
     * @type {string}
     * @memberof ChatDialogAttachmentResponse
     */
    'mimeType'?: string | null;
    /**
     * Размер в байтах
     * @type {number}
     * @memberof ChatDialogAttachmentResponse
     */
    'sizeBytes'?: number | null;
    /**
     * Адрес превью
     * @type {string}
     * @memberof ChatDialogAttachmentResponse
     */
    'previewUrl'?: string | null;
}
/**
 * Счётчики переписки
 * @export
 * @interface ChatDialogCountersResponse
 */
export interface ChatDialogCountersResponse {
    /**
     * Количество непрочитанных сообщений
     * @type {number}
     * @memberof ChatDialogCountersResponse
     */
    'unreadMessages'?: number;
    /**
     * Количество диалогов с непрочитанными сообщениями
     * @type {number}
     * @memberof ChatDialogCountersResponse
     */
    'unreadDialogs'?: number;
}
/**
 * Страница истории диалога
 * @export
 * @interface ChatDialogMessagePageResponse
 */
export interface ChatDialogMessagePageResponse {
    /**
     * Сообщения в порядке переписки
     * @type {Array<ChatDialogMessageResponse>}
     * @memberof ChatDialogMessagePageResponse
     */
    'items'?: Array<ChatDialogMessageResponse> | null;
    /**
     * Граница следующей страницы старых сообщений
     * @type {number}
     * @memberof ChatDialogMessagePageResponse
     */
    'nextBeforeSequence'?: number | null;
    /**
     * Граница следующей страницы новых сообщений
     * @type {number}
     * @memberof ChatDialogMessagePageResponse
     */
    'nextAfterSequence'?: number | null;
}
/**
 * Сообщение переписки
 * @export
 * @interface ChatDialogMessageResponse
 */
export interface ChatDialogMessageResponse {
    /**
     * Автор ответа от имени принимающего аккаунта
     * @type {string}
     * @memberof ChatDialogMessageResponse
     */
    'authorParticipantId'?: string | null;
    /**
     * Учётная запись фактического автора
     * @type {string}
     * @memberof ChatDialogMessageResponse
     */
    'authorAppUserId'?: string | null;
    /**
     * Имя автора ответа
     * @type {string}
     * @memberof ChatDialogMessageResponse
     */
    'authorName'?: string | null;
    /**
     * Сообщение
     * @type {string}
     * @memberof ChatDialogMessageResponse
     */
    'id'?: string;
    /**
     * Идентификатор отправки приложения
     * @type {string}
     * @memberof ChatDialogMessageResponse
     */
    'clientMessageId'?: string | null;
    /**
     * Завершившаяся попытка, для которой разрешён ручной повтор
     * @type {string}
     * @memberof ChatDialogMessageResponse
     */
    'retryAttemptId'?: string | null;
    /**
     * Порядковый номер в диалоге
     * @type {number}
     * @memberof ChatDialogMessageResponse
     */
    'sequence'?: number;
    /**
     * Отправитель
     * @type {string}
     * @memberof ChatDialogMessageResponse
     */
    'senderParticipantId'?: string;
    /**
     * Имя отправителя
     * @type {string}
     * @memberof ChatDialogMessageResponse
     */
    'senderName'?: string | null;
    /**
     * Аватар отправителя
     * @type {string}
     * @memberof ChatDialogMessageResponse
     */
    'senderAvatarUrl'?: string | null;
    /**
     * Отправлено от принимающего аккаунта
     * @type {boolean}
     * @memberof ChatDialogMessageResponse
     */
    'isOutgoing'?: boolean;
    /**
     * Текст сообщения
     * @type {string}
     * @memberof ChatDialogMessageResponse
     */
    'text'?: string | null;
    /**
     * 
     * @type {ApiChatMessageKindSimpleModel}
     * @memberof ChatDialogMessageResponse
     */
    'kind'?: ApiChatMessageKindSimpleModel;
    /**
     * Время приёма сообщения
     * @type {string}
     * @memberof ChatDialogMessageResponse
     */
    'receivedAt'?: string;
    /**
     * Время подтверждения отправки
     * @type {string}
     * @memberof ChatDialogMessageResponse
     */
    'sentAt'?: string | null;
    /**
     * 
     * @type {ApiChatMessageSendStatusSimpleModel}
     * @memberof ChatDialogMessageResponse
     */
    'sendStatus'?: ApiChatMessageSendStatusSimpleModel;
    /**
     * 
     * @type {ApiChatReadStateSimpleModel}
     * @memberof ChatDialogMessageResponse
     */
    'readState'?: ApiChatReadStateSimpleModel;
    /**
     * Вложения сообщения
     * @type {Array<ChatDialogAttachmentResponse>}
     * @memberof ChatDialogMessageResponse
     */
    'attachments'?: Array<ChatDialogAttachmentResponse> | null;
    /**
     * Версия редактирования
     * @type {number}
     * @memberof ChatDialogMessageResponse
     */
    'editVersion'?: number;
    /**
     * Время последнего редактирования
     * @type {string}
     * @memberof ChatDialogMessageResponse
     */
    'editedAt'?: string | null;
}
/**
 * Страница диалогов
 * @export
 * @interface ChatDialogPageResponse
 */
export interface ChatDialogPageResponse {
    /**
     * Учётные записи, удовлетворяющие поиску; null означает отсутствие ограничения
     * @type {Array<string>}
     * @memberof ChatDialogPageResponse
     */
    'matchedAppUserIds'?: Array<string> | null;
    /**
     * Общее количество диалогов с учётом условий поиска
     * @type {number}
     * @memberof ChatDialogPageResponse
     */
    'totalCount'?: number;
    /**
     * Диалоги страницы
     * @type {Array<ChatDialogResponse>}
     * @memberof ChatDialogPageResponse
     */
    'items'?: Array<ChatDialogResponse> | null;
    /**
     * Смещение следующей страницы
     * @type {number}
     * @memberof ChatDialogPageResponse
     */
    'nextOffset'?: number | null;
}
/**
 * Диалог с пользователем
 * @export
 * @interface ChatDialogResponse
 */
export interface ChatDialogResponse {
    /**
     * Время общего закрепления операторов
     * @type {string}
     * @memberof ChatDialogResponse
     */
    'operatorPinnedAt'?: string | null;
    /**
     * Рассчитанный приоритет диалога в списке
     * @type {number}
     * @memberof ChatDialogResponse
     */
    'sortIndex'?: number;
    /**
     * Диалог
     * @type {string}
     * @memberof ChatDialogResponse
     */
    'id'?: string;
    /**
     * Собеседник
     * @type {string}
     * @memberof ChatDialogResponse
     */
    'companionId'?: string;
    /**
     * Учётная запись собеседника
     * @type {string}
     * @memberof ChatDialogResponse
     */
    'companionAppUserId'?: string | null;
    /**
     * 
     * @type {ApiUserRoleSimpleModel}
     * @memberof ChatDialogResponse
     */
    'companionRole'?: ApiUserRoleSimpleModel;
    /**
     * Имя собеседника
     * @type {string}
     * @memberof ChatDialogResponse
     */
    'companionName'?: string | null;
    /**
     * Клички питомцев собеседника
     * @type {Array<string>}
     * @memberof ChatDialogResponse
     */
    'companionPetNames'?: Array<string> | null;
    /**
     * Аватар собеседника
     * @type {string}
     * @memberof ChatDialogResponse
     */
    'companionAvatarUrl'?: string | null;
    /**
     * Идентификатор собеседника в мессенджере
     * @type {string}
     * @memberof ChatDialogResponse
     */
    'messengerUserId'?: string | null;
    /**
     * 
     * @type {ApiChatChannelTypeSimpleModel}
     * @memberof ChatDialogResponse
     */
    'channel'?: ApiChatChannelTypeSimpleModel;
    /**
     * Название принимающего аккаунта
     * @type {string}
     * @memberof ChatDialogResponse
     */
    'accountName'?: string | null;
    /**
     * Время последнего сообщения
     * @type {string}
     * @memberof ChatDialogResponse
     */
    'lastActivityAt'?: string | null;
    /**
     * Счётчик непрочитанных сообщений с учётом ручной отметки
     * @type {number}
     * @memberof ChatDialogResponse
     */
    'unreadCount'?: number;
    /**
     * Ручная отметка диалога как непрочитанного
     * @type {boolean}
     * @memberof ChatDialogResponse
     */
    'isManuallyUnread'?: boolean;
    /**
     * 
     * @type {ChatDialogMessageResponse}
     * @memberof ChatDialogResponse
     */
    'lastMessage'?: ChatDialogMessageResponse;
    /**
     * Время личного закрепления диалога
     * @type {string}
     * @memberof ChatDialogResponse
     */
    'pinnedAt'?: string | null;
}
/**
 * Сохранённая версия сообщения
 * @export
 * @interface ChatMessageEditResponse
 */
export interface ChatMessageEditResponse {
    /**
     * Номер версии
     * @type {number}
     * @memberof ChatMessageEditResponse
     */
    'version'?: number;
    /**
     * Текст до правки
     * @type {string}
     * @memberof ChatMessageEditResponse
     */
    'previousText'?: string | null;
    /**
     * Текст после правки
     * @type {string}
     * @memberof ChatMessageEditResponse
     */
    'text'?: string | null;
    /**
     * Имя автора правки
     * @type {string}
     * @memberof ChatMessageEditResponse
     */
    'editorName'?: string | null;
    /**
     * Пользователь автора правки
     * @type {string}
     * @memberof ChatMessageEditResponse
     */
    'editorAppUserId'?: string | null;
    /**
     * Время правки
     * @type {string}
     * @memberof ChatMessageEditResponse
     */
    'editedAt'?: string;
}
/**
 * Замечание переноса переписки
 * @export
 * @interface ChatMigrationIssueResponse
 */
export interface ChatMigrationIssueResponse {
    /**
     * Замечание
     * @type {string}
     * @memberof ChatMigrationIssueResponse
     */
    'id'?: string;
    /**
     * Исходный объект
     * @type {string}
     * @memberof ChatMigrationIssueResponse
     */
    'sourceKey'?: string | null;
    /**
     * Причина
     * @type {string}
     * @memberof ChatMigrationIssueResponse
     */
    'code'?: string | null;
}
/**
 * Состояние переноса переписки
 * @export
 * @interface ChatMigrationRunResponse
 */
export interface ChatMigrationRunResponse {
    /**
     * Запуск
     * @type {string}
     * @memberof ChatMigrationRunResponse
     */
    'id'?: string;
    /**
     * Запрос запуска
     * @type {string}
     * @memberof ChatMigrationRunResponse
     */
    'requestId'?: string;
    /**
     * Проект Firebase
     * @type {string}
     * @memberof ChatMigrationRunResponse
     */
    'sourceProjectId'?: string | null;
    /**
     * Целевое окружение
     * @type {string}
     * @memberof ChatMigrationRunResponse
     */
    'targetName'?: string | null;
    /**
     * Подключение приложения
     * @type {string}
     * @memberof ChatMigrationRunResponse
     */
    'connectionId'?: string;
    /**
     * Предварительная проверка
     * @type {boolean}
     * @memberof ChatMigrationRunResponse
     */
    'dryRun'?: boolean;
    /**
     * 
     * @type {ApiChatMigrationStatusSimpleModel}
     * @memberof ChatMigrationRunResponse
     */
    'status'?: ApiChatMigrationStatusSimpleModel;
    /**
     * 
     * @type {ApiChatMigrationPhaseSimpleModel}
     * @memberof ChatMigrationRunResponse
     */
    'phase'?: ApiChatMigrationPhaseSimpleModel;
    /**
     * Последняя обработанная позиция
     * @type {string}
     * @memberof ChatMigrationRunResponse
     */
    'cursor'?: string | null;
    /**
     * Документы пользователей
     * @type {number}
     * @memberof ChatMigrationRunResponse
     */
    'usersScanned'?: number;
    /**
     * Документы истории
     * @type {number}
     * @memberof ChatMigrationRunResponse
     */
    'chatsScanned'?: number;
    /**
     * Обработанные диалоги
     * @type {number}
     * @memberof ChatMigrationRunResponse
     */
    'dialogsProcessed'?: number;
    /**
     * Сохранённые сообщения
     * @type {number}
     * @memberof ChatMigrationRunResponse
     */
    'messagesCreated'?: number;
    /**
     * Уже перенесённые сообщения
     * @type {number}
     * @memberof ChatMigrationRunResponse
     */
    'messagesSkipped'?: number;
    /**
     * Сообщения для переноса
     * @type {number}
     * @memberof ChatMigrationRunResponse
     */
    'messagesPlanned'?: number;
    /**
     * Замечания
     * @type {number}
     * @memberof ChatMigrationRunResponse
     */
    'issuesCount'?: number;
    /**
     * Причина приостановки
     * @type {string}
     * @memberof ChatMigrationRunResponse
     */
    'lastErrorCode'?: string | null;
    /**
     * Время запуска
     * @type {string}
     * @memberof ChatMigrationRunResponse
     */
    'created'?: string;
    /**
     * Время изменения
     * @type {string}
     * @memberof ChatMigrationRunResponse
     */
    'updated'?: string;
}
/**
 * Зафиксированное изменение переписки
 * @export
 * @interface ChatRealtimeEventResponse
 */
export interface ChatRealtimeEventResponse {
    /**
     * Версия зафиксированного состояния
     * @type {string}
     * @memberof ChatRealtimeEventResponse
     */
    'revision': string;
    /**
     * Изменённый диалог
     * @type {string}
     * @memberof ChatRealtimeEventResponse
     */
    'dialogId'?: string;
    /**
     * 
     * @type {ChatDialogResponse}
     * @memberof ChatRealtimeEventResponse
     */
    'dialog'?: ChatDialogResponse;
    /**
     * 
     * @type {ChatDialogMessageResponse}
     * @memberof ChatRealtimeEventResponse
     */
    'message'?: ChatDialogMessageResponse;
    /**
     * Удалённое сообщение
     * @type {string}
     * @memberof ChatRealtimeEventResponse
     */
    'removedMessageId'?: string | null;
    /**
     * Подтверждённая граница прочтения
     * @type {number}
     * @memberof ChatRealtimeEventResponse
     */
    'readThroughSequence'?: number;
    /**
     * 
     * @type {ChatDialogCountersResponse}
     * @memberof ChatRealtimeEventResponse
     */
    'counters': ChatDialogCountersResponse;
}
/**
 * Доступ к обновлениям переписки
 * @export
 * @interface ChatRealtimeResponse
 */
export interface ChatRealtimeResponse {
    /**
     * Переписка канала доступна независимо от режима обновлений
     * @type {boolean}
     * @memberof ChatRealtimeResponse
     */
    'isAvailable'?: boolean;
    /**
     * Обновления включены
     * @type {boolean}
     * @memberof ChatRealtimeResponse
     */
    'isEnabled'?: boolean;
    /**
     * Адрес API Supabase
     * @type {string}
     * @memberof ChatRealtimeResponse
     */
    'url'?: string | null;
    /**
     * Публичный ключ Supabase
     * @type {string}
     * @memberof ChatRealtimeResponse
     */
    'publicApiKey'?: string | null;
    /**
     * Разрешение на получение обновлений
     * @type {string}
     * @memberof ChatRealtimeResponse
     */
    'accessToken'?: string | null;
    /**
     * Канал обновлений переписки
     * @type {string}
     * @memberof ChatRealtimeResponse
     */
    'topic'?: string | null;
    /**
     * Срок действия доступа
     * @type {string}
     * @memberof ChatRealtimeResponse
     */
    'expiresAt'?: string | null;
}
/**
 * Согласованное состояние переписки
 * @export
 * @interface ChatRealtimeSnapshotResponse
 */
export interface ChatRealtimeSnapshotResponse {
    /**
     * Версия зафиксированного состояния
     * @type {string}
     * @memberof ChatRealtimeSnapshotResponse
     */
    'revision': string;
    /**
     * 
     * @type {ChatDialogPageResponse}
     * @memberof ChatRealtimeSnapshotResponse
     */
    'dialogs': ChatDialogPageResponse;
    /**
     * Выбранный диалог
     * @type {string}
     * @memberof ChatRealtimeSnapshotResponse
     */
    'dialogId'?: string | null;
    /**
     * 
     * @type {ChatDialogResponse}
     * @memberof ChatRealtimeSnapshotResponse
     */
    'selectedDialog'?: ChatDialogResponse;
    /**
     * 
     * @type {ChatDialogMessagePageResponse}
     * @memberof ChatRealtimeSnapshotResponse
     */
    'history'?: ChatDialogMessagePageResponse;
    /**
     * 
     * @type {ChatDialogCountersResponse}
     * @memberof ChatRealtimeSnapshotResponse
     */
    'counters': ChatDialogCountersResponse;
    /**
     * Подтверждённая граница прочтения
     * @type {number}
     * @memberof ChatRealtimeSnapshotResponse
     */
    'readThroughSequence'?: number;
}
/**
 * Каталог шаблонов сообщений чата
 * @export
 * @interface ChatReplyCatalogResponse
 */
export interface ChatReplyCatalogResponse {
    /**
     * Папки шаблонов
     * @type {Array<ChatReplyFolderResponse>}
     * @memberof ChatReplyCatalogResponse
     */
    'folders'?: Array<ChatReplyFolderResponse> | null;
    /**
     * Шаблоны сообщений
     * @type {Array<ChatReplyTemplateResponse>}
     * @memberof ChatReplyCatalogResponse
     */
    'templates'?: Array<ChatReplyTemplateResponse> | null;
}
/**
 * Папка шаблонов чата
 * @export
 * @interface ChatReplyFolderResponse
 */
export interface ChatReplyFolderResponse {
    /**
     * Идентификатор
     * @type {string}
     * @memberof ChatReplyFolderResponse
     */
    'id'?: string;
    /**
     * Название
     * @type {string}
     * @memberof ChatReplyFolderResponse
     */
    'name'?: string | null;
    /**
     * Родительская папка
     * @type {string}
     * @memberof ChatReplyFolderResponse
     */
    'parentId'?: string | null;
    /**
     * Версия записи
     * @type {string}
     * @memberof ChatReplyFolderResponse
     */
    'version'?: string;
}
/**
 * Шаблон сообщения чата
 * @export
 * @interface ChatReplyTemplateResponse
 */
export interface ChatReplyTemplateResponse {
    /**
     * Идентификатор
     * @type {string}
     * @memberof ChatReplyTemplateResponse
     */
    'id'?: string;
    /**
     * Название
     * @type {string}
     * @memberof ChatReplyTemplateResponse
     */
    'name'?: string | null;
    /**
     * Текст сообщения
     * @type {string}
     * @memberof ChatReplyTemplateResponse
     */
    'text'?: string | null;
    /**
     * Папка шаблона
     * @type {string}
     * @memberof ChatReplyTemplateResponse
     */
    'folderId'?: string;
    /**
     * Версия записи
     * @type {string}
     * @memberof ChatReplyTemplateResponse
     */
    'version'?: string;
}
/**
 * 
 * @export
 * @interface CitizenshipResponse
 */
export interface CitizenshipResponse {
    /**
     * 
     * @type {number}
     * @memberof CitizenshipResponse
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof CitizenshipResponse
     */
    'value'?: string | null;
}
/**
 * 
 * @export
 * @interface CityDistrictResponse
 */
export interface CityDistrictResponse {
    /**
     * Идентификатор
     * @type {number}
     * @memberof CityDistrictResponse
     */
    'id'?: number;
    /**
     * Дата создания
     * @type {string}
     * @memberof CityDistrictResponse
     */
    'created'?: string;
    /**
     * Дата обновления
     * @type {string}
     * @memberof CityDistrictResponse
     */
    'updated'?: string;
    /**
     * Наименование района
     * @type {string}
     * @memberof CityDistrictResponse
     */
    'name': string | null;
    /**
     * Идентификатор города
     * @type {number}
     * @memberof CityDistrictResponse
     */
    'cityId'?: number;
    /**
     * Наименование города
     * @type {string}
     * @memberof CityDistrictResponse
     */
    'cityName': string | null;
}
/**
 * 
 * @export
 * @interface CityResponse
 */
export interface CityResponse {
    /**
     * 
     * @type {number}
     * @memberof CityResponse
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof CityResponse
     */
    'value'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CityResponse
     */
    'subtitle'?: string | null;
}
/**
 * Модель ответа: Адрес-Клиента
 * @export
 * @interface ClientAddressResponse
 */
export interface ClientAddressResponse {
    /**
     * Идентификатор записи
     * @type {string}
     * @memberof ClientAddressResponse
     */
    'id'?: string;
    /**
     * Дата создания
     * @type {string}
     * @memberof ClientAddressResponse
     */
    'created'?: string;
    /**
     * Дата обновления
     * @type {string}
     * @memberof ClientAddressResponse
     */
    'updated'?: string;
    /**
     * 
     * @type {AddressResponse}
     * @memberof ClientAddressResponse
     */
    'address'?: AddressResponse;
    /**
     * Идентификатор клиента
     * @type {string}
     * @memberof ClientAddressResponse
     */
    'clientId'?: string;
    /**
     * Избранный адрес
     * @type {boolean}
     * @memberof ClientAddressResponse
     */
    'isFavorite'?: boolean;
}
/**
 * Данные профиля клиента
 * @export
 * @interface ClientResponse
 */
export interface ClientResponse {
    /**
     * Идентификатор клиента
     * @type {string}
     * @memberof ClientResponse
     */
    'id'?: string;
    /**
     * Дата создания
     * @type {string}
     * @memberof ClientResponse
     */
    'created'?: string;
    /**
     * Дата изменения
     * @type {string}
     * @memberof ClientResponse
     */
    'updated'?: string;
    /**
     * Заблокирован ли
     * @type {boolean}
     * @memberof ClientResponse
     */
    'isBlocked'?: boolean;
    /**
     * Url фотографии
     * @type {string}
     * @memberof ClientResponse
     */
    'photoUrl'?: string | null;
    /**
     * Имя клиента
     * @type {string}
     * @memberof ClientResponse
     */
    'firstName'?: string | null;
    /**
     * Клички активных питомцев клиента
     * @type {Array<string>}
     * @memberof ClientResponse
     */
    'petNames'?: Array<string> | null;
    /**
     * Улица, дом и квартира избранного действующего адреса клиента
     * @type {string}
     * @memberof ClientResponse
     */
    'favoriteAddress'?: string | null;
    /**
     * Мобильный телефон клиента
     * @type {string}
     * @memberof ClientResponse
     */
    'phone'?: string | null;
    /**
     * Email адрес
     * @type {string}
     * @memberof ClientResponse
     */
    'email'?: string | null;
    /**
     * Подтверждена ли электронная почта
     * @type {boolean}
     * @memberof ClientResponse
     */
    'isEmailVerified'?: boolean;
    /**
     * 
     * @type {PlatformType}
     * @memberof ClientResponse
     */
    'platform'?: PlatformType;
    /**
     * Версия приложения пользователя
     * @type {string}
     * @memberof ClientResponse
     */
    'appVersion'?: string | null;
    /**
     * 
     * @type {ApiNotificationPermissionStatusSimpleModel}
     * @memberof ClientResponse
     */
    'notificationPermissionStatus'?: ApiNotificationPermissionStatusSimpleModel;
    /**
     * Номер телефона, который указывали при авторизации
     * @type {string}
     * @memberof ClientResponse
     */
    'appUserPhone'?: string | null;
    /**
     * Идентификатор города проживания клиента
     * @type {number}
     * @memberof ClientResponse
     */
    'cityId'?: number;
    /**
     * Наименование города проживания клиента
     * @type {string}
     * @memberof ClientResponse
     */
    'cityName'?: string | null;
    /**
     * Краткое название населённого пункта
     * @type {string}
     * @memberof ClientResponse
     */
    'cityShortName'?: string | null;
    /**
     * Разрешены ли маркетинговые уведомления
     * @type {boolean}
     * @memberof ClientResponse
     */
    'isAllowMarketingNotifications'?: boolean;
    /**
     * Идентификатор пользователя
     * @type {string}
     * @memberof ClientResponse
     */
    'appUserId'?: string;
    /**
     * 
     * @type {ApiGenderSimpleModel}
     * @memberof ClientResponse
     */
    'gender'?: ApiGenderSimpleModel;
    /**
     * Привязан ли к VK
     * @type {boolean}
     * @memberof ClientResponse
     */
    'isVkLinked'?: boolean;
}


/**
 * 
 * @export
 * @interface ClientSubscriptionInfoReponse
 */
export interface ClientSubscriptionInfoReponse {
    /**
     * Идентификатор абонемента клиента
     * @type {string}
     * @memberof ClientSubscriptionInfoReponse
     */
    'id'?: string;
    /**
     * Наименование абонемента
     * @type {string}
     * @memberof ClientSubscriptionInfoReponse
     */
    'name'?: string | null;
    /**
     * Абонемент клиента активен
     * @type {boolean}
     * @memberof ClientSubscriptionInfoReponse
     */
    'isActive'?: boolean;
    /**
     * Идентификатор продукта на который выпускался абонемент
     * @type {string}
     * @memberof ClientSubscriptionInfoReponse
     */
    'associatedProductId'?: string;
    /**
     * 
     * @type {ApiProductTypeSimpleModel}
     * @memberof ClientSubscriptionInfoReponse
     */
    'associatedProductType'?: ApiProductTypeSimpleModel;
    /**
     * 
     * @type {ApiPetTypeSimpleModel}
     * @memberof ClientSubscriptionInfoReponse
     */
    'petType'?: ApiPetTypeSimpleModel;
    /**
     * Цвет фона для UI
     * @type {string}
     * @memberof ClientSubscriptionInfoReponse
     */
    'backgroundColor'?: string | null;
    /**
     * Дата начала действия абонемента клиента
     * @type {string}
     * @memberof ClientSubscriptionInfoReponse
     */
    'startDate'?: string;
    /**
     * Дата до которой действует абонемент у клиента
     * @type {string}
     * @memberof ClientSubscriptionInfoReponse
     */
    'expiration'?: string;
    /**
     * Количество использований абонемента первоначально
     * @type {number}
     * @memberof ClientSubscriptionInfoReponse
     */
    'numberOfUsesCount'?: number;
    /**
     * Оставшееся количество использований
     * @type {number}
     * @memberof ClientSubscriptionInfoReponse
     */
    'remainingUsesCount'?: number;
}
/**
 * Данные выданного абонемента
 * @export
 * @interface ClientSubscriptionResponse
 */
export interface ClientSubscriptionResponse {
    /**
     * Идентификатор выданного абонемента
     * @type {string}
     * @memberof ClientSubscriptionResponse
     */
    'id'?: string;
    /**
     * ID клиента
     * @type {string}
     * @memberof ClientSubscriptionResponse
     */
    'clientId'?: string;
    /**
     * ID абонемента
     * @type {string}
     * @memberof ClientSubscriptionResponse
     */
    'subscriptionId'?: string;
    /**
     * Название абонемента
     * @type {string}
     * @memberof ClientSubscriptionResponse
     */
    'subscriptionName'?: string | null;
    /**
     * 
     * @type {ApiProductTypeSimpleModel}
     * @memberof ClientSubscriptionResponse
     */
    'productType'?: ApiProductTypeSimpleModel;
    /**
     * 
     * @type {ApiPetTypeSimpleModel}
     * @memberof ClientSubscriptionResponse
     */
    'petType'?: ApiPetTypeSimpleModel;
    /**
     * Дата начала действия абонемента
     * @type {string}
     * @memberof ClientSubscriptionResponse
     */
    'startDate'?: string;
    /**
     * Дата окончания действия абонемента
     * @type {string}
     * @memberof ClientSubscriptionResponse
     */
    'endDate'?: string;
    /**
     * Признак активного абонемента
     * @type {boolean}
     * @memberof ClientSubscriptionResponse
     */
    'isActive'?: boolean;
    /**
     * Признак автопродления
     * @type {boolean}
     * @memberof ClientSubscriptionResponse
     */
    'autorenewal'?: boolean;
    /**
     * Скидка на основной продукт
     * @type {number}
     * @memberof ClientSubscriptionResponse
     */
    'baseDiscount'?: number;
    /**
     * Наименование продукта на который выпущен абонемент
     * @type {string}
     * @memberof ClientSubscriptionResponse
     */
    'associatedProductName'?: string | null;
    /**
     * Идентификатор продукта на который выпущен абонемент
     * @type {string}
     * @memberof ClientSubscriptionResponse
     */
    'associatedProductId'?: string;
    /**
     * Количество использований
     * @type {number}
     * @memberof ClientSubscriptionResponse
     */
    'count'?: number;
    /**
     * Количество зарезервированных использований
     * @type {number}
     * @memberof ClientSubscriptionResponse
     */
    'holdCount'?: number;
    /**
     * Второй питомец включён в одно использование абонемента
     * @type {boolean}
     * @memberof ClientSubscriptionResponse
     */
    'isSecondPetIncluded'?: boolean;
}
/**
 * 
 * @export
 * @interface CommonDiscountResponse
 */
export interface CommonDiscountResponse {
    /**
     * 
     * @type {ApiDiscountTypeSimpleModel}
     * @memberof CommonDiscountResponse
     */
    'discountType': ApiDiscountTypeSimpleModel;
    /**
     * Размер скидки
     * @type {number}
     * @memberof CommonDiscountResponse
     */
    'discount'?: number;
}
/**
 * 
 * @export
 * @interface CompleteOrderRequest
 */
export interface CompleteOrderRequest {
    /**
     * Идентификатор заказа
     * @type {string}
     * @memberof CompleteOrderRequest
     */
    'orderId'?: string;
    /**
     * Описание как прошел заказ
     * @type {string}
     * @memberof CompleteOrderRequest
     */
    'description'?: string | null;
    /**
     * Массив Url фотографий
     * @type {Array<string>}
     * @memberof CompleteOrderRequest
     */
    'photoUrls'?: Array<string> | null;
    /**
     * Время остановки таймера выполнения заказа
     * @type {string}
     * @memberof CompleteOrderRequest
     */
    'timerStoppedAt'?: string | null;
}
/**
 * Запрос создания внутреннего пользователя
 * @export
 * @interface CreateAccessAppUserRequest
 */
export interface CreateAccessAppUserRequest {
    /**
     * Логин внутреннего пользователя
     * @type {string}
     * @memberof CreateAccessAppUserRequest
     */
    'login'?: string | null;
    /**
     * 
     * @type {ApiUserRole}
     * @memberof CreateAccessAppUserRequest
     */
    'role'?: ApiUserRole;
    /**
     * Номер телефона
     * @type {string}
     * @memberof CreateAccessAppUserRequest
     */
    'phone'?: string | null;
    /**
     * Пароль пользователя
     * @type {string}
     * @memberof CreateAccessAppUserRequest
     */
    'password'?: string | null;
}


/**
 * 
 * @export
 * @interface CreateAmmunitionRequest
 */
export interface CreateAmmunitionRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateAmmunitionRequest
     */
    'title'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateAmmunitionRequest
     */
    'subTitle'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateAmmunitionRequest
     */
    'textContent'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateAmmunitionRequest
     */
    'imageUrl'?: string | null;
}
/**
 * 
 * @export
 * @interface CreateAnswerModel
 */
export interface CreateAnswerModel {
    /**
     * Текст ответа
     * @type {string}
     * @memberof CreateAnswerModel
     */
    'text': string | null;
    /**
     * Правильный/неверный ответ
     * @type {boolean}
     * @memberof CreateAnswerModel
     */
    'isTrue': boolean;
}
/**
 * 
 * @export
 * @interface CreateAnswerRequest
 */
export interface CreateAnswerRequest {
    /**
     * Id вопроса
     * @type {number}
     * @memberof CreateAnswerRequest
     */
    'questionId': number;
    /**
     * Текст ответа
     * @type {string}
     * @memberof CreateAnswerRequest
     */
    'text': string | null;
    /**
     * Правильный/неверный ответ
     * @type {boolean}
     * @memberof CreateAnswerRequest
     */
    'isTrue': boolean;
}
/**
 * Собеседник поддержки
 * @export
 * @interface CreateAppChatRequest
 */
export interface CreateAppChatRequest {
    /**
     * Учётная запись собеседника
     * @type {string}
     * @memberof CreateAppChatRequest
     */
    'companionAppUserId': string;
}
/**
 * 
 * @export
 * @interface CreateAppVersionRequest
 */
export interface CreateAppVersionRequest {
    /**
     * Идентификатор приложения в магазине
     * @type {string}
     * @memberof CreateAppVersionRequest
     */
    'appName'?: string | null;
    /**
     * 
     * @type {AppType}
     * @memberof CreateAppVersionRequest
     */
    'appType'?: AppType;
    /**
     * Минимально поддерживаемая версия
     * @type {string}
     * @memberof CreateAppVersionRequest
     */
    'minimumVersion'?: string | null;
    /**
     * Последняя версия приложения
     * @type {string}
     * @memberof CreateAppVersionRequest
     */
    'latestVersion'?: string | null;
    /**
     * Ссылка на приложение в App Store
     * @type {string}
     * @memberof CreateAppVersionRequest
     */
    'appStoreUrl'?: string | null;
    /**
     * Ссылка на приложение в Google Play
     * @type {string}
     * @memberof CreateAppVersionRequest
     */
    'playMarketUrl'?: string | null;
    /**
     * 
     * @type {PlatformType}
     * @memberof CreateAppVersionRequest
     */
    'platform'?: PlatformType;
}


/**
 * 
 * @export
 * @interface CreateBlogPostRequest
 */
export interface CreateBlogPostRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateBlogPostRequest
     */
    'title'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateBlogPostRequest
     */
    'content'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateBlogPostRequest
     */
    'author'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateBlogPostRequest
     */
    'imageUrl'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateBlogPostRequest
     */
    'time'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateBlogPostRequest
     */
    'duration'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof CreateBlogPostRequest
     */
    'isShowServices'?: boolean;
    /**
     * 
     * @type {ApiBlogPostAudience}
     * @memberof CreateBlogPostRequest
     */
    'audience'?: ApiBlogPostAudience;
}


/**
 * 
 * @export
 * @interface CreateClientAddressRequest
 */
export interface CreateClientAddressRequest {
    /**
     * Идентификатор клиента
     * @type {string}
     * @memberof CreateClientAddressRequest
     */
    'clientId'?: string;
    /**
     * 
     * @type {AddressRequest}
     * @memberof CreateClientAddressRequest
     */
    'address'?: AddressRequest;
}
/**
 * 
 * @export
 * @interface CreateClientByAdminRequest
 */
export interface CreateClientByAdminRequest {
    /**
     * Имя клиента
     * @type {string}
     * @memberof CreateClientByAdminRequest
     */
    'firstName'?: string | null;
    /**
     * Идентификатор города проживания клиента
     * @type {number}
     * @memberof CreateClientByAdminRequest
     */
    'cityId'?: number;
    /**
     * Номер телефона
     * @type {string}
     * @memberof CreateClientByAdminRequest
     */
    'phone'?: string | null;
    /**
     * 
     * @type {ApiGender}
     * @memberof CreateClientByAdminRequest
     */
    'gender'?: ApiGender;
    /**
     * 
     * @type {AddressRequest}
     * @memberof CreateClientByAdminRequest
     */
    'address'?: AddressRequest;
}


/**
 * 
 * @export
 * @interface CreateClientRequest
 */
export interface CreateClientRequest {
    /**
     * Имя клиента
     * @type {string}
     * @memberof CreateClientRequest
     */
    'firstName'?: string | null;
    /**
     * Идентификатор города проживания клиента
     * @type {number}
     * @memberof CreateClientRequest
     */
    'cityId'?: number;
    /**
     * 
     * @type {ApiGender}
     * @memberof CreateClientRequest
     */
    'gender'?: ApiGender;
    /**
     * Идентификатор пользователя приложения
     * @type {string}
     * @memberof CreateClientRequest
     */
    'appUserId'?: string;
}


/**
 * Запрос выдачи абонемента клиенту
 * @export
 * @interface CreateClientSubscriptionRequest
 */
export interface CreateClientSubscriptionRequest {
    /**
     * Идентификатор клиента
     * @type {string}
     * @memberof CreateClientSubscriptionRequest
     */
    'clientId'?: string;
    /**
     * Идентификатор абонемента
     * @type {string}
     * @memberof CreateClientSubscriptionRequest
     */
    'subscriptionId'?: string;
    /**
     * Комментарий
     * @type {string}
     * @memberof CreateClientSubscriptionRequest
     */
    'comment'?: string | null;
}
/**
 * 
 * @export
 * @interface CreateExecutorAccessTestRequest
 */
export interface CreateExecutorAccessTestRequest {
    /**
     * ID выгульщика
     * @type {string}
     * @memberof CreateExecutorAccessTestRequest
     */
    'executorId'?: string;
    /**
     * ID теста
     * @type {number}
     * @memberof CreateExecutorAccessTestRequest
     */
    'testId'?: number;
}
/**
 * 
 * @export
 * @interface CreateExecutorAddressRequest
 */
export interface CreateExecutorAddressRequest {
    /**
     * Идентификатор клиента
     * @type {string}
     * @memberof CreateExecutorAddressRequest
     */
    'executorId'?: string;
    /**
     * 
     * @type {AddressRequest}
     * @memberof CreateExecutorAddressRequest
     */
    'address'?: AddressRequest;
}
/**
 * 
 * @export
 * @interface CreateExecutorByAdminRequest
 */
export interface CreateExecutorByAdminRequest {
    /**
     * Url Фотографии
     * @type {string}
     * @memberof CreateExecutorByAdminRequest
     */
    'photoUrl'?: string | null;
    /**
     * Имя исполнителя
     * @type {string}
     * @memberof CreateExecutorByAdminRequest
     */
    'name'?: string | null;
    /**
     * Фамилия
     * @type {string}
     * @memberof CreateExecutorByAdminRequest
     */
    'lastName'?: string | null;
    /**
     * 
     * @type {ApiGender}
     * @memberof CreateExecutorByAdminRequest
     */
    'gender'?: ApiGender;
    /**
     * Дата рождения
     * @type {string}
     * @memberof CreateExecutorByAdminRequest
     */
    'birthDay'?: string;
    /**
     * Идентификатор гражданства
     * @type {number}
     * @memberof CreateExecutorByAdminRequest
     */
    'citizenshipId'?: number;
    /**
     * Идентификатор города
     * @type {number}
     * @memberof CreateExecutorByAdminRequest
     */
    'cityId'?: number;
    /**
     * Идентификатор опыта
     * @type {number}
     * @memberof CreateExecutorByAdminRequest
     */
    'experienceId'?: number;
    /**
     * Номер телефона
     * @type {string}
     * @memberof CreateExecutorByAdminRequest
     */
    'phone'?: string | null;
    /**
     * 
     * @type {SetAboutMyselfRequest}
     * @memberof CreateExecutorByAdminRequest
     */
    'setAboutMyself'?: SetAboutMyselfRequest;
    /**
     * 
     * @type {PassportDetailsRequest}
     * @memberof CreateExecutorByAdminRequest
     */
    'passportDetails'?: PassportDetailsRequest;
    /**
     * 
     * @type {AddressRequest}
     * @memberof CreateExecutorByAdminRequest
     */
    'address'?: AddressRequest;
}


/**
 * 
 * @export
 * @interface CreateExecutorLessonProgressRequest
 */
export interface CreateExecutorLessonProgressRequest {
    /**
     * ID выгульщика
     * @type {string}
     * @memberof CreateExecutorLessonProgressRequest
     */
    'executorId'?: string;
    /**
     * ID урока
     * @type {number}
     * @memberof CreateExecutorLessonProgressRequest
     */
    'lessonId'?: number;
}
/**
 * 
 * @export
 * @interface CreateExecutorRequest
 */
export interface CreateExecutorRequest {
    /**
     * Url Фотографии
     * @type {string}
     * @memberof CreateExecutorRequest
     */
    'photoUrl'?: string | null;
    /**
     * Имя исполнителя
     * @type {string}
     * @memberof CreateExecutorRequest
     */
    'name'?: string | null;
    /**
     * Фамилия
     * @type {string}
     * @memberof CreateExecutorRequest
     */
    'lastName'?: string | null;
    /**
     * 
     * @type {ApiGender}
     * @memberof CreateExecutorRequest
     */
    'gender'?: ApiGender;
    /**
     * Дата рождения
     * @type {string}
     * @memberof CreateExecutorRequest
     */
    'birthDay'?: string;
    /**
     * Идентификатор гражданства
     * @type {number}
     * @memberof CreateExecutorRequest
     */
    'citizenshipId'?: number;
    /**
     * Идентификатор города
     * @type {number}
     * @memberof CreateExecutorRequest
     */
    'cityId'?: number;
    /**
     * Идентификатор опыта
     * @type {number}
     * @memberof CreateExecutorRequest
     */
    'experienceId'?: number;
    /**
     * Идентификатор пользователя приложения
     * @type {string}
     * @memberof CreateExecutorRequest
     */
    'appUserId'?: string;
}


/**
 * 
 * @export
 * @interface CreateExecutorTestProgressModel
 */
export interface CreateExecutorTestProgressModel {
    /**
     * 
     * @type {number}
     * @memberof CreateExecutorTestProgressModel
     */
    'questionId'?: number;
    /**
     * 
     * @type {number}
     * @memberof CreateExecutorTestProgressModel
     */
    'answerId'?: number;
}
/**
 * 
 * @export
 * @interface CreateExecutorTestProgressRequest
 */
export interface CreateExecutorTestProgressRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateExecutorTestProgressRequest
     */
    'executorId'?: string;
    /**
     * 
     * @type {number}
     * @memberof CreateExecutorTestProgressRequest
     */
    'testId'?: number;
    /**
     * 
     * @type {Array<CreateExecutorTestProgressModel>}
     * @memberof CreateExecutorTestProgressRequest
     */
    'questionAnswer'?: Array<CreateExecutorTestProgressModel> | null;
}
/**
 * 
 * @export
 * @interface CreateExecutorTestProgressResponse
 */
export interface CreateExecutorTestProgressResponse {
    /**
     * ID выгульщика
     * @type {string}
     * @memberof CreateExecutorTestProgressResponse
     */
    'executorId'?: string;
    /**
     * ID теста
     * @type {number}
     * @memberof CreateExecutorTestProgressResponse
     */
    'testId'?: number;
    /**
     * Пройден ли
     * @type {boolean}
     * @memberof CreateExecutorTestProgressResponse
     */
    'isCompleted'?: boolean;
    /**
     * Кол-во баллов
     * @type {number}
     * @memberof CreateExecutorTestProgressResponse
     */
    'score'?: number;
    /**
     * Следующий тест на прохождение
     * @type {number}
     * @memberof CreateExecutorTestProgressResponse
     */
    'nextTestId'?: number | null;
}
/**
 * Запрос создания функционального переключателя
 * @export
 * @interface CreateFeatureToggleRequest
 */
export interface CreateFeatureToggleRequest {
    /**
     * 
     * @type {ApiFeatureToggleType}
     * @memberof CreateFeatureToggleRequest
     */
    'type'?: ApiFeatureToggleType;
    /**
     * Наименование функционального переключателя
     * @type {string}
     * @memberof CreateFeatureToggleRequest
     */
    'name'?: string | null;
    /**
     * Включен ли функциональный переключатель
     * @type {boolean}
     * @memberof CreateFeatureToggleRequest
     */
    'isEnabled'?: boolean;
}


/**
 * 
 * @export
 * @interface CreateLessonRequest
 */
export interface CreateLessonRequest {
    /**
     * 
     * @type {ApiPetType}
     * @memberof CreateLessonRequest
     */
    'petType': ApiPetType;
    /**
     * Заголовок
     * @type {string}
     * @memberof CreateLessonRequest
     */
    'title': string | null;
    /**
     * Название
     * @type {string}
     * @memberof CreateLessonRequest
     */
    'name': string | null;
    /**
     * Описание
     * @type {string}
     * @memberof CreateLessonRequest
     */
    'description': string | null;
    /**
     * Путь до видео урока
     * @type {string}
     * @memberof CreateLessonRequest
     */
    'videoUrl'?: string | null;
    /**
     * Картинка для карточки
     * @type {string}
     * @memberof CreateLessonRequest
     */
    'imageUrl'?: string | null;
    /**
     * Порядковый номер урока
     * @type {number}
     * @memberof CreateLessonRequest
     */
    'indexNumber': number;
    /**
     * Время на обучение
     * @type {string}
     * @memberof CreateLessonRequest
     */
    'timeToStudy': string;
}


/**
 * 
 * @export
 * @interface CreateLessonResponse
 */
export interface CreateLessonResponse {
    /**
     * 
     * @type {number}
     * @memberof CreateLessonResponse
     */
    'id'?: number;
    /**
     * 
     * @type {ApiPetTypeSimpleModel}
     * @memberof CreateLessonResponse
     */
    'petType'?: ApiPetTypeSimpleModel;
    /**
     * Заголовок
     * @type {string}
     * @memberof CreateLessonResponse
     */
    'title'?: string | null;
    /**
     * Название
     * @type {string}
     * @memberof CreateLessonResponse
     */
    'name'?: string | null;
    /**
     * Описание
     * @type {string}
     * @memberof CreateLessonResponse
     */
    'description'?: string | null;
    /**
     * Путь до видео урока
     * @type {string}
     * @memberof CreateLessonResponse
     */
    'videoUrl'?: string | null;
    /**
     * Картинка для карточки
     * @type {string}
     * @memberof CreateLessonResponse
     */
    'imageUrl'?: string | null;
    /**
     * Порядковый номер урока
     * @type {number}
     * @memberof CreateLessonResponse
     */
    'indexNumber'?: number;
    /**
     * Время на обучение
     * @type {string}
     * @memberof CreateLessonResponse
     */
    'timeToStudy'?: string;
}
/**
 * Создание сообщения для пользователя
 * @export
 * @interface CreateMessageDialogRequest
 */
export interface CreateMessageDialogRequest {
    /**
     * Маршрут показа диалога
     * @type {string}
     * @memberof CreateMessageDialogRequest
     */
    'routeName'?: string | null;
    /**
     * Объект на маршруте показа
     * @type {string}
     * @memberof CreateMessageDialogRequest
     */
    'routeEntityId'?: string | null;
    /**
     * Время доступности сообщения
     * @type {string}
     * @memberof CreateMessageDialogRequest
     */
    'activeFrom'?: string | null;
    /**
     * 
     * @type {ApiDialogActionType}
     * @memberof CreateMessageDialogRequest
     */
    'action'?: ApiDialogActionType;
    /**
     * Заголовок сообщения
     * @type {string}
     * @memberof CreateMessageDialogRequest
     */
    'title'?: string | null;
    /**
     * Текст сообщения
     * @type {string}
     * @memberof CreateMessageDialogRequest
     */
    'text'?: string | null;
    /**
     * Варианты ответа
     * @type {Array<DialogOptionResponse>}
     * @memberof CreateMessageDialogRequest
     */
    'options'?: Array<DialogOptionResponse> | null;
    /**
     * Срок действия сообщения
     * @type {string}
     * @memberof CreateMessageDialogRequest
     */
    'expiresAt'?: string | null;
    /**
     * Получатель сообщения
     * @type {string}
     * @memberof CreateMessageDialogRequest
     */
    'appUserId'?: string;
}


/**
 * Запрос создания задачи
 * @export
 * @interface CreateOperatorTaskRequest
 */
export interface CreateOperatorTaskRequest {
    /**
     * Название и описание задачи
     * @type {string}
     * @memberof CreateOperatorTaskRequest
     */
    'text'?: string | null;
    /**
     * 
     * @type {ApiOperatorTaskType}
     * @memberof CreateOperatorTaskRequest
     */
    'type'?: ApiOperatorTaskType;
    /**
     * Срок выполнения
     * @type {string}
     * @memberof CreateOperatorTaskRequest
     */
    'dueAtUtc'?: string | null;
    /**
     * 
     * @type {OperatorTaskAssigneeRequest}
     * @memberof CreateOperatorTaskRequest
     */
    'assignee'?: OperatorTaskAssigneeRequest;
    /**
     * 
     * @type {OperatorTaskContextRequest}
     * @memberof CreateOperatorTaskRequest
     */
    'context'?: OperatorTaskContextRequest;
    /**
     * 
     * @type {OperatorTaskReminderSettingsRequest}
     * @memberof CreateOperatorTaskRequest
     */
    'reminders'?: OperatorTaskReminderSettingsRequest;
    /**
     * Ключ запроса создания задачи
     * @type {string}
     * @memberof CreateOperatorTaskRequest
     */
    'clientRequestId'?: string;
    /**
     * 
     * @type {ApiOperatorTaskSource}
     * @memberof CreateOperatorTaskRequest
     */
    'createdFrom'?: ApiOperatorTaskSource;
}


/**
 * Данные создания заказа
 * @export
 * @interface CreateOrderRequest
 */
export interface CreateOrderRequest {
    /**
     * Идентификатор клиента
     * @type {string}
     * @memberof CreateOrderRequest
     */
    'clientId'?: string | null;
    /**
     * 
     * @type {ApiPetType}
     * @memberof CreateOrderRequest
     */
    'petType'?: ApiPetType;
    /**
     * 
     * @type {ApiProductType}
     * @memberof CreateOrderRequest
     */
    'productType'?: ApiProductType;
    /**
     * Идентификатор абонемента клиента для оплаты заказа
     * @type {string}
     * @memberof CreateOrderRequest
     */
    'clientSubscriptionId'?: string | null;
    /**
     * 
     * @type {SetSchedulePeriodRequest}
     * @memberof CreateOrderRequest
     */
    'schedulePeriod'?: SetSchedulePeriodRequest;
    /**
     * Идентификатор Адреса, который принадлежит Клиенту
     * @type {string}
     * @memberof CreateOrderRequest
     */
    'clientAddressId'?: string | null;
    /**
     * Идентификаторы питомцев
     * @type {Array<string>}
     * @memberof CreateOrderRequest
     */
    'petIds'?: Array<string> | null;
    /**
     * Идентификаторы доп. продуктов
     * @type {Array<string>}
     * @memberof CreateOrderRequest
     */
    'additionalProductIds'?: Array<string> | null;
    /**
     * Идентификатор адреса специалиста
     * @type {string}
     * @memberof CreateOrderRequest
     */
    'specialistAddressId'?: string | null;
    /**
     * 
     * @type {ApiSpecialistType}
     * @memberof CreateOrderRequest
     */
    'specialistType'?: ApiSpecialistType;
    /**
     * 
     * @type {ApiPetPlacement}
     * @memberof CreateOrderRequest
     */
    'petPlacement'?: ApiPetPlacement;
    /**
     * 
     * @type {ApiWhoWillBringPet}
     * @memberof CreateOrderRequest
     */
    'whoWillBringPet'?: ApiWhoWillBringPet;
    /**
     * Нужно ли отработать команды (активировать выполнение команд)
     * @type {boolean}
     * @memberof CreateOrderRequest
     */
    'isActiveCommand'?: boolean | null;
    /**
     * Описание команд, которые нужно отработать
     * @type {string}
     * @memberof CreateOrderRequest
     */
    'commandsDescription'?: string | null;
    /**
     * Комментарии к заказу
     * @type {string}
     * @memberof CreateOrderRequest
     */
    'comments'?: string | null;
    /**
     * Описание (например, как попасть в квартиру и т.п.)
     * @type {string}
     * @memberof CreateOrderRequest
     */
    'description'?: string | null;
}


/**
 * 
 * @export
 * @interface CreatePayoutMethodRequest
 */
export interface CreatePayoutMethodRequest {
    /**
     * Если СБП то только  номер тлф
     * @type {string}
     * @memberof CreatePayoutMethodRequest
     */
    'phone'?: string | null;
    /**
     * Номер карты
     * @type {string}
     * @memberof CreatePayoutMethodRequest
     */
    'cardNumber'?: string | null;
    /**
     * Расчетный счет 20 цифр
     * @type {string}
     * @memberof CreatePayoutMethodRequest
     */
    'bankAccount'?: string | null;
    /**
     * БИК Банка 9 цифр
     * @type {string}
     * @memberof CreatePayoutMethodRequest
     */
    'bik'?: string | null;
    /**
     * 
     * @type {ApiPayoutMethodType}
     * @memberof CreatePayoutMethodRequest
     */
    'type'?: ApiPayoutMethodType;
    /**
     * Показывает активный способ оплаты
     * @type {boolean}
     * @memberof CreatePayoutMethodRequest
     */
    'isActive'?: boolean;
    /**
     * Уникальный идентификатор исполнителя, связанного с этой картой.
     * @type {string}
     * @memberof CreatePayoutMethodRequest
     */
    'executorId'?: string;
}


/**
 * 
 * @export
 * @interface CreatePetRequest
 */
export interface CreatePetRequest {
    /**
     * Имя-Кличка
     * @type {string}
     * @memberof CreatePetRequest
     */
    'name': string | null;
    /**
     * Порода
     * @type {string}
     * @memberof CreatePetRequest
     */
    'breed': string | null;
    /**
     * Возраст
     * @type {string}
     * @memberof CreatePetRequest
     */
    'age': string | null;
    /**
     * Детали (о чем еще стоит знать)
     * @type {string}
     * @memberof CreatePetRequest
     */
    'details'?: string | null;
    /**
     * Цвет
     * @type {string}
     * @memberof CreatePetRequest
     */
    'color'?: string | null;
    /**
     * Вес
     * @type {number}
     * @memberof CreatePetRequest
     */
    'weight': number | null;
    /**
     * Рост
     * @type {number}
     * @memberof CreatePetRequest
     */
    'height'?: number | null;
    /**
     * Владелец
     * @type {string}
     * @memberof CreatePetRequest
     */
    'clientId': string | null;
    /**
     * Фото
     * @type {string}
     * @memberof CreatePetRequest
     */
    'image'?: string | null;
    /**
     * 
     * @type {ApiPetType}
     * @memberof CreatePetRequest
     */
    'type': ApiPetType;
    /**
     * 
     * @type {ApiGender}
     * @memberof CreatePetRequest
     */
    'gender': ApiGender;
    /**
     * Есть ли Статус вакцинации
     * @type {boolean}
     * @memberof CreatePetRequest
     */
    'vaccinationStatus'?: boolean | null;
    /**
     * Есть ли аллергия
     * @type {boolean}
     * @memberof CreatePetRequest
     */
    'allergyStatus'?: boolean | null;
    /**
     * Описание аллергии
     * @type {string}
     * @memberof CreatePetRequest
     */
    'allergyDescription'?: string | null;
    /**
     * Есть ли Статусы болезни
     * @type {boolean}
     * @memberof CreatePetRequest
     */
    'diseaseStatus'?: boolean | null;
    /**
     * Описание болезни
     * @type {string}
     * @memberof CreatePetRequest
     */
    'diseaseDescription'?: string | null;
    /**
     * Есть ли Хронические болезни
     * @type {boolean}
     * @memberof CreatePetRequest
     */
    'chronicDiseaseStatus'?: boolean | null;
    /**
     * Описание хронических болезней
     * @type {string}
     * @memberof CreatePetRequest
     */
    'chronicDiseaseDescription'?: string | null;
    /**
     * Есть ли Кастрация
     * @type {boolean}
     * @memberof CreatePetRequest
     */
    'neuteredStatus'?: boolean | null;
    /**
     * Описание о кастрации
     * @type {string}
     * @memberof CreatePetRequest
     */
    'neuteredDescription'?: string | null;
    /**
     * Есть ли Прочие операции
     * @type {boolean}
     * @memberof CreatePetRequest
     */
    'otherOperationsStatus'?: boolean | null;
    /**
     * Описание прочих операций
     * @type {string}
     * @memberof CreatePetRequest
     */
    'otherOperationsDescription'?: string | null;
    /**
     * Есть ли Статус страхов
     * @type {boolean}
     * @memberof CreatePetRequest
     */
    'fearsStatus'?: boolean | null;
    /**
     * Описание страхов
     * @type {string}
     * @memberof CreatePetRequest
     */
    'fearsDescription'?: string | null;
    /**
     * Есть ли травмы
     * @type {boolean}
     * @memberof CreatePetRequest
     */
    'injuryStatus'?: boolean | null;
    /**
     * Описание травм
     * @type {string}
     * @memberof CreatePetRequest
     */
    'injuryDescription'?: string | null;
    /**
     * График кормления
     * @type {string}
     * @memberof CreatePetRequest
     */
    'feedingRegime'?: string | null;
    /**
     * Чем любит заниматься дома
     * @type {string}
     * @memberof CreatePetRequest
     */
    'classesAtHome'?: string | null;
    /**
     * Условия пребывания питомца одного дома
     * @type {string}
     * @memberof CreatePetRequest
     */
    'canBeLeftAloneAtHomeDescription'?: string | null;
    /**
     * Чем любит заниматься на улице
     * @type {string}
     * @memberof CreatePetRequest
     */
    'classesOnTheStreet'?: string | null;
    /**
     * О чем ещё нам стоит знать (Дома)
     * @type {string}
     * @memberof CreatePetRequest
     */
    'additionalCommentsAtHome'?: string | null;
    /**
     * О чем ещё нам стоит знать (На Улицы)
     * @type {string}
     * @memberof CreatePetRequest
     */
    'additionalCommentsOnTheStreet'?: string | null;
    /**
     * График прогулок
     * @type {string}
     * @memberof CreatePetRequest
     */
    'walkingSchedule'?: string | null;
    /**
     * Важно ли чтобы питомец находился один на передержке
     * @type {boolean}
     * @memberof CreatePetRequest
     */
    'isImportantAloneInBoarding'?: boolean | null;
    /**
     * Другие вредные привычки, о которых стоит знать
     * @type {string}
     * @memberof CreatePetRequest
     */
    'anotherBadHabitsDescription'?: string | null;
    /**
     * Идентификаторы привычек
     * @type {Array<string>}
     * @memberof CreatePetRequest
     */
    'habitIds'?: Array<string> | null;
}


/**
 * 
 * @export
 * @interface CreatePolicyRequest
 */
export interface CreatePolicyRequest {
    /**
     * 
     * @type {string}
     * @memberof CreatePolicyRequest
     */
    'content'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreatePolicyRequest
     */
    'title'?: string | null;
    /**
     * 
     * @type {ApiPolicyAudience}
     * @memberof CreatePolicyRequest
     */
    'audience'?: ApiPolicyAudience;
    /**
     * 
     * @type {ApiPolicyType}
     * @memberof CreatePolicyRequest
     */
    'type'?: ApiPolicyType;
    /**
     * Показывать в приложении
     * @type {boolean}
     * @memberof CreatePolicyRequest
     */
    'isShowServices'?: boolean;
}


/**
 * Запрос создания прайс-листа
 * @export
 * @interface CreatePriceListRequest
 */
export interface CreatePriceListRequest {
    /**
     * Ночная надбавка
     * @type {number}
     * @memberof CreatePriceListRequest
     */
    'nightSurcharge'?: number;
    /**
     * Вознаграждение за ночную надбавку
     * @type {number}
     * @memberof CreatePriceListRequest
     */
    'nightSurchargeExecutorReward'?: number;
    /**
     * Наименование
     * @type {string}
     * @memberof CreatePriceListRequest
     */
    'name'?: string | null;
    /**
     * Идентификатор города
     * @type {number}
     * @memberof CreatePriceListRequest
     */
    'cityId'?: number | null;
    /**
     * Вознаграждение исполнителю
     * @type {number}
     * @memberof CreatePriceListRequest
     */
    'executorReward'?: number | null;
    /**
     * Цена продукта
     * @type {number}
     * @memberof CreatePriceListRequest
     */
    'price'?: number | null;
    /**
     * Идентификатор продукта
     * @type {string}
     * @memberof CreatePriceListRequest
     */
    'productId'?: string | null;
}
/**
 * Данные создаваемого периода ценообразования
 * @export
 * @interface CreatePricingPeriodRequest
 */
export interface CreatePricingPeriodRequest {
    /**
     * Показывать период как промоакцию
     * @type {boolean}
     * @memberof CreatePricingPeriodRequest
     */
    'isPromotion'?: boolean;
    /**
     * Показывать в тексте баннера даты его показа
     * @type {boolean}
     * @memberof CreatePricingPeriodRequest
     */
    'showPromotionDates'?: boolean;
    /**
     * Выбранный шаблон промобаннера
     * @type {string}
     * @memberof CreatePricingPeriodRequest
     */
    'promotionBannerTemplateId'?: string | null;
    /**
     * Первый день показа баннера включительно, по умолчанию начало ценового периода
     * @type {string}
     * @memberof CreatePricingPeriodRequest
     */
    'promotionStartDate'?: string | null;
    /**
     * Последний день показа баннера включительно, по умолчанию конец ценового периода
     * @type {string}
     * @memberof CreatePricingPeriodRequest
     */
    'promotionEndDate'?: string | null;
    /**
     * Начало периода включительно
     * @type {string}
     * @memberof CreatePricingPeriodRequest
     */
    'startDate'?: string;
    /**
     * Окончание периода включительно
     * @type {string}
     * @memberof CreatePricingPeriodRequest
     */
    'endDate'?: string;
    /**
     * Цена в периоде
     * @type {number}
     * @memberof CreatePricingPeriodRequest
     */
    'price'?: number;
    /**
     * Вознаграждение исполнителя в периоде
     * @type {number}
     * @memberof CreatePricingPeriodRequest
     */
    'executorReward'?: number;
    /**
     * Идентификатор продукта
     * @type {string}
     * @memberof CreatePricingPeriodRequest
     */
    'productId'?: string | null;
    /**
     * Идентификатор прайс-листа
     * @type {string}
     * @memberof CreatePricingPeriodRequest
     */
    'priceListId'?: string | null;
}
/**
 * Модель запроса на создание нового продукта
 * @export
 * @interface CreateProductRequest
 */
export interface CreateProductRequest {
    /**
     * Уровни скидки за длительную передержку
     * @type {Array<ProductBoardingDiscountTierModel>}
     * @memberof CreateProductRequest
     */
    'boardingDiscountTiers'?: Array<ProductBoardingDiscountTierModel> | null;
    /**
     * Ночная надбавка
     * @type {number}
     * @memberof CreateProductRequest
     */
    'nightSurcharge'?: number;
    /**
     * Вознаграждение за ночную надбавку
     * @type {number}
     * @memberof CreateProductRequest
     */
    'nightSurchargeExecutorReward'?: number;
    /**
     * Наименование продукта
     * @type {string}
     * @memberof CreateProductRequest
     */
    'name'?: string | null;
    /**
     * Цена услуги
     * @type {number}
     * @memberof CreateProductRequest
     */
    'price'?: number | null;
    /**
     * Базовая скидка продукта
     * @type {number}
     * @memberof CreateProductRequest
     */
    'discount'?: number;
    /**
     * Разрешено списание бонусов при оплате продукта
     * @type {boolean}
     * @memberof CreateProductRequest
     */
    'isBonusWriteOffAllowed'?: boolean;
    /**
     * Разрешено начисление бонусов за продукт
     * @type {boolean}
     * @memberof CreateProductRequest
     */
    'isBonusAccrualAllowed'?: boolean;
    /**
     * Вознаграждение исполнителю
     * @type {number}
     * @memberof CreateProductRequest
     */
    'executorReward'?: number | null;
    /**
     * Массив дополнительных услуг (например, \"помыть лапы\", \"накормить\", \"поменять воду\") //TODO: Пока будет в этой модели
     * @type {Array<string>}
     * @memberof CreateProductRequest
     */
    'serviceType'?: Array<string> | null;
    /**
     * Визуальное наименование продукта
     * @type {string}
     * @memberof CreateProductRequest
     */
    'displayName'?: string | null;
    /**
     * Описание продукта
     * @type {string}
     * @memberof CreateProductRequest
     */
    'description'?: string | null;
    /**
     * Полное описание продукта
     * @type {string}
     * @memberof CreateProductRequest
     * @deprecated
     */
    'fullDescription'?: string | null;
    /**
     * Блоки для карусели с информацией о продукте
     * @type {Array<string>}
     * @memberof CreateProductRequest
     */
    'infoBlocks'?: Array<string> | null;
    /**
     * Описание продукта для Исполнителя
     * @type {string}
     * @memberof CreateProductRequest
     */
    'descriptionForExecutor'?: string | null;
    /**
     * 
     * @type {ApiPetType}
     * @memberof CreateProductRequest
     */
    'petType'?: ApiPetType;
    /**
     * 
     * @type {ApiProductType}
     * @memberof CreateProductRequest
     */
    'type'?: ApiProductType;
    /**
     * 
     * @type {ApiProductSubType}
     * @memberof CreateProductRequest
     */
    'subType'?: ApiProductSubType;
    /**
     * Основные услуги, с которыми можно заказать дополнительную услугу
     * @type {Array<ApiProductType>}
     * @memberof CreateProductRequest
     */
    'compatibleBaseProductTypes'?: Array<ApiProductType> | null;
    /**
     * 
     * @type {ApiMoneyDebitType}
     * @memberof CreateProductRequest
     */
    'moneyDebitType'?: ApiMoneyDebitType;
    /**
     * Идентификатор шаблона абонимента
     * @type {string}
     * @memberof CreateProductRequest
     */
    'subscriptionId'?: string | null;
}


/**
 * Создание тиража шаблона
 * @export
 * @interface CreatePromoCodePrintingRequest
 */
export interface CreatePromoCodePrintingRequest {
    /**
     * Идентификатор шаблона
     * @type {string}
     * @memberof CreatePromoCodePrintingRequest
     */
    'templateId'?: string;
    /**
     * Количество промокодов
     * @type {number}
     * @memberof CreatePromoCodePrintingRequest
     */
    'capacity'?: number;
    /**
     * Крайний срок активации промокодов
     * @type {string}
     * @memberof CreatePromoCodePrintingRequest
     */
    'activateBefore'?: string | null;
}
/**
 * 
 * @export
 * @interface CreatePromoCodeRequest
 */
export interface CreatePromoCodeRequest {
    /**
     * Номер промокода
     * @type {string}
     * @memberof CreatePromoCodeRequest
     */
    'number'?: string | null;
    /**
     * Ручной номер промокода
     * @type {boolean}
     * @memberof CreatePromoCodeRequest
     */
    'isCustomNumber'?: boolean;
    /**
     * Значение скидки (руб. / %)
     * @type {number}
     * @memberof CreatePromoCodeRequest
     */
    'discount'?: number | null;
    /**
     * 
     * @type {ApiPromoCodeType}
     * @memberof CreatePromoCodeRequest
     */
    'type'?: ApiPromoCodeType;
    /**
     * Лимит скидки
     * @type {number}
     * @memberof CreatePromoCodeRequest
     */
    'limit'?: number | null;
    /**
     * Дата истечения промокода
     * @type {string}
     * @memberof CreatePromoCodeRequest
     */
    'expirationDate'?: string | null;
    /**
     * Срок действия после активации в днях
     * @type {number}
     * @memberof CreatePromoCodeRequest
     */
    'activeDurationDays'?: number | null;
    /**
     * Общий лимит использований промокода
     * @type {number}
     * @memberof CreatePromoCodeRequest
     */
    'limitTransactions'?: number | null;
    /**
     * Лимит использований промокода одним клиентом
     * @type {number}
     * @memberof CreatePromoCodeRequest
     */
    'clientTransactionLimit'?: number | null;
    /**
     * Крайний срок активации промокода
     * @type {string}
     * @memberof CreatePromoCodeRequest
     */
    'activateBefore'?: string | null;
}


/**
 * 
 * @export
 * @interface CreateQuestionAnswerModel
 */
export interface CreateQuestionAnswerModel {
    /**
     * Текст вопроса
     * @type {string}
     * @memberof CreateQuestionAnswerModel
     */
    'title': string | null;
    /**
     * Активен ли
     * @type {number}
     * @memberof CreateQuestionAnswerModel
     */
    'index': number;
    /**
     * 
     * @type {Array<CreateAnswerModel>}
     * @memberof CreateQuestionAnswerModel
     */
    'answers': Array<CreateAnswerModel> | null;
}
/**
 * 
 * @export
 * @interface CreateQuestionRequest
 */
export interface CreateQuestionRequest {
    /**
     * ID теста
     * @type {number}
     * @memberof CreateQuestionRequest
     */
    'testId'?: number;
    /**
     * Текст вопроса
     * @type {string}
     * @memberof CreateQuestionRequest
     */
    'title'?: string | null;
    /**
     * Активен ли
     * @type {number}
     * @memberof CreateQuestionRequest
     */
    'index'?: number;
}
/**
 * 
 * @export
 * @interface CreateReviewRequest
 */
export interface CreateReviewRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateReviewRequest
     */
    'description'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateReviewRequest
     */
    'executorId'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateReviewRequest
     */
    'orderId'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateReviewRequest
     */
    'clientId'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CreateReviewRequest
     */
    'mark'?: number;
}
/**
 * 
 * @export
 * @interface CreateSubscriptionRequest
 */
export interface CreateSubscriptionRequest {
    /**
     * Название абонемента
     * @type {string}
     * @memberof CreateSubscriptionRequest
     */
    'name'?: string | null;
    /**
     * Описание абонемента
     * @type {string}
     * @memberof CreateSubscriptionRequest
     */
    'description'?: string | null;
    /**
     * Заголовок абонемента
     * @type {string}
     * @memberof CreateSubscriptionRequest
     */
    'title'?: string | null;
    /**
     * Подзаголовок абонемента
     * @type {string}
     * @memberof CreateSubscriptionRequest
     */
    'subtitle'?: string | null;
    /**
     * Срок действия (указывается в днях)
     * @type {number}
     * @memberof CreateSubscriptionRequest
     */
    'durationDays'?: number;
    /**
     * Скидка на основной продукт
     * @type {number}
     * @memberof CreateSubscriptionRequest
     */
    'baseDiscount'?: number;
    /**
     * Цвет фона для UI
     * @type {string}
     * @memberof CreateSubscriptionRequest
     */
    'backgroundColor'?: string | null;
    /**
     * Время планирования (например, \"до 12 прогулок в месяц\")
     * @type {string}
     * @memberof CreateSubscriptionRequest
     */
    'planningTime'?: string | null;
    /**
     * Количество использований абонемента
     * @type {number}
     * @memberof CreateSubscriptionRequest
     */
    'numberOfUsesCount'?: number;
    /**
     * Доступен в продаже
     * @type {boolean}
     * @memberof CreateSubscriptionRequest
     */
    'isActive'?: boolean;
    /**
     * Второй питомец включён в одно использование абонемента
     * @type {boolean}
     * @memberof CreateSubscriptionRequest
     */
    'isSecondPetIncluded'?: boolean | null;
    /**
     * Ночная надбавка включена в абонемент
     * @type {boolean}
     * @memberof CreateSubscriptionRequest
     */
    'isNightSurchargeIncluded'?: boolean | null;
    /**
     * Идентификаторы дополнительных продуктов абонемента
     * @type {Array<string>}
     * @memberof CreateSubscriptionRequest
     */
    'additionalProductIds'?: Array<string> | null;
    /**
     * Идентификатор продукта, на который выпускается абонемент
     * @type {string}
     * @memberof CreateSubscriptionRequest
     */
    'productId'?: string | null;
}
/**
 * 
 * @export
 * @interface CreateTestQuestionAnswerRequest
 */
export interface CreateTestQuestionAnswerRequest {
    /**
     * Идентификатор урока
     * @type {number}
     * @memberof CreateTestQuestionAnswerRequest
     */
    'lessonId': number;
    /**
     * Индекс теста
     * @type {number}
     * @memberof CreateTestQuestionAnswerRequest
     */
    'index': number;
    /**
     * 
     * @type {Array<CreateQuestionAnswerModel>}
     * @memberof CreateTestQuestionAnswerRequest
     */
    'questionAnswers': Array<CreateQuestionAnswerModel> | null;
}
/**
 * 
 * @export
 * @interface CreateTestQuestionAnswerResponse
 */
export interface CreateTestQuestionAnswerResponse {
    /**
     * 
     * @type {number}
     * @memberof CreateTestQuestionAnswerResponse
     */
    'id'?: number;
    /**
     * Идентификатор урока
     * @type {number}
     * @memberof CreateTestQuestionAnswerResponse
     */
    'lessonId'?: number;
    /**
     * Индекс теста
     * @type {number}
     * @memberof CreateTestQuestionAnswerResponse
     */
    'index'?: number;
    /**
     * 
     * @type {Array<GetQuestionModel>}
     * @memberof CreateTestQuestionAnswerResponse
     */
    'questionsAnswers'?: Array<GetQuestionModel> | null;
}
/**
 * 
 * @export
 * @interface CreateTestRequest
 */
export interface CreateTestRequest {
    /**
     * Идентификатор урока
     * @type {number}
     * @memberof CreateTestRequest
     */
    'lessonId': number;
    /**
     * Индекс теста
     * @type {number}
     * @memberof CreateTestRequest
     */
    'index': number;
}
/**
 * 
 * @export
 * @interface CreateTestResponse
 */
export interface CreateTestResponse {
    /**
     * 
     * @type {number}
     * @memberof CreateTestResponse
     */
    'id'?: number;
    /**
     * Идентификатор урока
     * @type {number}
     * @memberof CreateTestResponse
     */
    'lessonId'?: number;
    /**
     * Индекс теста
     * @type {number}
     * @memberof CreateTestResponse
     */
    'index'?: number;
}
/**
 * Запрос личной переписки пользователя
 * @export
 * @interface CreateUserChatRequest
 */
export interface CreateUserChatRequest {
    /**
     * Профиль собеседника
     * @type {string}
     * @memberof CreateUserChatRequest
     */
    'companionId'?: string;
    /**
     * 
     * @type {ApiUserRole}
     * @memberof CreateUserChatRequest
     */
    'companionRole'?: ApiUserRole;
}


/**
 * Описание параметра фоновой задачи
 * @export
 * @interface CronJobParameterResponse
 */
export interface CronJobParameterResponse {
    /**
     * Ключ параметра
     * @type {string}
     * @memberof CronJobParameterResponse
     */
    'key'?: string | null;
    /**
     * Название параметра
     * @type {string}
     * @memberof CronJobParameterResponse
     */
    'label'?: string | null;
    /**
     * Тип значения параметра
     * @type {string}
     * @memberof CronJobParameterResponse
     */
    'kind'?: string | null;
    /**
     * Минимальное значение
     * @type {number}
     * @memberof CronJobParameterResponse
     */
    'minimum'?: number | null;
    /**
     * Максимальное значение
     * @type {number}
     * @memberof CronJobParameterResponse
     */
    'maximum'?: number | null;
}
/**
 * Настройки фоновой задачи
 * @export
 * @interface CronJobResponse
 */
export interface CronJobResponse {
    /**
     * Ключ обработчика
     * @type {string}
     * @memberof CronJobResponse
     */
    'jobKey'?: string | null;
    /**
     * Название задачи
     * @type {string}
     * @memberof CronJobResponse
     */
    'name'?: string | null;
    /**
     * Наличие подключённого обработчика
     * @type {boolean}
     * @memberof CronJobResponse
     */
    'isRegistered'?: boolean;
    /**
     * Версия настроек
     * @type {string}
     * @memberof CronJobResponse
     */
    'version'?: string;
    /**
     * Разрешение запусков
     * @type {boolean}
     * @memberof CronJobResponse
     */
    'isEnabled'?: boolean;
    /**
     * Расписание в UTC
     * @type {string}
     * @memberof CronJobResponse
     */
    'schedule'?: string | null;
    /**
     * Секундная точность расписания
     * @type {boolean}
     * @memberof CronJobResponse
     */
    'includeSeconds'?: boolean;
    /**
     * Контроль выполнения в Sentry
     * @type {boolean}
     * @memberof CronJobResponse
     */
    'sentryMonitorEnabled'?: boolean;
    /**
     * Допустимое опоздание запуска в минутах
     * @type {number}
     * @memberof CronJobResponse
     */
    'sentryCheckInMarginMinutes'?: number;
    /**
     * Допустимая длительность выполнения в минутах
     * @type {number}
     * @memberof CronJobResponse
     */
    'sentryMaxRuntimeMinutes'?: number;
    /**
     * Параметры обработчика
     * @type {{ [key: string]: string; }}
     * @memberof CronJobResponse
     */
    'parameters'?: { [key: string]: string; } | null;
    /**
     * Описание параметров обработчика
     * @type {Array<CronJobParameterResponse>}
     * @memberof CronJobResponse
     */
    'parameterDefinitions'?: Array<CronJobParameterResponse> | null;
}
/**
 * 
 * @export
 * @interface DeleteRequest
 */
export interface DeleteRequest {
    /**
     * Комментарий
     * @type {string}
     * @memberof DeleteRequest
     */
    'comment'?: string | null;
}
/**
 * Число выбранных ответов
 * @export
 * @interface DialogAnswerCountResponse
 */
export interface DialogAnswerCountResponse {
    /**
     * 
     * @type {ApiDialogOptionType}
     * @memberof DialogAnswerCountResponse
     */
    'optionType'?: ApiDialogOptionType;
    /**
     * Подпись выбранного ответа
     * @type {string}
     * @memberof DialogAnswerCountResponse
     */
    'text'?: string | null;
    /**
     * Число ответов
     * @type {number}
     * @memberof DialogAnswerCountResponse
     */
    'count'?: number;
}


/**
 * Страница подходящих получателей
 * @export
 * @interface DialogAudienceResponse
 */
export interface DialogAudienceResponse {
    /**
     * Получатели
     * @type {Array<DialogRecipientResponse>}
     * @memberof DialogAudienceResponse
     */
    'items'?: Array<DialogRecipientResponse> | null;
    /**
     * Число подходящих пользователей
     * @type {number}
     * @memberof DialogAudienceResponse
     */
    'allCount'?: number;
}
/**
 * Статистика и страница назначений
 * @export
 * @interface DialogBroadcastDetailsResponse
 */
export interface DialogBroadcastDetailsResponse {
    /**
     * 
     * @type {DialogBroadcastResponse}
     * @memberof DialogBroadcastDetailsResponse
     */
    'broadcast'?: DialogBroadcastResponse;
    /**
     * 
     * @type {DialogBroadcastStatisticsResponse}
     * @memberof DialogBroadcastDetailsResponse
     */
    'statistics'?: DialogBroadcastStatisticsResponse;
    /**
     * Назначения выпуска
     * @type {Array<DialogBroadcastDialogResponse>}
     * @memberof DialogBroadcastDetailsResponse
     */
    'dialogs'?: Array<DialogBroadcastDialogResponse> | null;
    /**
     * Число назначений по фильтру
     * @type {number}
     * @memberof DialogBroadcastDetailsResponse
     */
    'allCount'?: number;
}
/**
 * Назначение конкретному получателю
 * @export
 * @interface DialogBroadcastDialogResponse
 */
export interface DialogBroadcastDialogResponse {
    /**
     * Текст обратной связи пользователя
     * @type {string}
     * @memberof DialogBroadcastDialogResponse
     */
    'textAnswer'?: string | null;
    /**
     * Идентификатор диалога
     * @type {string}
     * @memberof DialogBroadcastDialogResponse
     */
    'id'?: string;
    /**
     * Пользователь приложения
     * @type {string}
     * @memberof DialogBroadcastDialogResponse
     */
    'appUserId'?: string;
    /**
     * Профиль получателя
     * @type {string}
     * @memberof DialogBroadcastDialogResponse
     */
    'profileId'?: string | null;
    /**
     * Имя получателя
     * @type {string}
     * @memberof DialogBroadcastDialogResponse
     */
    'name'?: string | null;
    /**
     * Телефон получателя
     * @type {string}
     * @memberof DialogBroadcastDialogResponse
     */
    'phone'?: string | null;
    /**
     * 
     * @type {ApiDialogAudienceType}
     * @memberof DialogBroadcastDialogResponse
     */
    'audience'?: ApiDialogAudienceType;
    /**
     * 
     * @type {ApiDialogStatus}
     * @memberof DialogBroadcastDialogResponse
     */
    'status'?: ApiDialogStatus;
    /**
     * Дата назначения
     * @type {string}
     * @memberof DialogBroadcastDialogResponse
     */
    'created'?: string;
    /**
     * Начало доступности
     * @type {string}
     * @memberof DialogBroadcastDialogResponse
     */
    'activeFrom'?: string | null;
    /**
     * Окончание доступности
     * @type {string}
     * @memberof DialogBroadcastDialogResponse
     */
    'expiresAt'?: string | null;
    /**
     * Дата ответа
     * @type {string}
     * @memberof DialogBroadcastDialogResponse
     */
    'respondedAt'?: string | null;
    /**
     * 
     * @type {ApiDialogOptionType}
     * @memberof DialogBroadcastDialogResponse
     */
    'answerOption'?: ApiDialogOptionType;
    /**
     * Подпись ответа
     * @type {string}
     * @memberof DialogBroadcastDialogResponse
     */
    'answerText'?: string | null;
}


/**
 * Страница выпусков
 * @export
 * @interface DialogBroadcastListResponse
 */
export interface DialogBroadcastListResponse {
    /**
     * Выпуски
     * @type {Array<DialogBroadcastResponse>}
     * @memberof DialogBroadcastListResponse
     */
    'items'?: Array<DialogBroadcastResponse> | null;
    /**
     * Общее число выпусков
     * @type {number}
     * @memberof DialogBroadcastListResponse
     */
    'allCount'?: number;
}
/**
 * Выпуск коммуникации
 * @export
 * @interface DialogBroadcastResponse
 */
export interface DialogBroadcastResponse {
    /**
     * Идентификатор выпуска
     * @type {string}
     * @memberof DialogBroadcastResponse
     */
    'id'?: string;
    /**
     * Шаблон диалогов
     * @type {string}
     * @memberof DialogBroadcastResponse
     */
    'templateId'?: string;
    /**
     * Заголовок шаблона
     * @type {string}
     * @memberof DialogBroadcastResponse
     */
    'templateTitle'?: string | null;
    /**
     * Название выпуска
     * @type {string}
     * @memberof DialogBroadcastResponse
     */
    'name'?: string | null;
    /**
     * Системный выпуск
     * @type {boolean}
     * @memberof DialogBroadcastResponse
     */
    'isSystem'?: boolean;
    /**
     * 
     * @type {ApiDialogAudienceType}
     * @memberof DialogBroadcastResponse
     */
    'audience'?: ApiDialogAudienceType;
    /**
     * Город аудитории
     * @type {number}
     * @memberof DialogBroadcastResponse
     */
    'cityId'?: number | null;
    /**
     * Описание отбора
     * @type {string}
     * @memberof DialogBroadcastResponse
     */
    'filterDescription'?: string | null;
    /**
     * Дата выпуска
     * @type {string}
     * @memberof DialogBroadcastResponse
     */
    'created'?: string;
    /**
     * Начало доступности
     * @type {string}
     * @memberof DialogBroadcastResponse
     */
    'activeFrom'?: string | null;
    /**
     * Окончание доступности
     * @type {string}
     * @memberof DialogBroadcastResponse
     */
    'expiresAt'?: string | null;
}


/**
 * Статистика ответов выпуска
 * @export
 * @interface DialogBroadcastStatisticsResponse
 */
export interface DialogBroadcastStatisticsResponse {
    /**
     * Всего назначений
     * @type {number}
     * @memberof DialogBroadcastStatisticsResponse
     */
    'total'?: number;
    /**
     * Получено ответов
     * @type {number}
     * @memberof DialogBroadcastStatisticsResponse
     */
    'responded'?: number;
    /**
     * Без ответа
     * @type {number}
     * @memberof DialogBroadcastStatisticsResponse
     */
    'unanswered'?: number;
    /**
     * Ожидают ответа
     * @type {number}
     * @memberof DialogBroadcastStatisticsResponse
     */
    'pending'?: number;
    /**
     * Подтверждено прочтение
     * @type {number}
     * @memberof DialogBroadcastStatisticsResponse
     */
    'read'?: number;
    /**
     * Ответили на вопрос
     * @type {number}
     * @memberof DialogBroadcastStatisticsResponse
     */
    'answered'?: number;
    /**
     * Срок истёк
     * @type {number}
     * @memberof DialogBroadcastStatisticsResponse
     */
    'expired'?: number;
    /**
     * Отменены
     * @type {number}
     * @memberof DialogBroadcastStatisticsResponse
     */
    'cancelled'?: number;
    /**
     * Распределение ответов
     * @type {Array<DialogAnswerCountResponse>}
     * @memberof DialogBroadcastStatisticsResponse
     */
    'answers'?: Array<DialogAnswerCountResponse> | null;
}
/**
 * 
 * @export
 * @interface DialogOptionResponse
 */
export interface DialogOptionResponse {
    /**
     * 
     * @type {ApiDialogOptionType}
     * @memberof DialogOptionResponse
     */
    'optionType'?: ApiDialogOptionType;
    /**
     * Текст варианта диалога для пользователя
     * @type {string}
     * @memberof DialogOptionResponse
     */
    'text'?: string | null;
}


/**
 * Получатель диалогового окна
 * @export
 * @interface DialogRecipientResponse
 */
export interface DialogRecipientResponse {
    /**
     * Пользователь приложения
     * @type {string}
     * @memberof DialogRecipientResponse
     */
    'id'?: string;
    /**
     * Профиль получателя
     * @type {string}
     * @memberof DialogRecipientResponse
     */
    'profileId'?: string | null;
    /**
     * Имя получателя
     * @type {string}
     * @memberof DialogRecipientResponse
     */
    'name'?: string | null;
    /**
     * Телефон получателя
     * @type {string}
     * @memberof DialogRecipientResponse
     */
    'phone'?: string | null;
    /**
     * 
     * @type {ApiDialogAudienceType}
     * @memberof DialogRecipientResponse
     */
    'audience'?: ApiDialogAudienceType;
    /**
     * Город получателя
     * @type {string}
     * @memberof DialogRecipientResponse
     */
    'cityName'?: string | null;
}


/**
 * Сохранённая конфигурация диалога
 * @export
 * @interface DialogTemplateResponse
 */
export interface DialogTemplateResponse {
    /**
     * Постоянный выпуск автоматических назначений
     * @type {string}
     * @memberof DialogTemplateResponse
     */
    'systemBroadcastId'?: string | null;
    /**
     * Идентификатор конфигурации
     * @type {string}
     * @memberof DialogTemplateResponse
     */
    'id'?: string;
    /**
     * Код конфигурации
     * @type {string}
     * @memberof DialogTemplateResponse
     */
    'code'?: string | null;
    /**
     * Заголовок диалога
     * @type {string}
     * @memberof DialogTemplateResponse
     */
    'title'?: string | null;
    /**
     * Описание диалога
     * @type {string}
     * @memberof DialogTemplateResponse
     */
    'text'?: string | null;
    /**
     * 
     * @type {ApiDialogActionType}
     * @memberof DialogTemplateResponse
     */
    'action'?: ApiDialogActionType;
    /**
     * 
     * @type {DialogTextInputResponse}
     * @memberof DialogTemplateResponse
     */
    'textInput'?: DialogTextInputResponse;
    /**
     * Варианты ответа
     * @type {Array<DialogOptionResponse>}
     * @memberof DialogTemplateResponse
     */
    'options'?: Array<DialogOptionResponse> | null;
    /**
     * Маршрут показа
     * @type {string}
     * @memberof DialogTemplateResponse
     */
    'routeName'?: string | null;
    /**
     * Объект на маршруте показа
     * @type {string}
     * @memberof DialogTemplateResponse
     */
    'routeEntityId'?: string | null;
    /**
     * Разрешено назначение диалога
     * @type {boolean}
     * @memberof DialogTemplateResponse
     */
    'isEnabled'?: boolean;
    /**
     * Версия конфигурации
     * @type {string}
     * @memberof DialogTemplateResponse
     */
    'version'?: string;
}


/**
 * Настройки поля текстовой обратной связи
 * @export
 * @interface DialogTextInputResponse
 */
export interface DialogTextInputResponse {
    /**
     * Подпись поля
     * @type {string}
     * @memberof DialogTextInputResponse
     */
    'label'?: string | null;
    /**
     * Подсказка внутри пустого поля
     * @type {string}
     * @memberof DialogTextInputResponse
     */
    'placeholder'?: string | null;
    /**
     * Допустимое количество символов ответа
     * @type {number}
     * @memberof DialogTextInputResponse
     */
    'maxLength'?: number;
}
/**
 * Запрос редактирования собственного сообщения
 * @export
 * @interface EditChatMessageRequest
 */
export interface EditChatMessageRequest {
    /**
     * Ключ повторного запроса
     * @type {string}
     * @memberof EditChatMessageRequest
     */
    'requestId'?: string;
    /**
     * Ожидаемая версия сообщения
     * @type {number}
     * @memberof EditChatMessageRequest
     */
    'expectedVersion'?: number;
    /**
     * Новый текст или подпись
     * @type {string}
     * @memberof EditChatMessageRequest
     */
    'text'?: string | null;
}
/**
 * Состояние подтверждения электронной почты
 * @export
 * @interface EmailVerificationStatusResponse
 */
export interface EmailVerificationStatusResponse {
    /**
     * Привязан ли адрес электронной почты
     * @type {boolean}
     * @memberof EmailVerificationStatusResponse
     */
    'hasEmail'?: boolean;
    /**
     * Подтверждён ли текущий адрес электронной почты
     * @type {boolean}
     * @memberof EmailVerificationStatusResponse
     */
    'isEmailVerified'?: boolean;
    /**
     * Время окончания действия отправленной ссылки в UTC
     * @type {string}
     * @memberof EmailVerificationStatusResponse
     */
    'expiresAt'?: string | null;
    /**
     * Время разрешённой повторной отправки в UTC
     * @type {string}
     * @memberof EmailVerificationStatusResponse
     */
    'resendAvailableAt'?: string | null;
    /**
     * Оставшееся число секунд до повторной отправки
     * @type {number}
     * @memberof EmailVerificationStatusResponse
     */
    'secondsBeforeResend'?: number;
}
/**
 * Сообщение об ошибке
 * @export
 * @interface ErrorContract
 */
export interface ErrorContract {
    /**
     * 
     * @type {number}
     * @memberof ErrorContract
     */
    'status'?: number | null;
    /**
     * Человекочитаемое сообщение об ошибке
     * @type {string}
     * @memberof ErrorContract
     */
    'message'?: string | null;
    /**
     * Сообщение для разработки
     * @type {string}
     * @memberof ErrorContract
     */
    'developerMessage'?: string | null;
    /**
     * Дата
     * @type {string}
     * @memberof ErrorContract
     */
    'date'?: string | null;
    /**
     * Наименование кода ошибки
     * @type {string}
     * @memberof ErrorContract
     */
    'errorExtensionCode'?: string | null;
    /**
     * 
     * @type {VoxErrorCode}
     * @memberof ErrorContract
     */
    'voxErrorCode'?: VoxErrorCode;
}


/**
 * Данные события в ответе API
 * @export
 * @interface EventResponse
 */
export interface EventResponse {
    /**
     * Идентификатор события
     * @type {string}
     * @memberof EventResponse
     */
    'id'?: string;
    /**
     * Тираж промокодов, связанный с событием
     * @type {string}
     * @memberof EventResponse
     */
    'promoCodePrintingId'?: string | null;
    /**
     * Дата создания события
     * @type {string}
     * @memberof EventResponse
     */
    'created'?: string;
    /**
     * Локальное время (по заказу)
     * @type {string}
     * @memberof EventResponse
     */
    'createdLocalTime'?: string | null;
    /**
     * 
     * @type {ApiEventTypeSimpleModel}
     * @memberof EventResponse
     */
    'type'?: ApiEventTypeSimpleModel;
    /**
     * Идентификатор заказа
     * @type {string}
     * @memberof EventResponse
     */
    'orderId'?: string | null;
    /**
     * Идентификатор исполнителя, связанного с событием
     * @type {string}
     * @memberof EventResponse
     */
    'executorId'?: string | null;
    /**
     * Идентификатор промокода, связанного с событием
     * @type {string}
     * @memberof EventResponse
     */
    'promoCodeId'?: string | null;
    /**
     * Идентификатор абонемента клиента, связанного с событием
     * @type {string}
     * @memberof EventResponse
     */
    'clientSubscriptionId'?: string | null;
    /**
     * Автор события
     * @type {string}
     * @memberof EventResponse
     */
    'userName'?: string | null;
    /**
     * Дополнительное описание
     * @type {string}
     * @memberof EventResponse
     */
    'description'?: string | null;
    /**
     * Комментарий
     * @type {string}
     * @memberof EventResponse
     */
    'comment'?: string | null;
}
/**
 * Модель ответа: Адрес-Исполнителя
 * @export
 * @interface ExecutorAddressResponse
 */
export interface ExecutorAddressResponse {
    /**
     * Идентификатор записи
     * @type {string}
     * @memberof ExecutorAddressResponse
     */
    'id'?: string;
    /**
     * Дата создания
     * @type {string}
     * @memberof ExecutorAddressResponse
     */
    'created'?: string;
    /**
     * Дата обновления
     * @type {string}
     * @memberof ExecutorAddressResponse
     */
    'updated'?: string;
    /**
     * 
     * @type {AddressResponse}
     * @memberof ExecutorAddressResponse
     */
    'address'?: AddressResponse;
    /**
     * Идентификатор исполнителя
     * @type {string}
     * @memberof ExecutorAddressResponse
     */
    'executorId'?: string;
    /**
     * Избранный адрес
     * @type {boolean}
     * @memberof ExecutorAddressResponse
     */
    'isFavorite'?: boolean;
}
/**
 * Текущее местоположение исполнителя
 * @export
 * @interface ExecutorLocationResponse
 */
export interface ExecutorLocationResponse {
    /**
     * Url аватарки исполнителя
     * @type {string}
     * @memberof ExecutorLocationResponse
     */
    'executorAvatarUrl'?: string | null;
    /**
     * Имя исполнителя
     * @type {string}
     * @memberof ExecutorLocationResponse
     */
    'executorName'?: string | null;
    /**
     * Рейтинг исполнителя
     * @type {number}
     * @memberof ExecutorLocationResponse
     */
    'rating'?: number | null;
    /**
     * ID исполнителя
     * @type {string}
     * @memberof ExecutorLocationResponse
     */
    'executorId'?: string;
    /**
     * Широта
     * @type {number}
     * @memberof ExecutorLocationResponse
     */
    'latitude'?: number;
    /**
     * Долгота
     * @type {number}
     * @memberof ExecutorLocationResponse
     */
    'longitude'?: number;
    /**
     * Описание
     * @type {string}
     * @memberof ExecutorLocationResponse
     */
    'description'?: string | null;
}
/**
 * Данные профиля исполнителя
 * @export
 * @interface ExecutorResponse
 */
export interface ExecutorResponse {
    /**
     * Идентификатор исполнителя
     * @type {string}
     * @memberof ExecutorResponse
     */
    'id'?: string;
    /**
     * Дата регистрации
     * @type {string}
     * @memberof ExecutorResponse
     */
    'created'?: string;
    /**
     * Открыт для работы
     * @type {boolean}
     * @memberof ExecutorResponse
     */
    'isOpenToWork'?: boolean;
    /**
     * Заблокирован ли
     * @type {boolean}
     * @memberof ExecutorResponse
     */
    'isBlocked'?: boolean;
    /**
     * Верифицирован ли исполнитель
     * @type {boolean}
     * @memberof ExecutorResponse
     */
    'isVerified'?: boolean;
    /**
     * Имеется ли штраф
     * @type {boolean}
     * @memberof ExecutorResponse
     */
    'hasPenalty'?: boolean;
    /**
     * Url фотографии
     * @type {string}
     * @memberof ExecutorResponse
     */
    'photoUrl'?: string | null;
    /**
     * Имя исполнителя
     * @type {string}
     * @memberof ExecutorResponse
     */
    'name'?: string | null;
    /**
     * Фамилия
     * @type {string}
     * @memberof ExecutorResponse
     */
    'lastName'?: string | null;
    /**
     * 
     * @type {ApiEmploymentKindSimpleModel}
     * @memberof ExecutorResponse
     */
    'employmentKind'?: ApiEmploymentKindSimpleModel;
    /**
     * 
     * @type {ApiGenderSimpleModel}
     * @memberof ExecutorResponse
     */
    'gender'?: ApiGenderSimpleModel;
    /**
     * Мобильный телефон исполнителя
     * @type {string}
     * @memberof ExecutorResponse
     */
    'phone'?: string | null;
    /**
     * Email адрес
     * @type {string}
     * @memberof ExecutorResponse
     */
    'email'?: string | null;
    /**
     * Подтверждена ли электронная почта
     * @type {boolean}
     * @memberof ExecutorResponse
     */
    'isEmailVerified'?: boolean;
    /**
     * 
     * @type {PlatformType}
     * @memberof ExecutorResponse
     */
    'platform'?: PlatformType;
    /**
     * Версия приложения пользователя
     * @type {string}
     * @memberof ExecutorResponse
     */
    'appVersion'?: string | null;
    /**
     * 
     * @type {ApiNotificationPermissionStatusSimpleModel}
     * @memberof ExecutorResponse
     */
    'notificationPermissionStatus'?: ApiNotificationPermissionStatusSimpleModel;
    /**
     * Идентификатор пользователя
     * @type {string}
     * @memberof ExecutorResponse
     */
    'appUserId'?: string;
    /**
     * Дата рождения
     * @type {string}
     * @memberof ExecutorResponse
     */
    'birthDay'?: string | null;
    /**
     * Идентификатор гражданства
     * @type {number}
     * @memberof ExecutorResponse
     */
    'citizenshipId'?: number;
    /**
     * Идентификатор города
     * @type {number}
     * @memberof ExecutorResponse
     */
    'cityId'?: number;
    /**
     * Наименование города
     * @type {string}
     * @memberof ExecutorResponse
     */
    'cityName'?: string | null;
    /**
     * Идентификатор опыта
     * @type {number}
     * @memberof ExecutorResponse
     */
    'experienceId'?: number;
    /**
     * Описание об опыте с животными
     * @type {string}
     * @memberof ExecutorResponse
     */
    'experienceWithPets'?: string | null;
    /**
     * Описание о хобби
     * @type {string}
     * @memberof ExecutorResponse
     */
    'hobby'?: string | null;
    /**
     * Описание деятельности
     * @type {string}
     * @memberof ExecutorResponse
     */
    'activity'?: string | null;
    /**
     * Описание об целях
     * @type {string}
     * @memberof ExecutorResponse
     */
    'targets'?: string | null;
    /**
     * Описание \"Живут ли с вами питомцы\"
     * @type {string}
     * @memberof ExecutorResponse
     */
    'doYouHavePets'?: string | null;
    /**
     * Рейтинг исполнителя
     * @type {number}
     * @memberof ExecutorResponse
     */
    'rating'?: number | null;
    /**
     * Количество опубликованных отзывов
     * @type {number}
     * @memberof ExecutorResponse
     */
    'reviewCount'?: number;
    /**
     * Идентификатор исполнителя в системе RocketWork
     * @type {number}
     * @memberof ExecutorResponse
     */
    'rocketWorkId'?: number | null;
    /**
     * Привязаны ли у исполнителя существующие платежные способы
     * @type {boolean}
     * @memberof ExecutorResponse
     */
    'hasPayoutMethods'?: boolean;
    /**
     * Привязан ли к VK
     * @type {boolean}
     * @memberof ExecutorResponse
     */
    'isVkLinked'?: boolean;
    /**
     * Разрешены ли маркетинговые уведомления
     * @type {boolean}
     * @memberof ExecutorResponse
     */
    'isAllowMarketingNotifications'?: boolean;
}


/**
 * 
 * @export
 * @interface ExecutorReviewsResponse
 */
export interface ExecutorReviewsResponse {
    /**
     * 
     * @type {number}
     * @memberof ExecutorReviewsResponse
     */
    'count'?: number;
    /**
     * 
     * @type {Array<ReviewResponse>}
     * @memberof ExecutorReviewsResponse
     */
    'reviews'?: Array<ReviewResponse> | null;
}
/**
 * Вознаграждение по продукту заказа
 * @export
 * @interface ExecutorRewardProductResponse
 */
export interface ExecutorRewardProductResponse {
    /**
     * Отображаемое название услуги
     * @type {string}
     * @memberof ExecutorRewardProductResponse
     */
    'displayName'?: string | null;
    /**
     * Вознаграждение с учётом количества и коэффициента
     * @type {number}
     * @memberof ExecutorRewardProductResponse
     */
    'reward'?: number;
    /**
     * Пояснение к расчёту вознаграждения
     * @type {string}
     * @memberof ExecutorRewardProductResponse
     */
    'description'?: string | null;
}
/**
 * Вознаграждение исполнителя по заказу
 * @export
 * @interface ExecutorRewardResponse
 */
export interface ExecutorRewardResponse {
    /**
     * Общее вознаграждение исполнителя
     * @type {number}
     * @memberof ExecutorRewardResponse
     */
    'totalReward'?: number;
    /**
     * Вознаграждение по продуктам заказа
     * @type {Array<ExecutorRewardProductResponse>}
     * @memberof ExecutorRewardResponse
     */
    'products'?: Array<ExecutorRewardProductResponse> | null;
}
/**
 * 
 * @export
 * @interface ExperienceResponse
 */
export interface ExperienceResponse {
    /**
     * 
     * @type {number}
     * @memberof ExperienceResponse
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof ExperienceResponse
     */
    'value'?: string | null;
}
/**
 * Сведения избранного или приглашённого исполнителя клиента
 * @export
 * @interface FavoriteExecutorResponse
 */
export interface FavoriteExecutorResponse {
    /**
     * Доступность исполнителя для приглашения
     * @type {boolean}
     * @memberof FavoriteExecutorResponse
     */
    'isAvailable'?: boolean;
    /**
     * Идентификатор исполнителя
     * @type {string}
     * @memberof FavoriteExecutorResponse
     */
    'executorId'?: string;
    /**
     * Имя исполнителя
     * @type {string}
     * @memberof FavoriteExecutorResponse
     */
    'name'?: string | null;
    /**
     * Ссылка на фотографию
     * @type {string}
     * @memberof FavoriteExecutorResponse
     */
    'photoUrl'?: string | null;
    /**
     * Рейтинг исполнителя
     * @type {number}
     * @memberof FavoriteExecutorResponse
     */
    'rating'?: number | null;
    /**
     * Количество опубликованных отзывов
     * @type {number}
     * @memberof FavoriteExecutorResponse
     */
    'reviewsCount'?: number;
}
/**
 * Избранные исполнители и ограничения выбора
 * @export
 * @interface FavoriteExecutorsResponse
 */
export interface FavoriteExecutorsResponse {
    /**
     * Избранные исполнители
     * @type {Array<FavoriteExecutorResponse>}
     * @memberof FavoriteExecutorsResponse
     */
    'executors'?: Array<FavoriteExecutorResponse> | null;
    /**
     * Максимальное количество избранных исполнителей
     * @type {number}
     * @memberof FavoriteExecutorsResponse
     */
    'favoriteLimit'?: number;
    /**
     * Максимальное количество приглашений на заказ
     * @type {number}
     * @memberof FavoriteExecutorsResponse
     */
    'invitationLimit'?: number;
}
/**
 * Данные функционального переключателя
 * @export
 * @interface FeatureTogglesResponse
 */
export interface FeatureTogglesResponse {
    /**
     * Идентификатор функционального переключателя
     * @type {string}
     * @memberof FeatureTogglesResponse
     */
    'id'?: string;
    /**
     * 
     * @type {ApiFeatureToggleTypeSimpleModel}
     * @memberof FeatureTogglesResponse
     */
    'type'?: ApiFeatureToggleTypeSimpleModel;
    /**
     * Наименование функционального переключателя
     * @type {string}
     * @memberof FeatureTogglesResponse
     */
    'name'?: string | null;
    /**
     * Описание действия функционального переключателя
     * @type {string}
     * @memberof FeatureTogglesResponse
     */
    'description'?: string | null;
    /**
     * Включен ли функциональный переключатель
     * @type {boolean}
     * @memberof FeatureTogglesResponse
     */
    'isEnabled'?: boolean;
}
/**
 * 
 * @export
 * @interface FeedbackRequest
 */
export interface FeedbackRequest {
    /**
     * 
     * @type {string}
     * @memberof FeedbackRequest
     */
    'text'?: string | null;
}
/**
 * Условия покупки абонемента
 * @export
 * @interface FullInfoSubscriptionResponse
 */
export interface FullInfoSubscriptionResponse {
    /**
     * Идентификатор абонемента
     * @type {string}
     * @memberof FullInfoSubscriptionResponse
     */
    'id'?: string;
    /**
     * Название абонемента
     * @type {string}
     * @memberof FullInfoSubscriptionResponse
     */
    'name'?: string | null;
    /**
     * Описание абонемента
     * @type {string}
     * @memberof FullInfoSubscriptionResponse
     */
    'description'?: string | null;
    /**
     * Заголовок абонемента
     * @type {string}
     * @memberof FullInfoSubscriptionResponse
     */
    'title'?: string | null;
    /**
     * Подзаголовок абонемента
     * @type {string}
     * @memberof FullInfoSubscriptionResponse
     */
    'subtitle'?: string | null;
    /**
     * Скидка на основной продукт
     * @type {number}
     * @memberof FullInfoSubscriptionResponse
     */
    'baseDiscount'?: number;
    /**
     * Второй питомец включён в одно использование абонемента
     * @type {boolean}
     * @memberof FullInfoSubscriptionResponse
     */
    'isSecondPetIncluded'?: boolean;
    /**
     * Ночная надбавка включена в абонемент
     * @type {boolean}
     * @memberof FullInfoSubscriptionResponse
     */
    'isNightSurchargeIncluded'?: boolean;
    /**
     * Цвет фона для UI
     * @type {string}
     * @memberof FullInfoSubscriptionResponse
     */
    'backgroundColor'?: string | null;
    /**
     * Время планирования (например, \"до 12 прогулок в месяц\")
     * @type {string}
     * @memberof FullInfoSubscriptionResponse
     */
    'planningTime'?: string | null;
    /**
     * Количество использований абонемента
     * @type {number}
     * @memberof FullInfoSubscriptionResponse
     */
    'numberOfUsesCount'?: number;
    /**
     * Доступен в продаже
     * @type {boolean}
     * @memberof FullInfoSubscriptionResponse
     */
    'isActive'?: boolean;
    /**
     * Срок действия (указывается в днях)
     * @type {number}
     * @memberof FullInfoSubscriptionResponse
     */
    'durationDays'?: number;
    /**
     * Цена базового продукта (ассоциируемого)
     * @type {number}
     * @memberof FullInfoSubscriptionResponse
     */
    'baseProductPrice'?: number;
    /**
     * Идентификатор продукта на который выпускался абонемент
     * @type {string}
     * @memberof FullInfoSubscriptionResponse
     */
    'associatedProductId'?: string;
    /**
     * Идентификатор продукта-абонемента
     * @type {string}
     * @memberof FullInfoSubscriptionResponse
     */
    'subscriptionProductId'?: string | null;
    /**
     * Цена всего продукта-абонемента
     * @type {number}
     * @memberof FullInfoSubscriptionResponse
     */
    'subscriptionProductPrice'?: number | null;
    /**
     * Стоимость одной услуги с учётом скидок
     * @type {number}
     * @memberof FullInfoSubscriptionResponse
     */
    'priceForOne'?: number;
    /**
     * Стоимость покупки абонемента со скидкой
     * @type {number}
     * @memberof FullInfoSubscriptionResponse
     */
    'subscriptionProductPriceWithDiscount'?: number;
}
/**
 * Запрос страницы внутренних пользователей
 * @export
 * @interface GetAccessAppUsersRequest
 */
export interface GetAccessAppUsersRequest {
    /**
     * Строка для поиска
     * @type {string}
     * @memberof GetAccessAppUsersRequest
     */
    'searchQuery'?: string | null;
    /**
     * Размер страницы
     * @type {number}
     * @memberof GetAccessAppUsersRequest
     */
    'takeCount'?: number | null;
    /**
     * Кол-во пропущенных записей
     * @type {number}
     * @memberof GetAccessAppUsersRequest
     */
    'skipCount'?: number | null;
    /**
     * Сортировка по возрастанию
     * @type {boolean}
     * @memberof GetAccessAppUsersRequest
     */
    'ascending'?: boolean | null;
    /**
     * Поле для сортировки
     * @type {string}
     * @memberof GetAccessAppUsersRequest
     */
    'ordering'?: string | null;
    /**
     * Удалённые записи
     * @type {boolean}
     * @memberof GetAccessAppUsersRequest
     */
    'isDeleted'?: boolean | null;
    /**
     * Дата создания: начало периода
     * @type {string}
     * @memberof GetAccessAppUsersRequest
     */
    'createdFrom'?: string | null;
    /**
     * Дата создания: конец периода
     * @type {string}
     * @memberof GetAccessAppUsersRequest
     */
    'createdTo'?: string | null;
    /**
     * Роли для фильтрации пользователей
     * @type {Array<ApiUserRole>}
     * @memberof GetAccessAppUsersRequest
     */
    'roles'?: Array<ApiUserRole> | null;
    /**
     * Состояние блокировки для фильтрации
     * @type {boolean}
     * @memberof GetAccessAppUsersRequest
     */
    'isBlocked'?: boolean | null;
}
/**
 * Страница внутренних пользователей
 * @export
 * @interface GetAccessAppUsersResponse
 */
export interface GetAccessAppUsersResponse {
    /**
     * Общее количество пользователей
     * @type {number}
     * @memberof GetAccessAppUsersResponse
     */
    'allCount'?: number;
    /**
     * Пользователи текущей страницы
     * @type {Array<AccessAppUserResponse>}
     * @memberof GetAccessAppUsersResponse
     */
    'appUsers'?: Array<AccessAppUserResponse> | null;
}
/**
 * 
 * @export
 * @interface GetAllProductsResponse
 */
export interface GetAllProductsResponse {
    /**
     * Общее количество
     * @type {number}
     * @memberof GetAllProductsResponse
     */
    'allCount'?: number;
    /**
     * Продукты
     * @type {Array<ProductShortResponse>}
     * @memberof GetAllProductsResponse
     */
    'products'?: Array<ProductShortResponse> | null;
}
/**
 * 
 * @export
 * @interface GetAnswerModel
 */
export interface GetAnswerModel {
    /**
     * 
     * @type {number}
     * @memberof GetAnswerModel
     */
    'id'?: number;
    /**
     * Id вопроса
     * @type {number}
     * @memberof GetAnswerModel
     */
    'questionId'?: number;
    /**
     * Текст ответа
     * @type {string}
     * @memberof GetAnswerModel
     */
    'text'?: string | null;
    /**
     * Правильный/неверный ответ
     * @type {boolean}
     * @memberof GetAnswerModel
     */
    'isTrue'?: boolean;
}
/**
 * 
 * @export
 * @interface GetAnswerResponse
 */
export interface GetAnswerResponse {
    /**
     * 
     * @type {number}
     * @memberof GetAnswerResponse
     */
    'id'?: number;
    /**
     * Id вопроса
     * @type {number}
     * @memberof GetAnswerResponse
     */
    'questionId'?: number;
    /**
     * Текст ответа
     * @type {string}
     * @memberof GetAnswerResponse
     */
    'text'?: string | null;
    /**
     * Правильный/неверный ответ
     * @type {boolean}
     * @memberof GetAnswerResponse
     */
    'isTrue'?: boolean;
}
/**
 * 
 * @export
 * @interface GetAnswerResponseModel
 */
export interface GetAnswerResponseModel {
    /**
     * 
     * @type {number}
     * @memberof GetAnswerResponseModel
     */
    'id'?: number;
    /**
     * Id вопроса
     * @type {number}
     * @memberof GetAnswerResponseModel
     */
    'questionId'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof GetAnswerResponseModel
     */
    'isTrue'?: boolean;
    /**
     * Текст ответа
     * @type {string}
     * @memberof GetAnswerResponseModel
     */
    'text'?: string | null;
}
/**
 * 
 * @export
 * @interface GetBaseProductsForOrderRequest
 */
export interface GetBaseProductsForOrderRequest {
    /**
     * Идентификатор клиента
     * @type {string}
     * @memberof GetBaseProductsForOrderRequest
     */
    'clientId'?: string;
    /**
     * Идентификатор продукта-базового
     * @type {string}
     * @memberof GetBaseProductsForOrderRequest
     */
    'productId'?: string;
}
/**
 * Параметры получения бонусных счетов
 * @export
 * @interface GetBonusAccountsRequest
 */
export interface GetBonusAccountsRequest {
    /**
     * Строка для поиска
     * @type {string}
     * @memberof GetBonusAccountsRequest
     */
    'searchQuery'?: string | null;
    /**
     * Размер страницы
     * @type {number}
     * @memberof GetBonusAccountsRequest
     */
    'takeCount'?: number | null;
    /**
     * Кол-во пропущенных записей
     * @type {number}
     * @memberof GetBonusAccountsRequest
     */
    'skipCount'?: number | null;
    /**
     * Сортировка по возрастанию
     * @type {boolean}
     * @memberof GetBonusAccountsRequest
     */
    'ascending'?: boolean | null;
    /**
     * Поле для сортировки
     * @type {string}
     * @memberof GetBonusAccountsRequest
     */
    'ordering'?: string | null;
    /**
     * Удалённые записи
     * @type {boolean}
     * @memberof GetBonusAccountsRequest
     */
    'isDeleted'?: boolean | null;
    /**
     * Поиск по номеру бонусного счёта
     * @type {string}
     * @memberof GetBonusAccountsRequest
     */
    'bonusAccountNumberSearch'?: string | null;
    /**
     * Поиск по номеру телефона клиента
     * @type {string}
     * @memberof GetBonusAccountsRequest
     */
    'clientPhoneSearch'?: string | null;
    /**
     * 
     * @type {BonusAccountSortField}
     * @memberof GetBonusAccountsRequest
     */
    'sortBy'?: BonusAccountSortField;
}


/**
 * Результат получения бонусных счетов
 * @export
 * @interface GetBonusAccountsResponse
 */
export interface GetBonusAccountsResponse {
    /**
     * Общее количество бонусных счетов
     * @type {number}
     * @memberof GetBonusAccountsResponse
     */
    'allCount'?: number;
    /**
     * Бонусные счета
     * @type {Array<BonusAccountShortResponse>}
     * @memberof GetBonusAccountsResponse
     */
    'bonusAccounts'?: Array<BonusAccountShortResponse> | null;
}
/**
 * 
 * @export
 * @interface GetCityDistrictsResponse
 */
export interface GetCityDistrictsResponse {
    /**
     * Общее количество
     * @type {number}
     * @memberof GetCityDistrictsResponse
     */
    'allCount'?: number;
    /**
     * Районы города
     * @type {Array<CityDistrictResponse>}
     * @memberof GetCityDistrictsResponse
     */
    'cityDistricts'?: Array<CityDistrictResponse> | null;
}
/**
 * 
 * @export
 * @interface GetClientSubscriptionResponse
 */
export interface GetClientSubscriptionResponse {
    /**
     * Идентификатор клиента
     * @type {string}
     * @memberof GetClientSubscriptionResponse
     */
    'clientId'?: string;
    /**
     * Общее количество использований по всем абонементам
     * @type {number}
     * @memberof GetClientSubscriptionResponse
     */
    'commonUsesCount'?: number;
    /**
     * 
     * @type {ApiPetTypeSimpleModel}
     * @memberof GetClientSubscriptionResponse
     */
    'petType'?: ApiPetTypeSimpleModel;
    /**
     * Укороченные данные по абонементам
     * @type {Array<ClientSubscriptionInfoReponse>}
     * @memberof GetClientSubscriptionResponse
     */
    'subscriptions'?: Array<ClientSubscriptionInfoReponse> | null;
}
/**
 * Запрос на получение абонементов клиента
 * @export
 * @interface GetClientSubscriptionsRequest
 */
export interface GetClientSubscriptionsRequest {
    /**
     * Поиск по идентификатору записи
     * @type {string}
     * @memberof GetClientSubscriptionsRequest
     */
    'idSearch'?: string | null;
    /**
     * Поиск по наименованию
     * @type {string}
     * @memberof GetClientSubscriptionsRequest
     */
    'nameSearch'?: string | null;
    /**
     * Поиск по названию типа продукта
     * @type {string}
     * @memberof GetClientSubscriptionsRequest
     */
    'productTypeSearch'?: string | null;
    /**
     * Поиск по названию типа питомца
     * @type {string}
     * @memberof GetClientSubscriptionsRequest
     */
    'petTypeSearch'?: string | null;
    /**
     * Поиск по оставшимся и общим использованиям
     * @type {string}
     * @memberof GetClientSubscriptionsRequest
     */
    'usageSearch'?: string | null;
    /**
     * Признак активного абонемента
     * @type {boolean}
     * @memberof GetClientSubscriptionsRequest
     */
    'isActive'?: boolean | null;
    /**
     * Нижняя включительная граница срока действия
     * @type {string}
     * @memberof GetClientSubscriptionsRequest
     */
    'expirationFrom'?: string | null;
    /**
     * Верхняя исключительная граница срока действия
     * @type {string}
     * @memberof GetClientSubscriptionsRequest
     */
    'expirationTo'?: string | null;
    /**
     * Идентификатор клиента
     * @type {string}
     * @memberof GetClientSubscriptionsRequest
     */
    'clientId'?: string;
    /**
     * 
     * @type {ApiPetType}
     * @memberof GetClientSubscriptionsRequest
     */
    'petType'?: ApiPetType;
}


/**
 * 
 * @export
 * @interface GetClientsResponse
 */
export interface GetClientsResponse {
    /**
     * Общее количество клиентов
     * @type {number}
     * @memberof GetClientsResponse
     */
    'allCount'?: number;
    /**
     * Клиенты
     * @type {Array<ClientResponse>}
     * @memberof GetClientsResponse
     */
    'clients'?: Array<ClientResponse> | null;
}
/**
 * Параметры получения событий
 * @export
 * @interface GetEventsRequest
 */
export interface GetEventsRequest {
    /**
     * Строка для поиска
     * @type {string}
     * @memberof GetEventsRequest
     */
    'searchQuery'?: string | null;
    /**
     * Размер страницы
     * @type {number}
     * @memberof GetEventsRequest
     */
    'takeCount'?: number | null;
    /**
     * Кол-во пропущенных записей
     * @type {number}
     * @memberof GetEventsRequest
     */
    'skipCount'?: number | null;
    /**
     * Сортировка по возрастанию
     * @type {boolean}
     * @memberof GetEventsRequest
     */
    'ascending'?: boolean | null;
    /**
     * Поле для сортировки
     * @type {string}
     * @memberof GetEventsRequest
     */
    'ordering'?: string | null;
    /**
     * Удалённые записи
     * @type {boolean}
     * @memberof GetEventsRequest
     */
    'isDeleted'?: boolean | null;
    /**
     * Поиск по названию типа
     * @type {string}
     * @memberof GetEventsRequest
     */
    'typeSearch'?: string | null;
    /**
     * Поиск по комментарию
     * @type {string}
     * @memberof GetEventsRequest
     */
    'commentSearch'?: string | null;
    /**
     * Поиск по тексту описания
     * @type {string}
     * @memberof GetEventsRequest
     */
    'descriptionSearch'?: string | null;
    /**
     * Поиск по имени пользователя
     * @type {string}
     * @memberof GetEventsRequest
     */
    'userNameSearch'?: string | null;
    /**
     * Дата события: начало периода
     * @type {string}
     * @memberof GetEventsRequest
     */
    'createdFrom'?: string | null;
    /**
     * Дата события: конец периода
     * @type {string}
     * @memberof GetEventsRequest
     */
    'createdTo'?: string | null;
    /**
     * Идентификатор клиента
     * @type {string}
     * @memberof GetEventsRequest
     */
    'clientId'?: string | null;
    /**
     * Идентификатор заказа
     * @type {string}
     * @memberof GetEventsRequest
     */
    'orderId'?: string | null;
    /**
     * Идентификатор связанной сущности
     * @type {string}
     * @memberof GetEventsRequest
     */
    'entityId'?: string | null;
    /**
     * Идентификатор промокода
     * @type {string}
     * @memberof GetEventsRequest
     */
    'promoCodeId'?: string | null;
    /**
     * Идентификатор абонемента клиента
     * @type {string}
     * @memberof GetEventsRequest
     */
    'clientSubscriptionId'?: string | null;
    /**
     * Идентификатор исполнителя
     * @type {string}
     * @memberof GetEventsRequest
     */
    'executorId'?: string | null;
}
/**
 * Результат получения событий
 * @export
 * @interface GetEventsResponse
 */
export interface GetEventsResponse {
    /**
     * Общее количество событий
     * @type {number}
     * @memberof GetEventsResponse
     */
    'allCount'?: number;
    /**
     * События
     * @type {Array<EventResponse>}
     * @memberof GetEventsResponse
     */
    'events'?: Array<EventResponse> | null;
}
/**
 * 
 * @export
 * @interface GetExecutorAccessTestResponse
 */
export interface GetExecutorAccessTestResponse {
    /**
     * 
     * @type {number}
     * @memberof GetExecutorAccessTestResponse
     */
    'id'?: number;
    /**
     * ID выгульщика
     * @type {string}
     * @memberof GetExecutorAccessTestResponse
     */
    'executorId'?: string;
    /**
     * ID теста
     * @type {number}
     * @memberof GetExecutorAccessTestResponse
     */
    'testId'?: number;
}
/**
 * 
 * @export
 * @interface GetExecutorLessonProgressBy
 */
export interface GetExecutorLessonProgressBy {
    /**
     * 
     * @type {number}
     * @memberof GetExecutorLessonProgressBy
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof GetExecutorLessonProgressBy
     */
    'executorId'?: string;
    /**
     * ID урока
     * @type {number}
     * @memberof GetExecutorLessonProgressBy
     */
    'lessonId'?: number;
    /**
     * Пройден ли
     * @type {boolean}
     * @memberof GetExecutorLessonProgressBy
     */
    'isCompleted'?: boolean;
    /**
     * Когда пройден
     * @type {string}
     * @memberof GetExecutorLessonProgressBy
     */
    'completedAt'?: string | null;
}
/**
 * 
 * @export
 * @interface GetExecutorLessonProgressByExecutorIdResponse
 */
export interface GetExecutorLessonProgressByExecutorIdResponse {
    /**
     * 
     * @type {number}
     * @memberof GetExecutorLessonProgressByExecutorIdResponse
     */
    'id'?: number;
    /**
     * ID урока
     * @type {number}
     * @memberof GetExecutorLessonProgressByExecutorIdResponse
     */
    'lessonId'?: number;
    /**
     * Порядковый номер урока
     * @type {number}
     * @memberof GetExecutorLessonProgressByExecutorIdResponse
     */
    'indexNumber'?: number;
    /**
     * 
     * @type {ApiPetTypeSimpleModel}
     * @memberof GetExecutorLessonProgressByExecutorIdResponse
     */
    'petType'?: ApiPetTypeSimpleModel;
    /**
     * Пройден ли
     * @type {boolean}
     * @memberof GetExecutorLessonProgressByExecutorIdResponse
     */
    'isCompleted'?: boolean;
    /**
     * Когда пройден
     * @type {string}
     * @memberof GetExecutorLessonProgressByExecutorIdResponse
     */
    'completedAt'?: string | null;
}
/**
 * 
 * @export
 * @interface GetExecutorLessonProgressResponse
 */
export interface GetExecutorLessonProgressResponse {
    /**
     * ID теста
     * @type {number}
     * @memberof GetExecutorLessonProgressResponse
     */
    'testId'?: number;
}
/**
 * 
 * @export
 * @interface GetExecutorsResponse
 */
export interface GetExecutorsResponse {
    /**
     * Общее количество исполнителей
     * @type {number}
     * @memberof GetExecutorsResponse
     */
    'allCount'?: number;
    /**
     * Исполнители
     * @type {Array<ExecutorResponse>}
     * @memberof GetExecutorsResponse
     */
    'executors'?: Array<ExecutorResponse> | null;
}
/**
 * 
 * @export
 * @interface GetLessonResponse
 */
export interface GetLessonResponse {
    /**
     * 
     * @type {number}
     * @memberof GetLessonResponse
     */
    'id'?: number;
    /**
     * 
     * @type {ApiPetTypeSimpleModel}
     * @memberof GetLessonResponse
     */
    'petType': ApiPetTypeSimpleModel;
    /**
     * Заголовок
     * @type {string}
     * @memberof GetLessonResponse
     */
    'title': string | null;
    /**
     * Название
     * @type {string}
     * @memberof GetLessonResponse
     */
    'name': string | null;
    /**
     * Описание
     * @type {string}
     * @memberof GetLessonResponse
     */
    'description': string | null;
    /**
     * Путь до видео урока
     * @type {string}
     * @memberof GetLessonResponse
     */
    'videoUrl'?: string | null;
    /**
     * Картинка для карточки
     * @type {string}
     * @memberof GetLessonResponse
     */
    'imageUrl'?: string | null;
    /**
     * Порядковый номер урока
     * @type {number}
     * @memberof GetLessonResponse
     */
    'indexNumber': number;
    /**
     * Время на обучение
     * @type {string}
     * @memberof GetLessonResponse
     */
    'timeToStudy': string;
}
/**
 * Страница ответственных сотрудников задачи
 * @export
 * @interface GetOperatorTaskAssigneesResponse
 */
export interface GetOperatorTaskAssigneesResponse {
    /**
     * Ответственные сотрудники
     * @type {Array<OperatorTaskAssigneeResponse>}
     * @memberof GetOperatorTaskAssigneesResponse
     */
    'items'?: Array<OperatorTaskAssigneeResponse> | null;
    /**
     * Количество подходящих сотрудников
     * @type {number}
     * @memberof GetOperatorTaskAssigneesResponse
     */
    'allCount'?: number;
}
/**
 * Задачи, требующие внимания, и ближайшие напоминания
 * @export
 * @interface GetOperatorTaskAttentionResponse
 */
export interface GetOperatorTaskAttentionResponse {
    /**
     * Задачи, требующие внимания
     * @type {Array<OperatorTaskAttentionItemResponse>}
     * @memberof GetOperatorTaskAttentionResponse
     */
    'items'?: Array<OperatorTaskAttentionItemResponse> | null;
    /**
     * Общее количество задач, требующих внимания
     * @type {number}
     * @memberof GetOperatorTaskAttentionResponse
     */
    'allCount'?: number;
    /**
     * Серверное время
     * @type {string}
     * @memberof GetOperatorTaskAttentionResponse
     */
    'serverTimeUtc'?: string;
    /**
     * Часовой пояс
     * @type {string}
     * @memberof GetOperatorTaskAttentionResponse
     */
    'timeZoneId'?: string | null;
    /**
     * Ближайшие задачи
     * @type {Array<OperatorTaskListItemResponse>}
     * @memberof GetOperatorTaskAttentionResponse
     */
    'upcoming'?: Array<OperatorTaskListItemResponse> | null;
}
/**
 * Задачи календарного диапазона
 * @export
 * @interface GetOperatorTaskCalendarResponse
 */
export interface GetOperatorTaskCalendarResponse {
    /**
     * Задачи календарного диапазона
     * @type {Array<OperatorTaskListItemResponse>}
     * @memberof GetOperatorTaskCalendarResponse
     */
    'items'?: Array<OperatorTaskListItemResponse> | null;
    /**
     * Общее количество задач календарного диапазона
     * @type {number}
     * @memberof GetOperatorTaskCalendarResponse
     */
    'allCount'?: number;
    /**
     * Серверное время
     * @type {string}
     * @memberof GetOperatorTaskCalendarResponse
     */
    'serverTimeUtc'?: string;
    /**
     * Часовой пояс
     * @type {string}
     * @memberof GetOperatorTaskCalendarResponse
     */
    'timeZoneId'?: string | null;
    /**
     * Наличие следующих записей
     * @type {boolean}
     * @memberof GetOperatorTaskCalendarResponse
     */
    'hasMore'?: boolean;
    /**
     * Начало календарного диапазона
     * @type {string}
     * @memberof GetOperatorTaskCalendarResponse
     */
    'fromUtc'?: string;
    /**
     * Конец календарного диапазона
     * @type {string}
     * @memberof GetOperatorTaskCalendarResponse
     */
    'toUtc'?: string;
}
/**
 * История изменений задачи
 * @export
 * @interface GetOperatorTaskHistoryResponse
 */
export interface GetOperatorTaskHistoryResponse {
    /**
     * Действия сотрудников над задачей
     * @type {Array<OperatorTaskHistoryEntryResponse>}
     * @memberof GetOperatorTaskHistoryResponse
     */
    'items'?: Array<OperatorTaskHistoryEntryResponse> | null;
    /**
     * Общее количество действий над задачей
     * @type {number}
     * @memberof GetOperatorTaskHistoryResponse
     */
    'allCount'?: number;
    /**
     * Серверное время
     * @type {string}
     * @memberof GetOperatorTaskHistoryResponse
     */
    'serverTimeUtc'?: string;
    /**
     * Часовой пояс
     * @type {string}
     * @memberof GetOperatorTaskHistoryResponse
     */
    'timeZoneId'?: string | null;
}
/**
 * Результаты поиска заказов и чатов для задачи
 * @export
 * @interface GetOperatorTaskRelatedResponse
 */
export interface GetOperatorTaskRelatedResponse {
    /**
     * Найденные заказы и чаты
     * @type {Array<OperatorTaskRelatedResponse>}
     * @memberof GetOperatorTaskRelatedResponse
     */
    'items'?: Array<OperatorTaskRelatedResponse> | null;
    /**
     * Общее количество найденных заказов и чатов
     * @type {number}
     * @memberof GetOperatorTaskRelatedResponse
     */
    'allCount'?: number;
    /**
     * Серверное время
     * @type {string}
     * @memberof GetOperatorTaskRelatedResponse
     */
    'serverTimeUtc'?: string;
    /**
     * Часовой пояс
     * @type {string}
     * @memberof GetOperatorTaskRelatedResponse
     */
    'timeZoneId'?: string | null;
}
/**
 * История напоминаний задач
 * @export
 * @interface GetOperatorTaskRemindersResponse
 */
export interface GetOperatorTaskRemindersResponse {
    /**
     * Наступившие напоминания задач
     * @type {Array<OperatorTaskReminderResponse>}
     * @memberof GetOperatorTaskRemindersResponse
     */
    'items'?: Array<OperatorTaskReminderResponse> | null;
    /**
     * Общее количество напоминаний задач
     * @type {number}
     * @memberof GetOperatorTaskRemindersResponse
     */
    'allCount'?: number;
    /**
     * Серверное время
     * @type {string}
     * @memberof GetOperatorTaskRemindersResponse
     */
    'serverTimeUtc'?: string;
    /**
     * Часовой пояс
     * @type {string}
     * @memberof GetOperatorTaskRemindersResponse
     */
    'timeZoneId'?: string | null;
}
/**
 * Страница общей очереди задач
 * @export
 * @interface GetOperatorTasksResponse
 */
export interface GetOperatorTasksResponse {
    /**
     * Задачи общей очереди
     * @type {Array<OperatorTaskListItemResponse>}
     * @memberof GetOperatorTasksResponse
     */
    'items'?: Array<OperatorTaskListItemResponse> | null;
    /**
     * Общее количество задач по выбранным фильтрам
     * @type {number}
     * @memberof GetOperatorTasksResponse
     */
    'allCount'?: number;
    /**
     * Серверное время
     * @type {string}
     * @memberof GetOperatorTasksResponse
     */
    'serverTimeUtc'?: string;
    /**
     * Часовой пояс
     * @type {string}
     * @memberof GetOperatorTasksResponse
     */
    'timeZoneId'?: string | null;
    /**
     * 
     * @type {OperatorTaskFilterCountsResponse}
     * @memberof GetOperatorTasksResponse
     */
    'filterCounts'?: OperatorTaskFilterCountsResponse;
}
/**
 * Запрос на получение или создание чата
 * @export
 * @interface GetOrCreateChatRequest
 */
export interface GetOrCreateChatRequest {
    /**
     * Идентификатор отправителя
     * @type {string}
     * @memberof GetOrCreateChatRequest
     */
    'ownerAppUserId'?: string;
    /**
     * Идентификатор собеседника
     * @type {string}
     * @memberof GetOrCreateChatRequest
     */
    'companionId'?: string;
    /**
     * 
     * @type {UserRole}
     * @memberof GetOrCreateChatRequest
     */
    'companionRole'?: UserRole;
}


/**
 * Данные найденной или созданной переписки
 * @export
 * @interface GetOrCreateChatResponse
 */
export interface GetOrCreateChatResponse {
    /**
     * Идентификатор чата
     * @type {string}
     * @memberof GetOrCreateChatResponse
     */
    'chatId'?: string;
    /**
     * AppUser идентификатор собеседника
     * @type {string}
     * @memberof GetOrCreateChatResponse
     */
    'companionAppUserId'?: string;
}
/**
 * Модель запроса при первичном открытии экрана заказа.  Получаем уже существующий черновик заказа или создаем новый
 * @export
 * @interface GetOrCreateOrderRequest
 */
export interface GetOrCreateOrderRequest {
    /**
     * Идентификатор клиента
     * @type {string}
     * @memberof GetOrCreateOrderRequest
     */
    'clientId'?: string;
    /**
     * Идентификатор продукта-базового
     * @type {string}
     * @memberof GetOrCreateOrderRequest
     */
    'productId'?: string;
}
/**
 * 
 * @export
 * @interface GetOrCreatePaymentRequest
 */
export interface GetOrCreatePaymentRequest {
    /**
     * Идентификатор заказа
     * @type {string}
     * @memberof GetOrCreatePaymentRequest
     */
    'orderId'?: string;
    /**
     * 
     * @type {ApplyPromoCodeRequest}
     * @memberof GetOrCreatePaymentRequest
     */
    'applyPromoCode'?: ApplyPromoCodeRequest;
    /**
     * 
     * @type {ApplyCustomServiceRequest}
     * @memberof GetOrCreatePaymentRequest
     */
    'applyCustomService'?: ApplyCustomServiceRequest;
    /**
     * 
     * @type {ApplyBonusPointsRequest}
     * @memberof GetOrCreatePaymentRequest
     */
    'applyBonusPoints'?: ApplyBonusPointsRequest;
}
/**
 * Список проблем заказов
 * @export
 * @interface GetOrderProblemsResponse
 */
export interface GetOrderProblemsResponse {
    /**
     * Количество записей по фильтру
     * @type {number}
     * @memberof GetOrderProblemsResponse
     */
    'allCount'?: number;
    /**
     * Количество активных проблем
     * @type {number}
     * @memberof GetOrderProblemsResponse
     */
    'activeCount'?: number;
    /**
     * Проблемы заказов
     * @type {Array<OrderProblemResponse>}
     * @memberof GetOrderProblemsResponse
     */
    'problems'?: Array<OrderProblemResponse> | null;
}
/**
 * Условия получения списка заказов
 * @export
 * @interface GetOrdersRequest
 */
export interface GetOrdersRequest {
    /**
     * Строка для поиска
     * @type {string}
     * @memberof GetOrdersRequest
     */
    'searchQuery'?: string | null;
    /**
     * Размер страницы
     * @type {number}
     * @memberof GetOrdersRequest
     */
    'takeCount'?: number | null;
    /**
     * Кол-во пропущенных записей
     * @type {number}
     * @memberof GetOrdersRequest
     */
    'skipCount'?: number | null;
    /**
     * Сортировка по возрастанию
     * @type {boolean}
     * @memberof GetOrdersRequest
     */
    'ascending'?: boolean | null;
    /**
     * Поле для сортировки
     * @type {string}
     * @memberof GetOrdersRequest
     */
    'ordering'?: string | null;
    /**
     * Удалённые записи
     * @type {boolean}
     * @memberof GetOrdersRequest
     */
    'isDeleted'?: boolean | null;
    /**
     * Поиск по идентификатору записи
     * @type {string}
     * @memberof GetOrdersRequest
     */
    'idSearch'?: string | null;
    /**
     * Поиск по названию типа продукта
     * @type {string}
     * @memberof GetOrdersRequest
     */
    'productTypeSearch'?: string | null;
    /**
     * Поиск по названию типа питомца
     * @type {string}
     * @memberof GetOrdersRequest
     */
    'petTypeSearch'?: string | null;
    /**
     * Поиск по названию статуса заказа
     * @type {string}
     * @memberof GetOrdersRequest
     */
    'statusSearch'?: string | null;
    /**
     * Первая календарная дата оказания услуги
     * @type {string}
     * @memberof GetOrdersRequest
     */
    'serviceDateFrom'?: string | null;
    /**
     * Последняя календарная дата оказания услуги
     * @type {string}
     * @memberof GetOrdersRequest
     */
    'serviceDateTo'?: string | null;
    /**
     * Нижняя включительная граница даты оформления заказа
     * @type {string}
     * @memberof GetOrdersRequest
     */
    'createdFrom'?: string | null;
    /**
     * Верхняя исключительная граница даты оформления заказа
     * @type {string}
     * @memberof GetOrdersRequest
     */
    'createdTo'?: string | null;
    /**
     * Нижняя включительная граница даты начала заказа
     * @type {string}
     * @memberof GetOrdersRequest
     */
    'startOrderTimeFrom'?: string | null;
    /**
     * Верхняя исключительная граница даты начала заказа
     * @type {string}
     * @memberof GetOrdersRequest
     */
    'startOrderTimeTo'?: string | null;
    /**
     * Нижняя включительная граница даты формирования заказа
     * @type {string}
     * @memberof GetOrdersRequest
     */
    'formedAtFrom'?: string | null;
    /**
     * Верхняя исключительная граница даты формирования заказа
     * @type {string}
     * @memberof GetOrdersRequest
     */
    'formedAtTo'?: string | null;
    /**
     * Нижняя включительная граница даты завершения заказа
     * @type {string}
     * @memberof GetOrdersRequest
     */
    'completedAtFrom'?: string | null;
    /**
     * Верхняя исключительная граница даты завершения заказа
     * @type {string}
     * @memberof GetOrdersRequest
     */
    'completedAtTo'?: string | null;
    /**
     * Поиск заказов по номеру заказа
     * @type {string}
     * @memberof GetOrdersRequest
     */
    'orderNumberSearch'?: string | null;
    /**
     * Поиск заказов по имени клиента
     * @type {string}
     * @memberof GetOrdersRequest
     */
    'clientNameSearch'?: string | null;
    /**
     * Поиск заказов по имени питомца
     * @type {string}
     * @memberof GetOrdersRequest
     */
    'petNameSearch'?: string | null;
    /**
     * Поиск заказов по фамилии и имени исполнителя
     * @type {string}
     * @memberof GetOrdersRequest
     */
    'executorFioSearch'?: string | null;
    /**
     * Поиск заказов по телефону клиента
     * @type {string}
     * @memberof GetOrdersRequest
     */
    'clientPhoneSearch'?: string | null;
    /**
     * Поиск заказов по телефону исполнителя
     * @type {string}
     * @memberof GetOrdersRequest
     */
    'executorPhoneSearch'?: string | null;
    /**
     * Поиск заказов, по которым была ли направлена оплата исполнителю
     * @type {boolean}
     * @memberof GetOrdersRequest
     */
    'isPaymentSentToExecutor'?: boolean | null;
    /**
     * Наличие известного статуса обязательного ручного чека ФНС
     * @type {boolean}
     * @memberof GetOrdersRequest
     */
    'hasManualFnsReceipt'?: boolean | null;
    /**
     * 
     * @type {ApiManualFnsReceiptStatus}
     * @memberof GetOrdersRequest
     */
    'manualFnsReceiptStatus'?: ApiManualFnsReceiptStatus;
    /**
     * Поиск заказов, по которым был ли подписан исполнителем Акт выполненных работ
     * @type {boolean}
     * @memberof GetOrdersRequest
     */
    'isExecutorSignedAcceptanceAct'?: boolean | null;
    /**
     * Идентификатор исполнителя
     * @type {string}
     * @memberof GetOrdersRequest
     */
    'executorId'?: string | null;
    /**
     * Идентификатор города для поиска
     * @type {number}
     * @memberof GetOrdersRequest
     */
    'cityId'?: number | null;
    /**
     * Идентификаторы районов города для поиска
     * @type {Array<number>}
     * @memberof GetOrdersRequest
     */
    'cityDistrictIds'?: Array<number> | null;
    /**
     * Тип заказа
     * @type {Array<ApiOrderType>}
     * @memberof GetOrdersRequest
     */
    'orderTypes'?: Array<ApiOrderType> | null;
    /**
     * Статусы заказа
     * @type {Array<ApiOrderStatus>}
     * @memberof GetOrdersRequest
     */
    'statuses'?: Array<ApiOrderStatus> | null;
    /**
     * Типы животных для поиска
     * @type {Array<ApiPetType>}
     * @memberof GetOrdersRequest
     */
    'petTypes'?: Array<ApiPetType> | null;
    /**
     * 
     * @type {ApiOrderReviewStatus}
     * @memberof GetOrdersRequest
     */
    'orderReviewStatus'?: ApiOrderReviewStatus;
    /**
     * Идентификатор клиента
     * @type {string}
     * @memberof GetOrdersRequest
     */
    'clientId'?: string | null;
    /**
     * 
     * @type {OrderRequestSource}
     * @memberof GetOrdersRequest
     */
    'source'?: OrderRequestSource;
    /**
     * 
     * @type {OrderSortField}
     * @memberof GetOrdersRequest
     */
    'sortBy'?: OrderSortField;
}


/**
 * 
 * @export
 * @interface GetOrdersResponse
 */
export interface GetOrdersResponse {
    /**
     * Общее количество заказов
     * @type {number}
     * @memberof GetOrdersResponse
     */
    'allCount'?: number;
    /**
     * Заказы
     * @type {Array<OrderShortResponse>}
     * @memberof GetOrdersResponse
     */
    'orders'?: Array<OrderShortResponse> | null;
}
/**
 * Условия получения диалога пользователя
 * @export
 * @interface GetPendingDialogRequest
 */
export interface GetPendingDialogRequest {
    /**
     * Приложение поддерживает текстовую обратную связь
     * @type {boolean}
     * @memberof GetPendingDialogRequest
     */
    'supportsTextInput'?: boolean;
    /**
     * Маршрут показа диалога
     * @type {string}
     * @memberof GetPendingDialogRequest
     */
    'routeName'?: string | null;
    /**
     * Объект на маршруте показа
     * @type {string}
     * @memberof GetPendingDialogRequest
     */
    'routeEntityId'?: string | null;
    /**
     * Идентификатор пользователя
     * @type {string}
     * @memberof GetPendingDialogRequest
     */
    'appUserId'?: string;
    /**
     * Идентификатор заказа
     * @type {string}
     * @memberof GetPendingDialogRequest
     */
    'orderId'?: string | null;
}
/**
 * Доступный пользователю диалог
 * @export
 * @interface GetPendingDialogResponse
 */
export interface GetPendingDialogResponse {
    /**
     * Идентификатор диалога
     * @type {string}
     * @memberof GetPendingDialogResponse
     */
    'id'?: string;
    /**
     * Идентификатор пользователя
     * @type {string}
     * @memberof GetPendingDialogResponse
     */
    'appUserId'?: string;
    /**
     * Идентификатор заказа
     * @type {string}
     * @memberof GetPendingDialogResponse
     */
    'orderId'?: string | null;
    /**
     * 
     * @type {DialogTextInputResponse}
     * @memberof GetPendingDialogResponse
     */
    'textInput'?: DialogTextInputResponse;
    /**
     * Варианты ответа в диалоге
     * @type {Array<DialogOptionResponse>}
     * @memberof GetPendingDialogResponse
     */
    'options'?: Array<DialogOptionResponse> | null;
    /**
     * Заголовок
     * @type {string}
     * @memberof GetPendingDialogResponse
     */
    'title'?: string | null;
    /**
     * Текст диалога
     * @type {string}
     * @memberof GetPendingDialogResponse
     */
    'text'?: string | null;
}
/**
 * 
 * @export
 * @interface GetPetHabitsResponse
 */
export interface GetPetHabitsResponse {
    /**
     * 
     * @type {Array<HabitResponse>}
     * @memberof GetPetHabitsResponse
     */
    'habits'?: Array<HabitResponse> | null;
}
/**
 * 
 * @export
 * @interface GetPriceListsResponse
 */
export interface GetPriceListsResponse {
    /**
     * Общее количество прайс-листов
     * @type {number}
     * @memberof GetPriceListsResponse
     */
    'allCount'?: number;
    /**
     * Прайс-листы
     * @type {Array<PriceListResponse>}
     * @memberof GetPriceListsResponse
     */
    'priceLists'?: Array<PriceListResponse> | null;
}
/**
 * Страница проблемных адресов
 * @export
 * @interface GetProblemAddressesResponse
 */
export interface GetProblemAddressesResponse {
    /**
     * Общее количество домов
     * @type {number}
     * @memberof GetProblemAddressesResponse
     */
    'allCount'?: number;
    /**
     * Дома
     * @type {Array<ProblemAddressResponse>}
     * @memberof GetProblemAddressesResponse
     */
    'addresses'?: Array<ProblemAddressResponse> | null;
}
/**
 * Страница отзывов о проблемных исполнителях
 * @export
 * @interface GetProblemExecutorsResponse
 */
export interface GetProblemExecutorsResponse {
    /**
     * Отзывы с низкими оценками
     * @type {Array<ProblemExecutorReviewResponse>}
     * @memberof GetProblemExecutorsResponse
     */
    'items'?: Array<ProblemExecutorReviewResponse> | null;
    /**
     * Количество подходящих отзывов
     * @type {number}
     * @memberof GetProblemExecutorsResponse
     */
    'allCount'?: number;
}
/**
 * Страница тиражей
 * @export
 * @interface GetPromoCodePrintingsResponse
 */
export interface GetPromoCodePrintingsResponse {
    /**
     * Тиражи страницы
     * @type {Array<PromoCodePrintingResponse>}
     * @memberof GetPromoCodePrintingsResponse
     */
    'items'?: Array<PromoCodePrintingResponse> | null;
    /**
     * Количество подходящих тиражей
     * @type {number}
     * @memberof GetPromoCodePrintingsResponse
     */
    'allCount'?: number;
}
/**
 * Страница шаблонов
 * @export
 * @interface GetPromoCodeTemplatesResponse
 */
export interface GetPromoCodeTemplatesResponse {
    /**
     * Шаблоны страницы
     * @type {Array<PromoCodeTemplateResponse>}
     * @memberof GetPromoCodeTemplatesResponse
     */
    'items'?: Array<PromoCodeTemplateResponse> | null;
    /**
     * Количество подходящих шаблонов
     * @type {number}
     * @memberof GetPromoCodeTemplatesResponse
     */
    'allCount'?: number;
}
/**
 * 
 * @export
 * @interface GetPromoCodesResponse
 */
export interface GetPromoCodesResponse {
    /**
     * Общее количество промокодов
     * @type {number}
     * @memberof GetPromoCodesResponse
     */
    'allCount'?: number;
    /**
     * Промокоды
     * @type {Array<PromoCodeResponse>}
     * @memberof GetPromoCodesResponse
     */
    'promoCodes'?: Array<PromoCodeResponse> | null;
}
/**
 * Список шаблонов промобаннеров с общим количеством
 * @export
 * @interface GetPromotionBannerTemplatesResponse
 */
export interface GetPromotionBannerTemplatesResponse {
    /**
     * Общее количество подходящих шаблонов
     * @type {number}
     * @memberof GetPromotionBannerTemplatesResponse
     */
    'allCount'?: number;
    /**
     * Сохранённые шаблоны
     * @type {Array<PromotionBannerTemplateResponse>}
     * @memberof GetPromotionBannerTemplatesResponse
     */
    'templates'?: Array<PromotionBannerTemplateResponse> | null;
}
/**
 * 
 * @export
 * @interface GetQuestionModel
 */
export interface GetQuestionModel {
    /**
     * 
     * @type {number}
     * @memberof GetQuestionModel
     */
    'id'?: number;
    /**
     * ID теста
     * @type {number}
     * @memberof GetQuestionModel
     */
    'testId'?: number;
    /**
     * Текст вопроса
     * @type {string}
     * @memberof GetQuestionModel
     */
    'title'?: string | null;
    /**
     * Активен ли
     * @type {number}
     * @memberof GetQuestionModel
     */
    'index'?: number;
    /**
     * Ответы
     * @type {Array<GetAnswerModel>}
     * @memberof GetQuestionModel
     */
    'answers'?: Array<GetAnswerModel> | null;
}
/**
 * 
 * @export
 * @interface GetQuestionResponse
 */
export interface GetQuestionResponse {
    /**
     * 
     * @type {number}
     * @memberof GetQuestionResponse
     */
    'id'?: number;
    /**
     * ID теста
     * @type {number}
     * @memberof GetQuestionResponse
     */
    'testId'?: number;
    /**
     * Текст вопроса
     * @type {string}
     * @memberof GetQuestionResponse
     */
    'title'?: string | null;
    /**
     * Активен ли
     * @type {number}
     * @memberof GetQuestionResponse
     */
    'index'?: number;
    /**
     * Ответы
     * @type {Array<GetAnswerResponseModel>}
     * @memberof GetQuestionResponse
     */
    'answers'?: Array<GetAnswerResponseModel> | null;
}
/**
 * 
 * @export
 * @interface GetReviewsResponse
 */
export interface GetReviewsResponse {
    /**
     * Общее количество отзывов
     * @type {number}
     * @memberof GetReviewsResponse
     */
    'allCount'?: number;
    /**
     * Отзывы
     * @type {Array<ReviewResponse>}
     * @memberof GetReviewsResponse
     */
    'reviews'?: Array<ReviewResponse> | null;
}
/**
 * 
 * @export
 * @interface GetSubscriptionsResponse
 */
export interface GetSubscriptionsResponse {
    /**
     * Общее количество исполнителей
     * @type {number}
     * @memberof GetSubscriptionsResponse
     */
    'allCount'?: number;
    /**
     * Абонементы
     * @type {Array<SubscriptionShortResponse>}
     * @memberof GetSubscriptionsResponse
     */
    'subscriptions'?: Array<SubscriptionShortResponse> | null;
}
/**
 * 
 * @export
 * @interface GetTestByIdResponse
 */
export interface GetTestByIdResponse {
    /**
     * 
     * @type {number}
     * @memberof GetTestByIdResponse
     */
    'id'?: number;
    /**
     * Идентификатор урока
     * @type {number}
     * @memberof GetTestByIdResponse
     */
    'lessonId'?: number;
    /**
     * Индекс теста
     * @type {number}
     * @memberof GetTestByIdResponse
     */
    'index'?: number;
    /**
     * Вопросы теста
     * @type {Array<GetQuestionResponse>}
     * @memberof GetTestByIdResponse
     */
    'questions'?: Array<GetQuestionResponse> | null;
}
/**
 * 
 * @export
 * @interface GetTestResponse
 */
export interface GetTestResponse {
    /**
     * 
     * @type {number}
     * @memberof GetTestResponse
     */
    'id'?: number;
    /**
     * Идентификатор урока
     * @type {number}
     * @memberof GetTestResponse
     */
    'lessonId'?: number;
    /**
     * Индекс теста
     * @type {number}
     * @memberof GetTestResponse
     */
    'index'?: number;
    /**
     * Вопросы теста
     * @type {Array<GetQuestionResponse>}
     * @memberof GetTestResponse
     */
    'questions'?: Array<GetQuestionResponse> | null;
}
/**
 * 
 * @export
 * @interface GetTotalResultModel
 */
export interface GetTotalResultModel {
    /**
     * 
     * @type {number}
     * @memberof GetTotalResultModel
     */
    'id'?: number;
    /**
     * ID выгульщика
     * @type {string}
     * @memberof GetTotalResultModel
     */
    'executorId'?: string;
    /**
     * ID теста
     * @type {number}
     * @memberof GetTotalResultModel
     */
    'testId'?: number;
    /**
     * Пройден ли
     * @type {boolean}
     * @memberof GetTotalResultModel
     */
    'isCompleted'?: boolean;
    /**
     * Кол-во баллов
     * @type {number}
     * @memberof GetTotalResultModel
     */
    'score'?: number;
}
/**
 * Данные пользователя чата
 * @export
 * @interface GetUserInfoResponse
 */
export interface GetUserInfoResponse {
    /**
     * Идентификатор клиента
     * @type {string}
     * @memberof GetUserInfoResponse
     */
    'clientId'?: string | null;
    /**
     * Идентификатор исполнителя
     * @type {string}
     * @memberof GetUserInfoResponse
     */
    'executorId'?: string | null;
    /**
     * Имя пользователя
     * @type {string}
     * @memberof GetUserInfoResponse
     */
    'name': string | null;
    /**
     * Ссылка на фотографию пользователя
     * @type {string}
     * @memberof GetUserInfoResponse
     */
    'photoUrl'?: string | null;
    /**
     * Номер телефона пользователя
     * @type {string}
     * @memberof GetUserInfoResponse
     */
    'phone'?: string | null;
    /**
     * Дата регистрации пользователя
     * @type {string}
     * @memberof GetUserInfoResponse
     */
    'registrationDate'?: string | null;
    /**
     * 
     * @type {CityResponse}
     * @memberof GetUserInfoResponse
     */
    'city'?: CityResponse;
    /**
     * Активные заказы пользователя
     * @type {Array<ActiveOrderResponse>}
     * @memberof GetUserInfoResponse
     */
    'activeOrders'?: Array<ActiveOrderResponse> | null;
    /**
     * 
     * @type {LastOrderResponse}
     * @memberof GetUserInfoResponse
     */
    'lastOrder'?: LastOrderResponse;
    /**
     * Питомцы пользователя
     * @type {Array<UserPetResponse>}
     * @memberof GetUserInfoResponse
     */
    'pets'?: Array<UserPetResponse> | null;
}
/**
 * 
 * @export
 * @interface GetVoxServicesByPetTypeRequest
 */
export interface GetVoxServicesByPetTypeRequest {
    /**
     * 
     * @type {ApiPetType}
     * @memberof GetVoxServicesByPetTypeRequest
     */
    'petType'?: ApiPetType;
}


/**
 * Простейшая модель
 * @export
 * @interface GuidSimpleModel
 */
export interface GuidSimpleModel {
    /**
     * Идентификатор
     * @type {string}
     * @memberof GuidSimpleModel
     */
    'id'?: string;
    /**
     * Наименование
     * @type {string}
     * @memberof GuidSimpleModel
     */
    'name'?: string | null;
}
/**
 * 
 * @export
 * @interface HabitRequest
 */
export interface HabitRequest {
    /**
     * Наименование
     * @type {string}
     * @memberof HabitRequest
     */
    'name'?: string | null;
    /**
     * 
     * @type {ApiHabitType}
     * @memberof HabitRequest
     */
    'type'?: ApiHabitType;
    /**
     * 
     * @type {ApiHabitPlaceType}
     * @memberof HabitRequest
     */
    'placeType'?: ApiHabitPlaceType;
    /**
     * 
     * @type {ApiPetType}
     * @memberof HabitRequest
     */
    'pet'?: ApiPetType;
}


/**
 * 
 * @export
 * @interface HabitResponse
 */
export interface HabitResponse {
    /**
     * 
     * @type {string}
     * @memberof HabitResponse
     */
    'id'?: string;
    /**
     * Наименование
     * @type {string}
     * @memberof HabitResponse
     */
    'name'?: string | null;
    /**
     * 
     * @type {ApiHabitTypeSimpleModel}
     * @memberof HabitResponse
     */
    'type'?: ApiHabitTypeSimpleModel;
    /**
     * 
     * @type {ApiPetTypeSimpleModel}
     * @memberof HabitResponse
     */
    'petType'?: ApiPetTypeSimpleModel;
    /**
     * 
     * @type {ApiHabitPlaceTypeSimpleModel}
     * @memberof HabitResponse
     */
    'placeType'?: ApiHabitPlaceTypeSimpleModel;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const HashSaltType = {
    Phone: 'phone',
    Email: 'email'
} as const;

export type HashSaltType = typeof HashSaltType[keyof typeof HashSaltType];


/**
 * Состояние сбора графа управляемой памяти экземпляра
 * @export
 * @interface HeapDumpJobResponse
 */
export interface HeapDumpJobResponse {
    /**
     * Идентификатор сбора на выбранном экземпляре
     * @type {string}
     * @memberof HeapDumpJobResponse
     */
    'jobId'?: string;
    /**
     * Идентификатор экземпляра приложения
     * @type {string}
     * @memberof HeapDumpJobResponse
     */
    'instanceId'?: string | null;
    /**
     * Состояние сбора
     * @type {string}
     * @memberof HeapDumpJobResponse
     */
    'status'?: string | null;
    /**
     * Причина запуска сбора
     * @type {string}
     * @memberof HeapDumpJobResponse
     */
    'trigger'?: string | null;
    /**
     * Время принятия запроса в UTC
     * @type {string}
     * @memberof HeapDumpJobResponse
     */
    'requestedAtUtc'?: string;
    /**
     * Время завершения обработки в UTC
     * @type {string}
     * @memberof HeapDumpJobResponse
     */
    'completedAtUtc'?: string | null;
    /**
     * Код причины отказа или пропуска
     * @type {string}
     * @memberof HeapDumpJobResponse
     */
    'reason'?: string | null;
    /**
     * Размер собранного файла в байтах
     * @type {number}
     * @memberof HeapDumpJobResponse
     */
    'sizeBytes'?: number | null;
    /**
     * Идентификатор события SDK без подтверждения доставки сервером
     * @type {string}
     * @memberof HeapDumpJobResponse
     */
    'eventId'?: string | null;
}
/**
 * Действующая промоакция для главного экрана
 * @export
 * @interface HomePromotionResponse
 */
export interface HomePromotionResponse {
    /**
     * Идентификатор периода
     * @type {string}
     * @memberof HomePromotionResponse
     */
    'id'?: string;
    /**
     * Идентификатор услуги
     * @type {string}
     * @memberof HomePromotionResponse
     */
    'productId'?: string;
    /**
     * Название услуги
     * @type {string}
     * @memberof HomePromotionResponse
     */
    'serviceName'?: string | null;
    /**
     * 
     * @type {ApiProductTypeSimpleModel}
     * @memberof HomePromotionResponse
     */
    'productType'?: ApiProductTypeSimpleModel;
    /**
     * 
     * @type {ApiPetTypeSimpleModel}
     * @memberof HomePromotionResponse
     */
    'petType'?: ApiPetTypeSimpleModel;
    /**
     * Цена услуги в периоде
     * @type {number}
     * @memberof HomePromotionResponse
     */
    'price'?: number;
    /**
     * Первый день периода в тексте баннера включительно
     * @type {string}
     * @memberof HomePromotionResponse
     */
    'startDate'?: string;
    /**
     * Последний день периода в тексте баннера включительно
     * @type {string}
     * @memberof HomePromotionResponse
     */
    'endDate'?: string;
    /**
     * Момент окончания показа баннера в UTC
     * @type {string}
     * @memberof HomePromotionResponse
     */
    'endsAtUtc'?: string;
    /**
     * Идентификатор сохранённого баннера
     * @type {string}
     * @memberof HomePromotionResponse
     */
    'bannerTemplateId'?: string;
    /**
     * Идентификатор формата баннера
     * @type {string}
     * @memberof HomePromotionResponse
     */
    'templateId'?: string | null;
    /**
     * Шаблон заголовка
     * @type {string}
     * @memberof HomePromotionResponse
     */
    'titleTemplate'?: string | null;
    /**
     * Метка акции
     * @type {string}
     * @memberof HomePromotionResponse
     */
    'badgeText'?: string | null;
    /**
     * Изображение баннера
     * @type {string}
     * @memberof HomePromotionResponse
     */
    'imageUrl'?: string | null;
    /**
     * Показывать таймер
     * @type {boolean}
     * @memberof HomePromotionResponse
     */
    'showCountdown'?: boolean;
    /**
     * Порядок показа
     * @type {number}
     * @memberof HomePromotionResponse
     */
    'sortOrder'?: number;
}
/**
 * Доступные промоакции главного экрана
 * @export
 * @interface HomePromotionsResponse
 */
export interface HomePromotionsResponse {
    /**
     * Город профиля клиента
     * @type {number}
     * @memberof HomePromotionsResponse
     */
    'cityId'?: number | null;
    /**
     * Текущее серверное время в UTC
     * @type {string}
     * @memberof HomePromotionsResponse
     */
    'serverTimeUtc'?: string;
    /**
     * Действующие акции всех типов услуг
     * @type {Array<HomePromotionResponse>}
     * @memberof HomePromotionsResponse
     */
    'promotions'?: Array<HomePromotionResponse> | null;
}
/**
 * Импорт объектов хранилища
 * @export
 * @interface ImportMediaRequest
 */
export interface ImportMediaRequest {
    /**
     * Ключи объектов
     * @type {Array<string>}
     * @memberof ImportMediaRequest
     */
    'keys'?: Array<string> | null;
    /**
     * Папка каталога
     * @type {string}
     * @memberof ImportMediaRequest
     */
    'folderId'?: string | null;
}
/**
 * Простейшая модель
 * @export
 * @interface Int64SimpleModel
 */
export interface Int64SimpleModel {
    /**
     * Идентификатор
     * @type {number}
     * @memberof Int64SimpleModel
     */
    'id'?: number;
    /**
     * Наименование
     * @type {string}
     * @memberof Int64SimpleModel
     */
    'name'?: string | null;
}
/**
 * Последний заказ пользователя
 * @export
 * @interface LastOrderResponse
 */
export interface LastOrderResponse {
    /**
     * Дата заказа
     * @type {string}
     * @memberof LastOrderResponse
     */
    'orderDate'?: string | null;
    /**
     * Номер заказа
     * @type {string}
     * @memberof LastOrderResponse
     */
    'orderNumber': string | null;
    /**
     * Идентификатор заказа
     * @type {string}
     * @memberof LastOrderResponse
     */
    'orderId'?: string;
}
/**
 * 
 * @export
 * @interface LogErrorRequest
 */
export interface LogErrorRequest {
    /**
     * Сообщение приложения
     * @type {string}
     * @memberof LogErrorRequest
     */
    'message'?: string | null;
    /**
     * Идентификатор исходной трассы приложения
     * @type {string}
     * @memberof LogErrorRequest
     */
    'traceId'?: string | null;
    /**
     * Идентификатор исходного участка трассы приложения
     * @type {string}
     * @memberof LogErrorRequest
     */
    'spanId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LogErrorRequest
     */
    'error'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LogErrorRequest
     */
    'stackTrace'?: string | null;
}
/**
 * Прикладной лог мобильного приложения
 * @export
 * @interface LogRequest
 */
export interface LogRequest {
    /**
     * Сообщение приложения
     * @type {string}
     * @memberof LogRequest
     */
    'message'?: string | null;
    /**
     * Идентификатор исходной трассы приложения
     * @type {string}
     * @memberof LogRequest
     */
    'traceId'?: string | null;
    /**
     * Идентификатор исходного участка трассы приложения
     * @type {string}
     * @memberof LogRequest
     */
    'spanId'?: string | null;
}
/**
 * 
 * @export
 * @interface LoginRequest
 */
export interface LoginRequest {
    /**
     * 
     * @type {string}
     * @memberof LoginRequest
     */
    'phone': string | null;
    /**
     * 
     * @type {string}
     * @memberof LoginRequest
     */
    'password': string | null;
    /**
     * 
     * @type {UserRole}
     * @memberof LoginRequest
     */
    'role': UserRole;
}


/**
 * Данные ручного формирования чека ФНС
 * @export
 * @interface ManualFnsReceipt
 */
export interface ManualFnsReceipt {
    /**
     * Статус обработки чека
     * @type {string}
     * @memberof ManualFnsReceipt
     */
    'status'?: string | null;
    /**
     * Ссылка на форму формирования чека
     * @type {string}
     * @memberof ManualFnsReceipt
     */
    'formUrl'?: string | null;
    /**
     * Необходимость ручного формирования чека
     * @type {boolean}
     * @memberof ManualFnsReceipt
     */
    'required'?: boolean | null;
}
/**
 * 
 * @export
 * @interface ManualPaymentConfirmRequest
 */
export interface ManualPaymentConfirmRequest {
    /**
     * Внешний идентификатор платежа в Robokassa
     * @type {string}
     * @memberof ManualPaymentConfirmRequest
     */
    'externalId'?: string | null;
    /**
     * Внешняя ссылка на оплату в Робокассе
     * @type {string}
     * @memberof ManualPaymentConfirmRequest
     */
    'robokassaPaymentUrl'?: string | null;
    /**
     * Комментарий от администратора
     * @type {string}
     * @memberof ManualPaymentConfirmRequest
     */
    'comment'?: string | null;
}
/**
 * Подтверждение прочтения диалога
 * @export
 * @interface MarkChatDialogReadRequest
 */
export interface MarkChatDialogReadRequest {
    /**
     * Последнее показанное сообщение
     * @type {string}
     * @memberof MarkChatDialogReadRequest
     */
    'throughMessageId': string;
}
/**
 * Сведения о файле
 * @export
 * @interface MediaAssetDetailsResponse
 */
export interface MediaAssetDetailsResponse {
    /**
     * 
     * @type {MediaAssetResponse}
     * @memberof MediaAssetDetailsResponse
     */
    'asset'?: MediaAssetResponse;
    /**
     * Места использования
     * @type {Array<MediaUsageResponse>}
     * @memberof MediaAssetDetailsResponse
     */
    'usage'?: Array<MediaUsageResponse> | null;
    /**
     * История изменений
     * @type {Array<MediaHistoryResponse>}
     * @memberof MediaAssetDetailsResponse
     */
    'history'?: Array<MediaHistoryResponse> | null;
}
/**
 * Страница медиатеки
 * @export
 * @interface MediaAssetPageResponse
 */
export interface MediaAssetPageResponse {
    /**
     * Всего найденных файлов
     * @type {number}
     * @memberof MediaAssetPageResponse
     */
    'allCount'?: number;
    /**
     * Файлы страницы
     * @type {Array<MediaAssetResponse>}
     * @memberof MediaAssetPageResponse
     */
    'items'?: Array<MediaAssetResponse> | null;
}
/**
 * Файл медиатеки
 * @export
 * @interface MediaAssetResponse
 */
export interface MediaAssetResponse {
    /**
     * Идентификатор файла
     * @type {string}
     * @memberof MediaAssetResponse
     */
    'id'?: string;
    /**
     * Версия записи
     * @type {string}
     * @memberof MediaAssetResponse
     */
    'version'?: string;
    /**
     * Название файла
     * @type {string}
     * @memberof MediaAssetResponse
     */
    'name'?: string | null;
    /**
     * Исходное имя
     * @type {string}
     * @memberof MediaAssetResponse
     */
    'originalName'?: string | null;
    /**
     * Постоянная ссылка
     * @type {string}
     * @memberof MediaAssetResponse
     */
    'url'?: string | null;
    /**
     * Ключ объекта
     * @type {string}
     * @memberof MediaAssetResponse
     */
    'objectKey'?: string | null;
    /**
     * Тип содержимого
     * @type {string}
     * @memberof MediaAssetResponse
     */
    'contentType'?: string | null;
    /**
     * Размер в байтах
     * @type {number}
     * @memberof MediaAssetResponse
     */
    'size'?: number | null;
    /**
     * Ширина изображения
     * @type {number}
     * @memberof MediaAssetResponse
     */
    'width'?: number | null;
    /**
     * Высота изображения
     * @type {number}
     * @memberof MediaAssetResponse
     */
    'height'?: number | null;
    /**
     * Папка каталога
     * @type {string}
     * @memberof MediaAssetResponse
     */
    'folderId'?: string | null;
    /**
     * Теги файла
     * @type {Array<string>}
     * @memberof MediaAssetResponse
     */
    'tags'?: Array<string> | null;
    /**
     * Дата добавления в каталог
     * @type {string}
     * @memberof MediaAssetResponse
     */
    'created'?: string;
    /**
     * Дата изменения объекта в хранилище
     * @type {string}
     * @memberof MediaAssetResponse
     */
    'sourceModified'?: string | null;
    /**
     * Сотрудник, добавивший файл
     * @type {string}
     * @memberof MediaAssetResponse
     */
    'uploadedBy'?: string | null;
    /**
     * Используется в контенте
     * @type {boolean}
     * @memberof MediaAssetResponse
     */
    'isUsed'?: boolean;
    /**
     * Сведения об использовании проверены
     * @type {boolean}
     * @memberof MediaAssetResponse
     */
    'usageChecked'?: boolean;
}
/**
 * Изменение выбранных файлов
 * @export
 * @interface MediaBulkUpdateRequest
 */
export interface MediaBulkUpdateRequest {
    /**
     * Файлы и версии
     * @type {Array<MediaVersionRequest>}
     * @memberof MediaBulkUpdateRequest
     */
    'items'?: Array<MediaVersionRequest> | null;
    /**
     * Папка назначения
     * @type {string}
     * @memberof MediaBulkUpdateRequest
     */
    'folderId'?: string | null;
    /**
     * Перенести файлы
     * @type {boolean}
     * @memberof MediaBulkUpdateRequest
     */
    'move'?: boolean;
    /**
     * Добавляемые теги
     * @type {Array<string>}
     * @memberof MediaBulkUpdateRequest
     */
    'addTags'?: Array<string> | null;
}
/**
 * Папка медиатеки
 * @export
 * @interface MediaFolderResponse
 */
export interface MediaFolderResponse {
    /**
     * Идентификатор папки
     * @type {string}
     * @memberof MediaFolderResponse
     */
    'id'?: string;
    /**
     * Версия записи
     * @type {string}
     * @memberof MediaFolderResponse
     */
    'version'?: string;
    /**
     * Название папки
     * @type {string}
     * @memberof MediaFolderResponse
     */
    'name'?: string | null;
    /**
     * Родительская папка
     * @type {string}
     * @memberof MediaFolderResponse
     */
    'parentId'?: string | null;
}
/**
 * Действие с файлом
 * @export
 * @interface MediaHistoryResponse
 */
export interface MediaHistoryResponse {
    /**
     * Время действия
     * @type {string}
     * @memberof MediaHistoryResponse
     */
    'created'?: string;
    /**
     * Сотрудник
     * @type {string}
     * @memberof MediaHistoryResponse
     */
    'actorId'?: string | null;
    /**
     * Описание действия
     * @type {string}
     * @memberof MediaHistoryResponse
     */
    'description'?: string | null;
}
/**
 * Выбор файлов
 * @export
 * @interface MediaSelectionRequest
 */
export interface MediaSelectionRequest {
    /**
     * Файлы медиатеки
     * @type {Array<string>}
     * @memberof MediaSelectionRequest
     */
    'ids'?: Array<string> | null;
}
/**
 * Объект хранилища
 * @export
 * @interface MediaStorageItemResponse
 */
export interface MediaStorageItemResponse {
    /**
     * Ключ объекта
     * @type {string}
     * @memberof MediaStorageItemResponse
     */
    'key'?: string | null;
    /**
     * Размер в байтах
     * @type {number}
     * @memberof MediaStorageItemResponse
     */
    'size'?: number;
    /**
     * Изменение объекта
     * @type {string}
     * @memberof MediaStorageItemResponse
     */
    'lastModified'?: string | null;
    /**
     * Содержимое файла уже проверено для каталога
     * @type {boolean}
     * @memberof MediaStorageItemResponse
     */
    'isImported'?: boolean;
}
/**
 * Страница объектов хранилища
 * @export
 * @interface MediaStoragePageResponse
 */
export interface MediaStoragePageResponse {
    /**
     * Бакет окружения
     * @type {string}
     * @memberof MediaStoragePageResponse
     */
    'bucket'?: string | null;
    /**
     * Продолжение списка
     * @type {string}
     * @memberof MediaStoragePageResponse
     */
    'continuationToken'?: string | null;
    /**
     * Объекты хранилища
     * @type {Array<MediaStorageItemResponse>}
     * @memberof MediaStoragePageResponse
     */
    'items'?: Array<MediaStorageItemResponse> | null;
}
/**
 * Использование файла
 * @export
 * @interface MediaUsageResponse
 */
export interface MediaUsageResponse {
    /**
     * Идентификатор связанного объекта
     * @type {string}
     * @memberof MediaUsageResponse
     */
    'id'?: string;
    /**
     * Название связанного объекта
     * @type {string}
     * @memberof MediaUsageResponse
     */
    'name'?: string | null;
    /**
     * Вид связанного объекта
     * @type {string}
     * @memberof MediaUsageResponse
     */
    'kind'?: string | null;
    /**
     * Маршрут карточки
     * @type {string}
     * @memberof MediaUsageResponse
     */
    'route'?: string | null;
}
/**
 * Версия выбранного файла
 * @export
 * @interface MediaVersionRequest
 */
export interface MediaVersionRequest {
    /**
     * Файл медиатеки
     * @type {string}
     * @memberof MediaVersionRequest
     */
    'id'?: string;
    /**
     * Версия записи
     * @type {string}
     * @memberof MediaVersionRequest
     */
    'version'?: string;
}
/**
 * Часовая история памяти экземпляра
 * @export
 * @interface MemoryDiagnosticsHistoryResponse
 */
export interface MemoryDiagnosticsHistoryResponse {
    /**
     * Идентификатор экземпляра приложения
     * @type {string}
     * @memberof MemoryDiagnosticsHistoryResponse
     */
    'instanceId'?: string | null;
    /**
     * Начало выбранного периода в UTC
     * @type {string}
     * @memberof MemoryDiagnosticsHistoryResponse
     */
    'fromUtc'?: string;
    /**
     * Конец выбранного периода в UTC
     * @type {string}
     * @memberof MemoryDiagnosticsHistoryResponse
     */
    'toUtc'?: string;
    /**
     * Почасовые показатели памяти
     * @type {Array<MemoryMetricResponse>}
     * @memberof MemoryDiagnosticsHistoryResponse
     */
    'points'?: Array<MemoryMetricResponse> | null;
}
/**
 * Доступные экземпляры приложения
 * @export
 * @interface MemoryDiagnosticsInstancesResponse
 */
export interface MemoryDiagnosticsInstancesResponse {
    /**
     * Экземпляры с сохранённой историей памяти
     * @type {Array<MemoryMetricInstanceResponse>}
     * @memberof MemoryDiagnosticsInstancesResponse
     */
    'instances'?: Array<MemoryMetricInstanceResponse> | null;
}
/**
 * Скользящие сводки памяти экземпляра
 * @export
 * @interface MemoryDiagnosticsWindowsResponse
 */
export interface MemoryDiagnosticsWindowsResponse {
    /**
     * Идентификатор экземпляра приложения
     * @type {string}
     * @memberof MemoryDiagnosticsWindowsResponse
     */
    'instanceId'?: string | null;
    /**
     * Сохранённые скользящие сводки
     * @type {Array<MemoryMetricResponse>}
     * @memberof MemoryDiagnosticsWindowsResponse
     */
    'windows'?: Array<MemoryMetricResponse> | null;
}
/**
 * Экземпляр приложения с историей памяти
 * @export
 * @interface MemoryMetricInstanceResponse
 */
export interface MemoryMetricInstanceResponse {
    /**
     * Идентификатор экземпляра приложения
     * @type {string}
     * @memberof MemoryMetricInstanceResponse
     */
    'instanceId'?: string | null;
    /**
     * Конец последнего сохранённого часа в UTC
     * @type {string}
     * @memberof MemoryMetricInstanceResponse
     */
    'lastPeriodEndUtc'?: string;
}
/**
 * Показатели памяти за один период
 * @export
 * @interface MemoryMetricResponse
 */
export interface MemoryMetricResponse {
    /**
     * Продолжительность периода в часах
     * @type {number}
     * @memberof MemoryMetricResponse
     */
    'windowHours'?: number;
    /**
     * Начало периода в UTC
     * @type {string}
     * @memberof MemoryMetricResponse
     */
    'periodStartUtc'?: string;
    /**
     * Конец периода в UTC
     * @type {string}
     * @memberof MemoryMetricResponse
     */
    'periodEndUtc'?: string;
    /**
     * Время запуска процесса в UTC
     * @type {string}
     * @memberof MemoryMetricResponse
     */
    'processStartedAtUtc'?: string | null;
    /**
     * Число измерений в периоде
     * @type {number}
     * @memberof MemoryMetricResponse
     */
    'sampleCount'?: number;
    /**
     * Средний рабочий набор процесса в байтах
     * @type {number}
     * @memberof MemoryMetricResponse
     */
    'averageWorkingSetBytes'?: number;
    /**
     * Пиковый рабочий набор процесса в байтах
     * @type {number}
     * @memberof MemoryMetricResponse
     */
    'peakWorkingSetBytes'?: number;
    /**
     * Средний объём частной памяти в байтах
     * @type {number}
     * @memberof MemoryMetricResponse
     */
    'averagePrivateBytes'?: number;
    /**
     * Пиковый объём частной памяти в байтах
     * @type {number}
     * @memberof MemoryMetricResponse
     */
    'peakPrivateBytes'?: number;
    /**
     * Средний размер управляемой кучи в байтах
     * @type {number}
     * @memberof MemoryMetricResponse
     */
    'averageManagedHeapBytes'?: number;
    /**
     * Пиковый размер управляемой кучи в байтах
     * @type {number}
     * @memberof MemoryMetricResponse
     */
    'peakManagedHeapBytes'?: number;
    /**
     * Средний объём памяти GC в байтах
     * @type {number}
     * @memberof MemoryMetricResponse
     */
    'averageGcCommittedBytes'?: number;
    /**
     * Пиковый объём памяти GC в байтах
     * @type {number}
     * @memberof MemoryMetricResponse
     */
    'peakGcCommittedBytes'?: number;
    /**
     * Средний объём фрагментации кучи в байтах
     * @type {number}
     * @memberof MemoryMetricResponse
     */
    'averageGcFragmentedBytes'?: number;
    /**
     * Пиковый объём фрагментации кучи в байтах
     * @type {number}
     * @memberof MemoryMetricResponse
     */
    'peakGcFragmentedBytes'?: number;
    /**
     * Рабочий набор первого измерения в байтах
     * @type {number}
     * @memberof MemoryMetricResponse
     */
    'firstWorkingSetBytes'?: number;
    /**
     * Рабочий набор последнего измерения в байтах
     * @type {number}
     * @memberof MemoryMetricResponse
     */
    'lastWorkingSetBytes'?: number;
    /**
     * Частная память первого измерения в байтах
     * @type {number}
     * @memberof MemoryMetricResponse
     */
    'firstPrivateBytes'?: number;
    /**
     * Частная память последнего измерения в байтах
     * @type {number}
     * @memberof MemoryMetricResponse
     */
    'lastPrivateBytes'?: number;
    /**
     * Управляемая куча первого измерения в байтах
     * @type {number}
     * @memberof MemoryMetricResponse
     */
    'firstManagedHeapBytes'?: number;
    /**
     * Управляемая куча последнего измерения в байтах
     * @type {number}
     * @memberof MemoryMetricResponse
     */
    'lastManagedHeapBytes'?: number;
    /**
     * Живые данные после первой полной сборки мусора в байтах
     * @type {number}
     * @memberof MemoryMetricResponse
     */
    'firstPostGen2LiveBytes'?: number | null;
    /**
     * Живые данные после последней полной сборки мусора в байтах
     * @type {number}
     * @memberof MemoryMetricResponse
     */
    'lastPostGen2LiveBytes'?: number | null;
    /**
     * Число измерений после полной сборки мусора
     * @type {number}
     * @memberof MemoryMetricResponse
     */
    'postGen2CollectionCount'?: number;
    /**
     * Число полных сборок мусора за период
     * @type {number}
     * @memberof MemoryMetricResponse
     */
    'gen2Collections'?: number;
    /**
     * Объём выделенной управляемой памяти за период в байтах
     * @type {number}
     * @memberof MemoryMetricResponse
     */
    'allocatedBytes'?: number;
    /**
     * Суммарное время пауз GC за период в миллисекундах
     * @type {number}
     * @memberof MemoryMetricResponse
     */
    'gcPauseMilliseconds'?: number;
}
/**
 * Статистика отправок по скользящим периодам
 * @export
 * @interface MessageSendStatisticsResponse
 */
export interface MessageSendStatisticsResponse {
    /**
     * Конец последнего завершённого часа UTC
     * @type {string}
     * @memberof MessageSendStatisticsResponse
     */
    'toUtc'?: string;
    /**
     * Время расчёта показателей либо отсутствие сохранённых данных
     * @type {string}
     * @memberof MessageSendStatisticsResponse
     */
    'calculatedAtUtc'?: string | null;
    /**
     * Показатели за поддерживаемые периоды
     * @type {Array<MessageSendWindowResponse>}
     * @memberof MessageSendStatisticsResponse
     */
    'windows'?: Array<MessageSendWindowResponse> | null;
}
/**
 * Число отправок за скользящий период
 * @export
 * @interface MessageSendWindowResponse
 */
export interface MessageSendWindowResponse {
    /**
     * Продолжительность периода в часах
     * @type {number}
     * @memberof MessageSendWindowResponse
     */
    'windowHours'?: number;
    /**
     * Начало периода UTC
     * @type {string}
     * @memberof MessageSendWindowResponse
     */
    'fromUtc'?: string;
    /**
     * Число отправленных SMS
     * @type {number}
     * @memberof MessageSendWindowResponse
     */
    'smsCount'?: number;
    /**
     * Число инициированных звонков
     * @type {number}
     * @memberof MessageSendWindowResponse
     */
    'callCount'?: number;
    /**
     * Число отправленных Email
     * @type {number}
     * @memberof MessageSendWindowResponse
     */
    'emailCount'?: number;
}
/**
 * Текстовка приложения
 * @export
 * @interface MessageTemplateResponse
 */
export interface MessageTemplateResponse {
    /**
     * Идентификатор текстовки
     * @type {string}
     * @memberof MessageTemplateResponse
     */
    'id'?: string;
    /**
     * 
     * @type {ApiMessageCodeSimpleModel}
     * @memberof MessageTemplateResponse
     */
    'code'?: ApiMessageCodeSimpleModel;
    /**
     * 
     * @type {ApiMessageTemplateGroupSimpleModel}
     * @memberof MessageTemplateResponse
     */
    'group'?: ApiMessageTemplateGroupSimpleModel;
    /**
     * Текст сообщения
     * @type {string}
     * @memberof MessageTemplateResponse
     */
    'text'?: string | null;
    /**
     * Пояснение места использования
     * @type {string}
     * @memberof MessageTemplateResponse
     */
    'description'?: string | null;
    /**
     * Версия текстовки
     * @type {string}
     * @memberof MessageTemplateResponse
     */
    'version'?: string;
    /**
     * Имена параметров сообщения
     * @type {Array<string>}
     * @memberof MessageTemplateResponse
     */
    'parameters'?: Array<string> | null;
}
/**
 * Результат постановки проверочного уведомления в очередь
 * @export
 * @interface NavigationPushResponse
 */
export interface NavigationPushResponse {
    /**
     * Назначение перехода при нажатии
     * @type {string}
     * @memberof NavigationPushResponse
     */
    'deepLink': string | null;
    /**
     * Постановка уведомления в очередь отправки
     * @type {boolean}
     * @memberof NavigationPushResponse
     */
    'queued'?: boolean;
}
/**
 * Назначение перехода из шаблона уведомления
 * @export
 * @interface NotificationNavigationTargetResponse
 */
export interface NotificationNavigationTargetResponse {
    /**
     * Идентификатор назначения
     * @type {string}
     * @memberof NotificationNavigationTargetResponse
     */
    'id'?: string;
    /**
     * Стабильный числовой тип назначения
     * @type {number}
     * @memberof NotificationNavigationTargetResponse
     */
    'type'?: number;
    /**
     * Название экрана
     * @type {string}
     * @memberof NotificationNavigationTargetResponse
     */
    'name'?: string | null;
    /**
     * Шаблон пути
     * @type {string}
     * @memberof NotificationNavigationTargetResponse
     */
    'pathTemplate'?: string | null;
    /**
     * Признак обязательного идентификатора
     * @type {boolean}
     * @memberof NotificationNavigationTargetResponse
     */
    'requiresEntityId'?: boolean;
    /**
     * Вид связанной сущности
     * @type {number}
     * @memberof NotificationNavigationTargetResponse
     */
    'entityType'?: number | null;
    /**
     * Доступность в приложении клиента
     * @type {boolean}
     * @memberof NotificationNavigationTargetResponse
     */
    'clientSupported'?: boolean;
    /**
     * Доступность в приложении исполнителя
     * @type {boolean}
     * @memberof NotificationNavigationTargetResponse
     */
    'executorSupported'?: boolean;
}
/**
 * Подтверждение нажатия на уведомление
 * @export
 * @interface NotificationOpenedRequest
 */
export interface NotificationOpenedRequest {
    /**
     * Идентификатор уведомления
     * @type {string}
     * @memberof NotificationOpenedRequest
     */
    'notificationId'?: string;
}
/**
 * Подтверждение получения уведомления устройством
 * @export
 * @interface NotificationReceivedRequest
 */
export interface NotificationReceivedRequest {
    /**
     * Идентификатор уведомления
     * @type {string}
     * @memberof NotificationReceivedRequest
     */
    'notificationId'?: string;
    /**
     * Разрешение на подтверждение получения
     * @type {string}
     * @memberof NotificationReceivedRequest
     */
    'receiptToken': string;
}
/**
 * Данные шаблона пуш-уведомления
 * @export
 * @interface NotificationTemplateResponse
 */
export interface NotificationTemplateResponse {
    /**
     * Идентификатор шаблона пуш-уведомления
     * @type {string}
     * @memberof NotificationTemplateResponse
     */
    'id'?: string;
    /**
     * 
     * @type {ApiNotificationTemplateAudienceSimpleModel}
     * @memberof NotificationTemplateResponse
     */
    'audience'?: ApiNotificationTemplateAudienceSimpleModel;
    /**
     * Идентификатор назначения перехода
     * @type {string}
     * @memberof NotificationTemplateResponse
     */
    'navigationTargetId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof NotificationTemplateResponse
     */
    'navigationPathTemplate'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof NotificationTemplateResponse
     */
    'navigationRequiresEntityId'?: boolean | null;
    /**
     * 
     * @type {number}
     * @memberof NotificationTemplateResponse
     */
    'navigationEntityType'?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof NotificationTemplateResponse
     */
    'navigationClientSupported'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof NotificationTemplateResponse
     */
    'navigationExecutorSupported'?: boolean | null;
    /**
     * 
     * @type {ApiNotificationCodeSimpleModel}
     * @memberof NotificationTemplateResponse
     */
    'code'?: ApiNotificationCodeSimpleModel;
    /**
     * Краткое наименование шаблона
     * @type {string}
     * @memberof NotificationTemplateResponse
     */
    'name'?: string | null;
    /**
     * Описание условий отправки шаблона
     * @type {string}
     * @memberof NotificationTemplateResponse
     */
    'description'?: string | null;
    /**
     * Заголовок пуш-уведомления
     * @type {string}
     * @memberof NotificationTemplateResponse
     */
    'title'?: string | null;
    /**
     * Текст пуш-уведомления
     * @type {string}
     * @memberof NotificationTemplateResponse
     */
    'body'?: string | null;
}
/**
 * Получатели уведомления о выходе версии приложения
 * @export
 * @interface NotifyAppVersionRequest
 */
export interface NotifyAppVersionRequest {
    /**
     * Оповестить всех клиентов
     * @type {boolean}
     * @memberof NotifyAppVersionRequest
     */
    'notifyClients'?: boolean;
    /**
     * Оповестить всех исполнителей
     * @type {boolean}
     * @memberof NotifyAppVersionRequest
     */
    'notifyExecutors'?: boolean;
}
/**
 * Запрос отправки уведомления пользователю
 * @export
 * @interface NotifyRequest
 */
export interface NotifyRequest {
    /**
     * Идентификатор учётной записи получателя
     * @type {string}
     * @memberof NotifyRequest
     */
    'userId': string;
    /**
     * Заголовок уведомления
     * @type {string}
     * @memberof NotifyRequest
     */
    'title': string | null;
    /**
     * Текст уведомления
     * @type {string}
     * @memberof NotifyRequest
     */
    'message': string | null;
    /**
     * Адрес изображения уведомления
     * @type {string}
     * @memberof NotifyRequest
     */
    'imageUrl'?: string | null;
    /**
     * Название связанной сущности для сохранения в уведомлении
     * @type {string}
     * @memberof NotifyRequest
     */
    'relatedEntityName'?: string | null;
    /**
     * Идентификатор связанной сущности
     * @type {string}
     * @memberof NotifyRequest
     */
    'relatedEntityId'?: string | null;
    /**
     * 
     * @type {PushNavigationTargetType}
     * @memberof NotifyRequest
     */
    'navigationTargetType'?: PushNavigationTargetType;
}


/**
 * Сотрудник, участвующий в работе с задачей
 * @export
 * @interface OperatorTaskActorResponse
 */
export interface OperatorTaskActorResponse {
    /**
     * Идентификатор сотрудника
     * @type {string}
     * @memberof OperatorTaskActorResponse
     */
    'id'?: string;
    /**
     * Имя сотрудника
     * @type {string}
     * @memberof OperatorTaskActorResponse
     */
    'name'?: string | null;
}
/**
 * Назначение ответственного сотрудника
 * @export
 * @interface OperatorTaskAssigneeRequest
 */
export interface OperatorTaskAssigneeRequest {
    /**
     * Идентификатор сотрудника
     * @type {string}
     * @memberof OperatorTaskAssigneeRequest
     */
    'appUserId'?: string | null;
}
/**
 * Ответственный сотрудник задачи
 * @export
 * @interface OperatorTaskAssigneeResponse
 */
export interface OperatorTaskAssigneeResponse {
    /**
     * Идентификатор сотрудника
     * @type {string}
     * @memberof OperatorTaskAssigneeResponse
     */
    'id'?: string;
    /**
     * Логин сотрудника
     * @type {string}
     * @memberof OperatorTaskAssigneeResponse
     */
    'login'?: string | null;
    /**
     * 
     * @type {ApiUserRoleSimpleModel}
     * @memberof OperatorTaskAssigneeResponse
     */
    'role'?: ApiUserRoleSimpleModel;
    /**
     * Доступность для назначения
     * @type {boolean}
     * @memberof OperatorTaskAssigneeResponse
     */
    'isAvailable'?: boolean;
}
/**
 * Задача, требующая внимания оператора
 * @export
 * @interface OperatorTaskAttentionItemResponse
 */
export interface OperatorTaskAttentionItemResponse {
    /**
     * 
     * @type {OperatorTaskListItemResponse}
     * @memberof OperatorTaskAttentionItemResponse
     */
    'task'?: OperatorTaskListItemResponse;
    /**
     * 
     * @type {ApiOperatorTaskAttentionReasonSimpleModel}
     * @memberof OperatorTaskAttentionItemResponse
     */
    'reason'?: ApiOperatorTaskAttentionReasonSimpleModel;
    /**
     * 
     * @type {OperatorTaskReminderResponse}
     * @memberof OperatorTaskAttentionItemResponse
     */
    'latestReminder'?: OperatorTaskReminderResponse;
}
/**
 * Настройки напоминания перед сроком задачи
 * @export
 * @interface OperatorTaskBeforeDeadlineReminderRequest
 */
export interface OperatorTaskBeforeDeadlineReminderRequest {
    /**
     * 
     * @type {ApiOperatorTaskBeforeDeadlineMode}
     * @memberof OperatorTaskBeforeDeadlineReminderRequest
     */
    'mode'?: ApiOperatorTaskBeforeDeadlineMode;
    /**
     * Московское время напоминания перед сроком
     * @type {string}
     * @memberof OperatorTaskBeforeDeadlineReminderRequest
     */
    'time'?: string | null;
    /**
     * Интервал до срока в минутах
     * @type {number}
     * @memberof OperatorTaskBeforeDeadlineReminderRequest
     */
    'offsetMinutes'?: number | null;
}


/**
 * Настройки напоминания перед сроком задачи
 * @export
 * @interface OperatorTaskBeforeDeadlineReminderResponse
 */
export interface OperatorTaskBeforeDeadlineReminderResponse {
    /**
     * 
     * @type {ApiOperatorTaskBeforeDeadlineModeSimpleModel}
     * @memberof OperatorTaskBeforeDeadlineReminderResponse
     */
    'mode'?: ApiOperatorTaskBeforeDeadlineModeSimpleModel;
    /**
     * Московское время напоминания перед сроком
     * @type {string}
     * @memberof OperatorTaskBeforeDeadlineReminderResponse
     */
    'time'?: string | null;
    /**
     * Интервал до срока в минутах
     * @type {number}
     * @memberof OperatorTaskBeforeDeadlineReminderResponse
     */
    'offsetMinutes'?: number | null;
}
/**
 * Данные чата для привязки к задаче
 * @export
 * @interface OperatorTaskChatContextRequest
 */
export interface OperatorTaskChatContextRequest {
    /**
     * Идентификатор чата поддержки
     * @type {string}
     * @memberof OperatorTaskChatContextRequest
     */
    'chatId'?: string | null;
    /**
     * Идентификатор собеседника чата
     * @type {string}
     * @memberof OperatorTaskChatContextRequest
     */
    'companionAppUserId'?: string | null;
    /**
     * 
     * @type {ApiUserRole}
     * @memberof OperatorTaskChatContextRequest
     */
    'companionRole'?: ApiUserRole;
}


/**
 * Связи задачи с заказом и чатом
 * @export
 * @interface OperatorTaskContextRequest
 */
export interface OperatorTaskContextRequest {
    /**
     * Идентификатор связанного заказа
     * @type {string}
     * @memberof OperatorTaskContextRequest
     */
    'orderId'?: string | null;
    /**
     * 
     * @type {OperatorTaskChatContextRequest}
     * @memberof OperatorTaskContextRequest
     */
    'chat'?: OperatorTaskChatContextRequest;
}
/**
 * Связи задачи с заказом и чатом
 * @export
 * @interface OperatorTaskContextResponse
 */
export interface OperatorTaskContextResponse {
    /**
     * 
     * @type {OperatorTaskRelatedResponse}
     * @memberof OperatorTaskContextResponse
     */
    'order'?: OperatorTaskRelatedResponse;
    /**
     * 
     * @type {OperatorTaskRelatedResponse}
     * @memberof OperatorTaskContextResponse
     */
    'chat'?: OperatorTaskRelatedResponse;
    /**
     * Недоступность проверки связей задачи
     * @type {boolean}
     * @memberof OperatorTaskContextResponse
     */
    'contextVerificationUnavailable'?: boolean;
}
/**
 * Настройки ежедневного напоминания задачи
 * @export
 * @interface OperatorTaskDailyReminderRequest
 */
export interface OperatorTaskDailyReminderRequest {
    /**
     * Первый день напоминаний
     * @type {string}
     * @memberof OperatorTaskDailyReminderRequest
     */
    'startDate'?: string | null;
    /**
     * Московское время ежедневного напоминания
     * @type {string}
     * @memberof OperatorTaskDailyReminderRequest
     */
    'time'?: string | null;
}
/**
 * Настройки ежедневного напоминания задачи
 * @export
 * @interface OperatorTaskDailyReminderResponse
 */
export interface OperatorTaskDailyReminderResponse {
    /**
     * Первый день напоминаний
     * @type {string}
     * @memberof OperatorTaskDailyReminderResponse
     */
    'startDate'?: string | null;
    /**
     * Московское время ежедневного напоминания
     * @type {string}
     * @memberof OperatorTaskDailyReminderResponse
     */
    'time'?: string | null;
}
/**
 * Карточка общей задачи операторов
 * @export
 * @interface OperatorTaskDetailsResponse
 */
export interface OperatorTaskDetailsResponse {
    /**
     * Идентификатор задачи
     * @type {string}
     * @memberof OperatorTaskDetailsResponse
     */
    'id'?: string;
    /**
     * Номер задачи
     * @type {number}
     * @memberof OperatorTaskDetailsResponse
     */
    'taskNumber'?: number;
    /**
     * 
     * @type {ApiOperatorTaskTypeSimpleModel}
     * @memberof OperatorTaskDetailsResponse
     */
    'type'?: ApiOperatorTaskTypeSimpleModel;
    /**
     * Срок выполнения
     * @type {string}
     * @memberof OperatorTaskDetailsResponse
     */
    'dueAtUtc'?: string;
    /**
     * 
     * @type {OperatorTaskAssigneeResponse}
     * @memberof OperatorTaskDetailsResponse
     */
    'assignee'?: OperatorTaskAssigneeResponse;
    /**
     * 
     * @type {OperatorTaskContextResponse}
     * @memberof OperatorTaskDetailsResponse
     */
    'context'?: OperatorTaskContextResponse;
    /**
     * Краткое описание задачи
     * @type {string}
     * @memberof OperatorTaskDetailsResponse
     */
    'textPreview'?: string | null;
    /**
     * 
     * @type {ApiOperatorTaskStatusSimpleModel}
     * @memberof OperatorTaskDetailsResponse
     */
    'status'?: ApiOperatorTaskStatusSimpleModel;
    /**
     * Просрочка задачи
     * @type {boolean}
     * @memberof OperatorTaskDetailsResponse
     */
    'isOverdue'?: boolean;
    /**
     * Версия задачи
     * @type {string}
     * @memberof OperatorTaskDetailsResponse
     */
    'version'?: string;
    /**
     * 
     * @type {OperatorTaskMomentResponse}
     * @memberof OperatorTaskDetailsResponse
     */
    'nextReminder'?: OperatorTaskMomentResponse;
    /**
     * Момент создания
     * @type {string}
     * @memberof OperatorTaskDetailsResponse
     */
    'created'?: string;
    /**
     * 
     * @type {OperatorTaskActorResponse}
     * @memberof OperatorTaskDetailsResponse
     */
    'createdBy'?: OperatorTaskActorResponse;
    /**
     * Момент выполнения
     * @type {string}
     * @memberof OperatorTaskDetailsResponse
     */
    'completedAtUtc'?: string | null;
    /**
     * 
     * @type {OperatorTaskActorResponse}
     * @memberof OperatorTaskDetailsResponse
     */
    'completedBy'?: OperatorTaskActorResponse;
    /**
     * Название и описание задачи
     * @type {string}
     * @memberof OperatorTaskDetailsResponse
     */
    'text'?: string | null;
    /**
     * 
     * @type {OperatorTaskReminderSettingsResponse}
     * @memberof OperatorTaskDetailsResponse
     */
    'reminders'?: OperatorTaskReminderSettingsResponse;
    /**
     * Момент изменения
     * @type {string}
     * @memberof OperatorTaskDetailsResponse
     */
    'updated'?: string;
    /**
     * 
     * @type {ApiOperatorTaskSourceSimpleModel}
     * @memberof OperatorTaskDetailsResponse
     */
    'createdFrom'?: ApiOperatorTaskSourceSimpleModel;
    /**
     * Версия расписания напоминаний
     * @type {string}
     * @memberof OperatorTaskDetailsResponse
     */
    'scheduleVersion'?: string;
    /**
     * Начало действия расписания напоминаний
     * @type {string}
     * @memberof OperatorTaskDetailsResponse
     */
    'scheduleEffectiveFromUtc'?: string;
    /**
     * Серверное время
     * @type {string}
     * @memberof OperatorTaskDetailsResponse
     */
    'serverTimeUtc'?: string;
    /**
     * Часовой пояс
     * @type {string}
     * @memberof OperatorTaskDetailsResponse
     */
    'timeZoneId'?: string | null;
}
/**
 * Количество задач по фильтрам состояния
 * @export
 * @interface OperatorTaskFilterCountsResponse
 */
export interface OperatorTaskFilterCountsResponse {
    /**
     * Количество задач в работе
     * @type {number}
     * @memberof OperatorTaskFilterCountsResponse
     */
    'inProgress'?: number;
    /**
     * Количество выполненных задач
     * @type {number}
     * @memberof OperatorTaskFilterCountsResponse
     */
    'completed'?: number;
    /**
     * Количество просроченных задач
     * @type {number}
     * @memberof OperatorTaskFilterCountsResponse
     */
    'overdue'?: number;
    /**
     * Общее количество задач
     * @type {number}
     * @memberof OperatorTaskFilterCountsResponse
     */
    'all'?: number;
}
/**
 * Запись истории действий над задачей
 * @export
 * @interface OperatorTaskHistoryEntryResponse
 */
export interface OperatorTaskHistoryEntryResponse {
    /**
     * Идентификатор события
     * @type {string}
     * @memberof OperatorTaskHistoryEntryResponse
     */
    'id'?: string;
    /**
     * 
     * @type {ApiOperatorTaskHistoryActionSimpleModel}
     * @memberof OperatorTaskHistoryEntryResponse
     */
    'action'?: ApiOperatorTaskHistoryActionSimpleModel;
    /**
     * 
     * @type {OperatorTaskActorResponse}
     * @memberof OperatorTaskHistoryEntryResponse
     */
    'actor'?: OperatorTaskActorResponse;
    /**
     * Момент действия над задачей
     * @type {string}
     * @memberof OperatorTaskHistoryEntryResponse
     */
    'occurredAtUtc'?: string;
    /**
     * Версия задачи до действия
     * @type {string}
     * @memberof OperatorTaskHistoryEntryResponse
     */
    'fromVersion'?: string | null;
    /**
     * Версия задачи после действия
     * @type {string}
     * @memberof OperatorTaskHistoryEntryResponse
     */
    'toVersion'?: string;
    /**
     * 
     * @type {OperatorTaskSnapshotResponse}
     * @memberof OperatorTaskHistoryEntryResponse
     */
    'before'?: OperatorTaskSnapshotResponse;
    /**
     * 
     * @type {OperatorTaskSnapshotResponse}
     * @memberof OperatorTaskHistoryEntryResponse
     */
    'after'?: OperatorTaskSnapshotResponse;
}
/**
 * Задача в общей очереди операторов
 * @export
 * @interface OperatorTaskListItemResponse
 */
export interface OperatorTaskListItemResponse {
    /**
     * Идентификатор задачи
     * @type {string}
     * @memberof OperatorTaskListItemResponse
     */
    'id'?: string;
    /**
     * Номер задачи
     * @type {number}
     * @memberof OperatorTaskListItemResponse
     */
    'taskNumber'?: number;
    /**
     * 
     * @type {ApiOperatorTaskTypeSimpleModel}
     * @memberof OperatorTaskListItemResponse
     */
    'type'?: ApiOperatorTaskTypeSimpleModel;
    /**
     * Срок выполнения
     * @type {string}
     * @memberof OperatorTaskListItemResponse
     */
    'dueAtUtc'?: string;
    /**
     * 
     * @type {OperatorTaskAssigneeResponse}
     * @memberof OperatorTaskListItemResponse
     */
    'assignee'?: OperatorTaskAssigneeResponse;
    /**
     * 
     * @type {OperatorTaskContextResponse}
     * @memberof OperatorTaskListItemResponse
     */
    'context'?: OperatorTaskContextResponse;
    /**
     * Краткое описание задачи
     * @type {string}
     * @memberof OperatorTaskListItemResponse
     */
    'textPreview'?: string | null;
    /**
     * 
     * @type {ApiOperatorTaskStatusSimpleModel}
     * @memberof OperatorTaskListItemResponse
     */
    'status'?: ApiOperatorTaskStatusSimpleModel;
    /**
     * Просрочка задачи
     * @type {boolean}
     * @memberof OperatorTaskListItemResponse
     */
    'isOverdue'?: boolean;
    /**
     * Версия задачи
     * @type {string}
     * @memberof OperatorTaskListItemResponse
     */
    'version'?: string;
    /**
     * 
     * @type {OperatorTaskMomentResponse}
     * @memberof OperatorTaskListItemResponse
     */
    'nextReminder'?: OperatorTaskMomentResponse;
    /**
     * Момент создания
     * @type {string}
     * @memberof OperatorTaskListItemResponse
     */
    'created'?: string;
    /**
     * 
     * @type {OperatorTaskActorResponse}
     * @memberof OperatorTaskListItemResponse
     */
    'createdBy'?: OperatorTaskActorResponse;
    /**
     * Момент выполнения
     * @type {string}
     * @memberof OperatorTaskListItemResponse
     */
    'completedAtUtc'?: string | null;
    /**
     * 
     * @type {OperatorTaskActorResponse}
     * @memberof OperatorTaskListItemResponse
     */
    'completedBy'?: OperatorTaskActorResponse;
}
/**
 * Запланированное напоминание задачи
 * @export
 * @interface OperatorTaskMomentResponse
 */
export interface OperatorTaskMomentResponse {
    /**
     * Запланированное время напоминания
     * @type {string}
     * @memberof OperatorTaskMomentResponse
     */
    'scheduledAtUtc'?: string;
    /**
     * Причины напоминания задачи
     * @type {Array<ApiOperatorTaskReminderReasonSimpleModel>}
     * @memberof OperatorTaskMomentResponse
     */
    'reasons'?: Array<ApiOperatorTaskReminderReasonSimpleModel> | null;
}
/**
 * Результат изменения задачи
 * @export
 * @interface OperatorTaskMutationResponse
 */
export interface OperatorTaskMutationResponse {
    /**
     * 
     * @type {OperatorTaskDetailsResponse}
     * @memberof OperatorTaskMutationResponse
     */
    'task'?: OperatorTaskDetailsResponse;
    /**
     * 
     * @type {OperatorTaskSummaryResponse}
     * @memberof OperatorTaskMutationResponse
     */
    'summary'?: OperatorTaskSummaryResponse;
    /**
     * Повтор ранее выполненного действия
     * @type {boolean}
     * @memberof OperatorTaskMutationResponse
     */
    'isReplay'?: boolean;
}
/**
 * Ограничения и настройки формы задачи
 * @export
 * @interface OperatorTaskOptionsResponse
 */
export interface OperatorTaskOptionsResponse {
    /**
     * Часовой пояс
     * @type {string}
     * @memberof OperatorTaskOptionsResponse
     */
    'timeZoneId'?: string | null;
    /**
     * Серверное время
     * @type {string}
     * @memberof OperatorTaskOptionsResponse
     */
    'serverTimeUtc'?: string;
    /**
     * Максимальная длина описания задачи
     * @type {number}
     * @memberof OperatorTaskOptionsResponse
     */
    'maxTextLength'?: number;
    /**
     * Максимальная длина поискового запроса
     * @type {number}
     * @memberof OperatorTaskOptionsResponse
     */
    'maxSearchLength'?: number;
    /**
     * Размер страницы списка задач
     * @type {number}
     * @memberof OperatorTaskOptionsResponse
     */
    'listDefaultTake'?: number;
    /**
     * Максимальный размер страницы списка задач
     * @type {number}
     * @memberof OperatorTaskOptionsResponse
     */
    'listMaxTake'?: number;
    /**
     * Максимальная длительность календарного диапазона в днях
     * @type {number}
     * @memberof OperatorTaskOptionsResponse
     */
    'calendarMaxDays'?: number;
    /**
     * Максимальный размер страницы календаря
     * @type {number}
     * @memberof OperatorTaskOptionsResponse
     */
    'calendarMaxTake'?: number;
    /**
     * Размер страницы поиска связанных объектов
     * @type {number}
     * @memberof OperatorTaskOptionsResponse
     */
    'lookupDefaultTake'?: number;
    /**
     * Максимальный размер страницы поиска связанных объектов
     * @type {number}
     * @memberof OperatorTaskOptionsResponse
     */
    'lookupMaxTake'?: number;
    /**
     * Минимальная длина запроса поиска связанных объектов
     * @type {number}
     * @memberof OperatorTaskOptionsResponse
     */
    'minLookupSearchLength'?: number;
    /**
     * Интервал повторов при просрочке в часах
     * @type {Array<number>}
     * @memberof OperatorTaskOptionsResponse
     */
    'overdueIntervalHours'?: Array<number> | null;
    /**
     * Максимальный интервал напоминания перед сроком в минутах
     * @type {number}
     * @memberof OperatorTaskOptionsResponse
     */
    'maxBeforeDeadlineOffsetMinutes'?: number;
    /**
     * Интервал обновления сводки задач в секундах
     * @type {number}
     * @memberof OperatorTaskOptionsResponse
     */
    'pollIntervalSeconds'?: number;
    /**
     * Период ближайших напоминаний в часах
     * @type {number}
     * @memberof OperatorTaskOptionsResponse
     */
    'upcomingWindowHours'?: number;
    /**
     * Количество ближайших задач
     * @type {number}
     * @memberof OperatorTaskOptionsResponse
     */
    'upcomingTake'?: number;
    /**
     * Первый номер задачи
     * @type {number}
     * @memberof OperatorTaskOptionsResponse
     */
    'firstTaskNumber'?: number;
    /**
     * Доставка напоминаний в Telegram
     * @type {boolean}
     * @memberof OperatorTaskOptionsResponse
     */
    'telegramRequired'?: boolean;
    /**
     * Группа Telegram для напоминаний операторов
     * @type {string}
     * @memberof OperatorTaskOptionsResponse
     */
    'telegramChannel'?: string | null;
    /**
     * 
     * @type {OperatorTaskReminderSettingsResponse}
     * @memberof OperatorTaskOptionsResponse
     */
    'oneTimeDefaults'?: OperatorTaskReminderSettingsResponse;
    /**
     * 
     * @type {OperatorTaskReminderSettingsResponse}
     * @memberof OperatorTaskOptionsResponse
     */
    'deadlineDefaults'?: OperatorTaskReminderSettingsResponse;
}
/**
 * Настройки повторных напоминаний о просрочке
 * @export
 * @interface OperatorTaskOverdueReminderRequest
 */
export interface OperatorTaskOverdueReminderRequest {
    /**
     * 
     * @type {ApiOperatorTaskOverdueMode}
     * @memberof OperatorTaskOverdueReminderRequest
     */
    'mode'?: ApiOperatorTaskOverdueMode;
    /**
     * Интервал повторов при просрочке в часах
     * @type {number}
     * @memberof OperatorTaskOverdueReminderRequest
     */
    'intervalHours'?: number | null;
    /**
     * Московское время повтора при просрочке
     * @type {string}
     * @memberof OperatorTaskOverdueReminderRequest
     */
    'time'?: string | null;
}


/**
 * Настройки повторных напоминаний о просрочке
 * @export
 * @interface OperatorTaskOverdueReminderResponse
 */
export interface OperatorTaskOverdueReminderResponse {
    /**
     * 
     * @type {ApiOperatorTaskOverdueModeSimpleModel}
     * @memberof OperatorTaskOverdueReminderResponse
     */
    'mode'?: ApiOperatorTaskOverdueModeSimpleModel;
    /**
     * Интервал повторов при просрочке в часах
     * @type {number}
     * @memberof OperatorTaskOverdueReminderResponse
     */
    'intervalHours'?: number | null;
    /**
     * Московское время повтора при просрочке
     * @type {string}
     * @memberof OperatorTaskOverdueReminderResponse
     */
    'time'?: string | null;
}
/**
 * Связанный с задачей заказ или чат
 * @export
 * @interface OperatorTaskRelatedResponse
 */
export interface OperatorTaskRelatedResponse {
    /**
     * 
     * @type {ApiOperatorTaskRelatedAvailabilitySimpleModel}
     * @memberof OperatorTaskRelatedResponse
     */
    'availability'?: ApiOperatorTaskRelatedAvailabilitySimpleModel;
    /**
     * Идентификатор связанного заказа
     * @type {string}
     * @memberof OperatorTaskRelatedResponse
     */
    'id'?: string | null;
    /**
     * Номер заказа
     * @type {number}
     * @memberof OperatorTaskRelatedResponse
     */
    'orderNumber'?: number | null;
    /**
     * Идентификатор чата поддержки
     * @type {string}
     * @memberof OperatorTaskRelatedResponse
     */
    'chatId'?: string | null;
    /**
     * Идентификатор владельца чата поддержки
     * @type {string}
     * @memberof OperatorTaskRelatedResponse
     */
    'ownerAppUserId'?: string | null;
    /**
     * Идентификатор собеседника чата
     * @type {string}
     * @memberof OperatorTaskRelatedResponse
     */
    'companionAppUserId'?: string | null;
    /**
     * 
     * @type {ApiUserRoleSimpleModel}
     * @memberof OperatorTaskRelatedResponse
     */
    'companionRole'?: ApiUserRoleSimpleModel;
    /**
     * Название связанного объекта
     * @type {string}
     * @memberof OperatorTaskRelatedResponse
     */
    'label'?: string | null;
}
/**
 * Предварительное расписание напоминаний задачи
 * @export
 * @interface OperatorTaskReminderPreviewResponse
 */
export interface OperatorTaskReminderPreviewResponse {
    /**
     * Предстоящие напоминания задачи
     * @type {Array<OperatorTaskMomentResponse>}
     * @memberof OperatorTaskReminderPreviewResponse
     */
    'items'?: Array<OperatorTaskMomentResponse> | null;
    /**
     * Продолжение расписания
     * @type {boolean}
     * @memberof OperatorTaskReminderPreviewResponse
     */
    'hasMore'?: boolean;
    /**
     * Время следующего напоминания
     * @type {string}
     * @memberof OperatorTaskReminderPreviewResponse
     */
    'nextReminderAtUtc'?: string | null;
    /**
     * Серверное время
     * @type {string}
     * @memberof OperatorTaskReminderPreviewResponse
     */
    'serverTimeUtc'?: string;
    /**
     * Часовой пояс
     * @type {string}
     * @memberof OperatorTaskReminderPreviewResponse
     */
    'timeZoneId'?: string | null;
}
/**
 * Наступившее напоминание задачи
 * @export
 * @interface OperatorTaskReminderResponse
 */
export interface OperatorTaskReminderResponse {
    /**
     * Идентификатор напоминания
     * @type {string}
     * @memberof OperatorTaskReminderResponse
     */
    'id'?: string;
    /**
     * 
     * @type {OperatorTaskListItemResponse}
     * @memberof OperatorTaskReminderResponse
     */
    'task'?: OperatorTaskListItemResponse;
    /**
     * Версия расписания напоминаний
     * @type {string}
     * @memberof OperatorTaskReminderResponse
     */
    'scheduleVersion'?: string;
    /**
     * Запланированное время напоминания
     * @type {string}
     * @memberof OperatorTaskReminderResponse
     */
    'scheduledAtUtc'?: string;
    /**
     * Момент сохранения напоминания
     * @type {string}
     * @memberof OperatorTaskReminderResponse
     */
    'created'?: string;
    /**
     * Причины напоминания задачи
     * @type {Array<ApiOperatorTaskReminderReasonSimpleModel>}
     * @memberof OperatorTaskReminderResponse
     */
    'reasons'?: Array<ApiOperatorTaskReminderReasonSimpleModel> | null;
    /**
     * Актуальность расписания напоминания
     * @type {boolean}
     * @memberof OperatorTaskReminderResponse
     */
    'isCurrentSchedule'?: boolean;
    /**
     * 
     * @type {ApiOperatorTaskTelegramStateSimpleModel}
     * @memberof OperatorTaskReminderResponse
     */
    'telegramState'?: ApiOperatorTaskTelegramStateSimpleModel;
    /**
     * Время отправки напоминания в Telegram
     * @type {string}
     * @memberof OperatorTaskReminderResponse
     */
    'telegramSentAtUtc'?: string | null;
}
/**
 * Настройки напоминаний задачи
 * @export
 * @interface OperatorTaskReminderSettingsRequest
 */
export interface OperatorTaskReminderSettingsRequest {
    /**
     * Напоминание при наступлении срока задачи
     * @type {boolean}
     * @memberof OperatorTaskReminderSettingsRequest
     */
    'atDeadline'?: boolean | null;
    /**
     * 
     * @type {OperatorTaskDailyReminderRequest}
     * @memberof OperatorTaskReminderSettingsRequest
     */
    'daily'?: OperatorTaskDailyReminderRequest;
    /**
     * 
     * @type {OperatorTaskBeforeDeadlineReminderRequest}
     * @memberof OperatorTaskReminderSettingsRequest
     */
    'beforeDeadline'?: OperatorTaskBeforeDeadlineReminderRequest;
    /**
     * 
     * @type {OperatorTaskOverdueReminderRequest}
     * @memberof OperatorTaskReminderSettingsRequest
     */
    'overdue'?: OperatorTaskOverdueReminderRequest;
}
/**
 * Настройки напоминаний задачи
 * @export
 * @interface OperatorTaskReminderSettingsResponse
 */
export interface OperatorTaskReminderSettingsResponse {
    /**
     * Напоминание при наступлении срока задачи
     * @type {boolean}
     * @memberof OperatorTaskReminderSettingsResponse
     */
    'atDeadline'?: boolean | null;
    /**
     * 
     * @type {OperatorTaskDailyReminderResponse}
     * @memberof OperatorTaskReminderSettingsResponse
     */
    'daily'?: OperatorTaskDailyReminderResponse;
    /**
     * 
     * @type {OperatorTaskBeforeDeadlineReminderResponse}
     * @memberof OperatorTaskReminderSettingsResponse
     */
    'beforeDeadline'?: OperatorTaskBeforeDeadlineReminderResponse;
    /**
     * 
     * @type {OperatorTaskOverdueReminderResponse}
     * @memberof OperatorTaskReminderSettingsResponse
     */
    'overdue'?: OperatorTaskOverdueReminderResponse;
}
/**
 * Снимок полей задачи
 * @export
 * @interface OperatorTaskSnapshotResponse
 */
export interface OperatorTaskSnapshotResponse {
    /**
     * Название и описание задачи
     * @type {string}
     * @memberof OperatorTaskSnapshotResponse
     */
    'text'?: string | null;
    /**
     * 
     * @type {ApiOperatorTaskTypeSimpleModel}
     * @memberof OperatorTaskSnapshotResponse
     */
    'type'?: ApiOperatorTaskTypeSimpleModel;
    /**
     * Срок выполнения
     * @type {string}
     * @memberof OperatorTaskSnapshotResponse
     */
    'dueAtUtc'?: string;
    /**
     * 
     * @type {OperatorTaskAssigneeResponse}
     * @memberof OperatorTaskSnapshotResponse
     */
    'assignee'?: OperatorTaskAssigneeResponse;
    /**
     * 
     * @type {OperatorTaskContextResponse}
     * @memberof OperatorTaskSnapshotResponse
     */
    'context'?: OperatorTaskContextResponse;
    /**
     * 
     * @type {OperatorTaskReminderSettingsResponse}
     * @memberof OperatorTaskSnapshotResponse
     */
    'reminders'?: OperatorTaskReminderSettingsResponse;
}
/**
 * Сводка общей очереди задач
 * @export
 * @interface OperatorTaskSummaryResponse
 */
export interface OperatorTaskSummaryResponse {
    /**
     * Серверное время
     * @type {string}
     * @memberof OperatorTaskSummaryResponse
     */
    'serverTimeUtc'?: string;
    /**
     * Часовой пояс
     * @type {string}
     * @memberof OperatorTaskSummaryResponse
     */
    'timeZoneId'?: string | null;
    /**
     * Количество задач в работе
     * @type {number}
     * @memberof OperatorTaskSummaryResponse
     */
    'inProgressCount'?: number;
    /**
     * Количество просроченных задач
     * @type {number}
     * @memberof OperatorTaskSummaryResponse
     */
    'overdueCount'?: number;
    /**
     * Количество предстоящих задач на сегодня
     * @type {number}
     * @memberof OperatorTaskSummaryResponse
     */
    'upcomingTodayCount'?: number;
    /**
     * Количество задач, выполненных сегодня
     * @type {number}
     * @memberof OperatorTaskSummaryResponse
     */
    'completedTodayCount'?: number;
    /**
     * Количество задач, требующих внимания
     * @type {number}
     * @memberof OperatorTaskSummaryResponse
     */
    'attentionCount'?: number;
}
/**
 * Результат аналитики отменённых заказов
 * @export
 * @interface OrderCancellationAnalyticsResponse
 */
export interface OrderCancellationAnalyticsResponse {
    /**
     * Количество заказов по всем фильтрам
     * @type {number}
     * @memberof OrderCancellationAnalyticsResponse
     */
    'allCount'?: number;
    /**
     * Страница отменённых заказов
     * @type {Array<OrderCancellationRowResponse>}
     * @memberof OrderCancellationAnalyticsResponse
     */
    'orders'?: Array<OrderCancellationRowResponse> | null;
}
/**
 * Отменённый заказ в аналитике
 * @export
 * @interface OrderCancellationRowResponse
 */
export interface OrderCancellationRowResponse {
    /**
     * Идентификатор заказа
     * @type {string}
     * @memberof OrderCancellationRowResponse
     */
    'id'?: string;
    /**
     * Номер заказа
     * @type {number}
     * @memberof OrderCancellationRowResponse
     */
    'orderNumber'?: number;
    /**
     * 
     * @type {ApiCancellationReason}
     * @memberof OrderCancellationRowResponse
     */
    'reason'?: ApiCancellationReason;
    /**
     * Сохранённое описание причины
     * @type {string}
     * @memberof OrderCancellationRowResponse
     */
    'description'?: string | null;
    /**
     * 
     * @type {ApiOrderCancellationActor}
     * @memberof OrderCancellationRowResponse
     */
    'initiator'?: ApiOrderCancellationActor;
    /**
     * Время последнего события отмены
     * @type {string}
     * @memberof OrderCancellationRowResponse
     */
    'cancelledAt'?: string | null;
}


/**
 * Детали заказа
 * @export
 * @interface OrderDetailsResponse
 */
export interface OrderDetailsResponse {
    /**
     * 
     * @type {ApiSpecialistTypeSimpleModel}
     * @memberof OrderDetailsResponse
     */
    'specialistType'?: ApiSpecialistTypeSimpleModel;
    /**
     * 
     * @type {ApiPetPlacementSimpleModel}
     * @memberof OrderDetailsResponse
     */
    'petPlacement'?: ApiPetPlacementSimpleModel;
    /**
     * 
     * @type {ApiWhoWillBringPetSimpleModel}
     * @memberof OrderDetailsResponse
     */
    'whoWillBringPet'?: ApiWhoWillBringPetSimpleModel;
    /**
     * Дата и время принятия заказа (назначения)
     * @type {string}
     * @memberof OrderDetailsResponse
     */
    'acceptedAt'?: string | null;
    /**
     * Дата и время завершения заказа (проставляется, когда заказа фактически завершен)
     * @type {string}
     * @memberof OrderDetailsResponse
     */
    'completedAt'?: string | null;
    /**
     * Нужно ли отработать команды (активировать выполнение команд)
     * @type {boolean}
     * @memberof OrderDetailsResponse
     */
    'isActiveCommand'?: boolean | null;
    /**
     * Описание команд, которые нужно отработать
     * @type {string}
     * @memberof OrderDetailsResponse
     */
    'commandsDescription'?: string | null;
    /**
     * Публичный комментарий к заказу
     * @type {string}
     * @memberof OrderDetailsResponse
     */
    'comments'?: string | null;
    /**
     * Приватные инструкции, доступные только разрешённым участникам заказа
     * @type {string}
     * @memberof OrderDetailsResponse
     */
    'description'?: string | null;
    /**
     * Описание услуги для исполнителя
     * @type {string}
     * @memberof OrderDetailsResponse
     */
    'serviceDescriptionForExecutor'?: string | null;
}
/**
 * Заказ, доступный для привязки сделки
 * @export
 * @interface OrderForTaskResponse
 */
export interface OrderForTaskResponse {
    /**
     * Идентификатор заказа
     * @type {string}
     * @memberof OrderForTaskResponse
     */
    'id'?: string;
    /**
     * Номер заказа
     * @type {string}
     * @memberof OrderForTaskResponse
     */
    'number'?: string | null;
    /**
     * 
     * @type {ApiOrderStatusSimpleModel}
     * @memberof OrderForTaskResponse
     */
    'status'?: ApiOrderStatusSimpleModel;
}
/**
 * Краткие данные питомца заказа для приложения
 * @export
 * @interface OrderPetResponse
 */
export interface OrderPetResponse {
    /**
     * Аватар питомца
     * @type {string}
     * @memberof OrderPetResponse
     */
    'avatarUrl'?: string | null;
    /**
     * Имя питомца
     * @type {string}
     * @memberof OrderPetResponse
     */
    'petName'?: string | null;
    /**
     * Порода питомца
     * @type {string}
     * @memberof OrderPetResponse
     */
    'petBreed'?: string | null;
    /**
     * Идентификатор питомца
     * @type {string}
     * @memberof OrderPetResponse
     */
    'petId'?: string;
    /**
     * 
     * @type {ApiPetTypeSimpleModel}
     * @memberof OrderPetResponse
     */
    'petType'?: ApiPetTypeSimpleModel;
}
/**
 * Ошибка попытки обработки заказа
 * @export
 * @interface OrderProblemAttemptResponse
 */
export interface OrderProblemAttemptResponse {
    /**
     * Номер попытки
     * @type {number}
     * @memberof OrderProblemAttemptResponse
     */
    'attemptNumber'?: number;
    /**
     * Время ошибки
     * @type {string}
     * @memberof OrderProblemAttemptResponse
     */
    'occurredAt'?: string;
    /**
     * Код ошибки
     * @type {string}
     * @memberof OrderProblemAttemptResponse
     */
    'errorCode'?: string | null;
    /**
     * Описание ошибки
     * @type {string}
     * @memberof OrderProblemAttemptResponse
     */
    'errorMessage'?: string | null;
}
/**
 * Данные проблемы заказа
 * @export
 * @interface OrderProblemDetailsResponse
 */
export interface OrderProblemDetailsResponse {
    /**
     * 
     * @type {OrderProblemResponse}
     * @memberof OrderProblemDetailsResponse
     */
    'problem'?: OrderProblemResponse;
    /**
     * 
     * @type {OrderResponse}
     * @memberof OrderProblemDetailsResponse
     */
    'order'?: OrderResponse;
    /**
     * Показаны сохранённые данные заказа
     * @type {boolean}
     * @memberof OrderProblemDetailsResponse
     */
    'isOrderSnapshot'?: boolean;
    /**
     * Исходные данные запроса Robokassa
     * @type {string}
     * @memberof OrderProblemDetailsResponse
     */
    'providerPayload'?: string | null;
    /**
     * Ошибки попыток обработки
     * @type {Array<OrderProblemAttemptResponse>}
     * @memberof OrderProblemDetailsResponse
     */
    'history'?: Array<OrderProblemAttemptResponse> | null;
}
/**
 * Проблема заказа
 * @export
 * @interface OrderProblemResponse
 */
export interface OrderProblemResponse {
    /**
     * Идентификатор проблемы
     * @type {string}
     * @memberof OrderProblemResponse
     */
    'id'?: string;
    /**
     * Внешний идентификатор оплаты
     * @type {string}
     * @memberof OrderProblemResponse
     */
    'externalId'?: string | null;
    /**
     * Операция, в которой возникла проблема
     * @type {string}
     * @memberof OrderProblemResponse
     */
    'source'?: string | null;
    /**
     * Идентификатор запроса
     * @type {string}
     * @memberof OrderProblemResponse
     */
    'correlationId'?: string | null;
    /**
     * Маршрут запроса
     * @type {string}
     * @memberof OrderProblemResponse
     */
    'requestPath'?: string | null;
    /**
     * HTTP-метод запроса
     * @type {string}
     * @memberof OrderProblemResponse
     */
    'requestMethod'?: string | null;
    /**
     * Диагностические данные операции
     * @type {string}
     * @memberof OrderProblemResponse
     */
    'diagnosticData'?: string | null;
    /**
     * Доступен повтор обработки
     * @type {boolean}
     * @memberof OrderProblemResponse
     */
    'canRetry'?: boolean;
    /**
     * Доступно ручное закрытие проблемы
     * @type {boolean}
     * @memberof OrderProblemResponse
     */
    'canResolve'?: boolean;
    /**
     * Подтверждённая сумма оплаты
     * @type {number}
     * @memberof OrderProblemResponse
     */
    'confirmedAmount'?: number | null;
    /**
     * 
     * @type {ApiOrderProblemKindSimpleModel}
     * @memberof OrderProblemResponse
     */
    'kind'?: ApiOrderProblemKindSimpleModel;
    /**
     * Идентификатор заказа
     * @type {string}
     * @memberof OrderProblemResponse
     */
    'orderId'?: string | null;
    /**
     * Идентификатор оплаты
     * @type {string}
     * @memberof OrderProblemResponse
     */
    'paymentId'?: string | null;
    /**
     * Идентификатор клиента
     * @type {string}
     * @memberof OrderProblemResponse
     */
    'clientId'?: string | null;
    /**
     * Код ошибки
     * @type {string}
     * @memberof OrderProblemResponse
     */
    'errorCode'?: string | null;
    /**
     * Описание ошибки
     * @type {string}
     * @memberof OrderProblemResponse
     */
    'errorMessage'?: string | null;
    /**
     * Количество попыток обработки
     * @type {number}
     * @memberof OrderProblemResponse
     */
    'attempts'?: number;
    /**
     * Время появления проблемы
     * @type {string}
     * @memberof OrderProblemResponse
     */
    'created'?: string;
    /**
     * Время последней ошибки
     * @type {string}
     * @memberof OrderProblemResponse
     */
    'lastOccurredAt'?: string;
    /**
     * Время следующей попытки
     * @type {string}
     * @memberof OrderProblemResponse
     */
    'nextAttemptAt'?: string | null;
    /**
     * Время устранения проблемы
     * @type {string}
     * @memberof OrderProblemResponse
     */
    'resolvedAt'?: string | null;
    /**
     * Проблема устранена
     * @type {boolean}
     * @memberof OrderProblemResponse
     */
    'isResolved'?: boolean;
}
/**
 * 
 * @export
 * @interface OrderProductResponse
 */
export interface OrderProductResponse {
    /**
     * Идентификатор продукта заказа
     * @type {string}
     * @memberof OrderProductResponse
     */
    'id'?: string;
    /**
     * Идентификатор продукта
     * @type {string}
     * @memberof OrderProductResponse
     */
    'productId'?: string;
    /**
     * Наименование продукта заказа
     * @type {string}
     * @memberof OrderProductResponse
     */
    'name'?: string | null;
    /**
     * Цена продукта
     * @type {number}
     * @memberof OrderProductResponse
     */
    'price'?: number;
    /**
     * Вознаграждение исполнителю за продукт
     * @type {number}
     * @memberof OrderProductResponse
     */
    'executorReward'?: number;
    /**
     * 
     * @type {ApiProductTypeSimpleModel}
     * @memberof OrderProductResponse
     */
    'productType'?: ApiProductTypeSimpleModel;
    /**
     * 
     * @type {ApiProductSubTypeSimpleModel}
     * @memberof OrderProductResponse
     */
    'subType'?: ApiProductSubTypeSimpleModel;
    /**
     * Базовый продукт?
     * @type {boolean}
     * @memberof OrderProductResponse
     */
    'isBase'?: boolean;
    /**
     * Продукт-абонементный?
     * @type {boolean}
     * @memberof OrderProductResponse
     */
    'isSubscriptionProduct'?: boolean;
    /**
     * Идентификатор абонемента
     * @type {string}
     * @memberof OrderProductResponse
     */
    'subscriptionId'?: string | null;
    /**
     * Идентификатор абонемента-клиента
     * @type {string}
     * @memberof OrderProductResponse
     */
    'clientSubscriptionId'?: string | null;
    /**
     * Массив дополнительных услуг (например, \"помыть лапы\", \"накормить\", \"поменять воду\")
     * @type {Array<string>}
     * @memberof OrderProductResponse
     */
    'serviceType'?: Array<string> | null;
}
/**
 * 
 * @export
 * @interface OrderReportResponse
 */
export interface OrderReportResponse {
    /**
     * Оставлен отзыв на заказ
     * @type {boolean}
     * @memberof OrderReportResponse
     */
    'isReviewExist'?: boolean;
    /**
     * Идентификатор заказа
     * @type {string}
     * @memberof OrderReportResponse
     */
    'orderId'?: string;
    /**
     * Номер заказа
     * @type {string}
     * @memberof OrderReportResponse
     */
    'orderNumber'?: string | null;
    /**
     * 
     * @type {TrackResponse}
     * @memberof OrderReportResponse
     */
    'track'?: TrackResponse;
    /**
     * Время начала выполнения заказа
     * @type {string}
     * @memberof OrderReportResponse
     */
    'startedAt'?: string | null;
    /**
     * Время завершения выполнения заказа
     * @type {string}
     * @memberof OrderReportResponse
     */
    'endedAt'?: string | null;
    /**
     * Фотоотчет
     * @type {Array<string>}
     * @memberof OrderReportResponse
     */
    'photoUrls'?: Array<string> | null;
    /**
     * Описание отчета
     * @type {string}
     * @memberof OrderReportResponse
     */
    'description'?: string | null;
    /**
     * Фотография исполнителя
     * @type {string}
     * @memberof OrderReportResponse
     */
    'executorPhotoUrl'?: string | null;
    /**
     * Имя исполнителя
     * @type {string}
     * @memberof OrderReportResponse
     */
    'executorName'?: string | null;
    /**
     * Идентификатор исполнителя
     * @type {string}
     * @memberof OrderReportResponse
     */
    'executorId'?: string;
    /**
     * Верифицирован ли исполнитель
     * @type {boolean}
     * @memberof OrderReportResponse
     */
    'executorIsVerified'?: boolean;
    /**
     * Рейтинг исполнителя
     * @type {number}
     * @memberof OrderReportResponse
     */
    'rating'?: number | null;
    /**
     * Кол-во отзывов
     * @type {number}
     * @memberof OrderReportResponse
     */
    'countOfReviews'?: number;
    /**
     * Оценка клиента по этому заказу
     * @type {number}
     * @memberof OrderReportResponse
     */
    'reviewMark'?: number | null;
}
/**
 * Источник запроса списка заказов
 * @export
 * @enum {string}
 */

export const OrderRequestSource = {
    Common: 'common',
    Client: 'client',
    Executor: 'executor',
    Administration: 'administration',
    ExecutorHistory: 'executorHistory'
} as const;

export type OrderRequestSource = typeof OrderRequestSource[keyof typeof OrderRequestSource];


/**
 * Данные заказа
 * @export
 * @interface OrderResponse
 */
export interface OrderResponse {
    /**
     * 
     * @type {ApiManualFnsReceiptStatusSimpleModel}
     * @memberof OrderResponse
     */
    'manualFnsReceiptStatus'?: ApiManualFnsReceiptStatusSimpleModel;
    /**
     * Ссылка на форму ручного формирования чека ФНС
     * @type {string}
     * @memberof OrderResponse
     */
    'manualFnsReceiptFormUrl'?: string | null;
    /**
     * Необходимость ручного формирования чека ФНС
     * @type {boolean}
     * @memberof OrderResponse
     */
    'manualFnsReceiptRequired'?: boolean | null;
    /**
     * Идентификатор заказа
     * @type {string}
     * @memberof OrderResponse
     */
    'id'?: string;
    /**
     * Дата создания заказа
     * @type {string}
     * @memberof OrderResponse
     */
    'created'?: string;
    /**
     * Номер заказа
     * @type {string}
     * @memberof OrderResponse
     */
    'orderNumber': string | null;
    /**
     * Идентификатор сделки
     * @type {number}
     * @memberof OrderResponse
     */
    'taskId'?: number | null;
    /**
     * 
     * @type {ApiOrderTypeSimpleModel}
     * @memberof OrderResponse
     */
    'orderType': ApiOrderTypeSimpleModel;
    /**
     * 
     * @type {ApiOrderCancellationInitiatorSimpleModel}
     * @memberof OrderResponse
     */
    'cancellationInitiator'?: ApiOrderCancellationInitiatorSimpleModel;
    /**
     * 
     * @type {ApiPetTypeSimpleModel}
     * @memberof OrderResponse
     */
    'petType'?: ApiPetTypeSimpleModel;
    /**
     * Идентификатор клиента
     * @type {string}
     * @memberof OrderResponse
     */
    'clientId'?: string;
    /**
     * Идентификатор исполнителя
     * @type {string}
     * @memberof OrderResponse
     */
    'executorId'?: string | null;
    /**
     * Имя клиента
     * @type {string}
     * @memberof OrderResponse
     */
    'clientName'?: string | null;
    /**
     * Фамилия и Имя исполнителя
     * @type {string}
     * @memberof OrderResponse
     */
    'executorFio'?: string | null;
    /**
     * Вознаграждение исполнителю
     * @type {number}
     * @memberof OrderResponse
     */
    'executorReward'?: number;
    /**
     * Можно начать выполнение заказа
     * @type {boolean}
     * @memberof OrderResponse
     * @deprecated
     */
    'canStartOrder'?: boolean;
    /**
     * Оставлен ли отзыв по заказу
     * @type {boolean}
     * @memberof OrderResponse
     */
    'isReviewExist'?: boolean;
    /**
     * Время начала заказа
     * @type {string}
     * @memberof OrderResponse
     */
    'startOrderTime'?: string | null;
    /**
     * Время начала заказа в местном времени
     * @type {string}
     * @memberof OrderResponse
     */
    'startOrderLocalTime'?: string | null;
    /**
     * Время завершения заказа
     * @type {string}
     * @memberof OrderResponse
     */
    'endOrderTime'?: string | null;
    /**
     * Заказ сформирован (готов к поиску исполнителя)
     * @type {string}
     * @memberof OrderResponse
     */
    'formedAt'?: string | null;
    /**
     * Идентификатор трек-маршрута
     * @type {number}
     * @memberof OrderResponse
     */
    'trackId'?: number | null;
    /**
     * Ссылка на web-страницу для подписания Акта выполненных работ Исполнителем
     * @type {string}
     * @memberof OrderResponse
     */
    'acceptanceSigningUri'?: string | null;
    /**
     * Ссылка на web-страницу для подписания договора Исполнителем
     * @type {string}
     * @memberof OrderResponse
     */
    'agreementSigningUri'?: string | null;
    /**
     * 
     * @type {ApiOrderStatusSimpleModel}
     * @memberof OrderResponse
     */
    'status': ApiOrderStatusSimpleModel;
    /**
     * 
     * @type {AddressResponse}
     * @memberof OrderResponse
     */
    'orderAddress'?: AddressResponse;
    /**
     * 
     * @type {AddressResponse}
     * @memberof OrderResponse
     */
    'executorAddress'?: AddressResponse;
    /**
     * 
     * @type {AddressResponse}
     * @memberof OrderResponse
     */
    'specialistAddress'?: AddressResponse;
    /**
     * 
     * @type {OrderDetailsResponse}
     * @memberof OrderResponse
     */
    'orderDetails'?: OrderDetailsResponse;
    /**
     * Питомцы заказа
     * @type {Array<OrderPetResponse>}
     * @memberof OrderResponse
     */
    'orderPets'?: Array<OrderPetResponse> | null;
    /**
     * События заказа
     * @type {Array<EventResponse>}
     * @memberof OrderResponse
     */
    'events'?: Array<EventResponse> | null;
    /**
     * Запланируемые периоды заказа
     * @type {Array<OrderSchedulePeriodResponse>}
     * @memberof OrderResponse
     */
    'orderSchedulePeriods'?: Array<OrderSchedulePeriodResponse> | null;
    /**
     * Продукты заказа
     * @type {Array<OrderProductResponse>}
     * @memberof OrderResponse
     */
    'orderProducts'?: Array<OrderProductResponse> | null;
    /**
     * 
     * @type {PaymentResponse}
     * @memberof OrderResponse
     */
    'payment'?: PaymentResponse;
}
/**
 * Расписание выполнения заказа
 * @export
 * @interface OrderSchedulePeriodResponse
 */
export interface OrderSchedulePeriodResponse {
    /**
     * Дата начала периода планирования
     * @type {string}
     * @memberof OrderSchedulePeriodResponse
     */
    'startDate'?: string;
    /**
     * Дата окончания периода планирования
     * @type {string}
     * @memberof OrderSchedulePeriodResponse
     */
    'endDate'?: string;
    /**
     * Планируемое время в этом периоде
     * @type {string}
     * @memberof OrderSchedulePeriodResponse
     */
    'time'?: string | null;
    /**
     * Планируемое время в этом периоде
     * @type {string}
     * @memberof OrderSchedulePeriodResponse
     */
    'localTime'?: string | null;
    /**
     * Планируемое время возврата питомца
     * @type {string}
     * @memberof OrderSchedulePeriodResponse
     */
    'endTime'?: string | null;
    /**
     * Время возврата в часовом поясе города заказа
     * @type {string}
     * @memberof OrderSchedulePeriodResponse
     */
    'localEndTime'?: string | null;
}
/**
 * Данные заказа
 * @export
 * @interface OrderShortResponse
 */
export interface OrderShortResponse {
    /**
     * Смещение времени города заказа относительно UTC в минутах
     * @type {number}
     * @memberof OrderShortResponse
     */
    'utcOffsetMinutes'?: number | null;
    /**
     * Персональное предложение клиентом
     * @type {boolean}
     * @memberof OrderShortResponse
     */
    'isPersonalOffer'?: boolean;
    /**
     * 
     * @type {ApiManualFnsReceiptStatusSimpleModel}
     * @memberof OrderShortResponse
     */
    'manualFnsReceiptStatus'?: ApiManualFnsReceiptStatusSimpleModel;
    /**
     * Ссылка на форму ручного формирования чека ФНС
     * @type {string}
     * @memberof OrderShortResponse
     */
    'manualFnsReceiptFormUrl'?: string | null;
    /**
     * Необходимость ручного формирования чека ФНС
     * @type {boolean}
     * @memberof OrderShortResponse
     */
    'manualFnsReceiptRequired'?: boolean | null;
    /**
     * Идентификатор заказа
     * @type {string}
     * @memberof OrderShortResponse
     */
    'id'?: string;
    /**
     * Номер заказа
     * @type {string}
     * @memberof OrderShortResponse
     */
    'orderNumber': string | null;
    /**
     * 
     * @type {ApiOrderTypeSimpleModel}
     * @memberof OrderShortResponse
     */
    'orderType': ApiOrderTypeSimpleModel;
    /**
     * 
     * @type {ApiPetTypeSimpleModel}
     * @memberof OrderShortResponse
     */
    'petType'?: ApiPetTypeSimpleModel;
    /**
     * Дата создания заказа
     * @type {string}
     * @memberof OrderShortResponse
     */
    'created'?: string;
    /**
     * Дата и время завершения заказа (проставляется, когда заказа фактически завершен)
     * @type {string}
     * @memberof OrderShortResponse
     */
    'completedAt'?: string | null;
    /**
     * Заказ сформирован (готов к поиску исполнителя)
     * @type {string}
     * @memberof OrderShortResponse
     */
    'formedAt'?: string | null;
    /**
     * Время начала заказа
     * @type {string}
     * @memberof OrderShortResponse
     */
    'startOrderTime'?: string | null;
    /**
     * Дата и время отмены заказа
     * @type {string}
     * @memberof OrderShortResponse
     */
    'orderCancelAt'?: string | null;
    /**
     * Если ли наличие отзыва от клиента
     * @type {boolean}
     * @memberof OrderShortResponse
     */
    'hasReview'?: boolean;
    /**
     * Подписал ли исполнитель Акт выполненных работ
     * @type {boolean}
     * @memberof OrderShortResponse
     */
    'isExecutorSignedAcceptanceAct'?: boolean;
    /**
     * Идентификатор клиента
     * @type {string}
     * @memberof OrderShortResponse
     */
    'clientId'?: string;
    /**
     * Имя клиента
     * @type {string}
     * @memberof OrderShortResponse
     */
    'clientName'?: string | null;
    /**
     * Телефон клиента
     * @type {string}
     * @memberof OrderShortResponse
     */
    'clientPhone'?: string | null;
    /**
     * Идентификатор исполнителя
     * @type {string}
     * @memberof OrderShortResponse
     */
    'executorId'?: string | null;
    /**
     * Идентификатор трек-маршрута
     * @type {number}
     * @memberof OrderShortResponse
     */
    'trackId'?: number | null;
    /**
     * Фамилия и Имя Исполнителя
     * @type {string}
     * @memberof OrderShortResponse
     */
    'executorFio'?: string | null;
    /**
     * Телефон исполнителя
     * @type {string}
     * @memberof OrderShortResponse
     */
    'executorPhone'?: string | null;
    /**
     * Была ли направлена оплата исполнителю
     * @type {boolean}
     * @memberof OrderShortResponse
     */
    'isPaymentSentToExecutor'?: boolean;
    /**
     * 
     * @type {AddressResponse}
     * @memberof OrderShortResponse
     */
    'address'?: AddressResponse;
    /**
     * Запланированные даты
     * @type {Array<OrderSchedulePeriodResponse>}
     * @memberof OrderShortResponse
     */
    'orderSchedulePeriods'?: Array<OrderSchedulePeriodResponse> | null;
    /**
     * Питомцы заказа
     * @type {Array<OrderPetResponse>}
     * @memberof OrderShortResponse
     */
    'orderPets'?: Array<OrderPetResponse> | null;
    /**
     * 
     * @type {ApiProductTypeSimpleModel}
     * @memberof OrderShortResponse
     */
    'productType': ApiProductTypeSimpleModel;
    /**
     * 
     * @type {ApiOrderStatusSimpleModel}
     * @memberof OrderShortResponse
     */
    'orderStatus': ApiOrderStatusSimpleModel;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const OrderSortField = {
    OrderNumber: 'orderNumber',
    ClientName: 'clientName',
    ExecutorFio: 'executorFio',
    StartOrderTime: 'startOrderTime',
    Created: 'created',
    Updated: 'updated',
    FormedAt: 'formedAt',
    CompletedAt: 'completedAt',
    Status: 'status',
    OrderType: 'orderType',
    Id: 'id'
} as const;

export type OrderSortField = typeof OrderSortField[keyof typeof OrderSortField];


/**
 * Сделка RocketWork и сведения о её сохранении в VOX
 * @export
 * @interface OrderTaskResponse
 */
export interface OrderTaskResponse {
    /**
     * Идентификатор сохранённой сущности сделки VOX
     * @type {string}
     * @memberof OrderTaskResponse
     */
    'localId'?: string | null;
    /**
     * Идентификатор связанного заказа
     * @type {string}
     * @memberof OrderTaskResponse
     */
    'orderId'?: string | null;
    /**
     * Номер связанного заказа
     * @type {string}
     * @memberof OrderTaskResponse
     */
    'orderNumber'?: string | null;
    /**
     * Идентификатор сделки
     * @type {number}
     * @memberof OrderTaskResponse
     */
    'id'?: number;
    /**
     * Внешний идентификатор сделки
     * @type {string}
     * @memberof OrderTaskResponse
     */
    'externalId'?: string | null;
    /**
     * Общая стоимость Сделки до вычета налогов (в рублях РФ),  включая сумму Дополнительной комиссии
     * @type {string}
     * @memberof OrderTaskResponse
     */
    'amountGross'?: string | null;
    /**
     * Сумма комиссии Платформы за выплату Исполнителю
     * @type {string}
     * @memberof OrderTaskResponse
     */
    'commission'?: string | null;
    /**
     * 
     * @type {ApiRocketTaskStatusSimpleModel}
     * @memberof OrderTaskResponse
     */
    'status'?: ApiRocketTaskStatusSimpleModel;
    /**
     * Описание услуг по договору
     * @type {Array<string>}
     * @memberof OrderTaskResponse
     */
    'description'?: Array<string> | null;
    /**
     * 
     * @type {ApiCanceledBySimpleModel}
     * @memberof OrderTaskResponse
     */
    'canceledBy'?: ApiCanceledBySimpleModel;
    /**
     * Время подписания договора Заказчиком (UTC)
     * @type {string}
     * @memberof OrderTaskResponse
     */
    'signedAt'?: string | null;
    /**
     * Ссылка на web-страницу для подписания договора Исполнителем
     * @type {string}
     * @memberof OrderTaskResponse
     */
    'agreementSigningUri'?: string | null;
    /**
     * Ссылка на PDF договора с Исполнителем
     * @type {string}
     * @memberof OrderTaskResponse
     */
    'agreementUri'?: string | null;
    /**
     * Время подписания договора Исполнителем (UTC)
     * @type {string}
     * @memberof OrderTaskResponse
     */
    'executorSignedAt'?: string | null;
    /**
     * Ссылка на PDF Акта выполненных работ
     * @type {string}
     * @memberof OrderTaskResponse
     */
    'acceptanceUri'?: string | null;
    /**
     * Ссылка на web-страницу для подписания Акта выполненных работ Исполнителем
     * @type {string}
     * @memberof OrderTaskResponse
     */
    'acceptanceSigningUri'?: string | null;
    /**
     * Время подписания Акта выполненных работ Исполнителем (UTC)
     * @type {string}
     * @memberof OrderTaskResponse
     */
    'acceptanceSignedAt'?: string | null;
    /**
     * Время выплаты Исполнителю по Сделке
     * @type {string}
     * @memberof OrderTaskResponse
     */
    'paidAt'?: string | null;
    /**
     * Ссылка на чек самозанятого исполнителя
     * @type {string}
     * @memberof OrderTaskResponse
     */
    'receiptUri'?: string | null;
    /**
     * Ошибки при оплате
     * @type {Array<string>}
     * @memberof OrderTaskResponse
     */
    'paymentErrors'?: Array<string> | null;
}
/**
 * Паспортные данные исполнителя
 * @export
 * @interface PassportDetailsRequest
 */
export interface PassportDetailsRequest {
    /**
     * Фамилия
     * @type {string}
     * @memberof PassportDetailsRequest
     */
    'lastName'?: string | null;
    /**
     * Имя
     * @type {string}
     * @memberof PassportDetailsRequest
     */
    'firstName'?: string | null;
    /**
     * Отчество
     * @type {string}
     * @memberof PassportDetailsRequest
     */
    'middleName'?: string | null;
    /**
     * Дата рождения
     * @type {string}
     * @memberof PassportDetailsRequest
     */
    'birthDate'?: string | null;
    /**
     * Серия паспорта
     * @type {string}
     * @memberof PassportDetailsRequest
     */
    'series'?: string | null;
    /**
     * Номер паспрта
     * @type {string}
     * @memberof PassportDetailsRequest
     */
    'number'?: string | null;
    /**
     * Место рождения
     * @type {string}
     * @memberof PassportDetailsRequest
     */
    'placeOfBorn'?: string | null;
    /**
     * Дата выдачи паспорта
     * @type {string}
     * @memberof PassportDetailsRequest
     */
    'dateOfIssue'?: string | null;
    /**
     * Кем выдан
     * @type {string}
     * @memberof PassportDetailsRequest
     */
    'whoIssued'?: string | null;
    /**
     * Код подразделения
     * @type {string}
     * @memberof PassportDetailsRequest
     */
    'passportIssuedByCode'?: string | null;
    /**
     * ИНН 12 цифр
     * @type {string}
     * @memberof PassportDetailsRequest
     */
    'inn'?: string | null;
    /**
     * 
     * @type {ApiExecutorEmploymentKind}
     * @memberof PassportDetailsRequest
     */
    'employmentKind'?: ApiExecutorEmploymentKind;
    /**
     * Адрес регистрации с точностью до номера квартиры
     * @type {string}
     * @memberof PassportDetailsRequest
     */
    'registrationAddress'?: string | null;
}


/**
 * 
 * @export
 * @interface PayForTaskRequest
 */
export interface PayForTaskRequest {
    /**
     * Идентификатор сделки
     * @type {number}
     * @memberof PayForTaskRequest
     */
    'taskId'?: number;
    /**
     * Комментарий
     * @type {string}
     * @memberof PayForTaskRequest
     */
    'comment'?: string | null;
}
/**
 * 
 * @export
 * @interface PaymentPositionDiscountResponse
 */
export interface PaymentPositionDiscountResponse {
    /**
     * 
     * @type {ApiDiscountTypeSimpleModel}
     * @memberof PaymentPositionDiscountResponse
     */
    'discountType': ApiDiscountTypeSimpleModel;
    /**
     * Скидка
     * @type {number}
     * @memberof PaymentPositionDiscountResponse
     */
    'discount'?: number;
}
/**
 * Позиция платежа для клиента
 * @export
 * @interface PaymentPositionResponse
 */
export interface PaymentPositionResponse {
    /**
     * Название продукта заказа, включая причину автоматической надбавки
     * @type {string}
     * @memberof PaymentPositionResponse
     */
    'name'?: string | null;
    /**
     * Идентификатор продукта заказа
     * @type {string}
     * @memberof PaymentPositionResponse
     */
    'orderProductId'?: string;
    /**
     * Сумма позиции
     * @type {number}
     * @memberof PaymentPositionResponse
     */
    'amount'?: number;
    /**
     * Сумма позиции со скидкой
     * @type {number}
     * @memberof PaymentPositionResponse
     */
    'amountWithDiscount'?: number;
    /**
     * Скидка
     * @type {number}
     * @memberof PaymentPositionResponse
     */
    'discount'?: number;
    /**
     * Количество
     * @type {number}
     * @memberof PaymentPositionResponse
     */
    'quantity'?: number;
    /**
     * Описание особенностей цены позиции
     * @type {string}
     * @memberof PaymentPositionResponse
     */
    'description'?: string | null;
    /**
     * Скидки применимые к позиции-продукту
     * @type {Array<PaymentPositionDiscountResponse>}
     * @memberof PaymentPositionResponse
     */
    'paymentPositionDiscounts'?: Array<PaymentPositionDiscountResponse> | null;
}
/**
 * Данные платежа и предварительного расчёта заказа
 * @export
 * @interface PaymentResponse
 */
export interface PaymentResponse {
    /**
     * Идентификатор платежа
     * @type {string}
     * @memberof PaymentResponse
     */
    'id'?: string;
    /**
     * Ссылка на оплату
     * @type {string}
     * @memberof PaymentResponse
     */
    'paymentUrl'?: string | null;
    /**
     * Идентификатор заказа
     * @type {string}
     * @memberof PaymentResponse
     */
    'orderId'?: string;
    /**
     * Идентификатор с автоинкрементом для InvId в Robokassa
     * @type {number}
     * @memberof PaymentResponse
     */
    'externalId'?: number;
    /**
     * Сумма платежа
     * @type {number}
     * @memberof PaymentResponse
     */
    'amount'?: number;
    /**
     * Сумма платежа со скидкой
     * @type {number}
     * @memberof PaymentResponse
     */
    'amountWithDiscount'?: number;
    /**
     * Скидка
     * @type {number}
     * @memberof PaymentResponse
     */
    'discount'?: number;
    /**
     * 
     * @type {ApiPaymentStatusSimpleModel}
     * @memberof PaymentResponse
     */
    'status'?: ApiPaymentStatusSimpleModel;
    /**
     * Позиции платежа
     * @type {Array<PaymentPositionResponse>}
     * @memberof PaymentResponse
     */
    'paymentPositions'?: Array<PaymentPositionResponse> | null;
    /**
     * Список общих скидок
     * @type {Array<CommonDiscountResponse>}
     * @memberof PaymentResponse
     */
    'discounts'?: Array<CommonDiscountResponse> | null;
    /**
     * Номер примененного промокода
     * @type {string}
     * @memberof PaymentResponse
     */
    'appliedPromoCodeNumber'?: string | null;
    /**
     * Баланс бонусов, доступный для текущего заказа с учётом его резерва
     * @type {number}
     * @memberof PaymentResponse
     */
    'availableBonusAmount'?: number | null;
    /**
     * Максимальная сумма бонусов для оплаты текущего заказа
     * @type {number}
     * @memberof PaymentResponse
     */
    'maximumBonusPaymentAmount'?: number | null;
    /**
     * Сумма бонусов, применённая к текущему расчёту
     * @type {number}
     * @memberof PaymentResponse
     */
    'appliedBonusAmount'?: number | null;
    /**
     * Ожидаемое начисление бонусов после завершения услуг
     * @type {number}
     * @memberof PaymentResponse
     */
    'expectedCashbackAmount'?: number | null;
    /**
     * Фактически списанные бонусы по платежу
     * @type {number}
     * @memberof PaymentResponse
     */
    'spentBonusAmount'?: number | null;
    /**
     * Фактически начисленные бонусы по платежу
     * @type {number}
     * @memberof PaymentResponse
     */
    'accruedBonusAmount'?: number | null;
    /**
     * Бонусы, возвращённые после списания по платежу
     * @type {number}
     * @memberof PaymentResponse
     */
    'refundedBonusAmount'?: number | null;
    /**
     * Бонусы, списанные при отмене начисления по платежу
     * @type {number}
     * @memberof PaymentResponse
     */
    'revokedBonusAmount'?: number | null;
}
/**
 * 
 * @export
 * @interface PayoutMethodResponse
 */
export interface PayoutMethodResponse {
    /**
     * 
     * @type {string}
     * @memberof PayoutMethodResponse
     */
    'id'?: string;
    /**
     * Если СБП то только  номер тлф
     * @type {string}
     * @memberof PayoutMethodResponse
     */
    'phone'?: string | null;
    /**
     * Номер карты
     * @type {string}
     * @memberof PayoutMethodResponse
     */
    'cardNumber'?: string | null;
    /**
     * Расчетный счет 20 цифр
     * @type {string}
     * @memberof PayoutMethodResponse
     */
    'bankAccount'?: string | null;
    /**
     * БИК Банка 9 цифр
     * @type {string}
     * @memberof PayoutMethodResponse
     */
    'bik'?: string | null;
    /**
     * 
     * @type {ApiPayoutMethodTypeSimpleModel}
     * @memberof PayoutMethodResponse
     */
    'type'?: ApiPayoutMethodTypeSimpleModel;
    /**
     * Показывает активный способ оплаты
     * @type {boolean}
     * @memberof PayoutMethodResponse
     */
    'isActive'?: boolean;
    /**
     * Идентификатор исполнителя
     * @type {string}
     * @memberof PayoutMethodResponse
     */
    'executorId'?: string;
}
/**
 * Ожидающий диалог пользователя и период обновления
 * @export
 * @interface PendingDialogsResponse
 */
export interface PendingDialogsResponse {
    /**
     * 
     * @type {GetPendingDialogResponse}
     * @memberof PendingDialogsResponse
     */
    'dialog'?: GetPendingDialogResponse;
    /**
     * Интервал опроса в секундах
     * @type {number}
     * @memberof PendingDialogsResponse
     */
    'pollIntervalSeconds'?: number;
}
/**
 * Группа прав административного каталога
 * @export
 * @interface PermissionGroupResponse
 */
export interface PermissionGroupResponse {
    /**
     * Код группы прав
     * @type {string}
     * @memberof PermissionGroupResponse
     */
    'code'?: string | null;
    /**
     * Наименование группы прав
     * @type {string}
     * @memberof PermissionGroupResponse
     */
    'name'?: string | null;
    /**
     * Права группы
     * @type {Array<PermissionResponse>}
     * @memberof PermissionGroupResponse
     */
    'permissions'?: Array<PermissionResponse> | null;
}
/**
 * Право административного каталога
 * @export
 * @interface PermissionResponse
 */
export interface PermissionResponse {
    /**
     * Идентификатор права
     * @type {string}
     * @memberof PermissionResponse
     */
    'id'?: string;
    /**
     * Уникальный код права
     * @type {string}
     * @memberof PermissionResponse
     */
    'code'?: string | null;
    /**
     * Код группы прав
     * @type {string}
     * @memberof PermissionResponse
     */
    'groupCode'?: string | null;
    /**
     * Наименование группы прав
     * @type {string}
     * @memberof PermissionResponse
     */
    'groupName'?: string | null;
    /**
     * Наименование права
     * @type {string}
     * @memberof PermissionResponse
     */
    'name'?: string | null;
    /**
     * Описание права
     * @type {string}
     * @memberof PermissionResponse
     */
    'description'?: string | null;
    /**
     * HTTP-метод API-операции
     * @type {string}
     * @memberof PermissionResponse
     */
    'httpMethod'?: string | null;
    /**
     * Маршрут API-операции
     * @type {string}
     * @memberof PermissionResponse
     */
    'route'?: string | null;
    /**
     * Относится ли право к административному интерфейсу
     * @type {boolean}
     * @memberof PermissionResponse
     */
    'isAdministrative'?: boolean;
    /**
     * Необходимые права просмотра
     * @type {Array<string>}
     * @memberof PermissionResponse
     */
    'requiredPermissionCodes'?: Array<string> | null;
    /**
     * Маршруты административного интерфейса
     * @type {Array<string>}
     * @memberof PermissionResponse
     */
    'uiRoutes'?: Array<string> | null;
    /**
     * Версия описания права
     * @type {string}
     * @memberof PermissionResponse
     */
    'version'?: string | null;
    /**
     * Признак активного права
     * @type {boolean}
     * @memberof PermissionResponse
     */
    'isActive'?: boolean;
    /**
     * Признак доступности права для назначения
     * @type {boolean}
     * @memberof PermissionResponse
     */
    'isDelegable'?: boolean;
}
/**
 * 
 * @export
 * @interface PetResponse
 */
export interface PetResponse {
    /**
     * Уникальный идентификатор питомца
     * @type {string}
     * @memberof PetResponse
     */
    'id'?: string | null;
    /**
     * Имя-Кличка
     * @type {string}
     * @memberof PetResponse
     */
    'name'?: string | null;
    /**
     * Порода
     * @type {string}
     * @memberof PetResponse
     */
    'breed'?: string | null;
    /**
     * Возраст
     * @type {number}
     * @memberof PetResponse
     */
    'age'?: number | null;
    /**
     * Описание
     * @type {string}
     * @memberof PetResponse
     */
    'description'?: string | null;
    /**
     * Детали
     * @type {string}
     * @memberof PetResponse
     */
    'details'?: string | null;
    /**
     * Цвет
     * @type {string}
     * @memberof PetResponse
     */
    'color'?: string | null;
    /**
     * Вес
     * @type {number}
     * @memberof PetResponse
     */
    'weight'?: number | null;
    /**
     * Рост
     * @type {number}
     * @memberof PetResponse
     */
    'height'?: number | null;
    /**
     * Владелец
     * @type {string}
     * @memberof PetResponse
     */
    'clientId'?: string;
    /**
     * Имя владельца питомца
     * @type {string}
     * @memberof PetResponse
     */
    'clientName'?: string | null;
    /**
     * Фото
     * @type {string}
     * @memberof PetResponse
     */
    'image'?: string | null;
    /**
     * 
     * @type {ApiPetTypeSimpleModel}
     * @memberof PetResponse
     */
    'type': ApiPetTypeSimpleModel;
    /**
     * Есть ли Статус вакцинации
     * @type {boolean}
     * @memberof PetResponse
     */
    'vaccinationStatus'?: boolean | null;
    /**
     * Есть ли аллергия
     * @type {boolean}
     * @memberof PetResponse
     */
    'allergyStatus'?: boolean | null;
    /**
     * Описание аллергии
     * @type {string}
     * @memberof PetResponse
     */
    'allergyDescription'?: string | null;
    /**
     * Есть ли Статусы болезни
     * @type {boolean}
     * @memberof PetResponse
     */
    'diseaseStatus'?: boolean | null;
    /**
     * Описание болезнии
     * @type {string}
     * @memberof PetResponse
     */
    'diseaseDescription'?: string | null;
    /**
     * Есть ли Хронические болезни
     * @type {boolean}
     * @memberof PetResponse
     */
    'chronicDiseaseStatus'?: boolean | null;
    /**
     * Описание хронических болезней
     * @type {string}
     * @memberof PetResponse
     */
    'chronicDiseaseDescription'?: string | null;
    /**
     * Есть ли Кастрация
     * @type {boolean}
     * @memberof PetResponse
     */
    'neuteredStatus'?: boolean | null;
    /**
     * Описание о кастрации
     * @type {string}
     * @memberof PetResponse
     */
    'neuteredDescription'?: string | null;
    /**
     * Есть ли Прочие операции
     * @type {boolean}
     * @memberof PetResponse
     */
    'otherOperationsStatus'?: boolean | null;
    /**
     * Описание прочих операций
     * @type {string}
     * @memberof PetResponse
     */
    'otherOperationsDescription'?: string | null;
    /**
     * Есть ли Статус страхов
     * @type {boolean}
     * @memberof PetResponse
     */
    'fearsStatus'?: boolean | null;
    /**
     * Описание страхов
     * @type {string}
     * @memberof PetResponse
     */
    'fearsDescription'?: string | null;
    /**
     * Есть ли травмы
     * @type {boolean}
     * @memberof PetResponse
     */
    'injuryStatus'?: boolean | null;
    /**
     * Описание травм
     * @type {string}
     * @memberof PetResponse
     */
    'injuryDescription'?: string | null;
    /**
     * График кормления
     * @type {string}
     * @memberof PetResponse
     */
    'feedingRegime'?: string | null;
    /**
     * Чем любит заниматься дома
     * @type {string}
     * @memberof PetResponse
     */
    'classesAtHome'?: string | null;
    /**
     * Условия пребывания питомца одного дома
     * @type {string}
     * @memberof PetResponse
     */
    'canBeLeftAloneAtHomeDescription'?: string | null;
    /**
     * Чем любит заниматься на улице
     * @type {string}
     * @memberof PetResponse
     */
    'classesOnTheStreet'?: string | null;
    /**
     * О чем ещё нам стоит знать (Дома)
     * @type {string}
     * @memberof PetResponse
     */
    'additionalCommentsAtHome'?: string | null;
    /**
     * О чем ещё нам стоит знать (На Улицы)
     * @type {string}
     * @memberof PetResponse
     */
    'additionalCommentsOnTheStreet'?: string | null;
    /**
     * График прогулок
     * @type {string}
     * @memberof PetResponse
     */
    'walkingSchedule'?: string | null;
    /**
     * Важно ли чтобы питомец находился один на передержке
     * @type {boolean}
     * @memberof PetResponse
     */
    'isImportantAloneInBoarding'?: boolean | null;
    /**
     * Другие вредные привычки, о которых стоит знать
     * @type {string}
     * @memberof PetResponse
     */
    'anotherBadHabitsDescription'?: string | null;
    /**
     * 
     * @type {ApiGenderSimpleModel}
     * @memberof PetResponse
     */
    'gender': ApiGenderSimpleModel;
    /**
     * Привычки
     * @type {Array<string>}
     * @memberof PetResponse
     */
    'habitIds'?: Array<string> | null;
}
/**
 * Данные подтверждения кода авторизации
 * @export
 * @interface PhoneVerifyRequest
 */
export interface PhoneVerifyRequest {
    /**
     * 
     * @type {BaseMessageItem}
     * @memberof PhoneVerifyRequest
     */
    'baseMessageItem'?: BaseMessageItem;
    /**
     * Токен устройства для уведомлений
     * @type {string}
     * @memberof PhoneVerifyRequest
     */
    'deviceToken'?: string | null;
    /**
     * Разрешены ли маркетинговые уведомления
     * @type {boolean}
     * @memberof PhoneVerifyRequest
     */
    'isAllowMarketingNotifications'?: boolean;
    /**
     * 
     * @type {PlatformType}
     * @memberof PhoneVerifyRequest
     */
    'platform'?: PlatformType;
    /**
     * Версия мобильного приложения
     * @type {string}
     * @memberof PhoneVerifyRequest
     */
    'appVersion'?: string | null;
}


/**
 * Личное закрепление диалога
 * @export
 * @interface PinChatRequest
 */
export interface PinChatRequest {
    /**
     * Закрепить диалог
     * @type {boolean}
     * @memberof PinChatRequest
     */
    'isPinned'?: boolean;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const PlatformType = {
    Undefined: 'undefined',
    Ios: 'ios',
    Android: 'android'
} as const;

export type PlatformType = typeof PlatformType[keyof typeof PlatformType];


/**
 * 
 * @export
 * @interface PolicyResponse
 */
export interface PolicyResponse {
    /**
     * 
     * @type {string}
     * @memberof PolicyResponse
     */
    'id'?: string;
    /**
     * Дата последнего обновления
     * @type {string}
     * @memberof PolicyResponse
     */
    'updated'?: string;
    /**
     * 
     * @type {string}
     * @memberof PolicyResponse
     */
    'content'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PolicyResponse
     */
    'title'?: string | null;
    /**
     * 
     * @type {ApiPolicyAudienceSimpleModel}
     * @memberof PolicyResponse
     */
    'audience'?: ApiPolicyAudienceSimpleModel;
    /**
     * 
     * @type {ApiPolicyTypeSimpleModel}
     * @memberof PolicyResponse
     */
    'type'?: ApiPolicyTypeSimpleModel;
    /**
     * Показывать в приложении
     * @type {boolean}
     * @memberof PolicyResponse
     */
    'isShowServices'?: boolean;
}
/**
 * 
 * @export
 * @interface PreprocessingCancelResponse
 */
export interface PreprocessingCancelResponse {
    /**
     * Сообщение исполнителю
     * @type {string}
     * @memberof PreprocessingCancelResponse
     */
    'message'?: string | null;
    /**
     * Будет ли штраф за отмену заказа
     * @type {boolean}
     * @memberof PreprocessingCancelResponse
     */
    'hasPenalty'?: boolean;
}
/**
 * 
 * @export
 * @interface PreprocessingStopExecuteOrderResponse
 */
export interface PreprocessingStopExecuteOrderResponse {
    /**
     * Сообщение исполнителю
     * @type {string}
     * @memberof PreprocessingStopExecuteOrderResponse
     */
    'message': string | null;
}
/**
 * Данные прайс-листа
 * @export
 * @interface PriceListResponse
 */
export interface PriceListResponse {
    /**
     * Ночная надбавка
     * @type {number}
     * @memberof PriceListResponse
     */
    'nightSurcharge'?: number;
    /**
     * Вознаграждение за ночную надбавку
     * @type {number}
     * @memberof PriceListResponse
     */
    'nightSurchargeExecutorReward'?: number;
    /**
     * Идентификатор прайс-листа
     * @type {string}
     * @memberof PriceListResponse
     */
    'id'?: string;
    /**
     * Дата создания
     * @type {string}
     * @memberof PriceListResponse
     */
    'created'?: string;
    /**
     * Дата изменения
     * @type {string}
     * @memberof PriceListResponse
     */
    'updated'?: string;
    /**
     * Наименование продукта
     * @type {string}
     * @memberof PriceListResponse
     */
    'productName'?: string | null;
    /**
     * 
     * @type {ApiProductTypeSimpleModel}
     * @memberof PriceListResponse
     */
    'productType'?: ApiProductTypeSimpleModel;
    /**
     * 
     * @type {ApiPetTypeSimpleModel}
     * @memberof PriceListResponse
     */
    'productPetType'?: ApiPetTypeSimpleModel;
    /**
     * Наименование города
     * @type {string}
     * @memberof PriceListResponse
     */
    'cityName'?: string | null;
    /**
     * Наименование региона
     * @type {string}
     * @memberof PriceListResponse
     */
    'regionName'?: string | null;
    /**
     * Наименование прайс-листа
     * @type {string}
     * @memberof PriceListResponse
     */
    'name'?: string | null;
    /**
     * Идентификатор города
     * @type {number}
     * @memberof PriceListResponse
     */
    'cityId'?: number;
    /**
     * Цена продукта
     * @type {number}
     * @memberof PriceListResponse
     */
    'price'?: number;
    /**
     * Вознаграждение исполнителю
     * @type {number}
     * @memberof PriceListResponse
     */
    'executorReward'?: number;
    /**
     * Идентификатор продукта
     * @type {string}
     * @memberof PriceListResponse
     */
    'productId'?: string;
}
/**
 * Сохранённый период ценообразования
 * @export
 * @interface PricingPeriodResponse
 */
export interface PricingPeriodResponse {
    /**
     * Показывать период как промоакцию
     * @type {boolean}
     * @memberof PricingPeriodResponse
     */
    'isPromotion'?: boolean;
    /**
     * Показывать в тексте баннера даты его показа
     * @type {boolean}
     * @memberof PricingPeriodResponse
     */
    'showPromotionDates'?: boolean;
    /**
     * Выбранный шаблон промобаннера
     * @type {string}
     * @memberof PricingPeriodResponse
     */
    'promotionBannerTemplateId'?: string | null;
    /**
     * Первый день показа баннера включительно, по умолчанию начало ценового периода
     * @type {string}
     * @memberof PricingPeriodResponse
     */
    'promotionStartDate'?: string | null;
    /**
     * Последний день показа баннера включительно, по умолчанию конец ценового периода
     * @type {string}
     * @memberof PricingPeriodResponse
     */
    'promotionEndDate'?: string | null;
    /**
     * Начало периода включительно
     * @type {string}
     * @memberof PricingPeriodResponse
     */
    'startDate'?: string;
    /**
     * Окончание периода включительно
     * @type {string}
     * @memberof PricingPeriodResponse
     */
    'endDate'?: string;
    /**
     * Цена в периоде
     * @type {number}
     * @memberof PricingPeriodResponse
     */
    'price'?: number;
    /**
     * Вознаграждение исполнителя в периоде
     * @type {number}
     * @memberof PricingPeriodResponse
     */
    'executorReward'?: number;
    /**
     * Идентификатор периода
     * @type {string}
     * @memberof PricingPeriodResponse
     */
    'id'?: string;
}
/**
 * Данные проверки координат дома
 * @export
 * @interface ProblemAddressResponse
 */
export interface ProblemAddressResponse {
    /**
     * Идентификатор точки дома
     * @type {string}
     * @memberof ProblemAddressResponse
     */
    'id'?: string;
    /**
     * Город
     * @type {string}
     * @memberof ProblemAddressResponse
     */
    'city'?: string | null;
    /**
     * Улица
     * @type {string}
     * @memberof ProblemAddressResponse
     */
    'street'?: string | null;
    /**
     * Номер дома
     * @type {string}
     * @memberof ProblemAddressResponse
     */
    'houseNumber'?: string | null;
    /**
     * Широта
     * @type {number}
     * @memberof ProblemAddressResponse
     */
    'latitude'?: number | null;
    /**
     * Долгота
     * @type {number}
     * @memberof ProblemAddressResponse
     */
    'longitude'?: number | null;
    /**
     * Дата проверки оператором
     * @type {string}
     * @memberof ProblemAddressResponse
     */
    'verifiedAt'?: string | null;
    /**
     * Идентификатор проверившего сотрудника
     * @type {string}
     * @memberof ProblemAddressResponse
     */
    'verifiedById'?: string | null;
    /**
     * Версия координат
     * @type {string}
     * @memberof ProblemAddressResponse
     */
    'version'?: string;
    /**
     * 
     * @type {ApiQcGeoStatusSimpleModel}
     * @memberof ProblemAddressResponse
     */
    'qcGeo'?: ApiQcGeoStatusSimpleModel;
    /**
     * История проверки
     * @type {Array<AddressPointCorrectionResponse>}
     * @memberof ProblemAddressResponse
     */
    'history'?: Array<AddressPointCorrectionResponse> | null;
}
/**
 * 
 * @export
 * @interface ProblemDetails
 */
export interface ProblemDetails {
    [key: string]: any;

    /**
     * 
     * @type {string}
     * @memberof ProblemDetails
     */
    'type'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProblemDetails
     */
    'title'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ProblemDetails
     */
    'status'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ProblemDetails
     */
    'detail'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProblemDetails
     */
    'instance'?: string | null;
}
/**
 * Отзыв с низкой оценкой для контроля качества
 * @export
 * @interface ProblemExecutorReviewResponse
 */
export interface ProblemExecutorReviewResponse {
    /**
     * Идентификатор отзыва
     * @type {number}
     * @memberof ProblemExecutorReviewResponse
     */
    'id'?: number;
    /**
     * Дата отзыва
     * @type {string}
     * @memberof ProblemExecutorReviewResponse
     */
    'created'?: string;
    /**
     * Оценка клиента
     * @type {number}
     * @memberof ProblemExecutorReviewResponse
     */
    'mark'?: number;
    /**
     * Текст отзыва
     * @type {string}
     * @memberof ProblemExecutorReviewResponse
     */
    'description'?: string | null;
    /**
     * Исполнитель отзыва
     * @type {string}
     * @memberof ProblemExecutorReviewResponse
     */
    'executorId'?: string;
    /**
     * Имя исполнителя
     * @type {string}
     * @memberof ProblemExecutorReviewResponse
     */
    'executorName'?: string | null;
    /**
     * Фамилия исполнителя
     * @type {string}
     * @memberof ProblemExecutorReviewResponse
     */
    'executorLastName'?: string | null;
    /**
     * Автор отзыва
     * @type {string}
     * @memberof ProblemExecutorReviewResponse
     */
    'clientId'?: string | null;
    /**
     * Имя автора отзыва
     * @type {string}
     * @memberof ProblemExecutorReviewResponse
     */
    'clientName'?: string | null;
    /**
     * Заказ отзыва
     * @type {string}
     * @memberof ProblemExecutorReviewResponse
     */
    'orderId'?: string | null;
    /**
     * Номер заказа
     * @type {string}
     * @memberof ProblemExecutorReviewResponse
     */
    'orderNumber'?: string | null;
    /**
     * Признак скрытого отзыва
     * @type {boolean}
     * @memberof ProblemExecutorReviewResponse
     */
    'isShadow'?: boolean;
}
/**
 * Уровень скидки за длительную передержку
 * @export
 * @interface ProductBoardingDiscountTierModel
 */
export interface ProductBoardingDiscountTierModel {
    /**
     * Минимальное количество дней
     * @type {number}
     * @memberof ProductBoardingDiscountTierModel
     */
    'fromDays'?: number;
    /**
     * Максимальное количество дней
     * @type {number}
     * @memberof ProductBoardingDiscountTierModel
     */
    'toDays'?: number;
    /**
     * Размер скидки в процентах
     * @type {number}
     * @memberof ProductBoardingDiscountTierModel
     */
    'discountPercent'?: number;
}
/**
 * Предложение продукта при оформлении заказа
 * @export
 * @interface ProductForOrderResponse
 */
export interface ProductForOrderResponse {
    /**
     * Уровни скидки за длительную передержку
     * @type {Array<ProductBoardingDiscountTierModel>}
     * @memberof ProductForOrderResponse
     */
    'boardingDiscountTiers'?: Array<ProductBoardingDiscountTierModel> | null;
    /**
     * Ночная надбавка
     * @type {number}
     * @memberof ProductForOrderResponse
     */
    'nightSurcharge'?: number;
    /**
     * Вознаграждение за ночную надбавку
     * @type {number}
     * @memberof ProductForOrderResponse
     */
    'nightSurchargeExecutorReward'?: number;
    /**
     * Идентификатор продукта
     * @type {string}
     * @memberof ProductForOrderResponse
     */
    'id'?: string;
    /**
     * Наименование продукта
     * @type {string}
     * @memberof ProductForOrderResponse
     */
    'name'?: string | null;
    /**
     * 
     * @type {ApiPetTypeSimpleModel}
     * @memberof ProductForOrderResponse
     */
    'petType'?: ApiPetTypeSimpleModel;
    /**
     * 
     * @type {ApiProductSubTypeSimpleModel}
     * @memberof ProductForOrderResponse
     */
    'subType'?: ApiProductSubTypeSimpleModel;
    /**
     * 
     * @type {ApiProductTypeSimpleModel}
     * @memberof ProductForOrderResponse
     */
    'type'?: ApiProductTypeSimpleModel;
    /**
     * Основные услуги, с которыми можно заказать дополнительную услугу
     * @type {Array<ApiProductTypeSimpleModel>}
     * @memberof ProductForOrderResponse
     */
    'compatibleBaseProductTypes'?: Array<ApiProductTypeSimpleModel> | null;
    /**
     * 
     * @type {ApiMoneyDebitTypeSimpleModel}
     * @memberof ProductForOrderResponse
     */
    'moneyDebitType'?: ApiMoneyDebitTypeSimpleModel;
    /**
     * Цена продукта
     * @type {number}
     * @memberof ProductForOrderResponse
     */
    'price'?: number | null;
    /**
     * Вознаграждение исполнителю
     * @type {number}
     * @memberof ProductForOrderResponse
     */
    'executorReward'?: number | null;
    /**
     * Базовая скидка продукта
     * @type {number}
     * @memberof ProductForOrderResponse
     */
    'discount'?: number;
    /**
     * Разрешено списание бонусов при оплате продукта
     * @type {boolean}
     * @memberof ProductForOrderResponse
     */
    'isBonusWriteOffAllowed'?: boolean;
    /**
     * Разрешено начисление бонусов за продукт
     * @type {boolean}
     * @memberof ProductForOrderResponse
     */
    'isBonusAccrualAllowed'?: boolean;
    /**
     * Идентификатор абонемента
     * @type {string}
     * @memberof ProductForOrderResponse
     */
    'subscriptionId'?: string | null;
    /**
     * Массив дополнительных услуг (например, \"помыть лапы\", \"накормить\", \"поменять воду\")
     * @type {Array<string>}
     * @memberof ProductForOrderResponse
     */
    'serviceType'?: Array<string> | null;
    /**
     * 
     * @type {VisualModel}
     * @memberof ProductForOrderResponse
     */
    'visualProductModel'?: VisualModel;
    /**
     * Базовый продукт?
     * @type {boolean}
     * @memberof ProductForOrderResponse
     */
    'isBase'?: boolean;
    /**
     * Продукт-абонементный?
     * @type {boolean}
     * @memberof ProductForOrderResponse
     */
    'isSubscriptionProduct'?: boolean;
    /**
     * Если это абонемент, мы предлагаем купить
     * @type {boolean}
     * @memberof ProductForOrderResponse
     */
    'isOfferToPurchase'?: boolean;
    /**
     * Количество использований продукта-абонемента у клиента
     * @type {number}
     * @memberof ProductForOrderResponse
     */
    'count'?: number | null;
    /**
     * Идентификатор абонемента-клиента
     * @type {string}
     * @memberof ProductForOrderResponse
     */
    'clientSubscriptionId'?: string | null;
    /**
     * 
     * @type {PurchaseSubscriptionProductResponse}
     * @memberof ProductForOrderResponse
     */
    'purchaseSubscriptionProductResponse'?: PurchaseSubscriptionProductResponse;
}
/**
 * Данные продукта для API
 * @export
 * @interface ProductResponse
 */
export interface ProductResponse {
    /**
     * Уровни скидки за длительную передержку
     * @type {Array<ProductBoardingDiscountTierModel>}
     * @memberof ProductResponse
     */
    'boardingDiscountTiers'?: Array<ProductBoardingDiscountTierModel> | null;
    /**
     * Ночная надбавка
     * @type {number}
     * @memberof ProductResponse
     */
    'nightSurcharge'?: number;
    /**
     * Вознаграждение за ночную надбавку
     * @type {number}
     * @memberof ProductResponse
     */
    'nightSurchargeExecutorReward'?: number;
    /**
     * Идентификатор продукта
     * @type {string}
     * @memberof ProductResponse
     */
    'id'?: string;
    /**
     * Наименование продукта
     * @type {string}
     * @memberof ProductResponse
     */
    'name'?: string | null;
    /**
     * 
     * @type {ApiPetTypeSimpleModel}
     * @memberof ProductResponse
     */
    'petType'?: ApiPetTypeSimpleModel;
    /**
     * 
     * @type {ApiProductSubTypeSimpleModel}
     * @memberof ProductResponse
     */
    'subType'?: ApiProductSubTypeSimpleModel;
    /**
     * 
     * @type {ApiProductTypeSimpleModel}
     * @memberof ProductResponse
     */
    'type'?: ApiProductTypeSimpleModel;
    /**
     * Основные услуги, с которыми можно заказать дополнительную услугу
     * @type {Array<ApiProductTypeSimpleModel>}
     * @memberof ProductResponse
     */
    'compatibleBaseProductTypes'?: Array<ApiProductTypeSimpleModel> | null;
    /**
     * 
     * @type {ApiMoneyDebitTypeSimpleModel}
     * @memberof ProductResponse
     */
    'moneyDebitType'?: ApiMoneyDebitTypeSimpleModel;
    /**
     * Цена продукта
     * @type {number}
     * @memberof ProductResponse
     */
    'price'?: number | null;
    /**
     * Вознаграждение исполнителю
     * @type {number}
     * @memberof ProductResponse
     */
    'executorReward'?: number | null;
    /**
     * Базовая скидка продукта
     * @type {number}
     * @memberof ProductResponse
     */
    'discount'?: number;
    /**
     * Разрешено списание бонусов при оплате продукта
     * @type {boolean}
     * @memberof ProductResponse
     */
    'isBonusWriteOffAllowed'?: boolean;
    /**
     * Разрешено начисление бонусов за продукт
     * @type {boolean}
     * @memberof ProductResponse
     */
    'isBonusAccrualAllowed'?: boolean;
    /**
     * Идентификатор абонемента
     * @type {string}
     * @memberof ProductResponse
     */
    'subscriptionId'?: string | null;
    /**
     * Массив дополнительных услуг (например, \"помыть лапы\", \"накормить\", \"поменять воду\")
     * @type {Array<string>}
     * @memberof ProductResponse
     */
    'serviceType'?: Array<string> | null;
    /**
     * 
     * @type {VisualModel}
     * @memberof ProductResponse
     */
    'visualProductModel'?: VisualModel;
}
/**
 * Информация о Продукте
 * @export
 * @interface ProductShortResponse
 */
export interface ProductShortResponse {
    /**
     * Идентификатор продукта
     * @type {string}
     * @memberof ProductShortResponse
     */
    'id'?: string;
    /**
     * Наименование продукта
     * @type {string}
     * @memberof ProductShortResponse
     */
    'name'?: string | null;
    /**
     * Цена продукта
     * @type {number}
     * @memberof ProductShortResponse
     */
    'price'?: number | null;
    /**
     * Цена продукта со скидкой
     * @type {number}
     * @memberof ProductShortResponse
     */
    'priceWithDiscount'?: number | null;
    /**
     * Скидка
     * @type {number}
     * @memberof ProductShortResponse
     */
    'discount'?: number;
    /**
     * Вознаграждение исполнителю
     * @type {number}
     * @memberof ProductShortResponse
     */
    'executorReward'?: number | null;
    /**
     * 
     * @type {ApiProductTypeSimpleModel}
     * @memberof ProductShortResponse
     */
    'productType'?: ApiProductTypeSimpleModel;
    /**
     * 
     * @type {ApiPetTypeSimpleModel}
     * @memberof ProductShortResponse
     */
    'petType'?: ApiPetTypeSimpleModel;
}
/**
 * Сведения о тираже
 * @export
 * @interface PromoCodePrintingResponse
 */
export interface PromoCodePrintingResponse {
    /**
     * Количество кодов, ожидающих активации или блокировки
     * @type {number}
     * @memberof PromoCodePrintingResponse
     */
    'newCount'?: number;
    /**
     * Идентификатор тиража
     * @type {string}
     * @memberof PromoCodePrintingResponse
     */
    'id'?: string;
    /**
     * Идентификатор шаблона
     * @type {string}
     * @memberof PromoCodePrintingResponse
     */
    'templateId'?: string;
    /**
     * Название шаблона
     * @type {string}
     * @memberof PromoCodePrintingResponse
     */
    'templateName'?: string | null;
    /**
     * Количество промокодов
     * @type {number}
     * @memberof PromoCodePrintingResponse
     */
    'capacity'?: number;
    /**
     * Дата создания
     * @type {string}
     * @memberof PromoCodePrintingResponse
     */
    'created'?: string;
    /**
     * Дата выпуска
     * @type {string}
     * @memberof PromoCodePrintingResponse
     */
    'issuedAt'?: string | null;
    /**
     * Крайний срок активации промокодов
     * @type {string}
     * @memberof PromoCodePrintingResponse
     */
    'activateBefore'?: string | null;
    /**
     * Общая дата окончания действия промокодов
     * @type {string}
     * @memberof PromoCodePrintingResponse
     */
    'expirationDate'?: string | null;
    /**
     * Тираж точечного промокода
     * @type {boolean}
     * @memberof PromoCodePrintingResponse
     */
    'isStandalone'?: boolean;
}
/**
 * Промокод
 * @export
 * @interface PromoCodeResponse
 */
export interface PromoCodeResponse {
    /**
     * Идентификатор тиража промокодов
     * @type {string}
     * @memberof PromoCodeResponse
     */
    'printingId'?: string | null;
    /**
     * Идентификатор шаблона промокодов
     * @type {string}
     * @memberof PromoCodeResponse
     */
    'templateId'?: string | null;
    /**
     * Название шаблона тиража
     * @type {string}
     * @memberof PromoCodeResponse
     */
    'templateName'?: string | null;
    /**
     * Идентификатор
     * @type {string}
     * @memberof PromoCodeResponse
     */
    'id'?: string;
    /**
     * Дата создания
     * @type {string}
     * @memberof PromoCodeResponse
     */
    'created': string;
    /**
     * Дата последнего обновления
     * @type {string}
     * @memberof PromoCodeResponse
     */
    'updated': string;
    /**
     * Номер промокода
     * @type {string}
     * @memberof PromoCodeResponse
     */
    'number'?: string | null;
    /**
     * Значение скидки (руб. / %)
     * @type {number}
     * @memberof PromoCodeResponse
     */
    'discount'?: number;
    /**
     * 
     * @type {ApiPromoCodeTypeSimpleModel}
     * @memberof PromoCodeResponse
     */
    'type'?: ApiPromoCodeTypeSimpleModel;
    /**
     * 
     * @type {ApiPromoCodeStatusSimpleModel}
     * @memberof PromoCodeResponse
     */
    'status'?: ApiPromoCodeStatusSimpleModel;
    /**
     * Лимит скидки
     * @type {number}
     * @memberof PromoCodeResponse
     */
    'limit'?: number | null;
    /**
     * Дата активации промокода
     * @type {string}
     * @memberof PromoCodeResponse
     */
    'activationDate'?: string | null;
    /**
     * Дата истечения промокода
     * @type {string}
     * @memberof PromoCodeResponse
     */
    'expirationDate'?: string | null;
    /**
     * Оставшееся количество использований промокода
     * @type {number}
     * @memberof PromoCodeResponse
     */
    'remainingTransactions'?: number | null;
    /**
     * Общий лимит использований промокода
     * @type {number}
     * @memberof PromoCodeResponse
     */
    'limitTransactions'?: number | null;
    /**
     * Лимит использований промокода одним клиентом
     * @type {number}
     * @memberof PromoCodeResponse
     */
    'clientTransactionLimit'?: number | null;
    /**
     * Срок действия после активации в днях
     * @type {number}
     * @memberof PromoCodeResponse
     */
    'activeDurationDays'?: number | null;
    /**
     * Ручной номер промокода
     * @type {boolean}
     * @memberof PromoCodeResponse
     */
    'isCustomNumber'?: boolean;
    /**
     * Крайний срок активации промокода
     * @type {string}
     * @memberof PromoCodeResponse
     */
    'activateBefore'?: string | null;
    /**
     * Точечный промокод
     * @type {boolean}
     * @memberof PromoCodeResponse
     */
    'isStandalone'?: boolean;
}
/**
 * Условия шаблона промокодов
 * @export
 * @interface PromoCodeTemplateResponse
 */
export interface PromoCodeTemplateResponse {
    /**
     * Идентификатор шаблона
     * @type {string}
     * @memberof PromoCodeTemplateResponse
     */
    'id'?: string;
    /**
     * Название шаблона
     * @type {string}
     * @memberof PromoCodeTemplateResponse
     */
    'name'?: string | null;
    /**
     * Версия условий
     * @type {string}
     * @memberof PromoCodeTemplateResponse
     */
    'version'?: string;
    /**
     * Дата создания
     * @type {string}
     * @memberof PromoCodeTemplateResponse
     */
    'created'?: string;
    /**
     * Дата изменения
     * @type {string}
     * @memberof PromoCodeTemplateResponse
     */
    'updated'?: string;
    /**
     * Значение скидки в рублях или процентах
     * @type {number}
     * @memberof PromoCodeTemplateResponse
     */
    'discount'?: number;
    /**
     * 
     * @type {ApiPromoCodeTypeSimpleModel}
     * @memberof PromoCodeTemplateResponse
     */
    'type'?: ApiPromoCodeTypeSimpleModel;
    /**
     * Максимальная сумма скидки
     * @type {number}
     * @memberof PromoCodeTemplateResponse
     */
    'limit'?: number | null;
    /**
     * Количество дней действия после активации
     * @type {number}
     * @memberof PromoCodeTemplateResponse
     */
    'activeDurationDays'?: number | null;
    /**
     * Общий лимит использований одного промокода
     * @type {number}
     * @memberof PromoCodeTemplateResponse
     */
    'limitTransactions'?: number | null;
    /**
     * Лимит использований одним клиентом
     * @type {number}
     * @memberof PromoCodeTemplateResponse
     */
    'clientTransactionLimit'?: number | null;
    /**
     * Служебный шаблон точечного промокода
     * @type {boolean}
     * @memberof PromoCodeTemplateResponse
     */
    'isStandalone'?: boolean;
}
/**
 * Сохранённый шаблон промобаннера
 * @export
 * @interface PromotionBannerTemplateResponse
 */
export interface PromotionBannerTemplateResponse {
    /**
     * Идентификатор шаблона
     * @type {string}
     * @memberof PromotionBannerTemplateResponse
     */
    'id'?: string;
    /**
     * Название шаблона
     * @type {string}
     * @memberof PromotionBannerTemplateResponse
     */
    'name'?: string | null;
    /**
     * 
     * @type {ApiProductTypeSimpleModel}
     * @memberof PromotionBannerTemplateResponse
     */
    'compatibleProductType'?: ApiProductTypeSimpleModel;
    /**
     * Вариант компоновки баннера
     * @type {string}
     * @memberof PromotionBannerTemplateResponse
     */
    'templateId'?: string | null;
    /**
     * Заголовок с подстановками цены и услуги
     * @type {string}
     * @memberof PromotionBannerTemplateResponse
     */
    'titleTemplate'?: string | null;
    /**
     * Метка промоакции
     * @type {string}
     * @memberof PromotionBannerTemplateResponse
     */
    'badgeText'?: string | null;
    /**
     * Фон без текста
     * @type {string}
     * @memberof PromotionBannerTemplateResponse
     */
    'imageUrl'?: string | null;
    /**
     * Показывать таймер
     * @type {boolean}
     * @memberof PromotionBannerTemplateResponse
     */
    'showCountdown'?: boolean;
    /**
     * Порядок показа в карусели
     * @type {number}
     * @memberof PromotionBannerTemplateResponse
     */
    'sortOrder'?: number;
}
/**
 * Команда выпуска диалогов
 * @export
 * @interface PublishDialogBroadcastRequest
 */
export interface PublishDialogBroadcastRequest {
    /**
     * 
     * @type {ApiDialogAudienceType}
     * @memberof PublishDialogBroadcastRequest
     */
    'audience'?: ApiDialogAudienceType;
    /**
     * Город получателей
     * @type {number}
     * @memberof PublishDialogBroadcastRequest
     */
    'cityId'?: number | null;
    /**
     * Поиск по имени
     * @type {string}
     * @memberof PublishDialogBroadcastRequest
     */
    'nameSearch'?: string | null;
    /**
     * Поиск по телефону
     * @type {string}
     * @memberof PublishDialogBroadcastRequest
     */
    'phoneSearch'?: string | null;
    /**
     * Поиск по кличке питомца клиента
     * @type {string}
     * @memberof PublishDialogBroadcastRequest
     */
    'petNameSearch'?: string | null;
    /**
     * Ключ повторного запроса
     * @type {string}
     * @memberof PublishDialogBroadcastRequest
     */
    'requestId'?: string;
    /**
     * Шаблон диалогов
     * @type {string}
     * @memberof PublishDialogBroadcastRequest
     */
    'templateId'?: string;
    /**
     * Название выпуска
     * @type {string}
     * @memberof PublishDialogBroadcastRequest
     */
    'name'?: string | null;
    /**
     * Назначить всем подходящим пользователям
     * @type {boolean}
     * @memberof PublishDialogBroadcastRequest
     */
    'allMatching'?: boolean;
    /**
     * Выбранные получатели
     * @type {Array<string>}
     * @memberof PublishDialogBroadcastRequest
     */
    'selectedAppUserIds'?: Array<string> | null;
    /**
     * Начало доступности
     * @type {string}
     * @memberof PublishDialogBroadcastRequest
     */
    'activeFrom'?: string | null;
    /**
     * Окончание доступности
     * @type {string}
     * @memberof PublishDialogBroadcastRequest
     */
    'expiresAt'?: string | null;
}


/**
 * Предложение покупки абонемента
 * @export
 * @interface PurchaseSubscriptionProductResponse
 */
export interface PurchaseSubscriptionProductResponse {
    /**
     * Идентификатор абонемент-продукта
     * @type {string}
     * @memberof PurchaseSubscriptionProductResponse
     */
    'id'?: string;
    /**
     * Наименование продукта
     * @type {string}
     * @memberof PurchaseSubscriptionProductResponse
     */
    'name'?: string | null;
    /**
     * Цена проудкта
     * @type {number}
     * @memberof PurchaseSubscriptionProductResponse
     */
    'price'?: number;
    /**
     * Базовая скидка продукта
     * @type {number}
     * @memberof PurchaseSubscriptionProductResponse
     */
    'discount'?: number;
    /**
     * Идентификатор абонемента
     * @type {string}
     * @memberof PurchaseSubscriptionProductResponse
     */
    'subscriptionId'?: string | null;
    /**
     * Срок действия (указывается в днях)
     * @type {number}
     * @memberof PurchaseSubscriptionProductResponse
     */
    'durationDays'?: number;
    /**
     * Количество использований абонемента
     * @type {number}
     * @memberof PurchaseSubscriptionProductResponse
     */
    'numberOfUsesCount'?: number;
    /**
     * Цвет фона для UI
     * @type {string}
     * @memberof PurchaseSubscriptionProductResponse
     */
    'backgroundColor'?: string | null;
}
/**
 * Назначение перехода из уведомления
 * @export
 * @interface PushNavigationTargetResponse
 */
export interface PushNavigationTargetResponse {
    /**
     * Служебное имя назначения
     * @type {string}
     * @memberof PushNavigationTargetResponse
     */
    'name': string | null;
    /**
     * Канонический путь без идентификатора
     * @type {string}
     * @memberof PushNavigationTargetResponse
     */
    'path': string | null;
    /**
     * Необходимость идентификатора сущности
     * @type {boolean}
     * @memberof PushNavigationTargetResponse
     */
    'requiresEntityId'?: boolean;
    /**
     * Поддержка назначения приложением клиента
     * @type {boolean}
     * @memberof PushNavigationTargetResponse
     */
    'clientSupported'?: boolean;
    /**
     * Поддержка назначения приложением исполнителя
     * @type {boolean}
     * @memberof PushNavigationTargetResponse
     */
    'executorSupported'?: boolean;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const PushNavigationTargetType = {
    Order: 'order',
    Chat: 'chat',
    Support: 'support',
    Orders: 'orders',
    Chats: 'chats',
    Main: 'main',
    OrderInProcess: 'orderInProcess',
    MyOrders: 'myOrders',
    Profile: 'profile',
    Article: 'article',
    Blog: 'blog',
    Education: 'education',
    PaymentDetails: 'paymentDetails',
    Addresses: 'addresses',
    Auth: 'auth'
} as const;

export type PushNavigationTargetType = typeof PushNavigationTargetType[keyof typeof PushNavigationTargetType];


/**
 * Данные для обновления авторизационной сессии
 * @export
 * @interface RefreshTokenRequest
 */
export interface RefreshTokenRequest {
    /**
     * Refresh token для обновления access token
     * @type {string}
     * @memberof RefreshTokenRequest
     */
    'refreshToken': string | null;
    /**
     * Токен устройства для уведомлений
     * @type {string}
     * @memberof RefreshTokenRequest
     */
    'deviceToken'?: string | null;
    /**
     * 
     * @type {PlatformType}
     * @memberof RefreshTokenRequest
     */
    'platform'?: PlatformType;
    /**
     * Версия мобильного приложения
     * @type {string}
     * @memberof RefreshTokenRequest
     */
    'appVersion'?: string | null;
}


/**
 * 
 * @export
 * @interface RefuseFromExecutorRequest
 */
export interface RefuseFromExecutorRequest {
    /**
     * Идентификатор заказа
     * @type {string}
     * @memberof RefuseFromExecutorRequest
     */
    'orderId'?: string;
    /**
     * 
     * @type {ApiRefusalFromExecutorType}
     * @memberof RefuseFromExecutorRequest
     */
    'refusalType'?: ApiRefusalFromExecutorType;
    /**
     * Описание причины отказа (для Custom Type)
     * @type {string}
     * @memberof RefuseFromExecutorRequest
     */
    'description'?: string | null;
}


/**
 * Запрос оператора на снятие исполнителя с заказа
 * @export
 * @interface RemoveOrderExecutorRequest
 */
export interface RemoveOrderExecutorRequest {
    /**
     * Идентификатор заказа
     * @type {string}
     * @memberof RemoveOrderExecutorRequest
     */
    'orderId': string;
    /**
     * Обязательный комментарий оператора
     * @type {string}
     * @memberof RemoveOrderExecutorRequest
     */
    'comment': string;
    /**
     * Назначить штраф снятому исполнителю
     * @type {boolean}
     * @memberof RemoveOrderExecutorRequest
     */
    'hasPenalty'?: boolean;
}
/**
 * Запрос замены персональных исключений прав пользователя
 * @export
 * @interface ReplaceAppUserPermissionOverridesRequest
 */
export interface ReplaceAppUserPermissionOverridesRequest {
    /**
     * Идентификаторы персонально разрешённых прав
     * @type {Array<string>}
     * @memberof ReplaceAppUserPermissionOverridesRequest
     */
    'allowedPermissionIds'?: Array<string> | null;
    /**
     * Идентификаторы персонально запрещённых прав
     * @type {Array<string>}
     * @memberof ReplaceAppUserPermissionOverridesRequest
     */
    'deniedPermissionIds'?: Array<string> | null;
    /**
     * Ожидаемая версия набора прав пользователя
     * @type {string}
     * @memberof ReplaceAppUserPermissionOverridesRequest
     */
    'expectedVersion'?: string | null;
}
/**
 * Запрос замены прав роли
 * @export
 * @interface ReplaceRolePermissionsRequest
 */
export interface ReplaceRolePermissionsRequest {
    /**
     * Идентификаторы назначаемых прав
     * @type {Array<string>}
     * @memberof ReplaceRolePermissionsRequest
     */
    'permissionIds'?: Array<string> | null;
    /**
     * Ожидаемая версия набора прав
     * @type {string}
     * @memberof ReplaceRolePermissionsRequest
     */
    'expectedVersion'?: string | null;
}
/**
 * Повторная передача сообщения после завершившейся попытки
 * @export
 * @interface RetryChatDialogMessageRequest
 */
export interface RetryChatDialogMessageRequest {
    /**
     * Неподтверждённая или неудачная попытка, показанная оператору
     * @type {string}
     * @memberof RetryChatDialogMessageRequest
     */
    'expectedAttemptId': string;
}
/**
 * Данные отзыва
 * @export
 * @interface ReviewResponse
 */
export interface ReviewResponse {
    /**
     * Идентификатор отзыва
     * @type {number}
     * @memberof ReviewResponse
     */
    'id'?: number;
    /**
     * Дата создания отзыва
     * @type {string}
     * @memberof ReviewResponse
     */
    'created'?: string;
    /**
     * Текст описания отзыва
     * @type {string}
     * @memberof ReviewResponse
     */
    'description'?: string | null;
    /**
     * Идентификатор исполнителя
     * @type {string}
     * @memberof ReviewResponse
     */
    'executorId'?: string;
    /**
     * Имя клиента, кто оставил отзыв
     * @type {string}
     * @memberof ReviewResponse
     */
    'clientName'?: string | null;
    /**
     * Ссылка на аватар клиента, который оставил отзыв
     * @type {string}
     * @memberof ReviewResponse
     */
    'clientAvatarUrl'?: string | null;
    /**
     * Идентификатор клиента
     * @type {string}
     * @memberof ReviewResponse
     */
    'clientId'?: string | null;
    /**
     * Оценка в отзыве
     * @type {number}
     * @memberof ReviewResponse
     */
    'mark'?: number;
    /**
     * 
     * @type {OrderShortResponse}
     * @memberof ReviewResponse
     */
    'orderShortResponse'?: OrderShortResponse;
}
/**
 * 
 * @export
 * @interface RocketExecutorResponse
 */
export interface RocketExecutorResponse {
    /**
     * 
     * @type {number}
     * @memberof RocketExecutorResponse
     */
    'id'?: number;
    /**
     * 
     * @type {ApiEmploymentKindSimpleModel}
     * @memberof RocketExecutorResponse
     */
    'employmentKind'?: ApiEmploymentKindSimpleModel;
    /**
     * 
     * @type {ApiSelfemployedStatusSimpleModel}
     * @memberof RocketExecutorResponse
     */
    'selfemployedStatus'?: ApiSelfemployedStatusSimpleModel;
    /**
     * 
     * @type {ApiPaymentReadinessSimpleModel}
     * @memberof RocketExecutorResponse
     */
    'paymentReadiness'?: ApiPaymentReadinessSimpleModel;
    /**
     * Налоговый резидент РФ
     * @type {boolean}
     * @memberof RocketExecutorResponse
     */
    'isResident'?: boolean;
    /**
     * Имя
     * @type {string}
     * @memberof RocketExecutorResponse
     */
    'firstName'?: string | null;
    /**
     * Отчество
     * @type {string}
     * @memberof RocketExecutorResponse
     */
    'secondName'?: string | null;
    /**
     * Фамилия
     * @type {string}
     * @memberof RocketExecutorResponse
     */
    'lastName'?: string | null;
    /**
     * ИНН
     * @type {string}
     * @memberof RocketExecutorResponse
     */
    'inn'?: string | null;
    /**
     * Телефон
     * @type {string}
     * @memberof RocketExecutorResponse
     */
    'phone'?: string | null;
}
/**
 * Данные сделки из события RocketWork
 * @export
 * @interface RocketTask
 */
export interface RocketTask {
    /**
     * 
     * @type {ManualFnsReceipt}
     * @memberof RocketTask
     */
    'manualFnsReceipt'?: ManualFnsReceipt;
    /**
     * Идентификатор Сделки
     * @type {number}
     * @memberof RocketTask
     */
    'id'?: number;
    /**
     * 
     * @type {RocketTaskStatus}
     * @memberof RocketTask
     */
    'status'?: RocketTaskStatus;
    /**
     * 
     * @type {CanceledBy}
     * @memberof RocketTask
     */
    'canceledBy'?: CanceledBy;
    /**
     * Время завершения выполнения сделки (UTC)
     * @type {string}
     * @memberof RocketTask
     */
    'completedAt'?: string | null;
    /**
     * Время подписания Акта выполненных работ Исполнителем (UTC)
     * @type {string}
     * @memberof RocketTask
     */
    'acceptanceSignedAt'?: string | null;
    /**
     * Время подписания договора Заказчиком (UTC)
     * @type {string}
     * @memberof RocketTask
     */
    'signedAt'?: string | null;
    /**
     * Время подписания договора Исполнителем (UTC)
     * @type {string}
     * @memberof RocketTask
     */
    'executorSignedAt'?: string | null;
    /**
     * Время выплаты Исполнителю по Сделке
     * @type {string}
     * @memberof RocketTask
     */
    'paidAt'?: string | null;
    /**
     * Ссылка на чек на сайте nalog.ru.  Доступно для Сделок выплаты самозанятым Исполнителям в статусе paid
     * @type {string}
     * @memberof RocketTask
     */
    'receiptUri'?: string | null;
    /**
     * Ссылка на web-страницу для подписания Акта выполненных работ Исполнителем  Может отсутствовать, если подписание акта недоступно
     * @type {string}
     * @memberof RocketTask
     */
    'acceptanceSigningUri'?: string | null;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const RocketTaskStatus = {
    Unknown: 'unknown',
    Draft: 'draft',
    Inwork: 'inwork',
    Accepting: 'accepting',
    Completed: 'completed',
    Paying: 'paying',
    Paid: 'paid',
    Error: 'error',
    Canceled: 'canceled'
} as const;

export type RocketTaskStatus = typeof RocketTaskStatus[keyof typeof RocketTaskStatus];


/**
 * 
 * @export
 * @interface RocketWorkWebhookEvent
 */
export interface RocketWorkWebhookEvent {
    /**
     * 
     * @type {number}
     * @memberof RocketWorkWebhookEvent
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof RocketWorkWebhookEvent
     */
    'event'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RocketWorkWebhookEvent
     */
    'happenedAt'?: string;
    /**
     * 
     * @type {RocketTask}
     * @memberof RocketWorkWebhookEvent
     */
    'data'?: RocketTask;
}
/**
 * Текущий снимок прав роли
 * @export
 * @interface RolePermissionsResponse
 */
export interface RolePermissionsResponse {
    /**
     * 
     * @type {ApiUserRoleSimpleModel}
     * @memberof RolePermissionsResponse
     */
    'role'?: ApiUserRoleSimpleModel;
    /**
     * Идентификаторы назначенных прав
     * @type {Array<string>}
     * @memberof RolePermissionsResponse
     */
    'permissionIds'?: Array<string> | null;
    /**
     * Версия набора прав
     * @type {string}
     * @memberof RolePermissionsResponse
     */
    'version'?: string | null;
}
/**
 * Отчёт переноса истории Salebot
 * @export
 * @interface SalebotImportRunResponse
 */
export interface SalebotImportRunResponse {
    /**
     * Запуск переноса
     * @type {string}
     * @memberof SalebotImportRunResponse
     */
    'id'?: string;
    /**
     * Время разрешённого следующего пакета
     * @type {string}
     * @memberof SalebotImportRunResponse
     */
    'nextStepAt'?: string | null;
    /**
     * Идентификатор запроса
     * @type {string}
     * @memberof SalebotImportRunResponse
     */
    'requestId'?: string;
    /**
     * Проект Salebot
     * @type {number}
     * @memberof SalebotImportRunResponse
     */
    'projectId'?: number;
    /**
     * Инициатор запуска
     * @type {string}
     * @memberof SalebotImportRunResponse
     */
    'initiatorAppUserId'?: string;
    /**
     * Идентификатор целевого хранилища
     * @type {string}
     * @memberof SalebotImportRunResponse
     */
    'targetFingerprint'?: string | null;
    /**
     * Предварительная проверка
     * @type {boolean}
     * @memberof SalebotImportRunResponse
     */
    'dryRun'?: boolean;
    /**
     * Начало запрошенной истории
     * @type {string}
     * @memberof SalebotImportRunResponse
     */
    'startAt'?: string;
    /**
     * Граница архивных сообщений
     * @type {string}
     * @memberof SalebotImportRunResponse
     */
    'archiveBefore'?: string;
    /**
     * Часовой пояс проекта
     * @type {string}
     * @memberof SalebotImportRunResponse
     */
    'timeZoneId'?: string | null;
    /**
     * Выбор всех клиентов
     * @type {boolean}
     * @memberof SalebotImportRunResponse
     */
    'allClients'?: boolean;
    /**
     * Размер пакета сообщений
     * @type {number}
     * @memberof SalebotImportRunResponse
     */
    'batchSize'?: number;
    /**
     * Пауза между запросами источника
     * @type {number}
     * @memberof SalebotImportRunResponse
     */
    'requestDelayMs'?: number;
    /**
     * 
     * @type {ApiChatMigrationStatusSimpleModel}
     * @memberof SalebotImportRunResponse
     */
    'status'?: ApiChatMigrationStatusSimpleModel;
    /**
     * Обработанные клиенты
     * @type {number}
     * @memberof SalebotImportRunResponse
     */
    'clientsProcessed'?: number;
    /**
     * Диалоги с историей
     * @type {number}
     * @memberof SalebotImportRunResponse
     */
    'dialogsProcessed'?: number;
    /**
     * Проверенные записи
     * @type {number}
     * @memberof SalebotImportRunResponse
     */
    'messagesProcessed'?: number;
    /**
     * Записи для переноса
     * @type {number}
     * @memberof SalebotImportRunResponse
     */
    'messagesPlanned'?: number;
    /**
     * Сохранённые сообщения
     * @type {number}
     * @memberof SalebotImportRunResponse
     */
    'messagesCreated'?: number;
    /**
     * Уже сохранённые сообщения
     * @type {number}
     * @memberof SalebotImportRunResponse
     */
    'messagesExisting'?: number;
    /**
     * Замечания переноса
     * @type {number}
     * @memberof SalebotImportRunResponse
     */
    'issuesCount'?: number;
    /**
     * Причина остановки
     * @type {string}
     * @memberof SalebotImportRunResponse
     */
    'lastErrorCode'?: string | null;
    /**
     * Выбранные клиенты
     * @type {Array<number>}
     * @memberof SalebotImportRunResponse
     */
    'clientIds'?: Array<number> | null;
    /**
     * Смещение списка клиентов
     * @type {number}
     * @memberof SalebotImportRunResponse
     */
    'clientOffset'?: number;
    /**
     * Позиция в пакете клиентов
     * @type {number}
     * @memberof SalebotImportRunResponse
     */
    'clientIndex'?: number;
    /**
     * День истории
     * @type {string}
     * @memberof SalebotImportRunResponse
     */
    'day'?: string | null;
    /**
     * Позиция в снимке истории
     * @type {number}
     * @memberof SalebotImportRunResponse
     */
    'messageIndex'?: number;
    /**
     * Подтверждение полноты архива
     * @type {boolean}
     * @memberof SalebotImportRunResponse
     */
    'fullHistoryConfirmed'?: boolean;
}
/**
 * Регистрация или изменение действия административного интерфейса
 * @export
 * @interface SaveAdminPermissionRequest
 */
export interface SaveAdminPermissionRequest {
    /**
     * Идентификатор изменяемого права
     * @type {string}
     * @memberof SaveAdminPermissionRequest
     */
    'id'?: string | null;
    /**
     * Стабильный код права
     * @type {string}
     * @memberof SaveAdminPermissionRequest
     */
    'code'?: string | null;
    /**
     * Код группы прав
     * @type {string}
     * @memberof SaveAdminPermissionRequest
     */
    'groupCode'?: string | null;
    /**
     * Название группы прав
     * @type {string}
     * @memberof SaveAdminPermissionRequest
     */
    'groupName'?: string | null;
    /**
     * Название действия или просмотра
     * @type {string}
     * @memberof SaveAdminPermissionRequest
     */
    'name'?: string | null;
    /**
     * Необходимые права просмотра
     * @type {Array<string>}
     * @memberof SaveAdminPermissionRequest
     */
    'requiredPermissionCodes'?: Array<string> | null;
    /**
     * Маршруты интерфейса
     * @type {Array<string>}
     * @memberof SaveAdminPermissionRequest
     */
    'uiRoutes'?: Array<string> | null;
    /**
     * Используется ли право при проверке доступа
     * @type {boolean}
     * @memberof SaveAdminPermissionRequest
     */
    'isActive'?: boolean;
    /**
     * Версия изменяемого описания права
     * @type {string}
     * @memberof SaveAdminPermissionRequest
     */
    'expectedVersion'?: string | null;
}
/**
 * 
 * @export
 * @interface SaveCashbackLevelRequest
 */
export interface SaveCashbackLevelRequest {
    /**
     * Название уровня
     * @type {string}
     * @memberof SaveCashbackLevelRequest
     */
    'name'?: string | null;
    /**
     * Надбавка к базовому проценту кэшбэка
     * @type {number}
     * @memberof SaveCashbackLevelRequest
     */
    'additionalCashbackPercent'?: number;
    /**
     * Порог суммы завершённых заказов
     * @type {number}
     * @memberof SaveCashbackLevelRequest
     */
    'requiredOrdersAmount'?: number;
    /**
     * Период расчёта суммы завершённых заказов в днях
     * @type {number}
     * @memberof SaveCashbackLevelRequest
     */
    'calculationPeriodDays'?: number;
}
/**
 * Сохранение правил бонусной программы
 * @export
 * @interface SaveCashbackRulesRequest
 */
export interface SaveCashbackRulesRequest {
    /**
     * Заголовок экрана
     * @type {string}
     * @memberof SaveCashbackRulesRequest
     */
    'title'?: string | null;
    /**
     * Заголовок вступления
     * @type {string}
     * @memberof SaveCashbackRulesRequest
     */
    'introTitle'?: string | null;
    /**
     * Текст вступления
     * @type {string}
     * @memberof SaveCashbackRulesRequest
     */
    'introDescription'?: string | null;
    /**
     * Пояснение условий оплаты
     * @type {string}
     * @memberof SaveCashbackRulesRequest
     */
    'paymentNotice'?: string | null;
    /**
     * Подпись перехода к уровням
     * @type {string}
     * @memberof SaveCashbackRulesRequest
     */
    'allLevelsButtonText'?: string | null;
    /**
     * Подпись возврата к кэшбеку
     * @type {string}
     * @memberof SaveCashbackRulesRequest
     */
    'returnButtonText'?: string | null;
    /**
     * Разделы правил в порядке показа
     * @type {Array<CashbackRuleSectionModel>}
     * @memberof SaveCashbackRulesRequest
     */
    'sections'?: Array<CashbackRuleSectionModel> | null;
}
/**
 * Данные папки шаблонов чата
 * @export
 * @interface SaveChatReplyFolderRequest
 */
export interface SaveChatReplyFolderRequest {
    /**
     * Название
     * @type {string}
     * @memberof SaveChatReplyFolderRequest
     */
    'name'?: string | null;
    /**
     * Родительская папка
     * @type {string}
     * @memberof SaveChatReplyFolderRequest
     */
    'parentId'?: string | null;
    /**
     * Версия записи
     * @type {string}
     * @memberof SaveChatReplyFolderRequest
     */
    'version'?: string | null;
}
/**
 * Данные шаблона сообщения чата
 * @export
 * @interface SaveChatReplyTemplateRequest
 */
export interface SaveChatReplyTemplateRequest {
    /**
     * Название
     * @type {string}
     * @memberof SaveChatReplyTemplateRequest
     */
    'name'?: string | null;
    /**
     * Текст сообщения
     * @type {string}
     * @memberof SaveChatReplyTemplateRequest
     */
    'text'?: string | null;
    /**
     * Папка шаблона
     * @type {string}
     * @memberof SaveChatReplyTemplateRequest
     */
    'folderId'?: string;
    /**
     * Версия записи
     * @type {string}
     * @memberof SaveChatReplyTemplateRequest
     */
    'version'?: string | null;
}
/**
 * Конфигурация назначаемого диалога
 * @export
 * @interface SaveDialogTemplateRequest
 */
export interface SaveDialogTemplateRequest {
    /**
     * Код конфигурации
     * @type {string}
     * @memberof SaveDialogTemplateRequest
     */
    'code'?: string | null;
    /**
     * Заголовок диалога
     * @type {string}
     * @memberof SaveDialogTemplateRequest
     */
    'title'?: string | null;
    /**
     * Описание диалога
     * @type {string}
     * @memberof SaveDialogTemplateRequest
     */
    'text'?: string | null;
    /**
     * 
     * @type {ApiDialogActionType}
     * @memberof SaveDialogTemplateRequest
     */
    'action'?: ApiDialogActionType;
    /**
     * 
     * @type {DialogTextInputResponse}
     * @memberof SaveDialogTemplateRequest
     */
    'textInput'?: DialogTextInputResponse;
    /**
     * Варианты ответа
     * @type {Array<DialogOptionResponse>}
     * @memberof SaveDialogTemplateRequest
     */
    'options'?: Array<DialogOptionResponse> | null;
    /**
     * Маршрут показа
     * @type {string}
     * @memberof SaveDialogTemplateRequest
     */
    'routeName'?: string | null;
    /**
     * Объект на маршруте показа
     * @type {string}
     * @memberof SaveDialogTemplateRequest
     */
    'routeEntityId'?: string | null;
    /**
     * Разрешено назначение диалога
     * @type {boolean}
     * @memberof SaveDialogTemplateRequest
     */
    'isEnabled'?: boolean;
    /**
     * Версия конфигурации
     * @type {string}
     * @memberof SaveDialogTemplateRequest
     */
    'version'?: string;
}


/**
 * Сохранение папки
 * @export
 * @interface SaveMediaFolderRequest
 */
export interface SaveMediaFolderRequest {
    /**
     * Название папки
     * @type {string}
     * @memberof SaveMediaFolderRequest
     */
    'name'?: string | null;
    /**
     * Родительская папка
     * @type {string}
     * @memberof SaveMediaFolderRequest
     */
    'parentId'?: string | null;
    /**
     * Версия записи
     * @type {string}
     * @memberof SaveMediaFolderRequest
     */
    'version'?: string | null;
}
/**
 * Настройки промоакции периода ценообразования
 * @export
 * @interface SavePricingPeriodPromotionRequest
 */
export interface SavePricingPeriodPromotionRequest {
    /**
     * Показывать период как промоакцию
     * @type {boolean}
     * @memberof SavePricingPeriodPromotionRequest
     */
    'isPromotion'?: boolean;
    /**
     * Показывать в тексте баннера даты его показа
     * @type {boolean}
     * @memberof SavePricingPeriodPromotionRequest
     */
    'showPromotionDates'?: boolean;
    /**
     * Выбранный шаблон промобаннера
     * @type {string}
     * @memberof SavePricingPeriodPromotionRequest
     */
    'promotionBannerTemplateId'?: string | null;
    /**
     * Первый день показа баннера включительно, по умолчанию начало ценового периода
     * @type {string}
     * @memberof SavePricingPeriodPromotionRequest
     */
    'promotionStartDate'?: string | null;
    /**
     * Последний день показа баннера включительно, по умолчанию конец ценового периода
     * @type {string}
     * @memberof SavePricingPeriodPromotionRequest
     */
    'promotionEndDate'?: string | null;
}
/**
 * Сохранение условий шаблона
 * @export
 * @interface SavePromoCodeTemplateRequest
 */
export interface SavePromoCodeTemplateRequest {
    /**
     * Идентификатор изменяемого шаблона
     * @type {string}
     * @memberof SavePromoCodeTemplateRequest
     */
    'id'?: string | null;
    /**
     * Версия изменяемых условий
     * @type {string}
     * @memberof SavePromoCodeTemplateRequest
     */
    'version'?: string | null;
    /**
     * Название шаблона
     * @type {string}
     * @memberof SavePromoCodeTemplateRequest
     */
    'name'?: string | null;
    /**
     * Значение скидки в рублях или процентах
     * @type {number}
     * @memberof SavePromoCodeTemplateRequest
     */
    'discount'?: number | null;
    /**
     * 
     * @type {ApiPromoCodeType}
     * @memberof SavePromoCodeTemplateRequest
     */
    'type'?: ApiPromoCodeType;
    /**
     * Максимальная сумма скидки
     * @type {number}
     * @memberof SavePromoCodeTemplateRequest
     */
    'limit'?: number | null;
    /**
     * Количество дней действия после активации
     * @type {number}
     * @memberof SavePromoCodeTemplateRequest
     */
    'activeDurationDays'?: number | null;
    /**
     * Общий лимит использований одного промокода
     * @type {number}
     * @memberof SavePromoCodeTemplateRequest
     */
    'limitTransactions'?: number | null;
    /**
     * Лимит использований одним клиентом
     * @type {number}
     * @memberof SavePromoCodeTemplateRequest
     */
    'clientTransactionLimit'?: number | null;
}


/**
 * Данные шаблона промобаннера
 * @export
 * @interface SavePromotionBannerTemplateRequest
 */
export interface SavePromotionBannerTemplateRequest {
    /**
     * Название шаблона
     * @type {string}
     * @memberof SavePromotionBannerTemplateRequest
     */
    'name'?: string | null;
    /**
     * 
     * @type {ApiProductType}
     * @memberof SavePromotionBannerTemplateRequest
     */
    'compatibleProductType'?: ApiProductType;
    /**
     * Вариант компоновки баннера
     * @type {string}
     * @memberof SavePromotionBannerTemplateRequest
     */
    'templateId'?: string | null;
    /**
     * Заголовок с подстановками цены и услуги
     * @type {string}
     * @memberof SavePromotionBannerTemplateRequest
     */
    'titleTemplate'?: string | null;
    /**
     * Метка промоакции
     * @type {string}
     * @memberof SavePromotionBannerTemplateRequest
     */
    'badgeText'?: string | null;
    /**
     * Фон без текста
     * @type {string}
     * @memberof SavePromotionBannerTemplateRequest
     */
    'imageUrl'?: string | null;
    /**
     * Показывать таймер
     * @type {boolean}
     * @memberof SavePromotionBannerTemplateRequest
     */
    'showCountdown'?: boolean | null;
    /**
     * Порядок показа в карусели
     * @type {number}
     * @memberof SavePromotionBannerTemplateRequest
     */
    'sortOrder'?: number | null;
}


/**
 * Запрос сохранения бота Telegram
 * @export
 * @interface SaveTelegramBotRequest
 */
export interface SaveTelegramBotRequest {
    /**
     * 
     * @type {ApiTelegramBot}
     * @memberof SaveTelegramBotRequest
     */
    'bot'?: ApiTelegramBot;
    /**
     * Числовой код бота
     * @type {number}
     * @memberof SaveTelegramBotRequest
     */
    'code'?: number;
    /**
     * Токен для замены текущего токена
     * @type {string}
     * @memberof SaveTelegramBotRequest
     */
    'apiKey'?: string | null;
    /**
     * Признак доступности бота
     * @type {boolean}
     * @memberof SaveTelegramBotRequest
     */
    'isEnabled'?: boolean;
}


/**
 * Запрос сохранения чата Telegram
 * @export
 * @interface SaveTelegramChatRequest
 */
export interface SaveTelegramChatRequest {
    /**
     * 
     * @type {ApiTelegramChat}
     * @memberof SaveTelegramChatRequest
     */
    'chat'?: ApiTelegramChat;
    /**
     * Числовой код чата
     * @type {number}
     * @memberof SaveTelegramChatRequest
     */
    'code'?: number;
    /**
     * Идентификатор чата
     * @type {number}
     * @memberof SaveTelegramChatRequest
     */
    'chatId'?: number;
    /**
     * 
     * @type {ApiTelegramBot}
     * @memberof SaveTelegramChatRequest
     */
    'useBot'?: ApiTelegramBot;
    /**
     * Числовой код бота для отправки в чат
     * @type {number}
     * @memberof SaveTelegramChatRequest
     */
    'useBotCode'?: number | null;
}


/**
 * Запрос сохранения настроек Telegram
 * @export
 * @interface SaveTelegramSettingsRequest
 */
export interface SaveTelegramSettingsRequest {
    /**
     * Адрес API Telegram
     * @type {string}
     * @memberof SaveTelegramSettingsRequest
     */
    'baseUrl'?: string | null;
    /**
     * Адрес прокси Telegram
     * @type {string}
     * @memberof SaveTelegramSettingsRequest
     */
    'proxyUrl'?: string | null;
    /**
     * Ссылка на бота ассистента
     * @type {string}
     * @memberof SaveTelegramSettingsRequest
     */
    'linkToAssistantBot'?: string | null;
    /**
     * Код бота для входящих сообщений
     * @type {number}
     * @memberof SaveTelegramSettingsRequest
     */
    'webhookBotCode'?: number | null;
    /**
     * Настройки ботов
     * @type {Array<SaveTelegramBotRequest>}
     * @memberof SaveTelegramSettingsRequest
     */
    'bots'?: Array<SaveTelegramBotRequest> | null;
    /**
     * Настройки чатов
     * @type {Array<SaveTelegramChatRequest>}
     * @memberof SaveTelegramSettingsRequest
     */
    'chats'?: Array<SaveTelegramChatRequest> | null;
}
/**
 * Данные для сохранения карточки услуги
 * @export
 * @interface SaveVoxServiceRequest
 */
export interface SaveVoxServiceRequest {
    /**
     * Название карточки
     * @type {string}
     * @memberof SaveVoxServiceRequest
     */
    'name'?: string | null;
    /**
     * Описание карточки
     * @type {string}
     * @memberof SaveVoxServiceRequest
     */
    'description'?: string | null;
    /**
     * Цвет фона
     * @type {string}
     * @memberof SaveVoxServiceRequest
     */
    'backgroundColor'?: string | null;
    /**
     * 
     * @type {ApiCardType}
     * @memberof SaveVoxServiceRequest
     */
    'cardType'?: ApiCardType;
    /**
     * Адрес изображения
     * @type {string}
     * @memberof SaveVoxServiceRequest
     */
    'imageUrl'?: string | null;
    /**
     * Базовый продукт
     * @type {string}
     * @memberof SaveVoxServiceRequest
     */
    'productId'?: string;
    /**
     * Порядок отображения
     * @type {number}
     * @memberof SaveVoxServiceRequest
     */
    'index'?: number;
    /**
     * Видимость в приложении
     * @type {boolean}
     * @memberof SaveVoxServiceRequest
     */
    'isShowServices'?: boolean;
    /**
     * Признак раздела в разработке
     * @type {boolean}
     * @memberof SaveVoxServiceRequest
     */
    'isUnderDevelopment'?: boolean;
    /**
     * Версия карточки
     * @type {string}
     * @memberof SaveVoxServiceRequest
     */
    'version'?: string | null;
}


/**
 * 
 * @export
 * @interface ScheduleOrderRequest
 */
export interface ScheduleOrderRequest {
    /**
     * Идентификатор заказа
     * @type {string}
     * @memberof ScheduleOrderRequest
     */
    'orderId'?: string;
    /**
     * Комментарий
     * @type {string}
     * @memberof ScheduleOrderRequest
     */
    'comment'?: string | null;
}
/**
 * Ответ пользователю в диалоге
 * @export
 * @interface SendChatDialogMessageRequest
 */
export interface SendChatDialogMessageRequest {
    /**
     * Идентификатор отправки клиента
     * @type {string}
     * @memberof SendChatDialogMessageRequest
     */
    'clientMessageId': string;
    /**
     * Текст сообщения
     * @type {string}
     * @memberof SendChatDialogMessageRequest
     */
    'text'?: string | null;
    /**
     * Адреса фотографий
     * @type {Array<string>}
     * @memberof SendChatDialogMessageRequest
     */
    'photoUrls'?: Array<string> | null;
}
/**
 * 
 * @export
 * @interface SendEmailRequest
 */
export interface SendEmailRequest {
    /**
     * 
     * @type {string}
     * @memberof SendEmailRequest
     */
    'email': string | null;
    /**
     * 
     * @type {string}
     * @memberof SendEmailRequest
     */
    'role': string | null;
}
/**
 * Запрос на отправку сообщения в чате
 * @export
 * @interface SendMessageRequest
 */
export interface SendMessageRequest {
    /**
     * Идентификатор отправителя
     * @type {string}
     * @memberof SendMessageRequest
     */
    'ownerUserId': string;
    /**
     * Идентификатор собеседника
     * @type {string}
     * @memberof SendMessageRequest
     */
    'companionId': string;
    /**
     * Текст сообщения
     * @type {string}
     * @memberof SendMessageRequest
     */
    'message'?: string | null;
    /**
     * Urls фотографий
     * @type {Array<string>}
     * @memberof SendMessageRequest
     */
    'photoUrls'?: Array<string> | null;
    /**
     * Идентификатор optimistic-сообщения клиента
     * @type {string}
     * @memberof SendMessageRequest
     */
    'clientMessageId'?: string | null;
    /**
     * Идентификатор последнего входящего сообщения, показанного отправителю
     * @type {string}
     * @memberof SendMessageRequest
     */
    'readThroughMessageId'?: string | null;
    /**
     * Ограничить подтверждение прочтения снимком клиента
     * @type {boolean}
     * @memberof SendMessageRequest
     */
    'useReadWatermark'?: boolean;
}
/**
 * 
 * @export
 * @interface SendPhoneRequest
 */
export interface SendPhoneRequest {
    /**
     * 
     * @type {string}
     * @memberof SendPhoneRequest
     */
    'phone': string | null;
    /**
     * 
     * @type {string}
     * @memberof SendPhoneRequest
     */
    'role': string | null;
}
/**
 * 
 * @export
 * @interface SendSmsRequest
 */
export interface SendSmsRequest {
    /**
     * 
     * @type {string}
     * @memberof SendSmsRequest
     */
    'phone': string | null;
    /**
     * 
     * @type {string}
     * @memberof SendSmsRequest
     */
    'role': string | null;
}
/**
 * 
 * @export
 * @interface SendTelegramRequest
 */
export interface SendTelegramRequest {
    /**
     * 
     * @type {string}
     * @memberof SendTelegramRequest
     */
    'phone': string | null;
    /**
     * 
     * @type {string}
     * @memberof SendTelegramRequest
     */
    'role': string | null;
}
/**
 * Запрос проверочного сообщения Telegram
 * @export
 * @interface SendTelegramTestMessageRequest
 */
export interface SendTelegramTestMessageRequest {
    /**
     * Код бота отправителя
     * @type {number}
     * @memberof SendTelegramTestMessageRequest
     */
    'botCode'?: number;
    /**
     * Код чата получателя
     * @type {number}
     * @memberof SendTelegramTestMessageRequest
     */
    'chatCode'?: number;
}
/**
 * 
 * @export
 * @interface SendVKRequest
 */
export interface SendVKRequest {
    /**
     * 
     * @type {string}
     * @memberof SendVKRequest
     */
    'phone': string | null;
    /**
     * 
     * @type {string}
     * @memberof SendVKRequest
     */
    'role': string | null;
}
/**
 * Информация \"Исполнитель - о себе\"
 * @export
 * @interface SetAboutMyselfRequest
 */
export interface SetAboutMyselfRequest {
    /**
     * Описание об опыте с животными
     * @type {string}
     * @memberof SetAboutMyselfRequest
     */
    'experienceWithPets'?: string | null;
    /**
     * Описание о хобби
     * @type {string}
     * @memberof SetAboutMyselfRequest
     */
    'hobby'?: string | null;
    /**
     * Описание деятельности
     * @type {string}
     * @memberof SetAboutMyselfRequest
     */
    'activity'?: string | null;
    /**
     * Описание об целях
     * @type {string}
     * @memberof SetAboutMyselfRequest
     */
    'targets'?: string | null;
    /**
     * Описание \"Живут ли с вами питомцы\"
     * @type {string}
     * @memberof SetAboutMyselfRequest
     */
    'doYouHavePets'?: string | null;
}
/**
 * Запрос установки нового пароля внутреннего пользователя
 * @export
 * @interface SetAccessAppUserPasswordRequest
 */
export interface SetAccessAppUserPasswordRequest {
    /**
     * Новый пароль пользователя
     * @type {string}
     * @memberof SetAccessAppUserPasswordRequest
     */
    'password'?: string | null;
}
/**
 * Модель запроса для прикрепления адреса к заказу,  выбранного среди существующих адресов клиента
 * @export
 * @interface SetAddressRequest
 */
export interface SetAddressRequest {
    /**
     * Идентификатор заказа
     * @type {string}
     * @memberof SetAddressRequest
     */
    'orderId'?: string;
    /**
     * Идентификатор адреса
     * @type {string}
     * @memberof SetAddressRequest
     */
    'addressId'?: string;
}
/**
 * Запрос привязки электронной почты клиента
 * @export
 * @interface SetClientEmailRequest
 */
export interface SetClientEmailRequest {
    /**
     * Идентификатор клиента
     * @type {string}
     * @memberof SetClientEmailRequest
     */
    'clientId': string;
    /**
     * Адрес электронной почты до 254 символов
     * @type {string}
     * @memberof SetClientEmailRequest
     */
    'email': string | null;
}
/**
 * 
 * @export
 * @interface SetClientPhotoRequest
 */
export interface SetClientPhotoRequest {
    /**
     * 
     * @type {string}
     * @memberof SetClientPhotoRequest
     */
    'clientId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SetClientPhotoRequest
     */
    'photoUrl'?: string | null;
}
/**
 * Запрос привязки электронной почты исполнителя
 * @export
 * @interface SetExecutorEmailRequest
 */
export interface SetExecutorEmailRequest {
    /**
     * Идентификатор исполнителя
     * @type {string}
     * @memberof SetExecutorEmailRequest
     */
    'executorId'?: string;
    /**
     * Адрес электронной почты до 254 символов
     * @type {string}
     * @memberof SetExecutorEmailRequest
     */
    'email'?: string | null;
}
/**
 * 
 * @export
 * @interface SetExecutorPhotoRequest
 */
export interface SetExecutorPhotoRequest {
    /**
     * 
     * @type {string}
     * @memberof SetExecutorPhotoRequest
     */
    'executorId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SetExecutorPhotoRequest
     */
    'photoUrl'?: string | null;
}
/**
 * Запрос изменения деталей заказа
 * @export
 * @interface SetOrderDetailsRequest
 */
export interface SetOrderDetailsRequest {
    /**
     * Идентификатор заказа
     * @type {string}
     * @memberof SetOrderDetailsRequest
     */
    'orderId'?: string;
    /**
     * Идентификатор адреса специалиста
     * @type {string}
     * @memberof SetOrderDetailsRequest
     */
    'specialistAddressId'?: string | null;
    /**
     * 
     * @type {ApiSpecialistType}
     * @memberof SetOrderDetailsRequest
     */
    'specialistType'?: ApiSpecialistType;
    /**
     * 
     * @type {ApiPetPlacement}
     * @memberof SetOrderDetailsRequest
     */
    'petPlacement'?: ApiPetPlacement;
    /**
     * 
     * @type {ApiWhoWillBringPet}
     * @memberof SetOrderDetailsRequest
     */
    'whoWillBringPet'?: ApiWhoWillBringPet;
    /**
     * Нужно ли отработать команды (активировать выполнение команд)
     * @type {boolean}
     * @memberof SetOrderDetailsRequest
     */
    'isActiveCommand'?: boolean | null;
    /**
     * Описание команд, которые нужно отработать
     * @type {string}
     * @memberof SetOrderDetailsRequest
     */
    'commandsDescription'?: string | null;
    /**
     * Публичный комментарий к заказу
     * @type {string}
     * @memberof SetOrderDetailsRequest
     */
    'comments'?: string | null;
    /**
     * Приватные инструкции, доступные только разрешённым участникам заказа
     * @type {string}
     * @memberof SetOrderDetailsRequest
     */
    'description'?: string | null;
}


/**
 * Модель запроса на установку запланированных периодов заказа
 * @export
 * @interface SetOrderSchedulePeriodsRequest
 */
export interface SetOrderSchedulePeriodsRequest {
    /**
     * Идентификатор заказа
     * @type {string}
     * @memberof SetOrderSchedulePeriodsRequest
     */
    'orderId'?: string;
    /**
     * Периоды планирования
     * @type {Array<SetSchedulePeriodRequest>}
     * @memberof SetOrderSchedulePeriodsRequest
     */
    'schedulePeriods'?: Array<SetSchedulePeriodRequest> | null;
}
/**
 * Результат установки расписания заказа
 * @export
 * @interface SetOrderSchedulePeriodsResponse
 */
export interface SetOrderSchedulePeriodsResponse {
    /**
     * Хотя бы один день расписания попадает в период особых цен
     * @type {boolean}
     * @memberof SetOrderSchedulePeriodsResponse
     */
    'hasSpecialPricingPeriod'?: boolean;
    /**
     * Сообщение для клиента при наличии периода особых цен
     * @type {string}
     * @memberof SetOrderSchedulePeriodsResponse
     */
    'message'?: string | null;
}
/**
 * Период планирования заказа
 * @export
 * @interface SetSchedulePeriodRequest
 */
export interface SetSchedulePeriodRequest {
    /**
     * Дата начала периода планирования
     * @type {string}
     * @memberof SetSchedulePeriodRequest
     */
    'startDate'?: string | null;
    /**
     * Дата окончания периода планирования
     * @type {string}
     * @memberof SetSchedulePeriodRequest
     */
    'endDate'?: string | null;
    /**
     * Планируемое время в этом периоде
     * @type {string}
     * @memberof SetSchedulePeriodRequest
     */
    'time'?: string | null;
    /**
     * Планируемое время возврата питомца
     * @type {string}
     * @memberof SetSchedulePeriodRequest
     */
    'endTime'?: string | null;
    /**
     * Планируемое время начала в часовом поясе города заказа
     * @type {string}
     * @memberof SetSchedulePeriodRequest
     */
    'localTime'?: string | null;
    /**
     * Планируемое время возврата в часовом поясе города заказа
     * @type {string}
     * @memberof SetSchedulePeriodRequest
     */
    'localEndTime'?: string | null;
}
/**
 * Значение параметра внутри документа настроек
 * @export
 * @interface SettingValue
 */
export interface SettingValue {
    /**
     * Стабильный ключ параметра
     * @type {string}
     * @memberof SettingValue
     */
    'key'?: string | null;
    /**
     * Название параметра
     * @type {string}
     * @memberof SettingValue
     */
    'name'?: string | null;
    /**
     * Значение параметра
     * @type {any}
     * @memberof SettingValue
     */
    'value'?: any;
}
/**
 * 
 * @export
 * @interface SpendBonusPointsRequest
 */
export interface SpendBonusPointsRequest {
    /**
     * Идентификатор клиента
     * @type {string}
     * @memberof SpendBonusPointsRequest
     */
    'clientId'?: string;
    /**
     * Идентификатор бизнес-операции для защиты от повторной обработки
     * @type {string}
     * @memberof SpendBonusPointsRequest
     */
    'operationId'?: string;
    /**
     * Количество баллов
     * @type {number}
     * @memberof SpendBonusPointsRequest
     */
    'amount'?: number;
    /**
     * Описание операции
     * @type {string}
     * @memberof SpendBonusPointsRequest
     */
    'description'?: string | null;
}
/**
 * Запрос переноса переписки
 * @export
 * @interface StartChatMigrationRequest
 */
export interface StartChatMigrationRequest {
    /**
     * Идентификатор запроса запуска
     * @type {string}
     * @memberof StartChatMigrationRequest
     */
    'requestId'?: string;
    /**
     * Предварительная проверка
     * @type {boolean}
     * @memberof StartChatMigrationRequest
     */
    'dryRun'?: boolean;
}
/**
 * Параметры переноса истории Salebot
 * @export
 * @interface StartSalebotImportRequest
 */
export interface StartSalebotImportRequest {
    /**
     * Идентификатор запроса
     * @type {string}
     * @memberof StartSalebotImportRequest
     */
    'requestId'?: string;
    /**
     * Проект Salebot
     * @type {number}
     * @memberof StartSalebotImportRequest
     */
    'projectId'?: number;
    /**
     * Предварительная проверка
     * @type {boolean}
     * @memberof StartSalebotImportRequest
     */
    'dryRun'?: boolean;
    /**
     * Начало запрошенной истории
     * @type {string}
     * @memberof StartSalebotImportRequest
     */
    'startAt'?: string;
    /**
     * Граница архива
     * @type {string}
     * @memberof StartSalebotImportRequest
     */
    'archiveBefore'?: string | null;
    /**
     * Часовой пояс проекта
     * @type {string}
     * @memberof StartSalebotImportRequest
     */
    'timeZoneId'?: string | null;
    /**
     * Выбранные клиенты
     * @type {Array<number>}
     * @memberof StartSalebotImportRequest
     */
    'clientIds'?: Array<number> | null;
    /**
     * Выбор всех клиентов
     * @type {boolean}
     * @memberof StartSalebotImportRequest
     */
    'allClients'?: boolean;
    /**
     * Размер пакета сообщений
     * @type {number}
     * @memberof StartSalebotImportRequest
     */
    'batchSize'?: number;
    /**
     * Пауза между запросами источника
     * @type {number}
     * @memberof StartSalebotImportRequest
     */
    'requestDelayMs'?: number;
}
/**
 * Ответ пользователя на диалог
 * @export
 * @interface SubmitDialogAnswerRequest
 */
export interface SubmitDialogAnswerRequest {
    /**
     * Текст обратной связи пользователя
     * @type {string}
     * @memberof SubmitDialogAnswerRequest
     */
    'textAnswer'?: string | null;
    /**
     * Идентификатор диалога
     * @type {string}
     * @memberof SubmitDialogAnswerRequest
     */
    'dialogId'?: string;
    /**
     * 
     * @type {ApiDialogOptionType}
     * @memberof SubmitDialogAnswerRequest
     */
    'optionType'?: ApiDialogOptionType;
}


/**
 * Подписка - абонемент
 * @export
 * @interface SubscriptionResponse
 */
export interface SubscriptionResponse {
    /**
     * Идентификатор абонемента
     * @type {string}
     * @memberof SubscriptionResponse
     */
    'id'?: string;
    /**
     * Название абонемента
     * @type {string}
     * @memberof SubscriptionResponse
     */
    'name'?: string | null;
    /**
     * Описание абонемента
     * @type {string}
     * @memberof SubscriptionResponse
     */
    'description'?: string | null;
    /**
     * Заголовок абонемента
     * @type {string}
     * @memberof SubscriptionResponse
     */
    'title'?: string | null;
    /**
     * Подзаголовок абонемента
     * @type {string}
     * @memberof SubscriptionResponse
     */
    'subtitle'?: string | null;
    /**
     * 
     * @type {ApiProductTypeSimpleModel}
     * @memberof SubscriptionResponse
     */
    'productType'?: ApiProductTypeSimpleModel;
    /**
     * 
     * @type {ApiPetTypeSimpleModel}
     * @memberof SubscriptionResponse
     */
    'petType'?: ApiPetTypeSimpleModel;
    /**
     * Срок действия (указывается в днях)
     * @type {number}
     * @memberof SubscriptionResponse
     */
    'durationDays'?: number;
    /**
     * Скидка на основной продукт
     * @type {number}
     * @memberof SubscriptionResponse
     */
    'baseDiscount'?: number;
    /**
     * Идентификатор продукта на который выпущен абонемент
     * @type {string}
     * @memberof SubscriptionResponse
     */
    'associatedProductId'?: string;
    /**
     * Наименование продукта на который выпущен абонемент
     * @type {string}
     * @memberof SubscriptionResponse
     */
    'associatedProductName'?: string | null;
    /**
     * Цвет фона для UI
     * @type {string}
     * @memberof SubscriptionResponse
     */
    'backgroundColor'?: string | null;
    /**
     * Время планирования (например, \"до 12 прогулок в месяц\")
     * @type {string}
     * @memberof SubscriptionResponse
     */
    'planningTime'?: string | null;
    /**
     * Количество использований абонемента
     * @type {number}
     * @memberof SubscriptionResponse
     */
    'numberOfUsesCount'?: number;
    /**
     * Доступен в продаже
     * @type {boolean}
     * @memberof SubscriptionResponse
     */
    'isActive'?: boolean;
    /**
     * Второй питомец включён в одно использование абонемента
     * @type {boolean}
     * @memberof SubscriptionResponse
     */
    'isSecondPetIncluded'?: boolean;
    /**
     * Ночная надбавка включена в абонемент
     * @type {boolean}
     * @memberof SubscriptionResponse
     */
    'isNightSurchargeIncluded'?: boolean;
    /**
     * Дополнительные продукты абонемента
     * @type {Array<GuidSimpleModel>}
     * @memberof SubscriptionResponse
     */
    'additionalProducts'?: Array<GuidSimpleModel> | null;
}
/**
 * 
 * @export
 * @interface SubscriptionShortResponse
 */
export interface SubscriptionShortResponse {
    /**
     * Идентификатор абонемента
     * @type {string}
     * @memberof SubscriptionShortResponse
     */
    'id'?: string;
    /**
     * Название подписки
     * @type {string}
     * @memberof SubscriptionShortResponse
     */
    'name'?: string | null;
    /**
     * 
     * @type {ApiProductTypeSimpleModel}
     * @memberof SubscriptionShortResponse
     */
    'productType'?: ApiProductTypeSimpleModel;
    /**
     * 
     * @type {ApiPetTypeSimpleModel}
     * @memberof SubscriptionShortResponse
     */
    'petType'?: ApiPetTypeSimpleModel;
    /**
     * Идентификатор продукта на который выпущен абонемент
     * @type {string}
     * @memberof SubscriptionShortResponse
     */
    'associatedProductId'?: string;
    /**
     * Наименование продукта на который выпущен абонемент
     * @type {string}
     * @memberof SubscriptionShortResponse
     */
    'associatedProductName'?: string | null;
    /**
     * Количество использований абонемента
     * @type {number}
     * @memberof SubscriptionShortResponse
     */
    'numberOfUsesCount'?: number;
    /**
     * Доступен для продажи
     * @type {boolean}
     * @memberof SubscriptionShortResponse
     */
    'isActive'?: boolean;
}
/**
 * Запрос обновления сведений о собеседнике
 * @export
 * @interface SynchronizeCompanionDataRequest
 */
export interface SynchronizeCompanionDataRequest {
    /**
     * Идентификатор инициатора
     * @type {string}
     * @memberof SynchronizeCompanionDataRequest
     */
    'ownerUserId'?: string;
    /**
     * Идентификатор собеседника
     * @type {string}
     * @memberof SynchronizeCompanionDataRequest
     */
    'companionId'?: string;
}
/**
 * Результат синхронизации каталога прав
 * @export
 * @interface SynchronizePermissionCatalogResponse
 */
export interface SynchronizePermissionCatalogResponse {
    /**
     * Количество созданных прав
     * @type {number}
     * @memberof SynchronizePermissionCatalogResponse
     */
    'createdCount'?: number;
    /**
     * Количество обновлённых прав
     * @type {number}
     * @memberof SynchronizePermissionCatalogResponse
     */
    'updatedCount'?: number;
    /**
     * Количество деактивированных прав
     * @type {number}
     * @memberof SynchronizePermissionCatalogResponse
     */
    'deactivatedCount'?: number;
}
/**
 * 
 * @export
 * @interface TagResponse
 */
export interface TagResponse {
    /**
     * Идентификатор тега
     * @type {string}
     * @memberof TagResponse
     */
    'id'?: string;
    /**
     * 
     * @type {ApiTagTypeSimpleModel}
     * @memberof TagResponse
     */
    'type'?: ApiTagTypeSimpleModel;
    /**
     * Значение тега
     * @type {string}
     * @memberof TagResponse
     */
    'value': string | null;
}
/**
 * Настройки бота Telegram для администратора
 * @export
 * @interface TelegramBotResponse
 */
export interface TelegramBotResponse {
    /**
     * 
     * @type {ApiTelegramBotSimpleModel}
     * @memberof TelegramBotResponse
     */
    'bot'?: ApiTelegramBotSimpleModel;
    /**
     * Числовой код бота для настройки до объявления enum
     * @type {number}
     * @memberof TelegramBotResponse
     */
    'code'?: number;
    /**
     * Название бота для администратора
     * @type {string}
     * @memberof TelegramBotResponse
     */
    'name': string | null;
    /**
     * Признак доступности бота
     * @type {boolean}
     * @memberof TelegramBotResponse
     */
    'isEnabled'?: boolean;
    /**
     * Признак сохранённого токена
     * @type {boolean}
     * @memberof TelegramBotResponse
     */
    'hasApiKey'?: boolean;
}
/**
 * Токен бота Telegram для супер-администратора
 * @export
 * @interface TelegramBotTokenResponse
 */
export interface TelegramBotTokenResponse {
    /**
     * Токен бота
     * @type {string}
     * @memberof TelegramBotTokenResponse
     */
    'apiKey': string | null;
}
/**
 * 
 * @export
 * @interface TelegramChat
 */
export interface TelegramChat {
    /**
     * 
     * @type {number}
     * @memberof TelegramChat
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof TelegramChat
     */
    'type'?: string | null;
}
/**
 * Настройки чата Telegram для администратора
 * @export
 * @interface TelegramChatResponse
 */
export interface TelegramChatResponse {
    /**
     * 
     * @type {ApiTelegramChatSimpleModel}
     * @memberof TelegramChatResponse
     */
    'chat'?: ApiTelegramChatSimpleModel;
    /**
     * Числовой код чата для настройки до объявления enum
     * @type {number}
     * @memberof TelegramChatResponse
     */
    'code'?: number;
    /**
     * Название чата для администратора
     * @type {string}
     * @memberof TelegramChatResponse
     */
    'name': string | null;
    /**
     * Идентификатор чата
     * @type {number}
     * @memberof TelegramChatResponse
     */
    'chatId'?: number;
    /**
     * 
     * @type {ApiTelegramBotSimpleModel}
     * @memberof TelegramChatResponse
     */
    'useBot'?: ApiTelegramBotSimpleModel;
    /**
     * Числовой код бота для отправки в чат
     * @type {number}
     * @memberof TelegramChatResponse
     */
    'useBotCode'?: number | null;
}
/**
 * 
 * @export
 * @interface TelegramMessage
 */
export interface TelegramMessage {
    /**
     * 
     * @type {TelegramUser}
     * @memberof TelegramMessage
     */
    'from'?: TelegramUser;
    /**
     * 
     * @type {TelegramChat}
     * @memberof TelegramMessage
     */
    'chat'?: TelegramChat;
    /**
     * 
     * @type {string}
     * @memberof TelegramMessage
     */
    'text'?: string | null;
}
/**
 * Настройки Telegram для администратора
 * @export
 * @interface TelegramSettingsResponse
 */
export interface TelegramSettingsResponse {
    /**
     * Адрес API Telegram
     * @type {string}
     * @memberof TelegramSettingsResponse
     */
    'baseUrl': string | null;
    /**
     * Адрес прокси Telegram
     * @type {string}
     * @memberof TelegramSettingsResponse
     */
    'proxyUrl'?: string | null;
    /**
     * Ссылка на бота ассистента
     * @type {string}
     * @memberof TelegramSettingsResponse
     */
    'linkToAssistantBot': string | null;
    /**
     * Код бота для входящих сообщений
     * @type {number}
     * @memberof TelegramSettingsResponse
     */
    'webhookBotCode'?: number;
    /**
     * Настройки ботов
     * @type {Array<TelegramBotResponse>}
     * @memberof TelegramSettingsResponse
     */
    'bots': Array<TelegramBotResponse> | null;
    /**
     * Настройки чатов
     * @type {Array<TelegramChatResponse>}
     * @memberof TelegramSettingsResponse
     */
    'chats': Array<TelegramChatResponse> | null;
}
/**
 * 
 * @export
 * @interface TelegramUpdateRequest
 */
export interface TelegramUpdateRequest {
    /**
     * 
     * @type {TelegramMessage}
     * @memberof TelegramUpdateRequest
     */
    'message'?: TelegramMessage;
}
/**
 * 
 * @export
 * @interface TelegramUser
 */
export interface TelegramUser {
    /**
     * 
     * @type {number}
     * @memberof TelegramUser
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof TelegramUser
     */
    'username'?: string | null;
}
/**
 * Данные выданных токенов авторизации
 * @export
 * @interface TokenResponse
 */
export interface TokenResponse {
    /**
     * Токен доступа
     * @type {string}
     * @memberof TokenResponse
     */
    'accessToken'?: string | null;
    /**
     * Срок действия токена доступа в секундах
     * @type {number}
     * @memberof TokenResponse
     */
    'expiresIn'?: number;
    /**
     * Токен обновления
     * @type {string}
     * @memberof TokenResponse
     */
    'refreshToken'?: string | null;
    /**
     * Срок действия токена обновления в секундах
     * @type {number}
     * @memberof TokenResponse
     */
    'refreshExpiresIn'?: number;
    /**
     * Идентификатор пользователя
     * @type {string}
     * @memberof TokenResponse
     */
    'userId'?: string | null;
    /**
     * Логин (если пользователь сотрудник)
     * @type {string}
     * @memberof TokenResponse
     */
    'login'?: string | null;
    /**
     * Наименование роли
     * @type {string}
     * @memberof TokenResponse
     */
    'role'?: string | null;
    /**
     * 
     * @type {ApiUserRole}
     * @memberof TokenResponse
     */
    'roleCode'?: ApiUserRole;
    /**
     * Область действия токена
     * @type {string}
     * @memberof TokenResponse
     */
    'scope'?: string | null;
}


/**
 * 
 * @export
 * @interface TrackLocationResponse
 */
export interface TrackLocationResponse {
    /**
     * Широта
     * @type {number}
     * @memberof TrackLocationResponse
     */
    'latitude'?: number;
    /**
     * Долгота
     * @type {number}
     * @memberof TrackLocationResponse
     */
    'longitude'?: number;
    /**
     * Дата-время создания
     * @type {string}
     * @memberof TrackLocationResponse
     */
    'created'?: string;
}
/**
 * 
 * @export
 * @interface TrackResponse
 */
export interface TrackResponse {
    /**
     * Идентификатор маршрута
     * @type {number}
     * @memberof TrackResponse
     */
    'trackId'?: number;
    /**
     * Время старта маршрута
     * @type {string}
     * @memberof TrackResponse
     */
    'startedAt'?: string;
    /**
     * Время окончания маршрута
     * @type {string}
     * @memberof TrackResponse
     */
    'endedAt'?: string;
    /**
     * Координаты маршрута
     * @type {Array<TrackLocationResponse>}
     * @memberof TrackResponse
     */
    'locations'?: Array<TrackLocationResponse> | null;
}
/**
 * Перенос профиля на другой телефон
 * @export
 * @interface TransferProfilePhoneRequest
 */
export interface TransferProfilePhoneRequest {
    /**
     * Новый телефон профиля
     * @type {string}
     * @memberof TransferProfilePhoneRequest
     */
    'phone': string;
    /**
     * Причина смены телефона и инициатор запроса
     * @type {string}
     * @memberof TransferProfilePhoneRequest
     */
    'comment': string;
}
/**
 * 
 * @export
 * @interface UnassignFromOrderRequest
 */
export interface UnassignFromOrderRequest {
    /**
     * Идентификатор заказа
     * @type {string}
     * @memberof UnassignFromOrderRequest
     */
    'orderId'?: string;
    /**
     * Идентификатор Исполнителя
     * @type {string}
     * @memberof UnassignFromOrderRequest
     */
    'executorId'?: string;
}
/**
 * 
 * @export
 * @interface UnblockRequest
 */
export interface UnblockRequest {
    /**
     * Причина
     * @type {string}
     * @memberof UnblockRequest
     */
    'reason': string | null;
}
/**
 * 
 * @export
 * @interface UpdateAmmunitionRequest
 */
export interface UpdateAmmunitionRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateAmmunitionRequest
     */
    'title'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateAmmunitionRequest
     */
    'subTitle'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateAmmunitionRequest
     */
    'textContent'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateAmmunitionRequest
     */
    'imageUrl'?: string | null;
}
/**
 * 
 * @export
 * @interface UpdateAnswerRequest
 */
export interface UpdateAnswerRequest {
    /**
     * 
     * @type {number}
     * @memberof UpdateAnswerRequest
     */
    'id': number;
    /**
     * Id вопроса
     * @type {number}
     * @memberof UpdateAnswerRequest
     */
    'questionId'?: number | null;
    /**
     * Текст ответа
     * @type {string}
     * @memberof UpdateAnswerRequest
     */
    'text'?: string | null;
    /**
     * Правильный/неверный ответ
     * @type {boolean}
     * @memberof UpdateAnswerRequest
     */
    'isTrue'?: boolean | null;
}
/**
 * 
 * @export
 * @interface UpdateAppVersionRequest
 */
export interface UpdateAppVersionRequest {
    /**
     * Идентификатор приложения в магазине
     * @type {string}
     * @memberof UpdateAppVersionRequest
     */
    'appName'?: string | null;
    /**
     * 
     * @type {AppType}
     * @memberof UpdateAppVersionRequest
     */
    'appType'?: AppType;
    /**
     * Минимально поддерживаемая версия
     * @type {string}
     * @memberof UpdateAppVersionRequest
     */
    'minimumVersion'?: string | null;
    /**
     * Последняя версия приложения
     * @type {string}
     * @memberof UpdateAppVersionRequest
     */
    'latestVersion'?: string | null;
    /**
     * Ссылка на приложение в App Store
     * @type {string}
     * @memberof UpdateAppVersionRequest
     */
    'appStoreUrl'?: string | null;
    /**
     * Ссылка на приложение в Google Play
     * @type {string}
     * @memberof UpdateAppVersionRequest
     */
    'playMarketUrl'?: string | null;
    /**
     * 
     * @type {PlatformType}
     * @memberof UpdateAppVersionRequest
     */
    'platform'?: PlatformType;
    /**
     * Идентификатор версии приложения
     * @type {string}
     * @memberof UpdateAppVersionRequest
     */
    'id'?: string;
}


/**
 * 
 * @export
 * @interface UpdateBlogPostRequest
 */
export interface UpdateBlogPostRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateBlogPostRequest
     */
    'title'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateBlogPostRequest
     */
    'content'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateBlogPostRequest
     */
    'author'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateBlogPostRequest
     */
    'imageUrl'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateBlogPostRequest
     */
    'time'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateBlogPostRequest
     */
    'duration'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateBlogPostRequest
     */
    'isShowServices'?: boolean;
    /**
     * 
     * @type {ApiBlogPostAudience}
     * @memberof UpdateBlogPostRequest
     */
    'audience'?: ApiBlogPostAudience;
}


/**
 * 
 * @export
 * @interface UpdateClientAddressRequest
 */
export interface UpdateClientAddressRequest {
    /**
     * Идентификатор клиента
     * @type {string}
     * @memberof UpdateClientAddressRequest
     */
    'clientId'?: string;
    /**
     * 
     * @type {AddressRequest}
     * @memberof UpdateClientAddressRequest
     */
    'address'?: AddressRequest;
    /**
     * Идентификатор адреса, данные которого изменить
     * @type {string}
     * @memberof UpdateClientAddressRequest
     */
    'addressId'?: string;
}
/**
 * 
 * @export
 * @interface UpdateClientRequest
 */
export interface UpdateClientRequest {
    /**
     * Имя клиента
     * @type {string}
     * @memberof UpdateClientRequest
     */
    'firstName'?: string | null;
    /**
     * Идентификатор города проживания клиента
     * @type {number}
     * @memberof UpdateClientRequest
     */
    'cityId'?: number;
    /**
     * 
     * @type {ApiGender}
     * @memberof UpdateClientRequest
     */
    'gender'?: ApiGender;
    /**
     * url фотографии
     * @type {string}
     * @memberof UpdateClientRequest
     */
    'photoUrl'?: string | null;
    /**
     * Разрешены ли маркетинговые уведомления
     * @type {boolean}
     * @memberof UpdateClientRequest
     */
    'isAllowMarketingNotifications'?: boolean;
}


/**
 * Запрос изменения выданного абонемента
 * @export
 * @interface UpdateClientSubscriptionRequest
 */
export interface UpdateClientSubscriptionRequest {
    /**
     * Дата окончания подписки
     * @type {string}
     * @memberof UpdateClientSubscriptionRequest
     */
    'endDate'?: string;
    /**
     * Признак активного абонемента
     * @type {boolean}
     * @memberof UpdateClientSubscriptionRequest
     */
    'isActive'?: boolean;
    /**
     * Автопродление
     * @type {boolean}
     * @memberof UpdateClientSubscriptionRequest
     */
    'autorenewal'?: boolean;
    /**
     * Количество использований
     * @type {number}
     * @memberof UpdateClientSubscriptionRequest
     */
    'count'?: number;
    /**
     * Скидка на основной продукт
     * @type {number}
     * @memberof UpdateClientSubscriptionRequest
     */
    'baseDiscount'?: number;
}
/**
 * Изменение настроек фоновой задачи
 * @export
 * @interface UpdateCronJobRequest
 */
export interface UpdateCronJobRequest {
    /**
     * Версия настроек
     * @type {string}
     * @memberof UpdateCronJobRequest
     */
    'version'?: string;
    /**
     * Разрешение запусков
     * @type {boolean}
     * @memberof UpdateCronJobRequest
     */
    'isEnabled'?: boolean;
    /**
     * Расписание в UTC
     * @type {string}
     * @memberof UpdateCronJobRequest
     */
    'schedule'?: string | null;
    /**
     * Секундная точность расписания
     * @type {boolean}
     * @memberof UpdateCronJobRequest
     */
    'includeSeconds'?: boolean;
    /**
     * Контроль выполнения в Sentry
     * @type {boolean}
     * @memberof UpdateCronJobRequest
     */
    'sentryMonitorEnabled'?: boolean;
    /**
     * Допустимое опоздание запуска в минутах
     * @type {number}
     * @memberof UpdateCronJobRequest
     */
    'sentryCheckInMarginMinutes'?: number;
    /**
     * Допустимая длительность выполнения в минутах
     * @type {number}
     * @memberof UpdateCronJobRequest
     */
    'sentryMaxRuntimeMinutes'?: number;
    /**
     * Параметры обработчика
     * @type {{ [key: string]: string; }}
     * @memberof UpdateCronJobRequest
     */
    'parameters'?: { [key: string]: string; } | null;
}
/**
 * 
 * @export
 * @interface UpdateExecutorAccessTestRequest
 */
export interface UpdateExecutorAccessTestRequest {
    /**
     * 
     * @type {number}
     * @memberof UpdateExecutorAccessTestRequest
     */
    'id'?: number;
    /**
     * ID выгульщика
     * @type {string}
     * @memberof UpdateExecutorAccessTestRequest
     */
    'executorId'?: string | null;
    /**
     * ID теста
     * @type {number}
     * @memberof UpdateExecutorAccessTestRequest
     */
    'testId'?: number | null;
}
/**
 * 
 * @export
 * @interface UpdateExecutorAddressRequest
 */
export interface UpdateExecutorAddressRequest {
    /**
     * Идентификатор клиента
     * @type {string}
     * @memberof UpdateExecutorAddressRequest
     */
    'executorId'?: string;
    /**
     * 
     * @type {AddressRequest}
     * @memberof UpdateExecutorAddressRequest
     */
    'address'?: AddressRequest;
    /**
     * Идентификатор адреса, данные которого изменить
     * @type {string}
     * @memberof UpdateExecutorAddressRequest
     */
    'addressId'?: string;
}
/**
 * 
 * @export
 * @interface UpdateExecutorByAdminRequest
 */
export interface UpdateExecutorByAdminRequest {
    /**
     * Url Фотографии
     * @type {string}
     * @memberof UpdateExecutorByAdminRequest
     */
    'photoUrl'?: string | null;
    /**
     * Имя исполнителя
     * @type {string}
     * @memberof UpdateExecutorByAdminRequest
     */
    'name'?: string | null;
    /**
     * Фамилия
     * @type {string}
     * @memberof UpdateExecutorByAdminRequest
     */
    'lastName'?: string | null;
    /**
     * 
     * @type {ApiGender}
     * @memberof UpdateExecutorByAdminRequest
     */
    'gender'?: ApiGender;
    /**
     * Дата рождения
     * @type {string}
     * @memberof UpdateExecutorByAdminRequest
     */
    'birthDay'?: string;
    /**
     * Идентификатор гражданства
     * @type {number}
     * @memberof UpdateExecutorByAdminRequest
     */
    'citizenshipId'?: number;
    /**
     * Идентификатор города
     * @type {number}
     * @memberof UpdateExecutorByAdminRequest
     */
    'cityId'?: number;
    /**
     * Идентификатор опыта
     * @type {number}
     * @memberof UpdateExecutorByAdminRequest
     */
    'experienceId'?: number;
    /**
     * 
     * @type {SetAboutMyselfRequest}
     * @memberof UpdateExecutorByAdminRequest
     */
    'setAboutMyself'?: SetAboutMyselfRequest;
}


/**
 * Данные для обновления профиля исполнителя
 * @export
 * @interface UpdateExecutorRequest
 */
export interface UpdateExecutorRequest {
    /**
     * Url Фотографии
     * @type {string}
     * @memberof UpdateExecutorRequest
     */
    'photoUrl'?: string | null;
    /**
     * Имя исполнителя
     * @type {string}
     * @memberof UpdateExecutorRequest
     */
    'name'?: string | null;
    /**
     * Фамилия
     * @type {string}
     * @memberof UpdateExecutorRequest
     */
    'lastName'?: string | null;
    /**
     * 
     * @type {ApiGender}
     * @memberof UpdateExecutorRequest
     */
    'gender'?: ApiGender;
    /**
     * Дата рождения
     * @type {string}
     * @memberof UpdateExecutorRequest
     */
    'birthDay'?: string;
    /**
     * Идентификатор гражданства
     * @type {number}
     * @memberof UpdateExecutorRequest
     */
    'citizenshipId'?: number;
    /**
     * Идентификатор города
     * @type {number}
     * @memberof UpdateExecutorRequest
     */
    'cityId'?: number;
    /**
     * Идентификатор опыта
     * @type {number}
     * @memberof UpdateExecutorRequest
     */
    'experienceId'?: number;
    /**
     * Опыт работы с животными, null сохраняет прежнее значение
     * @type {string}
     * @memberof UpdateExecutorRequest
     * @deprecated
     */
    'experienceWithPets'?: string | null;
    /**
     * Деятельность, null сохраняет прежнее значение
     * @type {string}
     * @memberof UpdateExecutorRequest
     * @deprecated
     */
    'activity'?: string | null;
    /**
     * Хобби, null сохраняет прежнее значение
     * @type {string}
     * @memberof UpdateExecutorRequest
     * @deprecated
     */
    'hobby'?: string | null;
    /**
     * Цели, null сохраняет прежнее значение
     * @type {string}
     * @memberof UpdateExecutorRequest
     * @deprecated
     */
    'targets'?: string | null;
    /**
     * Собственные животные, null сохраняет прежнее значение
     * @type {string}
     * @memberof UpdateExecutorRequest
     * @deprecated
     */
    'doYouHavePets'?: string | null;
    /**
     * Предпочитаемые районы для работы
     * @type {Array<number>}
     * @memberof UpdateExecutorRequest
     */
    'preferredCityDistrictIds'?: Array<number> | null;
    /**
     * Разрешены ли маркетинговые уведомления
     * @type {boolean}
     * @memberof UpdateExecutorRequest
     */
    'isAllowMarketingNotifications'?: boolean;
}


/**
 * Запрос обновления функционального переключателя
 * @export
 * @interface UpdateFeatureToggleRequest
 */
export interface UpdateFeatureToggleRequest {
    /**
     * 
     * @type {ApiFeatureToggleType}
     * @memberof UpdateFeatureToggleRequest
     */
    'type'?: ApiFeatureToggleType;
    /**
     * Наименование функционального переключателя
     * @type {string}
     * @memberof UpdateFeatureToggleRequest
     */
    'name'?: string | null;
    /**
     * Включен ли функциональный переключатель
     * @type {boolean}
     * @memberof UpdateFeatureToggleRequest
     */
    'isEnabled'?: boolean;
    /**
     * Идентификатор функционального переключателя
     * @type {string}
     * @memberof UpdateFeatureToggleRequest
     */
    'id'?: string;
}


/**
 * 
 * @export
 * @interface UpdateLessonRequest
 */
export interface UpdateLessonRequest {
    /**
     * 
     * @type {number}
     * @memberof UpdateLessonRequest
     */
    'id'?: number;
    /**
     * 
     * @type {ApiPetType}
     * @memberof UpdateLessonRequest
     */
    'petType'?: ApiPetType;
    /**
     * Заголовок
     * @type {string}
     * @memberof UpdateLessonRequest
     */
    'title'?: string | null;
    /**
     * Название
     * @type {string}
     * @memberof UpdateLessonRequest
     */
    'name'?: string | null;
    /**
     * Описание
     * @type {string}
     * @memberof UpdateLessonRequest
     */
    'description'?: string | null;
    /**
     * Путь до видео урока
     * @type {string}
     * @memberof UpdateLessonRequest
     */
    'videoUrl'?: string | null;
    /**
     * Картинка для карточки
     * @type {string}
     * @memberof UpdateLessonRequest
     */
    'imageUrl'?: string | null;
    /**
     * Порядковый номер урока
     * @type {number}
     * @memberof UpdateLessonRequest
     */
    'indexNumber'?: number | null;
    /**
     * Время на обучение
     * @type {string}
     * @memberof UpdateLessonRequest
     */
    'timeToStudy'?: string | null;
}


/**
 * 
 * @export
 * @interface UpdateLocationRequest
 */
export interface UpdateLocationRequest {
    /**
     * Идентификатор исполнителя
     * @type {string}
     * @memberof UpdateLocationRequest
     */
    'executorId'?: string;
    /**
     * Широта
     * @type {number}
     * @memberof UpdateLocationRequest
     */
    'latitude'?: number;
    /**
     * Долгота
     * @type {number}
     * @memberof UpdateLocationRequest
     */
    'longitude'?: number;
    /**
     * Дата-время обновления локации
     * @type {string}
     * @memberof UpdateLocationRequest
     */
    'updated'?: string;
}
/**
 * Изменение файла
 * @export
 * @interface UpdateMediaAssetRequest
 */
export interface UpdateMediaAssetRequest {
    /**
     * Название файла
     * @type {string}
     * @memberof UpdateMediaAssetRequest
     */
    'name'?: string | null;
    /**
     * Папка каталога
     * @type {string}
     * @memberof UpdateMediaAssetRequest
     */
    'folderId'?: string | null;
    /**
     * Теги файла
     * @type {Array<string>}
     * @memberof UpdateMediaAssetRequest
     */
    'tags'?: Array<string> | null;
    /**
     * Версия записи
     * @type {string}
     * @memberof UpdateMediaAssetRequest
     */
    'version'?: string;
}
/**
 * Изменение сообщения пользователя
 * @export
 * @interface UpdateMessageDialogRequest
 */
export interface UpdateMessageDialogRequest {
    /**
     * Маршрут показа диалога
     * @type {string}
     * @memberof UpdateMessageDialogRequest
     */
    'routeName'?: string | null;
    /**
     * Объект на маршруте показа
     * @type {string}
     * @memberof UpdateMessageDialogRequest
     */
    'routeEntityId'?: string | null;
    /**
     * Время доступности сообщения
     * @type {string}
     * @memberof UpdateMessageDialogRequest
     */
    'activeFrom'?: string | null;
    /**
     * 
     * @type {ApiDialogActionType}
     * @memberof UpdateMessageDialogRequest
     */
    'action'?: ApiDialogActionType;
    /**
     * Заголовок сообщения
     * @type {string}
     * @memberof UpdateMessageDialogRequest
     */
    'title'?: string | null;
    /**
     * Текст сообщения
     * @type {string}
     * @memberof UpdateMessageDialogRequest
     */
    'text'?: string | null;
    /**
     * Варианты ответа
     * @type {Array<DialogOptionResponse>}
     * @memberof UpdateMessageDialogRequest
     */
    'options'?: Array<DialogOptionResponse> | null;
    /**
     * Срок действия сообщения
     * @type {string}
     * @memberof UpdateMessageDialogRequest
     */
    'expiresAt'?: string | null;
}


/**
 * Изменение текстовки приложения
 * @export
 * @interface UpdateMessageTemplateRequest
 */
export interface UpdateMessageTemplateRequest {
    /**
     * 
     * @type {ApiMessageTemplateGroup}
     * @memberof UpdateMessageTemplateRequest
     */
    'group'?: ApiMessageTemplateGroup;
    /**
     * Текст сообщения
     * @type {string}
     * @memberof UpdateMessageTemplateRequest
     */
    'text'?: string | null;
    /**
     * Пояснение места использования
     * @type {string}
     * @memberof UpdateMessageTemplateRequest
     */
    'description'?: string | null;
    /**
     * Версия текстовки
     * @type {string}
     * @memberof UpdateMessageTemplateRequest
     */
    'version'?: string;
}


/**
 * Результат проверки системного разрешения уведомлений
 * @export
 * @interface UpdateNotificationPermissionRequest
 */
export interface UpdateNotificationPermissionRequest {
    /**
     * 
     * @type {ApiNotificationPermissionStatus}
     * @memberof UpdateNotificationPermissionRequest
     */
    'status'?: ApiNotificationPermissionStatus;
}


/**
 * Изменение шаблона пуш-уведомления
 * @export
 * @interface UpdateNotificationTemplateRequest
 */
export interface UpdateNotificationTemplateRequest {
    /**
     * 
     * @type {ApiNotificationTemplateAudience}
     * @memberof UpdateNotificationTemplateRequest
     */
    'audience'?: ApiNotificationTemplateAudience;
    /**
     * Идентификатор назначения перехода или отсутствие перехода
     * @type {string}
     * @memberof UpdateNotificationTemplateRequest
     */
    'navigationTargetId'?: string | null;
    /**
     * Путь из списка поддерживаемых маршрутов
     * @type {string}
     * @memberof UpdateNotificationTemplateRequest
     */
    'navigationPathTemplate'?: string | null;
    /**
     * Требуется ли ID сущности
     * @type {boolean}
     * @memberof UpdateNotificationTemplateRequest
     */
    'navigationRequiresEntityId'?: boolean | null;
    /**
     * Тип сущности: заказ, чат или статья
     * @type {number}
     * @memberof UpdateNotificationTemplateRequest
     */
    'navigationEntityType'?: number | null;
    /**
     * Доступность в приложении клиента
     * @type {boolean}
     * @memberof UpdateNotificationTemplateRequest
     */
    'navigationClientSupported'?: boolean | null;
    /**
     * Доступность в приложении исполнителя
     * @type {boolean}
     * @memberof UpdateNotificationTemplateRequest
     */
    'navigationExecutorSupported'?: boolean | null;
    /**
     * Наименование шаблона пуш-уведомления
     * @type {string}
     * @memberof UpdateNotificationTemplateRequest
     */
    'name'?: string | null;
    /**
     * Описание условий отправки шаблона
     * @type {string}
     * @memberof UpdateNotificationTemplateRequest
     */
    'description'?: string | null;
    /**
     * Заголовок пуш-уведомления
     * @type {string}
     * @memberof UpdateNotificationTemplateRequest
     */
    'title'?: string | null;
    /**
     * Текст пуш-уведомления
     * @type {string}
     * @memberof UpdateNotificationTemplateRequest
     */
    'body'?: string | null;
}


/**
 * Запрос изменения задачи
 * @export
 * @interface UpdateOperatorTaskRequest
 */
export interface UpdateOperatorTaskRequest {
    /**
     * Название и описание задачи
     * @type {string}
     * @memberof UpdateOperatorTaskRequest
     */
    'text'?: string | null;
    /**
     * 
     * @type {ApiOperatorTaskType}
     * @memberof UpdateOperatorTaskRequest
     */
    'type'?: ApiOperatorTaskType;
    /**
     * Срок выполнения
     * @type {string}
     * @memberof UpdateOperatorTaskRequest
     */
    'dueAtUtc'?: string | null;
    /**
     * 
     * @type {OperatorTaskAssigneeRequest}
     * @memberof UpdateOperatorTaskRequest
     */
    'assignee'?: OperatorTaskAssigneeRequest;
    /**
     * 
     * @type {OperatorTaskContextRequest}
     * @memberof UpdateOperatorTaskRequest
     */
    'context'?: OperatorTaskContextRequest;
    /**
     * 
     * @type {OperatorTaskReminderSettingsRequest}
     * @memberof UpdateOperatorTaskRequest
     */
    'reminders'?: OperatorTaskReminderSettingsRequest;
    /**
     * Версия задачи
     * @type {string}
     * @memberof UpdateOperatorTaskRequest
     */
    'version'?: string;
}


/**
 * 
 * @export
 * @interface UpdateOrderRequest
 */
export interface UpdateOrderRequest {
    /**
     * Идентификатор клиента
     * @type {string}
     * @memberof UpdateOrderRequest
     */
    'clientId'?: string | null;
    /**
     * 
     * @type {ApiPetType}
     * @memberof UpdateOrderRequest
     */
    'petType'?: ApiPetType;
    /**
     * 
     * @type {ApiProductType}
     * @memberof UpdateOrderRequest
     */
    'productType'?: ApiProductType;
    /**
     * Идентификатор абонемента клиента для оплаты заказа
     * @type {string}
     * @memberof UpdateOrderRequest
     */
    'clientSubscriptionId'?: string | null;
    /**
     * 
     * @type {SetSchedulePeriodRequest}
     * @memberof UpdateOrderRequest
     */
    'schedulePeriod'?: SetSchedulePeriodRequest;
    /**
     * Идентификатор Адреса, который принадлежит Клиенту
     * @type {string}
     * @memberof UpdateOrderRequest
     */
    'clientAddressId'?: string | null;
    /**
     * Идентификаторы питомцев
     * @type {Array<string>}
     * @memberof UpdateOrderRequest
     */
    'petIds'?: Array<string> | null;
    /**
     * Идентификаторы доп. продуктов
     * @type {Array<string>}
     * @memberof UpdateOrderRequest
     */
    'additionalProductIds'?: Array<string> | null;
    /**
     * Идентификатор адреса специалиста
     * @type {string}
     * @memberof UpdateOrderRequest
     */
    'specialistAddressId'?: string | null;
    /**
     * 
     * @type {ApiSpecialistType}
     * @memberof UpdateOrderRequest
     */
    'specialistType'?: ApiSpecialistType;
    /**
     * 
     * @type {ApiPetPlacement}
     * @memberof UpdateOrderRequest
     */
    'petPlacement'?: ApiPetPlacement;
    /**
     * 
     * @type {ApiWhoWillBringPet}
     * @memberof UpdateOrderRequest
     */
    'whoWillBringPet'?: ApiWhoWillBringPet;
    /**
     * Нужно ли отработать команды (активировать выполнение команд)
     * @type {boolean}
     * @memberof UpdateOrderRequest
     */
    'isActiveCommand'?: boolean | null;
    /**
     * Описание команд, которые нужно отработать
     * @type {string}
     * @memberof UpdateOrderRequest
     */
    'commandsDescription'?: string | null;
    /**
     * Комментарии к заказу
     * @type {string}
     * @memberof UpdateOrderRequest
     */
    'comments'?: string | null;
    /**
     * Описание (например, как попасть в квартиру и т.п.)
     * @type {string}
     * @memberof UpdateOrderRequest
     */
    'description'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateOrderRequest
     */
    'orderId'?: string;
}


/**
 * 
 * @export
 * @interface UpdatePayoutMethodRequest
 */
export interface UpdatePayoutMethodRequest {
    /**
     * Если СБП то только  номер тлф
     * @type {string}
     * @memberof UpdatePayoutMethodRequest
     */
    'phone'?: string | null;
    /**
     * Номер карты
     * @type {string}
     * @memberof UpdatePayoutMethodRequest
     */
    'cardNumber'?: string | null;
    /**
     * Расчетный счет 20 цифр
     * @type {string}
     * @memberof UpdatePayoutMethodRequest
     */
    'bankAccount'?: string | null;
    /**
     * БИК Банка 9 цифр
     * @type {string}
     * @memberof UpdatePayoutMethodRequest
     */
    'bik'?: string | null;
    /**
     * 
     * @type {ApiPayoutMethodType}
     * @memberof UpdatePayoutMethodRequest
     */
    'type'?: ApiPayoutMethodType;
    /**
     * Показывает активный способ оплаты
     * @type {boolean}
     * @memberof UpdatePayoutMethodRequest
     */
    'isActive'?: boolean;
    /**
     * Уникальный идентификатор исполнителя, связанного с этой картой.
     * @type {string}
     * @memberof UpdatePayoutMethodRequest
     */
    'executorId'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdatePayoutMethodRequest
     */
    'id'?: string;
}


/**
 * 
 * @export
 * @interface UpdatePetRequest
 */
export interface UpdatePetRequest {
    /**
     * Имя-Кличка
     * @type {string}
     * @memberof UpdatePetRequest
     */
    'name': string | null;
    /**
     * Порода
     * @type {string}
     * @memberof UpdatePetRequest
     */
    'breed': string | null;
    /**
     * Возраст
     * @type {string}
     * @memberof UpdatePetRequest
     */
    'age': string | null;
    /**
     * Детали (о чем еще стоит знать)
     * @type {string}
     * @memberof UpdatePetRequest
     */
    'details'?: string | null;
    /**
     * Цвет
     * @type {string}
     * @memberof UpdatePetRequest
     */
    'color'?: string | null;
    /**
     * Вес
     * @type {number}
     * @memberof UpdatePetRequest
     */
    'weight': number | null;
    /**
     * Рост
     * @type {number}
     * @memberof UpdatePetRequest
     */
    'height'?: number | null;
    /**
     * Владелец
     * @type {string}
     * @memberof UpdatePetRequest
     */
    'clientId': string | null;
    /**
     * Фото
     * @type {string}
     * @memberof UpdatePetRequest
     */
    'image'?: string | null;
    /**
     * 
     * @type {ApiPetType}
     * @memberof UpdatePetRequest
     */
    'type': ApiPetType;
    /**
     * 
     * @type {ApiGender}
     * @memberof UpdatePetRequest
     */
    'gender': ApiGender;
    /**
     * Есть ли Статус вакцинации
     * @type {boolean}
     * @memberof UpdatePetRequest
     */
    'vaccinationStatus'?: boolean | null;
    /**
     * Есть ли аллергия
     * @type {boolean}
     * @memberof UpdatePetRequest
     */
    'allergyStatus'?: boolean | null;
    /**
     * Описание аллергии
     * @type {string}
     * @memberof UpdatePetRequest
     */
    'allergyDescription'?: string | null;
    /**
     * Есть ли Статусы болезни
     * @type {boolean}
     * @memberof UpdatePetRequest
     */
    'diseaseStatus'?: boolean | null;
    /**
     * Описание болезни
     * @type {string}
     * @memberof UpdatePetRequest
     */
    'diseaseDescription'?: string | null;
    /**
     * Есть ли Хронические болезни
     * @type {boolean}
     * @memberof UpdatePetRequest
     */
    'chronicDiseaseStatus'?: boolean | null;
    /**
     * Описание хронических болезней
     * @type {string}
     * @memberof UpdatePetRequest
     */
    'chronicDiseaseDescription'?: string | null;
    /**
     * Есть ли Кастрация
     * @type {boolean}
     * @memberof UpdatePetRequest
     */
    'neuteredStatus'?: boolean | null;
    /**
     * Описание о кастрации
     * @type {string}
     * @memberof UpdatePetRequest
     */
    'neuteredDescription'?: string | null;
    /**
     * Есть ли Прочие операции
     * @type {boolean}
     * @memberof UpdatePetRequest
     */
    'otherOperationsStatus'?: boolean | null;
    /**
     * Описание прочих операций
     * @type {string}
     * @memberof UpdatePetRequest
     */
    'otherOperationsDescription'?: string | null;
    /**
     * Есть ли Статус страхов
     * @type {boolean}
     * @memberof UpdatePetRequest
     */
    'fearsStatus'?: boolean | null;
    /**
     * Описание страхов
     * @type {string}
     * @memberof UpdatePetRequest
     */
    'fearsDescription'?: string | null;
    /**
     * Есть ли травмы
     * @type {boolean}
     * @memberof UpdatePetRequest
     */
    'injuryStatus'?: boolean | null;
    /**
     * Описание травм
     * @type {string}
     * @memberof UpdatePetRequest
     */
    'injuryDescription'?: string | null;
    /**
     * График кормления
     * @type {string}
     * @memberof UpdatePetRequest
     */
    'feedingRegime'?: string | null;
    /**
     * Чем любит заниматься дома
     * @type {string}
     * @memberof UpdatePetRequest
     */
    'classesAtHome'?: string | null;
    /**
     * Условия пребывания питомца одного дома
     * @type {string}
     * @memberof UpdatePetRequest
     */
    'canBeLeftAloneAtHomeDescription'?: string | null;
    /**
     * Чем любит заниматься на улице
     * @type {string}
     * @memberof UpdatePetRequest
     */
    'classesOnTheStreet'?: string | null;
    /**
     * О чем ещё нам стоит знать (Дома)
     * @type {string}
     * @memberof UpdatePetRequest
     */
    'additionalCommentsAtHome'?: string | null;
    /**
     * О чем ещё нам стоит знать (На Улицы)
     * @type {string}
     * @memberof UpdatePetRequest
     */
    'additionalCommentsOnTheStreet'?: string | null;
    /**
     * График прогулок
     * @type {string}
     * @memberof UpdatePetRequest
     */
    'walkingSchedule'?: string | null;
    /**
     * Важно ли чтобы питомец находился один на передержке
     * @type {boolean}
     * @memberof UpdatePetRequest
     */
    'isImportantAloneInBoarding'?: boolean | null;
    /**
     * Другие вредные привычки, о которых стоит знать
     * @type {string}
     * @memberof UpdatePetRequest
     */
    'anotherBadHabitsDescription'?: string | null;
    /**
     * Идентификаторы привычек
     * @type {Array<string>}
     * @memberof UpdatePetRequest
     */
    'habitIds'?: Array<string> | null;
    /**
     * Идентификатор питомца
     * @type {string}
     * @memberof UpdatePetRequest
     */
    'id'?: string;
}


/**
 * 
 * @export
 * @interface UpdatePolicyRequest
 */
export interface UpdatePolicyRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdatePolicyRequest
     */
    'content'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdatePolicyRequest
     */
    'title'?: string | null;
    /**
     * 
     * @type {ApiPolicyAudience}
     * @memberof UpdatePolicyRequest
     */
    'audience'?: ApiPolicyAudience;
    /**
     * 
     * @type {ApiPolicyType}
     * @memberof UpdatePolicyRequest
     */
    'type'?: ApiPolicyType;
    /**
     * Показывать в приложении
     * @type {boolean}
     * @memberof UpdatePolicyRequest
     */
    'isShowServices'?: boolean;
}


/**
 * 
 * @export
 * @interface UpdatePriceListRequest
 */
export interface UpdatePriceListRequest {
    /**
     * Ночная надбавка
     * @type {number}
     * @memberof UpdatePriceListRequest
     */
    'nightSurcharge'?: number;
    /**
     * Вознаграждение за ночную надбавку
     * @type {number}
     * @memberof UpdatePriceListRequest
     */
    'nightSurchargeExecutorReward'?: number;
    /**
     * Наименование
     * @type {string}
     * @memberof UpdatePriceListRequest
     */
    'name'?: string | null;
    /**
     * Идентификатор города
     * @type {number}
     * @memberof UpdatePriceListRequest
     */
    'cityId'?: number | null;
    /**
     * Вознаграждение исполнителю
     * @type {number}
     * @memberof UpdatePriceListRequest
     */
    'executorReward'?: number | null;
    /**
     * Цена продукта
     * @type {number}
     * @memberof UpdatePriceListRequest
     */
    'price'?: number | null;
    /**
     * Идентификатор продукта
     * @type {string}
     * @memberof UpdatePriceListRequest
     */
    'productId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdatePriceListRequest
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdatePriceListRequest
     */
    'comment'?: string | null;
}
/**
 * Данные изменения продукта
 * @export
 * @interface UpdateProductRequest
 */
export interface UpdateProductRequest {
    /**
     * Уровни скидки за длительную передержку
     * @type {Array<ProductBoardingDiscountTierModel>}
     * @memberof UpdateProductRequest
     */
    'boardingDiscountTiers'?: Array<ProductBoardingDiscountTierModel> | null;
    /**
     * Ночная надбавка
     * @type {number}
     * @memberof UpdateProductRequest
     */
    'nightSurcharge'?: number;
    /**
     * Вознаграждение за ночную надбавку
     * @type {number}
     * @memberof UpdateProductRequest
     */
    'nightSurchargeExecutorReward'?: number;
    /**
     * Наименование продукта
     * @type {string}
     * @memberof UpdateProductRequest
     */
    'name'?: string | null;
    /**
     * Цена услуги
     * @type {number}
     * @memberof UpdateProductRequest
     */
    'price'?: number | null;
    /**
     * Базовая скидка продукта
     * @type {number}
     * @memberof UpdateProductRequest
     */
    'discount'?: number;
    /**
     * Разрешено списание бонусов при оплате продукта
     * @type {boolean}
     * @memberof UpdateProductRequest
     */
    'isBonusWriteOffAllowed'?: boolean;
    /**
     * Разрешено начисление бонусов за продукт
     * @type {boolean}
     * @memberof UpdateProductRequest
     */
    'isBonusAccrualAllowed'?: boolean;
    /**
     * Вознаграждение исполнителю
     * @type {number}
     * @memberof UpdateProductRequest
     */
    'executorReward'?: number | null;
    /**
     * Массив дополнительных услуг (например, \"помыть лапы\", \"накормить\", \"поменять воду\") //TODO: Пока будет в этой модели
     * @type {Array<string>}
     * @memberof UpdateProductRequest
     */
    'serviceType'?: Array<string> | null;
    /**
     * Визуальное наименование продукта
     * @type {string}
     * @memberof UpdateProductRequest
     */
    'displayName'?: string | null;
    /**
     * Описание продукта
     * @type {string}
     * @memberof UpdateProductRequest
     */
    'description'?: string | null;
    /**
     * Полное описание продукта
     * @type {string}
     * @memberof UpdateProductRequest
     * @deprecated
     */
    'fullDescription'?: string | null;
    /**
     * Блоки для карусели с информацией о продукте
     * @type {Array<string>}
     * @memberof UpdateProductRequest
     */
    'infoBlocks'?: Array<string> | null;
    /**
     * Описание продукта для Исполнителя
     * @type {string}
     * @memberof UpdateProductRequest
     */
    'descriptionForExecutor'?: string | null;
    /**
     * Идентификатор продукта
     * @type {string}
     * @memberof UpdateProductRequest
     */
    'id'?: string;
}
/**
 * 
 * @export
 * @interface UpdatePromoCodeRequest
 */
export interface UpdatePromoCodeRequest {
    /**
     * Номер промокода
     * @type {string}
     * @memberof UpdatePromoCodeRequest
     */
    'number'?: string | null;
    /**
     * Ручной номер промокода
     * @type {boolean}
     * @memberof UpdatePromoCodeRequest
     */
    'isCustomNumber'?: boolean;
    /**
     * Значение скидки (руб. / %)
     * @type {number}
     * @memberof UpdatePromoCodeRequest
     */
    'discount'?: number | null;
    /**
     * 
     * @type {ApiPromoCodeType}
     * @memberof UpdatePromoCodeRequest
     */
    'type'?: ApiPromoCodeType;
    /**
     * Лимит скидки
     * @type {number}
     * @memberof UpdatePromoCodeRequest
     */
    'limit'?: number | null;
    /**
     * Дата истечения промокода
     * @type {string}
     * @memberof UpdatePromoCodeRequest
     */
    'expirationDate'?: string | null;
    /**
     * Срок действия после активации в днях
     * @type {number}
     * @memberof UpdatePromoCodeRequest
     */
    'activeDurationDays'?: number | null;
    /**
     * Общий лимит использований промокода
     * @type {number}
     * @memberof UpdatePromoCodeRequest
     */
    'limitTransactions'?: number | null;
    /**
     * Лимит использований промокода одним клиентом
     * @type {number}
     * @memberof UpdatePromoCodeRequest
     */
    'clientTransactionLimit'?: number | null;
    /**
     * Крайний срок активации промокода
     * @type {string}
     * @memberof UpdatePromoCodeRequest
     */
    'activateBefore'?: string | null;
    /**
     * Идентификатор промокода
     * @type {string}
     * @memberof UpdatePromoCodeRequest
     */
    'id': string;
}


/**
 * 
 * @export
 * @interface UpdateQuestionRequest
 */
export interface UpdateQuestionRequest {
    /**
     * 
     * @type {number}
     * @memberof UpdateQuestionRequest
     */
    'id'?: number;
    /**
     * ID теста
     * @type {number}
     * @memberof UpdateQuestionRequest
     */
    'testId'?: number | null;
    /**
     * Текст вопроса
     * @type {string}
     * @memberof UpdateQuestionRequest
     */
    'title'?: string | null;
    /**
     * Активен ли
     * @type {number}
     * @memberof UpdateQuestionRequest
     */
    'index'?: number | null;
}
/**
 * 
 * @export
 * @interface UpdateReviewRequest
 */
export interface UpdateReviewRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateReviewRequest
     */
    'description'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateReviewRequest
     */
    'executorId'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateReviewRequest
     */
    'orderId'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateReviewRequest
     */
    'clientId'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof UpdateReviewRequest
     */
    'mark'?: number;
}
/**
 * 
 * @export
 * @interface UpdateSubscriptionRequest
 */
export interface UpdateSubscriptionRequest {
    /**
     * Название абонемента
     * @type {string}
     * @memberof UpdateSubscriptionRequest
     */
    'name'?: string | null;
    /**
     * Описание абонемента
     * @type {string}
     * @memberof UpdateSubscriptionRequest
     */
    'description'?: string | null;
    /**
     * Заголовок абонемента
     * @type {string}
     * @memberof UpdateSubscriptionRequest
     */
    'title'?: string | null;
    /**
     * Подзаголовок абонемента
     * @type {string}
     * @memberof UpdateSubscriptionRequest
     */
    'subtitle'?: string | null;
    /**
     * Срок действия (указывается в днях)
     * @type {number}
     * @memberof UpdateSubscriptionRequest
     */
    'durationDays'?: number;
    /**
     * Скидка на основной продукт
     * @type {number}
     * @memberof UpdateSubscriptionRequest
     */
    'baseDiscount'?: number;
    /**
     * Цвет фона для UI
     * @type {string}
     * @memberof UpdateSubscriptionRequest
     */
    'backgroundColor'?: string | null;
    /**
     * Время планирования (например, \"до 12 прогулок в месяц\")
     * @type {string}
     * @memberof UpdateSubscriptionRequest
     */
    'planningTime'?: string | null;
    /**
     * Количество использований абонемента
     * @type {number}
     * @memberof UpdateSubscriptionRequest
     */
    'numberOfUsesCount'?: number;
    /**
     * Доступен в продаже
     * @type {boolean}
     * @memberof UpdateSubscriptionRequest
     */
    'isActive'?: boolean;
    /**
     * Второй питомец включён в одно использование абонемента
     * @type {boolean}
     * @memberof UpdateSubscriptionRequest
     */
    'isSecondPetIncluded'?: boolean | null;
    /**
     * Ночная надбавка включена в абонемент
     * @type {boolean}
     * @memberof UpdateSubscriptionRequest
     */
    'isNightSurchargeIncluded'?: boolean | null;
    /**
     * Идентификаторы дополнительных продуктов абонемента
     * @type {Array<string>}
     * @memberof UpdateSubscriptionRequest
     */
    'additionalProductIds'?: Array<string> | null;
}
/**
 * Запрос обновления тега
 * @export
 * @interface UpdateTagRequest
 */
export interface UpdateTagRequest {
    /**
     * Идентификатор тега
     * @type {string}
     * @memberof UpdateTagRequest
     */
    'id'?: string;
    /**
     * Значение тега
     * @type {string}
     * @memberof UpdateTagRequest
     */
    'value'?: string | null;
}
/**
 * 
 * @export
 * @interface UpdateTestRequest
 */
export interface UpdateTestRequest {
    /**
     * 
     * @type {number}
     * @memberof UpdateTestRequest
     */
    'id'?: number;
    /**
     * Идентификатор урока
     * @type {number}
     * @memberof UpdateTestRequest
     */
    'lessonId'?: number | null;
    /**
     * Индекс теста
     * @type {number}
     * @memberof UpdateTestRequest
     */
    'index'?: number | null;
}
/**
 * 
 * @export
 * @interface UpdateTestResponse
 */
export interface UpdateTestResponse {
    /**
     * 
     * @type {number}
     * @memberof UpdateTestResponse
     */
    'id'?: number;
    /**
     * Идентификатор урока
     * @type {number}
     * @memberof UpdateTestResponse
     */
    'lessonId'?: number;
    /**
     * Индекс теста
     * @type {number}
     * @memberof UpdateTestResponse
     */
    'index'?: number;
}
/**
 * Изменение документа раздела настроек
 * @export
 * @interface UpdateVoxSettingRequest
 */
export interface UpdateVoxSettingRequest {
    /**
     * 
     * @type {ApiSettingType}
     * @memberof UpdateVoxSettingRequest
     */
    'type'?: ApiSettingType;
    /**
     * Общая версия документа
     * @type {string}
     * @memberof UpdateVoxSettingRequest
     */
    'version'?: string;
    /**
     * Полный набор параметров раздела
     * @type {Array<SettingValue>}
     * @memberof UpdateVoxSettingRequest
     */
    'settings'?: Array<SettingValue> | null;
}


/**
 * Питомец пользователя
 * @export
 * @interface UserPetResponse
 */
export interface UserPetResponse {
    /**
     * Идентификатор питомца
     * @type {string}
     * @memberof UserPetResponse
     */
    'petId'?: string;
    /**
     * 
     * @type {ApiPetTypeSimpleModel}
     * @memberof UserPetResponse
     */
    'petType'?: ApiPetTypeSimpleModel;
    /**
     * Имя питомца
     * @type {string}
     * @memberof UserPetResponse
     */
    'name'?: string | null;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const UserRole = {
    Undefined: 'undefined',
    Client: 'client',
    Executor: 'executor',
    Admin: 'admin',
    TechnicalSupport: 'technicalSupport',
    Marketer: 'marketer',
    Recruiter: 'recruiter',
    AiAssistant: 'aiAssistant',
    Developer: 'developer',
    RocketWork: 'rocketWork',
    SuperAdmin: 'superAdmin',
    Custom: 'custom'
} as const;

export type UserRole = typeof UserRole[keyof typeof UserRole];


/**
 * 
 * @export
 * @interface VerificationMessageResponse
 */
export interface VerificationMessageResponse {
    /**
     * Признак: Новый пользователь
     * @type {boolean}
     * @memberof VerificationMessageResponse
     */
    'isNewUser'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof VerificationMessageResponse
     */
    'errors'?: boolean;
    /**
     * 
     * @type {Array<BaseMessageItem>}
     * @memberof VerificationMessageResponse
     */
    'items'?: Array<BaseMessageItem> | null;
    /**
     * Время, когда можно совершить ещё одну попытку авторизации
     * @type {string}
     * @memberof VerificationMessageResponse
     */
    'expiresAt'?: string;
    /**
     * Секунд до повторного звонка
     * @type {number}
     * @memberof VerificationMessageResponse
     */
    'secondsBefore'?: number;
}
/**
 * Проверенные координаты дома
 * @export
 * @interface VerifyAddressPointRequest
 */
export interface VerifyAddressPointRequest {
    /**
     * Широта
     * @type {number}
     * @memberof VerifyAddressPointRequest
     */
    'latitude'?: number | null;
    /**
     * Долгота
     * @type {number}
     * @memberof VerifyAddressPointRequest
     */
    'longitude'?: number | null;
    /**
     * Версия координат
     * @type {string}
     * @memberof VerifyAddressPointRequest
     */
    'version'?: string;
}
/**
 * 
 * @export
 * @interface VersionCheckRequest
 */
export interface VersionCheckRequest {
    /**
     * 
     * @type {AppType}
     * @memberof VersionCheckRequest
     */
    'appType': AppType;
    /**
     * Главная версия
     * @type {number}
     * @memberof VersionCheckRequest
     */
    'majorVersion'?: number;
    /**
     * Минорная версия
     * @type {number}
     * @memberof VersionCheckRequest
     */
    'minorVersion'?: number;
    /**
     * Версия патча
     * @type {number}
     * @memberof VersionCheckRequest
     */
    'patchVersion'?: number;
    /**
     * 
     * @type {PlatformType}
     * @memberof VersionCheckRequest
     */
    'platform'?: PlatformType;
}


/**
 * 
 * @export
 * @interface VersionCheckResponse
 */
export interface VersionCheckResponse {
    /**
     * True - Обязательно к обновлению
     * @type {boolean}
     * @memberof VersionCheckResponse
     */
    'isUpdateRequired'?: boolean;
    /**
     * Есть новая версия, но необязательная к обновлению
     * @type {boolean}
     * @memberof VersionCheckResponse
     */
    'isUpdateAvailable'?: boolean;
    /**
     * Минимальная обязательная версия
     * @type {string}
     * @memberof VersionCheckResponse
     */
    'minimumVersion'?: string | null;
    /**
     * Последняя версия
     * @type {string}
     * @memberof VersionCheckResponse
     */
    'latestVersion'?: string | null;
    /**
     * Ссылка на платформу(store) чтобы обнвоить
     * @type {string}
     * @memberof VersionCheckResponse
     */
    'storeUrl'?: string | null;
}
/**
 * 
 * @export
 * @interface VisualModel
 */
export interface VisualModel {
    /**
     * Визуальное наименование продукта
     * @type {string}
     * @memberof VisualModel
     */
    'displayName'?: string | null;
    /**
     * Описание продукта
     * @type {string}
     * @memberof VisualModel
     */
    'description'?: string | null;
    /**
     * Полное описание продукта
     * @type {string}
     * @memberof VisualModel
     * @deprecated
     */
    'fullDescription'?: string | null;
    /**
     * Блоки для карусели с информацией о продукте
     * @type {Array<string>}
     * @memberof VisualModel
     */
    'infoBlocks'?: Array<string> | null;
    /**
     * Описание продукта для Исполнителя
     * @type {string}
     * @memberof VisualModel
     */
    'descriptionForExecutor'?: string | null;
}
/**
 * 
 * @export
 * @interface VkCallbackObject
 */
export interface VkCallbackObject {
    /**
     * 
     * @type {VkMessage}
     * @memberof VkCallbackObject
     */
    'message'?: VkMessage;
}
/**
 * 
 * @export
 * @interface VkCallbackRequest
 */
export interface VkCallbackRequest {
    /**
     * 
     * @type {string}
     * @memberof VkCallbackRequest
     */
    'type': string | null;
    /**
     * 
     * @type {VkCallbackObject}
     * @memberof VkCallbackRequest
     */
    'object'?: VkCallbackObject;
    /**
     * 
     * @type {string}
     * @memberof VkCallbackRequest
     */
    'secret'?: string | null;
}
/**
 * 
 * @export
 * @interface VkMessage
 */
export interface VkMessage {
    /**
     * 
     * @type {string}
     * @memberof VkMessage
     */
    'text'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof VkMessage
     */
    'payload'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof VkMessage
     */
    'ref'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof VkMessage
     */
    'fromId'?: number;
    /**
     * 
     * @type {number}
     * @memberof VkMessage
     */
    'peerId'?: number;
}
/**
 * Коды сообщений об ошибках
 * @export
 * @enum {string}
 */

export const VoxErrorCode = {
    UnspecifiedError: 'unspecifiedError',
    MalformedRequest: 'malformedRequest',
    ClientNotFound: 'clientNotFound',
    SqlDataBaseUnavailable: 'sqlDataBaseUnavailable',
    OrderNotFound: 'orderNotFound',
    AddressNotFound: 'addressNotFound',
    PetNotFound: 'petNotFound',
    VoxServiceNotFound: 'voxServiceNotFound',
    TestNotFound: 'testNotFound',
    ExecutorNotFound: 'executorNotFound',
    BlogNotFound: 'blogNotFound',
    TrainingMaterialNotFound: 'trainingMaterialNotFound',
    UserTokenNotFound: 'userTokenNotFound',
    OrderAdditionalServiceNotFound: 'orderAdditionalServiceNotFound',
    CityNotFound: 'cityNotFound',
    ClientAddressNotFound: 'clientAddressNotFound',
    ExecutorAddressNotFound: 'executorAddressNotFound',
    ClientInnNotRegistered: 'clientInnNotRegistered',
    ExperienceNotFound: 'experienceNotFound',
    CitizenshipNotFound: 'citizenshipNotFound',
    ReviewNotFound: 'reviewNotFound',
    ProductNotFound: 'productNotFound',
    PaymentNotFound: 'paymentNotFound',
    PhoneNumberInvalid: 'phoneNumberInvalid',
    PolicyNotFound: 'policyNotFound',
    AppUserNotFound: 'appUserNotFound',
    ClientAlreadyExist: 'clientAlreadyExist',
    PaymentAlreadyCompleted: 'paymentAlreadyCompleted',
    HabitNotFound: 'habitNotFound',
    HabitAlreadyExist: 'habitAlreadyExist',
    RulesNotFound: 'rulesNotFound',
    ExecutorAddressRequiredForOrder: 'executorAddressRequiredForOrder',
    OrderDetailsNotFound: 'orderDetailsNotFound',
    LessonNotFound: 'lessonNotFound',
    AnswerNotFound: 'answerNotFound',
    QuestionNotFound: 'questionNotFound',
    ExecutorLessonProgressNotFound: 'executorLessonProgressNotFound',
    LessonTestsNotFound: 'lessonTestsNotFound',
    ExecutorAccessTestsNotFound: 'executorAccessTestsNotFound',
    ExecutorTestProgressNotFound: 'executorTestProgressNotFound',
    ExecutorAccessTestsAlreadyExist: 'executorAccessTestsAlreadyExist',
    ExecutorTestResultsNotFound: 'executorTestResultsNotFound',
    TestOwnershipMismatch: 'testOwnershipMismatch',
    UserDocumentNotFound: 'userDocumentNotFound',
    AvatarNotFound: 'avatarNotFound',
    ChatNotFound: 'chatNotFound',
    TagNotFound: 'tagNotFound',
    LocationNotFound: 'locationNotFound',
    OrderReportNotFound: 'orderReportNotFound',
    OrderHasNotExecutor: 'orderHasNotExecutor',
    RocketExecutorNotFound: 'rocketExecutorNotFound',
    RocketWorkPlatformNotResponding: 'rocketWorkPlatformNotResponding',
    BaseOrderProductNotFound: 'baseOrderProductNotFound',
    ChatDocumentNotFound: 'chatDocumentNotFound',
    AuthorizationCodeIncorrect: 'authorizationCodeIncorrect',
    AuthorizationCodeExpired: 'authorizationCodeExpired',
    AiAssistantUserNotFound: 'aiAssistantUserNotFound',
    TechnicalSupportUserNotFound: 'technicalSupportUserNotFound',
    CompanionUserNotFound: 'companionUserNotFound',
    AppUserAlreadyExistWithId: 'appUserAlreadyExistWithId',
    DeviceTokenNotFound: 'deviceTokenNotFound',
    OrderHasNotBeenPaid: 'orderHasNotBeenPaid',
    ExecutorHasPenalty: 'executorHasPenalty',
    OrderHasNoExecutor: 'orderHasNoExecutor',
    ExecutorHasAlreadyBeenRejectedForThisOrder: 'executorHasAlreadyBeenRejectedForThisOrder',
    ReviewHasAlreadyBeenLeftForOrder: 'reviewHasAlreadyBeenLeftForOrder',
    SbpPhoneRequired: 'sbpPhoneRequired',
    OrderHasInvalidStatus: 'orderHasInvalidStatus',
    BikMustBe9Digits: 'bikMustBe9Digits',
    CardNumberNotAllowedForSbp: 'cardNumberNotAllowedForSbp',
    BankAccountNotAllowedForSbp: 'bankAccountNotAllowedForSbp',
    CardNumberRequired: 'cardNumberRequired',
    InvalidCardNumber: 'invalidCardNumber',
    ExtraBankDetailsNotAllowedForCard: 'extraBankDetailsNotAllowedForCard',
    BankAccountMustBe20Digits: 'bankAccountMustBe20Digits',
    PhoneOrCardNotAllowedForBankAccount: 'phoneOrCardNotAllowedForBankAccount',
    InvalidPayoutMethodType: 'invalidPayoutMethodType',
    ExecutorIdRequired: 'executorIdRequired',
    OrderHasNoRocketWorkAgreement: 'orderHasNoRocketWorkAgreement',
    AdvanceBookingTooShort: 'advanceBookingTooShort',
    ServiceTimeUnavailableForToSpecialist: 'serviceTimeUnavailableForToSpecialist',
    OrderInvalidForPlanning: 'orderInvalidForPlanning',
    SchedulePeriodStartRequired: 'schedulePeriodStartRequired',
    SchedulePeriodEndRequired: 'schedulePeriodEndRequired',
    ScheduledTimeRequired: 'scheduledTimeRequired',
    SchedulePeriodStartAfterEnd: 'schedulePeriodStartAfterEnd',
    SchedulePeriodsOverlapNotAllowed: 'schedulePeriodsOverlapNotAllowed',
    AuthRetryTooSoon: 'authRetryTooSoon',
    HabitNameRequired: 'habitNameRequired',
    InvalidHabitType: 'invalidHabitType',
    InvalidPetType: 'invalidPetType',
    LastNameRequired: 'lastNameRequired',
    FirstNameRequired: 'firstNameRequired',
    BirthDateRequired: 'birthDateRequired',
    PassportSeriesRequired: 'passportSeriesRequired',
    PassportSeriesInvalidFormat: 'passportSeriesInvalidFormat',
    PassportNumberRequired: 'passportNumberRequired',
    PassportNumberInvalidFormat: 'passportNumberInvalidFormat',
    PlaceOfBirthRequired: 'placeOfBirthRequired',
    PassportIssueDateRequired: 'passportIssueDateRequired',
    PassportIssuedByRequired: 'passportIssuedByRequired',
    EmploymentKindRequired: 'employmentKindRequired',
    InnRequired: 'innRequired',
    InnInvalidLengthForSelfemployed: 'innInvalidLengthForSelfemployed',
    ClientIdCannotBeEmpty: 'clientIdCannotBeEmpty',
    ConditionalFieldMismatch: 'conditionalFieldMismatch',
    FieldCannotBeEmpty: 'fieldCannotBeEmpty',
    FieldCannotContainOnlyWhitespace: 'fieldCannotContainOnlyWhitespace',
    FieldMustBeNumber: 'fieldMustBeNumber',
    FieldCannotBeNegative: 'fieldCannotBeNegative',
    FieldCannotBeNullOrWhiteSpace: 'fieldCannotBeNullOrWhiteSpace',
    PetAgeOutOfRange: 'petAgeOutOfRange',
    OwnerIdRequired: 'ownerIdRequired',
    WeightMustBePositive: 'weightMustBePositive',
    AgeCannotBeNegative: 'ageCannotBeNegative',
    HeightMustBePositive: 'heightMustBePositive',
    CancellationInitiatorIdRequired: 'cancellationInitiatorIdRequired',
    BaseOrderProductRequiresExecutorButNotAssigned: 'baseOrderProductRequiresExecutorButNotAssigned',
    ExecutorPayoutMethodNotFound: 'executorPayoutMethodNotFound',
    ExecutorPhoneNotFound: 'executorPhoneNotFound',
    PetPlacementNotFound: 'petPlacementNotFound',
    OrderSchedulePeriodNotFound: 'orderSchedulePeriodNotFound',
    OrderTaskNotFound: 'orderTaskNotFound',
    TrackNotFound: 'trackNotFound',
    DialogNotFound: 'dialogNotFound',
    InvalidDialogOption: 'invalidDialogOption',
    DialogAlreadyCompleted: 'dialogAlreadyCompleted',
    VkAccountAlreadyLinked: 'vkAccountAlreadyLinked',
    AppUserAlreadyExistWithPhone: 'appUserAlreadyExistWithPhone',
    DiscountExceedsPositionTotal: 'discountExceedsPositionTotal',
    DiscountExceedsMaximum: 'discountExceedsMaximum',
    NoProductsForPromoCode: 'noProductsForPromoCode',
    SubscriptionNotFound: 'subscriptionNotFound',
    ClientSubscriptionNotFound: 'clientSubscriptionNotFound',
    ExecutorScheduleConflict: 'executorScheduleConflict',
    PriceListNotFound: 'priceListNotFound',
    PriceListAlreadyExist: 'priceListAlreadyExist',
    OrderCityNotSpecified: 'orderCityNotSpecified',
    WalkingMaxTwoDogsExceeded: 'walkingMaxTwoDogsExceeded',
    PetHasActiveOrders: 'petHasActiveOrders',
    ExecutorPassportDataRequired: 'executorPassportDataRequired',
    ClientHasActiveOrders: 'clientHasActiveOrders',
    ExecutorHasActiveOrders: 'executorHasActiveOrders',
    OrderCancellationNotAllowedStartTooSoon: 'orderCancellationNotAllowedStartTooSoon',
    InvalidCredentials: 'invalidCredentials',
    CityDistrictNotFound: 'cityDistrictNotFound',
    OrderCancellationFailed: 'orderCancellationFailed',
    BikNotExist: 'bikNotExist',
    PetTypeMismatch: 'petTypeMismatch',
    PetNotBelongToClient: 'petNotBelongToClient',
    IncompletePetInfoForHomeServices: 'incompletePetInfoForHomeServices',
    ClientAddressLimitReached: 'clientAddressLimitReached',
    ExecutorAddressLimitReached: 'executorAddressLimitReached',
    TelegramAccountAlreadyLinked: 'telegramAccountAlreadyLinked',
    ExecutorNotVerified: 'executorNotVerified',
    ExecutorAlreadyVerified: 'executorAlreadyVerified',
    VkNotLinked: 'vkNotLinked',
    EmailAlreadyExists: 'emailAlreadyExists',
    EmailInvalid: 'emailInvalid',
    EmailRequired: 'emailRequired',
    PhoneNumberRequired: 'phoneNumberRequired',
    PasswordRequired: 'passwordRequired',
    EmailForeignNotAllowed: 'emailForeignNotAllowed',
    AuthCodeInvariantViolation: 'authCodeInvariantViolation',
    AppUserBlocked: 'appUserBlocked',
    ClientDataAccessForbidden: 'clientDataAccessForbidden',
    MessengerNotLinked: 'messengerNotLinked',
    PromoCodeTransactionLimitExceeded: 'promoCodeTransactionLimitExceeded',
    PromoCodeNumberAlreadyExists: 'promoCodeNumberAlreadyExists',
    PromoCodeNumberRequired: 'promoCodeNumberRequired',
    PromoCodeCanBeEditedOnlyInNewStatus: 'promoCodeCanBeEditedOnlyInNewStatus',
    PromoCodeDiscountRequired: 'promoCodeDiscountRequired',
    PromoCodeTypeRequired: 'promoCodeTypeRequired',
    PromoCodeNotFound: 'promoCodeNotFound',
    PromoCodeNotActive: 'promoCodeNotActive',
    PromoCodeExpired: 'promoCodeExpired',
    PromoCodeClientLimitExceeded: 'promoCodeClientLimitExceeded',
    PromoCodeActiveDurationDaysOutOfRange: 'promoCodeActiveDurationDaysOutOfRange',
    PromoCodeLimitTransactionsMustBePositive: 'promoCodeLimitTransactionsMustBePositive',
    PromoCodeClientTransactionLimitMustBePositive: 'promoCodeClientTransactionLimitMustBePositive',
    PromoCodePercentageDiscountOutOfRange: 'promoCodePercentageDiscountOutOfRange',
    PromoCodeNumberTooLong: 'promoCodeNumberTooLong',
    PromoCodeNumberInvalidFormat: 'promoCodeNumberInvalidFormat',
    PromoCodeBlocked: 'promoCodeBlocked',
    PromoCodeExhausted: 'promoCodeExhausted',
    PromoCodeNotYetActive: 'promoCodeNotYetActive',
    PromoCodeExpirationSettingsConflict: 'promoCodeExpirationSettingsConflict',
    PromoCodeCanBeActivatedOnlyInNewStatus: 'promoCodeCanBeActivatedOnlyInNewStatus',
    OrderTaskNotReadyForAcceptance: 'orderTaskNotReadyForAcceptance',
    BonusAccountNotFound: 'bonusAccountNotFound',
    BonusAccountBlocked: 'bonusAccountBlocked',
    InsufficientBonusBalance: 'insufficientBonusBalance',
    BonusOperationConflict: 'bonusOperationConflict',
    VoxSettingsNotFound: 'voxSettingsNotFound',
    BonusAccountConcurrencyConflict: 'bonusAccountConcurrencyConflict',
    CashbackLevelNotFound: 'cashbackLevelNotFound',
    CashbackLevelValueAlreadyExists: 'cashbackLevelValueAlreadyExists',
    CashbackLevelInUse: 'cashbackLevelInUse',
    BaseCashbackLevelCannotBeDeleted: 'baseCashbackLevelCannotBeDeleted',
    CashbackPercentOutOfRange: 'cashbackPercentOutOfRange',
    BaseCashbackLevelCannotBeRenumbered: 'baseCashbackLevelCannotBeRenumbered',
    BonusPaymentLimitExceeded: 'bonusPaymentLimitExceeded',
    InvalidBonusAccrualPositionActions: 'invalidBonusAccrualPositionActions',
    BonusAccrualPositionsDoNotMatchPayment: 'bonusAccrualPositionsDoNotMatchPayment',
    BonusOperationIdRequired: 'bonusOperationIdRequired',
    BonusPointsMustBePositive: 'bonusPointsMustBePositive',
    BonusTransactionNotFound: 'bonusTransactionNotFound',
    NotificationTemplateNotFound: 'notificationTemplateNotFound',
    NotificationTemplateAudienceInvalid: 'notificationTemplateAudienceInvalid',
    NotificationTemplateNameRequired: 'notificationTemplateNameRequired',
    NotificationTemplateNameTooLong: 'notificationTemplateNameTooLong',
    NotificationTemplateDescriptionRequired: 'notificationTemplateDescriptionRequired',
    NotificationTemplateDescriptionTooLong: 'notificationTemplateDescriptionTooLong',
    NotificationTemplateTitleRequired: 'notificationTemplateTitleRequired',
    NotificationTemplateTitleTooLong: 'notificationTemplateTitleTooLong',
    NotificationTemplateBodyRequired: 'notificationTemplateBodyRequired',
    NotificationTemplateBodyTooLong: 'notificationTemplateBodyTooLong',
    FeatureToggleNotFound: 'featureToggleNotFound',
    FeatureToggleNameRequired: 'featureToggleNameRequired',
    FeatureToggleNameTooLong: 'featureToggleNameTooLong',
    FeatureToggleTypeRequired: 'featureToggleTypeRequired',
    FeatureToggleTypeAlreadyExists: 'featureToggleTypeAlreadyExists',
    TagValueRequired: 'tagValueRequired',
    AccessManagementForbidden: 'accessManagementForbidden',
    AccessManagementRoleNotManageable: 'accessManagementRoleNotManageable',
    AccessManagementOverrideConflict: 'accessManagementOverrideConflict',
    AccessManagementPermissionNotDelegable: 'accessManagementPermissionNotDelegable',
    AccessManagementVersionRequired: 'accessManagementVersionRequired',
    AccessManagementDuplicatePermission: 'accessManagementDuplicatePermission',
    AccessManagementVersionConflict: 'accessManagementVersionConflict',
    AccessManagementAppUserNotManageable: 'accessManagementAppUserNotManageable',
    AccessManagementInvalidPagination: 'accessManagementInvalidPagination',
    AccessManagementInvalidCatalog: 'accessManagementInvalidCatalog',
    AccessManagementSelfRoleChangeForbidden: 'accessManagementSelfRoleChangeForbidden',
    AccessManagementLoginRequired: 'accessManagementLoginRequired',
    AccessManagementLoginInvalid: 'accessManagementLoginInvalid',
    AccessManagementLoginAlreadyExists: 'accessManagementLoginAlreadyExists',
    AccessManagementPasswordInvalid: 'accessManagementPasswordInvalid',
    OrderProductTypeInvalid: 'orderProductTypeInvalid',
    DogWalkingPetTypeInvalid: 'dogWalkingPetTypeInvalid',
    OrderClientRequired: 'orderClientRequired',
    OrderPetsRequired: 'orderPetsRequired',
    OrderClientAddressRequired: 'orderClientAddressRequired',
    OrderPetTypeRequired: 'orderPetTypeRequired',
    OrderProductTypeRequired: 'orderProductTypeRequired',
    OrderSchedulePeriodRequired: 'orderSchedulePeriodRequired',
    OrderClientSubscriptionUnavailable: 'orderClientSubscriptionUnavailable',
    OrderAdditionalProductsSameSubType: 'orderAdditionalProductsSameSubType',
    OrderPaymentMethodChangeUnavailable: 'orderPaymentMethodChangeUnavailable',
    ProductCompatibleTypeInvalid: 'productCompatibleTypeInvalid',
    ProductCompatibilityNotApplicable: 'productCompatibilityNotApplicable',
    ProductCompatibleTypeDuplicate: 'productCompatibleTypeDuplicate',
    ProductSubTypeInvalid: 'productSubTypeInvalid',
    ProductSubTypeNotApplicable: 'productSubTypeNotApplicable',
    MediaImageSaveFailed: 'mediaImageSaveFailed',
    MediaPreviewSaveFailed: 'mediaPreviewSaveFailed',
    MediaVideoSaveFailed: 'mediaVideoSaveFailed',
    MediaDeleteFailed: 'mediaDeleteFailed',
    TelegramSettingsNotFound: 'telegramSettingsNotFound',
    TelegramSettingsUrlInvalid: 'telegramSettingsUrlInvalid',
    TelegramSettingsLinkInvalid: 'telegramSettingsLinkInvalid',
    TelegramSettingsBotListInvalid: 'telegramSettingsBotListInvalid',
    TelegramSettingsBotTokenRequired: 'telegramSettingsBotTokenRequired',
    TelegramSettingsBotTokenInvalid: 'telegramSettingsBotTokenInvalid',
    TelegramSettingsChatListInvalid: 'telegramSettingsChatListInvalid',
    TelegramSettingsChatIdInvalid: 'telegramSettingsChatIdInvalid',
    TelegramSettingsChatBotInvalid: 'telegramSettingsChatBotInvalid',
    TelegramSettingsForbidden: 'telegramSettingsForbidden',
    TelegramSettingsBotTokenNotFound: 'telegramSettingsBotTokenNotFound',
    TelegramSettingsTestBotUnavailable: 'telegramSettingsTestBotUnavailable',
    TelegramSettingsTestChatUnavailable: 'telegramSettingsTestChatUnavailable',
    TelegramSettingsTestMessageFailed: 'telegramSettingsTestMessageFailed',
    MemoryDiagnosticsForbidden: 'memoryDiagnosticsForbidden',
    PricingPeriodNotFound: 'pricingPeriodNotFound',
    PricingPeriodDatesInvalid: 'pricingPeriodDatesInvalid',
    PricingPeriodAmountsInvalid: 'pricingPeriodAmountsInvalid',
    PricingPeriodOverlap: 'pricingPeriodOverlap',
    PricingPeriodStartInPast: 'pricingPeriodStartInPast',
    PricingPeriodTargetInvalid: 'pricingPeriodTargetInvalid',
    PricingPeriodBannerRequired: 'pricingPeriodBannerRequired',
    PricingPeriodBannerIncompatible: 'pricingPeriodBannerIncompatible',
    PricingPeriodEndDateTooLate: 'pricingPeriodEndDateTooLate',
    PricingPeriodPromotionDatesInvalid: 'pricingPeriodPromotionDatesInvalid',
    PromotionBannerTemplateNotFound: 'promotionBannerTemplateNotFound',
    PromotionBannerTemplateNameInvalid: 'promotionBannerTemplateNameInvalid',
    PromotionBannerTemplateProductTypeInvalid: 'promotionBannerTemplateProductTypeInvalid',
    PromotionBannerTemplateLayoutInvalid: 'promotionBannerTemplateLayoutInvalid',
    PromotionBannerTemplateTitleInvalid: 'promotionBannerTemplateTitleInvalid',
    PromotionBannerTemplateBadgeInvalid: 'promotionBannerTemplateBadgeInvalid',
    PromotionBannerTemplateImageInvalid: 'promotionBannerTemplateImageInvalid',
    PromotionBannerTemplateSortInvalid: 'promotionBannerTemplateSortInvalid',
    PromotionBannerTemplateTypeInUse: 'promotionBannerTemplateTypeInUse',
    PromotionBannerTemplateCountdownRequired: 'promotionBannerTemplateCountdownRequired',
    VoxSettingsWelcomeBonusInvalid: 'voxSettingsWelcomeBonusInvalid',
    VoxSettingsCashbackPercentInvalid: 'voxSettingsCashbackPercentInvalid',
    VoxSettingsCashbackLifetimeInvalid: 'voxSettingsCashbackLifetimeInvalid',
    VoxSettingsBonusPaymentPercentInvalid: 'voxSettingsBonusPaymentPercentInvalid',
    VoxSettingsAccessTokenLifetimeInvalid: 'voxSettingsAccessTokenLifetimeInvalid',
    VoxSettingsRefreshTokenLifetimeInvalid: 'voxSettingsRefreshTokenLifetimeInvalid',
    VoxSettingsTokenLifetimeOrderInvalid: 'voxSettingsTokenLifetimeOrderInvalid',
    VoxSettingsSmsResendIntervalInvalid: 'voxSettingsSmsResendIntervalInvalid',
    VoxSettingsAuthCodeLifetimeInvalid: 'voxSettingsAuthCodeLifetimeInvalid',
    VoxSettingsEmailVerificationLifetimeInvalid: 'voxSettingsEmailVerificationLifetimeInvalid',
    VoxSettingsEmailVerificationResendIntervalInvalid: 'voxSettingsEmailVerificationResendIntervalInvalid',
    VoxSettingsOperatorTasksInvalid: 'voxSettingsOperatorTasksInvalid',
    VoxSettingsOrderDealSigningTimeoutInvalid: 'voxSettingsOrderDealSigningTimeoutInvalid',
    MessageSendStatisticsForbidden: 'messageSendStatisticsForbidden',
    AppVersionNotificationAudienceRequired: 'appVersionNotificationAudienceRequired',
    AppVersionNotificationForbidden: 'appVersionNotificationForbidden',
    EmailVerificationTokenInvalid: 'emailVerificationTokenInvalid',
    EmailVerificationTokenExpired: 'emailVerificationTokenExpired',
    EmailVerificationRetryTooSoon: 'emailVerificationRetryTooSoon',
    EmailVerificationForbidden: 'emailVerificationForbidden',
    EmailTooLong: 'emailTooLong',
    EmailVerificationDeliveryFailed: 'emailVerificationDeliveryFailed',
    EmailNotVerified: 'emailNotVerified',
    NotificationNotFound: 'notificationNotFound',
    NotificationReceiptTokenInvalid: 'notificationReceiptTokenInvalid',
    NotificationPermissionStatusInvalid: 'notificationPermissionStatusInvalid',
    CashbackRulesNotFound: 'cashbackRulesNotFound',
    CashbackRulesTitleInvalid: 'cashbackRulesTitleInvalid',
    CashbackRulesIntroTitleInvalid: 'cashbackRulesIntroTitleInvalid',
    CashbackRulesIntroTextInvalid: 'cashbackRulesIntroTextInvalid',
    CashbackRulesNoticeInvalid: 'cashbackRulesNoticeInvalid',
    CashbackRulesButtonInvalid: 'cashbackRulesButtonInvalid',
    CashbackRulesSectionsInvalid: 'cashbackRulesSectionsInvalid',
    CashbackRulesSectionTitleInvalid: 'cashbackRulesSectionTitleInvalid',
    CashbackRulesSectionTextInvalid: 'cashbackRulesSectionTextInvalid',
    CashbackRulesForbidden: 'cashbackRulesForbidden',
    SubscriptionBaseProductInvalid: 'subscriptionBaseProductInvalid',
    SubscriptionAdditionalProductsInvalid: 'subscriptionAdditionalProductsInvalid',
    PaymentConfirmationAmountConflict: 'paymentConfirmationAmountConflict',
    OrderProblemNotFound: 'orderProblemNotFound',
    OrderProblemForbidden: 'orderProblemForbidden',
    OrderProblemProcessingNotCompleted: 'orderProblemProcessingNotCompleted',
    StoredRobokassaRequestInvalid: 'storedRobokassaRequestInvalid',
    PaymentExternalIdInvalid: 'paymentExternalIdInvalid',
    PaymentConfirmedAmountInvalid: 'paymentConfirmedAmountInvalid',
    PaymentAmountMismatch: 'paymentAmountMismatch',
    PaymentOrderProductsMissing: 'paymentOrderProductsMissing',
    ClientSubscriptionHoldInsufficient: 'clientSubscriptionHoldInsufficient',
    PaymentSignatureInvalid: 'paymentSignatureInvalid',
    PaymentReplacementUnavailable: 'paymentReplacementUnavailable',
    ProblemAddressForbidden: 'problemAddressForbidden',
    ProblemAddressNotFound: 'problemAddressNotFound',
    ProblemAddressLatitudeInvalid: 'problemAddressLatitudeInvalid',
    ProblemAddressLongitudeInvalid: 'problemAddressLongitudeInvalid',
    ProblemAddressVersionConflict: 'problemAddressVersionConflict',
    ProblemAddressQualityInvalid: 'problemAddressQualityInvalid',
    OrderCancellationAnalyticsForbidden: 'orderCancellationAnalyticsForbidden',
    ExecutorPenaltyForbidden: 'executorPenaltyForbidden',
    OperatorTaskNotFound: 'operatorTaskNotFound',
    OperatorTaskForbidden: 'operatorTaskForbidden',
    OperatorTaskTextRequired: 'operatorTaskTextRequired',
    OperatorTaskTextTooLong: 'operatorTaskTextTooLong',
    OperatorTaskTypeInvalid: 'operatorTaskTypeInvalid',
    OperatorTaskDeadlineInvalid: 'operatorTaskDeadlineInvalid',
    OperatorTaskContextRequired: 'operatorTaskContextRequired',
    OperatorTaskContextInvalid: 'operatorTaskContextInvalid',
    OperatorTaskReminderSettingsInvalid: 'operatorTaskReminderSettingsInvalid',
    OperatorTaskQueryInvalid: 'operatorTaskQueryInvalid',
    OperatorTaskCalendarRangeInvalid: 'operatorTaskCalendarRangeInvalid',
    OperatorTaskVersionConflict: 'operatorTaskVersionConflict',
    OperatorTaskIdempotencyConflict: 'operatorTaskIdempotencyConflict',
    OperatorTaskStateConflict: 'operatorTaskStateConflict',
    OperatorTaskContextVerificationUnavailable: 'operatorTaskContextVerificationUnavailable',
    OperatorTaskAssigneeInvalid: 'operatorTaskAssigneeInvalid',
    SchedulerForbidden: 'schedulerForbidden',
    SchedulerNotFound: 'schedulerNotFound',
    SchedulerHandlerUnavailable: 'schedulerHandlerUnavailable',
    SchedulerScheduleInvalid: 'schedulerScheduleInvalid',
    SchedulerSentryInvalid: 'schedulerSentryInvalid',
    SchedulerParametersInvalid: 'schedulerParametersInvalid',
    SchedulerVersionConflict: 'schedulerVersionConflict',
    SchedulerJobAlreadyRunning: 'schedulerJobAlreadyRunning',
    VoxSettingNotFound: 'voxSettingNotFound',
    VoxSettingForbidden: 'voxSettingForbidden',
    VoxSettingUnknown: 'voxSettingUnknown',
    VoxSettingValueInvalid: 'voxSettingValueInvalid',
    VoxSettingVersionConflict: 'voxSettingVersionConflict',
    OrderListFilterInvalid: 'orderListFilterInvalid',
    OrderUnavailableForExecutor: 'orderUnavailableForExecutor',
    SalebotNotConfigured: 'salebotNotConfigured',
    SalebotClientIdInvalid: 'salebotClientIdInvalid',
    SalebotMessageRequired: 'salebotMessageRequired',
    SalebotSendFailed: 'salebotSendFailed',
    SalebotTestClientNotConfigured: 'salebotTestClientNotConfigured',
    ChatParticipantUnavailable: 'chatParticipantUnavailable',
    ChatReadMessageInvalid: 'chatReadMessageInvalid',
    ChatMessageConflict: 'chatMessageConflict',
    ChatConnectionUnavailable: 'chatConnectionUnavailable',
    ChatMessageInvalid: 'chatMessageInvalid',
    ChatMessageRequired: 'chatMessageRequired',
    ChatMessageTooLong: 'chatMessageTooLong',
    ChatStaffForbidden: 'chatStaffForbidden',
    ChatPageInvalid: 'chatPageInvalid',
    ChatHistoryCursorInvalid: 'chatHistoryCursorInvalid',
    ChatDialogUnavailable: 'chatDialogUnavailable',
    ChatMessageUnavailable: 'chatMessageUnavailable',
    ChatMigrationDisabled: 'chatMigrationDisabled',
    ChatMigrationForbidden: 'chatMigrationForbidden',
    ChatMigrationConfigurationInvalid: 'chatMigrationConfigurationInvalid',
    ChatMigrationConflict: 'chatMigrationConflict',
    ChatMigrationNotFound: 'chatMigrationNotFound',
    ChatPhotoInvalid: 'chatPhotoInvalid',
    ChatPhotoCaptionTooLong: 'chatPhotoCaptionTooLong',
    ChatUserForbidden: 'chatUserForbidden',
    NightSurchargeInvalid: 'nightSurchargeInvalid',
    NightSurchargeExecutorRewardInvalid: 'nightSurchargeExecutorRewardInvalid',
    ChatEditForbidden: 'chatEditForbidden',
    ChatEditConflict: 'chatEditConflict',
    ChatEditInvalid: 'chatEditInvalid',
    ScheduledEndTimeRequired: 'scheduledEndTimeRequired',
    ScheduleEndMustBeAfterStart: 'scheduleEndMustBeAfterStart',
    MixedProductTariffNotFound: 'mixedProductTariffNotFound',
    MixedProductPricingUnavailable: 'mixedProductPricingUnavailable',
    ProductTariffRequired: 'productTariffRequired',
    RegistrationAddressRequired: 'registrationAddressRequired',
    ExecutorGenderRequired: 'executorGenderRequired',
    FavoriteExecutorLimitExceeded: 'favoriteExecutorLimitExceeded',
    OrderInvitationInvalid: 'orderInvitationInvalid',
    OrderInvitationLocked: 'orderInvitationLocked',
    DialogInvalidConfiguration: 'dialogInvalidConfiguration',
    DialogForbidden: 'dialogForbidden',
    DialogTemplateConflict: 'dialogTemplateConflict',
    DialogBroadcastConflict: 'dialogBroadcastConflict',
    DialogAudienceEmpty: 'dialogAudienceEmpty',
    DialogTextAnswerRequired: 'dialogTextAnswerRequired',
    DialogTextAnswerTooLong: 'dialogTextAnswerTooLong',
    MessageTemplateNotFound: 'messageTemplateNotFound',
    MessageTemplateForbidden: 'messageTemplateForbidden',
    MessageTemplateVersionConflict: 'messageTemplateVersionConflict',
    MessageTemplateGroupInvalid: 'messageTemplateGroupInvalid',
    MessageTemplateTextRequired: 'messageTemplateTextRequired',
    MessageTemplateTextTooLong: 'messageTemplateTextTooLong',
    MessageTemplateDescriptionTooLong: 'messageTemplateDescriptionTooLong',
    MessageTemplateParametersInvalid: 'messageTemplateParametersInvalid',
    ChatReplyForbidden: 'chatReplyForbidden',
    ChatReplyNotFound: 'chatReplyNotFound',
    ChatReplyInvalid: 'chatReplyInvalid',
    ChatReplyConflict: 'chatReplyConflict',
    ChatReplyFolderNotEmpty: 'chatReplyFolderNotEmpty',
    ChatReplyNameInvalid: 'chatReplyNameInvalid',
    ChatReplyTextInvalid: 'chatReplyTextInvalid',
    CacheNotFound: 'cacheNotFound',
    CacheIdInvalid: 'cacheIdInvalid',
    CacheManagementForbidden: 'cacheManagementForbidden',
    VoxServiceForbidden: 'voxServiceForbidden',
    VoxServiceInvalid: 'voxServiceInvalid',
    VoxServiceProductInvalid: 'voxServiceProductInvalid',
    VoxServiceProductDuplicate: 'voxServiceProductDuplicate',
    VoxServiceConflict: 'voxServiceConflict',
    ProblemExecutorsForbidden: 'problemExecutorsForbidden',
    ProfilePhoneTransferForbidden: 'profilePhoneTransferForbidden',
    ProfilePhoneAlreadyTaken: 'profilePhoneAlreadyTaken',
    ProfilePhoneTransferCommentInvalid: 'profilePhoneTransferCommentInvalid',
    MediaLibraryForbidden: 'mediaLibraryForbidden',
    MediaLibraryInvalid: 'mediaLibraryInvalid',
    MediaLibraryNotFound: 'mediaLibraryNotFound',
    MediaLibraryConflict: 'mediaLibraryConflict',
    MediaLibraryInUse: 'mediaLibraryInUse',
    MediaLibraryFolderNotEmpty: 'mediaLibraryFolderNotEmpty',
    MediaLibraryFileInvalid: 'mediaLibraryFileInvalid',
    MediaLibraryStorageUnavailable: 'mediaLibraryStorageUnavailable',
    ProductBoardingDiscountInvalid: 'productBoardingDiscountInvalid',
    OrderTaskBindingForbidden: 'orderTaskBindingForbidden',
    OrderTaskOrderSearchInvalid: 'orderTaskOrderSearchInvalid',
    OrderAlreadyHasTask: 'orderAlreadyHasTask',
    OrderTaskAlreadyLinked: 'orderTaskAlreadyLinked',
    OrderTaskSnapshotInvalid: 'orderTaskSnapshotInvalid',
    PromoCodeCatalogForbidden: 'promoCodeCatalogForbidden',
    PromoCodeTemplateNotFound: 'promoCodeTemplateNotFound',
    PromoCodePrintingNotFound: 'promoCodePrintingNotFound',
    PromoCodeTemplateNameInvalid: 'promoCodeTemplateNameInvalid',
    PromoCodeTemplateVersionConflict: 'promoCodeTemplateVersionConflict',
    PromoCodePrintingCapacityInvalid: 'promoCodePrintingCapacityInvalid',
    PromoCodePrintingAlreadyIssued: 'promoCodePrintingAlreadyIssued',
    PromoCodePrintingNumbersInvalid: 'promoCodePrintingNumbersInvalid',
    PromoCodePrintingNumberCountInvalid: 'promoCodePrintingNumberCountInvalid',
    PromoCodePrintingWorkbookInvalid: 'promoCodePrintingWorkbookInvalid',
    PromoCodePrintingEditForbidden: 'promoCodePrintingEditForbidden',
    PromoCodeCatalogPageInvalid: 'promoCodeCatalogPageInvalid',
    PromoCodeTemplateUnavailable: 'promoCodeTemplateUnavailable',
    PromoCodeActivationDeadlineExpired: 'promoCodeActivationDeadlineExpired',
    PromoCodeStandaloneTemplateManagedByCode: 'promoCodeStandaloneTemplateManagedByCode'
} as const;

export type VoxErrorCode = typeof VoxErrorCode[keyof typeof VoxErrorCode];


/**
 * Простейшая модель
 * @export
 * @interface VoxErrorCodeSimpleModel
 */
export interface VoxErrorCodeSimpleModel {
    /**
     * 
     * @type {VoxErrorCode}
     * @memberof VoxErrorCodeSimpleModel
     */
    'id'?: VoxErrorCode;
    /**
     * Наименование
     * @type {string}
     * @memberof VoxErrorCodeSimpleModel
     */
    'name'?: string | null;
}


/**
 * Карточка услуги для управления
 * @export
 * @interface VoxServiceCardResponse
 */
export interface VoxServiceCardResponse {
    /**
     * Идентификатор карточки
     * @type {string}
     * @memberof VoxServiceCardResponse
     */
    'id'?: string;
    /**
     * Название карточки
     * @type {string}
     * @memberof VoxServiceCardResponse
     */
    'name'?: string | null;
    /**
     * Описание карточки
     * @type {string}
     * @memberof VoxServiceCardResponse
     */
    'description'?: string | null;
    /**
     * Цвет фона
     * @type {string}
     * @memberof VoxServiceCardResponse
     */
    'backgroundColor'?: string | null;
    /**
     * 
     * @type {ApiCardType}
     * @memberof VoxServiceCardResponse
     */
    'cardType'?: ApiCardType;
    /**
     * Адрес изображения
     * @type {string}
     * @memberof VoxServiceCardResponse
     */
    'imageUrl'?: string | null;
    /**
     * Базовый продукт
     * @type {string}
     * @memberof VoxServiceCardResponse
     */
    'productId'?: string;
    /**
     * Порядок отображения
     * @type {number}
     * @memberof VoxServiceCardResponse
     */
    'index'?: number;
    /**
     * Видимость в приложении
     * @type {boolean}
     * @memberof VoxServiceCardResponse
     */
    'isShowServices'?: boolean;
    /**
     * Признак раздела в разработке
     * @type {boolean}
     * @memberof VoxServiceCardResponse
     */
    'isUnderDevelopment'?: boolean;
    /**
     * Версия карточки
     * @type {string}
     * @memberof VoxServiceCardResponse
     */
    'version'?: string;
    /**
     * Название продукта
     * @type {string}
     * @memberof VoxServiceCardResponse
     */
    'productName'?: string | null;
    /**
     * Признак удалённого продукта
     * @type {boolean}
     * @memberof VoxServiceCardResponse
     */
    'productDeleted'?: boolean;
}


/**
 * Каталог карточек услуг
 * @export
 * @interface VoxServiceCatalogResponse
 */
export interface VoxServiceCatalogResponse {
    /**
     * Карточки услуг
     * @type {Array<VoxServiceCardResponse>}
     * @memberof VoxServiceCatalogResponse
     */
    'items'?: Array<VoxServiceCardResponse> | null;
    /**
     * Доступные базовые продукты
     * @type {Array<VoxServiceProductResponse>}
     * @memberof VoxServiceCatalogResponse
     */
    'products'?: Array<VoxServiceProductResponse> | null;
}
/**
 * Продукт для карточки услуги
 * @export
 * @interface VoxServiceProductResponse
 */
export interface VoxServiceProductResponse {
    /**
     * Идентификатор продукта
     * @type {string}
     * @memberof VoxServiceProductResponse
     */
    'id'?: string;
    /**
     * Название продукта
     * @type {string}
     * @memberof VoxServiceProductResponse
     */
    'name'?: string | null;
    /**
     * 
     * @type {ApiPetType}
     * @memberof VoxServiceProductResponse
     */
    'petType'?: ApiPetType;
}


/**
 * Карточка услуги главного экрана
 * @export
 * @interface VoxServiceResponse
 */
export interface VoxServiceResponse {
    /**
     * Идентификатор карточки услуги
     * @type {string}
     * @memberof VoxServiceResponse
     */
    'id'?: string;
    /**
     * Наименование услуги
     * @type {string}
     * @memberof VoxServiceResponse
     */
    'name'?: string | null;
    /**
     * Описание
     * @type {string}
     * @memberof VoxServiceResponse
     */
    'description'?: string | null;
    /**
     * 
     * @type {ApiCardTypeSimpleModel}
     * @memberof VoxServiceResponse
     */
    'cardType'?: ApiCardTypeSimpleModel;
    /**
     * 
     * @type {ApiMoneyDebitTypeSimpleModel}
     * @memberof VoxServiceResponse
     */
    'moneyDebitType'?: ApiMoneyDebitTypeSimpleModel;
    /**
     * 
     * @type {ApiProductTypeSimpleModel}
     * @memberof VoxServiceResponse
     */
    'productType'?: ApiProductTypeSimpleModel;
    /**
     * Цвет фона для UI
     * @type {string}
     * @memberof VoxServiceResponse
     */
    'backgroundColor'?: string | null;
    /**
     * Идентификатор картинки
     * @type {string}
     * @memberof VoxServiceResponse
     */
    'imageUrl'?: string | null;
    /**
     * Цена продукта
     * @type {number}
     * @memberof VoxServiceResponse
     */
    'price'?: number | null;
    /**
     * Индекс сортировки для отображения
     * @type {number}
     * @memberof VoxServiceResponse
     */
    'index'?: number;
    /**
     * Идентификатор связанного базового продукта услуги
     * @type {string}
     * @memberof VoxServiceResponse
     */
    'productId'?: string;
    /**
     * Показывать в приложении
     * @type {boolean}
     * @memberof VoxServiceResponse
     */
    'isShowServices'?: boolean;
    /**
     * Раздел в разработке
     * @type {boolean}
     * @memberof VoxServiceResponse
     */
    'isUnderDevelopment'?: boolean;
}
/**
 * Прикладная настройка VOX
 * @export
 * @interface VoxSettingResponse
 */
export interface VoxSettingResponse {
    /**
     * 
     * @type {ApiSettingTypeSimpleModel}
     * @memberof VoxSettingResponse
     */
    'type'?: ApiSettingTypeSimpleModel;
    /**
     * Стабильный ключ настройки
     * @type {string}
     * @memberof VoxSettingResponse
     */
    'key'?: string | null;
    /**
     * Название настройки
     * @type {string}
     * @memberof VoxSettingResponse
     */
    'name'?: string | null;
    /**
     * Версия настройки
     * @type {string}
     * @memberof VoxSettingResponse
     */
    'version'?: string;
    /**
     * Значение настройки в формате JSON
     * @type {string}
     * @memberof VoxSettingResponse
     */
    'valueJson'?: string | null;
    /**
     * Доступность изменения настройки
     * @type {boolean}
     * @memberof VoxSettingResponse
     */
    'isEditable'?: boolean;
    /**
     * Вид значения настройки
     * @type {string}
     * @memberof VoxSettingResponse
     */
    'kind'?: string | null;
    /**
     * Минимальное числовое значение
     * @type {number}
     * @memberof VoxSettingResponse
     */
    'minimum'?: number | null;
    /**
     * Максимальное числовое значение
     * @type {number}
     * @memberof VoxSettingResponse
     */
    'maximum'?: number | null;
    /**
     * Максимальная длина текста или массива
     * @type {number}
     * @memberof VoxSettingResponse
     */
    'maximumLength'?: number | null;
}
/**
 * Документ раздела прикладных настроек
 * @export
 * @interface VoxSettingsResponse
 */
export interface VoxSettingsResponse {
    /**
     * 
     * @type {ApiSettingTypeSimpleModel}
     * @memberof VoxSettingsResponse
     */
    'type'?: ApiSettingTypeSimpleModel;
    /**
     * Общая версия документа
     * @type {string}
     * @memberof VoxSettingsResponse
     */
    'version'?: string;
    /**
     * Параметры раздела
     * @type {Array<VoxSettingResponse>}
     * @memberof VoxSettingsResponse
     */
    'settings'?: Array<VoxSettingResponse> | null;
}

/**
 * AccessManagementApi - axios parameter creator
 * @export
 */
export const AccessManagementApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Изменить роль внутреннего пользователя с отзывом refresh tokens
         * @param {string} id 
         * @param {string} [apiVersion] 
         * @param {ChangeAccessAppUserRoleRequest} [changeAccessAppUserRoleRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changeAppUserRole: async (id: string, apiVersion?: string, changeAccessAppUserRoleRequest?: ChangeAccessAppUserRoleRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('changeAppUserRole', 'id', id)
            const localVarPath = `/api/v1/access-management/app-users/{id}/role`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(changeAccessAppUserRoleRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Создать внутреннего пользователя с выбранной ролью
         * @param {string} [apiVersion] 
         * @param {CreateAccessAppUserRequest} [createAccessAppUserRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAppUser: async (apiVersion?: string, createAccessAppUserRequest?: CreateAccessAppUserRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/access-management/app-users`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createAccessAppUserRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Получить каталог действий административного интерфейса
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdminPermissionCatalog: async (apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/access-management/admin-permission-catalog`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Получить ролевые, персональные и итоговые права пользователя
         * @param {string} id 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAppUserPermissions: async (id: string, apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getAppUserPermissions', 'id', id)
            const localVarPath = `/api/v1/access-management/app-users/{id}/permissions`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Получить страницу внутренних пользователей
         * @param {string} [apiVersion] 
         * @param {GetAccessAppUsersRequest} [getAccessAppUsersRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAppUsers: async (apiVersion?: string, getAccessAppUsersRequest?: GetAccessAppUsersRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/access-management/get-app-users`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(getAccessAppUsersRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Получить активный каталог прав с группировкой
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPermissionCatalog: async (apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/access-management/permission-catalog`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Получить текущий снимок прав роли
         * @param {ApiUserRole} role Роль пользователя
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRolePermissions: async (role: ApiUserRole, apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'role' is not null or undefined
            assertParamExists('getRolePermissions', 'role', role)
            const localVarPath = `/api/v1/access-management/roles/{role}/permissions`
                .replace(`{${"role"}}`, encodeURIComponent(String(role)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Получить роли, для которых разрешено настраивать права
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRoles: async (apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/access-management/roles`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Атомарно заменить персональные разрешения и запреты пользователя
         * @param {string} id 
         * @param {string} [apiVersion] 
         * @param {ReplaceAppUserPermissionOverridesRequest} [replaceAppUserPermissionOverridesRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        replaceAppUserPermissionOverrides: async (id: string, apiVersion?: string, replaceAppUserPermissionOverridesRequest?: ReplaceAppUserPermissionOverridesRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('replaceAppUserPermissionOverrides', 'id', id)
            const localVarPath = `/api/v1/access-management/app-users/{id}/permission-overrides`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(replaceAppUserPermissionOverridesRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Атомарно заменить снимок прав роли
         * @param {ApiUserRole} role Роль пользователя
         * @param {string} [apiVersion] 
         * @param {ReplaceRolePermissionsRequest} [replaceRolePermissionsRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        replaceRolePermissions: async (role: ApiUserRole, apiVersion?: string, replaceRolePermissionsRequest?: ReplaceRolePermissionsRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'role' is not null or undefined
            assertParamExists('replaceRolePermissions', 'role', role)
            const localVarPath = `/api/v1/access-management/roles/{role}/permissions`
                .replace(`{${"role"}}`, encodeURIComponent(String(role)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(replaceRolePermissionsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Зарегистрировать или изменить действие административного интерфейса
         * @param {string} [apiVersion] 
         * @param {SaveAdminPermissionRequest} [saveAdminPermissionRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveAdminPermission: async (apiVersion?: string, saveAdminPermissionRequest?: SaveAdminPermissionRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/access-management/admin-permission-catalog`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(saveAdminPermissionRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Установить новый пароль внутреннего пользователя
         * @param {string} id 
         * @param {string} [apiVersion] 
         * @param {SetAccessAppUserPasswordRequest} [setAccessAppUserPasswordRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setAppUserPassword: async (id: string, apiVersion?: string, setAccessAppUserPasswordRequest?: SetAccessAppUserPasswordRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('setAppUserPassword', 'id', id)
            const localVarPath = `/api/v1/access-management/app-users/{id}/password`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(setAccessAppUserPasswordRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Синхронизировать каталог с актуальными MVC actions и деактивировать отсутствующие
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        synchronizePermissionCatalog: async (apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/access-management/permission-catalog/synchronize`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AccessManagementApi - functional programming interface
 * @export
 */
export const AccessManagementApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AccessManagementApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Изменить роль внутреннего пользователя с отзывом refresh tokens
         * @param {string} id 
         * @param {string} [apiVersion] 
         * @param {ChangeAccessAppUserRoleRequest} [changeAccessAppUserRoleRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async changeAppUserRole(id: string, apiVersion?: string, changeAccessAppUserRoleRequest?: ChangeAccessAppUserRoleRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ChangeAccessAppUserRoleResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.changeAppUserRole(id, apiVersion, changeAccessAppUserRoleRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AccessManagementApi.changeAppUserRole']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Создать внутреннего пользователя с выбранной ролью
         * @param {string} [apiVersion] 
         * @param {CreateAccessAppUserRequest} [createAccessAppUserRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createAppUser(apiVersion?: string, createAccessAppUserRequest?: CreateAccessAppUserRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AccessAppUserResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createAppUser(apiVersion, createAccessAppUserRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AccessManagementApi.createAppUser']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Получить каталог действий административного интерфейса
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAdminPermissionCatalog(apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PermissionResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAdminPermissionCatalog(apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AccessManagementApi.getAdminPermissionCatalog']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Получить ролевые, персональные и итоговые права пользователя
         * @param {string} id 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAppUserPermissions(id: string, apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AppUserPermissionsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAppUserPermissions(id, apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AccessManagementApi.getAppUserPermissions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Получить страницу внутренних пользователей
         * @param {string} [apiVersion] 
         * @param {GetAccessAppUsersRequest} [getAccessAppUsersRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAppUsers(apiVersion?: string, getAccessAppUsersRequest?: GetAccessAppUsersRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetAccessAppUsersResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAppUsers(apiVersion, getAccessAppUsersRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AccessManagementApi.getAppUsers']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Получить активный каталог прав с группировкой
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPermissionCatalog(apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PermissionGroupResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPermissionCatalog(apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AccessManagementApi.getPermissionCatalog']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Получить текущий снимок прав роли
         * @param {ApiUserRole} role Роль пользователя
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRolePermissions(role: ApiUserRole, apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RolePermissionsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRolePermissions(role, apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AccessManagementApi.getRolePermissions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Получить роли, для которых разрешено настраивать права
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRoles(apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AccessRoleResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRoles(apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AccessManagementApi.getRoles']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Атомарно заменить персональные разрешения и запреты пользователя
         * @param {string} id 
         * @param {string} [apiVersion] 
         * @param {ReplaceAppUserPermissionOverridesRequest} [replaceAppUserPermissionOverridesRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async replaceAppUserPermissionOverrides(id: string, apiVersion?: string, replaceAppUserPermissionOverridesRequest?: ReplaceAppUserPermissionOverridesRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AppUserPermissionsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.replaceAppUserPermissionOverrides(id, apiVersion, replaceAppUserPermissionOverridesRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AccessManagementApi.replaceAppUserPermissionOverrides']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Атомарно заменить снимок прав роли
         * @param {ApiUserRole} role Роль пользователя
         * @param {string} [apiVersion] 
         * @param {ReplaceRolePermissionsRequest} [replaceRolePermissionsRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async replaceRolePermissions(role: ApiUserRole, apiVersion?: string, replaceRolePermissionsRequest?: ReplaceRolePermissionsRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RolePermissionsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.replaceRolePermissions(role, apiVersion, replaceRolePermissionsRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AccessManagementApi.replaceRolePermissions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Зарегистрировать или изменить действие административного интерфейса
         * @param {string} [apiVersion] 
         * @param {SaveAdminPermissionRequest} [saveAdminPermissionRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async saveAdminPermission(apiVersion?: string, saveAdminPermissionRequest?: SaveAdminPermissionRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PermissionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.saveAdminPermission(apiVersion, saveAdminPermissionRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AccessManagementApi.saveAdminPermission']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Установить новый пароль внутреннего пользователя
         * @param {string} id 
         * @param {string} [apiVersion] 
         * @param {SetAccessAppUserPasswordRequest} [setAccessAppUserPasswordRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setAppUserPassword(id: string, apiVersion?: string, setAccessAppUserPasswordRequest?: SetAccessAppUserPasswordRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.setAppUserPassword(id, apiVersion, setAccessAppUserPasswordRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AccessManagementApi.setAppUserPassword']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Синхронизировать каталог с актуальными MVC actions и деактивировать отсутствующие
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async synchronizePermissionCatalog(apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SynchronizePermissionCatalogResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.synchronizePermissionCatalog(apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AccessManagementApi.synchronizePermissionCatalog']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AccessManagementApi - factory interface
 * @export
 */
export const AccessManagementApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AccessManagementApiFp(configuration)
    return {
        /**
         * 
         * @summary Изменить роль внутреннего пользователя с отзывом refresh tokens
         * @param {AccessManagementApiChangeAppUserRoleRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changeAppUserRole(requestParameters: AccessManagementApiChangeAppUserRoleRequest, options?: RawAxiosRequestConfig): AxiosPromise<ChangeAccessAppUserRoleResponse> {
            return localVarFp.changeAppUserRole(requestParameters.id, requestParameters.apiVersion, requestParameters.changeAccessAppUserRoleRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Создать внутреннего пользователя с выбранной ролью
         * @param {AccessManagementApiCreateAppUserRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAppUser(requestParameters: AccessManagementApiCreateAppUserRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<AccessAppUserResponse> {
            return localVarFp.createAppUser(requestParameters.apiVersion, requestParameters.createAccessAppUserRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Получить каталог действий административного интерфейса
         * @param {AccessManagementApiGetAdminPermissionCatalogRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdminPermissionCatalog(requestParameters: AccessManagementApiGetAdminPermissionCatalogRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<Array<PermissionResponse>> {
            return localVarFp.getAdminPermissionCatalog(requestParameters.apiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Получить ролевые, персональные и итоговые права пользователя
         * @param {AccessManagementApiGetAppUserPermissionsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAppUserPermissions(requestParameters: AccessManagementApiGetAppUserPermissionsRequest, options?: RawAxiosRequestConfig): AxiosPromise<AppUserPermissionsResponse> {
            return localVarFp.getAppUserPermissions(requestParameters.id, requestParameters.apiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Получить страницу внутренних пользователей
         * @param {AccessManagementApiGetAppUsersRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAppUsers(requestParameters: AccessManagementApiGetAppUsersRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<GetAccessAppUsersResponse> {
            return localVarFp.getAppUsers(requestParameters.apiVersion, requestParameters.getAccessAppUsersRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Получить активный каталог прав с группировкой
         * @param {AccessManagementApiGetPermissionCatalogRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPermissionCatalog(requestParameters: AccessManagementApiGetPermissionCatalogRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<Array<PermissionGroupResponse>> {
            return localVarFp.getPermissionCatalog(requestParameters.apiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Получить текущий снимок прав роли
         * @param {AccessManagementApiGetRolePermissionsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRolePermissions(requestParameters: AccessManagementApiGetRolePermissionsRequest, options?: RawAxiosRequestConfig): AxiosPromise<RolePermissionsResponse> {
            return localVarFp.getRolePermissions(requestParameters.role, requestParameters.apiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Получить роли, для которых разрешено настраивать права
         * @param {AccessManagementApiGetRolesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRoles(requestParameters: AccessManagementApiGetRolesRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<Array<AccessRoleResponse>> {
            return localVarFp.getRoles(requestParameters.apiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Атомарно заменить персональные разрешения и запреты пользователя
         * @param {AccessManagementApiReplaceAppUserPermissionOverridesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        replaceAppUserPermissionOverrides(requestParameters: AccessManagementApiReplaceAppUserPermissionOverridesRequest, options?: RawAxiosRequestConfig): AxiosPromise<AppUserPermissionsResponse> {
            return localVarFp.replaceAppUserPermissionOverrides(requestParameters.id, requestParameters.apiVersion, requestParameters.replaceAppUserPermissionOverridesRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Атомарно заменить снимок прав роли
         * @param {AccessManagementApiReplaceRolePermissionsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        replaceRolePermissions(requestParameters: AccessManagementApiReplaceRolePermissionsRequest, options?: RawAxiosRequestConfig): AxiosPromise<RolePermissionsResponse> {
            return localVarFp.replaceRolePermissions(requestParameters.role, requestParameters.apiVersion, requestParameters.replaceRolePermissionsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Зарегистрировать или изменить действие административного интерфейса
         * @param {AccessManagementApiSaveAdminPermissionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveAdminPermission(requestParameters: AccessManagementApiSaveAdminPermissionRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<PermissionResponse> {
            return localVarFp.saveAdminPermission(requestParameters.apiVersion, requestParameters.saveAdminPermissionRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Установить новый пароль внутреннего пользователя
         * @param {AccessManagementApiSetAppUserPasswordRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setAppUserPassword(requestParameters: AccessManagementApiSetAppUserPasswordRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.setAppUserPassword(requestParameters.id, requestParameters.apiVersion, requestParameters.setAccessAppUserPasswordRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Синхронизировать каталог с актуальными MVC actions и деактивировать отсутствующие
         * @param {AccessManagementApiSynchronizePermissionCatalogRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        synchronizePermissionCatalog(requestParameters: AccessManagementApiSynchronizePermissionCatalogRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<SynchronizePermissionCatalogResponse> {
            return localVarFp.synchronizePermissionCatalog(requestParameters.apiVersion, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for changeAppUserRole operation in AccessManagementApi.
 * @export
 * @interface AccessManagementApiChangeAppUserRoleRequest
 */
export interface AccessManagementApiChangeAppUserRoleRequest {
    /**
     * 
     * @type {string}
     * @memberof AccessManagementApiChangeAppUserRole
     */
    readonly id: string

    /**
     * 
     * @type {string}
     * @memberof AccessManagementApiChangeAppUserRole
     */
    readonly apiVersion?: string

    /**
     * 
     * @type {ChangeAccessAppUserRoleRequest}
     * @memberof AccessManagementApiChangeAppUserRole
     */
    readonly changeAccessAppUserRoleRequest?: ChangeAccessAppUserRoleRequest
}

/**
 * Request parameters for createAppUser operation in AccessManagementApi.
 * @export
 * @interface AccessManagementApiCreateAppUserRequest
 */
export interface AccessManagementApiCreateAppUserRequest {
    /**
     * 
     * @type {string}
     * @memberof AccessManagementApiCreateAppUser
     */
    readonly apiVersion?: string

    /**
     * 
     * @type {CreateAccessAppUserRequest}
     * @memberof AccessManagementApiCreateAppUser
     */
    readonly createAccessAppUserRequest?: CreateAccessAppUserRequest
}

/**
 * Request parameters for getAdminPermissionCatalog operation in AccessManagementApi.
 * @export
 * @interface AccessManagementApiGetAdminPermissionCatalogRequest
 */
export interface AccessManagementApiGetAdminPermissionCatalogRequest {
    /**
     * 
     * @type {string}
     * @memberof AccessManagementApiGetAdminPermissionCatalog
     */
    readonly apiVersion?: string
}

/**
 * Request parameters for getAppUserPermissions operation in AccessManagementApi.
 * @export
 * @interface AccessManagementApiGetAppUserPermissionsRequest
 */
export interface AccessManagementApiGetAppUserPermissionsRequest {
    /**
     * 
     * @type {string}
     * @memberof AccessManagementApiGetAppUserPermissions
     */
    readonly id: string

    /**
     * 
     * @type {string}
     * @memberof AccessManagementApiGetAppUserPermissions
     */
    readonly apiVersion?: string
}

/**
 * Request parameters for getAppUsers operation in AccessManagementApi.
 * @export
 * @interface AccessManagementApiGetAppUsersRequest
 */
export interface AccessManagementApiGetAppUsersRequest {
    /**
     * 
     * @type {string}
     * @memberof AccessManagementApiGetAppUsers
     */
    readonly apiVersion?: string

    /**
     * 
     * @type {GetAccessAppUsersRequest}
     * @memberof AccessManagementApiGetAppUsers
     */
    readonly getAccessAppUsersRequest?: GetAccessAppUsersRequest
}

/**
 * Request parameters for getPermissionCatalog operation in AccessManagementApi.
 * @export
 * @interface AccessManagementApiGetPermissionCatalogRequest
 */
export interface AccessManagementApiGetPermissionCatalogRequest {
    /**
     * 
     * @type {string}
     * @memberof AccessManagementApiGetPermissionCatalog
     */
    readonly apiVersion?: string
}

/**
 * Request parameters for getRolePermissions operation in AccessManagementApi.
 * @export
 * @interface AccessManagementApiGetRolePermissionsRequest
 */
export interface AccessManagementApiGetRolePermissionsRequest {
    /**
     * Роль пользователя
     * @type {ApiUserRole}
     * @memberof AccessManagementApiGetRolePermissions
     */
    readonly role: ApiUserRole

    /**
     * 
     * @type {string}
     * @memberof AccessManagementApiGetRolePermissions
     */
    readonly apiVersion?: string
}

/**
 * Request parameters for getRoles operation in AccessManagementApi.
 * @export
 * @interface AccessManagementApiGetRolesRequest
 */
export interface AccessManagementApiGetRolesRequest {
    /**
     * 
     * @type {string}
     * @memberof AccessManagementApiGetRoles
     */
    readonly apiVersion?: string
}

/**
 * Request parameters for replaceAppUserPermissionOverrides operation in AccessManagementApi.
 * @export
 * @interface AccessManagementApiReplaceAppUserPermissionOverridesRequest
 */
export interface AccessManagementApiReplaceAppUserPermissionOverridesRequest {
    /**
     * 
     * @type {string}
     * @memberof AccessManagementApiReplaceAppUserPermissionOverrides
     */
    readonly id: string

    /**
     * 
     * @type {string}
     * @memberof AccessManagementApiReplaceAppUserPermissionOverrides
     */
    readonly apiVersion?: string

    /**
     * 
     * @type {ReplaceAppUserPermissionOverridesRequest}
     * @memberof AccessManagementApiReplaceAppUserPermissionOverrides
     */
    readonly replaceAppUserPermissionOverridesRequest?: ReplaceAppUserPermissionOverridesRequest
}

/**
 * Request parameters for replaceRolePermissions operation in AccessManagementApi.
 * @export
 * @interface AccessManagementApiReplaceRolePermissionsRequest
 */
export interface AccessManagementApiReplaceRolePermissionsRequest {
    /**
     * Роль пользователя
     * @type {ApiUserRole}
     * @memberof AccessManagementApiReplaceRolePermissions
     */
    readonly role: ApiUserRole

    /**
     * 
     * @type {string}
     * @memberof AccessManagementApiReplaceRolePermissions
     */
    readonly apiVersion?: string

    /**
     * 
     * @type {ReplaceRolePermissionsRequest}
     * @memberof AccessManagementApiReplaceRolePermissions
     */
    readonly replaceRolePermissionsRequest?: ReplaceRolePermissionsRequest
}

/**
 * Request parameters for saveAdminPermission operation in AccessManagementApi.
 * @export
 * @interface AccessManagementApiSaveAdminPermissionRequest
 */
export interface AccessManagementApiSaveAdminPermissionRequest {
    /**
     * 
     * @type {string}
     * @memberof AccessManagementApiSaveAdminPermission
     */
    readonly apiVersion?: string

    /**
     * 
     * @type {SaveAdminPermissionRequest}
     * @memberof AccessManagementApiSaveAdminPermission
     */
    readonly saveAdminPermissionRequest?: SaveAdminPermissionRequest
}

/**
 * Request parameters for setAppUserPassword operation in AccessManagementApi.
 * @export
 * @interface AccessManagementApiSetAppUserPasswordRequest
 */
export interface AccessManagementApiSetAppUserPasswordRequest {
    /**
     * 
     * @type {string}
     * @memberof AccessManagementApiSetAppUserPassword
     */
    readonly id: string

    /**
     * 
     * @type {string}
     * @memberof AccessManagementApiSetAppUserPassword
     */
    readonly apiVersion?: string

    /**
     * 
     * @type {SetAccessAppUserPasswordRequest}
     * @memberof AccessManagementApiSetAppUserPassword
     */
    readonly setAccessAppUserPasswordRequest?: SetAccessAppUserPasswordRequest
}

/**
 * Request parameters for synchronizePermissionCatalog operation in AccessManagementApi.
 * @export
 * @interface AccessManagementApiSynchronizePermissionCatalogRequest
 */
export interface AccessManagementApiSynchronizePermissionCatalogRequest {
    /**
     * 
     * @type {string}
     * @memberof AccessManagementApiSynchronizePermissionCatalog
     */
    readonly apiVersion?: string
}

/**
 * AccessManagementApi - object-oriented interface
 * @export
 * @class AccessManagementApi
 * @extends {BaseAPI}
 */
export class AccessManagementApi extends BaseAPI {
    /**
     * 
     * @summary Изменить роль внутреннего пользователя с отзывом refresh tokens
     * @param {AccessManagementApiChangeAppUserRoleRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccessManagementApi
     */
    public changeAppUserRole(requestParameters: AccessManagementApiChangeAppUserRoleRequest, options?: RawAxiosRequestConfig) {
        return AccessManagementApiFp(this.configuration).changeAppUserRole(requestParameters.id, requestParameters.apiVersion, requestParameters.changeAccessAppUserRoleRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Создать внутреннего пользователя с выбранной ролью
     * @param {AccessManagementApiCreateAppUserRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccessManagementApi
     */
    public createAppUser(requestParameters: AccessManagementApiCreateAppUserRequest = {}, options?: RawAxiosRequestConfig) {
        return AccessManagementApiFp(this.configuration).createAppUser(requestParameters.apiVersion, requestParameters.createAccessAppUserRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Получить каталог действий административного интерфейса
     * @param {AccessManagementApiGetAdminPermissionCatalogRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccessManagementApi
     */
    public getAdminPermissionCatalog(requestParameters: AccessManagementApiGetAdminPermissionCatalogRequest = {}, options?: RawAxiosRequestConfig) {
        return AccessManagementApiFp(this.configuration).getAdminPermissionCatalog(requestParameters.apiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Получить ролевые, персональные и итоговые права пользователя
     * @param {AccessManagementApiGetAppUserPermissionsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccessManagementApi
     */
    public getAppUserPermissions(requestParameters: AccessManagementApiGetAppUserPermissionsRequest, options?: RawAxiosRequestConfig) {
        return AccessManagementApiFp(this.configuration).getAppUserPermissions(requestParameters.id, requestParameters.apiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Получить страницу внутренних пользователей
     * @param {AccessManagementApiGetAppUsersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccessManagementApi
     */
    public getAppUsers(requestParameters: AccessManagementApiGetAppUsersRequest = {}, options?: RawAxiosRequestConfig) {
        return AccessManagementApiFp(this.configuration).getAppUsers(requestParameters.apiVersion, requestParameters.getAccessAppUsersRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Получить активный каталог прав с группировкой
     * @param {AccessManagementApiGetPermissionCatalogRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccessManagementApi
     */
    public getPermissionCatalog(requestParameters: AccessManagementApiGetPermissionCatalogRequest = {}, options?: RawAxiosRequestConfig) {
        return AccessManagementApiFp(this.configuration).getPermissionCatalog(requestParameters.apiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Получить текущий снимок прав роли
     * @param {AccessManagementApiGetRolePermissionsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccessManagementApi
     */
    public getRolePermissions(requestParameters: AccessManagementApiGetRolePermissionsRequest, options?: RawAxiosRequestConfig) {
        return AccessManagementApiFp(this.configuration).getRolePermissions(requestParameters.role, requestParameters.apiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Получить роли, для которых разрешено настраивать права
     * @param {AccessManagementApiGetRolesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccessManagementApi
     */
    public getRoles(requestParameters: AccessManagementApiGetRolesRequest = {}, options?: RawAxiosRequestConfig) {
        return AccessManagementApiFp(this.configuration).getRoles(requestParameters.apiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Атомарно заменить персональные разрешения и запреты пользователя
     * @param {AccessManagementApiReplaceAppUserPermissionOverridesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccessManagementApi
     */
    public replaceAppUserPermissionOverrides(requestParameters: AccessManagementApiReplaceAppUserPermissionOverridesRequest, options?: RawAxiosRequestConfig) {
        return AccessManagementApiFp(this.configuration).replaceAppUserPermissionOverrides(requestParameters.id, requestParameters.apiVersion, requestParameters.replaceAppUserPermissionOverridesRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Атомарно заменить снимок прав роли
     * @param {AccessManagementApiReplaceRolePermissionsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccessManagementApi
     */
    public replaceRolePermissions(requestParameters: AccessManagementApiReplaceRolePermissionsRequest, options?: RawAxiosRequestConfig) {
        return AccessManagementApiFp(this.configuration).replaceRolePermissions(requestParameters.role, requestParameters.apiVersion, requestParameters.replaceRolePermissionsRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Зарегистрировать или изменить действие административного интерфейса
     * @param {AccessManagementApiSaveAdminPermissionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccessManagementApi
     */
    public saveAdminPermission(requestParameters: AccessManagementApiSaveAdminPermissionRequest = {}, options?: RawAxiosRequestConfig) {
        return AccessManagementApiFp(this.configuration).saveAdminPermission(requestParameters.apiVersion, requestParameters.saveAdminPermissionRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Установить новый пароль внутреннего пользователя
     * @param {AccessManagementApiSetAppUserPasswordRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccessManagementApi
     */
    public setAppUserPassword(requestParameters: AccessManagementApiSetAppUserPasswordRequest, options?: RawAxiosRequestConfig) {
        return AccessManagementApiFp(this.configuration).setAppUserPassword(requestParameters.id, requestParameters.apiVersion, requestParameters.setAccessAppUserPasswordRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Синхронизировать каталог с актуальными MVC actions и деактивировать отсутствующие
     * @param {AccessManagementApiSynchronizePermissionCatalogRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccessManagementApi
     */
    public synchronizePermissionCatalog(requestParameters: AccessManagementApiSynchronizePermissionCatalogRequest = {}, options?: RawAxiosRequestConfig) {
        return AccessManagementApiFp(this.configuration).synchronizePermissionCatalog(requestParameters.apiVersion, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AddressApi - axios parameter creator
 * @export
 */
export const AddressApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Найти адреса по строке поиска и городу
         * @param {string} [city] 
         * @param {string} [search] 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchAddress: async (city?: string, search?: string, apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/addresses/search-address`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (city !== undefined) {
                localVarQueryParameter['city'] = city;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }


    
            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AddressApi - functional programming interface
 * @export
 */
export const AddressApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AddressApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Найти адреса по строке поиска и городу
         * @param {string} [city] 
         * @param {string} [search] 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async searchAddress(city?: string, search?: string, apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<string>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.searchAddress(city, search, apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AddressApi.searchAddress']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AddressApi - factory interface
 * @export
 */
export const AddressApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AddressApiFp(configuration)
    return {
        /**
         * 
         * @summary Найти адреса по строке поиска и городу
         * @param {AddressApiSearchAddressRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchAddress(requestParameters: AddressApiSearchAddressRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<Array<string>> {
            return localVarFp.searchAddress(requestParameters.city, requestParameters.search, requestParameters.apiVersion, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for searchAddress operation in AddressApi.
 * @export
 * @interface AddressApiSearchAddressRequest
 */
export interface AddressApiSearchAddressRequest {
    /**
     * 
     * @type {string}
     * @memberof AddressApiSearchAddress
     */
    readonly city?: string

    /**
     * 
     * @type {string}
     * @memberof AddressApiSearchAddress
     */
    readonly search?: string

    /**
     * 
     * @type {string}
     * @memberof AddressApiSearchAddress
     */
    readonly apiVersion?: string
}

/**
 * AddressApi - object-oriented interface
 * @export
 * @class AddressApi
 * @extends {BaseAPI}
 */
export class AddressApi extends BaseAPI {
    /**
     * 
     * @summary Найти адреса по строке поиска и городу
     * @param {AddressApiSearchAddressRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AddressApi
     */
    public searchAddress(requestParameters: AddressApiSearchAddressRequest = {}, options?: RawAxiosRequestConfig) {
        return AddressApiFp(this.configuration).searchAddress(requestParameters.city, requestParameters.search, requestParameters.apiVersion, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AdminAccessApi - axios parameter creator
 * @export
 */
export const AdminAccessApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Получить доступные разделы, просмотры и действия
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCurrentAdminAccess: async (apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/admin-access/current`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AdminAccessApi - functional programming interface
 * @export
 */
export const AdminAccessApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AdminAccessApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Получить доступные разделы, просмотры и действия
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCurrentAdminAccess(apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminAccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCurrentAdminAccess(apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminAccessApi.getCurrentAdminAccess']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AdminAccessApi - factory interface
 * @export
 */
export const AdminAccessApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AdminAccessApiFp(configuration)
    return {
        /**
         * 
         * @summary Получить доступные разделы, просмотры и действия
         * @param {AdminAccessApiGetCurrentAdminAccessRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCurrentAdminAccess(requestParameters: AdminAccessApiGetCurrentAdminAccessRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<AdminAccessResponse> {
            return localVarFp.getCurrentAdminAccess(requestParameters.apiVersion, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for getCurrentAdminAccess operation in AdminAccessApi.
 * @export
 * @interface AdminAccessApiGetCurrentAdminAccessRequest
 */
export interface AdminAccessApiGetCurrentAdminAccessRequest {
    /**
     * 
     * @type {string}
     * @memberof AdminAccessApiGetCurrentAdminAccess
     */
    readonly apiVersion?: string
}

/**
 * AdminAccessApi - object-oriented interface
 * @export
 * @class AdminAccessApi
 * @extends {BaseAPI}
 */
export class AdminAccessApi extends BaseAPI {
    /**
     * 
     * @summary Получить доступные разделы, просмотры и действия
     * @param {AdminAccessApiGetCurrentAdminAccessRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminAccessApi
     */
    public getCurrentAdminAccess(requestParameters: AdminAccessApiGetCurrentAdminAccessRequest = {}, options?: RawAxiosRequestConfig) {
        return AdminAccessApiFp(this.configuration).getCurrentAdminAccess(requestParameters.apiVersion, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AmmunitionApi - axios parameter creator
 * @export
 */
export const AmmunitionApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Создать запись снаряжения и вернуть ссылку на неё
         * @param {string} [apiVersion] 
         * @param {CreateAmmunitionRequest} [createAmmunitionRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AmmunitionCreateAmmunitionPost: async (apiVersion?: string, createAmmunitionRequest?: CreateAmmunitionRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/ammunition/create-ammunition`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createAmmunitionRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Удалить запись снаряжения
         * @param {string} id 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AmmunitionDeleteAmmunitionIdDelete: async (id: string, apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiV1AmmunitionDeleteAmmunitionIdDelete', 'id', id)
            const localVarPath = `/api/v1/ammunition/delete-ammunition/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Получить справочник снаряжения
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AmmunitionGetAllAmmunitionGet: async (apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/ammunition/get-all-ammunition`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Получить снаряжение по идентификатору
         * @param {string} id 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AmmunitionGetammunitionbyIdGet: async (id: string, apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiV1AmmunitionGetammunitionbyIdGet', 'id', id)
            const localVarPath = `/api/v1/ammunition/getammunitionby/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Обновить запись снаряжения
         * @param {string} id 
         * @param {string} [apiVersion] 
         * @param {UpdateAmmunitionRequest} [updateAmmunitionRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AmmunitionUpdateAmmunitionIdPut: async (id: string, apiVersion?: string, updateAmmunitionRequest?: UpdateAmmunitionRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiV1AmmunitionUpdateAmmunitionIdPut', 'id', id)
            const localVarPath = `/api/v1/ammunition/update-ammunition/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateAmmunitionRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AmmunitionApi - functional programming interface
 * @export
 */
export const AmmunitionApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AmmunitionApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Создать запись снаряжения и вернуть ссылку на неё
         * @param {string} [apiVersion] 
         * @param {CreateAmmunitionRequest} [createAmmunitionRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1AmmunitionCreateAmmunitionPost(apiVersion?: string, createAmmunitionRequest?: CreateAmmunitionRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AmmunitionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1AmmunitionCreateAmmunitionPost(apiVersion, createAmmunitionRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AmmunitionApi.apiV1AmmunitionCreateAmmunitionPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Удалить запись снаряжения
         * @param {string} id 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1AmmunitionDeleteAmmunitionIdDelete(id: string, apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1AmmunitionDeleteAmmunitionIdDelete(id, apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AmmunitionApi.apiV1AmmunitionDeleteAmmunitionIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Получить справочник снаряжения
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1AmmunitionGetAllAmmunitionGet(apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AmmunitionResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1AmmunitionGetAllAmmunitionGet(apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AmmunitionApi.apiV1AmmunitionGetAllAmmunitionGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Получить снаряжение по идентификатору
         * @param {string} id 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1AmmunitionGetammunitionbyIdGet(id: string, apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AmmunitionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1AmmunitionGetammunitionbyIdGet(id, apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AmmunitionApi.apiV1AmmunitionGetammunitionbyIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Обновить запись снаряжения
         * @param {string} id 
         * @param {string} [apiVersion] 
         * @param {UpdateAmmunitionRequest} [updateAmmunitionRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1AmmunitionUpdateAmmunitionIdPut(id: string, apiVersion?: string, updateAmmunitionRequest?: UpdateAmmunitionRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AmmunitionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1AmmunitionUpdateAmmunitionIdPut(id, apiVersion, updateAmmunitionRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AmmunitionApi.apiV1AmmunitionUpdateAmmunitionIdPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AmmunitionApi - factory interface
 * @export
 */
export const AmmunitionApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AmmunitionApiFp(configuration)
    return {
        /**
         * 
         * @summary Создать запись снаряжения и вернуть ссылку на неё
         * @param {AmmunitionApiApiV1AmmunitionCreateAmmunitionPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AmmunitionCreateAmmunitionPost(requestParameters: AmmunitionApiApiV1AmmunitionCreateAmmunitionPostRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<AmmunitionResponse> {
            return localVarFp.apiV1AmmunitionCreateAmmunitionPost(requestParameters.apiVersion, requestParameters.createAmmunitionRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Удалить запись снаряжения
         * @param {AmmunitionApiApiV1AmmunitionDeleteAmmunitionIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AmmunitionDeleteAmmunitionIdDelete(requestParameters: AmmunitionApiApiV1AmmunitionDeleteAmmunitionIdDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiV1AmmunitionDeleteAmmunitionIdDelete(requestParameters.id, requestParameters.apiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Получить справочник снаряжения
         * @param {AmmunitionApiApiV1AmmunitionGetAllAmmunitionGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AmmunitionGetAllAmmunitionGet(requestParameters: AmmunitionApiApiV1AmmunitionGetAllAmmunitionGetRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<Array<AmmunitionResponse>> {
            return localVarFp.apiV1AmmunitionGetAllAmmunitionGet(requestParameters.apiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Получить снаряжение по идентификатору
         * @param {AmmunitionApiApiV1AmmunitionGetammunitionbyIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AmmunitionGetammunitionbyIdGet(requestParameters: AmmunitionApiApiV1AmmunitionGetammunitionbyIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<AmmunitionResponse> {
            return localVarFp.apiV1AmmunitionGetammunitionbyIdGet(requestParameters.id, requestParameters.apiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Обновить запись снаряжения
         * @param {AmmunitionApiApiV1AmmunitionUpdateAmmunitionIdPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AmmunitionUpdateAmmunitionIdPut(requestParameters: AmmunitionApiApiV1AmmunitionUpdateAmmunitionIdPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<AmmunitionResponse> {
            return localVarFp.apiV1AmmunitionUpdateAmmunitionIdPut(requestParameters.id, requestParameters.apiVersion, requestParameters.updateAmmunitionRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for apiV1AmmunitionCreateAmmunitionPost operation in AmmunitionApi.
 * @export
 * @interface AmmunitionApiApiV1AmmunitionCreateAmmunitionPostRequest
 */
export interface AmmunitionApiApiV1AmmunitionCreateAmmunitionPostRequest {
    /**
     * 
     * @type {string}
     * @memberof AmmunitionApiApiV1AmmunitionCreateAmmunitionPost
     */
    readonly apiVersion?: string

    /**
     * 
     * @type {CreateAmmunitionRequest}
     * @memberof AmmunitionApiApiV1AmmunitionCreateAmmunitionPost
     */
    readonly createAmmunitionRequest?: CreateAmmunitionRequest
}

/**
 * Request parameters for apiV1AmmunitionDeleteAmmunitionIdDelete operation in AmmunitionApi.
 * @export
 * @interface AmmunitionApiApiV1AmmunitionDeleteAmmunitionIdDeleteRequest
 */
export interface AmmunitionApiApiV1AmmunitionDeleteAmmunitionIdDeleteRequest {
    /**
     * 
     * @type {string}
     * @memberof AmmunitionApiApiV1AmmunitionDeleteAmmunitionIdDelete
     */
    readonly id: string

    /**
     * 
     * @type {string}
     * @memberof AmmunitionApiApiV1AmmunitionDeleteAmmunitionIdDelete
     */
    readonly apiVersion?: string
}

/**
 * Request parameters for apiV1AmmunitionGetAllAmmunitionGet operation in AmmunitionApi.
 * @export
 * @interface AmmunitionApiApiV1AmmunitionGetAllAmmunitionGetRequest
 */
export interface AmmunitionApiApiV1AmmunitionGetAllAmmunitionGetRequest {
    /**
     * 
     * @type {string}
     * @memberof AmmunitionApiApiV1AmmunitionGetAllAmmunitionGet
     */
    readonly apiVersion?: string
}

/**
 * Request parameters for apiV1AmmunitionGetammunitionbyIdGet operation in AmmunitionApi.
 * @export
 * @interface AmmunitionApiApiV1AmmunitionGetammunitionbyIdGetRequest
 */
export interface AmmunitionApiApiV1AmmunitionGetammunitionbyIdGetRequest {
    /**
     * 
     * @type {string}
     * @memberof AmmunitionApiApiV1AmmunitionGetammunitionbyIdGet
     */
    readonly id: string

    /**
     * 
     * @type {string}
     * @memberof AmmunitionApiApiV1AmmunitionGetammunitionbyIdGet
     */
    readonly apiVersion?: string
}

/**
 * Request parameters for apiV1AmmunitionUpdateAmmunitionIdPut operation in AmmunitionApi.
 * @export
 * @interface AmmunitionApiApiV1AmmunitionUpdateAmmunitionIdPutRequest
 */
export interface AmmunitionApiApiV1AmmunitionUpdateAmmunitionIdPutRequest {
    /**
     * 
     * @type {string}
     * @memberof AmmunitionApiApiV1AmmunitionUpdateAmmunitionIdPut
     */
    readonly id: string

    /**
     * 
     * @type {string}
     * @memberof AmmunitionApiApiV1AmmunitionUpdateAmmunitionIdPut
     */
    readonly apiVersion?: string

    /**
     * 
     * @type {UpdateAmmunitionRequest}
     * @memberof AmmunitionApiApiV1AmmunitionUpdateAmmunitionIdPut
     */
    readonly updateAmmunitionRequest?: UpdateAmmunitionRequest
}

/**
 * AmmunitionApi - object-oriented interface
 * @export
 * @class AmmunitionApi
 * @extends {BaseAPI}
 */
export class AmmunitionApi extends BaseAPI {
    /**
     * 
     * @summary Создать запись снаряжения и вернуть ссылку на неё
     * @param {AmmunitionApiApiV1AmmunitionCreateAmmunitionPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AmmunitionApi
     */
    public apiV1AmmunitionCreateAmmunitionPost(requestParameters: AmmunitionApiApiV1AmmunitionCreateAmmunitionPostRequest = {}, options?: RawAxiosRequestConfig) {
        return AmmunitionApiFp(this.configuration).apiV1AmmunitionCreateAmmunitionPost(requestParameters.apiVersion, requestParameters.createAmmunitionRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Удалить запись снаряжения
     * @param {AmmunitionApiApiV1AmmunitionDeleteAmmunitionIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AmmunitionApi
     */
    public apiV1AmmunitionDeleteAmmunitionIdDelete(requestParameters: AmmunitionApiApiV1AmmunitionDeleteAmmunitionIdDeleteRequest, options?: RawAxiosRequestConfig) {
        return AmmunitionApiFp(this.configuration).apiV1AmmunitionDeleteAmmunitionIdDelete(requestParameters.id, requestParameters.apiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Получить справочник снаряжения
     * @param {AmmunitionApiApiV1AmmunitionGetAllAmmunitionGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AmmunitionApi
     */
    public apiV1AmmunitionGetAllAmmunitionGet(requestParameters: AmmunitionApiApiV1AmmunitionGetAllAmmunitionGetRequest = {}, options?: RawAxiosRequestConfig) {
        return AmmunitionApiFp(this.configuration).apiV1AmmunitionGetAllAmmunitionGet(requestParameters.apiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Получить снаряжение по идентификатору
     * @param {AmmunitionApiApiV1AmmunitionGetammunitionbyIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AmmunitionApi
     */
    public apiV1AmmunitionGetammunitionbyIdGet(requestParameters: AmmunitionApiApiV1AmmunitionGetammunitionbyIdGetRequest, options?: RawAxiosRequestConfig) {
        return AmmunitionApiFp(this.configuration).apiV1AmmunitionGetammunitionbyIdGet(requestParameters.id, requestParameters.apiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Обновить запись снаряжения
     * @param {AmmunitionApiApiV1AmmunitionUpdateAmmunitionIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AmmunitionApi
     */
    public apiV1AmmunitionUpdateAmmunitionIdPut(requestParameters: AmmunitionApiApiV1AmmunitionUpdateAmmunitionIdPutRequest, options?: RawAxiosRequestConfig) {
        return AmmunitionApiFp(this.configuration).apiV1AmmunitionUpdateAmmunitionIdPut(requestParameters.id, requestParameters.apiVersion, requestParameters.updateAmmunitionRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AnswerApi - axios parameter creator
 * @export
 */
export const AnswerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Добавить новый ответ к вопросу.
         * @param {string} [apiVersion] 
         * @param {CreateAnswerRequest} [createAnswerRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAnswer: async (apiVersion?: string, createAnswerRequest?: CreateAnswerRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/answers/create-answer`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createAnswerRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Удалить ответ.
         * @param {number} id 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAnswer: async (id: number, apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteAnswer', 'id', id)
            const localVarPath = `/api/v1/answers/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Получить ответ по идентификатору  с отметкой верно или нет.
         * @param {number} id 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAnswerById: async (id: number, apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getAnswerById', 'id', id)
            const localVarPath = `/api/v1/answers/get-answer-by-id/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Получить все ответы по вопросу с отметкой верно или нет.
         * @param {number} questionId 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAnswersByQuestionId: async (questionId: number, apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'questionId' is not null or undefined
            assertParamExists('getAnswersByQuestionId', 'questionId', questionId)
            const localVarPath = `/api/v1/answers/get-answer-by-test-id/{questionId}`
                .replace(`{${"questionId"}}`, encodeURIComponent(String(questionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Обновить существующий ответ.
         * @param {string} [apiVersion] 
         * @param {UpdateAnswerRequest} [updateAnswerRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAnswer: async (apiVersion?: string, updateAnswerRequest?: UpdateAnswerRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/answers/update-answer`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateAnswerRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AnswerApi - functional programming interface
 * @export
 */
export const AnswerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AnswerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Добавить новый ответ к вопросу.
         * @param {string} [apiVersion] 
         * @param {CreateAnswerRequest} [createAnswerRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createAnswer(apiVersion?: string, createAnswerRequest?: CreateAnswerRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetAnswerResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createAnswer(apiVersion, createAnswerRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AnswerApi.createAnswer']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Удалить ответ.
         * @param {number} id 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteAnswer(id: number, apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteAnswer(id, apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AnswerApi.deleteAnswer']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Получить ответ по идентификатору  с отметкой верно или нет.
         * @param {number} id 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAnswerById(id: number, apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetAnswerResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAnswerById(id, apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AnswerApi.getAnswerById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Получить все ответы по вопросу с отметкой верно или нет.
         * @param {number} questionId 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAnswersByQuestionId(questionId: number, apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetAnswerResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAnswersByQuestionId(questionId, apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AnswerApi.getAnswersByQuestionId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Обновить существующий ответ.
         * @param {string} [apiVersion] 
         * @param {UpdateAnswerRequest} [updateAnswerRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateAnswer(apiVersion?: string, updateAnswerRequest?: UpdateAnswerRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetAnswerResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateAnswer(apiVersion, updateAnswerRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AnswerApi.updateAnswer']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AnswerApi - factory interface
 * @export
 */
export const AnswerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AnswerApiFp(configuration)
    return {
        /**
         * 
         * @summary Добавить новый ответ к вопросу.
         * @param {AnswerApiCreateAnswerRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAnswer(requestParameters: AnswerApiCreateAnswerRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<GetAnswerResponse> {
            return localVarFp.createAnswer(requestParameters.apiVersion, requestParameters.createAnswerRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Удалить ответ.
         * @param {AnswerApiDeleteAnswerRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAnswer(requestParameters: AnswerApiDeleteAnswerRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteAnswer(requestParameters.id, requestParameters.apiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Получить ответ по идентификатору  с отметкой верно или нет.
         * @param {AnswerApiGetAnswerByIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAnswerById(requestParameters: AnswerApiGetAnswerByIdRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetAnswerResponse> {
            return localVarFp.getAnswerById(requestParameters.id, requestParameters.apiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Получить все ответы по вопросу с отметкой верно или нет.
         * @param {AnswerApiGetAnswersByQuestionIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAnswersByQuestionId(requestParameters: AnswerApiGetAnswersByQuestionIdRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<GetAnswerResponse>> {
            return localVarFp.getAnswersByQuestionId(requestParameters.questionId, requestParameters.apiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Обновить существующий ответ.
         * @param {AnswerApiUpdateAnswerRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAnswer(requestParameters: AnswerApiUpdateAnswerRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<GetAnswerResponse> {
            return localVarFp.updateAnswer(requestParameters.apiVersion, requestParameters.updateAnswerRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for createAnswer operation in AnswerApi.
 * @export
 * @interface AnswerApiCreateAnswerRequest
 */
export interface AnswerApiCreateAnswerRequest {
    /**
     * 
     * @type {string}
     * @memberof AnswerApiCreateAnswer
     */
    readonly apiVersion?: string

    /**
     * 
     * @type {CreateAnswerRequest}
     * @memberof AnswerApiCreateAnswer
     */
    readonly createAnswerRequest?: CreateAnswerRequest
}

/**
 * Request parameters for deleteAnswer operation in AnswerApi.
 * @export
 * @interface AnswerApiDeleteAnswerRequest
 */
export interface AnswerApiDeleteAnswerRequest {
    /**
     * 
     * @type {number}
     * @memberof AnswerApiDeleteAnswer
     */
    readonly id: number

    /**
     * 
     * @type {string}
     * @memberof AnswerApiDeleteAnswer
     */
    readonly apiVersion?: string
}

/**
 * Request parameters for getAnswerById operation in AnswerApi.
 * @export
 * @interface AnswerApiGetAnswerByIdRequest
 */
export interface AnswerApiGetAnswerByIdRequest {
    /**
     * 
     * @type {number}
     * @memberof AnswerApiGetAnswerById
     */
    readonly id: number

    /**
     * 
     * @type {string}
     * @memberof AnswerApiGetAnswerById
     */
    readonly apiVersion?: string
}

/**
 * Request parameters for getAnswersByQuestionId operation in AnswerApi.
 * @export
 * @interface AnswerApiGetAnswersByQuestionIdRequest
 */
export interface AnswerApiGetAnswersByQuestionIdRequest {
    /**
     * 
     * @type {number}
     * @memberof AnswerApiGetAnswersByQuestionId
     */
    readonly questionId: number

    /**
     * 
     * @type {string}
     * @memberof AnswerApiGetAnswersByQuestionId
     */
    readonly apiVersion?: string
}

/**
 * Request parameters for updateAnswer operation in AnswerApi.
 * @export
 * @interface AnswerApiUpdateAnswerRequest
 */
export interface AnswerApiUpdateAnswerRequest {
    /**
     * 
     * @type {string}
     * @memberof AnswerApiUpdateAnswer
     */
    readonly apiVersion?: string

    /**
     * 
     * @type {UpdateAnswerRequest}
     * @memberof AnswerApiUpdateAnswer
     */
    readonly updateAnswerRequest?: UpdateAnswerRequest
}

/**
 * AnswerApi - object-oriented interface
 * @export
 * @class AnswerApi
 * @extends {BaseAPI}
 */
export class AnswerApi extends BaseAPI {
    /**
     * 
     * @summary Добавить новый ответ к вопросу.
     * @param {AnswerApiCreateAnswerRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AnswerApi
     */
    public createAnswer(requestParameters: AnswerApiCreateAnswerRequest = {}, options?: RawAxiosRequestConfig) {
        return AnswerApiFp(this.configuration).createAnswer(requestParameters.apiVersion, requestParameters.createAnswerRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Удалить ответ.
     * @param {AnswerApiDeleteAnswerRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AnswerApi
     */
    public deleteAnswer(requestParameters: AnswerApiDeleteAnswerRequest, options?: RawAxiosRequestConfig) {
        return AnswerApiFp(this.configuration).deleteAnswer(requestParameters.id, requestParameters.apiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Получить ответ по идентификатору  с отметкой верно или нет.
     * @param {AnswerApiGetAnswerByIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AnswerApi
     */
    public getAnswerById(requestParameters: AnswerApiGetAnswerByIdRequest, options?: RawAxiosRequestConfig) {
        return AnswerApiFp(this.configuration).getAnswerById(requestParameters.id, requestParameters.apiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Получить все ответы по вопросу с отметкой верно или нет.
     * @param {AnswerApiGetAnswersByQuestionIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AnswerApi
     */
    public getAnswersByQuestionId(requestParameters: AnswerApiGetAnswersByQuestionIdRequest, options?: RawAxiosRequestConfig) {
        return AnswerApiFp(this.configuration).getAnswersByQuestionId(requestParameters.questionId, requestParameters.apiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Обновить существующий ответ.
     * @param {AnswerApiUpdateAnswerRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AnswerApi
     */
    public updateAnswer(requestParameters: AnswerApiUpdateAnswerRequest = {}, options?: RawAxiosRequestConfig) {
        return AnswerApiFp(this.configuration).updateAnswer(requestParameters.apiVersion, requestParameters.updateAnswerRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AppChatApi - axios parameter creator
 * @export
 */
export const AppChatApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Найти существующую переписку поддержки
         * @param {string} [companionAppUserId] 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAppChat: async (companionAppUserId?: string, apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/admin/chats/direct`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (companionAppUserId !== undefined) {
                localVarQueryParameter['companionAppUserId'] = companionAppUserId;
            }


    
            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Получить активность переписки пользователей
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAppChatActivity: async (apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/admin/chats/activity`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Получить счётчики переписки приложения
         * @param {string} [ownerAppUserId] 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAppChatCounters: async (ownerAppUserId?: string, apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/admin/chats/counters`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (ownerAppUserId !== undefined) {
                localVarQueryParameter['ownerAppUserId'] = ownerAppUserId;
            }


    
            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Получить историю правок сообщения приложения
         * @param {string} dialogId 
         * @param {string} messageId 
         * @param {string} [ownerAppUserId] 
         * @param {number} [beforeVersion] 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAppChatMessageEdits: async (dialogId: string, messageId: string, ownerAppUserId?: string, beforeVersion?: number, apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'dialogId' is not null or undefined
            assertParamExists('getAppChatMessageEdits', 'dialogId', dialogId)
            // verify required parameter 'messageId' is not null or undefined
            assertParamExists('getAppChatMessageEdits', 'messageId', messageId)
            const localVarPath = `/api/v1/admin/chats/{dialogId}/messages/{messageId}/edits`
                .replace(`{${"dialogId"}}`, encodeURIComponent(String(dialogId)))
                .replace(`{${"messageId"}}`, encodeURIComponent(String(messageId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (ownerAppUserId !== undefined) {
                localVarQueryParameter['ownerAppUserId'] = ownerAppUserId;
            }

            if (beforeVersion !== undefined) {
                localVarQueryParameter['beforeVersion'] = beforeVersion;
            }


    
            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Получить историю переписки приложения
         * @param {string} dialogId 
         * @param {string} [ownerAppUserId] 
         * @param {number} [beforeSequence] Получить сообщения раньше указанного номера
         * @param {number} [limit] Размер страницы
         * @param {number} [afterSequence] 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAppChatMessages: async (dialogId: string, ownerAppUserId?: string, beforeSequence?: number, limit?: number, afterSequence?: number, apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'dialogId' is not null or undefined
            assertParamExists('getAppChatMessages', 'dialogId', dialogId)
            const localVarPath = `/api/v1/admin/chats/{dialogId}/messages`
                .replace(`{${"dialogId"}}`, encodeURIComponent(String(dialogId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (ownerAppUserId !== undefined) {
                localVarQueryParameter['ownerAppUserId'] = ownerAppUserId;
            }

            if (beforeSequence !== undefined) {
                localVarQueryParameter['BeforeSequence'] = beforeSequence;
            }

            if (limit !== undefined) {
                localVarQueryParameter['Limit'] = limit;
            }

            if (afterSequence !== undefined) {
                localVarQueryParameter['afterSequence'] = afterSequence;
            }


    
            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Получить доступ к обновлениям приложения
         * @param {string} [ownerAppUserId] 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAppChatRealtime: async (ownerAppUserId?: string, apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/admin/chats/realtime`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (ownerAppUserId !== undefined) {
                localVarQueryParameter['ownerAppUserId'] = ownerAppUserId;
            }


    
            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Получить согласованное состояние переписки приложения
         * @param {string} [ownerAppUserId] 
         * @param {Array<string>} [appUserIds] Выбранные учётные записи собеседников
         * @param {boolean} [filterPeople] Ограничивать список выбранными собеседниками
         * @param {ApiUserRole} [companionRole] Роль собеседника среди пользователей приложения VOX
         * @param {Array<number>} [channels] Каналы связи
         * @param {string} [companionName] Слова имени или фамилии собеседника VOX либо Salebot
         * @param {string} [petName] Часть имени питомца собеседника
         * @param {boolean} [unreadOnly] Только непрочитанные диалоги
         * @param {number} [dialogLimit] Число показанных диалогов
         * @param {string} [dialogId] Выбранный диалог
         * @param {number} [oldestSequence] Первое показанное сообщение
         * @param {number} [beforeSequence] Граница загрузки старой истории
         * @param {number} [newestSequence] Последнее показанное сообщение
         * @param {number} [afterSequence] Граница следующей непрочитанной страницы приложения
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAppChatSnapshot: async (ownerAppUserId?: string, appUserIds?: Array<string>, filterPeople?: boolean, companionRole?: ApiUserRole, channels?: Array<number>, companionName?: string, petName?: string, unreadOnly?: boolean, dialogLimit?: number, dialogId?: string, oldestSequence?: number, beforeSequence?: number, newestSequence?: number, afterSequence?: number, apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/admin/chats/realtime/snapshot`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (ownerAppUserId !== undefined) {
                localVarQueryParameter['ownerAppUserId'] = ownerAppUserId;
            }

            if (appUserIds) {
                localVarQueryParameter['AppUserIds'] = appUserIds;
            }

            if (filterPeople !== undefined) {
                localVarQueryParameter['FilterPeople'] = filterPeople;
            }

            if (companionRole !== undefined) {
                localVarQueryParameter['CompanionRole'] = companionRole;
            }

            if (channels) {
                localVarQueryParameter['Channels'] = channels;
            }

            if (companionName !== undefined) {
                localVarQueryParameter['CompanionName'] = companionName;
            }

            if (petName !== undefined) {
                localVarQueryParameter['PetName'] = petName;
            }

            if (unreadOnly !== undefined) {
                localVarQueryParameter['UnreadOnly'] = unreadOnly;
            }

            if (dialogLimit !== undefined) {
                localVarQueryParameter['DialogLimit'] = dialogLimit;
            }

            if (dialogId !== undefined) {
                localVarQueryParameter['DialogId'] = dialogId;
            }

            if (oldestSequence !== undefined) {
                localVarQueryParameter['OldestSequence'] = oldestSequence;
            }

            if (beforeSequence !== undefined) {
                localVarQueryParameter['BeforeSequence'] = beforeSequence;
            }

            if (newestSequence !== undefined) {
                localVarQueryParameter['NewestSequence'] = newestSequence;
            }

            if (afterSequence !== undefined) {
                localVarQueryParameter['AfterSequence'] = afterSequence;
            }


    
            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Получить переписки приложения
         * @param {string} [ownerAppUserId] 
         * @param {boolean} [pinnedOnly] Показывать только общие закрепления операторов
         * @param {Array<string>} [appUserIds] Выбранные учётные записи собеседников
         * @param {boolean} [filterPeople] Ограничивать список выбранными собеседниками
         * @param {ApiUserRole} [companionRole] Роль собеседника среди пользователей приложения VOX
         * @param {Array<number>} [channels] Каналы связи
         * @param {string} [companionName] Слова имени или фамилии собеседника VOX либо Salebot
         * @param {string} [petName] Часть имени питомца собеседника
         * @param {boolean} [unreadOnly] Показывать только диалоги с непрочитанными сообщениями
         * @param {string} [dialogId] Идентификатор диалога
         * @param {number} [offset] Смещение страницы
         * @param {number} [limit] Размер страницы
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAppChats: async (ownerAppUserId?: string, pinnedOnly?: boolean, appUserIds?: Array<string>, filterPeople?: boolean, companionRole?: ApiUserRole, channels?: Array<number>, companionName?: string, petName?: string, unreadOnly?: boolean, dialogId?: string, offset?: number, limit?: number, apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/admin/chats`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (ownerAppUserId !== undefined) {
                localVarQueryParameter['ownerAppUserId'] = ownerAppUserId;
            }

            if (pinnedOnly !== undefined) {
                localVarQueryParameter['PinnedOnly'] = pinnedOnly;
            }

            if (appUserIds) {
                localVarQueryParameter['AppUserIds'] = appUserIds;
            }

            if (filterPeople !== undefined) {
                localVarQueryParameter['FilterPeople'] = filterPeople;
            }

            if (companionRole !== undefined) {
                localVarQueryParameter['CompanionRole'] = companionRole;
            }

            if (channels) {
                localVarQueryParameter['Channels'] = channels;
            }

            if (companionName !== undefined) {
                localVarQueryParameter['CompanionName'] = companionName;
            }

            if (petName !== undefined) {
                localVarQueryParameter['PetName'] = petName;
            }

            if (unreadOnly !== undefined) {
                localVarQueryParameter['UnreadOnly'] = unreadOnly;
            }

            if (dialogId !== undefined) {
                localVarQueryParameter['DialogId'] = dialogId;
            }

            if (offset !== undefined) {
                localVarQueryParameter['Offset'] = offset;
            }

            if (limit !== undefined) {
                localVarQueryParameter['Limit'] = limit;
            }


    
            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Создать или найти переписку поддержки
         * @param {string} [apiVersion] 
         * @param {CreateAppChatRequest} [createAppChatRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrCreateAppChat: async (apiVersion?: string, createAppChatRequest?: CreateAppChatRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/admin/chats/direct`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createAppChatRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Подтвердить прочтение переписки приложения
         * @param {string} dialogId 
         * @param {string} [apiVersion] 
         * @param {MarkChatDialogReadRequest} [markChatDialogReadRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        markAppChatRead: async (dialogId: string, apiVersion?: string, markChatDialogReadRequest?: MarkChatDialogReadRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'dialogId' is not null or undefined
            assertParamExists('markAppChatRead', 'dialogId', dialogId)
            const localVarPath = `/api/v1/admin/chats/{dialogId}/read`
                .replace(`{${"dialogId"}}`, encodeURIComponent(String(dialogId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(markChatDialogReadRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Отметить всю переписку прочитанной
         * @param {string} dialogId 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        markAppChatReadAll: async (dialogId: string, apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'dialogId' is not null or undefined
            assertParamExists('markAppChatReadAll', 'dialogId', dialogId)
            const localVarPath = `/api/v1/admin/chats/{dialogId}/read-all`
                .replace(`{${"dialogId"}}`, encodeURIComponent(String(dialogId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Отметить диалог непрочитанным
         * @param {string} dialogId 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        markAppChatUnread: async (dialogId: string, apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'dialogId' is not null or undefined
            assertParamExists('markAppChatUnread', 'dialogId', dialogId)
            const localVarPath = `/api/v1/admin/chats/{dialogId}/unread`
                .replace(`{${"dialogId"}}`, encodeURIComponent(String(dialogId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Найти переписку приложения по ссылке
         * @param {string} chatId 
         * @param {string} [ownerAppUserId] 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resolveAppChat: async (chatId: string, ownerAppUserId?: string, apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'chatId' is not null or undefined
            assertParamExists('resolveAppChat', 'chatId', chatId)
            const localVarPath = `/api/v1/admin/chats/{chatId}/resolve`
                .replace(`{${"chatId"}}`, encodeURIComponent(String(chatId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (ownerAppUserId !== undefined) {
                localVarQueryParameter['ownerAppUserId'] = ownerAppUserId;
            }


    
            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Ответить в переписке приложения
         * @param {string} dialogId 
         * @param {string} [apiVersion] 
         * @param {SendChatDialogMessageRequest} [sendChatDialogMessageRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendAppChatMessage: async (dialogId: string, apiVersion?: string, sendChatDialogMessageRequest?: SendChatDialogMessageRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'dialogId' is not null or undefined
            assertParamExists('sendAppChatMessage', 'dialogId', dialogId)
            const localVarPath = `/api/v1/admin/chats/{dialogId}/messages`
                .replace(`{${"dialogId"}}`, encodeURIComponent(String(dialogId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(sendChatDialogMessageRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AppChatApi - functional programming interface
 * @export
 */
export const AppChatApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AppChatApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Найти существующую переписку поддержки
         * @param {string} [companionAppUserId] 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findAppChat(companionAppUserId?: string, apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ChatDialogPageResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findAppChat(companionAppUserId, apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AppChatApi.findAppChat']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Получить активность переписки пользователей
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAppChatActivity(apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AppChatActivityResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAppChatActivity(apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AppChatApi.getAppChatActivity']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Получить счётчики переписки приложения
         * @param {string} [ownerAppUserId] 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAppChatCounters(ownerAppUserId?: string, apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ChatDialogCountersResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAppChatCounters(ownerAppUserId, apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AppChatApi.getAppChatCounters']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Получить историю правок сообщения приложения
         * @param {string} dialogId 
         * @param {string} messageId 
         * @param {string} [ownerAppUserId] 
         * @param {number} [beforeVersion] 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAppChatMessageEdits(dialogId: string, messageId: string, ownerAppUserId?: string, beforeVersion?: number, apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ChatMessageEditResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAppChatMessageEdits(dialogId, messageId, ownerAppUserId, beforeVersion, apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AppChatApi.getAppChatMessageEdits']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Получить историю переписки приложения
         * @param {string} dialogId 
         * @param {string} [ownerAppUserId] 
         * @param {number} [beforeSequence] Получить сообщения раньше указанного номера
         * @param {number} [limit] Размер страницы
         * @param {number} [afterSequence] 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAppChatMessages(dialogId: string, ownerAppUserId?: string, beforeSequence?: number, limit?: number, afterSequence?: number, apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ChatDialogMessagePageResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAppChatMessages(dialogId, ownerAppUserId, beforeSequence, limit, afterSequence, apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AppChatApi.getAppChatMessages']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Получить доступ к обновлениям приложения
         * @param {string} [ownerAppUserId] 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAppChatRealtime(ownerAppUserId?: string, apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ChatRealtimeResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAppChatRealtime(ownerAppUserId, apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AppChatApi.getAppChatRealtime']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Получить согласованное состояние переписки приложения
         * @param {string} [ownerAppUserId] 
         * @param {Array<string>} [appUserIds] Выбранные учётные записи собеседников
         * @param {boolean} [filterPeople] Ограничивать список выбранными собеседниками
         * @param {ApiUserRole} [companionRole] Роль собеседника среди пользователей приложения VOX
         * @param {Array<number>} [channels] Каналы связи
         * @param {string} [companionName] Слова имени или фамилии собеседника VOX либо Salebot
         * @param {string} [petName] Часть имени питомца собеседника
         * @param {boolean} [unreadOnly] Только непрочитанные диалоги
         * @param {number} [dialogLimit] Число показанных диалогов
         * @param {string} [dialogId] Выбранный диалог
         * @param {number} [oldestSequence] Первое показанное сообщение
         * @param {number} [beforeSequence] Граница загрузки старой истории
         * @param {number} [newestSequence] Последнее показанное сообщение
         * @param {number} [afterSequence] Граница следующей непрочитанной страницы приложения
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAppChatSnapshot(ownerAppUserId?: string, appUserIds?: Array<string>, filterPeople?: boolean, companionRole?: ApiUserRole, channels?: Array<number>, companionName?: string, petName?: string, unreadOnly?: boolean, dialogLimit?: number, dialogId?: string, oldestSequence?: number, beforeSequence?: number, newestSequence?: number, afterSequence?: number, apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ChatRealtimeSnapshotResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAppChatSnapshot(ownerAppUserId, appUserIds, filterPeople, companionRole, channels, companionName, petName, unreadOnly, dialogLimit, dialogId, oldestSequence, beforeSequence, newestSequence, afterSequence, apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AppChatApi.getAppChatSnapshot']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Получить переписки приложения
         * @param {string} [ownerAppUserId] 
         * @param {boolean} [pinnedOnly] Показывать только общие закрепления операторов
         * @param {Array<string>} [appUserIds] Выбранные учётные записи собеседников
         * @param {boolean} [filterPeople] Ограничивать список выбранными собеседниками
         * @param {ApiUserRole} [companionRole] Роль собеседника среди пользователей приложения VOX
         * @param {Array<number>} [channels] Каналы связи
         * @param {string} [companionName] Слова имени или фамилии собеседника VOX либо Salebot
         * @param {string} [petName] Часть имени питомца собеседника
         * @param {boolean} [unreadOnly] Показывать только диалоги с непрочитанными сообщениями
         * @param {string} [dialogId] Идентификатор диалога
         * @param {number} [offset] Смещение страницы
         * @param {number} [limit] Размер страницы
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAppChats(ownerAppUserId?: string, pinnedOnly?: boolean, appUserIds?: Array<string>, filterPeople?: boolean, companionRole?: ApiUserRole, channels?: Array<number>, companionName?: string, petName?: string, unreadOnly?: boolean, dialogId?: string, offset?: number, limit?: number, apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ChatDialogPageResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAppChats(ownerAppUserId, pinnedOnly, appUserIds, filterPeople, companionRole, channels, companionName, petName, unreadOnly, dialogId, offset, limit, apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AppChatApi.getAppChats']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Создать или найти переписку поддержки
         * @param {string} [apiVersion] 
         * @param {CreateAppChatRequest} [createAppChatRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOrCreateAppChat(apiVersion?: string, createAppChatRequest?: CreateAppChatRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ChatDialogResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOrCreateAppChat(apiVersion, createAppChatRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AppChatApi.getOrCreateAppChat']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Подтвердить прочтение переписки приложения
         * @param {string} dialogId 
         * @param {string} [apiVersion] 
         * @param {MarkChatDialogReadRequest} [markChatDialogReadRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async markAppChatRead(dialogId: string, apiVersion?: string, markChatDialogReadRequest?: MarkChatDialogReadRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.markAppChatRead(dialogId, apiVersion, markChatDialogReadRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AppChatApi.markAppChatRead']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Отметить всю переписку прочитанной
         * @param {string} dialogId 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async markAppChatReadAll(dialogId: string, apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.markAppChatReadAll(dialogId, apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AppChatApi.markAppChatReadAll']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Отметить диалог непрочитанным
         * @param {string} dialogId 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async markAppChatUnread(dialogId: string, apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.markAppChatUnread(dialogId, apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AppChatApi.markAppChatUnread']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Найти переписку приложения по ссылке
         * @param {string} chatId 
         * @param {string} [ownerAppUserId] 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async resolveAppChat(chatId: string, ownerAppUserId?: string, apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ChatDialogResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.resolveAppChat(chatId, ownerAppUserId, apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AppChatApi.resolveAppChat']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Ответить в переписке приложения
         * @param {string} dialogId 
         * @param {string} [apiVersion] 
         * @param {SendChatDialogMessageRequest} [sendChatDialogMessageRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sendAppChatMessage(dialogId: string, apiVersion?: string, sendChatDialogMessageRequest?: SendChatDialogMessageRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ChatDialogMessageResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sendAppChatMessage(dialogId, apiVersion, sendChatDialogMessageRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AppChatApi.sendAppChatMessage']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AppChatApi - factory interface
 * @export
 */
export const AppChatApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AppChatApiFp(configuration)
    return {
        /**
         * 
         * @summary Найти существующую переписку поддержки
         * @param {AppChatApiFindAppChatRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAppChat(requestParameters: AppChatApiFindAppChatRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<ChatDialogPageResponse> {
            return localVarFp.findAppChat(requestParameters.companionAppUserId, requestParameters.apiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Получить активность переписки пользователей
         * @param {AppChatApiGetAppChatActivityRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAppChatActivity(requestParameters: AppChatApiGetAppChatActivityRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<Array<AppChatActivityResponse>> {
            return localVarFp.getAppChatActivity(requestParameters.apiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Получить счётчики переписки приложения
         * @param {AppChatApiGetAppChatCountersRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAppChatCounters(requestParameters: AppChatApiGetAppChatCountersRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<ChatDialogCountersResponse> {
            return localVarFp.getAppChatCounters(requestParameters.ownerAppUserId, requestParameters.apiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Получить историю правок сообщения приложения
         * @param {AppChatApiGetAppChatMessageEditsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAppChatMessageEdits(requestParameters: AppChatApiGetAppChatMessageEditsRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<ChatMessageEditResponse>> {
            return localVarFp.getAppChatMessageEdits(requestParameters.dialogId, requestParameters.messageId, requestParameters.ownerAppUserId, requestParameters.beforeVersion, requestParameters.apiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Получить историю переписки приложения
         * @param {AppChatApiGetAppChatMessagesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAppChatMessages(requestParameters: AppChatApiGetAppChatMessagesRequest, options?: RawAxiosRequestConfig): AxiosPromise<ChatDialogMessagePageResponse> {
            return localVarFp.getAppChatMessages(requestParameters.dialogId, requestParameters.ownerAppUserId, requestParameters.beforeSequence, requestParameters.limit, requestParameters.afterSequence, requestParameters.apiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Получить доступ к обновлениям приложения
         * @param {AppChatApiGetAppChatRealtimeRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAppChatRealtime(requestParameters: AppChatApiGetAppChatRealtimeRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<ChatRealtimeResponse> {
            return localVarFp.getAppChatRealtime(requestParameters.ownerAppUserId, requestParameters.apiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Получить согласованное состояние переписки приложения
         * @param {AppChatApiGetAppChatSnapshotRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAppChatSnapshot(requestParameters: AppChatApiGetAppChatSnapshotRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<ChatRealtimeSnapshotResponse> {
            return localVarFp.getAppChatSnapshot(requestParameters.ownerAppUserId, requestParameters.appUserIds, requestParameters.filterPeople, requestParameters.companionRole, requestParameters.channels, requestParameters.companionName, requestParameters.petName, requestParameters.unreadOnly, requestParameters.dialogLimit, requestParameters.dialogId, requestParameters.oldestSequence, requestParameters.beforeSequence, requestParameters.newestSequence, requestParameters.afterSequence, requestParameters.apiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Получить переписки приложения
         * @param {AppChatApiGetAppChatsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAppChats(requestParameters: AppChatApiGetAppChatsRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<ChatDialogPageResponse> {
            return localVarFp.getAppChats(requestParameters.ownerAppUserId, requestParameters.pinnedOnly, requestParameters.appUserIds, requestParameters.filterPeople, requestParameters.companionRole, requestParameters.channels, requestParameters.companionName, requestParameters.petName, requestParameters.unreadOnly, requestParameters.dialogId, requestParameters.offset, requestParameters.limit, requestParameters.apiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Создать или найти переписку поддержки
         * @param {AppChatApiGetOrCreateAppChatRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrCreateAppChat(requestParameters: AppChatApiGetOrCreateAppChatRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<ChatDialogResponse> {
            return localVarFp.getOrCreateAppChat(requestParameters.apiVersion, requestParameters.createAppChatRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Подтвердить прочтение переписки приложения
         * @param {AppChatApiMarkAppChatReadRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        markAppChatRead(requestParameters: AppChatApiMarkAppChatReadRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.markAppChatRead(requestParameters.dialogId, requestParameters.apiVersion, requestParameters.markChatDialogReadRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Отметить всю переписку прочитанной
         * @param {AppChatApiMarkAppChatReadAllRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        markAppChatReadAll(requestParameters: AppChatApiMarkAppChatReadAllRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.markAppChatReadAll(requestParameters.dialogId, requestParameters.apiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Отметить диалог непрочитанным
         * @param {AppChatApiMarkAppChatUnreadRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        markAppChatUnread(requestParameters: AppChatApiMarkAppChatUnreadRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.markAppChatUnread(requestParameters.dialogId, requestParameters.apiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Найти переписку приложения по ссылке
         * @param {AppChatApiResolveAppChatRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resolveAppChat(requestParameters: AppChatApiResolveAppChatRequest, options?: RawAxiosRequestConfig): AxiosPromise<ChatDialogResponse> {
            return localVarFp.resolveAppChat(requestParameters.chatId, requestParameters.ownerAppUserId, requestParameters.apiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Ответить в переписке приложения
         * @param {AppChatApiSendAppChatMessageRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendAppChatMessage(requestParameters: AppChatApiSendAppChatMessageRequest, options?: RawAxiosRequestConfig): AxiosPromise<ChatDialogMessageResponse> {
            return localVarFp.sendAppChatMessage(requestParameters.dialogId, requestParameters.apiVersion, requestParameters.sendChatDialogMessageRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for findAppChat operation in AppChatApi.
 * @export
 * @interface AppChatApiFindAppChatRequest
 */
export interface AppChatApiFindAppChatRequest {
    /**
     * 
     * @type {string}
     * @memberof AppChatApiFindAppChat
     */
    readonly companionAppUserId?: string

    /**
     * 
     * @type {string}
     * @memberof AppChatApiFindAppChat
     */
    readonly apiVersion?: string
}

/**
 * Request parameters for getAppChatActivity operation in AppChatApi.
 * @export
 * @interface AppChatApiGetAppChatActivityRequest
 */
export interface AppChatApiGetAppChatActivityRequest {
    /**
     * 
     * @type {string}
     * @memberof AppChatApiGetAppChatActivity
     */
    readonly apiVersion?: string
}

/**
 * Request parameters for getAppChatCounters operation in AppChatApi.
 * @export
 * @interface AppChatApiGetAppChatCountersRequest
 */
export interface AppChatApiGetAppChatCountersRequest {
    /**
     * 
     * @type {string}
     * @memberof AppChatApiGetAppChatCounters
     */
    readonly ownerAppUserId?: string

    /**
     * 
     * @type {string}
     * @memberof AppChatApiGetAppChatCounters
     */
    readonly apiVersion?: string
}

/**
 * Request parameters for getAppChatMessageEdits operation in AppChatApi.
 * @export
 * @interface AppChatApiGetAppChatMessageEditsRequest
 */
export interface AppChatApiGetAppChatMessageEditsRequest {
    /**
     * 
     * @type {string}
     * @memberof AppChatApiGetAppChatMessageEdits
     */
    readonly dialogId: string

    /**
     * 
     * @type {string}
     * @memberof AppChatApiGetAppChatMessageEdits
     */
    readonly messageId: string

    /**
     * 
     * @type {string}
     * @memberof AppChatApiGetAppChatMessageEdits
     */
    readonly ownerAppUserId?: string

    /**
     * 
     * @type {number}
     * @memberof AppChatApiGetAppChatMessageEdits
     */
    readonly beforeVersion?: number

    /**
     * 
     * @type {string}
     * @memberof AppChatApiGetAppChatMessageEdits
     */
    readonly apiVersion?: string
}

/**
 * Request parameters for getAppChatMessages operation in AppChatApi.
 * @export
 * @interface AppChatApiGetAppChatMessagesRequest
 */
export interface AppChatApiGetAppChatMessagesRequest {
    /**
     * 
     * @type {string}
     * @memberof AppChatApiGetAppChatMessages
     */
    readonly dialogId: string

    /**
     * 
     * @type {string}
     * @memberof AppChatApiGetAppChatMessages
     */
    readonly ownerAppUserId?: string

    /**
     * Получить сообщения раньше указанного номера
     * @type {number}
     * @memberof AppChatApiGetAppChatMessages
     */
    readonly beforeSequence?: number

    /**
     * Размер страницы
     * @type {number}
     * @memberof AppChatApiGetAppChatMessages
     */
    readonly limit?: number

    /**
     * 
     * @type {number}
     * @memberof AppChatApiGetAppChatMessages
     */
    readonly afterSequence?: number

    /**
     * 
     * @type {string}
     * @memberof AppChatApiGetAppChatMessages
     */
    readonly apiVersion?: string
}

/**
 * Request parameters for getAppChatRealtime operation in AppChatApi.
 * @export
 * @interface AppChatApiGetAppChatRealtimeRequest
 */
export interface AppChatApiGetAppChatRealtimeRequest {
    /**
     * 
     * @type {string}
     * @memberof AppChatApiGetAppChatRealtime
     */
    readonly ownerAppUserId?: string

    /**
     * 
     * @type {string}
     * @memberof AppChatApiGetAppChatRealtime
     */
    readonly apiVersion?: string
}

/**
 * Request parameters for getAppChatSnapshot operation in AppChatApi.
 * @export
 * @interface AppChatApiGetAppChatSnapshotRequest
 */
export interface AppChatApiGetAppChatSnapshotRequest {
    /**
     * 
     * @type {string}
     * @memberof AppChatApiGetAppChatSnapshot
     */
    readonly ownerAppUserId?: string

    /**
     * Выбранные учётные записи собеседников
     * @type {Array<string>}
     * @memberof AppChatApiGetAppChatSnapshot
     */
    readonly appUserIds?: Array<string>

    /**
     * Ограничивать список выбранными собеседниками
     * @type {boolean}
     * @memberof AppChatApiGetAppChatSnapshot
     */
    readonly filterPeople?: boolean

    /**
     * Роль собеседника среди пользователей приложения VOX
     * @type {ApiUserRole}
     * @memberof AppChatApiGetAppChatSnapshot
     */
    readonly companionRole?: ApiUserRole

    /**
     * Каналы связи
     * @type {Array<number>}
     * @memberof AppChatApiGetAppChatSnapshot
     */
    readonly channels?: Array<number>

    /**
     * Слова имени или фамилии собеседника VOX либо Salebot
     * @type {string}
     * @memberof AppChatApiGetAppChatSnapshot
     */
    readonly companionName?: string

    /**
     * Часть имени питомца собеседника
     * @type {string}
     * @memberof AppChatApiGetAppChatSnapshot
     */
    readonly petName?: string

    /**
     * Только непрочитанные диалоги
     * @type {boolean}
     * @memberof AppChatApiGetAppChatSnapshot
     */
    readonly unreadOnly?: boolean

    /**
     * Число показанных диалогов
     * @type {number}
     * @memberof AppChatApiGetAppChatSnapshot
     */
    readonly dialogLimit?: number

    /**
     * Выбранный диалог
     * @type {string}
     * @memberof AppChatApiGetAppChatSnapshot
     */
    readonly dialogId?: string

    /**
     * Первое показанное сообщение
     * @type {number}
     * @memberof AppChatApiGetAppChatSnapshot
     */
    readonly oldestSequence?: number

    /**
     * Граница загрузки старой истории
     * @type {number}
     * @memberof AppChatApiGetAppChatSnapshot
     */
    readonly beforeSequence?: number

    /**
     * Последнее показанное сообщение
     * @type {number}
     * @memberof AppChatApiGetAppChatSnapshot
     */
    readonly newestSequence?: number

    /**
     * Граница следующей непрочитанной страницы приложения
     * @type {number}
     * @memberof AppChatApiGetAppChatSnapshot
     */
    readonly afterSequence?: number

    /**
     * 
     * @type {string}
     * @memberof AppChatApiGetAppChatSnapshot
     */
    readonly apiVersion?: string
}

/**
 * Request parameters for getAppChats operation in AppChatApi.
 * @export
 * @interface AppChatApiGetAppChatsRequest
 */
export interface AppChatApiGetAppChatsRequest {
    /**
     * 
     * @type {string}
     * @memberof AppChatApiGetAppChats
     */
    readonly ownerAppUserId?: string

    /**
     * Показывать только общие закрепления операторов
     * @type {boolean}
     * @memberof AppChatApiGetAppChats
     */
    readonly pinnedOnly?: boolean

    /**
     * Выбранные учётные записи собеседников
     * @type {Array<string>}
     * @memberof AppChatApiGetAppChats
     */
    readonly appUserIds?: Array<string>

    /**
     * Ограничивать список выбранными собеседниками
     * @type {boolean}
     * @memberof AppChatApiGetAppChats
     */
    readonly filterPeople?: boolean

    /**
     * Роль собеседника среди пользователей приложения VOX
     * @type {ApiUserRole}
     * @memberof AppChatApiGetAppChats
     */
    readonly companionRole?: ApiUserRole

    /**
     * Каналы связи
     * @type {Array<number>}
     * @memberof AppChatApiGetAppChats
     */
    readonly channels?: Array<number>

    /**
     * Слова имени или фамилии собеседника VOX либо Salebot
     * @type {string}
     * @memberof AppChatApiGetAppChats
     */
    readonly companionName?: string

    /**
     * Часть имени питомца собеседника
     * @type {string}
     * @memberof AppChatApiGetAppChats
     */
    readonly petName?: string

    /**
     * Показывать только диалоги с непрочитанными сообщениями
     * @type {boolean}
     * @memberof AppChatApiGetAppChats
     */
    readonly unreadOnly?: boolean

    /**
     * Идентификатор диалога
     * @type {string}
     * @memberof AppChatApiGetAppChats
     */
    readonly dialogId?: string

    /**
     * Смещение страницы
     * @type {number}
     * @memberof AppChatApiGetAppChats
     */
    readonly offset?: number

    /**
     * Размер страницы
     * @type {number}
     * @memberof AppChatApiGetAppChats
     */
    readonly limit?: number

    /**
     * 
     * @type {string}
     * @memberof AppChatApiGetAppChats
     */
    readonly apiVersion?: string
}

/**
 * Request parameters for getOrCreateAppChat operation in AppChatApi.
 * @export
 * @interface AppChatApiGetOrCreateAppChatRequest
 */
export interface AppChatApiGetOrCreateAppChatRequest {
    /**
     * 
     * @type {string}
     * @memberof AppChatApiGetOrCreateAppChat
     */
    readonly apiVersion?: string

    /**
     * 
     * @type {CreateAppChatRequest}
     * @memberof AppChatApiGetOrCreateAppChat
     */
    readonly createAppChatRequest?: CreateAppChatRequest
}

/**
 * Request parameters for markAppChatRead operation in AppChatApi.
 * @export
 * @interface AppChatApiMarkAppChatReadRequest
 */
export interface AppChatApiMarkAppChatReadRequest {
    /**
     * 
     * @type {string}
     * @memberof AppChatApiMarkAppChatRead
     */
    readonly dialogId: string

    /**
     * 
     * @type {string}
     * @memberof AppChatApiMarkAppChatRead
     */
    readonly apiVersion?: string

    /**
     * 
     * @type {MarkChatDialogReadRequest}
     * @memberof AppChatApiMarkAppChatRead
     */
    readonly markChatDialogReadRequest?: MarkChatDialogReadRequest
}

/**
 * Request parameters for markAppChatReadAll operation in AppChatApi.
 * @export
 * @interface AppChatApiMarkAppChatReadAllRequest
 */
export interface AppChatApiMarkAppChatReadAllRequest {
    /**
     * 
     * @type {string}
     * @memberof AppChatApiMarkAppChatReadAll
     */
    readonly dialogId: string

    /**
     * 
     * @type {string}
     * @memberof AppChatApiMarkAppChatReadAll
     */
    readonly apiVersion?: string
}

/**
 * Request parameters for markAppChatUnread operation in AppChatApi.
 * @export
 * @interface AppChatApiMarkAppChatUnreadRequest
 */
export interface AppChatApiMarkAppChatUnreadRequest {
    /**
     * 
     * @type {string}
     * @memberof AppChatApiMarkAppChatUnread
     */
    readonly dialogId: string

    /**
     * 
     * @type {string}
     * @memberof AppChatApiMarkAppChatUnread
     */
    readonly apiVersion?: string
}

/**
 * Request parameters for resolveAppChat operation in AppChatApi.
 * @export
 * @interface AppChatApiResolveAppChatRequest
 */
export interface AppChatApiResolveAppChatRequest {
    /**
     * 
     * @type {string}
     * @memberof AppChatApiResolveAppChat
     */
    readonly chatId: string

    /**
     * 
     * @type {string}
     * @memberof AppChatApiResolveAppChat
     */
    readonly ownerAppUserId?: string

    /**
     * 
     * @type {string}
     * @memberof AppChatApiResolveAppChat
     */
    readonly apiVersion?: string
}

/**
 * Request parameters for sendAppChatMessage operation in AppChatApi.
 * @export
 * @interface AppChatApiSendAppChatMessageRequest
 */
export interface AppChatApiSendAppChatMessageRequest {
    /**
     * 
     * @type {string}
     * @memberof AppChatApiSendAppChatMessage
     */
    readonly dialogId: string

    /**
     * 
     * @type {string}
     * @memberof AppChatApiSendAppChatMessage
     */
    readonly apiVersion?: string

    /**
     * 
     * @type {SendChatDialogMessageRequest}
     * @memberof AppChatApiSendAppChatMessage
     */
    readonly sendChatDialogMessageRequest?: SendChatDialogMessageRequest
}

/**
 * AppChatApi - object-oriented interface
 * @export
 * @class AppChatApi
 * @extends {BaseAPI}
 */
export class AppChatApi extends BaseAPI {
    /**
     * 
     * @summary Найти существующую переписку поддержки
     * @param {AppChatApiFindAppChatRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppChatApi
     */
    public findAppChat(requestParameters: AppChatApiFindAppChatRequest = {}, options?: RawAxiosRequestConfig) {
        return AppChatApiFp(this.configuration).findAppChat(requestParameters.companionAppUserId, requestParameters.apiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Получить активность переписки пользователей
     * @param {AppChatApiGetAppChatActivityRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppChatApi
     */
    public getAppChatActivity(requestParameters: AppChatApiGetAppChatActivityRequest = {}, options?: RawAxiosRequestConfig) {
        return AppChatApiFp(this.configuration).getAppChatActivity(requestParameters.apiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Получить счётчики переписки приложения
     * @param {AppChatApiGetAppChatCountersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppChatApi
     */
    public getAppChatCounters(requestParameters: AppChatApiGetAppChatCountersRequest = {}, options?: RawAxiosRequestConfig) {
        return AppChatApiFp(this.configuration).getAppChatCounters(requestParameters.ownerAppUserId, requestParameters.apiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Получить историю правок сообщения приложения
     * @param {AppChatApiGetAppChatMessageEditsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppChatApi
     */
    public getAppChatMessageEdits(requestParameters: AppChatApiGetAppChatMessageEditsRequest, options?: RawAxiosRequestConfig) {
        return AppChatApiFp(this.configuration).getAppChatMessageEdits(requestParameters.dialogId, requestParameters.messageId, requestParameters.ownerAppUserId, requestParameters.beforeVersion, requestParameters.apiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Получить историю переписки приложения
     * @param {AppChatApiGetAppChatMessagesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppChatApi
     */
    public getAppChatMessages(requestParameters: AppChatApiGetAppChatMessagesRequest, options?: RawAxiosRequestConfig) {
        return AppChatApiFp(this.configuration).getAppChatMessages(requestParameters.dialogId, requestParameters.ownerAppUserId, requestParameters.beforeSequence, requestParameters.limit, requestParameters.afterSequence, requestParameters.apiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Получить доступ к обновлениям приложения
     * @param {AppChatApiGetAppChatRealtimeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppChatApi
     */
    public getAppChatRealtime(requestParameters: AppChatApiGetAppChatRealtimeRequest = {}, options?: RawAxiosRequestConfig) {
        return AppChatApiFp(this.configuration).getAppChatRealtime(requestParameters.ownerAppUserId, requestParameters.apiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Получить согласованное состояние переписки приложения
     * @param {AppChatApiGetAppChatSnapshotRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppChatApi
     */
    public getAppChatSnapshot(requestParameters: AppChatApiGetAppChatSnapshotRequest = {}, options?: RawAxiosRequestConfig) {
        return AppChatApiFp(this.configuration).getAppChatSnapshot(requestParameters.ownerAppUserId, requestParameters.appUserIds, requestParameters.filterPeople, requestParameters.companionRole, requestParameters.channels, requestParameters.companionName, requestParameters.petName, requestParameters.unreadOnly, requestParameters.dialogLimit, requestParameters.dialogId, requestParameters.oldestSequence, requestParameters.beforeSequence, requestParameters.newestSequence, requestParameters.afterSequence, requestParameters.apiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Получить переписки приложения
     * @param {AppChatApiGetAppChatsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppChatApi
     */
    public getAppChats(requestParameters: AppChatApiGetAppChatsRequest = {}, options?: RawAxiosRequestConfig) {
        return AppChatApiFp(this.configuration).getAppChats(requestParameters.ownerAppUserId, requestParameters.pinnedOnly, requestParameters.appUserIds, requestParameters.filterPeople, requestParameters.companionRole, requestParameters.channels, requestParameters.companionName, requestParameters.petName, requestParameters.unreadOnly, requestParameters.dialogId, requestParameters.offset, requestParameters.limit, requestParameters.apiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Создать или найти переписку поддержки
     * @param {AppChatApiGetOrCreateAppChatRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppChatApi
     */
    public getOrCreateAppChat(requestParameters: AppChatApiGetOrCreateAppChatRequest = {}, options?: RawAxiosRequestConfig) {
        return AppChatApiFp(this.configuration).getOrCreateAppChat(requestParameters.apiVersion, requestParameters.createAppChatRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Подтвердить прочтение переписки приложения
     * @param {AppChatApiMarkAppChatReadRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppChatApi
     */
    public markAppChatRead(requestParameters: AppChatApiMarkAppChatReadRequest, options?: RawAxiosRequestConfig) {
        return AppChatApiFp(this.configuration).markAppChatRead(requestParameters.dialogId, requestParameters.apiVersion, requestParameters.markChatDialogReadRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Отметить всю переписку прочитанной
     * @param {AppChatApiMarkAppChatReadAllRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppChatApi
     */
    public markAppChatReadAll(requestParameters: AppChatApiMarkAppChatReadAllRequest, options?: RawAxiosRequestConfig) {
        return AppChatApiFp(this.configuration).markAppChatReadAll(requestParameters.dialogId, requestParameters.apiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Отметить диалог непрочитанным
     * @param {AppChatApiMarkAppChatUnreadRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppChatApi
     */
    public markAppChatUnread(requestParameters: AppChatApiMarkAppChatUnreadRequest, options?: RawAxiosRequestConfig) {
        return AppChatApiFp(this.configuration).markAppChatUnread(requestParameters.dialogId, requestParameters.apiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Найти переписку приложения по ссылке
     * @param {AppChatApiResolveAppChatRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppChatApi
     */
    public resolveAppChat(requestParameters: AppChatApiResolveAppChatRequest, options?: RawAxiosRequestConfig) {
        return AppChatApiFp(this.configuration).resolveAppChat(requestParameters.chatId, requestParameters.ownerAppUserId, requestParameters.apiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Ответить в переписке приложения
     * @param {AppChatApiSendAppChatMessageRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppChatApi
     */
    public sendAppChatMessage(requestParameters: AppChatApiSendAppChatMessageRequest, options?: RawAxiosRequestConfig) {
        return AppChatApiFp(this.configuration).sendAppChatMessage(requestParameters.dialogId, requestParameters.apiVersion, requestParameters.sendChatDialogMessageRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AppLinkApi - axios parameter creator
 * @export
 */
export const AppLinkApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Открыть заказ в приложении исполнителя
         * @param {string} orderId 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AppLinksOrderOrderIdGet: async (orderId: string, apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orderId' is not null or undefined
            assertParamExists('apiV1AppLinksOrderOrderIdGet', 'orderId', orderId)
            const localVarPath = `/api/v1/app-links/order/{orderId}`
                .replace(`{${"orderId"}}`, encodeURIComponent(String(orderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AppLinkApi - functional programming interface
 * @export
 */
export const AppLinkApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AppLinkApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Открыть заказ в приложении исполнителя
         * @param {string} orderId 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1AppLinksOrderOrderIdGet(orderId: string, apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1AppLinksOrderOrderIdGet(orderId, apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AppLinkApi.apiV1AppLinksOrderOrderIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AppLinkApi - factory interface
 * @export
 */
export const AppLinkApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AppLinkApiFp(configuration)
    return {
        /**
         * 
         * @summary Открыть заказ в приложении исполнителя
         * @param {AppLinkApiApiV1AppLinksOrderOrderIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AppLinksOrderOrderIdGet(requestParameters: AppLinkApiApiV1AppLinksOrderOrderIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiV1AppLinksOrderOrderIdGet(requestParameters.orderId, requestParameters.apiVersion, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for apiV1AppLinksOrderOrderIdGet operation in AppLinkApi.
 * @export
 * @interface AppLinkApiApiV1AppLinksOrderOrderIdGetRequest
 */
export interface AppLinkApiApiV1AppLinksOrderOrderIdGetRequest {
    /**
     * 
     * @type {string}
     * @memberof AppLinkApiApiV1AppLinksOrderOrderIdGet
     */
    readonly orderId: string

    /**
     * 
     * @type {string}
     * @memberof AppLinkApiApiV1AppLinksOrderOrderIdGet
     */
    readonly apiVersion?: string
}

/**
 * AppLinkApi - object-oriented interface
 * @export
 * @class AppLinkApi
 * @extends {BaseAPI}
 */
export class AppLinkApi extends BaseAPI {
    /**
     * 
     * @summary Открыть заказ в приложении исполнителя
     * @param {AppLinkApiApiV1AppLinksOrderOrderIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppLinkApi
     */
    public apiV1AppLinksOrderOrderIdGet(requestParameters: AppLinkApiApiV1AppLinksOrderOrderIdGetRequest, options?: RawAxiosRequestConfig) {
        return AppLinkApiFp(this.configuration).apiV1AppLinksOrderOrderIdGet(requestParameters.orderId, requestParameters.apiVersion, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AppVersionApi - axios parameter creator
 * @export
 */
export const AppVersionApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Создать версию мобильного приложения
         * @param {string} [apiVersion] 
         * @param {CreateAppVersionRequest} [createAppVersionRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAppVersion: async (apiVersion?: string, createAppVersionRequest?: CreateAppVersionRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/app-versions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createAppVersionRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Получить версию мобильного приложения по идентификатору
         * @param {string} id 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAppVersionById: async (id: string, apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getAppVersionById', 'id', id)
            const localVarPath = `/api/v1/app-versions/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Получить текст оповещения о версии приложения
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAppVersionNotificationTemplate: async (apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/app-versions/notification-template`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Получить все версии мобильных приложений
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAppVersions: async (apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/app-versions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Поставить оповещение о версии приложения в очередь
         * @param {string} [apiVersion] 
         * @param {NotifyAppVersionRequest} [notifyAppVersionRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        notifyAppVersionUpdate: async (apiVersion?: string, notifyAppVersionRequest?: NotifyAppVersionRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/app-versions/notify-update`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(notifyAppVersionRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Обновить версию мобильного приложения
         * @param {string} id 
         * @param {string} [apiVersion] 
         * @param {UpdateAppVersionRequest} [updateAppVersionRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAppVersion: async (id: string, apiVersion?: string, updateAppVersionRequest?: UpdateAppVersionRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateAppVersion', 'id', id)
            const localVarPath = `/api/v1/app-versions/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateAppVersionRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AppVersionApi - functional programming interface
 * @export
 */
export const AppVersionApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AppVersionApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Создать версию мобильного приложения
         * @param {string} [apiVersion] 
         * @param {CreateAppVersionRequest} [createAppVersionRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createAppVersion(apiVersion?: string, createAppVersionRequest?: CreateAppVersionRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AppVersionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createAppVersion(apiVersion, createAppVersionRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AppVersionApi.createAppVersion']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Получить версию мобильного приложения по идентификатору
         * @param {string} id 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAppVersionById(id: string, apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AppVersionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAppVersionById(id, apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AppVersionApi.getAppVersionById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Получить текст оповещения о версии приложения
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAppVersionNotificationTemplate(apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AppVersionNotificationTemplateResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAppVersionNotificationTemplate(apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AppVersionApi.getAppVersionNotificationTemplate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Получить все версии мобильных приложений
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAppVersions(apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AppVersionResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAppVersions(apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AppVersionApi.getAppVersions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Поставить оповещение о версии приложения в очередь
         * @param {string} [apiVersion] 
         * @param {NotifyAppVersionRequest} [notifyAppVersionRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async notifyAppVersionUpdate(apiVersion?: string, notifyAppVersionRequest?: NotifyAppVersionRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.notifyAppVersionUpdate(apiVersion, notifyAppVersionRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AppVersionApi.notifyAppVersionUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Обновить версию мобильного приложения
         * @param {string} id 
         * @param {string} [apiVersion] 
         * @param {UpdateAppVersionRequest} [updateAppVersionRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateAppVersion(id: string, apiVersion?: string, updateAppVersionRequest?: UpdateAppVersionRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AppVersionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateAppVersion(id, apiVersion, updateAppVersionRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AppVersionApi.updateAppVersion']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AppVersionApi - factory interface
 * @export
 */
export const AppVersionApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AppVersionApiFp(configuration)
    return {
        /**
         * 
         * @summary Создать версию мобильного приложения
         * @param {AppVersionApiCreateAppVersionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAppVersion(requestParameters: AppVersionApiCreateAppVersionRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<AppVersionResponse> {
            return localVarFp.createAppVersion(requestParameters.apiVersion, requestParameters.createAppVersionRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Получить версию мобильного приложения по идентификатору
         * @param {AppVersionApiGetAppVersionByIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAppVersionById(requestParameters: AppVersionApiGetAppVersionByIdRequest, options?: RawAxiosRequestConfig): AxiosPromise<AppVersionResponse> {
            return localVarFp.getAppVersionById(requestParameters.id, requestParameters.apiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Получить текст оповещения о версии приложения
         * @param {AppVersionApiGetAppVersionNotificationTemplateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAppVersionNotificationTemplate(requestParameters: AppVersionApiGetAppVersionNotificationTemplateRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<AppVersionNotificationTemplateResponse> {
            return localVarFp.getAppVersionNotificationTemplate(requestParameters.apiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Получить все версии мобильных приложений
         * @param {AppVersionApiGetAppVersionsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAppVersions(requestParameters: AppVersionApiGetAppVersionsRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<Array<AppVersionResponse>> {
            return localVarFp.getAppVersions(requestParameters.apiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Поставить оповещение о версии приложения в очередь
         * @param {AppVersionApiNotifyAppVersionUpdateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        notifyAppVersionUpdate(requestParameters: AppVersionApiNotifyAppVersionUpdateRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.notifyAppVersionUpdate(requestParameters.apiVersion, requestParameters.notifyAppVersionRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Обновить версию мобильного приложения
         * @param {AppVersionApiUpdateAppVersionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAppVersion(requestParameters: AppVersionApiUpdateAppVersionRequest, options?: RawAxiosRequestConfig): AxiosPromise<AppVersionResponse> {
            return localVarFp.updateAppVersion(requestParameters.id, requestParameters.apiVersion, requestParameters.updateAppVersionRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for createAppVersion operation in AppVersionApi.
 * @export
 * @interface AppVersionApiCreateAppVersionRequest
 */
export interface AppVersionApiCreateAppVersionRequest {
    /**
     * 
     * @type {string}
     * @memberof AppVersionApiCreateAppVersion
     */
    readonly apiVersion?: string

    /**
     * 
     * @type {CreateAppVersionRequest}
     * @memberof AppVersionApiCreateAppVersion
     */
    readonly createAppVersionRequest?: CreateAppVersionRequest
}

/**
 * Request parameters for getAppVersionById operation in AppVersionApi.
 * @export
 * @interface AppVersionApiGetAppVersionByIdRequest
 */
export interface AppVersionApiGetAppVersionByIdRequest {
    /**
     * 
     * @type {string}
     * @memberof AppVersionApiGetAppVersionById
     */
    readonly id: string

    /**
     * 
     * @type {string}
     * @memberof AppVersionApiGetAppVersionById
     */
    readonly apiVersion?: string
}

/**
 * Request parameters for getAppVersionNotificationTemplate operation in AppVersionApi.
 * @export
 * @interface AppVersionApiGetAppVersionNotificationTemplateRequest
 */
export interface AppVersionApiGetAppVersionNotificationTemplateRequest {
    /**
     * 
     * @type {string}
     * @memberof AppVersionApiGetAppVersionNotificationTemplate
     */
    readonly apiVersion?: string
}

/**
 * Request parameters for getAppVersions operation in AppVersionApi.
 * @export
 * @interface AppVersionApiGetAppVersionsRequest
 */
export interface AppVersionApiGetAppVersionsRequest {
    /**
     * 
     * @type {string}
     * @memberof AppVersionApiGetAppVersions
     */
    readonly apiVersion?: string
}

/**
 * Request parameters for notifyAppVersionUpdate operation in AppVersionApi.
 * @export
 * @interface AppVersionApiNotifyAppVersionUpdateRequest
 */
export interface AppVersionApiNotifyAppVersionUpdateRequest {
    /**
     * 
     * @type {string}
     * @memberof AppVersionApiNotifyAppVersionUpdate
     */
    readonly apiVersion?: string

    /**
     * 
     * @type {NotifyAppVersionRequest}
     * @memberof AppVersionApiNotifyAppVersionUpdate
     */
    readonly notifyAppVersionRequest?: NotifyAppVersionRequest
}

/**
 * Request parameters for updateAppVersion operation in AppVersionApi.
 * @export
 * @interface AppVersionApiUpdateAppVersionRequest
 */
export interface AppVersionApiUpdateAppVersionRequest {
    /**
     * 
     * @type {string}
     * @memberof AppVersionApiUpdateAppVersion
     */
    readonly id: string

    /**
     * 
     * @type {string}
     * @memberof AppVersionApiUpdateAppVersion
     */
    readonly apiVersion?: string

    /**
     * 
     * @type {UpdateAppVersionRequest}
     * @memberof AppVersionApiUpdateAppVersion
     */
    readonly updateAppVersionRequest?: UpdateAppVersionRequest
}

/**
 * AppVersionApi - object-oriented interface
 * @export
 * @class AppVersionApi
 * @extends {BaseAPI}
 */
export class AppVersionApi extends BaseAPI {
    /**
     * 
     * @summary Создать версию мобильного приложения
     * @param {AppVersionApiCreateAppVersionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppVersionApi
     */
    public createAppVersion(requestParameters: AppVersionApiCreateAppVersionRequest = {}, options?: RawAxiosRequestConfig) {
        return AppVersionApiFp(this.configuration).createAppVersion(requestParameters.apiVersion, requestParameters.createAppVersionRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Получить версию мобильного приложения по идентификатору
     * @param {AppVersionApiGetAppVersionByIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppVersionApi
     */
    public getAppVersionById(requestParameters: AppVersionApiGetAppVersionByIdRequest, options?: RawAxiosRequestConfig) {
        return AppVersionApiFp(this.configuration).getAppVersionById(requestParameters.id, requestParameters.apiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Получить текст оповещения о версии приложения
     * @param {AppVersionApiGetAppVersionNotificationTemplateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppVersionApi
     */
    public getAppVersionNotificationTemplate(requestParameters: AppVersionApiGetAppVersionNotificationTemplateRequest = {}, options?: RawAxiosRequestConfig) {
        return AppVersionApiFp(this.configuration).getAppVersionNotificationTemplate(requestParameters.apiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Получить все версии мобильных приложений
     * @param {AppVersionApiGetAppVersionsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppVersionApi
     */
    public getAppVersions(requestParameters: AppVersionApiGetAppVersionsRequest = {}, options?: RawAxiosRequestConfig) {
        return AppVersionApiFp(this.configuration).getAppVersions(requestParameters.apiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Поставить оповещение о версии приложения в очередь
     * @param {AppVersionApiNotifyAppVersionUpdateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppVersionApi
     */
    public notifyAppVersionUpdate(requestParameters: AppVersionApiNotifyAppVersionUpdateRequest = {}, options?: RawAxiosRequestConfig) {
        return AppVersionApiFp(this.configuration).notifyAppVersionUpdate(requestParameters.apiVersion, requestParameters.notifyAppVersionRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Обновить версию мобильного приложения
     * @param {AppVersionApiUpdateAppVersionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppVersionApi
     */
    public updateAppVersion(requestParameters: AppVersionApiUpdateAppVersionRequest, options?: RawAxiosRequestConfig) {
        return AppVersionApiFp(this.configuration).updateAppVersion(requestParameters.id, requestParameters.apiVersion, requestParameters.updateAppVersionRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AuditApi - axios parameter creator
 * @export
 */
export const AuditApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Получить историю изменений продукта
         * @param {string} productId 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductHistory: async (productId: string, page?: number, pageSize?: number, apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'productId' is not null or undefined
            assertParamExists('getProductHistory', 'productId', productId)
            const localVarPath = `/api/v1/audit/products/{productId}`
                .replace(`{${"productId"}}`, encodeURIComponent(String(productId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }


    
            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Получить историю изменений раздела настроек
         * @param {ApiSettingType} type Раздел прикладных настроек
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVoxSettingsHistory: async (type: ApiSettingType, page?: number, pageSize?: number, apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'type' is not null or undefined
            assertParamExists('getVoxSettingsHistory', 'type', type)
            const localVarPath = `/api/v1/audit/vox-settings/{type}`
                .replace(`{${"type"}}`, encodeURIComponent(String(type)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }


    
            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AuditApi - functional programming interface
 * @export
 */
export const AuditApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AuditApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Получить историю изменений продукта
         * @param {string} productId 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProductHistory(productId: string, page?: number, pageSize?: number, apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AuditHistoryResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProductHistory(productId, page, pageSize, apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuditApi.getProductHistory']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Получить историю изменений раздела настроек
         * @param {ApiSettingType} type Раздел прикладных настроек
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getVoxSettingsHistory(type: ApiSettingType, page?: number, pageSize?: number, apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AuditHistoryResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getVoxSettingsHistory(type, page, pageSize, apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuditApi.getVoxSettingsHistory']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AuditApi - factory interface
 * @export
 */
export const AuditApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AuditApiFp(configuration)
    return {
        /**
         * 
         * @summary Получить историю изменений продукта
         * @param {AuditApiGetProductHistoryRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductHistory(requestParameters: AuditApiGetProductHistoryRequest, options?: RawAxiosRequestConfig): AxiosPromise<AuditHistoryResponse> {
            return localVarFp.getProductHistory(requestParameters.productId, requestParameters.page, requestParameters.pageSize, requestParameters.apiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Получить историю изменений раздела настроек
         * @param {AuditApiGetVoxSettingsHistoryRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVoxSettingsHistory(requestParameters: AuditApiGetVoxSettingsHistoryRequest, options?: RawAxiosRequestConfig): AxiosPromise<AuditHistoryResponse> {
            return localVarFp.getVoxSettingsHistory(requestParameters.type, requestParameters.page, requestParameters.pageSize, requestParameters.apiVersion, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for getProductHistory operation in AuditApi.
 * @export
 * @interface AuditApiGetProductHistoryRequest
 */
export interface AuditApiGetProductHistoryRequest {
    /**
     * 
     * @type {string}
     * @memberof AuditApiGetProductHistory
     */
    readonly productId: string

    /**
     * 
     * @type {number}
     * @memberof AuditApiGetProductHistory
     */
    readonly page?: number

    /**
     * 
     * @type {number}
     * @memberof AuditApiGetProductHistory
     */
    readonly pageSize?: number

    /**
     * 
     * @type {string}
     * @memberof AuditApiGetProductHistory
     */
    readonly apiVersion?: string
}

/**
 * Request parameters for getVoxSettingsHistory operation in AuditApi.
 * @export
 * @interface AuditApiGetVoxSettingsHistoryRequest
 */
export interface AuditApiGetVoxSettingsHistoryRequest {
    /**
     * Раздел прикладных настроек
     * @type {ApiSettingType}
     * @memberof AuditApiGetVoxSettingsHistory
     */
    readonly type: ApiSettingType

    /**
     * 
     * @type {number}
     * @memberof AuditApiGetVoxSettingsHistory
     */
    readonly page?: number

    /**
     * 
     * @type {number}
     * @memberof AuditApiGetVoxSettingsHistory
     */
    readonly pageSize?: number

    /**
     * 
     * @type {string}
     * @memberof AuditApiGetVoxSettingsHistory
     */
    readonly apiVersion?: string
}

/**
 * AuditApi - object-oriented interface
 * @export
 * @class AuditApi
 * @extends {BaseAPI}
 */
export class AuditApi extends BaseAPI {
    /**
     * 
     * @summary Получить историю изменений продукта
     * @param {AuditApiGetProductHistoryRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuditApi
     */
    public getProductHistory(requestParameters: AuditApiGetProductHistoryRequest, options?: RawAxiosRequestConfig) {
        return AuditApiFp(this.configuration).getProductHistory(requestParameters.productId, requestParameters.page, requestParameters.pageSize, requestParameters.apiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Получить историю изменений раздела настроек
     * @param {AuditApiGetVoxSettingsHistoryRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuditApi
     */
    public getVoxSettingsHistory(requestParameters: AuditApiGetVoxSettingsHistoryRequest, options?: RawAxiosRequestConfig) {
        return AuditApiFp(this.configuration).getVoxSettingsHistory(requestParameters.type, requestParameters.page, requestParameters.pageSize, requestParameters.apiVersion, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AuthApi - axios parameter creator
 * @export
 */
export const AuthApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Выполнить вход по логину и паролю
         * @param {string} [apiVersion] 
         * @param {LoginRequest} [loginRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AuthLoginPost: async (apiVersion?: string, loginRequest?: LoginRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/auth/login`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(loginRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Обновить авторизационную сессию
         * @param {string} [apiVersion] 
         * @param {RefreshTokenRequest} [refreshTokenRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AuthRefreshPost: async (apiVersion?: string, refreshTokenRequest?: RefreshTokenRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/auth/refresh`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(refreshTokenRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Отправить код входа звонком
         * @param {string} [apiVersion] 
         * @param {SendPhoneRequest} [sendPhoneRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AuthSendCallPost: async (apiVersion?: string, sendPhoneRequest?: SendPhoneRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/auth/send-call`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(sendPhoneRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Отправить код входа по электронной почте
         * @param {string} [apiVersion] 
         * @param {SendEmailRequest} [sendEmailRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AuthSendEmailPost: async (apiVersion?: string, sendEmailRequest?: SendEmailRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/auth/send-email`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(sendEmailRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Отправить код входа по SMS
         * @param {string} [apiVersion] 
         * @param {SendSmsRequest} [sendSmsRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AuthSendSmsPost: async (apiVersion?: string, sendSmsRequest?: SendSmsRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/auth/send-sms`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(sendSmsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Отправить код входа через Telegram
         * @param {string} [apiVersion] 
         * @param {SendTelegramRequest} [sendTelegramRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AuthSendTelegramPost: async (apiVersion?: string, sendTelegramRequest?: SendTelegramRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/auth/send-telegram`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(sendTelegramRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Отправить код входа через VK
         * @param {string} [apiVersion] 
         * @param {SendVKRequest} [sendVKRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AuthSendVkPost: async (apiVersion?: string, sendVKRequest?: SendVKRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/auth/send-vk`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(sendVKRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Проверить код входа
         * @param {string} [apiVersion] 
         * @param {PhoneVerifyRequest} [phoneVerifyRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AuthVerifyPost: async (apiVersion?: string, phoneVerifyRequest?: PhoneVerifyRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/auth/verify`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(phoneVerifyRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AuthApi - functional programming interface
 * @export
 */
export const AuthApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AuthApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Выполнить вход по логину и паролю
         * @param {string} [apiVersion] 
         * @param {LoginRequest} [loginRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1AuthLoginPost(apiVersion?: string, loginRequest?: LoginRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VerificationMessageResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1AuthLoginPost(apiVersion, loginRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthApi.apiV1AuthLoginPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Обновить авторизационную сессию
         * @param {string} [apiVersion] 
         * @param {RefreshTokenRequest} [refreshTokenRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1AuthRefreshPost(apiVersion?: string, refreshTokenRequest?: RefreshTokenRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TokenResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1AuthRefreshPost(apiVersion, refreshTokenRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthApi.apiV1AuthRefreshPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Отправить код входа звонком
         * @param {string} [apiVersion] 
         * @param {SendPhoneRequest} [sendPhoneRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1AuthSendCallPost(apiVersion?: string, sendPhoneRequest?: SendPhoneRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VerificationMessageResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1AuthSendCallPost(apiVersion, sendPhoneRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthApi.apiV1AuthSendCallPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Отправить код входа по электронной почте
         * @param {string} [apiVersion] 
         * @param {SendEmailRequest} [sendEmailRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1AuthSendEmailPost(apiVersion?: string, sendEmailRequest?: SendEmailRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VerificationMessageResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1AuthSendEmailPost(apiVersion, sendEmailRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthApi.apiV1AuthSendEmailPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Отправить код входа по SMS
         * @param {string} [apiVersion] 
         * @param {SendSmsRequest} [sendSmsRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1AuthSendSmsPost(apiVersion?: string, sendSmsRequest?: SendSmsRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VerificationMessageResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1AuthSendSmsPost(apiVersion, sendSmsRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthApi.apiV1AuthSendSmsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Отправить код входа через Telegram
         * @param {string} [apiVersion] 
         * @param {SendTelegramRequest} [sendTelegramRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1AuthSendTelegramPost(apiVersion?: string, sendTelegramRequest?: SendTelegramRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VerificationMessageResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1AuthSendTelegramPost(apiVersion, sendTelegramRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthApi.apiV1AuthSendTelegramPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Отправить код входа через VK
         * @param {string} [apiVersion] 
         * @param {SendVKRequest} [sendVKRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1AuthSendVkPost(apiVersion?: string, sendVKRequest?: SendVKRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VerificationMessageResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1AuthSendVkPost(apiVersion, sendVKRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthApi.apiV1AuthSendVkPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Проверить код входа
         * @param {string} [apiVersion] 
         * @param {PhoneVerifyRequest} [phoneVerifyRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1AuthVerifyPost(apiVersion?: string, phoneVerifyRequest?: PhoneVerifyRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TokenResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1AuthVerifyPost(apiVersion, phoneVerifyRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthApi.apiV1AuthVerifyPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AuthApi - factory interface
 * @export
 */
export const AuthApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AuthApiFp(configuration)
    return {
        /**
         * 
         * @summary Выполнить вход по логину и паролю
         * @param {AuthApiApiV1AuthLoginPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AuthLoginPost(requestParameters: AuthApiApiV1AuthLoginPostRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<VerificationMessageResponse> {
            return localVarFp.apiV1AuthLoginPost(requestParameters.apiVersion, requestParameters.loginRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Обновить авторизационную сессию
         * @param {AuthApiApiV1AuthRefreshPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AuthRefreshPost(requestParameters: AuthApiApiV1AuthRefreshPostRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<TokenResponse> {
            return localVarFp.apiV1AuthRefreshPost(requestParameters.apiVersion, requestParameters.refreshTokenRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Отправить код входа звонком
         * @param {AuthApiApiV1AuthSendCallPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AuthSendCallPost(requestParameters: AuthApiApiV1AuthSendCallPostRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<VerificationMessageResponse> {
            return localVarFp.apiV1AuthSendCallPost(requestParameters.apiVersion, requestParameters.sendPhoneRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Отправить код входа по электронной почте
         * @param {AuthApiApiV1AuthSendEmailPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AuthSendEmailPost(requestParameters: AuthApiApiV1AuthSendEmailPostRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<VerificationMessageResponse> {
            return localVarFp.apiV1AuthSendEmailPost(requestParameters.apiVersion, requestParameters.sendEmailRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Отправить код входа по SMS
         * @param {AuthApiApiV1AuthSendSmsPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AuthSendSmsPost(requestParameters: AuthApiApiV1AuthSendSmsPostRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<VerificationMessageResponse> {
            return localVarFp.apiV1AuthSendSmsPost(requestParameters.apiVersion, requestParameters.sendSmsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Отправить код входа через Telegram
         * @param {AuthApiApiV1AuthSendTelegramPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AuthSendTelegramPost(requestParameters: AuthApiApiV1AuthSendTelegramPostRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<VerificationMessageResponse> {
            return localVarFp.apiV1AuthSendTelegramPost(requestParameters.apiVersion, requestParameters.sendTelegramRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Отправить код входа через VK
         * @param {AuthApiApiV1AuthSendVkPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AuthSendVkPost(requestParameters: AuthApiApiV1AuthSendVkPostRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<VerificationMessageResponse> {
            return localVarFp.apiV1AuthSendVkPost(requestParameters.apiVersion, requestParameters.sendVKRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Проверить код входа
         * @param {AuthApiApiV1AuthVerifyPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AuthVerifyPost(requestParameters: AuthApiApiV1AuthVerifyPostRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<TokenResponse> {
            return localVarFp.apiV1AuthVerifyPost(requestParameters.apiVersion, requestParameters.phoneVerifyRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for apiV1AuthLoginPost operation in AuthApi.
 * @export
 * @interface AuthApiApiV1AuthLoginPostRequest
 */
export interface AuthApiApiV1AuthLoginPostRequest {
    /**
     * 
     * @type {string}
     * @memberof AuthApiApiV1AuthLoginPost
     */
    readonly apiVersion?: string

    /**
     * 
     * @type {LoginRequest}
     * @memberof AuthApiApiV1AuthLoginPost
     */
    readonly loginRequest?: LoginRequest
}

/**
 * Request parameters for apiV1AuthRefreshPost operation in AuthApi.
 * @export
 * @interface AuthApiApiV1AuthRefreshPostRequest
 */
export interface AuthApiApiV1AuthRefreshPostRequest {
    /**
     * 
     * @type {string}
     * @memberof AuthApiApiV1AuthRefreshPost
     */
    readonly apiVersion?: string

    /**
     * 
     * @type {RefreshTokenRequest}
     * @memberof AuthApiApiV1AuthRefreshPost
     */
    readonly refreshTokenRequest?: RefreshTokenRequest
}

/**
 * Request parameters for apiV1AuthSendCallPost operation in AuthApi.
 * @export
 * @interface AuthApiApiV1AuthSendCallPostRequest
 */
export interface AuthApiApiV1AuthSendCallPostRequest {
    /**
     * 
     * @type {string}
     * @memberof AuthApiApiV1AuthSendCallPost
     */
    readonly apiVersion?: string

    /**
     * 
     * @type {SendPhoneRequest}
     * @memberof AuthApiApiV1AuthSendCallPost
     */
    readonly sendPhoneRequest?: SendPhoneRequest
}

/**
 * Request parameters for apiV1AuthSendEmailPost operation in AuthApi.
 * @export
 * @interface AuthApiApiV1AuthSendEmailPostRequest
 */
export interface AuthApiApiV1AuthSendEmailPostRequest {
    /**
     * 
     * @type {string}
     * @memberof AuthApiApiV1AuthSendEmailPost
     */
    readonly apiVersion?: string

    /**
     * 
     * @type {SendEmailRequest}
     * @memberof AuthApiApiV1AuthSendEmailPost
     */
    readonly sendEmailRequest?: SendEmailRequest
}

/**
 * Request parameters for apiV1AuthSendSmsPost operation in AuthApi.
 * @export
 * @interface AuthApiApiV1AuthSendSmsPostRequest
 */
export interface AuthApiApiV1AuthSendSmsPostRequest {
    /**
     * 
     * @type {string}
     * @memberof AuthApiApiV1AuthSendSmsPost
     */
    readonly apiVersion?: string

    /**
     * 
     * @type {SendSmsRequest}
     * @memberof AuthApiApiV1AuthSendSmsPost
     */
    readonly sendSmsRequest?: SendSmsRequest
}

/**
 * Request parameters for apiV1AuthSendTelegramPost operation in AuthApi.
 * @export
 * @interface AuthApiApiV1AuthSendTelegramPostRequest
 */
export interface AuthApiApiV1AuthSendTelegramPostRequest {
    /**
     * 
     * @type {string}
     * @memberof AuthApiApiV1AuthSendTelegramPost
     */
    readonly apiVersion?: string

    /**
     * 
     * @type {SendTelegramRequest}
     * @memberof AuthApiApiV1AuthSendTelegramPost
     */
    readonly sendTelegramRequest?: SendTelegramRequest
}

/**
 * Request parameters for apiV1AuthSendVkPost operation in AuthApi.
 * @export
 * @interface AuthApiApiV1AuthSendVkPostRequest
 */
export interface AuthApiApiV1AuthSendVkPostRequest {
    /**
     * 
     * @type {string}
     * @memberof AuthApiApiV1AuthSendVkPost
     */
    readonly apiVersion?: string

    /**
     * 
     * @type {SendVKRequest}
     * @memberof AuthApiApiV1AuthSendVkPost
     */
    readonly sendVKRequest?: SendVKRequest
}

/**
 * Request parameters for apiV1AuthVerifyPost operation in AuthApi.
 * @export
 * @interface AuthApiApiV1AuthVerifyPostRequest
 */
export interface AuthApiApiV1AuthVerifyPostRequest {
    /**
     * 
     * @type {string}
     * @memberof AuthApiApiV1AuthVerifyPost
     */
    readonly apiVersion?: string

    /**
     * 
     * @type {PhoneVerifyRequest}
     * @memberof AuthApiApiV1AuthVerifyPost
     */
    readonly phoneVerifyRequest?: PhoneVerifyRequest
}

/**
 * AuthApi - object-oriented interface
 * @export
 * @class AuthApi
 * @extends {BaseAPI}
 */
export class AuthApi extends BaseAPI {
    /**
     * 
     * @summary Выполнить вход по логину и паролю
     * @param {AuthApiApiV1AuthLoginPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public apiV1AuthLoginPost(requestParameters: AuthApiApiV1AuthLoginPostRequest = {}, options?: RawAxiosRequestConfig) {
        return AuthApiFp(this.configuration).apiV1AuthLoginPost(requestParameters.apiVersion, requestParameters.loginRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Обновить авторизационную сессию
     * @param {AuthApiApiV1AuthRefreshPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public apiV1AuthRefreshPost(requestParameters: AuthApiApiV1AuthRefreshPostRequest = {}, options?: RawAxiosRequestConfig) {
        return AuthApiFp(this.configuration).apiV1AuthRefreshPost(requestParameters.apiVersion, requestParameters.refreshTokenRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Отправить код входа звонком
     * @param {AuthApiApiV1AuthSendCallPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public apiV1AuthSendCallPost(requestParameters: AuthApiApiV1AuthSendCallPostRequest = {}, options?: RawAxiosRequestConfig) {
        return AuthApiFp(this.configuration).apiV1AuthSendCallPost(requestParameters.apiVersion, requestParameters.sendPhoneRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Отправить код входа по электронной почте
     * @param {AuthApiApiV1AuthSendEmailPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public apiV1AuthSendEmailPost(requestParameters: AuthApiApiV1AuthSendEmailPostRequest = {}, options?: RawAxiosRequestConfig) {
        return AuthApiFp(this.configuration).apiV1AuthSendEmailPost(requestParameters.apiVersion, requestParameters.sendEmailRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Отправить код входа по SMS
     * @param {AuthApiApiV1AuthSendSmsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public apiV1AuthSendSmsPost(requestParameters: AuthApiApiV1AuthSendSmsPostRequest = {}, options?: RawAxiosRequestConfig) {
        return AuthApiFp(this.configuration).apiV1AuthSendSmsPost(requestParameters.apiVersion, requestParameters.sendSmsRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Отправить код входа через Telegram
     * @param {AuthApiApiV1AuthSendTelegramPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public apiV1AuthSendTelegramPost(requestParameters: AuthApiApiV1AuthSendTelegramPostRequest = {}, options?: RawAxiosRequestConfig) {
        return AuthApiFp(this.configuration).apiV1AuthSendTelegramPost(requestParameters.apiVersion, requestParameters.sendTelegramRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Отправить код входа через VK
     * @param {AuthApiApiV1AuthSendVkPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public apiV1AuthSendVkPost(requestParameters: AuthApiApiV1AuthSendVkPostRequest = {}, options?: RawAxiosRequestConfig) {
        return AuthApiFp(this.configuration).apiV1AuthSendVkPost(requestParameters.apiVersion, requestParameters.sendVKRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Проверить код входа
     * @param {AuthApiApiV1AuthVerifyPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public apiV1AuthVerifyPost(requestParameters: AuthApiApiV1AuthVerifyPostRequest = {}, options?: RawAxiosRequestConfig) {
        return AuthApiFp(this.configuration).apiV1AuthVerifyPost(requestParameters.apiVersion, requestParameters.phoneVerifyRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AvatarApi - axios parameter creator
 * @export
 */
export const AvatarApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Получить аватары по заданным условиям
         * @param {ApiGender} [gender] Пол
         * @param {ApiPetType} [petType] Тип питомца
         * @param {string} [searchQuery] Строка для поиска
         * @param {number} [takeCount] Размер страницы
         * @param {number} [skipCount] Кол-во пропущенных записей
         * @param {boolean} [ascending] Сортировка по возрастанию
         * @param {string} [ordering] Поле для сортировки
         * @param {boolean} [isDeleted] Удалённые записи
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllAvatars: async (gender?: ApiGender, petType?: ApiPetType, searchQuery?: string, takeCount?: number, skipCount?: number, ascending?: boolean, ordering?: string, isDeleted?: boolean, apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/avatars/get-all-avatars`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (gender !== undefined) {
                localVarQueryParameter['Gender'] = gender;
            }

            if (petType !== undefined) {
                localVarQueryParameter['PetType'] = petType;
            }

            if (searchQuery !== undefined) {
                localVarQueryParameter['SearchQuery'] = searchQuery;
            }

            if (takeCount !== undefined) {
                localVarQueryParameter['TakeCount'] = takeCount;
            }

            if (skipCount !== undefined) {
                localVarQueryParameter['SkipCount'] = skipCount;
            }

            if (ascending !== undefined) {
                localVarQueryParameter['Ascending'] = ascending;
            }

            if (ordering !== undefined) {
                localVarQueryParameter['Ordering'] = ordering;
            }

            if (isDeleted !== undefined) {
                localVarQueryParameter['IsDeleted'] = isDeleted;
            }


    
            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Получить аватар по ID
         * @param {string} id Идентификатор аватара
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAvatarById: async (id: string, apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getAvatarById', 'id', id)
            const localVarPath = `/api/v1/avatars/get-avatar-by-id/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AvatarApi - functional programming interface
 * @export
 */
export const AvatarApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AvatarApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Получить аватары по заданным условиям
         * @param {ApiGender} [gender] Пол
         * @param {ApiPetType} [petType] Тип питомца
         * @param {string} [searchQuery] Строка для поиска
         * @param {number} [takeCount] Размер страницы
         * @param {number} [skipCount] Кол-во пропущенных записей
         * @param {boolean} [ascending] Сортировка по возрастанию
         * @param {string} [ordering] Поле для сортировки
         * @param {boolean} [isDeleted] Удалённые записи
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllAvatars(gender?: ApiGender, petType?: ApiPetType, searchQuery?: string, takeCount?: number, skipCount?: number, ascending?: boolean, ordering?: string, isDeleted?: boolean, apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AvatarResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllAvatars(gender, petType, searchQuery, takeCount, skipCount, ascending, ordering, isDeleted, apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AvatarApi.getAllAvatars']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Получить аватар по ID
         * @param {string} id Идентификатор аватара
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAvatarById(id: string, apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AvatarResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAvatarById(id, apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AvatarApi.getAvatarById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AvatarApi - factory interface
 * @export
 */
export const AvatarApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AvatarApiFp(configuration)
    return {
        /**
         * 
         * @summary Получить аватары по заданным условиям
         * @param {AvatarApiGetAllAvatarsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllAvatars(requestParameters: AvatarApiGetAllAvatarsRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<Array<AvatarResponse>> {
            return localVarFp.getAllAvatars(requestParameters.gender, requestParameters.petType, requestParameters.searchQuery, requestParameters.takeCount, requestParameters.skipCount, requestParameters.ascending, requestParameters.ordering, requestParameters.isDeleted, requestParameters.apiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Получить аватар по ID
         * @param {AvatarApiGetAvatarByIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAvatarById(requestParameters: AvatarApiGetAvatarByIdRequest, options?: RawAxiosRequestConfig): AxiosPromise<AvatarResponse> {
            return localVarFp.getAvatarById(requestParameters.id, requestParameters.apiVersion, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for getAllAvatars operation in AvatarApi.
 * @export
 * @interface AvatarApiGetAllAvatarsRequest
 */
export interface AvatarApiGetAllAvatarsRequest {
    /**
     * Пол
     * @type {ApiGender}
     * @memberof AvatarApiGetAllAvatars
     */
    readonly gender?: ApiGender

    /**
     * Тип питомца
     * @type {ApiPetType}
     * @memberof AvatarApiGetAllAvatars
     */
    readonly petType?: ApiPetType

    /**
     * Строка для поиска
     * @type {string}
     * @memberof AvatarApiGetAllAvatars
     */
    readonly searchQuery?: string

    /**
     * Размер страницы
     * @type {number}
     * @memberof AvatarApiGetAllAvatars
     */
    readonly takeCount?: number

    /**
     * Кол-во пропущенных записей
     * @type {number}
     * @memberof AvatarApiGetAllAvatars
     */
    readonly skipCount?: number

    /**
     * Сортировка по возрастанию
     * @type {boolean}
     * @memberof AvatarApiGetAllAvatars
     */
    readonly ascending?: boolean

    /**
     * Поле для сортировки
     * @type {string}
     * @memberof AvatarApiGetAllAvatars
     */
    readonly ordering?: string

    /**
     * Удалённые записи
     * @type {boolean}
     * @memberof AvatarApiGetAllAvatars
     */
    readonly isDeleted?: boolean

    /**
     * 
     * @type {string}
     * @memberof AvatarApiGetAllAvatars
     */
    readonly apiVersion?: string
}

/**
 * Request parameters for getAvatarById operation in AvatarApi.
 * @export
 * @interface AvatarApiGetAvatarByIdRequest
 */
export interface AvatarApiGetAvatarByIdRequest {
    /**
     * Идентификатор аватара
     * @type {string}
     * @memberof AvatarApiGetAvatarById
     */
    readonly id: string

    /**
     * 
     * @type {string}
     * @memberof AvatarApiGetAvatarById
     */
    readonly apiVersion?: string
}

/**
 * AvatarApi - object-oriented interface
 * @export
 * @class AvatarApi
 * @extends {BaseAPI}
 */
export class AvatarApi extends BaseAPI {
    /**
     * 
     * @summary Получить аватары по заданным условиям
     * @param {AvatarApiGetAllAvatarsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AvatarApi
     */
    public getAllAvatars(requestParameters: AvatarApiGetAllAvatarsRequest = {}, options?: RawAxiosRequestConfig) {
        return AvatarApiFp(this.configuration).getAllAvatars(requestParameters.gender, requestParameters.petType, requestParameters.searchQuery, requestParameters.takeCount, requestParameters.skipCount, requestParameters.ascending, requestParameters.ordering, requestParameters.isDeleted, requestParameters.apiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Получить аватар по ID
     * @param {AvatarApiGetAvatarByIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AvatarApi
     */
    public getAvatarById(requestParameters: AvatarApiGetAvatarByIdRequest, options?: RawAxiosRequestConfig) {
        return AvatarApiFp(this.configuration).getAvatarById(requestParameters.id, requestParameters.apiVersion, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * BankApi - axios parameter creator
 * @export
 */
export const BankApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Получить список банков
         * @param {string} [bankName] 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1BanksGetAllGet: async (bankName?: string, apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/banks/get-all`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (bankName !== undefined) {
                localVarQueryParameter['bankName'] = bankName;
            }


    
            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * BankApi - functional programming interface
 * @export
 */
export const BankApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = BankApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Получить список банков
         * @param {string} [bankName] 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1BanksGetAllGet(bankName?: string, apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<BankResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1BanksGetAllGet(bankName, apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BankApi.apiV1BanksGetAllGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * BankApi - factory interface
 * @export
 */
export const BankApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = BankApiFp(configuration)
    return {
        /**
         * 
         * @summary Получить список банков
         * @param {BankApiApiV1BanksGetAllGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1BanksGetAllGet(requestParameters: BankApiApiV1BanksGetAllGetRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<Array<BankResponse>> {
            return localVarFp.apiV1BanksGetAllGet(requestParameters.bankName, requestParameters.apiVersion, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for apiV1BanksGetAllGet operation in BankApi.
 * @export
 * @interface BankApiApiV1BanksGetAllGetRequest
 */
export interface BankApiApiV1BanksGetAllGetRequest {
    /**
     * 
     * @type {string}
     * @memberof BankApiApiV1BanksGetAllGet
     */
    readonly bankName?: string

    /**
     * 
     * @type {string}
     * @memberof BankApiApiV1BanksGetAllGet
     */
    readonly apiVersion?: string
}

/**
 * BankApi - object-oriented interface
 * @export
 * @class BankApi
 * @extends {BaseAPI}
 */
export class BankApi extends BaseAPI {
    /**
     * 
     * @summary Получить список банков
     * @param {BankApiApiV1BanksGetAllGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BankApi
     */
    public apiV1BanksGetAllGet(requestParameters: BankApiApiV1BanksGetAllGetRequest = {}, options?: RawAxiosRequestConfig) {
        return BankApiFp(this.configuration).apiV1BanksGetAllGet(requestParameters.bankName, requestParameters.apiVersion, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * BlogApi - axios parameter creator
 * @export
 */
export const BlogApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Получить посты блога
         * @param {boolean} [isShowServices] Показывать блоги в приложении пользователям
         * @param {Array<ApiBlogPostAudience>} [audiences] Тип целевой аудитории читателей блога для поиска
         * @param {string} [searchQuery] Строка для поиска
         * @param {number} [takeCount] Размер страницы
         * @param {number} [skipCount] Кол-во пропущенных записей
         * @param {boolean} [ascending] Сортировка по возрастанию
         * @param {string} [ordering] Поле для сортировки
         * @param {boolean} [isDeleted] Удалённые записи
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1BlogsGetAllGet: async (isShowServices?: boolean, audiences?: Array<ApiBlogPostAudience>, searchQuery?: string, takeCount?: number, skipCount?: number, ascending?: boolean, ordering?: string, isDeleted?: boolean, apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/blogs/get-all`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (isShowServices !== undefined) {
                localVarQueryParameter['IsShowServices'] = isShowServices;
            }

            if (audiences) {
                localVarQueryParameter['Audiences'] = audiences;
            }

            if (searchQuery !== undefined) {
                localVarQueryParameter['SearchQuery'] = searchQuery;
            }

            if (takeCount !== undefined) {
                localVarQueryParameter['TakeCount'] = takeCount;
            }

            if (skipCount !== undefined) {
                localVarQueryParameter['SkipCount'] = skipCount;
            }

            if (ascending !== undefined) {
                localVarQueryParameter['Ascending'] = ascending;
            }

            if (ordering !== undefined) {
                localVarQueryParameter['Ordering'] = ordering;
            }

            if (isDeleted !== undefined) {
                localVarQueryParameter['IsDeleted'] = isDeleted;
            }


    
            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Создать пост блога
         * @param {string} [apiVersion] 
         * @param {CreateBlogPostRequest} [createBlogPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createBlog: async (apiVersion?: string, createBlogPostRequest?: CreateBlogPostRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/blogs`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createBlogPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Удалить пост блога
         * @param {string} id Идентификатор поста блога
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteBlog: async (id: string, apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteBlog', 'id', id)
            const localVarPath = `/api/v1/blogs/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Получить пост блога по ID
         * @param {string} id 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBlogById: async (id: string, apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getBlogById', 'id', id)
            const localVarPath = `/api/v1/blogs/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Обновить пост блога
         * @param {string} id Идентификатор поста блога
         * @param {string} [apiVersion] 
         * @param {UpdateBlogPostRequest} [updateBlogPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateBlog: async (id: string, apiVersion?: string, updateBlogPostRequest?: UpdateBlogPostRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateBlog', 'id', id)
            const localVarPath = `/api/v1/blogs/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateBlogPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * BlogApi - functional programming interface
 * @export
 */
export const BlogApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = BlogApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Получить посты блога
         * @param {boolean} [isShowServices] Показывать блоги в приложении пользователям
         * @param {Array<ApiBlogPostAudience>} [audiences] Тип целевой аудитории читателей блога для поиска
         * @param {string} [searchQuery] Строка для поиска
         * @param {number} [takeCount] Размер страницы
         * @param {number} [skipCount] Кол-во пропущенных записей
         * @param {boolean} [ascending] Сортировка по возрастанию
         * @param {string} [ordering] Поле для сортировки
         * @param {boolean} [isDeleted] Удалённые записи
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1BlogsGetAllGet(isShowServices?: boolean, audiences?: Array<ApiBlogPostAudience>, searchQuery?: string, takeCount?: number, skipCount?: number, ascending?: boolean, ordering?: string, isDeleted?: boolean, apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<BlogPostResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1BlogsGetAllGet(isShowServices, audiences, searchQuery, takeCount, skipCount, ascending, ordering, isDeleted, apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BlogApi.apiV1BlogsGetAllGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Создать пост блога
         * @param {string} [apiVersion] 
         * @param {CreateBlogPostRequest} [createBlogPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createBlog(apiVersion?: string, createBlogPostRequest?: CreateBlogPostRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BlogPostResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createBlog(apiVersion, createBlogPostRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BlogApi.createBlog']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Удалить пост блога
         * @param {string} id Идентификатор поста блога
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteBlog(id: string, apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteBlog(id, apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BlogApi.deleteBlog']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Получить пост блога по ID
         * @param {string} id 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getBlogById(id: string, apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BlogPostResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getBlogById(id, apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BlogApi.getBlogById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Обновить пост блога
         * @param {string} id Идентификатор поста блога
         * @param {string} [apiVersion] 
         * @param {UpdateBlogPostRequest} [updateBlogPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateBlog(id: string, apiVersion?: string, updateBlogPostRequest?: UpdateBlogPostRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BlogPostResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateBlog(id, apiVersion, updateBlogPostRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BlogApi.updateBlog']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * BlogApi - factory interface
 * @export
 */
export const BlogApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = BlogApiFp(configuration)
    return {
        /**
         * 
         * @summary Получить посты блога
         * @param {BlogApiApiV1BlogsGetAllGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1BlogsGetAllGet(requestParameters: BlogApiApiV1BlogsGetAllGetRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<Array<BlogPostResponse>> {
            return localVarFp.apiV1BlogsGetAllGet(requestParameters.isShowServices, requestParameters.audiences, requestParameters.searchQuery, requestParameters.takeCount, requestParameters.skipCount, requestParameters.ascending, requestParameters.ordering, requestParameters.isDeleted, requestParameters.apiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Создать пост блога
         * @param {BlogApiCreateBlogRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createBlog(requestParameters: BlogApiCreateBlogRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<BlogPostResponse> {
            return localVarFp.createBlog(requestParameters.apiVersion, requestParameters.createBlogPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Удалить пост блога
         * @param {BlogApiDeleteBlogRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteBlog(requestParameters: BlogApiDeleteBlogRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteBlog(requestParameters.id, requestParameters.apiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Получить пост блога по ID
         * @param {BlogApiGetBlogByIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBlogById(requestParameters: BlogApiGetBlogByIdRequest, options?: RawAxiosRequestConfig): AxiosPromise<BlogPostResponse> {
            return localVarFp.getBlogById(requestParameters.id, requestParameters.apiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Обновить пост блога
         * @param {BlogApiUpdateBlogRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateBlog(requestParameters: BlogApiUpdateBlogRequest, options?: RawAxiosRequestConfig): AxiosPromise<BlogPostResponse> {
            return localVarFp.updateBlog(requestParameters.id, requestParameters.apiVersion, requestParameters.updateBlogPostRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for apiV1BlogsGetAllGet operation in BlogApi.
 * @export
 * @interface BlogApiApiV1BlogsGetAllGetRequest
 */
export interface BlogApiApiV1BlogsGetAllGetRequest {
    /**
     * Показывать блоги в приложении пользователям
     * @type {boolean}
     * @memberof BlogApiApiV1BlogsGetAllGet
     */
    readonly isShowServices?: boolean

    /**
     * Тип целевой аудитории читателей блога для поиска
     * @type {Array<ApiBlogPostAudience>}
     * @memberof BlogApiApiV1BlogsGetAllGet
     */
    readonly audiences?: Array<ApiBlogPostAudience>

    /**
     * Строка для поиска
     * @type {string}
     * @memberof BlogApiApiV1BlogsGetAllGet
     */
    readonly searchQuery?: string

    /**
     * Размер страницы
     * @type {number}
     * @memberof BlogApiApiV1BlogsGetAllGet
     */
    readonly takeCount?: number

    /**
     * Кол-во пропущенных записей
     * @type {number}
     * @memberof BlogApiApiV1BlogsGetAllGet
     */
    readonly skipCount?: number

    /**
     * Сортировка по возрастанию
     * @type {boolean}
     * @memberof BlogApiApiV1BlogsGetAllGet
     */
    readonly ascending?: boolean

    /**
     * Поле для сортировки
     * @type {string}
     * @memberof BlogApiApiV1BlogsGetAllGet
     */
    readonly ordering?: string

    /**
     * Удалённые записи
     * @type {boolean}
     * @memberof BlogApiApiV1BlogsGetAllGet
     */
    readonly isDeleted?: boolean

    /**
     * 
     * @type {string}
     * @memberof BlogApiApiV1BlogsGetAllGet
     */
    readonly apiVersion?: string
}

/**
 * Request parameters for createBlog operation in BlogApi.
 * @export
 * @interface BlogApiCreateBlogRequest
 */
export interface BlogApiCreateBlogRequest {
    /**
     * 
     * @type {string}
     * @memberof BlogApiCreateBlog
     */
    readonly apiVersion?: string

    /**
     * 
     * @type {CreateBlogPostRequest}
     * @memberof BlogApiCreateBlog
     */
    readonly createBlogPostRequest?: CreateBlogPostRequest
}

/**
 * Request parameters for deleteBlog operation in BlogApi.
 * @export
 * @interface BlogApiDeleteBlogRequest
 */
export interface BlogApiDeleteBlogRequest {
    /**
     * Идентификатор поста блога
     * @type {string}
     * @memberof BlogApiDeleteBlog
     */
    readonly id: string

    /**
     * 
     * @type {string}
     * @memberof BlogApiDeleteBlog
     */
    readonly apiVersion?: string
}

/**
 * Request parameters for getBlogById operation in BlogApi.
 * @export
 * @interface BlogApiGetBlogByIdRequest
 */
export interface BlogApiGetBlogByIdRequest {
    /**
     * 
     * @type {string}
     * @memberof BlogApiGetBlogById
     */
    readonly id: string

    /**
     * 
     * @type {string}
     * @memberof BlogApiGetBlogById
     */
    readonly apiVersion?: string
}

/**
 * Request parameters for updateBlog operation in BlogApi.
 * @export
 * @interface BlogApiUpdateBlogRequest
 */
export interface BlogApiUpdateBlogRequest {
    /**
     * Идентификатор поста блога
     * @type {string}
     * @memberof BlogApiUpdateBlog
     */
    readonly id: string

    /**
     * 
     * @type {string}
     * @memberof BlogApiUpdateBlog
     */
    readonly apiVersion?: string

    /**
     * 
     * @type {UpdateBlogPostRequest}
     * @memberof BlogApiUpdateBlog
     */
    readonly updateBlogPostRequest?: UpdateBlogPostRequest
}

/**
 * BlogApi - object-oriented interface
 * @export
 * @class BlogApi
 * @extends {BaseAPI}
 */
export class BlogApi extends BaseAPI {
    /**
     * 
     * @summary Получить посты блога
     * @param {BlogApiApiV1BlogsGetAllGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BlogApi
     */
    public apiV1BlogsGetAllGet(requestParameters: BlogApiApiV1BlogsGetAllGetRequest = {}, options?: RawAxiosRequestConfig) {
        return BlogApiFp(this.configuration).apiV1BlogsGetAllGet(requestParameters.isShowServices, requestParameters.audiences, requestParameters.searchQuery, requestParameters.takeCount, requestParameters.skipCount, requestParameters.ascending, requestParameters.ordering, requestParameters.isDeleted, requestParameters.apiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Создать пост блога
     * @param {BlogApiCreateBlogRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BlogApi
     */
    public createBlog(requestParameters: BlogApiCreateBlogRequest = {}, options?: RawAxiosRequestConfig) {
        return BlogApiFp(this.configuration).createBlog(requestParameters.apiVersion, requestParameters.createBlogPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Удалить пост блога
     * @param {BlogApiDeleteBlogRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BlogApi
     */
    public deleteBlog(requestParameters: BlogApiDeleteBlogRequest, options?: RawAxiosRequestConfig) {
        return BlogApiFp(this.configuration).deleteBlog(requestParameters.id, requestParameters.apiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Получить пост блога по ID
     * @param {BlogApiGetBlogByIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BlogApi
     */
    public getBlogById(requestParameters: BlogApiGetBlogByIdRequest, options?: RawAxiosRequestConfig) {
        return BlogApiFp(this.configuration).getBlogById(requestParameters.id, requestParameters.apiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Обновить пост блога
     * @param {BlogApiUpdateBlogRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BlogApi
     */
    public updateBlog(requestParameters: BlogApiUpdateBlogRequest, options?: RawAxiosRequestConfig) {
        return BlogApiFp(this.configuration).updateBlog(requestParameters.id, requestParameters.apiVersion, requestParameters.updateBlogPostRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * BonusAccountApi - axios parameter creator
 * @export
 */
export const BonusAccountApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Начислить бонусные баллы
         * @param {string} [apiVersion] 
         * @param {AccrueBonusPointsRequest} [accrueBonusPointsRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accrue: async (apiVersion?: string, accrueBonusPointsRequest?: AccrueBonusPointsRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/bonus-accounts/accrue`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(accrueBonusPointsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Заблокировать бонусный счёт
         * @param {string} clientId 
         * @param {string} [apiVersion] 
         * @param {ChangeBonusAccountRequest} [changeBonusAccountRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        blockBonusAccount: async (clientId: string, apiVersion?: string, changeBonusAccountRequest?: ChangeBonusAccountRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'clientId' is not null or undefined
            assertParamExists('blockBonusAccount', 'clientId', clientId)
            const localVarPath = `/api/v1/bonus-accounts/{clientId}/block`
                .replace(`{${"clientId"}}`, encodeURIComponent(String(clientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(changeBonusAccountRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Получить детализацию выбранного начисления бонусов
         * @param {string} clientId 
         * @param {string} transactionId 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccrualDetails: async (clientId: string, transactionId: string, apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'clientId' is not null or undefined
            assertParamExists('getAccrualDetails', 'clientId', clientId)
            // verify required parameter 'transactionId' is not null or undefined
            assertParamExists('getAccrualDetails', 'transactionId', transactionId)
            const localVarPath = `/api/v1/bonus-accounts/{clientId}/accruals/{transactionId}`
                .replace(`{${"clientId"}}`, encodeURIComponent(String(clientId)))
                .replace(`{${"transactionId"}}`, encodeURIComponent(String(transactionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Получить активный бонусный баланс
         * @param {string} clientId 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBalance: async (clientId: string, apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'clientId' is not null or undefined
            assertParamExists('getBalance', 'clientId', clientId)
            const localVarPath = `/api/v1/bonus-accounts/{clientId}/balance`
                .replace(`{${"clientId"}}`, encodeURIComponent(String(clientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Получить бонусный счёт с уровнем и транзакциями
         * @param {string} clientId 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBonusAccount: async (clientId: string, apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'clientId' is not null or undefined
            assertParamExists('getBonusAccount', 'clientId', clientId)
            const localVarPath = `/api/v1/bonus-accounts/{clientId}`
                .replace(`{${"clientId"}}`, encodeURIComponent(String(clientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Получить бонусные счета с фильтрацией и пагинацией
         * @param {string} [apiVersion] 
         * @param {GetBonusAccountsRequest} [getBonusAccountsRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBonusAccounts: async (apiVersion?: string, getBonusAccountsRequest?: GetBonusAccountsRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/bonus-accounts/get-bonus-accounts`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(getBonusAccountsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Получить персональный процент кэшбэка
         * @param {string} clientId 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCashbackPercent: async (clientId: string, apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'clientId' is not null or undefined
            assertParamExists('getCashbackPercent', 'clientId', clientId)
            const localVarPath = `/api/v1/bonus-accounts/{clientId}/cashback-percent`
                .replace(`{${"clientId"}}`, encodeURIComponent(String(clientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Получить детализацию выбранного списания или сгорания
         * @param {string} clientId 
         * @param {string} transactionId 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDebitDetails: async (clientId: string, transactionId: string, apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'clientId' is not null or undefined
            assertParamExists('getDebitDetails', 'clientId', clientId)
            // verify required parameter 'transactionId' is not null or undefined
            assertParamExists('getDebitDetails', 'transactionId', transactionId)
            const localVarPath = `/api/v1/bonus-accounts/{clientId}/debits/{transactionId}`
                .replace(`{${"clientId"}}`, encodeURIComponent(String(clientId)))
                .replace(`{${"transactionId"}}`, encodeURIComponent(String(transactionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Списать бонусные баллы
         * @param {string} [apiVersion] 
         * @param {SpendBonusPointsRequest} [spendBonusPointsRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        spend: async (apiVersion?: string, spendBonusPointsRequest?: SpendBonusPointsRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/bonus-accounts/spend`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(spendBonusPointsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Разблокировать бонусный счёт
         * @param {string} clientId 
         * @param {string} [apiVersion] 
         * @param {ChangeBonusAccountRequest} [changeBonusAccountRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unblockBonusAccount: async (clientId: string, apiVersion?: string, changeBonusAccountRequest?: ChangeBonusAccountRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'clientId' is not null or undefined
            assertParamExists('unblockBonusAccount', 'clientId', clientId)
            const localVarPath = `/api/v1/bonus-accounts/{clientId}/unblock`
                .replace(`{${"clientId"}}`, encodeURIComponent(String(clientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(changeBonusAccountRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * BonusAccountApi - functional programming interface
 * @export
 */
export const BonusAccountApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = BonusAccountApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Начислить бонусные баллы
         * @param {string} [apiVersion] 
         * @param {AccrueBonusPointsRequest} [accrueBonusPointsRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async accrue(apiVersion?: string, accrueBonusPointsRequest?: AccrueBonusPointsRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BonusOperationResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.accrue(apiVersion, accrueBonusPointsRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BonusAccountApi.accrue']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Заблокировать бонусный счёт
         * @param {string} clientId 
         * @param {string} [apiVersion] 
         * @param {ChangeBonusAccountRequest} [changeBonusAccountRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async blockBonusAccount(clientId: string, apiVersion?: string, changeBonusAccountRequest?: ChangeBonusAccountRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BonusBalanceResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.blockBonusAccount(clientId, apiVersion, changeBonusAccountRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BonusAccountApi.blockBonusAccount']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Получить детализацию выбранного начисления бонусов
         * @param {string} clientId 
         * @param {string} transactionId 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAccrualDetails(clientId: string, transactionId: string, apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BonusAccrualDetailsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAccrualDetails(clientId, transactionId, apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BonusAccountApi.getAccrualDetails']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Получить активный бонусный баланс
         * @param {string} clientId 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getBalance(clientId: string, apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BonusBalanceResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getBalance(clientId, apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BonusAccountApi.getBalance']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Получить бонусный счёт с уровнем и транзакциями
         * @param {string} clientId 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getBonusAccount(clientId: string, apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BonusAccountResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getBonusAccount(clientId, apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BonusAccountApi.getBonusAccount']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Получить бонусные счета с фильтрацией и пагинацией
         * @param {string} [apiVersion] 
         * @param {GetBonusAccountsRequest} [getBonusAccountsRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getBonusAccounts(apiVersion?: string, getBonusAccountsRequest?: GetBonusAccountsRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetBonusAccountsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getBonusAccounts(apiVersion, getBonusAccountsRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BonusAccountApi.getBonusAccounts']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Получить персональный процент кэшбэка
         * @param {string} clientId 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCashbackPercent(clientId: string, apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<number>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCashbackPercent(clientId, apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BonusAccountApi.getCashbackPercent']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Получить детализацию выбранного списания или сгорания
         * @param {string} clientId 
         * @param {string} transactionId 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDebitDetails(clientId: string, transactionId: string, apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BonusDebitDetailsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDebitDetails(clientId, transactionId, apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BonusAccountApi.getDebitDetails']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Списать бонусные баллы
         * @param {string} [apiVersion] 
         * @param {SpendBonusPointsRequest} [spendBonusPointsRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async spend(apiVersion?: string, spendBonusPointsRequest?: SpendBonusPointsRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BonusOperationResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.spend(apiVersion, spendBonusPointsRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BonusAccountApi.spend']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Разблокировать бонусный счёт
         * @param {string} clientId 
         * @param {string} [apiVersion] 
         * @param {ChangeBonusAccountRequest} [changeBonusAccountRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async unblockBonusAccount(clientId: string, apiVersion?: string, changeBonusAccountRequest?: ChangeBonusAccountRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BonusBalanceResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.unblockBonusAccount(clientId, apiVersion, changeBonusAccountRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BonusAccountApi.unblockBonusAccount']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * BonusAccountApi - factory interface
 * @export
 */
export const BonusAccountApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = BonusAccountApiFp(configuration)
    return {
        /**
         * 
         * @summary Начислить бонусные баллы
         * @param {BonusAccountApiAccrueRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accrue(requestParameters: BonusAccountApiAccrueRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<BonusOperationResponse> {
            return localVarFp.accrue(requestParameters.apiVersion, requestParameters.accrueBonusPointsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Заблокировать бонусный счёт
         * @param {BonusAccountApiBlockBonusAccountRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        blockBonusAccount(requestParameters: BonusAccountApiBlockBonusAccountRequest, options?: RawAxiosRequestConfig): AxiosPromise<BonusBalanceResponse> {
            return localVarFp.blockBonusAccount(requestParameters.clientId, requestParameters.apiVersion, requestParameters.changeBonusAccountRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Получить детализацию выбранного начисления бонусов
         * @param {BonusAccountApiGetAccrualDetailsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccrualDetails(requestParameters: BonusAccountApiGetAccrualDetailsRequest, options?: RawAxiosRequestConfig): AxiosPromise<BonusAccrualDetailsResponse> {
            return localVarFp.getAccrualDetails(requestParameters.clientId, requestParameters.transactionId, requestParameters.apiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Получить активный бонусный баланс
         * @param {BonusAccountApiGetBalanceRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBalance(requestParameters: BonusAccountApiGetBalanceRequest, options?: RawAxiosRequestConfig): AxiosPromise<BonusBalanceResponse> {
            return localVarFp.getBalance(requestParameters.clientId, requestParameters.apiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Получить бонусный счёт с уровнем и транзакциями
         * @param {BonusAccountApiGetBonusAccountRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBonusAccount(requestParameters: BonusAccountApiGetBonusAccountRequest, options?: RawAxiosRequestConfig): AxiosPromise<BonusAccountResponse> {
            return localVarFp.getBonusAccount(requestParameters.clientId, requestParameters.apiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Получить бонусные счета с фильтрацией и пагинацией
         * @param {BonusAccountApiGetBonusAccountsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBonusAccounts(requestParameters: BonusAccountApiGetBonusAccountsRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<GetBonusAccountsResponse> {
            return localVarFp.getBonusAccounts(requestParameters.apiVersion, requestParameters.getBonusAccountsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Получить персональный процент кэшбэка
         * @param {BonusAccountApiGetCashbackPercentRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCashbackPercent(requestParameters: BonusAccountApiGetCashbackPercentRequest, options?: RawAxiosRequestConfig): AxiosPromise<number> {
            return localVarFp.getCashbackPercent(requestParameters.clientId, requestParameters.apiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Получить детализацию выбранного списания или сгорания
         * @param {BonusAccountApiGetDebitDetailsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDebitDetails(requestParameters: BonusAccountApiGetDebitDetailsRequest, options?: RawAxiosRequestConfig): AxiosPromise<BonusDebitDetailsResponse> {
            return localVarFp.getDebitDetails(requestParameters.clientId, requestParameters.transactionId, requestParameters.apiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Списать бонусные баллы
         * @param {BonusAccountApiSpendRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        spend(requestParameters: BonusAccountApiSpendRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<BonusOperationResponse> {
            return localVarFp.spend(requestParameters.apiVersion, requestParameters.spendBonusPointsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Разблокировать бонусный счёт
         * @param {BonusAccountApiUnblockBonusAccountRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unblockBonusAccount(requestParameters: BonusAccountApiUnblockBonusAccountRequest, options?: RawAxiosRequestConfig): AxiosPromise<BonusBalanceResponse> {
            return localVarFp.unblockBonusAccount(requestParameters.clientId, requestParameters.apiVersion, requestParameters.changeBonusAccountRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for accrue operation in BonusAccountApi.
 * @export
 * @interface BonusAccountApiAccrueRequest
 */
export interface BonusAccountApiAccrueRequest {
    /**
     * 
     * @type {string}
     * @memberof BonusAccountApiAccrue
     */
    readonly apiVersion?: string

    /**
     * 
     * @type {AccrueBonusPointsRequest}
     * @memberof BonusAccountApiAccrue
     */
    readonly accrueBonusPointsRequest?: AccrueBonusPointsRequest
}

/**
 * Request parameters for blockBonusAccount operation in BonusAccountApi.
 * @export
 * @interface BonusAccountApiBlockBonusAccountRequest
 */
export interface BonusAccountApiBlockBonusAccountRequest {
    /**
     * 
     * @type {string}
     * @memberof BonusAccountApiBlockBonusAccount
     */
    readonly clientId: string

    /**
     * 
     * @type {string}
     * @memberof BonusAccountApiBlockBonusAccount
     */
    readonly apiVersion?: string

    /**
     * 
     * @type {ChangeBonusAccountRequest}
     * @memberof BonusAccountApiBlockBonusAccount
     */
    readonly changeBonusAccountRequest?: ChangeBonusAccountRequest
}

/**
 * Request parameters for getAccrualDetails operation in BonusAccountApi.
 * @export
 * @interface BonusAccountApiGetAccrualDetailsRequest
 */
export interface BonusAccountApiGetAccrualDetailsRequest {
    /**
     * 
     * @type {string}
     * @memberof BonusAccountApiGetAccrualDetails
     */
    readonly clientId: string

    /**
     * 
     * @type {string}
     * @memberof BonusAccountApiGetAccrualDetails
     */
    readonly transactionId: string

    /**
     * 
     * @type {string}
     * @memberof BonusAccountApiGetAccrualDetails
     */
    readonly apiVersion?: string
}

/**
 * Request parameters for getBalance operation in BonusAccountApi.
 * @export
 * @interface BonusAccountApiGetBalanceRequest
 */
export interface BonusAccountApiGetBalanceRequest {
    /**
     * 
     * @type {string}
     * @memberof BonusAccountApiGetBalance
     */
    readonly clientId: string

    /**
     * 
     * @type {string}
     * @memberof BonusAccountApiGetBalance
     */
    readonly apiVersion?: string
}

/**
 * Request parameters for getBonusAccount operation in BonusAccountApi.
 * @export
 * @interface BonusAccountApiGetBonusAccountRequest
 */
export interface BonusAccountApiGetBonusAccountRequest {
    /**
     * 
     * @type {string}
     * @memberof BonusAccountApiGetBonusAccount
     */
    readonly clientId: string

    /**
     * 
     * @type {string}
     * @memberof BonusAccountApiGetBonusAccount
     */
    readonly apiVersion?: string
}

/**
 * Request parameters for getBonusAccounts operation in BonusAccountApi.
 * @export
 * @interface BonusAccountApiGetBonusAccountsRequest
 */
export interface BonusAccountApiGetBonusAccountsRequest {
    /**
     * 
     * @type {string}
     * @memberof BonusAccountApiGetBonusAccounts
     */
    readonly apiVersion?: string

    /**
     * 
     * @type {GetBonusAccountsRequest}
     * @memberof BonusAccountApiGetBonusAccounts
     */
    readonly getBonusAccountsRequest?: GetBonusAccountsRequest
}

/**
 * Request parameters for getCashbackPercent operation in BonusAccountApi.
 * @export
 * @interface BonusAccountApiGetCashbackPercentRequest
 */
export interface BonusAccountApiGetCashbackPercentRequest {
    /**
     * 
     * @type {string}
     * @memberof BonusAccountApiGetCashbackPercent
     */
    readonly clientId: string

    /**
     * 
     * @type {string}
     * @memberof BonusAccountApiGetCashbackPercent
     */
    readonly apiVersion?: string
}

/**
 * Request parameters for getDebitDetails operation in BonusAccountApi.
 * @export
 * @interface BonusAccountApiGetDebitDetailsRequest
 */
export interface BonusAccountApiGetDebitDetailsRequest {
    /**
     * 
     * @type {string}
     * @memberof BonusAccountApiGetDebitDetails
     */
    readonly clientId: string

    /**
     * 
     * @type {string}
     * @memberof BonusAccountApiGetDebitDetails
     */
    readonly transactionId: string

    /**
     * 
     * @type {string}
     * @memberof BonusAccountApiGetDebitDetails
     */
    readonly apiVersion?: string
}

/**
 * Request parameters for spend operation in BonusAccountApi.
 * @export
 * @interface BonusAccountApiSpendRequest
 */
export interface BonusAccountApiSpendRequest {
    /**
     * 
     * @type {string}
     * @memberof BonusAccountApiSpend
     */
    readonly apiVersion?: string

    /**
     * 
     * @type {SpendBonusPointsRequest}
     * @memberof BonusAccountApiSpend
     */
    readonly spendBonusPointsRequest?: SpendBonusPointsRequest
}

/**
 * Request parameters for unblockBonusAccount operation in BonusAccountApi.
 * @export
 * @interface BonusAccountApiUnblockBonusAccountRequest
 */
export interface BonusAccountApiUnblockBonusAccountRequest {
    /**
     * 
     * @type {string}
     * @memberof BonusAccountApiUnblockBonusAccount
     */
    readonly clientId: string

    /**
     * 
     * @type {string}
     * @memberof BonusAccountApiUnblockBonusAccount
     */
    readonly apiVersion?: string

    /**
     * 
     * @type {ChangeBonusAccountRequest}
     * @memberof BonusAccountApiUnblockBonusAccount
     */
    readonly changeBonusAccountRequest?: ChangeBonusAccountRequest
}

/**
 * BonusAccountApi - object-oriented interface
 * @export
 * @class BonusAccountApi
 * @extends {BaseAPI}
 */
export class BonusAccountApi extends BaseAPI {
    /**
     * 
     * @summary Начислить бонусные баллы
     * @param {BonusAccountApiAccrueRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BonusAccountApi
     */
    public accrue(requestParameters: BonusAccountApiAccrueRequest = {}, options?: RawAxiosRequestConfig) {
        return BonusAccountApiFp(this.configuration).accrue(requestParameters.apiVersion, requestParameters.accrueBonusPointsRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Заблокировать бонусный счёт
     * @param {BonusAccountApiBlockBonusAccountRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BonusAccountApi
     */
    public blockBonusAccount(requestParameters: BonusAccountApiBlockBonusAccountRequest, options?: RawAxiosRequestConfig) {
        return BonusAccountApiFp(this.configuration).blockBonusAccount(requestParameters.clientId, requestParameters.apiVersion, requestParameters.changeBonusAccountRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Получить детализацию выбранного начисления бонусов
     * @param {BonusAccountApiGetAccrualDetailsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BonusAccountApi
     */
    public getAccrualDetails(requestParameters: BonusAccountApiGetAccrualDetailsRequest, options?: RawAxiosRequestConfig) {
        return BonusAccountApiFp(this.configuration).getAccrualDetails(requestParameters.clientId, requestParameters.transactionId, requestParameters.apiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Получить активный бонусный баланс
     * @param {BonusAccountApiGetBalanceRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BonusAccountApi
     */
    public getBalance(requestParameters: BonusAccountApiGetBalanceRequest, options?: RawAxiosRequestConfig) {
        return BonusAccountApiFp(this.configuration).getBalance(requestParameters.clientId, requestParameters.apiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Получить бонусный счёт с уровнем и транзакциями
     * @param {BonusAccountApiGetBonusAccountRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BonusAccountApi
     */
    public getBonusAccount(requestParameters: BonusAccountApiGetBonusAccountRequest, options?: RawAxiosRequestConfig) {
        return BonusAccountApiFp(this.configuration).getBonusAccount(requestParameters.clientId, requestParameters.apiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Получить бонусные счета с фильтрацией и пагинацией
     * @param {BonusAccountApiGetBonusAccountsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BonusAccountApi
     */
    public getBonusAccounts(requestParameters: BonusAccountApiGetBonusAccountsRequest = {}, options?: RawAxiosRequestConfig) {
        return BonusAccountApiFp(this.configuration).getBonusAccounts(requestParameters.apiVersion, requestParameters.getBonusAccountsRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Получить персональный процент кэшбэка
     * @param {BonusAccountApiGetCashbackPercentRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BonusAccountApi
     */
    public getCashbackPercent(requestParameters: BonusAccountApiGetCashbackPercentRequest, options?: RawAxiosRequestConfig) {
        return BonusAccountApiFp(this.configuration).getCashbackPercent(requestParameters.clientId, requestParameters.apiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Получить детализацию выбранного списания или сгорания
     * @param {BonusAccountApiGetDebitDetailsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BonusAccountApi
     */
    public getDebitDetails(requestParameters: BonusAccountApiGetDebitDetailsRequest, options?: RawAxiosRequestConfig) {
        return BonusAccountApiFp(this.configuration).getDebitDetails(requestParameters.clientId, requestParameters.transactionId, requestParameters.apiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Списать бонусные баллы
     * @param {BonusAccountApiSpendRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BonusAccountApi
     */
    public spend(requestParameters: BonusAccountApiSpendRequest = {}, options?: RawAxiosRequestConfig) {
        return BonusAccountApiFp(this.configuration).spend(requestParameters.apiVersion, requestParameters.spendBonusPointsRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Разблокировать бонусный счёт
     * @param {BonusAccountApiUnblockBonusAccountRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BonusAccountApi
     */
    public unblockBonusAccount(requestParameters: BonusAccountApiUnblockBonusAccountRequest, options?: RawAxiosRequestConfig) {
        return BonusAccountApiFp(this.configuration).unblockBonusAccount(requestParameters.clientId, requestParameters.apiVersion, requestParameters.changeBonusAccountRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * CacheManagementApi - axios parameter creator
 * @export
 */
export const CacheManagementApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Получить разделы управления кэшем
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAdminCacheGet: async (apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/admin/cache`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Принудительное обновление всего кэша
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAdminCacheRefreshAllPost: async (apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/admin/cache/refresh/all`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Принудительное обновление кэша аватаров
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAdminCacheRefreshAvatarsPost: async (apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/admin/cache/refresh/avatars`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Принудительное обновление кэша городов
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAdminCacheRefreshCitiesPost: async (apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/admin/cache/refresh/cities`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Перезагрузить запись выбранного кэша
         * @param {string} name 
         * @param {string} id 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAdminCacheRefreshNameIdPost: async (name: string, id: string, apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'name' is not null or undefined
            assertParamExists('apiAdminCacheRefreshNameIdPost', 'name', name)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAdminCacheRefreshNameIdPost', 'id', id)
            const localVarPath = `/api/admin/cache/refresh/{name}/{id}`
                .replace(`{${"name"}}`, encodeURIComponent(String(name)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Перезагрузить все записи выбранного кэша
         * @param {string} name 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAdminCacheRefreshNamePost: async (name: string, apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'name' is not null or undefined
            assertParamExists('apiAdminCacheRefreshNamePost', 'name', name)
            const localVarPath = `/api/admin/cache/refresh/{name}`
                .replace(`{${"name"}}`, encodeURIComponent(String(name)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Принудительное обновление кэша продуктов
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAdminCacheRefreshProductsPost: async (apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/admin/cache/refresh/products`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CacheManagementApi - functional programming interface
 * @export
 */
export const CacheManagementApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CacheManagementApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Получить разделы управления кэшем
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAdminCacheGet(apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CacheResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAdminCacheGet(apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CacheManagementApi.apiAdminCacheGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Принудительное обновление всего кэша
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAdminCacheRefreshAllPost(apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAdminCacheRefreshAllPost(apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CacheManagementApi.apiAdminCacheRefreshAllPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Принудительное обновление кэша аватаров
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAdminCacheRefreshAvatarsPost(apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAdminCacheRefreshAvatarsPost(apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CacheManagementApi.apiAdminCacheRefreshAvatarsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Принудительное обновление кэша городов
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAdminCacheRefreshCitiesPost(apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAdminCacheRefreshCitiesPost(apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CacheManagementApi.apiAdminCacheRefreshCitiesPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Перезагрузить запись выбранного кэша
         * @param {string} name 
         * @param {string} id 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAdminCacheRefreshNameIdPost(name: string, id: string, apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAdminCacheRefreshNameIdPost(name, id, apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CacheManagementApi.apiAdminCacheRefreshNameIdPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Перезагрузить все записи выбранного кэша
         * @param {string} name 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAdminCacheRefreshNamePost(name: string, apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAdminCacheRefreshNamePost(name, apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CacheManagementApi.apiAdminCacheRefreshNamePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Принудительное обновление кэша продуктов
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAdminCacheRefreshProductsPost(apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAdminCacheRefreshProductsPost(apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CacheManagementApi.apiAdminCacheRefreshProductsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * CacheManagementApi - factory interface
 * @export
 */
export const CacheManagementApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CacheManagementApiFp(configuration)
    return {
        /**
         * 
         * @summary Получить разделы управления кэшем
         * @param {CacheManagementApiApiAdminCacheGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAdminCacheGet(requestParameters: CacheManagementApiApiAdminCacheGetRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<Array<CacheResponse>> {
            return localVarFp.apiAdminCacheGet(requestParameters.apiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Принудительное обновление всего кэша
         * @param {CacheManagementApiApiAdminCacheRefreshAllPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAdminCacheRefreshAllPost(requestParameters: CacheManagementApiApiAdminCacheRefreshAllPostRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiAdminCacheRefreshAllPost(requestParameters.apiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Принудительное обновление кэша аватаров
         * @param {CacheManagementApiApiAdminCacheRefreshAvatarsPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAdminCacheRefreshAvatarsPost(requestParameters: CacheManagementApiApiAdminCacheRefreshAvatarsPostRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiAdminCacheRefreshAvatarsPost(requestParameters.apiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Принудительное обновление кэша городов
         * @param {CacheManagementApiApiAdminCacheRefreshCitiesPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAdminCacheRefreshCitiesPost(requestParameters: CacheManagementApiApiAdminCacheRefreshCitiesPostRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiAdminCacheRefreshCitiesPost(requestParameters.apiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Перезагрузить запись выбранного кэша
         * @param {CacheManagementApiApiAdminCacheRefreshNameIdPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAdminCacheRefreshNameIdPost(requestParameters: CacheManagementApiApiAdminCacheRefreshNameIdPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiAdminCacheRefreshNameIdPost(requestParameters.name, requestParameters.id, requestParameters.apiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Перезагрузить все записи выбранного кэша
         * @param {CacheManagementApiApiAdminCacheRefreshNamePostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAdminCacheRefreshNamePost(requestParameters: CacheManagementApiApiAdminCacheRefreshNamePostRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiAdminCacheRefreshNamePost(requestParameters.name, requestParameters.apiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Принудительное обновление кэша продуктов
         * @param {CacheManagementApiApiAdminCacheRefreshProductsPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAdminCacheRefreshProductsPost(requestParameters: CacheManagementApiApiAdminCacheRefreshProductsPostRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiAdminCacheRefreshProductsPost(requestParameters.apiVersion, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for apiAdminCacheGet operation in CacheManagementApi.
 * @export
 * @interface CacheManagementApiApiAdminCacheGetRequest
 */
export interface CacheManagementApiApiAdminCacheGetRequest {
    /**
     * 
     * @type {string}
     * @memberof CacheManagementApiApiAdminCacheGet
     */
    readonly apiVersion?: string
}

/**
 * Request parameters for apiAdminCacheRefreshAllPost operation in CacheManagementApi.
 * @export
 * @interface CacheManagementApiApiAdminCacheRefreshAllPostRequest
 */
export interface CacheManagementApiApiAdminCacheRefreshAllPostRequest {
    /**
     * 
     * @type {string}
     * @memberof CacheManagementApiApiAdminCacheRefreshAllPost
     */
    readonly apiVersion?: string
}

/**
 * Request parameters for apiAdminCacheRefreshAvatarsPost operation in CacheManagementApi.
 * @export
 * @interface CacheManagementApiApiAdminCacheRefreshAvatarsPostRequest
 */
export interface CacheManagementApiApiAdminCacheRefreshAvatarsPostRequest {
    /**
     * 
     * @type {string}
     * @memberof CacheManagementApiApiAdminCacheRefreshAvatarsPost
     */
    readonly apiVersion?: string
}

/**
 * Request parameters for apiAdminCacheRefreshCitiesPost operation in CacheManagementApi.
 * @export
 * @interface CacheManagementApiApiAdminCacheRefreshCitiesPostRequest
 */
export interface CacheManagementApiApiAdminCacheRefreshCitiesPostRequest {
    /**
     * 
     * @type {string}
     * @memberof CacheManagementApiApiAdminCacheRefreshCitiesPost
     */
    readonly apiVersion?: string
}

/**
 * Request parameters for apiAdminCacheRefreshNameIdPost operation in CacheManagementApi.
 * @export
 * @interface CacheManagementApiApiAdminCacheRefreshNameIdPostRequest
 */
export interface CacheManagementApiApiAdminCacheRefreshNameIdPostRequest {
    /**
     * 
     * @type {string}
     * @memberof CacheManagementApiApiAdminCacheRefreshNameIdPost
     */
    readonly name: string

    /**
     * 
     * @type {string}
     * @memberof CacheManagementApiApiAdminCacheRefreshNameIdPost
     */
    readonly id: string

    /**
     * 
     * @type {string}
     * @memberof CacheManagementApiApiAdminCacheRefreshNameIdPost
     */
    readonly apiVersion?: string
}

/**
 * Request parameters for apiAdminCacheRefreshNamePost operation in CacheManagementApi.
 * @export
 * @interface CacheManagementApiApiAdminCacheRefreshNamePostRequest
 */
export interface CacheManagementApiApiAdminCacheRefreshNamePostRequest {
    /**
     * 
     * @type {string}
     * @memberof CacheManagementApiApiAdminCacheRefreshNamePost
     */
    readonly name: string

    /**
     * 
     * @type {string}
     * @memberof CacheManagementApiApiAdminCacheRefreshNamePost
     */
    readonly apiVersion?: string
}

/**
 * Request parameters for apiAdminCacheRefreshProductsPost operation in CacheManagementApi.
 * @export
 * @interface CacheManagementApiApiAdminCacheRefreshProductsPostRequest
 */
export interface CacheManagementApiApiAdminCacheRefreshProductsPostRequest {
    /**
     * 
     * @type {string}
     * @memberof CacheManagementApiApiAdminCacheRefreshProductsPost
     */
    readonly apiVersion?: string
}

/**
 * CacheManagementApi - object-oriented interface
 * @export
 * @class CacheManagementApi
 * @extends {BaseAPI}
 */
export class CacheManagementApi extends BaseAPI {
    /**
     * 
     * @summary Получить разделы управления кэшем
     * @param {CacheManagementApiApiAdminCacheGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CacheManagementApi
     */
    public apiAdminCacheGet(requestParameters: CacheManagementApiApiAdminCacheGetRequest = {}, options?: RawAxiosRequestConfig) {
        return CacheManagementApiFp(this.configuration).apiAdminCacheGet(requestParameters.apiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Принудительное обновление всего кэша
     * @param {CacheManagementApiApiAdminCacheRefreshAllPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CacheManagementApi
     */
    public apiAdminCacheRefreshAllPost(requestParameters: CacheManagementApiApiAdminCacheRefreshAllPostRequest = {}, options?: RawAxiosRequestConfig) {
        return CacheManagementApiFp(this.configuration).apiAdminCacheRefreshAllPost(requestParameters.apiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Принудительное обновление кэша аватаров
     * @param {CacheManagementApiApiAdminCacheRefreshAvatarsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CacheManagementApi
     */
    public apiAdminCacheRefreshAvatarsPost(requestParameters: CacheManagementApiApiAdminCacheRefreshAvatarsPostRequest = {}, options?: RawAxiosRequestConfig) {
        return CacheManagementApiFp(this.configuration).apiAdminCacheRefreshAvatarsPost(requestParameters.apiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Принудительное обновление кэша городов
     * @param {CacheManagementApiApiAdminCacheRefreshCitiesPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CacheManagementApi
     */
    public apiAdminCacheRefreshCitiesPost(requestParameters: CacheManagementApiApiAdminCacheRefreshCitiesPostRequest = {}, options?: RawAxiosRequestConfig) {
        return CacheManagementApiFp(this.configuration).apiAdminCacheRefreshCitiesPost(requestParameters.apiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Перезагрузить запись выбранного кэша
     * @param {CacheManagementApiApiAdminCacheRefreshNameIdPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CacheManagementApi
     */
    public apiAdminCacheRefreshNameIdPost(requestParameters: CacheManagementApiApiAdminCacheRefreshNameIdPostRequest, options?: RawAxiosRequestConfig) {
        return CacheManagementApiFp(this.configuration).apiAdminCacheRefreshNameIdPost(requestParameters.name, requestParameters.id, requestParameters.apiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Перезагрузить все записи выбранного кэша
     * @param {CacheManagementApiApiAdminCacheRefreshNamePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CacheManagementApi
     */
    public apiAdminCacheRefreshNamePost(requestParameters: CacheManagementApiApiAdminCacheRefreshNamePostRequest, options?: RawAxiosRequestConfig) {
        return CacheManagementApiFp(this.configuration).apiAdminCacheRefreshNamePost(requestParameters.name, requestParameters.apiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Принудительное обновление кэша продуктов
     * @param {CacheManagementApiApiAdminCacheRefreshProductsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CacheManagementApi
     */
    public apiAdminCacheRefreshProductsPost(requestParameters: CacheManagementApiApiAdminCacheRefreshProductsPostRequest = {}, options?: RawAxiosRequestConfig) {
        return CacheManagementApiFp(this.configuration).apiAdminCacheRefreshProductsPost(requestParameters.apiVersion, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * CashbackLevelApi - axios parameter creator
 * @export
 */
export const CashbackLevelApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Создать уровень кэшбэка
         * @param {string} [apiVersion] 
         * @param {SaveCashbackLevelRequest} [saveCashbackLevelRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCashbackLevel: async (apiVersion?: string, saveCashbackLevelRequest?: SaveCashbackLevelRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/cashback-levels`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(saveCashbackLevelRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Удалить уровень кэшбэка
         * @param {string} id 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCashbackLevel: async (id: string, apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteCashbackLevel', 'id', id)
            const localVarPath = `/api/v1/cashback-levels/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Получить все уровни кэшбэка
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllCashbackLevels: async (apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/cashback-levels`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Получить уровень кэшбэка
         * @param {string} id 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCashbackLevel: async (id: string, apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getCashbackLevel', 'id', id)
            const localVarPath = `/api/v1/cashback-levels/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Обновить уровень кэшбэка
         * @param {string} id 
         * @param {string} [apiVersion] 
         * @param {SaveCashbackLevelRequest} [saveCashbackLevelRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCashbackLevel: async (id: string, apiVersion?: string, saveCashbackLevelRequest?: SaveCashbackLevelRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateCashbackLevel', 'id', id)
            const localVarPath = `/api/v1/cashback-levels/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(saveCashbackLevelRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CashbackLevelApi - functional programming interface
 * @export
 */
export const CashbackLevelApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CashbackLevelApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Создать уровень кэшбэка
         * @param {string} [apiVersion] 
         * @param {SaveCashbackLevelRequest} [saveCashbackLevelRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createCashbackLevel(apiVersion?: string, saveCashbackLevelRequest?: SaveCashbackLevelRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CashbackLevelResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createCashbackLevel(apiVersion, saveCashbackLevelRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CashbackLevelApi.createCashbackLevel']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Удалить уровень кэшбэка
         * @param {string} id 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteCashbackLevel(id: string, apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteCashbackLevel(id, apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CashbackLevelApi.deleteCashbackLevel']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Получить все уровни кэшбэка
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllCashbackLevels(apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CashbackLevelResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllCashbackLevels(apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CashbackLevelApi.getAllCashbackLevels']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Получить уровень кэшбэка
         * @param {string} id 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCashbackLevel(id: string, apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CashbackLevelResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCashbackLevel(id, apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CashbackLevelApi.getCashbackLevel']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Обновить уровень кэшбэка
         * @param {string} id 
         * @param {string} [apiVersion] 
         * @param {SaveCashbackLevelRequest} [saveCashbackLevelRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateCashbackLevel(id: string, apiVersion?: string, saveCashbackLevelRequest?: SaveCashbackLevelRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CashbackLevelResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateCashbackLevel(id, apiVersion, saveCashbackLevelRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CashbackLevelApi.updateCashbackLevel']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * CashbackLevelApi - factory interface
 * @export
 */
export const CashbackLevelApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CashbackLevelApiFp(configuration)
    return {
        /**
         * 
         * @summary Создать уровень кэшбэка
         * @param {CashbackLevelApiCreateCashbackLevelRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCashbackLevel(requestParameters: CashbackLevelApiCreateCashbackLevelRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<CashbackLevelResponse> {
            return localVarFp.createCashbackLevel(requestParameters.apiVersion, requestParameters.saveCashbackLevelRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Удалить уровень кэшбэка
         * @param {CashbackLevelApiDeleteCashbackLevelRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCashbackLevel(requestParameters: CashbackLevelApiDeleteCashbackLevelRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteCashbackLevel(requestParameters.id, requestParameters.apiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Получить все уровни кэшбэка
         * @param {CashbackLevelApiGetAllCashbackLevelsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllCashbackLevels(requestParameters: CashbackLevelApiGetAllCashbackLevelsRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<Array<CashbackLevelResponse>> {
            return localVarFp.getAllCashbackLevels(requestParameters.apiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Получить уровень кэшбэка
         * @param {CashbackLevelApiGetCashbackLevelRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCashbackLevel(requestParameters: CashbackLevelApiGetCashbackLevelRequest, options?: RawAxiosRequestConfig): AxiosPromise<CashbackLevelResponse> {
            return localVarFp.getCashbackLevel(requestParameters.id, requestParameters.apiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Обновить уровень кэшбэка
         * @param {CashbackLevelApiUpdateCashbackLevelRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCashbackLevel(requestParameters: CashbackLevelApiUpdateCashbackLevelRequest, options?: RawAxiosRequestConfig): AxiosPromise<CashbackLevelResponse> {
            return localVarFp.updateCashbackLevel(requestParameters.id, requestParameters.apiVersion, requestParameters.saveCashbackLevelRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for createCashbackLevel operation in CashbackLevelApi.
 * @export
 * @interface CashbackLevelApiCreateCashbackLevelRequest
 */
export interface CashbackLevelApiCreateCashbackLevelRequest {
    /**
     * 
     * @type {string}
     * @memberof CashbackLevelApiCreateCashbackLevel
     */
    readonly apiVersion?: string

    /**
     * 
     * @type {SaveCashbackLevelRequest}
     * @memberof CashbackLevelApiCreateCashbackLevel
     */
    readonly saveCashbackLevelRequest?: SaveCashbackLevelRequest
}

/**
 * Request parameters for deleteCashbackLevel operation in CashbackLevelApi.
 * @export
 * @interface CashbackLevelApiDeleteCashbackLevelRequest
 */
export interface CashbackLevelApiDeleteCashbackLevelRequest {
    /**
     * 
     * @type {string}
     * @memberof CashbackLevelApiDeleteCashbackLevel
     */
    readonly id: string

    /**
     * 
     * @type {string}
     * @memberof CashbackLevelApiDeleteCashbackLevel
     */
    readonly apiVersion?: string
}

/**
 * Request parameters for getAllCashbackLevels operation in CashbackLevelApi.
 * @export
 * @interface CashbackLevelApiGetAllCashbackLevelsRequest
 */
export interface CashbackLevelApiGetAllCashbackLevelsRequest {
    /**
     * 
     * @type {string}
     * @memberof CashbackLevelApiGetAllCashbackLevels
     */
    readonly apiVersion?: string
}

/**
 * Request parameters for getCashbackLevel operation in CashbackLevelApi.
 * @export
 * @interface CashbackLevelApiGetCashbackLevelRequest
 */
export interface CashbackLevelApiGetCashbackLevelRequest {
    /**
     * 
     * @type {string}
     * @memberof CashbackLevelApiGetCashbackLevel
     */
    readonly id: string

    /**
     * 
     * @type {string}
     * @memberof CashbackLevelApiGetCashbackLevel
     */
    readonly apiVersion?: string
}

/**
 * Request parameters for updateCashbackLevel operation in CashbackLevelApi.
 * @export
 * @interface CashbackLevelApiUpdateCashbackLevelRequest
 */
export interface CashbackLevelApiUpdateCashbackLevelRequest {
    /**
     * 
     * @type {string}
     * @memberof CashbackLevelApiUpdateCashbackLevel
     */
    readonly id: string

    /**
     * 
     * @type {string}
     * @memberof CashbackLevelApiUpdateCashbackLevel
     */
    readonly apiVersion?: string

    /**
     * 
     * @type {SaveCashbackLevelRequest}
     * @memberof CashbackLevelApiUpdateCashbackLevel
     */
    readonly saveCashbackLevelRequest?: SaveCashbackLevelRequest
}

/**
 * CashbackLevelApi - object-oriented interface
 * @export
 * @class CashbackLevelApi
 * @extends {BaseAPI}
 */
export class CashbackLevelApi extends BaseAPI {
    /**
     * 
     * @summary Создать уровень кэшбэка
     * @param {CashbackLevelApiCreateCashbackLevelRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CashbackLevelApi
     */
    public createCashbackLevel(requestParameters: CashbackLevelApiCreateCashbackLevelRequest = {}, options?: RawAxiosRequestConfig) {
        return CashbackLevelApiFp(this.configuration).createCashbackLevel(requestParameters.apiVersion, requestParameters.saveCashbackLevelRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Удалить уровень кэшбэка
     * @param {CashbackLevelApiDeleteCashbackLevelRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CashbackLevelApi
     */
    public deleteCashbackLevel(requestParameters: CashbackLevelApiDeleteCashbackLevelRequest, options?: RawAxiosRequestConfig) {
        return CashbackLevelApiFp(this.configuration).deleteCashbackLevel(requestParameters.id, requestParameters.apiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Получить все уровни кэшбэка
     * @param {CashbackLevelApiGetAllCashbackLevelsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CashbackLevelApi
     */
    public getAllCashbackLevels(requestParameters: CashbackLevelApiGetAllCashbackLevelsRequest = {}, options?: RawAxiosRequestConfig) {
        return CashbackLevelApiFp(this.configuration).getAllCashbackLevels(requestParameters.apiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Получить уровень кэшбэка
     * @param {CashbackLevelApiGetCashbackLevelRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CashbackLevelApi
     */
    public getCashbackLevel(requestParameters: CashbackLevelApiGetCashbackLevelRequest, options?: RawAxiosRequestConfig) {
        return CashbackLevelApiFp(this.configuration).getCashbackLevel(requestParameters.id, requestParameters.apiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Обновить уровень кэшбэка
     * @param {CashbackLevelApiUpdateCashbackLevelRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CashbackLevelApi
     */
    public updateCashbackLevel(requestParameters: CashbackLevelApiUpdateCashbackLevelRequest, options?: RawAxiosRequestConfig) {
        return CashbackLevelApiFp(this.configuration).updateCashbackLevel(requestParameters.id, requestParameters.apiVersion, requestParameters.saveCashbackLevelRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * CashbackRulesApi - axios parameter creator
 * @export
 */
export const CashbackRulesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Получить правила бонусной программы
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1CashbackRulesGet: async (apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/cashback-rules`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CashbackRulesApi - functional programming interface
 * @export
 */
export const CashbackRulesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CashbackRulesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Получить правила бонусной программы
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1CashbackRulesGet(apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CashbackRulesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1CashbackRulesGet(apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CashbackRulesApi.apiV1CashbackRulesGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * CashbackRulesApi - factory interface
 * @export
 */
export const CashbackRulesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CashbackRulesApiFp(configuration)
    return {
        /**
         * 
         * @summary Получить правила бонусной программы
         * @param {CashbackRulesApiApiV1CashbackRulesGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1CashbackRulesGet(requestParameters: CashbackRulesApiApiV1CashbackRulesGetRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<CashbackRulesResponse> {
            return localVarFp.apiV1CashbackRulesGet(requestParameters.apiVersion, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for apiV1CashbackRulesGet operation in CashbackRulesApi.
 * @export
 * @interface CashbackRulesApiApiV1CashbackRulesGetRequest
 */
export interface CashbackRulesApiApiV1CashbackRulesGetRequest {
    /**
     * 
     * @type {string}
     * @memberof CashbackRulesApiApiV1CashbackRulesGet
     */
    readonly apiVersion?: string
}

/**
 * CashbackRulesApi - object-oriented interface
 * @export
 * @class CashbackRulesApi
 * @extends {BaseAPI}
 */
export class CashbackRulesApi extends BaseAPI {
    /**
     * 
     * @summary Получить правила бонусной программы
     * @param {CashbackRulesApiApiV1CashbackRulesGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CashbackRulesApi
     */
    public apiV1CashbackRulesGet(requestParameters: CashbackRulesApiApiV1CashbackRulesGetRequest = {}, options?: RawAxiosRequestConfig) {
        return CashbackRulesApiFp(this.configuration).apiV1CashbackRulesGet(requestParameters.apiVersion, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * CashbackRulesAdminApi - axios parameter creator
 * @export
 */
export const CashbackRulesAdminApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Получить правила бонусной программы
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCashbackRules: async (apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/admin/cashback-rules`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Сохранить правила бонусной программы
         * @param {string} [apiVersion] 
         * @param {SaveCashbackRulesRequest} [saveCashbackRulesRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveCashbackRules: async (apiVersion?: string, saveCashbackRulesRequest?: SaveCashbackRulesRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/admin/cashback-rules`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(saveCashbackRulesRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CashbackRulesAdminApi - functional programming interface
 * @export
 */
export const CashbackRulesAdminApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CashbackRulesAdminApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Получить правила бонусной программы
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCashbackRules(apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CashbackRulesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCashbackRules(apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CashbackRulesAdminApi.getCashbackRules']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Сохранить правила бонусной программы
         * @param {string} [apiVersion] 
         * @param {SaveCashbackRulesRequest} [saveCashbackRulesRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async saveCashbackRules(apiVersion?: string, saveCashbackRulesRequest?: SaveCashbackRulesRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CashbackRulesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.saveCashbackRules(apiVersion, saveCashbackRulesRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CashbackRulesAdminApi.saveCashbackRules']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * CashbackRulesAdminApi - factory interface
 * @export
 */
export const CashbackRulesAdminApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CashbackRulesAdminApiFp(configuration)
    return {
        /**
         * 
         * @summary Получить правила бонусной программы
         * @param {CashbackRulesAdminApiGetCashbackRulesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCashbackRules(requestParameters: CashbackRulesAdminApiGetCashbackRulesRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<CashbackRulesResponse> {
            return localVarFp.getCashbackRules(requestParameters.apiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Сохранить правила бонусной программы
         * @param {CashbackRulesAdminApiSaveCashbackRulesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveCashbackRules(requestParameters: CashbackRulesAdminApiSaveCashbackRulesRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<CashbackRulesResponse> {
            return localVarFp.saveCashbackRules(requestParameters.apiVersion, requestParameters.saveCashbackRulesRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for getCashbackRules operation in CashbackRulesAdminApi.
 * @export
 * @interface CashbackRulesAdminApiGetCashbackRulesRequest
 */
export interface CashbackRulesAdminApiGetCashbackRulesRequest {
    /**
     * 
     * @type {string}
     * @memberof CashbackRulesAdminApiGetCashbackRules
     */
    readonly apiVersion?: string
}

/**
 * Request parameters for saveCashbackRules operation in CashbackRulesAdminApi.
 * @export
 * @interface CashbackRulesAdminApiSaveCashbackRulesRequest
 */
export interface CashbackRulesAdminApiSaveCashbackRulesRequest {
    /**
     * 
     * @type {string}
     * @memberof CashbackRulesAdminApiSaveCashbackRules
     */
    readonly apiVersion?: string

    /**
     * 
     * @type {SaveCashbackRulesRequest}
     * @memberof CashbackRulesAdminApiSaveCashbackRules
     */
    readonly saveCashbackRulesRequest?: SaveCashbackRulesRequest
}

/**
 * CashbackRulesAdminApi - object-oriented interface
 * @export
 * @class CashbackRulesAdminApi
 * @extends {BaseAPI}
 */
export class CashbackRulesAdminApi extends BaseAPI {
    /**
     * 
     * @summary Получить правила бонусной программы
     * @param {CashbackRulesAdminApiGetCashbackRulesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CashbackRulesAdminApi
     */
    public getCashbackRules(requestParameters: CashbackRulesAdminApiGetCashbackRulesRequest = {}, options?: RawAxiosRequestConfig) {
        return CashbackRulesAdminApiFp(this.configuration).getCashbackRules(requestParameters.apiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Сохранить правила бонусной программы
     * @param {CashbackRulesAdminApiSaveCashbackRulesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CashbackRulesAdminApi
     */
    public saveCashbackRules(requestParameters: CashbackRulesAdminApiSaveCashbackRulesRequest = {}, options?: RawAxiosRequestConfig) {
        return CashbackRulesAdminApiFp(this.configuration).saveCashbackRules(requestParameters.apiVersion, requestParameters.saveCashbackRulesRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ChatApi - axios parameter creator
 * @export
 */
export const ChatApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Создать документ для пользователя Администратор Backend
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAdminBackend: async (apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/chats/create-backend-admin`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Создать пользователя для AI ассистента
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAiAssistant: async (apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/chats/create-ai-assistant`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Создать пользователя для чата
         * @param {string} appUserId Идентификатор пользователя
         * @param {UserRole} role 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createChatUser: async (appUserId: string, role: UserRole, apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'appUserId' is not null or undefined
            assertParamExists('createChatUser', 'appUserId', appUserId)
            // verify required parameter 'role' is not null or undefined
            assertParamExists('createChatUser', 'role', role)
            const localVarPath = `/api/v1/chats/create-chat-user/{appUserId}/{role}`
                .replace(`{${"appUserId"}}`, encodeURIComponent(String(appUserId)))
                .replace(`{${"role"}}`, encodeURIComponent(String(role)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Создать пользователя для технической поддержки
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTechnicalSupport: async (apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/chats/create-technical-support`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Получить счётчики переписки
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getChatDialogCounters: async (apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/admin/chat-dialogs/counters`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Получить историю диалога
         * @param {string} dialogId 
         * @param {number} [beforeSequence] Получить сообщения раньше указанного номера
         * @param {number} [limit] Размер страницы
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getChatDialogMessages: async (dialogId: string, beforeSequence?: number, limit?: number, apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'dialogId' is not null or undefined
            assertParamExists('getChatDialogMessages', 'dialogId', dialogId)
            const localVarPath = `/api/v1/admin/chat-dialogs/{dialogId}/messages`
                .replace(`{${"dialogId"}}`, encodeURIComponent(String(dialogId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (beforeSequence !== undefined) {
                localVarQueryParameter['BeforeSequence'] = beforeSequence;
            }

            if (limit !== undefined) {
                localVarQueryParameter['Limit'] = limit;
            }


    
            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Получить доступ к обновлениям переписки
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getChatDialogRealtime: async (apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/admin/chat-dialogs/realtime`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Получить согласованное состояние переписки
         * @param {Array<string>} [appUserIds] Выбранные учётные записи собеседников
         * @param {boolean} [filterPeople] Ограничивать список выбранными собеседниками
         * @param {ApiUserRole} [companionRole] Роль собеседника среди пользователей приложения VOX
         * @param {Array<number>} [channels] Каналы связи
         * @param {string} [companionName] Слова имени или фамилии собеседника VOX либо Salebot
         * @param {string} [petName] Часть имени питомца собеседника
         * @param {boolean} [unreadOnly] Только непрочитанные диалоги
         * @param {number} [dialogLimit] Число показанных диалогов
         * @param {string} [dialogId] Выбранный диалог
         * @param {number} [oldestSequence] Первое показанное сообщение
         * @param {number} [beforeSequence] Граница загрузки старой истории
         * @param {number} [newestSequence] Последнее показанное сообщение
         * @param {number} [afterSequence] Граница следующей непрочитанной страницы приложения
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getChatDialogSnapshot: async (appUserIds?: Array<string>, filterPeople?: boolean, companionRole?: ApiUserRole, channels?: Array<number>, companionName?: string, petName?: string, unreadOnly?: boolean, dialogLimit?: number, dialogId?: string, oldestSequence?: number, beforeSequence?: number, newestSequence?: number, afterSequence?: number, apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/admin/chat-dialogs/realtime/snapshot`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (appUserIds) {
                localVarQueryParameter['AppUserIds'] = appUserIds;
            }

            if (filterPeople !== undefined) {
                localVarQueryParameter['FilterPeople'] = filterPeople;
            }

            if (companionRole !== undefined) {
                localVarQueryParameter['CompanionRole'] = companionRole;
            }

            if (channels) {
                localVarQueryParameter['Channels'] = channels;
            }

            if (companionName !== undefined) {
                localVarQueryParameter['CompanionName'] = companionName;
            }

            if (petName !== undefined) {
                localVarQueryParameter['PetName'] = petName;
            }

            if (unreadOnly !== undefined) {
                localVarQueryParameter['UnreadOnly'] = unreadOnly;
            }

            if (dialogLimit !== undefined) {
                localVarQueryParameter['DialogLimit'] = dialogLimit;
            }

            if (dialogId !== undefined) {
                localVarQueryParameter['DialogId'] = dialogId;
            }

            if (oldestSequence !== undefined) {
                localVarQueryParameter['OldestSequence'] = oldestSequence;
            }

            if (beforeSequence !== undefined) {
                localVarQueryParameter['BeforeSequence'] = beforeSequence;
            }

            if (newestSequence !== undefined) {
                localVarQueryParameter['NewestSequence'] = newestSequence;
            }

            if (afterSequence !== undefined) {
                localVarQueryParameter['AfterSequence'] = afterSequence;
            }


    
            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Получить диалоги
         * @param {boolean} [pinnedOnly] Показывать только общие закрепления операторов
         * @param {Array<string>} [appUserIds] Выбранные учётные записи собеседников
         * @param {boolean} [filterPeople] Ограничивать список выбранными собеседниками
         * @param {ApiUserRole} [companionRole] Роль собеседника среди пользователей приложения VOX
         * @param {Array<number>} [channels] Каналы связи
         * @param {string} [companionName] Слова имени или фамилии собеседника VOX либо Salebot
         * @param {string} [petName] Часть имени питомца собеседника
         * @param {boolean} [unreadOnly] Показывать только диалоги с непрочитанными сообщениями
         * @param {string} [dialogId] Идентификатор диалога
         * @param {number} [offset] Смещение страницы
         * @param {number} [limit] Размер страницы
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getChatDialogs: async (pinnedOnly?: boolean, appUserIds?: Array<string>, filterPeople?: boolean, companionRole?: ApiUserRole, channels?: Array<number>, companionName?: string, petName?: string, unreadOnly?: boolean, dialogId?: string, offset?: number, limit?: number, apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/admin/chat-dialogs`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (pinnedOnly !== undefined) {
                localVarQueryParameter['PinnedOnly'] = pinnedOnly;
            }

            if (appUserIds) {
                localVarQueryParameter['AppUserIds'] = appUserIds;
            }

            if (filterPeople !== undefined) {
                localVarQueryParameter['FilterPeople'] = filterPeople;
            }

            if (companionRole !== undefined) {
                localVarQueryParameter['CompanionRole'] = companionRole;
            }

            if (channels) {
                localVarQueryParameter['Channels'] = channels;
            }

            if (companionName !== undefined) {
                localVarQueryParameter['CompanionName'] = companionName;
            }

            if (petName !== undefined) {
                localVarQueryParameter['PetName'] = petName;
            }

            if (unreadOnly !== undefined) {
                localVarQueryParameter['UnreadOnly'] = unreadOnly;
            }

            if (dialogId !== undefined) {
                localVarQueryParameter['DialogId'] = dialogId;
            }

            if (offset !== undefined) {
                localVarQueryParameter['Offset'] = offset;
            }

            if (limit !== undefined) {
                localVarQueryParameter['Limit'] = limit;
            }


    
            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Получить или создать чат для собеседников
         * @param {string} [apiVersion] 
         * @param {GetOrCreateChatRequest} [getOrCreateChatRequest] Модель запроса
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrCreateChat: async (apiVersion?: string, getOrCreateChatRequest?: GetOrCreateChatRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/chats/get-or-create-chat`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(getOrCreateChatRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Получить информацию о пользователе
         * @param {string} [appUserId] 
         * @param {UserRole} [role] 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserInfo: async (appUserId?: string, role?: UserRole, apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/chats/get-user-info`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (appUserId !== undefined) {
                localVarQueryParameter['appUserId'] = appUserId;
            }

            if (role !== undefined) {
                localVarQueryParameter['role'] = role;
            }


    
            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Подтвердить прочтение диалога
         * @param {string} dialogId 
         * @param {string} [apiVersion] 
         * @param {MarkChatDialogReadRequest} [markChatDialogReadRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        markChatDialogRead: async (dialogId: string, apiVersion?: string, markChatDialogReadRequest?: MarkChatDialogReadRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'dialogId' is not null or undefined
            assertParamExists('markChatDialogRead', 'dialogId', dialogId)
            const localVarPath = `/api/v1/admin/chat-dialogs/{dialogId}/read`
                .replace(`{${"dialogId"}}`, encodeURIComponent(String(dialogId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(markChatDialogReadRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Отметить всю переписку прочитанной
         * @param {string} dialogId 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        markChatDialogReadAll: async (dialogId: string, apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'dialogId' is not null or undefined
            assertParamExists('markChatDialogReadAll', 'dialogId', dialogId)
            const localVarPath = `/api/v1/admin/chat-dialogs/{dialogId}/read-all`
                .replace(`{${"dialogId"}}`, encodeURIComponent(String(dialogId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Отметить диалог непрочитанным
         * @param {string} dialogId 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        markChatDialogUnread: async (dialogId: string, apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'dialogId' is not null or undefined
            assertParamExists('markChatDialogUnread', 'dialogId', dialogId)
            const localVarPath = `/api/v1/admin/chat-dialogs/{dialogId}/unread`
                .replace(`{${"dialogId"}}`, encodeURIComponent(String(dialogId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Повторить передачу существующего сообщения
         * @param {string} dialogId 
         * @param {string} messageId 
         * @param {string} [apiVersion] 
         * @param {RetryChatDialogMessageRequest} [retryChatDialogMessageRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retryChatDialogMessage: async (dialogId: string, messageId: string, apiVersion?: string, retryChatDialogMessageRequest?: RetryChatDialogMessageRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'dialogId' is not null or undefined
            assertParamExists('retryChatDialogMessage', 'dialogId', dialogId)
            // verify required parameter 'messageId' is not null or undefined
            assertParamExists('retryChatDialogMessage', 'messageId', messageId)
            const localVarPath = `/api/v1/admin/chat-dialogs/{dialogId}/messages/{messageId}/retry`
                .replace(`{${"dialogId"}}`, encodeURIComponent(String(dialogId)))
                .replace(`{${"messageId"}}`, encodeURIComponent(String(messageId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(retryChatDialogMessageRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Отправить ответ пользователю
         * @param {string} dialogId 
         * @param {string} [apiVersion] 
         * @param {SendChatDialogMessageRequest} [sendChatDialogMessageRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendChatDialogMessage: async (dialogId: string, apiVersion?: string, sendChatDialogMessageRequest?: SendChatDialogMessageRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'dialogId' is not null or undefined
            assertParamExists('sendChatDialogMessage', 'dialogId', dialogId)
            const localVarPath = `/api/v1/admin/chat-dialogs/{dialogId}/messages`
                .replace(`{${"dialogId"}}`, encodeURIComponent(String(dialogId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(sendChatDialogMessageRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Отправить сообщение
         * @param {string} [apiVersion] 
         * @param {SendMessageRequest} [sendMessageRequest] Модель запроса на отправку сообещния
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendMessage: async (apiVersion?: string, sendMessageRequest?: SendMessageRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/chats/send-message`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(sendMessageRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Синхронизировать данные о собеседнике
         * @param {string} [apiVersion] 
         * @param {SynchronizeCompanionDataRequest} [synchronizeCompanionDataRequest] Модель запроса на синхронизацию данных о собеседнике
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        synchronizeCompanionData: async (apiVersion?: string, synchronizeCompanionDataRequest?: SynchronizeCompanionDataRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/chats/synchronize-companion-data`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(synchronizeCompanionDataRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Просмотреть сообщения в чате
         * @param {string} appUserId Идентификатор пользователя
         * @param {string} chatId Идентификатор чата
         * @param {string} [readThroughMessageId] Последнее показанное входящее сообщение
         * @param {boolean} [useReadWatermark] Ограничить чтение снимком клиента
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        viewMessages: async (appUserId: string, chatId: string, readThroughMessageId?: string, useReadWatermark?: boolean, apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'appUserId' is not null or undefined
            assertParamExists('viewMessages', 'appUserId', appUserId)
            // verify required parameter 'chatId' is not null or undefined
            assertParamExists('viewMessages', 'chatId', chatId)
            const localVarPath = `/api/v1/chats/view-messages/{appUserId}/{chatId}`
                .replace(`{${"appUserId"}}`, encodeURIComponent(String(appUserId)))
                .replace(`{${"chatId"}}`, encodeURIComponent(String(chatId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (readThroughMessageId !== undefined) {
                localVarQueryParameter['readThroughMessageId'] = readThroughMessageId;
            }

            if (useReadWatermark !== undefined) {
                localVarQueryParameter['useReadWatermark'] = useReadWatermark;
            }


    
            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ChatApi - functional programming interface
 * @export
 */
export const ChatApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ChatApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Создать документ для пользователя Администратор Backend
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createAdminBackend(apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createAdminBackend(apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ChatApi.createAdminBackend']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Создать пользователя для AI ассистента
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createAiAssistant(apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createAiAssistant(apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ChatApi.createAiAssistant']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Создать пользователя для чата
         * @param {string} appUserId Идентификатор пользователя
         * @param {UserRole} role 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createChatUser(appUserId: string, role: UserRole, apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createChatUser(appUserId, role, apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ChatApi.createChatUser']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Создать пользователя для технической поддержки
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createTechnicalSupport(apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createTechnicalSupport(apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ChatApi.createTechnicalSupport']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Получить счётчики переписки
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getChatDialogCounters(apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ChatDialogCountersResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getChatDialogCounters(apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ChatApi.getChatDialogCounters']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Получить историю диалога
         * @param {string} dialogId 
         * @param {number} [beforeSequence] Получить сообщения раньше указанного номера
         * @param {number} [limit] Размер страницы
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getChatDialogMessages(dialogId: string, beforeSequence?: number, limit?: number, apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ChatDialogMessagePageResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getChatDialogMessages(dialogId, beforeSequence, limit, apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ChatApi.getChatDialogMessages']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Получить доступ к обновлениям переписки
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getChatDialogRealtime(apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ChatRealtimeResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getChatDialogRealtime(apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ChatApi.getChatDialogRealtime']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Получить согласованное состояние переписки
         * @param {Array<string>} [appUserIds] Выбранные учётные записи собеседников
         * @param {boolean} [filterPeople] Ограничивать список выбранными собеседниками
         * @param {ApiUserRole} [companionRole] Роль собеседника среди пользователей приложения VOX
         * @param {Array<number>} [channels] Каналы связи
         * @param {string} [companionName] Слова имени или фамилии собеседника VOX либо Salebot
         * @param {string} [petName] Часть имени питомца собеседника
         * @param {boolean} [unreadOnly] Только непрочитанные диалоги
         * @param {number} [dialogLimit] Число показанных диалогов
         * @param {string} [dialogId] Выбранный диалог
         * @param {number} [oldestSequence] Первое показанное сообщение
         * @param {number} [beforeSequence] Граница загрузки старой истории
         * @param {number} [newestSequence] Последнее показанное сообщение
         * @param {number} [afterSequence] Граница следующей непрочитанной страницы приложения
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getChatDialogSnapshot(appUserIds?: Array<string>, filterPeople?: boolean, companionRole?: ApiUserRole, channels?: Array<number>, companionName?: string, petName?: string, unreadOnly?: boolean, dialogLimit?: number, dialogId?: string, oldestSequence?: number, beforeSequence?: number, newestSequence?: number, afterSequence?: number, apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ChatRealtimeSnapshotResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getChatDialogSnapshot(appUserIds, filterPeople, companionRole, channels, companionName, petName, unreadOnly, dialogLimit, dialogId, oldestSequence, beforeSequence, newestSequence, afterSequence, apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ChatApi.getChatDialogSnapshot']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Получить диалоги
         * @param {boolean} [pinnedOnly] Показывать только общие закрепления операторов
         * @param {Array<string>} [appUserIds] Выбранные учётные записи собеседников
         * @param {boolean} [filterPeople] Ограничивать список выбранными собеседниками
         * @param {ApiUserRole} [companionRole] Роль собеседника среди пользователей приложения VOX
         * @param {Array<number>} [channels] Каналы связи
         * @param {string} [companionName] Слова имени или фамилии собеседника VOX либо Salebot
         * @param {string} [petName] Часть имени питомца собеседника
         * @param {boolean} [unreadOnly] Показывать только диалоги с непрочитанными сообщениями
         * @param {string} [dialogId] Идентификатор диалога
         * @param {number} [offset] Смещение страницы
         * @param {number} [limit] Размер страницы
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getChatDialogs(pinnedOnly?: boolean, appUserIds?: Array<string>, filterPeople?: boolean, companionRole?: ApiUserRole, channels?: Array<number>, companionName?: string, petName?: string, unreadOnly?: boolean, dialogId?: string, offset?: number, limit?: number, apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ChatDialogPageResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getChatDialogs(pinnedOnly, appUserIds, filterPeople, companionRole, channels, companionName, petName, unreadOnly, dialogId, offset, limit, apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ChatApi.getChatDialogs']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Получить или создать чат для собеседников
         * @param {string} [apiVersion] 
         * @param {GetOrCreateChatRequest} [getOrCreateChatRequest] Модель запроса
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOrCreateChat(apiVersion?: string, getOrCreateChatRequest?: GetOrCreateChatRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetOrCreateChatResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOrCreateChat(apiVersion, getOrCreateChatRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ChatApi.getOrCreateChat']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Получить информацию о пользователе
         * @param {string} [appUserId] 
         * @param {UserRole} [role] 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUserInfo(appUserId?: string, role?: UserRole, apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetUserInfoResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUserInfo(appUserId, role, apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ChatApi.getUserInfo']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Подтвердить прочтение диалога
         * @param {string} dialogId 
         * @param {string} [apiVersion] 
         * @param {MarkChatDialogReadRequest} [markChatDialogReadRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async markChatDialogRead(dialogId: string, apiVersion?: string, markChatDialogReadRequest?: MarkChatDialogReadRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.markChatDialogRead(dialogId, apiVersion, markChatDialogReadRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ChatApi.markChatDialogRead']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Отметить всю переписку прочитанной
         * @param {string} dialogId 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async markChatDialogReadAll(dialogId: string, apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.markChatDialogReadAll(dialogId, apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ChatApi.markChatDialogReadAll']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Отметить диалог непрочитанным
         * @param {string} dialogId 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async markChatDialogUnread(dialogId: string, apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.markChatDialogUnread(dialogId, apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ChatApi.markChatDialogUnread']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Повторить передачу существующего сообщения
         * @param {string} dialogId 
         * @param {string} messageId 
         * @param {string} [apiVersion] 
         * @param {RetryChatDialogMessageRequest} [retryChatDialogMessageRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async retryChatDialogMessage(dialogId: string, messageId: string, apiVersion?: string, retryChatDialogMessageRequest?: RetryChatDialogMessageRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ChatDialogMessageResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.retryChatDialogMessage(dialogId, messageId, apiVersion, retryChatDialogMessageRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ChatApi.retryChatDialogMessage']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Отправить ответ пользователю
         * @param {string} dialogId 
         * @param {string} [apiVersion] 
         * @param {SendChatDialogMessageRequest} [sendChatDialogMessageRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sendChatDialogMessage(dialogId: string, apiVersion?: string, sendChatDialogMessageRequest?: SendChatDialogMessageRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ChatDialogMessageResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sendChatDialogMessage(dialogId, apiVersion, sendChatDialogMessageRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ChatApi.sendChatDialogMessage']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Отправить сообщение
         * @param {string} [apiVersion] 
         * @param {SendMessageRequest} [sendMessageRequest] Модель запроса на отправку сообещния
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sendMessage(apiVersion?: string, sendMessageRequest?: SendMessageRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sendMessage(apiVersion, sendMessageRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ChatApi.sendMessage']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Синхронизировать данные о собеседнике
         * @param {string} [apiVersion] 
         * @param {SynchronizeCompanionDataRequest} [synchronizeCompanionDataRequest] Модель запроса на синхронизацию данных о собеседнике
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async synchronizeCompanionData(apiVersion?: string, synchronizeCompanionDataRequest?: SynchronizeCompanionDataRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.synchronizeCompanionData(apiVersion, synchronizeCompanionDataRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ChatApi.synchronizeCompanionData']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Просмотреть сообщения в чате
         * @param {string} appUserId Идентификатор пользователя
         * @param {string} chatId Идентификатор чата
         * @param {string} [readThroughMessageId] Последнее показанное входящее сообщение
         * @param {boolean} [useReadWatermark] Ограничить чтение снимком клиента
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async viewMessages(appUserId: string, chatId: string, readThroughMessageId?: string, useReadWatermark?: boolean, apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.viewMessages(appUserId, chatId, readThroughMessageId, useReadWatermark, apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ChatApi.viewMessages']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ChatApi - factory interface
 * @export
 */
export const ChatApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ChatApiFp(configuration)
    return {
        /**
         * 
         * @summary Создать документ для пользователя Администратор Backend
         * @param {ChatApiCreateAdminBackendRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAdminBackend(requestParameters: ChatApiCreateAdminBackendRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.createAdminBackend(requestParameters.apiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Создать пользователя для AI ассистента
         * @param {ChatApiCreateAiAssistantRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAiAssistant(requestParameters: ChatApiCreateAiAssistantRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.createAiAssistant(requestParameters.apiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Создать пользователя для чата
         * @param {ChatApiCreateChatUserRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createChatUser(requestParameters: ChatApiCreateChatUserRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.createChatUser(requestParameters.appUserId, requestParameters.role, requestParameters.apiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Создать пользователя для технической поддержки
         * @param {ChatApiCreateTechnicalSupportRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTechnicalSupport(requestParameters: ChatApiCreateTechnicalSupportRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.createTechnicalSupport(requestParameters.apiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Получить счётчики переписки
         * @param {ChatApiGetChatDialogCountersRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getChatDialogCounters(requestParameters: ChatApiGetChatDialogCountersRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<ChatDialogCountersResponse> {
            return localVarFp.getChatDialogCounters(requestParameters.apiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Получить историю диалога
         * @param {ChatApiGetChatDialogMessagesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getChatDialogMessages(requestParameters: ChatApiGetChatDialogMessagesRequest, options?: RawAxiosRequestConfig): AxiosPromise<ChatDialogMessagePageResponse> {
            return localVarFp.getChatDialogMessages(requestParameters.dialogId, requestParameters.beforeSequence, requestParameters.limit, requestParameters.apiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Получить доступ к обновлениям переписки
         * @param {ChatApiGetChatDialogRealtimeRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getChatDialogRealtime(requestParameters: ChatApiGetChatDialogRealtimeRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<ChatRealtimeResponse> {
            return localVarFp.getChatDialogRealtime(requestParameters.apiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Получить согласованное состояние переписки
         * @param {ChatApiGetChatDialogSnapshotRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getChatDialogSnapshot(requestParameters: ChatApiGetChatDialogSnapshotRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<ChatRealtimeSnapshotResponse> {
            return localVarFp.getChatDialogSnapshot(requestParameters.appUserIds, requestParameters.filterPeople, requestParameters.companionRole, requestParameters.channels, requestParameters.companionName, requestParameters.petName, requestParameters.unreadOnly, requestParameters.dialogLimit, requestParameters.dialogId, requestParameters.oldestSequence, requestParameters.beforeSequence, requestParameters.newestSequence, requestParameters.afterSequence, requestParameters.apiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Получить диалоги
         * @param {ChatApiGetChatDialogsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getChatDialogs(requestParameters: ChatApiGetChatDialogsRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<ChatDialogPageResponse> {
            return localVarFp.getChatDialogs(requestParameters.pinnedOnly, requestParameters.appUserIds, requestParameters.filterPeople, requestParameters.companionRole, requestParameters.channels, requestParameters.companionName, requestParameters.petName, requestParameters.unreadOnly, requestParameters.dialogId, requestParameters.offset, requestParameters.limit, requestParameters.apiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Получить или создать чат для собеседников
         * @param {ChatApiGetOrCreateChatRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrCreateChat(requestParameters: ChatApiGetOrCreateChatRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<GetOrCreateChatResponse> {
            return localVarFp.getOrCreateChat(requestParameters.apiVersion, requestParameters.getOrCreateChatRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Получить информацию о пользователе
         * @param {ChatApiGetUserInfoRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserInfo(requestParameters: ChatApiGetUserInfoRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<GetUserInfoResponse> {
            return localVarFp.getUserInfo(requestParameters.appUserId, requestParameters.role, requestParameters.apiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Подтвердить прочтение диалога
         * @param {ChatApiMarkChatDialogReadRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        markChatDialogRead(requestParameters: ChatApiMarkChatDialogReadRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.markChatDialogRead(requestParameters.dialogId, requestParameters.apiVersion, requestParameters.markChatDialogReadRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Отметить всю переписку прочитанной
         * @param {ChatApiMarkChatDialogReadAllRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        markChatDialogReadAll(requestParameters: ChatApiMarkChatDialogReadAllRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.markChatDialogReadAll(requestParameters.dialogId, requestParameters.apiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Отметить диалог непрочитанным
         * @param {ChatApiMarkChatDialogUnreadRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        markChatDialogUnread(requestParameters: ChatApiMarkChatDialogUnreadRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.markChatDialogUnread(requestParameters.dialogId, requestParameters.apiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Повторить передачу существующего сообщения
         * @param {ChatApiRetryChatDialogMessageRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retryChatDialogMessage(requestParameters: ChatApiRetryChatDialogMessageRequest, options?: RawAxiosRequestConfig): AxiosPromise<ChatDialogMessageResponse> {
            return localVarFp.retryChatDialogMessage(requestParameters.dialogId, requestParameters.messageId, requestParameters.apiVersion, requestParameters.retryChatDialogMessageRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Отправить ответ пользователю
         * @param {ChatApiSendChatDialogMessageRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendChatDialogMessage(requestParameters: ChatApiSendChatDialogMessageRequest, options?: RawAxiosRequestConfig): AxiosPromise<ChatDialogMessageResponse> {
            return localVarFp.sendChatDialogMessage(requestParameters.dialogId, requestParameters.apiVersion, requestParameters.sendChatDialogMessageRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Отправить сообщение
         * @param {ChatApiSendMessageRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendMessage(requestParameters: ChatApiSendMessageRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.sendMessage(requestParameters.apiVersion, requestParameters.sendMessageRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Синхронизировать данные о собеседнике
         * @param {ChatApiSynchronizeCompanionDataRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        synchronizeCompanionData(requestParameters: ChatApiSynchronizeCompanionDataRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.synchronizeCompanionData(requestParameters.apiVersion, requestParameters.synchronizeCompanionDataRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Просмотреть сообщения в чате
         * @param {ChatApiViewMessagesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        viewMessages(requestParameters: ChatApiViewMessagesRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.viewMessages(requestParameters.appUserId, requestParameters.chatId, requestParameters.readThroughMessageId, requestParameters.useReadWatermark, requestParameters.apiVersion, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for createAdminBackend operation in ChatApi.
 * @export
 * @interface ChatApiCreateAdminBackendRequest
 */
export interface ChatApiCreateAdminBackendRequest {
    /**
     * 
     * @type {string}
     * @memberof ChatApiCreateAdminBackend
     */
    readonly apiVersion?: string
}

/**
 * Request parameters for createAiAssistant operation in ChatApi.
 * @export
 * @interface ChatApiCreateAiAssistantRequest
 */
export interface ChatApiCreateAiAssistantRequest {
    /**
     * 
     * @type {string}
     * @memberof ChatApiCreateAiAssistant
     */
    readonly apiVersion?: string
}

/**
 * Request parameters for createChatUser operation in ChatApi.
 * @export
 * @interface ChatApiCreateChatUserRequest
 */
export interface ChatApiCreateChatUserRequest {
    /**
     * Идентификатор пользователя
     * @type {string}
     * @memberof ChatApiCreateChatUser
     */
    readonly appUserId: string

    /**
     * 
     * @type {UserRole}
     * @memberof ChatApiCreateChatUser
     */
    readonly role: UserRole

    /**
     * 
     * @type {string}
     * @memberof ChatApiCreateChatUser
     */
    readonly apiVersion?: string
}

/**
 * Request parameters for createTechnicalSupport operation in ChatApi.
 * @export
 * @interface ChatApiCreateTechnicalSupportRequest
 */
export interface ChatApiCreateTechnicalSupportRequest {
    /**
     * 
     * @type {string}
     * @memberof ChatApiCreateTechnicalSupport
     */
    readonly apiVersion?: string
}

/**
 * Request parameters for getChatDialogCounters operation in ChatApi.
 * @export
 * @interface ChatApiGetChatDialogCountersRequest
 */
export interface ChatApiGetChatDialogCountersRequest {
    /**
     * 
     * @type {string}
     * @memberof ChatApiGetChatDialogCounters
     */
    readonly apiVersion?: string
}

/**
 * Request parameters for getChatDialogMessages operation in ChatApi.
 * @export
 * @interface ChatApiGetChatDialogMessagesRequest
 */
export interface ChatApiGetChatDialogMessagesRequest {
    /**
     * 
     * @type {string}
     * @memberof ChatApiGetChatDialogMessages
     */
    readonly dialogId: string

    /**
     * Получить сообщения раньше указанного номера
     * @type {number}
     * @memberof ChatApiGetChatDialogMessages
     */
    readonly beforeSequence?: number

    /**
     * Размер страницы
     * @type {number}
     * @memberof ChatApiGetChatDialogMessages
     */
    readonly limit?: number

    /**
     * 
     * @type {string}
     * @memberof ChatApiGetChatDialogMessages
     */
    readonly apiVersion?: string
}

/**
 * Request parameters for getChatDialogRealtime operation in ChatApi.
 * @export
 * @interface ChatApiGetChatDialogRealtimeRequest
 */
export interface ChatApiGetChatDialogRealtimeRequest {
    /**
     * 
     * @type {string}
     * @memberof ChatApiGetChatDialogRealtime
     */
    readonly apiVersion?: string
}

/**
 * Request parameters for getChatDialogSnapshot operation in ChatApi.
 * @export
 * @interface ChatApiGetChatDialogSnapshotRequest
 */
export interface ChatApiGetChatDialogSnapshotRequest {
    /**
     * Выбранные учётные записи собеседников
     * @type {Array<string>}
     * @memberof ChatApiGetChatDialogSnapshot
     */
    readonly appUserIds?: Array<string>

    /**
     * Ограничивать список выбранными собеседниками
     * @type {boolean}
     * @memberof ChatApiGetChatDialogSnapshot
     */
    readonly filterPeople?: boolean

    /**
     * Роль собеседника среди пользователей приложения VOX
     * @type {ApiUserRole}
     * @memberof ChatApiGetChatDialogSnapshot
     */
    readonly companionRole?: ApiUserRole

    /**
     * Каналы связи
     * @type {Array<number>}
     * @memberof ChatApiGetChatDialogSnapshot
     */
    readonly channels?: Array<number>

    /**
     * Слова имени или фамилии собеседника VOX либо Salebot
     * @type {string}
     * @memberof ChatApiGetChatDialogSnapshot
     */
    readonly companionName?: string

    /**
     * Часть имени питомца собеседника
     * @type {string}
     * @memberof ChatApiGetChatDialogSnapshot
     */
    readonly petName?: string

    /**
     * Только непрочитанные диалоги
     * @type {boolean}
     * @memberof ChatApiGetChatDialogSnapshot
     */
    readonly unreadOnly?: boolean

    /**
     * Число показанных диалогов
     * @type {number}
     * @memberof ChatApiGetChatDialogSnapshot
     */
    readonly dialogLimit?: number

    /**
     * Выбранный диалог
     * @type {string}
     * @memberof ChatApiGetChatDialogSnapshot
     */
    readonly dialogId?: string

    /**
     * Первое показанное сообщение
     * @type {number}
     * @memberof ChatApiGetChatDialogSnapshot
     */
    readonly oldestSequence?: number

    /**
     * Граница загрузки старой истории
     * @type {number}
     * @memberof ChatApiGetChatDialogSnapshot
     */
    readonly beforeSequence?: number

    /**
     * Последнее показанное сообщение
     * @type {number}
     * @memberof ChatApiGetChatDialogSnapshot
     */
    readonly newestSequence?: number

    /**
     * Граница следующей непрочитанной страницы приложения
     * @type {number}
     * @memberof ChatApiGetChatDialogSnapshot
     */
    readonly afterSequence?: number

    /**
     * 
     * @type {string}
     * @memberof ChatApiGetChatDialogSnapshot
     */
    readonly apiVersion?: string
}

/**
 * Request parameters for getChatDialogs operation in ChatApi.
 * @export
 * @interface ChatApiGetChatDialogsRequest
 */
export interface ChatApiGetChatDialogsRequest {
    /**
     * Показывать только общие закрепления операторов
     * @type {boolean}
     * @memberof ChatApiGetChatDialogs
     */
    readonly pinnedOnly?: boolean

    /**
     * Выбранные учётные записи собеседников
     * @type {Array<string>}
     * @memberof ChatApiGetChatDialogs
     */
    readonly appUserIds?: Array<string>

    /**
     * Ограничивать список выбранными собеседниками
     * @type {boolean}
     * @memberof ChatApiGetChatDialogs
     */
    readonly filterPeople?: boolean

    /**
     * Роль собеседника среди пользователей приложения VOX
     * @type {ApiUserRole}
     * @memberof ChatApiGetChatDialogs
     */
    readonly companionRole?: ApiUserRole

    /**
     * Каналы связи
     * @type {Array<number>}
     * @memberof ChatApiGetChatDialogs
     */
    readonly channels?: Array<number>

    /**
     * Слова имени или фамилии собеседника VOX либо Salebot
     * @type {string}
     * @memberof ChatApiGetChatDialogs
     */
    readonly companionName?: string

    /**
     * Часть имени питомца собеседника
     * @type {string}
     * @memberof ChatApiGetChatDialogs
     */
    readonly petName?: string

    /**
     * Показывать только диалоги с непрочитанными сообщениями
     * @type {boolean}
     * @memberof ChatApiGetChatDialogs
     */
    readonly unreadOnly?: boolean

    /**
     * Идентификатор диалога
     * @type {string}
     * @memberof ChatApiGetChatDialogs
     */
    readonly dialogId?: string

    /**
     * Смещение страницы
     * @type {number}
     * @memberof ChatApiGetChatDialogs
     */
    readonly offset?: number

    /**
     * Размер страницы
     * @type {number}
     * @memberof ChatApiGetChatDialogs
     */
    readonly limit?: number

    /**
     * 
     * @type {string}
     * @memberof ChatApiGetChatDialogs
     */
    readonly apiVersion?: string
}

/**
 * Request parameters for getOrCreateChat operation in ChatApi.
 * @export
 * @interface ChatApiGetOrCreateChatRequest
 */
export interface ChatApiGetOrCreateChatRequest {
    /**
     * 
     * @type {string}
     * @memberof ChatApiGetOrCreateChat
     */
    readonly apiVersion?: string

    /**
     * Модель запроса
     * @type {GetOrCreateChatRequest}
     * @memberof ChatApiGetOrCreateChat
     */
    readonly getOrCreateChatRequest?: GetOrCreateChatRequest
}

/**
 * Request parameters for getUserInfo operation in ChatApi.
 * @export
 * @interface ChatApiGetUserInfoRequest
 */
export interface ChatApiGetUserInfoRequest {
    /**
     * 
     * @type {string}
     * @memberof ChatApiGetUserInfo
     */
    readonly appUserId?: string

    /**
     * 
     * @type {UserRole}
     * @memberof ChatApiGetUserInfo
     */
    readonly role?: UserRole

    /**
     * 
     * @type {string}
     * @memberof ChatApiGetUserInfo
     */
    readonly apiVersion?: string
}

/**
 * Request parameters for markChatDialogRead operation in ChatApi.
 * @export
 * @interface ChatApiMarkChatDialogReadRequest
 */
export interface ChatApiMarkChatDialogReadRequest {
    /**
     * 
     * @type {string}
     * @memberof ChatApiMarkChatDialogRead
     */
    readonly dialogId: string

    /**
     * 
     * @type {string}
     * @memberof ChatApiMarkChatDialogRead
     */
    readonly apiVersion?: string

    /**
     * 
     * @type {MarkChatDialogReadRequest}
     * @memberof ChatApiMarkChatDialogRead
     */
    readonly markChatDialogReadRequest?: MarkChatDialogReadRequest
}

/**
 * Request parameters for markChatDialogReadAll operation in ChatApi.
 * @export
 * @interface ChatApiMarkChatDialogReadAllRequest
 */
export interface ChatApiMarkChatDialogReadAllRequest {
    /**
     * 
     * @type {string}
     * @memberof ChatApiMarkChatDialogReadAll
     */
    readonly dialogId: string

    /**
     * 
     * @type {string}
     * @memberof ChatApiMarkChatDialogReadAll
     */
    readonly apiVersion?: string
}

/**
 * Request parameters for markChatDialogUnread operation in ChatApi.
 * @export
 * @interface ChatApiMarkChatDialogUnreadRequest
 */
export interface ChatApiMarkChatDialogUnreadRequest {
    /**
     * 
     * @type {string}
     * @memberof ChatApiMarkChatDialogUnread
     */
    readonly dialogId: string

    /**
     * 
     * @type {string}
     * @memberof ChatApiMarkChatDialogUnread
     */
    readonly apiVersion?: string
}

/**
 * Request parameters for retryChatDialogMessage operation in ChatApi.
 * @export
 * @interface ChatApiRetryChatDialogMessageRequest
 */
export interface ChatApiRetryChatDialogMessageRequest {
    /**
     * 
     * @type {string}
     * @memberof ChatApiRetryChatDialogMessage
     */
    readonly dialogId: string

    /**
     * 
     * @type {string}
     * @memberof ChatApiRetryChatDialogMessage
     */
    readonly messageId: string

    /**
     * 
     * @type {string}
     * @memberof ChatApiRetryChatDialogMessage
     */
    readonly apiVersion?: string

    /**
     * 
     * @type {RetryChatDialogMessageRequest}
     * @memberof ChatApiRetryChatDialogMessage
     */
    readonly retryChatDialogMessageRequest?: RetryChatDialogMessageRequest
}

/**
 * Request parameters for sendChatDialogMessage operation in ChatApi.
 * @export
 * @interface ChatApiSendChatDialogMessageRequest
 */
export interface ChatApiSendChatDialogMessageRequest {
    /**
     * 
     * @type {string}
     * @memberof ChatApiSendChatDialogMessage
     */
    readonly dialogId: string

    /**
     * 
     * @type {string}
     * @memberof ChatApiSendChatDialogMessage
     */
    readonly apiVersion?: string

    /**
     * 
     * @type {SendChatDialogMessageRequest}
     * @memberof ChatApiSendChatDialogMessage
     */
    readonly sendChatDialogMessageRequest?: SendChatDialogMessageRequest
}

/**
 * Request parameters for sendMessage operation in ChatApi.
 * @export
 * @interface ChatApiSendMessageRequest
 */
export interface ChatApiSendMessageRequest {
    /**
     * 
     * @type {string}
     * @memberof ChatApiSendMessage
     */
    readonly apiVersion?: string

    /**
     * Модель запроса на отправку сообещния
     * @type {SendMessageRequest}
     * @memberof ChatApiSendMessage
     */
    readonly sendMessageRequest?: SendMessageRequest
}

/**
 * Request parameters for synchronizeCompanionData operation in ChatApi.
 * @export
 * @interface ChatApiSynchronizeCompanionDataRequest
 */
export interface ChatApiSynchronizeCompanionDataRequest {
    /**
     * 
     * @type {string}
     * @memberof ChatApiSynchronizeCompanionData
     */
    readonly apiVersion?: string

    /**
     * Модель запроса на синхронизацию данных о собеседнике
     * @type {SynchronizeCompanionDataRequest}
     * @memberof ChatApiSynchronizeCompanionData
     */
    readonly synchronizeCompanionDataRequest?: SynchronizeCompanionDataRequest
}

/**
 * Request parameters for viewMessages operation in ChatApi.
 * @export
 * @interface ChatApiViewMessagesRequest
 */
export interface ChatApiViewMessagesRequest {
    /**
     * Идентификатор пользователя
     * @type {string}
     * @memberof ChatApiViewMessages
     */
    readonly appUserId: string

    /**
     * Идентификатор чата
     * @type {string}
     * @memberof ChatApiViewMessages
     */
    readonly chatId: string

    /**
     * Последнее показанное входящее сообщение
     * @type {string}
     * @memberof ChatApiViewMessages
     */
    readonly readThroughMessageId?: string

    /**
     * Ограничить чтение снимком клиента
     * @type {boolean}
     * @memberof ChatApiViewMessages
     */
    readonly useReadWatermark?: boolean

    /**
     * 
     * @type {string}
     * @memberof ChatApiViewMessages
     */
    readonly apiVersion?: string
}

/**
 * ChatApi - object-oriented interface
 * @export
 * @class ChatApi
 * @extends {BaseAPI}
 */
export class ChatApi extends BaseAPI {
    /**
     * 
     * @summary Создать документ для пользователя Администратор Backend
     * @param {ChatApiCreateAdminBackendRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChatApi
     */
    public createAdminBackend(requestParameters: ChatApiCreateAdminBackendRequest = {}, options?: RawAxiosRequestConfig) {
        return ChatApiFp(this.configuration).createAdminBackend(requestParameters.apiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Создать пользователя для AI ассистента
     * @param {ChatApiCreateAiAssistantRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChatApi
     */
    public createAiAssistant(requestParameters: ChatApiCreateAiAssistantRequest = {}, options?: RawAxiosRequestConfig) {
        return ChatApiFp(this.configuration).createAiAssistant(requestParameters.apiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Создать пользователя для чата
     * @param {ChatApiCreateChatUserRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChatApi
     */
    public createChatUser(requestParameters: ChatApiCreateChatUserRequest, options?: RawAxiosRequestConfig) {
        return ChatApiFp(this.configuration).createChatUser(requestParameters.appUserId, requestParameters.role, requestParameters.apiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Создать пользователя для технической поддержки
     * @param {ChatApiCreateTechnicalSupportRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChatApi
     */
    public createTechnicalSupport(requestParameters: ChatApiCreateTechnicalSupportRequest = {}, options?: RawAxiosRequestConfig) {
        return ChatApiFp(this.configuration).createTechnicalSupport(requestParameters.apiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Получить счётчики переписки
     * @param {ChatApiGetChatDialogCountersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChatApi
     */
    public getChatDialogCounters(requestParameters: ChatApiGetChatDialogCountersRequest = {}, options?: RawAxiosRequestConfig) {
        return ChatApiFp(this.configuration).getChatDialogCounters(requestParameters.apiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Получить историю диалога
     * @param {ChatApiGetChatDialogMessagesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChatApi
     */
    public getChatDialogMessages(requestParameters: ChatApiGetChatDialogMessagesRequest, options?: RawAxiosRequestConfig) {
        return ChatApiFp(this.configuration).getChatDialogMessages(requestParameters.dialogId, requestParameters.beforeSequence, requestParameters.limit, requestParameters.apiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Получить доступ к обновлениям переписки
     * @param {ChatApiGetChatDialogRealtimeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChatApi
     */
    public getChatDialogRealtime(requestParameters: ChatApiGetChatDialogRealtimeRequest = {}, options?: RawAxiosRequestConfig) {
        return ChatApiFp(this.configuration).getChatDialogRealtime(requestParameters.apiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Получить согласованное состояние переписки
     * @param {ChatApiGetChatDialogSnapshotRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChatApi
     */
    public getChatDialogSnapshot(requestParameters: ChatApiGetChatDialogSnapshotRequest = {}, options?: RawAxiosRequestConfig) {
        return ChatApiFp(this.configuration).getChatDialogSnapshot(requestParameters.appUserIds, requestParameters.filterPeople, requestParameters.companionRole, requestParameters.channels, requestParameters.companionName, requestParameters.petName, requestParameters.unreadOnly, requestParameters.dialogLimit, requestParameters.dialogId, requestParameters.oldestSequence, requestParameters.beforeSequence, requestParameters.newestSequence, requestParameters.afterSequence, requestParameters.apiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Получить диалоги
     * @param {ChatApiGetChatDialogsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChatApi
     */
    public getChatDialogs(requestParameters: ChatApiGetChatDialogsRequest = {}, options?: RawAxiosRequestConfig) {
        return ChatApiFp(this.configuration).getChatDialogs(requestParameters.pinnedOnly, requestParameters.appUserIds, requestParameters.filterPeople, requestParameters.companionRole, requestParameters.channels, requestParameters.companionName, requestParameters.petName, requestParameters.unreadOnly, requestParameters.dialogId, requestParameters.offset, requestParameters.limit, requestParameters.apiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Получить или создать чат для собеседников
     * @param {ChatApiGetOrCreateChatRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChatApi
     */
    public getOrCreateChat(requestParameters: ChatApiGetOrCreateChatRequest = {}, options?: RawAxiosRequestConfig) {
        return ChatApiFp(this.configuration).getOrCreateChat(requestParameters.apiVersion, requestParameters.getOrCreateChatRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Получить информацию о пользователе
     * @param {ChatApiGetUserInfoRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChatApi
     */
    public getUserInfo(requestParameters: ChatApiGetUserInfoRequest = {}, options?: RawAxiosRequestConfig) {
        return ChatApiFp(this.configuration).getUserInfo(requestParameters.appUserId, requestParameters.role, requestParameters.apiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Подтвердить прочтение диалога
     * @param {ChatApiMarkChatDialogReadRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChatApi
     */
    public markChatDialogRead(requestParameters: ChatApiMarkChatDialogReadRequest, options?: RawAxiosRequestConfig) {
        return ChatApiFp(this.configuration).markChatDialogRead(requestParameters.dialogId, requestParameters.apiVersion, requestParameters.markChatDialogReadRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Отметить всю переписку прочитанной
     * @param {ChatApiMarkChatDialogReadAllRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChatApi
     */
    public markChatDialogReadAll(requestParameters: ChatApiMarkChatDialogReadAllRequest, options?: RawAxiosRequestConfig) {
        return ChatApiFp(this.configuration).markChatDialogReadAll(requestParameters.dialogId, requestParameters.apiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Отметить диалог непрочитанным
     * @param {ChatApiMarkChatDialogUnreadRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChatApi
     */
    public markChatDialogUnread(requestParameters: ChatApiMarkChatDialogUnreadRequest, options?: RawAxiosRequestConfig) {
        return ChatApiFp(this.configuration).markChatDialogUnread(requestParameters.dialogId, requestParameters.apiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Повторить передачу существующего сообщения
     * @param {ChatApiRetryChatDialogMessageRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChatApi
     */
    public retryChatDialogMessage(requestParameters: ChatApiRetryChatDialogMessageRequest, options?: RawAxiosRequestConfig) {
        return ChatApiFp(this.configuration).retryChatDialogMessage(requestParameters.dialogId, requestParameters.messageId, requestParameters.apiVersion, requestParameters.retryChatDialogMessageRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Отправить ответ пользователю
     * @param {ChatApiSendChatDialogMessageRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChatApi
     */
    public sendChatDialogMessage(requestParameters: ChatApiSendChatDialogMessageRequest, options?: RawAxiosRequestConfig) {
        return ChatApiFp(this.configuration).sendChatDialogMessage(requestParameters.dialogId, requestParameters.apiVersion, requestParameters.sendChatDialogMessageRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Отправить сообщение
     * @param {ChatApiSendMessageRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChatApi
     */
    public sendMessage(requestParameters: ChatApiSendMessageRequest = {}, options?: RawAxiosRequestConfig) {
        return ChatApiFp(this.configuration).sendMessage(requestParameters.apiVersion, requestParameters.sendMessageRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Синхронизировать данные о собеседнике
     * @param {ChatApiSynchronizeCompanionDataRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChatApi
     */
    public synchronizeCompanionData(requestParameters: ChatApiSynchronizeCompanionDataRequest = {}, options?: RawAxiosRequestConfig) {
        return ChatApiFp(this.configuration).synchronizeCompanionData(requestParameters.apiVersion, requestParameters.synchronizeCompanionDataRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Просмотреть сообщения в чате
     * @param {ChatApiViewMessagesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChatApi
     */
    public viewMessages(requestParameters: ChatApiViewMessagesRequest, options?: RawAxiosRequestConfig) {
        return ChatApiFp(this.configuration).viewMessages(requestParameters.appUserId, requestParameters.chatId, requestParameters.readThroughMessageId, requestParameters.useReadWatermark, requestParameters.apiVersion, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ChatMigrationsApi - axios parameter creator
 * @export
 */
export const ChatMigrationsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Запустить перенос переписки
         * @param {string} [apiVersion] 
         * @param {StartChatMigrationRequest} [startChatMigrationRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminChatMigrationsRunsPost: async (apiVersion?: string, startChatMigrationRequest?: StartChatMigrationRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/admin/chat-migrations/runs`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(startChatMigrationRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Отменить дальнейший перенос
         * @param {string} runId 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminChatMigrationsRunsRunIdCancelPost: async (runId: string, apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'runId' is not null or undefined
            assertParamExists('apiV1AdminChatMigrationsRunsRunIdCancelPost', 'runId', runId)
            const localVarPath = `/api/v1/admin/chat-migrations/runs/{runId}/cancel`
                .replace(`{${"runId"}}`, encodeURIComponent(String(runId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Получить состояние переноса
         * @param {string} runId 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminChatMigrationsRunsRunIdGet: async (runId: string, apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'runId' is not null or undefined
            assertParamExists('apiV1AdminChatMigrationsRunsRunIdGet', 'runId', runId)
            const localVarPath = `/api/v1/admin/chat-migrations/runs/{runId}`
                .replace(`{${"runId"}}`, encodeURIComponent(String(runId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Получить замечания переноса
         * @param {string} runId 
         * @param {number} [offset] 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminChatMigrationsRunsRunIdIssuesGet: async (runId: string, offset?: number, apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'runId' is not null or undefined
            assertParamExists('apiV1AdminChatMigrationsRunsRunIdIssuesGet', 'runId', runId)
            const localVarPath = `/api/v1/admin/chat-migrations/runs/{runId}/issues`
                .replace(`{${"runId"}}`, encodeURIComponent(String(runId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }


    
            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Продолжить перенос переписки
         * @param {string} runId 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminChatMigrationsRunsRunIdResumePost: async (runId: string, apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'runId' is not null or undefined
            assertParamExists('apiV1AdminChatMigrationsRunsRunIdResumePost', 'runId', runId)
            const localVarPath = `/api/v1/admin/chat-migrations/runs/{runId}/resume`
                .replace(`{${"runId"}}`, encodeURIComponent(String(runId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ChatMigrationsApi - functional programming interface
 * @export
 */
export const ChatMigrationsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ChatMigrationsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Запустить перенос переписки
         * @param {string} [apiVersion] 
         * @param {StartChatMigrationRequest} [startChatMigrationRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1AdminChatMigrationsRunsPost(apiVersion?: string, startChatMigrationRequest?: StartChatMigrationRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ChatMigrationRunResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1AdminChatMigrationsRunsPost(apiVersion, startChatMigrationRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ChatMigrationsApi.apiV1AdminChatMigrationsRunsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Отменить дальнейший перенос
         * @param {string} runId 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1AdminChatMigrationsRunsRunIdCancelPost(runId: string, apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1AdminChatMigrationsRunsRunIdCancelPost(runId, apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ChatMigrationsApi.apiV1AdminChatMigrationsRunsRunIdCancelPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Получить состояние переноса
         * @param {string} runId 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1AdminChatMigrationsRunsRunIdGet(runId: string, apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ChatMigrationRunResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1AdminChatMigrationsRunsRunIdGet(runId, apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ChatMigrationsApi.apiV1AdminChatMigrationsRunsRunIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Получить замечания переноса
         * @param {string} runId 
         * @param {number} [offset] 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1AdminChatMigrationsRunsRunIdIssuesGet(runId: string, offset?: number, apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ChatMigrationIssueResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1AdminChatMigrationsRunsRunIdIssuesGet(runId, offset, apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ChatMigrationsApi.apiV1AdminChatMigrationsRunsRunIdIssuesGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Продолжить перенос переписки
         * @param {string} runId 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1AdminChatMigrationsRunsRunIdResumePost(runId: string, apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ChatMigrationRunResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1AdminChatMigrationsRunsRunIdResumePost(runId, apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ChatMigrationsApi.apiV1AdminChatMigrationsRunsRunIdResumePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ChatMigrationsApi - factory interface
 * @export
 */
export const ChatMigrationsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ChatMigrationsApiFp(configuration)
    return {
        /**
         * 
         * @summary Запустить перенос переписки
         * @param {ChatMigrationsApiApiV1AdminChatMigrationsRunsPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminChatMigrationsRunsPost(requestParameters: ChatMigrationsApiApiV1AdminChatMigrationsRunsPostRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<ChatMigrationRunResponse> {
            return localVarFp.apiV1AdminChatMigrationsRunsPost(requestParameters.apiVersion, requestParameters.startChatMigrationRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Отменить дальнейший перенос
         * @param {ChatMigrationsApiApiV1AdminChatMigrationsRunsRunIdCancelPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminChatMigrationsRunsRunIdCancelPost(requestParameters: ChatMigrationsApiApiV1AdminChatMigrationsRunsRunIdCancelPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiV1AdminChatMigrationsRunsRunIdCancelPost(requestParameters.runId, requestParameters.apiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Получить состояние переноса
         * @param {ChatMigrationsApiApiV1AdminChatMigrationsRunsRunIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminChatMigrationsRunsRunIdGet(requestParameters: ChatMigrationsApiApiV1AdminChatMigrationsRunsRunIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<ChatMigrationRunResponse> {
            return localVarFp.apiV1AdminChatMigrationsRunsRunIdGet(requestParameters.runId, requestParameters.apiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Получить замечания переноса
         * @param {ChatMigrationsApiApiV1AdminChatMigrationsRunsRunIdIssuesGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminChatMigrationsRunsRunIdIssuesGet(requestParameters: ChatMigrationsApiApiV1AdminChatMigrationsRunsRunIdIssuesGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<ChatMigrationIssueResponse>> {
            return localVarFp.apiV1AdminChatMigrationsRunsRunIdIssuesGet(requestParameters.runId, requestParameters.offset, requestParameters.apiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Продолжить перенос переписки
         * @param {ChatMigrationsApiApiV1AdminChatMigrationsRunsRunIdResumePostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminChatMigrationsRunsRunIdResumePost(requestParameters: ChatMigrationsApiApiV1AdminChatMigrationsRunsRunIdResumePostRequest, options?: RawAxiosRequestConfig): AxiosPromise<ChatMigrationRunResponse> {
            return localVarFp.apiV1AdminChatMigrationsRunsRunIdResumePost(requestParameters.runId, requestParameters.apiVersion, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for apiV1AdminChatMigrationsRunsPost operation in ChatMigrationsApi.
 * @export
 * @interface ChatMigrationsApiApiV1AdminChatMigrationsRunsPostRequest
 */
export interface ChatMigrationsApiApiV1AdminChatMigrationsRunsPostRequest {
    /**
     * 
     * @type {string}
     * @memberof ChatMigrationsApiApiV1AdminChatMigrationsRunsPost
     */
    readonly apiVersion?: string

    /**
     * 
     * @type {StartChatMigrationRequest}
     * @memberof ChatMigrationsApiApiV1AdminChatMigrationsRunsPost
     */
    readonly startChatMigrationRequest?: StartChatMigrationRequest
}

/**
 * Request parameters for apiV1AdminChatMigrationsRunsRunIdCancelPost operation in ChatMigrationsApi.
 * @export
 * @interface ChatMigrationsApiApiV1AdminChatMigrationsRunsRunIdCancelPostRequest
 */
export interface ChatMigrationsApiApiV1AdminChatMigrationsRunsRunIdCancelPostRequest {
    /**
     * 
     * @type {string}
     * @memberof ChatMigrationsApiApiV1AdminChatMigrationsRunsRunIdCancelPost
     */
    readonly runId: string

    /**
     * 
     * @type {string}
     * @memberof ChatMigrationsApiApiV1AdminChatMigrationsRunsRunIdCancelPost
     */
    readonly apiVersion?: string
}

/**
 * Request parameters for apiV1AdminChatMigrationsRunsRunIdGet operation in ChatMigrationsApi.
 * @export
 * @interface ChatMigrationsApiApiV1AdminChatMigrationsRunsRunIdGetRequest
 */
export interface ChatMigrationsApiApiV1AdminChatMigrationsRunsRunIdGetRequest {
    /**
     * 
     * @type {string}
     * @memberof ChatMigrationsApiApiV1AdminChatMigrationsRunsRunIdGet
     */
    readonly runId: string

    /**
     * 
     * @type {string}
     * @memberof ChatMigrationsApiApiV1AdminChatMigrationsRunsRunIdGet
     */
    readonly apiVersion?: string
}

/**
 * Request parameters for apiV1AdminChatMigrationsRunsRunIdIssuesGet operation in ChatMigrationsApi.
 * @export
 * @interface ChatMigrationsApiApiV1AdminChatMigrationsRunsRunIdIssuesGetRequest
 */
export interface ChatMigrationsApiApiV1AdminChatMigrationsRunsRunIdIssuesGetRequest {
    /**
     * 
     * @type {string}
     * @memberof ChatMigrationsApiApiV1AdminChatMigrationsRunsRunIdIssuesGet
     */
    readonly runId: string

    /**
     * 
     * @type {number}
     * @memberof ChatMigrationsApiApiV1AdminChatMigrationsRunsRunIdIssuesGet
     */
    readonly offset?: number

    /**
     * 
     * @type {string}
     * @memberof ChatMigrationsApiApiV1AdminChatMigrationsRunsRunIdIssuesGet
     */
    readonly apiVersion?: string
}

/**
 * Request parameters for apiV1AdminChatMigrationsRunsRunIdResumePost operation in ChatMigrationsApi.
 * @export
 * @interface ChatMigrationsApiApiV1AdminChatMigrationsRunsRunIdResumePostRequest
 */
export interface ChatMigrationsApiApiV1AdminChatMigrationsRunsRunIdResumePostRequest {
    /**
     * 
     * @type {string}
     * @memberof ChatMigrationsApiApiV1AdminChatMigrationsRunsRunIdResumePost
     */
    readonly runId: string

    /**
     * 
     * @type {string}
     * @memberof ChatMigrationsApiApiV1AdminChatMigrationsRunsRunIdResumePost
     */
    readonly apiVersion?: string
}

/**
 * ChatMigrationsApi - object-oriented interface
 * @export
 * @class ChatMigrationsApi
 * @extends {BaseAPI}
 */
export class ChatMigrationsApi extends BaseAPI {
    /**
     * 
     * @summary Запустить перенос переписки
     * @param {ChatMigrationsApiApiV1AdminChatMigrationsRunsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChatMigrationsApi
     */
    public apiV1AdminChatMigrationsRunsPost(requestParameters: ChatMigrationsApiApiV1AdminChatMigrationsRunsPostRequest = {}, options?: RawAxiosRequestConfig) {
        return ChatMigrationsApiFp(this.configuration).apiV1AdminChatMigrationsRunsPost(requestParameters.apiVersion, requestParameters.startChatMigrationRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Отменить дальнейший перенос
     * @param {ChatMigrationsApiApiV1AdminChatMigrationsRunsRunIdCancelPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChatMigrationsApi
     */
    public apiV1AdminChatMigrationsRunsRunIdCancelPost(requestParameters: ChatMigrationsApiApiV1AdminChatMigrationsRunsRunIdCancelPostRequest, options?: RawAxiosRequestConfig) {
        return ChatMigrationsApiFp(this.configuration).apiV1AdminChatMigrationsRunsRunIdCancelPost(requestParameters.runId, requestParameters.apiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Получить состояние переноса
     * @param {ChatMigrationsApiApiV1AdminChatMigrationsRunsRunIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChatMigrationsApi
     */
    public apiV1AdminChatMigrationsRunsRunIdGet(requestParameters: ChatMigrationsApiApiV1AdminChatMigrationsRunsRunIdGetRequest, options?: RawAxiosRequestConfig) {
        return ChatMigrationsApiFp(this.configuration).apiV1AdminChatMigrationsRunsRunIdGet(requestParameters.runId, requestParameters.apiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Получить замечания переноса
     * @param {ChatMigrationsApiApiV1AdminChatMigrationsRunsRunIdIssuesGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChatMigrationsApi
     */
    public apiV1AdminChatMigrationsRunsRunIdIssuesGet(requestParameters: ChatMigrationsApiApiV1AdminChatMigrationsRunsRunIdIssuesGetRequest, options?: RawAxiosRequestConfig) {
        return ChatMigrationsApiFp(this.configuration).apiV1AdminChatMigrationsRunsRunIdIssuesGet(requestParameters.runId, requestParameters.offset, requestParameters.apiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Продолжить перенос переписки
     * @param {ChatMigrationsApiApiV1AdminChatMigrationsRunsRunIdResumePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChatMigrationsApi
     */
    public apiV1AdminChatMigrationsRunsRunIdResumePost(requestParameters: ChatMigrationsApiApiV1AdminChatMigrationsRunsRunIdResumePostRequest, options?: RawAxiosRequestConfig) {
        return ChatMigrationsApiFp(this.configuration).apiV1AdminChatMigrationsRunsRunIdResumePost(requestParameters.runId, requestParameters.apiVersion, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ChatPersonalizationApi - axios parameter creator
 * @export
 */
export const ChatPersonalizationApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Редактировать собственный ответ оператора от имени поддержки
         * @param {string} dialogId 
         * @param {string} messageId 
         * @param {string} [apiVersion] 
         * @param {EditChatMessageRequest} [editChatMessageRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editOperatorChatMessage: async (dialogId: string, messageId: string, apiVersion?: string, editChatMessageRequest?: EditChatMessageRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'dialogId' is not null or undefined
            assertParamExists('editOperatorChatMessage', 'dialogId', dialogId)
            // verify required parameter 'messageId' is not null or undefined
            assertParamExists('editOperatorChatMessage', 'messageId', messageId)
            const localVarPath = `/api/v1/admin/chats/{dialogId}/messages/{messageId}`
                .replace(`{${"dialogId"}}`, encodeURIComponent(String(dialogId)))
                .replace(`{${"messageId"}}`, encodeURIComponent(String(messageId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(editChatMessageRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Редактировать собственное сообщение пользователя
         * @param {string} dialogId 
         * @param {string} messageId 
         * @param {string} [apiVersion] 
         * @param {EditChatMessageRequest} [editChatMessageRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editUserChatMessage: async (dialogId: string, messageId: string, apiVersion?: string, editChatMessageRequest?: EditChatMessageRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'dialogId' is not null or undefined
            assertParamExists('editUserChatMessage', 'dialogId', dialogId)
            // verify required parameter 'messageId' is not null or undefined
            assertParamExists('editUserChatMessage', 'messageId', messageId)
            const localVarPath = `/api/v1/chats/me/{dialogId}/messages/{messageId}`
                .replace(`{${"dialogId"}}`, encodeURIComponent(String(dialogId)))
                .replace(`{${"messageId"}}`, encodeURIComponent(String(messageId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(editChatMessageRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Закрепить переписку приложения для текущего сотрудника
         * @param {string} dialogId 
         * @param {string} [apiVersion] 
         * @param {PinChatRequest} [pinChatRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setOperatorAppChatPin: async (dialogId: string, apiVersion?: string, pinChatRequest?: PinChatRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'dialogId' is not null or undefined
            assertParamExists('setOperatorAppChatPin', 'dialogId', dialogId)
            const localVarPath = `/api/v1/admin/chats/{dialogId}/pin`
                .replace(`{${"dialogId"}}`, encodeURIComponent(String(dialogId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(pinChatRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Закрепить переписку внешнего канала для текущего сотрудника
         * @param {string} dialogId 
         * @param {string} [apiVersion] 
         * @param {PinChatRequest} [pinChatRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setOperatorExternalChatPin: async (dialogId: string, apiVersion?: string, pinChatRequest?: PinChatRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'dialogId' is not null or undefined
            assertParamExists('setOperatorExternalChatPin', 'dialogId', dialogId)
            const localVarPath = `/api/v1/admin/chat-dialogs/{dialogId}/pin`
                .replace(`{${"dialogId"}}`, encodeURIComponent(String(dialogId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(pinChatRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Установить закрепление диалога текущего пользователя
         * @param {string} dialogId 
         * @param {string} [apiVersion] 
         * @param {PinChatRequest} [pinChatRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setUserChatPin: async (dialogId: string, apiVersion?: string, pinChatRequest?: PinChatRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'dialogId' is not null or undefined
            assertParamExists('setUserChatPin', 'dialogId', dialogId)
            const localVarPath = `/api/v1/chats/me/{dialogId}/pin`
                .replace(`{${"dialogId"}}`, encodeURIComponent(String(dialogId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(pinChatRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ChatPersonalizationApi - functional programming interface
 * @export
 */
export const ChatPersonalizationApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ChatPersonalizationApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Редактировать собственный ответ оператора от имени поддержки
         * @param {string} dialogId 
         * @param {string} messageId 
         * @param {string} [apiVersion] 
         * @param {EditChatMessageRequest} [editChatMessageRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async editOperatorChatMessage(dialogId: string, messageId: string, apiVersion?: string, editChatMessageRequest?: EditChatMessageRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.editOperatorChatMessage(dialogId, messageId, apiVersion, editChatMessageRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ChatPersonalizationApi.editOperatorChatMessage']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Редактировать собственное сообщение пользователя
         * @param {string} dialogId 
         * @param {string} messageId 
         * @param {string} [apiVersion] 
         * @param {EditChatMessageRequest} [editChatMessageRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async editUserChatMessage(dialogId: string, messageId: string, apiVersion?: string, editChatMessageRequest?: EditChatMessageRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.editUserChatMessage(dialogId, messageId, apiVersion, editChatMessageRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ChatPersonalizationApi.editUserChatMessage']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Закрепить переписку приложения для текущего сотрудника
         * @param {string} dialogId 
         * @param {string} [apiVersion] 
         * @param {PinChatRequest} [pinChatRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setOperatorAppChatPin(dialogId: string, apiVersion?: string, pinChatRequest?: PinChatRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.setOperatorAppChatPin(dialogId, apiVersion, pinChatRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ChatPersonalizationApi.setOperatorAppChatPin']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Закрепить переписку внешнего канала для текущего сотрудника
         * @param {string} dialogId 
         * @param {string} [apiVersion] 
         * @param {PinChatRequest} [pinChatRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setOperatorExternalChatPin(dialogId: string, apiVersion?: string, pinChatRequest?: PinChatRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.setOperatorExternalChatPin(dialogId, apiVersion, pinChatRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ChatPersonalizationApi.setOperatorExternalChatPin']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Установить закрепление диалога текущего пользователя
         * @param {string} dialogId 
         * @param {string} [apiVersion] 
         * @param {PinChatRequest} [pinChatRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setUserChatPin(dialogId: string, apiVersion?: string, pinChatRequest?: PinChatRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.setUserChatPin(dialogId, apiVersion, pinChatRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ChatPersonalizationApi.setUserChatPin']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ChatPersonalizationApi - factory interface
 * @export
 */
export const ChatPersonalizationApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ChatPersonalizationApiFp(configuration)
    return {
        /**
         * 
         * @summary Редактировать собственный ответ оператора от имени поддержки
         * @param {ChatPersonalizationApiEditOperatorChatMessageRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editOperatorChatMessage(requestParameters: ChatPersonalizationApiEditOperatorChatMessageRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.editOperatorChatMessage(requestParameters.dialogId, requestParameters.messageId, requestParameters.apiVersion, requestParameters.editChatMessageRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Редактировать собственное сообщение пользователя
         * @param {ChatPersonalizationApiEditUserChatMessageRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editUserChatMessage(requestParameters: ChatPersonalizationApiEditUserChatMessageRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.editUserChatMessage(requestParameters.dialogId, requestParameters.messageId, requestParameters.apiVersion, requestParameters.editChatMessageRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Закрепить переписку приложения для текущего сотрудника
         * @param {ChatPersonalizationApiSetOperatorAppChatPinRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setOperatorAppChatPin(requestParameters: ChatPersonalizationApiSetOperatorAppChatPinRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.setOperatorAppChatPin(requestParameters.dialogId, requestParameters.apiVersion, requestParameters.pinChatRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Закрепить переписку внешнего канала для текущего сотрудника
         * @param {ChatPersonalizationApiSetOperatorExternalChatPinRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setOperatorExternalChatPin(requestParameters: ChatPersonalizationApiSetOperatorExternalChatPinRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.setOperatorExternalChatPin(requestParameters.dialogId, requestParameters.apiVersion, requestParameters.pinChatRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Установить закрепление диалога текущего пользователя
         * @param {ChatPersonalizationApiSetUserChatPinRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setUserChatPin(requestParameters: ChatPersonalizationApiSetUserChatPinRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.setUserChatPin(requestParameters.dialogId, requestParameters.apiVersion, requestParameters.pinChatRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for editOperatorChatMessage operation in ChatPersonalizationApi.
 * @export
 * @interface ChatPersonalizationApiEditOperatorChatMessageRequest
 */
export interface ChatPersonalizationApiEditOperatorChatMessageRequest {
    /**
     * 
     * @type {string}
     * @memberof ChatPersonalizationApiEditOperatorChatMessage
     */
    readonly dialogId: string

    /**
     * 
     * @type {string}
     * @memberof ChatPersonalizationApiEditOperatorChatMessage
     */
    readonly messageId: string

    /**
     * 
     * @type {string}
     * @memberof ChatPersonalizationApiEditOperatorChatMessage
     */
    readonly apiVersion?: string

    /**
     * 
     * @type {EditChatMessageRequest}
     * @memberof ChatPersonalizationApiEditOperatorChatMessage
     */
    readonly editChatMessageRequest?: EditChatMessageRequest
}

/**
 * Request parameters for editUserChatMessage operation in ChatPersonalizationApi.
 * @export
 * @interface ChatPersonalizationApiEditUserChatMessageRequest
 */
export interface ChatPersonalizationApiEditUserChatMessageRequest {
    /**
     * 
     * @type {string}
     * @memberof ChatPersonalizationApiEditUserChatMessage
     */
    readonly dialogId: string

    /**
     * 
     * @type {string}
     * @memberof ChatPersonalizationApiEditUserChatMessage
     */
    readonly messageId: string

    /**
     * 
     * @type {string}
     * @memberof ChatPersonalizationApiEditUserChatMessage
     */
    readonly apiVersion?: string

    /**
     * 
     * @type {EditChatMessageRequest}
     * @memberof ChatPersonalizationApiEditUserChatMessage
     */
    readonly editChatMessageRequest?: EditChatMessageRequest
}

/**
 * Request parameters for setOperatorAppChatPin operation in ChatPersonalizationApi.
 * @export
 * @interface ChatPersonalizationApiSetOperatorAppChatPinRequest
 */
export interface ChatPersonalizationApiSetOperatorAppChatPinRequest {
    /**
     * 
     * @type {string}
     * @memberof ChatPersonalizationApiSetOperatorAppChatPin
     */
    readonly dialogId: string

    /**
     * 
     * @type {string}
     * @memberof ChatPersonalizationApiSetOperatorAppChatPin
     */
    readonly apiVersion?: string

    /**
     * 
     * @type {PinChatRequest}
     * @memberof ChatPersonalizationApiSetOperatorAppChatPin
     */
    readonly pinChatRequest?: PinChatRequest
}

/**
 * Request parameters for setOperatorExternalChatPin operation in ChatPersonalizationApi.
 * @export
 * @interface ChatPersonalizationApiSetOperatorExternalChatPinRequest
 */
export interface ChatPersonalizationApiSetOperatorExternalChatPinRequest {
    /**
     * 
     * @type {string}
     * @memberof ChatPersonalizationApiSetOperatorExternalChatPin
     */
    readonly dialogId: string

    /**
     * 
     * @type {string}
     * @memberof ChatPersonalizationApiSetOperatorExternalChatPin
     */
    readonly apiVersion?: string

    /**
     * 
     * @type {PinChatRequest}
     * @memberof ChatPersonalizationApiSetOperatorExternalChatPin
     */
    readonly pinChatRequest?: PinChatRequest
}

/**
 * Request parameters for setUserChatPin operation in ChatPersonalizationApi.
 * @export
 * @interface ChatPersonalizationApiSetUserChatPinRequest
 */
export interface ChatPersonalizationApiSetUserChatPinRequest {
    /**
     * 
     * @type {string}
     * @memberof ChatPersonalizationApiSetUserChatPin
     */
    readonly dialogId: string

    /**
     * 
     * @type {string}
     * @memberof ChatPersonalizationApiSetUserChatPin
     */
    readonly apiVersion?: string

    /**
     * 
     * @type {PinChatRequest}
     * @memberof ChatPersonalizationApiSetUserChatPin
     */
    readonly pinChatRequest?: PinChatRequest
}

/**
 * ChatPersonalizationApi - object-oriented interface
 * @export
 * @class ChatPersonalizationApi
 * @extends {BaseAPI}
 */
export class ChatPersonalizationApi extends BaseAPI {
    /**
     * 
     * @summary Редактировать собственный ответ оператора от имени поддержки
     * @param {ChatPersonalizationApiEditOperatorChatMessageRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChatPersonalizationApi
     */
    public editOperatorChatMessage(requestParameters: ChatPersonalizationApiEditOperatorChatMessageRequest, options?: RawAxiosRequestConfig) {
        return ChatPersonalizationApiFp(this.configuration).editOperatorChatMessage(requestParameters.dialogId, requestParameters.messageId, requestParameters.apiVersion, requestParameters.editChatMessageRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Редактировать собственное сообщение пользователя
     * @param {ChatPersonalizationApiEditUserChatMessageRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChatPersonalizationApi
     */
    public editUserChatMessage(requestParameters: ChatPersonalizationApiEditUserChatMessageRequest, options?: RawAxiosRequestConfig) {
        return ChatPersonalizationApiFp(this.configuration).editUserChatMessage(requestParameters.dialogId, requestParameters.messageId, requestParameters.apiVersion, requestParameters.editChatMessageRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Закрепить переписку приложения для текущего сотрудника
     * @param {ChatPersonalizationApiSetOperatorAppChatPinRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChatPersonalizationApi
     */
    public setOperatorAppChatPin(requestParameters: ChatPersonalizationApiSetOperatorAppChatPinRequest, options?: RawAxiosRequestConfig) {
        return ChatPersonalizationApiFp(this.configuration).setOperatorAppChatPin(requestParameters.dialogId, requestParameters.apiVersion, requestParameters.pinChatRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Закрепить переписку внешнего канала для текущего сотрудника
     * @param {ChatPersonalizationApiSetOperatorExternalChatPinRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChatPersonalizationApi
     */
    public setOperatorExternalChatPin(requestParameters: ChatPersonalizationApiSetOperatorExternalChatPinRequest, options?: RawAxiosRequestConfig) {
        return ChatPersonalizationApiFp(this.configuration).setOperatorExternalChatPin(requestParameters.dialogId, requestParameters.apiVersion, requestParameters.pinChatRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Установить закрепление диалога текущего пользователя
     * @param {ChatPersonalizationApiSetUserChatPinRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChatPersonalizationApi
     */
    public setUserChatPin(requestParameters: ChatPersonalizationApiSetUserChatPinRequest, options?: RawAxiosRequestConfig) {
        return ChatPersonalizationApiFp(this.configuration).setUserChatPin(requestParameters.dialogId, requestParameters.apiVersion, requestParameters.pinChatRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ChatReplyTemplatesApi - axios parameter creator
 * @export
 */
export const ChatReplyTemplatesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Создать папку шаблонов
         * @param {string} [apiVersion] 
         * @param {SaveChatReplyFolderRequest} [saveChatReplyFolderRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createChatReplyFolder: async (apiVersion?: string, saveChatReplyFolderRequest?: SaveChatReplyFolderRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/chat-reply-templates/folders`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(saveChatReplyFolderRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Создать шаблон сообщения
         * @param {string} [apiVersion] 
         * @param {SaveChatReplyTemplateRequest} [saveChatReplyTemplateRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createChatReplyTemplate: async (apiVersion?: string, saveChatReplyTemplateRequest?: SaveChatReplyTemplateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/chat-reply-templates/templates`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(saveChatReplyTemplateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Удалить пустую папку
         * @param {string} id 
         * @param {string} [version] 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteChatReplyFolder: async (id: string, version?: string, apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteChatReplyFolder', 'id', id)
            const localVarPath = `/api/v1/chat-reply-templates/folders/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (version !== undefined) {
                localVarQueryParameter['version'] = version;
            }


    
            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Удалить шаблон сообщения
         * @param {string} id 
         * @param {string} [version] 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteChatReplyTemplate: async (id: string, version?: string, apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteChatReplyTemplate', 'id', id)
            const localVarPath = `/api/v1/chat-reply-templates/templates/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (version !== undefined) {
                localVarQueryParameter['version'] = version;
            }


    
            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Получить каталог шаблонов
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getChatReplyCatalog: async (apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/chat-reply-templates`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Изменить папку шаблонов
         * @param {string} id 
         * @param {string} [apiVersion] 
         * @param {SaveChatReplyFolderRequest} [saveChatReplyFolderRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateChatReplyFolder: async (id: string, apiVersion?: string, saveChatReplyFolderRequest?: SaveChatReplyFolderRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateChatReplyFolder', 'id', id)
            const localVarPath = `/api/v1/chat-reply-templates/folders/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(saveChatReplyFolderRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Изменить шаблон сообщения
         * @param {string} id 
         * @param {string} [apiVersion] 
         * @param {SaveChatReplyTemplateRequest} [saveChatReplyTemplateRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateChatReplyTemplate: async (id: string, apiVersion?: string, saveChatReplyTemplateRequest?: SaveChatReplyTemplateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateChatReplyTemplate', 'id', id)
            const localVarPath = `/api/v1/chat-reply-templates/templates/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(saveChatReplyTemplateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ChatReplyTemplatesApi - functional programming interface
 * @export
 */
export const ChatReplyTemplatesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ChatReplyTemplatesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Создать папку шаблонов
         * @param {string} [apiVersion] 
         * @param {SaveChatReplyFolderRequest} [saveChatReplyFolderRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createChatReplyFolder(apiVersion?: string, saveChatReplyFolderRequest?: SaveChatReplyFolderRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createChatReplyFolder(apiVersion, saveChatReplyFolderRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ChatReplyTemplatesApi.createChatReplyFolder']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Создать шаблон сообщения
         * @param {string} [apiVersion] 
         * @param {SaveChatReplyTemplateRequest} [saveChatReplyTemplateRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createChatReplyTemplate(apiVersion?: string, saveChatReplyTemplateRequest?: SaveChatReplyTemplateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createChatReplyTemplate(apiVersion, saveChatReplyTemplateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ChatReplyTemplatesApi.createChatReplyTemplate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Удалить пустую папку
         * @param {string} id 
         * @param {string} [version] 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteChatReplyFolder(id: string, version?: string, apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteChatReplyFolder(id, version, apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ChatReplyTemplatesApi.deleteChatReplyFolder']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Удалить шаблон сообщения
         * @param {string} id 
         * @param {string} [version] 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteChatReplyTemplate(id: string, version?: string, apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteChatReplyTemplate(id, version, apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ChatReplyTemplatesApi.deleteChatReplyTemplate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Получить каталог шаблонов
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getChatReplyCatalog(apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ChatReplyCatalogResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getChatReplyCatalog(apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ChatReplyTemplatesApi.getChatReplyCatalog']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Изменить папку шаблонов
         * @param {string} id 
         * @param {string} [apiVersion] 
         * @param {SaveChatReplyFolderRequest} [saveChatReplyFolderRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateChatReplyFolder(id: string, apiVersion?: string, saveChatReplyFolderRequest?: SaveChatReplyFolderRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateChatReplyFolder(id, apiVersion, saveChatReplyFolderRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ChatReplyTemplatesApi.updateChatReplyFolder']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Изменить шаблон сообщения
         * @param {string} id 
         * @param {string} [apiVersion] 
         * @param {SaveChatReplyTemplateRequest} [saveChatReplyTemplateRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateChatReplyTemplate(id: string, apiVersion?: string, saveChatReplyTemplateRequest?: SaveChatReplyTemplateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateChatReplyTemplate(id, apiVersion, saveChatReplyTemplateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ChatReplyTemplatesApi.updateChatReplyTemplate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ChatReplyTemplatesApi - factory interface
 * @export
 */
export const ChatReplyTemplatesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ChatReplyTemplatesApiFp(configuration)
    return {
        /**
         * 
         * @summary Создать папку шаблонов
         * @param {ChatReplyTemplatesApiCreateChatReplyFolderRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createChatReplyFolder(requestParameters: ChatReplyTemplatesApiCreateChatReplyFolderRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.createChatReplyFolder(requestParameters.apiVersion, requestParameters.saveChatReplyFolderRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Создать шаблон сообщения
         * @param {ChatReplyTemplatesApiCreateChatReplyTemplateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createChatReplyTemplate(requestParameters: ChatReplyTemplatesApiCreateChatReplyTemplateRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.createChatReplyTemplate(requestParameters.apiVersion, requestParameters.saveChatReplyTemplateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Удалить пустую папку
         * @param {ChatReplyTemplatesApiDeleteChatReplyFolderRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteChatReplyFolder(requestParameters: ChatReplyTemplatesApiDeleteChatReplyFolderRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteChatReplyFolder(requestParameters.id, requestParameters.version, requestParameters.apiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Удалить шаблон сообщения
         * @param {ChatReplyTemplatesApiDeleteChatReplyTemplateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteChatReplyTemplate(requestParameters: ChatReplyTemplatesApiDeleteChatReplyTemplateRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteChatReplyTemplate(requestParameters.id, requestParameters.version, requestParameters.apiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Получить каталог шаблонов
         * @param {ChatReplyTemplatesApiGetChatReplyCatalogRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getChatReplyCatalog(requestParameters: ChatReplyTemplatesApiGetChatReplyCatalogRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<ChatReplyCatalogResponse> {
            return localVarFp.getChatReplyCatalog(requestParameters.apiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Изменить папку шаблонов
         * @param {ChatReplyTemplatesApiUpdateChatReplyFolderRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateChatReplyFolder(requestParameters: ChatReplyTemplatesApiUpdateChatReplyFolderRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateChatReplyFolder(requestParameters.id, requestParameters.apiVersion, requestParameters.saveChatReplyFolderRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Изменить шаблон сообщения
         * @param {ChatReplyTemplatesApiUpdateChatReplyTemplateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateChatReplyTemplate(requestParameters: ChatReplyTemplatesApiUpdateChatReplyTemplateRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateChatReplyTemplate(requestParameters.id, requestParameters.apiVersion, requestParameters.saveChatReplyTemplateRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for createChatReplyFolder operation in ChatReplyTemplatesApi.
 * @export
 * @interface ChatReplyTemplatesApiCreateChatReplyFolderRequest
 */
export interface ChatReplyTemplatesApiCreateChatReplyFolderRequest {
    /**
     * 
     * @type {string}
     * @memberof ChatReplyTemplatesApiCreateChatReplyFolder
     */
    readonly apiVersion?: string

    /**
     * 
     * @type {SaveChatReplyFolderRequest}
     * @memberof ChatReplyTemplatesApiCreateChatReplyFolder
     */
    readonly saveChatReplyFolderRequest?: SaveChatReplyFolderRequest
}

/**
 * Request parameters for createChatReplyTemplate operation in ChatReplyTemplatesApi.
 * @export
 * @interface ChatReplyTemplatesApiCreateChatReplyTemplateRequest
 */
export interface ChatReplyTemplatesApiCreateChatReplyTemplateRequest {
    /**
     * 
     * @type {string}
     * @memberof ChatReplyTemplatesApiCreateChatReplyTemplate
     */
    readonly apiVersion?: string

    /**
     * 
     * @type {SaveChatReplyTemplateRequest}
     * @memberof ChatReplyTemplatesApiCreateChatReplyTemplate
     */
    readonly saveChatReplyTemplateRequest?: SaveChatReplyTemplateRequest
}

/**
 * Request parameters for deleteChatReplyFolder operation in ChatReplyTemplatesApi.
 * @export
 * @interface ChatReplyTemplatesApiDeleteChatReplyFolderRequest
 */
export interface ChatReplyTemplatesApiDeleteChatReplyFolderRequest {
    /**
     * 
     * @type {string}
     * @memberof ChatReplyTemplatesApiDeleteChatReplyFolder
     */
    readonly id: string

    /**
     * 
     * @type {string}
     * @memberof ChatReplyTemplatesApiDeleteChatReplyFolder
     */
    readonly version?: string

    /**
     * 
     * @type {string}
     * @memberof ChatReplyTemplatesApiDeleteChatReplyFolder
     */
    readonly apiVersion?: string
}

/**
 * Request parameters for deleteChatReplyTemplate operation in ChatReplyTemplatesApi.
 * @export
 * @interface ChatReplyTemplatesApiDeleteChatReplyTemplateRequest
 */
export interface ChatReplyTemplatesApiDeleteChatReplyTemplateRequest {
    /**
     * 
     * @type {string}
     * @memberof ChatReplyTemplatesApiDeleteChatReplyTemplate
     */
    readonly id: string

    /**
     * 
     * @type {string}
     * @memberof ChatReplyTemplatesApiDeleteChatReplyTemplate
     */
    readonly version?: string

    /**
     * 
     * @type {string}
     * @memberof ChatReplyTemplatesApiDeleteChatReplyTemplate
     */
    readonly apiVersion?: string
}

/**
 * Request parameters for getChatReplyCatalog operation in ChatReplyTemplatesApi.
 * @export
 * @interface ChatReplyTemplatesApiGetChatReplyCatalogRequest
 */
export interface ChatReplyTemplatesApiGetChatReplyCatalogRequest {
    /**
     * 
     * @type {string}
     * @memberof ChatReplyTemplatesApiGetChatReplyCatalog
     */
    readonly apiVersion?: string
}

/**
 * Request parameters for updateChatReplyFolder operation in ChatReplyTemplatesApi.
 * @export
 * @interface ChatReplyTemplatesApiUpdateChatReplyFolderRequest
 */
export interface ChatReplyTemplatesApiUpdateChatReplyFolderRequest {
    /**
     * 
     * @type {string}
     * @memberof ChatReplyTemplatesApiUpdateChatReplyFolder
     */
    readonly id: string

    /**
     * 
     * @type {string}
     * @memberof ChatReplyTemplatesApiUpdateChatReplyFolder
     */
    readonly apiVersion?: string

    /**
     * 
     * @type {SaveChatReplyFolderRequest}
     * @memberof ChatReplyTemplatesApiUpdateChatReplyFolder
     */
    readonly saveChatReplyFolderRequest?: SaveChatReplyFolderRequest
}

/**
 * Request parameters for updateChatReplyTemplate operation in ChatReplyTemplatesApi.
 * @export
 * @interface ChatReplyTemplatesApiUpdateChatReplyTemplateRequest
 */
export interface ChatReplyTemplatesApiUpdateChatReplyTemplateRequest {
    /**
     * 
     * @type {string}
     * @memberof ChatReplyTemplatesApiUpdateChatReplyTemplate
     */
    readonly id: string

    /**
     * 
     * @type {string}
     * @memberof ChatReplyTemplatesApiUpdateChatReplyTemplate
     */
    readonly apiVersion?: string

    /**
     * 
     * @type {SaveChatReplyTemplateRequest}
     * @memberof ChatReplyTemplatesApiUpdateChatReplyTemplate
     */
    readonly saveChatReplyTemplateRequest?: SaveChatReplyTemplateRequest
}

/**
 * ChatReplyTemplatesApi - object-oriented interface
 * @export
 * @class ChatReplyTemplatesApi
 * @extends {BaseAPI}
 */
export class ChatReplyTemplatesApi extends BaseAPI {
    /**
     * 
     * @summary Создать папку шаблонов
     * @param {ChatReplyTemplatesApiCreateChatReplyFolderRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChatReplyTemplatesApi
     */
    public createChatReplyFolder(requestParameters: ChatReplyTemplatesApiCreateChatReplyFolderRequest = {}, options?: RawAxiosRequestConfig) {
        return ChatReplyTemplatesApiFp(this.configuration).createChatReplyFolder(requestParameters.apiVersion, requestParameters.saveChatReplyFolderRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Создать шаблон сообщения
     * @param {ChatReplyTemplatesApiCreateChatReplyTemplateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChatReplyTemplatesApi
     */
    public createChatReplyTemplate(requestParameters: ChatReplyTemplatesApiCreateChatReplyTemplateRequest = {}, options?: RawAxiosRequestConfig) {
        return ChatReplyTemplatesApiFp(this.configuration).createChatReplyTemplate(requestParameters.apiVersion, requestParameters.saveChatReplyTemplateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Удалить пустую папку
     * @param {ChatReplyTemplatesApiDeleteChatReplyFolderRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChatReplyTemplatesApi
     */
    public deleteChatReplyFolder(requestParameters: ChatReplyTemplatesApiDeleteChatReplyFolderRequest, options?: RawAxiosRequestConfig) {
        return ChatReplyTemplatesApiFp(this.configuration).deleteChatReplyFolder(requestParameters.id, requestParameters.version, requestParameters.apiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Удалить шаблон сообщения
     * @param {ChatReplyTemplatesApiDeleteChatReplyTemplateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChatReplyTemplatesApi
     */
    public deleteChatReplyTemplate(requestParameters: ChatReplyTemplatesApiDeleteChatReplyTemplateRequest, options?: RawAxiosRequestConfig) {
        return ChatReplyTemplatesApiFp(this.configuration).deleteChatReplyTemplate(requestParameters.id, requestParameters.version, requestParameters.apiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Получить каталог шаблонов
     * @param {ChatReplyTemplatesApiGetChatReplyCatalogRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChatReplyTemplatesApi
     */
    public getChatReplyCatalog(requestParameters: ChatReplyTemplatesApiGetChatReplyCatalogRequest = {}, options?: RawAxiosRequestConfig) {
        return ChatReplyTemplatesApiFp(this.configuration).getChatReplyCatalog(requestParameters.apiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Изменить папку шаблонов
     * @param {ChatReplyTemplatesApiUpdateChatReplyFolderRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChatReplyTemplatesApi
     */
    public updateChatReplyFolder(requestParameters: ChatReplyTemplatesApiUpdateChatReplyFolderRequest, options?: RawAxiosRequestConfig) {
        return ChatReplyTemplatesApiFp(this.configuration).updateChatReplyFolder(requestParameters.id, requestParameters.apiVersion, requestParameters.saveChatReplyFolderRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Изменить шаблон сообщения
     * @param {ChatReplyTemplatesApiUpdateChatReplyTemplateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChatReplyTemplatesApi
     */
    public updateChatReplyTemplate(requestParameters: ChatReplyTemplatesApiUpdateChatReplyTemplateRequest, options?: RawAxiosRequestConfig) {
        return ChatReplyTemplatesApiFp(this.configuration).updateChatReplyTemplate(requestParameters.id, requestParameters.apiVersion, requestParameters.saveChatReplyTemplateRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * CitiesApi - axios parameter creator
 * @export
 */
export const CitiesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Получить данные всех городов
         * @param {string} [searchQuery] Строка для поиска
         * @param {number} [takeCount] Размер страницы
         * @param {number} [skipCount] Кол-во пропущенных записей
         * @param {boolean} [ascending] Сортировка по возрастанию
         * @param {string} [ordering] Поле для сортировки
         * @param {boolean} [isDeleted] Удалённые записи
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllCities: async (searchQuery?: string, takeCount?: number, skipCount?: number, ascending?: boolean, ordering?: string, isDeleted?: boolean, apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/cities`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (searchQuery !== undefined) {
                localVarQueryParameter['SearchQuery'] = searchQuery;
            }

            if (takeCount !== undefined) {
                localVarQueryParameter['TakeCount'] = takeCount;
            }

            if (skipCount !== undefined) {
                localVarQueryParameter['SkipCount'] = skipCount;
            }

            if (ascending !== undefined) {
                localVarQueryParameter['Ascending'] = ascending;
            }

            if (ordering !== undefined) {
                localVarQueryParameter['Ordering'] = ordering;
            }

            if (isDeleted !== undefined) {
                localVarQueryParameter['IsDeleted'] = isDeleted;
            }


    
            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Получить данные города по ID
         * @param {number} id 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCityById: async (id: number, apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getCityById', 'id', id)
            const localVarPath = `/api/v1/cities/get-city-by-id/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Найти города по строке поиска
         * @param {string} [search] 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchCity: async (search?: string, apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/cities/search-city`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }


    
            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CitiesApi - functional programming interface
 * @export
 */
export const CitiesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CitiesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Получить данные всех городов
         * @param {string} [searchQuery] Строка для поиска
         * @param {number} [takeCount] Размер страницы
         * @param {number} [skipCount] Кол-во пропущенных записей
         * @param {boolean} [ascending] Сортировка по возрастанию
         * @param {string} [ordering] Поле для сортировки
         * @param {boolean} [isDeleted] Удалённые записи
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllCities(searchQuery?: string, takeCount?: number, skipCount?: number, ascending?: boolean, ordering?: string, isDeleted?: boolean, apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CityResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllCities(searchQuery, takeCount, skipCount, ascending, ordering, isDeleted, apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CitiesApi.getAllCities']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Получить данные города по ID
         * @param {number} id 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCityById(id: number, apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CityResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCityById(id, apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CitiesApi.getCityById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Найти города по строке поиска
         * @param {string} [search] 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async searchCity(search?: string, apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Int64SimpleModel>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.searchCity(search, apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CitiesApi.searchCity']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * CitiesApi - factory interface
 * @export
 */
export const CitiesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CitiesApiFp(configuration)
    return {
        /**
         * 
         * @summary Получить данные всех городов
         * @param {CitiesApiGetAllCitiesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllCities(requestParameters: CitiesApiGetAllCitiesRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<Array<CityResponse>> {
            return localVarFp.getAllCities(requestParameters.searchQuery, requestParameters.takeCount, requestParameters.skipCount, requestParameters.ascending, requestParameters.ordering, requestParameters.isDeleted, requestParameters.apiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Получить данные города по ID
         * @param {CitiesApiGetCityByIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCityById(requestParameters: CitiesApiGetCityByIdRequest, options?: RawAxiosRequestConfig): AxiosPromise<CityResponse> {
            return localVarFp.getCityById(requestParameters.id, requestParameters.apiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Найти города по строке поиска
         * @param {CitiesApiSearchCityRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchCity(requestParameters: CitiesApiSearchCityRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<Array<Int64SimpleModel>> {
            return localVarFp.searchCity(requestParameters.search, requestParameters.apiVersion, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for getAllCities operation in CitiesApi.
 * @export
 * @interface CitiesApiGetAllCitiesRequest
 */
export interface CitiesApiGetAllCitiesRequest {
    /**
     * Строка для поиска
     * @type {string}
     * @memberof CitiesApiGetAllCities
     */
    readonly searchQuery?: string

    /**
     * Размер страницы
     * @type {number}
     * @memberof CitiesApiGetAllCities
     */
    readonly takeCount?: number

    /**
     * Кол-во пропущенных записей
     * @type {number}
     * @memberof CitiesApiGetAllCities
     */
    readonly skipCount?: number

    /**
     * Сортировка по возрастанию
     * @type {boolean}
     * @memberof CitiesApiGetAllCities
     */
    readonly ascending?: boolean

    /**
     * Поле для сортировки
     * @type {string}
     * @memberof CitiesApiGetAllCities
     */
    readonly ordering?: string

    /**
     * Удалённые записи
     * @type {boolean}
     * @memberof CitiesApiGetAllCities
     */
    readonly isDeleted?: boolean

    /**
     * 
     * @type {string}
     * @memberof CitiesApiGetAllCities
     */
    readonly apiVersion?: string
}

/**
 * Request parameters for getCityById operation in CitiesApi.
 * @export
 * @interface CitiesApiGetCityByIdRequest
 */
export interface CitiesApiGetCityByIdRequest {
    /**
     * 
     * @type {number}
     * @memberof CitiesApiGetCityById
     */
    readonly id: number

    /**
     * 
     * @type {string}
     * @memberof CitiesApiGetCityById
     */
    readonly apiVersion?: string
}

/**
 * Request parameters for searchCity operation in CitiesApi.
 * @export
 * @interface CitiesApiSearchCityRequest
 */
export interface CitiesApiSearchCityRequest {
    /**
     * 
     * @type {string}
     * @memberof CitiesApiSearchCity
     */
    readonly search?: string

    /**
     * 
     * @type {string}
     * @memberof CitiesApiSearchCity
     */
    readonly apiVersion?: string
}

/**
 * CitiesApi - object-oriented interface
 * @export
 * @class CitiesApi
 * @extends {BaseAPI}
 */
export class CitiesApi extends BaseAPI {
    /**
     * 
     * @summary Получить данные всех городов
     * @param {CitiesApiGetAllCitiesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CitiesApi
     */
    public getAllCities(requestParameters: CitiesApiGetAllCitiesRequest = {}, options?: RawAxiosRequestConfig) {
        return CitiesApiFp(this.configuration).getAllCities(requestParameters.searchQuery, requestParameters.takeCount, requestParameters.skipCount, requestParameters.ascending, requestParameters.ordering, requestParameters.isDeleted, requestParameters.apiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Получить данные города по ID
     * @param {CitiesApiGetCityByIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CitiesApi
     */
    public getCityById(requestParameters: CitiesApiGetCityByIdRequest, options?: RawAxiosRequestConfig) {
        return CitiesApiFp(this.configuration).getCityById(requestParameters.id, requestParameters.apiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Найти города по строке поиска
     * @param {CitiesApiSearchCityRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CitiesApi
     */
    public searchCity(requestParameters: CitiesApiSearchCityRequest = {}, options?: RawAxiosRequestConfig) {
        return CitiesApiFp(this.configuration).searchCity(requestParameters.search, requestParameters.apiVersion, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * CitizenshipsApi - axios parameter creator
 * @export
 */
export const CitizenshipsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Получить справочник гражданств
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllCitizenships: async (apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/citizenships`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CitizenshipsApi - functional programming interface
 * @export
 */
export const CitizenshipsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CitizenshipsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Получить справочник гражданств
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllCitizenships(apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CitizenshipResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllCitizenships(apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CitizenshipsApi.getAllCitizenships']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * CitizenshipsApi - factory interface
 * @export
 */
export const CitizenshipsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CitizenshipsApiFp(configuration)
    return {
        /**
         * 
         * @summary Получить справочник гражданств
         * @param {CitizenshipsApiGetAllCitizenshipsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllCitizenships(requestParameters: CitizenshipsApiGetAllCitizenshipsRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<Array<CitizenshipResponse>> {
            return localVarFp.getAllCitizenships(requestParameters.apiVersion, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for getAllCitizenships operation in CitizenshipsApi.
 * @export
 * @interface CitizenshipsApiGetAllCitizenshipsRequest
 */
export interface CitizenshipsApiGetAllCitizenshipsRequest {
    /**
     * 
     * @type {string}
     * @memberof CitizenshipsApiGetAllCitizenships
     */
    readonly apiVersion?: string
}

/**
 * CitizenshipsApi - object-oriented interface
 * @export
 * @class CitizenshipsApi
 * @extends {BaseAPI}
 */
export class CitizenshipsApi extends BaseAPI {
    /**
     * 
     * @summary Получить справочник гражданств
     * @param {CitizenshipsApiGetAllCitizenshipsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CitizenshipsApi
     */
    public getAllCitizenships(requestParameters: CitizenshipsApiGetAllCitizenshipsRequest = {}, options?: RawAxiosRequestConfig) {
        return CitizenshipsApiFp(this.configuration).getAllCitizenships(requestParameters.apiVersion, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * CityDistrictApi - axios parameter creator
 * @export
 */
export const CityDistrictApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Получить данные района города по ID
         * @param {number} id 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCityDistrictById: async (id: number, apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getCityDistrictById', 'id', id)
            const localVarPath = `/api/v1/city-districts/get-city-district-by-id/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Получить данные районов
         * @param {Array<number>} [cityIds] Идентификаторы городов
         * @param {string} [executorId] Идентификатор исполнителя
         * @param {string} [searchQuery] Строка для поиска
         * @param {number} [takeCount] Размер страницы
         * @param {number} [skipCount] Кол-во пропущенных записей
         * @param {boolean} [ascending] Сортировка по возрастанию
         * @param {string} [ordering] Поле для сортировки
         * @param {boolean} [isDeleted] Удалённые записи
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCityDistricts: async (cityIds?: Array<number>, executorId?: string, searchQuery?: string, takeCount?: number, skipCount?: number, ascending?: boolean, ordering?: string, isDeleted?: boolean, apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/city-districts/get-city-districts`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (cityIds) {
                localVarQueryParameter['CityIds'] = cityIds;
            }

            if (executorId !== undefined) {
                localVarQueryParameter['ExecutorId'] = executorId;
            }

            if (searchQuery !== undefined) {
                localVarQueryParameter['SearchQuery'] = searchQuery;
            }

            if (takeCount !== undefined) {
                localVarQueryParameter['TakeCount'] = takeCount;
            }

            if (skipCount !== undefined) {
                localVarQueryParameter['SkipCount'] = skipCount;
            }

            if (ascending !== undefined) {
                localVarQueryParameter['Ascending'] = ascending;
            }

            if (ordering !== undefined) {
                localVarQueryParameter['Ordering'] = ordering;
            }

            if (isDeleted !== undefined) {
                localVarQueryParameter['IsDeleted'] = isDeleted;
            }


    
            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CityDistrictApi - functional programming interface
 * @export
 */
export const CityDistrictApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CityDistrictApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Получить данные района города по ID
         * @param {number} id 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCityDistrictById(id: number, apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CityDistrictResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCityDistrictById(id, apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CityDistrictApi.getCityDistrictById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Получить данные районов
         * @param {Array<number>} [cityIds] Идентификаторы городов
         * @param {string} [executorId] Идентификатор исполнителя
         * @param {string} [searchQuery] Строка для поиска
         * @param {number} [takeCount] Размер страницы
         * @param {number} [skipCount] Кол-во пропущенных записей
         * @param {boolean} [ascending] Сортировка по возрастанию
         * @param {string} [ordering] Поле для сортировки
         * @param {boolean} [isDeleted] Удалённые записи
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCityDistricts(cityIds?: Array<number>, executorId?: string, searchQuery?: string, takeCount?: number, skipCount?: number, ascending?: boolean, ordering?: string, isDeleted?: boolean, apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetCityDistrictsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCityDistricts(cityIds, executorId, searchQuery, takeCount, skipCount, ascending, ordering, isDeleted, apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CityDistrictApi.getCityDistricts']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * CityDistrictApi - factory interface
 * @export
 */
export const CityDistrictApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CityDistrictApiFp(configuration)
    return {
        /**
         * 
         * @summary Получить данные района города по ID
         * @param {CityDistrictApiGetCityDistrictByIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCityDistrictById(requestParameters: CityDistrictApiGetCityDistrictByIdRequest, options?: RawAxiosRequestConfig): AxiosPromise<CityDistrictResponse> {
            return localVarFp.getCityDistrictById(requestParameters.id, requestParameters.apiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Получить данные районов
         * @param {CityDistrictApiGetCityDistrictsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCityDistricts(requestParameters: CityDistrictApiGetCityDistrictsRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<GetCityDistrictsResponse> {
            return localVarFp.getCityDistricts(requestParameters.cityIds, requestParameters.executorId, requestParameters.searchQuery, requestParameters.takeCount, requestParameters.skipCount, requestParameters.ascending, requestParameters.ordering, requestParameters.isDeleted, requestParameters.apiVersion, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for getCityDistrictById operation in CityDistrictApi.
 * @export
 * @interface CityDistrictApiGetCityDistrictByIdRequest
 */
export interface CityDistrictApiGetCityDistrictByIdRequest {
    /**
     * 
     * @type {number}
     * @memberof CityDistrictApiGetCityDistrictById
     */
    readonly id: number

    /**
     * 
     * @type {string}
     * @memberof CityDistrictApiGetCityDistrictById
     */
    readonly apiVersion?: string
}

/**
 * Request parameters for getCityDistricts operation in CityDistrictApi.
 * @export
 * @interface CityDistrictApiGetCityDistrictsRequest
 */
export interface CityDistrictApiGetCityDistrictsRequest {
    /**
     * Идентификаторы городов
     * @type {Array<number>}
     * @memberof CityDistrictApiGetCityDistricts
     */
    readonly cityIds?: Array<number>

    /**
     * Идентификатор исполнителя
     * @type {string}
     * @memberof CityDistrictApiGetCityDistricts
     */
    readonly executorId?: string

    /**
     * Строка для поиска
     * @type {string}
     * @memberof CityDistrictApiGetCityDistricts
     */
    readonly searchQuery?: string

    /**
     * Размер страницы
     * @type {number}
     * @memberof CityDistrictApiGetCityDistricts
     */
    readonly takeCount?: number

    /**
     * Кол-во пропущенных записей
     * @type {number}
     * @memberof CityDistrictApiGetCityDistricts
     */
    readonly skipCount?: number

    /**
     * Сортировка по возрастанию
     * @type {boolean}
     * @memberof CityDistrictApiGetCityDistricts
     */
    readonly ascending?: boolean

    /**
     * Поле для сортировки
     * @type {string}
     * @memberof CityDistrictApiGetCityDistricts
     */
    readonly ordering?: string

    /**
     * Удалённые записи
     * @type {boolean}
     * @memberof CityDistrictApiGetCityDistricts
     */
    readonly isDeleted?: boolean

    /**
     * 
     * @type {string}
     * @memberof CityDistrictApiGetCityDistricts
     */
    readonly apiVersion?: string
}

/**
 * CityDistrictApi - object-oriented interface
 * @export
 * @class CityDistrictApi
 * @extends {BaseAPI}
 */
export class CityDistrictApi extends BaseAPI {
    /**
     * 
     * @summary Получить данные района города по ID
     * @param {CityDistrictApiGetCityDistrictByIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CityDistrictApi
     */
    public getCityDistrictById(requestParameters: CityDistrictApiGetCityDistrictByIdRequest, options?: RawAxiosRequestConfig) {
        return CityDistrictApiFp(this.configuration).getCityDistrictById(requestParameters.id, requestParameters.apiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Получить данные районов
     * @param {CityDistrictApiGetCityDistrictsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CityDistrictApi
     */
    public getCityDistricts(requestParameters: CityDistrictApiGetCityDistrictsRequest = {}, options?: RawAxiosRequestConfig) {
        return CityDistrictApiFp(this.configuration).getCityDistricts(requestParameters.cityIds, requestParameters.executorId, requestParameters.searchQuery, requestParameters.takeCount, requestParameters.skipCount, requestParameters.ascending, requestParameters.ordering, requestParameters.isDeleted, requestParameters.apiVersion, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ClientApi - axios parameter creator
 * @export
 */
export const ClientApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Заблокировать профиль Клиента
         * @param {string} clientId 
         * @param {string} [apiVersion] 
         * @param {BlockRequest} [blockRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        blockClient: async (clientId: string, apiVersion?: string, blockRequest?: BlockRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'clientId' is not null or undefined
            assertParamExists('blockClient', 'clientId', clientId)
            const localVarPath = `/api/v1/clients/block/{clientId}`
                .replace(`{${"clientId"}}`, encodeURIComponent(String(clientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(blockRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Создать нового клиента
         * @param {string} [apiVersion] 
         * @param {CreateClientRequest} [createClientRequest] Модель запроса с данными клиента
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createClient: async (apiVersion?: string, createClientRequest?: CreateClientRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/clients/create-client`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createClientRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Создать нового клиента с нуля из админки
         * @param {string} [apiVersion] 
         * @param {CreateClientByAdminRequest} [createClientByAdminRequest] Модель запроса с данными клиента
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createClientByAdmin: async (apiVersion?: string, createClientByAdminRequest?: CreateClientByAdminRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/clients/create-client-by-admin`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createClientByAdminRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Удалить профиль Клиента
         * @param {string} clientId Идентификатор клиента
         * @param {string} [apiVersion] 
         * @param {DeleteRequest} [deleteRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteClient: async (clientId: string, apiVersion?: string, deleteRequest?: DeleteRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'clientId' is not null or undefined
            assertParamExists('deleteClient', 'clientId', clientId)
            const localVarPath = `/api/v1/clients/{clientId}`
                .replace(`{${"clientId"}}`, encodeURIComponent(String(clientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(deleteRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Получить данные клиента по AppUserId
         * @param {string} appUserId Идентификатор пользователя приложения
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getClientByAppUserId: async (appUserId: string, apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'appUserId' is not null or undefined
            assertParamExists('getClientByAppUserId', 'appUserId', appUserId)
            const localVarPath = `/api/v1/clients/byAppUserId/{appUserId}`
                .replace(`{${"appUserId"}}`, encodeURIComponent(String(appUserId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Получить данные клиента
         * @param {string} clientId Идентификатор клиента
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getClientById: async (clientId: string, apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'clientId' is not null or undefined
            assertParamExists('getClientById', 'clientId', clientId)
            const localVarPath = `/api/v1/clients/{clientId}`
                .replace(`{${"clientId"}}`, encodeURIComponent(String(clientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Получить данные Клиентов
         * @param {string} [createdFrom] Дата регистрации: начало периода
         * @param {string} [createdTo] Дата регистрации: конец периода
         * @param {string} [firstNameSearch] Поиск по Имени
         * @param {string} [phoneSearch] Поиск по номеру телефона
         * @param {string} [streetSearch] Поиск по улице действующих адресов клиента
         * @param {string} [petNameSearch] Поиск по кличке действующего питомца клиента
         * @param {number} [cityId] Идентификатор города
         * @param {string} [searchQuery] Строка для поиска
         * @param {number} [takeCount] Размер страницы
         * @param {number} [skipCount] Кол-во пропущенных записей
         * @param {boolean} [ascending] Сортировка по возрастанию
         * @param {string} [ordering] Поле для сортировки
         * @param {boolean} [isDeleted] Удалённые записи
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getClients: async (createdFrom?: string, createdTo?: string, firstNameSearch?: string, phoneSearch?: string, streetSearch?: string, petNameSearch?: string, cityId?: number, searchQuery?: string, takeCount?: number, skipCount?: number, ascending?: boolean, ordering?: string, isDeleted?: boolean, apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/clients/get-clients`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (createdFrom !== undefined) {
                localVarQueryParameter['CreatedFrom'] = (createdFrom as any instanceof Date) ?
                    (createdFrom as any).toISOString() :
                    createdFrom;
            }

            if (createdTo !== undefined) {
                localVarQueryParameter['CreatedTo'] = (createdTo as any instanceof Date) ?
                    (createdTo as any).toISOString() :
                    createdTo;
            }

            if (firstNameSearch !== undefined) {
                localVarQueryParameter['FirstNameSearch'] = firstNameSearch;
            }

            if (phoneSearch !== undefined) {
                localVarQueryParameter['PhoneSearch'] = phoneSearch;
            }

            if (streetSearch !== undefined) {
                localVarQueryParameter['StreetSearch'] = streetSearch;
            }

            if (petNameSearch !== undefined) {
                localVarQueryParameter['PetNameSearch'] = petNameSearch;
            }

            if (cityId !== undefined) {
                localVarQueryParameter['CityId'] = cityId;
            }

            if (searchQuery !== undefined) {
                localVarQueryParameter['SearchQuery'] = searchQuery;
            }

            if (takeCount !== undefined) {
                localVarQueryParameter['TakeCount'] = takeCount;
            }

            if (skipCount !== undefined) {
                localVarQueryParameter['SkipCount'] = skipCount;
            }

            if (ascending !== undefined) {
                localVarQueryParameter['Ascending'] = ascending;
            }

            if (ordering !== undefined) {
                localVarQueryParameter['Ordering'] = ordering;
            }

            if (isDeleted !== undefined) {
                localVarQueryParameter['IsDeleted'] = isDeleted;
            }


    
            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Установить Email адрес в профиле клиента
         * @param {string} [apiVersion] 
         * @param {SetClientEmailRequest} [setClientEmailRequest] Модель запроса
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setClientEmail: async (apiVersion?: string, setClientEmailRequest?: SetClientEmailRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/clients/set-client-email`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(setClientEmailRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Обновить фотографию профиля клиента
         * @param {string} [apiVersion] 
         * @param {SetClientPhotoRequest} [setClientPhotoRequest] Модель запроса
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setClientPhoto: async (apiVersion?: string, setClientPhotoRequest?: SetClientPhotoRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/clients/set-client-photo`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(setClientPhotoRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Перенести профиль клиента на другой телефон
         * @param {string} profileId 
         * @param {string} [apiVersion] 
         * @param {TransferProfilePhoneRequest} [transferProfilePhoneRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        transferClientPhone: async (profileId: string, apiVersion?: string, transferProfilePhoneRequest?: TransferProfilePhoneRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'profileId' is not null or undefined
            assertParamExists('transferClientPhone', 'profileId', profileId)
            const localVarPath = `/api/v1/clients/{profileId}/transfer-phone`
                .replace(`{${"profileId"}}`, encodeURIComponent(String(profileId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(transferProfilePhoneRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Разблокировать профиль Клиента
         * @param {string} clientId 
         * @param {string} [apiVersion] 
         * @param {UnblockRequest} [unblockRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unblockClient: async (clientId: string, apiVersion?: string, unblockRequest?: UnblockRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'clientId' is not null or undefined
            assertParamExists('unblockClient', 'clientId', clientId)
            const localVarPath = `/api/v1/clients/unblock/{clientId}`
                .replace(`{${"clientId"}}`, encodeURIComponent(String(clientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(unblockRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Обновить данные клиента
         * @param {string} clientId Идентификатор клиента
         * @param {string} [apiVersion] 
         * @param {UpdateClientRequest} [updateClientRequest] Модель запроса с данными клиента для обновления
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateClient: async (clientId: string, apiVersion?: string, updateClientRequest?: UpdateClientRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'clientId' is not null or undefined
            assertParamExists('updateClient', 'clientId', clientId)
            const localVarPath = `/api/v1/clients/update-client/{clientId}`
                .replace(`{${"clientId"}}`, encodeURIComponent(String(clientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateClientRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ClientApi - functional programming interface
 * @export
 */
export const ClientApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ClientApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Заблокировать профиль Клиента
         * @param {string} clientId 
         * @param {string} [apiVersion] 
         * @param {BlockRequest} [blockRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async blockClient(clientId: string, apiVersion?: string, blockRequest?: BlockRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.blockClient(clientId, apiVersion, blockRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClientApi.blockClient']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Создать нового клиента
         * @param {string} [apiVersion] 
         * @param {CreateClientRequest} [createClientRequest] Модель запроса с данными клиента
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createClient(apiVersion?: string, createClientRequest?: CreateClientRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ClientResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createClient(apiVersion, createClientRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClientApi.createClient']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Создать нового клиента с нуля из админки
         * @param {string} [apiVersion] 
         * @param {CreateClientByAdminRequest} [createClientByAdminRequest] Модель запроса с данными клиента
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createClientByAdmin(apiVersion?: string, createClientByAdminRequest?: CreateClientByAdminRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ClientResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createClientByAdmin(apiVersion, createClientByAdminRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClientApi.createClientByAdmin']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Удалить профиль Клиента
         * @param {string} clientId Идентификатор клиента
         * @param {string} [apiVersion] 
         * @param {DeleteRequest} [deleteRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteClient(clientId: string, apiVersion?: string, deleteRequest?: DeleteRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteClient(clientId, apiVersion, deleteRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClientApi.deleteClient']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Получить данные клиента по AppUserId
         * @param {string} appUserId Идентификатор пользователя приложения
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getClientByAppUserId(appUserId: string, apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ClientResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getClientByAppUserId(appUserId, apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClientApi.getClientByAppUserId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Получить данные клиента
         * @param {string} clientId Идентификатор клиента
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getClientById(clientId: string, apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ClientResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getClientById(clientId, apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClientApi.getClientById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Получить данные Клиентов
         * @param {string} [createdFrom] Дата регистрации: начало периода
         * @param {string} [createdTo] Дата регистрации: конец периода
         * @param {string} [firstNameSearch] Поиск по Имени
         * @param {string} [phoneSearch] Поиск по номеру телефона
         * @param {string} [streetSearch] Поиск по улице действующих адресов клиента
         * @param {string} [petNameSearch] Поиск по кличке действующего питомца клиента
         * @param {number} [cityId] Идентификатор города
         * @param {string} [searchQuery] Строка для поиска
         * @param {number} [takeCount] Размер страницы
         * @param {number} [skipCount] Кол-во пропущенных записей
         * @param {boolean} [ascending] Сортировка по возрастанию
         * @param {string} [ordering] Поле для сортировки
         * @param {boolean} [isDeleted] Удалённые записи
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getClients(createdFrom?: string, createdTo?: string, firstNameSearch?: string, phoneSearch?: string, streetSearch?: string, petNameSearch?: string, cityId?: number, searchQuery?: string, takeCount?: number, skipCount?: number, ascending?: boolean, ordering?: string, isDeleted?: boolean, apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetClientsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getClients(createdFrom, createdTo, firstNameSearch, phoneSearch, streetSearch, petNameSearch, cityId, searchQuery, takeCount, skipCount, ascending, ordering, isDeleted, apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClientApi.getClients']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Установить Email адрес в профиле клиента
         * @param {string} [apiVersion] 
         * @param {SetClientEmailRequest} [setClientEmailRequest] Модель запроса
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setClientEmail(apiVersion?: string, setClientEmailRequest?: SetClientEmailRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.setClientEmail(apiVersion, setClientEmailRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClientApi.setClientEmail']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Обновить фотографию профиля клиента
         * @param {string} [apiVersion] 
         * @param {SetClientPhotoRequest} [setClientPhotoRequest] Модель запроса
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setClientPhoto(apiVersion?: string, setClientPhotoRequest?: SetClientPhotoRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.setClientPhoto(apiVersion, setClientPhotoRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClientApi.setClientPhoto']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Перенести профиль клиента на другой телефон
         * @param {string} profileId 
         * @param {string} [apiVersion] 
         * @param {TransferProfilePhoneRequest} [transferProfilePhoneRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async transferClientPhone(profileId: string, apiVersion?: string, transferProfilePhoneRequest?: TransferProfilePhoneRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.transferClientPhone(profileId, apiVersion, transferProfilePhoneRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClientApi.transferClientPhone']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Разблокировать профиль Клиента
         * @param {string} clientId 
         * @param {string} [apiVersion] 
         * @param {UnblockRequest} [unblockRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async unblockClient(clientId: string, apiVersion?: string, unblockRequest?: UnblockRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.unblockClient(clientId, apiVersion, unblockRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClientApi.unblockClient']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Обновить данные клиента
         * @param {string} clientId Идентификатор клиента
         * @param {string} [apiVersion] 
         * @param {UpdateClientRequest} [updateClientRequest] Модель запроса с данными клиента для обновления
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateClient(clientId: string, apiVersion?: string, updateClientRequest?: UpdateClientRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ClientResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateClient(clientId, apiVersion, updateClientRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClientApi.updateClient']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ClientApi - factory interface
 * @export
 */
export const ClientApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ClientApiFp(configuration)
    return {
        /**
         * 
         * @summary Заблокировать профиль Клиента
         * @param {ClientApiBlockClientRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        blockClient(requestParameters: ClientApiBlockClientRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.blockClient(requestParameters.clientId, requestParameters.apiVersion, requestParameters.blockRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Создать нового клиента
         * @param {ClientApiCreateClientRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createClient(requestParameters: ClientApiCreateClientRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<ClientResponse> {
            return localVarFp.createClient(requestParameters.apiVersion, requestParameters.createClientRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Создать нового клиента с нуля из админки
         * @param {ClientApiCreateClientByAdminRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createClientByAdmin(requestParameters: ClientApiCreateClientByAdminRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<ClientResponse> {
            return localVarFp.createClientByAdmin(requestParameters.apiVersion, requestParameters.createClientByAdminRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Удалить профиль Клиента
         * @param {ClientApiDeleteClientRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteClient(requestParameters: ClientApiDeleteClientRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteClient(requestParameters.clientId, requestParameters.apiVersion, requestParameters.deleteRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Получить данные клиента по AppUserId
         * @param {ClientApiGetClientByAppUserIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getClientByAppUserId(requestParameters: ClientApiGetClientByAppUserIdRequest, options?: RawAxiosRequestConfig): AxiosPromise<ClientResponse> {
            return localVarFp.getClientByAppUserId(requestParameters.appUserId, requestParameters.apiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Получить данные клиента
         * @param {ClientApiGetClientByIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getClientById(requestParameters: ClientApiGetClientByIdRequest, options?: RawAxiosRequestConfig): AxiosPromise<ClientResponse> {
            return localVarFp.getClientById(requestParameters.clientId, requestParameters.apiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Получить данные Клиентов
         * @param {ClientApiGetClientsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getClients(requestParameters: ClientApiGetClientsRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<GetClientsResponse> {
            return localVarFp.getClients(requestParameters.createdFrom, requestParameters.createdTo, requestParameters.firstNameSearch, requestParameters.phoneSearch, requestParameters.streetSearch, requestParameters.petNameSearch, requestParameters.cityId, requestParameters.searchQuery, requestParameters.takeCount, requestParameters.skipCount, requestParameters.ascending, requestParameters.ordering, requestParameters.isDeleted, requestParameters.apiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Установить Email адрес в профиле клиента
         * @param {ClientApiSetClientEmailRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setClientEmail(requestParameters: ClientApiSetClientEmailRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.setClientEmail(requestParameters.apiVersion, requestParameters.setClientEmailRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Обновить фотографию профиля клиента
         * @param {ClientApiSetClientPhotoRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setClientPhoto(requestParameters: ClientApiSetClientPhotoRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.setClientPhoto(requestParameters.apiVersion, requestParameters.setClientPhotoRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Перенести профиль клиента на другой телефон
         * @param {ClientApiTransferClientPhoneRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        transferClientPhone(requestParameters: ClientApiTransferClientPhoneRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.transferClientPhone(requestParameters.profileId, requestParameters.apiVersion, requestParameters.transferProfilePhoneRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Разблокировать профиль Клиента
         * @param {ClientApiUnblockClientRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unblockClient(requestParameters: ClientApiUnblockClientRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.unblockClient(requestParameters.clientId, requestParameters.apiVersion, requestParameters.unblockRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Обновить данные клиента
         * @param {ClientApiUpdateClientRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateClient(requestParameters: ClientApiUpdateClientRequest, options?: RawAxiosRequestConfig): AxiosPromise<ClientResponse> {
            return localVarFp.updateClient(requestParameters.clientId, requestParameters.apiVersion, requestParameters.updateClientRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for blockClient operation in ClientApi.
 * @export
 * @interface ClientApiBlockClientRequest
 */
export interface ClientApiBlockClientRequest {
    /**
     * 
     * @type {string}
     * @memberof ClientApiBlockClient
     */
    readonly clientId: string

    /**
     * 
     * @type {string}
     * @memberof ClientApiBlockClient
     */
    readonly apiVersion?: string

    /**
     * 
     * @type {BlockRequest}
     * @memberof ClientApiBlockClient
     */
    readonly blockRequest?: BlockRequest
}

/**
 * Request parameters for createClient operation in ClientApi.
 * @export
 * @interface ClientApiCreateClientRequest
 */
export interface ClientApiCreateClientRequest {
    /**
     * 
     * @type {string}
     * @memberof ClientApiCreateClient
     */
    readonly apiVersion?: string

    /**
     * Модель запроса с данными клиента
     * @type {CreateClientRequest}
     * @memberof ClientApiCreateClient
     */
    readonly createClientRequest?: CreateClientRequest
}

/**
 * Request parameters for createClientByAdmin operation in ClientApi.
 * @export
 * @interface ClientApiCreateClientByAdminRequest
 */
export interface ClientApiCreateClientByAdminRequest {
    /**
     * 
     * @type {string}
     * @memberof ClientApiCreateClientByAdmin
     */
    readonly apiVersion?: string

    /**
     * Модель запроса с данными клиента
     * @type {CreateClientByAdminRequest}
     * @memberof ClientApiCreateClientByAdmin
     */
    readonly createClientByAdminRequest?: CreateClientByAdminRequest
}

/**
 * Request parameters for deleteClient operation in ClientApi.
 * @export
 * @interface ClientApiDeleteClientRequest
 */
export interface ClientApiDeleteClientRequest {
    /**
     * Идентификатор клиента
     * @type {string}
     * @memberof ClientApiDeleteClient
     */
    readonly clientId: string

    /**
     * 
     * @type {string}
     * @memberof ClientApiDeleteClient
     */
    readonly apiVersion?: string

    /**
     * 
     * @type {DeleteRequest}
     * @memberof ClientApiDeleteClient
     */
    readonly deleteRequest?: DeleteRequest
}

/**
 * Request parameters for getClientByAppUserId operation in ClientApi.
 * @export
 * @interface ClientApiGetClientByAppUserIdRequest
 */
export interface ClientApiGetClientByAppUserIdRequest {
    /**
     * Идентификатор пользователя приложения
     * @type {string}
     * @memberof ClientApiGetClientByAppUserId
     */
    readonly appUserId: string

    /**
     * 
     * @type {string}
     * @memberof ClientApiGetClientByAppUserId
     */
    readonly apiVersion?: string
}

/**
 * Request parameters for getClientById operation in ClientApi.
 * @export
 * @interface ClientApiGetClientByIdRequest
 */
export interface ClientApiGetClientByIdRequest {
    /**
     * Идентификатор клиента
     * @type {string}
     * @memberof ClientApiGetClientById
     */
    readonly clientId: string

    /**
     * 
     * @type {string}
     * @memberof ClientApiGetClientById
     */
    readonly apiVersion?: string
}

/**
 * Request parameters for getClients operation in ClientApi.
 * @export
 * @interface ClientApiGetClientsRequest
 */
export interface ClientApiGetClientsRequest {
    /**
     * Дата регистрации: начало периода
     * @type {string}
     * @memberof ClientApiGetClients
     */
    readonly createdFrom?: string

    /**
     * Дата регистрации: конец периода
     * @type {string}
     * @memberof ClientApiGetClients
     */
    readonly createdTo?: string

    /**
     * Поиск по Имени
     * @type {string}
     * @memberof ClientApiGetClients
     */
    readonly firstNameSearch?: string

    /**
     * Поиск по номеру телефона
     * @type {string}
     * @memberof ClientApiGetClients
     */
    readonly phoneSearch?: string

    /**
     * Поиск по улице действующих адресов клиента
     * @type {string}
     * @memberof ClientApiGetClients
     */
    readonly streetSearch?: string

    /**
     * Поиск по кличке действующего питомца клиента
     * @type {string}
     * @memberof ClientApiGetClients
     */
    readonly petNameSearch?: string

    /**
     * Идентификатор города
     * @type {number}
     * @memberof ClientApiGetClients
     */
    readonly cityId?: number

    /**
     * Строка для поиска
     * @type {string}
     * @memberof ClientApiGetClients
     */
    readonly searchQuery?: string

    /**
     * Размер страницы
     * @type {number}
     * @memberof ClientApiGetClients
     */
    readonly takeCount?: number

    /**
     * Кол-во пропущенных записей
     * @type {number}
     * @memberof ClientApiGetClients
     */
    readonly skipCount?: number

    /**
     * Сортировка по возрастанию
     * @type {boolean}
     * @memberof ClientApiGetClients
     */
    readonly ascending?: boolean

    /**
     * Поле для сортировки
     * @type {string}
     * @memberof ClientApiGetClients
     */
    readonly ordering?: string

    /**
     * Удалённые записи
     * @type {boolean}
     * @memberof ClientApiGetClients
     */
    readonly isDeleted?: boolean

    /**
     * 
     * @type {string}
     * @memberof ClientApiGetClients
     */
    readonly apiVersion?: string
}

/**
 * Request parameters for setClientEmail operation in ClientApi.
 * @export
 * @interface ClientApiSetClientEmailRequest
 */
export interface ClientApiSetClientEmailRequest {
    /**
     * 
     * @type {string}
     * @memberof ClientApiSetClientEmail
     */
    readonly apiVersion?: string

    /**
     * Модель запроса
     * @type {SetClientEmailRequest}
     * @memberof ClientApiSetClientEmail
     */
    readonly setClientEmailRequest?: SetClientEmailRequest
}

/**
 * Request parameters for setClientPhoto operation in ClientApi.
 * @export
 * @interface ClientApiSetClientPhotoRequest
 */
export interface ClientApiSetClientPhotoRequest {
    /**
     * 
     * @type {string}
     * @memberof ClientApiSetClientPhoto
     */
    readonly apiVersion?: string

    /**
     * Модель запроса
     * @type {SetClientPhotoRequest}
     * @memberof ClientApiSetClientPhoto
     */
    readonly setClientPhotoRequest?: SetClientPhotoRequest
}

/**
 * Request parameters for transferClientPhone operation in ClientApi.
 * @export
 * @interface ClientApiTransferClientPhoneRequest
 */
export interface ClientApiTransferClientPhoneRequest {
    /**
     * 
     * @type {string}
     * @memberof ClientApiTransferClientPhone
     */
    readonly profileId: string

    /**
     * 
     * @type {string}
     * @memberof ClientApiTransferClientPhone
     */
    readonly apiVersion?: string

    /**
     * 
     * @type {TransferProfilePhoneRequest}
     * @memberof ClientApiTransferClientPhone
     */
    readonly transferProfilePhoneRequest?: TransferProfilePhoneRequest
}

/**
 * Request parameters for unblockClient operation in ClientApi.
 * @export
 * @interface ClientApiUnblockClientRequest
 */
export interface ClientApiUnblockClientRequest {
    /**
     * 
     * @type {string}
     * @memberof ClientApiUnblockClient
     */
    readonly clientId: string

    /**
     * 
     * @type {string}
     * @memberof ClientApiUnblockClient
     */
    readonly apiVersion?: string

    /**
     * 
     * @type {UnblockRequest}
     * @memberof ClientApiUnblockClient
     */
    readonly unblockRequest?: UnblockRequest
}

/**
 * Request parameters for updateClient operation in ClientApi.
 * @export
 * @interface ClientApiUpdateClientRequest
 */
export interface ClientApiUpdateClientRequest {
    /**
     * Идентификатор клиента
     * @type {string}
     * @memberof ClientApiUpdateClient
     */
    readonly clientId: string

    /**
     * 
     * @type {string}
     * @memberof ClientApiUpdateClient
     */
    readonly apiVersion?: string

    /**
     * Модель запроса с данными клиента для обновления
     * @type {UpdateClientRequest}
     * @memberof ClientApiUpdateClient
     */
    readonly updateClientRequest?: UpdateClientRequest
}

/**
 * ClientApi - object-oriented interface
 * @export
 * @class ClientApi
 * @extends {BaseAPI}
 */
export class ClientApi extends BaseAPI {
    /**
     * 
     * @summary Заблокировать профиль Клиента
     * @param {ClientApiBlockClientRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientApi
     */
    public blockClient(requestParameters: ClientApiBlockClientRequest, options?: RawAxiosRequestConfig) {
        return ClientApiFp(this.configuration).blockClient(requestParameters.clientId, requestParameters.apiVersion, requestParameters.blockRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Создать нового клиента
     * @param {ClientApiCreateClientRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientApi
     */
    public createClient(requestParameters: ClientApiCreateClientRequest = {}, options?: RawAxiosRequestConfig) {
        return ClientApiFp(this.configuration).createClient(requestParameters.apiVersion, requestParameters.createClientRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Создать нового клиента с нуля из админки
     * @param {ClientApiCreateClientByAdminRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientApi
     */
    public createClientByAdmin(requestParameters: ClientApiCreateClientByAdminRequest = {}, options?: RawAxiosRequestConfig) {
        return ClientApiFp(this.configuration).createClientByAdmin(requestParameters.apiVersion, requestParameters.createClientByAdminRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Удалить профиль Клиента
     * @param {ClientApiDeleteClientRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientApi
     */
    public deleteClient(requestParameters: ClientApiDeleteClientRequest, options?: RawAxiosRequestConfig) {
        return ClientApiFp(this.configuration).deleteClient(requestParameters.clientId, requestParameters.apiVersion, requestParameters.deleteRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Получить данные клиента по AppUserId
     * @param {ClientApiGetClientByAppUserIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientApi
     */
    public getClientByAppUserId(requestParameters: ClientApiGetClientByAppUserIdRequest, options?: RawAxiosRequestConfig) {
        return ClientApiFp(this.configuration).getClientByAppUserId(requestParameters.appUserId, requestParameters.apiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Получить данные клиента
     * @param {ClientApiGetClientByIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientApi
     */
    public getClientById(requestParameters: ClientApiGetClientByIdRequest, options?: RawAxiosRequestConfig) {
        return ClientApiFp(this.configuration).getClientById(requestParameters.clientId, requestParameters.apiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Получить данные Клиентов
     * @param {ClientApiGetClientsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientApi
     */
    public getClients(requestParameters: ClientApiGetClientsRequest = {}, options?: RawAxiosRequestConfig) {
        return ClientApiFp(this.configuration).getClients(requestParameters.createdFrom, requestParameters.createdTo, requestParameters.firstNameSearch, requestParameters.phoneSearch, requestParameters.streetSearch, requestParameters.petNameSearch, requestParameters.cityId, requestParameters.searchQuery, requestParameters.takeCount, requestParameters.skipCount, requestParameters.ascending, requestParameters.ordering, requestParameters.isDeleted, requestParameters.apiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Установить Email адрес в профиле клиента
     * @param {ClientApiSetClientEmailRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientApi
     */
    public setClientEmail(requestParameters: ClientApiSetClientEmailRequest = {}, options?: RawAxiosRequestConfig) {
        return ClientApiFp(this.configuration).setClientEmail(requestParameters.apiVersion, requestParameters.setClientEmailRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Обновить фотографию профиля клиента
     * @param {ClientApiSetClientPhotoRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientApi
     */
    public setClientPhoto(requestParameters: ClientApiSetClientPhotoRequest = {}, options?: RawAxiosRequestConfig) {
        return ClientApiFp(this.configuration).setClientPhoto(requestParameters.apiVersion, requestParameters.setClientPhotoRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Перенести профиль клиента на другой телефон
     * @param {ClientApiTransferClientPhoneRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientApi
     */
    public transferClientPhone(requestParameters: ClientApiTransferClientPhoneRequest, options?: RawAxiosRequestConfig) {
        return ClientApiFp(this.configuration).transferClientPhone(requestParameters.profileId, requestParameters.apiVersion, requestParameters.transferProfilePhoneRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Разблокировать профиль Клиента
     * @param {ClientApiUnblockClientRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientApi
     */
    public unblockClient(requestParameters: ClientApiUnblockClientRequest, options?: RawAxiosRequestConfig) {
        return ClientApiFp(this.configuration).unblockClient(requestParameters.clientId, requestParameters.apiVersion, requestParameters.unblockRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Обновить данные клиента
     * @param {ClientApiUpdateClientRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientApi
     */
    public updateClient(requestParameters: ClientApiUpdateClientRequest, options?: RawAxiosRequestConfig) {
        return ClientApiFp(this.configuration).updateClient(requestParameters.clientId, requestParameters.apiVersion, requestParameters.updateClientRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ClientAddressApi - axios parameter creator
 * @export
 */
export const ClientAddressApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Добавить адрес клиента
         * @param {string} [apiVersion] 
         * @param {CreateClientAddressRequest} [createClientAddressRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createClientAddress: async (apiVersion?: string, createClientAddressRequest?: CreateClientAddressRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/client-addresses/create`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createClientAddressRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Удалить адрес клиента
         * @param {string} id 
         * @param {string} [apiVersion] 
         * @param {DeleteRequest} [deleteRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteClientAddress: async (id: string, apiVersion?: string, deleteRequest?: DeleteRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteClientAddress', 'id', id)
            const localVarPath = `/api/v1/client-addresses/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(deleteRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Получить адреса клиента
         * @param {string} clientId 
         * @param {string} [cityNameSearch] Поиск по названию города
         * @param {string} [streetSearch] Поиск по улице
         * @param {string} [houseNumberSearch] Поиск по номеру дома
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllClientAddresses: async (clientId: string, cityNameSearch?: string, streetSearch?: string, houseNumberSearch?: string, apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'clientId' is not null or undefined
            assertParamExists('getAllClientAddresses', 'clientId', clientId)
            const localVarPath = `/api/v1/client-addresses/{clientId}/get-all`
                .replace(`{${"clientId"}}`, encodeURIComponent(String(clientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (cityNameSearch !== undefined) {
                localVarQueryParameter['CityNameSearch'] = cityNameSearch;
            }

            if (streetSearch !== undefined) {
                localVarQueryParameter['StreetSearch'] = streetSearch;
            }

            if (houseNumberSearch !== undefined) {
                localVarQueryParameter['HouseNumberSearch'] = houseNumberSearch;
            }


    
            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Получить адрес клиента по идентификатору адреса
         * @param {string} addressId 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getClientAddressByAddressId: async (addressId: string, apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'addressId' is not null or undefined
            assertParamExists('getClientAddressByAddressId', 'addressId', addressId)
            const localVarPath = `/api/v1/client-addresses/{addressId}`
                .replace(`{${"addressId"}}`, encodeURIComponent(String(addressId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Получить адрес клиента по идентификатору записи
         * @param {string} id 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getClientAddressById: async (id: string, apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getClientAddressById', 'id', id)
            const localVarPath = `/api/v1/client-addresses/get-by-id/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Сделать адрес клиента избранным
         * @param {string} id 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setClientAddressFavorite: async (id: string, apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('setClientAddressFavorite', 'id', id)
            const localVarPath = `/api/v1/client-addresses/{id}/favorite`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Обновить адрес клиента
         * @param {string} [apiVersion] 
         * @param {UpdateClientAddressRequest} [updateClientAddressRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateClientAddress: async (apiVersion?: string, updateClientAddressRequest?: UpdateClientAddressRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/client-addresses/update`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateClientAddressRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ClientAddressApi - functional programming interface
 * @export
 */
export const ClientAddressApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ClientAddressApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Добавить адрес клиента
         * @param {string} [apiVersion] 
         * @param {CreateClientAddressRequest} [createClientAddressRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createClientAddress(apiVersion?: string, createClientAddressRequest?: CreateClientAddressRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ClientAddressResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createClientAddress(apiVersion, createClientAddressRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClientAddressApi.createClientAddress']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Удалить адрес клиента
         * @param {string} id 
         * @param {string} [apiVersion] 
         * @param {DeleteRequest} [deleteRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteClientAddress(id: string, apiVersion?: string, deleteRequest?: DeleteRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteClientAddress(id, apiVersion, deleteRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClientAddressApi.deleteClientAddress']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Получить адреса клиента
         * @param {string} clientId 
         * @param {string} [cityNameSearch] Поиск по названию города
         * @param {string} [streetSearch] Поиск по улице
         * @param {string} [houseNumberSearch] Поиск по номеру дома
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllClientAddresses(clientId: string, cityNameSearch?: string, streetSearch?: string, houseNumberSearch?: string, apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ClientAddressResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllClientAddresses(clientId, cityNameSearch, streetSearch, houseNumberSearch, apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClientAddressApi.getAllClientAddresses']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Получить адрес клиента по идентификатору адреса
         * @param {string} addressId 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getClientAddressByAddressId(addressId: string, apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ClientAddressResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getClientAddressByAddressId(addressId, apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClientAddressApi.getClientAddressByAddressId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Получить адрес клиента по идентификатору записи
         * @param {string} id 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getClientAddressById(id: string, apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ClientAddressResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getClientAddressById(id, apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClientAddressApi.getClientAddressById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Сделать адрес клиента избранным
         * @param {string} id 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setClientAddressFavorite(id: string, apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.setClientAddressFavorite(id, apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClientAddressApi.setClientAddressFavorite']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Обновить адрес клиента
         * @param {string} [apiVersion] 
         * @param {UpdateClientAddressRequest} [updateClientAddressRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateClientAddress(apiVersion?: string, updateClientAddressRequest?: UpdateClientAddressRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ClientAddressResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateClientAddress(apiVersion, updateClientAddressRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClientAddressApi.updateClientAddress']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ClientAddressApi - factory interface
 * @export
 */
export const ClientAddressApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ClientAddressApiFp(configuration)
    return {
        /**
         * 
         * @summary Добавить адрес клиента
         * @param {ClientAddressApiCreateClientAddressRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createClientAddress(requestParameters: ClientAddressApiCreateClientAddressRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<ClientAddressResponse> {
            return localVarFp.createClientAddress(requestParameters.apiVersion, requestParameters.createClientAddressRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Удалить адрес клиента
         * @param {ClientAddressApiDeleteClientAddressRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteClientAddress(requestParameters: ClientAddressApiDeleteClientAddressRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteClientAddress(requestParameters.id, requestParameters.apiVersion, requestParameters.deleteRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Получить адреса клиента
         * @param {ClientAddressApiGetAllClientAddressesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllClientAddresses(requestParameters: ClientAddressApiGetAllClientAddressesRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<ClientAddressResponse>> {
            return localVarFp.getAllClientAddresses(requestParameters.clientId, requestParameters.cityNameSearch, requestParameters.streetSearch, requestParameters.houseNumberSearch, requestParameters.apiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Получить адрес клиента по идентификатору адреса
         * @param {ClientAddressApiGetClientAddressByAddressIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getClientAddressByAddressId(requestParameters: ClientAddressApiGetClientAddressByAddressIdRequest, options?: RawAxiosRequestConfig): AxiosPromise<ClientAddressResponse> {
            return localVarFp.getClientAddressByAddressId(requestParameters.addressId, requestParameters.apiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Получить адрес клиента по идентификатору записи
         * @param {ClientAddressApiGetClientAddressByIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getClientAddressById(requestParameters: ClientAddressApiGetClientAddressByIdRequest, options?: RawAxiosRequestConfig): AxiosPromise<ClientAddressResponse> {
            return localVarFp.getClientAddressById(requestParameters.id, requestParameters.apiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Сделать адрес клиента избранным
         * @param {ClientAddressApiSetClientAddressFavoriteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setClientAddressFavorite(requestParameters: ClientAddressApiSetClientAddressFavoriteRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.setClientAddressFavorite(requestParameters.id, requestParameters.apiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Обновить адрес клиента
         * @param {ClientAddressApiUpdateClientAddressRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateClientAddress(requestParameters: ClientAddressApiUpdateClientAddressRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<ClientAddressResponse> {
            return localVarFp.updateClientAddress(requestParameters.apiVersion, requestParameters.updateClientAddressRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for createClientAddress operation in ClientAddressApi.
 * @export
 * @interface ClientAddressApiCreateClientAddressRequest
 */
export interface ClientAddressApiCreateClientAddressRequest {
    /**
     * 
     * @type {string}
     * @memberof ClientAddressApiCreateClientAddress
     */
    readonly apiVersion?: string

    /**
     * 
     * @type {CreateClientAddressRequest}
     * @memberof ClientAddressApiCreateClientAddress
     */
    readonly createClientAddressRequest?: CreateClientAddressRequest
}

/**
 * Request parameters for deleteClientAddress operation in ClientAddressApi.
 * @export
 * @interface ClientAddressApiDeleteClientAddressRequest
 */
export interface ClientAddressApiDeleteClientAddressRequest {
    /**
     * 
     * @type {string}
     * @memberof ClientAddressApiDeleteClientAddress
     */
    readonly id: string

    /**
     * 
     * @type {string}
     * @memberof ClientAddressApiDeleteClientAddress
     */
    readonly apiVersion?: string

    /**
     * 
     * @type {DeleteRequest}
     * @memberof ClientAddressApiDeleteClientAddress
     */
    readonly deleteRequest?: DeleteRequest
}

/**
 * Request parameters for getAllClientAddresses operation in ClientAddressApi.
 * @export
 * @interface ClientAddressApiGetAllClientAddressesRequest
 */
export interface ClientAddressApiGetAllClientAddressesRequest {
    /**
     * 
     * @type {string}
     * @memberof ClientAddressApiGetAllClientAddresses
     */
    readonly clientId: string

    /**
     * Поиск по названию города
     * @type {string}
     * @memberof ClientAddressApiGetAllClientAddresses
     */
    readonly cityNameSearch?: string

    /**
     * Поиск по улице
     * @type {string}
     * @memberof ClientAddressApiGetAllClientAddresses
     */
    readonly streetSearch?: string

    /**
     * Поиск по номеру дома
     * @type {string}
     * @memberof ClientAddressApiGetAllClientAddresses
     */
    readonly houseNumberSearch?: string

    /**
     * 
     * @type {string}
     * @memberof ClientAddressApiGetAllClientAddresses
     */
    readonly apiVersion?: string
}

/**
 * Request parameters for getClientAddressByAddressId operation in ClientAddressApi.
 * @export
 * @interface ClientAddressApiGetClientAddressByAddressIdRequest
 */
export interface ClientAddressApiGetClientAddressByAddressIdRequest {
    /**
     * 
     * @type {string}
     * @memberof ClientAddressApiGetClientAddressByAddressId
     */
    readonly addressId: string

    /**
     * 
     * @type {string}
     * @memberof ClientAddressApiGetClientAddressByAddressId
     */
    readonly apiVersion?: string
}

/**
 * Request parameters for getClientAddressById operation in ClientAddressApi.
 * @export
 * @interface ClientAddressApiGetClientAddressByIdRequest
 */
export interface ClientAddressApiGetClientAddressByIdRequest {
    /**
     * 
     * @type {string}
     * @memberof ClientAddressApiGetClientAddressById
     */
    readonly id: string

    /**
     * 
     * @type {string}
     * @memberof ClientAddressApiGetClientAddressById
     */
    readonly apiVersion?: string
}

/**
 * Request parameters for setClientAddressFavorite operation in ClientAddressApi.
 * @export
 * @interface ClientAddressApiSetClientAddressFavoriteRequest
 */
export interface ClientAddressApiSetClientAddressFavoriteRequest {
    /**
     * 
     * @type {string}
     * @memberof ClientAddressApiSetClientAddressFavorite
     */
    readonly id: string

    /**
     * 
     * @type {string}
     * @memberof ClientAddressApiSetClientAddressFavorite
     */
    readonly apiVersion?: string
}

/**
 * Request parameters for updateClientAddress operation in ClientAddressApi.
 * @export
 * @interface ClientAddressApiUpdateClientAddressRequest
 */
export interface ClientAddressApiUpdateClientAddressRequest {
    /**
     * 
     * @type {string}
     * @memberof ClientAddressApiUpdateClientAddress
     */
    readonly apiVersion?: string

    /**
     * 
     * @type {UpdateClientAddressRequest}
     * @memberof ClientAddressApiUpdateClientAddress
     */
    readonly updateClientAddressRequest?: UpdateClientAddressRequest
}

/**
 * ClientAddressApi - object-oriented interface
 * @export
 * @class ClientAddressApi
 * @extends {BaseAPI}
 */
export class ClientAddressApi extends BaseAPI {
    /**
     * 
     * @summary Добавить адрес клиента
     * @param {ClientAddressApiCreateClientAddressRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientAddressApi
     */
    public createClientAddress(requestParameters: ClientAddressApiCreateClientAddressRequest = {}, options?: RawAxiosRequestConfig) {
        return ClientAddressApiFp(this.configuration).createClientAddress(requestParameters.apiVersion, requestParameters.createClientAddressRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Удалить адрес клиента
     * @param {ClientAddressApiDeleteClientAddressRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientAddressApi
     */
    public deleteClientAddress(requestParameters: ClientAddressApiDeleteClientAddressRequest, options?: RawAxiosRequestConfig) {
        return ClientAddressApiFp(this.configuration).deleteClientAddress(requestParameters.id, requestParameters.apiVersion, requestParameters.deleteRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Получить адреса клиента
     * @param {ClientAddressApiGetAllClientAddressesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientAddressApi
     */
    public getAllClientAddresses(requestParameters: ClientAddressApiGetAllClientAddressesRequest, options?: RawAxiosRequestConfig) {
        return ClientAddressApiFp(this.configuration).getAllClientAddresses(requestParameters.clientId, requestParameters.cityNameSearch, requestParameters.streetSearch, requestParameters.houseNumberSearch, requestParameters.apiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Получить адрес клиента по идентификатору адреса
     * @param {ClientAddressApiGetClientAddressByAddressIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientAddressApi
     */
    public getClientAddressByAddressId(requestParameters: ClientAddressApiGetClientAddressByAddressIdRequest, options?: RawAxiosRequestConfig) {
        return ClientAddressApiFp(this.configuration).getClientAddressByAddressId(requestParameters.addressId, requestParameters.apiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Получить адрес клиента по идентификатору записи
     * @param {ClientAddressApiGetClientAddressByIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientAddressApi
     */
    public getClientAddressById(requestParameters: ClientAddressApiGetClientAddressByIdRequest, options?: RawAxiosRequestConfig) {
        return ClientAddressApiFp(this.configuration).getClientAddressById(requestParameters.id, requestParameters.apiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Сделать адрес клиента избранным
     * @param {ClientAddressApiSetClientAddressFavoriteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientAddressApi
     */
    public setClientAddressFavorite(requestParameters: ClientAddressApiSetClientAddressFavoriteRequest, options?: RawAxiosRequestConfig) {
        return ClientAddressApiFp(this.configuration).setClientAddressFavorite(requestParameters.id, requestParameters.apiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Обновить адрес клиента
     * @param {ClientAddressApiUpdateClientAddressRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientAddressApi
     */
    public updateClientAddress(requestParameters: ClientAddressApiUpdateClientAddressRequest = {}, options?: RawAxiosRequestConfig) {
        return ClientAddressApiFp(this.configuration).updateClientAddress(requestParameters.apiVersion, requestParameters.updateClientAddressRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ClientOrderRepeatApi - axios parameter creator
 * @export
 */
export const ClientOrderRepeatApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Перенести настройки заказа клиента в черновик услуги
         * @param {string} orderId 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1OrdersOrderIdRepeatClientPost: async (orderId: string, apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orderId' is not null or undefined
            assertParamExists('apiV1OrdersOrderIdRepeatClientPost', 'orderId', orderId)
            const localVarPath = `/api/v1/orders/{orderId}/repeat-client`
                .replace(`{${"orderId"}}`, encodeURIComponent(String(orderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ClientOrderRepeatApi - functional programming interface
 * @export
 */
export const ClientOrderRepeatApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ClientOrderRepeatApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Перенести настройки заказа клиента в черновик услуги
         * @param {string} orderId 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1OrdersOrderIdRepeatClientPost(orderId: string, apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrderResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1OrdersOrderIdRepeatClientPost(orderId, apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClientOrderRepeatApi.apiV1OrdersOrderIdRepeatClientPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ClientOrderRepeatApi - factory interface
 * @export
 */
export const ClientOrderRepeatApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ClientOrderRepeatApiFp(configuration)
    return {
        /**
         * 
         * @summary Перенести настройки заказа клиента в черновик услуги
         * @param {ClientOrderRepeatApiApiV1OrdersOrderIdRepeatClientPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1OrdersOrderIdRepeatClientPost(requestParameters: ClientOrderRepeatApiApiV1OrdersOrderIdRepeatClientPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<OrderResponse> {
            return localVarFp.apiV1OrdersOrderIdRepeatClientPost(requestParameters.orderId, requestParameters.apiVersion, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for apiV1OrdersOrderIdRepeatClientPost operation in ClientOrderRepeatApi.
 * @export
 * @interface ClientOrderRepeatApiApiV1OrdersOrderIdRepeatClientPostRequest
 */
export interface ClientOrderRepeatApiApiV1OrdersOrderIdRepeatClientPostRequest {
    /**
     * 
     * @type {string}
     * @memberof ClientOrderRepeatApiApiV1OrdersOrderIdRepeatClientPost
     */
    readonly orderId: string

    /**
     * 
     * @type {string}
     * @memberof ClientOrderRepeatApiApiV1OrdersOrderIdRepeatClientPost
     */
    readonly apiVersion?: string
}

/**
 * ClientOrderRepeatApi - object-oriented interface
 * @export
 * @class ClientOrderRepeatApi
 * @extends {BaseAPI}
 */
export class ClientOrderRepeatApi extends BaseAPI {
    /**
     * 
     * @summary Перенести настройки заказа клиента в черновик услуги
     * @param {ClientOrderRepeatApiApiV1OrdersOrderIdRepeatClientPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientOrderRepeatApi
     */
    public apiV1OrdersOrderIdRepeatClientPost(requestParameters: ClientOrderRepeatApiApiV1OrdersOrderIdRepeatClientPostRequest, options?: RawAxiosRequestConfig) {
        return ClientOrderRepeatApiFp(this.configuration).apiV1OrdersOrderIdRepeatClientPost(requestParameters.orderId, requestParameters.apiVersion, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ClientSubscriptionApi - axios parameter creator
 * @export
 */
export const ClientSubscriptionApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Выдать абонемент клиенту через админку
         * @param {string} [apiVersion] 
         * @param {CreateClientSubscriptionRequest} [createClientSubscriptionRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createClientSubscriptionByAdmin: async (apiVersion?: string, createClientSubscriptionRequest?: CreateClientSubscriptionRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/client-subscription/create-client-subscription-by-admin`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createClientSubscriptionRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Получить данные клиента
         * @param {string} clientSubscriptionId Идентификатор связки выданного абонемента клиенту
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getClientSubscriptionById: async (clientSubscriptionId: string, apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'clientSubscriptionId' is not null or undefined
            assertParamExists('getClientSubscriptionById', 'clientSubscriptionId', clientSubscriptionId)
            const localVarPath = `/api/v1/client-subscription/{clientSubscriptionId}`
                .replace(`{${"clientSubscriptionId"}}`, encodeURIComponent(String(clientSubscriptionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Обновить данные выданного абонемент клиенту через админку
         * @param {string} clientSubscriptionId 
         * @param {string} [apiVersion] 
         * @param {UpdateClientSubscriptionRequest} [updateClientSubscriptionRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateClientSubscriptionByAdmin: async (clientSubscriptionId: string, apiVersion?: string, updateClientSubscriptionRequest?: UpdateClientSubscriptionRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'clientSubscriptionId' is not null or undefined
            assertParamExists('updateClientSubscriptionByAdmin', 'clientSubscriptionId', clientSubscriptionId)
            const localVarPath = `/api/v1/client-subscription/update-client-subscription-by-admin/{clientSubscriptionId}`
                .replace(`{${"clientSubscriptionId"}}`, encodeURIComponent(String(clientSubscriptionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateClientSubscriptionRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ClientSubscriptionApi - functional programming interface
 * @export
 */
export const ClientSubscriptionApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ClientSubscriptionApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Выдать абонемент клиенту через админку
         * @param {string} [apiVersion] 
         * @param {CreateClientSubscriptionRequest} [createClientSubscriptionRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createClientSubscriptionByAdmin(apiVersion?: string, createClientSubscriptionRequest?: CreateClientSubscriptionRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ClientSubscriptionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createClientSubscriptionByAdmin(apiVersion, createClientSubscriptionRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClientSubscriptionApi.createClientSubscriptionByAdmin']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Получить данные клиента
         * @param {string} clientSubscriptionId Идентификатор связки выданного абонемента клиенту
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getClientSubscriptionById(clientSubscriptionId: string, apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ClientSubscriptionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getClientSubscriptionById(clientSubscriptionId, apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClientSubscriptionApi.getClientSubscriptionById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Обновить данные выданного абонемент клиенту через админку
         * @param {string} clientSubscriptionId 
         * @param {string} [apiVersion] 
         * @param {UpdateClientSubscriptionRequest} [updateClientSubscriptionRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateClientSubscriptionByAdmin(clientSubscriptionId: string, apiVersion?: string, updateClientSubscriptionRequest?: UpdateClientSubscriptionRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ClientSubscriptionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateClientSubscriptionByAdmin(clientSubscriptionId, apiVersion, updateClientSubscriptionRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClientSubscriptionApi.updateClientSubscriptionByAdmin']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ClientSubscriptionApi - factory interface
 * @export
 */
export const ClientSubscriptionApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ClientSubscriptionApiFp(configuration)
    return {
        /**
         * 
         * @summary Выдать абонемент клиенту через админку
         * @param {ClientSubscriptionApiCreateClientSubscriptionByAdminRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createClientSubscriptionByAdmin(requestParameters: ClientSubscriptionApiCreateClientSubscriptionByAdminRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<ClientSubscriptionResponse> {
            return localVarFp.createClientSubscriptionByAdmin(requestParameters.apiVersion, requestParameters.createClientSubscriptionRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Получить данные клиента
         * @param {ClientSubscriptionApiGetClientSubscriptionByIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getClientSubscriptionById(requestParameters: ClientSubscriptionApiGetClientSubscriptionByIdRequest, options?: RawAxiosRequestConfig): AxiosPromise<ClientSubscriptionResponse> {
            return localVarFp.getClientSubscriptionById(requestParameters.clientSubscriptionId, requestParameters.apiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Обновить данные выданного абонемент клиенту через админку
         * @param {ClientSubscriptionApiUpdateClientSubscriptionByAdminRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateClientSubscriptionByAdmin(requestParameters: ClientSubscriptionApiUpdateClientSubscriptionByAdminRequest, options?: RawAxiosRequestConfig): AxiosPromise<ClientSubscriptionResponse> {
            return localVarFp.updateClientSubscriptionByAdmin(requestParameters.clientSubscriptionId, requestParameters.apiVersion, requestParameters.updateClientSubscriptionRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for createClientSubscriptionByAdmin operation in ClientSubscriptionApi.
 * @export
 * @interface ClientSubscriptionApiCreateClientSubscriptionByAdminRequest
 */
export interface ClientSubscriptionApiCreateClientSubscriptionByAdminRequest {
    /**
     * 
     * @type {string}
     * @memberof ClientSubscriptionApiCreateClientSubscriptionByAdmin
     */
    readonly apiVersion?: string

    /**
     * 
     * @type {CreateClientSubscriptionRequest}
     * @memberof ClientSubscriptionApiCreateClientSubscriptionByAdmin
     */
    readonly createClientSubscriptionRequest?: CreateClientSubscriptionRequest
}

/**
 * Request parameters for getClientSubscriptionById operation in ClientSubscriptionApi.
 * @export
 * @interface ClientSubscriptionApiGetClientSubscriptionByIdRequest
 */
export interface ClientSubscriptionApiGetClientSubscriptionByIdRequest {
    /**
     * Идентификатор связки выданного абонемента клиенту
     * @type {string}
     * @memberof ClientSubscriptionApiGetClientSubscriptionById
     */
    readonly clientSubscriptionId: string

    /**
     * 
     * @type {string}
     * @memberof ClientSubscriptionApiGetClientSubscriptionById
     */
    readonly apiVersion?: string
}

/**
 * Request parameters for updateClientSubscriptionByAdmin operation in ClientSubscriptionApi.
 * @export
 * @interface ClientSubscriptionApiUpdateClientSubscriptionByAdminRequest
 */
export interface ClientSubscriptionApiUpdateClientSubscriptionByAdminRequest {
    /**
     * 
     * @type {string}
     * @memberof ClientSubscriptionApiUpdateClientSubscriptionByAdmin
     */
    readonly clientSubscriptionId: string

    /**
     * 
     * @type {string}
     * @memberof ClientSubscriptionApiUpdateClientSubscriptionByAdmin
     */
    readonly apiVersion?: string

    /**
     * 
     * @type {UpdateClientSubscriptionRequest}
     * @memberof ClientSubscriptionApiUpdateClientSubscriptionByAdmin
     */
    readonly updateClientSubscriptionRequest?: UpdateClientSubscriptionRequest
}

/**
 * ClientSubscriptionApi - object-oriented interface
 * @export
 * @class ClientSubscriptionApi
 * @extends {BaseAPI}
 */
export class ClientSubscriptionApi extends BaseAPI {
    /**
     * 
     * @summary Выдать абонемент клиенту через админку
     * @param {ClientSubscriptionApiCreateClientSubscriptionByAdminRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientSubscriptionApi
     */
    public createClientSubscriptionByAdmin(requestParameters: ClientSubscriptionApiCreateClientSubscriptionByAdminRequest = {}, options?: RawAxiosRequestConfig) {
        return ClientSubscriptionApiFp(this.configuration).createClientSubscriptionByAdmin(requestParameters.apiVersion, requestParameters.createClientSubscriptionRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Получить данные клиента
     * @param {ClientSubscriptionApiGetClientSubscriptionByIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientSubscriptionApi
     */
    public getClientSubscriptionById(requestParameters: ClientSubscriptionApiGetClientSubscriptionByIdRequest, options?: RawAxiosRequestConfig) {
        return ClientSubscriptionApiFp(this.configuration).getClientSubscriptionById(requestParameters.clientSubscriptionId, requestParameters.apiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Обновить данные выданного абонемент клиенту через админку
     * @param {ClientSubscriptionApiUpdateClientSubscriptionByAdminRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientSubscriptionApi
     */
    public updateClientSubscriptionByAdmin(requestParameters: ClientSubscriptionApiUpdateClientSubscriptionByAdminRequest, options?: RawAxiosRequestConfig) {
        return ClientSubscriptionApiFp(this.configuration).updateClientSubscriptionByAdmin(requestParameters.clientSubscriptionId, requestParameters.apiVersion, requestParameters.updateClientSubscriptionRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * DialogApi - axios parameter creator
 * @export
 */
export const DialogApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Отменить ожидающее сообщение пользователю
         * @param {string} dialogId 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DialogsDialogIdDelete: async (dialogId: string, apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'dialogId' is not null or undefined
            assertParamExists('apiV1DialogsDialogIdDelete', 'dialogId', dialogId)
            const localVarPath = `/api/v1/dialogs/{dialogId}`
                .replace(`{${"dialogId"}}`, encodeURIComponent(String(dialogId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Изменить ожидающее сообщение пользователю
         * @param {string} dialogId 
         * @param {string} [apiVersion] 
         * @param {UpdateMessageDialogRequest} [updateMessageDialogRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DialogsDialogIdPut: async (dialogId: string, apiVersion?: string, updateMessageDialogRequest?: UpdateMessageDialogRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'dialogId' is not null or undefined
            assertParamExists('apiV1DialogsDialogIdPut', 'dialogId', dialogId)
            const localVarPath = `/api/v1/dialogs/{dialogId}`
                .replace(`{${"dialogId"}}`, encodeURIComponent(String(dialogId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateMessageDialogRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Создать сообщение пользователю
         * @param {string} [apiVersion] 
         * @param {CreateMessageDialogRequest} [createMessageDialogRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DialogsPost: async (apiVersion?: string, createMessageDialogRequest?: CreateMessageDialogRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/dialogs`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createMessageDialogRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Получить Диалог в статусе \"Ожидает ответ\"
         * @param {string} [apiVersion] 
         * @param {GetPendingDialogRequest} [getPendingDialogRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPendingDialog: async (apiVersion?: string, getPendingDialogRequest?: GetPendingDialogRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/dialogs/get-pending-dialog`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(getPendingDialogRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Отправить ответ по диалогу
         * @param {string} [apiVersion] 
         * @param {SubmitDialogAnswerRequest} [submitDialogAnswerRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submitDialogAnswer: async (apiVersion?: string, submitDialogAnswerRequest?: SubmitDialogAnswerRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/dialogs/submit-dialog-answer`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(submitDialogAnswerRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DialogApi - functional programming interface
 * @export
 */
export const DialogApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DialogApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Отменить ожидающее сообщение пользователю
         * @param {string} dialogId 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1DialogsDialogIdDelete(dialogId: string, apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1DialogsDialogIdDelete(dialogId, apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DialogApi.apiV1DialogsDialogIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Изменить ожидающее сообщение пользователю
         * @param {string} dialogId 
         * @param {string} [apiVersion] 
         * @param {UpdateMessageDialogRequest} [updateMessageDialogRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1DialogsDialogIdPut(dialogId: string, apiVersion?: string, updateMessageDialogRequest?: UpdateMessageDialogRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1DialogsDialogIdPut(dialogId, apiVersion, updateMessageDialogRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DialogApi.apiV1DialogsDialogIdPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Создать сообщение пользователю
         * @param {string} [apiVersion] 
         * @param {CreateMessageDialogRequest} [createMessageDialogRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1DialogsPost(apiVersion?: string, createMessageDialogRequest?: CreateMessageDialogRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1DialogsPost(apiVersion, createMessageDialogRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DialogApi.apiV1DialogsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Получить Диалог в статусе \"Ожидает ответ\"
         * @param {string} [apiVersion] 
         * @param {GetPendingDialogRequest} [getPendingDialogRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPendingDialog(apiVersion?: string, getPendingDialogRequest?: GetPendingDialogRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetPendingDialogResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPendingDialog(apiVersion, getPendingDialogRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DialogApi.getPendingDialog']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Отправить ответ по диалогу
         * @param {string} [apiVersion] 
         * @param {SubmitDialogAnswerRequest} [submitDialogAnswerRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async submitDialogAnswer(apiVersion?: string, submitDialogAnswerRequest?: SubmitDialogAnswerRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.submitDialogAnswer(apiVersion, submitDialogAnswerRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DialogApi.submitDialogAnswer']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * DialogApi - factory interface
 * @export
 */
export const DialogApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DialogApiFp(configuration)
    return {
        /**
         * 
         * @summary Отменить ожидающее сообщение пользователю
         * @param {DialogApiApiV1DialogsDialogIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DialogsDialogIdDelete(requestParameters: DialogApiApiV1DialogsDialogIdDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiV1DialogsDialogIdDelete(requestParameters.dialogId, requestParameters.apiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Изменить ожидающее сообщение пользователю
         * @param {DialogApiApiV1DialogsDialogIdPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DialogsDialogIdPut(requestParameters: DialogApiApiV1DialogsDialogIdPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiV1DialogsDialogIdPut(requestParameters.dialogId, requestParameters.apiVersion, requestParameters.updateMessageDialogRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Создать сообщение пользователю
         * @param {DialogApiApiV1DialogsPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DialogsPost(requestParameters: DialogApiApiV1DialogsPostRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.apiV1DialogsPost(requestParameters.apiVersion, requestParameters.createMessageDialogRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Получить Диалог в статусе \"Ожидает ответ\"
         * @param {DialogApiGetPendingDialogRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPendingDialog(requestParameters: DialogApiGetPendingDialogRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<GetPendingDialogResponse> {
            return localVarFp.getPendingDialog(requestParameters.apiVersion, requestParameters.getPendingDialogRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Отправить ответ по диалогу
         * @param {DialogApiSubmitDialogAnswerRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submitDialogAnswer(requestParameters: DialogApiSubmitDialogAnswerRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.submitDialogAnswer(requestParameters.apiVersion, requestParameters.submitDialogAnswerRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for apiV1DialogsDialogIdDelete operation in DialogApi.
 * @export
 * @interface DialogApiApiV1DialogsDialogIdDeleteRequest
 */
export interface DialogApiApiV1DialogsDialogIdDeleteRequest {
    /**
     * 
     * @type {string}
     * @memberof DialogApiApiV1DialogsDialogIdDelete
     */
    readonly dialogId: string

    /**
     * 
     * @type {string}
     * @memberof DialogApiApiV1DialogsDialogIdDelete
     */
    readonly apiVersion?: string
}

/**
 * Request parameters for apiV1DialogsDialogIdPut operation in DialogApi.
 * @export
 * @interface DialogApiApiV1DialogsDialogIdPutRequest
 */
export interface DialogApiApiV1DialogsDialogIdPutRequest {
    /**
     * 
     * @type {string}
     * @memberof DialogApiApiV1DialogsDialogIdPut
     */
    readonly dialogId: string

    /**
     * 
     * @type {string}
     * @memberof DialogApiApiV1DialogsDialogIdPut
     */
    readonly apiVersion?: string

    /**
     * 
     * @type {UpdateMessageDialogRequest}
     * @memberof DialogApiApiV1DialogsDialogIdPut
     */
    readonly updateMessageDialogRequest?: UpdateMessageDialogRequest
}

/**
 * Request parameters for apiV1DialogsPost operation in DialogApi.
 * @export
 * @interface DialogApiApiV1DialogsPostRequest
 */
export interface DialogApiApiV1DialogsPostRequest {
    /**
     * 
     * @type {string}
     * @memberof DialogApiApiV1DialogsPost
     */
    readonly apiVersion?: string

    /**
     * 
     * @type {CreateMessageDialogRequest}
     * @memberof DialogApiApiV1DialogsPost
     */
    readonly createMessageDialogRequest?: CreateMessageDialogRequest
}

/**
 * Request parameters for getPendingDialog operation in DialogApi.
 * @export
 * @interface DialogApiGetPendingDialogRequest
 */
export interface DialogApiGetPendingDialogRequest {
    /**
     * 
     * @type {string}
     * @memberof DialogApiGetPendingDialog
     */
    readonly apiVersion?: string

    /**
     * 
     * @type {GetPendingDialogRequest}
     * @memberof DialogApiGetPendingDialog
     */
    readonly getPendingDialogRequest?: GetPendingDialogRequest
}

/**
 * Request parameters for submitDialogAnswer operation in DialogApi.
 * @export
 * @interface DialogApiSubmitDialogAnswerRequest
 */
export interface DialogApiSubmitDialogAnswerRequest {
    /**
     * 
     * @type {string}
     * @memberof DialogApiSubmitDialogAnswer
     */
    readonly apiVersion?: string

    /**
     * 
     * @type {SubmitDialogAnswerRequest}
     * @memberof DialogApiSubmitDialogAnswer
     */
    readonly submitDialogAnswerRequest?: SubmitDialogAnswerRequest
}

/**
 * DialogApi - object-oriented interface
 * @export
 * @class DialogApi
 * @extends {BaseAPI}
 */
export class DialogApi extends BaseAPI {
    /**
     * 
     * @summary Отменить ожидающее сообщение пользователю
     * @param {DialogApiApiV1DialogsDialogIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DialogApi
     */
    public apiV1DialogsDialogIdDelete(requestParameters: DialogApiApiV1DialogsDialogIdDeleteRequest, options?: RawAxiosRequestConfig) {
        return DialogApiFp(this.configuration).apiV1DialogsDialogIdDelete(requestParameters.dialogId, requestParameters.apiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Изменить ожидающее сообщение пользователю
     * @param {DialogApiApiV1DialogsDialogIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DialogApi
     */
    public apiV1DialogsDialogIdPut(requestParameters: DialogApiApiV1DialogsDialogIdPutRequest, options?: RawAxiosRequestConfig) {
        return DialogApiFp(this.configuration).apiV1DialogsDialogIdPut(requestParameters.dialogId, requestParameters.apiVersion, requestParameters.updateMessageDialogRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Создать сообщение пользователю
     * @param {DialogApiApiV1DialogsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DialogApi
     */
    public apiV1DialogsPost(requestParameters: DialogApiApiV1DialogsPostRequest = {}, options?: RawAxiosRequestConfig) {
        return DialogApiFp(this.configuration).apiV1DialogsPost(requestParameters.apiVersion, requestParameters.createMessageDialogRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Получить Диалог в статусе \"Ожидает ответ\"
     * @param {DialogApiGetPendingDialogRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DialogApi
     */
    public getPendingDialog(requestParameters: DialogApiGetPendingDialogRequest = {}, options?: RawAxiosRequestConfig) {
        return DialogApiFp(this.configuration).getPendingDialog(requestParameters.apiVersion, requestParameters.getPendingDialogRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Отправить ответ по диалогу
     * @param {DialogApiSubmitDialogAnswerRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DialogApi
     */
    public submitDialogAnswer(requestParameters: DialogApiSubmitDialogAnswerRequest = {}, options?: RawAxiosRequestConfig) {
        return DialogApiFp(this.configuration).submitDialogAnswer(requestParameters.apiVersion, requestParameters.submitDialogAnswerRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * DialogBroadcastsApi - axios parameter creator
 * @export
 */
export const DialogBroadcastsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Получить подходящих получателей
         * @param {number} [skipCount] Количество пропускаемых строк
         * @param {number} [takeCount] Размер страницы
         * @param {ApiDialogAudienceType} [audience] Приложения получателей
         * @param {number} [cityId] Город получателей
         * @param {string} [nameSearch] Поиск по имени
         * @param {string} [phoneSearch] Поиск по телефону
         * @param {string} [petNameSearch] Поиск по кличке питомца клиента
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DialogsBroadcastsAudienceGet: async (skipCount?: number, takeCount?: number, audience?: ApiDialogAudienceType, cityId?: number, nameSearch?: string, phoneSearch?: string, petNameSearch?: string, apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/dialogs/broadcasts/audience`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (skipCount !== undefined) {
                localVarQueryParameter['SkipCount'] = skipCount;
            }

            if (takeCount !== undefined) {
                localVarQueryParameter['TakeCount'] = takeCount;
            }

            if (audience !== undefined) {
                localVarQueryParameter['Audience'] = audience;
            }

            if (cityId !== undefined) {
                localVarQueryParameter['CityId'] = cityId;
            }

            if (nameSearch !== undefined) {
                localVarQueryParameter['NameSearch'] = nameSearch;
            }

            if (phoneSearch !== undefined) {
                localVarQueryParameter['PhoneSearch'] = phoneSearch;
            }

            if (petNameSearch !== undefined) {
                localVarQueryParameter['PetNameSearch'] = petNameSearch;
            }


    
            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Получить статистику и страницу назначений
         * @param {string} broadcastId 
         * @param {boolean} [hasAnswer] Наличие ответа
         * @param {number} [skipCount] Количество пропускаемых строк
         * @param {number} [takeCount] Размер страницы
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DialogsBroadcastsBroadcastIdGet: async (broadcastId: string, hasAnswer?: boolean, skipCount?: number, takeCount?: number, apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'broadcastId' is not null or undefined
            assertParamExists('apiV1DialogsBroadcastsBroadcastIdGet', 'broadcastId', broadcastId)
            const localVarPath = `/api/v1/dialogs/broadcasts/{broadcastId}`
                .replace(`{${"broadcastId"}}`, encodeURIComponent(String(broadcastId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (hasAnswer !== undefined) {
                localVarQueryParameter['HasAnswer'] = hasAnswer;
            }

            if (skipCount !== undefined) {
                localVarQueryParameter['SkipCount'] = skipCount;
            }

            if (takeCount !== undefined) {
                localVarQueryParameter['TakeCount'] = takeCount;
            }


    
            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Получить выпуски
         * @param {string} [templateId] Фильтр по шаблону
         * @param {boolean} [isSystem] Фильтр системных выпусков
         * @param {number} [skipCount] Количество пропускаемых строк
         * @param {number} [takeCount] Размер страницы
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DialogsBroadcastsGet: async (templateId?: string, isSystem?: boolean, skipCount?: number, takeCount?: number, apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/dialogs/broadcasts`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (templateId !== undefined) {
                localVarQueryParameter['TemplateId'] = templateId;
            }

            if (isSystem !== undefined) {
                localVarQueryParameter['IsSystem'] = isSystem;
            }

            if (skipCount !== undefined) {
                localVarQueryParameter['SkipCount'] = skipCount;
            }

            if (takeCount !== undefined) {
                localVarQueryParameter['TakeCount'] = takeCount;
            }


    
            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Выпустить диалоги
         * @param {string} [apiVersion] 
         * @param {PublishDialogBroadcastRequest} [publishDialogBroadcastRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DialogsBroadcastsPost: async (apiVersion?: string, publishDialogBroadcastRequest?: PublishDialogBroadcastRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/dialogs/broadcasts`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(publishDialogBroadcastRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DialogBroadcastsApi - functional programming interface
 * @export
 */
export const DialogBroadcastsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DialogBroadcastsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Получить подходящих получателей
         * @param {number} [skipCount] Количество пропускаемых строк
         * @param {number} [takeCount] Размер страницы
         * @param {ApiDialogAudienceType} [audience] Приложения получателей
         * @param {number} [cityId] Город получателей
         * @param {string} [nameSearch] Поиск по имени
         * @param {string} [phoneSearch] Поиск по телефону
         * @param {string} [petNameSearch] Поиск по кличке питомца клиента
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1DialogsBroadcastsAudienceGet(skipCount?: number, takeCount?: number, audience?: ApiDialogAudienceType, cityId?: number, nameSearch?: string, phoneSearch?: string, petNameSearch?: string, apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DialogAudienceResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1DialogsBroadcastsAudienceGet(skipCount, takeCount, audience, cityId, nameSearch, phoneSearch, petNameSearch, apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DialogBroadcastsApi.apiV1DialogsBroadcastsAudienceGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Получить статистику и страницу назначений
         * @param {string} broadcastId 
         * @param {boolean} [hasAnswer] Наличие ответа
         * @param {number} [skipCount] Количество пропускаемых строк
         * @param {number} [takeCount] Размер страницы
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1DialogsBroadcastsBroadcastIdGet(broadcastId: string, hasAnswer?: boolean, skipCount?: number, takeCount?: number, apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DialogBroadcastDetailsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1DialogsBroadcastsBroadcastIdGet(broadcastId, hasAnswer, skipCount, takeCount, apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DialogBroadcastsApi.apiV1DialogsBroadcastsBroadcastIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Получить выпуски
         * @param {string} [templateId] Фильтр по шаблону
         * @param {boolean} [isSystem] Фильтр системных выпусков
         * @param {number} [skipCount] Количество пропускаемых строк
         * @param {number} [takeCount] Размер страницы
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1DialogsBroadcastsGet(templateId?: string, isSystem?: boolean, skipCount?: number, takeCount?: number, apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DialogBroadcastListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1DialogsBroadcastsGet(templateId, isSystem, skipCount, takeCount, apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DialogBroadcastsApi.apiV1DialogsBroadcastsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Выпустить диалоги
         * @param {string} [apiVersion] 
         * @param {PublishDialogBroadcastRequest} [publishDialogBroadcastRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1DialogsBroadcastsPost(apiVersion?: string, publishDialogBroadcastRequest?: PublishDialogBroadcastRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1DialogsBroadcastsPost(apiVersion, publishDialogBroadcastRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DialogBroadcastsApi.apiV1DialogsBroadcastsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * DialogBroadcastsApi - factory interface
 * @export
 */
export const DialogBroadcastsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DialogBroadcastsApiFp(configuration)
    return {
        /**
         * 
         * @summary Получить подходящих получателей
         * @param {DialogBroadcastsApiApiV1DialogsBroadcastsAudienceGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DialogsBroadcastsAudienceGet(requestParameters: DialogBroadcastsApiApiV1DialogsBroadcastsAudienceGetRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<DialogAudienceResponse> {
            return localVarFp.apiV1DialogsBroadcastsAudienceGet(requestParameters.skipCount, requestParameters.takeCount, requestParameters.audience, requestParameters.cityId, requestParameters.nameSearch, requestParameters.phoneSearch, requestParameters.petNameSearch, requestParameters.apiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Получить статистику и страницу назначений
         * @param {DialogBroadcastsApiApiV1DialogsBroadcastsBroadcastIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DialogsBroadcastsBroadcastIdGet(requestParameters: DialogBroadcastsApiApiV1DialogsBroadcastsBroadcastIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<DialogBroadcastDetailsResponse> {
            return localVarFp.apiV1DialogsBroadcastsBroadcastIdGet(requestParameters.broadcastId, requestParameters.hasAnswer, requestParameters.skipCount, requestParameters.takeCount, requestParameters.apiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Получить выпуски
         * @param {DialogBroadcastsApiApiV1DialogsBroadcastsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DialogsBroadcastsGet(requestParameters: DialogBroadcastsApiApiV1DialogsBroadcastsGetRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<DialogBroadcastListResponse> {
            return localVarFp.apiV1DialogsBroadcastsGet(requestParameters.templateId, requestParameters.isSystem, requestParameters.skipCount, requestParameters.takeCount, requestParameters.apiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Выпустить диалоги
         * @param {DialogBroadcastsApiApiV1DialogsBroadcastsPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DialogsBroadcastsPost(requestParameters: DialogBroadcastsApiApiV1DialogsBroadcastsPostRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.apiV1DialogsBroadcastsPost(requestParameters.apiVersion, requestParameters.publishDialogBroadcastRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for apiV1DialogsBroadcastsAudienceGet operation in DialogBroadcastsApi.
 * @export
 * @interface DialogBroadcastsApiApiV1DialogsBroadcastsAudienceGetRequest
 */
export interface DialogBroadcastsApiApiV1DialogsBroadcastsAudienceGetRequest {
    /**
     * Количество пропускаемых строк
     * @type {number}
     * @memberof DialogBroadcastsApiApiV1DialogsBroadcastsAudienceGet
     */
    readonly skipCount?: number

    /**
     * Размер страницы
     * @type {number}
     * @memberof DialogBroadcastsApiApiV1DialogsBroadcastsAudienceGet
     */
    readonly takeCount?: number

    /**
     * Приложения получателей
     * @type {ApiDialogAudienceType}
     * @memberof DialogBroadcastsApiApiV1DialogsBroadcastsAudienceGet
     */
    readonly audience?: ApiDialogAudienceType

    /**
     * Город получателей
     * @type {number}
     * @memberof DialogBroadcastsApiApiV1DialogsBroadcastsAudienceGet
     */
    readonly cityId?: number

    /**
     * Поиск по имени
     * @type {string}
     * @memberof DialogBroadcastsApiApiV1DialogsBroadcastsAudienceGet
     */
    readonly nameSearch?: string

    /**
     * Поиск по телефону
     * @type {string}
     * @memberof DialogBroadcastsApiApiV1DialogsBroadcastsAudienceGet
     */
    readonly phoneSearch?: string

    /**
     * Поиск по кличке питомца клиента
     * @type {string}
     * @memberof DialogBroadcastsApiApiV1DialogsBroadcastsAudienceGet
     */
    readonly petNameSearch?: string

    /**
     * 
     * @type {string}
     * @memberof DialogBroadcastsApiApiV1DialogsBroadcastsAudienceGet
     */
    readonly apiVersion?: string
}

/**
 * Request parameters for apiV1DialogsBroadcastsBroadcastIdGet operation in DialogBroadcastsApi.
 * @export
 * @interface DialogBroadcastsApiApiV1DialogsBroadcastsBroadcastIdGetRequest
 */
export interface DialogBroadcastsApiApiV1DialogsBroadcastsBroadcastIdGetRequest {
    /**
     * 
     * @type {string}
     * @memberof DialogBroadcastsApiApiV1DialogsBroadcastsBroadcastIdGet
     */
    readonly broadcastId: string

    /**
     * Наличие ответа
     * @type {boolean}
     * @memberof DialogBroadcastsApiApiV1DialogsBroadcastsBroadcastIdGet
     */
    readonly hasAnswer?: boolean

    /**
     * Количество пропускаемых строк
     * @type {number}
     * @memberof DialogBroadcastsApiApiV1DialogsBroadcastsBroadcastIdGet
     */
    readonly skipCount?: number

    /**
     * Размер страницы
     * @type {number}
     * @memberof DialogBroadcastsApiApiV1DialogsBroadcastsBroadcastIdGet
     */
    readonly takeCount?: number

    /**
     * 
     * @type {string}
     * @memberof DialogBroadcastsApiApiV1DialogsBroadcastsBroadcastIdGet
     */
    readonly apiVersion?: string
}

/**
 * Request parameters for apiV1DialogsBroadcastsGet operation in DialogBroadcastsApi.
 * @export
 * @interface DialogBroadcastsApiApiV1DialogsBroadcastsGetRequest
 */
export interface DialogBroadcastsApiApiV1DialogsBroadcastsGetRequest {
    /**
     * Фильтр по шаблону
     * @type {string}
     * @memberof DialogBroadcastsApiApiV1DialogsBroadcastsGet
     */
    readonly templateId?: string

    /**
     * Фильтр системных выпусков
     * @type {boolean}
     * @memberof DialogBroadcastsApiApiV1DialogsBroadcastsGet
     */
    readonly isSystem?: boolean

    /**
     * Количество пропускаемых строк
     * @type {number}
     * @memberof DialogBroadcastsApiApiV1DialogsBroadcastsGet
     */
    readonly skipCount?: number

    /**
     * Размер страницы
     * @type {number}
     * @memberof DialogBroadcastsApiApiV1DialogsBroadcastsGet
     */
    readonly takeCount?: number

    /**
     * 
     * @type {string}
     * @memberof DialogBroadcastsApiApiV1DialogsBroadcastsGet
     */
    readonly apiVersion?: string
}

/**
 * Request parameters for apiV1DialogsBroadcastsPost operation in DialogBroadcastsApi.
 * @export
 * @interface DialogBroadcastsApiApiV1DialogsBroadcastsPostRequest
 */
export interface DialogBroadcastsApiApiV1DialogsBroadcastsPostRequest {
    /**
     * 
     * @type {string}
     * @memberof DialogBroadcastsApiApiV1DialogsBroadcastsPost
     */
    readonly apiVersion?: string

    /**
     * 
     * @type {PublishDialogBroadcastRequest}
     * @memberof DialogBroadcastsApiApiV1DialogsBroadcastsPost
     */
    readonly publishDialogBroadcastRequest?: PublishDialogBroadcastRequest
}

/**
 * DialogBroadcastsApi - object-oriented interface
 * @export
 * @class DialogBroadcastsApi
 * @extends {BaseAPI}
 */
export class DialogBroadcastsApi extends BaseAPI {
    /**
     * 
     * @summary Получить подходящих получателей
     * @param {DialogBroadcastsApiApiV1DialogsBroadcastsAudienceGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DialogBroadcastsApi
     */
    public apiV1DialogsBroadcastsAudienceGet(requestParameters: DialogBroadcastsApiApiV1DialogsBroadcastsAudienceGetRequest = {}, options?: RawAxiosRequestConfig) {
        return DialogBroadcastsApiFp(this.configuration).apiV1DialogsBroadcastsAudienceGet(requestParameters.skipCount, requestParameters.takeCount, requestParameters.audience, requestParameters.cityId, requestParameters.nameSearch, requestParameters.phoneSearch, requestParameters.petNameSearch, requestParameters.apiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Получить статистику и страницу назначений
     * @param {DialogBroadcastsApiApiV1DialogsBroadcastsBroadcastIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DialogBroadcastsApi
     */
    public apiV1DialogsBroadcastsBroadcastIdGet(requestParameters: DialogBroadcastsApiApiV1DialogsBroadcastsBroadcastIdGetRequest, options?: RawAxiosRequestConfig) {
        return DialogBroadcastsApiFp(this.configuration).apiV1DialogsBroadcastsBroadcastIdGet(requestParameters.broadcastId, requestParameters.hasAnswer, requestParameters.skipCount, requestParameters.takeCount, requestParameters.apiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Получить выпуски
     * @param {DialogBroadcastsApiApiV1DialogsBroadcastsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DialogBroadcastsApi
     */
    public apiV1DialogsBroadcastsGet(requestParameters: DialogBroadcastsApiApiV1DialogsBroadcastsGetRequest = {}, options?: RawAxiosRequestConfig) {
        return DialogBroadcastsApiFp(this.configuration).apiV1DialogsBroadcastsGet(requestParameters.templateId, requestParameters.isSystem, requestParameters.skipCount, requestParameters.takeCount, requestParameters.apiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Выпустить диалоги
     * @param {DialogBroadcastsApiApiV1DialogsBroadcastsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DialogBroadcastsApi
     */
    public apiV1DialogsBroadcastsPost(requestParameters: DialogBroadcastsApiApiV1DialogsBroadcastsPostRequest = {}, options?: RawAxiosRequestConfig) {
        return DialogBroadcastsApiFp(this.configuration).apiV1DialogsBroadcastsPost(requestParameters.apiVersion, requestParameters.publishDialogBroadcastRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * DialogTemplatesApi - axios parameter creator
 * @export
 */
export const DialogTemplatesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Получить конфигурации диалогов
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DialogsTemplatesGet: async (apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/dialogs/templates`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Создать конфигурацию диалога
         * @param {string} [apiVersion] 
         * @param {SaveDialogTemplateRequest} [saveDialogTemplateRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DialogsTemplatesPost: async (apiVersion?: string, saveDialogTemplateRequest?: SaveDialogTemplateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/dialogs/templates`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(saveDialogTemplateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Назначить диалог пользователю
         * @param {string} templateId 
         * @param {string} [apiVersion] 
         * @param {AssignDialogTemplateRequest} [assignDialogTemplateRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DialogsTemplatesTemplateIdAssignPost: async (templateId: string, apiVersion?: string, assignDialogTemplateRequest?: AssignDialogTemplateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'templateId' is not null or undefined
            assertParamExists('apiV1DialogsTemplatesTemplateIdAssignPost', 'templateId', templateId)
            const localVarPath = `/api/v1/dialogs/templates/{templateId}/assign`
                .replace(`{${"templateId"}}`, encodeURIComponent(String(templateId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(assignDialogTemplateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Изменить конфигурацию диалога
         * @param {string} templateId 
         * @param {string} [apiVersion] 
         * @param {SaveDialogTemplateRequest} [saveDialogTemplateRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DialogsTemplatesTemplateIdPut: async (templateId: string, apiVersion?: string, saveDialogTemplateRequest?: SaveDialogTemplateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'templateId' is not null or undefined
            assertParamExists('apiV1DialogsTemplatesTemplateIdPut', 'templateId', templateId)
            const localVarPath = `/api/v1/dialogs/templates/{templateId}`
                .replace(`{${"templateId"}}`, encodeURIComponent(String(templateId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(saveDialogTemplateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DialogTemplatesApi - functional programming interface
 * @export
 */
export const DialogTemplatesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DialogTemplatesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Получить конфигурации диалогов
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1DialogsTemplatesGet(apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DialogTemplateResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1DialogsTemplatesGet(apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DialogTemplatesApi.apiV1DialogsTemplatesGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Создать конфигурацию диалога
         * @param {string} [apiVersion] 
         * @param {SaveDialogTemplateRequest} [saveDialogTemplateRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1DialogsTemplatesPost(apiVersion?: string, saveDialogTemplateRequest?: SaveDialogTemplateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1DialogsTemplatesPost(apiVersion, saveDialogTemplateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DialogTemplatesApi.apiV1DialogsTemplatesPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Назначить диалог пользователю
         * @param {string} templateId 
         * @param {string} [apiVersion] 
         * @param {AssignDialogTemplateRequest} [assignDialogTemplateRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1DialogsTemplatesTemplateIdAssignPost(templateId: string, apiVersion?: string, assignDialogTemplateRequest?: AssignDialogTemplateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1DialogsTemplatesTemplateIdAssignPost(templateId, apiVersion, assignDialogTemplateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DialogTemplatesApi.apiV1DialogsTemplatesTemplateIdAssignPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Изменить конфигурацию диалога
         * @param {string} templateId 
         * @param {string} [apiVersion] 
         * @param {SaveDialogTemplateRequest} [saveDialogTemplateRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1DialogsTemplatesTemplateIdPut(templateId: string, apiVersion?: string, saveDialogTemplateRequest?: SaveDialogTemplateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1DialogsTemplatesTemplateIdPut(templateId, apiVersion, saveDialogTemplateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DialogTemplatesApi.apiV1DialogsTemplatesTemplateIdPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * DialogTemplatesApi - factory interface
 * @export
 */
export const DialogTemplatesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DialogTemplatesApiFp(configuration)
    return {
        /**
         * 
         * @summary Получить конфигурации диалогов
         * @param {DialogTemplatesApiApiV1DialogsTemplatesGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DialogsTemplatesGet(requestParameters: DialogTemplatesApiApiV1DialogsTemplatesGetRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<Array<DialogTemplateResponse>> {
            return localVarFp.apiV1DialogsTemplatesGet(requestParameters.apiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Создать конфигурацию диалога
         * @param {DialogTemplatesApiApiV1DialogsTemplatesPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DialogsTemplatesPost(requestParameters: DialogTemplatesApiApiV1DialogsTemplatesPostRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.apiV1DialogsTemplatesPost(requestParameters.apiVersion, requestParameters.saveDialogTemplateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Назначить диалог пользователю
         * @param {DialogTemplatesApiApiV1DialogsTemplatesTemplateIdAssignPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DialogsTemplatesTemplateIdAssignPost(requestParameters: DialogTemplatesApiApiV1DialogsTemplatesTemplateIdAssignPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.apiV1DialogsTemplatesTemplateIdAssignPost(requestParameters.templateId, requestParameters.apiVersion, requestParameters.assignDialogTemplateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Изменить конфигурацию диалога
         * @param {DialogTemplatesApiApiV1DialogsTemplatesTemplateIdPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DialogsTemplatesTemplateIdPut(requestParameters: DialogTemplatesApiApiV1DialogsTemplatesTemplateIdPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiV1DialogsTemplatesTemplateIdPut(requestParameters.templateId, requestParameters.apiVersion, requestParameters.saveDialogTemplateRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for apiV1DialogsTemplatesGet operation in DialogTemplatesApi.
 * @export
 * @interface DialogTemplatesApiApiV1DialogsTemplatesGetRequest
 */
export interface DialogTemplatesApiApiV1DialogsTemplatesGetRequest {
    /**
     * 
     * @type {string}
     * @memberof DialogTemplatesApiApiV1DialogsTemplatesGet
     */
    readonly apiVersion?: string
}

/**
 * Request parameters for apiV1DialogsTemplatesPost operation in DialogTemplatesApi.
 * @export
 * @interface DialogTemplatesApiApiV1DialogsTemplatesPostRequest
 */
export interface DialogTemplatesApiApiV1DialogsTemplatesPostRequest {
    /**
     * 
     * @type {string}
     * @memberof DialogTemplatesApiApiV1DialogsTemplatesPost
     */
    readonly apiVersion?: string

    /**
     * 
     * @type {SaveDialogTemplateRequest}
     * @memberof DialogTemplatesApiApiV1DialogsTemplatesPost
     */
    readonly saveDialogTemplateRequest?: SaveDialogTemplateRequest
}

/**
 * Request parameters for apiV1DialogsTemplatesTemplateIdAssignPost operation in DialogTemplatesApi.
 * @export
 * @interface DialogTemplatesApiApiV1DialogsTemplatesTemplateIdAssignPostRequest
 */
export interface DialogTemplatesApiApiV1DialogsTemplatesTemplateIdAssignPostRequest {
    /**
     * 
     * @type {string}
     * @memberof DialogTemplatesApiApiV1DialogsTemplatesTemplateIdAssignPost
     */
    readonly templateId: string

    /**
     * 
     * @type {string}
     * @memberof DialogTemplatesApiApiV1DialogsTemplatesTemplateIdAssignPost
     */
    readonly apiVersion?: string

    /**
     * 
     * @type {AssignDialogTemplateRequest}
     * @memberof DialogTemplatesApiApiV1DialogsTemplatesTemplateIdAssignPost
     */
    readonly assignDialogTemplateRequest?: AssignDialogTemplateRequest
}

/**
 * Request parameters for apiV1DialogsTemplatesTemplateIdPut operation in DialogTemplatesApi.
 * @export
 * @interface DialogTemplatesApiApiV1DialogsTemplatesTemplateIdPutRequest
 */
export interface DialogTemplatesApiApiV1DialogsTemplatesTemplateIdPutRequest {
    /**
     * 
     * @type {string}
     * @memberof DialogTemplatesApiApiV1DialogsTemplatesTemplateIdPut
     */
    readonly templateId: string

    /**
     * 
     * @type {string}
     * @memberof DialogTemplatesApiApiV1DialogsTemplatesTemplateIdPut
     */
    readonly apiVersion?: string

    /**
     * 
     * @type {SaveDialogTemplateRequest}
     * @memberof DialogTemplatesApiApiV1DialogsTemplatesTemplateIdPut
     */
    readonly saveDialogTemplateRequest?: SaveDialogTemplateRequest
}

/**
 * DialogTemplatesApi - object-oriented interface
 * @export
 * @class DialogTemplatesApi
 * @extends {BaseAPI}
 */
export class DialogTemplatesApi extends BaseAPI {
    /**
     * 
     * @summary Получить конфигурации диалогов
     * @param {DialogTemplatesApiApiV1DialogsTemplatesGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DialogTemplatesApi
     */
    public apiV1DialogsTemplatesGet(requestParameters: DialogTemplatesApiApiV1DialogsTemplatesGetRequest = {}, options?: RawAxiosRequestConfig) {
        return DialogTemplatesApiFp(this.configuration).apiV1DialogsTemplatesGet(requestParameters.apiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Создать конфигурацию диалога
     * @param {DialogTemplatesApiApiV1DialogsTemplatesPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DialogTemplatesApi
     */
    public apiV1DialogsTemplatesPost(requestParameters: DialogTemplatesApiApiV1DialogsTemplatesPostRequest = {}, options?: RawAxiosRequestConfig) {
        return DialogTemplatesApiFp(this.configuration).apiV1DialogsTemplatesPost(requestParameters.apiVersion, requestParameters.saveDialogTemplateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Назначить диалог пользователю
     * @param {DialogTemplatesApiApiV1DialogsTemplatesTemplateIdAssignPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DialogTemplatesApi
     */
    public apiV1DialogsTemplatesTemplateIdAssignPost(requestParameters: DialogTemplatesApiApiV1DialogsTemplatesTemplateIdAssignPostRequest, options?: RawAxiosRequestConfig) {
        return DialogTemplatesApiFp(this.configuration).apiV1DialogsTemplatesTemplateIdAssignPost(requestParameters.templateId, requestParameters.apiVersion, requestParameters.assignDialogTemplateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Изменить конфигурацию диалога
     * @param {DialogTemplatesApiApiV1DialogsTemplatesTemplateIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DialogTemplatesApi
     */
    public apiV1DialogsTemplatesTemplateIdPut(requestParameters: DialogTemplatesApiApiV1DialogsTemplatesTemplateIdPutRequest, options?: RawAxiosRequestConfig) {
        return DialogTemplatesApiFp(this.configuration).apiV1DialogsTemplatesTemplateIdPut(requestParameters.templateId, requestParameters.apiVersion, requestParameters.saveDialogTemplateRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * EmailVerificationApi - axios parameter creator
 * @export
 */
export const EmailVerificationApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Повторно отправить письмо подтверждения текущему пользователю
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1EmailVerificationResendPost: async (apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/email-verification/resend`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Получить состояние подтверждения электронной почты
         * @param {string} [appUserId] 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1EmailVerificationStatusGet: async (appUserId?: string, apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/email-verification/status`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (appUserId !== undefined) {
                localVarQueryParameter['appUserId'] = appUserId;
            }


    
            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * EmailVerificationApi - functional programming interface
 * @export
 */
export const EmailVerificationApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = EmailVerificationApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Повторно отправить письмо подтверждения текущему пользователю
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1EmailVerificationResendPost(apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EmailVerificationStatusResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1EmailVerificationResendPost(apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EmailVerificationApi.apiV1EmailVerificationResendPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Получить состояние подтверждения электронной почты
         * @param {string} [appUserId] 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1EmailVerificationStatusGet(appUserId?: string, apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EmailVerificationStatusResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1EmailVerificationStatusGet(appUserId, apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EmailVerificationApi.apiV1EmailVerificationStatusGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * EmailVerificationApi - factory interface
 * @export
 */
export const EmailVerificationApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = EmailVerificationApiFp(configuration)
    return {
        /**
         * 
         * @summary Повторно отправить письмо подтверждения текущему пользователю
         * @param {EmailVerificationApiApiV1EmailVerificationResendPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1EmailVerificationResendPost(requestParameters: EmailVerificationApiApiV1EmailVerificationResendPostRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<EmailVerificationStatusResponse> {
            return localVarFp.apiV1EmailVerificationResendPost(requestParameters.apiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Получить состояние подтверждения электронной почты
         * @param {EmailVerificationApiApiV1EmailVerificationStatusGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1EmailVerificationStatusGet(requestParameters: EmailVerificationApiApiV1EmailVerificationStatusGetRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<EmailVerificationStatusResponse> {
            return localVarFp.apiV1EmailVerificationStatusGet(requestParameters.appUserId, requestParameters.apiVersion, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for apiV1EmailVerificationResendPost operation in EmailVerificationApi.
 * @export
 * @interface EmailVerificationApiApiV1EmailVerificationResendPostRequest
 */
export interface EmailVerificationApiApiV1EmailVerificationResendPostRequest {
    /**
     * 
     * @type {string}
     * @memberof EmailVerificationApiApiV1EmailVerificationResendPost
     */
    readonly apiVersion?: string
}

/**
 * Request parameters for apiV1EmailVerificationStatusGet operation in EmailVerificationApi.
 * @export
 * @interface EmailVerificationApiApiV1EmailVerificationStatusGetRequest
 */
export interface EmailVerificationApiApiV1EmailVerificationStatusGetRequest {
    /**
     * 
     * @type {string}
     * @memberof EmailVerificationApiApiV1EmailVerificationStatusGet
     */
    readonly appUserId?: string

    /**
     * 
     * @type {string}
     * @memberof EmailVerificationApiApiV1EmailVerificationStatusGet
     */
    readonly apiVersion?: string
}

/**
 * EmailVerificationApi - object-oriented interface
 * @export
 * @class EmailVerificationApi
 * @extends {BaseAPI}
 */
export class EmailVerificationApi extends BaseAPI {
    /**
     * 
     * @summary Повторно отправить письмо подтверждения текущему пользователю
     * @param {EmailVerificationApiApiV1EmailVerificationResendPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmailVerificationApi
     */
    public apiV1EmailVerificationResendPost(requestParameters: EmailVerificationApiApiV1EmailVerificationResendPostRequest = {}, options?: RawAxiosRequestConfig) {
        return EmailVerificationApiFp(this.configuration).apiV1EmailVerificationResendPost(requestParameters.apiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Получить состояние подтверждения электронной почты
     * @param {EmailVerificationApiApiV1EmailVerificationStatusGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmailVerificationApi
     */
    public apiV1EmailVerificationStatusGet(requestParameters: EmailVerificationApiApiV1EmailVerificationStatusGetRequest = {}, options?: RawAxiosRequestConfig) {
        return EmailVerificationApiFp(this.configuration).apiV1EmailVerificationStatusGet(requestParameters.appUserId, requestParameters.apiVersion, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * EmailVerificationPageApi - axios parameter creator
 * @export
 */
export const EmailVerificationPageApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Открыть страницу подтверждения электронной почты
         * @param {string} [verificationToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1EmailVerificationConfirmGet: async (verificationToken?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/email-verification/confirm`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (verificationToken !== undefined) {
                localVarQueryParameter['verificationToken'] = verificationToken;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Подтвердить электронную почту
         * @param {string} [verificationToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1EmailVerificationConfirmPost: async (verificationToken?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/email-verification/confirm`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new URLSearchParams();

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


            if (verificationToken !== undefined) { 
                localVarFormParams.set('verificationToken', verificationToken as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'application/x-www-form-urlencoded';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams.toString();

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * EmailVerificationPageApi - functional programming interface
 * @export
 */
export const EmailVerificationPageApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = EmailVerificationPageApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Открыть страницу подтверждения электронной почты
         * @param {string} [verificationToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1EmailVerificationConfirmGet(verificationToken?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1EmailVerificationConfirmGet(verificationToken, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EmailVerificationPageApi.apiV1EmailVerificationConfirmGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Подтвердить электронную почту
         * @param {string} [verificationToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1EmailVerificationConfirmPost(verificationToken?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1EmailVerificationConfirmPost(verificationToken, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EmailVerificationPageApi.apiV1EmailVerificationConfirmPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * EmailVerificationPageApi - factory interface
 * @export
 */
export const EmailVerificationPageApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = EmailVerificationPageApiFp(configuration)
    return {
        /**
         * 
         * @summary Открыть страницу подтверждения электронной почты
         * @param {EmailVerificationPageApiApiV1EmailVerificationConfirmGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1EmailVerificationConfirmGet(requestParameters: EmailVerificationPageApiApiV1EmailVerificationConfirmGetRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiV1EmailVerificationConfirmGet(requestParameters.verificationToken, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Подтвердить электронную почту
         * @param {EmailVerificationPageApiApiV1EmailVerificationConfirmPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1EmailVerificationConfirmPost(requestParameters: EmailVerificationPageApiApiV1EmailVerificationConfirmPostRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiV1EmailVerificationConfirmPost(requestParameters.verificationToken, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for apiV1EmailVerificationConfirmGet operation in EmailVerificationPageApi.
 * @export
 * @interface EmailVerificationPageApiApiV1EmailVerificationConfirmGetRequest
 */
export interface EmailVerificationPageApiApiV1EmailVerificationConfirmGetRequest {
    /**
     * 
     * @type {string}
     * @memberof EmailVerificationPageApiApiV1EmailVerificationConfirmGet
     */
    readonly verificationToken?: string
}

/**
 * Request parameters for apiV1EmailVerificationConfirmPost operation in EmailVerificationPageApi.
 * @export
 * @interface EmailVerificationPageApiApiV1EmailVerificationConfirmPostRequest
 */
export interface EmailVerificationPageApiApiV1EmailVerificationConfirmPostRequest {
    /**
     * 
     * @type {string}
     * @memberof EmailVerificationPageApiApiV1EmailVerificationConfirmPost
     */
    readonly verificationToken?: string
}

/**
 * EmailVerificationPageApi - object-oriented interface
 * @export
 * @class EmailVerificationPageApi
 * @extends {BaseAPI}
 */
export class EmailVerificationPageApi extends BaseAPI {
    /**
     * 
     * @summary Открыть страницу подтверждения электронной почты
     * @param {EmailVerificationPageApiApiV1EmailVerificationConfirmGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmailVerificationPageApi
     */
    public apiV1EmailVerificationConfirmGet(requestParameters: EmailVerificationPageApiApiV1EmailVerificationConfirmGetRequest = {}, options?: RawAxiosRequestConfig) {
        return EmailVerificationPageApiFp(this.configuration).apiV1EmailVerificationConfirmGet(requestParameters.verificationToken, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Подтвердить электронную почту
     * @param {EmailVerificationPageApiApiV1EmailVerificationConfirmPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmailVerificationPageApi
     */
    public apiV1EmailVerificationConfirmPost(requestParameters: EmailVerificationPageApiApiV1EmailVerificationConfirmPostRequest = {}, options?: RawAxiosRequestConfig) {
        return EmailVerificationPageApiFp(this.configuration).apiV1EmailVerificationConfirmPost(requestParameters.verificationToken, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * EnumApi - axios parameter creator
 * @export
 */
export const EnumApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Получить Аудитории читателей блога
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBlogPostAudience: async (apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/enums/blog-post-audiences`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Получить данные Типов карточек Vox
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCardTypes: async (apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/enums/card-types`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Получить данные Тип скидки
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDiscountTypes: async (apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/enums/discount-types`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Получить Типы сущностей
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntityTypes: async (apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/enums/entity-types`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Получить Коды Ошибок
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getErrorCodes: async (apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/enums/error-codes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Получить данные Типы событий
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEventTypes: async (apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/enums/event-types`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Получить данные Типов занятости исполнителя
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getExecutorEmploymentKinds: async (apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/enums/executor-employment-kinds`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Получить данные Гендеров
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGenders: async (apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/enums/genders`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Получить данные Типы место проявления привычки
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getHabitPlaceTypes: async (apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/enums/habit-place-types`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Получить данные типов привычек
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getHabitTypes: async (apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/enums/habit-types`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Получить данные типов списания денег
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMoneyDebitType: async (apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/enums/money-debit-types`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Получить данные Тип причины отказа от заказа
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrderCancelTypes: async (apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/enums/order-cancel-types`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Получить данные Статусов заказ
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrderStatuses: async (apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/enums/order-statuses`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Получить данные Статусы платежа
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPaymentStatuses: async (apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/enums/payment-statuses`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Получить данные Типы способов оплаты
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPayoutMethodTypes: async (apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/enums/payout-method-types`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Получить данные Где будет находиться питомец
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPetPlacements: async (apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/enums/pet-placements`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Получить данные типов питомцев
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPetTypes: async (apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/enums/pet-types`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Получить Аудитории политик
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPolicyAudiences: async (apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/enums/policy-audiences`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Получить Типы политик
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPolicyTypes: async (apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/enums/policy-types`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Получить данные подтипов продуктов
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductSubTypes: async (apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/enums/product-sub-types`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Получить данные типов продуктов
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductTypes: async (apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/enums/product-types`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Получить данные Причины отказа от исполнителя
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRefusalFromExecutorTypes: async (apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/enums/refusal-from-executor-types`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Получить Типы специалистов
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSpecialistTypes: async (apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/enums/specialist-types`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Получить данные Типы тегов
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTagTypes: async (apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/enums/tag-types`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Получить данные Роли пользователя
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserRoles: async (apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/enums/user-roles`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Получить данные Кто отвезет питомца к няне
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWhoWillBringPet: async (apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/enums/who-will-bring-pet`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * EnumApi - functional programming interface
 * @export
 */
export const EnumApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = EnumApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Получить Аудитории читателей блога
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getBlogPostAudience(apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ApiBlogPostAudienceSimpleModel>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getBlogPostAudience(apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EnumApi.getBlogPostAudience']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Получить данные Типов карточек Vox
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCardTypes(apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ApiCardTypeSimpleModel>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCardTypes(apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EnumApi.getCardTypes']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Получить данные Тип скидки
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDiscountTypes(apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ApiDiscountTypeSimpleModel>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDiscountTypes(apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EnumApi.getDiscountTypes']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Получить Типы сущностей
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEntityTypes(apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ApiEntityTypeSimpleModel>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEntityTypes(apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EnumApi.getEntityTypes']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Получить Коды Ошибок
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getErrorCodes(apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<VoxErrorCodeSimpleModel>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getErrorCodes(apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EnumApi.getErrorCodes']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Получить данные Типы событий
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEventTypes(apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ApiEventTypeSimpleModel>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEventTypes(apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EnumApi.getEventTypes']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Получить данные Типов занятости исполнителя
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getExecutorEmploymentKinds(apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ApiExecutorEmploymentKindSimpleModel>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getExecutorEmploymentKinds(apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EnumApi.getExecutorEmploymentKinds']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Получить данные Гендеров
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getGenders(apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ApiGenderSimpleModel>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getGenders(apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EnumApi.getGenders']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Получить данные Типы место проявления привычки
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getHabitPlaceTypes(apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ApiHabitPlaceTypeSimpleModel>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getHabitPlaceTypes(apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EnumApi.getHabitPlaceTypes']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Получить данные типов привычек
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getHabitTypes(apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ApiHabitTypeSimpleModel>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getHabitTypes(apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EnumApi.getHabitTypes']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Получить данные типов списания денег
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMoneyDebitType(apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ApiMoneyDebitTypeSimpleModel>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMoneyDebitType(apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EnumApi.getMoneyDebitType']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Получить данные Тип причины отказа от заказа
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOrderCancelTypes(apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ApiOrderCancelTypeSimpleModel>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOrderCancelTypes(apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EnumApi.getOrderCancelTypes']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Получить данные Статусов заказ
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOrderStatuses(apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ApiOrderStatusSimpleModel>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOrderStatuses(apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EnumApi.getOrderStatuses']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Получить данные Статусы платежа
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPaymentStatuses(apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ApiPaymentStatusSimpleModel>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPaymentStatuses(apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EnumApi.getPaymentStatuses']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Получить данные Типы способов оплаты
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPayoutMethodTypes(apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ApiPayoutMethodTypeSimpleModel>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPayoutMethodTypes(apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EnumApi.getPayoutMethodTypes']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Получить данные Где будет находиться питомец
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPetPlacements(apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ApiPetPlacementSimpleModel>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPetPlacements(apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EnumApi.getPetPlacements']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Получить данные типов питомцев
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPetTypes(apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ApiPetTypeSimpleModel>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPetTypes(apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EnumApi.getPetTypes']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Получить Аудитории политик
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPolicyAudiences(apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ApiPolicyAudienceSimpleModel>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPolicyAudiences(apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EnumApi.getPolicyAudiences']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Получить Типы политик
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPolicyTypes(apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ApiPolicyTypeSimpleModel>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPolicyTypes(apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EnumApi.getPolicyTypes']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Получить данные подтипов продуктов
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProductSubTypes(apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ApiProductSubTypeSimpleModel>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProductSubTypes(apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EnumApi.getProductSubTypes']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Получить данные типов продуктов
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProductTypes(apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ApiProductTypeSimpleModel>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProductTypes(apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EnumApi.getProductTypes']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Получить данные Причины отказа от исполнителя
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRefusalFromExecutorTypes(apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ApiRefusalFromExecutorTypeSimpleModel>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRefusalFromExecutorTypes(apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EnumApi.getRefusalFromExecutorTypes']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Получить Типы специалистов
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSpecialistTypes(apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ApiSpecialistTypeSimpleModel>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSpecialistTypes(apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EnumApi.getSpecialistTypes']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Получить данные Типы тегов
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTagTypes(apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ApiTagTypeSimpleModel>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTagTypes(apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EnumApi.getTagTypes']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Получить данные Роли пользователя
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUserRoles(apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ApiUserRoleSimpleModel>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUserRoles(apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EnumApi.getUserRoles']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Получить данные Кто отвезет питомца к няне
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getWhoWillBringPet(apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ApiWhoWillBringPetSimpleModel>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getWhoWillBringPet(apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EnumApi.getWhoWillBringPet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * EnumApi - factory interface
 * @export
 */
export const EnumApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = EnumApiFp(configuration)
    return {
        /**
         * 
         * @summary Получить Аудитории читателей блога
         * @param {EnumApiGetBlogPostAudienceRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBlogPostAudience(requestParameters: EnumApiGetBlogPostAudienceRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<Array<ApiBlogPostAudienceSimpleModel>> {
            return localVarFp.getBlogPostAudience(requestParameters.apiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Получить данные Типов карточек Vox
         * @param {EnumApiGetCardTypesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCardTypes(requestParameters: EnumApiGetCardTypesRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<Array<ApiCardTypeSimpleModel>> {
            return localVarFp.getCardTypes(requestParameters.apiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Получить данные Тип скидки
         * @param {EnumApiGetDiscountTypesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDiscountTypes(requestParameters: EnumApiGetDiscountTypesRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<Array<ApiDiscountTypeSimpleModel>> {
            return localVarFp.getDiscountTypes(requestParameters.apiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Получить Типы сущностей
         * @param {EnumApiGetEntityTypesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntityTypes(requestParameters: EnumApiGetEntityTypesRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<Array<ApiEntityTypeSimpleModel>> {
            return localVarFp.getEntityTypes(requestParameters.apiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Получить Коды Ошибок
         * @param {EnumApiGetErrorCodesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getErrorCodes(requestParameters: EnumApiGetErrorCodesRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<Array<VoxErrorCodeSimpleModel>> {
            return localVarFp.getErrorCodes(requestParameters.apiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Получить данные Типы событий
         * @param {EnumApiGetEventTypesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEventTypes(requestParameters: EnumApiGetEventTypesRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<Array<ApiEventTypeSimpleModel>> {
            return localVarFp.getEventTypes(requestParameters.apiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Получить данные Типов занятости исполнителя
         * @param {EnumApiGetExecutorEmploymentKindsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getExecutorEmploymentKinds(requestParameters: EnumApiGetExecutorEmploymentKindsRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<Array<ApiExecutorEmploymentKindSimpleModel>> {
            return localVarFp.getExecutorEmploymentKinds(requestParameters.apiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Получить данные Гендеров
         * @param {EnumApiGetGendersRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGenders(requestParameters: EnumApiGetGendersRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<Array<ApiGenderSimpleModel>> {
            return localVarFp.getGenders(requestParameters.apiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Получить данные Типы место проявления привычки
         * @param {EnumApiGetHabitPlaceTypesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getHabitPlaceTypes(requestParameters: EnumApiGetHabitPlaceTypesRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<Array<ApiHabitPlaceTypeSimpleModel>> {
            return localVarFp.getHabitPlaceTypes(requestParameters.apiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Получить данные типов привычек
         * @param {EnumApiGetHabitTypesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getHabitTypes(requestParameters: EnumApiGetHabitTypesRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<Array<ApiHabitTypeSimpleModel>> {
            return localVarFp.getHabitTypes(requestParameters.apiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Получить данные типов списания денег
         * @param {EnumApiGetMoneyDebitTypeRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMoneyDebitType(requestParameters: EnumApiGetMoneyDebitTypeRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<Array<ApiMoneyDebitTypeSimpleModel>> {
            return localVarFp.getMoneyDebitType(requestParameters.apiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Получить данные Тип причины отказа от заказа
         * @param {EnumApiGetOrderCancelTypesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrderCancelTypes(requestParameters: EnumApiGetOrderCancelTypesRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<Array<ApiOrderCancelTypeSimpleModel>> {
            return localVarFp.getOrderCancelTypes(requestParameters.apiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Получить данные Статусов заказ
         * @param {EnumApiGetOrderStatusesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrderStatuses(requestParameters: EnumApiGetOrderStatusesRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<Array<ApiOrderStatusSimpleModel>> {
            return localVarFp.getOrderStatuses(requestParameters.apiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Получить данные Статусы платежа
         * @param {EnumApiGetPaymentStatusesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPaymentStatuses(requestParameters: EnumApiGetPaymentStatusesRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<Array<ApiPaymentStatusSimpleModel>> {
            return localVarFp.getPaymentStatuses(requestParameters.apiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Получить данные Типы способов оплаты
         * @param {EnumApiGetPayoutMethodTypesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPayoutMethodTypes(requestParameters: EnumApiGetPayoutMethodTypesRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<Array<ApiPayoutMethodTypeSimpleModel>> {
            return localVarFp.getPayoutMethodTypes(requestParameters.apiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Получить данные Где будет находиться питомец
         * @param {EnumApiGetPetPlacementsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPetPlacements(requestParameters: EnumApiGetPetPlacementsRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<Array<ApiPetPlacementSimpleModel>> {
            return localVarFp.getPetPlacements(requestParameters.apiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Получить данные типов питомцев
         * @param {EnumApiGetPetTypesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPetTypes(requestParameters: EnumApiGetPetTypesRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<Array<ApiPetTypeSimpleModel>> {
            return localVarFp.getPetTypes(requestParameters.apiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Получить Аудитории политик
         * @param {EnumApiGetPolicyAudiencesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPolicyAudiences(requestParameters: EnumApiGetPolicyAudiencesRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<Array<ApiPolicyAudienceSimpleModel>> {
            return localVarFp.getPolicyAudiences(requestParameters.apiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Получить Типы политик
         * @param {EnumApiGetPolicyTypesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPolicyTypes(requestParameters: EnumApiGetPolicyTypesRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<Array<ApiPolicyTypeSimpleModel>> {
            return localVarFp.getPolicyTypes(requestParameters.apiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Получить данные подтипов продуктов
         * @param {EnumApiGetProductSubTypesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductSubTypes(requestParameters: EnumApiGetProductSubTypesRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<Array<ApiProductSubTypeSimpleModel>> {
            return localVarFp.getProductSubTypes(requestParameters.apiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Получить данные типов продуктов
         * @param {EnumApiGetProductTypesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductTypes(requestParameters: EnumApiGetProductTypesRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<Array<ApiProductTypeSimpleModel>> {
            return localVarFp.getProductTypes(requestParameters.apiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Получить данные Причины отказа от исполнителя
         * @param {EnumApiGetRefusalFromExecutorTypesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRefusalFromExecutorTypes(requestParameters: EnumApiGetRefusalFromExecutorTypesRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<Array<ApiRefusalFromExecutorTypeSimpleModel>> {
            return localVarFp.getRefusalFromExecutorTypes(requestParameters.apiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Получить Типы специалистов
         * @param {EnumApiGetSpecialistTypesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSpecialistTypes(requestParameters: EnumApiGetSpecialistTypesRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<Array<ApiSpecialistTypeSimpleModel>> {
            return localVarFp.getSpecialistTypes(requestParameters.apiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Получить данные Типы тегов
         * @param {EnumApiGetTagTypesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTagTypes(requestParameters: EnumApiGetTagTypesRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<Array<ApiTagTypeSimpleModel>> {
            return localVarFp.getTagTypes(requestParameters.apiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Получить данные Роли пользователя
         * @param {EnumApiGetUserRolesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserRoles(requestParameters: EnumApiGetUserRolesRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<Array<ApiUserRoleSimpleModel>> {
            return localVarFp.getUserRoles(requestParameters.apiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Получить данные Кто отвезет питомца к няне
         * @param {EnumApiGetWhoWillBringPetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWhoWillBringPet(requestParameters: EnumApiGetWhoWillBringPetRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<Array<ApiWhoWillBringPetSimpleModel>> {
            return localVarFp.getWhoWillBringPet(requestParameters.apiVersion, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for getBlogPostAudience operation in EnumApi.
 * @export
 * @interface EnumApiGetBlogPostAudienceRequest
 */
export interface EnumApiGetBlogPostAudienceRequest {
    /**
     * 
     * @type {string}
     * @memberof EnumApiGetBlogPostAudience
     */
    readonly apiVersion?: string
}

/**
 * Request parameters for getCardTypes operation in EnumApi.
 * @export
 * @interface EnumApiGetCardTypesRequest
 */
export interface EnumApiGetCardTypesRequest {
    /**
     * 
     * @type {string}
     * @memberof EnumApiGetCardTypes
     */
    readonly apiVersion?: string
}

/**
 * Request parameters for getDiscountTypes operation in EnumApi.
 * @export
 * @interface EnumApiGetDiscountTypesRequest
 */
export interface EnumApiGetDiscountTypesRequest {
    /**
     * 
     * @type {string}
     * @memberof EnumApiGetDiscountTypes
     */
    readonly apiVersion?: string
}

/**
 * Request parameters for getEntityTypes operation in EnumApi.
 * @export
 * @interface EnumApiGetEntityTypesRequest
 */
export interface EnumApiGetEntityTypesRequest {
    /**
     * 
     * @type {string}
     * @memberof EnumApiGetEntityTypes
     */
    readonly apiVersion?: string
}

/**
 * Request parameters for getErrorCodes operation in EnumApi.
 * @export
 * @interface EnumApiGetErrorCodesRequest
 */
export interface EnumApiGetErrorCodesRequest {
    /**
     * 
     * @type {string}
     * @memberof EnumApiGetErrorCodes
     */
    readonly apiVersion?: string
}

/**
 * Request parameters for getEventTypes operation in EnumApi.
 * @export
 * @interface EnumApiGetEventTypesRequest
 */
export interface EnumApiGetEventTypesRequest {
    /**
     * 
     * @type {string}
     * @memberof EnumApiGetEventTypes
     */
    readonly apiVersion?: string
}

/**
 * Request parameters for getExecutorEmploymentKinds operation in EnumApi.
 * @export
 * @interface EnumApiGetExecutorEmploymentKindsRequest
 */
export interface EnumApiGetExecutorEmploymentKindsRequest {
    /**
     * 
     * @type {string}
     * @memberof EnumApiGetExecutorEmploymentKinds
     */
    readonly apiVersion?: string
}

/**
 * Request parameters for getGenders operation in EnumApi.
 * @export
 * @interface EnumApiGetGendersRequest
 */
export interface EnumApiGetGendersRequest {
    /**
     * 
     * @type {string}
     * @memberof EnumApiGetGenders
     */
    readonly apiVersion?: string
}

/**
 * Request parameters for getHabitPlaceTypes operation in EnumApi.
 * @export
 * @interface EnumApiGetHabitPlaceTypesRequest
 */
export interface EnumApiGetHabitPlaceTypesRequest {
    /**
     * 
     * @type {string}
     * @memberof EnumApiGetHabitPlaceTypes
     */
    readonly apiVersion?: string
}

/**
 * Request parameters for getHabitTypes operation in EnumApi.
 * @export
 * @interface EnumApiGetHabitTypesRequest
 */
export interface EnumApiGetHabitTypesRequest {
    /**
     * 
     * @type {string}
     * @memberof EnumApiGetHabitTypes
     */
    readonly apiVersion?: string
}

/**
 * Request parameters for getMoneyDebitType operation in EnumApi.
 * @export
 * @interface EnumApiGetMoneyDebitTypeRequest
 */
export interface EnumApiGetMoneyDebitTypeRequest {
    /**
     * 
     * @type {string}
     * @memberof EnumApiGetMoneyDebitType
     */
    readonly apiVersion?: string
}

/**
 * Request parameters for getOrderCancelTypes operation in EnumApi.
 * @export
 * @interface EnumApiGetOrderCancelTypesRequest
 */
export interface EnumApiGetOrderCancelTypesRequest {
    /**
     * 
     * @type {string}
     * @memberof EnumApiGetOrderCancelTypes
     */
    readonly apiVersion?: string
}

/**
 * Request parameters for getOrderStatuses operation in EnumApi.
 * @export
 * @interface EnumApiGetOrderStatusesRequest
 */
export interface EnumApiGetOrderStatusesRequest {
    /**
     * 
     * @type {string}
     * @memberof EnumApiGetOrderStatuses
     */
    readonly apiVersion?: string
}

/**
 * Request parameters for getPaymentStatuses operation in EnumApi.
 * @export
 * @interface EnumApiGetPaymentStatusesRequest
 */
export interface EnumApiGetPaymentStatusesRequest {
    /**
     * 
     * @type {string}
     * @memberof EnumApiGetPaymentStatuses
     */
    readonly apiVersion?: string
}

/**
 * Request parameters for getPayoutMethodTypes operation in EnumApi.
 * @export
 * @interface EnumApiGetPayoutMethodTypesRequest
 */
export interface EnumApiGetPayoutMethodTypesRequest {
    /**
     * 
     * @type {string}
     * @memberof EnumApiGetPayoutMethodTypes
     */
    readonly apiVersion?: string
}

/**
 * Request parameters for getPetPlacements operation in EnumApi.
 * @export
 * @interface EnumApiGetPetPlacementsRequest
 */
export interface EnumApiGetPetPlacementsRequest {
    /**
     * 
     * @type {string}
     * @memberof EnumApiGetPetPlacements
     */
    readonly apiVersion?: string
}

/**
 * Request parameters for getPetTypes operation in EnumApi.
 * @export
 * @interface EnumApiGetPetTypesRequest
 */
export interface EnumApiGetPetTypesRequest {
    /**
     * 
     * @type {string}
     * @memberof EnumApiGetPetTypes
     */
    readonly apiVersion?: string
}

/**
 * Request parameters for getPolicyAudiences operation in EnumApi.
 * @export
 * @interface EnumApiGetPolicyAudiencesRequest
 */
export interface EnumApiGetPolicyAudiencesRequest {
    /**
     * 
     * @type {string}
     * @memberof EnumApiGetPolicyAudiences
     */
    readonly apiVersion?: string
}

/**
 * Request parameters for getPolicyTypes operation in EnumApi.
 * @export
 * @interface EnumApiGetPolicyTypesRequest
 */
export interface EnumApiGetPolicyTypesRequest {
    /**
     * 
     * @type {string}
     * @memberof EnumApiGetPolicyTypes
     */
    readonly apiVersion?: string
}

/**
 * Request parameters for getProductSubTypes operation in EnumApi.
 * @export
 * @interface EnumApiGetProductSubTypesRequest
 */
export interface EnumApiGetProductSubTypesRequest {
    /**
     * 
     * @type {string}
     * @memberof EnumApiGetProductSubTypes
     */
    readonly apiVersion?: string
}

/**
 * Request parameters for getProductTypes operation in EnumApi.
 * @export
 * @interface EnumApiGetProductTypesRequest
 */
export interface EnumApiGetProductTypesRequest {
    /**
     * 
     * @type {string}
     * @memberof EnumApiGetProductTypes
     */
    readonly apiVersion?: string
}

/**
 * Request parameters for getRefusalFromExecutorTypes operation in EnumApi.
 * @export
 * @interface EnumApiGetRefusalFromExecutorTypesRequest
 */
export interface EnumApiGetRefusalFromExecutorTypesRequest {
    /**
     * 
     * @type {string}
     * @memberof EnumApiGetRefusalFromExecutorTypes
     */
    readonly apiVersion?: string
}

/**
 * Request parameters for getSpecialistTypes operation in EnumApi.
 * @export
 * @interface EnumApiGetSpecialistTypesRequest
 */
export interface EnumApiGetSpecialistTypesRequest {
    /**
     * 
     * @type {string}
     * @memberof EnumApiGetSpecialistTypes
     */
    readonly apiVersion?: string
}

/**
 * Request parameters for getTagTypes operation in EnumApi.
 * @export
 * @interface EnumApiGetTagTypesRequest
 */
export interface EnumApiGetTagTypesRequest {
    /**
     * 
     * @type {string}
     * @memberof EnumApiGetTagTypes
     */
    readonly apiVersion?: string
}

/**
 * Request parameters for getUserRoles operation in EnumApi.
 * @export
 * @interface EnumApiGetUserRolesRequest
 */
export interface EnumApiGetUserRolesRequest {
    /**
     * 
     * @type {string}
     * @memberof EnumApiGetUserRoles
     */
    readonly apiVersion?: string
}

/**
 * Request parameters for getWhoWillBringPet operation in EnumApi.
 * @export
 * @interface EnumApiGetWhoWillBringPetRequest
 */
export interface EnumApiGetWhoWillBringPetRequest {
    /**
     * 
     * @type {string}
     * @memberof EnumApiGetWhoWillBringPet
     */
    readonly apiVersion?: string
}

/**
 * EnumApi - object-oriented interface
 * @export
 * @class EnumApi
 * @extends {BaseAPI}
 */
export class EnumApi extends BaseAPI {
    /**
     * 
     * @summary Получить Аудитории читателей блога
     * @param {EnumApiGetBlogPostAudienceRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EnumApi
     */
    public getBlogPostAudience(requestParameters: EnumApiGetBlogPostAudienceRequest = {}, options?: RawAxiosRequestConfig) {
        return EnumApiFp(this.configuration).getBlogPostAudience(requestParameters.apiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Получить данные Типов карточек Vox
     * @param {EnumApiGetCardTypesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EnumApi
     */
    public getCardTypes(requestParameters: EnumApiGetCardTypesRequest = {}, options?: RawAxiosRequestConfig) {
        return EnumApiFp(this.configuration).getCardTypes(requestParameters.apiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Получить данные Тип скидки
     * @param {EnumApiGetDiscountTypesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EnumApi
     */
    public getDiscountTypes(requestParameters: EnumApiGetDiscountTypesRequest = {}, options?: RawAxiosRequestConfig) {
        return EnumApiFp(this.configuration).getDiscountTypes(requestParameters.apiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Получить Типы сущностей
     * @param {EnumApiGetEntityTypesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EnumApi
     */
    public getEntityTypes(requestParameters: EnumApiGetEntityTypesRequest = {}, options?: RawAxiosRequestConfig) {
        return EnumApiFp(this.configuration).getEntityTypes(requestParameters.apiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Получить Коды Ошибок
     * @param {EnumApiGetErrorCodesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EnumApi
     */
    public getErrorCodes(requestParameters: EnumApiGetErrorCodesRequest = {}, options?: RawAxiosRequestConfig) {
        return EnumApiFp(this.configuration).getErrorCodes(requestParameters.apiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Получить данные Типы событий
     * @param {EnumApiGetEventTypesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EnumApi
     */
    public getEventTypes(requestParameters: EnumApiGetEventTypesRequest = {}, options?: RawAxiosRequestConfig) {
        return EnumApiFp(this.configuration).getEventTypes(requestParameters.apiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Получить данные Типов занятости исполнителя
     * @param {EnumApiGetExecutorEmploymentKindsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EnumApi
     */
    public getExecutorEmploymentKinds(requestParameters: EnumApiGetExecutorEmploymentKindsRequest = {}, options?: RawAxiosRequestConfig) {
        return EnumApiFp(this.configuration).getExecutorEmploymentKinds(requestParameters.apiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Получить данные Гендеров
     * @param {EnumApiGetGendersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EnumApi
     */
    public getGenders(requestParameters: EnumApiGetGendersRequest = {}, options?: RawAxiosRequestConfig) {
        return EnumApiFp(this.configuration).getGenders(requestParameters.apiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Получить данные Типы место проявления привычки
     * @param {EnumApiGetHabitPlaceTypesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EnumApi
     */
    public getHabitPlaceTypes(requestParameters: EnumApiGetHabitPlaceTypesRequest = {}, options?: RawAxiosRequestConfig) {
        return EnumApiFp(this.configuration).getHabitPlaceTypes(requestParameters.apiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Получить данные типов привычек
     * @param {EnumApiGetHabitTypesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EnumApi
     */
    public getHabitTypes(requestParameters: EnumApiGetHabitTypesRequest = {}, options?: RawAxiosRequestConfig) {
        return EnumApiFp(this.configuration).getHabitTypes(requestParameters.apiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Получить данные типов списания денег
     * @param {EnumApiGetMoneyDebitTypeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EnumApi
     */
    public getMoneyDebitType(requestParameters: EnumApiGetMoneyDebitTypeRequest = {}, options?: RawAxiosRequestConfig) {
        return EnumApiFp(this.configuration).getMoneyDebitType(requestParameters.apiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Получить данные Тип причины отказа от заказа
     * @param {EnumApiGetOrderCancelTypesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EnumApi
     */
    public getOrderCancelTypes(requestParameters: EnumApiGetOrderCancelTypesRequest = {}, options?: RawAxiosRequestConfig) {
        return EnumApiFp(this.configuration).getOrderCancelTypes(requestParameters.apiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Получить данные Статусов заказ
     * @param {EnumApiGetOrderStatusesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EnumApi
     */
    public getOrderStatuses(requestParameters: EnumApiGetOrderStatusesRequest = {}, options?: RawAxiosRequestConfig) {
        return EnumApiFp(this.configuration).getOrderStatuses(requestParameters.apiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Получить данные Статусы платежа
     * @param {EnumApiGetPaymentStatusesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EnumApi
     */
    public getPaymentStatuses(requestParameters: EnumApiGetPaymentStatusesRequest = {}, options?: RawAxiosRequestConfig) {
        return EnumApiFp(this.configuration).getPaymentStatuses(requestParameters.apiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Получить данные Типы способов оплаты
     * @param {EnumApiGetPayoutMethodTypesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EnumApi
     */
    public getPayoutMethodTypes(requestParameters: EnumApiGetPayoutMethodTypesRequest = {}, options?: RawAxiosRequestConfig) {
        return EnumApiFp(this.configuration).getPayoutMethodTypes(requestParameters.apiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Получить данные Где будет находиться питомец
     * @param {EnumApiGetPetPlacementsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EnumApi
     */
    public getPetPlacements(requestParameters: EnumApiGetPetPlacementsRequest = {}, options?: RawAxiosRequestConfig) {
        return EnumApiFp(this.configuration).getPetPlacements(requestParameters.apiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Получить данные типов питомцев
     * @param {EnumApiGetPetTypesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EnumApi
     */
    public getPetTypes(requestParameters: EnumApiGetPetTypesRequest = {}, options?: RawAxiosRequestConfig) {
        return EnumApiFp(this.configuration).getPetTypes(requestParameters.apiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Получить Аудитории политик
     * @param {EnumApiGetPolicyAudiencesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EnumApi
     */
    public getPolicyAudiences(requestParameters: EnumApiGetPolicyAudiencesRequest = {}, options?: RawAxiosRequestConfig) {
        return EnumApiFp(this.configuration).getPolicyAudiences(requestParameters.apiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Получить Типы политик
     * @param {EnumApiGetPolicyTypesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EnumApi
     */
    public getPolicyTypes(requestParameters: EnumApiGetPolicyTypesRequest = {}, options?: RawAxiosRequestConfig) {
        return EnumApiFp(this.configuration).getPolicyTypes(requestParameters.apiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Получить данные подтипов продуктов
     * @param {EnumApiGetProductSubTypesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EnumApi
     */
    public getProductSubTypes(requestParameters: EnumApiGetProductSubTypesRequest = {}, options?: RawAxiosRequestConfig) {
        return EnumApiFp(this.configuration).getProductSubTypes(requestParameters.apiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Получить данные типов продуктов
     * @param {EnumApiGetProductTypesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EnumApi
     */
    public getProductTypes(requestParameters: EnumApiGetProductTypesRequest = {}, options?: RawAxiosRequestConfig) {
        return EnumApiFp(this.configuration).getProductTypes(requestParameters.apiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Получить данные Причины отказа от исполнителя
     * @param {EnumApiGetRefusalFromExecutorTypesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EnumApi
     */
    public getRefusalFromExecutorTypes(requestParameters: EnumApiGetRefusalFromExecutorTypesRequest = {}, options?: RawAxiosRequestConfig) {
        return EnumApiFp(this.configuration).getRefusalFromExecutorTypes(requestParameters.apiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Получить Типы специалистов
     * @param {EnumApiGetSpecialistTypesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EnumApi
     */
    public getSpecialistTypes(requestParameters: EnumApiGetSpecialistTypesRequest = {}, options?: RawAxiosRequestConfig) {
        return EnumApiFp(this.configuration).getSpecialistTypes(requestParameters.apiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Получить данные Типы тегов
     * @param {EnumApiGetTagTypesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EnumApi
     */
    public getTagTypes(requestParameters: EnumApiGetTagTypesRequest = {}, options?: RawAxiosRequestConfig) {
        return EnumApiFp(this.configuration).getTagTypes(requestParameters.apiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Получить данные Роли пользователя
     * @param {EnumApiGetUserRolesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EnumApi
     */
    public getUserRoles(requestParameters: EnumApiGetUserRolesRequest = {}, options?: RawAxiosRequestConfig) {
        return EnumApiFp(this.configuration).getUserRoles(requestParameters.apiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Получить данные Кто отвезет питомца к няне
     * @param {EnumApiGetWhoWillBringPetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EnumApi
     */
    public getWhoWillBringPet(requestParameters: EnumApiGetWhoWillBringPetRequest = {}, options?: RawAxiosRequestConfig) {
        return EnumApiFp(this.configuration).getWhoWillBringPet(requestParameters.apiVersion, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * EventApi - axios parameter creator
 * @export
 */
export const EventApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Получить события с фильтрацией, сортировкой и пагинацией
         * @param {string} [apiVersion] 
         * @param {GetEventsRequest} [getEventsRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEvents: async (apiVersion?: string, getEventsRequest?: GetEventsRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/events/get-events`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(getEventsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * EventApi - functional programming interface
 * @export
 */
export const EventApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = EventApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Получить события с фильтрацией, сортировкой и пагинацией
         * @param {string} [apiVersion] 
         * @param {GetEventsRequest} [getEventsRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEvents(apiVersion?: string, getEventsRequest?: GetEventsRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetEventsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEvents(apiVersion, getEventsRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EventApi.getEvents']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * EventApi - factory interface
 * @export
 */
export const EventApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = EventApiFp(configuration)
    return {
        /**
         * 
         * @summary Получить события с фильтрацией, сортировкой и пагинацией
         * @param {EventApiGetEventsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEvents(requestParameters: EventApiGetEventsRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<GetEventsResponse> {
            return localVarFp.getEvents(requestParameters.apiVersion, requestParameters.getEventsRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for getEvents operation in EventApi.
 * @export
 * @interface EventApiGetEventsRequest
 */
export interface EventApiGetEventsRequest {
    /**
     * 
     * @type {string}
     * @memberof EventApiGetEvents
     */
    readonly apiVersion?: string

    /**
     * 
     * @type {GetEventsRequest}
     * @memberof EventApiGetEvents
     */
    readonly getEventsRequest?: GetEventsRequest
}

/**
 * EventApi - object-oriented interface
 * @export
 * @class EventApi
 * @extends {BaseAPI}
 */
export class EventApi extends BaseAPI {
    /**
     * 
     * @summary Получить события с фильтрацией, сортировкой и пагинацией
     * @param {EventApiGetEventsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventApi
     */
    public getEvents(requestParameters: EventApiGetEventsRequest = {}, options?: RawAxiosRequestConfig) {
        return EventApiFp(this.configuration).getEvents(requestParameters.apiVersion, requestParameters.getEventsRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ExecutorApi - axios parameter creator
 * @export
 */
export const ExecutorApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Назначить штраф исполнителю администратором
         * @param {string} executorId 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignExecutorPenalty: async (executorId: string, apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'executorId' is not null or undefined
            assertParamExists('assignExecutorPenalty', 'executorId', executorId)
            const localVarPath = `/executors/{executorId}/assign-penalty`
                .replace(`{${"executorId"}}`, encodeURIComponent(String(executorId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Заблокировать профиль Исполнителя
         * @param {string} executorId 
         * @param {string} [apiVersion] 
         * @param {BlockRequest} [blockRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        blockExecutor: async (executorId: string, apiVersion?: string, blockRequest?: BlockRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'executorId' is not null or undefined
            assertParamExists('blockExecutor', 'executorId', executorId)
            const localVarPath = `/executors/block/{executorId}`
                .replace(`{${"executorId"}}`, encodeURIComponent(String(executorId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(blockRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Создать профиль исполнителя
         * @param {string} [apiVersion] 
         * @param {CreateExecutorRequest} [createExecutorRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createExecutor: async (apiVersion?: string, createExecutorRequest?: CreateExecutorRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/executors/create`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createExecutorRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Создать профиль исполнителя
         * @param {string} [apiVersion] 
         * @param {CreateExecutorByAdminRequest} [createExecutorByAdminRequest] Модель запроса с данными исполнителя
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createExecutorByAdmin: async (apiVersion?: string, createExecutorByAdminRequest?: CreateExecutorByAdminRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/executors/create-executor-by-admin`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createExecutorByAdminRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Удалить профиль Исполнителя
         * @param {string} executorId 
         * @param {string} [apiVersion] 
         * @param {DeleteRequest} [deleteRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteExecutor: async (executorId: string, apiVersion?: string, deleteRequest?: DeleteRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'executorId' is not null or undefined
            assertParamExists('deleteExecutor', 'executorId', executorId)
            const localVarPath = `/executors/delete/{executorId}`
                .replace(`{${"executorId"}}`, encodeURIComponent(String(executorId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(deleteRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Получить исполнителя по пользователю приложения
         * @param {string} appUserId Идентификатор пользователя приложения
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getExecutorByAppUserId: async (appUserId: string, apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'appUserId' is not null or undefined
            assertParamExists('getExecutorByAppUserId', 'appUserId', appUserId)
            const localVarPath = `/executors/byAppUserId/{appUserId}`
                .replace(`{${"appUserId"}}`, encodeURIComponent(String(appUserId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Получить данные исполнителя
         * @param {string} executorId Идентификатор исполнителя
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getExecutorById: async (executorId: string, apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'executorId' is not null or undefined
            assertParamExists('getExecutorById', 'executorId', executorId)
            const localVarPath = `/executors/{executorId}`
                .replace(`{${"executorId"}}`, encodeURIComponent(String(executorId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Получить данные исполнителей
         * @param {string} [createdFrom] Дата регистрации: начало периода
         * @param {string} [createdTo] Дата регистрации: конец периода
         * @param {string} [firstNameSearch] Поиск по Имени
         * @param {string} [lastNameSearch] Поиск по Фамилии
         * @param {string} [phoneSearch] Поиск по номеру телефона
         * @param {number} [cityId] Идентификатор города
         * @param {boolean} [hasRocketWork] Привязан ли профиль RocketWork
         * @param {boolean} [isVerified] Верифицирован ли
         * @param {boolean} [hasPenalty] Имеется ли штраф
         * @param {string} [searchQuery] Строка для поиска
         * @param {number} [takeCount] Размер страницы
         * @param {number} [skipCount] Кол-во пропущенных записей
         * @param {boolean} [ascending] Сортировка по возрастанию
         * @param {string} [ordering] Поле для сортировки
         * @param {boolean} [isDeleted] Удалённые записи
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getExecutors: async (createdFrom?: string, createdTo?: string, firstNameSearch?: string, lastNameSearch?: string, phoneSearch?: string, cityId?: number, hasRocketWork?: boolean, isVerified?: boolean, hasPenalty?: boolean, searchQuery?: string, takeCount?: number, skipCount?: number, ascending?: boolean, ordering?: string, isDeleted?: boolean, apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/executors/get-executors`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (createdFrom !== undefined) {
                localVarQueryParameter['CreatedFrom'] = (createdFrom as any instanceof Date) ?
                    (createdFrom as any).toISOString() :
                    createdFrom;
            }

            if (createdTo !== undefined) {
                localVarQueryParameter['CreatedTo'] = (createdTo as any instanceof Date) ?
                    (createdTo as any).toISOString() :
                    createdTo;
            }

            if (firstNameSearch !== undefined) {
                localVarQueryParameter['FirstNameSearch'] = firstNameSearch;
            }

            if (lastNameSearch !== undefined) {
                localVarQueryParameter['LastNameSearch'] = lastNameSearch;
            }

            if (phoneSearch !== undefined) {
                localVarQueryParameter['PhoneSearch'] = phoneSearch;
            }

            if (cityId !== undefined) {
                localVarQueryParameter['CityId'] = cityId;
            }

            if (hasRocketWork !== undefined) {
                localVarQueryParameter['HasRocketWork'] = hasRocketWork;
            }

            if (isVerified !== undefined) {
                localVarQueryParameter['IsVerified'] = isVerified;
            }

            if (hasPenalty !== undefined) {
                localVarQueryParameter['HasPenalty'] = hasPenalty;
            }

            if (searchQuery !== undefined) {
                localVarQueryParameter['SearchQuery'] = searchQuery;
            }

            if (takeCount !== undefined) {
                localVarQueryParameter['TakeCount'] = takeCount;
            }

            if (skipCount !== undefined) {
                localVarQueryParameter['SkipCount'] = skipCount;
            }

            if (ascending !== undefined) {
                localVarQueryParameter['Ascending'] = ascending;
            }

            if (ordering !== undefined) {
                localVarQueryParameter['Ordering'] = ordering;
            }

            if (isDeleted !== undefined) {
                localVarQueryParameter['IsDeleted'] = isDeleted;
            }


    
            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Зарегистрировать паспортные данные исполнителя
         * @param {string} executorId Идентификатор исполнителя
         * @param {string} [apiVersion] 
         * @param {PassportDetailsRequest} [passportDetailsRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        registrationPassportDetails: async (executorId: string, apiVersion?: string, passportDetailsRequest?: PassportDetailsRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'executorId' is not null or undefined
            assertParamExists('registrationPassportDetails', 'executorId', executorId)
            const localVarPath = `/executors/registration-passport-details/{executorId}`
                .replace(`{${"executorId"}}`, encodeURIComponent(String(executorId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(passportDetailsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Снять штраф исполнителя администратором
         * @param {string} executorId 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeExecutorPenalty: async (executorId: string, apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'executorId' is not null or undefined
            assertParamExists('removeExecutorPenalty', 'executorId', executorId)
            const localVarPath = `/executors/{executorId}/remove-penalty`
                .replace(`{${"executorId"}}`, encodeURIComponent(String(executorId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Найти исполнителя в RocketWork по ИНН
         * @param {string} inn 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchExecutorInRocketWorkByInn: async (inn: string, apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'inn' is not null or undefined
            assertParamExists('searchExecutorInRocketWorkByInn', 'inn', inn)
            const localVarPath = `/executors/search-executor-in-rocket-work-by-inn/{inn}`
                .replace(`{${"inn"}}`, encodeURIComponent(String(inn)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Найти исполнителя в RocketWork по телефону
         * @param {string} phone 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchExecutorInRocketWorkByPhone: async (phone: string, apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'phone' is not null or undefined
            assertParamExists('searchExecutorInRocketWorkByPhone', 'phone', phone)
            const localVarPath = `/executors/search-executor-in-rocket-work-by-phone/{phone}`
                .replace(`{${"phone"}}`, encodeURIComponent(String(phone)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Установить данные \"О себе\"
         * @param {string} executorId 
         * @param {string} [apiVersion] 
         * @param {SetAboutMyselfRequest} [setAboutMyselfRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setAboutMyself: async (executorId: string, apiVersion?: string, setAboutMyselfRequest?: SetAboutMyselfRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'executorId' is not null or undefined
            assertParamExists('setAboutMyself', 'executorId', executorId)
            const localVarPath = `/executors/set-about-myself/{executorId}`
                .replace(`{${"executorId"}}`, encodeURIComponent(String(executorId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(setAboutMyselfRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Закрыть исполнителя для работы
         * @param {string} executorId 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setCloseToWorkStatus: async (executorId: string, apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'executorId' is not null or undefined
            assertParamExists('setCloseToWorkStatus', 'executorId', executorId)
            const localVarPath = `/executors/set-close-to-work-status/{executorId}`
                .replace(`{${"executorId"}}`, encodeURIComponent(String(executorId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Установить электронную почту исполнителя
         * @param {string} [apiVersion] 
         * @param {SetExecutorEmailRequest} [setExecutorEmailRequest] Модель запроса
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setExecutorEmail: async (apiVersion?: string, setExecutorEmailRequest?: SetExecutorEmailRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/executors/set-executor-email`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(setExecutorEmailRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Обновить фотографию профиля исполнителя
         * @param {string} [apiVersion] 
         * @param {SetExecutorPhotoRequest} [setExecutorPhotoRequest] Модель запроса
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setExecutorPhoto: async (apiVersion?: string, setExecutorPhotoRequest?: SetExecutorPhotoRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/executors/set-executor-photo`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(setExecutorPhotoRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Открыть исполнителя для работы
         * @param {string} executorId 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setOpenToWorkStatus: async (executorId: string, apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'executorId' is not null or undefined
            assertParamExists('setOpenToWorkStatus', 'executorId', executorId)
            const localVarPath = `/executors/set-open-to-work-status/{executorId}`
                .replace(`{${"executorId"}}`, encodeURIComponent(String(executorId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Перенести профиль исполнителя на другой телефон
         * @param {string} profileId 
         * @param {string} [apiVersion] 
         * @param {TransferProfilePhoneRequest} [transferProfilePhoneRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        transferExecutorPhone: async (profileId: string, apiVersion?: string, transferProfilePhoneRequest?: TransferProfilePhoneRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'profileId' is not null or undefined
            assertParamExists('transferExecutorPhone', 'profileId', profileId)
            const localVarPath = `/api/v1/executors/{profileId}/transfer-phone`
                .replace(`{${"profileId"}}`, encodeURIComponent(String(profileId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(transferProfilePhoneRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Разблокировать профиль Исполнителя
         * @param {string} executorId 
         * @param {string} [apiVersion] 
         * @param {UnblockRequest} [unblockRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unblockExecutor: async (executorId: string, apiVersion?: string, unblockRequest?: UnblockRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'executorId' is not null or undefined
            assertParamExists('unblockExecutor', 'executorId', executorId)
            const localVarPath = `/executors/unblock/{executorId}`
                .replace(`{${"executorId"}}`, encodeURIComponent(String(executorId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(unblockRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Обновить данные исполнителя
         * @param {string} [executorId] Идентификатор исполнителя
         * @param {string} [apiVersion] 
         * @param {UpdateExecutorRequest} [updateExecutorRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateExecutor: async (executorId?: string, apiVersion?: string, updateExecutorRequest?: UpdateExecutorRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/executors/update`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (executorId !== undefined) {
                localVarQueryParameter['executorId'] = executorId;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateExecutorRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Обновить профиль исполнителя
         * @param {string} [executorId] Идентификатор исполнителя
         * @param {string} [apiVersion] 
         * @param {UpdateExecutorByAdminRequest} [updateExecutorByAdminRequest] Модель запроса с данными исполнителя
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateExecutorByAdmin: async (executorId?: string, apiVersion?: string, updateExecutorByAdminRequest?: UpdateExecutorByAdminRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/executors/update-executor-by-admin`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (executorId !== undefined) {
                localVarQueryParameter['executorId'] = executorId;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateExecutorByAdminRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Верифицировать исполнителя
         * @param {string} executorId Идентификатор исполнителя
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        verifyExecutor: async (executorId: string, apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'executorId' is not null or undefined
            assertParamExists('verifyExecutor', 'executorId', executorId)
            const localVarPath = `/executors/{executorId}/verify`
                .replace(`{${"executorId"}}`, encodeURIComponent(String(executorId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ExecutorApi - functional programming interface
 * @export
 */
export const ExecutorApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ExecutorApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Назначить штраф исполнителю администратором
         * @param {string} executorId 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async assignExecutorPenalty(executorId: string, apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.assignExecutorPenalty(executorId, apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ExecutorApi.assignExecutorPenalty']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Заблокировать профиль Исполнителя
         * @param {string} executorId 
         * @param {string} [apiVersion] 
         * @param {BlockRequest} [blockRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async blockExecutor(executorId: string, apiVersion?: string, blockRequest?: BlockRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.blockExecutor(executorId, apiVersion, blockRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ExecutorApi.blockExecutor']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Создать профиль исполнителя
         * @param {string} [apiVersion] 
         * @param {CreateExecutorRequest} [createExecutorRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createExecutor(apiVersion?: string, createExecutorRequest?: CreateExecutorRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ExecutorResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createExecutor(apiVersion, createExecutorRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ExecutorApi.createExecutor']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Создать профиль исполнителя
         * @param {string} [apiVersion] 
         * @param {CreateExecutorByAdminRequest} [createExecutorByAdminRequest] Модель запроса с данными исполнителя
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createExecutorByAdmin(apiVersion?: string, createExecutorByAdminRequest?: CreateExecutorByAdminRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ExecutorResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createExecutorByAdmin(apiVersion, createExecutorByAdminRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ExecutorApi.createExecutorByAdmin']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Удалить профиль Исполнителя
         * @param {string} executorId 
         * @param {string} [apiVersion] 
         * @param {DeleteRequest} [deleteRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteExecutor(executorId: string, apiVersion?: string, deleteRequest?: DeleteRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteExecutor(executorId, apiVersion, deleteRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ExecutorApi.deleteExecutor']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Получить исполнителя по пользователю приложения
         * @param {string} appUserId Идентификатор пользователя приложения
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getExecutorByAppUserId(appUserId: string, apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ExecutorResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getExecutorByAppUserId(appUserId, apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ExecutorApi.getExecutorByAppUserId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Получить данные исполнителя
         * @param {string} executorId Идентификатор исполнителя
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getExecutorById(executorId: string, apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ExecutorResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getExecutorById(executorId, apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ExecutorApi.getExecutorById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Получить данные исполнителей
         * @param {string} [createdFrom] Дата регистрации: начало периода
         * @param {string} [createdTo] Дата регистрации: конец периода
         * @param {string} [firstNameSearch] Поиск по Имени
         * @param {string} [lastNameSearch] Поиск по Фамилии
         * @param {string} [phoneSearch] Поиск по номеру телефона
         * @param {number} [cityId] Идентификатор города
         * @param {boolean} [hasRocketWork] Привязан ли профиль RocketWork
         * @param {boolean} [isVerified] Верифицирован ли
         * @param {boolean} [hasPenalty] Имеется ли штраф
         * @param {string} [searchQuery] Строка для поиска
         * @param {number} [takeCount] Размер страницы
         * @param {number} [skipCount] Кол-во пропущенных записей
         * @param {boolean} [ascending] Сортировка по возрастанию
         * @param {string} [ordering] Поле для сортировки
         * @param {boolean} [isDeleted] Удалённые записи
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getExecutors(createdFrom?: string, createdTo?: string, firstNameSearch?: string, lastNameSearch?: string, phoneSearch?: string, cityId?: number, hasRocketWork?: boolean, isVerified?: boolean, hasPenalty?: boolean, searchQuery?: string, takeCount?: number, skipCount?: number, ascending?: boolean, ordering?: string, isDeleted?: boolean, apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetExecutorsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getExecutors(createdFrom, createdTo, firstNameSearch, lastNameSearch, phoneSearch, cityId, hasRocketWork, isVerified, hasPenalty, searchQuery, takeCount, skipCount, ascending, ordering, isDeleted, apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ExecutorApi.getExecutors']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Зарегистрировать паспортные данные исполнителя
         * @param {string} executorId Идентификатор исполнителя
         * @param {string} [apiVersion] 
         * @param {PassportDetailsRequest} [passportDetailsRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async registrationPassportDetails(executorId: string, apiVersion?: string, passportDetailsRequest?: PassportDetailsRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ExecutorResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.registrationPassportDetails(executorId, apiVersion, passportDetailsRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ExecutorApi.registrationPassportDetails']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Снять штраф исполнителя администратором
         * @param {string} executorId 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async removeExecutorPenalty(executorId: string, apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.removeExecutorPenalty(executorId, apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ExecutorApi.removeExecutorPenalty']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Найти исполнителя в RocketWork по ИНН
         * @param {string} inn 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async searchExecutorInRocketWorkByInn(inn: string, apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RocketExecutorResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.searchExecutorInRocketWorkByInn(inn, apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ExecutorApi.searchExecutorInRocketWorkByInn']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Найти исполнителя в RocketWork по телефону
         * @param {string} phone 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async searchExecutorInRocketWorkByPhone(phone: string, apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RocketExecutorResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.searchExecutorInRocketWorkByPhone(phone, apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ExecutorApi.searchExecutorInRocketWorkByPhone']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Установить данные \"О себе\"
         * @param {string} executorId 
         * @param {string} [apiVersion] 
         * @param {SetAboutMyselfRequest} [setAboutMyselfRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setAboutMyself(executorId: string, apiVersion?: string, setAboutMyselfRequest?: SetAboutMyselfRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ExecutorResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.setAboutMyself(executorId, apiVersion, setAboutMyselfRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ExecutorApi.setAboutMyself']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Закрыть исполнителя для работы
         * @param {string} executorId 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setCloseToWorkStatus(executorId: string, apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.setCloseToWorkStatus(executorId, apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ExecutorApi.setCloseToWorkStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Установить электронную почту исполнителя
         * @param {string} [apiVersion] 
         * @param {SetExecutorEmailRequest} [setExecutorEmailRequest] Модель запроса
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setExecutorEmail(apiVersion?: string, setExecutorEmailRequest?: SetExecutorEmailRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.setExecutorEmail(apiVersion, setExecutorEmailRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ExecutorApi.setExecutorEmail']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Обновить фотографию профиля исполнителя
         * @param {string} [apiVersion] 
         * @param {SetExecutorPhotoRequest} [setExecutorPhotoRequest] Модель запроса
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setExecutorPhoto(apiVersion?: string, setExecutorPhotoRequest?: SetExecutorPhotoRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.setExecutorPhoto(apiVersion, setExecutorPhotoRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ExecutorApi.setExecutorPhoto']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Открыть исполнителя для работы
         * @param {string} executorId 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setOpenToWorkStatus(executorId: string, apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.setOpenToWorkStatus(executorId, apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ExecutorApi.setOpenToWorkStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Перенести профиль исполнителя на другой телефон
         * @param {string} profileId 
         * @param {string} [apiVersion] 
         * @param {TransferProfilePhoneRequest} [transferProfilePhoneRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async transferExecutorPhone(profileId: string, apiVersion?: string, transferProfilePhoneRequest?: TransferProfilePhoneRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.transferExecutorPhone(profileId, apiVersion, transferProfilePhoneRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ExecutorApi.transferExecutorPhone']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Разблокировать профиль Исполнителя
         * @param {string} executorId 
         * @param {string} [apiVersion] 
         * @param {UnblockRequest} [unblockRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async unblockExecutor(executorId: string, apiVersion?: string, unblockRequest?: UnblockRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.unblockExecutor(executorId, apiVersion, unblockRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ExecutorApi.unblockExecutor']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Обновить данные исполнителя
         * @param {string} [executorId] Идентификатор исполнителя
         * @param {string} [apiVersion] 
         * @param {UpdateExecutorRequest} [updateExecutorRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateExecutor(executorId?: string, apiVersion?: string, updateExecutorRequest?: UpdateExecutorRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ExecutorResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateExecutor(executorId, apiVersion, updateExecutorRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ExecutorApi.updateExecutor']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Обновить профиль исполнителя
         * @param {string} [executorId] Идентификатор исполнителя
         * @param {string} [apiVersion] 
         * @param {UpdateExecutorByAdminRequest} [updateExecutorByAdminRequest] Модель запроса с данными исполнителя
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateExecutorByAdmin(executorId?: string, apiVersion?: string, updateExecutorByAdminRequest?: UpdateExecutorByAdminRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ExecutorResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateExecutorByAdmin(executorId, apiVersion, updateExecutorByAdminRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ExecutorApi.updateExecutorByAdmin']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Верифицировать исполнителя
         * @param {string} executorId Идентификатор исполнителя
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async verifyExecutor(executorId: string, apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.verifyExecutor(executorId, apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ExecutorApi.verifyExecutor']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ExecutorApi - factory interface
 * @export
 */
export const ExecutorApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ExecutorApiFp(configuration)
    return {
        /**
         * 
         * @summary Назначить штраф исполнителю администратором
         * @param {ExecutorApiAssignExecutorPenaltyRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignExecutorPenalty(requestParameters: ExecutorApiAssignExecutorPenaltyRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.assignExecutorPenalty(requestParameters.executorId, requestParameters.apiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Заблокировать профиль Исполнителя
         * @param {ExecutorApiBlockExecutorRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        blockExecutor(requestParameters: ExecutorApiBlockExecutorRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.blockExecutor(requestParameters.executorId, requestParameters.apiVersion, requestParameters.blockRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Создать профиль исполнителя
         * @param {ExecutorApiCreateExecutorRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createExecutor(requestParameters: ExecutorApiCreateExecutorRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<ExecutorResponse> {
            return localVarFp.createExecutor(requestParameters.apiVersion, requestParameters.createExecutorRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Создать профиль исполнителя
         * @param {ExecutorApiCreateExecutorByAdminRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createExecutorByAdmin(requestParameters: ExecutorApiCreateExecutorByAdminRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<ExecutorResponse> {
            return localVarFp.createExecutorByAdmin(requestParameters.apiVersion, requestParameters.createExecutorByAdminRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Удалить профиль Исполнителя
         * @param {ExecutorApiDeleteExecutorRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteExecutor(requestParameters: ExecutorApiDeleteExecutorRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteExecutor(requestParameters.executorId, requestParameters.apiVersion, requestParameters.deleteRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Получить исполнителя по пользователю приложения
         * @param {ExecutorApiGetExecutorByAppUserIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getExecutorByAppUserId(requestParameters: ExecutorApiGetExecutorByAppUserIdRequest, options?: RawAxiosRequestConfig): AxiosPromise<ExecutorResponse> {
            return localVarFp.getExecutorByAppUserId(requestParameters.appUserId, requestParameters.apiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Получить данные исполнителя
         * @param {ExecutorApiGetExecutorByIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getExecutorById(requestParameters: ExecutorApiGetExecutorByIdRequest, options?: RawAxiosRequestConfig): AxiosPromise<ExecutorResponse> {
            return localVarFp.getExecutorById(requestParameters.executorId, requestParameters.apiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Получить данные исполнителей
         * @param {ExecutorApiGetExecutorsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getExecutors(requestParameters: ExecutorApiGetExecutorsRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<GetExecutorsResponse> {
            return localVarFp.getExecutors(requestParameters.createdFrom, requestParameters.createdTo, requestParameters.firstNameSearch, requestParameters.lastNameSearch, requestParameters.phoneSearch, requestParameters.cityId, requestParameters.hasRocketWork, requestParameters.isVerified, requestParameters.hasPenalty, requestParameters.searchQuery, requestParameters.takeCount, requestParameters.skipCount, requestParameters.ascending, requestParameters.ordering, requestParameters.isDeleted, requestParameters.apiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Зарегистрировать паспортные данные исполнителя
         * @param {ExecutorApiRegistrationPassportDetailsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        registrationPassportDetails(requestParameters: ExecutorApiRegistrationPassportDetailsRequest, options?: RawAxiosRequestConfig): AxiosPromise<ExecutorResponse> {
            return localVarFp.registrationPassportDetails(requestParameters.executorId, requestParameters.apiVersion, requestParameters.passportDetailsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Снять штраф исполнителя администратором
         * @param {ExecutorApiRemoveExecutorPenaltyRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeExecutorPenalty(requestParameters: ExecutorApiRemoveExecutorPenaltyRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.removeExecutorPenalty(requestParameters.executorId, requestParameters.apiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Найти исполнителя в RocketWork по ИНН
         * @param {ExecutorApiSearchExecutorInRocketWorkByInnRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchExecutorInRocketWorkByInn(requestParameters: ExecutorApiSearchExecutorInRocketWorkByInnRequest, options?: RawAxiosRequestConfig): AxiosPromise<RocketExecutorResponse> {
            return localVarFp.searchExecutorInRocketWorkByInn(requestParameters.inn, requestParameters.apiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Найти исполнителя в RocketWork по телефону
         * @param {ExecutorApiSearchExecutorInRocketWorkByPhoneRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchExecutorInRocketWorkByPhone(requestParameters: ExecutorApiSearchExecutorInRocketWorkByPhoneRequest, options?: RawAxiosRequestConfig): AxiosPromise<RocketExecutorResponse> {
            return localVarFp.searchExecutorInRocketWorkByPhone(requestParameters.phone, requestParameters.apiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Установить данные \"О себе\"
         * @param {ExecutorApiSetAboutMyselfRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setAboutMyself(requestParameters: ExecutorApiSetAboutMyselfRequest, options?: RawAxiosRequestConfig): AxiosPromise<ExecutorResponse> {
            return localVarFp.setAboutMyself(requestParameters.executorId, requestParameters.apiVersion, requestParameters.setAboutMyselfRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Закрыть исполнителя для работы
         * @param {ExecutorApiSetCloseToWorkStatusRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setCloseToWorkStatus(requestParameters: ExecutorApiSetCloseToWorkStatusRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.setCloseToWorkStatus(requestParameters.executorId, requestParameters.apiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Установить электронную почту исполнителя
         * @param {ExecutorApiSetExecutorEmailRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setExecutorEmail(requestParameters: ExecutorApiSetExecutorEmailRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.setExecutorEmail(requestParameters.apiVersion, requestParameters.setExecutorEmailRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Обновить фотографию профиля исполнителя
         * @param {ExecutorApiSetExecutorPhotoRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setExecutorPhoto(requestParameters: ExecutorApiSetExecutorPhotoRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.setExecutorPhoto(requestParameters.apiVersion, requestParameters.setExecutorPhotoRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Открыть исполнителя для работы
         * @param {ExecutorApiSetOpenToWorkStatusRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setOpenToWorkStatus(requestParameters: ExecutorApiSetOpenToWorkStatusRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.setOpenToWorkStatus(requestParameters.executorId, requestParameters.apiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Перенести профиль исполнителя на другой телефон
         * @param {ExecutorApiTransferExecutorPhoneRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        transferExecutorPhone(requestParameters: ExecutorApiTransferExecutorPhoneRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.transferExecutorPhone(requestParameters.profileId, requestParameters.apiVersion, requestParameters.transferProfilePhoneRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Разблокировать профиль Исполнителя
         * @param {ExecutorApiUnblockExecutorRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unblockExecutor(requestParameters: ExecutorApiUnblockExecutorRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.unblockExecutor(requestParameters.executorId, requestParameters.apiVersion, requestParameters.unblockRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Обновить данные исполнителя
         * @param {ExecutorApiUpdateExecutorRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateExecutor(requestParameters: ExecutorApiUpdateExecutorRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<ExecutorResponse> {
            return localVarFp.updateExecutor(requestParameters.executorId, requestParameters.apiVersion, requestParameters.updateExecutorRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Обновить профиль исполнителя
         * @param {ExecutorApiUpdateExecutorByAdminRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateExecutorByAdmin(requestParameters: ExecutorApiUpdateExecutorByAdminRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<ExecutorResponse> {
            return localVarFp.updateExecutorByAdmin(requestParameters.executorId, requestParameters.apiVersion, requestParameters.updateExecutorByAdminRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Верифицировать исполнителя
         * @param {ExecutorApiVerifyExecutorRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        verifyExecutor(requestParameters: ExecutorApiVerifyExecutorRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.verifyExecutor(requestParameters.executorId, requestParameters.apiVersion, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for assignExecutorPenalty operation in ExecutorApi.
 * @export
 * @interface ExecutorApiAssignExecutorPenaltyRequest
 */
export interface ExecutorApiAssignExecutorPenaltyRequest {
    /**
     * 
     * @type {string}
     * @memberof ExecutorApiAssignExecutorPenalty
     */
    readonly executorId: string

    /**
     * 
     * @type {string}
     * @memberof ExecutorApiAssignExecutorPenalty
     */
    readonly apiVersion?: string
}

/**
 * Request parameters for blockExecutor operation in ExecutorApi.
 * @export
 * @interface ExecutorApiBlockExecutorRequest
 */
export interface ExecutorApiBlockExecutorRequest {
    /**
     * 
     * @type {string}
     * @memberof ExecutorApiBlockExecutor
     */
    readonly executorId: string

    /**
     * 
     * @type {string}
     * @memberof ExecutorApiBlockExecutor
     */
    readonly apiVersion?: string

    /**
     * 
     * @type {BlockRequest}
     * @memberof ExecutorApiBlockExecutor
     */
    readonly blockRequest?: BlockRequest
}

/**
 * Request parameters for createExecutor operation in ExecutorApi.
 * @export
 * @interface ExecutorApiCreateExecutorRequest
 */
export interface ExecutorApiCreateExecutorRequest {
    /**
     * 
     * @type {string}
     * @memberof ExecutorApiCreateExecutor
     */
    readonly apiVersion?: string

    /**
     * 
     * @type {CreateExecutorRequest}
     * @memberof ExecutorApiCreateExecutor
     */
    readonly createExecutorRequest?: CreateExecutorRequest
}

/**
 * Request parameters for createExecutorByAdmin operation in ExecutorApi.
 * @export
 * @interface ExecutorApiCreateExecutorByAdminRequest
 */
export interface ExecutorApiCreateExecutorByAdminRequest {
    /**
     * 
     * @type {string}
     * @memberof ExecutorApiCreateExecutorByAdmin
     */
    readonly apiVersion?: string

    /**
     * Модель запроса с данными исполнителя
     * @type {CreateExecutorByAdminRequest}
     * @memberof ExecutorApiCreateExecutorByAdmin
     */
    readonly createExecutorByAdminRequest?: CreateExecutorByAdminRequest
}

/**
 * Request parameters for deleteExecutor operation in ExecutorApi.
 * @export
 * @interface ExecutorApiDeleteExecutorRequest
 */
export interface ExecutorApiDeleteExecutorRequest {
    /**
     * 
     * @type {string}
     * @memberof ExecutorApiDeleteExecutor
     */
    readonly executorId: string

    /**
     * 
     * @type {string}
     * @memberof ExecutorApiDeleteExecutor
     */
    readonly apiVersion?: string

    /**
     * 
     * @type {DeleteRequest}
     * @memberof ExecutorApiDeleteExecutor
     */
    readonly deleteRequest?: DeleteRequest
}

/**
 * Request parameters for getExecutorByAppUserId operation in ExecutorApi.
 * @export
 * @interface ExecutorApiGetExecutorByAppUserIdRequest
 */
export interface ExecutorApiGetExecutorByAppUserIdRequest {
    /**
     * Идентификатор пользователя приложения
     * @type {string}
     * @memberof ExecutorApiGetExecutorByAppUserId
     */
    readonly appUserId: string

    /**
     * 
     * @type {string}
     * @memberof ExecutorApiGetExecutorByAppUserId
     */
    readonly apiVersion?: string
}

/**
 * Request parameters for getExecutorById operation in ExecutorApi.
 * @export
 * @interface ExecutorApiGetExecutorByIdRequest
 */
export interface ExecutorApiGetExecutorByIdRequest {
    /**
     * Идентификатор исполнителя
     * @type {string}
     * @memberof ExecutorApiGetExecutorById
     */
    readonly executorId: string

    /**
     * 
     * @type {string}
     * @memberof ExecutorApiGetExecutorById
     */
    readonly apiVersion?: string
}

/**
 * Request parameters for getExecutors operation in ExecutorApi.
 * @export
 * @interface ExecutorApiGetExecutorsRequest
 */
export interface ExecutorApiGetExecutorsRequest {
    /**
     * Дата регистрации: начало периода
     * @type {string}
     * @memberof ExecutorApiGetExecutors
     */
    readonly createdFrom?: string

    /**
     * Дата регистрации: конец периода
     * @type {string}
     * @memberof ExecutorApiGetExecutors
     */
    readonly createdTo?: string

    /**
     * Поиск по Имени
     * @type {string}
     * @memberof ExecutorApiGetExecutors
     */
    readonly firstNameSearch?: string

    /**
     * Поиск по Фамилии
     * @type {string}
     * @memberof ExecutorApiGetExecutors
     */
    readonly lastNameSearch?: string

    /**
     * Поиск по номеру телефона
     * @type {string}
     * @memberof ExecutorApiGetExecutors
     */
    readonly phoneSearch?: string

    /**
     * Идентификатор города
     * @type {number}
     * @memberof ExecutorApiGetExecutors
     */
    readonly cityId?: number

    /**
     * Привязан ли профиль RocketWork
     * @type {boolean}
     * @memberof ExecutorApiGetExecutors
     */
    readonly hasRocketWork?: boolean

    /**
     * Верифицирован ли
     * @type {boolean}
     * @memberof ExecutorApiGetExecutors
     */
    readonly isVerified?: boolean

    /**
     * Имеется ли штраф
     * @type {boolean}
     * @memberof ExecutorApiGetExecutors
     */
    readonly hasPenalty?: boolean

    /**
     * Строка для поиска
     * @type {string}
     * @memberof ExecutorApiGetExecutors
     */
    readonly searchQuery?: string

    /**
     * Размер страницы
     * @type {number}
     * @memberof ExecutorApiGetExecutors
     */
    readonly takeCount?: number

    /**
     * Кол-во пропущенных записей
     * @type {number}
     * @memberof ExecutorApiGetExecutors
     */
    readonly skipCount?: number

    /**
     * Сортировка по возрастанию
     * @type {boolean}
     * @memberof ExecutorApiGetExecutors
     */
    readonly ascending?: boolean

    /**
     * Поле для сортировки
     * @type {string}
     * @memberof ExecutorApiGetExecutors
     */
    readonly ordering?: string

    /**
     * Удалённые записи
     * @type {boolean}
     * @memberof ExecutorApiGetExecutors
     */
    readonly isDeleted?: boolean

    /**
     * 
     * @type {string}
     * @memberof ExecutorApiGetExecutors
     */
    readonly apiVersion?: string
}

/**
 * Request parameters for registrationPassportDetails operation in ExecutorApi.
 * @export
 * @interface ExecutorApiRegistrationPassportDetailsRequest
 */
export interface ExecutorApiRegistrationPassportDetailsRequest {
    /**
     * Идентификатор исполнителя
     * @type {string}
     * @memberof ExecutorApiRegistrationPassportDetails
     */
    readonly executorId: string

    /**
     * 
     * @type {string}
     * @memberof ExecutorApiRegistrationPassportDetails
     */
    readonly apiVersion?: string

    /**
     * 
     * @type {PassportDetailsRequest}
     * @memberof ExecutorApiRegistrationPassportDetails
     */
    readonly passportDetailsRequest?: PassportDetailsRequest
}

/**
 * Request parameters for removeExecutorPenalty operation in ExecutorApi.
 * @export
 * @interface ExecutorApiRemoveExecutorPenaltyRequest
 */
export interface ExecutorApiRemoveExecutorPenaltyRequest {
    /**
     * 
     * @type {string}
     * @memberof ExecutorApiRemoveExecutorPenalty
     */
    readonly executorId: string

    /**
     * 
     * @type {string}
     * @memberof ExecutorApiRemoveExecutorPenalty
     */
    readonly apiVersion?: string
}

/**
 * Request parameters for searchExecutorInRocketWorkByInn operation in ExecutorApi.
 * @export
 * @interface ExecutorApiSearchExecutorInRocketWorkByInnRequest
 */
export interface ExecutorApiSearchExecutorInRocketWorkByInnRequest {
    /**
     * 
     * @type {string}
     * @memberof ExecutorApiSearchExecutorInRocketWorkByInn
     */
    readonly inn: string

    /**
     * 
     * @type {string}
     * @memberof ExecutorApiSearchExecutorInRocketWorkByInn
     */
    readonly apiVersion?: string
}

/**
 * Request parameters for searchExecutorInRocketWorkByPhone operation in ExecutorApi.
 * @export
 * @interface ExecutorApiSearchExecutorInRocketWorkByPhoneRequest
 */
export interface ExecutorApiSearchExecutorInRocketWorkByPhoneRequest {
    /**
     * 
     * @type {string}
     * @memberof ExecutorApiSearchExecutorInRocketWorkByPhone
     */
    readonly phone: string

    /**
     * 
     * @type {string}
     * @memberof ExecutorApiSearchExecutorInRocketWorkByPhone
     */
    readonly apiVersion?: string
}

/**
 * Request parameters for setAboutMyself operation in ExecutorApi.
 * @export
 * @interface ExecutorApiSetAboutMyselfRequest
 */
export interface ExecutorApiSetAboutMyselfRequest {
    /**
     * 
     * @type {string}
     * @memberof ExecutorApiSetAboutMyself
     */
    readonly executorId: string

    /**
     * 
     * @type {string}
     * @memberof ExecutorApiSetAboutMyself
     */
    readonly apiVersion?: string

    /**
     * 
     * @type {SetAboutMyselfRequest}
     * @memberof ExecutorApiSetAboutMyself
     */
    readonly setAboutMyselfRequest?: SetAboutMyselfRequest
}

/**
 * Request parameters for setCloseToWorkStatus operation in ExecutorApi.
 * @export
 * @interface ExecutorApiSetCloseToWorkStatusRequest
 */
export interface ExecutorApiSetCloseToWorkStatusRequest {
    /**
     * 
     * @type {string}
     * @memberof ExecutorApiSetCloseToWorkStatus
     */
    readonly executorId: string

    /**
     * 
     * @type {string}
     * @memberof ExecutorApiSetCloseToWorkStatus
     */
    readonly apiVersion?: string
}

/**
 * Request parameters for setExecutorEmail operation in ExecutorApi.
 * @export
 * @interface ExecutorApiSetExecutorEmailRequest
 */
export interface ExecutorApiSetExecutorEmailRequest {
    /**
     * 
     * @type {string}
     * @memberof ExecutorApiSetExecutorEmail
     */
    readonly apiVersion?: string

    /**
     * Модель запроса
     * @type {SetExecutorEmailRequest}
     * @memberof ExecutorApiSetExecutorEmail
     */
    readonly setExecutorEmailRequest?: SetExecutorEmailRequest
}

/**
 * Request parameters for setExecutorPhoto operation in ExecutorApi.
 * @export
 * @interface ExecutorApiSetExecutorPhotoRequest
 */
export interface ExecutorApiSetExecutorPhotoRequest {
    /**
     * 
     * @type {string}
     * @memberof ExecutorApiSetExecutorPhoto
     */
    readonly apiVersion?: string

    /**
     * Модель запроса
     * @type {SetExecutorPhotoRequest}
     * @memberof ExecutorApiSetExecutorPhoto
     */
    readonly setExecutorPhotoRequest?: SetExecutorPhotoRequest
}

/**
 * Request parameters for setOpenToWorkStatus operation in ExecutorApi.
 * @export
 * @interface ExecutorApiSetOpenToWorkStatusRequest
 */
export interface ExecutorApiSetOpenToWorkStatusRequest {
    /**
     * 
     * @type {string}
     * @memberof ExecutorApiSetOpenToWorkStatus
     */
    readonly executorId: string

    /**
     * 
     * @type {string}
     * @memberof ExecutorApiSetOpenToWorkStatus
     */
    readonly apiVersion?: string
}

/**
 * Request parameters for transferExecutorPhone operation in ExecutorApi.
 * @export
 * @interface ExecutorApiTransferExecutorPhoneRequest
 */
export interface ExecutorApiTransferExecutorPhoneRequest {
    /**
     * 
     * @type {string}
     * @memberof ExecutorApiTransferExecutorPhone
     */
    readonly profileId: string

    /**
     * 
     * @type {string}
     * @memberof ExecutorApiTransferExecutorPhone
     */
    readonly apiVersion?: string

    /**
     * 
     * @type {TransferProfilePhoneRequest}
     * @memberof ExecutorApiTransferExecutorPhone
     */
    readonly transferProfilePhoneRequest?: TransferProfilePhoneRequest
}

/**
 * Request parameters for unblockExecutor operation in ExecutorApi.
 * @export
 * @interface ExecutorApiUnblockExecutorRequest
 */
export interface ExecutorApiUnblockExecutorRequest {
    /**
     * 
     * @type {string}
     * @memberof ExecutorApiUnblockExecutor
     */
    readonly executorId: string

    /**
     * 
     * @type {string}
     * @memberof ExecutorApiUnblockExecutor
     */
    readonly apiVersion?: string

    /**
     * 
     * @type {UnblockRequest}
     * @memberof ExecutorApiUnblockExecutor
     */
    readonly unblockRequest?: UnblockRequest
}

/**
 * Request parameters for updateExecutor operation in ExecutorApi.
 * @export
 * @interface ExecutorApiUpdateExecutorRequest
 */
export interface ExecutorApiUpdateExecutorRequest {
    /**
     * Идентификатор исполнителя
     * @type {string}
     * @memberof ExecutorApiUpdateExecutor
     */
    readonly executorId?: string

    /**
     * 
     * @type {string}
     * @memberof ExecutorApiUpdateExecutor
     */
    readonly apiVersion?: string

    /**
     * 
     * @type {UpdateExecutorRequest}
     * @memberof ExecutorApiUpdateExecutor
     */
    readonly updateExecutorRequest?: UpdateExecutorRequest
}

/**
 * Request parameters for updateExecutorByAdmin operation in ExecutorApi.
 * @export
 * @interface ExecutorApiUpdateExecutorByAdminRequest
 */
export interface ExecutorApiUpdateExecutorByAdminRequest {
    /**
     * Идентификатор исполнителя
     * @type {string}
     * @memberof ExecutorApiUpdateExecutorByAdmin
     */
    readonly executorId?: string

    /**
     * 
     * @type {string}
     * @memberof ExecutorApiUpdateExecutorByAdmin
     */
    readonly apiVersion?: string

    /**
     * Модель запроса с данными исполнителя
     * @type {UpdateExecutorByAdminRequest}
     * @memberof ExecutorApiUpdateExecutorByAdmin
     */
    readonly updateExecutorByAdminRequest?: UpdateExecutorByAdminRequest
}

/**
 * Request parameters for verifyExecutor operation in ExecutorApi.
 * @export
 * @interface ExecutorApiVerifyExecutorRequest
 */
export interface ExecutorApiVerifyExecutorRequest {
    /**
     * Идентификатор исполнителя
     * @type {string}
     * @memberof ExecutorApiVerifyExecutor
     */
    readonly executorId: string

    /**
     * 
     * @type {string}
     * @memberof ExecutorApiVerifyExecutor
     */
    readonly apiVersion?: string
}

/**
 * ExecutorApi - object-oriented interface
 * @export
 * @class ExecutorApi
 * @extends {BaseAPI}
 */
export class ExecutorApi extends BaseAPI {
    /**
     * 
     * @summary Назначить штраф исполнителю администратором
     * @param {ExecutorApiAssignExecutorPenaltyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExecutorApi
     */
    public assignExecutorPenalty(requestParameters: ExecutorApiAssignExecutorPenaltyRequest, options?: RawAxiosRequestConfig) {
        return ExecutorApiFp(this.configuration).assignExecutorPenalty(requestParameters.executorId, requestParameters.apiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Заблокировать профиль Исполнителя
     * @param {ExecutorApiBlockExecutorRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExecutorApi
     */
    public blockExecutor(requestParameters: ExecutorApiBlockExecutorRequest, options?: RawAxiosRequestConfig) {
        return ExecutorApiFp(this.configuration).blockExecutor(requestParameters.executorId, requestParameters.apiVersion, requestParameters.blockRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Создать профиль исполнителя
     * @param {ExecutorApiCreateExecutorRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExecutorApi
     */
    public createExecutor(requestParameters: ExecutorApiCreateExecutorRequest = {}, options?: RawAxiosRequestConfig) {
        return ExecutorApiFp(this.configuration).createExecutor(requestParameters.apiVersion, requestParameters.createExecutorRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Создать профиль исполнителя
     * @param {ExecutorApiCreateExecutorByAdminRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExecutorApi
     */
    public createExecutorByAdmin(requestParameters: ExecutorApiCreateExecutorByAdminRequest = {}, options?: RawAxiosRequestConfig) {
        return ExecutorApiFp(this.configuration).createExecutorByAdmin(requestParameters.apiVersion, requestParameters.createExecutorByAdminRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Удалить профиль Исполнителя
     * @param {ExecutorApiDeleteExecutorRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExecutorApi
     */
    public deleteExecutor(requestParameters: ExecutorApiDeleteExecutorRequest, options?: RawAxiosRequestConfig) {
        return ExecutorApiFp(this.configuration).deleteExecutor(requestParameters.executorId, requestParameters.apiVersion, requestParameters.deleteRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Получить исполнителя по пользователю приложения
     * @param {ExecutorApiGetExecutorByAppUserIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExecutorApi
     */
    public getExecutorByAppUserId(requestParameters: ExecutorApiGetExecutorByAppUserIdRequest, options?: RawAxiosRequestConfig) {
        return ExecutorApiFp(this.configuration).getExecutorByAppUserId(requestParameters.appUserId, requestParameters.apiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Получить данные исполнителя
     * @param {ExecutorApiGetExecutorByIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExecutorApi
     */
    public getExecutorById(requestParameters: ExecutorApiGetExecutorByIdRequest, options?: RawAxiosRequestConfig) {
        return ExecutorApiFp(this.configuration).getExecutorById(requestParameters.executorId, requestParameters.apiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Получить данные исполнителей
     * @param {ExecutorApiGetExecutorsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExecutorApi
     */
    public getExecutors(requestParameters: ExecutorApiGetExecutorsRequest = {}, options?: RawAxiosRequestConfig) {
        return ExecutorApiFp(this.configuration).getExecutors(requestParameters.createdFrom, requestParameters.createdTo, requestParameters.firstNameSearch, requestParameters.lastNameSearch, requestParameters.phoneSearch, requestParameters.cityId, requestParameters.hasRocketWork, requestParameters.isVerified, requestParameters.hasPenalty, requestParameters.searchQuery, requestParameters.takeCount, requestParameters.skipCount, requestParameters.ascending, requestParameters.ordering, requestParameters.isDeleted, requestParameters.apiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Зарегистрировать паспортные данные исполнителя
     * @param {ExecutorApiRegistrationPassportDetailsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExecutorApi
     */
    public registrationPassportDetails(requestParameters: ExecutorApiRegistrationPassportDetailsRequest, options?: RawAxiosRequestConfig) {
        return ExecutorApiFp(this.configuration).registrationPassportDetails(requestParameters.executorId, requestParameters.apiVersion, requestParameters.passportDetailsRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Снять штраф исполнителя администратором
     * @param {ExecutorApiRemoveExecutorPenaltyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExecutorApi
     */
    public removeExecutorPenalty(requestParameters: ExecutorApiRemoveExecutorPenaltyRequest, options?: RawAxiosRequestConfig) {
        return ExecutorApiFp(this.configuration).removeExecutorPenalty(requestParameters.executorId, requestParameters.apiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Найти исполнителя в RocketWork по ИНН
     * @param {ExecutorApiSearchExecutorInRocketWorkByInnRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExecutorApi
     */
    public searchExecutorInRocketWorkByInn(requestParameters: ExecutorApiSearchExecutorInRocketWorkByInnRequest, options?: RawAxiosRequestConfig) {
        return ExecutorApiFp(this.configuration).searchExecutorInRocketWorkByInn(requestParameters.inn, requestParameters.apiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Найти исполнителя в RocketWork по телефону
     * @param {ExecutorApiSearchExecutorInRocketWorkByPhoneRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExecutorApi
     */
    public searchExecutorInRocketWorkByPhone(requestParameters: ExecutorApiSearchExecutorInRocketWorkByPhoneRequest, options?: RawAxiosRequestConfig) {
        return ExecutorApiFp(this.configuration).searchExecutorInRocketWorkByPhone(requestParameters.phone, requestParameters.apiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Установить данные \"О себе\"
     * @param {ExecutorApiSetAboutMyselfRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExecutorApi
     */
    public setAboutMyself(requestParameters: ExecutorApiSetAboutMyselfRequest, options?: RawAxiosRequestConfig) {
        return ExecutorApiFp(this.configuration).setAboutMyself(requestParameters.executorId, requestParameters.apiVersion, requestParameters.setAboutMyselfRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Закрыть исполнителя для работы
     * @param {ExecutorApiSetCloseToWorkStatusRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExecutorApi
     */
    public setCloseToWorkStatus(requestParameters: ExecutorApiSetCloseToWorkStatusRequest, options?: RawAxiosRequestConfig) {
        return ExecutorApiFp(this.configuration).setCloseToWorkStatus(requestParameters.executorId, requestParameters.apiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Установить электронную почту исполнителя
     * @param {ExecutorApiSetExecutorEmailRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExecutorApi
     */
    public setExecutorEmail(requestParameters: ExecutorApiSetExecutorEmailRequest = {}, options?: RawAxiosRequestConfig) {
        return ExecutorApiFp(this.configuration).setExecutorEmail(requestParameters.apiVersion, requestParameters.setExecutorEmailRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Обновить фотографию профиля исполнителя
     * @param {ExecutorApiSetExecutorPhotoRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExecutorApi
     */
    public setExecutorPhoto(requestParameters: ExecutorApiSetExecutorPhotoRequest = {}, options?: RawAxiosRequestConfig) {
        return ExecutorApiFp(this.configuration).setExecutorPhoto(requestParameters.apiVersion, requestParameters.setExecutorPhotoRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Открыть исполнителя для работы
     * @param {ExecutorApiSetOpenToWorkStatusRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExecutorApi
     */
    public setOpenToWorkStatus(requestParameters: ExecutorApiSetOpenToWorkStatusRequest, options?: RawAxiosRequestConfig) {
        return ExecutorApiFp(this.configuration).setOpenToWorkStatus(requestParameters.executorId, requestParameters.apiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Перенести профиль исполнителя на другой телефон
     * @param {ExecutorApiTransferExecutorPhoneRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExecutorApi
     */
    public transferExecutorPhone(requestParameters: ExecutorApiTransferExecutorPhoneRequest, options?: RawAxiosRequestConfig) {
        return ExecutorApiFp(this.configuration).transferExecutorPhone(requestParameters.profileId, requestParameters.apiVersion, requestParameters.transferProfilePhoneRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Разблокировать профиль Исполнителя
     * @param {ExecutorApiUnblockExecutorRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExecutorApi
     */
    public unblockExecutor(requestParameters: ExecutorApiUnblockExecutorRequest, options?: RawAxiosRequestConfig) {
        return ExecutorApiFp(this.configuration).unblockExecutor(requestParameters.executorId, requestParameters.apiVersion, requestParameters.unblockRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Обновить данные исполнителя
     * @param {ExecutorApiUpdateExecutorRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExecutorApi
     */
    public updateExecutor(requestParameters: ExecutorApiUpdateExecutorRequest = {}, options?: RawAxiosRequestConfig) {
        return ExecutorApiFp(this.configuration).updateExecutor(requestParameters.executorId, requestParameters.apiVersion, requestParameters.updateExecutorRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Обновить профиль исполнителя
     * @param {ExecutorApiUpdateExecutorByAdminRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExecutorApi
     */
    public updateExecutorByAdmin(requestParameters: ExecutorApiUpdateExecutorByAdminRequest = {}, options?: RawAxiosRequestConfig) {
        return ExecutorApiFp(this.configuration).updateExecutorByAdmin(requestParameters.executorId, requestParameters.apiVersion, requestParameters.updateExecutorByAdminRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Верифицировать исполнителя
     * @param {ExecutorApiVerifyExecutorRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExecutorApi
     */
    public verifyExecutor(requestParameters: ExecutorApiVerifyExecutorRequest, options?: RawAxiosRequestConfig) {
        return ExecutorApiFp(this.configuration).verifyExecutor(requestParameters.executorId, requestParameters.apiVersion, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ExecutorAddressApi - axios parameter creator
 * @export
 */
export const ExecutorAddressApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Добавить адрес исполнителя
         * @param {string} [apiVersion] 
         * @param {CreateExecutorAddressRequest} [createExecutorAddressRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createExecutorAddress: async (apiVersion?: string, createExecutorAddressRequest?: CreateExecutorAddressRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/executor-addresses/create`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createExecutorAddressRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Удалить адрес исполнителя
         * @param {string} id 
         * @param {string} [apiVersion] 
         * @param {DeleteRequest} [deleteRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteExecutorAddress: async (id: string, apiVersion?: string, deleteRequest?: DeleteRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteExecutorAddress', 'id', id)
            const localVarPath = `/api/v1/executor-addresses/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(deleteRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Получить адреса исполнителя
         * @param {string} executorId 
         * @param {string} [cityNameSearch] Поиск по названию города
         * @param {string} [streetSearch] Поиск по улице
         * @param {string} [houseNumberSearch] Поиск по номеру дома
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllExecutorAddresses: async (executorId: string, cityNameSearch?: string, streetSearch?: string, houseNumberSearch?: string, apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'executorId' is not null or undefined
            assertParamExists('getAllExecutorAddresses', 'executorId', executorId)
            const localVarPath = `/api/v1/executor-addresses/{executorId}/get-all`
                .replace(`{${"executorId"}}`, encodeURIComponent(String(executorId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (cityNameSearch !== undefined) {
                localVarQueryParameter['CityNameSearch'] = cityNameSearch;
            }

            if (streetSearch !== undefined) {
                localVarQueryParameter['StreetSearch'] = streetSearch;
            }

            if (houseNumberSearch !== undefined) {
                localVarQueryParameter['HouseNumberSearch'] = houseNumberSearch;
            }


    
            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Получить адрес исполнителя по идентификатору адреса
         * @param {string} addressId 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getExecutorAddressByAddressId: async (addressId: string, apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'addressId' is not null or undefined
            assertParamExists('getExecutorAddressByAddressId', 'addressId', addressId)
            const localVarPath = `/api/v1/executor-addresses/{addressId}`
                .replace(`{${"addressId"}}`, encodeURIComponent(String(addressId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Получить адрес исполнителя по идентификатору записи
         * @param {string} id 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getExecutorAddressById: async (id: string, apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getExecutorAddressById', 'id', id)
            const localVarPath = `/api/v1/executor-addresses/get-by-id/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Сделать адрес исполнителя избранным
         * @param {string} id 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setExecutorAddressFavorite: async (id: string, apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('setExecutorAddressFavorite', 'id', id)
            const localVarPath = `/api/v1/executor-addresses/{id}/favorite`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Обновить адрес исполнителя
         * @param {string} [apiVersion] 
         * @param {UpdateExecutorAddressRequest} [updateExecutorAddressRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateExecutorAddress: async (apiVersion?: string, updateExecutorAddressRequest?: UpdateExecutorAddressRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/executor-addresses/update`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateExecutorAddressRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ExecutorAddressApi - functional programming interface
 * @export
 */
export const ExecutorAddressApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ExecutorAddressApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Добавить адрес исполнителя
         * @param {string} [apiVersion] 
         * @param {CreateExecutorAddressRequest} [createExecutorAddressRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createExecutorAddress(apiVersion?: string, createExecutorAddressRequest?: CreateExecutorAddressRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ExecutorAddressResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createExecutorAddress(apiVersion, createExecutorAddressRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ExecutorAddressApi.createExecutorAddress']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Удалить адрес исполнителя
         * @param {string} id 
         * @param {string} [apiVersion] 
         * @param {DeleteRequest} [deleteRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteExecutorAddress(id: string, apiVersion?: string, deleteRequest?: DeleteRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteExecutorAddress(id, apiVersion, deleteRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ExecutorAddressApi.deleteExecutorAddress']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Получить адреса исполнителя
         * @param {string} executorId 
         * @param {string} [cityNameSearch] Поиск по названию города
         * @param {string} [streetSearch] Поиск по улице
         * @param {string} [houseNumberSearch] Поиск по номеру дома
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllExecutorAddresses(executorId: string, cityNameSearch?: string, streetSearch?: string, houseNumberSearch?: string, apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ExecutorAddressResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllExecutorAddresses(executorId, cityNameSearch, streetSearch, houseNumberSearch, apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ExecutorAddressApi.getAllExecutorAddresses']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Получить адрес исполнителя по идентификатору адреса
         * @param {string} addressId 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getExecutorAddressByAddressId(addressId: string, apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ExecutorAddressResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getExecutorAddressByAddressId(addressId, apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ExecutorAddressApi.getExecutorAddressByAddressId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Получить адрес исполнителя по идентификатору записи
         * @param {string} id 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getExecutorAddressById(id: string, apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ExecutorAddressResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getExecutorAddressById(id, apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ExecutorAddressApi.getExecutorAddressById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Сделать адрес исполнителя избранным
         * @param {string} id 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setExecutorAddressFavorite(id: string, apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.setExecutorAddressFavorite(id, apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ExecutorAddressApi.setExecutorAddressFavorite']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Обновить адрес исполнителя
         * @param {string} [apiVersion] 
         * @param {UpdateExecutorAddressRequest} [updateExecutorAddressRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateExecutorAddress(apiVersion?: string, updateExecutorAddressRequest?: UpdateExecutorAddressRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ExecutorAddressResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateExecutorAddress(apiVersion, updateExecutorAddressRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ExecutorAddressApi.updateExecutorAddress']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ExecutorAddressApi - factory interface
 * @export
 */
export const ExecutorAddressApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ExecutorAddressApiFp(configuration)
    return {
        /**
         * 
         * @summary Добавить адрес исполнителя
         * @param {ExecutorAddressApiCreateExecutorAddressRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createExecutorAddress(requestParameters: ExecutorAddressApiCreateExecutorAddressRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<ExecutorAddressResponse> {
            return localVarFp.createExecutorAddress(requestParameters.apiVersion, requestParameters.createExecutorAddressRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Удалить адрес исполнителя
         * @param {ExecutorAddressApiDeleteExecutorAddressRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteExecutorAddress(requestParameters: ExecutorAddressApiDeleteExecutorAddressRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteExecutorAddress(requestParameters.id, requestParameters.apiVersion, requestParameters.deleteRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Получить адреса исполнителя
         * @param {ExecutorAddressApiGetAllExecutorAddressesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllExecutorAddresses(requestParameters: ExecutorAddressApiGetAllExecutorAddressesRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<ExecutorAddressResponse>> {
            return localVarFp.getAllExecutorAddresses(requestParameters.executorId, requestParameters.cityNameSearch, requestParameters.streetSearch, requestParameters.houseNumberSearch, requestParameters.apiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Получить адрес исполнителя по идентификатору адреса
         * @param {ExecutorAddressApiGetExecutorAddressByAddressIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getExecutorAddressByAddressId(requestParameters: ExecutorAddressApiGetExecutorAddressByAddressIdRequest, options?: RawAxiosRequestConfig): AxiosPromise<ExecutorAddressResponse> {
            return localVarFp.getExecutorAddressByAddressId(requestParameters.addressId, requestParameters.apiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Получить адрес исполнителя по идентификатору записи
         * @param {ExecutorAddressApiGetExecutorAddressByIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getExecutorAddressById(requestParameters: ExecutorAddressApiGetExecutorAddressByIdRequest, options?: RawAxiosRequestConfig): AxiosPromise<ExecutorAddressResponse> {
            return localVarFp.getExecutorAddressById(requestParameters.id, requestParameters.apiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Сделать адрес исполнителя избранным
         * @param {ExecutorAddressApiSetExecutorAddressFavoriteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setExecutorAddressFavorite(requestParameters: ExecutorAddressApiSetExecutorAddressFavoriteRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.setExecutorAddressFavorite(requestParameters.id, requestParameters.apiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Обновить адрес исполнителя
         * @param {ExecutorAddressApiUpdateExecutorAddressRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateExecutorAddress(requestParameters: ExecutorAddressApiUpdateExecutorAddressRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<ExecutorAddressResponse> {
            return localVarFp.updateExecutorAddress(requestParameters.apiVersion, requestParameters.updateExecutorAddressRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for createExecutorAddress operation in ExecutorAddressApi.
 * @export
 * @interface ExecutorAddressApiCreateExecutorAddressRequest
 */
export interface ExecutorAddressApiCreateExecutorAddressRequest {
    /**
     * 
     * @type {string}
     * @memberof ExecutorAddressApiCreateExecutorAddress
     */
    readonly apiVersion?: string

    /**
     * 
     * @type {CreateExecutorAddressRequest}
     * @memberof ExecutorAddressApiCreateExecutorAddress
     */
    readonly createExecutorAddressRequest?: CreateExecutorAddressRequest
}

/**
 * Request parameters for deleteExecutorAddress operation in ExecutorAddressApi.
 * @export
 * @interface ExecutorAddressApiDeleteExecutorAddressRequest
 */
export interface ExecutorAddressApiDeleteExecutorAddressRequest {
    /**
     * 
     * @type {string}
     * @memberof ExecutorAddressApiDeleteExecutorAddress
     */
    readonly id: string

    /**
     * 
     * @type {string}
     * @memberof ExecutorAddressApiDeleteExecutorAddress
     */
    readonly apiVersion?: string

    /**
     * 
     * @type {DeleteRequest}
     * @memberof ExecutorAddressApiDeleteExecutorAddress
     */
    readonly deleteRequest?: DeleteRequest
}

/**
 * Request parameters for getAllExecutorAddresses operation in ExecutorAddressApi.
 * @export
 * @interface ExecutorAddressApiGetAllExecutorAddressesRequest
 */
export interface ExecutorAddressApiGetAllExecutorAddressesRequest {
    /**
     * 
     * @type {string}
     * @memberof ExecutorAddressApiGetAllExecutorAddresses
     */
    readonly executorId: string

    /**
     * Поиск по названию города
     * @type {string}
     * @memberof ExecutorAddressApiGetAllExecutorAddresses
     */
    readonly cityNameSearch?: string

    /**
     * Поиск по улице
     * @type {string}
     * @memberof ExecutorAddressApiGetAllExecutorAddresses
     */
    readonly streetSearch?: string

    /**
     * Поиск по номеру дома
     * @type {string}
     * @memberof ExecutorAddressApiGetAllExecutorAddresses
     */
    readonly houseNumberSearch?: string

    /**
     * 
     * @type {string}
     * @memberof ExecutorAddressApiGetAllExecutorAddresses
     */
    readonly apiVersion?: string
}

/**
 * Request parameters for getExecutorAddressByAddressId operation in ExecutorAddressApi.
 * @export
 * @interface ExecutorAddressApiGetExecutorAddressByAddressIdRequest
 */
export interface ExecutorAddressApiGetExecutorAddressByAddressIdRequest {
    /**
     * 
     * @type {string}
     * @memberof ExecutorAddressApiGetExecutorAddressByAddressId
     */
    readonly addressId: string

    /**
     * 
     * @type {string}
     * @memberof ExecutorAddressApiGetExecutorAddressByAddressId
     */
    readonly apiVersion?: string
}

/**
 * Request parameters for getExecutorAddressById operation in ExecutorAddressApi.
 * @export
 * @interface ExecutorAddressApiGetExecutorAddressByIdRequest
 */
export interface ExecutorAddressApiGetExecutorAddressByIdRequest {
    /**
     * 
     * @type {string}
     * @memberof ExecutorAddressApiGetExecutorAddressById
     */
    readonly id: string

    /**
     * 
     * @type {string}
     * @memberof ExecutorAddressApiGetExecutorAddressById
     */
    readonly apiVersion?: string
}

/**
 * Request parameters for setExecutorAddressFavorite operation in ExecutorAddressApi.
 * @export
 * @interface ExecutorAddressApiSetExecutorAddressFavoriteRequest
 */
export interface ExecutorAddressApiSetExecutorAddressFavoriteRequest {
    /**
     * 
     * @type {string}
     * @memberof ExecutorAddressApiSetExecutorAddressFavorite
     */
    readonly id: string

    /**
     * 
     * @type {string}
     * @memberof ExecutorAddressApiSetExecutorAddressFavorite
     */
    readonly apiVersion?: string
}

/**
 * Request parameters for updateExecutorAddress operation in ExecutorAddressApi.
 * @export
 * @interface ExecutorAddressApiUpdateExecutorAddressRequest
 */
export interface ExecutorAddressApiUpdateExecutorAddressRequest {
    /**
     * 
     * @type {string}
     * @memberof ExecutorAddressApiUpdateExecutorAddress
     */
    readonly apiVersion?: string

    /**
     * 
     * @type {UpdateExecutorAddressRequest}
     * @memberof ExecutorAddressApiUpdateExecutorAddress
     */
    readonly updateExecutorAddressRequest?: UpdateExecutorAddressRequest
}

/**
 * ExecutorAddressApi - object-oriented interface
 * @export
 * @class ExecutorAddressApi
 * @extends {BaseAPI}
 */
export class ExecutorAddressApi extends BaseAPI {
    /**
     * 
     * @summary Добавить адрес исполнителя
     * @param {ExecutorAddressApiCreateExecutorAddressRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExecutorAddressApi
     */
    public createExecutorAddress(requestParameters: ExecutorAddressApiCreateExecutorAddressRequest = {}, options?: RawAxiosRequestConfig) {
        return ExecutorAddressApiFp(this.configuration).createExecutorAddress(requestParameters.apiVersion, requestParameters.createExecutorAddressRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Удалить адрес исполнителя
     * @param {ExecutorAddressApiDeleteExecutorAddressRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExecutorAddressApi
     */
    public deleteExecutorAddress(requestParameters: ExecutorAddressApiDeleteExecutorAddressRequest, options?: RawAxiosRequestConfig) {
        return ExecutorAddressApiFp(this.configuration).deleteExecutorAddress(requestParameters.id, requestParameters.apiVersion, requestParameters.deleteRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Получить адреса исполнителя
     * @param {ExecutorAddressApiGetAllExecutorAddressesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExecutorAddressApi
     */
    public getAllExecutorAddresses(requestParameters: ExecutorAddressApiGetAllExecutorAddressesRequest, options?: RawAxiosRequestConfig) {
        return ExecutorAddressApiFp(this.configuration).getAllExecutorAddresses(requestParameters.executorId, requestParameters.cityNameSearch, requestParameters.streetSearch, requestParameters.houseNumberSearch, requestParameters.apiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Получить адрес исполнителя по идентификатору адреса
     * @param {ExecutorAddressApiGetExecutorAddressByAddressIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExecutorAddressApi
     */
    public getExecutorAddressByAddressId(requestParameters: ExecutorAddressApiGetExecutorAddressByAddressIdRequest, options?: RawAxiosRequestConfig) {
        return ExecutorAddressApiFp(this.configuration).getExecutorAddressByAddressId(requestParameters.addressId, requestParameters.apiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Получить адрес исполнителя по идентификатору записи
     * @param {ExecutorAddressApiGetExecutorAddressByIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExecutorAddressApi
     */
    public getExecutorAddressById(requestParameters: ExecutorAddressApiGetExecutorAddressByIdRequest, options?: RawAxiosRequestConfig) {
        return ExecutorAddressApiFp(this.configuration).getExecutorAddressById(requestParameters.id, requestParameters.apiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Сделать адрес исполнителя избранным
     * @param {ExecutorAddressApiSetExecutorAddressFavoriteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExecutorAddressApi
     */
    public setExecutorAddressFavorite(requestParameters: ExecutorAddressApiSetExecutorAddressFavoriteRequest, options?: RawAxiosRequestConfig) {
        return ExecutorAddressApiFp(this.configuration).setExecutorAddressFavorite(requestParameters.id, requestParameters.apiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Обновить адрес исполнителя
     * @param {ExecutorAddressApiUpdateExecutorAddressRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExecutorAddressApi
     */
    public updateExecutorAddress(requestParameters: ExecutorAddressApiUpdateExecutorAddressRequest = {}, options?: RawAxiosRequestConfig) {
        return ExecutorAddressApiFp(this.configuration).updateExecutorAddress(requestParameters.apiVersion, requestParameters.updateExecutorAddressRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ExecutorProgressApi - axios parameter creator
 * @export
 */
export const ExecutorProgressApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Создать запись доступности теста исполнителю.
         * @param {string} [apiVersion] 
         * @param {CreateExecutorAccessTestRequest} [createExecutorAccessTestRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createExecutorAccessTest: async (apiVersion?: string, createExecutorAccessTestRequest?: CreateExecutorAccessTestRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/executor-progresses/create-executor-access-test`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createExecutorAccessTestRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Создать запись о просмотре урока
         * @param {string} [apiVersion] 
         * @param {CreateExecutorLessonProgressRequest} [createExecutorLessonProgressRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createExecutorLessonProgress: async (apiVersion?: string, createExecutorLessonProgressRequest?: CreateExecutorLessonProgressRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/executor-progresses/create-executor-lesson-progresses`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createExecutorLessonProgressRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Создать запись о просмотре урока чтобы открыть доступ к тесту.  Если записи о просмотре теста существует, то - они удалятся вместе с доступными тестами исполнителя.  Вернет testId который доступен после просмотра урока исполнителю
         * @param {string} [apiVersion] 
         * @param {CreateExecutorLessonProgressRequest} [createExecutorLessonProgressRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createExecutorLessonProgressAsync: async (apiVersion?: string, createExecutorLessonProgressRequest?: CreateExecutorLessonProgressRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/executor-progresses/create-executor-lesson-progress`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createExecutorLessonProgressRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Создание записей ответов на тест и вывод результата  если в уроке имеется следующий тест тогда он становится доступным и вернется NextTestId  для прохождения и можно отвечать на вопросы
         * @param {string} [apiVersion] 
         * @param {CreateExecutorTestProgressRequest} [createExecutorTestProgressRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createExecutorTestProgress: async (apiVersion?: string, createExecutorTestProgressRequest?: CreateExecutorTestProgressRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/executor-progresses/create-executor-test-progress`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createExecutorTestProgressRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Удаляется запись доступности теста исполнителю.
         * @param {number} id 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteExecutorAccessTest: async (id: number, apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteExecutorAccessTest', 'id', id)
            const localVarPath = `/api/v1/executor-progresses/delete-executor-access-test/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Удалить запись о просмотре урока.  Удалятся доступные тесты
         * @param {number} id 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteExecutorLessonProgress: async (id: number, apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteExecutorLessonProgress', 'id', id)
            const localVarPath = `/api/v1/executor-progresses/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Получение всех доступных тестов по пройденным урокам.  Получение по ID исполнителя
         * @param {string} executorId 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getExecutorAccessTestByExecutorId: async (executorId: string, apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'executorId' is not null or undefined
            assertParamExists('getExecutorAccessTestByExecutorId', 'executorId', executorId)
            const localVarPath = `/api/v1/executor-progresses/get-executor-access-test-by-executor-id/{executorId}`
                .replace(`{${"executorId"}}`, encodeURIComponent(String(executorId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Получение всех пройденных уроков исполнителя.
         * @param {string} executorId Идентификатор исполнителя
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getExecutorLessonProgressByExecutorId: async (executorId: string, apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'executorId' is not null or undefined
            assertParamExists('getExecutorLessonProgressByExecutorId', 'executorId', executorId)
            const localVarPath = `/api/v1/executor-progresses/get-executor-lesson-progress-by-executor-id/{executorId}`
                .replace(`{${"executorId"}}`, encodeURIComponent(String(executorId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Получение записи о том что урок пройден.
         * @param {number} id 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getExecutorLessonProgressById: async (id: number, apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getExecutorLessonProgressById', 'id', id)
            const localVarPath = `/api/v1/executor-progresses/get-executor-lesson-progress-by-id/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Получение результатов на тесты по ID исполнителя.
         * @param {string} executorId 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTotalResultByExecutorId: async (executorId: string, apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'executorId' is not null or undefined
            assertParamExists('getTotalResultByExecutorId', 'executorId', executorId)
            const localVarPath = `/api/v1/executor-progresses/get-total-result-by-executor-id/{executorId}`
                .replace(`{${"executorId"}}`, encodeURIComponent(String(executorId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Получение результата на тест по ID исполнителя и Id теста.
         * @param {number} testId 
         * @param {string} executorId 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTotalResultByTestByExecutorId: async (testId: number, executorId: string, apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'testId' is not null or undefined
            assertParamExists('getTotalResultByTestByExecutorId', 'testId', testId)
            // verify required parameter 'executorId' is not null or undefined
            assertParamExists('getTotalResultByTestByExecutorId', 'executorId', executorId)
            const localVarPath = `/api/v1/executor-progresses/get-total-result-by-test-by-executor-id/{testId}/{executorId}`
                .replace(`{${"testId"}}`, encodeURIComponent(String(testId)))
                .replace(`{${"executorId"}}`, encodeURIComponent(String(executorId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Обновить запись доступности теста исполнителю.
         * @param {string} [apiVersion] 
         * @param {UpdateExecutorAccessTestRequest} [updateExecutorAccessTestRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateExecutorAccessTest: async (apiVersion?: string, updateExecutorAccessTestRequest?: UpdateExecutorAccessTestRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/executor-progresses/update-executor-access-test`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateExecutorAccessTestRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ExecutorProgressApi - functional programming interface
 * @export
 */
export const ExecutorProgressApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ExecutorProgressApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Создать запись доступности теста исполнителю.
         * @param {string} [apiVersion] 
         * @param {CreateExecutorAccessTestRequest} [createExecutorAccessTestRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createExecutorAccessTest(apiVersion?: string, createExecutorAccessTestRequest?: CreateExecutorAccessTestRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetExecutorAccessTestResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createExecutorAccessTest(apiVersion, createExecutorAccessTestRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ExecutorProgressApi.createExecutorAccessTest']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Создать запись о просмотре урока
         * @param {string} [apiVersion] 
         * @param {CreateExecutorLessonProgressRequest} [createExecutorLessonProgressRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createExecutorLessonProgress(apiVersion?: string, createExecutorLessonProgressRequest?: CreateExecutorLessonProgressRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetExecutorLessonProgressBy>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createExecutorLessonProgress(apiVersion, createExecutorLessonProgressRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ExecutorProgressApi.createExecutorLessonProgress']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Создать запись о просмотре урока чтобы открыть доступ к тесту.  Если записи о просмотре теста существует, то - они удалятся вместе с доступными тестами исполнителя.  Вернет testId который доступен после просмотра урока исполнителю
         * @param {string} [apiVersion] 
         * @param {CreateExecutorLessonProgressRequest} [createExecutorLessonProgressRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createExecutorLessonProgressAsync(apiVersion?: string, createExecutorLessonProgressRequest?: CreateExecutorLessonProgressRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetExecutorLessonProgressResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createExecutorLessonProgressAsync(apiVersion, createExecutorLessonProgressRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ExecutorProgressApi.createExecutorLessonProgressAsync']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Создание записей ответов на тест и вывод результата  если в уроке имеется следующий тест тогда он становится доступным и вернется NextTestId  для прохождения и можно отвечать на вопросы
         * @param {string} [apiVersion] 
         * @param {CreateExecutorTestProgressRequest} [createExecutorTestProgressRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createExecutorTestProgress(apiVersion?: string, createExecutorTestProgressRequest?: CreateExecutorTestProgressRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateExecutorTestProgressResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createExecutorTestProgress(apiVersion, createExecutorTestProgressRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ExecutorProgressApi.createExecutorTestProgress']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Удаляется запись доступности теста исполнителю.
         * @param {number} id 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteExecutorAccessTest(id: number, apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteExecutorAccessTest(id, apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ExecutorProgressApi.deleteExecutorAccessTest']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Удалить запись о просмотре урока.  Удалятся доступные тесты
         * @param {number} id 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteExecutorLessonProgress(id: number, apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteExecutorLessonProgress(id, apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ExecutorProgressApi.deleteExecutorLessonProgress']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Получение всех доступных тестов по пройденным урокам.  Получение по ID исполнителя
         * @param {string} executorId 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getExecutorAccessTestByExecutorId(executorId: string, apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetExecutorAccessTestResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getExecutorAccessTestByExecutorId(executorId, apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ExecutorProgressApi.getExecutorAccessTestByExecutorId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Получение всех пройденных уроков исполнителя.
         * @param {string} executorId Идентификатор исполнителя
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getExecutorLessonProgressByExecutorId(executorId: string, apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetExecutorLessonProgressByExecutorIdResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getExecutorLessonProgressByExecutorId(executorId, apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ExecutorProgressApi.getExecutorLessonProgressByExecutorId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Получение записи о том что урок пройден.
         * @param {number} id 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getExecutorLessonProgressById(id: number, apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetExecutorLessonProgressBy>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getExecutorLessonProgressById(id, apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ExecutorProgressApi.getExecutorLessonProgressById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Получение результатов на тесты по ID исполнителя.
         * @param {string} executorId 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTotalResultByExecutorId(executorId: string, apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetTotalResultModel>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTotalResultByExecutorId(executorId, apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ExecutorProgressApi.getTotalResultByExecutorId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Получение результата на тест по ID исполнителя и Id теста.
         * @param {number} testId 
         * @param {string} executorId 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTotalResultByTestByExecutorId(testId: number, executorId: string, apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetTotalResultModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTotalResultByTestByExecutorId(testId, executorId, apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ExecutorProgressApi.getTotalResultByTestByExecutorId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Обновить запись доступности теста исполнителю.
         * @param {string} [apiVersion] 
         * @param {UpdateExecutorAccessTestRequest} [updateExecutorAccessTestRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateExecutorAccessTest(apiVersion?: string, updateExecutorAccessTestRequest?: UpdateExecutorAccessTestRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetExecutorAccessTestResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateExecutorAccessTest(apiVersion, updateExecutorAccessTestRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ExecutorProgressApi.updateExecutorAccessTest']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ExecutorProgressApi - factory interface
 * @export
 */
export const ExecutorProgressApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ExecutorProgressApiFp(configuration)
    return {
        /**
         * 
         * @summary Создать запись доступности теста исполнителю.
         * @param {ExecutorProgressApiCreateExecutorAccessTestRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createExecutorAccessTest(requestParameters: ExecutorProgressApiCreateExecutorAccessTestRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<GetExecutorAccessTestResponse> {
            return localVarFp.createExecutorAccessTest(requestParameters.apiVersion, requestParameters.createExecutorAccessTestRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Создать запись о просмотре урока
         * @param {ExecutorProgressApiCreateExecutorLessonProgressRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createExecutorLessonProgress(requestParameters: ExecutorProgressApiCreateExecutorLessonProgressRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<GetExecutorLessonProgressBy> {
            return localVarFp.createExecutorLessonProgress(requestParameters.apiVersion, requestParameters.createExecutorLessonProgressRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Создать запись о просмотре урока чтобы открыть доступ к тесту.  Если записи о просмотре теста существует, то - они удалятся вместе с доступными тестами исполнителя.  Вернет testId который доступен после просмотра урока исполнителю
         * @param {ExecutorProgressApiCreateExecutorLessonProgressAsyncRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createExecutorLessonProgressAsync(requestParameters: ExecutorProgressApiCreateExecutorLessonProgressAsyncRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<GetExecutorLessonProgressResponse> {
            return localVarFp.createExecutorLessonProgressAsync(requestParameters.apiVersion, requestParameters.createExecutorLessonProgressRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Создание записей ответов на тест и вывод результата  если в уроке имеется следующий тест тогда он становится доступным и вернется NextTestId  для прохождения и можно отвечать на вопросы
         * @param {ExecutorProgressApiCreateExecutorTestProgressRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createExecutorTestProgress(requestParameters: ExecutorProgressApiCreateExecutorTestProgressRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<CreateExecutorTestProgressResponse> {
            return localVarFp.createExecutorTestProgress(requestParameters.apiVersion, requestParameters.createExecutorTestProgressRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Удаляется запись доступности теста исполнителю.
         * @param {ExecutorProgressApiDeleteExecutorAccessTestRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteExecutorAccessTest(requestParameters: ExecutorProgressApiDeleteExecutorAccessTestRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteExecutorAccessTest(requestParameters.id, requestParameters.apiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Удалить запись о просмотре урока.  Удалятся доступные тесты
         * @param {ExecutorProgressApiDeleteExecutorLessonProgressRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteExecutorLessonProgress(requestParameters: ExecutorProgressApiDeleteExecutorLessonProgressRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteExecutorLessonProgress(requestParameters.id, requestParameters.apiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Получение всех доступных тестов по пройденным урокам.  Получение по ID исполнителя
         * @param {ExecutorProgressApiGetExecutorAccessTestByExecutorIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getExecutorAccessTestByExecutorId(requestParameters: ExecutorProgressApiGetExecutorAccessTestByExecutorIdRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<GetExecutorAccessTestResponse>> {
            return localVarFp.getExecutorAccessTestByExecutorId(requestParameters.executorId, requestParameters.apiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Получение всех пройденных уроков исполнителя.
         * @param {ExecutorProgressApiGetExecutorLessonProgressByExecutorIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getExecutorLessonProgressByExecutorId(requestParameters: ExecutorProgressApiGetExecutorLessonProgressByExecutorIdRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<GetExecutorLessonProgressByExecutorIdResponse>> {
            return localVarFp.getExecutorLessonProgressByExecutorId(requestParameters.executorId, requestParameters.apiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Получение записи о том что урок пройден.
         * @param {ExecutorProgressApiGetExecutorLessonProgressByIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getExecutorLessonProgressById(requestParameters: ExecutorProgressApiGetExecutorLessonProgressByIdRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetExecutorLessonProgressBy> {
            return localVarFp.getExecutorLessonProgressById(requestParameters.id, requestParameters.apiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Получение результатов на тесты по ID исполнителя.
         * @param {ExecutorProgressApiGetTotalResultByExecutorIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTotalResultByExecutorId(requestParameters: ExecutorProgressApiGetTotalResultByExecutorIdRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<GetTotalResultModel>> {
            return localVarFp.getTotalResultByExecutorId(requestParameters.executorId, requestParameters.apiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Получение результата на тест по ID исполнителя и Id теста.
         * @param {ExecutorProgressApiGetTotalResultByTestByExecutorIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTotalResultByTestByExecutorId(requestParameters: ExecutorProgressApiGetTotalResultByTestByExecutorIdRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetTotalResultModel> {
            return localVarFp.getTotalResultByTestByExecutorId(requestParameters.testId, requestParameters.executorId, requestParameters.apiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Обновить запись доступности теста исполнителю.
         * @param {ExecutorProgressApiUpdateExecutorAccessTestRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateExecutorAccessTest(requestParameters: ExecutorProgressApiUpdateExecutorAccessTestRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<GetExecutorAccessTestResponse> {
            return localVarFp.updateExecutorAccessTest(requestParameters.apiVersion, requestParameters.updateExecutorAccessTestRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for createExecutorAccessTest operation in ExecutorProgressApi.
 * @export
 * @interface ExecutorProgressApiCreateExecutorAccessTestRequest
 */
export interface ExecutorProgressApiCreateExecutorAccessTestRequest {
    /**
     * 
     * @type {string}
     * @memberof ExecutorProgressApiCreateExecutorAccessTest
     */
    readonly apiVersion?: string

    /**
     * 
     * @type {CreateExecutorAccessTestRequest}
     * @memberof ExecutorProgressApiCreateExecutorAccessTest
     */
    readonly createExecutorAccessTestRequest?: CreateExecutorAccessTestRequest
}

/**
 * Request parameters for createExecutorLessonProgress operation in ExecutorProgressApi.
 * @export
 * @interface ExecutorProgressApiCreateExecutorLessonProgressRequest
 */
export interface ExecutorProgressApiCreateExecutorLessonProgressRequest {
    /**
     * 
     * @type {string}
     * @memberof ExecutorProgressApiCreateExecutorLessonProgress
     */
    readonly apiVersion?: string

    /**
     * 
     * @type {CreateExecutorLessonProgressRequest}
     * @memberof ExecutorProgressApiCreateExecutorLessonProgress
     */
    readonly createExecutorLessonProgressRequest?: CreateExecutorLessonProgressRequest
}

/**
 * Request parameters for createExecutorLessonProgressAsync operation in ExecutorProgressApi.
 * @export
 * @interface ExecutorProgressApiCreateExecutorLessonProgressAsyncRequest
 */
export interface ExecutorProgressApiCreateExecutorLessonProgressAsyncRequest {
    /**
     * 
     * @type {string}
     * @memberof ExecutorProgressApiCreateExecutorLessonProgressAsync
     */
    readonly apiVersion?: string

    /**
     * 
     * @type {CreateExecutorLessonProgressRequest}
     * @memberof ExecutorProgressApiCreateExecutorLessonProgressAsync
     */
    readonly createExecutorLessonProgressRequest?: CreateExecutorLessonProgressRequest
}

/**
 * Request parameters for createExecutorTestProgress operation in ExecutorProgressApi.
 * @export
 * @interface ExecutorProgressApiCreateExecutorTestProgressRequest
 */
export interface ExecutorProgressApiCreateExecutorTestProgressRequest {
    /**
     * 
     * @type {string}
     * @memberof ExecutorProgressApiCreateExecutorTestProgress
     */
    readonly apiVersion?: string

    /**
     * 
     * @type {CreateExecutorTestProgressRequest}
     * @memberof ExecutorProgressApiCreateExecutorTestProgress
     */
    readonly createExecutorTestProgressRequest?: CreateExecutorTestProgressRequest
}

/**
 * Request parameters for deleteExecutorAccessTest operation in ExecutorProgressApi.
 * @export
 * @interface ExecutorProgressApiDeleteExecutorAccessTestRequest
 */
export interface ExecutorProgressApiDeleteExecutorAccessTestRequest {
    /**
     * 
     * @type {number}
     * @memberof ExecutorProgressApiDeleteExecutorAccessTest
     */
    readonly id: number

    /**
     * 
     * @type {string}
     * @memberof ExecutorProgressApiDeleteExecutorAccessTest
     */
    readonly apiVersion?: string
}

/**
 * Request parameters for deleteExecutorLessonProgress operation in ExecutorProgressApi.
 * @export
 * @interface ExecutorProgressApiDeleteExecutorLessonProgressRequest
 */
export interface ExecutorProgressApiDeleteExecutorLessonProgressRequest {
    /**
     * 
     * @type {number}
     * @memberof ExecutorProgressApiDeleteExecutorLessonProgress
     */
    readonly id: number

    /**
     * 
     * @type {string}
     * @memberof ExecutorProgressApiDeleteExecutorLessonProgress
     */
    readonly apiVersion?: string
}

/**
 * Request parameters for getExecutorAccessTestByExecutorId operation in ExecutorProgressApi.
 * @export
 * @interface ExecutorProgressApiGetExecutorAccessTestByExecutorIdRequest
 */
export interface ExecutorProgressApiGetExecutorAccessTestByExecutorIdRequest {
    /**
     * 
     * @type {string}
     * @memberof ExecutorProgressApiGetExecutorAccessTestByExecutorId
     */
    readonly executorId: string

    /**
     * 
     * @type {string}
     * @memberof ExecutorProgressApiGetExecutorAccessTestByExecutorId
     */
    readonly apiVersion?: string
}

/**
 * Request parameters for getExecutorLessonProgressByExecutorId operation in ExecutorProgressApi.
 * @export
 * @interface ExecutorProgressApiGetExecutorLessonProgressByExecutorIdRequest
 */
export interface ExecutorProgressApiGetExecutorLessonProgressByExecutorIdRequest {
    /**
     * Идентификатор исполнителя
     * @type {string}
     * @memberof ExecutorProgressApiGetExecutorLessonProgressByExecutorId
     */
    readonly executorId: string

    /**
     * 
     * @type {string}
     * @memberof ExecutorProgressApiGetExecutorLessonProgressByExecutorId
     */
    readonly apiVersion?: string
}

/**
 * Request parameters for getExecutorLessonProgressById operation in ExecutorProgressApi.
 * @export
 * @interface ExecutorProgressApiGetExecutorLessonProgressByIdRequest
 */
export interface ExecutorProgressApiGetExecutorLessonProgressByIdRequest {
    /**
     * 
     * @type {number}
     * @memberof ExecutorProgressApiGetExecutorLessonProgressById
     */
    readonly id: number

    /**
     * 
     * @type {string}
     * @memberof ExecutorProgressApiGetExecutorLessonProgressById
     */
    readonly apiVersion?: string
}

/**
 * Request parameters for getTotalResultByExecutorId operation in ExecutorProgressApi.
 * @export
 * @interface ExecutorProgressApiGetTotalResultByExecutorIdRequest
 */
export interface ExecutorProgressApiGetTotalResultByExecutorIdRequest {
    /**
     * 
     * @type {string}
     * @memberof ExecutorProgressApiGetTotalResultByExecutorId
     */
    readonly executorId: string

    /**
     * 
     * @type {string}
     * @memberof ExecutorProgressApiGetTotalResultByExecutorId
     */
    readonly apiVersion?: string
}

/**
 * Request parameters for getTotalResultByTestByExecutorId operation in ExecutorProgressApi.
 * @export
 * @interface ExecutorProgressApiGetTotalResultByTestByExecutorIdRequest
 */
export interface ExecutorProgressApiGetTotalResultByTestByExecutorIdRequest {
    /**
     * 
     * @type {number}
     * @memberof ExecutorProgressApiGetTotalResultByTestByExecutorId
     */
    readonly testId: number

    /**
     * 
     * @type {string}
     * @memberof ExecutorProgressApiGetTotalResultByTestByExecutorId
     */
    readonly executorId: string

    /**
     * 
     * @type {string}
     * @memberof ExecutorProgressApiGetTotalResultByTestByExecutorId
     */
    readonly apiVersion?: string
}

/**
 * Request parameters for updateExecutorAccessTest operation in ExecutorProgressApi.
 * @export
 * @interface ExecutorProgressApiUpdateExecutorAccessTestRequest
 */
export interface ExecutorProgressApiUpdateExecutorAccessTestRequest {
    /**
     * 
     * @type {string}
     * @memberof ExecutorProgressApiUpdateExecutorAccessTest
     */
    readonly apiVersion?: string

    /**
     * 
     * @type {UpdateExecutorAccessTestRequest}
     * @memberof ExecutorProgressApiUpdateExecutorAccessTest
     */
    readonly updateExecutorAccessTestRequest?: UpdateExecutorAccessTestRequest
}

/**
 * ExecutorProgressApi - object-oriented interface
 * @export
 * @class ExecutorProgressApi
 * @extends {BaseAPI}
 */
export class ExecutorProgressApi extends BaseAPI {
    /**
     * 
     * @summary Создать запись доступности теста исполнителю.
     * @param {ExecutorProgressApiCreateExecutorAccessTestRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExecutorProgressApi
     */
    public createExecutorAccessTest(requestParameters: ExecutorProgressApiCreateExecutorAccessTestRequest = {}, options?: RawAxiosRequestConfig) {
        return ExecutorProgressApiFp(this.configuration).createExecutorAccessTest(requestParameters.apiVersion, requestParameters.createExecutorAccessTestRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Создать запись о просмотре урока
     * @param {ExecutorProgressApiCreateExecutorLessonProgressRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExecutorProgressApi
     */
    public createExecutorLessonProgress(requestParameters: ExecutorProgressApiCreateExecutorLessonProgressRequest = {}, options?: RawAxiosRequestConfig) {
        return ExecutorProgressApiFp(this.configuration).createExecutorLessonProgress(requestParameters.apiVersion, requestParameters.createExecutorLessonProgressRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Создать запись о просмотре урока чтобы открыть доступ к тесту.  Если записи о просмотре теста существует, то - они удалятся вместе с доступными тестами исполнителя.  Вернет testId который доступен после просмотра урока исполнителю
     * @param {ExecutorProgressApiCreateExecutorLessonProgressAsyncRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExecutorProgressApi
     */
    public createExecutorLessonProgressAsync(requestParameters: ExecutorProgressApiCreateExecutorLessonProgressAsyncRequest = {}, options?: RawAxiosRequestConfig) {
        return ExecutorProgressApiFp(this.configuration).createExecutorLessonProgressAsync(requestParameters.apiVersion, requestParameters.createExecutorLessonProgressRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Создание записей ответов на тест и вывод результата  если в уроке имеется следующий тест тогда он становится доступным и вернется NextTestId  для прохождения и можно отвечать на вопросы
     * @param {ExecutorProgressApiCreateExecutorTestProgressRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExecutorProgressApi
     */
    public createExecutorTestProgress(requestParameters: ExecutorProgressApiCreateExecutorTestProgressRequest = {}, options?: RawAxiosRequestConfig) {
        return ExecutorProgressApiFp(this.configuration).createExecutorTestProgress(requestParameters.apiVersion, requestParameters.createExecutorTestProgressRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Удаляется запись доступности теста исполнителю.
     * @param {ExecutorProgressApiDeleteExecutorAccessTestRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExecutorProgressApi
     */
    public deleteExecutorAccessTest(requestParameters: ExecutorProgressApiDeleteExecutorAccessTestRequest, options?: RawAxiosRequestConfig) {
        return ExecutorProgressApiFp(this.configuration).deleteExecutorAccessTest(requestParameters.id, requestParameters.apiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Удалить запись о просмотре урока.  Удалятся доступные тесты
     * @param {ExecutorProgressApiDeleteExecutorLessonProgressRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExecutorProgressApi
     */
    public deleteExecutorLessonProgress(requestParameters: ExecutorProgressApiDeleteExecutorLessonProgressRequest, options?: RawAxiosRequestConfig) {
        return ExecutorProgressApiFp(this.configuration).deleteExecutorLessonProgress(requestParameters.id, requestParameters.apiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Получение всех доступных тестов по пройденным урокам.  Получение по ID исполнителя
     * @param {ExecutorProgressApiGetExecutorAccessTestByExecutorIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExecutorProgressApi
     */
    public getExecutorAccessTestByExecutorId(requestParameters: ExecutorProgressApiGetExecutorAccessTestByExecutorIdRequest, options?: RawAxiosRequestConfig) {
        return ExecutorProgressApiFp(this.configuration).getExecutorAccessTestByExecutorId(requestParameters.executorId, requestParameters.apiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Получение всех пройденных уроков исполнителя.
     * @param {ExecutorProgressApiGetExecutorLessonProgressByExecutorIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExecutorProgressApi
     */
    public getExecutorLessonProgressByExecutorId(requestParameters: ExecutorProgressApiGetExecutorLessonProgressByExecutorIdRequest, options?: RawAxiosRequestConfig) {
        return ExecutorProgressApiFp(this.configuration).getExecutorLessonProgressByExecutorId(requestParameters.executorId, requestParameters.apiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Получение записи о том что урок пройден.
     * @param {ExecutorProgressApiGetExecutorLessonProgressByIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExecutorProgressApi
     */
    public getExecutorLessonProgressById(requestParameters: ExecutorProgressApiGetExecutorLessonProgressByIdRequest, options?: RawAxiosRequestConfig) {
        return ExecutorProgressApiFp(this.configuration).getExecutorLessonProgressById(requestParameters.id, requestParameters.apiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Получение результатов на тесты по ID исполнителя.
     * @param {ExecutorProgressApiGetTotalResultByExecutorIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExecutorProgressApi
     */
    public getTotalResultByExecutorId(requestParameters: ExecutorProgressApiGetTotalResultByExecutorIdRequest, options?: RawAxiosRequestConfig) {
        return ExecutorProgressApiFp(this.configuration).getTotalResultByExecutorId(requestParameters.executorId, requestParameters.apiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Получение результата на тест по ID исполнителя и Id теста.
     * @param {ExecutorProgressApiGetTotalResultByTestByExecutorIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExecutorProgressApi
     */
    public getTotalResultByTestByExecutorId(requestParameters: ExecutorProgressApiGetTotalResultByTestByExecutorIdRequest, options?: RawAxiosRequestConfig) {
        return ExecutorProgressApiFp(this.configuration).getTotalResultByTestByExecutorId(requestParameters.testId, requestParameters.executorId, requestParameters.apiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Обновить запись доступности теста исполнителю.
     * @param {ExecutorProgressApiUpdateExecutorAccessTestRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExecutorProgressApi
     */
    public updateExecutorAccessTest(requestParameters: ExecutorProgressApiUpdateExecutorAccessTestRequest = {}, options?: RawAxiosRequestConfig) {
        return ExecutorProgressApiFp(this.configuration).updateExecutorAccessTest(requestParameters.apiVersion, requestParameters.updateExecutorAccessTestRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ExperiencesApi - axios parameter creator
 * @export
 */
export const ExperiencesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Получить справочник опыта исполнителей
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllExperiences: async (apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/experiences`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ExperiencesApi - functional programming interface
 * @export
 */
export const ExperiencesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ExperiencesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Получить справочник опыта исполнителей
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllExperiences(apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ExperienceResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllExperiences(apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ExperiencesApi.getAllExperiences']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ExperiencesApi - factory interface
 * @export
 */
export const ExperiencesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ExperiencesApiFp(configuration)
    return {
        /**
         * 
         * @summary Получить справочник опыта исполнителей
         * @param {ExperiencesApiGetAllExperiencesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllExperiences(requestParameters: ExperiencesApiGetAllExperiencesRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<Array<ExperienceResponse>> {
            return localVarFp.getAllExperiences(requestParameters.apiVersion, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for getAllExperiences operation in ExperiencesApi.
 * @export
 * @interface ExperiencesApiGetAllExperiencesRequest
 */
export interface ExperiencesApiGetAllExperiencesRequest {
    /**
     * 
     * @type {string}
     * @memberof ExperiencesApiGetAllExperiences
     */
    readonly apiVersion?: string
}

/**
 * ExperiencesApi - object-oriented interface
 * @export
 * @class ExperiencesApi
 * @extends {BaseAPI}
 */
export class ExperiencesApi extends BaseAPI {
    /**
     * 
     * @summary Получить справочник опыта исполнителей
     * @param {ExperiencesApiGetAllExperiencesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExperiencesApi
     */
    public getAllExperiences(requestParameters: ExperiencesApiGetAllExperiencesRequest = {}, options?: RawAxiosRequestConfig) {
        return ExperiencesApiFp(this.configuration).getAllExperiences(requestParameters.apiVersion, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * FavoriteExecutorsApi - axios parameter creator
 * @export
 */
export const FavoriteExecutorsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Удалить исполнителя из избранного
         * @param {string} executorId 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1FavoriteExecutorsExecutorIdDelete: async (executorId: string, apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'executorId' is not null or undefined
            assertParamExists('apiV1FavoriteExecutorsExecutorIdDelete', 'executorId', executorId)
            const localVarPath = `/api/v1/favorite-executors/{executorId}`
                .replace(`{${"executorId"}}`, encodeURIComponent(String(executorId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Добавить исполнителя в избранное
         * @param {string} executorId 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1FavoriteExecutorsExecutorIdPut: async (executorId: string, apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'executorId' is not null or undefined
            assertParamExists('apiV1FavoriteExecutorsExecutorIdPut', 'executorId', executorId)
            const localVarPath = `/api/v1/favorite-executors/{executorId}`
                .replace(`{${"executorId"}}`, encodeURIComponent(String(executorId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Получить избранных исполнителей и ограничения выбора
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1FavoriteExecutorsGet: async (apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/favorite-executors`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Получить сведения приглашённых исполнителей для деталей и истории заказа
         * @param {string} orderId 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1FavoriteExecutorsOrdersOrderIdExecutorsGet: async (orderId: string, apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orderId' is not null or undefined
            assertParamExists('apiV1FavoriteExecutorsOrdersOrderIdExecutorsGet', 'orderId', orderId)
            const localVarPath = `/api/v1/favorite-executors/orders/{orderId}/executors`
                .replace(`{${"orderId"}}`, encodeURIComponent(String(orderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Получить выбранных для заказа исполнителей
         * @param {string} orderId 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1FavoriteExecutorsOrdersOrderIdGet: async (orderId: string, apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orderId' is not null or undefined
            assertParamExists('apiV1FavoriteExecutorsOrdersOrderIdGet', 'orderId', orderId)
            const localVarPath = `/api/v1/favorite-executors/orders/{orderId}`
                .replace(`{${"orderId"}}`, encodeURIComponent(String(orderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Сохранить выбранных для заказа исполнителей
         * @param {string} orderId 
         * @param {string} [apiVersion] 
         * @param {Array<string>} [requestBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1FavoriteExecutorsOrdersOrderIdPut: async (orderId: string, apiVersion?: string, requestBody?: Array<string>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orderId' is not null or undefined
            assertParamExists('apiV1FavoriteExecutorsOrdersOrderIdPut', 'orderId', orderId)
            const localVarPath = `/api/v1/favorite-executors/orders/{orderId}`
                .replace(`{${"orderId"}}`, encodeURIComponent(String(orderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * FavoriteExecutorsApi - functional programming interface
 * @export
 */
export const FavoriteExecutorsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = FavoriteExecutorsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Удалить исполнителя из избранного
         * @param {string} executorId 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1FavoriteExecutorsExecutorIdDelete(executorId: string, apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1FavoriteExecutorsExecutorIdDelete(executorId, apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FavoriteExecutorsApi.apiV1FavoriteExecutorsExecutorIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Добавить исполнителя в избранное
         * @param {string} executorId 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1FavoriteExecutorsExecutorIdPut(executorId: string, apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1FavoriteExecutorsExecutorIdPut(executorId, apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FavoriteExecutorsApi.apiV1FavoriteExecutorsExecutorIdPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Получить избранных исполнителей и ограничения выбора
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1FavoriteExecutorsGet(apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FavoriteExecutorsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1FavoriteExecutorsGet(apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FavoriteExecutorsApi.apiV1FavoriteExecutorsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Получить сведения приглашённых исполнителей для деталей и истории заказа
         * @param {string} orderId 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1FavoriteExecutorsOrdersOrderIdExecutorsGet(orderId: string, apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<FavoriteExecutorResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1FavoriteExecutorsOrdersOrderIdExecutorsGet(orderId, apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FavoriteExecutorsApi.apiV1FavoriteExecutorsOrdersOrderIdExecutorsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Получить выбранных для заказа исполнителей
         * @param {string} orderId 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1FavoriteExecutorsOrdersOrderIdGet(orderId: string, apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<string>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1FavoriteExecutorsOrdersOrderIdGet(orderId, apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FavoriteExecutorsApi.apiV1FavoriteExecutorsOrdersOrderIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Сохранить выбранных для заказа исполнителей
         * @param {string} orderId 
         * @param {string} [apiVersion] 
         * @param {Array<string>} [requestBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1FavoriteExecutorsOrdersOrderIdPut(orderId: string, apiVersion?: string, requestBody?: Array<string>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1FavoriteExecutorsOrdersOrderIdPut(orderId, apiVersion, requestBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FavoriteExecutorsApi.apiV1FavoriteExecutorsOrdersOrderIdPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * FavoriteExecutorsApi - factory interface
 * @export
 */
export const FavoriteExecutorsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = FavoriteExecutorsApiFp(configuration)
    return {
        /**
         * 
         * @summary Удалить исполнителя из избранного
         * @param {FavoriteExecutorsApiApiV1FavoriteExecutorsExecutorIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1FavoriteExecutorsExecutorIdDelete(requestParameters: FavoriteExecutorsApiApiV1FavoriteExecutorsExecutorIdDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiV1FavoriteExecutorsExecutorIdDelete(requestParameters.executorId, requestParameters.apiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Добавить исполнителя в избранное
         * @param {FavoriteExecutorsApiApiV1FavoriteExecutorsExecutorIdPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1FavoriteExecutorsExecutorIdPut(requestParameters: FavoriteExecutorsApiApiV1FavoriteExecutorsExecutorIdPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiV1FavoriteExecutorsExecutorIdPut(requestParameters.executorId, requestParameters.apiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Получить избранных исполнителей и ограничения выбора
         * @param {FavoriteExecutorsApiApiV1FavoriteExecutorsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1FavoriteExecutorsGet(requestParameters: FavoriteExecutorsApiApiV1FavoriteExecutorsGetRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<FavoriteExecutorsResponse> {
            return localVarFp.apiV1FavoriteExecutorsGet(requestParameters.apiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Получить сведения приглашённых исполнителей для деталей и истории заказа
         * @param {FavoriteExecutorsApiApiV1FavoriteExecutorsOrdersOrderIdExecutorsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1FavoriteExecutorsOrdersOrderIdExecutorsGet(requestParameters: FavoriteExecutorsApiApiV1FavoriteExecutorsOrdersOrderIdExecutorsGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<FavoriteExecutorResponse>> {
            return localVarFp.apiV1FavoriteExecutorsOrdersOrderIdExecutorsGet(requestParameters.orderId, requestParameters.apiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Получить выбранных для заказа исполнителей
         * @param {FavoriteExecutorsApiApiV1FavoriteExecutorsOrdersOrderIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1FavoriteExecutorsOrdersOrderIdGet(requestParameters: FavoriteExecutorsApiApiV1FavoriteExecutorsOrdersOrderIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<string>> {
            return localVarFp.apiV1FavoriteExecutorsOrdersOrderIdGet(requestParameters.orderId, requestParameters.apiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Сохранить выбранных для заказа исполнителей
         * @param {FavoriteExecutorsApiApiV1FavoriteExecutorsOrdersOrderIdPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1FavoriteExecutorsOrdersOrderIdPut(requestParameters: FavoriteExecutorsApiApiV1FavoriteExecutorsOrdersOrderIdPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiV1FavoriteExecutorsOrdersOrderIdPut(requestParameters.orderId, requestParameters.apiVersion, requestParameters.requestBody, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for apiV1FavoriteExecutorsExecutorIdDelete operation in FavoriteExecutorsApi.
 * @export
 * @interface FavoriteExecutorsApiApiV1FavoriteExecutorsExecutorIdDeleteRequest
 */
export interface FavoriteExecutorsApiApiV1FavoriteExecutorsExecutorIdDeleteRequest {
    /**
     * 
     * @type {string}
     * @memberof FavoriteExecutorsApiApiV1FavoriteExecutorsExecutorIdDelete
     */
    readonly executorId: string

    /**
     * 
     * @type {string}
     * @memberof FavoriteExecutorsApiApiV1FavoriteExecutorsExecutorIdDelete
     */
    readonly apiVersion?: string
}

/**
 * Request parameters for apiV1FavoriteExecutorsExecutorIdPut operation in FavoriteExecutorsApi.
 * @export
 * @interface FavoriteExecutorsApiApiV1FavoriteExecutorsExecutorIdPutRequest
 */
export interface FavoriteExecutorsApiApiV1FavoriteExecutorsExecutorIdPutRequest {
    /**
     * 
     * @type {string}
     * @memberof FavoriteExecutorsApiApiV1FavoriteExecutorsExecutorIdPut
     */
    readonly executorId: string

    /**
     * 
     * @type {string}
     * @memberof FavoriteExecutorsApiApiV1FavoriteExecutorsExecutorIdPut
     */
    readonly apiVersion?: string
}

/**
 * Request parameters for apiV1FavoriteExecutorsGet operation in FavoriteExecutorsApi.
 * @export
 * @interface FavoriteExecutorsApiApiV1FavoriteExecutorsGetRequest
 */
export interface FavoriteExecutorsApiApiV1FavoriteExecutorsGetRequest {
    /**
     * 
     * @type {string}
     * @memberof FavoriteExecutorsApiApiV1FavoriteExecutorsGet
     */
    readonly apiVersion?: string
}

/**
 * Request parameters for apiV1FavoriteExecutorsOrdersOrderIdExecutorsGet operation in FavoriteExecutorsApi.
 * @export
 * @interface FavoriteExecutorsApiApiV1FavoriteExecutorsOrdersOrderIdExecutorsGetRequest
 */
export interface FavoriteExecutorsApiApiV1FavoriteExecutorsOrdersOrderIdExecutorsGetRequest {
    /**
     * 
     * @type {string}
     * @memberof FavoriteExecutorsApiApiV1FavoriteExecutorsOrdersOrderIdExecutorsGet
     */
    readonly orderId: string

    /**
     * 
     * @type {string}
     * @memberof FavoriteExecutorsApiApiV1FavoriteExecutorsOrdersOrderIdExecutorsGet
     */
    readonly apiVersion?: string
}

/**
 * Request parameters for apiV1FavoriteExecutorsOrdersOrderIdGet operation in FavoriteExecutorsApi.
 * @export
 * @interface FavoriteExecutorsApiApiV1FavoriteExecutorsOrdersOrderIdGetRequest
 */
export interface FavoriteExecutorsApiApiV1FavoriteExecutorsOrdersOrderIdGetRequest {
    /**
     * 
     * @type {string}
     * @memberof FavoriteExecutorsApiApiV1FavoriteExecutorsOrdersOrderIdGet
     */
    readonly orderId: string

    /**
     * 
     * @type {string}
     * @memberof FavoriteExecutorsApiApiV1FavoriteExecutorsOrdersOrderIdGet
     */
    readonly apiVersion?: string
}

/**
 * Request parameters for apiV1FavoriteExecutorsOrdersOrderIdPut operation in FavoriteExecutorsApi.
 * @export
 * @interface FavoriteExecutorsApiApiV1FavoriteExecutorsOrdersOrderIdPutRequest
 */
export interface FavoriteExecutorsApiApiV1FavoriteExecutorsOrdersOrderIdPutRequest {
    /**
     * 
     * @type {string}
     * @memberof FavoriteExecutorsApiApiV1FavoriteExecutorsOrdersOrderIdPut
     */
    readonly orderId: string

    /**
     * 
     * @type {string}
     * @memberof FavoriteExecutorsApiApiV1FavoriteExecutorsOrdersOrderIdPut
     */
    readonly apiVersion?: string

    /**
     * 
     * @type {Array<string>}
     * @memberof FavoriteExecutorsApiApiV1FavoriteExecutorsOrdersOrderIdPut
     */
    readonly requestBody?: Array<string>
}

/**
 * FavoriteExecutorsApi - object-oriented interface
 * @export
 * @class FavoriteExecutorsApi
 * @extends {BaseAPI}
 */
export class FavoriteExecutorsApi extends BaseAPI {
    /**
     * 
     * @summary Удалить исполнителя из избранного
     * @param {FavoriteExecutorsApiApiV1FavoriteExecutorsExecutorIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FavoriteExecutorsApi
     */
    public apiV1FavoriteExecutorsExecutorIdDelete(requestParameters: FavoriteExecutorsApiApiV1FavoriteExecutorsExecutorIdDeleteRequest, options?: RawAxiosRequestConfig) {
        return FavoriteExecutorsApiFp(this.configuration).apiV1FavoriteExecutorsExecutorIdDelete(requestParameters.executorId, requestParameters.apiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Добавить исполнителя в избранное
     * @param {FavoriteExecutorsApiApiV1FavoriteExecutorsExecutorIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FavoriteExecutorsApi
     */
    public apiV1FavoriteExecutorsExecutorIdPut(requestParameters: FavoriteExecutorsApiApiV1FavoriteExecutorsExecutorIdPutRequest, options?: RawAxiosRequestConfig) {
        return FavoriteExecutorsApiFp(this.configuration).apiV1FavoriteExecutorsExecutorIdPut(requestParameters.executorId, requestParameters.apiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Получить избранных исполнителей и ограничения выбора
     * @param {FavoriteExecutorsApiApiV1FavoriteExecutorsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FavoriteExecutorsApi
     */
    public apiV1FavoriteExecutorsGet(requestParameters: FavoriteExecutorsApiApiV1FavoriteExecutorsGetRequest = {}, options?: RawAxiosRequestConfig) {
        return FavoriteExecutorsApiFp(this.configuration).apiV1FavoriteExecutorsGet(requestParameters.apiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Получить сведения приглашённых исполнителей для деталей и истории заказа
     * @param {FavoriteExecutorsApiApiV1FavoriteExecutorsOrdersOrderIdExecutorsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FavoriteExecutorsApi
     */
    public apiV1FavoriteExecutorsOrdersOrderIdExecutorsGet(requestParameters: FavoriteExecutorsApiApiV1FavoriteExecutorsOrdersOrderIdExecutorsGetRequest, options?: RawAxiosRequestConfig) {
        return FavoriteExecutorsApiFp(this.configuration).apiV1FavoriteExecutorsOrdersOrderIdExecutorsGet(requestParameters.orderId, requestParameters.apiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Получить выбранных для заказа исполнителей
     * @param {FavoriteExecutorsApiApiV1FavoriteExecutorsOrdersOrderIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FavoriteExecutorsApi
     */
    public apiV1FavoriteExecutorsOrdersOrderIdGet(requestParameters: FavoriteExecutorsApiApiV1FavoriteExecutorsOrdersOrderIdGetRequest, options?: RawAxiosRequestConfig) {
        return FavoriteExecutorsApiFp(this.configuration).apiV1FavoriteExecutorsOrdersOrderIdGet(requestParameters.orderId, requestParameters.apiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Сохранить выбранных для заказа исполнителей
     * @param {FavoriteExecutorsApiApiV1FavoriteExecutorsOrdersOrderIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FavoriteExecutorsApi
     */
    public apiV1FavoriteExecutorsOrdersOrderIdPut(requestParameters: FavoriteExecutorsApiApiV1FavoriteExecutorsOrdersOrderIdPutRequest, options?: RawAxiosRequestConfig) {
        return FavoriteExecutorsApiFp(this.configuration).apiV1FavoriteExecutorsOrdersOrderIdPut(requestParameters.orderId, requestParameters.apiVersion, requestParameters.requestBody, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * FeatureTogglesApi - axios parameter creator
 * @export
 */
export const FeatureTogglesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Создать функциональный переключатель
         * @param {string} [apiVersion] 
         * @param {CreateFeatureToggleRequest} [createFeatureToggleRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createFeatureToggle: async (apiVersion?: string, createFeatureToggleRequest?: CreateFeatureToggleRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/feature_toggles`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createFeatureToggleRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Получить все функциональные переключатели
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllFeatureToggles: async (apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/feature_toggles/get-all`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Обновить функциональный переключатель
         * @param {string} id 
         * @param {string} [apiVersion] 
         * @param {UpdateFeatureToggleRequest} [updateFeatureToggleRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateFeatureToggle: async (id: string, apiVersion?: string, updateFeatureToggleRequest?: UpdateFeatureToggleRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateFeatureToggle', 'id', id)
            const localVarPath = `/api/v1/feature_toggles/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateFeatureToggleRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * FeatureTogglesApi - functional programming interface
 * @export
 */
export const FeatureTogglesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = FeatureTogglesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Создать функциональный переключатель
         * @param {string} [apiVersion] 
         * @param {CreateFeatureToggleRequest} [createFeatureToggleRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createFeatureToggle(apiVersion?: string, createFeatureToggleRequest?: CreateFeatureToggleRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FeatureTogglesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createFeatureToggle(apiVersion, createFeatureToggleRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FeatureTogglesApi.createFeatureToggle']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Получить все функциональные переключатели
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllFeatureToggles(apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<FeatureTogglesResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllFeatureToggles(apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FeatureTogglesApi.getAllFeatureToggles']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Обновить функциональный переключатель
         * @param {string} id 
         * @param {string} [apiVersion] 
         * @param {UpdateFeatureToggleRequest} [updateFeatureToggleRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateFeatureToggle(id: string, apiVersion?: string, updateFeatureToggleRequest?: UpdateFeatureToggleRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FeatureTogglesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateFeatureToggle(id, apiVersion, updateFeatureToggleRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FeatureTogglesApi.updateFeatureToggle']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * FeatureTogglesApi - factory interface
 * @export
 */
export const FeatureTogglesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = FeatureTogglesApiFp(configuration)
    return {
        /**
         * 
         * @summary Создать функциональный переключатель
         * @param {FeatureTogglesApiCreateFeatureToggleRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createFeatureToggle(requestParameters: FeatureTogglesApiCreateFeatureToggleRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<FeatureTogglesResponse> {
            return localVarFp.createFeatureToggle(requestParameters.apiVersion, requestParameters.createFeatureToggleRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Получить все функциональные переключатели
         * @param {FeatureTogglesApiGetAllFeatureTogglesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllFeatureToggles(requestParameters: FeatureTogglesApiGetAllFeatureTogglesRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<Array<FeatureTogglesResponse>> {
            return localVarFp.getAllFeatureToggles(requestParameters.apiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Обновить функциональный переключатель
         * @param {FeatureTogglesApiUpdateFeatureToggleRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateFeatureToggle(requestParameters: FeatureTogglesApiUpdateFeatureToggleRequest, options?: RawAxiosRequestConfig): AxiosPromise<FeatureTogglesResponse> {
            return localVarFp.updateFeatureToggle(requestParameters.id, requestParameters.apiVersion, requestParameters.updateFeatureToggleRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for createFeatureToggle operation in FeatureTogglesApi.
 * @export
 * @interface FeatureTogglesApiCreateFeatureToggleRequest
 */
export interface FeatureTogglesApiCreateFeatureToggleRequest {
    /**
     * 
     * @type {string}
     * @memberof FeatureTogglesApiCreateFeatureToggle
     */
    readonly apiVersion?: string

    /**
     * 
     * @type {CreateFeatureToggleRequest}
     * @memberof FeatureTogglesApiCreateFeatureToggle
     */
    readonly createFeatureToggleRequest?: CreateFeatureToggleRequest
}

/**
 * Request parameters for getAllFeatureToggles operation in FeatureTogglesApi.
 * @export
 * @interface FeatureTogglesApiGetAllFeatureTogglesRequest
 */
export interface FeatureTogglesApiGetAllFeatureTogglesRequest {
    /**
     * 
     * @type {string}
     * @memberof FeatureTogglesApiGetAllFeatureToggles
     */
    readonly apiVersion?: string
}

/**
 * Request parameters for updateFeatureToggle operation in FeatureTogglesApi.
 * @export
 * @interface FeatureTogglesApiUpdateFeatureToggleRequest
 */
export interface FeatureTogglesApiUpdateFeatureToggleRequest {
    /**
     * 
     * @type {string}
     * @memberof FeatureTogglesApiUpdateFeatureToggle
     */
    readonly id: string

    /**
     * 
     * @type {string}
     * @memberof FeatureTogglesApiUpdateFeatureToggle
     */
    readonly apiVersion?: string

    /**
     * 
     * @type {UpdateFeatureToggleRequest}
     * @memberof FeatureTogglesApiUpdateFeatureToggle
     */
    readonly updateFeatureToggleRequest?: UpdateFeatureToggleRequest
}

/**
 * FeatureTogglesApi - object-oriented interface
 * @export
 * @class FeatureTogglesApi
 * @extends {BaseAPI}
 */
export class FeatureTogglesApi extends BaseAPI {
    /**
     * 
     * @summary Создать функциональный переключатель
     * @param {FeatureTogglesApiCreateFeatureToggleRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FeatureTogglesApi
     */
    public createFeatureToggle(requestParameters: FeatureTogglesApiCreateFeatureToggleRequest = {}, options?: RawAxiosRequestConfig) {
        return FeatureTogglesApiFp(this.configuration).createFeatureToggle(requestParameters.apiVersion, requestParameters.createFeatureToggleRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Получить все функциональные переключатели
     * @param {FeatureTogglesApiGetAllFeatureTogglesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FeatureTogglesApi
     */
    public getAllFeatureToggles(requestParameters: FeatureTogglesApiGetAllFeatureTogglesRequest = {}, options?: RawAxiosRequestConfig) {
        return FeatureTogglesApiFp(this.configuration).getAllFeatureToggles(requestParameters.apiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Обновить функциональный переключатель
     * @param {FeatureTogglesApiUpdateFeatureToggleRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FeatureTogglesApi
     */
    public updateFeatureToggle(requestParameters: FeatureTogglesApiUpdateFeatureToggleRequest, options?: RawAxiosRequestConfig) {
        return FeatureTogglesApiFp(this.configuration).updateFeatureToggle(requestParameters.id, requestParameters.apiVersion, requestParameters.updateFeatureToggleRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * FeedbackApi - axios parameter creator
 * @export
 */
export const FeedbackApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Оставить обратную связь
         * @param {string} [apiVersion] 
         * @param {FeedbackRequest} [feedbackRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1FeedbackLeaveFeedbackPost: async (apiVersion?: string, feedbackRequest?: FeedbackRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/feedback/leave-feedback`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(feedbackRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * FeedbackApi - functional programming interface
 * @export
 */
export const FeedbackApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = FeedbackApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Оставить обратную связь
         * @param {string} [apiVersion] 
         * @param {FeedbackRequest} [feedbackRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1FeedbackLeaveFeedbackPost(apiVersion?: string, feedbackRequest?: FeedbackRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1FeedbackLeaveFeedbackPost(apiVersion, feedbackRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FeedbackApi.apiV1FeedbackLeaveFeedbackPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * FeedbackApi - factory interface
 * @export
 */
export const FeedbackApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = FeedbackApiFp(configuration)
    return {
        /**
         * 
         * @summary Оставить обратную связь
         * @param {FeedbackApiApiV1FeedbackLeaveFeedbackPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1FeedbackLeaveFeedbackPost(requestParameters: FeedbackApiApiV1FeedbackLeaveFeedbackPostRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiV1FeedbackLeaveFeedbackPost(requestParameters.apiVersion, requestParameters.feedbackRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for apiV1FeedbackLeaveFeedbackPost operation in FeedbackApi.
 * @export
 * @interface FeedbackApiApiV1FeedbackLeaveFeedbackPostRequest
 */
export interface FeedbackApiApiV1FeedbackLeaveFeedbackPostRequest {
    /**
     * 
     * @type {string}
     * @memberof FeedbackApiApiV1FeedbackLeaveFeedbackPost
     */
    readonly apiVersion?: string

    /**
     * 
     * @type {FeedbackRequest}
     * @memberof FeedbackApiApiV1FeedbackLeaveFeedbackPost
     */
    readonly feedbackRequest?: FeedbackRequest
}

/**
 * FeedbackApi - object-oriented interface
 * @export
 * @class FeedbackApi
 * @extends {BaseAPI}
 */
export class FeedbackApi extends BaseAPI {
    /**
     * 
     * @summary Оставить обратную связь
     * @param {FeedbackApiApiV1FeedbackLeaveFeedbackPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FeedbackApi
     */
    public apiV1FeedbackLeaveFeedbackPost(requestParameters: FeedbackApiApiV1FeedbackLeaveFeedbackPostRequest = {}, options?: RawAxiosRequestConfig) {
        return FeedbackApiFp(this.configuration).apiV1FeedbackLeaveFeedbackPost(requestParameters.apiVersion, requestParameters.feedbackRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * FileApi - axios parameter creator
 * @export
 */
export const FileApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Загрузить файл чата
         * @param {string} [apiVersion] 
         * @param {File} [file] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ChatsFileUploadPost: async (apiVersion?: string, file?: File, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/chats/file/upload`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * FileApi - functional programming interface
 * @export
 */
export const FileApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = FileApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Загрузить файл чата
         * @param {string} [apiVersion] 
         * @param {File} [file] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1ChatsFileUploadPost(apiVersion?: string, file?: File, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1ChatsFileUploadPost(apiVersion, file, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FileApi.apiV1ChatsFileUploadPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * FileApi - factory interface
 * @export
 */
export const FileApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = FileApiFp(configuration)
    return {
        /**
         * 
         * @summary Загрузить файл чата
         * @param {FileApiApiV1ChatsFileUploadPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ChatsFileUploadPost(requestParameters: FileApiApiV1ChatsFileUploadPostRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiV1ChatsFileUploadPost(requestParameters.apiVersion, requestParameters.file, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for apiV1ChatsFileUploadPost operation in FileApi.
 * @export
 * @interface FileApiApiV1ChatsFileUploadPostRequest
 */
export interface FileApiApiV1ChatsFileUploadPostRequest {
    /**
     * 
     * @type {string}
     * @memberof FileApiApiV1ChatsFileUploadPost
     */
    readonly apiVersion?: string

    /**
     * 
     * @type {File}
     * @memberof FileApiApiV1ChatsFileUploadPost
     */
    readonly file?: File
}

/**
 * FileApi - object-oriented interface
 * @export
 * @class FileApi
 * @extends {BaseAPI}
 */
export class FileApi extends BaseAPI {
    /**
     * 
     * @summary Загрузить файл чата
     * @param {FileApiApiV1ChatsFileUploadPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FileApi
     */
    public apiV1ChatsFileUploadPost(requestParameters: FileApiApiV1ChatsFileUploadPostRequest = {}, options?: RawAxiosRequestConfig) {
        return FileApiFp(this.configuration).apiV1ChatsFileUploadPost(requestParameters.apiVersion, requestParameters.file, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * HabitsApi - axios parameter creator
 * @export
 */
export const HabitsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Создать новую привычку
         * @param {string} [apiVersion] 
         * @param {HabitRequest} [habitRequest] Модель запроса с данными клиента
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createHabit: async (apiVersion?: string, habitRequest?: HabitRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/habits/create`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(habitRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Мягко удалить привычку
         * @param {string} habitId Идентификатор привычки
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteHabit: async (habitId: string, apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'habitId' is not null or undefined
            assertParamExists('deleteHabit', 'habitId', habitId)
            const localVarPath = `/api/v1/habits/{habitId}`
                .replace(`{${"habitId"}}`, encodeURIComponent(String(habitId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Получить все доступные привычки
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllHabit: async (apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/habits`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Получить привычку по ID
         * @param {string} habitId 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getHabitById: async (habitId: string, apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'habitId' is not null or undefined
            assertParamExists('getHabitById', 'habitId', habitId)
            const localVarPath = `/api/v1/habits/{habitId}`
                .replace(`{${"habitId"}}`, encodeURIComponent(String(habitId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Обновить привычку
         * @param {string} habitId 
         * @param {string} [apiVersion] 
         * @param {HabitRequest} [habitRequest] Модель запроса с данными клиента для обновления
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateHabit: async (habitId: string, apiVersion?: string, habitRequest?: HabitRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'habitId' is not null or undefined
            assertParamExists('updateHabit', 'habitId', habitId)
            const localVarPath = `/api/v1/habits/update/{habitId}`
                .replace(`{${"habitId"}}`, encodeURIComponent(String(habitId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(habitRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * HabitsApi - functional programming interface
 * @export
 */
export const HabitsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = HabitsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Создать новую привычку
         * @param {string} [apiVersion] 
         * @param {HabitRequest} [habitRequest] Модель запроса с данными клиента
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createHabit(apiVersion?: string, habitRequest?: HabitRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<HabitResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createHabit(apiVersion, habitRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['HabitsApi.createHabit']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Мягко удалить привычку
         * @param {string} habitId Идентификатор привычки
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteHabit(habitId: string, apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteHabit(habitId, apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['HabitsApi.deleteHabit']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Получить все доступные привычки
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllHabit(apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<HabitResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllHabit(apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['HabitsApi.getAllHabit']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Получить привычку по ID
         * @param {string} habitId 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getHabitById(habitId: string, apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<HabitResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getHabitById(habitId, apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['HabitsApi.getHabitById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Обновить привычку
         * @param {string} habitId 
         * @param {string} [apiVersion] 
         * @param {HabitRequest} [habitRequest] Модель запроса с данными клиента для обновления
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateHabit(habitId: string, apiVersion?: string, habitRequest?: HabitRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<HabitResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateHabit(habitId, apiVersion, habitRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['HabitsApi.updateHabit']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * HabitsApi - factory interface
 * @export
 */
export const HabitsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = HabitsApiFp(configuration)
    return {
        /**
         * 
         * @summary Создать новую привычку
         * @param {HabitsApiCreateHabitRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createHabit(requestParameters: HabitsApiCreateHabitRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<HabitResponse> {
            return localVarFp.createHabit(requestParameters.apiVersion, requestParameters.habitRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Мягко удалить привычку
         * @param {HabitsApiDeleteHabitRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteHabit(requestParameters: HabitsApiDeleteHabitRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteHabit(requestParameters.habitId, requestParameters.apiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Получить все доступные привычки
         * @param {HabitsApiGetAllHabitRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllHabit(requestParameters: HabitsApiGetAllHabitRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<Array<HabitResponse>> {
            return localVarFp.getAllHabit(requestParameters.apiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Получить привычку по ID
         * @param {HabitsApiGetHabitByIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getHabitById(requestParameters: HabitsApiGetHabitByIdRequest, options?: RawAxiosRequestConfig): AxiosPromise<HabitResponse> {
            return localVarFp.getHabitById(requestParameters.habitId, requestParameters.apiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Обновить привычку
         * @param {HabitsApiUpdateHabitRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateHabit(requestParameters: HabitsApiUpdateHabitRequest, options?: RawAxiosRequestConfig): AxiosPromise<HabitResponse> {
            return localVarFp.updateHabit(requestParameters.habitId, requestParameters.apiVersion, requestParameters.habitRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for createHabit operation in HabitsApi.
 * @export
 * @interface HabitsApiCreateHabitRequest
 */
export interface HabitsApiCreateHabitRequest {
    /**
     * 
     * @type {string}
     * @memberof HabitsApiCreateHabit
     */
    readonly apiVersion?: string

    /**
     * Модель запроса с данными клиента
     * @type {HabitRequest}
     * @memberof HabitsApiCreateHabit
     */
    readonly habitRequest?: HabitRequest
}

/**
 * Request parameters for deleteHabit operation in HabitsApi.
 * @export
 * @interface HabitsApiDeleteHabitRequest
 */
export interface HabitsApiDeleteHabitRequest {
    /**
     * Идентификатор привычки
     * @type {string}
     * @memberof HabitsApiDeleteHabit
     */
    readonly habitId: string

    /**
     * 
     * @type {string}
     * @memberof HabitsApiDeleteHabit
     */
    readonly apiVersion?: string
}

/**
 * Request parameters for getAllHabit operation in HabitsApi.
 * @export
 * @interface HabitsApiGetAllHabitRequest
 */
export interface HabitsApiGetAllHabitRequest {
    /**
     * 
     * @type {string}
     * @memberof HabitsApiGetAllHabit
     */
    readonly apiVersion?: string
}

/**
 * Request parameters for getHabitById operation in HabitsApi.
 * @export
 * @interface HabitsApiGetHabitByIdRequest
 */
export interface HabitsApiGetHabitByIdRequest {
    /**
     * 
     * @type {string}
     * @memberof HabitsApiGetHabitById
     */
    readonly habitId: string

    /**
     * 
     * @type {string}
     * @memberof HabitsApiGetHabitById
     */
    readonly apiVersion?: string
}

/**
 * Request parameters for updateHabit operation in HabitsApi.
 * @export
 * @interface HabitsApiUpdateHabitRequest
 */
export interface HabitsApiUpdateHabitRequest {
    /**
     * 
     * @type {string}
     * @memberof HabitsApiUpdateHabit
     */
    readonly habitId: string

    /**
     * 
     * @type {string}
     * @memberof HabitsApiUpdateHabit
     */
    readonly apiVersion?: string

    /**
     * Модель запроса с данными клиента для обновления
     * @type {HabitRequest}
     * @memberof HabitsApiUpdateHabit
     */
    readonly habitRequest?: HabitRequest
}

/**
 * HabitsApi - object-oriented interface
 * @export
 * @class HabitsApi
 * @extends {BaseAPI}
 */
export class HabitsApi extends BaseAPI {
    /**
     * 
     * @summary Создать новую привычку
     * @param {HabitsApiCreateHabitRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HabitsApi
     */
    public createHabit(requestParameters: HabitsApiCreateHabitRequest = {}, options?: RawAxiosRequestConfig) {
        return HabitsApiFp(this.configuration).createHabit(requestParameters.apiVersion, requestParameters.habitRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Мягко удалить привычку
     * @param {HabitsApiDeleteHabitRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HabitsApi
     */
    public deleteHabit(requestParameters: HabitsApiDeleteHabitRequest, options?: RawAxiosRequestConfig) {
        return HabitsApiFp(this.configuration).deleteHabit(requestParameters.habitId, requestParameters.apiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Получить все доступные привычки
     * @param {HabitsApiGetAllHabitRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HabitsApi
     */
    public getAllHabit(requestParameters: HabitsApiGetAllHabitRequest = {}, options?: RawAxiosRequestConfig) {
        return HabitsApiFp(this.configuration).getAllHabit(requestParameters.apiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Получить привычку по ID
     * @param {HabitsApiGetHabitByIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HabitsApi
     */
    public getHabitById(requestParameters: HabitsApiGetHabitByIdRequest, options?: RawAxiosRequestConfig) {
        return HabitsApiFp(this.configuration).getHabitById(requestParameters.habitId, requestParameters.apiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Обновить привычку
     * @param {HabitsApiUpdateHabitRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HabitsApi
     */
    public updateHabit(requestParameters: HabitsApiUpdateHabitRequest, options?: RawAxiosRequestConfig) {
        return HabitsApiFp(this.configuration).updateHabit(requestParameters.habitId, requestParameters.apiVersion, requestParameters.habitRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * HealthApi - axios parameter creator
 * @export
 */
export const HealthApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Вернуть признак доступности HTTP-приложения
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        healthGet: async (apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/health`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * HealthApi - functional programming interface
 * @export
 */
export const HealthApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = HealthApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Вернуть признак доступности HTTP-приложения
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async healthGet(apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.healthGet(apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['HealthApi.healthGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * HealthApi - factory interface
 * @export
 */
export const HealthApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = HealthApiFp(configuration)
    return {
        /**
         * 
         * @summary Вернуть признак доступности HTTP-приложения
         * @param {HealthApiHealthGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        healthGet(requestParameters: HealthApiHealthGetRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.healthGet(requestParameters.apiVersion, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for healthGet operation in HealthApi.
 * @export
 * @interface HealthApiHealthGetRequest
 */
export interface HealthApiHealthGetRequest {
    /**
     * 
     * @type {string}
     * @memberof HealthApiHealthGet
     */
    readonly apiVersion?: string
}

/**
 * HealthApi - object-oriented interface
 * @export
 * @class HealthApi
 * @extends {BaseAPI}
 */
export class HealthApi extends BaseAPI {
    /**
     * 
     * @summary Вернуть признак доступности HTTP-приложения
     * @param {HealthApiHealthGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HealthApi
     */
    public healthGet(requestParameters: HealthApiHealthGetRequest = {}, options?: RawAxiosRequestConfig) {
        return HealthApiFp(this.configuration).healthGet(requestParameters.apiVersion, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * HeapDumpsApi - axios parameter creator
 * @export
 */
export const HeapDumpsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Запросить граф управляемой памяти на выбранном экземпляре
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createMemoryHeapDump: async (apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/memory-diagnostics/heap-dumps`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Получить состояние сбора на выбранном экземпляре
         * @param {string} jobId 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMemoryHeapDump: async (jobId: string, apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'jobId' is not null or undefined
            assertParamExists('getMemoryHeapDump', 'jobId', jobId)
            const localVarPath = `/api/v1/memory-diagnostics/heap-dumps/{jobId}`
                .replace(`{${"jobId"}}`, encodeURIComponent(String(jobId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * HeapDumpsApi - functional programming interface
 * @export
 */
export const HeapDumpsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = HeapDumpsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Запросить граф управляемой памяти на выбранном экземпляре
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createMemoryHeapDump(apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<HeapDumpJobResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createMemoryHeapDump(apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['HeapDumpsApi.createMemoryHeapDump']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Получить состояние сбора на выбранном экземпляре
         * @param {string} jobId 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMemoryHeapDump(jobId: string, apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<HeapDumpJobResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMemoryHeapDump(jobId, apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['HeapDumpsApi.getMemoryHeapDump']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * HeapDumpsApi - factory interface
 * @export
 */
export const HeapDumpsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = HeapDumpsApiFp(configuration)
    return {
        /**
         * 
         * @summary Запросить граф управляемой памяти на выбранном экземпляре
         * @param {HeapDumpsApiCreateMemoryHeapDumpRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createMemoryHeapDump(requestParameters: HeapDumpsApiCreateMemoryHeapDumpRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<HeapDumpJobResponse> {
            return localVarFp.createMemoryHeapDump(requestParameters.apiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Получить состояние сбора на выбранном экземпляре
         * @param {HeapDumpsApiGetMemoryHeapDumpRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMemoryHeapDump(requestParameters: HeapDumpsApiGetMemoryHeapDumpRequest, options?: RawAxiosRequestConfig): AxiosPromise<HeapDumpJobResponse> {
            return localVarFp.getMemoryHeapDump(requestParameters.jobId, requestParameters.apiVersion, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for createMemoryHeapDump operation in HeapDumpsApi.
 * @export
 * @interface HeapDumpsApiCreateMemoryHeapDumpRequest
 */
export interface HeapDumpsApiCreateMemoryHeapDumpRequest {
    /**
     * 
     * @type {string}
     * @memberof HeapDumpsApiCreateMemoryHeapDump
     */
    readonly apiVersion?: string
}

/**
 * Request parameters for getMemoryHeapDump operation in HeapDumpsApi.
 * @export
 * @interface HeapDumpsApiGetMemoryHeapDumpRequest
 */
export interface HeapDumpsApiGetMemoryHeapDumpRequest {
    /**
     * 
     * @type {string}
     * @memberof HeapDumpsApiGetMemoryHeapDump
     */
    readonly jobId: string

    /**
     * 
     * @type {string}
     * @memberof HeapDumpsApiGetMemoryHeapDump
     */
    readonly apiVersion?: string
}

/**
 * HeapDumpsApi - object-oriented interface
 * @export
 * @class HeapDumpsApi
 * @extends {BaseAPI}
 */
export class HeapDumpsApi extends BaseAPI {
    /**
     * 
     * @summary Запросить граф управляемой памяти на выбранном экземпляре
     * @param {HeapDumpsApiCreateMemoryHeapDumpRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HeapDumpsApi
     */
    public createMemoryHeapDump(requestParameters: HeapDumpsApiCreateMemoryHeapDumpRequest = {}, options?: RawAxiosRequestConfig) {
        return HeapDumpsApiFp(this.configuration).createMemoryHeapDump(requestParameters.apiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Получить состояние сбора на выбранном экземпляре
     * @param {HeapDumpsApiGetMemoryHeapDumpRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HeapDumpsApi
     */
    public getMemoryHeapDump(requestParameters: HeapDumpsApiGetMemoryHeapDumpRequest, options?: RawAxiosRequestConfig) {
        return HeapDumpsApiFp(this.configuration).getMemoryHeapDump(requestParameters.jobId, requestParameters.apiVersion, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * HelpApi - axios parameter creator
 * @export
 */
export const HelpApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Провести Encrypt по AES-256
         * @param {string} [value] 
         * @param {AesKeyType} [keyCard] Тип AES-256 ключа
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        aes256Encrypt: async (value?: string, keyCard?: AesKeyType, apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/help/aes-256-encrypt`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (value !== undefined) {
                localVarQueryParameter['value'] = value;
            }

            if (keyCard !== undefined) {
                localVarQueryParameter['keyCard'] = keyCard;
            }


    
            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Проверить документы пользователя и чат с технической поддержкой
         * @param {string} [appUserId] 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        chatUserExists: async (appUserId?: string, apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/help/chat-user-exists`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (appUserId !== undefined) {
                localVarQueryParameter['appUserId'] = appUserId;
            }


    
            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Создать документ пользователя с начальными чатами
         * @param {string} [appUserId] 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createChatUserFirestore: async (appUserId?: string, apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/help/create-chat-user`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (appUserId !== undefined) {
                localVarQueryParameter['appUserId'] = appUserId;
            }


    
            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Создать подписку на события сделок RocketWork и вернуть токен доступа
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPostbackSubscriptions: async (apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/help/create-postback_subscriptions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Создать недостающие стороны чата пользователя с технической поддержкой
         * @param {string} [appUserId] 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTechnicalSupportChat: async (appUserId?: string, apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/help/create-technical-support-chat`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (appUserId !== undefined) {
                localVarQueryParameter['appUserId'] = appUserId;
            }


    
            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Удалить подписку на события RocketWork
         * @param {number} subscriptionId 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePostbackSubscriptions: async (subscriptionId: number, apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'subscriptionId' is not null or undefined
            assertParamExists('deletePostbackSubscriptions', 'subscriptionId', subscriptionId)
            const localVarPath = `/api/v1/help/delete-postback_subscriptions/{subscriptionId}`
                .replace(`{${"subscriptionId"}}`, encodeURIComponent(String(subscriptionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Сгенерировать ключ шифрования AES-256
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateAes256Key: async (apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/help/generate-aes-256-key`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Сгенерировать hash для пароля
         * @param {string} [value] 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generatePasswordHash: async (value?: string, apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/help/generate-password-hash`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (value !== undefined) {
                localVarQueryParameter['value'] = value;
            }


    
            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Сгенерировать salt
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateSalt: async (apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/help/generate-salt`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Получить хэш
         * @param {string} [value] 
         * @param {HashSaltType} [hashSaltType] 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getHash: async (value?: string, hashSaltType?: HashSaltType, apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/help/get-hash`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (value !== undefined) {
                localVarQueryParameter['value'] = value;
            }

            if (hashSaltType !== undefined) {
                localVarQueryParameter['hashSaltType'] = hashSaltType;
            }


    
            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Запросить текущие подписки на события RocketWork
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPostbackSubscriptions: async (apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/help/get-postback_subscriptions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Обновить имена и фотографии собеседников в документах чатов
         * @param {string} [appUserId] 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserFromFireBase: async (appUserId?: string, apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/help/GetUserFromFireBase`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (appUserId !== undefined) {
                localVarQueryParameter['appUserId'] = appUserId;
            }


    
            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Отправить тестовое электронное письмо
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendTestEmail: async (apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/help/test-email`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Отправить тестовое сообщение в информационный чат Telegram
         * @param {string} [message] 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendTestMessageToTelegram: async (message?: string, apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/help/SendTestMessageToTelegram`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (message !== undefined) {
                localVarQueryParameter['message'] = message;
            }


    
            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Заполнить недостающие координаты адресов
         * @param {string} [orderId] 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        startGeoCoder: async (orderId?: string, apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/help/StartGeoCoder`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (orderId !== undefined) {
                localVarQueryParameter['orderId'] = orderId;
            }


    
            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Синхронизировать счётчики непрочитанных сообщений пользователя
         * @param {string} [appUserId] 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncChatReadState: async (appUserId?: string, apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/help/SyncChatReadState`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (appUserId !== undefined) {
                localVarQueryParameter['appUserId'] = appUserId;
            }


    
            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Поставить в очередь тестовое уведомление исполнителей о заказе
         * @param {string} [orderId] 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        testNotifyExecutorsAboutNewOrderTask: async (orderId?: string, apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/help/TestNotifyExecutorsAboutNewOrderTask`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (orderId !== undefined) {
                localVarQueryParameter['orderId'] = orderId;
            }


    
            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Обновить привязку адресов к районам
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAddressDistricts: async (apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/help/update-address-districts`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Заполнить отсутствующие фотографии клиентов аватарами по полу
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateClientAvatars: async (apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/help/update-client-avatars`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Заполнить отсутствующие фотографии исполнителей аватарами по полу
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateExecutorAvatars: async (apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/help/update-executor-avatars`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * HelpApi - functional programming interface
 * @export
 */
export const HelpApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = HelpApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Провести Encrypt по AES-256
         * @param {string} [value] 
         * @param {AesKeyType} [keyCard] Тип AES-256 ключа
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async aes256Encrypt(value?: string, keyCard?: AesKeyType, apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.aes256Encrypt(value, keyCard, apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['HelpApi.aes256Encrypt']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Проверить документы пользователя и чат с технической поддержкой
         * @param {string} [appUserId] 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async chatUserExists(appUserId?: string, apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.chatUserExists(appUserId, apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['HelpApi.chatUserExists']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Создать документ пользователя с начальными чатами
         * @param {string} [appUserId] 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createChatUserFirestore(appUserId?: string, apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createChatUserFirestore(appUserId, apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['HelpApi.createChatUserFirestore']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Создать подписку на события сделок RocketWork и вернуть токен доступа
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createPostbackSubscriptions(apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createPostbackSubscriptions(apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['HelpApi.createPostbackSubscriptions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Создать недостающие стороны чата пользователя с технической поддержкой
         * @param {string} [appUserId] 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createTechnicalSupportChat(appUserId?: string, apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createTechnicalSupportChat(appUserId, apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['HelpApi.createTechnicalSupportChat']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Удалить подписку на события RocketWork
         * @param {number} subscriptionId 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deletePostbackSubscriptions(subscriptionId: number, apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deletePostbackSubscriptions(subscriptionId, apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['HelpApi.deletePostbackSubscriptions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Сгенерировать ключ шифрования AES-256
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async generateAes256Key(apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.generateAes256Key(apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['HelpApi.generateAes256Key']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Сгенерировать hash для пароля
         * @param {string} [value] 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async generatePasswordHash(value?: string, apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.generatePasswordHash(value, apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['HelpApi.generatePasswordHash']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Сгенерировать salt
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async generateSalt(apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.generateSalt(apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['HelpApi.generateSalt']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Получить хэш
         * @param {string} [value] 
         * @param {HashSaltType} [hashSaltType] 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getHash(value?: string, hashSaltType?: HashSaltType, apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getHash(value, hashSaltType, apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['HelpApi.getHash']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Запросить текущие подписки на события RocketWork
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPostbackSubscriptions(apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPostbackSubscriptions(apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['HelpApi.getPostbackSubscriptions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Обновить имена и фотографии собеседников в документах чатов
         * @param {string} [appUserId] 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUserFromFireBase(appUserId?: string, apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUserFromFireBase(appUserId, apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['HelpApi.getUserFromFireBase']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Отправить тестовое электронное письмо
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sendTestEmail(apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sendTestEmail(apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['HelpApi.sendTestEmail']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Отправить тестовое сообщение в информационный чат Telegram
         * @param {string} [message] 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sendTestMessageToTelegram(message?: string, apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sendTestMessageToTelegram(message, apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['HelpApi.sendTestMessageToTelegram']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Заполнить недостающие координаты адресов
         * @param {string} [orderId] 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async startGeoCoder(orderId?: string, apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.startGeoCoder(orderId, apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['HelpApi.startGeoCoder']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Синхронизировать счётчики непрочитанных сообщений пользователя
         * @param {string} [appUserId] 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async syncChatReadState(appUserId?: string, apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.syncChatReadState(appUserId, apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['HelpApi.syncChatReadState']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Поставить в очередь тестовое уведомление исполнителей о заказе
         * @param {string} [orderId] 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async testNotifyExecutorsAboutNewOrderTask(orderId?: string, apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.testNotifyExecutorsAboutNewOrderTask(orderId, apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['HelpApi.testNotifyExecutorsAboutNewOrderTask']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Обновить привязку адресов к районам
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateAddressDistricts(apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateAddressDistricts(apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['HelpApi.updateAddressDistricts']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Заполнить отсутствующие фотографии клиентов аватарами по полу
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateClientAvatars(apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateClientAvatars(apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['HelpApi.updateClientAvatars']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Заполнить отсутствующие фотографии исполнителей аватарами по полу
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateExecutorAvatars(apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateExecutorAvatars(apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['HelpApi.updateExecutorAvatars']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * HelpApi - factory interface
 * @export
 */
export const HelpApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = HelpApiFp(configuration)
    return {
        /**
         * 
         * @summary Провести Encrypt по AES-256
         * @param {HelpApiAes256EncryptRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        aes256Encrypt(requestParameters: HelpApiAes256EncryptRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.aes256Encrypt(requestParameters.value, requestParameters.keyCard, requestParameters.apiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Проверить документы пользователя и чат с технической поддержкой
         * @param {HelpApiChatUserExistsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        chatUserExists(requestParameters: HelpApiChatUserExistsRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.chatUserExists(requestParameters.appUserId, requestParameters.apiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Создать документ пользователя с начальными чатами
         * @param {HelpApiCreateChatUserFirestoreRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createChatUserFirestore(requestParameters: HelpApiCreateChatUserFirestoreRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.createChatUserFirestore(requestParameters.appUserId, requestParameters.apiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Создать подписку на события сделок RocketWork и вернуть токен доступа
         * @param {HelpApiCreatePostbackSubscriptionsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPostbackSubscriptions(requestParameters: HelpApiCreatePostbackSubscriptionsRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.createPostbackSubscriptions(requestParameters.apiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Создать недостающие стороны чата пользователя с технической поддержкой
         * @param {HelpApiCreateTechnicalSupportChatRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTechnicalSupportChat(requestParameters: HelpApiCreateTechnicalSupportChatRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.createTechnicalSupportChat(requestParameters.appUserId, requestParameters.apiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Удалить подписку на события RocketWork
         * @param {HelpApiDeletePostbackSubscriptionsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePostbackSubscriptions(requestParameters: HelpApiDeletePostbackSubscriptionsRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deletePostbackSubscriptions(requestParameters.subscriptionId, requestParameters.apiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Сгенерировать ключ шифрования AES-256
         * @param {HelpApiGenerateAes256KeyRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateAes256Key(requestParameters: HelpApiGenerateAes256KeyRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.generateAes256Key(requestParameters.apiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Сгенерировать hash для пароля
         * @param {HelpApiGeneratePasswordHashRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generatePasswordHash(requestParameters: HelpApiGeneratePasswordHashRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.generatePasswordHash(requestParameters.value, requestParameters.apiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Сгенерировать salt
         * @param {HelpApiGenerateSaltRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateSalt(requestParameters: HelpApiGenerateSaltRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.generateSalt(requestParameters.apiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Получить хэш
         * @param {HelpApiGetHashRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getHash(requestParameters: HelpApiGetHashRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.getHash(requestParameters.value, requestParameters.hashSaltType, requestParameters.apiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Запросить текущие подписки на события RocketWork
         * @param {HelpApiGetPostbackSubscriptionsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPostbackSubscriptions(requestParameters: HelpApiGetPostbackSubscriptionsRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.getPostbackSubscriptions(requestParameters.apiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Обновить имена и фотографии собеседников в документах чатов
         * @param {HelpApiGetUserFromFireBaseRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserFromFireBase(requestParameters: HelpApiGetUserFromFireBaseRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.getUserFromFireBase(requestParameters.appUserId, requestParameters.apiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Отправить тестовое электронное письмо
         * @param {HelpApiSendTestEmailRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendTestEmail(requestParameters: HelpApiSendTestEmailRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.sendTestEmail(requestParameters.apiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Отправить тестовое сообщение в информационный чат Telegram
         * @param {HelpApiSendTestMessageToTelegramRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendTestMessageToTelegram(requestParameters: HelpApiSendTestMessageToTelegramRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.sendTestMessageToTelegram(requestParameters.message, requestParameters.apiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Заполнить недостающие координаты адресов
         * @param {HelpApiStartGeoCoderRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        startGeoCoder(requestParameters: HelpApiStartGeoCoderRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.startGeoCoder(requestParameters.orderId, requestParameters.apiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Синхронизировать счётчики непрочитанных сообщений пользователя
         * @param {HelpApiSyncChatReadStateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncChatReadState(requestParameters: HelpApiSyncChatReadStateRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.syncChatReadState(requestParameters.appUserId, requestParameters.apiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Поставить в очередь тестовое уведомление исполнителей о заказе
         * @param {HelpApiTestNotifyExecutorsAboutNewOrderTaskRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        testNotifyExecutorsAboutNewOrderTask(requestParameters: HelpApiTestNotifyExecutorsAboutNewOrderTaskRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.testNotifyExecutorsAboutNewOrderTask(requestParameters.orderId, requestParameters.apiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Обновить привязку адресов к районам
         * @param {HelpApiUpdateAddressDistrictsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAddressDistricts(requestParameters: HelpApiUpdateAddressDistrictsRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateAddressDistricts(requestParameters.apiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Заполнить отсутствующие фотографии клиентов аватарами по полу
         * @param {HelpApiUpdateClientAvatarsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateClientAvatars(requestParameters: HelpApiUpdateClientAvatarsRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateClientAvatars(requestParameters.apiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Заполнить отсутствующие фотографии исполнителей аватарами по полу
         * @param {HelpApiUpdateExecutorAvatarsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateExecutorAvatars(requestParameters: HelpApiUpdateExecutorAvatarsRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateExecutorAvatars(requestParameters.apiVersion, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for aes256Encrypt operation in HelpApi.
 * @export
 * @interface HelpApiAes256EncryptRequest
 */
export interface HelpApiAes256EncryptRequest {
    /**
     * 
     * @type {string}
     * @memberof HelpApiAes256Encrypt
     */
    readonly value?: string

    /**
     * Тип AES-256 ключа
     * @type {AesKeyType}
     * @memberof HelpApiAes256Encrypt
     */
    readonly keyCard?: AesKeyType

    /**
     * 
     * @type {string}
     * @memberof HelpApiAes256Encrypt
     */
    readonly apiVersion?: string
}

/**
 * Request parameters for chatUserExists operation in HelpApi.
 * @export
 * @interface HelpApiChatUserExistsRequest
 */
export interface HelpApiChatUserExistsRequest {
    /**
     * 
     * @type {string}
     * @memberof HelpApiChatUserExists
     */
    readonly appUserId?: string

    /**
     * 
     * @type {string}
     * @memberof HelpApiChatUserExists
     */
    readonly apiVersion?: string
}

/**
 * Request parameters for createChatUserFirestore operation in HelpApi.
 * @export
 * @interface HelpApiCreateChatUserFirestoreRequest
 */
export interface HelpApiCreateChatUserFirestoreRequest {
    /**
     * 
     * @type {string}
     * @memberof HelpApiCreateChatUserFirestore
     */
    readonly appUserId?: string

    /**
     * 
     * @type {string}
     * @memberof HelpApiCreateChatUserFirestore
     */
    readonly apiVersion?: string
}

/**
 * Request parameters for createPostbackSubscriptions operation in HelpApi.
 * @export
 * @interface HelpApiCreatePostbackSubscriptionsRequest
 */
export interface HelpApiCreatePostbackSubscriptionsRequest {
    /**
     * 
     * @type {string}
     * @memberof HelpApiCreatePostbackSubscriptions
     */
    readonly apiVersion?: string
}

/**
 * Request parameters for createTechnicalSupportChat operation in HelpApi.
 * @export
 * @interface HelpApiCreateTechnicalSupportChatRequest
 */
export interface HelpApiCreateTechnicalSupportChatRequest {
    /**
     * 
     * @type {string}
     * @memberof HelpApiCreateTechnicalSupportChat
     */
    readonly appUserId?: string

    /**
     * 
     * @type {string}
     * @memberof HelpApiCreateTechnicalSupportChat
     */
    readonly apiVersion?: string
}

/**
 * Request parameters for deletePostbackSubscriptions operation in HelpApi.
 * @export
 * @interface HelpApiDeletePostbackSubscriptionsRequest
 */
export interface HelpApiDeletePostbackSubscriptionsRequest {
    /**
     * 
     * @type {number}
     * @memberof HelpApiDeletePostbackSubscriptions
     */
    readonly subscriptionId: number

    /**
     * 
     * @type {string}
     * @memberof HelpApiDeletePostbackSubscriptions
     */
    readonly apiVersion?: string
}

/**
 * Request parameters for generateAes256Key operation in HelpApi.
 * @export
 * @interface HelpApiGenerateAes256KeyRequest
 */
export interface HelpApiGenerateAes256KeyRequest {
    /**
     * 
     * @type {string}
     * @memberof HelpApiGenerateAes256Key
     */
    readonly apiVersion?: string
}

/**
 * Request parameters for generatePasswordHash operation in HelpApi.
 * @export
 * @interface HelpApiGeneratePasswordHashRequest
 */
export interface HelpApiGeneratePasswordHashRequest {
    /**
     * 
     * @type {string}
     * @memberof HelpApiGeneratePasswordHash
     */
    readonly value?: string

    /**
     * 
     * @type {string}
     * @memberof HelpApiGeneratePasswordHash
     */
    readonly apiVersion?: string
}

/**
 * Request parameters for generateSalt operation in HelpApi.
 * @export
 * @interface HelpApiGenerateSaltRequest
 */
export interface HelpApiGenerateSaltRequest {
    /**
     * 
     * @type {string}
     * @memberof HelpApiGenerateSalt
     */
    readonly apiVersion?: string
}

/**
 * Request parameters for getHash operation in HelpApi.
 * @export
 * @interface HelpApiGetHashRequest
 */
export interface HelpApiGetHashRequest {
    /**
     * 
     * @type {string}
     * @memberof HelpApiGetHash
     */
    readonly value?: string

    /**
     * 
     * @type {HashSaltType}
     * @memberof HelpApiGetHash
     */
    readonly hashSaltType?: HashSaltType

    /**
     * 
     * @type {string}
     * @memberof HelpApiGetHash
     */
    readonly apiVersion?: string
}

/**
 * Request parameters for getPostbackSubscriptions operation in HelpApi.
 * @export
 * @interface HelpApiGetPostbackSubscriptionsRequest
 */
export interface HelpApiGetPostbackSubscriptionsRequest {
    /**
     * 
     * @type {string}
     * @memberof HelpApiGetPostbackSubscriptions
     */
    readonly apiVersion?: string
}

/**
 * Request parameters for getUserFromFireBase operation in HelpApi.
 * @export
 * @interface HelpApiGetUserFromFireBaseRequest
 */
export interface HelpApiGetUserFromFireBaseRequest {
    /**
     * 
     * @type {string}
     * @memberof HelpApiGetUserFromFireBase
     */
    readonly appUserId?: string

    /**
     * 
     * @type {string}
     * @memberof HelpApiGetUserFromFireBase
     */
    readonly apiVersion?: string
}

/**
 * Request parameters for sendTestEmail operation in HelpApi.
 * @export
 * @interface HelpApiSendTestEmailRequest
 */
export interface HelpApiSendTestEmailRequest {
    /**
     * 
     * @type {string}
     * @memberof HelpApiSendTestEmail
     */
    readonly apiVersion?: string
}

/**
 * Request parameters for sendTestMessageToTelegram operation in HelpApi.
 * @export
 * @interface HelpApiSendTestMessageToTelegramRequest
 */
export interface HelpApiSendTestMessageToTelegramRequest {
    /**
     * 
     * @type {string}
     * @memberof HelpApiSendTestMessageToTelegram
     */
    readonly message?: string

    /**
     * 
     * @type {string}
     * @memberof HelpApiSendTestMessageToTelegram
     */
    readonly apiVersion?: string
}

/**
 * Request parameters for startGeoCoder operation in HelpApi.
 * @export
 * @interface HelpApiStartGeoCoderRequest
 */
export interface HelpApiStartGeoCoderRequest {
    /**
     * 
     * @type {string}
     * @memberof HelpApiStartGeoCoder
     */
    readonly orderId?: string

    /**
     * 
     * @type {string}
     * @memberof HelpApiStartGeoCoder
     */
    readonly apiVersion?: string
}

/**
 * Request parameters for syncChatReadState operation in HelpApi.
 * @export
 * @interface HelpApiSyncChatReadStateRequest
 */
export interface HelpApiSyncChatReadStateRequest {
    /**
     * 
     * @type {string}
     * @memberof HelpApiSyncChatReadState
     */
    readonly appUserId?: string

    /**
     * 
     * @type {string}
     * @memberof HelpApiSyncChatReadState
     */
    readonly apiVersion?: string
}

/**
 * Request parameters for testNotifyExecutorsAboutNewOrderTask operation in HelpApi.
 * @export
 * @interface HelpApiTestNotifyExecutorsAboutNewOrderTaskRequest
 */
export interface HelpApiTestNotifyExecutorsAboutNewOrderTaskRequest {
    /**
     * 
     * @type {string}
     * @memberof HelpApiTestNotifyExecutorsAboutNewOrderTask
     */
    readonly orderId?: string

    /**
     * 
     * @type {string}
     * @memberof HelpApiTestNotifyExecutorsAboutNewOrderTask
     */
    readonly apiVersion?: string
}

/**
 * Request parameters for updateAddressDistricts operation in HelpApi.
 * @export
 * @interface HelpApiUpdateAddressDistrictsRequest
 */
export interface HelpApiUpdateAddressDistrictsRequest {
    /**
     * 
     * @type {string}
     * @memberof HelpApiUpdateAddressDistricts
     */
    readonly apiVersion?: string
}

/**
 * Request parameters for updateClientAvatars operation in HelpApi.
 * @export
 * @interface HelpApiUpdateClientAvatarsRequest
 */
export interface HelpApiUpdateClientAvatarsRequest {
    /**
     * 
     * @type {string}
     * @memberof HelpApiUpdateClientAvatars
     */
    readonly apiVersion?: string
}

/**
 * Request parameters for updateExecutorAvatars operation in HelpApi.
 * @export
 * @interface HelpApiUpdateExecutorAvatarsRequest
 */
export interface HelpApiUpdateExecutorAvatarsRequest {
    /**
     * 
     * @type {string}
     * @memberof HelpApiUpdateExecutorAvatars
     */
    readonly apiVersion?: string
}

/**
 * HelpApi - object-oriented interface
 * @export
 * @class HelpApi
 * @extends {BaseAPI}
 */
export class HelpApi extends BaseAPI {
    /**
     * 
     * @summary Провести Encrypt по AES-256
     * @param {HelpApiAes256EncryptRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HelpApi
     */
    public aes256Encrypt(requestParameters: HelpApiAes256EncryptRequest = {}, options?: RawAxiosRequestConfig) {
        return HelpApiFp(this.configuration).aes256Encrypt(requestParameters.value, requestParameters.keyCard, requestParameters.apiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Проверить документы пользователя и чат с технической поддержкой
     * @param {HelpApiChatUserExistsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HelpApi
     */
    public chatUserExists(requestParameters: HelpApiChatUserExistsRequest = {}, options?: RawAxiosRequestConfig) {
        return HelpApiFp(this.configuration).chatUserExists(requestParameters.appUserId, requestParameters.apiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Создать документ пользователя с начальными чатами
     * @param {HelpApiCreateChatUserFirestoreRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HelpApi
     */
    public createChatUserFirestore(requestParameters: HelpApiCreateChatUserFirestoreRequest = {}, options?: RawAxiosRequestConfig) {
        return HelpApiFp(this.configuration).createChatUserFirestore(requestParameters.appUserId, requestParameters.apiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Создать подписку на события сделок RocketWork и вернуть токен доступа
     * @param {HelpApiCreatePostbackSubscriptionsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HelpApi
     */
    public createPostbackSubscriptions(requestParameters: HelpApiCreatePostbackSubscriptionsRequest = {}, options?: RawAxiosRequestConfig) {
        return HelpApiFp(this.configuration).createPostbackSubscriptions(requestParameters.apiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Создать недостающие стороны чата пользователя с технической поддержкой
     * @param {HelpApiCreateTechnicalSupportChatRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HelpApi
     */
    public createTechnicalSupportChat(requestParameters: HelpApiCreateTechnicalSupportChatRequest = {}, options?: RawAxiosRequestConfig) {
        return HelpApiFp(this.configuration).createTechnicalSupportChat(requestParameters.appUserId, requestParameters.apiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Удалить подписку на события RocketWork
     * @param {HelpApiDeletePostbackSubscriptionsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HelpApi
     */
    public deletePostbackSubscriptions(requestParameters: HelpApiDeletePostbackSubscriptionsRequest, options?: RawAxiosRequestConfig) {
        return HelpApiFp(this.configuration).deletePostbackSubscriptions(requestParameters.subscriptionId, requestParameters.apiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Сгенерировать ключ шифрования AES-256
     * @param {HelpApiGenerateAes256KeyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HelpApi
     */
    public generateAes256Key(requestParameters: HelpApiGenerateAes256KeyRequest = {}, options?: RawAxiosRequestConfig) {
        return HelpApiFp(this.configuration).generateAes256Key(requestParameters.apiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Сгенерировать hash для пароля
     * @param {HelpApiGeneratePasswordHashRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HelpApi
     */
    public generatePasswordHash(requestParameters: HelpApiGeneratePasswordHashRequest = {}, options?: RawAxiosRequestConfig) {
        return HelpApiFp(this.configuration).generatePasswordHash(requestParameters.value, requestParameters.apiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Сгенерировать salt
     * @param {HelpApiGenerateSaltRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HelpApi
     */
    public generateSalt(requestParameters: HelpApiGenerateSaltRequest = {}, options?: RawAxiosRequestConfig) {
        return HelpApiFp(this.configuration).generateSalt(requestParameters.apiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Получить хэш
     * @param {HelpApiGetHashRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HelpApi
     */
    public getHash(requestParameters: HelpApiGetHashRequest = {}, options?: RawAxiosRequestConfig) {
        return HelpApiFp(this.configuration).getHash(requestParameters.value, requestParameters.hashSaltType, requestParameters.apiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Запросить текущие подписки на события RocketWork
     * @param {HelpApiGetPostbackSubscriptionsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HelpApi
     */
    public getPostbackSubscriptions(requestParameters: HelpApiGetPostbackSubscriptionsRequest = {}, options?: RawAxiosRequestConfig) {
        return HelpApiFp(this.configuration).getPostbackSubscriptions(requestParameters.apiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Обновить имена и фотографии собеседников в документах чатов
     * @param {HelpApiGetUserFromFireBaseRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HelpApi
     */
    public getUserFromFireBase(requestParameters: HelpApiGetUserFromFireBaseRequest = {}, options?: RawAxiosRequestConfig) {
        return HelpApiFp(this.configuration).getUserFromFireBase(requestParameters.appUserId, requestParameters.apiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Отправить тестовое электронное письмо
     * @param {HelpApiSendTestEmailRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HelpApi
     */
    public sendTestEmail(requestParameters: HelpApiSendTestEmailRequest = {}, options?: RawAxiosRequestConfig) {
        return HelpApiFp(this.configuration).sendTestEmail(requestParameters.apiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Отправить тестовое сообщение в информационный чат Telegram
     * @param {HelpApiSendTestMessageToTelegramRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HelpApi
     */
    public sendTestMessageToTelegram(requestParameters: HelpApiSendTestMessageToTelegramRequest = {}, options?: RawAxiosRequestConfig) {
        return HelpApiFp(this.configuration).sendTestMessageToTelegram(requestParameters.message, requestParameters.apiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Заполнить недостающие координаты адресов
     * @param {HelpApiStartGeoCoderRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HelpApi
     */
    public startGeoCoder(requestParameters: HelpApiStartGeoCoderRequest = {}, options?: RawAxiosRequestConfig) {
        return HelpApiFp(this.configuration).startGeoCoder(requestParameters.orderId, requestParameters.apiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Синхронизировать счётчики непрочитанных сообщений пользователя
     * @param {HelpApiSyncChatReadStateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HelpApi
     */
    public syncChatReadState(requestParameters: HelpApiSyncChatReadStateRequest = {}, options?: RawAxiosRequestConfig) {
        return HelpApiFp(this.configuration).syncChatReadState(requestParameters.appUserId, requestParameters.apiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Поставить в очередь тестовое уведомление исполнителей о заказе
     * @param {HelpApiTestNotifyExecutorsAboutNewOrderTaskRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HelpApi
     */
    public testNotifyExecutorsAboutNewOrderTask(requestParameters: HelpApiTestNotifyExecutorsAboutNewOrderTaskRequest = {}, options?: RawAxiosRequestConfig) {
        return HelpApiFp(this.configuration).testNotifyExecutorsAboutNewOrderTask(requestParameters.orderId, requestParameters.apiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Обновить привязку адресов к районам
     * @param {HelpApiUpdateAddressDistrictsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HelpApi
     */
    public updateAddressDistricts(requestParameters: HelpApiUpdateAddressDistrictsRequest = {}, options?: RawAxiosRequestConfig) {
        return HelpApiFp(this.configuration).updateAddressDistricts(requestParameters.apiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Заполнить отсутствующие фотографии клиентов аватарами по полу
     * @param {HelpApiUpdateClientAvatarsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HelpApi
     */
    public updateClientAvatars(requestParameters: HelpApiUpdateClientAvatarsRequest = {}, options?: RawAxiosRequestConfig) {
        return HelpApiFp(this.configuration).updateClientAvatars(requestParameters.apiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Заполнить отсутствующие фотографии исполнителей аватарами по полу
     * @param {HelpApiUpdateExecutorAvatarsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HelpApi
     */
    public updateExecutorAvatars(requestParameters: HelpApiUpdateExecutorAvatarsRequest = {}, options?: RawAxiosRequestConfig) {
        return HelpApiFp(this.configuration).updateExecutorAvatars(requestParameters.apiVersion, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * HelpPushApi - axios parameter creator
 * @export
 */
export const HelpPushApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Получить назначения переходов и поддержку мобильными приложениями
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPushTargets: async (apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/help/push-targets`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Поставить проверочный push с выбранным назначением в очередь отправки
         * @param {string} [apiVersion] 
         * @param {NotifyRequest} [notifyRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendNavigationPush: async (apiVersion?: string, notifyRequest?: NotifyRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/help/send-push`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(notifyRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * HelpPushApi - functional programming interface
 * @export
 */
export const HelpPushApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = HelpPushApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Получить назначения переходов и поддержку мобильными приложениями
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPushTargets(apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PushNavigationTargetResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPushTargets(apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['HelpPushApi.getPushTargets']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Поставить проверочный push с выбранным назначением в очередь отправки
         * @param {string} [apiVersion] 
         * @param {NotifyRequest} [notifyRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sendNavigationPush(apiVersion?: string, notifyRequest?: NotifyRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<NavigationPushResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sendNavigationPush(apiVersion, notifyRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['HelpPushApi.sendNavigationPush']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * HelpPushApi - factory interface
 * @export
 */
export const HelpPushApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = HelpPushApiFp(configuration)
    return {
        /**
         * 
         * @summary Получить назначения переходов и поддержку мобильными приложениями
         * @param {HelpPushApiGetPushTargetsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPushTargets(requestParameters: HelpPushApiGetPushTargetsRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<Array<PushNavigationTargetResponse>> {
            return localVarFp.getPushTargets(requestParameters.apiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Поставить проверочный push с выбранным назначением в очередь отправки
         * @param {HelpPushApiSendNavigationPushRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendNavigationPush(requestParameters: HelpPushApiSendNavigationPushRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<NavigationPushResponse> {
            return localVarFp.sendNavigationPush(requestParameters.apiVersion, requestParameters.notifyRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for getPushTargets operation in HelpPushApi.
 * @export
 * @interface HelpPushApiGetPushTargetsRequest
 */
export interface HelpPushApiGetPushTargetsRequest {
    /**
     * 
     * @type {string}
     * @memberof HelpPushApiGetPushTargets
     */
    readonly apiVersion?: string
}

/**
 * Request parameters for sendNavigationPush operation in HelpPushApi.
 * @export
 * @interface HelpPushApiSendNavigationPushRequest
 */
export interface HelpPushApiSendNavigationPushRequest {
    /**
     * 
     * @type {string}
     * @memberof HelpPushApiSendNavigationPush
     */
    readonly apiVersion?: string

    /**
     * 
     * @type {NotifyRequest}
     * @memberof HelpPushApiSendNavigationPush
     */
    readonly notifyRequest?: NotifyRequest
}

/**
 * HelpPushApi - object-oriented interface
 * @export
 * @class HelpPushApi
 * @extends {BaseAPI}
 */
export class HelpPushApi extends BaseAPI {
    /**
     * 
     * @summary Получить назначения переходов и поддержку мобильными приложениями
     * @param {HelpPushApiGetPushTargetsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HelpPushApi
     */
    public getPushTargets(requestParameters: HelpPushApiGetPushTargetsRequest = {}, options?: RawAxiosRequestConfig) {
        return HelpPushApiFp(this.configuration).getPushTargets(requestParameters.apiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Поставить проверочный push с выбранным назначением в очередь отправки
     * @param {HelpPushApiSendNavigationPushRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HelpPushApi
     */
    public sendNavigationPush(requestParameters: HelpPushApiSendNavigationPushRequest = {}, options?: RawAxiosRequestConfig) {
        return HelpPushApiFp(this.configuration).sendNavigationPush(requestParameters.apiVersion, requestParameters.notifyRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * HomeApi - axios parameter creator
 * @export
 */
export const HomeApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Получить действующие промоакции города профиля клиента
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getHomePromotions: async (apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/home/promotions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * HomeApi - functional programming interface
 * @export
 */
export const HomeApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = HomeApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Получить действующие промоакции города профиля клиента
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getHomePromotions(apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<HomePromotionsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getHomePromotions(apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['HomeApi.getHomePromotions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * HomeApi - factory interface
 * @export
 */
export const HomeApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = HomeApiFp(configuration)
    return {
        /**
         * 
         * @summary Получить действующие промоакции города профиля клиента
         * @param {HomeApiGetHomePromotionsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getHomePromotions(requestParameters: HomeApiGetHomePromotionsRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<HomePromotionsResponse> {
            return localVarFp.getHomePromotions(requestParameters.apiVersion, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for getHomePromotions operation in HomeApi.
 * @export
 * @interface HomeApiGetHomePromotionsRequest
 */
export interface HomeApiGetHomePromotionsRequest {
    /**
     * 
     * @type {string}
     * @memberof HomeApiGetHomePromotions
     */
    readonly apiVersion?: string
}

/**
 * HomeApi - object-oriented interface
 * @export
 * @class HomeApi
 * @extends {BaseAPI}
 */
export class HomeApi extends BaseAPI {
    /**
     * 
     * @summary Получить действующие промоакции города профиля клиента
     * @param {HomeApiGetHomePromotionsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HomeApi
     */
    public getHomePromotions(requestParameters: HomeApiGetHomePromotionsRequest = {}, options?: RawAxiosRequestConfig) {
        return HomeApiFp(this.configuration).getHomePromotions(requestParameters.apiVersion, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ImageApi - axios parameter creator
 * @export
 */
export const ImageApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Сохранить изображение и предпросмотр и вернуть ссылку на оригинал
         * @param {string} [apiVersion] 
         * @param {File} [file] 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        apiV1ImagePost: async (apiVersion?: string, file?: File, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/image`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ImageApi - functional programming interface
 * @export
 */
export const ImageApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ImageApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Сохранить изображение и предпросмотр и вернуть ссылку на оригинал
         * @param {string} [apiVersion] 
         * @param {File} [file] 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        async apiV1ImagePost(apiVersion?: string, file?: File, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1ImagePost(apiVersion, file, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ImageApi.apiV1ImagePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ImageApi - factory interface
 * @export
 */
export const ImageApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ImageApiFp(configuration)
    return {
        /**
         * 
         * @summary Сохранить изображение и предпросмотр и вернуть ссылку на оригинал
         * @param {ImageApiApiV1ImagePostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        apiV1ImagePost(requestParameters: ImageApiApiV1ImagePostRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.apiV1ImagePost(requestParameters.apiVersion, requestParameters.file, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for apiV1ImagePost operation in ImageApi.
 * @export
 * @interface ImageApiApiV1ImagePostRequest
 */
export interface ImageApiApiV1ImagePostRequest {
    /**
     * 
     * @type {string}
     * @memberof ImageApiApiV1ImagePost
     */
    readonly apiVersion?: string

    /**
     * 
     * @type {File}
     * @memberof ImageApiApiV1ImagePost
     */
    readonly file?: File
}

/**
 * ImageApi - object-oriented interface
 * @export
 * @class ImageApi
 * @extends {BaseAPI}
 */
export class ImageApi extends BaseAPI {
    /**
     * 
     * @summary Сохранить изображение и предпросмотр и вернуть ссылку на оригинал
     * @param {ImageApiApiV1ImagePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof ImageApi
     */
    public apiV1ImagePost(requestParameters: ImageApiApiV1ImagePostRequest = {}, options?: RawAxiosRequestConfig) {
        return ImageApiFp(this.configuration).apiV1ImagePost(requestParameters.apiVersion, requestParameters.file, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * LessonApi - axios parameter creator
 * @export
 */
export const LessonApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Создать урок
         * @param {string} [apiVersion] 
         * @param {CreateLessonRequest} [createLessonRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createLesson: async (apiVersion?: string, createLessonRequest?: CreateLessonRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/lessons`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createLessonRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Удалить урок
         * @param {number} id Идентификатор урока
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteLesson: async (id: number, apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteLesson', 'id', id)
            const localVarPath = `/api/v1/lessons/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Получить все уроки  С фильтрацией по типу питомцев
         * @param {ApiPetType} [petType] Виды питомцев и совместный тип заказа
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllLessons: async (petType?: ApiPetType, apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/lessons`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (petType !== undefined) {
                localVarQueryParameter['petType'] = petType;
            }


    
            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Получить урок по ID
         * @param {number} id 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLessonById: async (id: number, apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getLessonById', 'id', id)
            const localVarPath = `/api/v1/lessons/GetLessonById/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Обновить урок по ID
         * @param {string} [apiVersion] 
         * @param {UpdateLessonRequest} [updateLessonRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateLesson: async (apiVersion?: string, updateLessonRequest?: UpdateLessonRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/lessons`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateLessonRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * LessonApi - functional programming interface
 * @export
 */
export const LessonApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = LessonApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Создать урок
         * @param {string} [apiVersion] 
         * @param {CreateLessonRequest} [createLessonRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createLesson(apiVersion?: string, createLessonRequest?: CreateLessonRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateLessonResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createLesson(apiVersion, createLessonRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LessonApi.createLesson']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Удалить урок
         * @param {number} id Идентификатор урока
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteLesson(id: number, apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteLesson(id, apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LessonApi.deleteLesson']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Получить все уроки  С фильтрацией по типу питомцев
         * @param {ApiPetType} [petType] Виды питомцев и совместный тип заказа
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllLessons(petType?: ApiPetType, apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetLessonResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllLessons(petType, apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LessonApi.getAllLessons']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Получить урок по ID
         * @param {number} id 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLessonById(id: number, apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetLessonResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLessonById(id, apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LessonApi.getLessonById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Обновить урок по ID
         * @param {string} [apiVersion] 
         * @param {UpdateLessonRequest} [updateLessonRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateLesson(apiVersion?: string, updateLessonRequest?: UpdateLessonRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetLessonResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateLesson(apiVersion, updateLessonRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LessonApi.updateLesson']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * LessonApi - factory interface
 * @export
 */
export const LessonApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = LessonApiFp(configuration)
    return {
        /**
         * 
         * @summary Создать урок
         * @param {LessonApiCreateLessonRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createLesson(requestParameters: LessonApiCreateLessonRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<CreateLessonResponse> {
            return localVarFp.createLesson(requestParameters.apiVersion, requestParameters.createLessonRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Удалить урок
         * @param {LessonApiDeleteLessonRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteLesson(requestParameters: LessonApiDeleteLessonRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteLesson(requestParameters.id, requestParameters.apiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Получить все уроки  С фильтрацией по типу питомцев
         * @param {LessonApiGetAllLessonsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllLessons(requestParameters: LessonApiGetAllLessonsRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<Array<GetLessonResponse>> {
            return localVarFp.getAllLessons(requestParameters.petType, requestParameters.apiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Получить урок по ID
         * @param {LessonApiGetLessonByIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLessonById(requestParameters: LessonApiGetLessonByIdRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetLessonResponse> {
            return localVarFp.getLessonById(requestParameters.id, requestParameters.apiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Обновить урок по ID
         * @param {LessonApiUpdateLessonRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateLesson(requestParameters: LessonApiUpdateLessonRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<GetLessonResponse> {
            return localVarFp.updateLesson(requestParameters.apiVersion, requestParameters.updateLessonRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for createLesson operation in LessonApi.
 * @export
 * @interface LessonApiCreateLessonRequest
 */
export interface LessonApiCreateLessonRequest {
    /**
     * 
     * @type {string}
     * @memberof LessonApiCreateLesson
     */
    readonly apiVersion?: string

    /**
     * 
     * @type {CreateLessonRequest}
     * @memberof LessonApiCreateLesson
     */
    readonly createLessonRequest?: CreateLessonRequest
}

/**
 * Request parameters for deleteLesson operation in LessonApi.
 * @export
 * @interface LessonApiDeleteLessonRequest
 */
export interface LessonApiDeleteLessonRequest {
    /**
     * Идентификатор урока
     * @type {number}
     * @memberof LessonApiDeleteLesson
     */
    readonly id: number

    /**
     * 
     * @type {string}
     * @memberof LessonApiDeleteLesson
     */
    readonly apiVersion?: string
}

/**
 * Request parameters for getAllLessons operation in LessonApi.
 * @export
 * @interface LessonApiGetAllLessonsRequest
 */
export interface LessonApiGetAllLessonsRequest {
    /**
     * Виды питомцев и совместный тип заказа
     * @type {ApiPetType}
     * @memberof LessonApiGetAllLessons
     */
    readonly petType?: ApiPetType

    /**
     * 
     * @type {string}
     * @memberof LessonApiGetAllLessons
     */
    readonly apiVersion?: string
}

/**
 * Request parameters for getLessonById operation in LessonApi.
 * @export
 * @interface LessonApiGetLessonByIdRequest
 */
export interface LessonApiGetLessonByIdRequest {
    /**
     * 
     * @type {number}
     * @memberof LessonApiGetLessonById
     */
    readonly id: number

    /**
     * 
     * @type {string}
     * @memberof LessonApiGetLessonById
     */
    readonly apiVersion?: string
}

/**
 * Request parameters for updateLesson operation in LessonApi.
 * @export
 * @interface LessonApiUpdateLessonRequest
 */
export interface LessonApiUpdateLessonRequest {
    /**
     * 
     * @type {string}
     * @memberof LessonApiUpdateLesson
     */
    readonly apiVersion?: string

    /**
     * 
     * @type {UpdateLessonRequest}
     * @memberof LessonApiUpdateLesson
     */
    readonly updateLessonRequest?: UpdateLessonRequest
}

/**
 * LessonApi - object-oriented interface
 * @export
 * @class LessonApi
 * @extends {BaseAPI}
 */
export class LessonApi extends BaseAPI {
    /**
     * 
     * @summary Создать урок
     * @param {LessonApiCreateLessonRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LessonApi
     */
    public createLesson(requestParameters: LessonApiCreateLessonRequest = {}, options?: RawAxiosRequestConfig) {
        return LessonApiFp(this.configuration).createLesson(requestParameters.apiVersion, requestParameters.createLessonRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Удалить урок
     * @param {LessonApiDeleteLessonRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LessonApi
     */
    public deleteLesson(requestParameters: LessonApiDeleteLessonRequest, options?: RawAxiosRequestConfig) {
        return LessonApiFp(this.configuration).deleteLesson(requestParameters.id, requestParameters.apiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Получить все уроки  С фильтрацией по типу питомцев
     * @param {LessonApiGetAllLessonsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LessonApi
     */
    public getAllLessons(requestParameters: LessonApiGetAllLessonsRequest = {}, options?: RawAxiosRequestConfig) {
        return LessonApiFp(this.configuration).getAllLessons(requestParameters.petType, requestParameters.apiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Получить урок по ID
     * @param {LessonApiGetLessonByIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LessonApi
     */
    public getLessonById(requestParameters: LessonApiGetLessonByIdRequest, options?: RawAxiosRequestConfig) {
        return LessonApiFp(this.configuration).getLessonById(requestParameters.id, requestParameters.apiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Обновить урок по ID
     * @param {LessonApiUpdateLessonRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LessonApi
     */
    public updateLesson(requestParameters: LessonApiUpdateLessonRequest = {}, options?: RawAxiosRequestConfig) {
        return LessonApiFp(this.configuration).updateLesson(requestParameters.apiVersion, requestParameters.updateLessonRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * LocationApi - axios parameter creator
 * @export
 */
export const LocationApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Массово обновить геолокации исполнителя
         * @param {string} [apiVersion] 
         * @param {Array<UpdateLocationRequest>} [updateLocationRequest] Модель запроса на обновление локации
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkUpdateLocations: async (apiVersion?: string, updateLocationRequest?: Array<UpdateLocationRequest>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/geo/bulk-update-locations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateLocationRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Получить активный отслеживаемый маршрут
         * @param {string} executorId 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getActiveTracking: async (executorId: string, apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'executorId' is not null or undefined
            assertParamExists('getActiveTracking', 'executorId', executorId)
            const localVarPath = `/api/v1/geo/get-active-tracking/{executorId}`
                .replace(`{${"executorId"}}`, encodeURIComponent(String(executorId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Получить все координаты локаций исполнителя
         * @param {number} cityId Идентификатор города
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllExecutorLocations: async (cityId: number, apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'cityId' is not null or undefined
            assertParamExists('getAllExecutorLocations', 'cityId', cityId)
            const localVarPath = `/api/v1/geo/all-executor-locations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (cityId !== undefined) {
                localVarQueryParameter['cityId'] = cityId;
            }


    
            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Получить локацию исполнителя
         * @param {string} executorId Идентификатор исполнителя
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getExecutorLocation: async (executorId: string, apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'executorId' is not null or undefined
            assertParamExists('getExecutorLocation', 'executorId', executorId)
            const localVarPath = `/api/v1/geo/executor-location/{executorId}`
                .replace(`{${"executorId"}}`, encodeURIComponent(String(executorId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Получить геолокации всех исполнителей в радиусе
         * @param {number} cityId Идентификатор города
         * @param {number} latitude Широта
         * @param {number} longitude Долгота
         * @param {number} radius Радиус поиска (км)
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getExecutorLocationsInRadius: async (cityId: number, latitude: number, longitude: number, radius: number, apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'cityId' is not null or undefined
            assertParamExists('getExecutorLocationsInRadius', 'cityId', cityId)
            // verify required parameter 'latitude' is not null or undefined
            assertParamExists('getExecutorLocationsInRadius', 'latitude', latitude)
            // verify required parameter 'longitude' is not null or undefined
            assertParamExists('getExecutorLocationsInRadius', 'longitude', longitude)
            // verify required parameter 'radius' is not null or undefined
            assertParamExists('getExecutorLocationsInRadius', 'radius', radius)
            const localVarPath = `/api/v1/geo/executor-locations-in-radius`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (cityId !== undefined) {
                localVarQueryParameter['CityId'] = cityId;
            }

            if (latitude !== undefined) {
                localVarQueryParameter['Latitude'] = latitude;
            }

            if (longitude !== undefined) {
                localVarQueryParameter['Longitude'] = longitude;
            }

            if (radius !== undefined) {
                localVarQueryParameter['Radius'] = radius;
            }


    
            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Получить геолокации отслеживаемого маршрута
         * @param {number} trackId Идентификатор отслеживаемого маршрута
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTracking: async (trackId: number, apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'trackId' is not null or undefined
            assertParamExists('getTracking', 'trackId', trackId)
            const localVarPath = `/api/v1/geo/get-tracking/{trackId}`
                .replace(`{${"trackId"}}`, encodeURIComponent(String(trackId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Обновить геолокацию исполнителя
         * @param {string} [apiVersion] 
         * @param {UpdateLocationRequest} [updateLocationRequest] Модель запроса на обновление локации
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateLocation: async (apiVersion?: string, updateLocationRequest?: UpdateLocationRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/geo/update-location`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateLocationRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * LocationApi - functional programming interface
 * @export
 */
export const LocationApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = LocationApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Массово обновить геолокации исполнителя
         * @param {string} [apiVersion] 
         * @param {Array<UpdateLocationRequest>} [updateLocationRequest] Модель запроса на обновление локации
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async bulkUpdateLocations(apiVersion?: string, updateLocationRequest?: Array<UpdateLocationRequest>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.bulkUpdateLocations(apiVersion, updateLocationRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LocationApi.bulkUpdateLocations']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Получить активный отслеживаемый маршрут
         * @param {string} executorId 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getActiveTracking(executorId: string, apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TrackResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getActiveTracking(executorId, apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LocationApi.getActiveTracking']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Получить все координаты локаций исполнителя
         * @param {number} cityId Идентификатор города
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllExecutorLocations(cityId: number, apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ExecutorLocationResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllExecutorLocations(cityId, apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LocationApi.getAllExecutorLocations']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Получить локацию исполнителя
         * @param {string} executorId Идентификатор исполнителя
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getExecutorLocation(executorId: string, apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ExecutorLocationResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getExecutorLocation(executorId, apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LocationApi.getExecutorLocation']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Получить геолокации всех исполнителей в радиусе
         * @param {number} cityId Идентификатор города
         * @param {number} latitude Широта
         * @param {number} longitude Долгота
         * @param {number} radius Радиус поиска (км)
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getExecutorLocationsInRadius(cityId: number, latitude: number, longitude: number, radius: number, apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ExecutorLocationResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getExecutorLocationsInRadius(cityId, latitude, longitude, radius, apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LocationApi.getExecutorLocationsInRadius']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Получить геолокации отслеживаемого маршрута
         * @param {number} trackId Идентификатор отслеживаемого маршрута
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTracking(trackId: number, apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TrackResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTracking(trackId, apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LocationApi.getTracking']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Обновить геолокацию исполнителя
         * @param {string} [apiVersion] 
         * @param {UpdateLocationRequest} [updateLocationRequest] Модель запроса на обновление локации
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateLocation(apiVersion?: string, updateLocationRequest?: UpdateLocationRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateLocation(apiVersion, updateLocationRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LocationApi.updateLocation']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * LocationApi - factory interface
 * @export
 */
export const LocationApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = LocationApiFp(configuration)
    return {
        /**
         * 
         * @summary Массово обновить геолокации исполнителя
         * @param {LocationApiBulkUpdateLocationsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkUpdateLocations(requestParameters: LocationApiBulkUpdateLocationsRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.bulkUpdateLocations(requestParameters.apiVersion, requestParameters.updateLocationRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Получить активный отслеживаемый маршрут
         * @param {LocationApiGetActiveTrackingRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getActiveTracking(requestParameters: LocationApiGetActiveTrackingRequest, options?: RawAxiosRequestConfig): AxiosPromise<TrackResponse> {
            return localVarFp.getActiveTracking(requestParameters.executorId, requestParameters.apiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Получить все координаты локаций исполнителя
         * @param {LocationApiGetAllExecutorLocationsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllExecutorLocations(requestParameters: LocationApiGetAllExecutorLocationsRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<ExecutorLocationResponse>> {
            return localVarFp.getAllExecutorLocations(requestParameters.cityId, requestParameters.apiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Получить локацию исполнителя
         * @param {LocationApiGetExecutorLocationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getExecutorLocation(requestParameters: LocationApiGetExecutorLocationRequest, options?: RawAxiosRequestConfig): AxiosPromise<ExecutorLocationResponse> {
            return localVarFp.getExecutorLocation(requestParameters.executorId, requestParameters.apiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Получить геолокации всех исполнителей в радиусе
         * @param {LocationApiGetExecutorLocationsInRadiusRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getExecutorLocationsInRadius(requestParameters: LocationApiGetExecutorLocationsInRadiusRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<ExecutorLocationResponse>> {
            return localVarFp.getExecutorLocationsInRadius(requestParameters.cityId, requestParameters.latitude, requestParameters.longitude, requestParameters.radius, requestParameters.apiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Получить геолокации отслеживаемого маршрута
         * @param {LocationApiGetTrackingRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTracking(requestParameters: LocationApiGetTrackingRequest, options?: RawAxiosRequestConfig): AxiosPromise<TrackResponse> {
            return localVarFp.getTracking(requestParameters.trackId, requestParameters.apiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Обновить геолокацию исполнителя
         * @param {LocationApiUpdateLocationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateLocation(requestParameters: LocationApiUpdateLocationRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateLocation(requestParameters.apiVersion, requestParameters.updateLocationRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for bulkUpdateLocations operation in LocationApi.
 * @export
 * @interface LocationApiBulkUpdateLocationsRequest
 */
export interface LocationApiBulkUpdateLocationsRequest {
    /**
     * 
     * @type {string}
     * @memberof LocationApiBulkUpdateLocations
     */
    readonly apiVersion?: string

    /**
     * Модель запроса на обновление локации
     * @type {Array<UpdateLocationRequest>}
     * @memberof LocationApiBulkUpdateLocations
     */
    readonly updateLocationRequest?: Array<UpdateLocationRequest>
}

/**
 * Request parameters for getActiveTracking operation in LocationApi.
 * @export
 * @interface LocationApiGetActiveTrackingRequest
 */
export interface LocationApiGetActiveTrackingRequest {
    /**
     * 
     * @type {string}
     * @memberof LocationApiGetActiveTracking
     */
    readonly executorId: string

    /**
     * 
     * @type {string}
     * @memberof LocationApiGetActiveTracking
     */
    readonly apiVersion?: string
}

/**
 * Request parameters for getAllExecutorLocations operation in LocationApi.
 * @export
 * @interface LocationApiGetAllExecutorLocationsRequest
 */
export interface LocationApiGetAllExecutorLocationsRequest {
    /**
     * Идентификатор города
     * @type {number}
     * @memberof LocationApiGetAllExecutorLocations
     */
    readonly cityId: number

    /**
     * 
     * @type {string}
     * @memberof LocationApiGetAllExecutorLocations
     */
    readonly apiVersion?: string
}

/**
 * Request parameters for getExecutorLocation operation in LocationApi.
 * @export
 * @interface LocationApiGetExecutorLocationRequest
 */
export interface LocationApiGetExecutorLocationRequest {
    /**
     * Идентификатор исполнителя
     * @type {string}
     * @memberof LocationApiGetExecutorLocation
     */
    readonly executorId: string

    /**
     * 
     * @type {string}
     * @memberof LocationApiGetExecutorLocation
     */
    readonly apiVersion?: string
}

/**
 * Request parameters for getExecutorLocationsInRadius operation in LocationApi.
 * @export
 * @interface LocationApiGetExecutorLocationsInRadiusRequest
 */
export interface LocationApiGetExecutorLocationsInRadiusRequest {
    /**
     * Идентификатор города
     * @type {number}
     * @memberof LocationApiGetExecutorLocationsInRadius
     */
    readonly cityId: number

    /**
     * Широта
     * @type {number}
     * @memberof LocationApiGetExecutorLocationsInRadius
     */
    readonly latitude: number

    /**
     * Долгота
     * @type {number}
     * @memberof LocationApiGetExecutorLocationsInRadius
     */
    readonly longitude: number

    /**
     * Радиус поиска (км)
     * @type {number}
     * @memberof LocationApiGetExecutorLocationsInRadius
     */
    readonly radius: number

    /**
     * 
     * @type {string}
     * @memberof LocationApiGetExecutorLocationsInRadius
     */
    readonly apiVersion?: string
}

/**
 * Request parameters for getTracking operation in LocationApi.
 * @export
 * @interface LocationApiGetTrackingRequest
 */
export interface LocationApiGetTrackingRequest {
    /**
     * Идентификатор отслеживаемого маршрута
     * @type {number}
     * @memberof LocationApiGetTracking
     */
    readonly trackId: number

    /**
     * 
     * @type {string}
     * @memberof LocationApiGetTracking
     */
    readonly apiVersion?: string
}

/**
 * Request parameters for updateLocation operation in LocationApi.
 * @export
 * @interface LocationApiUpdateLocationRequest
 */
export interface LocationApiUpdateLocationRequest {
    /**
     * 
     * @type {string}
     * @memberof LocationApiUpdateLocation
     */
    readonly apiVersion?: string

    /**
     * Модель запроса на обновление локации
     * @type {UpdateLocationRequest}
     * @memberof LocationApiUpdateLocation
     */
    readonly updateLocationRequest?: UpdateLocationRequest
}

/**
 * LocationApi - object-oriented interface
 * @export
 * @class LocationApi
 * @extends {BaseAPI}
 */
export class LocationApi extends BaseAPI {
    /**
     * 
     * @summary Массово обновить геолокации исполнителя
     * @param {LocationApiBulkUpdateLocationsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LocationApi
     */
    public bulkUpdateLocations(requestParameters: LocationApiBulkUpdateLocationsRequest = {}, options?: RawAxiosRequestConfig) {
        return LocationApiFp(this.configuration).bulkUpdateLocations(requestParameters.apiVersion, requestParameters.updateLocationRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Получить активный отслеживаемый маршрут
     * @param {LocationApiGetActiveTrackingRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LocationApi
     */
    public getActiveTracking(requestParameters: LocationApiGetActiveTrackingRequest, options?: RawAxiosRequestConfig) {
        return LocationApiFp(this.configuration).getActiveTracking(requestParameters.executorId, requestParameters.apiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Получить все координаты локаций исполнителя
     * @param {LocationApiGetAllExecutorLocationsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LocationApi
     */
    public getAllExecutorLocations(requestParameters: LocationApiGetAllExecutorLocationsRequest, options?: RawAxiosRequestConfig) {
        return LocationApiFp(this.configuration).getAllExecutorLocations(requestParameters.cityId, requestParameters.apiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Получить локацию исполнителя
     * @param {LocationApiGetExecutorLocationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LocationApi
     */
    public getExecutorLocation(requestParameters: LocationApiGetExecutorLocationRequest, options?: RawAxiosRequestConfig) {
        return LocationApiFp(this.configuration).getExecutorLocation(requestParameters.executorId, requestParameters.apiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Получить геолокации всех исполнителей в радиусе
     * @param {LocationApiGetExecutorLocationsInRadiusRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LocationApi
     */
    public getExecutorLocationsInRadius(requestParameters: LocationApiGetExecutorLocationsInRadiusRequest, options?: RawAxiosRequestConfig) {
        return LocationApiFp(this.configuration).getExecutorLocationsInRadius(requestParameters.cityId, requestParameters.latitude, requestParameters.longitude, requestParameters.radius, requestParameters.apiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Получить геолокации отслеживаемого маршрута
     * @param {LocationApiGetTrackingRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LocationApi
     */
    public getTracking(requestParameters: LocationApiGetTrackingRequest, options?: RawAxiosRequestConfig) {
        return LocationApiFp(this.configuration).getTracking(requestParameters.trackId, requestParameters.apiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Обновить геолокацию исполнителя
     * @param {LocationApiUpdateLocationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LocationApi
     */
    public updateLocation(requestParameters: LocationApiUpdateLocationRequest = {}, options?: RawAxiosRequestConfig) {
        return LocationApiFp(this.configuration).updateLocation(requestParameters.apiVersion, requestParameters.updateLocationRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * LogsApi - axios parameter creator
 * @export
 */
export const LogsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Записать отладочное сообщение приложения
         * @param {string} [apiVersion] 
         * @param {LogRequest} [logRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1LogsDebugPost: async (apiVersion?: string, logRequest?: LogRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/logs/debug`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(logRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Записать ошибку приложения и отправить уведомление
         * @param {string} [apiVersion] 
         * @param {LogErrorRequest} [logErrorRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1LogsErrorPost: async (apiVersion?: string, logErrorRequest?: LogErrorRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/logs/error`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(logErrorRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Записать информационное сообщение приложения
         * @param {string} [apiVersion] 
         * @param {LogRequest} [logRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1LogsInfoPost: async (apiVersion?: string, logRequest?: LogRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/logs/info`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(logRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Записать предупреждение приложения
         * @param {string} [apiVersion] 
         * @param {LogRequest} [logRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1LogsWarningPost: async (apiVersion?: string, logRequest?: LogRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/logs/warning`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(logRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * LogsApi - functional programming interface
 * @export
 */
export const LogsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = LogsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Записать отладочное сообщение приложения
         * @param {string} [apiVersion] 
         * @param {LogRequest} [logRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1LogsDebugPost(apiVersion?: string, logRequest?: LogRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1LogsDebugPost(apiVersion, logRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LogsApi.apiV1LogsDebugPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Записать ошибку приложения и отправить уведомление
         * @param {string} [apiVersion] 
         * @param {LogErrorRequest} [logErrorRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1LogsErrorPost(apiVersion?: string, logErrorRequest?: LogErrorRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1LogsErrorPost(apiVersion, logErrorRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LogsApi.apiV1LogsErrorPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Записать информационное сообщение приложения
         * @param {string} [apiVersion] 
         * @param {LogRequest} [logRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1LogsInfoPost(apiVersion?: string, logRequest?: LogRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1LogsInfoPost(apiVersion, logRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LogsApi.apiV1LogsInfoPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Записать предупреждение приложения
         * @param {string} [apiVersion] 
         * @param {LogRequest} [logRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1LogsWarningPost(apiVersion?: string, logRequest?: LogRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1LogsWarningPost(apiVersion, logRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LogsApi.apiV1LogsWarningPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * LogsApi - factory interface
 * @export
 */
export const LogsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = LogsApiFp(configuration)
    return {
        /**
         * 
         * @summary Записать отладочное сообщение приложения
         * @param {LogsApiApiV1LogsDebugPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1LogsDebugPost(requestParameters: LogsApiApiV1LogsDebugPostRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiV1LogsDebugPost(requestParameters.apiVersion, requestParameters.logRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Записать ошибку приложения и отправить уведомление
         * @param {LogsApiApiV1LogsErrorPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1LogsErrorPost(requestParameters: LogsApiApiV1LogsErrorPostRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiV1LogsErrorPost(requestParameters.apiVersion, requestParameters.logErrorRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Записать информационное сообщение приложения
         * @param {LogsApiApiV1LogsInfoPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1LogsInfoPost(requestParameters: LogsApiApiV1LogsInfoPostRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiV1LogsInfoPost(requestParameters.apiVersion, requestParameters.logRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Записать предупреждение приложения
         * @param {LogsApiApiV1LogsWarningPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1LogsWarningPost(requestParameters: LogsApiApiV1LogsWarningPostRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiV1LogsWarningPost(requestParameters.apiVersion, requestParameters.logRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for apiV1LogsDebugPost operation in LogsApi.
 * @export
 * @interface LogsApiApiV1LogsDebugPostRequest
 */
export interface LogsApiApiV1LogsDebugPostRequest {
    /**
     * 
     * @type {string}
     * @memberof LogsApiApiV1LogsDebugPost
     */
    readonly apiVersion?: string

    /**
     * 
     * @type {LogRequest}
     * @memberof LogsApiApiV1LogsDebugPost
     */
    readonly logRequest?: LogRequest
}

/**
 * Request parameters for apiV1LogsErrorPost operation in LogsApi.
 * @export
 * @interface LogsApiApiV1LogsErrorPostRequest
 */
export interface LogsApiApiV1LogsErrorPostRequest {
    /**
     * 
     * @type {string}
     * @memberof LogsApiApiV1LogsErrorPost
     */
    readonly apiVersion?: string

    /**
     * 
     * @type {LogErrorRequest}
     * @memberof LogsApiApiV1LogsErrorPost
     */
    readonly logErrorRequest?: LogErrorRequest
}

/**
 * Request parameters for apiV1LogsInfoPost operation in LogsApi.
 * @export
 * @interface LogsApiApiV1LogsInfoPostRequest
 */
export interface LogsApiApiV1LogsInfoPostRequest {
    /**
     * 
     * @type {string}
     * @memberof LogsApiApiV1LogsInfoPost
     */
    readonly apiVersion?: string

    /**
     * 
     * @type {LogRequest}
     * @memberof LogsApiApiV1LogsInfoPost
     */
    readonly logRequest?: LogRequest
}

/**
 * Request parameters for apiV1LogsWarningPost operation in LogsApi.
 * @export
 * @interface LogsApiApiV1LogsWarningPostRequest
 */
export interface LogsApiApiV1LogsWarningPostRequest {
    /**
     * 
     * @type {string}
     * @memberof LogsApiApiV1LogsWarningPost
     */
    readonly apiVersion?: string

    /**
     * 
     * @type {LogRequest}
     * @memberof LogsApiApiV1LogsWarningPost
     */
    readonly logRequest?: LogRequest
}

/**
 * LogsApi - object-oriented interface
 * @export
 * @class LogsApi
 * @extends {BaseAPI}
 */
export class LogsApi extends BaseAPI {
    /**
     * 
     * @summary Записать отладочное сообщение приложения
     * @param {LogsApiApiV1LogsDebugPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LogsApi
     */
    public apiV1LogsDebugPost(requestParameters: LogsApiApiV1LogsDebugPostRequest = {}, options?: RawAxiosRequestConfig) {
        return LogsApiFp(this.configuration).apiV1LogsDebugPost(requestParameters.apiVersion, requestParameters.logRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Записать ошибку приложения и отправить уведомление
     * @param {LogsApiApiV1LogsErrorPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LogsApi
     */
    public apiV1LogsErrorPost(requestParameters: LogsApiApiV1LogsErrorPostRequest = {}, options?: RawAxiosRequestConfig) {
        return LogsApiFp(this.configuration).apiV1LogsErrorPost(requestParameters.apiVersion, requestParameters.logErrorRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Записать информационное сообщение приложения
     * @param {LogsApiApiV1LogsInfoPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LogsApi
     */
    public apiV1LogsInfoPost(requestParameters: LogsApiApiV1LogsInfoPostRequest = {}, options?: RawAxiosRequestConfig) {
        return LogsApiFp(this.configuration).apiV1LogsInfoPost(requestParameters.apiVersion, requestParameters.logRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Записать предупреждение приложения
     * @param {LogsApiApiV1LogsWarningPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LogsApi
     */
    public apiV1LogsWarningPost(requestParameters: LogsApiApiV1LogsWarningPostRequest = {}, options?: RawAxiosRequestConfig) {
        return LogsApiFp(this.configuration).apiV1LogsWarningPost(requestParameters.apiVersion, requestParameters.logRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * MediaApi - axios parameter creator
 * @export
 */
export const MediaApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Удалить медиафайл по URL
         * @param {string} [url] 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1MediaDelete: async (url?: string, apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/media`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (url !== undefined) {
                localVarQueryParameter['url'] = url;
            }


    
            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Загрузить Изображение-Файл. Лимит размера 25 МБ
         * @param {string} [apiVersion] 
         * @param {File} [file] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1MediaUploadImagePost: async (apiVersion?: string, file?: File, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/media/upload-image`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Загрузить Видео-Файл. Лимит размера 150 МБ
         * @param {string} [apiVersion] 
         * @param {File} [file] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1MediaUploadVideoPost: async (apiVersion?: string, file?: File, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/media/upload-video`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * MediaApi - functional programming interface
 * @export
 */
export const MediaApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = MediaApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Удалить медиафайл по URL
         * @param {string} [url] 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1MediaDelete(url?: string, apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1MediaDelete(url, apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MediaApi.apiV1MediaDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Загрузить Изображение-Файл. Лимит размера 25 МБ
         * @param {string} [apiVersion] 
         * @param {File} [file] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1MediaUploadImagePost(apiVersion?: string, file?: File, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1MediaUploadImagePost(apiVersion, file, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MediaApi.apiV1MediaUploadImagePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Загрузить Видео-Файл. Лимит размера 150 МБ
         * @param {string} [apiVersion] 
         * @param {File} [file] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1MediaUploadVideoPost(apiVersion?: string, file?: File, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1MediaUploadVideoPost(apiVersion, file, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MediaApi.apiV1MediaUploadVideoPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * MediaApi - factory interface
 * @export
 */
export const MediaApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = MediaApiFp(configuration)
    return {
        /**
         * 
         * @summary Удалить медиафайл по URL
         * @param {MediaApiApiV1MediaDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1MediaDelete(requestParameters: MediaApiApiV1MediaDeleteRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.apiV1MediaDelete(requestParameters.url, requestParameters.apiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Загрузить Изображение-Файл. Лимит размера 25 МБ
         * @param {MediaApiApiV1MediaUploadImagePostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1MediaUploadImagePost(requestParameters: MediaApiApiV1MediaUploadImagePostRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.apiV1MediaUploadImagePost(requestParameters.apiVersion, requestParameters.file, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Загрузить Видео-Файл. Лимит размера 150 МБ
         * @param {MediaApiApiV1MediaUploadVideoPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1MediaUploadVideoPost(requestParameters: MediaApiApiV1MediaUploadVideoPostRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.apiV1MediaUploadVideoPost(requestParameters.apiVersion, requestParameters.file, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for apiV1MediaDelete operation in MediaApi.
 * @export
 * @interface MediaApiApiV1MediaDeleteRequest
 */
export interface MediaApiApiV1MediaDeleteRequest {
    /**
     * 
     * @type {string}
     * @memberof MediaApiApiV1MediaDelete
     */
    readonly url?: string

    /**
     * 
     * @type {string}
     * @memberof MediaApiApiV1MediaDelete
     */
    readonly apiVersion?: string
}

/**
 * Request parameters for apiV1MediaUploadImagePost operation in MediaApi.
 * @export
 * @interface MediaApiApiV1MediaUploadImagePostRequest
 */
export interface MediaApiApiV1MediaUploadImagePostRequest {
    /**
     * 
     * @type {string}
     * @memberof MediaApiApiV1MediaUploadImagePost
     */
    readonly apiVersion?: string

    /**
     * 
     * @type {File}
     * @memberof MediaApiApiV1MediaUploadImagePost
     */
    readonly file?: File
}

/**
 * Request parameters for apiV1MediaUploadVideoPost operation in MediaApi.
 * @export
 * @interface MediaApiApiV1MediaUploadVideoPostRequest
 */
export interface MediaApiApiV1MediaUploadVideoPostRequest {
    /**
     * 
     * @type {string}
     * @memberof MediaApiApiV1MediaUploadVideoPost
     */
    readonly apiVersion?: string

    /**
     * 
     * @type {File}
     * @memberof MediaApiApiV1MediaUploadVideoPost
     */
    readonly file?: File
}

/**
 * MediaApi - object-oriented interface
 * @export
 * @class MediaApi
 * @extends {BaseAPI}
 */
export class MediaApi extends BaseAPI {
    /**
     * 
     * @summary Удалить медиафайл по URL
     * @param {MediaApiApiV1MediaDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MediaApi
     */
    public apiV1MediaDelete(requestParameters: MediaApiApiV1MediaDeleteRequest = {}, options?: RawAxiosRequestConfig) {
        return MediaApiFp(this.configuration).apiV1MediaDelete(requestParameters.url, requestParameters.apiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Загрузить Изображение-Файл. Лимит размера 25 МБ
     * @param {MediaApiApiV1MediaUploadImagePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MediaApi
     */
    public apiV1MediaUploadImagePost(requestParameters: MediaApiApiV1MediaUploadImagePostRequest = {}, options?: RawAxiosRequestConfig) {
        return MediaApiFp(this.configuration).apiV1MediaUploadImagePost(requestParameters.apiVersion, requestParameters.file, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Загрузить Видео-Файл. Лимит размера 150 МБ
     * @param {MediaApiApiV1MediaUploadVideoPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MediaApi
     */
    public apiV1MediaUploadVideoPost(requestParameters: MediaApiApiV1MediaUploadVideoPostRequest = {}, options?: RawAxiosRequestConfig) {
        return MediaApiFp(this.configuration).apiV1MediaUploadVideoPost(requestParameters.apiVersion, requestParameters.file, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * MediaLibraryApi - axios parameter creator
 * @export
 */
export const MediaLibraryApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Создать папку медиатеки
         * @param {string} [apiVersion] 
         * @param {SaveMediaFolderRequest} [saveMediaFolderRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createMediaFolder: async (apiVersion?: string, saveMediaFolderRequest?: SaveMediaFolderRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/media-library/folders`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(saveMediaFolderRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Удалить выбранные файлы медиатеки
         * @param {string} [apiVersion] 
         * @param {Array<MediaVersionRequest>} [mediaVersionRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteMediaAssets: async (apiVersion?: string, mediaVersionRequest?: Array<MediaVersionRequest>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/media-library/assets`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(mediaVersionRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Удалить папку медиатеки
         * @param {string} id 
         * @param {string} [version] 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteMediaFolder: async (id: string, version?: string, apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteMediaFolder', 'id', id)
            const localVarPath = `/api/v1/media-library/folders/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (version !== undefined) {
                localVarQueryParameter['version'] = version;
            }


    
            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Скачать выбранные изображения архивом
         * @param {string} [apiVersion] 
         * @param {MediaSelectionRequest} [mediaSelectionRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadMediaAssets: async (apiVersion?: string, mediaSelectionRequest?: MediaSelectionRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/media-library/download`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(mediaSelectionRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Получить сведения о файле медиатеки
         * @param {string} id 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMediaAssetDetails: async (id: string, apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getMediaAssetDetails', 'id', id)
            const localVarPath = `/api/v1/media-library/assets/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Найти изображения медиатеки
         * @param {string} [folderId] Папка каталога
         * @param {boolean} [rootOnly] Только корневая папка
         * @param {string} [contentType] Тип содержимого
         * @param {string} [createdFrom] Начало периода добавления
         * @param {string} [createdTo] Конец периода добавления
         * @param {boolean} [unusedOnly] Только неиспользуемые файлы
         * @param {boolean} [includeUsage] Включить сведения об использовании файлов
         * @param {number} [takeCount] Размер страницы
         * @param {string} [searchQuery] Строка для поиска
         * @param {number} [skipCount] Кол-во пропущенных записей
         * @param {boolean} [ascending] Сортировка по возрастанию
         * @param {string} [ordering] Поле для сортировки
         * @param {boolean} [isDeleted] Удалённые записи
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMediaAssets: async (folderId?: string, rootOnly?: boolean, contentType?: string, createdFrom?: string, createdTo?: string, unusedOnly?: boolean, includeUsage?: boolean, takeCount?: number, searchQuery?: string, skipCount?: number, ascending?: boolean, ordering?: string, isDeleted?: boolean, apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/media-library/get-media-assets`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (folderId !== undefined) {
                localVarQueryParameter['FolderId'] = folderId;
            }

            if (rootOnly !== undefined) {
                localVarQueryParameter['RootOnly'] = rootOnly;
            }

            if (contentType !== undefined) {
                localVarQueryParameter['ContentType'] = contentType;
            }

            if (createdFrom !== undefined) {
                localVarQueryParameter['CreatedFrom'] = (createdFrom as any instanceof Date) ?
                    (createdFrom as any).toISOString() :
                    createdFrom;
            }

            if (createdTo !== undefined) {
                localVarQueryParameter['CreatedTo'] = (createdTo as any instanceof Date) ?
                    (createdTo as any).toISOString() :
                    createdTo;
            }

            if (unusedOnly !== undefined) {
                localVarQueryParameter['UnusedOnly'] = unusedOnly;
            }

            if (includeUsage !== undefined) {
                localVarQueryParameter['IncludeUsage'] = includeUsage;
            }

            if (takeCount !== undefined) {
                localVarQueryParameter['TakeCount'] = takeCount;
            }

            if (searchQuery !== undefined) {
                localVarQueryParameter['SearchQuery'] = searchQuery;
            }

            if (skipCount !== undefined) {
                localVarQueryParameter['SkipCount'] = skipCount;
            }

            if (ascending !== undefined) {
                localVarQueryParameter['Ascending'] = ascending;
            }

            if (ordering !== undefined) {
                localVarQueryParameter['Ordering'] = ordering;
            }

            if (isDeleted !== undefined) {
                localVarQueryParameter['IsDeleted'] = isDeleted;
            }


    
            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Получить папки медиатеки
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMediaFolders: async (apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/media-library/folders`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Получить объекты хранилища медиатеки
         * @param {string} [prefix] 
         * @param {string} [continuationToken] 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMediaStorage: async (prefix?: string, continuationToken?: string, apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/media-library/storage`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (prefix !== undefined) {
                localVarQueryParameter['prefix'] = prefix;
            }

            if (continuationToken !== undefined) {
                localVarQueryParameter['continuationToken'] = continuationToken;
            }


    
            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Импортировать изображения в медиатеку
         * @param {string} [apiVersion] 
         * @param {ImportMediaRequest} [importMediaRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importMediaAssets: async (apiVersion?: string, importMediaRequest?: ImportMediaRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/media-library/import`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(importMediaRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Изменить файл медиатеки
         * @param {string} id 
         * @param {string} [apiVersion] 
         * @param {UpdateMediaAssetRequest} [updateMediaAssetRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMediaAsset: async (id: string, apiVersion?: string, updateMediaAssetRequest?: UpdateMediaAssetRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateMediaAsset', 'id', id)
            const localVarPath = `/api/v1/media-library/assets/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateMediaAssetRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Изменить папку медиатеки
         * @param {string} id 
         * @param {string} [apiVersion] 
         * @param {SaveMediaFolderRequest} [saveMediaFolderRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMediaFolder: async (id: string, apiVersion?: string, saveMediaFolderRequest?: SaveMediaFolderRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateMediaFolder', 'id', id)
            const localVarPath = `/api/v1/media-library/folders/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(saveMediaFolderRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Изменить выбранные файлы медиатеки
         * @param {string} [apiVersion] 
         * @param {MediaBulkUpdateRequest} [mediaBulkUpdateRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMediaSelection: async (apiVersion?: string, mediaBulkUpdateRequest?: MediaBulkUpdateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/media-library/bulk`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(mediaBulkUpdateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Загрузить изображение в медиатеку
         * @param {string} [apiVersion] 
         * @param {File} [file] Изображение
         * @param {string} [folderId] Папка назначения
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadMediaAsset: async (apiVersion?: string, file?: File, folderId?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/media-library/upload`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


            if (file !== undefined) { 
                localVarFormParams.append('File', file as any);
            }
    
            if (folderId !== undefined) { 
                localVarFormParams.append('FolderId', folderId as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * MediaLibraryApi - functional programming interface
 * @export
 */
export const MediaLibraryApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = MediaLibraryApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Создать папку медиатеки
         * @param {string} [apiVersion] 
         * @param {SaveMediaFolderRequest} [saveMediaFolderRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createMediaFolder(apiVersion?: string, saveMediaFolderRequest?: SaveMediaFolderRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createMediaFolder(apiVersion, saveMediaFolderRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MediaLibraryApi.createMediaFolder']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Удалить выбранные файлы медиатеки
         * @param {string} [apiVersion] 
         * @param {Array<MediaVersionRequest>} [mediaVersionRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteMediaAssets(apiVersion?: string, mediaVersionRequest?: Array<MediaVersionRequest>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteMediaAssets(apiVersion, mediaVersionRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MediaLibraryApi.deleteMediaAssets']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Удалить папку медиатеки
         * @param {string} id 
         * @param {string} [version] 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteMediaFolder(id: string, version?: string, apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteMediaFolder(id, version, apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MediaLibraryApi.deleteMediaFolder']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Скачать выбранные изображения архивом
         * @param {string} [apiVersion] 
         * @param {MediaSelectionRequest} [mediaSelectionRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async downloadMediaAssets(apiVersion?: string, mediaSelectionRequest?: MediaSelectionRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.downloadMediaAssets(apiVersion, mediaSelectionRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MediaLibraryApi.downloadMediaAssets']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Получить сведения о файле медиатеки
         * @param {string} id 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMediaAssetDetails(id: string, apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MediaAssetDetailsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMediaAssetDetails(id, apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MediaLibraryApi.getMediaAssetDetails']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Найти изображения медиатеки
         * @param {string} [folderId] Папка каталога
         * @param {boolean} [rootOnly] Только корневая папка
         * @param {string} [contentType] Тип содержимого
         * @param {string} [createdFrom] Начало периода добавления
         * @param {string} [createdTo] Конец периода добавления
         * @param {boolean} [unusedOnly] Только неиспользуемые файлы
         * @param {boolean} [includeUsage] Включить сведения об использовании файлов
         * @param {number} [takeCount] Размер страницы
         * @param {string} [searchQuery] Строка для поиска
         * @param {number} [skipCount] Кол-во пропущенных записей
         * @param {boolean} [ascending] Сортировка по возрастанию
         * @param {string} [ordering] Поле для сортировки
         * @param {boolean} [isDeleted] Удалённые записи
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMediaAssets(folderId?: string, rootOnly?: boolean, contentType?: string, createdFrom?: string, createdTo?: string, unusedOnly?: boolean, includeUsage?: boolean, takeCount?: number, searchQuery?: string, skipCount?: number, ascending?: boolean, ordering?: string, isDeleted?: boolean, apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MediaAssetPageResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMediaAssets(folderId, rootOnly, contentType, createdFrom, createdTo, unusedOnly, includeUsage, takeCount, searchQuery, skipCount, ascending, ordering, isDeleted, apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MediaLibraryApi.getMediaAssets']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Получить папки медиатеки
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMediaFolders(apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<MediaFolderResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMediaFolders(apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MediaLibraryApi.getMediaFolders']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Получить объекты хранилища медиатеки
         * @param {string} [prefix] 
         * @param {string} [continuationToken] 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMediaStorage(prefix?: string, continuationToken?: string, apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MediaStoragePageResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMediaStorage(prefix, continuationToken, apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MediaLibraryApi.getMediaStorage']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Импортировать изображения в медиатеку
         * @param {string} [apiVersion] 
         * @param {ImportMediaRequest} [importMediaRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async importMediaAssets(apiVersion?: string, importMediaRequest?: ImportMediaRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<number>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.importMediaAssets(apiVersion, importMediaRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MediaLibraryApi.importMediaAssets']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Изменить файл медиатеки
         * @param {string} id 
         * @param {string} [apiVersion] 
         * @param {UpdateMediaAssetRequest} [updateMediaAssetRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateMediaAsset(id: string, apiVersion?: string, updateMediaAssetRequest?: UpdateMediaAssetRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateMediaAsset(id, apiVersion, updateMediaAssetRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MediaLibraryApi.updateMediaAsset']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Изменить папку медиатеки
         * @param {string} id 
         * @param {string} [apiVersion] 
         * @param {SaveMediaFolderRequest} [saveMediaFolderRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateMediaFolder(id: string, apiVersion?: string, saveMediaFolderRequest?: SaveMediaFolderRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateMediaFolder(id, apiVersion, saveMediaFolderRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MediaLibraryApi.updateMediaFolder']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Изменить выбранные файлы медиатеки
         * @param {string} [apiVersion] 
         * @param {MediaBulkUpdateRequest} [mediaBulkUpdateRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateMediaSelection(apiVersion?: string, mediaBulkUpdateRequest?: MediaBulkUpdateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateMediaSelection(apiVersion, mediaBulkUpdateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MediaLibraryApi.updateMediaSelection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Загрузить изображение в медиатеку
         * @param {string} [apiVersion] 
         * @param {File} [file] Изображение
         * @param {string} [folderId] Папка назначения
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async uploadMediaAsset(apiVersion?: string, file?: File, folderId?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MediaAssetResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.uploadMediaAsset(apiVersion, file, folderId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MediaLibraryApi.uploadMediaAsset']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * MediaLibraryApi - factory interface
 * @export
 */
export const MediaLibraryApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = MediaLibraryApiFp(configuration)
    return {
        /**
         * 
         * @summary Создать папку медиатеки
         * @param {MediaLibraryApiCreateMediaFolderRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createMediaFolder(requestParameters: MediaLibraryApiCreateMediaFolderRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.createMediaFolder(requestParameters.apiVersion, requestParameters.saveMediaFolderRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Удалить выбранные файлы медиатеки
         * @param {MediaLibraryApiDeleteMediaAssetsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteMediaAssets(requestParameters: MediaLibraryApiDeleteMediaAssetsRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteMediaAssets(requestParameters.apiVersion, requestParameters.mediaVersionRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Удалить папку медиатеки
         * @param {MediaLibraryApiDeleteMediaFolderRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteMediaFolder(requestParameters: MediaLibraryApiDeleteMediaFolderRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteMediaFolder(requestParameters.id, requestParameters.version, requestParameters.apiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Скачать выбранные изображения архивом
         * @param {MediaLibraryApiDownloadMediaAssetsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadMediaAssets(requestParameters: MediaLibraryApiDownloadMediaAssetsRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<File> {
            return localVarFp.downloadMediaAssets(requestParameters.apiVersion, requestParameters.mediaSelectionRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Получить сведения о файле медиатеки
         * @param {MediaLibraryApiGetMediaAssetDetailsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMediaAssetDetails(requestParameters: MediaLibraryApiGetMediaAssetDetailsRequest, options?: RawAxiosRequestConfig): AxiosPromise<MediaAssetDetailsResponse> {
            return localVarFp.getMediaAssetDetails(requestParameters.id, requestParameters.apiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Найти изображения медиатеки
         * @param {MediaLibraryApiGetMediaAssetsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMediaAssets(requestParameters: MediaLibraryApiGetMediaAssetsRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<MediaAssetPageResponse> {
            return localVarFp.getMediaAssets(requestParameters.folderId, requestParameters.rootOnly, requestParameters.contentType, requestParameters.createdFrom, requestParameters.createdTo, requestParameters.unusedOnly, requestParameters.includeUsage, requestParameters.takeCount, requestParameters.searchQuery, requestParameters.skipCount, requestParameters.ascending, requestParameters.ordering, requestParameters.isDeleted, requestParameters.apiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Получить папки медиатеки
         * @param {MediaLibraryApiGetMediaFoldersRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMediaFolders(requestParameters: MediaLibraryApiGetMediaFoldersRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<Array<MediaFolderResponse>> {
            return localVarFp.getMediaFolders(requestParameters.apiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Получить объекты хранилища медиатеки
         * @param {MediaLibraryApiGetMediaStorageRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMediaStorage(requestParameters: MediaLibraryApiGetMediaStorageRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<MediaStoragePageResponse> {
            return localVarFp.getMediaStorage(requestParameters.prefix, requestParameters.continuationToken, requestParameters.apiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Импортировать изображения в медиатеку
         * @param {MediaLibraryApiImportMediaAssetsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importMediaAssets(requestParameters: MediaLibraryApiImportMediaAssetsRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<number> {
            return localVarFp.importMediaAssets(requestParameters.apiVersion, requestParameters.importMediaRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Изменить файл медиатеки
         * @param {MediaLibraryApiUpdateMediaAssetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMediaAsset(requestParameters: MediaLibraryApiUpdateMediaAssetRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateMediaAsset(requestParameters.id, requestParameters.apiVersion, requestParameters.updateMediaAssetRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Изменить папку медиатеки
         * @param {MediaLibraryApiUpdateMediaFolderRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMediaFolder(requestParameters: MediaLibraryApiUpdateMediaFolderRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateMediaFolder(requestParameters.id, requestParameters.apiVersion, requestParameters.saveMediaFolderRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Изменить выбранные файлы медиатеки
         * @param {MediaLibraryApiUpdateMediaSelectionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMediaSelection(requestParameters: MediaLibraryApiUpdateMediaSelectionRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateMediaSelection(requestParameters.apiVersion, requestParameters.mediaBulkUpdateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Загрузить изображение в медиатеку
         * @param {MediaLibraryApiUploadMediaAssetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadMediaAsset(requestParameters: MediaLibraryApiUploadMediaAssetRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<MediaAssetResponse> {
            return localVarFp.uploadMediaAsset(requestParameters.apiVersion, requestParameters.file, requestParameters.folderId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for createMediaFolder operation in MediaLibraryApi.
 * @export
 * @interface MediaLibraryApiCreateMediaFolderRequest
 */
export interface MediaLibraryApiCreateMediaFolderRequest {
    /**
     * 
     * @type {string}
     * @memberof MediaLibraryApiCreateMediaFolder
     */
    readonly apiVersion?: string

    /**
     * 
     * @type {SaveMediaFolderRequest}
     * @memberof MediaLibraryApiCreateMediaFolder
     */
    readonly saveMediaFolderRequest?: SaveMediaFolderRequest
}

/**
 * Request parameters for deleteMediaAssets operation in MediaLibraryApi.
 * @export
 * @interface MediaLibraryApiDeleteMediaAssetsRequest
 */
export interface MediaLibraryApiDeleteMediaAssetsRequest {
    /**
     * 
     * @type {string}
     * @memberof MediaLibraryApiDeleteMediaAssets
     */
    readonly apiVersion?: string

    /**
     * 
     * @type {Array<MediaVersionRequest>}
     * @memberof MediaLibraryApiDeleteMediaAssets
     */
    readonly mediaVersionRequest?: Array<MediaVersionRequest>
}

/**
 * Request parameters for deleteMediaFolder operation in MediaLibraryApi.
 * @export
 * @interface MediaLibraryApiDeleteMediaFolderRequest
 */
export interface MediaLibraryApiDeleteMediaFolderRequest {
    /**
     * 
     * @type {string}
     * @memberof MediaLibraryApiDeleteMediaFolder
     */
    readonly id: string

    /**
     * 
     * @type {string}
     * @memberof MediaLibraryApiDeleteMediaFolder
     */
    readonly version?: string

    /**
     * 
     * @type {string}
     * @memberof MediaLibraryApiDeleteMediaFolder
     */
    readonly apiVersion?: string
}

/**
 * Request parameters for downloadMediaAssets operation in MediaLibraryApi.
 * @export
 * @interface MediaLibraryApiDownloadMediaAssetsRequest
 */
export interface MediaLibraryApiDownloadMediaAssetsRequest {
    /**
     * 
     * @type {string}
     * @memberof MediaLibraryApiDownloadMediaAssets
     */
    readonly apiVersion?: string

    /**
     * 
     * @type {MediaSelectionRequest}
     * @memberof MediaLibraryApiDownloadMediaAssets
     */
    readonly mediaSelectionRequest?: MediaSelectionRequest
}

/**
 * Request parameters for getMediaAssetDetails operation in MediaLibraryApi.
 * @export
 * @interface MediaLibraryApiGetMediaAssetDetailsRequest
 */
export interface MediaLibraryApiGetMediaAssetDetailsRequest {
    /**
     * 
     * @type {string}
     * @memberof MediaLibraryApiGetMediaAssetDetails
     */
    readonly id: string

    /**
     * 
     * @type {string}
     * @memberof MediaLibraryApiGetMediaAssetDetails
     */
    readonly apiVersion?: string
}

/**
 * Request parameters for getMediaAssets operation in MediaLibraryApi.
 * @export
 * @interface MediaLibraryApiGetMediaAssetsRequest
 */
export interface MediaLibraryApiGetMediaAssetsRequest {
    /**
     * Папка каталога
     * @type {string}
     * @memberof MediaLibraryApiGetMediaAssets
     */
    readonly folderId?: string

    /**
     * Только корневая папка
     * @type {boolean}
     * @memberof MediaLibraryApiGetMediaAssets
     */
    readonly rootOnly?: boolean

    /**
     * Тип содержимого
     * @type {string}
     * @memberof MediaLibraryApiGetMediaAssets
     */
    readonly contentType?: string

    /**
     * Начало периода добавления
     * @type {string}
     * @memberof MediaLibraryApiGetMediaAssets
     */
    readonly createdFrom?: string

    /**
     * Конец периода добавления
     * @type {string}
     * @memberof MediaLibraryApiGetMediaAssets
     */
    readonly createdTo?: string

    /**
     * Только неиспользуемые файлы
     * @type {boolean}
     * @memberof MediaLibraryApiGetMediaAssets
     */
    readonly unusedOnly?: boolean

    /**
     * Включить сведения об использовании файлов
     * @type {boolean}
     * @memberof MediaLibraryApiGetMediaAssets
     */
    readonly includeUsage?: boolean

    /**
     * Размер страницы
     * @type {number}
     * @memberof MediaLibraryApiGetMediaAssets
     */
    readonly takeCount?: number

    /**
     * Строка для поиска
     * @type {string}
     * @memberof MediaLibraryApiGetMediaAssets
     */
    readonly searchQuery?: string

    /**
     * Кол-во пропущенных записей
     * @type {number}
     * @memberof MediaLibraryApiGetMediaAssets
     */
    readonly skipCount?: number

    /**
     * Сортировка по возрастанию
     * @type {boolean}
     * @memberof MediaLibraryApiGetMediaAssets
     */
    readonly ascending?: boolean

    /**
     * Поле для сортировки
     * @type {string}
     * @memberof MediaLibraryApiGetMediaAssets
     */
    readonly ordering?: string

    /**
     * Удалённые записи
     * @type {boolean}
     * @memberof MediaLibraryApiGetMediaAssets
     */
    readonly isDeleted?: boolean

    /**
     * 
     * @type {string}
     * @memberof MediaLibraryApiGetMediaAssets
     */
    readonly apiVersion?: string
}

/**
 * Request parameters for getMediaFolders operation in MediaLibraryApi.
 * @export
 * @interface MediaLibraryApiGetMediaFoldersRequest
 */
export interface MediaLibraryApiGetMediaFoldersRequest {
    /**
     * 
     * @type {string}
     * @memberof MediaLibraryApiGetMediaFolders
     */
    readonly apiVersion?: string
}

/**
 * Request parameters for getMediaStorage operation in MediaLibraryApi.
 * @export
 * @interface MediaLibraryApiGetMediaStorageRequest
 */
export interface MediaLibraryApiGetMediaStorageRequest {
    /**
     * 
     * @type {string}
     * @memberof MediaLibraryApiGetMediaStorage
     */
    readonly prefix?: string

    /**
     * 
     * @type {string}
     * @memberof MediaLibraryApiGetMediaStorage
     */
    readonly continuationToken?: string

    /**
     * 
     * @type {string}
     * @memberof MediaLibraryApiGetMediaStorage
     */
    readonly apiVersion?: string
}

/**
 * Request parameters for importMediaAssets operation in MediaLibraryApi.
 * @export
 * @interface MediaLibraryApiImportMediaAssetsRequest
 */
export interface MediaLibraryApiImportMediaAssetsRequest {
    /**
     * 
     * @type {string}
     * @memberof MediaLibraryApiImportMediaAssets
     */
    readonly apiVersion?: string

    /**
     * 
     * @type {ImportMediaRequest}
     * @memberof MediaLibraryApiImportMediaAssets
     */
    readonly importMediaRequest?: ImportMediaRequest
}

/**
 * Request parameters for updateMediaAsset operation in MediaLibraryApi.
 * @export
 * @interface MediaLibraryApiUpdateMediaAssetRequest
 */
export interface MediaLibraryApiUpdateMediaAssetRequest {
    /**
     * 
     * @type {string}
     * @memberof MediaLibraryApiUpdateMediaAsset
     */
    readonly id: string

    /**
     * 
     * @type {string}
     * @memberof MediaLibraryApiUpdateMediaAsset
     */
    readonly apiVersion?: string

    /**
     * 
     * @type {UpdateMediaAssetRequest}
     * @memberof MediaLibraryApiUpdateMediaAsset
     */
    readonly updateMediaAssetRequest?: UpdateMediaAssetRequest
}

/**
 * Request parameters for updateMediaFolder operation in MediaLibraryApi.
 * @export
 * @interface MediaLibraryApiUpdateMediaFolderRequest
 */
export interface MediaLibraryApiUpdateMediaFolderRequest {
    /**
     * 
     * @type {string}
     * @memberof MediaLibraryApiUpdateMediaFolder
     */
    readonly id: string

    /**
     * 
     * @type {string}
     * @memberof MediaLibraryApiUpdateMediaFolder
     */
    readonly apiVersion?: string

    /**
     * 
     * @type {SaveMediaFolderRequest}
     * @memberof MediaLibraryApiUpdateMediaFolder
     */
    readonly saveMediaFolderRequest?: SaveMediaFolderRequest
}

/**
 * Request parameters for updateMediaSelection operation in MediaLibraryApi.
 * @export
 * @interface MediaLibraryApiUpdateMediaSelectionRequest
 */
export interface MediaLibraryApiUpdateMediaSelectionRequest {
    /**
     * 
     * @type {string}
     * @memberof MediaLibraryApiUpdateMediaSelection
     */
    readonly apiVersion?: string

    /**
     * 
     * @type {MediaBulkUpdateRequest}
     * @memberof MediaLibraryApiUpdateMediaSelection
     */
    readonly mediaBulkUpdateRequest?: MediaBulkUpdateRequest
}

/**
 * Request parameters for uploadMediaAsset operation in MediaLibraryApi.
 * @export
 * @interface MediaLibraryApiUploadMediaAssetRequest
 */
export interface MediaLibraryApiUploadMediaAssetRequest {
    /**
     * 
     * @type {string}
     * @memberof MediaLibraryApiUploadMediaAsset
     */
    readonly apiVersion?: string

    /**
     * Изображение
     * @type {File}
     * @memberof MediaLibraryApiUploadMediaAsset
     */
    readonly file?: File

    /**
     * Папка назначения
     * @type {string}
     * @memberof MediaLibraryApiUploadMediaAsset
     */
    readonly folderId?: string
}

/**
 * MediaLibraryApi - object-oriented interface
 * @export
 * @class MediaLibraryApi
 * @extends {BaseAPI}
 */
export class MediaLibraryApi extends BaseAPI {
    /**
     * 
     * @summary Создать папку медиатеки
     * @param {MediaLibraryApiCreateMediaFolderRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MediaLibraryApi
     */
    public createMediaFolder(requestParameters: MediaLibraryApiCreateMediaFolderRequest = {}, options?: RawAxiosRequestConfig) {
        return MediaLibraryApiFp(this.configuration).createMediaFolder(requestParameters.apiVersion, requestParameters.saveMediaFolderRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Удалить выбранные файлы медиатеки
     * @param {MediaLibraryApiDeleteMediaAssetsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MediaLibraryApi
     */
    public deleteMediaAssets(requestParameters: MediaLibraryApiDeleteMediaAssetsRequest = {}, options?: RawAxiosRequestConfig) {
        return MediaLibraryApiFp(this.configuration).deleteMediaAssets(requestParameters.apiVersion, requestParameters.mediaVersionRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Удалить папку медиатеки
     * @param {MediaLibraryApiDeleteMediaFolderRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MediaLibraryApi
     */
    public deleteMediaFolder(requestParameters: MediaLibraryApiDeleteMediaFolderRequest, options?: RawAxiosRequestConfig) {
        return MediaLibraryApiFp(this.configuration).deleteMediaFolder(requestParameters.id, requestParameters.version, requestParameters.apiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Скачать выбранные изображения архивом
     * @param {MediaLibraryApiDownloadMediaAssetsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MediaLibraryApi
     */
    public downloadMediaAssets(requestParameters: MediaLibraryApiDownloadMediaAssetsRequest = {}, options?: RawAxiosRequestConfig) {
        return MediaLibraryApiFp(this.configuration).downloadMediaAssets(requestParameters.apiVersion, requestParameters.mediaSelectionRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Получить сведения о файле медиатеки
     * @param {MediaLibraryApiGetMediaAssetDetailsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MediaLibraryApi
     */
    public getMediaAssetDetails(requestParameters: MediaLibraryApiGetMediaAssetDetailsRequest, options?: RawAxiosRequestConfig) {
        return MediaLibraryApiFp(this.configuration).getMediaAssetDetails(requestParameters.id, requestParameters.apiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Найти изображения медиатеки
     * @param {MediaLibraryApiGetMediaAssetsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MediaLibraryApi
     */
    public getMediaAssets(requestParameters: MediaLibraryApiGetMediaAssetsRequest = {}, options?: RawAxiosRequestConfig) {
        return MediaLibraryApiFp(this.configuration).getMediaAssets(requestParameters.folderId, requestParameters.rootOnly, requestParameters.contentType, requestParameters.createdFrom, requestParameters.createdTo, requestParameters.unusedOnly, requestParameters.includeUsage, requestParameters.takeCount, requestParameters.searchQuery, requestParameters.skipCount, requestParameters.ascending, requestParameters.ordering, requestParameters.isDeleted, requestParameters.apiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Получить папки медиатеки
     * @param {MediaLibraryApiGetMediaFoldersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MediaLibraryApi
     */
    public getMediaFolders(requestParameters: MediaLibraryApiGetMediaFoldersRequest = {}, options?: RawAxiosRequestConfig) {
        return MediaLibraryApiFp(this.configuration).getMediaFolders(requestParameters.apiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Получить объекты хранилища медиатеки
     * @param {MediaLibraryApiGetMediaStorageRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MediaLibraryApi
     */
    public getMediaStorage(requestParameters: MediaLibraryApiGetMediaStorageRequest = {}, options?: RawAxiosRequestConfig) {
        return MediaLibraryApiFp(this.configuration).getMediaStorage(requestParameters.prefix, requestParameters.continuationToken, requestParameters.apiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Импортировать изображения в медиатеку
     * @param {MediaLibraryApiImportMediaAssetsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MediaLibraryApi
     */
    public importMediaAssets(requestParameters: MediaLibraryApiImportMediaAssetsRequest = {}, options?: RawAxiosRequestConfig) {
        return MediaLibraryApiFp(this.configuration).importMediaAssets(requestParameters.apiVersion, requestParameters.importMediaRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Изменить файл медиатеки
     * @param {MediaLibraryApiUpdateMediaAssetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MediaLibraryApi
     */
    public updateMediaAsset(requestParameters: MediaLibraryApiUpdateMediaAssetRequest, options?: RawAxiosRequestConfig) {
        return MediaLibraryApiFp(this.configuration).updateMediaAsset(requestParameters.id, requestParameters.apiVersion, requestParameters.updateMediaAssetRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Изменить папку медиатеки
     * @param {MediaLibraryApiUpdateMediaFolderRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MediaLibraryApi
     */
    public updateMediaFolder(requestParameters: MediaLibraryApiUpdateMediaFolderRequest, options?: RawAxiosRequestConfig) {
        return MediaLibraryApiFp(this.configuration).updateMediaFolder(requestParameters.id, requestParameters.apiVersion, requestParameters.saveMediaFolderRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Изменить выбранные файлы медиатеки
     * @param {MediaLibraryApiUpdateMediaSelectionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MediaLibraryApi
     */
    public updateMediaSelection(requestParameters: MediaLibraryApiUpdateMediaSelectionRequest = {}, options?: RawAxiosRequestConfig) {
        return MediaLibraryApiFp(this.configuration).updateMediaSelection(requestParameters.apiVersion, requestParameters.mediaBulkUpdateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Загрузить изображение в медиатеку
     * @param {MediaLibraryApiUploadMediaAssetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MediaLibraryApi
     */
    public uploadMediaAsset(requestParameters: MediaLibraryApiUploadMediaAssetRequest = {}, options?: RawAxiosRequestConfig) {
        return MediaLibraryApiFp(this.configuration).uploadMediaAsset(requestParameters.apiVersion, requestParameters.file, requestParameters.folderId, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * MemoryDiagnosticsApi - axios parameter creator
 * @export
 */
export const MemoryDiagnosticsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Получить часовую историю памяти экземпляра
         * @param {string} instanceId Идентификатор экземпляра приложения
         * @param {number} [hours] Продолжительность истории в часах
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMemoryDiagnosticsHistory: async (instanceId: string, hours?: number, apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'instanceId' is not null or undefined
            assertParamExists('getMemoryDiagnosticsHistory', 'instanceId', instanceId)
            const localVarPath = `/api/v1/memory-diagnostics/history`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (hours !== undefined) {
                localVarQueryParameter['Hours'] = hours;
            }

            if (instanceId !== undefined) {
                localVarQueryParameter['InstanceId'] = instanceId;
            }


    
            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Получить экземпляры с историей памяти
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMemoryDiagnosticsInstances: async (apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/memory-diagnostics/instances`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Получить скользящие сводки памяти экземпляра
         * @param {string} instanceId Идентификатор экземпляра приложения
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMemoryDiagnosticsWindows: async (instanceId: string, apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'instanceId' is not null or undefined
            assertParamExists('getMemoryDiagnosticsWindows', 'instanceId', instanceId)
            const localVarPath = `/api/v1/memory-diagnostics/windows`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (instanceId !== undefined) {
                localVarQueryParameter['InstanceId'] = instanceId;
            }


    
            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * MemoryDiagnosticsApi - functional programming interface
 * @export
 */
export const MemoryDiagnosticsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = MemoryDiagnosticsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Получить часовую историю памяти экземпляра
         * @param {string} instanceId Идентификатор экземпляра приложения
         * @param {number} [hours] Продолжительность истории в часах
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMemoryDiagnosticsHistory(instanceId: string, hours?: number, apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MemoryDiagnosticsHistoryResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMemoryDiagnosticsHistory(instanceId, hours, apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MemoryDiagnosticsApi.getMemoryDiagnosticsHistory']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Получить экземпляры с историей памяти
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMemoryDiagnosticsInstances(apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MemoryDiagnosticsInstancesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMemoryDiagnosticsInstances(apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MemoryDiagnosticsApi.getMemoryDiagnosticsInstances']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Получить скользящие сводки памяти экземпляра
         * @param {string} instanceId Идентификатор экземпляра приложения
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMemoryDiagnosticsWindows(instanceId: string, apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MemoryDiagnosticsWindowsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMemoryDiagnosticsWindows(instanceId, apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MemoryDiagnosticsApi.getMemoryDiagnosticsWindows']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * MemoryDiagnosticsApi - factory interface
 * @export
 */
export const MemoryDiagnosticsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = MemoryDiagnosticsApiFp(configuration)
    return {
        /**
         * 
         * @summary Получить часовую историю памяти экземпляра
         * @param {MemoryDiagnosticsApiGetMemoryDiagnosticsHistoryRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMemoryDiagnosticsHistory(requestParameters: MemoryDiagnosticsApiGetMemoryDiagnosticsHistoryRequest, options?: RawAxiosRequestConfig): AxiosPromise<MemoryDiagnosticsHistoryResponse> {
            return localVarFp.getMemoryDiagnosticsHistory(requestParameters.instanceId, requestParameters.hours, requestParameters.apiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Получить экземпляры с историей памяти
         * @param {MemoryDiagnosticsApiGetMemoryDiagnosticsInstancesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMemoryDiagnosticsInstances(requestParameters: MemoryDiagnosticsApiGetMemoryDiagnosticsInstancesRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<MemoryDiagnosticsInstancesResponse> {
            return localVarFp.getMemoryDiagnosticsInstances(requestParameters.apiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Получить скользящие сводки памяти экземпляра
         * @param {MemoryDiagnosticsApiGetMemoryDiagnosticsWindowsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMemoryDiagnosticsWindows(requestParameters: MemoryDiagnosticsApiGetMemoryDiagnosticsWindowsRequest, options?: RawAxiosRequestConfig): AxiosPromise<MemoryDiagnosticsWindowsResponse> {
            return localVarFp.getMemoryDiagnosticsWindows(requestParameters.instanceId, requestParameters.apiVersion, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for getMemoryDiagnosticsHistory operation in MemoryDiagnosticsApi.
 * @export
 * @interface MemoryDiagnosticsApiGetMemoryDiagnosticsHistoryRequest
 */
export interface MemoryDiagnosticsApiGetMemoryDiagnosticsHistoryRequest {
    /**
     * Идентификатор экземпляра приложения
     * @type {string}
     * @memberof MemoryDiagnosticsApiGetMemoryDiagnosticsHistory
     */
    readonly instanceId: string

    /**
     * Продолжительность истории в часах
     * @type {number}
     * @memberof MemoryDiagnosticsApiGetMemoryDiagnosticsHistory
     */
    readonly hours?: number

    /**
     * 
     * @type {string}
     * @memberof MemoryDiagnosticsApiGetMemoryDiagnosticsHistory
     */
    readonly apiVersion?: string
}

/**
 * Request parameters for getMemoryDiagnosticsInstances operation in MemoryDiagnosticsApi.
 * @export
 * @interface MemoryDiagnosticsApiGetMemoryDiagnosticsInstancesRequest
 */
export interface MemoryDiagnosticsApiGetMemoryDiagnosticsInstancesRequest {
    /**
     * 
     * @type {string}
     * @memberof MemoryDiagnosticsApiGetMemoryDiagnosticsInstances
     */
    readonly apiVersion?: string
}

/**
 * Request parameters for getMemoryDiagnosticsWindows operation in MemoryDiagnosticsApi.
 * @export
 * @interface MemoryDiagnosticsApiGetMemoryDiagnosticsWindowsRequest
 */
export interface MemoryDiagnosticsApiGetMemoryDiagnosticsWindowsRequest {
    /**
     * Идентификатор экземпляра приложения
     * @type {string}
     * @memberof MemoryDiagnosticsApiGetMemoryDiagnosticsWindows
     */
    readonly instanceId: string

    /**
     * 
     * @type {string}
     * @memberof MemoryDiagnosticsApiGetMemoryDiagnosticsWindows
     */
    readonly apiVersion?: string
}

/**
 * MemoryDiagnosticsApi - object-oriented interface
 * @export
 * @class MemoryDiagnosticsApi
 * @extends {BaseAPI}
 */
export class MemoryDiagnosticsApi extends BaseAPI {
    /**
     * 
     * @summary Получить часовую историю памяти экземпляра
     * @param {MemoryDiagnosticsApiGetMemoryDiagnosticsHistoryRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MemoryDiagnosticsApi
     */
    public getMemoryDiagnosticsHistory(requestParameters: MemoryDiagnosticsApiGetMemoryDiagnosticsHistoryRequest, options?: RawAxiosRequestConfig) {
        return MemoryDiagnosticsApiFp(this.configuration).getMemoryDiagnosticsHistory(requestParameters.instanceId, requestParameters.hours, requestParameters.apiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Получить экземпляры с историей памяти
     * @param {MemoryDiagnosticsApiGetMemoryDiagnosticsInstancesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MemoryDiagnosticsApi
     */
    public getMemoryDiagnosticsInstances(requestParameters: MemoryDiagnosticsApiGetMemoryDiagnosticsInstancesRequest = {}, options?: RawAxiosRequestConfig) {
        return MemoryDiagnosticsApiFp(this.configuration).getMemoryDiagnosticsInstances(requestParameters.apiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Получить скользящие сводки памяти экземпляра
     * @param {MemoryDiagnosticsApiGetMemoryDiagnosticsWindowsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MemoryDiagnosticsApi
     */
    public getMemoryDiagnosticsWindows(requestParameters: MemoryDiagnosticsApiGetMemoryDiagnosticsWindowsRequest, options?: RawAxiosRequestConfig) {
        return MemoryDiagnosticsApiFp(this.configuration).getMemoryDiagnosticsWindows(requestParameters.instanceId, requestParameters.apiVersion, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * MessageSendStatisticsApi - axios parameter creator
 * @export
 */
export const MessageSendStatisticsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Получить показатели скользящих периодов
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMessageSendStatisticsWindows: async (apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/message-send-statistics/windows`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * MessageSendStatisticsApi - functional programming interface
 * @export
 */
export const MessageSendStatisticsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = MessageSendStatisticsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Получить показатели скользящих периодов
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMessageSendStatisticsWindows(apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MessageSendStatisticsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMessageSendStatisticsWindows(apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MessageSendStatisticsApi.getMessageSendStatisticsWindows']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * MessageSendStatisticsApi - factory interface
 * @export
 */
export const MessageSendStatisticsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = MessageSendStatisticsApiFp(configuration)
    return {
        /**
         * 
         * @summary Получить показатели скользящих периодов
         * @param {MessageSendStatisticsApiGetMessageSendStatisticsWindowsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMessageSendStatisticsWindows(requestParameters: MessageSendStatisticsApiGetMessageSendStatisticsWindowsRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<MessageSendStatisticsResponse> {
            return localVarFp.getMessageSendStatisticsWindows(requestParameters.apiVersion, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for getMessageSendStatisticsWindows operation in MessageSendStatisticsApi.
 * @export
 * @interface MessageSendStatisticsApiGetMessageSendStatisticsWindowsRequest
 */
export interface MessageSendStatisticsApiGetMessageSendStatisticsWindowsRequest {
    /**
     * 
     * @type {string}
     * @memberof MessageSendStatisticsApiGetMessageSendStatisticsWindows
     */
    readonly apiVersion?: string
}

/**
 * MessageSendStatisticsApi - object-oriented interface
 * @export
 * @class MessageSendStatisticsApi
 * @extends {BaseAPI}
 */
export class MessageSendStatisticsApi extends BaseAPI {
    /**
     * 
     * @summary Получить показатели скользящих периодов
     * @param {MessageSendStatisticsApiGetMessageSendStatisticsWindowsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MessageSendStatisticsApi
     */
    public getMessageSendStatisticsWindows(requestParameters: MessageSendStatisticsApiGetMessageSendStatisticsWindowsRequest = {}, options?: RawAxiosRequestConfig) {
        return MessageSendStatisticsApiFp(this.configuration).getMessageSendStatisticsWindows(requestParameters.apiVersion, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * MessageTemplatesApi - axios parameter creator
 * @export
 */
export const MessageTemplatesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Получить каталог текстовок
         * @param {ApiMessageTemplateGroup} [group] Группы текстовок приложения
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1MessageTemplatesGet: async (group?: ApiMessageTemplateGroup, apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/message-templates`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (group !== undefined) {
                localVarQueryParameter['group'] = group;
            }


    
            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Получить тематические группы
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1MessageTemplatesGroupsGet: async (apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/message-templates/groups`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Получить текстовку
         * @param {string} id 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1MessageTemplatesIdGet: async (id: string, apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiV1MessageTemplatesIdGet', 'id', id)
            const localVarPath = `/api/v1/message-templates/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Изменить текстовку
         * @param {string} id 
         * @param {string} [apiVersion] 
         * @param {UpdateMessageTemplateRequest} [updateMessageTemplateRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1MessageTemplatesIdPut: async (id: string, apiVersion?: string, updateMessageTemplateRequest?: UpdateMessageTemplateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiV1MessageTemplatesIdPut', 'id', id)
            const localVarPath = `/api/v1/message-templates/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateMessageTemplateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * MessageTemplatesApi - functional programming interface
 * @export
 */
export const MessageTemplatesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = MessageTemplatesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Получить каталог текстовок
         * @param {ApiMessageTemplateGroup} [group] Группы текстовок приложения
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1MessageTemplatesGet(group?: ApiMessageTemplateGroup, apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<MessageTemplateResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1MessageTemplatesGet(group, apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MessageTemplatesApi.apiV1MessageTemplatesGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Получить тематические группы
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1MessageTemplatesGroupsGet(apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ApiMessageTemplateGroupSimpleModel>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1MessageTemplatesGroupsGet(apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MessageTemplatesApi.apiV1MessageTemplatesGroupsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Получить текстовку
         * @param {string} id 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1MessageTemplatesIdGet(id: string, apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MessageTemplateResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1MessageTemplatesIdGet(id, apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MessageTemplatesApi.apiV1MessageTemplatesIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Изменить текстовку
         * @param {string} id 
         * @param {string} [apiVersion] 
         * @param {UpdateMessageTemplateRequest} [updateMessageTemplateRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1MessageTemplatesIdPut(id: string, apiVersion?: string, updateMessageTemplateRequest?: UpdateMessageTemplateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1MessageTemplatesIdPut(id, apiVersion, updateMessageTemplateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MessageTemplatesApi.apiV1MessageTemplatesIdPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * MessageTemplatesApi - factory interface
 * @export
 */
export const MessageTemplatesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = MessageTemplatesApiFp(configuration)
    return {
        /**
         * 
         * @summary Получить каталог текстовок
         * @param {MessageTemplatesApiApiV1MessageTemplatesGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1MessageTemplatesGet(requestParameters: MessageTemplatesApiApiV1MessageTemplatesGetRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<Array<MessageTemplateResponse>> {
            return localVarFp.apiV1MessageTemplatesGet(requestParameters.group, requestParameters.apiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Получить тематические группы
         * @param {MessageTemplatesApiApiV1MessageTemplatesGroupsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1MessageTemplatesGroupsGet(requestParameters: MessageTemplatesApiApiV1MessageTemplatesGroupsGetRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<Array<ApiMessageTemplateGroupSimpleModel>> {
            return localVarFp.apiV1MessageTemplatesGroupsGet(requestParameters.apiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Получить текстовку
         * @param {MessageTemplatesApiApiV1MessageTemplatesIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1MessageTemplatesIdGet(requestParameters: MessageTemplatesApiApiV1MessageTemplatesIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<MessageTemplateResponse> {
            return localVarFp.apiV1MessageTemplatesIdGet(requestParameters.id, requestParameters.apiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Изменить текстовку
         * @param {MessageTemplatesApiApiV1MessageTemplatesIdPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1MessageTemplatesIdPut(requestParameters: MessageTemplatesApiApiV1MessageTemplatesIdPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiV1MessageTemplatesIdPut(requestParameters.id, requestParameters.apiVersion, requestParameters.updateMessageTemplateRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for apiV1MessageTemplatesGet operation in MessageTemplatesApi.
 * @export
 * @interface MessageTemplatesApiApiV1MessageTemplatesGetRequest
 */
export interface MessageTemplatesApiApiV1MessageTemplatesGetRequest {
    /**
     * Группы текстовок приложения
     * @type {ApiMessageTemplateGroup}
     * @memberof MessageTemplatesApiApiV1MessageTemplatesGet
     */
    readonly group?: ApiMessageTemplateGroup

    /**
     * 
     * @type {string}
     * @memberof MessageTemplatesApiApiV1MessageTemplatesGet
     */
    readonly apiVersion?: string
}

/**
 * Request parameters for apiV1MessageTemplatesGroupsGet operation in MessageTemplatesApi.
 * @export
 * @interface MessageTemplatesApiApiV1MessageTemplatesGroupsGetRequest
 */
export interface MessageTemplatesApiApiV1MessageTemplatesGroupsGetRequest {
    /**
     * 
     * @type {string}
     * @memberof MessageTemplatesApiApiV1MessageTemplatesGroupsGet
     */
    readonly apiVersion?: string
}

/**
 * Request parameters for apiV1MessageTemplatesIdGet operation in MessageTemplatesApi.
 * @export
 * @interface MessageTemplatesApiApiV1MessageTemplatesIdGetRequest
 */
export interface MessageTemplatesApiApiV1MessageTemplatesIdGetRequest {
    /**
     * 
     * @type {string}
     * @memberof MessageTemplatesApiApiV1MessageTemplatesIdGet
     */
    readonly id: string

    /**
     * 
     * @type {string}
     * @memberof MessageTemplatesApiApiV1MessageTemplatesIdGet
     */
    readonly apiVersion?: string
}

/**
 * Request parameters for apiV1MessageTemplatesIdPut operation in MessageTemplatesApi.
 * @export
 * @interface MessageTemplatesApiApiV1MessageTemplatesIdPutRequest
 */
export interface MessageTemplatesApiApiV1MessageTemplatesIdPutRequest {
    /**
     * 
     * @type {string}
     * @memberof MessageTemplatesApiApiV1MessageTemplatesIdPut
     */
    readonly id: string

    /**
     * 
     * @type {string}
     * @memberof MessageTemplatesApiApiV1MessageTemplatesIdPut
     */
    readonly apiVersion?: string

    /**
     * 
     * @type {UpdateMessageTemplateRequest}
     * @memberof MessageTemplatesApiApiV1MessageTemplatesIdPut
     */
    readonly updateMessageTemplateRequest?: UpdateMessageTemplateRequest
}

/**
 * MessageTemplatesApi - object-oriented interface
 * @export
 * @class MessageTemplatesApi
 * @extends {BaseAPI}
 */
export class MessageTemplatesApi extends BaseAPI {
    /**
     * 
     * @summary Получить каталог текстовок
     * @param {MessageTemplatesApiApiV1MessageTemplatesGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MessageTemplatesApi
     */
    public apiV1MessageTemplatesGet(requestParameters: MessageTemplatesApiApiV1MessageTemplatesGetRequest = {}, options?: RawAxiosRequestConfig) {
        return MessageTemplatesApiFp(this.configuration).apiV1MessageTemplatesGet(requestParameters.group, requestParameters.apiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Получить тематические группы
     * @param {MessageTemplatesApiApiV1MessageTemplatesGroupsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MessageTemplatesApi
     */
    public apiV1MessageTemplatesGroupsGet(requestParameters: MessageTemplatesApiApiV1MessageTemplatesGroupsGetRequest = {}, options?: RawAxiosRequestConfig) {
        return MessageTemplatesApiFp(this.configuration).apiV1MessageTemplatesGroupsGet(requestParameters.apiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Получить текстовку
     * @param {MessageTemplatesApiApiV1MessageTemplatesIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MessageTemplatesApi
     */
    public apiV1MessageTemplatesIdGet(requestParameters: MessageTemplatesApiApiV1MessageTemplatesIdGetRequest, options?: RawAxiosRequestConfig) {
        return MessageTemplatesApiFp(this.configuration).apiV1MessageTemplatesIdGet(requestParameters.id, requestParameters.apiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Изменить текстовку
     * @param {MessageTemplatesApiApiV1MessageTemplatesIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MessageTemplatesApi
     */
    public apiV1MessageTemplatesIdPut(requestParameters: MessageTemplatesApiApiV1MessageTemplatesIdPutRequest, options?: RawAxiosRequestConfig) {
        return MessageTemplatesApiFp(this.configuration).apiV1MessageTemplatesIdPut(requestParameters.id, requestParameters.apiVersion, requestParameters.updateMessageTemplateRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * NotificationApi - axios parameter creator
 * @export
 */
export const NotificationApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Отправить пуш-уведомление
         * @param {string} [apiVersion] 
         * @param {NotifyRequest} [notifyRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendNotification: async (apiVersion?: string, notifyRequest?: NotifyRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/notification/send`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(notifyRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * NotificationApi - functional programming interface
 * @export
 */
export const NotificationApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = NotificationApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Отправить пуш-уведомление
         * @param {string} [apiVersion] 
         * @param {NotifyRequest} [notifyRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sendNotification(apiVersion?: string, notifyRequest?: NotifyRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sendNotification(apiVersion, notifyRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotificationApi.sendNotification']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * NotificationApi - factory interface
 * @export
 */
export const NotificationApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = NotificationApiFp(configuration)
    return {
        /**
         * 
         * @summary Отправить пуш-уведомление
         * @param {NotificationApiSendNotificationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendNotification(requestParameters: NotificationApiSendNotificationRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.sendNotification(requestParameters.apiVersion, requestParameters.notifyRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for sendNotification operation in NotificationApi.
 * @export
 * @interface NotificationApiSendNotificationRequest
 */
export interface NotificationApiSendNotificationRequest {
    /**
     * 
     * @type {string}
     * @memberof NotificationApiSendNotification
     */
    readonly apiVersion?: string

    /**
     * 
     * @type {NotifyRequest}
     * @memberof NotificationApiSendNotification
     */
    readonly notifyRequest?: NotifyRequest
}

/**
 * NotificationApi - object-oriented interface
 * @export
 * @class NotificationApi
 * @extends {BaseAPI}
 */
export class NotificationApi extends BaseAPI {
    /**
     * 
     * @summary Отправить пуш-уведомление
     * @param {NotificationApiSendNotificationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationApi
     */
    public sendNotification(requestParameters: NotificationApiSendNotificationRequest = {}, options?: RawAxiosRequestConfig) {
        return NotificationApiFp(this.configuration).sendNotification(requestParameters.apiVersion, requestParameters.notifyRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * NotificationPermissionApi - axios parameter creator
 * @export
 */
export const NotificationPermissionApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Обновить системное разрешение уведомлений текущего пользователя
         * @param {string} [apiVersion] 
         * @param {UpdateNotificationPermissionRequest} [updateNotificationPermissionRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePermission: async (apiVersion?: string, updateNotificationPermissionRequest?: UpdateNotificationPermissionRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/notification/permission`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateNotificationPermissionRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * NotificationPermissionApi - functional programming interface
 * @export
 */
export const NotificationPermissionApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = NotificationPermissionApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Обновить системное разрешение уведомлений текущего пользователя
         * @param {string} [apiVersion] 
         * @param {UpdateNotificationPermissionRequest} [updateNotificationPermissionRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updatePermission(apiVersion?: string, updateNotificationPermissionRequest?: UpdateNotificationPermissionRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updatePermission(apiVersion, updateNotificationPermissionRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotificationPermissionApi.updatePermission']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * NotificationPermissionApi - factory interface
 * @export
 */
export const NotificationPermissionApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = NotificationPermissionApiFp(configuration)
    return {
        /**
         * 
         * @summary Обновить системное разрешение уведомлений текущего пользователя
         * @param {NotificationPermissionApiUpdatePermissionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePermission(requestParameters: NotificationPermissionApiUpdatePermissionRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updatePermission(requestParameters.apiVersion, requestParameters.updateNotificationPermissionRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for updatePermission operation in NotificationPermissionApi.
 * @export
 * @interface NotificationPermissionApiUpdatePermissionRequest
 */
export interface NotificationPermissionApiUpdatePermissionRequest {
    /**
     * 
     * @type {string}
     * @memberof NotificationPermissionApiUpdatePermission
     */
    readonly apiVersion?: string

    /**
     * 
     * @type {UpdateNotificationPermissionRequest}
     * @memberof NotificationPermissionApiUpdatePermission
     */
    readonly updateNotificationPermissionRequest?: UpdateNotificationPermissionRequest
}

/**
 * NotificationPermissionApi - object-oriented interface
 * @export
 * @class NotificationPermissionApi
 * @extends {BaseAPI}
 */
export class NotificationPermissionApi extends BaseAPI {
    /**
     * 
     * @summary Обновить системное разрешение уведомлений текущего пользователя
     * @param {NotificationPermissionApiUpdatePermissionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationPermissionApi
     */
    public updatePermission(requestParameters: NotificationPermissionApiUpdatePermissionRequest = {}, options?: RawAxiosRequestConfig) {
        return NotificationPermissionApiFp(this.configuration).updatePermission(requestParameters.apiVersion, requestParameters.updateNotificationPermissionRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * NotificationReceiptApi - axios parameter creator
 * @export
 */
export const NotificationReceiptApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Подтвердить нажатие владельца на уведомление
         * @param {string} [apiVersion] 
         * @param {NotificationOpenedRequest} [notificationOpenedRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        opened: async (apiVersion?: string, notificationOpenedRequest?: NotificationOpenedRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/notification/opened`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(notificationOpenedRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Подтвердить получение уведомления устройством
         * @param {string} [apiVersion] 
         * @param {NotificationReceivedRequest} [notificationReceivedRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        received: async (apiVersion?: string, notificationReceivedRequest?: NotificationReceivedRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/notification/received`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(notificationReceivedRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * NotificationReceiptApi - functional programming interface
 * @export
 */
export const NotificationReceiptApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = NotificationReceiptApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Подтвердить нажатие владельца на уведомление
         * @param {string} [apiVersion] 
         * @param {NotificationOpenedRequest} [notificationOpenedRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async opened(apiVersion?: string, notificationOpenedRequest?: NotificationOpenedRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.opened(apiVersion, notificationOpenedRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotificationReceiptApi.opened']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Подтвердить получение уведомления устройством
         * @param {string} [apiVersion] 
         * @param {NotificationReceivedRequest} [notificationReceivedRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async received(apiVersion?: string, notificationReceivedRequest?: NotificationReceivedRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.received(apiVersion, notificationReceivedRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotificationReceiptApi.received']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * NotificationReceiptApi - factory interface
 * @export
 */
export const NotificationReceiptApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = NotificationReceiptApiFp(configuration)
    return {
        /**
         * 
         * @summary Подтвердить нажатие владельца на уведомление
         * @param {NotificationReceiptApiOpenedRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        opened(requestParameters: NotificationReceiptApiOpenedRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.opened(requestParameters.apiVersion, requestParameters.notificationOpenedRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Подтвердить получение уведомления устройством
         * @param {NotificationReceiptApiReceivedRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        received(requestParameters: NotificationReceiptApiReceivedRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.received(requestParameters.apiVersion, requestParameters.notificationReceivedRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for opened operation in NotificationReceiptApi.
 * @export
 * @interface NotificationReceiptApiOpenedRequest
 */
export interface NotificationReceiptApiOpenedRequest {
    /**
     * 
     * @type {string}
     * @memberof NotificationReceiptApiOpened
     */
    readonly apiVersion?: string

    /**
     * 
     * @type {NotificationOpenedRequest}
     * @memberof NotificationReceiptApiOpened
     */
    readonly notificationOpenedRequest?: NotificationOpenedRequest
}

/**
 * Request parameters for received operation in NotificationReceiptApi.
 * @export
 * @interface NotificationReceiptApiReceivedRequest
 */
export interface NotificationReceiptApiReceivedRequest {
    /**
     * 
     * @type {string}
     * @memberof NotificationReceiptApiReceived
     */
    readonly apiVersion?: string

    /**
     * 
     * @type {NotificationReceivedRequest}
     * @memberof NotificationReceiptApiReceived
     */
    readonly notificationReceivedRequest?: NotificationReceivedRequest
}

/**
 * NotificationReceiptApi - object-oriented interface
 * @export
 * @class NotificationReceiptApi
 * @extends {BaseAPI}
 */
export class NotificationReceiptApi extends BaseAPI {
    /**
     * 
     * @summary Подтвердить нажатие владельца на уведомление
     * @param {NotificationReceiptApiOpenedRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationReceiptApi
     */
    public opened(requestParameters: NotificationReceiptApiOpenedRequest = {}, options?: RawAxiosRequestConfig) {
        return NotificationReceiptApiFp(this.configuration).opened(requestParameters.apiVersion, requestParameters.notificationOpenedRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Подтвердить получение уведомления устройством
     * @param {NotificationReceiptApiReceivedRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationReceiptApi
     */
    public received(requestParameters: NotificationReceiptApiReceivedRequest = {}, options?: RawAxiosRequestConfig) {
        return NotificationReceiptApiFp(this.configuration).received(requestParameters.apiVersion, requestParameters.notificationReceivedRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * NotificationTemplateApi - axios parameter creator
 * @export
 */
export const NotificationTemplateApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Получить назначения переходов для шаблонов уведомлений
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNavigationTargets: async (apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/notification-templates/navigation-targets`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Получить шаблон пуш-уведомления по идентификатору
         * @param {string} id 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNotificationTemplateById: async (id: string, apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getNotificationTemplateById', 'id', id)
            const localVarPath = `/api/v1/notification-templates/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Получить все шаблоны пуш-уведомлений
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNotificationTemplates: async (apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/notification-templates`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Обновить текст шаблона пуш-уведомления
         * @param {string} id 
         * @param {string} [apiVersion] 
         * @param {UpdateNotificationTemplateRequest} [updateNotificationTemplateRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateNotificationTemplate: async (id: string, apiVersion?: string, updateNotificationTemplateRequest?: UpdateNotificationTemplateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateNotificationTemplate', 'id', id)
            const localVarPath = `/api/v1/notification-templates/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateNotificationTemplateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * NotificationTemplateApi - functional programming interface
 * @export
 */
export const NotificationTemplateApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = NotificationTemplateApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Получить назначения переходов для шаблонов уведомлений
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getNavigationTargets(apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<NotificationNavigationTargetResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getNavigationTargets(apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotificationTemplateApi.getNavigationTargets']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Получить шаблон пуш-уведомления по идентификатору
         * @param {string} id 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getNotificationTemplateById(id: string, apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<NotificationTemplateResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getNotificationTemplateById(id, apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotificationTemplateApi.getNotificationTemplateById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Получить все шаблоны пуш-уведомлений
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getNotificationTemplates(apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<NotificationTemplateResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getNotificationTemplates(apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotificationTemplateApi.getNotificationTemplates']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Обновить текст шаблона пуш-уведомления
         * @param {string} id 
         * @param {string} [apiVersion] 
         * @param {UpdateNotificationTemplateRequest} [updateNotificationTemplateRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateNotificationTemplate(id: string, apiVersion?: string, updateNotificationTemplateRequest?: UpdateNotificationTemplateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<NotificationTemplateResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateNotificationTemplate(id, apiVersion, updateNotificationTemplateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotificationTemplateApi.updateNotificationTemplate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * NotificationTemplateApi - factory interface
 * @export
 */
export const NotificationTemplateApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = NotificationTemplateApiFp(configuration)
    return {
        /**
         * 
         * @summary Получить назначения переходов для шаблонов уведомлений
         * @param {NotificationTemplateApiGetNavigationTargetsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNavigationTargets(requestParameters: NotificationTemplateApiGetNavigationTargetsRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<Array<NotificationNavigationTargetResponse>> {
            return localVarFp.getNavigationTargets(requestParameters.apiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Получить шаблон пуш-уведомления по идентификатору
         * @param {NotificationTemplateApiGetNotificationTemplateByIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNotificationTemplateById(requestParameters: NotificationTemplateApiGetNotificationTemplateByIdRequest, options?: RawAxiosRequestConfig): AxiosPromise<NotificationTemplateResponse> {
            return localVarFp.getNotificationTemplateById(requestParameters.id, requestParameters.apiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Получить все шаблоны пуш-уведомлений
         * @param {NotificationTemplateApiGetNotificationTemplatesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNotificationTemplates(requestParameters: NotificationTemplateApiGetNotificationTemplatesRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<Array<NotificationTemplateResponse>> {
            return localVarFp.getNotificationTemplates(requestParameters.apiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Обновить текст шаблона пуш-уведомления
         * @param {NotificationTemplateApiUpdateNotificationTemplateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateNotificationTemplate(requestParameters: NotificationTemplateApiUpdateNotificationTemplateRequest, options?: RawAxiosRequestConfig): AxiosPromise<NotificationTemplateResponse> {
            return localVarFp.updateNotificationTemplate(requestParameters.id, requestParameters.apiVersion, requestParameters.updateNotificationTemplateRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for getNavigationTargets operation in NotificationTemplateApi.
 * @export
 * @interface NotificationTemplateApiGetNavigationTargetsRequest
 */
export interface NotificationTemplateApiGetNavigationTargetsRequest {
    /**
     * 
     * @type {string}
     * @memberof NotificationTemplateApiGetNavigationTargets
     */
    readonly apiVersion?: string
}

/**
 * Request parameters for getNotificationTemplateById operation in NotificationTemplateApi.
 * @export
 * @interface NotificationTemplateApiGetNotificationTemplateByIdRequest
 */
export interface NotificationTemplateApiGetNotificationTemplateByIdRequest {
    /**
     * 
     * @type {string}
     * @memberof NotificationTemplateApiGetNotificationTemplateById
     */
    readonly id: string

    /**
     * 
     * @type {string}
     * @memberof NotificationTemplateApiGetNotificationTemplateById
     */
    readonly apiVersion?: string
}

/**
 * Request parameters for getNotificationTemplates operation in NotificationTemplateApi.
 * @export
 * @interface NotificationTemplateApiGetNotificationTemplatesRequest
 */
export interface NotificationTemplateApiGetNotificationTemplatesRequest {
    /**
     * 
     * @type {string}
     * @memberof NotificationTemplateApiGetNotificationTemplates
     */
    readonly apiVersion?: string
}

/**
 * Request parameters for updateNotificationTemplate operation in NotificationTemplateApi.
 * @export
 * @interface NotificationTemplateApiUpdateNotificationTemplateRequest
 */
export interface NotificationTemplateApiUpdateNotificationTemplateRequest {
    /**
     * 
     * @type {string}
     * @memberof NotificationTemplateApiUpdateNotificationTemplate
     */
    readonly id: string

    /**
     * 
     * @type {string}
     * @memberof NotificationTemplateApiUpdateNotificationTemplate
     */
    readonly apiVersion?: string

    /**
     * 
     * @type {UpdateNotificationTemplateRequest}
     * @memberof NotificationTemplateApiUpdateNotificationTemplate
     */
    readonly updateNotificationTemplateRequest?: UpdateNotificationTemplateRequest
}

/**
 * NotificationTemplateApi - object-oriented interface
 * @export
 * @class NotificationTemplateApi
 * @extends {BaseAPI}
 */
export class NotificationTemplateApi extends BaseAPI {
    /**
     * 
     * @summary Получить назначения переходов для шаблонов уведомлений
     * @param {NotificationTemplateApiGetNavigationTargetsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationTemplateApi
     */
    public getNavigationTargets(requestParameters: NotificationTemplateApiGetNavigationTargetsRequest = {}, options?: RawAxiosRequestConfig) {
        return NotificationTemplateApiFp(this.configuration).getNavigationTargets(requestParameters.apiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Получить шаблон пуш-уведомления по идентификатору
     * @param {NotificationTemplateApiGetNotificationTemplateByIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationTemplateApi
     */
    public getNotificationTemplateById(requestParameters: NotificationTemplateApiGetNotificationTemplateByIdRequest, options?: RawAxiosRequestConfig) {
        return NotificationTemplateApiFp(this.configuration).getNotificationTemplateById(requestParameters.id, requestParameters.apiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Получить все шаблоны пуш-уведомлений
     * @param {NotificationTemplateApiGetNotificationTemplatesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationTemplateApi
     */
    public getNotificationTemplates(requestParameters: NotificationTemplateApiGetNotificationTemplatesRequest = {}, options?: RawAxiosRequestConfig) {
        return NotificationTemplateApiFp(this.configuration).getNotificationTemplates(requestParameters.apiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Обновить текст шаблона пуш-уведомления
     * @param {NotificationTemplateApiUpdateNotificationTemplateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationTemplateApi
     */
    public updateNotificationTemplate(requestParameters: NotificationTemplateApiUpdateNotificationTemplateRequest, options?: RawAxiosRequestConfig) {
        return NotificationTemplateApiFp(this.configuration).updateNotificationTemplate(requestParameters.id, requestParameters.apiVersion, requestParameters.updateNotificationTemplateRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * OperatorTasksApi - axios parameter creator
 * @export
 */
export const OperatorTasksApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Отметить выполнение задачи
         * @param {string} id 
         * @param {string} [apiVersion] 
         * @param {ChangeOperatorTaskStatusRequest} [changeOperatorTaskStatusRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        completeOperatorTask: async (id: string, apiVersion?: string, changeOperatorTaskStatusRequest?: ChangeOperatorTaskStatusRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('completeOperatorTask', 'id', id)
            const localVarPath = `/api/v1/operator-tasks/{id}/complete`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(changeOperatorTaskStatusRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Создать общую задачу операторов
         * @param {string} [apiVersion] 
         * @param {CreateOperatorTaskRequest} [createOperatorTaskRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOperatorTask: async (apiVersion?: string, createOperatorTaskRequest?: CreateOperatorTaskRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/operator-tasks`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createOperatorTaskRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Получить карточку задачи
         * @param {string} id 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOperatorTask: async (id: string, apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getOperatorTask', 'id', id)
            const localVarPath = `/api/v1/operator-tasks/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Получить сотрудников для назначения ответственными
         * @param {number} [takeCount] Размер страницы
         * @param {string} [searchQuery] Строка для поиска
         * @param {number} [skipCount] Кол-во пропущенных записей
         * @param {boolean} [ascending] Сортировка по возрастанию
         * @param {string} [ordering] Поле для сортировки
         * @param {boolean} [isDeleted] Удалённые записи
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOperatorTaskAssignees: async (takeCount?: number, searchQuery?: string, skipCount?: number, ascending?: boolean, ordering?: string, isDeleted?: boolean, apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/operator-tasks/assignees`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (takeCount !== undefined) {
                localVarQueryParameter['TakeCount'] = takeCount;
            }

            if (searchQuery !== undefined) {
                localVarQueryParameter['SearchQuery'] = searchQuery;
            }

            if (skipCount !== undefined) {
                localVarQueryParameter['SkipCount'] = skipCount;
            }

            if (ascending !== undefined) {
                localVarQueryParameter['Ascending'] = ascending;
            }

            if (ordering !== undefined) {
                localVarQueryParameter['Ordering'] = ordering;
            }

            if (isDeleted !== undefined) {
                localVarQueryParameter['IsDeleted'] = isDeleted;
            }


    
            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Получить задачи, требующие внимания
         * @param {string} [operatorTaskId] Идентификатор задачи
         * @param {string} [fromUtc] Начало периода
         * @param {string} [toUtc] Конец периода
         * @param {number} [takeCount] Размер страницы
         * @param {string} [searchQuery] Строка для поиска
         * @param {number} [skipCount] Кол-во пропущенных записей
         * @param {boolean} [ascending] Сортировка по возрастанию
         * @param {string} [ordering] Поле для сортировки
         * @param {boolean} [isDeleted] Удалённые записи
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOperatorTaskAttention: async (operatorTaskId?: string, fromUtc?: string, toUtc?: string, takeCount?: number, searchQuery?: string, skipCount?: number, ascending?: boolean, ordering?: string, isDeleted?: boolean, apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/operator-tasks/attention`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (operatorTaskId !== undefined) {
                localVarQueryParameter['OperatorTaskId'] = operatorTaskId;
            }

            if (fromUtc !== undefined) {
                localVarQueryParameter['FromUtc'] = (fromUtc as any instanceof Date) ?
                    (fromUtc as any).toISOString() :
                    fromUtc;
            }

            if (toUtc !== undefined) {
                localVarQueryParameter['ToUtc'] = (toUtc as any instanceof Date) ?
                    (toUtc as any).toISOString() :
                    toUtc;
            }

            if (takeCount !== undefined) {
                localVarQueryParameter['TakeCount'] = takeCount;
            }

            if (searchQuery !== undefined) {
                localVarQueryParameter['SearchQuery'] = searchQuery;
            }

            if (skipCount !== undefined) {
                localVarQueryParameter['SkipCount'] = skipCount;
            }

            if (ascending !== undefined) {
                localVarQueryParameter['Ascending'] = ascending;
            }

            if (ordering !== undefined) {
                localVarQueryParameter['Ordering'] = ordering;
            }

            if (isDeleted !== undefined) {
                localVarQueryParameter['IsDeleted'] = isDeleted;
            }


    
            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Получить задачи календарного интервала
         * @param {string} [fromUtc] Начало календарного диапазона
         * @param {string} [toUtc] Конец календарного диапазона
         * @param {number} [takeCount] Размер страницы
         * @param {string} [nextReminderFromUtc] Дата ближайшего напоминания: начало периода
         * @param {string} [nextReminderToUtc] Дата ближайшего напоминания: конец периода
         * @param {ApiOperatorTaskView} [view] Режим просмотра
         * @param {Array<ApiOperatorTaskType>} [types] Типы задач
         * @param {string} [dueFromUtc] Начало диапазона сроков выполнения
         * @param {string} [dueToUtc] Конец диапазона сроков выполнения
         * @param {string} [orderId] Идентификатор связанного заказа
         * @param {string} [chatId] Идентификатор чата поддержки
         * @param {string} [assigneeId] Идентификатор ответственного сотрудника
         * @param {string} [searchQuery] Строка для поиска
         * @param {number} [skipCount] Кол-во пропущенных записей
         * @param {boolean} [ascending] Сортировка по возрастанию
         * @param {string} [ordering] Поле для сортировки
         * @param {boolean} [isDeleted] Удалённые записи
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOperatorTaskCalendar: async (fromUtc?: string, toUtc?: string, takeCount?: number, nextReminderFromUtc?: string, nextReminderToUtc?: string, view?: ApiOperatorTaskView, types?: Array<ApiOperatorTaskType>, dueFromUtc?: string, dueToUtc?: string, orderId?: string, chatId?: string, assigneeId?: string, searchQuery?: string, skipCount?: number, ascending?: boolean, ordering?: string, isDeleted?: boolean, apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/operator-tasks/calendar`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (fromUtc !== undefined) {
                localVarQueryParameter['FromUtc'] = (fromUtc as any instanceof Date) ?
                    (fromUtc as any).toISOString() :
                    fromUtc;
            }

            if (toUtc !== undefined) {
                localVarQueryParameter['ToUtc'] = (toUtc as any instanceof Date) ?
                    (toUtc as any).toISOString() :
                    toUtc;
            }

            if (takeCount !== undefined) {
                localVarQueryParameter['TakeCount'] = takeCount;
            }

            if (nextReminderFromUtc !== undefined) {
                localVarQueryParameter['NextReminderFromUtc'] = (nextReminderFromUtc as any instanceof Date) ?
                    (nextReminderFromUtc as any).toISOString() :
                    nextReminderFromUtc;
            }

            if (nextReminderToUtc !== undefined) {
                localVarQueryParameter['NextReminderToUtc'] = (nextReminderToUtc as any instanceof Date) ?
                    (nextReminderToUtc as any).toISOString() :
                    nextReminderToUtc;
            }

            if (view !== undefined) {
                localVarQueryParameter['View'] = view;
            }

            if (types) {
                localVarQueryParameter['Types'] = types;
            }

            if (dueFromUtc !== undefined) {
                localVarQueryParameter['DueFromUtc'] = (dueFromUtc as any instanceof Date) ?
                    (dueFromUtc as any).toISOString() :
                    dueFromUtc;
            }

            if (dueToUtc !== undefined) {
                localVarQueryParameter['DueToUtc'] = (dueToUtc as any instanceof Date) ?
                    (dueToUtc as any).toISOString() :
                    dueToUtc;
            }

            if (orderId !== undefined) {
                localVarQueryParameter['OrderId'] = orderId;
            }

            if (chatId !== undefined) {
                localVarQueryParameter['ChatId'] = chatId;
            }

            if (assigneeId !== undefined) {
                localVarQueryParameter['AssigneeId'] = assigneeId;
            }

            if (searchQuery !== undefined) {
                localVarQueryParameter['SearchQuery'] = searchQuery;
            }

            if (skipCount !== undefined) {
                localVarQueryParameter['SkipCount'] = skipCount;
            }

            if (ascending !== undefined) {
                localVarQueryParameter['Ascending'] = ascending;
            }

            if (ordering !== undefined) {
                localVarQueryParameter['Ordering'] = ordering;
            }

            if (isDeleted !== undefined) {
                localVarQueryParameter['IsDeleted'] = isDeleted;
            }


    
            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Получить историю изменений задачи
         * @param {string} id 
         * @param {string} [operatorTaskId] Идентификатор задачи
         * @param {string} [fromUtc] Начало периода
         * @param {string} [toUtc] Конец периода
         * @param {number} [takeCount] Размер страницы
         * @param {string} [searchQuery] Строка для поиска
         * @param {number} [skipCount] Кол-во пропущенных записей
         * @param {boolean} [ascending] Сортировка по возрастанию
         * @param {string} [ordering] Поле для сортировки
         * @param {boolean} [isDeleted] Удалённые записи
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOperatorTaskHistory: async (id: string, operatorTaskId?: string, fromUtc?: string, toUtc?: string, takeCount?: number, searchQuery?: string, skipCount?: number, ascending?: boolean, ordering?: string, isDeleted?: boolean, apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getOperatorTaskHistory', 'id', id)
            const localVarPath = `/api/v1/operator-tasks/{id}/history`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (operatorTaskId !== undefined) {
                localVarQueryParameter['OperatorTaskId'] = operatorTaskId;
            }

            if (fromUtc !== undefined) {
                localVarQueryParameter['FromUtc'] = (fromUtc as any instanceof Date) ?
                    (fromUtc as any).toISOString() :
                    fromUtc;
            }

            if (toUtc !== undefined) {
                localVarQueryParameter['ToUtc'] = (toUtc as any instanceof Date) ?
                    (toUtc as any).toISOString() :
                    toUtc;
            }

            if (takeCount !== undefined) {
                localVarQueryParameter['TakeCount'] = takeCount;
            }

            if (searchQuery !== undefined) {
                localVarQueryParameter['SearchQuery'] = searchQuery;
            }

            if (skipCount !== undefined) {
                localVarQueryParameter['SkipCount'] = skipCount;
            }

            if (ascending !== undefined) {
                localVarQueryParameter['Ascending'] = ascending;
            }

            if (ordering !== undefined) {
                localVarQueryParameter['Ordering'] = ordering;
            }

            if (isDeleted !== undefined) {
                localVarQueryParameter['IsDeleted'] = isDeleted;
            }


    
            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Получить ограничения и настройки формы задачи
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOperatorTaskOptions: async (apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/operator-tasks/options`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Найти чаты для привязки к задаче
         * @param {string} [chatId] Идентификатор чата поддержки
         * @param {number} [takeCount] Размер страницы
         * @param {string} [searchQuery] Строка для поиска
         * @param {number} [skipCount] Кол-во пропущенных записей
         * @param {boolean} [ascending] Сортировка по возрастанию
         * @param {string} [ordering] Поле для сортировки
         * @param {boolean} [isDeleted] Удалённые записи
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOperatorTaskRelatedChats: async (chatId?: string, takeCount?: number, searchQuery?: string, skipCount?: number, ascending?: boolean, ordering?: string, isDeleted?: boolean, apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/operator-tasks/related-chats`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (chatId !== undefined) {
                localVarQueryParameter['ChatId'] = chatId;
            }

            if (takeCount !== undefined) {
                localVarQueryParameter['TakeCount'] = takeCount;
            }

            if (searchQuery !== undefined) {
                localVarQueryParameter['SearchQuery'] = searchQuery;
            }

            if (skipCount !== undefined) {
                localVarQueryParameter['SkipCount'] = skipCount;
            }

            if (ascending !== undefined) {
                localVarQueryParameter['Ascending'] = ascending;
            }

            if (ordering !== undefined) {
                localVarQueryParameter['Ordering'] = ordering;
            }

            if (isDeleted !== undefined) {
                localVarQueryParameter['IsDeleted'] = isDeleted;
            }


    
            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Найти заказы для привязки к задаче
         * @param {string} [chatId] Идентификатор чата поддержки
         * @param {number} [takeCount] Размер страницы
         * @param {string} [searchQuery] Строка для поиска
         * @param {number} [skipCount] Кол-во пропущенных записей
         * @param {boolean} [ascending] Сортировка по возрастанию
         * @param {string} [ordering] Поле для сортировки
         * @param {boolean} [isDeleted] Удалённые записи
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOperatorTaskRelatedOrders: async (chatId?: string, takeCount?: number, searchQuery?: string, skipCount?: number, ascending?: boolean, ordering?: string, isDeleted?: boolean, apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/operator-tasks/related-orders`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (chatId !== undefined) {
                localVarQueryParameter['ChatId'] = chatId;
            }

            if (takeCount !== undefined) {
                localVarQueryParameter['TakeCount'] = takeCount;
            }

            if (searchQuery !== undefined) {
                localVarQueryParameter['SearchQuery'] = searchQuery;
            }

            if (skipCount !== undefined) {
                localVarQueryParameter['SkipCount'] = skipCount;
            }

            if (ascending !== undefined) {
                localVarQueryParameter['Ascending'] = ascending;
            }

            if (ordering !== undefined) {
                localVarQueryParameter['Ordering'] = ordering;
            }

            if (isDeleted !== undefined) {
                localVarQueryParameter['IsDeleted'] = isDeleted;
            }


    
            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Получить историю напоминаний задач
         * @param {string} [operatorTaskId] Идентификатор задачи
         * @param {string} [fromUtc] Начало периода
         * @param {string} [toUtc] Конец периода
         * @param {number} [takeCount] Размер страницы
         * @param {string} [searchQuery] Строка для поиска
         * @param {number} [skipCount] Кол-во пропущенных записей
         * @param {boolean} [ascending] Сортировка по возрастанию
         * @param {string} [ordering] Поле для сортировки
         * @param {boolean} [isDeleted] Удалённые записи
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOperatorTaskReminders: async (operatorTaskId?: string, fromUtc?: string, toUtc?: string, takeCount?: number, searchQuery?: string, skipCount?: number, ascending?: boolean, ordering?: string, isDeleted?: boolean, apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/operator-tasks/reminders`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (operatorTaskId !== undefined) {
                localVarQueryParameter['OperatorTaskId'] = operatorTaskId;
            }

            if (fromUtc !== undefined) {
                localVarQueryParameter['FromUtc'] = (fromUtc as any instanceof Date) ?
                    (fromUtc as any).toISOString() :
                    fromUtc;
            }

            if (toUtc !== undefined) {
                localVarQueryParameter['ToUtc'] = (toUtc as any instanceof Date) ?
                    (toUtc as any).toISOString() :
                    toUtc;
            }

            if (takeCount !== undefined) {
                localVarQueryParameter['TakeCount'] = takeCount;
            }

            if (searchQuery !== undefined) {
                localVarQueryParameter['SearchQuery'] = searchQuery;
            }

            if (skipCount !== undefined) {
                localVarQueryParameter['SkipCount'] = skipCount;
            }

            if (ascending !== undefined) {
                localVarQueryParameter['Ascending'] = ascending;
            }

            if (ordering !== undefined) {
                localVarQueryParameter['Ordering'] = ordering;
            }

            if (isDeleted !== undefined) {
                localVarQueryParameter['IsDeleted'] = isDeleted;
            }


    
            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Получить сводку задач операторов
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOperatorTaskSummary: async (apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/operator-tasks/summary`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Получить общую очередь задач операторов
         * @param {string} [nextReminderFromUtc] Дата ближайшего напоминания: начало периода
         * @param {string} [nextReminderToUtc] Дата ближайшего напоминания: конец периода
         * @param {ApiOperatorTaskView} [view] Режим просмотра
         * @param {Array<ApiOperatorTaskType>} [types] Типы задач
         * @param {string} [dueFromUtc] Начало диапазона сроков выполнения
         * @param {string} [dueToUtc] Конец диапазона сроков выполнения
         * @param {string} [orderId] Идентификатор связанного заказа
         * @param {string} [chatId] Идентификатор чата поддержки
         * @param {string} [assigneeId] Идентификатор ответственного сотрудника
         * @param {number} [takeCount] Размер страницы
         * @param {string} [searchQuery] Строка для поиска
         * @param {number} [skipCount] Кол-во пропущенных записей
         * @param {boolean} [ascending] Сортировка по возрастанию
         * @param {string} [ordering] Поле для сортировки
         * @param {boolean} [isDeleted] Удалённые записи
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOperatorTasks: async (nextReminderFromUtc?: string, nextReminderToUtc?: string, view?: ApiOperatorTaskView, types?: Array<ApiOperatorTaskType>, dueFromUtc?: string, dueToUtc?: string, orderId?: string, chatId?: string, assigneeId?: string, takeCount?: number, searchQuery?: string, skipCount?: number, ascending?: boolean, ordering?: string, isDeleted?: boolean, apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/operator-tasks/get-operator-tasks`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nextReminderFromUtc !== undefined) {
                localVarQueryParameter['NextReminderFromUtc'] = (nextReminderFromUtc as any instanceof Date) ?
                    (nextReminderFromUtc as any).toISOString() :
                    nextReminderFromUtc;
            }

            if (nextReminderToUtc !== undefined) {
                localVarQueryParameter['NextReminderToUtc'] = (nextReminderToUtc as any instanceof Date) ?
                    (nextReminderToUtc as any).toISOString() :
                    nextReminderToUtc;
            }

            if (view !== undefined) {
                localVarQueryParameter['View'] = view;
            }

            if (types) {
                localVarQueryParameter['Types'] = types;
            }

            if (dueFromUtc !== undefined) {
                localVarQueryParameter['DueFromUtc'] = (dueFromUtc as any instanceof Date) ?
                    (dueFromUtc as any).toISOString() :
                    dueFromUtc;
            }

            if (dueToUtc !== undefined) {
                localVarQueryParameter['DueToUtc'] = (dueToUtc as any instanceof Date) ?
                    (dueToUtc as any).toISOString() :
                    dueToUtc;
            }

            if (orderId !== undefined) {
                localVarQueryParameter['OrderId'] = orderId;
            }

            if (chatId !== undefined) {
                localVarQueryParameter['ChatId'] = chatId;
            }

            if (assigneeId !== undefined) {
                localVarQueryParameter['AssigneeId'] = assigneeId;
            }

            if (takeCount !== undefined) {
                localVarQueryParameter['TakeCount'] = takeCount;
            }

            if (searchQuery !== undefined) {
                localVarQueryParameter['SearchQuery'] = searchQuery;
            }

            if (skipCount !== undefined) {
                localVarQueryParameter['SkipCount'] = skipCount;
            }

            if (ascending !== undefined) {
                localVarQueryParameter['Ascending'] = ascending;
            }

            if (ordering !== undefined) {
                localVarQueryParameter['Ordering'] = ordering;
            }

            if (isDeleted !== undefined) {
                localVarQueryParameter['IsDeleted'] = isDeleted;
            }


    
            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Рассчитать предварительное расписание напоминаний
         * @param {ApiOperatorTaskType} [type] Тип задачи
         * @param {string} [dueAtUtc] Срок выполнения
         * @param {string} [operatorTaskId] Идентификатор задачи
         * @param {string} [version] Версия задачи
         * @param {boolean} [atDeadline] Напоминание при наступлении срока задачи
         * @param {string} [dailyStartDate] Первый день ежедневных напоминаний
         * @param {string} [dailyTime] Московское время ежедневного напоминания
         * @param {ApiOperatorTaskBeforeDeadlineMode} [beforeDeadlineMode] Способ напоминания перед сроком задачи
         * @param {string} [beforeDeadlineTime] Московское время напоминания перед сроком
         * @param {number} [beforeDeadlineOffsetMinutes] Интервал до срока в минутах
         * @param {ApiOperatorTaskOverdueMode} [overdueMode] Периодичность напоминаний о просрочке
         * @param {number} [overdueIntervalHours] Интервал повторов при просрочке в часах
         * @param {string} [overdueTime] Московское время повторного напоминания о просрочке
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        previewOperatorTaskReminders: async (type?: ApiOperatorTaskType, dueAtUtc?: string, operatorTaskId?: string, version?: string, atDeadline?: boolean, dailyStartDate?: string, dailyTime?: string, beforeDeadlineMode?: ApiOperatorTaskBeforeDeadlineMode, beforeDeadlineTime?: string, beforeDeadlineOffsetMinutes?: number, overdueMode?: ApiOperatorTaskOverdueMode, overdueIntervalHours?: number, overdueTime?: string, apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/operator-tasks/reminder-preview`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (type !== undefined) {
                localVarQueryParameter['Type'] = type;
            }

            if (dueAtUtc !== undefined) {
                localVarQueryParameter['DueAtUtc'] = (dueAtUtc as any instanceof Date) ?
                    (dueAtUtc as any).toISOString() :
                    dueAtUtc;
            }

            if (operatorTaskId !== undefined) {
                localVarQueryParameter['OperatorTaskId'] = operatorTaskId;
            }

            if (version !== undefined) {
                localVarQueryParameter['Version'] = version;
            }

            if (atDeadline !== undefined) {
                localVarQueryParameter['AtDeadline'] = atDeadline;
            }

            if (dailyStartDate !== undefined) {
                localVarQueryParameter['DailyStartDate'] = (dailyStartDate as any instanceof Date) ?
                    (dailyStartDate as any).toISOString().substring(0,10) :
                    dailyStartDate;
            }

            if (dailyTime !== undefined) {
                localVarQueryParameter['DailyTime'] = dailyTime;
            }

            if (beforeDeadlineMode !== undefined) {
                localVarQueryParameter['BeforeDeadlineMode'] = beforeDeadlineMode;
            }

            if (beforeDeadlineTime !== undefined) {
                localVarQueryParameter['BeforeDeadlineTime'] = beforeDeadlineTime;
            }

            if (beforeDeadlineOffsetMinutes !== undefined) {
                localVarQueryParameter['BeforeDeadlineOffsetMinutes'] = beforeDeadlineOffsetMinutes;
            }

            if (overdueMode !== undefined) {
                localVarQueryParameter['OverdueMode'] = overdueMode;
            }

            if (overdueIntervalHours !== undefined) {
                localVarQueryParameter['OverdueIntervalHours'] = overdueIntervalHours;
            }

            if (overdueTime !== undefined) {
                localVarQueryParameter['OverdueTime'] = overdueTime;
            }


    
            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Вернуть задачу в работу
         * @param {string} id 
         * @param {string} [apiVersion] 
         * @param {ChangeOperatorTaskStatusRequest} [changeOperatorTaskStatusRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reopenOperatorTask: async (id: string, apiVersion?: string, changeOperatorTaskStatusRequest?: ChangeOperatorTaskStatusRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('reopenOperatorTask', 'id', id)
            const localVarPath = `/api/v1/operator-tasks/{id}/reopen`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(changeOperatorTaskStatusRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Изменить общую задачу операторов
         * @param {string} id 
         * @param {string} [apiVersion] 
         * @param {UpdateOperatorTaskRequest} [updateOperatorTaskRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOperatorTask: async (id: string, apiVersion?: string, updateOperatorTaskRequest?: UpdateOperatorTaskRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateOperatorTask', 'id', id)
            const localVarPath = `/api/v1/operator-tasks/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateOperatorTaskRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * OperatorTasksApi - functional programming interface
 * @export
 */
export const OperatorTasksApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = OperatorTasksApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Отметить выполнение задачи
         * @param {string} id 
         * @param {string} [apiVersion] 
         * @param {ChangeOperatorTaskStatusRequest} [changeOperatorTaskStatusRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async completeOperatorTask(id: string, apiVersion?: string, changeOperatorTaskStatusRequest?: ChangeOperatorTaskStatusRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OperatorTaskMutationResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.completeOperatorTask(id, apiVersion, changeOperatorTaskStatusRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OperatorTasksApi.completeOperatorTask']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Создать общую задачу операторов
         * @param {string} [apiVersion] 
         * @param {CreateOperatorTaskRequest} [createOperatorTaskRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createOperatorTask(apiVersion?: string, createOperatorTaskRequest?: CreateOperatorTaskRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OperatorTaskMutationResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createOperatorTask(apiVersion, createOperatorTaskRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OperatorTasksApi.createOperatorTask']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Получить карточку задачи
         * @param {string} id 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOperatorTask(id: string, apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OperatorTaskDetailsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOperatorTask(id, apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OperatorTasksApi.getOperatorTask']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Получить сотрудников для назначения ответственными
         * @param {number} [takeCount] Размер страницы
         * @param {string} [searchQuery] Строка для поиска
         * @param {number} [skipCount] Кол-во пропущенных записей
         * @param {boolean} [ascending] Сортировка по возрастанию
         * @param {string} [ordering] Поле для сортировки
         * @param {boolean} [isDeleted] Удалённые записи
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOperatorTaskAssignees(takeCount?: number, searchQuery?: string, skipCount?: number, ascending?: boolean, ordering?: string, isDeleted?: boolean, apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetOperatorTaskAssigneesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOperatorTaskAssignees(takeCount, searchQuery, skipCount, ascending, ordering, isDeleted, apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OperatorTasksApi.getOperatorTaskAssignees']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Получить задачи, требующие внимания
         * @param {string} [operatorTaskId] Идентификатор задачи
         * @param {string} [fromUtc] Начало периода
         * @param {string} [toUtc] Конец периода
         * @param {number} [takeCount] Размер страницы
         * @param {string} [searchQuery] Строка для поиска
         * @param {number} [skipCount] Кол-во пропущенных записей
         * @param {boolean} [ascending] Сортировка по возрастанию
         * @param {string} [ordering] Поле для сортировки
         * @param {boolean} [isDeleted] Удалённые записи
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOperatorTaskAttention(operatorTaskId?: string, fromUtc?: string, toUtc?: string, takeCount?: number, searchQuery?: string, skipCount?: number, ascending?: boolean, ordering?: string, isDeleted?: boolean, apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetOperatorTaskAttentionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOperatorTaskAttention(operatorTaskId, fromUtc, toUtc, takeCount, searchQuery, skipCount, ascending, ordering, isDeleted, apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OperatorTasksApi.getOperatorTaskAttention']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Получить задачи календарного интервала
         * @param {string} [fromUtc] Начало календарного диапазона
         * @param {string} [toUtc] Конец календарного диапазона
         * @param {number} [takeCount] Размер страницы
         * @param {string} [nextReminderFromUtc] Дата ближайшего напоминания: начало периода
         * @param {string} [nextReminderToUtc] Дата ближайшего напоминания: конец периода
         * @param {ApiOperatorTaskView} [view] Режим просмотра
         * @param {Array<ApiOperatorTaskType>} [types] Типы задач
         * @param {string} [dueFromUtc] Начало диапазона сроков выполнения
         * @param {string} [dueToUtc] Конец диапазона сроков выполнения
         * @param {string} [orderId] Идентификатор связанного заказа
         * @param {string} [chatId] Идентификатор чата поддержки
         * @param {string} [assigneeId] Идентификатор ответственного сотрудника
         * @param {string} [searchQuery] Строка для поиска
         * @param {number} [skipCount] Кол-во пропущенных записей
         * @param {boolean} [ascending] Сортировка по возрастанию
         * @param {string} [ordering] Поле для сортировки
         * @param {boolean} [isDeleted] Удалённые записи
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOperatorTaskCalendar(fromUtc?: string, toUtc?: string, takeCount?: number, nextReminderFromUtc?: string, nextReminderToUtc?: string, view?: ApiOperatorTaskView, types?: Array<ApiOperatorTaskType>, dueFromUtc?: string, dueToUtc?: string, orderId?: string, chatId?: string, assigneeId?: string, searchQuery?: string, skipCount?: number, ascending?: boolean, ordering?: string, isDeleted?: boolean, apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetOperatorTaskCalendarResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOperatorTaskCalendar(fromUtc, toUtc, takeCount, nextReminderFromUtc, nextReminderToUtc, view, types, dueFromUtc, dueToUtc, orderId, chatId, assigneeId, searchQuery, skipCount, ascending, ordering, isDeleted, apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OperatorTasksApi.getOperatorTaskCalendar']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Получить историю изменений задачи
         * @param {string} id 
         * @param {string} [operatorTaskId] Идентификатор задачи
         * @param {string} [fromUtc] Начало периода
         * @param {string} [toUtc] Конец периода
         * @param {number} [takeCount] Размер страницы
         * @param {string} [searchQuery] Строка для поиска
         * @param {number} [skipCount] Кол-во пропущенных записей
         * @param {boolean} [ascending] Сортировка по возрастанию
         * @param {string} [ordering] Поле для сортировки
         * @param {boolean} [isDeleted] Удалённые записи
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOperatorTaskHistory(id: string, operatorTaskId?: string, fromUtc?: string, toUtc?: string, takeCount?: number, searchQuery?: string, skipCount?: number, ascending?: boolean, ordering?: string, isDeleted?: boolean, apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetOperatorTaskHistoryResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOperatorTaskHistory(id, operatorTaskId, fromUtc, toUtc, takeCount, searchQuery, skipCount, ascending, ordering, isDeleted, apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OperatorTasksApi.getOperatorTaskHistory']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Получить ограничения и настройки формы задачи
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOperatorTaskOptions(apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OperatorTaskOptionsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOperatorTaskOptions(apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OperatorTasksApi.getOperatorTaskOptions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Найти чаты для привязки к задаче
         * @param {string} [chatId] Идентификатор чата поддержки
         * @param {number} [takeCount] Размер страницы
         * @param {string} [searchQuery] Строка для поиска
         * @param {number} [skipCount] Кол-во пропущенных записей
         * @param {boolean} [ascending] Сортировка по возрастанию
         * @param {string} [ordering] Поле для сортировки
         * @param {boolean} [isDeleted] Удалённые записи
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOperatorTaskRelatedChats(chatId?: string, takeCount?: number, searchQuery?: string, skipCount?: number, ascending?: boolean, ordering?: string, isDeleted?: boolean, apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetOperatorTaskRelatedResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOperatorTaskRelatedChats(chatId, takeCount, searchQuery, skipCount, ascending, ordering, isDeleted, apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OperatorTasksApi.getOperatorTaskRelatedChats']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Найти заказы для привязки к задаче
         * @param {string} [chatId] Идентификатор чата поддержки
         * @param {number} [takeCount] Размер страницы
         * @param {string} [searchQuery] Строка для поиска
         * @param {number} [skipCount] Кол-во пропущенных записей
         * @param {boolean} [ascending] Сортировка по возрастанию
         * @param {string} [ordering] Поле для сортировки
         * @param {boolean} [isDeleted] Удалённые записи
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOperatorTaskRelatedOrders(chatId?: string, takeCount?: number, searchQuery?: string, skipCount?: number, ascending?: boolean, ordering?: string, isDeleted?: boolean, apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetOperatorTaskRelatedResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOperatorTaskRelatedOrders(chatId, takeCount, searchQuery, skipCount, ascending, ordering, isDeleted, apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OperatorTasksApi.getOperatorTaskRelatedOrders']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Получить историю напоминаний задач
         * @param {string} [operatorTaskId] Идентификатор задачи
         * @param {string} [fromUtc] Начало периода
         * @param {string} [toUtc] Конец периода
         * @param {number} [takeCount] Размер страницы
         * @param {string} [searchQuery] Строка для поиска
         * @param {number} [skipCount] Кол-во пропущенных записей
         * @param {boolean} [ascending] Сортировка по возрастанию
         * @param {string} [ordering] Поле для сортировки
         * @param {boolean} [isDeleted] Удалённые записи
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOperatorTaskReminders(operatorTaskId?: string, fromUtc?: string, toUtc?: string, takeCount?: number, searchQuery?: string, skipCount?: number, ascending?: boolean, ordering?: string, isDeleted?: boolean, apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetOperatorTaskRemindersResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOperatorTaskReminders(operatorTaskId, fromUtc, toUtc, takeCount, searchQuery, skipCount, ascending, ordering, isDeleted, apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OperatorTasksApi.getOperatorTaskReminders']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Получить сводку задач операторов
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOperatorTaskSummary(apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OperatorTaskSummaryResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOperatorTaskSummary(apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OperatorTasksApi.getOperatorTaskSummary']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Получить общую очередь задач операторов
         * @param {string} [nextReminderFromUtc] Дата ближайшего напоминания: начало периода
         * @param {string} [nextReminderToUtc] Дата ближайшего напоминания: конец периода
         * @param {ApiOperatorTaskView} [view] Режим просмотра
         * @param {Array<ApiOperatorTaskType>} [types] Типы задач
         * @param {string} [dueFromUtc] Начало диапазона сроков выполнения
         * @param {string} [dueToUtc] Конец диапазона сроков выполнения
         * @param {string} [orderId] Идентификатор связанного заказа
         * @param {string} [chatId] Идентификатор чата поддержки
         * @param {string} [assigneeId] Идентификатор ответственного сотрудника
         * @param {number} [takeCount] Размер страницы
         * @param {string} [searchQuery] Строка для поиска
         * @param {number} [skipCount] Кол-во пропущенных записей
         * @param {boolean} [ascending] Сортировка по возрастанию
         * @param {string} [ordering] Поле для сортировки
         * @param {boolean} [isDeleted] Удалённые записи
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOperatorTasks(nextReminderFromUtc?: string, nextReminderToUtc?: string, view?: ApiOperatorTaskView, types?: Array<ApiOperatorTaskType>, dueFromUtc?: string, dueToUtc?: string, orderId?: string, chatId?: string, assigneeId?: string, takeCount?: number, searchQuery?: string, skipCount?: number, ascending?: boolean, ordering?: string, isDeleted?: boolean, apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetOperatorTasksResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOperatorTasks(nextReminderFromUtc, nextReminderToUtc, view, types, dueFromUtc, dueToUtc, orderId, chatId, assigneeId, takeCount, searchQuery, skipCount, ascending, ordering, isDeleted, apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OperatorTasksApi.getOperatorTasks']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Рассчитать предварительное расписание напоминаний
         * @param {ApiOperatorTaskType} [type] Тип задачи
         * @param {string} [dueAtUtc] Срок выполнения
         * @param {string} [operatorTaskId] Идентификатор задачи
         * @param {string} [version] Версия задачи
         * @param {boolean} [atDeadline] Напоминание при наступлении срока задачи
         * @param {string} [dailyStartDate] Первый день ежедневных напоминаний
         * @param {string} [dailyTime] Московское время ежедневного напоминания
         * @param {ApiOperatorTaskBeforeDeadlineMode} [beforeDeadlineMode] Способ напоминания перед сроком задачи
         * @param {string} [beforeDeadlineTime] Московское время напоминания перед сроком
         * @param {number} [beforeDeadlineOffsetMinutes] Интервал до срока в минутах
         * @param {ApiOperatorTaskOverdueMode} [overdueMode] Периодичность напоминаний о просрочке
         * @param {number} [overdueIntervalHours] Интервал повторов при просрочке в часах
         * @param {string} [overdueTime] Московское время повторного напоминания о просрочке
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async previewOperatorTaskReminders(type?: ApiOperatorTaskType, dueAtUtc?: string, operatorTaskId?: string, version?: string, atDeadline?: boolean, dailyStartDate?: string, dailyTime?: string, beforeDeadlineMode?: ApiOperatorTaskBeforeDeadlineMode, beforeDeadlineTime?: string, beforeDeadlineOffsetMinutes?: number, overdueMode?: ApiOperatorTaskOverdueMode, overdueIntervalHours?: number, overdueTime?: string, apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OperatorTaskReminderPreviewResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.previewOperatorTaskReminders(type, dueAtUtc, operatorTaskId, version, atDeadline, dailyStartDate, dailyTime, beforeDeadlineMode, beforeDeadlineTime, beforeDeadlineOffsetMinutes, overdueMode, overdueIntervalHours, overdueTime, apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OperatorTasksApi.previewOperatorTaskReminders']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Вернуть задачу в работу
         * @param {string} id 
         * @param {string} [apiVersion] 
         * @param {ChangeOperatorTaskStatusRequest} [changeOperatorTaskStatusRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reopenOperatorTask(id: string, apiVersion?: string, changeOperatorTaskStatusRequest?: ChangeOperatorTaskStatusRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OperatorTaskMutationResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reopenOperatorTask(id, apiVersion, changeOperatorTaskStatusRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OperatorTasksApi.reopenOperatorTask']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Изменить общую задачу операторов
         * @param {string} id 
         * @param {string} [apiVersion] 
         * @param {UpdateOperatorTaskRequest} [updateOperatorTaskRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateOperatorTask(id: string, apiVersion?: string, updateOperatorTaskRequest?: UpdateOperatorTaskRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OperatorTaskMutationResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateOperatorTask(id, apiVersion, updateOperatorTaskRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OperatorTasksApi.updateOperatorTask']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * OperatorTasksApi - factory interface
 * @export
 */
export const OperatorTasksApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = OperatorTasksApiFp(configuration)
    return {
        /**
         * 
         * @summary Отметить выполнение задачи
         * @param {OperatorTasksApiCompleteOperatorTaskRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        completeOperatorTask(requestParameters: OperatorTasksApiCompleteOperatorTaskRequest, options?: RawAxiosRequestConfig): AxiosPromise<OperatorTaskMutationResponse> {
            return localVarFp.completeOperatorTask(requestParameters.id, requestParameters.apiVersion, requestParameters.changeOperatorTaskStatusRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Создать общую задачу операторов
         * @param {OperatorTasksApiCreateOperatorTaskRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOperatorTask(requestParameters: OperatorTasksApiCreateOperatorTaskRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<OperatorTaskMutationResponse> {
            return localVarFp.createOperatorTask(requestParameters.apiVersion, requestParameters.createOperatorTaskRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Получить карточку задачи
         * @param {OperatorTasksApiGetOperatorTaskRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOperatorTask(requestParameters: OperatorTasksApiGetOperatorTaskRequest, options?: RawAxiosRequestConfig): AxiosPromise<OperatorTaskDetailsResponse> {
            return localVarFp.getOperatorTask(requestParameters.id, requestParameters.apiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Получить сотрудников для назначения ответственными
         * @param {OperatorTasksApiGetOperatorTaskAssigneesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOperatorTaskAssignees(requestParameters: OperatorTasksApiGetOperatorTaskAssigneesRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<GetOperatorTaskAssigneesResponse> {
            return localVarFp.getOperatorTaskAssignees(requestParameters.takeCount, requestParameters.searchQuery, requestParameters.skipCount, requestParameters.ascending, requestParameters.ordering, requestParameters.isDeleted, requestParameters.apiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Получить задачи, требующие внимания
         * @param {OperatorTasksApiGetOperatorTaskAttentionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOperatorTaskAttention(requestParameters: OperatorTasksApiGetOperatorTaskAttentionRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<GetOperatorTaskAttentionResponse> {
            return localVarFp.getOperatorTaskAttention(requestParameters.operatorTaskId, requestParameters.fromUtc, requestParameters.toUtc, requestParameters.takeCount, requestParameters.searchQuery, requestParameters.skipCount, requestParameters.ascending, requestParameters.ordering, requestParameters.isDeleted, requestParameters.apiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Получить задачи календарного интервала
         * @param {OperatorTasksApiGetOperatorTaskCalendarRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOperatorTaskCalendar(requestParameters: OperatorTasksApiGetOperatorTaskCalendarRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<GetOperatorTaskCalendarResponse> {
            return localVarFp.getOperatorTaskCalendar(requestParameters.fromUtc, requestParameters.toUtc, requestParameters.takeCount, requestParameters.nextReminderFromUtc, requestParameters.nextReminderToUtc, requestParameters.view, requestParameters.types, requestParameters.dueFromUtc, requestParameters.dueToUtc, requestParameters.orderId, requestParameters.chatId, requestParameters.assigneeId, requestParameters.searchQuery, requestParameters.skipCount, requestParameters.ascending, requestParameters.ordering, requestParameters.isDeleted, requestParameters.apiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Получить историю изменений задачи
         * @param {OperatorTasksApiGetOperatorTaskHistoryRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOperatorTaskHistory(requestParameters: OperatorTasksApiGetOperatorTaskHistoryRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetOperatorTaskHistoryResponse> {
            return localVarFp.getOperatorTaskHistory(requestParameters.id, requestParameters.operatorTaskId, requestParameters.fromUtc, requestParameters.toUtc, requestParameters.takeCount, requestParameters.searchQuery, requestParameters.skipCount, requestParameters.ascending, requestParameters.ordering, requestParameters.isDeleted, requestParameters.apiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Получить ограничения и настройки формы задачи
         * @param {OperatorTasksApiGetOperatorTaskOptionsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOperatorTaskOptions(requestParameters: OperatorTasksApiGetOperatorTaskOptionsRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<OperatorTaskOptionsResponse> {
            return localVarFp.getOperatorTaskOptions(requestParameters.apiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Найти чаты для привязки к задаче
         * @param {OperatorTasksApiGetOperatorTaskRelatedChatsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOperatorTaskRelatedChats(requestParameters: OperatorTasksApiGetOperatorTaskRelatedChatsRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<GetOperatorTaskRelatedResponse> {
            return localVarFp.getOperatorTaskRelatedChats(requestParameters.chatId, requestParameters.takeCount, requestParameters.searchQuery, requestParameters.skipCount, requestParameters.ascending, requestParameters.ordering, requestParameters.isDeleted, requestParameters.apiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Найти заказы для привязки к задаче
         * @param {OperatorTasksApiGetOperatorTaskRelatedOrdersRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOperatorTaskRelatedOrders(requestParameters: OperatorTasksApiGetOperatorTaskRelatedOrdersRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<GetOperatorTaskRelatedResponse> {
            return localVarFp.getOperatorTaskRelatedOrders(requestParameters.chatId, requestParameters.takeCount, requestParameters.searchQuery, requestParameters.skipCount, requestParameters.ascending, requestParameters.ordering, requestParameters.isDeleted, requestParameters.apiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Получить историю напоминаний задач
         * @param {OperatorTasksApiGetOperatorTaskRemindersRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOperatorTaskReminders(requestParameters: OperatorTasksApiGetOperatorTaskRemindersRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<GetOperatorTaskRemindersResponse> {
            return localVarFp.getOperatorTaskReminders(requestParameters.operatorTaskId, requestParameters.fromUtc, requestParameters.toUtc, requestParameters.takeCount, requestParameters.searchQuery, requestParameters.skipCount, requestParameters.ascending, requestParameters.ordering, requestParameters.isDeleted, requestParameters.apiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Получить сводку задач операторов
         * @param {OperatorTasksApiGetOperatorTaskSummaryRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOperatorTaskSummary(requestParameters: OperatorTasksApiGetOperatorTaskSummaryRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<OperatorTaskSummaryResponse> {
            return localVarFp.getOperatorTaskSummary(requestParameters.apiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Получить общую очередь задач операторов
         * @param {OperatorTasksApiGetOperatorTasksRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOperatorTasks(requestParameters: OperatorTasksApiGetOperatorTasksRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<GetOperatorTasksResponse> {
            return localVarFp.getOperatorTasks(requestParameters.nextReminderFromUtc, requestParameters.nextReminderToUtc, requestParameters.view, requestParameters.types, requestParameters.dueFromUtc, requestParameters.dueToUtc, requestParameters.orderId, requestParameters.chatId, requestParameters.assigneeId, requestParameters.takeCount, requestParameters.searchQuery, requestParameters.skipCount, requestParameters.ascending, requestParameters.ordering, requestParameters.isDeleted, requestParameters.apiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Рассчитать предварительное расписание напоминаний
         * @param {OperatorTasksApiPreviewOperatorTaskRemindersRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        previewOperatorTaskReminders(requestParameters: OperatorTasksApiPreviewOperatorTaskRemindersRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<OperatorTaskReminderPreviewResponse> {
            return localVarFp.previewOperatorTaskReminders(requestParameters.type, requestParameters.dueAtUtc, requestParameters.operatorTaskId, requestParameters.version, requestParameters.atDeadline, requestParameters.dailyStartDate, requestParameters.dailyTime, requestParameters.beforeDeadlineMode, requestParameters.beforeDeadlineTime, requestParameters.beforeDeadlineOffsetMinutes, requestParameters.overdueMode, requestParameters.overdueIntervalHours, requestParameters.overdueTime, requestParameters.apiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Вернуть задачу в работу
         * @param {OperatorTasksApiReopenOperatorTaskRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reopenOperatorTask(requestParameters: OperatorTasksApiReopenOperatorTaskRequest, options?: RawAxiosRequestConfig): AxiosPromise<OperatorTaskMutationResponse> {
            return localVarFp.reopenOperatorTask(requestParameters.id, requestParameters.apiVersion, requestParameters.changeOperatorTaskStatusRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Изменить общую задачу операторов
         * @param {OperatorTasksApiUpdateOperatorTaskRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOperatorTask(requestParameters: OperatorTasksApiUpdateOperatorTaskRequest, options?: RawAxiosRequestConfig): AxiosPromise<OperatorTaskMutationResponse> {
            return localVarFp.updateOperatorTask(requestParameters.id, requestParameters.apiVersion, requestParameters.updateOperatorTaskRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for completeOperatorTask operation in OperatorTasksApi.
 * @export
 * @interface OperatorTasksApiCompleteOperatorTaskRequest
 */
export interface OperatorTasksApiCompleteOperatorTaskRequest {
    /**
     * 
     * @type {string}
     * @memberof OperatorTasksApiCompleteOperatorTask
     */
    readonly id: string

    /**
     * 
     * @type {string}
     * @memberof OperatorTasksApiCompleteOperatorTask
     */
    readonly apiVersion?: string

    /**
     * 
     * @type {ChangeOperatorTaskStatusRequest}
     * @memberof OperatorTasksApiCompleteOperatorTask
     */
    readonly changeOperatorTaskStatusRequest?: ChangeOperatorTaskStatusRequest
}

/**
 * Request parameters for createOperatorTask operation in OperatorTasksApi.
 * @export
 * @interface OperatorTasksApiCreateOperatorTaskRequest
 */
export interface OperatorTasksApiCreateOperatorTaskRequest {
    /**
     * 
     * @type {string}
     * @memberof OperatorTasksApiCreateOperatorTask
     */
    readonly apiVersion?: string

    /**
     * 
     * @type {CreateOperatorTaskRequest}
     * @memberof OperatorTasksApiCreateOperatorTask
     */
    readonly createOperatorTaskRequest?: CreateOperatorTaskRequest
}

/**
 * Request parameters for getOperatorTask operation in OperatorTasksApi.
 * @export
 * @interface OperatorTasksApiGetOperatorTaskRequest
 */
export interface OperatorTasksApiGetOperatorTaskRequest {
    /**
     * 
     * @type {string}
     * @memberof OperatorTasksApiGetOperatorTask
     */
    readonly id: string

    /**
     * 
     * @type {string}
     * @memberof OperatorTasksApiGetOperatorTask
     */
    readonly apiVersion?: string
}

/**
 * Request parameters for getOperatorTaskAssignees operation in OperatorTasksApi.
 * @export
 * @interface OperatorTasksApiGetOperatorTaskAssigneesRequest
 */
export interface OperatorTasksApiGetOperatorTaskAssigneesRequest {
    /**
     * Размер страницы
     * @type {number}
     * @memberof OperatorTasksApiGetOperatorTaskAssignees
     */
    readonly takeCount?: number

    /**
     * Строка для поиска
     * @type {string}
     * @memberof OperatorTasksApiGetOperatorTaskAssignees
     */
    readonly searchQuery?: string

    /**
     * Кол-во пропущенных записей
     * @type {number}
     * @memberof OperatorTasksApiGetOperatorTaskAssignees
     */
    readonly skipCount?: number

    /**
     * Сортировка по возрастанию
     * @type {boolean}
     * @memberof OperatorTasksApiGetOperatorTaskAssignees
     */
    readonly ascending?: boolean

    /**
     * Поле для сортировки
     * @type {string}
     * @memberof OperatorTasksApiGetOperatorTaskAssignees
     */
    readonly ordering?: string

    /**
     * Удалённые записи
     * @type {boolean}
     * @memberof OperatorTasksApiGetOperatorTaskAssignees
     */
    readonly isDeleted?: boolean

    /**
     * 
     * @type {string}
     * @memberof OperatorTasksApiGetOperatorTaskAssignees
     */
    readonly apiVersion?: string
}

/**
 * Request parameters for getOperatorTaskAttention operation in OperatorTasksApi.
 * @export
 * @interface OperatorTasksApiGetOperatorTaskAttentionRequest
 */
export interface OperatorTasksApiGetOperatorTaskAttentionRequest {
    /**
     * Идентификатор задачи
     * @type {string}
     * @memberof OperatorTasksApiGetOperatorTaskAttention
     */
    readonly operatorTaskId?: string

    /**
     * Начало периода
     * @type {string}
     * @memberof OperatorTasksApiGetOperatorTaskAttention
     */
    readonly fromUtc?: string

    /**
     * Конец периода
     * @type {string}
     * @memberof OperatorTasksApiGetOperatorTaskAttention
     */
    readonly toUtc?: string

    /**
     * Размер страницы
     * @type {number}
     * @memberof OperatorTasksApiGetOperatorTaskAttention
     */
    readonly takeCount?: number

    /**
     * Строка для поиска
     * @type {string}
     * @memberof OperatorTasksApiGetOperatorTaskAttention
     */
    readonly searchQuery?: string

    /**
     * Кол-во пропущенных записей
     * @type {number}
     * @memberof OperatorTasksApiGetOperatorTaskAttention
     */
    readonly skipCount?: number

    /**
     * Сортировка по возрастанию
     * @type {boolean}
     * @memberof OperatorTasksApiGetOperatorTaskAttention
     */
    readonly ascending?: boolean

    /**
     * Поле для сортировки
     * @type {string}
     * @memberof OperatorTasksApiGetOperatorTaskAttention
     */
    readonly ordering?: string

    /**
     * Удалённые записи
     * @type {boolean}
     * @memberof OperatorTasksApiGetOperatorTaskAttention
     */
    readonly isDeleted?: boolean

    /**
     * 
     * @type {string}
     * @memberof OperatorTasksApiGetOperatorTaskAttention
     */
    readonly apiVersion?: string
}

/**
 * Request parameters for getOperatorTaskCalendar operation in OperatorTasksApi.
 * @export
 * @interface OperatorTasksApiGetOperatorTaskCalendarRequest
 */
export interface OperatorTasksApiGetOperatorTaskCalendarRequest {
    /**
     * Начало календарного диапазона
     * @type {string}
     * @memberof OperatorTasksApiGetOperatorTaskCalendar
     */
    readonly fromUtc?: string

    /**
     * Конец календарного диапазона
     * @type {string}
     * @memberof OperatorTasksApiGetOperatorTaskCalendar
     */
    readonly toUtc?: string

    /**
     * Размер страницы
     * @type {number}
     * @memberof OperatorTasksApiGetOperatorTaskCalendar
     */
    readonly takeCount?: number

    /**
     * Дата ближайшего напоминания: начало периода
     * @type {string}
     * @memberof OperatorTasksApiGetOperatorTaskCalendar
     */
    readonly nextReminderFromUtc?: string

    /**
     * Дата ближайшего напоминания: конец периода
     * @type {string}
     * @memberof OperatorTasksApiGetOperatorTaskCalendar
     */
    readonly nextReminderToUtc?: string

    /**
     * Режим просмотра
     * @type {ApiOperatorTaskView}
     * @memberof OperatorTasksApiGetOperatorTaskCalendar
     */
    readonly view?: ApiOperatorTaskView

    /**
     * Типы задач
     * @type {Array<ApiOperatorTaskType>}
     * @memberof OperatorTasksApiGetOperatorTaskCalendar
     */
    readonly types?: Array<ApiOperatorTaskType>

    /**
     * Начало диапазона сроков выполнения
     * @type {string}
     * @memberof OperatorTasksApiGetOperatorTaskCalendar
     */
    readonly dueFromUtc?: string

    /**
     * Конец диапазона сроков выполнения
     * @type {string}
     * @memberof OperatorTasksApiGetOperatorTaskCalendar
     */
    readonly dueToUtc?: string

    /**
     * Идентификатор связанного заказа
     * @type {string}
     * @memberof OperatorTasksApiGetOperatorTaskCalendar
     */
    readonly orderId?: string

    /**
     * Идентификатор чата поддержки
     * @type {string}
     * @memberof OperatorTasksApiGetOperatorTaskCalendar
     */
    readonly chatId?: string

    /**
     * Идентификатор ответственного сотрудника
     * @type {string}
     * @memberof OperatorTasksApiGetOperatorTaskCalendar
     */
    readonly assigneeId?: string

    /**
     * Строка для поиска
     * @type {string}
     * @memberof OperatorTasksApiGetOperatorTaskCalendar
     */
    readonly searchQuery?: string

    /**
     * Кол-во пропущенных записей
     * @type {number}
     * @memberof OperatorTasksApiGetOperatorTaskCalendar
     */
    readonly skipCount?: number

    /**
     * Сортировка по возрастанию
     * @type {boolean}
     * @memberof OperatorTasksApiGetOperatorTaskCalendar
     */
    readonly ascending?: boolean

    /**
     * Поле для сортировки
     * @type {string}
     * @memberof OperatorTasksApiGetOperatorTaskCalendar
     */
    readonly ordering?: string

    /**
     * Удалённые записи
     * @type {boolean}
     * @memberof OperatorTasksApiGetOperatorTaskCalendar
     */
    readonly isDeleted?: boolean

    /**
     * 
     * @type {string}
     * @memberof OperatorTasksApiGetOperatorTaskCalendar
     */
    readonly apiVersion?: string
}

/**
 * Request parameters for getOperatorTaskHistory operation in OperatorTasksApi.
 * @export
 * @interface OperatorTasksApiGetOperatorTaskHistoryRequest
 */
export interface OperatorTasksApiGetOperatorTaskHistoryRequest {
    /**
     * 
     * @type {string}
     * @memberof OperatorTasksApiGetOperatorTaskHistory
     */
    readonly id: string

    /**
     * Идентификатор задачи
     * @type {string}
     * @memberof OperatorTasksApiGetOperatorTaskHistory
     */
    readonly operatorTaskId?: string

    /**
     * Начало периода
     * @type {string}
     * @memberof OperatorTasksApiGetOperatorTaskHistory
     */
    readonly fromUtc?: string

    /**
     * Конец периода
     * @type {string}
     * @memberof OperatorTasksApiGetOperatorTaskHistory
     */
    readonly toUtc?: string

    /**
     * Размер страницы
     * @type {number}
     * @memberof OperatorTasksApiGetOperatorTaskHistory
     */
    readonly takeCount?: number

    /**
     * Строка для поиска
     * @type {string}
     * @memberof OperatorTasksApiGetOperatorTaskHistory
     */
    readonly searchQuery?: string

    /**
     * Кол-во пропущенных записей
     * @type {number}
     * @memberof OperatorTasksApiGetOperatorTaskHistory
     */
    readonly skipCount?: number

    /**
     * Сортировка по возрастанию
     * @type {boolean}
     * @memberof OperatorTasksApiGetOperatorTaskHistory
     */
    readonly ascending?: boolean

    /**
     * Поле для сортировки
     * @type {string}
     * @memberof OperatorTasksApiGetOperatorTaskHistory
     */
    readonly ordering?: string

    /**
     * Удалённые записи
     * @type {boolean}
     * @memberof OperatorTasksApiGetOperatorTaskHistory
     */
    readonly isDeleted?: boolean

    /**
     * 
     * @type {string}
     * @memberof OperatorTasksApiGetOperatorTaskHistory
     */
    readonly apiVersion?: string
}

/**
 * Request parameters for getOperatorTaskOptions operation in OperatorTasksApi.
 * @export
 * @interface OperatorTasksApiGetOperatorTaskOptionsRequest
 */
export interface OperatorTasksApiGetOperatorTaskOptionsRequest {
    /**
     * 
     * @type {string}
     * @memberof OperatorTasksApiGetOperatorTaskOptions
     */
    readonly apiVersion?: string
}

/**
 * Request parameters for getOperatorTaskRelatedChats operation in OperatorTasksApi.
 * @export
 * @interface OperatorTasksApiGetOperatorTaskRelatedChatsRequest
 */
export interface OperatorTasksApiGetOperatorTaskRelatedChatsRequest {
    /**
     * Идентификатор чата поддержки
     * @type {string}
     * @memberof OperatorTasksApiGetOperatorTaskRelatedChats
     */
    readonly chatId?: string

    /**
     * Размер страницы
     * @type {number}
     * @memberof OperatorTasksApiGetOperatorTaskRelatedChats
     */
    readonly takeCount?: number

    /**
     * Строка для поиска
     * @type {string}
     * @memberof OperatorTasksApiGetOperatorTaskRelatedChats
     */
    readonly searchQuery?: string

    /**
     * Кол-во пропущенных записей
     * @type {number}
     * @memberof OperatorTasksApiGetOperatorTaskRelatedChats
     */
    readonly skipCount?: number

    /**
     * Сортировка по возрастанию
     * @type {boolean}
     * @memberof OperatorTasksApiGetOperatorTaskRelatedChats
     */
    readonly ascending?: boolean

    /**
     * Поле для сортировки
     * @type {string}
     * @memberof OperatorTasksApiGetOperatorTaskRelatedChats
     */
    readonly ordering?: string

    /**
     * Удалённые записи
     * @type {boolean}
     * @memberof OperatorTasksApiGetOperatorTaskRelatedChats
     */
    readonly isDeleted?: boolean

    /**
     * 
     * @type {string}
     * @memberof OperatorTasksApiGetOperatorTaskRelatedChats
     */
    readonly apiVersion?: string
}

/**
 * Request parameters for getOperatorTaskRelatedOrders operation in OperatorTasksApi.
 * @export
 * @interface OperatorTasksApiGetOperatorTaskRelatedOrdersRequest
 */
export interface OperatorTasksApiGetOperatorTaskRelatedOrdersRequest {
    /**
     * Идентификатор чата поддержки
     * @type {string}
     * @memberof OperatorTasksApiGetOperatorTaskRelatedOrders
     */
    readonly chatId?: string

    /**
     * Размер страницы
     * @type {number}
     * @memberof OperatorTasksApiGetOperatorTaskRelatedOrders
     */
    readonly takeCount?: number

    /**
     * Строка для поиска
     * @type {string}
     * @memberof OperatorTasksApiGetOperatorTaskRelatedOrders
     */
    readonly searchQuery?: string

    /**
     * Кол-во пропущенных записей
     * @type {number}
     * @memberof OperatorTasksApiGetOperatorTaskRelatedOrders
     */
    readonly skipCount?: number

    /**
     * Сортировка по возрастанию
     * @type {boolean}
     * @memberof OperatorTasksApiGetOperatorTaskRelatedOrders
     */
    readonly ascending?: boolean

    /**
     * Поле для сортировки
     * @type {string}
     * @memberof OperatorTasksApiGetOperatorTaskRelatedOrders
     */
    readonly ordering?: string

    /**
     * Удалённые записи
     * @type {boolean}
     * @memberof OperatorTasksApiGetOperatorTaskRelatedOrders
     */
    readonly isDeleted?: boolean

    /**
     * 
     * @type {string}
     * @memberof OperatorTasksApiGetOperatorTaskRelatedOrders
     */
    readonly apiVersion?: string
}

/**
 * Request parameters for getOperatorTaskReminders operation in OperatorTasksApi.
 * @export
 * @interface OperatorTasksApiGetOperatorTaskRemindersRequest
 */
export interface OperatorTasksApiGetOperatorTaskRemindersRequest {
    /**
     * Идентификатор задачи
     * @type {string}
     * @memberof OperatorTasksApiGetOperatorTaskReminders
     */
    readonly operatorTaskId?: string

    /**
     * Начало периода
     * @type {string}
     * @memberof OperatorTasksApiGetOperatorTaskReminders
     */
    readonly fromUtc?: string

    /**
     * Конец периода
     * @type {string}
     * @memberof OperatorTasksApiGetOperatorTaskReminders
     */
    readonly toUtc?: string

    /**
     * Размер страницы
     * @type {number}
     * @memberof OperatorTasksApiGetOperatorTaskReminders
     */
    readonly takeCount?: number

    /**
     * Строка для поиска
     * @type {string}
     * @memberof OperatorTasksApiGetOperatorTaskReminders
     */
    readonly searchQuery?: string

    /**
     * Кол-во пропущенных записей
     * @type {number}
     * @memberof OperatorTasksApiGetOperatorTaskReminders
     */
    readonly skipCount?: number

    /**
     * Сортировка по возрастанию
     * @type {boolean}
     * @memberof OperatorTasksApiGetOperatorTaskReminders
     */
    readonly ascending?: boolean

    /**
     * Поле для сортировки
     * @type {string}
     * @memberof OperatorTasksApiGetOperatorTaskReminders
     */
    readonly ordering?: string

    /**
     * Удалённые записи
     * @type {boolean}
     * @memberof OperatorTasksApiGetOperatorTaskReminders
     */
    readonly isDeleted?: boolean

    /**
     * 
     * @type {string}
     * @memberof OperatorTasksApiGetOperatorTaskReminders
     */
    readonly apiVersion?: string
}

/**
 * Request parameters for getOperatorTaskSummary operation in OperatorTasksApi.
 * @export
 * @interface OperatorTasksApiGetOperatorTaskSummaryRequest
 */
export interface OperatorTasksApiGetOperatorTaskSummaryRequest {
    /**
     * 
     * @type {string}
     * @memberof OperatorTasksApiGetOperatorTaskSummary
     */
    readonly apiVersion?: string
}

/**
 * Request parameters for getOperatorTasks operation in OperatorTasksApi.
 * @export
 * @interface OperatorTasksApiGetOperatorTasksRequest
 */
export interface OperatorTasksApiGetOperatorTasksRequest {
    /**
     * Дата ближайшего напоминания: начало периода
     * @type {string}
     * @memberof OperatorTasksApiGetOperatorTasks
     */
    readonly nextReminderFromUtc?: string

    /**
     * Дата ближайшего напоминания: конец периода
     * @type {string}
     * @memberof OperatorTasksApiGetOperatorTasks
     */
    readonly nextReminderToUtc?: string

    /**
     * Режим просмотра
     * @type {ApiOperatorTaskView}
     * @memberof OperatorTasksApiGetOperatorTasks
     */
    readonly view?: ApiOperatorTaskView

    /**
     * Типы задач
     * @type {Array<ApiOperatorTaskType>}
     * @memberof OperatorTasksApiGetOperatorTasks
     */
    readonly types?: Array<ApiOperatorTaskType>

    /**
     * Начало диапазона сроков выполнения
     * @type {string}
     * @memberof OperatorTasksApiGetOperatorTasks
     */
    readonly dueFromUtc?: string

    /**
     * Конец диапазона сроков выполнения
     * @type {string}
     * @memberof OperatorTasksApiGetOperatorTasks
     */
    readonly dueToUtc?: string

    /**
     * Идентификатор связанного заказа
     * @type {string}
     * @memberof OperatorTasksApiGetOperatorTasks
     */
    readonly orderId?: string

    /**
     * Идентификатор чата поддержки
     * @type {string}
     * @memberof OperatorTasksApiGetOperatorTasks
     */
    readonly chatId?: string

    /**
     * Идентификатор ответственного сотрудника
     * @type {string}
     * @memberof OperatorTasksApiGetOperatorTasks
     */
    readonly assigneeId?: string

    /**
     * Размер страницы
     * @type {number}
     * @memberof OperatorTasksApiGetOperatorTasks
     */
    readonly takeCount?: number

    /**
     * Строка для поиска
     * @type {string}
     * @memberof OperatorTasksApiGetOperatorTasks
     */
    readonly searchQuery?: string

    /**
     * Кол-во пропущенных записей
     * @type {number}
     * @memberof OperatorTasksApiGetOperatorTasks
     */
    readonly skipCount?: number

    /**
     * Сортировка по возрастанию
     * @type {boolean}
     * @memberof OperatorTasksApiGetOperatorTasks
     */
    readonly ascending?: boolean

    /**
     * Поле для сортировки
     * @type {string}
     * @memberof OperatorTasksApiGetOperatorTasks
     */
    readonly ordering?: string

    /**
     * Удалённые записи
     * @type {boolean}
     * @memberof OperatorTasksApiGetOperatorTasks
     */
    readonly isDeleted?: boolean

    /**
     * 
     * @type {string}
     * @memberof OperatorTasksApiGetOperatorTasks
     */
    readonly apiVersion?: string
}

/**
 * Request parameters for previewOperatorTaskReminders operation in OperatorTasksApi.
 * @export
 * @interface OperatorTasksApiPreviewOperatorTaskRemindersRequest
 */
export interface OperatorTasksApiPreviewOperatorTaskRemindersRequest {
    /**
     * Тип задачи
     * @type {ApiOperatorTaskType}
     * @memberof OperatorTasksApiPreviewOperatorTaskReminders
     */
    readonly type?: ApiOperatorTaskType

    /**
     * Срок выполнения
     * @type {string}
     * @memberof OperatorTasksApiPreviewOperatorTaskReminders
     */
    readonly dueAtUtc?: string

    /**
     * Идентификатор задачи
     * @type {string}
     * @memberof OperatorTasksApiPreviewOperatorTaskReminders
     */
    readonly operatorTaskId?: string

    /**
     * Версия задачи
     * @type {string}
     * @memberof OperatorTasksApiPreviewOperatorTaskReminders
     */
    readonly version?: string

    /**
     * Напоминание при наступлении срока задачи
     * @type {boolean}
     * @memberof OperatorTasksApiPreviewOperatorTaskReminders
     */
    readonly atDeadline?: boolean

    /**
     * Первый день ежедневных напоминаний
     * @type {string}
     * @memberof OperatorTasksApiPreviewOperatorTaskReminders
     */
    readonly dailyStartDate?: string

    /**
     * Московское время ежедневного напоминания
     * @type {string}
     * @memberof OperatorTasksApiPreviewOperatorTaskReminders
     */
    readonly dailyTime?: string

    /**
     * Способ напоминания перед сроком задачи
     * @type {ApiOperatorTaskBeforeDeadlineMode}
     * @memberof OperatorTasksApiPreviewOperatorTaskReminders
     */
    readonly beforeDeadlineMode?: ApiOperatorTaskBeforeDeadlineMode

    /**
     * Московское время напоминания перед сроком
     * @type {string}
     * @memberof OperatorTasksApiPreviewOperatorTaskReminders
     */
    readonly beforeDeadlineTime?: string

    /**
     * Интервал до срока в минутах
     * @type {number}
     * @memberof OperatorTasksApiPreviewOperatorTaskReminders
     */
    readonly beforeDeadlineOffsetMinutes?: number

    /**
     * Периодичность напоминаний о просрочке
     * @type {ApiOperatorTaskOverdueMode}
     * @memberof OperatorTasksApiPreviewOperatorTaskReminders
     */
    readonly overdueMode?: ApiOperatorTaskOverdueMode

    /**
     * Интервал повторов при просрочке в часах
     * @type {number}
     * @memberof OperatorTasksApiPreviewOperatorTaskReminders
     */
    readonly overdueIntervalHours?: number

    /**
     * Московское время повторного напоминания о просрочке
     * @type {string}
     * @memberof OperatorTasksApiPreviewOperatorTaskReminders
     */
    readonly overdueTime?: string

    /**
     * 
     * @type {string}
     * @memberof OperatorTasksApiPreviewOperatorTaskReminders
     */
    readonly apiVersion?: string
}

/**
 * Request parameters for reopenOperatorTask operation in OperatorTasksApi.
 * @export
 * @interface OperatorTasksApiReopenOperatorTaskRequest
 */
export interface OperatorTasksApiReopenOperatorTaskRequest {
    /**
     * 
     * @type {string}
     * @memberof OperatorTasksApiReopenOperatorTask
     */
    readonly id: string

    /**
     * 
     * @type {string}
     * @memberof OperatorTasksApiReopenOperatorTask
     */
    readonly apiVersion?: string

    /**
     * 
     * @type {ChangeOperatorTaskStatusRequest}
     * @memberof OperatorTasksApiReopenOperatorTask
     */
    readonly changeOperatorTaskStatusRequest?: ChangeOperatorTaskStatusRequest
}

/**
 * Request parameters for updateOperatorTask operation in OperatorTasksApi.
 * @export
 * @interface OperatorTasksApiUpdateOperatorTaskRequest
 */
export interface OperatorTasksApiUpdateOperatorTaskRequest {
    /**
     * 
     * @type {string}
     * @memberof OperatorTasksApiUpdateOperatorTask
     */
    readonly id: string

    /**
     * 
     * @type {string}
     * @memberof OperatorTasksApiUpdateOperatorTask
     */
    readonly apiVersion?: string

    /**
     * 
     * @type {UpdateOperatorTaskRequest}
     * @memberof OperatorTasksApiUpdateOperatorTask
     */
    readonly updateOperatorTaskRequest?: UpdateOperatorTaskRequest
}

/**
 * OperatorTasksApi - object-oriented interface
 * @export
 * @class OperatorTasksApi
 * @extends {BaseAPI}
 */
export class OperatorTasksApi extends BaseAPI {
    /**
     * 
     * @summary Отметить выполнение задачи
     * @param {OperatorTasksApiCompleteOperatorTaskRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OperatorTasksApi
     */
    public completeOperatorTask(requestParameters: OperatorTasksApiCompleteOperatorTaskRequest, options?: RawAxiosRequestConfig) {
        return OperatorTasksApiFp(this.configuration).completeOperatorTask(requestParameters.id, requestParameters.apiVersion, requestParameters.changeOperatorTaskStatusRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Создать общую задачу операторов
     * @param {OperatorTasksApiCreateOperatorTaskRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OperatorTasksApi
     */
    public createOperatorTask(requestParameters: OperatorTasksApiCreateOperatorTaskRequest = {}, options?: RawAxiosRequestConfig) {
        return OperatorTasksApiFp(this.configuration).createOperatorTask(requestParameters.apiVersion, requestParameters.createOperatorTaskRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Получить карточку задачи
     * @param {OperatorTasksApiGetOperatorTaskRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OperatorTasksApi
     */
    public getOperatorTask(requestParameters: OperatorTasksApiGetOperatorTaskRequest, options?: RawAxiosRequestConfig) {
        return OperatorTasksApiFp(this.configuration).getOperatorTask(requestParameters.id, requestParameters.apiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Получить сотрудников для назначения ответственными
     * @param {OperatorTasksApiGetOperatorTaskAssigneesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OperatorTasksApi
     */
    public getOperatorTaskAssignees(requestParameters: OperatorTasksApiGetOperatorTaskAssigneesRequest = {}, options?: RawAxiosRequestConfig) {
        return OperatorTasksApiFp(this.configuration).getOperatorTaskAssignees(requestParameters.takeCount, requestParameters.searchQuery, requestParameters.skipCount, requestParameters.ascending, requestParameters.ordering, requestParameters.isDeleted, requestParameters.apiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Получить задачи, требующие внимания
     * @param {OperatorTasksApiGetOperatorTaskAttentionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OperatorTasksApi
     */
    public getOperatorTaskAttention(requestParameters: OperatorTasksApiGetOperatorTaskAttentionRequest = {}, options?: RawAxiosRequestConfig) {
        return OperatorTasksApiFp(this.configuration).getOperatorTaskAttention(requestParameters.operatorTaskId, requestParameters.fromUtc, requestParameters.toUtc, requestParameters.takeCount, requestParameters.searchQuery, requestParameters.skipCount, requestParameters.ascending, requestParameters.ordering, requestParameters.isDeleted, requestParameters.apiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Получить задачи календарного интервала
     * @param {OperatorTasksApiGetOperatorTaskCalendarRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OperatorTasksApi
     */
    public getOperatorTaskCalendar(requestParameters: OperatorTasksApiGetOperatorTaskCalendarRequest = {}, options?: RawAxiosRequestConfig) {
        return OperatorTasksApiFp(this.configuration).getOperatorTaskCalendar(requestParameters.fromUtc, requestParameters.toUtc, requestParameters.takeCount, requestParameters.nextReminderFromUtc, requestParameters.nextReminderToUtc, requestParameters.view, requestParameters.types, requestParameters.dueFromUtc, requestParameters.dueToUtc, requestParameters.orderId, requestParameters.chatId, requestParameters.assigneeId, requestParameters.searchQuery, requestParameters.skipCount, requestParameters.ascending, requestParameters.ordering, requestParameters.isDeleted, requestParameters.apiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Получить историю изменений задачи
     * @param {OperatorTasksApiGetOperatorTaskHistoryRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OperatorTasksApi
     */
    public getOperatorTaskHistory(requestParameters: OperatorTasksApiGetOperatorTaskHistoryRequest, options?: RawAxiosRequestConfig) {
        return OperatorTasksApiFp(this.configuration).getOperatorTaskHistory(requestParameters.id, requestParameters.operatorTaskId, requestParameters.fromUtc, requestParameters.toUtc, requestParameters.takeCount, requestParameters.searchQuery, requestParameters.skipCount, requestParameters.ascending, requestParameters.ordering, requestParameters.isDeleted, requestParameters.apiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Получить ограничения и настройки формы задачи
     * @param {OperatorTasksApiGetOperatorTaskOptionsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OperatorTasksApi
     */
    public getOperatorTaskOptions(requestParameters: OperatorTasksApiGetOperatorTaskOptionsRequest = {}, options?: RawAxiosRequestConfig) {
        return OperatorTasksApiFp(this.configuration).getOperatorTaskOptions(requestParameters.apiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Найти чаты для привязки к задаче
     * @param {OperatorTasksApiGetOperatorTaskRelatedChatsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OperatorTasksApi
     */
    public getOperatorTaskRelatedChats(requestParameters: OperatorTasksApiGetOperatorTaskRelatedChatsRequest = {}, options?: RawAxiosRequestConfig) {
        return OperatorTasksApiFp(this.configuration).getOperatorTaskRelatedChats(requestParameters.chatId, requestParameters.takeCount, requestParameters.searchQuery, requestParameters.skipCount, requestParameters.ascending, requestParameters.ordering, requestParameters.isDeleted, requestParameters.apiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Найти заказы для привязки к задаче
     * @param {OperatorTasksApiGetOperatorTaskRelatedOrdersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OperatorTasksApi
     */
    public getOperatorTaskRelatedOrders(requestParameters: OperatorTasksApiGetOperatorTaskRelatedOrdersRequest = {}, options?: RawAxiosRequestConfig) {
        return OperatorTasksApiFp(this.configuration).getOperatorTaskRelatedOrders(requestParameters.chatId, requestParameters.takeCount, requestParameters.searchQuery, requestParameters.skipCount, requestParameters.ascending, requestParameters.ordering, requestParameters.isDeleted, requestParameters.apiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Получить историю напоминаний задач
     * @param {OperatorTasksApiGetOperatorTaskRemindersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OperatorTasksApi
     */
    public getOperatorTaskReminders(requestParameters: OperatorTasksApiGetOperatorTaskRemindersRequest = {}, options?: RawAxiosRequestConfig) {
        return OperatorTasksApiFp(this.configuration).getOperatorTaskReminders(requestParameters.operatorTaskId, requestParameters.fromUtc, requestParameters.toUtc, requestParameters.takeCount, requestParameters.searchQuery, requestParameters.skipCount, requestParameters.ascending, requestParameters.ordering, requestParameters.isDeleted, requestParameters.apiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Получить сводку задач операторов
     * @param {OperatorTasksApiGetOperatorTaskSummaryRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OperatorTasksApi
     */
    public getOperatorTaskSummary(requestParameters: OperatorTasksApiGetOperatorTaskSummaryRequest = {}, options?: RawAxiosRequestConfig) {
        return OperatorTasksApiFp(this.configuration).getOperatorTaskSummary(requestParameters.apiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Получить общую очередь задач операторов
     * @param {OperatorTasksApiGetOperatorTasksRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OperatorTasksApi
     */
    public getOperatorTasks(requestParameters: OperatorTasksApiGetOperatorTasksRequest = {}, options?: RawAxiosRequestConfig) {
        return OperatorTasksApiFp(this.configuration).getOperatorTasks(requestParameters.nextReminderFromUtc, requestParameters.nextReminderToUtc, requestParameters.view, requestParameters.types, requestParameters.dueFromUtc, requestParameters.dueToUtc, requestParameters.orderId, requestParameters.chatId, requestParameters.assigneeId, requestParameters.takeCount, requestParameters.searchQuery, requestParameters.skipCount, requestParameters.ascending, requestParameters.ordering, requestParameters.isDeleted, requestParameters.apiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Рассчитать предварительное расписание напоминаний
     * @param {OperatorTasksApiPreviewOperatorTaskRemindersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OperatorTasksApi
     */
    public previewOperatorTaskReminders(requestParameters: OperatorTasksApiPreviewOperatorTaskRemindersRequest = {}, options?: RawAxiosRequestConfig) {
        return OperatorTasksApiFp(this.configuration).previewOperatorTaskReminders(requestParameters.type, requestParameters.dueAtUtc, requestParameters.operatorTaskId, requestParameters.version, requestParameters.atDeadline, requestParameters.dailyStartDate, requestParameters.dailyTime, requestParameters.beforeDeadlineMode, requestParameters.beforeDeadlineTime, requestParameters.beforeDeadlineOffsetMinutes, requestParameters.overdueMode, requestParameters.overdueIntervalHours, requestParameters.overdueTime, requestParameters.apiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Вернуть задачу в работу
     * @param {OperatorTasksApiReopenOperatorTaskRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OperatorTasksApi
     */
    public reopenOperatorTask(requestParameters: OperatorTasksApiReopenOperatorTaskRequest, options?: RawAxiosRequestConfig) {
        return OperatorTasksApiFp(this.configuration).reopenOperatorTask(requestParameters.id, requestParameters.apiVersion, requestParameters.changeOperatorTaskStatusRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Изменить общую задачу операторов
     * @param {OperatorTasksApiUpdateOperatorTaskRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OperatorTasksApi
     */
    public updateOperatorTask(requestParameters: OperatorTasksApiUpdateOperatorTaskRequest, options?: RawAxiosRequestConfig) {
        return OperatorTasksApiFp(this.configuration).updateOperatorTask(requestParameters.id, requestParameters.apiVersion, requestParameters.updateOperatorTaskRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * OrderApi - axios parameter creator
 * @export
 */
export const OrderApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Принять заказ исполнителем и отправить запрос на согласование клиенту
         * @param {string} [apiVersion] 
         * @param {AcceptOrderRequest} [acceptOrderRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        acceptOrder: async (apiVersion?: string, acceptOrderRequest?: AcceptOrderRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/orders/accept-order`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(acceptOrderRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Добавить или удалить продукт из заказа
         * @param {string} [apiVersion] 
         * @param {AddOrRemoveOrderProductRequest} [addOrRemoveOrderProductRequest] Модель запроса по добавлению или удалению продукта заказа
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addOrRemoveOrderProduct: async (apiVersion?: string, addOrRemoveOrderProductRequest?: AddOrRemoveOrderProductRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/orders/add-or-remove-order-product`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(addOrRemoveOrderProductRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Добавить или удалить питомца из заказа
         * @param {string} [apiVersion] 
         * @param {AddOrRemovePetRequest} [addOrRemovePetRequest] Модель запроса по назначению питомца заказу
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addOrRemovePet: async (apiVersion?: string, addOrRemovePetRequest?: AddOrRemovePetRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/orders/add-or-remove-pet`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(addOrRemovePetRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Утвердить исполнителя заказа от имени администратора
         * @param {string} [apiVersion] 
         * @param {ApproveOrderExecutorRequest} [approveOrderExecutorRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1OrdersApproveOrderExecutorByAdminPost: async (apiVersion?: string, approveOrderExecutorRequest?: ApproveOrderExecutorRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/orders/approve-order-executor-by-admin`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(approveOrderExecutorRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Получить завершенные заказы, по которым клиент еще не оставил отзыв
         * @param {string} clientId 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1OrdersGetCompletedOrdersWithoutReviewGet: async (clientId: string, apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'clientId' is not null or undefined
            assertParamExists('apiV1OrdersGetCompletedOrdersWithoutReviewGet', 'clientId', clientId)
            const localVarPath = `/api/v1/orders/get-completed-orders-without-review`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (clientId !== undefined) {
                localVarQueryParameter['clientId'] = clientId;
            }


    
            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Снять исполнителя с заказа оператором
         * @param {string} [apiVersion] 
         * @param {RemoveOrderExecutorRequest} [removeOrderExecutorRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1OrdersRemoveExecutorByAdminPost: async (apiVersion?: string, removeOrderExecutorRequest?: RemoveOrderExecutorRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/orders/remove-executor-by-admin`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(removeOrderExecutorRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Установить периоды планирования заказа
         * @param {string} [apiVersion] 
         * @param {SetOrderSchedulePeriodsRequest} [setOrderSchedulePeriodsRequest] Модель запроса
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1OrdersSetSchedulePeriodsPost: async (apiVersion?: string, setOrderSchedulePeriodsRequest?: SetOrderSchedulePeriodsRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/orders/set-schedule-periods`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(setOrderSchedulePeriodsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Утвердить исполнителя заказа
         * @param {string} orderId 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        approveOrderExecutor: async (orderId: string, apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orderId' is not null or undefined
            assertParamExists('approveOrderExecutor', 'orderId', orderId)
            const localVarPath = `/api/v1/orders/approve-order-executor/{orderId}`
                .replace(`{${"orderId"}}`, encodeURIComponent(String(orderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Назначить исполнителя на заказ
         * @param {string} [apiVersion] 
         * @param {AssignExecutorToOrderRequest} [assignExecutorToOrderRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignExecutorToOrder: async (apiVersion?: string, assignExecutorToOrderRequest?: AssignExecutorToOrderRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/orders/assign-executor`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(assignExecutorToOrderRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Отказаться от заказа
         * @param {string} [apiVersion] 
         * @param {CancelOrderRequest} [cancelOrderRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelOrder: async (apiVersion?: string, cancelOrderRequest?: CancelOrderRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/orders/cancel-order`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(cancelOrderRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Завершить выполнение заказа
         * @param {string} [apiVersion] 
         * @param {CompleteOrderRequest} [completeOrderRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        completeOrder: async (apiVersion?: string, completeOrderRequest?: CompleteOrderRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/orders/complete-order`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(completeOrderRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Создать заказ оператором
         * @param {string} [apiVersion] 
         * @param {CreateOrderRequest} [createOrderRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOrder: async (apiVersion?: string, createOrderRequest?: CreateOrderRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/orders/create-order`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createOrderRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Получить данные заказа
         * @param {string} id 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getById: async (id: string, apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getById', 'id', id)
            const localVarPath = `/api/v1/orders/get-by-id/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Получить расчет по вознаграждению исполнителя
         * @param {string} [orderId] Идентификатор заказа
         * @param {string} [executorId] Идентификатор исполнителя
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getExecutorReward: async (orderId?: string, executorId?: string, apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/orders/get-executor-reward`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (orderId !== undefined) {
                localVarQueryParameter['OrderId'] = orderId;
            }

            if (executorId !== undefined) {
                localVarQueryParameter['ExecutorId'] = executorId;
            }


    
            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Получить данные заказа или создать новый
         * @param {string} [apiVersion] 
         * @param {GetOrCreateOrderRequest} [getOrCreateOrderRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrCreateDraftOrder: async (apiVersion?: string, getOrCreateOrderRequest?: GetOrCreateOrderRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/orders/get-or-create-order`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(getOrCreateOrderRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Получить отчет о проделанном заказе
         * @param {string} orderId 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrderReport: async (orderId: string, apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orderId' is not null or undefined
            assertParamExists('getOrderReport', 'orderId', orderId)
            const localVarPath = `/api/v1/orders/get-order-report/{orderId}`
                .replace(`{${"orderId"}}`, encodeURIComponent(String(orderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Получить заказы
         * @param {string} [apiVersion] 
         * @param {GetOrdersRequest} [getOrdersRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrders: async (apiVersion?: string, getOrdersRequest?: GetOrdersRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/orders/get-orders`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(getOrdersRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Предварительная обработка отмены заказа
         * @param {string} orderId 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        preprocessingCancelOrder: async (orderId: string, apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orderId' is not null or undefined
            assertParamExists('preprocessingCancelOrder', 'orderId', orderId)
            const localVarPath = `/api/v1/orders/preprocessing-cancel-order/{orderId}`
                .replace(`{${"orderId"}}`, encodeURIComponent(String(orderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Предварительная обработка завершения выполнения заказа
         * @param {string} orderId 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        preprocessingStopExecuteOrder: async (orderId: string, apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orderId' is not null or undefined
            assertParamExists('preprocessingStopExecuteOrder', 'orderId', orderId)
            const localVarPath = `/api/v1/orders/preprocessing-stop-execute-order/{orderId}`
                .replace(`{${"orderId"}}`, encodeURIComponent(String(orderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Отказаться от исполнителя
         * @param {string} [apiVersion] 
         * @param {RefuseFromExecutorRequest} [refuseFromExecutorRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        refuseFromExecutor: async (apiVersion?: string, refuseFromExecutorRequest?: RefuseFromExecutorRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/orders/refuse-from-executor`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(refuseFromExecutorRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Повторить существующий заказ
         * @param {string} orderId 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        repeatOrder: async (orderId: string, apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orderId' is not null or undefined
            assertParamExists('repeatOrder', 'orderId', orderId)
            const localVarPath = `/api/v1/orders/{orderId}/repeat`
                .replace(`{${"orderId"}}`, encodeURIComponent(String(orderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Запланировать заказ клиентом
         * @param {string} orderId 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        scheduleOrder: async (orderId: string, apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orderId' is not null or undefined
            assertParamExists('scheduleOrder', 'orderId', orderId)
            const localVarPath = `/api/v1/orders/schedule-order/{orderId}`
                .replace(`{${"orderId"}}`, encodeURIComponent(String(orderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Запланировать заказ администратором
         * @param {string} [apiVersion] 
         * @param {ScheduleOrderRequest} [scheduleOrderRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        scheduleOrderByAdmin: async (apiVersion?: string, scheduleOrderRequest?: ScheduleOrderRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/orders/schedule-order-by-admin`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(scheduleOrderRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Установить адрес заказа
         * @param {string} [apiVersion] 
         * @param {SetAddressRequest} [setAddressRequest] Модель запроса по назначению адреса заказа
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setAddress: async (apiVersion?: string, setAddressRequest?: SetAddressRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/orders/set-address`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(setAddressRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Установить детали заказа
         * @param {string} [apiVersion] 
         * @param {SetOrderDetailsRequest} [setOrderDetailsRequest] Модель запроса по назначению деталей заказа
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setOrderDetails: async (apiVersion?: string, setOrderDetailsRequest?: SetOrderDetailsRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/orders/set-order-details`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(setOrderDetailsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Начать выполнение заказа
         * @param {string} orderId 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        startExecuteOrder: async (orderId: string, apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orderId' is not null or undefined
            assertParamExists('startExecuteOrder', 'orderId', orderId)
            const localVarPath = `/api/v1/orders/start-execute-order/{orderId}`
                .replace(`{${"orderId"}}`, encodeURIComponent(String(orderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Начать выполнение заказа оператором
         * @param {string} orderId 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        startExecuteOrderByAdmin: async (orderId: string, apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orderId' is not null or undefined
            assertParamExists('startExecuteOrderByAdmin', 'orderId', orderId)
            const localVarPath = `/api/v1/orders/start-execute-order-by-admin/{orderId}`
                .replace(`{${"orderId"}}`, encodeURIComponent(String(orderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Отказаться от заказа исполнителем
         * @param {string} [apiVersion] 
         * @param {UnassignFromOrderRequest} [unassignFromOrderRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unassignFromOrder: async (apiVersion?: string, unassignFromOrderRequest?: UnassignFromOrderRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/orders/unassign`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(unassignFromOrderRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Обновить заказ оператором
         * @param {string} [apiVersion] 
         * @param {UpdateOrderRequest} [updateOrderRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOrder: async (apiVersion?: string, updateOrderRequest?: UpdateOrderRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/orders/update-order`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateOrderRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * OrderApi - functional programming interface
 * @export
 */
export const OrderApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = OrderApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Принять заказ исполнителем и отправить запрос на согласование клиенту
         * @param {string} [apiVersion] 
         * @param {AcceptOrderRequest} [acceptOrderRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async acceptOrder(apiVersion?: string, acceptOrderRequest?: AcceptOrderRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AcceptOrderResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.acceptOrder(apiVersion, acceptOrderRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrderApi.acceptOrder']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Добавить или удалить продукт из заказа
         * @param {string} [apiVersion] 
         * @param {AddOrRemoveOrderProductRequest} [addOrRemoveOrderProductRequest] Модель запроса по добавлению или удалению продукта заказа
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addOrRemoveOrderProduct(apiVersion?: string, addOrRemoveOrderProductRequest?: AddOrRemoveOrderProductRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrderResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addOrRemoveOrderProduct(apiVersion, addOrRemoveOrderProductRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrderApi.addOrRemoveOrderProduct']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Добавить или удалить питомца из заказа
         * @param {string} [apiVersion] 
         * @param {AddOrRemovePetRequest} [addOrRemovePetRequest] Модель запроса по назначению питомца заказу
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addOrRemovePet(apiVersion?: string, addOrRemovePetRequest?: AddOrRemovePetRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrderResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addOrRemovePet(apiVersion, addOrRemovePetRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrderApi.addOrRemovePet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Утвердить исполнителя заказа от имени администратора
         * @param {string} [apiVersion] 
         * @param {ApproveOrderExecutorRequest} [approveOrderExecutorRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1OrdersApproveOrderExecutorByAdminPost(apiVersion?: string, approveOrderExecutorRequest?: ApproveOrderExecutorRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1OrdersApproveOrderExecutorByAdminPost(apiVersion, approveOrderExecutorRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrderApi.apiV1OrdersApproveOrderExecutorByAdminPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Получить завершенные заказы, по которым клиент еще не оставил отзыв
         * @param {string} clientId 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1OrdersGetCompletedOrdersWithoutReviewGet(clientId: string, apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<OrderReportResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1OrdersGetCompletedOrdersWithoutReviewGet(clientId, apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrderApi.apiV1OrdersGetCompletedOrdersWithoutReviewGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Снять исполнителя с заказа оператором
         * @param {string} [apiVersion] 
         * @param {RemoveOrderExecutorRequest} [removeOrderExecutorRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1OrdersRemoveExecutorByAdminPost(apiVersion?: string, removeOrderExecutorRequest?: RemoveOrderExecutorRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1OrdersRemoveExecutorByAdminPost(apiVersion, removeOrderExecutorRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrderApi.apiV1OrdersRemoveExecutorByAdminPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Установить периоды планирования заказа
         * @param {string} [apiVersion] 
         * @param {SetOrderSchedulePeriodsRequest} [setOrderSchedulePeriodsRequest] Модель запроса
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1OrdersSetSchedulePeriodsPost(apiVersion?: string, setOrderSchedulePeriodsRequest?: SetOrderSchedulePeriodsRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SetOrderSchedulePeriodsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1OrdersSetSchedulePeriodsPost(apiVersion, setOrderSchedulePeriodsRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrderApi.apiV1OrdersSetSchedulePeriodsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Утвердить исполнителя заказа
         * @param {string} orderId 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async approveOrderExecutor(orderId: string, apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.approveOrderExecutor(orderId, apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrderApi.approveOrderExecutor']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Назначить исполнителя на заказ
         * @param {string} [apiVersion] 
         * @param {AssignExecutorToOrderRequest} [assignExecutorToOrderRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async assignExecutorToOrder(apiVersion?: string, assignExecutorToOrderRequest?: AssignExecutorToOrderRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.assignExecutorToOrder(apiVersion, assignExecutorToOrderRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrderApi.assignExecutorToOrder']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Отказаться от заказа
         * @param {string} [apiVersion] 
         * @param {CancelOrderRequest} [cancelOrderRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cancelOrder(apiVersion?: string, cancelOrderRequest?: CancelOrderRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cancelOrder(apiVersion, cancelOrderRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrderApi.cancelOrder']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Завершить выполнение заказа
         * @param {string} [apiVersion] 
         * @param {CompleteOrderRequest} [completeOrderRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async completeOrder(apiVersion?: string, completeOrderRequest?: CompleteOrderRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.completeOrder(apiVersion, completeOrderRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrderApi.completeOrder']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Создать заказ оператором
         * @param {string} [apiVersion] 
         * @param {CreateOrderRequest} [createOrderRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createOrder(apiVersion?: string, createOrderRequest?: CreateOrderRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrderResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createOrder(apiVersion, createOrderRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrderApi.createOrder']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Получить данные заказа
         * @param {string} id 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getById(id: string, apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrderResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getById(id, apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrderApi.getById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Получить расчет по вознаграждению исполнителя
         * @param {string} [orderId] Идентификатор заказа
         * @param {string} [executorId] Идентификатор исполнителя
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getExecutorReward(orderId?: string, executorId?: string, apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ExecutorRewardResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getExecutorReward(orderId, executorId, apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrderApi.getExecutorReward']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Получить данные заказа или создать новый
         * @param {string} [apiVersion] 
         * @param {GetOrCreateOrderRequest} [getOrCreateOrderRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOrCreateDraftOrder(apiVersion?: string, getOrCreateOrderRequest?: GetOrCreateOrderRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrderResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOrCreateDraftOrder(apiVersion, getOrCreateOrderRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrderApi.getOrCreateDraftOrder']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Получить отчет о проделанном заказе
         * @param {string} orderId 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOrderReport(orderId: string, apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrderReportResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOrderReport(orderId, apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrderApi.getOrderReport']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Получить заказы
         * @param {string} [apiVersion] 
         * @param {GetOrdersRequest} [getOrdersRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOrders(apiVersion?: string, getOrdersRequest?: GetOrdersRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetOrdersResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOrders(apiVersion, getOrdersRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrderApi.getOrders']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Предварительная обработка отмены заказа
         * @param {string} orderId 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async preprocessingCancelOrder(orderId: string, apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PreprocessingCancelResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.preprocessingCancelOrder(orderId, apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrderApi.preprocessingCancelOrder']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Предварительная обработка завершения выполнения заказа
         * @param {string} orderId 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async preprocessingStopExecuteOrder(orderId: string, apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PreprocessingStopExecuteOrderResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.preprocessingStopExecuteOrder(orderId, apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrderApi.preprocessingStopExecuteOrder']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Отказаться от исполнителя
         * @param {string} [apiVersion] 
         * @param {RefuseFromExecutorRequest} [refuseFromExecutorRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async refuseFromExecutor(apiVersion?: string, refuseFromExecutorRequest?: RefuseFromExecutorRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.refuseFromExecutor(apiVersion, refuseFromExecutorRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrderApi.refuseFromExecutor']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Повторить существующий заказ
         * @param {string} orderId 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async repeatOrder(orderId: string, apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrderResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.repeatOrder(orderId, apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrderApi.repeatOrder']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Запланировать заказ клиентом
         * @param {string} orderId 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async scheduleOrder(orderId: string, apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.scheduleOrder(orderId, apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrderApi.scheduleOrder']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Запланировать заказ администратором
         * @param {string} [apiVersion] 
         * @param {ScheduleOrderRequest} [scheduleOrderRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async scheduleOrderByAdmin(apiVersion?: string, scheduleOrderRequest?: ScheduleOrderRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.scheduleOrderByAdmin(apiVersion, scheduleOrderRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrderApi.scheduleOrderByAdmin']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Установить адрес заказа
         * @param {string} [apiVersion] 
         * @param {SetAddressRequest} [setAddressRequest] Модель запроса по назначению адреса заказа
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setAddress(apiVersion?: string, setAddressRequest?: SetAddressRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrderResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.setAddress(apiVersion, setAddressRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrderApi.setAddress']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Установить детали заказа
         * @param {string} [apiVersion] 
         * @param {SetOrderDetailsRequest} [setOrderDetailsRequest] Модель запроса по назначению деталей заказа
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setOrderDetails(apiVersion?: string, setOrderDetailsRequest?: SetOrderDetailsRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrderResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.setOrderDetails(apiVersion, setOrderDetailsRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrderApi.setOrderDetails']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Начать выполнение заказа
         * @param {string} orderId 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async startExecuteOrder(orderId: string, apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.startExecuteOrder(orderId, apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrderApi.startExecuteOrder']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Начать выполнение заказа оператором
         * @param {string} orderId 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async startExecuteOrderByAdmin(orderId: string, apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.startExecuteOrderByAdmin(orderId, apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrderApi.startExecuteOrderByAdmin']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Отказаться от заказа исполнителем
         * @param {string} [apiVersion] 
         * @param {UnassignFromOrderRequest} [unassignFromOrderRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async unassignFromOrder(apiVersion?: string, unassignFromOrderRequest?: UnassignFromOrderRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.unassignFromOrder(apiVersion, unassignFromOrderRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrderApi.unassignFromOrder']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Обновить заказ оператором
         * @param {string} [apiVersion] 
         * @param {UpdateOrderRequest} [updateOrderRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateOrder(apiVersion?: string, updateOrderRequest?: UpdateOrderRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrderResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateOrder(apiVersion, updateOrderRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrderApi.updateOrder']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * OrderApi - factory interface
 * @export
 */
export const OrderApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = OrderApiFp(configuration)
    return {
        /**
         * 
         * @summary Принять заказ исполнителем и отправить запрос на согласование клиенту
         * @param {OrderApiAcceptOrderRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        acceptOrder(requestParameters: OrderApiAcceptOrderRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<AcceptOrderResponse> {
            return localVarFp.acceptOrder(requestParameters.apiVersion, requestParameters.acceptOrderRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Добавить или удалить продукт из заказа
         * @param {OrderApiAddOrRemoveOrderProductRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addOrRemoveOrderProduct(requestParameters: OrderApiAddOrRemoveOrderProductRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<OrderResponse> {
            return localVarFp.addOrRemoveOrderProduct(requestParameters.apiVersion, requestParameters.addOrRemoveOrderProductRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Добавить или удалить питомца из заказа
         * @param {OrderApiAddOrRemovePetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addOrRemovePet(requestParameters: OrderApiAddOrRemovePetRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<OrderResponse> {
            return localVarFp.addOrRemovePet(requestParameters.apiVersion, requestParameters.addOrRemovePetRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Утвердить исполнителя заказа от имени администратора
         * @param {OrderApiApiV1OrdersApproveOrderExecutorByAdminPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1OrdersApproveOrderExecutorByAdminPost(requestParameters: OrderApiApiV1OrdersApproveOrderExecutorByAdminPostRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiV1OrdersApproveOrderExecutorByAdminPost(requestParameters.apiVersion, requestParameters.approveOrderExecutorRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Получить завершенные заказы, по которым клиент еще не оставил отзыв
         * @param {OrderApiApiV1OrdersGetCompletedOrdersWithoutReviewGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1OrdersGetCompletedOrdersWithoutReviewGet(requestParameters: OrderApiApiV1OrdersGetCompletedOrdersWithoutReviewGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<OrderReportResponse>> {
            return localVarFp.apiV1OrdersGetCompletedOrdersWithoutReviewGet(requestParameters.clientId, requestParameters.apiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Снять исполнителя с заказа оператором
         * @param {OrderApiApiV1OrdersRemoveExecutorByAdminPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1OrdersRemoveExecutorByAdminPost(requestParameters: OrderApiApiV1OrdersRemoveExecutorByAdminPostRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiV1OrdersRemoveExecutorByAdminPost(requestParameters.apiVersion, requestParameters.removeOrderExecutorRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Установить периоды планирования заказа
         * @param {OrderApiApiV1OrdersSetSchedulePeriodsPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1OrdersSetSchedulePeriodsPost(requestParameters: OrderApiApiV1OrdersSetSchedulePeriodsPostRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<SetOrderSchedulePeriodsResponse> {
            return localVarFp.apiV1OrdersSetSchedulePeriodsPost(requestParameters.apiVersion, requestParameters.setOrderSchedulePeriodsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Утвердить исполнителя заказа
         * @param {OrderApiApproveOrderExecutorRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        approveOrderExecutor(requestParameters: OrderApiApproveOrderExecutorRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.approveOrderExecutor(requestParameters.orderId, requestParameters.apiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Назначить исполнителя на заказ
         * @param {OrderApiAssignExecutorToOrderRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignExecutorToOrder(requestParameters: OrderApiAssignExecutorToOrderRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.assignExecutorToOrder(requestParameters.apiVersion, requestParameters.assignExecutorToOrderRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Отказаться от заказа
         * @param {OrderApiCancelOrderRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelOrder(requestParameters: OrderApiCancelOrderRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.cancelOrder(requestParameters.apiVersion, requestParameters.cancelOrderRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Завершить выполнение заказа
         * @param {OrderApiCompleteOrderRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        completeOrder(requestParameters: OrderApiCompleteOrderRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.completeOrder(requestParameters.apiVersion, requestParameters.completeOrderRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Создать заказ оператором
         * @param {OrderApiCreateOrderRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOrder(requestParameters: OrderApiCreateOrderRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<OrderResponse> {
            return localVarFp.createOrder(requestParameters.apiVersion, requestParameters.createOrderRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Получить данные заказа
         * @param {OrderApiGetByIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getById(requestParameters: OrderApiGetByIdRequest, options?: RawAxiosRequestConfig): AxiosPromise<OrderResponse> {
            return localVarFp.getById(requestParameters.id, requestParameters.apiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Получить расчет по вознаграждению исполнителя
         * @param {OrderApiGetExecutorRewardRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getExecutorReward(requestParameters: OrderApiGetExecutorRewardRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<ExecutorRewardResponse> {
            return localVarFp.getExecutorReward(requestParameters.orderId, requestParameters.executorId, requestParameters.apiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Получить данные заказа или создать новый
         * @param {OrderApiGetOrCreateDraftOrderRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrCreateDraftOrder(requestParameters: OrderApiGetOrCreateDraftOrderRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<OrderResponse> {
            return localVarFp.getOrCreateDraftOrder(requestParameters.apiVersion, requestParameters.getOrCreateOrderRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Получить отчет о проделанном заказе
         * @param {OrderApiGetOrderReportRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrderReport(requestParameters: OrderApiGetOrderReportRequest, options?: RawAxiosRequestConfig): AxiosPromise<OrderReportResponse> {
            return localVarFp.getOrderReport(requestParameters.orderId, requestParameters.apiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Получить заказы
         * @param {OrderApiGetOrdersRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrders(requestParameters: OrderApiGetOrdersRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<GetOrdersResponse> {
            return localVarFp.getOrders(requestParameters.apiVersion, requestParameters.getOrdersRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Предварительная обработка отмены заказа
         * @param {OrderApiPreprocessingCancelOrderRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        preprocessingCancelOrder(requestParameters: OrderApiPreprocessingCancelOrderRequest, options?: RawAxiosRequestConfig): AxiosPromise<PreprocessingCancelResponse> {
            return localVarFp.preprocessingCancelOrder(requestParameters.orderId, requestParameters.apiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Предварительная обработка завершения выполнения заказа
         * @param {OrderApiPreprocessingStopExecuteOrderRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        preprocessingStopExecuteOrder(requestParameters: OrderApiPreprocessingStopExecuteOrderRequest, options?: RawAxiosRequestConfig): AxiosPromise<PreprocessingStopExecuteOrderResponse> {
            return localVarFp.preprocessingStopExecuteOrder(requestParameters.orderId, requestParameters.apiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Отказаться от исполнителя
         * @param {OrderApiRefuseFromExecutorRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        refuseFromExecutor(requestParameters: OrderApiRefuseFromExecutorRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.refuseFromExecutor(requestParameters.apiVersion, requestParameters.refuseFromExecutorRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Повторить существующий заказ
         * @param {OrderApiRepeatOrderRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        repeatOrder(requestParameters: OrderApiRepeatOrderRequest, options?: RawAxiosRequestConfig): AxiosPromise<OrderResponse> {
            return localVarFp.repeatOrder(requestParameters.orderId, requestParameters.apiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Запланировать заказ клиентом
         * @param {OrderApiScheduleOrderRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        scheduleOrder(requestParameters: OrderApiScheduleOrderRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.scheduleOrder(requestParameters.orderId, requestParameters.apiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Запланировать заказ администратором
         * @param {OrderApiScheduleOrderByAdminRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        scheduleOrderByAdmin(requestParameters: OrderApiScheduleOrderByAdminRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.scheduleOrderByAdmin(requestParameters.apiVersion, requestParameters.scheduleOrderRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Установить адрес заказа
         * @param {OrderApiSetAddressRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setAddress(requestParameters: OrderApiSetAddressRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<OrderResponse> {
            return localVarFp.setAddress(requestParameters.apiVersion, requestParameters.setAddressRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Установить детали заказа
         * @param {OrderApiSetOrderDetailsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setOrderDetails(requestParameters: OrderApiSetOrderDetailsRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<OrderResponse> {
            return localVarFp.setOrderDetails(requestParameters.apiVersion, requestParameters.setOrderDetailsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Начать выполнение заказа
         * @param {OrderApiStartExecuteOrderRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        startExecuteOrder(requestParameters: OrderApiStartExecuteOrderRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.startExecuteOrder(requestParameters.orderId, requestParameters.apiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Начать выполнение заказа оператором
         * @param {OrderApiStartExecuteOrderByAdminRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        startExecuteOrderByAdmin(requestParameters: OrderApiStartExecuteOrderByAdminRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.startExecuteOrderByAdmin(requestParameters.orderId, requestParameters.apiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Отказаться от заказа исполнителем
         * @param {OrderApiUnassignFromOrderRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unassignFromOrder(requestParameters: OrderApiUnassignFromOrderRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.unassignFromOrder(requestParameters.apiVersion, requestParameters.unassignFromOrderRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Обновить заказ оператором
         * @param {OrderApiUpdateOrderRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOrder(requestParameters: OrderApiUpdateOrderRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<OrderResponse> {
            return localVarFp.updateOrder(requestParameters.apiVersion, requestParameters.updateOrderRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for acceptOrder operation in OrderApi.
 * @export
 * @interface OrderApiAcceptOrderRequest
 */
export interface OrderApiAcceptOrderRequest {
    /**
     * 
     * @type {string}
     * @memberof OrderApiAcceptOrder
     */
    readonly apiVersion?: string

    /**
     * 
     * @type {AcceptOrderRequest}
     * @memberof OrderApiAcceptOrder
     */
    readonly acceptOrderRequest?: AcceptOrderRequest
}

/**
 * Request parameters for addOrRemoveOrderProduct operation in OrderApi.
 * @export
 * @interface OrderApiAddOrRemoveOrderProductRequest
 */
export interface OrderApiAddOrRemoveOrderProductRequest {
    /**
     * 
     * @type {string}
     * @memberof OrderApiAddOrRemoveOrderProduct
     */
    readonly apiVersion?: string

    /**
     * Модель запроса по добавлению или удалению продукта заказа
     * @type {AddOrRemoveOrderProductRequest}
     * @memberof OrderApiAddOrRemoveOrderProduct
     */
    readonly addOrRemoveOrderProductRequest?: AddOrRemoveOrderProductRequest
}

/**
 * Request parameters for addOrRemovePet operation in OrderApi.
 * @export
 * @interface OrderApiAddOrRemovePetRequest
 */
export interface OrderApiAddOrRemovePetRequest {
    /**
     * 
     * @type {string}
     * @memberof OrderApiAddOrRemovePet
     */
    readonly apiVersion?: string

    /**
     * Модель запроса по назначению питомца заказу
     * @type {AddOrRemovePetRequest}
     * @memberof OrderApiAddOrRemovePet
     */
    readonly addOrRemovePetRequest?: AddOrRemovePetRequest
}

/**
 * Request parameters for apiV1OrdersApproveOrderExecutorByAdminPost operation in OrderApi.
 * @export
 * @interface OrderApiApiV1OrdersApproveOrderExecutorByAdminPostRequest
 */
export interface OrderApiApiV1OrdersApproveOrderExecutorByAdminPostRequest {
    /**
     * 
     * @type {string}
     * @memberof OrderApiApiV1OrdersApproveOrderExecutorByAdminPost
     */
    readonly apiVersion?: string

    /**
     * 
     * @type {ApproveOrderExecutorRequest}
     * @memberof OrderApiApiV1OrdersApproveOrderExecutorByAdminPost
     */
    readonly approveOrderExecutorRequest?: ApproveOrderExecutorRequest
}

/**
 * Request parameters for apiV1OrdersGetCompletedOrdersWithoutReviewGet operation in OrderApi.
 * @export
 * @interface OrderApiApiV1OrdersGetCompletedOrdersWithoutReviewGetRequest
 */
export interface OrderApiApiV1OrdersGetCompletedOrdersWithoutReviewGetRequest {
    /**
     * 
     * @type {string}
     * @memberof OrderApiApiV1OrdersGetCompletedOrdersWithoutReviewGet
     */
    readonly clientId: string

    /**
     * 
     * @type {string}
     * @memberof OrderApiApiV1OrdersGetCompletedOrdersWithoutReviewGet
     */
    readonly apiVersion?: string
}

/**
 * Request parameters for apiV1OrdersRemoveExecutorByAdminPost operation in OrderApi.
 * @export
 * @interface OrderApiApiV1OrdersRemoveExecutorByAdminPostRequest
 */
export interface OrderApiApiV1OrdersRemoveExecutorByAdminPostRequest {
    /**
     * 
     * @type {string}
     * @memberof OrderApiApiV1OrdersRemoveExecutorByAdminPost
     */
    readonly apiVersion?: string

    /**
     * 
     * @type {RemoveOrderExecutorRequest}
     * @memberof OrderApiApiV1OrdersRemoveExecutorByAdminPost
     */
    readonly removeOrderExecutorRequest?: RemoveOrderExecutorRequest
}

/**
 * Request parameters for apiV1OrdersSetSchedulePeriodsPost operation in OrderApi.
 * @export
 * @interface OrderApiApiV1OrdersSetSchedulePeriodsPostRequest
 */
export interface OrderApiApiV1OrdersSetSchedulePeriodsPostRequest {
    /**
     * 
     * @type {string}
     * @memberof OrderApiApiV1OrdersSetSchedulePeriodsPost
     */
    readonly apiVersion?: string

    /**
     * Модель запроса
     * @type {SetOrderSchedulePeriodsRequest}
     * @memberof OrderApiApiV1OrdersSetSchedulePeriodsPost
     */
    readonly setOrderSchedulePeriodsRequest?: SetOrderSchedulePeriodsRequest
}

/**
 * Request parameters for approveOrderExecutor operation in OrderApi.
 * @export
 * @interface OrderApiApproveOrderExecutorRequest
 */
export interface OrderApiApproveOrderExecutorRequest {
    /**
     * 
     * @type {string}
     * @memberof OrderApiApproveOrderExecutor
     */
    readonly orderId: string

    /**
     * 
     * @type {string}
     * @memberof OrderApiApproveOrderExecutor
     */
    readonly apiVersion?: string
}

/**
 * Request parameters for assignExecutorToOrder operation in OrderApi.
 * @export
 * @interface OrderApiAssignExecutorToOrderRequest
 */
export interface OrderApiAssignExecutorToOrderRequest {
    /**
     * 
     * @type {string}
     * @memberof OrderApiAssignExecutorToOrder
     */
    readonly apiVersion?: string

    /**
     * 
     * @type {AssignExecutorToOrderRequest}
     * @memberof OrderApiAssignExecutorToOrder
     */
    readonly assignExecutorToOrderRequest?: AssignExecutorToOrderRequest
}

/**
 * Request parameters for cancelOrder operation in OrderApi.
 * @export
 * @interface OrderApiCancelOrderRequest
 */
export interface OrderApiCancelOrderRequest {
    /**
     * 
     * @type {string}
     * @memberof OrderApiCancelOrder
     */
    readonly apiVersion?: string

    /**
     * 
     * @type {CancelOrderRequest}
     * @memberof OrderApiCancelOrder
     */
    readonly cancelOrderRequest?: CancelOrderRequest
}

/**
 * Request parameters for completeOrder operation in OrderApi.
 * @export
 * @interface OrderApiCompleteOrderRequest
 */
export interface OrderApiCompleteOrderRequest {
    /**
     * 
     * @type {string}
     * @memberof OrderApiCompleteOrder
     */
    readonly apiVersion?: string

    /**
     * 
     * @type {CompleteOrderRequest}
     * @memberof OrderApiCompleteOrder
     */
    readonly completeOrderRequest?: CompleteOrderRequest
}

/**
 * Request parameters for createOrder operation in OrderApi.
 * @export
 * @interface OrderApiCreateOrderRequest
 */
export interface OrderApiCreateOrderRequest {
    /**
     * 
     * @type {string}
     * @memberof OrderApiCreateOrder
     */
    readonly apiVersion?: string

    /**
     * 
     * @type {CreateOrderRequest}
     * @memberof OrderApiCreateOrder
     */
    readonly createOrderRequest?: CreateOrderRequest
}

/**
 * Request parameters for getById operation in OrderApi.
 * @export
 * @interface OrderApiGetByIdRequest
 */
export interface OrderApiGetByIdRequest {
    /**
     * 
     * @type {string}
     * @memberof OrderApiGetById
     */
    readonly id: string

    /**
     * 
     * @type {string}
     * @memberof OrderApiGetById
     */
    readonly apiVersion?: string
}

/**
 * Request parameters for getExecutorReward operation in OrderApi.
 * @export
 * @interface OrderApiGetExecutorRewardRequest
 */
export interface OrderApiGetExecutorRewardRequest {
    /**
     * Идентификатор заказа
     * @type {string}
     * @memberof OrderApiGetExecutorReward
     */
    readonly orderId?: string

    /**
     * Идентификатор исполнителя
     * @type {string}
     * @memberof OrderApiGetExecutorReward
     */
    readonly executorId?: string

    /**
     * 
     * @type {string}
     * @memberof OrderApiGetExecutorReward
     */
    readonly apiVersion?: string
}

/**
 * Request parameters for getOrCreateDraftOrder operation in OrderApi.
 * @export
 * @interface OrderApiGetOrCreateDraftOrderRequest
 */
export interface OrderApiGetOrCreateDraftOrderRequest {
    /**
     * 
     * @type {string}
     * @memberof OrderApiGetOrCreateDraftOrder
     */
    readonly apiVersion?: string

    /**
     * 
     * @type {GetOrCreateOrderRequest}
     * @memberof OrderApiGetOrCreateDraftOrder
     */
    readonly getOrCreateOrderRequest?: GetOrCreateOrderRequest
}

/**
 * Request parameters for getOrderReport operation in OrderApi.
 * @export
 * @interface OrderApiGetOrderReportRequest
 */
export interface OrderApiGetOrderReportRequest {
    /**
     * 
     * @type {string}
     * @memberof OrderApiGetOrderReport
     */
    readonly orderId: string

    /**
     * 
     * @type {string}
     * @memberof OrderApiGetOrderReport
     */
    readonly apiVersion?: string
}

/**
 * Request parameters for getOrders operation in OrderApi.
 * @export
 * @interface OrderApiGetOrdersRequest
 */
export interface OrderApiGetOrdersRequest {
    /**
     * 
     * @type {string}
     * @memberof OrderApiGetOrders
     */
    readonly apiVersion?: string

    /**
     * 
     * @type {GetOrdersRequest}
     * @memberof OrderApiGetOrders
     */
    readonly getOrdersRequest?: GetOrdersRequest
}

/**
 * Request parameters for preprocessingCancelOrder operation in OrderApi.
 * @export
 * @interface OrderApiPreprocessingCancelOrderRequest
 */
export interface OrderApiPreprocessingCancelOrderRequest {
    /**
     * 
     * @type {string}
     * @memberof OrderApiPreprocessingCancelOrder
     */
    readonly orderId: string

    /**
     * 
     * @type {string}
     * @memberof OrderApiPreprocessingCancelOrder
     */
    readonly apiVersion?: string
}

/**
 * Request parameters for preprocessingStopExecuteOrder operation in OrderApi.
 * @export
 * @interface OrderApiPreprocessingStopExecuteOrderRequest
 */
export interface OrderApiPreprocessingStopExecuteOrderRequest {
    /**
     * 
     * @type {string}
     * @memberof OrderApiPreprocessingStopExecuteOrder
     */
    readonly orderId: string

    /**
     * 
     * @type {string}
     * @memberof OrderApiPreprocessingStopExecuteOrder
     */
    readonly apiVersion?: string
}

/**
 * Request parameters for refuseFromExecutor operation in OrderApi.
 * @export
 * @interface OrderApiRefuseFromExecutorRequest
 */
export interface OrderApiRefuseFromExecutorRequest {
    /**
     * 
     * @type {string}
     * @memberof OrderApiRefuseFromExecutor
     */
    readonly apiVersion?: string

    /**
     * 
     * @type {RefuseFromExecutorRequest}
     * @memberof OrderApiRefuseFromExecutor
     */
    readonly refuseFromExecutorRequest?: RefuseFromExecutorRequest
}

/**
 * Request parameters for repeatOrder operation in OrderApi.
 * @export
 * @interface OrderApiRepeatOrderRequest
 */
export interface OrderApiRepeatOrderRequest {
    /**
     * 
     * @type {string}
     * @memberof OrderApiRepeatOrder
     */
    readonly orderId: string

    /**
     * 
     * @type {string}
     * @memberof OrderApiRepeatOrder
     */
    readonly apiVersion?: string
}

/**
 * Request parameters for scheduleOrder operation in OrderApi.
 * @export
 * @interface OrderApiScheduleOrderRequest
 */
export interface OrderApiScheduleOrderRequest {
    /**
     * 
     * @type {string}
     * @memberof OrderApiScheduleOrder
     */
    readonly orderId: string

    /**
     * 
     * @type {string}
     * @memberof OrderApiScheduleOrder
     */
    readonly apiVersion?: string
}

/**
 * Request parameters for scheduleOrderByAdmin operation in OrderApi.
 * @export
 * @interface OrderApiScheduleOrderByAdminRequest
 */
export interface OrderApiScheduleOrderByAdminRequest {
    /**
     * 
     * @type {string}
     * @memberof OrderApiScheduleOrderByAdmin
     */
    readonly apiVersion?: string

    /**
     * 
     * @type {ScheduleOrderRequest}
     * @memberof OrderApiScheduleOrderByAdmin
     */
    readonly scheduleOrderRequest?: ScheduleOrderRequest
}

/**
 * Request parameters for setAddress operation in OrderApi.
 * @export
 * @interface OrderApiSetAddressRequest
 */
export interface OrderApiSetAddressRequest {
    /**
     * 
     * @type {string}
     * @memberof OrderApiSetAddress
     */
    readonly apiVersion?: string

    /**
     * Модель запроса по назначению адреса заказа
     * @type {SetAddressRequest}
     * @memberof OrderApiSetAddress
     */
    readonly setAddressRequest?: SetAddressRequest
}

/**
 * Request parameters for setOrderDetails operation in OrderApi.
 * @export
 * @interface OrderApiSetOrderDetailsRequest
 */
export interface OrderApiSetOrderDetailsRequest {
    /**
     * 
     * @type {string}
     * @memberof OrderApiSetOrderDetails
     */
    readonly apiVersion?: string

    /**
     * Модель запроса по назначению деталей заказа
     * @type {SetOrderDetailsRequest}
     * @memberof OrderApiSetOrderDetails
     */
    readonly setOrderDetailsRequest?: SetOrderDetailsRequest
}

/**
 * Request parameters for startExecuteOrder operation in OrderApi.
 * @export
 * @interface OrderApiStartExecuteOrderRequest
 */
export interface OrderApiStartExecuteOrderRequest {
    /**
     * 
     * @type {string}
     * @memberof OrderApiStartExecuteOrder
     */
    readonly orderId: string

    /**
     * 
     * @type {string}
     * @memberof OrderApiStartExecuteOrder
     */
    readonly apiVersion?: string
}

/**
 * Request parameters for startExecuteOrderByAdmin operation in OrderApi.
 * @export
 * @interface OrderApiStartExecuteOrderByAdminRequest
 */
export interface OrderApiStartExecuteOrderByAdminRequest {
    /**
     * 
     * @type {string}
     * @memberof OrderApiStartExecuteOrderByAdmin
     */
    readonly orderId: string

    /**
     * 
     * @type {string}
     * @memberof OrderApiStartExecuteOrderByAdmin
     */
    readonly apiVersion?: string
}

/**
 * Request parameters for unassignFromOrder operation in OrderApi.
 * @export
 * @interface OrderApiUnassignFromOrderRequest
 */
export interface OrderApiUnassignFromOrderRequest {
    /**
     * 
     * @type {string}
     * @memberof OrderApiUnassignFromOrder
     */
    readonly apiVersion?: string

    /**
     * 
     * @type {UnassignFromOrderRequest}
     * @memberof OrderApiUnassignFromOrder
     */
    readonly unassignFromOrderRequest?: UnassignFromOrderRequest
}

/**
 * Request parameters for updateOrder operation in OrderApi.
 * @export
 * @interface OrderApiUpdateOrderRequest
 */
export interface OrderApiUpdateOrderRequest {
    /**
     * 
     * @type {string}
     * @memberof OrderApiUpdateOrder
     */
    readonly apiVersion?: string

    /**
     * 
     * @type {UpdateOrderRequest}
     * @memberof OrderApiUpdateOrder
     */
    readonly updateOrderRequest?: UpdateOrderRequest
}

/**
 * OrderApi - object-oriented interface
 * @export
 * @class OrderApi
 * @extends {BaseAPI}
 */
export class OrderApi extends BaseAPI {
    /**
     * 
     * @summary Принять заказ исполнителем и отправить запрос на согласование клиенту
     * @param {OrderApiAcceptOrderRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderApi
     */
    public acceptOrder(requestParameters: OrderApiAcceptOrderRequest = {}, options?: RawAxiosRequestConfig) {
        return OrderApiFp(this.configuration).acceptOrder(requestParameters.apiVersion, requestParameters.acceptOrderRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Добавить или удалить продукт из заказа
     * @param {OrderApiAddOrRemoveOrderProductRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderApi
     */
    public addOrRemoveOrderProduct(requestParameters: OrderApiAddOrRemoveOrderProductRequest = {}, options?: RawAxiosRequestConfig) {
        return OrderApiFp(this.configuration).addOrRemoveOrderProduct(requestParameters.apiVersion, requestParameters.addOrRemoveOrderProductRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Добавить или удалить питомца из заказа
     * @param {OrderApiAddOrRemovePetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderApi
     */
    public addOrRemovePet(requestParameters: OrderApiAddOrRemovePetRequest = {}, options?: RawAxiosRequestConfig) {
        return OrderApiFp(this.configuration).addOrRemovePet(requestParameters.apiVersion, requestParameters.addOrRemovePetRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Утвердить исполнителя заказа от имени администратора
     * @param {OrderApiApiV1OrdersApproveOrderExecutorByAdminPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderApi
     */
    public apiV1OrdersApproveOrderExecutorByAdminPost(requestParameters: OrderApiApiV1OrdersApproveOrderExecutorByAdminPostRequest = {}, options?: RawAxiosRequestConfig) {
        return OrderApiFp(this.configuration).apiV1OrdersApproveOrderExecutorByAdminPost(requestParameters.apiVersion, requestParameters.approveOrderExecutorRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Получить завершенные заказы, по которым клиент еще не оставил отзыв
     * @param {OrderApiApiV1OrdersGetCompletedOrdersWithoutReviewGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderApi
     */
    public apiV1OrdersGetCompletedOrdersWithoutReviewGet(requestParameters: OrderApiApiV1OrdersGetCompletedOrdersWithoutReviewGetRequest, options?: RawAxiosRequestConfig) {
        return OrderApiFp(this.configuration).apiV1OrdersGetCompletedOrdersWithoutReviewGet(requestParameters.clientId, requestParameters.apiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Снять исполнителя с заказа оператором
     * @param {OrderApiApiV1OrdersRemoveExecutorByAdminPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderApi
     */
    public apiV1OrdersRemoveExecutorByAdminPost(requestParameters: OrderApiApiV1OrdersRemoveExecutorByAdminPostRequest = {}, options?: RawAxiosRequestConfig) {
        return OrderApiFp(this.configuration).apiV1OrdersRemoveExecutorByAdminPost(requestParameters.apiVersion, requestParameters.removeOrderExecutorRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Установить периоды планирования заказа
     * @param {OrderApiApiV1OrdersSetSchedulePeriodsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderApi
     */
    public apiV1OrdersSetSchedulePeriodsPost(requestParameters: OrderApiApiV1OrdersSetSchedulePeriodsPostRequest = {}, options?: RawAxiosRequestConfig) {
        return OrderApiFp(this.configuration).apiV1OrdersSetSchedulePeriodsPost(requestParameters.apiVersion, requestParameters.setOrderSchedulePeriodsRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Утвердить исполнителя заказа
     * @param {OrderApiApproveOrderExecutorRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderApi
     */
    public approveOrderExecutor(requestParameters: OrderApiApproveOrderExecutorRequest, options?: RawAxiosRequestConfig) {
        return OrderApiFp(this.configuration).approveOrderExecutor(requestParameters.orderId, requestParameters.apiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Назначить исполнителя на заказ
     * @param {OrderApiAssignExecutorToOrderRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderApi
     */
    public assignExecutorToOrder(requestParameters: OrderApiAssignExecutorToOrderRequest = {}, options?: RawAxiosRequestConfig) {
        return OrderApiFp(this.configuration).assignExecutorToOrder(requestParameters.apiVersion, requestParameters.assignExecutorToOrderRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Отказаться от заказа
     * @param {OrderApiCancelOrderRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderApi
     */
    public cancelOrder(requestParameters: OrderApiCancelOrderRequest = {}, options?: RawAxiosRequestConfig) {
        return OrderApiFp(this.configuration).cancelOrder(requestParameters.apiVersion, requestParameters.cancelOrderRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Завершить выполнение заказа
     * @param {OrderApiCompleteOrderRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderApi
     */
    public completeOrder(requestParameters: OrderApiCompleteOrderRequest = {}, options?: RawAxiosRequestConfig) {
        return OrderApiFp(this.configuration).completeOrder(requestParameters.apiVersion, requestParameters.completeOrderRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Создать заказ оператором
     * @param {OrderApiCreateOrderRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderApi
     */
    public createOrder(requestParameters: OrderApiCreateOrderRequest = {}, options?: RawAxiosRequestConfig) {
        return OrderApiFp(this.configuration).createOrder(requestParameters.apiVersion, requestParameters.createOrderRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Получить данные заказа
     * @param {OrderApiGetByIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderApi
     */
    public getById(requestParameters: OrderApiGetByIdRequest, options?: RawAxiosRequestConfig) {
        return OrderApiFp(this.configuration).getById(requestParameters.id, requestParameters.apiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Получить расчет по вознаграждению исполнителя
     * @param {OrderApiGetExecutorRewardRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderApi
     */
    public getExecutorReward(requestParameters: OrderApiGetExecutorRewardRequest = {}, options?: RawAxiosRequestConfig) {
        return OrderApiFp(this.configuration).getExecutorReward(requestParameters.orderId, requestParameters.executorId, requestParameters.apiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Получить данные заказа или создать новый
     * @param {OrderApiGetOrCreateDraftOrderRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderApi
     */
    public getOrCreateDraftOrder(requestParameters: OrderApiGetOrCreateDraftOrderRequest = {}, options?: RawAxiosRequestConfig) {
        return OrderApiFp(this.configuration).getOrCreateDraftOrder(requestParameters.apiVersion, requestParameters.getOrCreateOrderRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Получить отчет о проделанном заказе
     * @param {OrderApiGetOrderReportRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderApi
     */
    public getOrderReport(requestParameters: OrderApiGetOrderReportRequest, options?: RawAxiosRequestConfig) {
        return OrderApiFp(this.configuration).getOrderReport(requestParameters.orderId, requestParameters.apiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Получить заказы
     * @param {OrderApiGetOrdersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderApi
     */
    public getOrders(requestParameters: OrderApiGetOrdersRequest = {}, options?: RawAxiosRequestConfig) {
        return OrderApiFp(this.configuration).getOrders(requestParameters.apiVersion, requestParameters.getOrdersRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Предварительная обработка отмены заказа
     * @param {OrderApiPreprocessingCancelOrderRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderApi
     */
    public preprocessingCancelOrder(requestParameters: OrderApiPreprocessingCancelOrderRequest, options?: RawAxiosRequestConfig) {
        return OrderApiFp(this.configuration).preprocessingCancelOrder(requestParameters.orderId, requestParameters.apiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Предварительная обработка завершения выполнения заказа
     * @param {OrderApiPreprocessingStopExecuteOrderRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderApi
     */
    public preprocessingStopExecuteOrder(requestParameters: OrderApiPreprocessingStopExecuteOrderRequest, options?: RawAxiosRequestConfig) {
        return OrderApiFp(this.configuration).preprocessingStopExecuteOrder(requestParameters.orderId, requestParameters.apiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Отказаться от исполнителя
     * @param {OrderApiRefuseFromExecutorRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderApi
     */
    public refuseFromExecutor(requestParameters: OrderApiRefuseFromExecutorRequest = {}, options?: RawAxiosRequestConfig) {
        return OrderApiFp(this.configuration).refuseFromExecutor(requestParameters.apiVersion, requestParameters.refuseFromExecutorRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Повторить существующий заказ
     * @param {OrderApiRepeatOrderRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderApi
     */
    public repeatOrder(requestParameters: OrderApiRepeatOrderRequest, options?: RawAxiosRequestConfig) {
        return OrderApiFp(this.configuration).repeatOrder(requestParameters.orderId, requestParameters.apiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Запланировать заказ клиентом
     * @param {OrderApiScheduleOrderRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderApi
     */
    public scheduleOrder(requestParameters: OrderApiScheduleOrderRequest, options?: RawAxiosRequestConfig) {
        return OrderApiFp(this.configuration).scheduleOrder(requestParameters.orderId, requestParameters.apiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Запланировать заказ администратором
     * @param {OrderApiScheduleOrderByAdminRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderApi
     */
    public scheduleOrderByAdmin(requestParameters: OrderApiScheduleOrderByAdminRequest = {}, options?: RawAxiosRequestConfig) {
        return OrderApiFp(this.configuration).scheduleOrderByAdmin(requestParameters.apiVersion, requestParameters.scheduleOrderRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Установить адрес заказа
     * @param {OrderApiSetAddressRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderApi
     */
    public setAddress(requestParameters: OrderApiSetAddressRequest = {}, options?: RawAxiosRequestConfig) {
        return OrderApiFp(this.configuration).setAddress(requestParameters.apiVersion, requestParameters.setAddressRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Установить детали заказа
     * @param {OrderApiSetOrderDetailsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderApi
     */
    public setOrderDetails(requestParameters: OrderApiSetOrderDetailsRequest = {}, options?: RawAxiosRequestConfig) {
        return OrderApiFp(this.configuration).setOrderDetails(requestParameters.apiVersion, requestParameters.setOrderDetailsRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Начать выполнение заказа
     * @param {OrderApiStartExecuteOrderRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderApi
     */
    public startExecuteOrder(requestParameters: OrderApiStartExecuteOrderRequest, options?: RawAxiosRequestConfig) {
        return OrderApiFp(this.configuration).startExecuteOrder(requestParameters.orderId, requestParameters.apiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Начать выполнение заказа оператором
     * @param {OrderApiStartExecuteOrderByAdminRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderApi
     */
    public startExecuteOrderByAdmin(requestParameters: OrderApiStartExecuteOrderByAdminRequest, options?: RawAxiosRequestConfig) {
        return OrderApiFp(this.configuration).startExecuteOrderByAdmin(requestParameters.orderId, requestParameters.apiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Отказаться от заказа исполнителем
     * @param {OrderApiUnassignFromOrderRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderApi
     */
    public unassignFromOrder(requestParameters: OrderApiUnassignFromOrderRequest = {}, options?: RawAxiosRequestConfig) {
        return OrderApiFp(this.configuration).unassignFromOrder(requestParameters.apiVersion, requestParameters.unassignFromOrderRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Обновить заказ оператором
     * @param {OrderApiUpdateOrderRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderApi
     */
    public updateOrder(requestParameters: OrderApiUpdateOrderRequest = {}, options?: RawAxiosRequestConfig) {
        return OrderApiFp(this.configuration).updateOrder(requestParameters.apiVersion, requestParameters.updateOrderRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * OrderCancellationAnalyticsApi - axios parameter creator
 * @export
 */
export const OrderCancellationAnalyticsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Получить страницу отменённых заказов с причинами и инициаторами
         * @param {number} [takeCount] Размер страницы от одного до двухсот заказов
         * @param {Array<ApiCancellationReason>} [reasons] Причины отмены
         * @param {Array<ApiOrderCancellationActor>} [initiators] Инициаторы отмены
         * @param {string} [orderNumberSearch] Поиск номера заказа
         * @param {string} [descriptionSearch] Поиск текста причины
         * @param {string} [cancelledAtFrom] Начало диапазона отмены включительно
         * @param {string} [cancelledAtTo] Конец диапазона отмены исключительно
         * @param {string} [searchQuery] Строка для поиска
         * @param {number} [skipCount] Кол-во пропущенных записей
         * @param {boolean} [ascending] Сортировка по возрастанию
         * @param {string} [ordering] Поле для сортировки
         * @param {boolean} [isDeleted] Удалённые записи
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCancelledOrders: async (takeCount?: number, reasons?: Array<ApiCancellationReason>, initiators?: Array<ApiOrderCancellationActor>, orderNumberSearch?: string, descriptionSearch?: string, cancelledAtFrom?: string, cancelledAtTo?: string, searchQuery?: string, skipCount?: number, ascending?: boolean, ordering?: string, isDeleted?: boolean, apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/order-cancellation-analytics/get-orders`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (takeCount !== undefined) {
                localVarQueryParameter['TakeCount'] = takeCount;
            }

            if (reasons) {
                localVarQueryParameter['Reasons'] = reasons;
            }

            if (initiators) {
                localVarQueryParameter['Initiators'] = initiators;
            }

            if (orderNumberSearch !== undefined) {
                localVarQueryParameter['OrderNumberSearch'] = orderNumberSearch;
            }

            if (descriptionSearch !== undefined) {
                localVarQueryParameter['DescriptionSearch'] = descriptionSearch;
            }

            if (cancelledAtFrom !== undefined) {
                localVarQueryParameter['CancelledAtFrom'] = (cancelledAtFrom as any instanceof Date) ?
                    (cancelledAtFrom as any).toISOString() :
                    cancelledAtFrom;
            }

            if (cancelledAtTo !== undefined) {
                localVarQueryParameter['CancelledAtTo'] = (cancelledAtTo as any instanceof Date) ?
                    (cancelledAtTo as any).toISOString() :
                    cancelledAtTo;
            }

            if (searchQuery !== undefined) {
                localVarQueryParameter['SearchQuery'] = searchQuery;
            }

            if (skipCount !== undefined) {
                localVarQueryParameter['SkipCount'] = skipCount;
            }

            if (ascending !== undefined) {
                localVarQueryParameter['Ascending'] = ascending;
            }

            if (ordering !== undefined) {
                localVarQueryParameter['Ordering'] = ordering;
            }

            if (isDeleted !== undefined) {
                localVarQueryParameter['IsDeleted'] = isDeleted;
            }


    
            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * OrderCancellationAnalyticsApi - functional programming interface
 * @export
 */
export const OrderCancellationAnalyticsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = OrderCancellationAnalyticsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Получить страницу отменённых заказов с причинами и инициаторами
         * @param {number} [takeCount] Размер страницы от одного до двухсот заказов
         * @param {Array<ApiCancellationReason>} [reasons] Причины отмены
         * @param {Array<ApiOrderCancellationActor>} [initiators] Инициаторы отмены
         * @param {string} [orderNumberSearch] Поиск номера заказа
         * @param {string} [descriptionSearch] Поиск текста причины
         * @param {string} [cancelledAtFrom] Начало диапазона отмены включительно
         * @param {string} [cancelledAtTo] Конец диапазона отмены исключительно
         * @param {string} [searchQuery] Строка для поиска
         * @param {number} [skipCount] Кол-во пропущенных записей
         * @param {boolean} [ascending] Сортировка по возрастанию
         * @param {string} [ordering] Поле для сортировки
         * @param {boolean} [isDeleted] Удалённые записи
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCancelledOrders(takeCount?: number, reasons?: Array<ApiCancellationReason>, initiators?: Array<ApiOrderCancellationActor>, orderNumberSearch?: string, descriptionSearch?: string, cancelledAtFrom?: string, cancelledAtTo?: string, searchQuery?: string, skipCount?: number, ascending?: boolean, ordering?: string, isDeleted?: boolean, apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrderCancellationAnalyticsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCancelledOrders(takeCount, reasons, initiators, orderNumberSearch, descriptionSearch, cancelledAtFrom, cancelledAtTo, searchQuery, skipCount, ascending, ordering, isDeleted, apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrderCancellationAnalyticsApi.getCancelledOrders']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * OrderCancellationAnalyticsApi - factory interface
 * @export
 */
export const OrderCancellationAnalyticsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = OrderCancellationAnalyticsApiFp(configuration)
    return {
        /**
         * 
         * @summary Получить страницу отменённых заказов с причинами и инициаторами
         * @param {OrderCancellationAnalyticsApiGetCancelledOrdersRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCancelledOrders(requestParameters: OrderCancellationAnalyticsApiGetCancelledOrdersRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<OrderCancellationAnalyticsResponse> {
            return localVarFp.getCancelledOrders(requestParameters.takeCount, requestParameters.reasons, requestParameters.initiators, requestParameters.orderNumberSearch, requestParameters.descriptionSearch, requestParameters.cancelledAtFrom, requestParameters.cancelledAtTo, requestParameters.searchQuery, requestParameters.skipCount, requestParameters.ascending, requestParameters.ordering, requestParameters.isDeleted, requestParameters.apiVersion, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for getCancelledOrders operation in OrderCancellationAnalyticsApi.
 * @export
 * @interface OrderCancellationAnalyticsApiGetCancelledOrdersRequest
 */
export interface OrderCancellationAnalyticsApiGetCancelledOrdersRequest {
    /**
     * Размер страницы от одного до двухсот заказов
     * @type {number}
     * @memberof OrderCancellationAnalyticsApiGetCancelledOrders
     */
    readonly takeCount?: number

    /**
     * Причины отмены
     * @type {Array<ApiCancellationReason>}
     * @memberof OrderCancellationAnalyticsApiGetCancelledOrders
     */
    readonly reasons?: Array<ApiCancellationReason>

    /**
     * Инициаторы отмены
     * @type {Array<ApiOrderCancellationActor>}
     * @memberof OrderCancellationAnalyticsApiGetCancelledOrders
     */
    readonly initiators?: Array<ApiOrderCancellationActor>

    /**
     * Поиск номера заказа
     * @type {string}
     * @memberof OrderCancellationAnalyticsApiGetCancelledOrders
     */
    readonly orderNumberSearch?: string

    /**
     * Поиск текста причины
     * @type {string}
     * @memberof OrderCancellationAnalyticsApiGetCancelledOrders
     */
    readonly descriptionSearch?: string

    /**
     * Начало диапазона отмены включительно
     * @type {string}
     * @memberof OrderCancellationAnalyticsApiGetCancelledOrders
     */
    readonly cancelledAtFrom?: string

    /**
     * Конец диапазона отмены исключительно
     * @type {string}
     * @memberof OrderCancellationAnalyticsApiGetCancelledOrders
     */
    readonly cancelledAtTo?: string

    /**
     * Строка для поиска
     * @type {string}
     * @memberof OrderCancellationAnalyticsApiGetCancelledOrders
     */
    readonly searchQuery?: string

    /**
     * Кол-во пропущенных записей
     * @type {number}
     * @memberof OrderCancellationAnalyticsApiGetCancelledOrders
     */
    readonly skipCount?: number

    /**
     * Сортировка по возрастанию
     * @type {boolean}
     * @memberof OrderCancellationAnalyticsApiGetCancelledOrders
     */
    readonly ascending?: boolean

    /**
     * Поле для сортировки
     * @type {string}
     * @memberof OrderCancellationAnalyticsApiGetCancelledOrders
     */
    readonly ordering?: string

    /**
     * Удалённые записи
     * @type {boolean}
     * @memberof OrderCancellationAnalyticsApiGetCancelledOrders
     */
    readonly isDeleted?: boolean

    /**
     * 
     * @type {string}
     * @memberof OrderCancellationAnalyticsApiGetCancelledOrders
     */
    readonly apiVersion?: string
}

/**
 * OrderCancellationAnalyticsApi - object-oriented interface
 * @export
 * @class OrderCancellationAnalyticsApi
 * @extends {BaseAPI}
 */
export class OrderCancellationAnalyticsApi extends BaseAPI {
    /**
     * 
     * @summary Получить страницу отменённых заказов с причинами и инициаторами
     * @param {OrderCancellationAnalyticsApiGetCancelledOrdersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderCancellationAnalyticsApi
     */
    public getCancelledOrders(requestParameters: OrderCancellationAnalyticsApiGetCancelledOrdersRequest = {}, options?: RawAxiosRequestConfig) {
        return OrderCancellationAnalyticsApiFp(this.configuration).getCancelledOrders(requestParameters.takeCount, requestParameters.reasons, requestParameters.initiators, requestParameters.orderNumberSearch, requestParameters.descriptionSearch, requestParameters.cancelledAtFrom, requestParameters.cancelledAtTo, requestParameters.searchQuery, requestParameters.skipCount, requestParameters.ascending, requestParameters.ordering, requestParameters.isDeleted, requestParameters.apiVersion, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * OrderProblemsApi - axios parameter creator
 * @export
 */
export const OrderProblemsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Получить количество активных проблем
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getActiveOrderProblemCount: async (apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/order-problems/active-count`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Получить данные проблемы заказа
         * @param {string} id 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrderProblemDetails: async (id: string, apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getOrderProblemDetails', 'id', id)
            const localVarPath = `/api/v1/order-problems/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Получить проблемы заказов
         * @param {string} [lastOccurredFrom] Дата последней ошибки: начало периода
         * @param {string} [lastOccurredTo] Дата последней ошибки: конец периода
         * @param {boolean} [isResolved] Проблема устранена
         * @param {string} [externalId] Внешний идентификатор оплаты
         * @param {string} [orderId] Идентификатор заказа
         * @param {string} [searchQuery] Строка для поиска
         * @param {number} [takeCount] Размер страницы
         * @param {number} [skipCount] Кол-во пропущенных записей
         * @param {boolean} [ascending] Сортировка по возрастанию
         * @param {string} [ordering] Поле для сортировки
         * @param {boolean} [isDeleted] Удалённые записи
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrderProblems: async (lastOccurredFrom?: string, lastOccurredTo?: string, isResolved?: boolean, externalId?: string, orderId?: string, searchQuery?: string, takeCount?: number, skipCount?: number, ascending?: boolean, ordering?: string, isDeleted?: boolean, apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/order-problems/get-order-problems`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (lastOccurredFrom !== undefined) {
                localVarQueryParameter['LastOccurredFrom'] = (lastOccurredFrom as any instanceof Date) ?
                    (lastOccurredFrom as any).toISOString() :
                    lastOccurredFrom;
            }

            if (lastOccurredTo !== undefined) {
                localVarQueryParameter['LastOccurredTo'] = (lastOccurredTo as any instanceof Date) ?
                    (lastOccurredTo as any).toISOString() :
                    lastOccurredTo;
            }

            if (isResolved !== undefined) {
                localVarQueryParameter['IsResolved'] = isResolved;
            }

            if (externalId !== undefined) {
                localVarQueryParameter['ExternalId'] = externalId;
            }

            if (orderId !== undefined) {
                localVarQueryParameter['OrderId'] = orderId;
            }

            if (searchQuery !== undefined) {
                localVarQueryParameter['SearchQuery'] = searchQuery;
            }

            if (takeCount !== undefined) {
                localVarQueryParameter['TakeCount'] = takeCount;
            }

            if (skipCount !== undefined) {
                localVarQueryParameter['SkipCount'] = skipCount;
            }

            if (ascending !== undefined) {
                localVarQueryParameter['Ascending'] = ascending;
            }

            if (ordering !== undefined) {
                localVarQueryParameter['Ordering'] = ordering;
            }

            if (isDeleted !== undefined) {
                localVarQueryParameter['IsDeleted'] = isDeleted;
            }


    
            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Отметить проблему операции как устранённую
         * @param {string} id 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resolveOrderProblem: async (id: string, apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('resolveOrderProblem', 'id', id)
            const localVarPath = `/api/v1/order-problems/{id}/resolve`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Повторить обработку проблемы заказа
         * @param {string} id 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retryOrderProblem: async (id: string, apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('retryOrderProblem', 'id', id)
            const localVarPath = `/api/v1/order-problems/{id}/retry`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * OrderProblemsApi - functional programming interface
 * @export
 */
export const OrderProblemsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = OrderProblemsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Получить количество активных проблем
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getActiveOrderProblemCount(apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<number>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getActiveOrderProblemCount(apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrderProblemsApi.getActiveOrderProblemCount']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Получить данные проблемы заказа
         * @param {string} id 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOrderProblemDetails(id: string, apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrderProblemDetailsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOrderProblemDetails(id, apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrderProblemsApi.getOrderProblemDetails']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Получить проблемы заказов
         * @param {string} [lastOccurredFrom] Дата последней ошибки: начало периода
         * @param {string} [lastOccurredTo] Дата последней ошибки: конец периода
         * @param {boolean} [isResolved] Проблема устранена
         * @param {string} [externalId] Внешний идентификатор оплаты
         * @param {string} [orderId] Идентификатор заказа
         * @param {string} [searchQuery] Строка для поиска
         * @param {number} [takeCount] Размер страницы
         * @param {number} [skipCount] Кол-во пропущенных записей
         * @param {boolean} [ascending] Сортировка по возрастанию
         * @param {string} [ordering] Поле для сортировки
         * @param {boolean} [isDeleted] Удалённые записи
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOrderProblems(lastOccurredFrom?: string, lastOccurredTo?: string, isResolved?: boolean, externalId?: string, orderId?: string, searchQuery?: string, takeCount?: number, skipCount?: number, ascending?: boolean, ordering?: string, isDeleted?: boolean, apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetOrderProblemsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOrderProblems(lastOccurredFrom, lastOccurredTo, isResolved, externalId, orderId, searchQuery, takeCount, skipCount, ascending, ordering, isDeleted, apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrderProblemsApi.getOrderProblems']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Отметить проблему операции как устранённую
         * @param {string} id 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async resolveOrderProblem(id: string, apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrderProblemDetailsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.resolveOrderProblem(id, apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrderProblemsApi.resolveOrderProblem']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Повторить обработку проблемы заказа
         * @param {string} id 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async retryOrderProblem(id: string, apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrderProblemDetailsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.retryOrderProblem(id, apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrderProblemsApi.retryOrderProblem']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * OrderProblemsApi - factory interface
 * @export
 */
export const OrderProblemsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = OrderProblemsApiFp(configuration)
    return {
        /**
         * 
         * @summary Получить количество активных проблем
         * @param {OrderProblemsApiGetActiveOrderProblemCountRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getActiveOrderProblemCount(requestParameters: OrderProblemsApiGetActiveOrderProblemCountRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<number> {
            return localVarFp.getActiveOrderProblemCount(requestParameters.apiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Получить данные проблемы заказа
         * @param {OrderProblemsApiGetOrderProblemDetailsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrderProblemDetails(requestParameters: OrderProblemsApiGetOrderProblemDetailsRequest, options?: RawAxiosRequestConfig): AxiosPromise<OrderProblemDetailsResponse> {
            return localVarFp.getOrderProblemDetails(requestParameters.id, requestParameters.apiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Получить проблемы заказов
         * @param {OrderProblemsApiGetOrderProblemsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrderProblems(requestParameters: OrderProblemsApiGetOrderProblemsRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<GetOrderProblemsResponse> {
            return localVarFp.getOrderProblems(requestParameters.lastOccurredFrom, requestParameters.lastOccurredTo, requestParameters.isResolved, requestParameters.externalId, requestParameters.orderId, requestParameters.searchQuery, requestParameters.takeCount, requestParameters.skipCount, requestParameters.ascending, requestParameters.ordering, requestParameters.isDeleted, requestParameters.apiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Отметить проблему операции как устранённую
         * @param {OrderProblemsApiResolveOrderProblemRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resolveOrderProblem(requestParameters: OrderProblemsApiResolveOrderProblemRequest, options?: RawAxiosRequestConfig): AxiosPromise<OrderProblemDetailsResponse> {
            return localVarFp.resolveOrderProblem(requestParameters.id, requestParameters.apiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Повторить обработку проблемы заказа
         * @param {OrderProblemsApiRetryOrderProblemRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retryOrderProblem(requestParameters: OrderProblemsApiRetryOrderProblemRequest, options?: RawAxiosRequestConfig): AxiosPromise<OrderProblemDetailsResponse> {
            return localVarFp.retryOrderProblem(requestParameters.id, requestParameters.apiVersion, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for getActiveOrderProblemCount operation in OrderProblemsApi.
 * @export
 * @interface OrderProblemsApiGetActiveOrderProblemCountRequest
 */
export interface OrderProblemsApiGetActiveOrderProblemCountRequest {
    /**
     * 
     * @type {string}
     * @memberof OrderProblemsApiGetActiveOrderProblemCount
     */
    readonly apiVersion?: string
}

/**
 * Request parameters for getOrderProblemDetails operation in OrderProblemsApi.
 * @export
 * @interface OrderProblemsApiGetOrderProblemDetailsRequest
 */
export interface OrderProblemsApiGetOrderProblemDetailsRequest {
    /**
     * 
     * @type {string}
     * @memberof OrderProblemsApiGetOrderProblemDetails
     */
    readonly id: string

    /**
     * 
     * @type {string}
     * @memberof OrderProblemsApiGetOrderProblemDetails
     */
    readonly apiVersion?: string
}

/**
 * Request parameters for getOrderProblems operation in OrderProblemsApi.
 * @export
 * @interface OrderProblemsApiGetOrderProblemsRequest
 */
export interface OrderProblemsApiGetOrderProblemsRequest {
    /**
     * Дата последней ошибки: начало периода
     * @type {string}
     * @memberof OrderProblemsApiGetOrderProblems
     */
    readonly lastOccurredFrom?: string

    /**
     * Дата последней ошибки: конец периода
     * @type {string}
     * @memberof OrderProblemsApiGetOrderProblems
     */
    readonly lastOccurredTo?: string

    /**
     * Проблема устранена
     * @type {boolean}
     * @memberof OrderProblemsApiGetOrderProblems
     */
    readonly isResolved?: boolean

    /**
     * Внешний идентификатор оплаты
     * @type {string}
     * @memberof OrderProblemsApiGetOrderProblems
     */
    readonly externalId?: string

    /**
     * Идентификатор заказа
     * @type {string}
     * @memberof OrderProblemsApiGetOrderProblems
     */
    readonly orderId?: string

    /**
     * Строка для поиска
     * @type {string}
     * @memberof OrderProblemsApiGetOrderProblems
     */
    readonly searchQuery?: string

    /**
     * Размер страницы
     * @type {number}
     * @memberof OrderProblemsApiGetOrderProblems
     */
    readonly takeCount?: number

    /**
     * Кол-во пропущенных записей
     * @type {number}
     * @memberof OrderProblemsApiGetOrderProblems
     */
    readonly skipCount?: number

    /**
     * Сортировка по возрастанию
     * @type {boolean}
     * @memberof OrderProblemsApiGetOrderProblems
     */
    readonly ascending?: boolean

    /**
     * Поле для сортировки
     * @type {string}
     * @memberof OrderProblemsApiGetOrderProblems
     */
    readonly ordering?: string

    /**
     * Удалённые записи
     * @type {boolean}
     * @memberof OrderProblemsApiGetOrderProblems
     */
    readonly isDeleted?: boolean

    /**
     * 
     * @type {string}
     * @memberof OrderProblemsApiGetOrderProblems
     */
    readonly apiVersion?: string
}

/**
 * Request parameters for resolveOrderProblem operation in OrderProblemsApi.
 * @export
 * @interface OrderProblemsApiResolveOrderProblemRequest
 */
export interface OrderProblemsApiResolveOrderProblemRequest {
    /**
     * 
     * @type {string}
     * @memberof OrderProblemsApiResolveOrderProblem
     */
    readonly id: string

    /**
     * 
     * @type {string}
     * @memberof OrderProblemsApiResolveOrderProblem
     */
    readonly apiVersion?: string
}

/**
 * Request parameters for retryOrderProblem operation in OrderProblemsApi.
 * @export
 * @interface OrderProblemsApiRetryOrderProblemRequest
 */
export interface OrderProblemsApiRetryOrderProblemRequest {
    /**
     * 
     * @type {string}
     * @memberof OrderProblemsApiRetryOrderProblem
     */
    readonly id: string

    /**
     * 
     * @type {string}
     * @memberof OrderProblemsApiRetryOrderProblem
     */
    readonly apiVersion?: string
}

/**
 * OrderProblemsApi - object-oriented interface
 * @export
 * @class OrderProblemsApi
 * @extends {BaseAPI}
 */
export class OrderProblemsApi extends BaseAPI {
    /**
     * 
     * @summary Получить количество активных проблем
     * @param {OrderProblemsApiGetActiveOrderProblemCountRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderProblemsApi
     */
    public getActiveOrderProblemCount(requestParameters: OrderProblemsApiGetActiveOrderProblemCountRequest = {}, options?: RawAxiosRequestConfig) {
        return OrderProblemsApiFp(this.configuration).getActiveOrderProblemCount(requestParameters.apiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Получить данные проблемы заказа
     * @param {OrderProblemsApiGetOrderProblemDetailsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderProblemsApi
     */
    public getOrderProblemDetails(requestParameters: OrderProblemsApiGetOrderProblemDetailsRequest, options?: RawAxiosRequestConfig) {
        return OrderProblemsApiFp(this.configuration).getOrderProblemDetails(requestParameters.id, requestParameters.apiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Получить проблемы заказов
     * @param {OrderProblemsApiGetOrderProblemsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderProblemsApi
     */
    public getOrderProblems(requestParameters: OrderProblemsApiGetOrderProblemsRequest = {}, options?: RawAxiosRequestConfig) {
        return OrderProblemsApiFp(this.configuration).getOrderProblems(requestParameters.lastOccurredFrom, requestParameters.lastOccurredTo, requestParameters.isResolved, requestParameters.externalId, requestParameters.orderId, requestParameters.searchQuery, requestParameters.takeCount, requestParameters.skipCount, requestParameters.ascending, requestParameters.ordering, requestParameters.isDeleted, requestParameters.apiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Отметить проблему операции как устранённую
     * @param {OrderProblemsApiResolveOrderProblemRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderProblemsApi
     */
    public resolveOrderProblem(requestParameters: OrderProblemsApiResolveOrderProblemRequest, options?: RawAxiosRequestConfig) {
        return OrderProblemsApiFp(this.configuration).resolveOrderProblem(requestParameters.id, requestParameters.apiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Повторить обработку проблемы заказа
     * @param {OrderProblemsApiRetryOrderProblemRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderProblemsApi
     */
    public retryOrderProblem(requestParameters: OrderProblemsApiRetryOrderProblemRequest, options?: RawAxiosRequestConfig) {
        return OrderProblemsApiFp(this.configuration).retryOrderProblem(requestParameters.id, requestParameters.apiVersion, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * OrderTaskApi - axios parameter creator
 * @export
 */
export const OrderTaskApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Импортировать сделку RocketWork и связать её с заказом
         * @param {string} [apiVersion] 
         * @param {BindOrderTaskRequest} [bindOrderTaskRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bindOrderTask: async (apiVersion?: string, bindOrderTaskRequest?: BindOrderTaskRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/order-tasks/bind`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(bindOrderTaskRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Отменить сделку RocketWork
         * @param {string} [apiVersion] 
         * @param {CancelTaskRequest} [cancelTaskRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelTask: async (apiVersion?: string, cancelTaskRequest?: CancelTaskRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/order-tasks/cancel-task`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(cancelTaskRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Найти заказ без сделки по номеру или идентификатору
         * @param {string} [orderId] Идентификатор заказа
         * @param {number} [orderNumber] Номер заказа
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findOrderForTask: async (orderId?: string, orderNumber?: number, apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/order-tasks/find-order`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (orderId !== undefined) {
                localVarQueryParameter['OrderId'] = orderId;
            }

            if (orderNumber !== undefined) {
                localVarQueryParameter['OrderNumber'] = orderNumber;
            }


    
            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Получить данные сделки по ID заказа
         * @param {string} orderId Идентификатор заказа VOX
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getByOrderId: async (orderId: string, apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orderId' is not null or undefined
            assertParamExists('getByOrderId', 'orderId', orderId)
            const localVarPath = `/api/v1/order-tasks/get-by-order-id/{orderId}`
                .replace(`{${"orderId"}}`, encodeURIComponent(String(orderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Найти сделку RocketWork по её ID и получить сведения о привязке к заказу
         * @param {number} taskId Идентификатор сделки
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getByTaskId: async (taskId: number, apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'taskId' is not null or undefined
            assertParamExists('getByTaskId', 'taskId', taskId)
            const localVarPath = `/api/v1/order-tasks/get-by-task-id/{taskId}`
                .replace(`{${"taskId"}}`, encodeURIComponent(String(taskId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Получить статус сделки заказа
         * @param {number} taskId Идентификатор сделки
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrderTaskStatus: async (taskId: number, apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'taskId' is not null or undefined
            assertParamExists('getOrderTaskStatus', 'taskId', taskId)
            const localVarPath = `/api/v1/order-tasks/get-order-task-status/{taskId}`
                .replace(`{${"taskId"}}`, encodeURIComponent(String(taskId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Направить оплату исполнителю за сделку (заказ)
         * @param {string} [apiVersion] 
         * @param {PayForTaskRequest} [payForTaskRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        payForTask: async (apiVersion?: string, payForTaskRequest?: PayForTaskRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/order-tasks/pay-for-task`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(payForTaskRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * OrderTaskApi - functional programming interface
 * @export
 */
export const OrderTaskApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = OrderTaskApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Импортировать сделку RocketWork и связать её с заказом
         * @param {string} [apiVersion] 
         * @param {BindOrderTaskRequest} [bindOrderTaskRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async bindOrderTask(apiVersion?: string, bindOrderTaskRequest?: BindOrderTaskRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrderTaskResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.bindOrderTask(apiVersion, bindOrderTaskRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrderTaskApi.bindOrderTask']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Отменить сделку RocketWork
         * @param {string} [apiVersion] 
         * @param {CancelTaskRequest} [cancelTaskRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cancelTask(apiVersion?: string, cancelTaskRequest?: CancelTaskRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cancelTask(apiVersion, cancelTaskRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrderTaskApi.cancelTask']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Найти заказ без сделки по номеру или идентификатору
         * @param {string} [orderId] Идентификатор заказа
         * @param {number} [orderNumber] Номер заказа
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findOrderForTask(orderId?: string, orderNumber?: number, apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrderForTaskResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findOrderForTask(orderId, orderNumber, apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrderTaskApi.findOrderForTask']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Получить данные сделки по ID заказа
         * @param {string} orderId Идентификатор заказа VOX
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getByOrderId(orderId: string, apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrderTaskResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getByOrderId(orderId, apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrderTaskApi.getByOrderId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Найти сделку RocketWork по её ID и получить сведения о привязке к заказу
         * @param {number} taskId Идентификатор сделки
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getByTaskId(taskId: number, apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrderTaskResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getByTaskId(taskId, apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrderTaskApi.getByTaskId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Получить статус сделки заказа
         * @param {number} taskId Идентификатор сделки
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOrderTaskStatus(taskId: number, apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiRocketTaskStatusSimpleModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOrderTaskStatus(taskId, apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrderTaskApi.getOrderTaskStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Направить оплату исполнителю за сделку (заказ)
         * @param {string} [apiVersion] 
         * @param {PayForTaskRequest} [payForTaskRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async payForTask(apiVersion?: string, payForTaskRequest?: PayForTaskRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.payForTask(apiVersion, payForTaskRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrderTaskApi.payForTask']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * OrderTaskApi - factory interface
 * @export
 */
export const OrderTaskApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = OrderTaskApiFp(configuration)
    return {
        /**
         * 
         * @summary Импортировать сделку RocketWork и связать её с заказом
         * @param {OrderTaskApiBindOrderTaskRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bindOrderTask(requestParameters: OrderTaskApiBindOrderTaskRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<OrderTaskResponse> {
            return localVarFp.bindOrderTask(requestParameters.apiVersion, requestParameters.bindOrderTaskRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Отменить сделку RocketWork
         * @param {OrderTaskApiCancelTaskRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelTask(requestParameters: OrderTaskApiCancelTaskRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.cancelTask(requestParameters.apiVersion, requestParameters.cancelTaskRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Найти заказ без сделки по номеру или идентификатору
         * @param {OrderTaskApiFindOrderForTaskRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findOrderForTask(requestParameters: OrderTaskApiFindOrderForTaskRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<OrderForTaskResponse> {
            return localVarFp.findOrderForTask(requestParameters.orderId, requestParameters.orderNumber, requestParameters.apiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Получить данные сделки по ID заказа
         * @param {OrderTaskApiGetByOrderIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getByOrderId(requestParameters: OrderTaskApiGetByOrderIdRequest, options?: RawAxiosRequestConfig): AxiosPromise<OrderTaskResponse> {
            return localVarFp.getByOrderId(requestParameters.orderId, requestParameters.apiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Найти сделку RocketWork по её ID и получить сведения о привязке к заказу
         * @param {OrderTaskApiGetByTaskIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getByTaskId(requestParameters: OrderTaskApiGetByTaskIdRequest, options?: RawAxiosRequestConfig): AxiosPromise<OrderTaskResponse> {
            return localVarFp.getByTaskId(requestParameters.taskId, requestParameters.apiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Получить статус сделки заказа
         * @param {OrderTaskApiGetOrderTaskStatusRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrderTaskStatus(requestParameters: OrderTaskApiGetOrderTaskStatusRequest, options?: RawAxiosRequestConfig): AxiosPromise<ApiRocketTaskStatusSimpleModel> {
            return localVarFp.getOrderTaskStatus(requestParameters.taskId, requestParameters.apiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Направить оплату исполнителю за сделку (заказ)
         * @param {OrderTaskApiPayForTaskRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        payForTask(requestParameters: OrderTaskApiPayForTaskRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.payForTask(requestParameters.apiVersion, requestParameters.payForTaskRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for bindOrderTask operation in OrderTaskApi.
 * @export
 * @interface OrderTaskApiBindOrderTaskRequest
 */
export interface OrderTaskApiBindOrderTaskRequest {
    /**
     * 
     * @type {string}
     * @memberof OrderTaskApiBindOrderTask
     */
    readonly apiVersion?: string

    /**
     * 
     * @type {BindOrderTaskRequest}
     * @memberof OrderTaskApiBindOrderTask
     */
    readonly bindOrderTaskRequest?: BindOrderTaskRequest
}

/**
 * Request parameters for cancelTask operation in OrderTaskApi.
 * @export
 * @interface OrderTaskApiCancelTaskRequest
 */
export interface OrderTaskApiCancelTaskRequest {
    /**
     * 
     * @type {string}
     * @memberof OrderTaskApiCancelTask
     */
    readonly apiVersion?: string

    /**
     * 
     * @type {CancelTaskRequest}
     * @memberof OrderTaskApiCancelTask
     */
    readonly cancelTaskRequest?: CancelTaskRequest
}

/**
 * Request parameters for findOrderForTask operation in OrderTaskApi.
 * @export
 * @interface OrderTaskApiFindOrderForTaskRequest
 */
export interface OrderTaskApiFindOrderForTaskRequest {
    /**
     * Идентификатор заказа
     * @type {string}
     * @memberof OrderTaskApiFindOrderForTask
     */
    readonly orderId?: string

    /**
     * Номер заказа
     * @type {number}
     * @memberof OrderTaskApiFindOrderForTask
     */
    readonly orderNumber?: number

    /**
     * 
     * @type {string}
     * @memberof OrderTaskApiFindOrderForTask
     */
    readonly apiVersion?: string
}

/**
 * Request parameters for getByOrderId operation in OrderTaskApi.
 * @export
 * @interface OrderTaskApiGetByOrderIdRequest
 */
export interface OrderTaskApiGetByOrderIdRequest {
    /**
     * Идентификатор заказа VOX
     * @type {string}
     * @memberof OrderTaskApiGetByOrderId
     */
    readonly orderId: string

    /**
     * 
     * @type {string}
     * @memberof OrderTaskApiGetByOrderId
     */
    readonly apiVersion?: string
}

/**
 * Request parameters for getByTaskId operation in OrderTaskApi.
 * @export
 * @interface OrderTaskApiGetByTaskIdRequest
 */
export interface OrderTaskApiGetByTaskIdRequest {
    /**
     * Идентификатор сделки
     * @type {number}
     * @memberof OrderTaskApiGetByTaskId
     */
    readonly taskId: number

    /**
     * 
     * @type {string}
     * @memberof OrderTaskApiGetByTaskId
     */
    readonly apiVersion?: string
}

/**
 * Request parameters for getOrderTaskStatus operation in OrderTaskApi.
 * @export
 * @interface OrderTaskApiGetOrderTaskStatusRequest
 */
export interface OrderTaskApiGetOrderTaskStatusRequest {
    /**
     * Идентификатор сделки
     * @type {number}
     * @memberof OrderTaskApiGetOrderTaskStatus
     */
    readonly taskId: number

    /**
     * 
     * @type {string}
     * @memberof OrderTaskApiGetOrderTaskStatus
     */
    readonly apiVersion?: string
}

/**
 * Request parameters for payForTask operation in OrderTaskApi.
 * @export
 * @interface OrderTaskApiPayForTaskRequest
 */
export interface OrderTaskApiPayForTaskRequest {
    /**
     * 
     * @type {string}
     * @memberof OrderTaskApiPayForTask
     */
    readonly apiVersion?: string

    /**
     * 
     * @type {PayForTaskRequest}
     * @memberof OrderTaskApiPayForTask
     */
    readonly payForTaskRequest?: PayForTaskRequest
}

/**
 * OrderTaskApi - object-oriented interface
 * @export
 * @class OrderTaskApi
 * @extends {BaseAPI}
 */
export class OrderTaskApi extends BaseAPI {
    /**
     * 
     * @summary Импортировать сделку RocketWork и связать её с заказом
     * @param {OrderTaskApiBindOrderTaskRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderTaskApi
     */
    public bindOrderTask(requestParameters: OrderTaskApiBindOrderTaskRequest = {}, options?: RawAxiosRequestConfig) {
        return OrderTaskApiFp(this.configuration).bindOrderTask(requestParameters.apiVersion, requestParameters.bindOrderTaskRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Отменить сделку RocketWork
     * @param {OrderTaskApiCancelTaskRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderTaskApi
     */
    public cancelTask(requestParameters: OrderTaskApiCancelTaskRequest = {}, options?: RawAxiosRequestConfig) {
        return OrderTaskApiFp(this.configuration).cancelTask(requestParameters.apiVersion, requestParameters.cancelTaskRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Найти заказ без сделки по номеру или идентификатору
     * @param {OrderTaskApiFindOrderForTaskRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderTaskApi
     */
    public findOrderForTask(requestParameters: OrderTaskApiFindOrderForTaskRequest = {}, options?: RawAxiosRequestConfig) {
        return OrderTaskApiFp(this.configuration).findOrderForTask(requestParameters.orderId, requestParameters.orderNumber, requestParameters.apiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Получить данные сделки по ID заказа
     * @param {OrderTaskApiGetByOrderIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderTaskApi
     */
    public getByOrderId(requestParameters: OrderTaskApiGetByOrderIdRequest, options?: RawAxiosRequestConfig) {
        return OrderTaskApiFp(this.configuration).getByOrderId(requestParameters.orderId, requestParameters.apiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Найти сделку RocketWork по её ID и получить сведения о привязке к заказу
     * @param {OrderTaskApiGetByTaskIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderTaskApi
     */
    public getByTaskId(requestParameters: OrderTaskApiGetByTaskIdRequest, options?: RawAxiosRequestConfig) {
        return OrderTaskApiFp(this.configuration).getByTaskId(requestParameters.taskId, requestParameters.apiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Получить статус сделки заказа
     * @param {OrderTaskApiGetOrderTaskStatusRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderTaskApi
     */
    public getOrderTaskStatus(requestParameters: OrderTaskApiGetOrderTaskStatusRequest, options?: RawAxiosRequestConfig) {
        return OrderTaskApiFp(this.configuration).getOrderTaskStatus(requestParameters.taskId, requestParameters.apiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Направить оплату исполнителю за сделку (заказ)
     * @param {OrderTaskApiPayForTaskRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderTaskApi
     */
    public payForTask(requestParameters: OrderTaskApiPayForTaskRequest = {}, options?: RawAxiosRequestConfig) {
        return OrderTaskApiFp(this.configuration).payForTask(requestParameters.apiVersion, requestParameters.payForTaskRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * PaymentsApi - axios parameter creator
 * @export
 */
export const PaymentsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Ручное подтверждение оплаты из админки
         * @param {string} [apiVersion] 
         * @param {ManualPaymentConfirmRequest} [manualPaymentConfirmRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PaymentsManualConfirmPost: async (apiVersion?: string, manualPaymentConfirmRequest?: ManualPaymentConfirmRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/payments/manual-confirm`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(manualPaymentConfirmRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Рассчитать платёж заказа с применением скидок
         * @param {string} [apiVersion] 
         * @param {GetOrCreatePaymentRequest} [getOrCreatePaymentRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        applyDiscounts: async (apiVersion?: string, getOrCreatePaymentRequest?: GetOrCreatePaymentRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/payments/apply-discounts`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(getOrCreatePaymentRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Сохранить платёж заказа
         * @param {string} [apiVersion] 
         * @param {GetOrCreatePaymentRequest} [getOrCreatePaymentRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPayment: async (apiVersion?: string, getOrCreatePaymentRequest?: GetOrCreatePaymentRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/payments/create-payment`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(getOrCreatePaymentRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Генерация ссылки для платежа
         * @param {string} paymentId Идентификатор платежа
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generatePaymentUrl: async (paymentId: string, apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'paymentId' is not null or undefined
            assertParamExists('generatePaymentUrl', 'paymentId', paymentId)
            const localVarPath = `/api/v1/payments/generate-payment-url/{paymentId}`
                .replace(`{${"paymentId"}}`, encodeURIComponent(String(paymentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Получить данные платежа по ID
         * @param {string} id Идентификатор платежа
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPaymentById: async (id: string, apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getPaymentById', 'id', id)
            const localVarPath = `/api/v1/payments/byId/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Получить платёж по идентификатору заказа
         * @param {string} orderId 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPaymentByOrderId: async (orderId: string, apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orderId' is not null or undefined
            assertParamExists('getPaymentByOrderId', 'orderId', orderId)
            const localVarPath = `/api/v1/payments/get-payment-by-order-id/{orderId}`
                .replace(`{${"orderId"}}`, encodeURIComponent(String(orderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Получить текущий статус платежа
         * @param {string} paymentId 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPaymentStatus: async (paymentId: string, apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'paymentId' is not null or undefined
            assertParamExists('getPaymentStatus', 'paymentId', paymentId)
            const localVarPath = `/api/v1/payments/get-payment-status/{paymentId}`
                .replace(`{${"paymentId"}}`, encodeURIComponent(String(paymentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Обработать платеж перед генерацией ссылки на платеж  Если true - то следует продолжить операцию и перейти к методу generate-payment-url  Если false - то считать что оплата прошла успешна
         * @param {string} paymentId Идентификатор платежа
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        handleBeforeGeneratePaymentUrl: async (paymentId: string, apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'paymentId' is not null or undefined
            assertParamExists('handleBeforeGeneratePaymentUrl', 'paymentId', paymentId)
            const localVarPath = `/api/v1/payments/handle-before-generate-payment-url/{paymentId}`
                .replace(`{${"paymentId"}}`, encodeURIComponent(String(paymentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PaymentsApi - functional programming interface
 * @export
 */
export const PaymentsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PaymentsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Ручное подтверждение оплаты из админки
         * @param {string} [apiVersion] 
         * @param {ManualPaymentConfirmRequest} [manualPaymentConfirmRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1PaymentsManualConfirmPost(apiVersion?: string, manualPaymentConfirmRequest?: ManualPaymentConfirmRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1PaymentsManualConfirmPost(apiVersion, manualPaymentConfirmRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PaymentsApi.apiV1PaymentsManualConfirmPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Рассчитать платёж заказа с применением скидок
         * @param {string} [apiVersion] 
         * @param {GetOrCreatePaymentRequest} [getOrCreatePaymentRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async applyDiscounts(apiVersion?: string, getOrCreatePaymentRequest?: GetOrCreatePaymentRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaymentResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.applyDiscounts(apiVersion, getOrCreatePaymentRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PaymentsApi.applyDiscounts']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Сохранить платёж заказа
         * @param {string} [apiVersion] 
         * @param {GetOrCreatePaymentRequest} [getOrCreatePaymentRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createPayment(apiVersion?: string, getOrCreatePaymentRequest?: GetOrCreatePaymentRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaymentResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createPayment(apiVersion, getOrCreatePaymentRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PaymentsApi.createPayment']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Генерация ссылки для платежа
         * @param {string} paymentId Идентификатор платежа
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async generatePaymentUrl(paymentId: string, apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.generatePaymentUrl(paymentId, apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PaymentsApi.generatePaymentUrl']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Получить данные платежа по ID
         * @param {string} id Идентификатор платежа
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPaymentById(id: string, apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaymentResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPaymentById(id, apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PaymentsApi.getPaymentById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Получить платёж по идентификатору заказа
         * @param {string} orderId 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPaymentByOrderId(orderId: string, apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaymentResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPaymentByOrderId(orderId, apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PaymentsApi.getPaymentByOrderId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Получить текущий статус платежа
         * @param {string} paymentId 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPaymentStatus(paymentId: string, apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiPaymentStatusSimpleModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPaymentStatus(paymentId, apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PaymentsApi.getPaymentStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Обработать платеж перед генерацией ссылки на платеж  Если true - то следует продолжить операцию и перейти к методу generate-payment-url  Если false - то считать что оплата прошла успешна
         * @param {string} paymentId Идентификатор платежа
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async handleBeforeGeneratePaymentUrl(paymentId: string, apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.handleBeforeGeneratePaymentUrl(paymentId, apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PaymentsApi.handleBeforeGeneratePaymentUrl']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * PaymentsApi - factory interface
 * @export
 */
export const PaymentsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PaymentsApiFp(configuration)
    return {
        /**
         * 
         * @summary Ручное подтверждение оплаты из админки
         * @param {PaymentsApiApiV1PaymentsManualConfirmPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PaymentsManualConfirmPost(requestParameters: PaymentsApiApiV1PaymentsManualConfirmPostRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiV1PaymentsManualConfirmPost(requestParameters.apiVersion, requestParameters.manualPaymentConfirmRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Рассчитать платёж заказа с применением скидок
         * @param {PaymentsApiApplyDiscountsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        applyDiscounts(requestParameters: PaymentsApiApplyDiscountsRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<PaymentResponse> {
            return localVarFp.applyDiscounts(requestParameters.apiVersion, requestParameters.getOrCreatePaymentRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Сохранить платёж заказа
         * @param {PaymentsApiCreatePaymentRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPayment(requestParameters: PaymentsApiCreatePaymentRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<PaymentResponse> {
            return localVarFp.createPayment(requestParameters.apiVersion, requestParameters.getOrCreatePaymentRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Генерация ссылки для платежа
         * @param {PaymentsApiGeneratePaymentUrlRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generatePaymentUrl(requestParameters: PaymentsApiGeneratePaymentUrlRequest, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.generatePaymentUrl(requestParameters.paymentId, requestParameters.apiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Получить данные платежа по ID
         * @param {PaymentsApiGetPaymentByIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPaymentById(requestParameters: PaymentsApiGetPaymentByIdRequest, options?: RawAxiosRequestConfig): AxiosPromise<PaymentResponse> {
            return localVarFp.getPaymentById(requestParameters.id, requestParameters.apiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Получить платёж по идентификатору заказа
         * @param {PaymentsApiGetPaymentByOrderIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPaymentByOrderId(requestParameters: PaymentsApiGetPaymentByOrderIdRequest, options?: RawAxiosRequestConfig): AxiosPromise<PaymentResponse> {
            return localVarFp.getPaymentByOrderId(requestParameters.orderId, requestParameters.apiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Получить текущий статус платежа
         * @param {PaymentsApiGetPaymentStatusRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPaymentStatus(requestParameters: PaymentsApiGetPaymentStatusRequest, options?: RawAxiosRequestConfig): AxiosPromise<ApiPaymentStatusSimpleModel> {
            return localVarFp.getPaymentStatus(requestParameters.paymentId, requestParameters.apiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Обработать платеж перед генерацией ссылки на платеж  Если true - то следует продолжить операцию и перейти к методу generate-payment-url  Если false - то считать что оплата прошла успешна
         * @param {PaymentsApiHandleBeforeGeneratePaymentUrlRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        handleBeforeGeneratePaymentUrl(requestParameters: PaymentsApiHandleBeforeGeneratePaymentUrlRequest, options?: RawAxiosRequestConfig): AxiosPromise<boolean> {
            return localVarFp.handleBeforeGeneratePaymentUrl(requestParameters.paymentId, requestParameters.apiVersion, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for apiV1PaymentsManualConfirmPost operation in PaymentsApi.
 * @export
 * @interface PaymentsApiApiV1PaymentsManualConfirmPostRequest
 */
export interface PaymentsApiApiV1PaymentsManualConfirmPostRequest {
    /**
     * 
     * @type {string}
     * @memberof PaymentsApiApiV1PaymentsManualConfirmPost
     */
    readonly apiVersion?: string

    /**
     * 
     * @type {ManualPaymentConfirmRequest}
     * @memberof PaymentsApiApiV1PaymentsManualConfirmPost
     */
    readonly manualPaymentConfirmRequest?: ManualPaymentConfirmRequest
}

/**
 * Request parameters for applyDiscounts operation in PaymentsApi.
 * @export
 * @interface PaymentsApiApplyDiscountsRequest
 */
export interface PaymentsApiApplyDiscountsRequest {
    /**
     * 
     * @type {string}
     * @memberof PaymentsApiApplyDiscounts
     */
    readonly apiVersion?: string

    /**
     * 
     * @type {GetOrCreatePaymentRequest}
     * @memberof PaymentsApiApplyDiscounts
     */
    readonly getOrCreatePaymentRequest?: GetOrCreatePaymentRequest
}

/**
 * Request parameters for createPayment operation in PaymentsApi.
 * @export
 * @interface PaymentsApiCreatePaymentRequest
 */
export interface PaymentsApiCreatePaymentRequest {
    /**
     * 
     * @type {string}
     * @memberof PaymentsApiCreatePayment
     */
    readonly apiVersion?: string

    /**
     * 
     * @type {GetOrCreatePaymentRequest}
     * @memberof PaymentsApiCreatePayment
     */
    readonly getOrCreatePaymentRequest?: GetOrCreatePaymentRequest
}

/**
 * Request parameters for generatePaymentUrl operation in PaymentsApi.
 * @export
 * @interface PaymentsApiGeneratePaymentUrlRequest
 */
export interface PaymentsApiGeneratePaymentUrlRequest {
    /**
     * Идентификатор платежа
     * @type {string}
     * @memberof PaymentsApiGeneratePaymentUrl
     */
    readonly paymentId: string

    /**
     * 
     * @type {string}
     * @memberof PaymentsApiGeneratePaymentUrl
     */
    readonly apiVersion?: string
}

/**
 * Request parameters for getPaymentById operation in PaymentsApi.
 * @export
 * @interface PaymentsApiGetPaymentByIdRequest
 */
export interface PaymentsApiGetPaymentByIdRequest {
    /**
     * Идентификатор платежа
     * @type {string}
     * @memberof PaymentsApiGetPaymentById
     */
    readonly id: string

    /**
     * 
     * @type {string}
     * @memberof PaymentsApiGetPaymentById
     */
    readonly apiVersion?: string
}

/**
 * Request parameters for getPaymentByOrderId operation in PaymentsApi.
 * @export
 * @interface PaymentsApiGetPaymentByOrderIdRequest
 */
export interface PaymentsApiGetPaymentByOrderIdRequest {
    /**
     * 
     * @type {string}
     * @memberof PaymentsApiGetPaymentByOrderId
     */
    readonly orderId: string

    /**
     * 
     * @type {string}
     * @memberof PaymentsApiGetPaymentByOrderId
     */
    readonly apiVersion?: string
}

/**
 * Request parameters for getPaymentStatus operation in PaymentsApi.
 * @export
 * @interface PaymentsApiGetPaymentStatusRequest
 */
export interface PaymentsApiGetPaymentStatusRequest {
    /**
     * 
     * @type {string}
     * @memberof PaymentsApiGetPaymentStatus
     */
    readonly paymentId: string

    /**
     * 
     * @type {string}
     * @memberof PaymentsApiGetPaymentStatus
     */
    readonly apiVersion?: string
}

/**
 * Request parameters for handleBeforeGeneratePaymentUrl operation in PaymentsApi.
 * @export
 * @interface PaymentsApiHandleBeforeGeneratePaymentUrlRequest
 */
export interface PaymentsApiHandleBeforeGeneratePaymentUrlRequest {
    /**
     * Идентификатор платежа
     * @type {string}
     * @memberof PaymentsApiHandleBeforeGeneratePaymentUrl
     */
    readonly paymentId: string

    /**
     * 
     * @type {string}
     * @memberof PaymentsApiHandleBeforeGeneratePaymentUrl
     */
    readonly apiVersion?: string
}

/**
 * PaymentsApi - object-oriented interface
 * @export
 * @class PaymentsApi
 * @extends {BaseAPI}
 */
export class PaymentsApi extends BaseAPI {
    /**
     * 
     * @summary Ручное подтверждение оплаты из админки
     * @param {PaymentsApiApiV1PaymentsManualConfirmPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentsApi
     */
    public apiV1PaymentsManualConfirmPost(requestParameters: PaymentsApiApiV1PaymentsManualConfirmPostRequest = {}, options?: RawAxiosRequestConfig) {
        return PaymentsApiFp(this.configuration).apiV1PaymentsManualConfirmPost(requestParameters.apiVersion, requestParameters.manualPaymentConfirmRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Рассчитать платёж заказа с применением скидок
     * @param {PaymentsApiApplyDiscountsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentsApi
     */
    public applyDiscounts(requestParameters: PaymentsApiApplyDiscountsRequest = {}, options?: RawAxiosRequestConfig) {
        return PaymentsApiFp(this.configuration).applyDiscounts(requestParameters.apiVersion, requestParameters.getOrCreatePaymentRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Сохранить платёж заказа
     * @param {PaymentsApiCreatePaymentRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentsApi
     */
    public createPayment(requestParameters: PaymentsApiCreatePaymentRequest = {}, options?: RawAxiosRequestConfig) {
        return PaymentsApiFp(this.configuration).createPayment(requestParameters.apiVersion, requestParameters.getOrCreatePaymentRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Генерация ссылки для платежа
     * @param {PaymentsApiGeneratePaymentUrlRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentsApi
     */
    public generatePaymentUrl(requestParameters: PaymentsApiGeneratePaymentUrlRequest, options?: RawAxiosRequestConfig) {
        return PaymentsApiFp(this.configuration).generatePaymentUrl(requestParameters.paymentId, requestParameters.apiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Получить данные платежа по ID
     * @param {PaymentsApiGetPaymentByIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentsApi
     */
    public getPaymentById(requestParameters: PaymentsApiGetPaymentByIdRequest, options?: RawAxiosRequestConfig) {
        return PaymentsApiFp(this.configuration).getPaymentById(requestParameters.id, requestParameters.apiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Получить платёж по идентификатору заказа
     * @param {PaymentsApiGetPaymentByOrderIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentsApi
     */
    public getPaymentByOrderId(requestParameters: PaymentsApiGetPaymentByOrderIdRequest, options?: RawAxiosRequestConfig) {
        return PaymentsApiFp(this.configuration).getPaymentByOrderId(requestParameters.orderId, requestParameters.apiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Получить текущий статус платежа
     * @param {PaymentsApiGetPaymentStatusRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentsApi
     */
    public getPaymentStatus(requestParameters: PaymentsApiGetPaymentStatusRequest, options?: RawAxiosRequestConfig) {
        return PaymentsApiFp(this.configuration).getPaymentStatus(requestParameters.paymentId, requestParameters.apiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Обработать платеж перед генерацией ссылки на платеж  Если true - то следует продолжить операцию и перейти к методу generate-payment-url  Если false - то считать что оплата прошла успешна
     * @param {PaymentsApiHandleBeforeGeneratePaymentUrlRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentsApi
     */
    public handleBeforeGeneratePaymentUrl(requestParameters: PaymentsApiHandleBeforeGeneratePaymentUrlRequest, options?: RawAxiosRequestConfig) {
        return PaymentsApiFp(this.configuration).handleBeforeGeneratePaymentUrl(requestParameters.paymentId, requestParameters.apiVersion, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * PayoutMethodApi - axios parameter creator
 * @export
 */
export const PayoutMethodApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Добавить способ получения средств исполнителя.
         * @param {string} [apiVersion] 
         * @param {CreatePayoutMethodRequest} [createPayoutMethodRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPayoutMethod: async (apiVersion?: string, createPayoutMethodRequest?: CreatePayoutMethodRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/payout-method/create-payout-method`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createPayoutMethodRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Удалить способ получения средств исполнителя по ID.
         * @param {string} id 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePayoutMethod: async (id: string, apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deletePayoutMethod', 'id', id)
            const localVarPath = `/api/v1/payout-method/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Получить список получения средств исполнителя.
         * @param {string} executorId 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllPayoutMethodsByExecutorId: async (executorId: string, apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'executorId' is not null or undefined
            assertParamExists('getAllPayoutMethodsByExecutorId', 'executorId', executorId)
            const localVarPath = `/api/v1/payout-method/get-all-payout-methods-by-executor-id/{executorId}`
                .replace(`{${"executorId"}}`, encodeURIComponent(String(executorId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Получить способ получения средств исполнителя по ID.
         * @param {string} id 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPayoutMethodById: async (id: string, apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getPayoutMethodById', 'id', id)
            const localVarPath = `/api/v1/payout-method/get-payout-method-by-id/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Обновить способ получения средств исполнителя по ID.
         * @param {string} [apiVersion] 
         * @param {UpdatePayoutMethodRequest} [updatePayoutMethodRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePayoutMethod: async (apiVersion?: string, updatePayoutMethodRequest?: UpdatePayoutMethodRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/payout-method/update-payment-method`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updatePayoutMethodRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PayoutMethodApi - functional programming interface
 * @export
 */
export const PayoutMethodApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PayoutMethodApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Добавить способ получения средств исполнителя.
         * @param {string} [apiVersion] 
         * @param {CreatePayoutMethodRequest} [createPayoutMethodRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createPayoutMethod(apiVersion?: string, createPayoutMethodRequest?: CreatePayoutMethodRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PayoutMethodResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createPayoutMethod(apiVersion, createPayoutMethodRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PayoutMethodApi.createPayoutMethod']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Удалить способ получения средств исполнителя по ID.
         * @param {string} id 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deletePayoutMethod(id: string, apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deletePayoutMethod(id, apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PayoutMethodApi.deletePayoutMethod']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Получить список получения средств исполнителя.
         * @param {string} executorId 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllPayoutMethodsByExecutorId(executorId: string, apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PayoutMethodResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllPayoutMethodsByExecutorId(executorId, apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PayoutMethodApi.getAllPayoutMethodsByExecutorId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Получить способ получения средств исполнителя по ID.
         * @param {string} id 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPayoutMethodById(id: string, apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PayoutMethodResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPayoutMethodById(id, apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PayoutMethodApi.getPayoutMethodById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Обновить способ получения средств исполнителя по ID.
         * @param {string} [apiVersion] 
         * @param {UpdatePayoutMethodRequest} [updatePayoutMethodRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updatePayoutMethod(apiVersion?: string, updatePayoutMethodRequest?: UpdatePayoutMethodRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PayoutMethodResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updatePayoutMethod(apiVersion, updatePayoutMethodRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PayoutMethodApi.updatePayoutMethod']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * PayoutMethodApi - factory interface
 * @export
 */
export const PayoutMethodApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PayoutMethodApiFp(configuration)
    return {
        /**
         * 
         * @summary Добавить способ получения средств исполнителя.
         * @param {PayoutMethodApiCreatePayoutMethodRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPayoutMethod(requestParameters: PayoutMethodApiCreatePayoutMethodRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<PayoutMethodResponse> {
            return localVarFp.createPayoutMethod(requestParameters.apiVersion, requestParameters.createPayoutMethodRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Удалить способ получения средств исполнителя по ID.
         * @param {PayoutMethodApiDeletePayoutMethodRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePayoutMethod(requestParameters: PayoutMethodApiDeletePayoutMethodRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deletePayoutMethod(requestParameters.id, requestParameters.apiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Получить список получения средств исполнителя.
         * @param {PayoutMethodApiGetAllPayoutMethodsByExecutorIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllPayoutMethodsByExecutorId(requestParameters: PayoutMethodApiGetAllPayoutMethodsByExecutorIdRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<PayoutMethodResponse>> {
            return localVarFp.getAllPayoutMethodsByExecutorId(requestParameters.executorId, requestParameters.apiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Получить способ получения средств исполнителя по ID.
         * @param {PayoutMethodApiGetPayoutMethodByIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPayoutMethodById(requestParameters: PayoutMethodApiGetPayoutMethodByIdRequest, options?: RawAxiosRequestConfig): AxiosPromise<PayoutMethodResponse> {
            return localVarFp.getPayoutMethodById(requestParameters.id, requestParameters.apiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Обновить способ получения средств исполнителя по ID.
         * @param {PayoutMethodApiUpdatePayoutMethodRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePayoutMethod(requestParameters: PayoutMethodApiUpdatePayoutMethodRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<PayoutMethodResponse> {
            return localVarFp.updatePayoutMethod(requestParameters.apiVersion, requestParameters.updatePayoutMethodRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for createPayoutMethod operation in PayoutMethodApi.
 * @export
 * @interface PayoutMethodApiCreatePayoutMethodRequest
 */
export interface PayoutMethodApiCreatePayoutMethodRequest {
    /**
     * 
     * @type {string}
     * @memberof PayoutMethodApiCreatePayoutMethod
     */
    readonly apiVersion?: string

    /**
     * 
     * @type {CreatePayoutMethodRequest}
     * @memberof PayoutMethodApiCreatePayoutMethod
     */
    readonly createPayoutMethodRequest?: CreatePayoutMethodRequest
}

/**
 * Request parameters for deletePayoutMethod operation in PayoutMethodApi.
 * @export
 * @interface PayoutMethodApiDeletePayoutMethodRequest
 */
export interface PayoutMethodApiDeletePayoutMethodRequest {
    /**
     * 
     * @type {string}
     * @memberof PayoutMethodApiDeletePayoutMethod
     */
    readonly id: string

    /**
     * 
     * @type {string}
     * @memberof PayoutMethodApiDeletePayoutMethod
     */
    readonly apiVersion?: string
}

/**
 * Request parameters for getAllPayoutMethodsByExecutorId operation in PayoutMethodApi.
 * @export
 * @interface PayoutMethodApiGetAllPayoutMethodsByExecutorIdRequest
 */
export interface PayoutMethodApiGetAllPayoutMethodsByExecutorIdRequest {
    /**
     * 
     * @type {string}
     * @memberof PayoutMethodApiGetAllPayoutMethodsByExecutorId
     */
    readonly executorId: string

    /**
     * 
     * @type {string}
     * @memberof PayoutMethodApiGetAllPayoutMethodsByExecutorId
     */
    readonly apiVersion?: string
}

/**
 * Request parameters for getPayoutMethodById operation in PayoutMethodApi.
 * @export
 * @interface PayoutMethodApiGetPayoutMethodByIdRequest
 */
export interface PayoutMethodApiGetPayoutMethodByIdRequest {
    /**
     * 
     * @type {string}
     * @memberof PayoutMethodApiGetPayoutMethodById
     */
    readonly id: string

    /**
     * 
     * @type {string}
     * @memberof PayoutMethodApiGetPayoutMethodById
     */
    readonly apiVersion?: string
}

/**
 * Request parameters for updatePayoutMethod operation in PayoutMethodApi.
 * @export
 * @interface PayoutMethodApiUpdatePayoutMethodRequest
 */
export interface PayoutMethodApiUpdatePayoutMethodRequest {
    /**
     * 
     * @type {string}
     * @memberof PayoutMethodApiUpdatePayoutMethod
     */
    readonly apiVersion?: string

    /**
     * 
     * @type {UpdatePayoutMethodRequest}
     * @memberof PayoutMethodApiUpdatePayoutMethod
     */
    readonly updatePayoutMethodRequest?: UpdatePayoutMethodRequest
}

/**
 * PayoutMethodApi - object-oriented interface
 * @export
 * @class PayoutMethodApi
 * @extends {BaseAPI}
 */
export class PayoutMethodApi extends BaseAPI {
    /**
     * 
     * @summary Добавить способ получения средств исполнителя.
     * @param {PayoutMethodApiCreatePayoutMethodRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PayoutMethodApi
     */
    public createPayoutMethod(requestParameters: PayoutMethodApiCreatePayoutMethodRequest = {}, options?: RawAxiosRequestConfig) {
        return PayoutMethodApiFp(this.configuration).createPayoutMethod(requestParameters.apiVersion, requestParameters.createPayoutMethodRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Удалить способ получения средств исполнителя по ID.
     * @param {PayoutMethodApiDeletePayoutMethodRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PayoutMethodApi
     */
    public deletePayoutMethod(requestParameters: PayoutMethodApiDeletePayoutMethodRequest, options?: RawAxiosRequestConfig) {
        return PayoutMethodApiFp(this.configuration).deletePayoutMethod(requestParameters.id, requestParameters.apiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Получить список получения средств исполнителя.
     * @param {PayoutMethodApiGetAllPayoutMethodsByExecutorIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PayoutMethodApi
     */
    public getAllPayoutMethodsByExecutorId(requestParameters: PayoutMethodApiGetAllPayoutMethodsByExecutorIdRequest, options?: RawAxiosRequestConfig) {
        return PayoutMethodApiFp(this.configuration).getAllPayoutMethodsByExecutorId(requestParameters.executorId, requestParameters.apiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Получить способ получения средств исполнителя по ID.
     * @param {PayoutMethodApiGetPayoutMethodByIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PayoutMethodApi
     */
    public getPayoutMethodById(requestParameters: PayoutMethodApiGetPayoutMethodByIdRequest, options?: RawAxiosRequestConfig) {
        return PayoutMethodApiFp(this.configuration).getPayoutMethodById(requestParameters.id, requestParameters.apiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Обновить способ получения средств исполнителя по ID.
     * @param {PayoutMethodApiUpdatePayoutMethodRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PayoutMethodApi
     */
    public updatePayoutMethod(requestParameters: PayoutMethodApiUpdatePayoutMethodRequest = {}, options?: RawAxiosRequestConfig) {
        return PayoutMethodApiFp(this.configuration).updatePayoutMethod(requestParameters.apiVersion, requestParameters.updatePayoutMethodRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * PetsApi - axios parameter creator
 * @export
 */
export const PetsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Создать профиль питомца
         * @param {string} [apiVersion] 
         * @param {CreatePetRequest} [createPetRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPet: async (apiVersion?: string, createPetRequest?: CreatePetRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/pets/create`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createPetRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Создать профиль питомца через админку
         * @param {string} [apiVersion] 
         * @param {CreatePetRequest} [createPetRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPetByAdmin: async (apiVersion?: string, createPetRequest?: CreatePetRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/pets/create-by-admin`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createPetRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Удалить питомца
         * @param {string} petId Идентификатор питомца
         * @param {string} [apiVersion] 
         * @param {DeleteRequest} [deleteRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePet: async (petId: string, apiVersion?: string, deleteRequest?: DeleteRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'petId' is not null or undefined
            assertParamExists('deletePet', 'petId', petId)
            const localVarPath = `/api/v1/pets/{petId}`
                .replace(`{${"petId"}}`, encodeURIComponent(String(petId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(deleteRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Получить питомца по идентификатору
         * @param {string} petId Идентификатор питомца
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPetById: async (petId: string, apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'petId' is not null or undefined
            assertParamExists('getPetById', 'petId', petId)
            const localVarPath = `/api/v1/pets/{petId}`
                .replace(`{${"petId"}}`, encodeURIComponent(String(petId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Получить все привычки питомца по идентификатору питомца
         * @param {string} petId Идентификатор питомца
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPetHabitsByPetId: async (petId: string, apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'petId' is not null or undefined
            assertParamExists('getPetHabitsByPetId', 'petId', petId)
            const localVarPath = `/api/v1/pets/get-pet-habits-by-id/{petId}`
                .replace(`{${"petId"}}`, encodeURIComponent(String(petId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Получить питомцев по идентификатору владельца
         * @param {string} clientId Идентификатор клиента
         * @param {string} [idSearch] Поиск по идентификатору записи
         * @param {string} [nameSearch] Поиск по наименованию
         * @param {string} [breedSearch] Поиск по породе питомца
         * @param {string} [typeSearch] Поиск по названию типа
         * @param {string} [genderSearch] Поиск по названию пола
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPetsByClientId: async (clientId: string, idSearch?: string, nameSearch?: string, breedSearch?: string, typeSearch?: string, genderSearch?: string, apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'clientId' is not null or undefined
            assertParamExists('getPetsByClientId', 'clientId', clientId)
            const localVarPath = `/api/v1/pets/client/{clientId}`
                .replace(`{${"clientId"}}`, encodeURIComponent(String(clientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (idSearch !== undefined) {
                localVarQueryParameter['IdSearch'] = idSearch;
            }

            if (nameSearch !== undefined) {
                localVarQueryParameter['NameSearch'] = nameSearch;
            }

            if (breedSearch !== undefined) {
                localVarQueryParameter['BreedSearch'] = breedSearch;
            }

            if (typeSearch !== undefined) {
                localVarQueryParameter['TypeSearch'] = typeSearch;
            }

            if (genderSearch !== undefined) {
                localVarQueryParameter['GenderSearch'] = genderSearch;
            }


    
            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Поиск породы
         * @param {ApiPetType} [petType] Тип питомцы
         * @param {string} [search] Строка поиска
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchBreed: async (petType?: ApiPetType, search?: string, apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/pets/search-breed`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (petType !== undefined) {
                localVarQueryParameter['petType'] = petType;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }


    
            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Обновить питомца
         * @param {string} [apiVersion] 
         * @param {UpdatePetRequest} [updatePetRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePet: async (apiVersion?: string, updatePetRequest?: UpdatePetRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/pets`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updatePetRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PetsApi - functional programming interface
 * @export
 */
export const PetsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PetsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Создать профиль питомца
         * @param {string} [apiVersion] 
         * @param {CreatePetRequest} [createPetRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createPet(apiVersion?: string, createPetRequest?: CreatePetRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PetResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createPet(apiVersion, createPetRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PetsApi.createPet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Создать профиль питомца через админку
         * @param {string} [apiVersion] 
         * @param {CreatePetRequest} [createPetRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createPetByAdmin(apiVersion?: string, createPetRequest?: CreatePetRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PetResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createPetByAdmin(apiVersion, createPetRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PetsApi.createPetByAdmin']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Удалить питомца
         * @param {string} petId Идентификатор питомца
         * @param {string} [apiVersion] 
         * @param {DeleteRequest} [deleteRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deletePet(petId: string, apiVersion?: string, deleteRequest?: DeleteRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deletePet(petId, apiVersion, deleteRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PetsApi.deletePet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Получить питомца по идентификатору
         * @param {string} petId Идентификатор питомца
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPetById(petId: string, apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PetResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPetById(petId, apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PetsApi.getPetById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Получить все привычки питомца по идентификатору питомца
         * @param {string} petId Идентификатор питомца
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPetHabitsByPetId(petId: string, apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetPetHabitsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPetHabitsByPetId(petId, apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PetsApi.getPetHabitsByPetId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Получить питомцев по идентификатору владельца
         * @param {string} clientId Идентификатор клиента
         * @param {string} [idSearch] Поиск по идентификатору записи
         * @param {string} [nameSearch] Поиск по наименованию
         * @param {string} [breedSearch] Поиск по породе питомца
         * @param {string} [typeSearch] Поиск по названию типа
         * @param {string} [genderSearch] Поиск по названию пола
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPetsByClientId(clientId: string, idSearch?: string, nameSearch?: string, breedSearch?: string, typeSearch?: string, genderSearch?: string, apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PetResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPetsByClientId(clientId, idSearch, nameSearch, breedSearch, typeSearch, genderSearch, apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PetsApi.getPetsByClientId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Поиск породы
         * @param {ApiPetType} [petType] Тип питомцы
         * @param {string} [search] Строка поиска
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async searchBreed(petType?: ApiPetType, search?: string, apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<string>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.searchBreed(petType, search, apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PetsApi.searchBreed']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Обновить питомца
         * @param {string} [apiVersion] 
         * @param {UpdatePetRequest} [updatePetRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updatePet(apiVersion?: string, updatePetRequest?: UpdatePetRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PetResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updatePet(apiVersion, updatePetRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PetsApi.updatePet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * PetsApi - factory interface
 * @export
 */
export const PetsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PetsApiFp(configuration)
    return {
        /**
         * 
         * @summary Создать профиль питомца
         * @param {PetsApiCreatePetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPet(requestParameters: PetsApiCreatePetRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<PetResponse> {
            return localVarFp.createPet(requestParameters.apiVersion, requestParameters.createPetRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Создать профиль питомца через админку
         * @param {PetsApiCreatePetByAdminRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPetByAdmin(requestParameters: PetsApiCreatePetByAdminRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<PetResponse> {
            return localVarFp.createPetByAdmin(requestParameters.apiVersion, requestParameters.createPetRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Удалить питомца
         * @param {PetsApiDeletePetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePet(requestParameters: PetsApiDeletePetRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deletePet(requestParameters.petId, requestParameters.apiVersion, requestParameters.deleteRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Получить питомца по идентификатору
         * @param {PetsApiGetPetByIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPetById(requestParameters: PetsApiGetPetByIdRequest, options?: RawAxiosRequestConfig): AxiosPromise<PetResponse> {
            return localVarFp.getPetById(requestParameters.petId, requestParameters.apiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Получить все привычки питомца по идентификатору питомца
         * @param {PetsApiGetPetHabitsByPetIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPetHabitsByPetId(requestParameters: PetsApiGetPetHabitsByPetIdRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetPetHabitsResponse> {
            return localVarFp.getPetHabitsByPetId(requestParameters.petId, requestParameters.apiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Получить питомцев по идентификатору владельца
         * @param {PetsApiGetPetsByClientIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPetsByClientId(requestParameters: PetsApiGetPetsByClientIdRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<PetResponse>> {
            return localVarFp.getPetsByClientId(requestParameters.clientId, requestParameters.idSearch, requestParameters.nameSearch, requestParameters.breedSearch, requestParameters.typeSearch, requestParameters.genderSearch, requestParameters.apiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Поиск породы
         * @param {PetsApiSearchBreedRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchBreed(requestParameters: PetsApiSearchBreedRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<Array<string>> {
            return localVarFp.searchBreed(requestParameters.petType, requestParameters.search, requestParameters.apiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Обновить питомца
         * @param {PetsApiUpdatePetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePet(requestParameters: PetsApiUpdatePetRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<PetResponse> {
            return localVarFp.updatePet(requestParameters.apiVersion, requestParameters.updatePetRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for createPet operation in PetsApi.
 * @export
 * @interface PetsApiCreatePetRequest
 */
export interface PetsApiCreatePetRequest {
    /**
     * 
     * @type {string}
     * @memberof PetsApiCreatePet
     */
    readonly apiVersion?: string

    /**
     * 
     * @type {CreatePetRequest}
     * @memberof PetsApiCreatePet
     */
    readonly createPetRequest?: CreatePetRequest
}

/**
 * Request parameters for createPetByAdmin operation in PetsApi.
 * @export
 * @interface PetsApiCreatePetByAdminRequest
 */
export interface PetsApiCreatePetByAdminRequest {
    /**
     * 
     * @type {string}
     * @memberof PetsApiCreatePetByAdmin
     */
    readonly apiVersion?: string

    /**
     * 
     * @type {CreatePetRequest}
     * @memberof PetsApiCreatePetByAdmin
     */
    readonly createPetRequest?: CreatePetRequest
}

/**
 * Request parameters for deletePet operation in PetsApi.
 * @export
 * @interface PetsApiDeletePetRequest
 */
export interface PetsApiDeletePetRequest {
    /**
     * Идентификатор питомца
     * @type {string}
     * @memberof PetsApiDeletePet
     */
    readonly petId: string

    /**
     * 
     * @type {string}
     * @memberof PetsApiDeletePet
     */
    readonly apiVersion?: string

    /**
     * 
     * @type {DeleteRequest}
     * @memberof PetsApiDeletePet
     */
    readonly deleteRequest?: DeleteRequest
}

/**
 * Request parameters for getPetById operation in PetsApi.
 * @export
 * @interface PetsApiGetPetByIdRequest
 */
export interface PetsApiGetPetByIdRequest {
    /**
     * Идентификатор питомца
     * @type {string}
     * @memberof PetsApiGetPetById
     */
    readonly petId: string

    /**
     * 
     * @type {string}
     * @memberof PetsApiGetPetById
     */
    readonly apiVersion?: string
}

/**
 * Request parameters for getPetHabitsByPetId operation in PetsApi.
 * @export
 * @interface PetsApiGetPetHabitsByPetIdRequest
 */
export interface PetsApiGetPetHabitsByPetIdRequest {
    /**
     * Идентификатор питомца
     * @type {string}
     * @memberof PetsApiGetPetHabitsByPetId
     */
    readonly petId: string

    /**
     * 
     * @type {string}
     * @memberof PetsApiGetPetHabitsByPetId
     */
    readonly apiVersion?: string
}

/**
 * Request parameters for getPetsByClientId operation in PetsApi.
 * @export
 * @interface PetsApiGetPetsByClientIdRequest
 */
export interface PetsApiGetPetsByClientIdRequest {
    /**
     * Идентификатор клиента
     * @type {string}
     * @memberof PetsApiGetPetsByClientId
     */
    readonly clientId: string

    /**
     * Поиск по идентификатору записи
     * @type {string}
     * @memberof PetsApiGetPetsByClientId
     */
    readonly idSearch?: string

    /**
     * Поиск по наименованию
     * @type {string}
     * @memberof PetsApiGetPetsByClientId
     */
    readonly nameSearch?: string

    /**
     * Поиск по породе питомца
     * @type {string}
     * @memberof PetsApiGetPetsByClientId
     */
    readonly breedSearch?: string

    /**
     * Поиск по названию типа
     * @type {string}
     * @memberof PetsApiGetPetsByClientId
     */
    readonly typeSearch?: string

    /**
     * Поиск по названию пола
     * @type {string}
     * @memberof PetsApiGetPetsByClientId
     */
    readonly genderSearch?: string

    /**
     * 
     * @type {string}
     * @memberof PetsApiGetPetsByClientId
     */
    readonly apiVersion?: string
}

/**
 * Request parameters for searchBreed operation in PetsApi.
 * @export
 * @interface PetsApiSearchBreedRequest
 */
export interface PetsApiSearchBreedRequest {
    /**
     * Тип питомцы
     * @type {ApiPetType}
     * @memberof PetsApiSearchBreed
     */
    readonly petType?: ApiPetType

    /**
     * Строка поиска
     * @type {string}
     * @memberof PetsApiSearchBreed
     */
    readonly search?: string

    /**
     * 
     * @type {string}
     * @memberof PetsApiSearchBreed
     */
    readonly apiVersion?: string
}

/**
 * Request parameters for updatePet operation in PetsApi.
 * @export
 * @interface PetsApiUpdatePetRequest
 */
export interface PetsApiUpdatePetRequest {
    /**
     * 
     * @type {string}
     * @memberof PetsApiUpdatePet
     */
    readonly apiVersion?: string

    /**
     * 
     * @type {UpdatePetRequest}
     * @memberof PetsApiUpdatePet
     */
    readonly updatePetRequest?: UpdatePetRequest
}

/**
 * PetsApi - object-oriented interface
 * @export
 * @class PetsApi
 * @extends {BaseAPI}
 */
export class PetsApi extends BaseAPI {
    /**
     * 
     * @summary Создать профиль питомца
     * @param {PetsApiCreatePetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PetsApi
     */
    public createPet(requestParameters: PetsApiCreatePetRequest = {}, options?: RawAxiosRequestConfig) {
        return PetsApiFp(this.configuration).createPet(requestParameters.apiVersion, requestParameters.createPetRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Создать профиль питомца через админку
     * @param {PetsApiCreatePetByAdminRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PetsApi
     */
    public createPetByAdmin(requestParameters: PetsApiCreatePetByAdminRequest = {}, options?: RawAxiosRequestConfig) {
        return PetsApiFp(this.configuration).createPetByAdmin(requestParameters.apiVersion, requestParameters.createPetRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Удалить питомца
     * @param {PetsApiDeletePetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PetsApi
     */
    public deletePet(requestParameters: PetsApiDeletePetRequest, options?: RawAxiosRequestConfig) {
        return PetsApiFp(this.configuration).deletePet(requestParameters.petId, requestParameters.apiVersion, requestParameters.deleteRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Получить питомца по идентификатору
     * @param {PetsApiGetPetByIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PetsApi
     */
    public getPetById(requestParameters: PetsApiGetPetByIdRequest, options?: RawAxiosRequestConfig) {
        return PetsApiFp(this.configuration).getPetById(requestParameters.petId, requestParameters.apiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Получить все привычки питомца по идентификатору питомца
     * @param {PetsApiGetPetHabitsByPetIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PetsApi
     */
    public getPetHabitsByPetId(requestParameters: PetsApiGetPetHabitsByPetIdRequest, options?: RawAxiosRequestConfig) {
        return PetsApiFp(this.configuration).getPetHabitsByPetId(requestParameters.petId, requestParameters.apiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Получить питомцев по идентификатору владельца
     * @param {PetsApiGetPetsByClientIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PetsApi
     */
    public getPetsByClientId(requestParameters: PetsApiGetPetsByClientIdRequest, options?: RawAxiosRequestConfig) {
        return PetsApiFp(this.configuration).getPetsByClientId(requestParameters.clientId, requestParameters.idSearch, requestParameters.nameSearch, requestParameters.breedSearch, requestParameters.typeSearch, requestParameters.genderSearch, requestParameters.apiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Поиск породы
     * @param {PetsApiSearchBreedRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PetsApi
     */
    public searchBreed(requestParameters: PetsApiSearchBreedRequest = {}, options?: RawAxiosRequestConfig) {
        return PetsApiFp(this.configuration).searchBreed(requestParameters.petType, requestParameters.search, requestParameters.apiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Обновить питомца
     * @param {PetsApiUpdatePetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PetsApi
     */
    public updatePet(requestParameters: PetsApiUpdatePetRequest = {}, options?: RawAxiosRequestConfig) {
        return PetsApiFp(this.configuration).updatePet(requestParameters.apiVersion, requestParameters.updatePetRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * PoliciesApi - axios parameter creator
 * @export
 */
export const PoliciesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Создать политику
         * @param {string} [apiVersion] 
         * @param {CreatePolicyRequest} [createPolicyRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PoliciesCreatePolicyPost: async (apiVersion?: string, createPolicyRequest?: CreatePolicyRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/policies/create-policy`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createPolicyRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Получить политики
         * @param {Array<ApiPolicyType>} [types] Типы политик
         * @param {Array<ApiPolicyAudience>} [audiences] Аудитории политик
         * @param {boolean} [isShowServices] Показывать в приложении
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PoliciesGetAllGet: async (types?: Array<ApiPolicyType>, audiences?: Array<ApiPolicyAudience>, isShowServices?: boolean, apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/policies/get-all`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (types) {
                localVarQueryParameter['Types'] = types;
            }

            if (audiences) {
                localVarQueryParameter['Audiences'] = audiences;
            }

            if (isShowServices !== undefined) {
                localVarQueryParameter['IsShowServices'] = isShowServices;
            }


    
            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Удалить политику
         * @param {string} id 
         * @param {string} [apiVersion] 
         * @param {DeleteRequest} [deleteRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PoliciesIdDelete: async (id: string, apiVersion?: string, deleteRequest?: DeleteRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiV1PoliciesIdDelete', 'id', id)
            const localVarPath = `/api/v1/policies/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(deleteRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Получить политику по идентификатору
         * @param {string} id 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PoliciesIdGet: async (id: string, apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiV1PoliciesIdGet', 'id', id)
            const localVarPath = `/api/v1/policies/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Обновить данные политики
         * @param {string} id 
         * @param {string} [apiVersion] 
         * @param {UpdatePolicyRequest} [updatePolicyRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PoliciesUpdatePolicyIdPut: async (id: string, apiVersion?: string, updatePolicyRequest?: UpdatePolicyRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiV1PoliciesUpdatePolicyIdPut', 'id', id)
            const localVarPath = `/api/v1/policies/update-policy/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updatePolicyRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PoliciesApi - functional programming interface
 * @export
 */
export const PoliciesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PoliciesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Создать политику
         * @param {string} [apiVersion] 
         * @param {CreatePolicyRequest} [createPolicyRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1PoliciesCreatePolicyPost(apiVersion?: string, createPolicyRequest?: CreatePolicyRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PolicyResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1PoliciesCreatePolicyPost(apiVersion, createPolicyRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PoliciesApi.apiV1PoliciesCreatePolicyPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Получить политики
         * @param {Array<ApiPolicyType>} [types] Типы политик
         * @param {Array<ApiPolicyAudience>} [audiences] Аудитории политик
         * @param {boolean} [isShowServices] Показывать в приложении
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1PoliciesGetAllGet(types?: Array<ApiPolicyType>, audiences?: Array<ApiPolicyAudience>, isShowServices?: boolean, apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PolicyResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1PoliciesGetAllGet(types, audiences, isShowServices, apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PoliciesApi.apiV1PoliciesGetAllGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Удалить политику
         * @param {string} id 
         * @param {string} [apiVersion] 
         * @param {DeleteRequest} [deleteRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1PoliciesIdDelete(id: string, apiVersion?: string, deleteRequest?: DeleteRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1PoliciesIdDelete(id, apiVersion, deleteRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PoliciesApi.apiV1PoliciesIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Получить политику по идентификатору
         * @param {string} id 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1PoliciesIdGet(id: string, apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PolicyResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1PoliciesIdGet(id, apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PoliciesApi.apiV1PoliciesIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Обновить данные политики
         * @param {string} id 
         * @param {string} [apiVersion] 
         * @param {UpdatePolicyRequest} [updatePolicyRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1PoliciesUpdatePolicyIdPut(id: string, apiVersion?: string, updatePolicyRequest?: UpdatePolicyRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PolicyResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1PoliciesUpdatePolicyIdPut(id, apiVersion, updatePolicyRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PoliciesApi.apiV1PoliciesUpdatePolicyIdPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * PoliciesApi - factory interface
 * @export
 */
export const PoliciesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PoliciesApiFp(configuration)
    return {
        /**
         * 
         * @summary Создать политику
         * @param {PoliciesApiApiV1PoliciesCreatePolicyPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PoliciesCreatePolicyPost(requestParameters: PoliciesApiApiV1PoliciesCreatePolicyPostRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<PolicyResponse> {
            return localVarFp.apiV1PoliciesCreatePolicyPost(requestParameters.apiVersion, requestParameters.createPolicyRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Получить политики
         * @param {PoliciesApiApiV1PoliciesGetAllGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PoliciesGetAllGet(requestParameters: PoliciesApiApiV1PoliciesGetAllGetRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<Array<PolicyResponse>> {
            return localVarFp.apiV1PoliciesGetAllGet(requestParameters.types, requestParameters.audiences, requestParameters.isShowServices, requestParameters.apiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Удалить политику
         * @param {PoliciesApiApiV1PoliciesIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PoliciesIdDelete(requestParameters: PoliciesApiApiV1PoliciesIdDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiV1PoliciesIdDelete(requestParameters.id, requestParameters.apiVersion, requestParameters.deleteRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Получить политику по идентификатору
         * @param {PoliciesApiApiV1PoliciesIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PoliciesIdGet(requestParameters: PoliciesApiApiV1PoliciesIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<PolicyResponse> {
            return localVarFp.apiV1PoliciesIdGet(requestParameters.id, requestParameters.apiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Обновить данные политики
         * @param {PoliciesApiApiV1PoliciesUpdatePolicyIdPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PoliciesUpdatePolicyIdPut(requestParameters: PoliciesApiApiV1PoliciesUpdatePolicyIdPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<PolicyResponse> {
            return localVarFp.apiV1PoliciesUpdatePolicyIdPut(requestParameters.id, requestParameters.apiVersion, requestParameters.updatePolicyRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for apiV1PoliciesCreatePolicyPost operation in PoliciesApi.
 * @export
 * @interface PoliciesApiApiV1PoliciesCreatePolicyPostRequest
 */
export interface PoliciesApiApiV1PoliciesCreatePolicyPostRequest {
    /**
     * 
     * @type {string}
     * @memberof PoliciesApiApiV1PoliciesCreatePolicyPost
     */
    readonly apiVersion?: string

    /**
     * 
     * @type {CreatePolicyRequest}
     * @memberof PoliciesApiApiV1PoliciesCreatePolicyPost
     */
    readonly createPolicyRequest?: CreatePolicyRequest
}

/**
 * Request parameters for apiV1PoliciesGetAllGet operation in PoliciesApi.
 * @export
 * @interface PoliciesApiApiV1PoliciesGetAllGetRequest
 */
export interface PoliciesApiApiV1PoliciesGetAllGetRequest {
    /**
     * Типы политик
     * @type {Array<ApiPolicyType>}
     * @memberof PoliciesApiApiV1PoliciesGetAllGet
     */
    readonly types?: Array<ApiPolicyType>

    /**
     * Аудитории политик
     * @type {Array<ApiPolicyAudience>}
     * @memberof PoliciesApiApiV1PoliciesGetAllGet
     */
    readonly audiences?: Array<ApiPolicyAudience>

    /**
     * Показывать в приложении
     * @type {boolean}
     * @memberof PoliciesApiApiV1PoliciesGetAllGet
     */
    readonly isShowServices?: boolean

    /**
     * 
     * @type {string}
     * @memberof PoliciesApiApiV1PoliciesGetAllGet
     */
    readonly apiVersion?: string
}

/**
 * Request parameters for apiV1PoliciesIdDelete operation in PoliciesApi.
 * @export
 * @interface PoliciesApiApiV1PoliciesIdDeleteRequest
 */
export interface PoliciesApiApiV1PoliciesIdDeleteRequest {
    /**
     * 
     * @type {string}
     * @memberof PoliciesApiApiV1PoliciesIdDelete
     */
    readonly id: string

    /**
     * 
     * @type {string}
     * @memberof PoliciesApiApiV1PoliciesIdDelete
     */
    readonly apiVersion?: string

    /**
     * 
     * @type {DeleteRequest}
     * @memberof PoliciesApiApiV1PoliciesIdDelete
     */
    readonly deleteRequest?: DeleteRequest
}

/**
 * Request parameters for apiV1PoliciesIdGet operation in PoliciesApi.
 * @export
 * @interface PoliciesApiApiV1PoliciesIdGetRequest
 */
export interface PoliciesApiApiV1PoliciesIdGetRequest {
    /**
     * 
     * @type {string}
     * @memberof PoliciesApiApiV1PoliciesIdGet
     */
    readonly id: string

    /**
     * 
     * @type {string}
     * @memberof PoliciesApiApiV1PoliciesIdGet
     */
    readonly apiVersion?: string
}

/**
 * Request parameters for apiV1PoliciesUpdatePolicyIdPut operation in PoliciesApi.
 * @export
 * @interface PoliciesApiApiV1PoliciesUpdatePolicyIdPutRequest
 */
export interface PoliciesApiApiV1PoliciesUpdatePolicyIdPutRequest {
    /**
     * 
     * @type {string}
     * @memberof PoliciesApiApiV1PoliciesUpdatePolicyIdPut
     */
    readonly id: string

    /**
     * 
     * @type {string}
     * @memberof PoliciesApiApiV1PoliciesUpdatePolicyIdPut
     */
    readonly apiVersion?: string

    /**
     * 
     * @type {UpdatePolicyRequest}
     * @memberof PoliciesApiApiV1PoliciesUpdatePolicyIdPut
     */
    readonly updatePolicyRequest?: UpdatePolicyRequest
}

/**
 * PoliciesApi - object-oriented interface
 * @export
 * @class PoliciesApi
 * @extends {BaseAPI}
 */
export class PoliciesApi extends BaseAPI {
    /**
     * 
     * @summary Создать политику
     * @param {PoliciesApiApiV1PoliciesCreatePolicyPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PoliciesApi
     */
    public apiV1PoliciesCreatePolicyPost(requestParameters: PoliciesApiApiV1PoliciesCreatePolicyPostRequest = {}, options?: RawAxiosRequestConfig) {
        return PoliciesApiFp(this.configuration).apiV1PoliciesCreatePolicyPost(requestParameters.apiVersion, requestParameters.createPolicyRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Получить политики
     * @param {PoliciesApiApiV1PoliciesGetAllGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PoliciesApi
     */
    public apiV1PoliciesGetAllGet(requestParameters: PoliciesApiApiV1PoliciesGetAllGetRequest = {}, options?: RawAxiosRequestConfig) {
        return PoliciesApiFp(this.configuration).apiV1PoliciesGetAllGet(requestParameters.types, requestParameters.audiences, requestParameters.isShowServices, requestParameters.apiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Удалить политику
     * @param {PoliciesApiApiV1PoliciesIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PoliciesApi
     */
    public apiV1PoliciesIdDelete(requestParameters: PoliciesApiApiV1PoliciesIdDeleteRequest, options?: RawAxiosRequestConfig) {
        return PoliciesApiFp(this.configuration).apiV1PoliciesIdDelete(requestParameters.id, requestParameters.apiVersion, requestParameters.deleteRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Получить политику по идентификатору
     * @param {PoliciesApiApiV1PoliciesIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PoliciesApi
     */
    public apiV1PoliciesIdGet(requestParameters: PoliciesApiApiV1PoliciesIdGetRequest, options?: RawAxiosRequestConfig) {
        return PoliciesApiFp(this.configuration).apiV1PoliciesIdGet(requestParameters.id, requestParameters.apiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Обновить данные политики
     * @param {PoliciesApiApiV1PoliciesUpdatePolicyIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PoliciesApi
     */
    public apiV1PoliciesUpdatePolicyIdPut(requestParameters: PoliciesApiApiV1PoliciesUpdatePolicyIdPutRequest, options?: RawAxiosRequestConfig) {
        return PoliciesApiFp(this.configuration).apiV1PoliciesUpdatePolicyIdPut(requestParameters.id, requestParameters.apiVersion, requestParameters.updatePolicyRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * PriceListApi - axios parameter creator
 * @export
 */
export const PriceListApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Удалить прайс-лист
         * @param {string} id 
         * @param {string} [apiVersion] 
         * @param {DeleteRequest} [deleteRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PriceListsIdDelete: async (id: string, apiVersion?: string, deleteRequest?: DeleteRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiV1PriceListsIdDelete', 'id', id)
            const localVarPath = `/api/v1/price-lists/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(deleteRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Создать прайс-лист
         * @param {string} [apiVersion] 
         * @param {CreatePriceListRequest} [createPriceListRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPriceList: async (apiVersion?: string, createPriceListRequest?: CreatePriceListRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/price-lists/create-price-list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createPriceListRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Получить данные прайс-листа по ID
         * @param {string} id 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPriceListById: async (id: string, apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getPriceListById', 'id', id)
            const localVarPath = `/api/v1/price-lists/get-price-list-by-id/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Получить страницу прайс-листов
         * @param {string} [createdFrom] Дата создания: начало периода
         * @param {string} [createdTo] Дата создания: конец периода
         * @param {string} [updatedFrom] Дата обновления: начало периода
         * @param {string} [updatedTo] Дата обновления: конец периода
         * @param {number} [cityId] Идентификатор города
         * @param {Array<ApiProductType>} [productTypes] Типы продуктов
         * @param {Array<ApiPetType>} [petTypes] Типы питомцев
         * @param {string} [searchQuery] Строка для поиска
         * @param {number} [takeCount] Размер страницы
         * @param {number} [skipCount] Кол-во пропущенных записей
         * @param {boolean} [ascending] Сортировка по возрастанию
         * @param {string} [ordering] Поле для сортировки
         * @param {boolean} [isDeleted] Удалённые записи
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPriceLists: async (createdFrom?: string, createdTo?: string, updatedFrom?: string, updatedTo?: string, cityId?: number, productTypes?: Array<ApiProductType>, petTypes?: Array<ApiPetType>, searchQuery?: string, takeCount?: number, skipCount?: number, ascending?: boolean, ordering?: string, isDeleted?: boolean, apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/price-lists/get-price-lists`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (createdFrom !== undefined) {
                localVarQueryParameter['CreatedFrom'] = (createdFrom as any instanceof Date) ?
                    (createdFrom as any).toISOString() :
                    createdFrom;
            }

            if (createdTo !== undefined) {
                localVarQueryParameter['CreatedTo'] = (createdTo as any instanceof Date) ?
                    (createdTo as any).toISOString() :
                    createdTo;
            }

            if (updatedFrom !== undefined) {
                localVarQueryParameter['UpdatedFrom'] = (updatedFrom as any instanceof Date) ?
                    (updatedFrom as any).toISOString() :
                    updatedFrom;
            }

            if (updatedTo !== undefined) {
                localVarQueryParameter['UpdatedTo'] = (updatedTo as any instanceof Date) ?
                    (updatedTo as any).toISOString() :
                    updatedTo;
            }

            if (cityId !== undefined) {
                localVarQueryParameter['CityId'] = cityId;
            }

            if (productTypes) {
                localVarQueryParameter['ProductTypes'] = productTypes;
            }

            if (petTypes) {
                localVarQueryParameter['PetTypes'] = petTypes;
            }

            if (searchQuery !== undefined) {
                localVarQueryParameter['SearchQuery'] = searchQuery;
            }

            if (takeCount !== undefined) {
                localVarQueryParameter['TakeCount'] = takeCount;
            }

            if (skipCount !== undefined) {
                localVarQueryParameter['SkipCount'] = skipCount;
            }

            if (ascending !== undefined) {
                localVarQueryParameter['Ascending'] = ascending;
            }

            if (ordering !== undefined) {
                localVarQueryParameter['Ordering'] = ordering;
            }

            if (isDeleted !== undefined) {
                localVarQueryParameter['IsDeleted'] = isDeleted;
            }


    
            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Обновить данные прайс-листа
         * @param {string} [apiVersion] 
         * @param {UpdatePriceListRequest} [updatePriceListRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePriceList: async (apiVersion?: string, updatePriceListRequest?: UpdatePriceListRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/price-lists/update-price-list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updatePriceListRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PriceListApi - functional programming interface
 * @export
 */
export const PriceListApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PriceListApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Удалить прайс-лист
         * @param {string} id 
         * @param {string} [apiVersion] 
         * @param {DeleteRequest} [deleteRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1PriceListsIdDelete(id: string, apiVersion?: string, deleteRequest?: DeleteRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1PriceListsIdDelete(id, apiVersion, deleteRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PriceListApi.apiV1PriceListsIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Создать прайс-лист
         * @param {string} [apiVersion] 
         * @param {CreatePriceListRequest} [createPriceListRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createPriceList(apiVersion?: string, createPriceListRequest?: CreatePriceListRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PriceListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createPriceList(apiVersion, createPriceListRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PriceListApi.createPriceList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Получить данные прайс-листа по ID
         * @param {string} id 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPriceListById(id: string, apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PriceListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPriceListById(id, apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PriceListApi.getPriceListById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Получить страницу прайс-листов
         * @param {string} [createdFrom] Дата создания: начало периода
         * @param {string} [createdTo] Дата создания: конец периода
         * @param {string} [updatedFrom] Дата обновления: начало периода
         * @param {string} [updatedTo] Дата обновления: конец периода
         * @param {number} [cityId] Идентификатор города
         * @param {Array<ApiProductType>} [productTypes] Типы продуктов
         * @param {Array<ApiPetType>} [petTypes] Типы питомцев
         * @param {string} [searchQuery] Строка для поиска
         * @param {number} [takeCount] Размер страницы
         * @param {number} [skipCount] Кол-во пропущенных записей
         * @param {boolean} [ascending] Сортировка по возрастанию
         * @param {string} [ordering] Поле для сортировки
         * @param {boolean} [isDeleted] Удалённые записи
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPriceLists(createdFrom?: string, createdTo?: string, updatedFrom?: string, updatedTo?: string, cityId?: number, productTypes?: Array<ApiProductType>, petTypes?: Array<ApiPetType>, searchQuery?: string, takeCount?: number, skipCount?: number, ascending?: boolean, ordering?: string, isDeleted?: boolean, apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetPriceListsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPriceLists(createdFrom, createdTo, updatedFrom, updatedTo, cityId, productTypes, petTypes, searchQuery, takeCount, skipCount, ascending, ordering, isDeleted, apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PriceListApi.getPriceLists']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Обновить данные прайс-листа
         * @param {string} [apiVersion] 
         * @param {UpdatePriceListRequest} [updatePriceListRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updatePriceList(apiVersion?: string, updatePriceListRequest?: UpdatePriceListRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PriceListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updatePriceList(apiVersion, updatePriceListRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PriceListApi.updatePriceList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * PriceListApi - factory interface
 * @export
 */
export const PriceListApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PriceListApiFp(configuration)
    return {
        /**
         * 
         * @summary Удалить прайс-лист
         * @param {PriceListApiApiV1PriceListsIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PriceListsIdDelete(requestParameters: PriceListApiApiV1PriceListsIdDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiV1PriceListsIdDelete(requestParameters.id, requestParameters.apiVersion, requestParameters.deleteRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Создать прайс-лист
         * @param {PriceListApiCreatePriceListRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPriceList(requestParameters: PriceListApiCreatePriceListRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<PriceListResponse> {
            return localVarFp.createPriceList(requestParameters.apiVersion, requestParameters.createPriceListRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Получить данные прайс-листа по ID
         * @param {PriceListApiGetPriceListByIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPriceListById(requestParameters: PriceListApiGetPriceListByIdRequest, options?: RawAxiosRequestConfig): AxiosPromise<PriceListResponse> {
            return localVarFp.getPriceListById(requestParameters.id, requestParameters.apiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Получить страницу прайс-листов
         * @param {PriceListApiGetPriceListsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPriceLists(requestParameters: PriceListApiGetPriceListsRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<GetPriceListsResponse> {
            return localVarFp.getPriceLists(requestParameters.createdFrom, requestParameters.createdTo, requestParameters.updatedFrom, requestParameters.updatedTo, requestParameters.cityId, requestParameters.productTypes, requestParameters.petTypes, requestParameters.searchQuery, requestParameters.takeCount, requestParameters.skipCount, requestParameters.ascending, requestParameters.ordering, requestParameters.isDeleted, requestParameters.apiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Обновить данные прайс-листа
         * @param {PriceListApiUpdatePriceListRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePriceList(requestParameters: PriceListApiUpdatePriceListRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<PriceListResponse> {
            return localVarFp.updatePriceList(requestParameters.apiVersion, requestParameters.updatePriceListRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for apiV1PriceListsIdDelete operation in PriceListApi.
 * @export
 * @interface PriceListApiApiV1PriceListsIdDeleteRequest
 */
export interface PriceListApiApiV1PriceListsIdDeleteRequest {
    /**
     * 
     * @type {string}
     * @memberof PriceListApiApiV1PriceListsIdDelete
     */
    readonly id: string

    /**
     * 
     * @type {string}
     * @memberof PriceListApiApiV1PriceListsIdDelete
     */
    readonly apiVersion?: string

    /**
     * 
     * @type {DeleteRequest}
     * @memberof PriceListApiApiV1PriceListsIdDelete
     */
    readonly deleteRequest?: DeleteRequest
}

/**
 * Request parameters for createPriceList operation in PriceListApi.
 * @export
 * @interface PriceListApiCreatePriceListRequest
 */
export interface PriceListApiCreatePriceListRequest {
    /**
     * 
     * @type {string}
     * @memberof PriceListApiCreatePriceList
     */
    readonly apiVersion?: string

    /**
     * 
     * @type {CreatePriceListRequest}
     * @memberof PriceListApiCreatePriceList
     */
    readonly createPriceListRequest?: CreatePriceListRequest
}

/**
 * Request parameters for getPriceListById operation in PriceListApi.
 * @export
 * @interface PriceListApiGetPriceListByIdRequest
 */
export interface PriceListApiGetPriceListByIdRequest {
    /**
     * 
     * @type {string}
     * @memberof PriceListApiGetPriceListById
     */
    readonly id: string

    /**
     * 
     * @type {string}
     * @memberof PriceListApiGetPriceListById
     */
    readonly apiVersion?: string
}

/**
 * Request parameters for getPriceLists operation in PriceListApi.
 * @export
 * @interface PriceListApiGetPriceListsRequest
 */
export interface PriceListApiGetPriceListsRequest {
    /**
     * Дата создания: начало периода
     * @type {string}
     * @memberof PriceListApiGetPriceLists
     */
    readonly createdFrom?: string

    /**
     * Дата создания: конец периода
     * @type {string}
     * @memberof PriceListApiGetPriceLists
     */
    readonly createdTo?: string

    /**
     * Дата обновления: начало периода
     * @type {string}
     * @memberof PriceListApiGetPriceLists
     */
    readonly updatedFrom?: string

    /**
     * Дата обновления: конец периода
     * @type {string}
     * @memberof PriceListApiGetPriceLists
     */
    readonly updatedTo?: string

    /**
     * Идентификатор города
     * @type {number}
     * @memberof PriceListApiGetPriceLists
     */
    readonly cityId?: number

    /**
     * Типы продуктов
     * @type {Array<ApiProductType>}
     * @memberof PriceListApiGetPriceLists
     */
    readonly productTypes?: Array<ApiProductType>

    /**
     * Типы питомцев
     * @type {Array<ApiPetType>}
     * @memberof PriceListApiGetPriceLists
     */
    readonly petTypes?: Array<ApiPetType>

    /**
     * Строка для поиска
     * @type {string}
     * @memberof PriceListApiGetPriceLists
     */
    readonly searchQuery?: string

    /**
     * Размер страницы
     * @type {number}
     * @memberof PriceListApiGetPriceLists
     */
    readonly takeCount?: number

    /**
     * Кол-во пропущенных записей
     * @type {number}
     * @memberof PriceListApiGetPriceLists
     */
    readonly skipCount?: number

    /**
     * Сортировка по возрастанию
     * @type {boolean}
     * @memberof PriceListApiGetPriceLists
     */
    readonly ascending?: boolean

    /**
     * Поле для сортировки
     * @type {string}
     * @memberof PriceListApiGetPriceLists
     */
    readonly ordering?: string

    /**
     * Удалённые записи
     * @type {boolean}
     * @memberof PriceListApiGetPriceLists
     */
    readonly isDeleted?: boolean

    /**
     * 
     * @type {string}
     * @memberof PriceListApiGetPriceLists
     */
    readonly apiVersion?: string
}

/**
 * Request parameters for updatePriceList operation in PriceListApi.
 * @export
 * @interface PriceListApiUpdatePriceListRequest
 */
export interface PriceListApiUpdatePriceListRequest {
    /**
     * 
     * @type {string}
     * @memberof PriceListApiUpdatePriceList
     */
    readonly apiVersion?: string

    /**
     * 
     * @type {UpdatePriceListRequest}
     * @memberof PriceListApiUpdatePriceList
     */
    readonly updatePriceListRequest?: UpdatePriceListRequest
}

/**
 * PriceListApi - object-oriented interface
 * @export
 * @class PriceListApi
 * @extends {BaseAPI}
 */
export class PriceListApi extends BaseAPI {
    /**
     * 
     * @summary Удалить прайс-лист
     * @param {PriceListApiApiV1PriceListsIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PriceListApi
     */
    public apiV1PriceListsIdDelete(requestParameters: PriceListApiApiV1PriceListsIdDeleteRequest, options?: RawAxiosRequestConfig) {
        return PriceListApiFp(this.configuration).apiV1PriceListsIdDelete(requestParameters.id, requestParameters.apiVersion, requestParameters.deleteRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Создать прайс-лист
     * @param {PriceListApiCreatePriceListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PriceListApi
     */
    public createPriceList(requestParameters: PriceListApiCreatePriceListRequest = {}, options?: RawAxiosRequestConfig) {
        return PriceListApiFp(this.configuration).createPriceList(requestParameters.apiVersion, requestParameters.createPriceListRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Получить данные прайс-листа по ID
     * @param {PriceListApiGetPriceListByIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PriceListApi
     */
    public getPriceListById(requestParameters: PriceListApiGetPriceListByIdRequest, options?: RawAxiosRequestConfig) {
        return PriceListApiFp(this.configuration).getPriceListById(requestParameters.id, requestParameters.apiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Получить страницу прайс-листов
     * @param {PriceListApiGetPriceListsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PriceListApi
     */
    public getPriceLists(requestParameters: PriceListApiGetPriceListsRequest = {}, options?: RawAxiosRequestConfig) {
        return PriceListApiFp(this.configuration).getPriceLists(requestParameters.createdFrom, requestParameters.createdTo, requestParameters.updatedFrom, requestParameters.updatedTo, requestParameters.cityId, requestParameters.productTypes, requestParameters.petTypes, requestParameters.searchQuery, requestParameters.takeCount, requestParameters.skipCount, requestParameters.ascending, requestParameters.ordering, requestParameters.isDeleted, requestParameters.apiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Обновить данные прайс-листа
     * @param {PriceListApiUpdatePriceListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PriceListApi
     */
    public updatePriceList(requestParameters: PriceListApiUpdatePriceListRequest = {}, options?: RawAxiosRequestConfig) {
        return PriceListApiFp(this.configuration).updatePriceList(requestParameters.apiVersion, requestParameters.updatePriceListRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * PricingPeriodsApi - axios parameter creator
 * @export
 */
export const PricingPeriodsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Создать период продукта или прайс-листа
         * @param {string} [apiVersion] 
         * @param {CreatePricingPeriodRequest} [createPricingPeriodRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPricingPeriod: async (apiVersion?: string, createPricingPeriodRequest?: CreatePricingPeriodRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/pricing-periods`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createPricingPeriodRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Удалить период по идентификатору
         * @param {string} id 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePricingPeriod: async (id: string, apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deletePricingPeriod', 'id', id)
            const localVarPath = `/api/v1/pricing-periods/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Получить период по идентификатору
         * @param {string} id 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPricingPeriodById: async (id: string, apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getPricingPeriodById', 'id', id)
            const localVarPath = `/api/v1/pricing-periods/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Получить периоды продукта или прайс-листа
         * @param {string} [productId] Идентификатор продукта
         * @param {string} [priceListId] Идентификатор прайс-листа
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPricingPeriods: async (productId?: string, priceListId?: string, apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/pricing-periods/get-pricing-periods`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (productId !== undefined) {
                localVarQueryParameter['ProductId'] = productId;
            }

            if (priceListId !== undefined) {
                localVarQueryParameter['PriceListId'] = priceListId;
            }


    
            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Сохранить настройки промоакции периода
         * @param {string} id 
         * @param {string} [apiVersion] 
         * @param {SavePricingPeriodPromotionRequest} [savePricingPeriodPromotionRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        savePricingPeriodPromotion: async (id: string, apiVersion?: string, savePricingPeriodPromotionRequest?: SavePricingPeriodPromotionRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('savePricingPeriodPromotion', 'id', id)
            const localVarPath = `/api/v1/pricing-periods/{id}/promotion`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(savePricingPeriodPromotionRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PricingPeriodsApi - functional programming interface
 * @export
 */
export const PricingPeriodsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PricingPeriodsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Создать период продукта или прайс-листа
         * @param {string} [apiVersion] 
         * @param {CreatePricingPeriodRequest} [createPricingPeriodRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createPricingPeriod(apiVersion?: string, createPricingPeriodRequest?: CreatePricingPeriodRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PricingPeriodResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createPricingPeriod(apiVersion, createPricingPeriodRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PricingPeriodsApi.createPricingPeriod']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Удалить период по идентификатору
         * @param {string} id 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deletePricingPeriod(id: string, apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deletePricingPeriod(id, apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PricingPeriodsApi.deletePricingPeriod']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Получить период по идентификатору
         * @param {string} id 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPricingPeriodById(id: string, apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PricingPeriodResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPricingPeriodById(id, apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PricingPeriodsApi.getPricingPeriodById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Получить периоды продукта или прайс-листа
         * @param {string} [productId] Идентификатор продукта
         * @param {string} [priceListId] Идентификатор прайс-листа
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPricingPeriods(productId?: string, priceListId?: string, apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PricingPeriodResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPricingPeriods(productId, priceListId, apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PricingPeriodsApi.getPricingPeriods']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Сохранить настройки промоакции периода
         * @param {string} id 
         * @param {string} [apiVersion] 
         * @param {SavePricingPeriodPromotionRequest} [savePricingPeriodPromotionRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async savePricingPeriodPromotion(id: string, apiVersion?: string, savePricingPeriodPromotionRequest?: SavePricingPeriodPromotionRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PricingPeriodResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.savePricingPeriodPromotion(id, apiVersion, savePricingPeriodPromotionRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PricingPeriodsApi.savePricingPeriodPromotion']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * PricingPeriodsApi - factory interface
 * @export
 */
export const PricingPeriodsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PricingPeriodsApiFp(configuration)
    return {
        /**
         * 
         * @summary Создать период продукта или прайс-листа
         * @param {PricingPeriodsApiCreatePricingPeriodRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPricingPeriod(requestParameters: PricingPeriodsApiCreatePricingPeriodRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<PricingPeriodResponse> {
            return localVarFp.createPricingPeriod(requestParameters.apiVersion, requestParameters.createPricingPeriodRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Удалить период по идентификатору
         * @param {PricingPeriodsApiDeletePricingPeriodRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePricingPeriod(requestParameters: PricingPeriodsApiDeletePricingPeriodRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deletePricingPeriod(requestParameters.id, requestParameters.apiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Получить период по идентификатору
         * @param {PricingPeriodsApiGetPricingPeriodByIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPricingPeriodById(requestParameters: PricingPeriodsApiGetPricingPeriodByIdRequest, options?: RawAxiosRequestConfig): AxiosPromise<PricingPeriodResponse> {
            return localVarFp.getPricingPeriodById(requestParameters.id, requestParameters.apiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Получить периоды продукта или прайс-листа
         * @param {PricingPeriodsApiGetPricingPeriodsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPricingPeriods(requestParameters: PricingPeriodsApiGetPricingPeriodsRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<Array<PricingPeriodResponse>> {
            return localVarFp.getPricingPeriods(requestParameters.productId, requestParameters.priceListId, requestParameters.apiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Сохранить настройки промоакции периода
         * @param {PricingPeriodsApiSavePricingPeriodPromotionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        savePricingPeriodPromotion(requestParameters: PricingPeriodsApiSavePricingPeriodPromotionRequest, options?: RawAxiosRequestConfig): AxiosPromise<PricingPeriodResponse> {
            return localVarFp.savePricingPeriodPromotion(requestParameters.id, requestParameters.apiVersion, requestParameters.savePricingPeriodPromotionRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for createPricingPeriod operation in PricingPeriodsApi.
 * @export
 * @interface PricingPeriodsApiCreatePricingPeriodRequest
 */
export interface PricingPeriodsApiCreatePricingPeriodRequest {
    /**
     * 
     * @type {string}
     * @memberof PricingPeriodsApiCreatePricingPeriod
     */
    readonly apiVersion?: string

    /**
     * 
     * @type {CreatePricingPeriodRequest}
     * @memberof PricingPeriodsApiCreatePricingPeriod
     */
    readonly createPricingPeriodRequest?: CreatePricingPeriodRequest
}

/**
 * Request parameters for deletePricingPeriod operation in PricingPeriodsApi.
 * @export
 * @interface PricingPeriodsApiDeletePricingPeriodRequest
 */
export interface PricingPeriodsApiDeletePricingPeriodRequest {
    /**
     * 
     * @type {string}
     * @memberof PricingPeriodsApiDeletePricingPeriod
     */
    readonly id: string

    /**
     * 
     * @type {string}
     * @memberof PricingPeriodsApiDeletePricingPeriod
     */
    readonly apiVersion?: string
}

/**
 * Request parameters for getPricingPeriodById operation in PricingPeriodsApi.
 * @export
 * @interface PricingPeriodsApiGetPricingPeriodByIdRequest
 */
export interface PricingPeriodsApiGetPricingPeriodByIdRequest {
    /**
     * 
     * @type {string}
     * @memberof PricingPeriodsApiGetPricingPeriodById
     */
    readonly id: string

    /**
     * 
     * @type {string}
     * @memberof PricingPeriodsApiGetPricingPeriodById
     */
    readonly apiVersion?: string
}

/**
 * Request parameters for getPricingPeriods operation in PricingPeriodsApi.
 * @export
 * @interface PricingPeriodsApiGetPricingPeriodsRequest
 */
export interface PricingPeriodsApiGetPricingPeriodsRequest {
    /**
     * Идентификатор продукта
     * @type {string}
     * @memberof PricingPeriodsApiGetPricingPeriods
     */
    readonly productId?: string

    /**
     * Идентификатор прайс-листа
     * @type {string}
     * @memberof PricingPeriodsApiGetPricingPeriods
     */
    readonly priceListId?: string

    /**
     * 
     * @type {string}
     * @memberof PricingPeriodsApiGetPricingPeriods
     */
    readonly apiVersion?: string
}

/**
 * Request parameters for savePricingPeriodPromotion operation in PricingPeriodsApi.
 * @export
 * @interface PricingPeriodsApiSavePricingPeriodPromotionRequest
 */
export interface PricingPeriodsApiSavePricingPeriodPromotionRequest {
    /**
     * 
     * @type {string}
     * @memberof PricingPeriodsApiSavePricingPeriodPromotion
     */
    readonly id: string

    /**
     * 
     * @type {string}
     * @memberof PricingPeriodsApiSavePricingPeriodPromotion
     */
    readonly apiVersion?: string

    /**
     * 
     * @type {SavePricingPeriodPromotionRequest}
     * @memberof PricingPeriodsApiSavePricingPeriodPromotion
     */
    readonly savePricingPeriodPromotionRequest?: SavePricingPeriodPromotionRequest
}

/**
 * PricingPeriodsApi - object-oriented interface
 * @export
 * @class PricingPeriodsApi
 * @extends {BaseAPI}
 */
export class PricingPeriodsApi extends BaseAPI {
    /**
     * 
     * @summary Создать период продукта или прайс-листа
     * @param {PricingPeriodsApiCreatePricingPeriodRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PricingPeriodsApi
     */
    public createPricingPeriod(requestParameters: PricingPeriodsApiCreatePricingPeriodRequest = {}, options?: RawAxiosRequestConfig) {
        return PricingPeriodsApiFp(this.configuration).createPricingPeriod(requestParameters.apiVersion, requestParameters.createPricingPeriodRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Удалить период по идентификатору
     * @param {PricingPeriodsApiDeletePricingPeriodRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PricingPeriodsApi
     */
    public deletePricingPeriod(requestParameters: PricingPeriodsApiDeletePricingPeriodRequest, options?: RawAxiosRequestConfig) {
        return PricingPeriodsApiFp(this.configuration).deletePricingPeriod(requestParameters.id, requestParameters.apiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Получить период по идентификатору
     * @param {PricingPeriodsApiGetPricingPeriodByIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PricingPeriodsApi
     */
    public getPricingPeriodById(requestParameters: PricingPeriodsApiGetPricingPeriodByIdRequest, options?: RawAxiosRequestConfig) {
        return PricingPeriodsApiFp(this.configuration).getPricingPeriodById(requestParameters.id, requestParameters.apiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Получить периоды продукта или прайс-листа
     * @param {PricingPeriodsApiGetPricingPeriodsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PricingPeriodsApi
     */
    public getPricingPeriods(requestParameters: PricingPeriodsApiGetPricingPeriodsRequest = {}, options?: RawAxiosRequestConfig) {
        return PricingPeriodsApiFp(this.configuration).getPricingPeriods(requestParameters.productId, requestParameters.priceListId, requestParameters.apiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Сохранить настройки промоакции периода
     * @param {PricingPeriodsApiSavePricingPeriodPromotionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PricingPeriodsApi
     */
    public savePricingPeriodPromotion(requestParameters: PricingPeriodsApiSavePricingPeriodPromotionRequest, options?: RawAxiosRequestConfig) {
        return PricingPeriodsApiFp(this.configuration).savePricingPeriodPromotion(requestParameters.id, requestParameters.apiVersion, requestParameters.savePricingPeriodPromotionRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ProblemAddressesApi - axios parameter creator
 * @export
 */
export const ProblemAddressesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Получить координаты дома и историю проверки
         * @param {string} id 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProblemAddress: async (id: string, apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getProblemAddress', 'id', id)
            const localVarPath = `/api/v1/problem-addresses/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Получить страницу проблемных адресов
         * @param {string} [verifiedFrom] Дата проверки: начало периода
         * @param {string} [verifiedTo] Дата проверки: конец периода
         * @param {string} [search] Поиск по адресу
         * @param {string} [city] Город
         * @param {number} [qcGeo] Код исходной точности
         * @param {boolean} [isVerified] Координаты проверены оператором
         * @param {string} [searchQuery] Строка для поиска
         * @param {number} [takeCount] Размер страницы
         * @param {number} [skipCount] Кол-во пропущенных записей
         * @param {boolean} [ascending] Сортировка по возрастанию
         * @param {string} [ordering] Поле для сортировки
         * @param {boolean} [isDeleted] Удалённые записи
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProblemAddresses: async (verifiedFrom?: string, verifiedTo?: string, search?: string, city?: string, qcGeo?: number, isVerified?: boolean, searchQuery?: string, takeCount?: number, skipCount?: number, ascending?: boolean, ordering?: string, isDeleted?: boolean, apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/problem-addresses/get-problem-addresses`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (verifiedFrom !== undefined) {
                localVarQueryParameter['VerifiedFrom'] = (verifiedFrom as any instanceof Date) ?
                    (verifiedFrom as any).toISOString() :
                    verifiedFrom;
            }

            if (verifiedTo !== undefined) {
                localVarQueryParameter['VerifiedTo'] = (verifiedTo as any instanceof Date) ?
                    (verifiedTo as any).toISOString() :
                    verifiedTo;
            }

            if (search !== undefined) {
                localVarQueryParameter['Search'] = search;
            }

            if (city !== undefined) {
                localVarQueryParameter['City'] = city;
            }

            if (qcGeo !== undefined) {
                localVarQueryParameter['QcGeo'] = qcGeo;
            }

            if (isVerified !== undefined) {
                localVarQueryParameter['IsVerified'] = isVerified;
            }

            if (searchQuery !== undefined) {
                localVarQueryParameter['SearchQuery'] = searchQuery;
            }

            if (takeCount !== undefined) {
                localVarQueryParameter['TakeCount'] = takeCount;
            }

            if (skipCount !== undefined) {
                localVarQueryParameter['SkipCount'] = skipCount;
            }

            if (ascending !== undefined) {
                localVarQueryParameter['Ascending'] = ascending;
            }

            if (ordering !== undefined) {
                localVarQueryParameter['Ordering'] = ordering;
            }

            if (isDeleted !== undefined) {
                localVarQueryParameter['IsDeleted'] = isDeleted;
            }


    
            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Сохранить проверенные координаты дома
         * @param {string} id 
         * @param {string} [apiVersion] 
         * @param {VerifyAddressPointRequest} [verifyAddressPointRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        verifyAddressPoint: async (id: string, apiVersion?: string, verifyAddressPointRequest?: VerifyAddressPointRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('verifyAddressPoint', 'id', id)
            const localVarPath = `/api/v1/problem-addresses/{id}/verify`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(verifyAddressPointRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ProblemAddressesApi - functional programming interface
 * @export
 */
export const ProblemAddressesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ProblemAddressesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Получить координаты дома и историю проверки
         * @param {string} id 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProblemAddress(id: string, apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProblemAddressResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProblemAddress(id, apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProblemAddressesApi.getProblemAddress']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Получить страницу проблемных адресов
         * @param {string} [verifiedFrom] Дата проверки: начало периода
         * @param {string} [verifiedTo] Дата проверки: конец периода
         * @param {string} [search] Поиск по адресу
         * @param {string} [city] Город
         * @param {number} [qcGeo] Код исходной точности
         * @param {boolean} [isVerified] Координаты проверены оператором
         * @param {string} [searchQuery] Строка для поиска
         * @param {number} [takeCount] Размер страницы
         * @param {number} [skipCount] Кол-во пропущенных записей
         * @param {boolean} [ascending] Сортировка по возрастанию
         * @param {string} [ordering] Поле для сортировки
         * @param {boolean} [isDeleted] Удалённые записи
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProblemAddresses(verifiedFrom?: string, verifiedTo?: string, search?: string, city?: string, qcGeo?: number, isVerified?: boolean, searchQuery?: string, takeCount?: number, skipCount?: number, ascending?: boolean, ordering?: string, isDeleted?: boolean, apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetProblemAddressesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProblemAddresses(verifiedFrom, verifiedTo, search, city, qcGeo, isVerified, searchQuery, takeCount, skipCount, ascending, ordering, isDeleted, apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProblemAddressesApi.getProblemAddresses']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Сохранить проверенные координаты дома
         * @param {string} id 
         * @param {string} [apiVersion] 
         * @param {VerifyAddressPointRequest} [verifyAddressPointRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async verifyAddressPoint(id: string, apiVersion?: string, verifyAddressPointRequest?: VerifyAddressPointRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProblemAddressResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.verifyAddressPoint(id, apiVersion, verifyAddressPointRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProblemAddressesApi.verifyAddressPoint']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ProblemAddressesApi - factory interface
 * @export
 */
export const ProblemAddressesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ProblemAddressesApiFp(configuration)
    return {
        /**
         * 
         * @summary Получить координаты дома и историю проверки
         * @param {ProblemAddressesApiGetProblemAddressRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProblemAddress(requestParameters: ProblemAddressesApiGetProblemAddressRequest, options?: RawAxiosRequestConfig): AxiosPromise<ProblemAddressResponse> {
            return localVarFp.getProblemAddress(requestParameters.id, requestParameters.apiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Получить страницу проблемных адресов
         * @param {ProblemAddressesApiGetProblemAddressesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProblemAddresses(requestParameters: ProblemAddressesApiGetProblemAddressesRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<GetProblemAddressesResponse> {
            return localVarFp.getProblemAddresses(requestParameters.verifiedFrom, requestParameters.verifiedTo, requestParameters.search, requestParameters.city, requestParameters.qcGeo, requestParameters.isVerified, requestParameters.searchQuery, requestParameters.takeCount, requestParameters.skipCount, requestParameters.ascending, requestParameters.ordering, requestParameters.isDeleted, requestParameters.apiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Сохранить проверенные координаты дома
         * @param {ProblemAddressesApiVerifyAddressPointRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        verifyAddressPoint(requestParameters: ProblemAddressesApiVerifyAddressPointRequest, options?: RawAxiosRequestConfig): AxiosPromise<ProblemAddressResponse> {
            return localVarFp.verifyAddressPoint(requestParameters.id, requestParameters.apiVersion, requestParameters.verifyAddressPointRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for getProblemAddress operation in ProblemAddressesApi.
 * @export
 * @interface ProblemAddressesApiGetProblemAddressRequest
 */
export interface ProblemAddressesApiGetProblemAddressRequest {
    /**
     * 
     * @type {string}
     * @memberof ProblemAddressesApiGetProblemAddress
     */
    readonly id: string

    /**
     * 
     * @type {string}
     * @memberof ProblemAddressesApiGetProblemAddress
     */
    readonly apiVersion?: string
}

/**
 * Request parameters for getProblemAddresses operation in ProblemAddressesApi.
 * @export
 * @interface ProblemAddressesApiGetProblemAddressesRequest
 */
export interface ProblemAddressesApiGetProblemAddressesRequest {
    /**
     * Дата проверки: начало периода
     * @type {string}
     * @memberof ProblemAddressesApiGetProblemAddresses
     */
    readonly verifiedFrom?: string

    /**
     * Дата проверки: конец периода
     * @type {string}
     * @memberof ProblemAddressesApiGetProblemAddresses
     */
    readonly verifiedTo?: string

    /**
     * Поиск по адресу
     * @type {string}
     * @memberof ProblemAddressesApiGetProblemAddresses
     */
    readonly search?: string

    /**
     * Город
     * @type {string}
     * @memberof ProblemAddressesApiGetProblemAddresses
     */
    readonly city?: string

    /**
     * Код исходной точности
     * @type {number}
     * @memberof ProblemAddressesApiGetProblemAddresses
     */
    readonly qcGeo?: number

    /**
     * Координаты проверены оператором
     * @type {boolean}
     * @memberof ProblemAddressesApiGetProblemAddresses
     */
    readonly isVerified?: boolean

    /**
     * Строка для поиска
     * @type {string}
     * @memberof ProblemAddressesApiGetProblemAddresses
     */
    readonly searchQuery?: string

    /**
     * Размер страницы
     * @type {number}
     * @memberof ProblemAddressesApiGetProblemAddresses
     */
    readonly takeCount?: number

    /**
     * Кол-во пропущенных записей
     * @type {number}
     * @memberof ProblemAddressesApiGetProblemAddresses
     */
    readonly skipCount?: number

    /**
     * Сортировка по возрастанию
     * @type {boolean}
     * @memberof ProblemAddressesApiGetProblemAddresses
     */
    readonly ascending?: boolean

    /**
     * Поле для сортировки
     * @type {string}
     * @memberof ProblemAddressesApiGetProblemAddresses
     */
    readonly ordering?: string

    /**
     * Удалённые записи
     * @type {boolean}
     * @memberof ProblemAddressesApiGetProblemAddresses
     */
    readonly isDeleted?: boolean

    /**
     * 
     * @type {string}
     * @memberof ProblemAddressesApiGetProblemAddresses
     */
    readonly apiVersion?: string
}

/**
 * Request parameters for verifyAddressPoint operation in ProblemAddressesApi.
 * @export
 * @interface ProblemAddressesApiVerifyAddressPointRequest
 */
export interface ProblemAddressesApiVerifyAddressPointRequest {
    /**
     * 
     * @type {string}
     * @memberof ProblemAddressesApiVerifyAddressPoint
     */
    readonly id: string

    /**
     * 
     * @type {string}
     * @memberof ProblemAddressesApiVerifyAddressPoint
     */
    readonly apiVersion?: string

    /**
     * 
     * @type {VerifyAddressPointRequest}
     * @memberof ProblemAddressesApiVerifyAddressPoint
     */
    readonly verifyAddressPointRequest?: VerifyAddressPointRequest
}

/**
 * ProblemAddressesApi - object-oriented interface
 * @export
 * @class ProblemAddressesApi
 * @extends {BaseAPI}
 */
export class ProblemAddressesApi extends BaseAPI {
    /**
     * 
     * @summary Получить координаты дома и историю проверки
     * @param {ProblemAddressesApiGetProblemAddressRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProblemAddressesApi
     */
    public getProblemAddress(requestParameters: ProblemAddressesApiGetProblemAddressRequest, options?: RawAxiosRequestConfig) {
        return ProblemAddressesApiFp(this.configuration).getProblemAddress(requestParameters.id, requestParameters.apiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Получить страницу проблемных адресов
     * @param {ProblemAddressesApiGetProblemAddressesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProblemAddressesApi
     */
    public getProblemAddresses(requestParameters: ProblemAddressesApiGetProblemAddressesRequest = {}, options?: RawAxiosRequestConfig) {
        return ProblemAddressesApiFp(this.configuration).getProblemAddresses(requestParameters.verifiedFrom, requestParameters.verifiedTo, requestParameters.search, requestParameters.city, requestParameters.qcGeo, requestParameters.isVerified, requestParameters.searchQuery, requestParameters.takeCount, requestParameters.skipCount, requestParameters.ascending, requestParameters.ordering, requestParameters.isDeleted, requestParameters.apiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Сохранить проверенные координаты дома
     * @param {ProblemAddressesApiVerifyAddressPointRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProblemAddressesApi
     */
    public verifyAddressPoint(requestParameters: ProblemAddressesApiVerifyAddressPointRequest, options?: RawAxiosRequestConfig) {
        return ProblemAddressesApiFp(this.configuration).verifyAddressPoint(requestParameters.id, requestParameters.apiVersion, requestParameters.verifyAddressPointRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ProblemExecutorsApi - axios parameter creator
 * @export
 */
export const ProblemExecutorsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Получить страницу проблемных исполнителей
         * @param {string} [createdFrom] Дата отзыва: начало периода
         * @param {string} [createdTo] Дата отзыва: конец периода
         * @param {number} [skipCount] Количество пропускаемых отзывов
         * @param {number} [takeCount] Размер страницы
         * @param {number} [mark] Оценка клиента
         * @param {string} [executorFioSearch] Имя и фамилия исполнителя
         * @param {string} [executorPhoneSearch] Телефон исполнителя
         * @param {string} [clientNameSearch] Имя клиента
         * @param {string} [clientPhoneSearch] Телефон клиента
         * @param {string} [petNameSearch] Кличка питомца
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProblemExecutors: async (createdFrom?: string, createdTo?: string, skipCount?: number, takeCount?: number, mark?: number, executorFioSearch?: string, executorPhoneSearch?: string, clientNameSearch?: string, clientPhoneSearch?: string, petNameSearch?: string, apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/problem-executors`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (createdFrom !== undefined) {
                localVarQueryParameter['CreatedFrom'] = (createdFrom as any instanceof Date) ?
                    (createdFrom as any).toISOString() :
                    createdFrom;
            }

            if (createdTo !== undefined) {
                localVarQueryParameter['CreatedTo'] = (createdTo as any instanceof Date) ?
                    (createdTo as any).toISOString() :
                    createdTo;
            }

            if (skipCount !== undefined) {
                localVarQueryParameter['SkipCount'] = skipCount;
            }

            if (takeCount !== undefined) {
                localVarQueryParameter['TakeCount'] = takeCount;
            }

            if (mark !== undefined) {
                localVarQueryParameter['Mark'] = mark;
            }

            if (executorFioSearch !== undefined) {
                localVarQueryParameter['ExecutorFioSearch'] = executorFioSearch;
            }

            if (executorPhoneSearch !== undefined) {
                localVarQueryParameter['ExecutorPhoneSearch'] = executorPhoneSearch;
            }

            if (clientNameSearch !== undefined) {
                localVarQueryParameter['ClientNameSearch'] = clientNameSearch;
            }

            if (clientPhoneSearch !== undefined) {
                localVarQueryParameter['ClientPhoneSearch'] = clientPhoneSearch;
            }

            if (petNameSearch !== undefined) {
                localVarQueryParameter['PetNameSearch'] = petNameSearch;
            }


    
            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ProblemExecutorsApi - functional programming interface
 * @export
 */
export const ProblemExecutorsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ProblemExecutorsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Получить страницу проблемных исполнителей
         * @param {string} [createdFrom] Дата отзыва: начало периода
         * @param {string} [createdTo] Дата отзыва: конец периода
         * @param {number} [skipCount] Количество пропускаемых отзывов
         * @param {number} [takeCount] Размер страницы
         * @param {number} [mark] Оценка клиента
         * @param {string} [executorFioSearch] Имя и фамилия исполнителя
         * @param {string} [executorPhoneSearch] Телефон исполнителя
         * @param {string} [clientNameSearch] Имя клиента
         * @param {string} [clientPhoneSearch] Телефон клиента
         * @param {string} [petNameSearch] Кличка питомца
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProblemExecutors(createdFrom?: string, createdTo?: string, skipCount?: number, takeCount?: number, mark?: number, executorFioSearch?: string, executorPhoneSearch?: string, clientNameSearch?: string, clientPhoneSearch?: string, petNameSearch?: string, apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetProblemExecutorsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProblemExecutors(createdFrom, createdTo, skipCount, takeCount, mark, executorFioSearch, executorPhoneSearch, clientNameSearch, clientPhoneSearch, petNameSearch, apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProblemExecutorsApi.getProblemExecutors']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ProblemExecutorsApi - factory interface
 * @export
 */
export const ProblemExecutorsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ProblemExecutorsApiFp(configuration)
    return {
        /**
         * 
         * @summary Получить страницу проблемных исполнителей
         * @param {ProblemExecutorsApiGetProblemExecutorsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProblemExecutors(requestParameters: ProblemExecutorsApiGetProblemExecutorsRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<GetProblemExecutorsResponse> {
            return localVarFp.getProblemExecutors(requestParameters.createdFrom, requestParameters.createdTo, requestParameters.skipCount, requestParameters.takeCount, requestParameters.mark, requestParameters.executorFioSearch, requestParameters.executorPhoneSearch, requestParameters.clientNameSearch, requestParameters.clientPhoneSearch, requestParameters.petNameSearch, requestParameters.apiVersion, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for getProblemExecutors operation in ProblemExecutorsApi.
 * @export
 * @interface ProblemExecutorsApiGetProblemExecutorsRequest
 */
export interface ProblemExecutorsApiGetProblemExecutorsRequest {
    /**
     * Дата отзыва: начало периода
     * @type {string}
     * @memberof ProblemExecutorsApiGetProblemExecutors
     */
    readonly createdFrom?: string

    /**
     * Дата отзыва: конец периода
     * @type {string}
     * @memberof ProblemExecutorsApiGetProblemExecutors
     */
    readonly createdTo?: string

    /**
     * Количество пропускаемых отзывов
     * @type {number}
     * @memberof ProblemExecutorsApiGetProblemExecutors
     */
    readonly skipCount?: number

    /**
     * Размер страницы
     * @type {number}
     * @memberof ProblemExecutorsApiGetProblemExecutors
     */
    readonly takeCount?: number

    /**
     * Оценка клиента
     * @type {number}
     * @memberof ProblemExecutorsApiGetProblemExecutors
     */
    readonly mark?: number

    /**
     * Имя и фамилия исполнителя
     * @type {string}
     * @memberof ProblemExecutorsApiGetProblemExecutors
     */
    readonly executorFioSearch?: string

    /**
     * Телефон исполнителя
     * @type {string}
     * @memberof ProblemExecutorsApiGetProblemExecutors
     */
    readonly executorPhoneSearch?: string

    /**
     * Имя клиента
     * @type {string}
     * @memberof ProblemExecutorsApiGetProblemExecutors
     */
    readonly clientNameSearch?: string

    /**
     * Телефон клиента
     * @type {string}
     * @memberof ProblemExecutorsApiGetProblemExecutors
     */
    readonly clientPhoneSearch?: string

    /**
     * Кличка питомца
     * @type {string}
     * @memberof ProblemExecutorsApiGetProblemExecutors
     */
    readonly petNameSearch?: string

    /**
     * 
     * @type {string}
     * @memberof ProblemExecutorsApiGetProblemExecutors
     */
    readonly apiVersion?: string
}

/**
 * ProblemExecutorsApi - object-oriented interface
 * @export
 * @class ProblemExecutorsApi
 * @extends {BaseAPI}
 */
export class ProblemExecutorsApi extends BaseAPI {
    /**
     * 
     * @summary Получить страницу проблемных исполнителей
     * @param {ProblemExecutorsApiGetProblemExecutorsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProblemExecutorsApi
     */
    public getProblemExecutors(requestParameters: ProblemExecutorsApiGetProblemExecutorsRequest = {}, options?: RawAxiosRequestConfig) {
        return ProblemExecutorsApiFp(this.configuration).getProblemExecutors(requestParameters.createdFrom, requestParameters.createdTo, requestParameters.skipCount, requestParameters.takeCount, requestParameters.mark, requestParameters.executorFioSearch, requestParameters.executorPhoneSearch, requestParameters.clientNameSearch, requestParameters.clientPhoneSearch, requestParameters.petNameSearch, requestParameters.apiVersion, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ProductApi - axios parameter creator
 * @export
 */
export const ProductApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Удалить продукт
         * @param {string} id 
         * @param {string} [apiVersion] 
         * @param {DeleteRequest} [deleteRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ProductsIdDelete: async (id: string, apiVersion?: string, deleteRequest?: DeleteRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiV1ProductsIdDelete', 'id', id)
            const localVarPath = `/api/v1/products/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(deleteRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Создать продукт
         * @param {string} [apiVersion] 
         * @param {CreateProductRequest} [createProductRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createProduct: async (apiVersion?: string, createProductRequest?: CreateProductRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/products/create-product`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createProductRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Получить дополнительные продукты для заказа
         * @param {string} productId 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdditionalProductsForOrder: async (productId: string, apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'productId' is not null or undefined
            assertParamExists('getAdditionalProductsForOrder', 'productId', productId)
            const localVarPath = `/api/v1/products/get-additional-products-for-order/{productId}`
                .replace(`{${"productId"}}`, encodeURIComponent(String(productId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Получить дополнительные продукты по типам услуги и животного
         * @param {ApiPetType} [petType] Виды питомцев и совместный тип заказа
         * @param {ApiProductType} [productType] 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdditionalProductsForOrderByTypes: async (petType?: ApiPetType, productType?: ApiProductType, apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/products/get-additional-products-for-order-by-types`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (petType !== undefined) {
                localVarQueryParameter['petType'] = petType;
            }

            if (productType !== undefined) {
                localVarQueryParameter['productType'] = productType;
            }


    
            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Получить все продукты
         * @param {ApiProductType} [productType] Тип продукта
         * @param {ApiPetType} [petType] Тип животного
         * @param {boolean} [isBase] Признак основного продукта
         * @param {string} [searchQuery] Строка для поиска
         * @param {number} [takeCount] Размер страницы
         * @param {number} [skipCount] Кол-во пропущенных записей
         * @param {boolean} [ascending] Сортировка по возрастанию
         * @param {string} [ordering] Поле для сортировки
         * @param {boolean} [isDeleted] Удалённые записи
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllProducts: async (productType?: ApiProductType, petType?: ApiPetType, isBase?: boolean, searchQuery?: string, takeCount?: number, skipCount?: number, ascending?: boolean, ordering?: string, isDeleted?: boolean, apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/products/get-all-products`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (productType !== undefined) {
                localVarQueryParameter['ProductType'] = productType;
            }

            if (petType !== undefined) {
                localVarQueryParameter['PetType'] = petType;
            }

            if (isBase !== undefined) {
                localVarQueryParameter['IsBase'] = isBase;
            }

            if (searchQuery !== undefined) {
                localVarQueryParameter['SearchQuery'] = searchQuery;
            }

            if (takeCount !== undefined) {
                localVarQueryParameter['TakeCount'] = takeCount;
            }

            if (skipCount !== undefined) {
                localVarQueryParameter['SkipCount'] = skipCount;
            }

            if (ascending !== undefined) {
                localVarQueryParameter['Ascending'] = ascending;
            }

            if (ordering !== undefined) {
                localVarQueryParameter['Ordering'] = ordering;
            }

            if (isDeleted !== undefined) {
                localVarQueryParameter['IsDeleted'] = isDeleted;
            }


    
            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Получить предложенные базовые продукты для заказа
         * @param {string} [apiVersion] 
         * @param {GetBaseProductsForOrderRequest} [getBaseProductsForOrderRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBaseProductsForOrder: async (apiVersion?: string, getBaseProductsForOrderRequest?: GetBaseProductsForOrderRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/products/get-base-products-for-order`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(getBaseProductsForOrderRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Получить продукт по ID
         * @param {string} id 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductById: async (id: string, apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getProductById', 'id', id)
            const localVarPath = `/api/v1/products/get-product-by-id/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Обновить данные продукта
         * @param {string} [apiVersion] 
         * @param {UpdateProductRequest} [updateProductRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProduct: async (apiVersion?: string, updateProductRequest?: UpdateProductRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/products/update-product`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateProductRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ProductApi - functional programming interface
 * @export
 */
export const ProductApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ProductApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Удалить продукт
         * @param {string} id 
         * @param {string} [apiVersion] 
         * @param {DeleteRequest} [deleteRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1ProductsIdDelete(id: string, apiVersion?: string, deleteRequest?: DeleteRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1ProductsIdDelete(id, apiVersion, deleteRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductApi.apiV1ProductsIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Создать продукт
         * @param {string} [apiVersion] 
         * @param {CreateProductRequest} [createProductRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createProduct(apiVersion?: string, createProductRequest?: CreateProductRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProductResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createProduct(apiVersion, createProductRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductApi.createProduct']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Получить дополнительные продукты для заказа
         * @param {string} productId 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAdditionalProductsForOrder(productId: string, apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdditionalProductsForOrderResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAdditionalProductsForOrder(productId, apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductApi.getAdditionalProductsForOrder']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Получить дополнительные продукты по типам услуги и животного
         * @param {ApiPetType} [petType] Виды питомцев и совместный тип заказа
         * @param {ApiProductType} [productType] 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAdditionalProductsForOrderByTypes(petType?: ApiPetType, productType?: ApiProductType, apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdditionalProductsForOrderResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAdditionalProductsForOrderByTypes(petType, productType, apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductApi.getAdditionalProductsForOrderByTypes']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Получить все продукты
         * @param {ApiProductType} [productType] Тип продукта
         * @param {ApiPetType} [petType] Тип животного
         * @param {boolean} [isBase] Признак основного продукта
         * @param {string} [searchQuery] Строка для поиска
         * @param {number} [takeCount] Размер страницы
         * @param {number} [skipCount] Кол-во пропущенных записей
         * @param {boolean} [ascending] Сортировка по возрастанию
         * @param {string} [ordering] Поле для сортировки
         * @param {boolean} [isDeleted] Удалённые записи
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllProducts(productType?: ApiProductType, petType?: ApiPetType, isBase?: boolean, searchQuery?: string, takeCount?: number, skipCount?: number, ascending?: boolean, ordering?: string, isDeleted?: boolean, apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetAllProductsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllProducts(productType, petType, isBase, searchQuery, takeCount, skipCount, ascending, ordering, isDeleted, apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductApi.getAllProducts']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Получить предложенные базовые продукты для заказа
         * @param {string} [apiVersion] 
         * @param {GetBaseProductsForOrderRequest} [getBaseProductsForOrderRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getBaseProductsForOrder(apiVersion?: string, getBaseProductsForOrderRequest?: GetBaseProductsForOrderRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BaseProductsForOrderResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getBaseProductsForOrder(apiVersion, getBaseProductsForOrderRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductApi.getBaseProductsForOrder']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Получить продукт по ID
         * @param {string} id 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProductById(id: string, apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProductResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProductById(id, apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductApi.getProductById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Обновить данные продукта
         * @param {string} [apiVersion] 
         * @param {UpdateProductRequest} [updateProductRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateProduct(apiVersion?: string, updateProductRequest?: UpdateProductRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProductResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateProduct(apiVersion, updateProductRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductApi.updateProduct']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ProductApi - factory interface
 * @export
 */
export const ProductApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ProductApiFp(configuration)
    return {
        /**
         * 
         * @summary Удалить продукт
         * @param {ProductApiApiV1ProductsIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ProductsIdDelete(requestParameters: ProductApiApiV1ProductsIdDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiV1ProductsIdDelete(requestParameters.id, requestParameters.apiVersion, requestParameters.deleteRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Создать продукт
         * @param {ProductApiCreateProductRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createProduct(requestParameters: ProductApiCreateProductRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<ProductResponse> {
            return localVarFp.createProduct(requestParameters.apiVersion, requestParameters.createProductRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Получить дополнительные продукты для заказа
         * @param {ProductApiGetAdditionalProductsForOrderRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdditionalProductsForOrder(requestParameters: ProductApiGetAdditionalProductsForOrderRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdditionalProductsForOrderResponse> {
            return localVarFp.getAdditionalProductsForOrder(requestParameters.productId, requestParameters.apiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Получить дополнительные продукты по типам услуги и животного
         * @param {ProductApiGetAdditionalProductsForOrderByTypesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdditionalProductsForOrderByTypes(requestParameters: ProductApiGetAdditionalProductsForOrderByTypesRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<AdditionalProductsForOrderResponse> {
            return localVarFp.getAdditionalProductsForOrderByTypes(requestParameters.petType, requestParameters.productType, requestParameters.apiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Получить все продукты
         * @param {ProductApiGetAllProductsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllProducts(requestParameters: ProductApiGetAllProductsRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<GetAllProductsResponse> {
            return localVarFp.getAllProducts(requestParameters.productType, requestParameters.petType, requestParameters.isBase, requestParameters.searchQuery, requestParameters.takeCount, requestParameters.skipCount, requestParameters.ascending, requestParameters.ordering, requestParameters.isDeleted, requestParameters.apiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Получить предложенные базовые продукты для заказа
         * @param {ProductApiGetBaseProductsForOrderRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBaseProductsForOrder(requestParameters: ProductApiGetBaseProductsForOrderRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<BaseProductsForOrderResponse> {
            return localVarFp.getBaseProductsForOrder(requestParameters.apiVersion, requestParameters.getBaseProductsForOrderRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Получить продукт по ID
         * @param {ProductApiGetProductByIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductById(requestParameters: ProductApiGetProductByIdRequest, options?: RawAxiosRequestConfig): AxiosPromise<ProductResponse> {
            return localVarFp.getProductById(requestParameters.id, requestParameters.apiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Обновить данные продукта
         * @param {ProductApiUpdateProductRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProduct(requestParameters: ProductApiUpdateProductRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<ProductResponse> {
            return localVarFp.updateProduct(requestParameters.apiVersion, requestParameters.updateProductRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for apiV1ProductsIdDelete operation in ProductApi.
 * @export
 * @interface ProductApiApiV1ProductsIdDeleteRequest
 */
export interface ProductApiApiV1ProductsIdDeleteRequest {
    /**
     * 
     * @type {string}
     * @memberof ProductApiApiV1ProductsIdDelete
     */
    readonly id: string

    /**
     * 
     * @type {string}
     * @memberof ProductApiApiV1ProductsIdDelete
     */
    readonly apiVersion?: string

    /**
     * 
     * @type {DeleteRequest}
     * @memberof ProductApiApiV1ProductsIdDelete
     */
    readonly deleteRequest?: DeleteRequest
}

/**
 * Request parameters for createProduct operation in ProductApi.
 * @export
 * @interface ProductApiCreateProductRequest
 */
export interface ProductApiCreateProductRequest {
    /**
     * 
     * @type {string}
     * @memberof ProductApiCreateProduct
     */
    readonly apiVersion?: string

    /**
     * 
     * @type {CreateProductRequest}
     * @memberof ProductApiCreateProduct
     */
    readonly createProductRequest?: CreateProductRequest
}

/**
 * Request parameters for getAdditionalProductsForOrder operation in ProductApi.
 * @export
 * @interface ProductApiGetAdditionalProductsForOrderRequest
 */
export interface ProductApiGetAdditionalProductsForOrderRequest {
    /**
     * 
     * @type {string}
     * @memberof ProductApiGetAdditionalProductsForOrder
     */
    readonly productId: string

    /**
     * 
     * @type {string}
     * @memberof ProductApiGetAdditionalProductsForOrder
     */
    readonly apiVersion?: string
}

/**
 * Request parameters for getAdditionalProductsForOrderByTypes operation in ProductApi.
 * @export
 * @interface ProductApiGetAdditionalProductsForOrderByTypesRequest
 */
export interface ProductApiGetAdditionalProductsForOrderByTypesRequest {
    /**
     * Виды питомцев и совместный тип заказа
     * @type {ApiPetType}
     * @memberof ProductApiGetAdditionalProductsForOrderByTypes
     */
    readonly petType?: ApiPetType

    /**
     * 
     * @type {ApiProductType}
     * @memberof ProductApiGetAdditionalProductsForOrderByTypes
     */
    readonly productType?: ApiProductType

    /**
     * 
     * @type {string}
     * @memberof ProductApiGetAdditionalProductsForOrderByTypes
     */
    readonly apiVersion?: string
}

/**
 * Request parameters for getAllProducts operation in ProductApi.
 * @export
 * @interface ProductApiGetAllProductsRequest
 */
export interface ProductApiGetAllProductsRequest {
    /**
     * Тип продукта
     * @type {ApiProductType}
     * @memberof ProductApiGetAllProducts
     */
    readonly productType?: ApiProductType

    /**
     * Тип животного
     * @type {ApiPetType}
     * @memberof ProductApiGetAllProducts
     */
    readonly petType?: ApiPetType

    /**
     * Признак основного продукта
     * @type {boolean}
     * @memberof ProductApiGetAllProducts
     */
    readonly isBase?: boolean

    /**
     * Строка для поиска
     * @type {string}
     * @memberof ProductApiGetAllProducts
     */
    readonly searchQuery?: string

    /**
     * Размер страницы
     * @type {number}
     * @memberof ProductApiGetAllProducts
     */
    readonly takeCount?: number

    /**
     * Кол-во пропущенных записей
     * @type {number}
     * @memberof ProductApiGetAllProducts
     */
    readonly skipCount?: number

    /**
     * Сортировка по возрастанию
     * @type {boolean}
     * @memberof ProductApiGetAllProducts
     */
    readonly ascending?: boolean

    /**
     * Поле для сортировки
     * @type {string}
     * @memberof ProductApiGetAllProducts
     */
    readonly ordering?: string

    /**
     * Удалённые записи
     * @type {boolean}
     * @memberof ProductApiGetAllProducts
     */
    readonly isDeleted?: boolean

    /**
     * 
     * @type {string}
     * @memberof ProductApiGetAllProducts
     */
    readonly apiVersion?: string
}

/**
 * Request parameters for getBaseProductsForOrder operation in ProductApi.
 * @export
 * @interface ProductApiGetBaseProductsForOrderRequest
 */
export interface ProductApiGetBaseProductsForOrderRequest {
    /**
     * 
     * @type {string}
     * @memberof ProductApiGetBaseProductsForOrder
     */
    readonly apiVersion?: string

    /**
     * 
     * @type {GetBaseProductsForOrderRequest}
     * @memberof ProductApiGetBaseProductsForOrder
     */
    readonly getBaseProductsForOrderRequest?: GetBaseProductsForOrderRequest
}

/**
 * Request parameters for getProductById operation in ProductApi.
 * @export
 * @interface ProductApiGetProductByIdRequest
 */
export interface ProductApiGetProductByIdRequest {
    /**
     * 
     * @type {string}
     * @memberof ProductApiGetProductById
     */
    readonly id: string

    /**
     * 
     * @type {string}
     * @memberof ProductApiGetProductById
     */
    readonly apiVersion?: string
}

/**
 * Request parameters for updateProduct operation in ProductApi.
 * @export
 * @interface ProductApiUpdateProductRequest
 */
export interface ProductApiUpdateProductRequest {
    /**
     * 
     * @type {string}
     * @memberof ProductApiUpdateProduct
     */
    readonly apiVersion?: string

    /**
     * 
     * @type {UpdateProductRequest}
     * @memberof ProductApiUpdateProduct
     */
    readonly updateProductRequest?: UpdateProductRequest
}

/**
 * ProductApi - object-oriented interface
 * @export
 * @class ProductApi
 * @extends {BaseAPI}
 */
export class ProductApi extends BaseAPI {
    /**
     * 
     * @summary Удалить продукт
     * @param {ProductApiApiV1ProductsIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductApi
     */
    public apiV1ProductsIdDelete(requestParameters: ProductApiApiV1ProductsIdDeleteRequest, options?: RawAxiosRequestConfig) {
        return ProductApiFp(this.configuration).apiV1ProductsIdDelete(requestParameters.id, requestParameters.apiVersion, requestParameters.deleteRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Создать продукт
     * @param {ProductApiCreateProductRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductApi
     */
    public createProduct(requestParameters: ProductApiCreateProductRequest = {}, options?: RawAxiosRequestConfig) {
        return ProductApiFp(this.configuration).createProduct(requestParameters.apiVersion, requestParameters.createProductRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Получить дополнительные продукты для заказа
     * @param {ProductApiGetAdditionalProductsForOrderRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductApi
     */
    public getAdditionalProductsForOrder(requestParameters: ProductApiGetAdditionalProductsForOrderRequest, options?: RawAxiosRequestConfig) {
        return ProductApiFp(this.configuration).getAdditionalProductsForOrder(requestParameters.productId, requestParameters.apiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Получить дополнительные продукты по типам услуги и животного
     * @param {ProductApiGetAdditionalProductsForOrderByTypesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductApi
     */
    public getAdditionalProductsForOrderByTypes(requestParameters: ProductApiGetAdditionalProductsForOrderByTypesRequest = {}, options?: RawAxiosRequestConfig) {
        return ProductApiFp(this.configuration).getAdditionalProductsForOrderByTypes(requestParameters.petType, requestParameters.productType, requestParameters.apiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Получить все продукты
     * @param {ProductApiGetAllProductsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductApi
     */
    public getAllProducts(requestParameters: ProductApiGetAllProductsRequest = {}, options?: RawAxiosRequestConfig) {
        return ProductApiFp(this.configuration).getAllProducts(requestParameters.productType, requestParameters.petType, requestParameters.isBase, requestParameters.searchQuery, requestParameters.takeCount, requestParameters.skipCount, requestParameters.ascending, requestParameters.ordering, requestParameters.isDeleted, requestParameters.apiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Получить предложенные базовые продукты для заказа
     * @param {ProductApiGetBaseProductsForOrderRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductApi
     */
    public getBaseProductsForOrder(requestParameters: ProductApiGetBaseProductsForOrderRequest = {}, options?: RawAxiosRequestConfig) {
        return ProductApiFp(this.configuration).getBaseProductsForOrder(requestParameters.apiVersion, requestParameters.getBaseProductsForOrderRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Получить продукт по ID
     * @param {ProductApiGetProductByIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductApi
     */
    public getProductById(requestParameters: ProductApiGetProductByIdRequest, options?: RawAxiosRequestConfig) {
        return ProductApiFp(this.configuration).getProductById(requestParameters.id, requestParameters.apiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Обновить данные продукта
     * @param {ProductApiUpdateProductRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductApi
     */
    public updateProduct(requestParameters: ProductApiUpdateProductRequest = {}, options?: RawAxiosRequestConfig) {
        return ProductApiFp(this.configuration).updateProduct(requestParameters.apiVersion, requestParameters.updateProductRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * PromoCodeApi - axios parameter creator
 * @export
 */
export const PromoCodeApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Активировать промокод
         * @param {string} id 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PromocodesActivateIdPost: async (id: string, apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiV1PromocodesActivateIdPost', 'id', id)
            const localVarPath = `/api/v1/promocodes/activate/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Заблокировать промокод
         * @param {string} id 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PromocodesBlockIdDelete: async (id: string, apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiV1PromocodesBlockIdDelete', 'id', id)
            const localVarPath = `/api/v1/promocodes/block/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Получить все промокоды
         * @param {string} [activationFrom] Дата активации: включительное начало периода
         * @param {string} [activationTo] Дата активации: исключительное окончание периода
         * @param {string} [printingId] Тираж промокодов
         * @param {string} [createdFrom] Дата создания: начало периода
         * @param {string} [createdTo] Дата создания: конец периода
         * @param {string} [numberSearch] Номер промокода
         * @param {Array<ApiPromoCodeStatus>} [statuses] Статусы промокодов
         * @param {Array<ApiPromoCodeType>} [types] Типы промокодов
         * @param {string} [searchQuery] Строка для поиска
         * @param {number} [takeCount] Размер страницы
         * @param {number} [skipCount] Кол-во пропущенных записей
         * @param {boolean} [ascending] Сортировка по возрастанию
         * @param {string} [ordering] Поле для сортировки
         * @param {boolean} [isDeleted] Удалённые записи
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PromocodesGetPromoCodesGet: async (activationFrom?: string, activationTo?: string, printingId?: string, createdFrom?: string, createdTo?: string, numberSearch?: string, statuses?: Array<ApiPromoCodeStatus>, types?: Array<ApiPromoCodeType>, searchQuery?: string, takeCount?: number, skipCount?: number, ascending?: boolean, ordering?: string, isDeleted?: boolean, apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/promocodes/get-promo-codes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (activationFrom !== undefined) {
                localVarQueryParameter['ActivationFrom'] = (activationFrom as any instanceof Date) ?
                    (activationFrom as any).toISOString() :
                    activationFrom;
            }

            if (activationTo !== undefined) {
                localVarQueryParameter['ActivationTo'] = (activationTo as any instanceof Date) ?
                    (activationTo as any).toISOString() :
                    activationTo;
            }

            if (printingId !== undefined) {
                localVarQueryParameter['PrintingId'] = printingId;
            }

            if (createdFrom !== undefined) {
                localVarQueryParameter['CreatedFrom'] = (createdFrom as any instanceof Date) ?
                    (createdFrom as any).toISOString() :
                    createdFrom;
            }

            if (createdTo !== undefined) {
                localVarQueryParameter['CreatedTo'] = (createdTo as any instanceof Date) ?
                    (createdTo as any).toISOString() :
                    createdTo;
            }

            if (numberSearch !== undefined) {
                localVarQueryParameter['NumberSearch'] = numberSearch;
            }

            if (statuses) {
                localVarQueryParameter['Statuses'] = statuses;
            }

            if (types) {
                localVarQueryParameter['Types'] = types;
            }

            if (searchQuery !== undefined) {
                localVarQueryParameter['SearchQuery'] = searchQuery;
            }

            if (takeCount !== undefined) {
                localVarQueryParameter['TakeCount'] = takeCount;
            }

            if (skipCount !== undefined) {
                localVarQueryParameter['SkipCount'] = skipCount;
            }

            if (ascending !== undefined) {
                localVarQueryParameter['Ascending'] = ascending;
            }

            if (ordering !== undefined) {
                localVarQueryParameter['Ordering'] = ordering;
            }

            if (isDeleted !== undefined) {
                localVarQueryParameter['IsDeleted'] = isDeleted;
            }


    
            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Создать промокод
         * @param {string} [apiVersion] 
         * @param {CreatePromoCodeRequest} [createPromoCodeRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPromoCode: async (apiVersion?: string, createPromoCodeRequest?: CreatePromoCodeRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/promocodes/create-promo-code`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createPromoCodeRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Получить промокод по идентификатору
         * @param {string} id 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPromoCodeById: async (id: string, apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getPromoCodeById', 'id', id)
            const localVarPath = `/api/v1/promocodes/get-promo-code-by-id/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Обновить данные промокода
         * @param {string} [apiVersion] 
         * @param {UpdatePromoCodeRequest} [updatePromoCodeRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePromoCode: async (apiVersion?: string, updatePromoCodeRequest?: UpdatePromoCodeRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/promocodes/update-promo-code`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updatePromoCodeRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PromoCodeApi - functional programming interface
 * @export
 */
export const PromoCodeApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PromoCodeApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Активировать промокод
         * @param {string} id 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1PromocodesActivateIdPost(id: string, apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1PromocodesActivateIdPost(id, apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PromoCodeApi.apiV1PromocodesActivateIdPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Заблокировать промокод
         * @param {string} id 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1PromocodesBlockIdDelete(id: string, apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1PromocodesBlockIdDelete(id, apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PromoCodeApi.apiV1PromocodesBlockIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Получить все промокоды
         * @param {string} [activationFrom] Дата активации: включительное начало периода
         * @param {string} [activationTo] Дата активации: исключительное окончание периода
         * @param {string} [printingId] Тираж промокодов
         * @param {string} [createdFrom] Дата создания: начало периода
         * @param {string} [createdTo] Дата создания: конец периода
         * @param {string} [numberSearch] Номер промокода
         * @param {Array<ApiPromoCodeStatus>} [statuses] Статусы промокодов
         * @param {Array<ApiPromoCodeType>} [types] Типы промокодов
         * @param {string} [searchQuery] Строка для поиска
         * @param {number} [takeCount] Размер страницы
         * @param {number} [skipCount] Кол-во пропущенных записей
         * @param {boolean} [ascending] Сортировка по возрастанию
         * @param {string} [ordering] Поле для сортировки
         * @param {boolean} [isDeleted] Удалённые записи
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1PromocodesGetPromoCodesGet(activationFrom?: string, activationTo?: string, printingId?: string, createdFrom?: string, createdTo?: string, numberSearch?: string, statuses?: Array<ApiPromoCodeStatus>, types?: Array<ApiPromoCodeType>, searchQuery?: string, takeCount?: number, skipCount?: number, ascending?: boolean, ordering?: string, isDeleted?: boolean, apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetPromoCodesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1PromocodesGetPromoCodesGet(activationFrom, activationTo, printingId, createdFrom, createdTo, numberSearch, statuses, types, searchQuery, takeCount, skipCount, ascending, ordering, isDeleted, apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PromoCodeApi.apiV1PromocodesGetPromoCodesGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Создать промокод
         * @param {string} [apiVersion] 
         * @param {CreatePromoCodeRequest} [createPromoCodeRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createPromoCode(apiVersion?: string, createPromoCodeRequest?: CreatePromoCodeRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PromoCodeResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createPromoCode(apiVersion, createPromoCodeRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PromoCodeApi.createPromoCode']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Получить промокод по идентификатору
         * @param {string} id 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPromoCodeById(id: string, apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PromoCodeResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPromoCodeById(id, apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PromoCodeApi.getPromoCodeById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Обновить данные промокода
         * @param {string} [apiVersion] 
         * @param {UpdatePromoCodeRequest} [updatePromoCodeRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updatePromoCode(apiVersion?: string, updatePromoCodeRequest?: UpdatePromoCodeRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PromoCodeResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updatePromoCode(apiVersion, updatePromoCodeRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PromoCodeApi.updatePromoCode']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * PromoCodeApi - factory interface
 * @export
 */
export const PromoCodeApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PromoCodeApiFp(configuration)
    return {
        /**
         * 
         * @summary Активировать промокод
         * @param {PromoCodeApiApiV1PromocodesActivateIdPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PromocodesActivateIdPost(requestParameters: PromoCodeApiApiV1PromocodesActivateIdPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiV1PromocodesActivateIdPost(requestParameters.id, requestParameters.apiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Заблокировать промокод
         * @param {PromoCodeApiApiV1PromocodesBlockIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PromocodesBlockIdDelete(requestParameters: PromoCodeApiApiV1PromocodesBlockIdDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiV1PromocodesBlockIdDelete(requestParameters.id, requestParameters.apiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Получить все промокоды
         * @param {PromoCodeApiApiV1PromocodesGetPromoCodesGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PromocodesGetPromoCodesGet(requestParameters: PromoCodeApiApiV1PromocodesGetPromoCodesGetRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<GetPromoCodesResponse> {
            return localVarFp.apiV1PromocodesGetPromoCodesGet(requestParameters.activationFrom, requestParameters.activationTo, requestParameters.printingId, requestParameters.createdFrom, requestParameters.createdTo, requestParameters.numberSearch, requestParameters.statuses, requestParameters.types, requestParameters.searchQuery, requestParameters.takeCount, requestParameters.skipCount, requestParameters.ascending, requestParameters.ordering, requestParameters.isDeleted, requestParameters.apiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Создать промокод
         * @param {PromoCodeApiCreatePromoCodeRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPromoCode(requestParameters: PromoCodeApiCreatePromoCodeRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<PromoCodeResponse> {
            return localVarFp.createPromoCode(requestParameters.apiVersion, requestParameters.createPromoCodeRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Получить промокод по идентификатору
         * @param {PromoCodeApiGetPromoCodeByIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPromoCodeById(requestParameters: PromoCodeApiGetPromoCodeByIdRequest, options?: RawAxiosRequestConfig): AxiosPromise<PromoCodeResponse> {
            return localVarFp.getPromoCodeById(requestParameters.id, requestParameters.apiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Обновить данные промокода
         * @param {PromoCodeApiUpdatePromoCodeRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePromoCode(requestParameters: PromoCodeApiUpdatePromoCodeRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<PromoCodeResponse> {
            return localVarFp.updatePromoCode(requestParameters.apiVersion, requestParameters.updatePromoCodeRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for apiV1PromocodesActivateIdPost operation in PromoCodeApi.
 * @export
 * @interface PromoCodeApiApiV1PromocodesActivateIdPostRequest
 */
export interface PromoCodeApiApiV1PromocodesActivateIdPostRequest {
    /**
     * 
     * @type {string}
     * @memberof PromoCodeApiApiV1PromocodesActivateIdPost
     */
    readonly id: string

    /**
     * 
     * @type {string}
     * @memberof PromoCodeApiApiV1PromocodesActivateIdPost
     */
    readonly apiVersion?: string
}

/**
 * Request parameters for apiV1PromocodesBlockIdDelete operation in PromoCodeApi.
 * @export
 * @interface PromoCodeApiApiV1PromocodesBlockIdDeleteRequest
 */
export interface PromoCodeApiApiV1PromocodesBlockIdDeleteRequest {
    /**
     * 
     * @type {string}
     * @memberof PromoCodeApiApiV1PromocodesBlockIdDelete
     */
    readonly id: string

    /**
     * 
     * @type {string}
     * @memberof PromoCodeApiApiV1PromocodesBlockIdDelete
     */
    readonly apiVersion?: string
}

/**
 * Request parameters for apiV1PromocodesGetPromoCodesGet operation in PromoCodeApi.
 * @export
 * @interface PromoCodeApiApiV1PromocodesGetPromoCodesGetRequest
 */
export interface PromoCodeApiApiV1PromocodesGetPromoCodesGetRequest {
    /**
     * Дата активации: включительное начало периода
     * @type {string}
     * @memberof PromoCodeApiApiV1PromocodesGetPromoCodesGet
     */
    readonly activationFrom?: string

    /**
     * Дата активации: исключительное окончание периода
     * @type {string}
     * @memberof PromoCodeApiApiV1PromocodesGetPromoCodesGet
     */
    readonly activationTo?: string

    /**
     * Тираж промокодов
     * @type {string}
     * @memberof PromoCodeApiApiV1PromocodesGetPromoCodesGet
     */
    readonly printingId?: string

    /**
     * Дата создания: начало периода
     * @type {string}
     * @memberof PromoCodeApiApiV1PromocodesGetPromoCodesGet
     */
    readonly createdFrom?: string

    /**
     * Дата создания: конец периода
     * @type {string}
     * @memberof PromoCodeApiApiV1PromocodesGetPromoCodesGet
     */
    readonly createdTo?: string

    /**
     * Номер промокода
     * @type {string}
     * @memberof PromoCodeApiApiV1PromocodesGetPromoCodesGet
     */
    readonly numberSearch?: string

    /**
     * Статусы промокодов
     * @type {Array<ApiPromoCodeStatus>}
     * @memberof PromoCodeApiApiV1PromocodesGetPromoCodesGet
     */
    readonly statuses?: Array<ApiPromoCodeStatus>

    /**
     * Типы промокодов
     * @type {Array<ApiPromoCodeType>}
     * @memberof PromoCodeApiApiV1PromocodesGetPromoCodesGet
     */
    readonly types?: Array<ApiPromoCodeType>

    /**
     * Строка для поиска
     * @type {string}
     * @memberof PromoCodeApiApiV1PromocodesGetPromoCodesGet
     */
    readonly searchQuery?: string

    /**
     * Размер страницы
     * @type {number}
     * @memberof PromoCodeApiApiV1PromocodesGetPromoCodesGet
     */
    readonly takeCount?: number

    /**
     * Кол-во пропущенных записей
     * @type {number}
     * @memberof PromoCodeApiApiV1PromocodesGetPromoCodesGet
     */
    readonly skipCount?: number

    /**
     * Сортировка по возрастанию
     * @type {boolean}
     * @memberof PromoCodeApiApiV1PromocodesGetPromoCodesGet
     */
    readonly ascending?: boolean

    /**
     * Поле для сортировки
     * @type {string}
     * @memberof PromoCodeApiApiV1PromocodesGetPromoCodesGet
     */
    readonly ordering?: string

    /**
     * Удалённые записи
     * @type {boolean}
     * @memberof PromoCodeApiApiV1PromocodesGetPromoCodesGet
     */
    readonly isDeleted?: boolean

    /**
     * 
     * @type {string}
     * @memberof PromoCodeApiApiV1PromocodesGetPromoCodesGet
     */
    readonly apiVersion?: string
}

/**
 * Request parameters for createPromoCode operation in PromoCodeApi.
 * @export
 * @interface PromoCodeApiCreatePromoCodeRequest
 */
export interface PromoCodeApiCreatePromoCodeRequest {
    /**
     * 
     * @type {string}
     * @memberof PromoCodeApiCreatePromoCode
     */
    readonly apiVersion?: string

    /**
     * 
     * @type {CreatePromoCodeRequest}
     * @memberof PromoCodeApiCreatePromoCode
     */
    readonly createPromoCodeRequest?: CreatePromoCodeRequest
}

/**
 * Request parameters for getPromoCodeById operation in PromoCodeApi.
 * @export
 * @interface PromoCodeApiGetPromoCodeByIdRequest
 */
export interface PromoCodeApiGetPromoCodeByIdRequest {
    /**
     * 
     * @type {string}
     * @memberof PromoCodeApiGetPromoCodeById
     */
    readonly id: string

    /**
     * 
     * @type {string}
     * @memberof PromoCodeApiGetPromoCodeById
     */
    readonly apiVersion?: string
}

/**
 * Request parameters for updatePromoCode operation in PromoCodeApi.
 * @export
 * @interface PromoCodeApiUpdatePromoCodeRequest
 */
export interface PromoCodeApiUpdatePromoCodeRequest {
    /**
     * 
     * @type {string}
     * @memberof PromoCodeApiUpdatePromoCode
     */
    readonly apiVersion?: string

    /**
     * 
     * @type {UpdatePromoCodeRequest}
     * @memberof PromoCodeApiUpdatePromoCode
     */
    readonly updatePromoCodeRequest?: UpdatePromoCodeRequest
}

/**
 * PromoCodeApi - object-oriented interface
 * @export
 * @class PromoCodeApi
 * @extends {BaseAPI}
 */
export class PromoCodeApi extends BaseAPI {
    /**
     * 
     * @summary Активировать промокод
     * @param {PromoCodeApiApiV1PromocodesActivateIdPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PromoCodeApi
     */
    public apiV1PromocodesActivateIdPost(requestParameters: PromoCodeApiApiV1PromocodesActivateIdPostRequest, options?: RawAxiosRequestConfig) {
        return PromoCodeApiFp(this.configuration).apiV1PromocodesActivateIdPost(requestParameters.id, requestParameters.apiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Заблокировать промокод
     * @param {PromoCodeApiApiV1PromocodesBlockIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PromoCodeApi
     */
    public apiV1PromocodesBlockIdDelete(requestParameters: PromoCodeApiApiV1PromocodesBlockIdDeleteRequest, options?: RawAxiosRequestConfig) {
        return PromoCodeApiFp(this.configuration).apiV1PromocodesBlockIdDelete(requestParameters.id, requestParameters.apiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Получить все промокоды
     * @param {PromoCodeApiApiV1PromocodesGetPromoCodesGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PromoCodeApi
     */
    public apiV1PromocodesGetPromoCodesGet(requestParameters: PromoCodeApiApiV1PromocodesGetPromoCodesGetRequest = {}, options?: RawAxiosRequestConfig) {
        return PromoCodeApiFp(this.configuration).apiV1PromocodesGetPromoCodesGet(requestParameters.activationFrom, requestParameters.activationTo, requestParameters.printingId, requestParameters.createdFrom, requestParameters.createdTo, requestParameters.numberSearch, requestParameters.statuses, requestParameters.types, requestParameters.searchQuery, requestParameters.takeCount, requestParameters.skipCount, requestParameters.ascending, requestParameters.ordering, requestParameters.isDeleted, requestParameters.apiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Создать промокод
     * @param {PromoCodeApiCreatePromoCodeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PromoCodeApi
     */
    public createPromoCode(requestParameters: PromoCodeApiCreatePromoCodeRequest = {}, options?: RawAxiosRequestConfig) {
        return PromoCodeApiFp(this.configuration).createPromoCode(requestParameters.apiVersion, requestParameters.createPromoCodeRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Получить промокод по идентификатору
     * @param {PromoCodeApiGetPromoCodeByIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PromoCodeApi
     */
    public getPromoCodeById(requestParameters: PromoCodeApiGetPromoCodeByIdRequest, options?: RawAxiosRequestConfig) {
        return PromoCodeApiFp(this.configuration).getPromoCodeById(requestParameters.id, requestParameters.apiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Обновить данные промокода
     * @param {PromoCodeApiUpdatePromoCodeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PromoCodeApi
     */
    public updatePromoCode(requestParameters: PromoCodeApiUpdatePromoCodeRequest = {}, options?: RawAxiosRequestConfig) {
        return PromoCodeApiFp(this.configuration).updatePromoCode(requestParameters.apiVersion, requestParameters.updatePromoCodeRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * PromoCodePrintingApi - axios parameter creator
 * @export
 */
export const PromoCodePrintingApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Активировать новые промокоды тиража
         * @param {string} id 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        activatePromoCodePrinting: async (id: string, apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('activatePromoCodePrinting', 'id', id)
            const localVarPath = `/api/v1/promo-code-printings/{id}/activate`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Заблокировать только оставшиеся новые коды тиража
         * @param {string} id 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        blockNewPromoCodePrinting: async (id: string, apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('blockNewPromoCodePrinting', 'id', id)
            const localVarPath = `/api/v1/promo-code-printings/{id}/block-new`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Заблокировать все промокоды тиража независимо от текущего статуса
         * @param {string} id 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        blockPromoCodePrinting: async (id: string, apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('blockPromoCodePrinting', 'id', id)
            const localVarPath = `/api/v1/promo-code-printings/{id}/block`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Создать тираж существующего шаблона
         * @param {string} [apiVersion] 
         * @param {CreatePromoCodePrintingRequest} [createPromoCodePrintingRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPromoCodePrinting: async (apiVersion?: string, createPromoCodePrintingRequest?: CreatePromoCodePrintingRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/promo-code-printings/create`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createPromoCodePrintingRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Выгрузить номера тиража в Excel
         * @param {string} id 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportPromoCodePrinting: async (id: string, apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('exportPromoCodePrinting', 'id', id)
            const localVarPath = `/api/v1/promo-code-printings/{id}/export`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Сгенерировать номера полного тиража
         * @param {string} id 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generatePromoCodePrinting: async (id: string, apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('generatePromoCodePrinting', 'id', id)
            const localVarPath = `/api/v1/promo-code-printings/{id}/generate`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Получить сведения одного тиража
         * @param {string} id 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPromoCodePrinting: async (id: string, apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getPromoCodePrinting', 'id', id)
            const localVarPath = `/api/v1/promo-code-printings/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Получить страницу тиражей
         * @param {string} [createdFrom] Дата создания: включительное начало периода
         * @param {string} [createdTo] Дата создания: исключительное окончание периода
         * @param {string} [issuedFrom] Дата выпуска: включительное начало периода
         * @param {string} [issuedTo] Дата выпуска: исключительное окончание периода
         * @param {string} [templateId] Идентификатор шаблона
         * @param {number} [skipCount] Количество пропускаемых записей
         * @param {number} [takeCount] Размер страницы
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPromoCodePrintings: async (createdFrom?: string, createdTo?: string, issuedFrom?: string, issuedTo?: string, templateId?: string, skipCount?: number, takeCount?: number, apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/promo-code-printings`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (createdFrom !== undefined) {
                localVarQueryParameter['CreatedFrom'] = (createdFrom as any instanceof Date) ?
                    (createdFrom as any).toISOString() :
                    createdFrom;
            }

            if (createdTo !== undefined) {
                localVarQueryParameter['CreatedTo'] = (createdTo as any instanceof Date) ?
                    (createdTo as any).toISOString() :
                    createdTo;
            }

            if (issuedFrom !== undefined) {
                localVarQueryParameter['IssuedFrom'] = (issuedFrom as any instanceof Date) ?
                    (issuedFrom as any).toISOString() :
                    issuedFrom;
            }

            if (issuedTo !== undefined) {
                localVarQueryParameter['IssuedTo'] = (issuedTo as any instanceof Date) ?
                    (issuedTo as any).toISOString() :
                    issuedTo;
            }

            if (templateId !== undefined) {
                localVarQueryParameter['TemplateId'] = templateId;
            }

            if (skipCount !== undefined) {
                localVarQueryParameter['SkipCount'] = skipCount;
            }

            if (takeCount !== undefined) {
                localVarQueryParameter['TakeCount'] = takeCount;
            }


    
            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Импортировать промокоды тиража из Excel
         * @param {string} id 
         * @param {string} [apiVersion] 
         * @param {File} [file] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importPromoCodePrinting: async (id: string, apiVersion?: string, file?: File, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('importPromoCodePrinting', 'id', id)
            const localVarPath = `/api/v1/promo-code-printings/{id}/import`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PromoCodePrintingApi - functional programming interface
 * @export
 */
export const PromoCodePrintingApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PromoCodePrintingApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Активировать новые промокоды тиража
         * @param {string} id 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async activatePromoCodePrinting(id: string, apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PromoCodePrintingResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.activatePromoCodePrinting(id, apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PromoCodePrintingApi.activatePromoCodePrinting']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Заблокировать только оставшиеся новые коды тиража
         * @param {string} id 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async blockNewPromoCodePrinting(id: string, apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PromoCodePrintingResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.blockNewPromoCodePrinting(id, apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PromoCodePrintingApi.blockNewPromoCodePrinting']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Заблокировать все промокоды тиража независимо от текущего статуса
         * @param {string} id 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async blockPromoCodePrinting(id: string, apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PromoCodePrintingResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.blockPromoCodePrinting(id, apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PromoCodePrintingApi.blockPromoCodePrinting']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Создать тираж существующего шаблона
         * @param {string} [apiVersion] 
         * @param {CreatePromoCodePrintingRequest} [createPromoCodePrintingRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createPromoCodePrinting(apiVersion?: string, createPromoCodePrintingRequest?: CreatePromoCodePrintingRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PromoCodePrintingResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createPromoCodePrinting(apiVersion, createPromoCodePrintingRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PromoCodePrintingApi.createPromoCodePrinting']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Выгрузить номера тиража в Excel
         * @param {string} id 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async exportPromoCodePrinting(id: string, apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.exportPromoCodePrinting(id, apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PromoCodePrintingApi.exportPromoCodePrinting']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Сгенерировать номера полного тиража
         * @param {string} id 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async generatePromoCodePrinting(id: string, apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PromoCodePrintingResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.generatePromoCodePrinting(id, apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PromoCodePrintingApi.generatePromoCodePrinting']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Получить сведения одного тиража
         * @param {string} id 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPromoCodePrinting(id: string, apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PromoCodePrintingResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPromoCodePrinting(id, apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PromoCodePrintingApi.getPromoCodePrinting']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Получить страницу тиражей
         * @param {string} [createdFrom] Дата создания: включительное начало периода
         * @param {string} [createdTo] Дата создания: исключительное окончание периода
         * @param {string} [issuedFrom] Дата выпуска: включительное начало периода
         * @param {string} [issuedTo] Дата выпуска: исключительное окончание периода
         * @param {string} [templateId] Идентификатор шаблона
         * @param {number} [skipCount] Количество пропускаемых записей
         * @param {number} [takeCount] Размер страницы
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPromoCodePrintings(createdFrom?: string, createdTo?: string, issuedFrom?: string, issuedTo?: string, templateId?: string, skipCount?: number, takeCount?: number, apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetPromoCodePrintingsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPromoCodePrintings(createdFrom, createdTo, issuedFrom, issuedTo, templateId, skipCount, takeCount, apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PromoCodePrintingApi.getPromoCodePrintings']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Импортировать промокоды тиража из Excel
         * @param {string} id 
         * @param {string} [apiVersion] 
         * @param {File} [file] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async importPromoCodePrinting(id: string, apiVersion?: string, file?: File, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PromoCodePrintingResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.importPromoCodePrinting(id, apiVersion, file, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PromoCodePrintingApi.importPromoCodePrinting']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * PromoCodePrintingApi - factory interface
 * @export
 */
export const PromoCodePrintingApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PromoCodePrintingApiFp(configuration)
    return {
        /**
         * 
         * @summary Активировать новые промокоды тиража
         * @param {PromoCodePrintingApiActivatePromoCodePrintingRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        activatePromoCodePrinting(requestParameters: PromoCodePrintingApiActivatePromoCodePrintingRequest, options?: RawAxiosRequestConfig): AxiosPromise<PromoCodePrintingResponse> {
            return localVarFp.activatePromoCodePrinting(requestParameters.id, requestParameters.apiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Заблокировать только оставшиеся новые коды тиража
         * @param {PromoCodePrintingApiBlockNewPromoCodePrintingRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        blockNewPromoCodePrinting(requestParameters: PromoCodePrintingApiBlockNewPromoCodePrintingRequest, options?: RawAxiosRequestConfig): AxiosPromise<PromoCodePrintingResponse> {
            return localVarFp.blockNewPromoCodePrinting(requestParameters.id, requestParameters.apiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Заблокировать все промокоды тиража независимо от текущего статуса
         * @param {PromoCodePrintingApiBlockPromoCodePrintingRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        blockPromoCodePrinting(requestParameters: PromoCodePrintingApiBlockPromoCodePrintingRequest, options?: RawAxiosRequestConfig): AxiosPromise<PromoCodePrintingResponse> {
            return localVarFp.blockPromoCodePrinting(requestParameters.id, requestParameters.apiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Создать тираж существующего шаблона
         * @param {PromoCodePrintingApiCreatePromoCodePrintingRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPromoCodePrinting(requestParameters: PromoCodePrintingApiCreatePromoCodePrintingRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<PromoCodePrintingResponse> {
            return localVarFp.createPromoCodePrinting(requestParameters.apiVersion, requestParameters.createPromoCodePrintingRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Выгрузить номера тиража в Excel
         * @param {PromoCodePrintingApiExportPromoCodePrintingRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportPromoCodePrinting(requestParameters: PromoCodePrintingApiExportPromoCodePrintingRequest, options?: RawAxiosRequestConfig): AxiosPromise<File> {
            return localVarFp.exportPromoCodePrinting(requestParameters.id, requestParameters.apiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Сгенерировать номера полного тиража
         * @param {PromoCodePrintingApiGeneratePromoCodePrintingRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generatePromoCodePrinting(requestParameters: PromoCodePrintingApiGeneratePromoCodePrintingRequest, options?: RawAxiosRequestConfig): AxiosPromise<PromoCodePrintingResponse> {
            return localVarFp.generatePromoCodePrinting(requestParameters.id, requestParameters.apiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Получить сведения одного тиража
         * @param {PromoCodePrintingApiGetPromoCodePrintingRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPromoCodePrinting(requestParameters: PromoCodePrintingApiGetPromoCodePrintingRequest, options?: RawAxiosRequestConfig): AxiosPromise<PromoCodePrintingResponse> {
            return localVarFp.getPromoCodePrinting(requestParameters.id, requestParameters.apiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Получить страницу тиражей
         * @param {PromoCodePrintingApiGetPromoCodePrintingsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPromoCodePrintings(requestParameters: PromoCodePrintingApiGetPromoCodePrintingsRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<GetPromoCodePrintingsResponse> {
            return localVarFp.getPromoCodePrintings(requestParameters.createdFrom, requestParameters.createdTo, requestParameters.issuedFrom, requestParameters.issuedTo, requestParameters.templateId, requestParameters.skipCount, requestParameters.takeCount, requestParameters.apiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Импортировать промокоды тиража из Excel
         * @param {PromoCodePrintingApiImportPromoCodePrintingRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importPromoCodePrinting(requestParameters: PromoCodePrintingApiImportPromoCodePrintingRequest, options?: RawAxiosRequestConfig): AxiosPromise<PromoCodePrintingResponse> {
            return localVarFp.importPromoCodePrinting(requestParameters.id, requestParameters.apiVersion, requestParameters.file, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for activatePromoCodePrinting operation in PromoCodePrintingApi.
 * @export
 * @interface PromoCodePrintingApiActivatePromoCodePrintingRequest
 */
export interface PromoCodePrintingApiActivatePromoCodePrintingRequest {
    /**
     * 
     * @type {string}
     * @memberof PromoCodePrintingApiActivatePromoCodePrinting
     */
    readonly id: string

    /**
     * 
     * @type {string}
     * @memberof PromoCodePrintingApiActivatePromoCodePrinting
     */
    readonly apiVersion?: string
}

/**
 * Request parameters for blockNewPromoCodePrinting operation in PromoCodePrintingApi.
 * @export
 * @interface PromoCodePrintingApiBlockNewPromoCodePrintingRequest
 */
export interface PromoCodePrintingApiBlockNewPromoCodePrintingRequest {
    /**
     * 
     * @type {string}
     * @memberof PromoCodePrintingApiBlockNewPromoCodePrinting
     */
    readonly id: string

    /**
     * 
     * @type {string}
     * @memberof PromoCodePrintingApiBlockNewPromoCodePrinting
     */
    readonly apiVersion?: string
}

/**
 * Request parameters for blockPromoCodePrinting operation in PromoCodePrintingApi.
 * @export
 * @interface PromoCodePrintingApiBlockPromoCodePrintingRequest
 */
export interface PromoCodePrintingApiBlockPromoCodePrintingRequest {
    /**
     * 
     * @type {string}
     * @memberof PromoCodePrintingApiBlockPromoCodePrinting
     */
    readonly id: string

    /**
     * 
     * @type {string}
     * @memberof PromoCodePrintingApiBlockPromoCodePrinting
     */
    readonly apiVersion?: string
}

/**
 * Request parameters for createPromoCodePrinting operation in PromoCodePrintingApi.
 * @export
 * @interface PromoCodePrintingApiCreatePromoCodePrintingRequest
 */
export interface PromoCodePrintingApiCreatePromoCodePrintingRequest {
    /**
     * 
     * @type {string}
     * @memberof PromoCodePrintingApiCreatePromoCodePrinting
     */
    readonly apiVersion?: string

    /**
     * 
     * @type {CreatePromoCodePrintingRequest}
     * @memberof PromoCodePrintingApiCreatePromoCodePrinting
     */
    readonly createPromoCodePrintingRequest?: CreatePromoCodePrintingRequest
}

/**
 * Request parameters for exportPromoCodePrinting operation in PromoCodePrintingApi.
 * @export
 * @interface PromoCodePrintingApiExportPromoCodePrintingRequest
 */
export interface PromoCodePrintingApiExportPromoCodePrintingRequest {
    /**
     * 
     * @type {string}
     * @memberof PromoCodePrintingApiExportPromoCodePrinting
     */
    readonly id: string

    /**
     * 
     * @type {string}
     * @memberof PromoCodePrintingApiExportPromoCodePrinting
     */
    readonly apiVersion?: string
}

/**
 * Request parameters for generatePromoCodePrinting operation in PromoCodePrintingApi.
 * @export
 * @interface PromoCodePrintingApiGeneratePromoCodePrintingRequest
 */
export interface PromoCodePrintingApiGeneratePromoCodePrintingRequest {
    /**
     * 
     * @type {string}
     * @memberof PromoCodePrintingApiGeneratePromoCodePrinting
     */
    readonly id: string

    /**
     * 
     * @type {string}
     * @memberof PromoCodePrintingApiGeneratePromoCodePrinting
     */
    readonly apiVersion?: string
}

/**
 * Request parameters for getPromoCodePrinting operation in PromoCodePrintingApi.
 * @export
 * @interface PromoCodePrintingApiGetPromoCodePrintingRequest
 */
export interface PromoCodePrintingApiGetPromoCodePrintingRequest {
    /**
     * 
     * @type {string}
     * @memberof PromoCodePrintingApiGetPromoCodePrinting
     */
    readonly id: string

    /**
     * 
     * @type {string}
     * @memberof PromoCodePrintingApiGetPromoCodePrinting
     */
    readonly apiVersion?: string
}

/**
 * Request parameters for getPromoCodePrintings operation in PromoCodePrintingApi.
 * @export
 * @interface PromoCodePrintingApiGetPromoCodePrintingsRequest
 */
export interface PromoCodePrintingApiGetPromoCodePrintingsRequest {
    /**
     * Дата создания: включительное начало периода
     * @type {string}
     * @memberof PromoCodePrintingApiGetPromoCodePrintings
     */
    readonly createdFrom?: string

    /**
     * Дата создания: исключительное окончание периода
     * @type {string}
     * @memberof PromoCodePrintingApiGetPromoCodePrintings
     */
    readonly createdTo?: string

    /**
     * Дата выпуска: включительное начало периода
     * @type {string}
     * @memberof PromoCodePrintingApiGetPromoCodePrintings
     */
    readonly issuedFrom?: string

    /**
     * Дата выпуска: исключительное окончание периода
     * @type {string}
     * @memberof PromoCodePrintingApiGetPromoCodePrintings
     */
    readonly issuedTo?: string

    /**
     * Идентификатор шаблона
     * @type {string}
     * @memberof PromoCodePrintingApiGetPromoCodePrintings
     */
    readonly templateId?: string

    /**
     * Количество пропускаемых записей
     * @type {number}
     * @memberof PromoCodePrintingApiGetPromoCodePrintings
     */
    readonly skipCount?: number

    /**
     * Размер страницы
     * @type {number}
     * @memberof PromoCodePrintingApiGetPromoCodePrintings
     */
    readonly takeCount?: number

    /**
     * 
     * @type {string}
     * @memberof PromoCodePrintingApiGetPromoCodePrintings
     */
    readonly apiVersion?: string
}

/**
 * Request parameters for importPromoCodePrinting operation in PromoCodePrintingApi.
 * @export
 * @interface PromoCodePrintingApiImportPromoCodePrintingRequest
 */
export interface PromoCodePrintingApiImportPromoCodePrintingRequest {
    /**
     * 
     * @type {string}
     * @memberof PromoCodePrintingApiImportPromoCodePrinting
     */
    readonly id: string

    /**
     * 
     * @type {string}
     * @memberof PromoCodePrintingApiImportPromoCodePrinting
     */
    readonly apiVersion?: string

    /**
     * 
     * @type {File}
     * @memberof PromoCodePrintingApiImportPromoCodePrinting
     */
    readonly file?: File
}

/**
 * PromoCodePrintingApi - object-oriented interface
 * @export
 * @class PromoCodePrintingApi
 * @extends {BaseAPI}
 */
export class PromoCodePrintingApi extends BaseAPI {
    /**
     * 
     * @summary Активировать новые промокоды тиража
     * @param {PromoCodePrintingApiActivatePromoCodePrintingRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PromoCodePrintingApi
     */
    public activatePromoCodePrinting(requestParameters: PromoCodePrintingApiActivatePromoCodePrintingRequest, options?: RawAxiosRequestConfig) {
        return PromoCodePrintingApiFp(this.configuration).activatePromoCodePrinting(requestParameters.id, requestParameters.apiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Заблокировать только оставшиеся новые коды тиража
     * @param {PromoCodePrintingApiBlockNewPromoCodePrintingRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PromoCodePrintingApi
     */
    public blockNewPromoCodePrinting(requestParameters: PromoCodePrintingApiBlockNewPromoCodePrintingRequest, options?: RawAxiosRequestConfig) {
        return PromoCodePrintingApiFp(this.configuration).blockNewPromoCodePrinting(requestParameters.id, requestParameters.apiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Заблокировать все промокоды тиража независимо от текущего статуса
     * @param {PromoCodePrintingApiBlockPromoCodePrintingRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PromoCodePrintingApi
     */
    public blockPromoCodePrinting(requestParameters: PromoCodePrintingApiBlockPromoCodePrintingRequest, options?: RawAxiosRequestConfig) {
        return PromoCodePrintingApiFp(this.configuration).blockPromoCodePrinting(requestParameters.id, requestParameters.apiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Создать тираж существующего шаблона
     * @param {PromoCodePrintingApiCreatePromoCodePrintingRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PromoCodePrintingApi
     */
    public createPromoCodePrinting(requestParameters: PromoCodePrintingApiCreatePromoCodePrintingRequest = {}, options?: RawAxiosRequestConfig) {
        return PromoCodePrintingApiFp(this.configuration).createPromoCodePrinting(requestParameters.apiVersion, requestParameters.createPromoCodePrintingRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Выгрузить номера тиража в Excel
     * @param {PromoCodePrintingApiExportPromoCodePrintingRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PromoCodePrintingApi
     */
    public exportPromoCodePrinting(requestParameters: PromoCodePrintingApiExportPromoCodePrintingRequest, options?: RawAxiosRequestConfig) {
        return PromoCodePrintingApiFp(this.configuration).exportPromoCodePrinting(requestParameters.id, requestParameters.apiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Сгенерировать номера полного тиража
     * @param {PromoCodePrintingApiGeneratePromoCodePrintingRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PromoCodePrintingApi
     */
    public generatePromoCodePrinting(requestParameters: PromoCodePrintingApiGeneratePromoCodePrintingRequest, options?: RawAxiosRequestConfig) {
        return PromoCodePrintingApiFp(this.configuration).generatePromoCodePrinting(requestParameters.id, requestParameters.apiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Получить сведения одного тиража
     * @param {PromoCodePrintingApiGetPromoCodePrintingRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PromoCodePrintingApi
     */
    public getPromoCodePrinting(requestParameters: PromoCodePrintingApiGetPromoCodePrintingRequest, options?: RawAxiosRequestConfig) {
        return PromoCodePrintingApiFp(this.configuration).getPromoCodePrinting(requestParameters.id, requestParameters.apiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Получить страницу тиражей
     * @param {PromoCodePrintingApiGetPromoCodePrintingsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PromoCodePrintingApi
     */
    public getPromoCodePrintings(requestParameters: PromoCodePrintingApiGetPromoCodePrintingsRequest = {}, options?: RawAxiosRequestConfig) {
        return PromoCodePrintingApiFp(this.configuration).getPromoCodePrintings(requestParameters.createdFrom, requestParameters.createdTo, requestParameters.issuedFrom, requestParameters.issuedTo, requestParameters.templateId, requestParameters.skipCount, requestParameters.takeCount, requestParameters.apiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Импортировать промокоды тиража из Excel
     * @param {PromoCodePrintingApiImportPromoCodePrintingRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PromoCodePrintingApi
     */
    public importPromoCodePrinting(requestParameters: PromoCodePrintingApiImportPromoCodePrintingRequest, options?: RawAxiosRequestConfig) {
        return PromoCodePrintingApiFp(this.configuration).importPromoCodePrinting(requestParameters.id, requestParameters.apiVersion, requestParameters.file, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * PromoCodeTemplateApi - axios parameter creator
 * @export
 */
export const PromoCodeTemplateApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Получить условия одного шаблона
         * @param {string} id 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPromoCodeTemplate: async (id: string, apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getPromoCodeTemplate', 'id', id)
            const localVarPath = `/api/v1/promo-code-templates/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Получить страницу шаблонов
         * @param {Array<ApiPromoCodeType>} [types] Типы скидки
         * @param {number} [discount] Значение скидки
         * @param {string} [createdFrom] Дата создания: включительное начало периода
         * @param {string} [createdTo] Дата создания: исключительное окончание периода
         * @param {string} [searchQuery] Поиск по названию
         * @param {number} [skipCount] Количество пропускаемых записей
         * @param {number} [takeCount] Размер страницы
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPromoCodeTemplates: async (types?: Array<ApiPromoCodeType>, discount?: number, createdFrom?: string, createdTo?: string, searchQuery?: string, skipCount?: number, takeCount?: number, apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/promo-code-templates`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (types) {
                localVarQueryParameter['Types'] = types;
            }

            if (discount !== undefined) {
                localVarQueryParameter['Discount'] = discount;
            }

            if (createdFrom !== undefined) {
                localVarQueryParameter['CreatedFrom'] = (createdFrom as any instanceof Date) ?
                    (createdFrom as any).toISOString() :
                    createdFrom;
            }

            if (createdTo !== undefined) {
                localVarQueryParameter['CreatedTo'] = (createdTo as any instanceof Date) ?
                    (createdTo as any).toISOString() :
                    createdTo;
            }

            if (searchQuery !== undefined) {
                localVarQueryParameter['SearchQuery'] = searchQuery;
            }

            if (skipCount !== undefined) {
                localVarQueryParameter['SkipCount'] = skipCount;
            }

            if (takeCount !== undefined) {
                localVarQueryParameter['TakeCount'] = takeCount;
            }


    
            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Создать либо изменить шаблон с проверкой версии
         * @param {string} [apiVersion] 
         * @param {SavePromoCodeTemplateRequest} [savePromoCodeTemplateRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        savePromoCodeTemplate: async (apiVersion?: string, savePromoCodeTemplateRequest?: SavePromoCodeTemplateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/promo-code-templates/save`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(savePromoCodeTemplateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PromoCodeTemplateApi - functional programming interface
 * @export
 */
export const PromoCodeTemplateApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PromoCodeTemplateApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Получить условия одного шаблона
         * @param {string} id 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPromoCodeTemplate(id: string, apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PromoCodeTemplateResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPromoCodeTemplate(id, apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PromoCodeTemplateApi.getPromoCodeTemplate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Получить страницу шаблонов
         * @param {Array<ApiPromoCodeType>} [types] Типы скидки
         * @param {number} [discount] Значение скидки
         * @param {string} [createdFrom] Дата создания: включительное начало периода
         * @param {string} [createdTo] Дата создания: исключительное окончание периода
         * @param {string} [searchQuery] Поиск по названию
         * @param {number} [skipCount] Количество пропускаемых записей
         * @param {number} [takeCount] Размер страницы
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPromoCodeTemplates(types?: Array<ApiPromoCodeType>, discount?: number, createdFrom?: string, createdTo?: string, searchQuery?: string, skipCount?: number, takeCount?: number, apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetPromoCodeTemplatesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPromoCodeTemplates(types, discount, createdFrom, createdTo, searchQuery, skipCount, takeCount, apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PromoCodeTemplateApi.getPromoCodeTemplates']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Создать либо изменить шаблон с проверкой версии
         * @param {string} [apiVersion] 
         * @param {SavePromoCodeTemplateRequest} [savePromoCodeTemplateRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async savePromoCodeTemplate(apiVersion?: string, savePromoCodeTemplateRequest?: SavePromoCodeTemplateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PromoCodeTemplateResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.savePromoCodeTemplate(apiVersion, savePromoCodeTemplateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PromoCodeTemplateApi.savePromoCodeTemplate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * PromoCodeTemplateApi - factory interface
 * @export
 */
export const PromoCodeTemplateApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PromoCodeTemplateApiFp(configuration)
    return {
        /**
         * 
         * @summary Получить условия одного шаблона
         * @param {PromoCodeTemplateApiGetPromoCodeTemplateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPromoCodeTemplate(requestParameters: PromoCodeTemplateApiGetPromoCodeTemplateRequest, options?: RawAxiosRequestConfig): AxiosPromise<PromoCodeTemplateResponse> {
            return localVarFp.getPromoCodeTemplate(requestParameters.id, requestParameters.apiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Получить страницу шаблонов
         * @param {PromoCodeTemplateApiGetPromoCodeTemplatesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPromoCodeTemplates(requestParameters: PromoCodeTemplateApiGetPromoCodeTemplatesRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<GetPromoCodeTemplatesResponse> {
            return localVarFp.getPromoCodeTemplates(requestParameters.types, requestParameters.discount, requestParameters.createdFrom, requestParameters.createdTo, requestParameters.searchQuery, requestParameters.skipCount, requestParameters.takeCount, requestParameters.apiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Создать либо изменить шаблон с проверкой версии
         * @param {PromoCodeTemplateApiSavePromoCodeTemplateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        savePromoCodeTemplate(requestParameters: PromoCodeTemplateApiSavePromoCodeTemplateRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<PromoCodeTemplateResponse> {
            return localVarFp.savePromoCodeTemplate(requestParameters.apiVersion, requestParameters.savePromoCodeTemplateRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for getPromoCodeTemplate operation in PromoCodeTemplateApi.
 * @export
 * @interface PromoCodeTemplateApiGetPromoCodeTemplateRequest
 */
export interface PromoCodeTemplateApiGetPromoCodeTemplateRequest {
    /**
     * 
     * @type {string}
     * @memberof PromoCodeTemplateApiGetPromoCodeTemplate
     */
    readonly id: string

    /**
     * 
     * @type {string}
     * @memberof PromoCodeTemplateApiGetPromoCodeTemplate
     */
    readonly apiVersion?: string
}

/**
 * Request parameters for getPromoCodeTemplates operation in PromoCodeTemplateApi.
 * @export
 * @interface PromoCodeTemplateApiGetPromoCodeTemplatesRequest
 */
export interface PromoCodeTemplateApiGetPromoCodeTemplatesRequest {
    /**
     * Типы скидки
     * @type {Array<ApiPromoCodeType>}
     * @memberof PromoCodeTemplateApiGetPromoCodeTemplates
     */
    readonly types?: Array<ApiPromoCodeType>

    /**
     * Значение скидки
     * @type {number}
     * @memberof PromoCodeTemplateApiGetPromoCodeTemplates
     */
    readonly discount?: number

    /**
     * Дата создания: включительное начало периода
     * @type {string}
     * @memberof PromoCodeTemplateApiGetPromoCodeTemplates
     */
    readonly createdFrom?: string

    /**
     * Дата создания: исключительное окончание периода
     * @type {string}
     * @memberof PromoCodeTemplateApiGetPromoCodeTemplates
     */
    readonly createdTo?: string

    /**
     * Поиск по названию
     * @type {string}
     * @memberof PromoCodeTemplateApiGetPromoCodeTemplates
     */
    readonly searchQuery?: string

    /**
     * Количество пропускаемых записей
     * @type {number}
     * @memberof PromoCodeTemplateApiGetPromoCodeTemplates
     */
    readonly skipCount?: number

    /**
     * Размер страницы
     * @type {number}
     * @memberof PromoCodeTemplateApiGetPromoCodeTemplates
     */
    readonly takeCount?: number

    /**
     * 
     * @type {string}
     * @memberof PromoCodeTemplateApiGetPromoCodeTemplates
     */
    readonly apiVersion?: string
}

/**
 * Request parameters for savePromoCodeTemplate operation in PromoCodeTemplateApi.
 * @export
 * @interface PromoCodeTemplateApiSavePromoCodeTemplateRequest
 */
export interface PromoCodeTemplateApiSavePromoCodeTemplateRequest {
    /**
     * 
     * @type {string}
     * @memberof PromoCodeTemplateApiSavePromoCodeTemplate
     */
    readonly apiVersion?: string

    /**
     * 
     * @type {SavePromoCodeTemplateRequest}
     * @memberof PromoCodeTemplateApiSavePromoCodeTemplate
     */
    readonly savePromoCodeTemplateRequest?: SavePromoCodeTemplateRequest
}

/**
 * PromoCodeTemplateApi - object-oriented interface
 * @export
 * @class PromoCodeTemplateApi
 * @extends {BaseAPI}
 */
export class PromoCodeTemplateApi extends BaseAPI {
    /**
     * 
     * @summary Получить условия одного шаблона
     * @param {PromoCodeTemplateApiGetPromoCodeTemplateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PromoCodeTemplateApi
     */
    public getPromoCodeTemplate(requestParameters: PromoCodeTemplateApiGetPromoCodeTemplateRequest, options?: RawAxiosRequestConfig) {
        return PromoCodeTemplateApiFp(this.configuration).getPromoCodeTemplate(requestParameters.id, requestParameters.apiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Получить страницу шаблонов
     * @param {PromoCodeTemplateApiGetPromoCodeTemplatesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PromoCodeTemplateApi
     */
    public getPromoCodeTemplates(requestParameters: PromoCodeTemplateApiGetPromoCodeTemplatesRequest = {}, options?: RawAxiosRequestConfig) {
        return PromoCodeTemplateApiFp(this.configuration).getPromoCodeTemplates(requestParameters.types, requestParameters.discount, requestParameters.createdFrom, requestParameters.createdTo, requestParameters.searchQuery, requestParameters.skipCount, requestParameters.takeCount, requestParameters.apiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Создать либо изменить шаблон с проверкой версии
     * @param {PromoCodeTemplateApiSavePromoCodeTemplateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PromoCodeTemplateApi
     */
    public savePromoCodeTemplate(requestParameters: PromoCodeTemplateApiSavePromoCodeTemplateRequest = {}, options?: RawAxiosRequestConfig) {
        return PromoCodeTemplateApiFp(this.configuration).savePromoCodeTemplate(requestParameters.apiVersion, requestParameters.savePromoCodeTemplateRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * PromotionBannerTemplatesApi - axios parameter creator
 * @export
 */
export const PromotionBannerTemplatesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Создать шаблон промобаннера
         * @param {string} [apiVersion] 
         * @param {SavePromotionBannerTemplateRequest} [savePromotionBannerTemplateRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPromotionBannerTemplate: async (apiVersion?: string, savePromotionBannerTemplateRequest?: SavePromotionBannerTemplateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/promotion-banner-templates`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(savePromotionBannerTemplateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Получить сохранённый шаблон
         * @param {string} id 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPromotionBannerTemplate: async (id: string, apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getPromotionBannerTemplate', 'id', id)
            const localVarPath = `/api/v1/promotion-banner-templates/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Получить список шаблонов промобаннеров
         * @param {ApiProductType} [productType] Совместимый тип продукта
         * @param {string} [searchQuery] Строка для поиска
         * @param {number} [takeCount] Размер страницы
         * @param {number} [skipCount] Кол-во пропущенных записей
         * @param {boolean} [ascending] Сортировка по возрастанию
         * @param {string} [ordering] Поле для сортировки
         * @param {boolean} [isDeleted] Удалённые записи
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPromotionBannerTemplates: async (productType?: ApiProductType, searchQuery?: string, takeCount?: number, skipCount?: number, ascending?: boolean, ordering?: string, isDeleted?: boolean, apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/promotion-banner-templates/get-promotion-banner-templates`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (productType !== undefined) {
                localVarQueryParameter['ProductType'] = productType;
            }

            if (searchQuery !== undefined) {
                localVarQueryParameter['SearchQuery'] = searchQuery;
            }

            if (takeCount !== undefined) {
                localVarQueryParameter['TakeCount'] = takeCount;
            }

            if (skipCount !== undefined) {
                localVarQueryParameter['SkipCount'] = skipCount;
            }

            if (ascending !== undefined) {
                localVarQueryParameter['Ascending'] = ascending;
            }

            if (ordering !== undefined) {
                localVarQueryParameter['Ordering'] = ordering;
            }

            if (isDeleted !== undefined) {
                localVarQueryParameter['IsDeleted'] = isDeleted;
            }


    
            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Изменить сохранённый шаблон промобаннера
         * @param {string} id 
         * @param {string} [apiVersion] 
         * @param {SavePromotionBannerTemplateRequest} [savePromotionBannerTemplateRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePromotionBannerTemplate: async (id: string, apiVersion?: string, savePromotionBannerTemplateRequest?: SavePromotionBannerTemplateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updatePromotionBannerTemplate', 'id', id)
            const localVarPath = `/api/v1/promotion-banner-templates/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(savePromotionBannerTemplateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PromotionBannerTemplatesApi - functional programming interface
 * @export
 */
export const PromotionBannerTemplatesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PromotionBannerTemplatesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Создать шаблон промобаннера
         * @param {string} [apiVersion] 
         * @param {SavePromotionBannerTemplateRequest} [savePromotionBannerTemplateRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createPromotionBannerTemplate(apiVersion?: string, savePromotionBannerTemplateRequest?: SavePromotionBannerTemplateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PromotionBannerTemplateResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createPromotionBannerTemplate(apiVersion, savePromotionBannerTemplateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PromotionBannerTemplatesApi.createPromotionBannerTemplate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Получить сохранённый шаблон
         * @param {string} id 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPromotionBannerTemplate(id: string, apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PromotionBannerTemplateResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPromotionBannerTemplate(id, apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PromotionBannerTemplatesApi.getPromotionBannerTemplate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Получить список шаблонов промобаннеров
         * @param {ApiProductType} [productType] Совместимый тип продукта
         * @param {string} [searchQuery] Строка для поиска
         * @param {number} [takeCount] Размер страницы
         * @param {number} [skipCount] Кол-во пропущенных записей
         * @param {boolean} [ascending] Сортировка по возрастанию
         * @param {string} [ordering] Поле для сортировки
         * @param {boolean} [isDeleted] Удалённые записи
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPromotionBannerTemplates(productType?: ApiProductType, searchQuery?: string, takeCount?: number, skipCount?: number, ascending?: boolean, ordering?: string, isDeleted?: boolean, apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetPromotionBannerTemplatesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPromotionBannerTemplates(productType, searchQuery, takeCount, skipCount, ascending, ordering, isDeleted, apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PromotionBannerTemplatesApi.getPromotionBannerTemplates']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Изменить сохранённый шаблон промобаннера
         * @param {string} id 
         * @param {string} [apiVersion] 
         * @param {SavePromotionBannerTemplateRequest} [savePromotionBannerTemplateRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updatePromotionBannerTemplate(id: string, apiVersion?: string, savePromotionBannerTemplateRequest?: SavePromotionBannerTemplateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PromotionBannerTemplateResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updatePromotionBannerTemplate(id, apiVersion, savePromotionBannerTemplateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PromotionBannerTemplatesApi.updatePromotionBannerTemplate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * PromotionBannerTemplatesApi - factory interface
 * @export
 */
export const PromotionBannerTemplatesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PromotionBannerTemplatesApiFp(configuration)
    return {
        /**
         * 
         * @summary Создать шаблон промобаннера
         * @param {PromotionBannerTemplatesApiCreatePromotionBannerTemplateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPromotionBannerTemplate(requestParameters: PromotionBannerTemplatesApiCreatePromotionBannerTemplateRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<PromotionBannerTemplateResponse> {
            return localVarFp.createPromotionBannerTemplate(requestParameters.apiVersion, requestParameters.savePromotionBannerTemplateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Получить сохранённый шаблон
         * @param {PromotionBannerTemplatesApiGetPromotionBannerTemplateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPromotionBannerTemplate(requestParameters: PromotionBannerTemplatesApiGetPromotionBannerTemplateRequest, options?: RawAxiosRequestConfig): AxiosPromise<PromotionBannerTemplateResponse> {
            return localVarFp.getPromotionBannerTemplate(requestParameters.id, requestParameters.apiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Получить список шаблонов промобаннеров
         * @param {PromotionBannerTemplatesApiGetPromotionBannerTemplatesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPromotionBannerTemplates(requestParameters: PromotionBannerTemplatesApiGetPromotionBannerTemplatesRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<GetPromotionBannerTemplatesResponse> {
            return localVarFp.getPromotionBannerTemplates(requestParameters.productType, requestParameters.searchQuery, requestParameters.takeCount, requestParameters.skipCount, requestParameters.ascending, requestParameters.ordering, requestParameters.isDeleted, requestParameters.apiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Изменить сохранённый шаблон промобаннера
         * @param {PromotionBannerTemplatesApiUpdatePromotionBannerTemplateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePromotionBannerTemplate(requestParameters: PromotionBannerTemplatesApiUpdatePromotionBannerTemplateRequest, options?: RawAxiosRequestConfig): AxiosPromise<PromotionBannerTemplateResponse> {
            return localVarFp.updatePromotionBannerTemplate(requestParameters.id, requestParameters.apiVersion, requestParameters.savePromotionBannerTemplateRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for createPromotionBannerTemplate operation in PromotionBannerTemplatesApi.
 * @export
 * @interface PromotionBannerTemplatesApiCreatePromotionBannerTemplateRequest
 */
export interface PromotionBannerTemplatesApiCreatePromotionBannerTemplateRequest {
    /**
     * 
     * @type {string}
     * @memberof PromotionBannerTemplatesApiCreatePromotionBannerTemplate
     */
    readonly apiVersion?: string

    /**
     * 
     * @type {SavePromotionBannerTemplateRequest}
     * @memberof PromotionBannerTemplatesApiCreatePromotionBannerTemplate
     */
    readonly savePromotionBannerTemplateRequest?: SavePromotionBannerTemplateRequest
}

/**
 * Request parameters for getPromotionBannerTemplate operation in PromotionBannerTemplatesApi.
 * @export
 * @interface PromotionBannerTemplatesApiGetPromotionBannerTemplateRequest
 */
export interface PromotionBannerTemplatesApiGetPromotionBannerTemplateRequest {
    /**
     * 
     * @type {string}
     * @memberof PromotionBannerTemplatesApiGetPromotionBannerTemplate
     */
    readonly id: string

    /**
     * 
     * @type {string}
     * @memberof PromotionBannerTemplatesApiGetPromotionBannerTemplate
     */
    readonly apiVersion?: string
}

/**
 * Request parameters for getPromotionBannerTemplates operation in PromotionBannerTemplatesApi.
 * @export
 * @interface PromotionBannerTemplatesApiGetPromotionBannerTemplatesRequest
 */
export interface PromotionBannerTemplatesApiGetPromotionBannerTemplatesRequest {
    /**
     * Совместимый тип продукта
     * @type {ApiProductType}
     * @memberof PromotionBannerTemplatesApiGetPromotionBannerTemplates
     */
    readonly productType?: ApiProductType

    /**
     * Строка для поиска
     * @type {string}
     * @memberof PromotionBannerTemplatesApiGetPromotionBannerTemplates
     */
    readonly searchQuery?: string

    /**
     * Размер страницы
     * @type {number}
     * @memberof PromotionBannerTemplatesApiGetPromotionBannerTemplates
     */
    readonly takeCount?: number

    /**
     * Кол-во пропущенных записей
     * @type {number}
     * @memberof PromotionBannerTemplatesApiGetPromotionBannerTemplates
     */
    readonly skipCount?: number

    /**
     * Сортировка по возрастанию
     * @type {boolean}
     * @memberof PromotionBannerTemplatesApiGetPromotionBannerTemplates
     */
    readonly ascending?: boolean

    /**
     * Поле для сортировки
     * @type {string}
     * @memberof PromotionBannerTemplatesApiGetPromotionBannerTemplates
     */
    readonly ordering?: string

    /**
     * Удалённые записи
     * @type {boolean}
     * @memberof PromotionBannerTemplatesApiGetPromotionBannerTemplates
     */
    readonly isDeleted?: boolean

    /**
     * 
     * @type {string}
     * @memberof PromotionBannerTemplatesApiGetPromotionBannerTemplates
     */
    readonly apiVersion?: string
}

/**
 * Request parameters for updatePromotionBannerTemplate operation in PromotionBannerTemplatesApi.
 * @export
 * @interface PromotionBannerTemplatesApiUpdatePromotionBannerTemplateRequest
 */
export interface PromotionBannerTemplatesApiUpdatePromotionBannerTemplateRequest {
    /**
     * 
     * @type {string}
     * @memberof PromotionBannerTemplatesApiUpdatePromotionBannerTemplate
     */
    readonly id: string

    /**
     * 
     * @type {string}
     * @memberof PromotionBannerTemplatesApiUpdatePromotionBannerTemplate
     */
    readonly apiVersion?: string

    /**
     * 
     * @type {SavePromotionBannerTemplateRequest}
     * @memberof PromotionBannerTemplatesApiUpdatePromotionBannerTemplate
     */
    readonly savePromotionBannerTemplateRequest?: SavePromotionBannerTemplateRequest
}

/**
 * PromotionBannerTemplatesApi - object-oriented interface
 * @export
 * @class PromotionBannerTemplatesApi
 * @extends {BaseAPI}
 */
export class PromotionBannerTemplatesApi extends BaseAPI {
    /**
     * 
     * @summary Создать шаблон промобаннера
     * @param {PromotionBannerTemplatesApiCreatePromotionBannerTemplateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PromotionBannerTemplatesApi
     */
    public createPromotionBannerTemplate(requestParameters: PromotionBannerTemplatesApiCreatePromotionBannerTemplateRequest = {}, options?: RawAxiosRequestConfig) {
        return PromotionBannerTemplatesApiFp(this.configuration).createPromotionBannerTemplate(requestParameters.apiVersion, requestParameters.savePromotionBannerTemplateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Получить сохранённый шаблон
     * @param {PromotionBannerTemplatesApiGetPromotionBannerTemplateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PromotionBannerTemplatesApi
     */
    public getPromotionBannerTemplate(requestParameters: PromotionBannerTemplatesApiGetPromotionBannerTemplateRequest, options?: RawAxiosRequestConfig) {
        return PromotionBannerTemplatesApiFp(this.configuration).getPromotionBannerTemplate(requestParameters.id, requestParameters.apiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Получить список шаблонов промобаннеров
     * @param {PromotionBannerTemplatesApiGetPromotionBannerTemplatesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PromotionBannerTemplatesApi
     */
    public getPromotionBannerTemplates(requestParameters: PromotionBannerTemplatesApiGetPromotionBannerTemplatesRequest = {}, options?: RawAxiosRequestConfig) {
        return PromotionBannerTemplatesApiFp(this.configuration).getPromotionBannerTemplates(requestParameters.productType, requestParameters.searchQuery, requestParameters.takeCount, requestParameters.skipCount, requestParameters.ascending, requestParameters.ordering, requestParameters.isDeleted, requestParameters.apiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Изменить сохранённый шаблон промобаннера
     * @param {PromotionBannerTemplatesApiUpdatePromotionBannerTemplateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PromotionBannerTemplatesApi
     */
    public updatePromotionBannerTemplate(requestParameters: PromotionBannerTemplatesApiUpdatePromotionBannerTemplateRequest, options?: RawAxiosRequestConfig) {
        return PromotionBannerTemplatesApiFp(this.configuration).updatePromotionBannerTemplate(requestParameters.id, requestParameters.apiVersion, requestParameters.savePromotionBannerTemplateRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * QuestionApi - axios parameter creator
 * @export
 */
export const QuestionApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Добавить новый вопрос в тесте.
         * @param {string} [apiVersion] 
         * @param {CreateQuestionRequest} [createQuestionRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createQuestion: async (apiVersion?: string, createQuestionRequest?: CreateQuestionRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/questions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createQuestionRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Удалить вопрос.
         * @param {number} id 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteQuestion: async (id: number, apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteQuestion', 'id', id)
            const localVarPath = `/api/v1/questions/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Получить вопрос по идентификатору.
         * @param {number} id 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getQuestionById: async (id: number, apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getQuestionById', 'id', id)
            const localVarPath = `/api/v1/questions/questions/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Получить все вопросы по тесту с ответами.
         * @param {number} testId 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getQuestionsByTestId: async (testId: number, apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'testId' is not null or undefined
            assertParamExists('getQuestionsByTestId', 'testId', testId)
            const localVarPath = `/api/v1/questions/questions/{testId}/with-answers`
                .replace(`{${"testId"}}`, encodeURIComponent(String(testId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Обновить существующий вопрос.
         * @param {string} [apiVersion] 
         * @param {UpdateQuestionRequest} [updateQuestionRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateQuestion: async (apiVersion?: string, updateQuestionRequest?: UpdateQuestionRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/questions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateQuestionRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * QuestionApi - functional programming interface
 * @export
 */
export const QuestionApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = QuestionApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Добавить новый вопрос в тесте.
         * @param {string} [apiVersion] 
         * @param {CreateQuestionRequest} [createQuestionRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createQuestion(apiVersion?: string, createQuestionRequest?: CreateQuestionRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetQuestionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createQuestion(apiVersion, createQuestionRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QuestionApi.createQuestion']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Удалить вопрос.
         * @param {number} id 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteQuestion(id: number, apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteQuestion(id, apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QuestionApi.deleteQuestion']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Получить вопрос по идентификатору.
         * @param {number} id 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getQuestionById(id: number, apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetQuestionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getQuestionById(id, apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QuestionApi.getQuestionById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Получить все вопросы по тесту с ответами.
         * @param {number} testId 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getQuestionsByTestId(testId: number, apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetQuestionResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getQuestionsByTestId(testId, apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QuestionApi.getQuestionsByTestId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Обновить существующий вопрос.
         * @param {string} [apiVersion] 
         * @param {UpdateQuestionRequest} [updateQuestionRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateQuestion(apiVersion?: string, updateQuestionRequest?: UpdateQuestionRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetQuestionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateQuestion(apiVersion, updateQuestionRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QuestionApi.updateQuestion']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * QuestionApi - factory interface
 * @export
 */
export const QuestionApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = QuestionApiFp(configuration)
    return {
        /**
         * 
         * @summary Добавить новый вопрос в тесте.
         * @param {QuestionApiCreateQuestionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createQuestion(requestParameters: QuestionApiCreateQuestionRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<GetQuestionResponse> {
            return localVarFp.createQuestion(requestParameters.apiVersion, requestParameters.createQuestionRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Удалить вопрос.
         * @param {QuestionApiDeleteQuestionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteQuestion(requestParameters: QuestionApiDeleteQuestionRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteQuestion(requestParameters.id, requestParameters.apiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Получить вопрос по идентификатору.
         * @param {QuestionApiGetQuestionByIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getQuestionById(requestParameters: QuestionApiGetQuestionByIdRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetQuestionResponse> {
            return localVarFp.getQuestionById(requestParameters.id, requestParameters.apiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Получить все вопросы по тесту с ответами.
         * @param {QuestionApiGetQuestionsByTestIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getQuestionsByTestId(requestParameters: QuestionApiGetQuestionsByTestIdRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<GetQuestionResponse>> {
            return localVarFp.getQuestionsByTestId(requestParameters.testId, requestParameters.apiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Обновить существующий вопрос.
         * @param {QuestionApiUpdateQuestionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateQuestion(requestParameters: QuestionApiUpdateQuestionRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<GetQuestionResponse> {
            return localVarFp.updateQuestion(requestParameters.apiVersion, requestParameters.updateQuestionRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for createQuestion operation in QuestionApi.
 * @export
 * @interface QuestionApiCreateQuestionRequest
 */
export interface QuestionApiCreateQuestionRequest {
    /**
     * 
     * @type {string}
     * @memberof QuestionApiCreateQuestion
     */
    readonly apiVersion?: string

    /**
     * 
     * @type {CreateQuestionRequest}
     * @memberof QuestionApiCreateQuestion
     */
    readonly createQuestionRequest?: CreateQuestionRequest
}

/**
 * Request parameters for deleteQuestion operation in QuestionApi.
 * @export
 * @interface QuestionApiDeleteQuestionRequest
 */
export interface QuestionApiDeleteQuestionRequest {
    /**
     * 
     * @type {number}
     * @memberof QuestionApiDeleteQuestion
     */
    readonly id: number

    /**
     * 
     * @type {string}
     * @memberof QuestionApiDeleteQuestion
     */
    readonly apiVersion?: string
}

/**
 * Request parameters for getQuestionById operation in QuestionApi.
 * @export
 * @interface QuestionApiGetQuestionByIdRequest
 */
export interface QuestionApiGetQuestionByIdRequest {
    /**
     * 
     * @type {number}
     * @memberof QuestionApiGetQuestionById
     */
    readonly id: number

    /**
     * 
     * @type {string}
     * @memberof QuestionApiGetQuestionById
     */
    readonly apiVersion?: string
}

/**
 * Request parameters for getQuestionsByTestId operation in QuestionApi.
 * @export
 * @interface QuestionApiGetQuestionsByTestIdRequest
 */
export interface QuestionApiGetQuestionsByTestIdRequest {
    /**
     * 
     * @type {number}
     * @memberof QuestionApiGetQuestionsByTestId
     */
    readonly testId: number

    /**
     * 
     * @type {string}
     * @memberof QuestionApiGetQuestionsByTestId
     */
    readonly apiVersion?: string
}

/**
 * Request parameters for updateQuestion operation in QuestionApi.
 * @export
 * @interface QuestionApiUpdateQuestionRequest
 */
export interface QuestionApiUpdateQuestionRequest {
    /**
     * 
     * @type {string}
     * @memberof QuestionApiUpdateQuestion
     */
    readonly apiVersion?: string

    /**
     * 
     * @type {UpdateQuestionRequest}
     * @memberof QuestionApiUpdateQuestion
     */
    readonly updateQuestionRequest?: UpdateQuestionRequest
}

/**
 * QuestionApi - object-oriented interface
 * @export
 * @class QuestionApi
 * @extends {BaseAPI}
 */
export class QuestionApi extends BaseAPI {
    /**
     * 
     * @summary Добавить новый вопрос в тесте.
     * @param {QuestionApiCreateQuestionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QuestionApi
     */
    public createQuestion(requestParameters: QuestionApiCreateQuestionRequest = {}, options?: RawAxiosRequestConfig) {
        return QuestionApiFp(this.configuration).createQuestion(requestParameters.apiVersion, requestParameters.createQuestionRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Удалить вопрос.
     * @param {QuestionApiDeleteQuestionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QuestionApi
     */
    public deleteQuestion(requestParameters: QuestionApiDeleteQuestionRequest, options?: RawAxiosRequestConfig) {
        return QuestionApiFp(this.configuration).deleteQuestion(requestParameters.id, requestParameters.apiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Получить вопрос по идентификатору.
     * @param {QuestionApiGetQuestionByIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QuestionApi
     */
    public getQuestionById(requestParameters: QuestionApiGetQuestionByIdRequest, options?: RawAxiosRequestConfig) {
        return QuestionApiFp(this.configuration).getQuestionById(requestParameters.id, requestParameters.apiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Получить все вопросы по тесту с ответами.
     * @param {QuestionApiGetQuestionsByTestIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QuestionApi
     */
    public getQuestionsByTestId(requestParameters: QuestionApiGetQuestionsByTestIdRequest, options?: RawAxiosRequestConfig) {
        return QuestionApiFp(this.configuration).getQuestionsByTestId(requestParameters.testId, requestParameters.apiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Обновить существующий вопрос.
     * @param {QuestionApiUpdateQuestionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QuestionApi
     */
    public updateQuestion(requestParameters: QuestionApiUpdateQuestionRequest = {}, options?: RawAxiosRequestConfig) {
        return QuestionApiFp(this.configuration).updateQuestion(requestParameters.apiVersion, requestParameters.updateQuestionRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ReviewsApi - axios parameter creator
 * @export
 */
export const ReviewsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Получить отзывы исполнителя
         * @param {string} executorId 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ReviewsGetByExecutorExecutorIdGet: async (executorId: string, apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'executorId' is not null or undefined
            assertParamExists('apiV1ReviewsGetByExecutorExecutorIdGet', 'executorId', executorId)
            const localVarPath = `/api/v1/reviews/getByExecutor/{executorId}`
                .replace(`{${"executorId"}}`, encodeURIComponent(String(executorId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Получить отзыв по идентификатору
         * @param {number} id 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ReviewsIdGet: async (id: number, apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiV1ReviewsIdGet', 'id', id)
            const localVarPath = `/api/v1/reviews/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Обновить данные отзыва
         * @param {number} id Идентификатор отзыва
         * @param {string} [apiVersion] 
         * @param {UpdateReviewRequest} [updateReviewRequest] Новые данные отзыва
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ReviewsIdPut: async (id: number, apiVersion?: string, updateReviewRequest?: UpdateReviewRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiV1ReviewsIdPut', 'id', id)
            const localVarPath = `/api/v1/reviews/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateReviewRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Создать отзыв
         * @param {string} [apiVersion] 
         * @param {CreateReviewRequest} [createReviewRequest] Данные нового отзыва
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ReviewsPost: async (apiVersion?: string, createReviewRequest?: CreateReviewRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/reviews`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createReviewRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Удалить отзыв
         * @param {number} reviewId Идентификатор отзыва
         * @param {string} [apiVersion] 
         * @param {DeleteRequest} [deleteRequest] Комментарий к удалению
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteReview: async (reviewId: number, apiVersion?: string, deleteRequest?: DeleteRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'reviewId' is not null or undefined
            assertParamExists('deleteReview', 'reviewId', reviewId)
            const localVarPath = `/api/v1/reviews/{reviewId}`
                .replace(`{${"reviewId"}}`, encodeURIComponent(String(reviewId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(deleteRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Получить отзывы
         * @param {number} [mark] Оценка отзыва
         * @param {string} [descriptionSearch] Поиск по тексту описания
         * @param {string} [clientNameSearch] Поиск по имени клиента
         * @param {string} [orderNumberSearch] Поиск по номеру заказа
         * @param {string} [clientId] Идентификатор клиента, оставившего отзывы
         * @param {string} [executorId] Идентификатор исполнителя
         * @param {string} [orderId] Идентификатор заказа
         * @param {boolean} [isShadow] Признак теневого отзыва
         * @param {string} [searchQuery] Строка для поиска
         * @param {number} [takeCount] Размер страницы
         * @param {number} [skipCount] Кол-во пропущенных записей
         * @param {boolean} [ascending] Сортировка по возрастанию
         * @param {string} [ordering] Поле для сортировки
         * @param {boolean} [isDeleted] Удалённые записи
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReviews: async (mark?: number, descriptionSearch?: string, clientNameSearch?: string, orderNumberSearch?: string, clientId?: string, executorId?: string, orderId?: string, isShadow?: boolean, searchQuery?: string, takeCount?: number, skipCount?: number, ascending?: boolean, ordering?: string, isDeleted?: boolean, apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/reviews/get-reviews`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (mark !== undefined) {
                localVarQueryParameter['Mark'] = mark;
            }

            if (descriptionSearch !== undefined) {
                localVarQueryParameter['DescriptionSearch'] = descriptionSearch;
            }

            if (clientNameSearch !== undefined) {
                localVarQueryParameter['ClientNameSearch'] = clientNameSearch;
            }

            if (orderNumberSearch !== undefined) {
                localVarQueryParameter['OrderNumberSearch'] = orderNumberSearch;
            }

            if (clientId !== undefined) {
                localVarQueryParameter['ClientId'] = clientId;
            }

            if (executorId !== undefined) {
                localVarQueryParameter['ExecutorId'] = executorId;
            }

            if (orderId !== undefined) {
                localVarQueryParameter['OrderId'] = orderId;
            }

            if (isShadow !== undefined) {
                localVarQueryParameter['IsShadow'] = isShadow;
            }

            if (searchQuery !== undefined) {
                localVarQueryParameter['SearchQuery'] = searchQuery;
            }

            if (takeCount !== undefined) {
                localVarQueryParameter['TakeCount'] = takeCount;
            }

            if (skipCount !== undefined) {
                localVarQueryParameter['SkipCount'] = skipCount;
            }

            if (ascending !== undefined) {
                localVarQueryParameter['Ascending'] = ascending;
            }

            if (ordering !== undefined) {
                localVarQueryParameter['Ordering'] = ordering;
            }

            if (isDeleted !== undefined) {
                localVarQueryParameter['IsDeleted'] = isDeleted;
            }


    
            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ReviewsApi - functional programming interface
 * @export
 */
export const ReviewsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ReviewsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Получить отзывы исполнителя
         * @param {string} executorId 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1ReviewsGetByExecutorExecutorIdGet(executorId: string, apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ExecutorReviewsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1ReviewsGetByExecutorExecutorIdGet(executorId, apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReviewsApi.apiV1ReviewsGetByExecutorExecutorIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Получить отзыв по идентификатору
         * @param {number} id 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1ReviewsIdGet(id: number, apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ReviewResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1ReviewsIdGet(id, apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReviewsApi.apiV1ReviewsIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Обновить данные отзыва
         * @param {number} id Идентификатор отзыва
         * @param {string} [apiVersion] 
         * @param {UpdateReviewRequest} [updateReviewRequest] Новые данные отзыва
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1ReviewsIdPut(id: number, apiVersion?: string, updateReviewRequest?: UpdateReviewRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ReviewResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1ReviewsIdPut(id, apiVersion, updateReviewRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReviewsApi.apiV1ReviewsIdPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Создать отзыв
         * @param {string} [apiVersion] 
         * @param {CreateReviewRequest} [createReviewRequest] Данные нового отзыва
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1ReviewsPost(apiVersion?: string, createReviewRequest?: CreateReviewRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ReviewResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1ReviewsPost(apiVersion, createReviewRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReviewsApi.apiV1ReviewsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Удалить отзыв
         * @param {number} reviewId Идентификатор отзыва
         * @param {string} [apiVersion] 
         * @param {DeleteRequest} [deleteRequest] Комментарий к удалению
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteReview(reviewId: number, apiVersion?: string, deleteRequest?: DeleteRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteReview(reviewId, apiVersion, deleteRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReviewsApi.deleteReview']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Получить отзывы
         * @param {number} [mark] Оценка отзыва
         * @param {string} [descriptionSearch] Поиск по тексту описания
         * @param {string} [clientNameSearch] Поиск по имени клиента
         * @param {string} [orderNumberSearch] Поиск по номеру заказа
         * @param {string} [clientId] Идентификатор клиента, оставившего отзывы
         * @param {string} [executorId] Идентификатор исполнителя
         * @param {string} [orderId] Идентификатор заказа
         * @param {boolean} [isShadow] Признак теневого отзыва
         * @param {string} [searchQuery] Строка для поиска
         * @param {number} [takeCount] Размер страницы
         * @param {number} [skipCount] Кол-во пропущенных записей
         * @param {boolean} [ascending] Сортировка по возрастанию
         * @param {string} [ordering] Поле для сортировки
         * @param {boolean} [isDeleted] Удалённые записи
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getReviews(mark?: number, descriptionSearch?: string, clientNameSearch?: string, orderNumberSearch?: string, clientId?: string, executorId?: string, orderId?: string, isShadow?: boolean, searchQuery?: string, takeCount?: number, skipCount?: number, ascending?: boolean, ordering?: string, isDeleted?: boolean, apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetReviewsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getReviews(mark, descriptionSearch, clientNameSearch, orderNumberSearch, clientId, executorId, orderId, isShadow, searchQuery, takeCount, skipCount, ascending, ordering, isDeleted, apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReviewsApi.getReviews']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ReviewsApi - factory interface
 * @export
 */
export const ReviewsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ReviewsApiFp(configuration)
    return {
        /**
         * 
         * @summary Получить отзывы исполнителя
         * @param {ReviewsApiApiV1ReviewsGetByExecutorExecutorIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ReviewsGetByExecutorExecutorIdGet(requestParameters: ReviewsApiApiV1ReviewsGetByExecutorExecutorIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<ExecutorReviewsResponse> {
            return localVarFp.apiV1ReviewsGetByExecutorExecutorIdGet(requestParameters.executorId, requestParameters.apiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Получить отзыв по идентификатору
         * @param {ReviewsApiApiV1ReviewsIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ReviewsIdGet(requestParameters: ReviewsApiApiV1ReviewsIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<ReviewResponse> {
            return localVarFp.apiV1ReviewsIdGet(requestParameters.id, requestParameters.apiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Обновить данные отзыва
         * @param {ReviewsApiApiV1ReviewsIdPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ReviewsIdPut(requestParameters: ReviewsApiApiV1ReviewsIdPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<ReviewResponse> {
            return localVarFp.apiV1ReviewsIdPut(requestParameters.id, requestParameters.apiVersion, requestParameters.updateReviewRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Создать отзыв
         * @param {ReviewsApiApiV1ReviewsPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ReviewsPost(requestParameters: ReviewsApiApiV1ReviewsPostRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<ReviewResponse> {
            return localVarFp.apiV1ReviewsPost(requestParameters.apiVersion, requestParameters.createReviewRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Удалить отзыв
         * @param {ReviewsApiDeleteReviewRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteReview(requestParameters: ReviewsApiDeleteReviewRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteReview(requestParameters.reviewId, requestParameters.apiVersion, requestParameters.deleteRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Получить отзывы
         * @param {ReviewsApiGetReviewsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReviews(requestParameters: ReviewsApiGetReviewsRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<GetReviewsResponse> {
            return localVarFp.getReviews(requestParameters.mark, requestParameters.descriptionSearch, requestParameters.clientNameSearch, requestParameters.orderNumberSearch, requestParameters.clientId, requestParameters.executorId, requestParameters.orderId, requestParameters.isShadow, requestParameters.searchQuery, requestParameters.takeCount, requestParameters.skipCount, requestParameters.ascending, requestParameters.ordering, requestParameters.isDeleted, requestParameters.apiVersion, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for apiV1ReviewsGetByExecutorExecutorIdGet operation in ReviewsApi.
 * @export
 * @interface ReviewsApiApiV1ReviewsGetByExecutorExecutorIdGetRequest
 */
export interface ReviewsApiApiV1ReviewsGetByExecutorExecutorIdGetRequest {
    /**
     * 
     * @type {string}
     * @memberof ReviewsApiApiV1ReviewsGetByExecutorExecutorIdGet
     */
    readonly executorId: string

    /**
     * 
     * @type {string}
     * @memberof ReviewsApiApiV1ReviewsGetByExecutorExecutorIdGet
     */
    readonly apiVersion?: string
}

/**
 * Request parameters for apiV1ReviewsIdGet operation in ReviewsApi.
 * @export
 * @interface ReviewsApiApiV1ReviewsIdGetRequest
 */
export interface ReviewsApiApiV1ReviewsIdGetRequest {
    /**
     * 
     * @type {number}
     * @memberof ReviewsApiApiV1ReviewsIdGet
     */
    readonly id: number

    /**
     * 
     * @type {string}
     * @memberof ReviewsApiApiV1ReviewsIdGet
     */
    readonly apiVersion?: string
}

/**
 * Request parameters for apiV1ReviewsIdPut operation in ReviewsApi.
 * @export
 * @interface ReviewsApiApiV1ReviewsIdPutRequest
 */
export interface ReviewsApiApiV1ReviewsIdPutRequest {
    /**
     * Идентификатор отзыва
     * @type {number}
     * @memberof ReviewsApiApiV1ReviewsIdPut
     */
    readonly id: number

    /**
     * 
     * @type {string}
     * @memberof ReviewsApiApiV1ReviewsIdPut
     */
    readonly apiVersion?: string

    /**
     * Новые данные отзыва
     * @type {UpdateReviewRequest}
     * @memberof ReviewsApiApiV1ReviewsIdPut
     */
    readonly updateReviewRequest?: UpdateReviewRequest
}

/**
 * Request parameters for apiV1ReviewsPost operation in ReviewsApi.
 * @export
 * @interface ReviewsApiApiV1ReviewsPostRequest
 */
export interface ReviewsApiApiV1ReviewsPostRequest {
    /**
     * 
     * @type {string}
     * @memberof ReviewsApiApiV1ReviewsPost
     */
    readonly apiVersion?: string

    /**
     * Данные нового отзыва
     * @type {CreateReviewRequest}
     * @memberof ReviewsApiApiV1ReviewsPost
     */
    readonly createReviewRequest?: CreateReviewRequest
}

/**
 * Request parameters for deleteReview operation in ReviewsApi.
 * @export
 * @interface ReviewsApiDeleteReviewRequest
 */
export interface ReviewsApiDeleteReviewRequest {
    /**
     * Идентификатор отзыва
     * @type {number}
     * @memberof ReviewsApiDeleteReview
     */
    readonly reviewId: number

    /**
     * 
     * @type {string}
     * @memberof ReviewsApiDeleteReview
     */
    readonly apiVersion?: string

    /**
     * Комментарий к удалению
     * @type {DeleteRequest}
     * @memberof ReviewsApiDeleteReview
     */
    readonly deleteRequest?: DeleteRequest
}

/**
 * Request parameters for getReviews operation in ReviewsApi.
 * @export
 * @interface ReviewsApiGetReviewsRequest
 */
export interface ReviewsApiGetReviewsRequest {
    /**
     * Оценка отзыва
     * @type {number}
     * @memberof ReviewsApiGetReviews
     */
    readonly mark?: number

    /**
     * Поиск по тексту описания
     * @type {string}
     * @memberof ReviewsApiGetReviews
     */
    readonly descriptionSearch?: string

    /**
     * Поиск по имени клиента
     * @type {string}
     * @memberof ReviewsApiGetReviews
     */
    readonly clientNameSearch?: string

    /**
     * Поиск по номеру заказа
     * @type {string}
     * @memberof ReviewsApiGetReviews
     */
    readonly orderNumberSearch?: string

    /**
     * Идентификатор клиента, оставившего отзывы
     * @type {string}
     * @memberof ReviewsApiGetReviews
     */
    readonly clientId?: string

    /**
     * Идентификатор исполнителя
     * @type {string}
     * @memberof ReviewsApiGetReviews
     */
    readonly executorId?: string

    /**
     * Идентификатор заказа
     * @type {string}
     * @memberof ReviewsApiGetReviews
     */
    readonly orderId?: string

    /**
     * Признак теневого отзыва
     * @type {boolean}
     * @memberof ReviewsApiGetReviews
     */
    readonly isShadow?: boolean

    /**
     * Строка для поиска
     * @type {string}
     * @memberof ReviewsApiGetReviews
     */
    readonly searchQuery?: string

    /**
     * Размер страницы
     * @type {number}
     * @memberof ReviewsApiGetReviews
     */
    readonly takeCount?: number

    /**
     * Кол-во пропущенных записей
     * @type {number}
     * @memberof ReviewsApiGetReviews
     */
    readonly skipCount?: number

    /**
     * Сортировка по возрастанию
     * @type {boolean}
     * @memberof ReviewsApiGetReviews
     */
    readonly ascending?: boolean

    /**
     * Поле для сортировки
     * @type {string}
     * @memberof ReviewsApiGetReviews
     */
    readonly ordering?: string

    /**
     * Удалённые записи
     * @type {boolean}
     * @memberof ReviewsApiGetReviews
     */
    readonly isDeleted?: boolean

    /**
     * 
     * @type {string}
     * @memberof ReviewsApiGetReviews
     */
    readonly apiVersion?: string
}

/**
 * ReviewsApi - object-oriented interface
 * @export
 * @class ReviewsApi
 * @extends {BaseAPI}
 */
export class ReviewsApi extends BaseAPI {
    /**
     * 
     * @summary Получить отзывы исполнителя
     * @param {ReviewsApiApiV1ReviewsGetByExecutorExecutorIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReviewsApi
     */
    public apiV1ReviewsGetByExecutorExecutorIdGet(requestParameters: ReviewsApiApiV1ReviewsGetByExecutorExecutorIdGetRequest, options?: RawAxiosRequestConfig) {
        return ReviewsApiFp(this.configuration).apiV1ReviewsGetByExecutorExecutorIdGet(requestParameters.executorId, requestParameters.apiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Получить отзыв по идентификатору
     * @param {ReviewsApiApiV1ReviewsIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReviewsApi
     */
    public apiV1ReviewsIdGet(requestParameters: ReviewsApiApiV1ReviewsIdGetRequest, options?: RawAxiosRequestConfig) {
        return ReviewsApiFp(this.configuration).apiV1ReviewsIdGet(requestParameters.id, requestParameters.apiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Обновить данные отзыва
     * @param {ReviewsApiApiV1ReviewsIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReviewsApi
     */
    public apiV1ReviewsIdPut(requestParameters: ReviewsApiApiV1ReviewsIdPutRequest, options?: RawAxiosRequestConfig) {
        return ReviewsApiFp(this.configuration).apiV1ReviewsIdPut(requestParameters.id, requestParameters.apiVersion, requestParameters.updateReviewRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Создать отзыв
     * @param {ReviewsApiApiV1ReviewsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReviewsApi
     */
    public apiV1ReviewsPost(requestParameters: ReviewsApiApiV1ReviewsPostRequest = {}, options?: RawAxiosRequestConfig) {
        return ReviewsApiFp(this.configuration).apiV1ReviewsPost(requestParameters.apiVersion, requestParameters.createReviewRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Удалить отзыв
     * @param {ReviewsApiDeleteReviewRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReviewsApi
     */
    public deleteReview(requestParameters: ReviewsApiDeleteReviewRequest, options?: RawAxiosRequestConfig) {
        return ReviewsApiFp(this.configuration).deleteReview(requestParameters.reviewId, requestParameters.apiVersion, requestParameters.deleteRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Получить отзывы
     * @param {ReviewsApiGetReviewsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReviewsApi
     */
    public getReviews(requestParameters: ReviewsApiGetReviewsRequest = {}, options?: RawAxiosRequestConfig) {
        return ReviewsApiFp(this.configuration).getReviews(requestParameters.mark, requestParameters.descriptionSearch, requestParameters.clientNameSearch, requestParameters.orderNumberSearch, requestParameters.clientId, requestParameters.executorId, requestParameters.orderId, requestParameters.isShadow, requestParameters.searchQuery, requestParameters.takeCount, requestParameters.skipCount, requestParameters.ascending, requestParameters.ordering, requestParameters.isDeleted, requestParameters.apiVersion, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * RobokassaApi - axios parameter creator
 * @export
 */
export const RobokassaApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Получить адрес возврата после отказа покупателя от оплаты
         * @param {string} [apiVersion] 
         * @param {string} [outSum] 
         * @param {string} [invId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1RobokassasFailedPost: async (apiVersion?: string, outSum?: string, invId?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/robokassas/failed`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


            if (outSum !== undefined) { 
                localVarFormParams.append('outSum', outSum as any);
            }
    
            if (invId !== undefined) { 
                localVarFormParams.append('invId', invId as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Прочитать и зарегистрировать данные JWS-уведомления Robokassa
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1RobokassasResult2Post: async (apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/robokassas/result2`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Предназначен для получения Вашим сайтом оповещения об успешном платеже
         * @param {string} outSum 
         * @param {string} invId 
         * @param {string} fee Комиссия Robokassa за совершение операции.
         * @param {string} signatureValue 
         * @param {string} paymentMethod Метод оплаты
         * @param {string} incCurrLabel Валюта, которой платил клиент.
         * @param {string} [apiVersion] 
         * @param {string} [eMail] Email, указанный покупателем в процессе оплаты.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1RobokassasResultPost: async (outSum: string, invId: string, fee: string, signatureValue: string, paymentMethod: string, incCurrLabel: string, apiVersion?: string, eMail?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'outSum' is not null or undefined
            assertParamExists('apiV1RobokassasResultPost', 'outSum', outSum)
            // verify required parameter 'invId' is not null or undefined
            assertParamExists('apiV1RobokassasResultPost', 'invId', invId)
            // verify required parameter 'fee' is not null or undefined
            assertParamExists('apiV1RobokassasResultPost', 'fee', fee)
            // verify required parameter 'signatureValue' is not null or undefined
            assertParamExists('apiV1RobokassasResultPost', 'signatureValue', signatureValue)
            // verify required parameter 'paymentMethod' is not null or undefined
            assertParamExists('apiV1RobokassasResultPost', 'paymentMethod', paymentMethod)
            // verify required parameter 'incCurrLabel' is not null or undefined
            assertParamExists('apiV1RobokassasResultPost', 'incCurrLabel', incCurrLabel)
            const localVarPath = `/api/v1/robokassas/result`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


            if (outSum !== undefined) { 
                localVarFormParams.append('OutSum', outSum as any);
            }
    
            if (invId !== undefined) { 
                localVarFormParams.append('InvId', invId as any);
            }
    
            if (fee !== undefined) { 
                localVarFormParams.append('Fee', fee as any);
            }
    
            if (signatureValue !== undefined) { 
                localVarFormParams.append('SignatureValue', signatureValue as any);
            }
    
            if (paymentMethod !== undefined) { 
                localVarFormParams.append('PaymentMethod', paymentMethod as any);
            }
    
            if (incCurrLabel !== undefined) { 
                localVarFormParams.append('IncCurrLabel', incCurrLabel as any);
            }
    
            if (eMail !== undefined) { 
                localVarFormParams.append('EMail', eMail as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Показать результат успешной оплаты
         * @param {string} [apiVersion] 
         * @param {string} [outSum] 
         * @param {string} [invId] 
         * @param {string} [signatureValue] 
         * @param {string} [culture] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1RobokassasSuccessPost: async (apiVersion?: string, outSum?: string, invId?: string, signatureValue?: string, culture?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/robokassas/success`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


            if (outSum !== undefined) { 
                localVarFormParams.append('outSum', outSum as any);
            }
    
            if (invId !== undefined) { 
                localVarFormParams.append('invId', invId as any);
            }
    
            if (signatureValue !== undefined) { 
                localVarFormParams.append('signatureValue', signatureValue as any);
            }
    
            if (culture !== undefined) { 
                localVarFormParams.append('culture', culture as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * RobokassaApi - functional programming interface
 * @export
 */
export const RobokassaApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = RobokassaApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Получить адрес возврата после отказа покупателя от оплаты
         * @param {string} [apiVersion] 
         * @param {string} [outSum] 
         * @param {string} [invId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1RobokassasFailedPost(apiVersion?: string, outSum?: string, invId?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1RobokassasFailedPost(apiVersion, outSum, invId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RobokassaApi.apiV1RobokassasFailedPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Прочитать и зарегистрировать данные JWS-уведомления Robokassa
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1RobokassasResult2Post(apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1RobokassasResult2Post(apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RobokassaApi.apiV1RobokassasResult2Post']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Предназначен для получения Вашим сайтом оповещения об успешном платеже
         * @param {string} outSum 
         * @param {string} invId 
         * @param {string} fee Комиссия Robokassa за совершение операции.
         * @param {string} signatureValue 
         * @param {string} paymentMethod Метод оплаты
         * @param {string} incCurrLabel Валюта, которой платил клиент.
         * @param {string} [apiVersion] 
         * @param {string} [eMail] Email, указанный покупателем в процессе оплаты.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1RobokassasResultPost(outSum: string, invId: string, fee: string, signatureValue: string, paymentMethod: string, incCurrLabel: string, apiVersion?: string, eMail?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1RobokassasResultPost(outSum, invId, fee, signatureValue, paymentMethod, incCurrLabel, apiVersion, eMail, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RobokassaApi.apiV1RobokassasResultPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Показать результат успешной оплаты
         * @param {string} [apiVersion] 
         * @param {string} [outSum] 
         * @param {string} [invId] 
         * @param {string} [signatureValue] 
         * @param {string} [culture] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1RobokassasSuccessPost(apiVersion?: string, outSum?: string, invId?: string, signatureValue?: string, culture?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1RobokassasSuccessPost(apiVersion, outSum, invId, signatureValue, culture, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RobokassaApi.apiV1RobokassasSuccessPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * RobokassaApi - factory interface
 * @export
 */
export const RobokassaApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = RobokassaApiFp(configuration)
    return {
        /**
         * 
         * @summary Получить адрес возврата после отказа покупателя от оплаты
         * @param {RobokassaApiApiV1RobokassasFailedPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1RobokassasFailedPost(requestParameters: RobokassaApiApiV1RobokassasFailedPostRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.apiV1RobokassasFailedPost(requestParameters.apiVersion, requestParameters.outSum, requestParameters.invId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Прочитать и зарегистрировать данные JWS-уведомления Robokassa
         * @param {RobokassaApiApiV1RobokassasResult2PostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1RobokassasResult2Post(requestParameters: RobokassaApiApiV1RobokassasResult2PostRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiV1RobokassasResult2Post(requestParameters.apiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Предназначен для получения Вашим сайтом оповещения об успешном платеже
         * @param {RobokassaApiApiV1RobokassasResultPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1RobokassasResultPost(requestParameters: RobokassaApiApiV1RobokassasResultPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiV1RobokassasResultPost(requestParameters.outSum, requestParameters.invId, requestParameters.fee, requestParameters.signatureValue, requestParameters.paymentMethod, requestParameters.incCurrLabel, requestParameters.apiVersion, requestParameters.eMail, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Показать результат успешной оплаты
         * @param {RobokassaApiApiV1RobokassasSuccessPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1RobokassasSuccessPost(requestParameters: RobokassaApiApiV1RobokassasSuccessPostRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.apiV1RobokassasSuccessPost(requestParameters.apiVersion, requestParameters.outSum, requestParameters.invId, requestParameters.signatureValue, requestParameters.culture, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for apiV1RobokassasFailedPost operation in RobokassaApi.
 * @export
 * @interface RobokassaApiApiV1RobokassasFailedPostRequest
 */
export interface RobokassaApiApiV1RobokassasFailedPostRequest {
    /**
     * 
     * @type {string}
     * @memberof RobokassaApiApiV1RobokassasFailedPost
     */
    readonly apiVersion?: string

    /**
     * 
     * @type {string}
     * @memberof RobokassaApiApiV1RobokassasFailedPost
     */
    readonly outSum?: string

    /**
     * 
     * @type {string}
     * @memberof RobokassaApiApiV1RobokassasFailedPost
     */
    readonly invId?: string
}

/**
 * Request parameters for apiV1RobokassasResult2Post operation in RobokassaApi.
 * @export
 * @interface RobokassaApiApiV1RobokassasResult2PostRequest
 */
export interface RobokassaApiApiV1RobokassasResult2PostRequest {
    /**
     * 
     * @type {string}
     * @memberof RobokassaApiApiV1RobokassasResult2Post
     */
    readonly apiVersion?: string
}

/**
 * Request parameters for apiV1RobokassasResultPost operation in RobokassaApi.
 * @export
 * @interface RobokassaApiApiV1RobokassasResultPostRequest
 */
export interface RobokassaApiApiV1RobokassasResultPostRequest {
    /**
     * 
     * @type {string}
     * @memberof RobokassaApiApiV1RobokassasResultPost
     */
    readonly outSum: string

    /**
     * 
     * @type {string}
     * @memberof RobokassaApiApiV1RobokassasResultPost
     */
    readonly invId: string

    /**
     * Комиссия Robokassa за совершение операции.
     * @type {string}
     * @memberof RobokassaApiApiV1RobokassasResultPost
     */
    readonly fee: string

    /**
     * 
     * @type {string}
     * @memberof RobokassaApiApiV1RobokassasResultPost
     */
    readonly signatureValue: string

    /**
     * Метод оплаты
     * @type {string}
     * @memberof RobokassaApiApiV1RobokassasResultPost
     */
    readonly paymentMethod: string

    /**
     * Валюта, которой платил клиент.
     * @type {string}
     * @memberof RobokassaApiApiV1RobokassasResultPost
     */
    readonly incCurrLabel: string

    /**
     * 
     * @type {string}
     * @memberof RobokassaApiApiV1RobokassasResultPost
     */
    readonly apiVersion?: string

    /**
     * Email, указанный покупателем в процессе оплаты.
     * @type {string}
     * @memberof RobokassaApiApiV1RobokassasResultPost
     */
    readonly eMail?: string
}

/**
 * Request parameters for apiV1RobokassasSuccessPost operation in RobokassaApi.
 * @export
 * @interface RobokassaApiApiV1RobokassasSuccessPostRequest
 */
export interface RobokassaApiApiV1RobokassasSuccessPostRequest {
    /**
     * 
     * @type {string}
     * @memberof RobokassaApiApiV1RobokassasSuccessPost
     */
    readonly apiVersion?: string

    /**
     * 
     * @type {string}
     * @memberof RobokassaApiApiV1RobokassasSuccessPost
     */
    readonly outSum?: string

    /**
     * 
     * @type {string}
     * @memberof RobokassaApiApiV1RobokassasSuccessPost
     */
    readonly invId?: string

    /**
     * 
     * @type {string}
     * @memberof RobokassaApiApiV1RobokassasSuccessPost
     */
    readonly signatureValue?: string

    /**
     * 
     * @type {string}
     * @memberof RobokassaApiApiV1RobokassasSuccessPost
     */
    readonly culture?: string
}

/**
 * RobokassaApi - object-oriented interface
 * @export
 * @class RobokassaApi
 * @extends {BaseAPI}
 */
export class RobokassaApi extends BaseAPI {
    /**
     * 
     * @summary Получить адрес возврата после отказа покупателя от оплаты
     * @param {RobokassaApiApiV1RobokassasFailedPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RobokassaApi
     */
    public apiV1RobokassasFailedPost(requestParameters: RobokassaApiApiV1RobokassasFailedPostRequest = {}, options?: RawAxiosRequestConfig) {
        return RobokassaApiFp(this.configuration).apiV1RobokassasFailedPost(requestParameters.apiVersion, requestParameters.outSum, requestParameters.invId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Прочитать и зарегистрировать данные JWS-уведомления Robokassa
     * @param {RobokassaApiApiV1RobokassasResult2PostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RobokassaApi
     */
    public apiV1RobokassasResult2Post(requestParameters: RobokassaApiApiV1RobokassasResult2PostRequest = {}, options?: RawAxiosRequestConfig) {
        return RobokassaApiFp(this.configuration).apiV1RobokassasResult2Post(requestParameters.apiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Предназначен для получения Вашим сайтом оповещения об успешном платеже
     * @param {RobokassaApiApiV1RobokassasResultPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RobokassaApi
     */
    public apiV1RobokassasResultPost(requestParameters: RobokassaApiApiV1RobokassasResultPostRequest, options?: RawAxiosRequestConfig) {
        return RobokassaApiFp(this.configuration).apiV1RobokassasResultPost(requestParameters.outSum, requestParameters.invId, requestParameters.fee, requestParameters.signatureValue, requestParameters.paymentMethod, requestParameters.incCurrLabel, requestParameters.apiVersion, requestParameters.eMail, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Показать результат успешной оплаты
     * @param {RobokassaApiApiV1RobokassasSuccessPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RobokassaApi
     */
    public apiV1RobokassasSuccessPost(requestParameters: RobokassaApiApiV1RobokassasSuccessPostRequest = {}, options?: RawAxiosRequestConfig) {
        return RobokassaApiFp(this.configuration).apiV1RobokassasSuccessPost(requestParameters.apiVersion, requestParameters.outSum, requestParameters.invId, requestParameters.signatureValue, requestParameters.culture, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * RocketWorkApi - axios parameter creator
 * @export
 */
export const RocketWorkApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Принять событие сделки RocketWork
         * @param {string} [apiVersion] 
         * @param {RocketWorkWebhookEvent} [rocketWorkWebhookEvent] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1RocketworkTasksPost: async (apiVersion?: string, rocketWorkWebhookEvent?: RocketWorkWebhookEvent, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/rocketwork/tasks`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(rocketWorkWebhookEvent, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * RocketWorkApi - functional programming interface
 * @export
 */
export const RocketWorkApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = RocketWorkApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Принять событие сделки RocketWork
         * @param {string} [apiVersion] 
         * @param {RocketWorkWebhookEvent} [rocketWorkWebhookEvent] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1RocketworkTasksPost(apiVersion?: string, rocketWorkWebhookEvent?: RocketWorkWebhookEvent, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1RocketworkTasksPost(apiVersion, rocketWorkWebhookEvent, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RocketWorkApi.apiV1RocketworkTasksPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * RocketWorkApi - factory interface
 * @export
 */
export const RocketWorkApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = RocketWorkApiFp(configuration)
    return {
        /**
         * 
         * @summary Принять событие сделки RocketWork
         * @param {RocketWorkApiApiV1RocketworkTasksPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1RocketworkTasksPost(requestParameters: RocketWorkApiApiV1RocketworkTasksPostRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiV1RocketworkTasksPost(requestParameters.apiVersion, requestParameters.rocketWorkWebhookEvent, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for apiV1RocketworkTasksPost operation in RocketWorkApi.
 * @export
 * @interface RocketWorkApiApiV1RocketworkTasksPostRequest
 */
export interface RocketWorkApiApiV1RocketworkTasksPostRequest {
    /**
     * 
     * @type {string}
     * @memberof RocketWorkApiApiV1RocketworkTasksPost
     */
    readonly apiVersion?: string

    /**
     * 
     * @type {RocketWorkWebhookEvent}
     * @memberof RocketWorkApiApiV1RocketworkTasksPost
     */
    readonly rocketWorkWebhookEvent?: RocketWorkWebhookEvent
}

/**
 * RocketWorkApi - object-oriented interface
 * @export
 * @class RocketWorkApi
 * @extends {BaseAPI}
 */
export class RocketWorkApi extends BaseAPI {
    /**
     * 
     * @summary Принять событие сделки RocketWork
     * @param {RocketWorkApiApiV1RocketworkTasksPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RocketWorkApi
     */
    public apiV1RocketworkTasksPost(requestParameters: RocketWorkApiApiV1RocketworkTasksPostRequest = {}, options?: RawAxiosRequestConfig) {
        return RocketWorkApiFp(this.configuration).apiV1RocketworkTasksPost(requestParameters.apiVersion, requestParameters.rocketWorkWebhookEvent, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * SalebotApi - axios parameter creator
 * @export
 */
export const SalebotApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Принять событие сообщения от Salebot
         * @param {string} [apiVersion] 
         * @param {{ [key: string]: Array<any>; }} [requestBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        receiveWebhook: async (apiVersion?: string, requestBody?: { [key: string]: Array<any>; }, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/integrations/salebot/webhook`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Обработать сохранённое событие Salebot локально
         * @param {string} id 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        replaySalebotWebhook: async (id: string, apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('replaySalebotWebhook', 'id', id)
            const localVarPath = `/api/v1/help/replay-salebot-webhook/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SalebotApi - functional programming interface
 * @export
 */
export const SalebotApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SalebotApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Принять событие сообщения от Salebot
         * @param {string} [apiVersion] 
         * @param {{ [key: string]: Array<any>; }} [requestBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async receiveWebhook(apiVersion?: string, requestBody?: { [key: string]: Array<any>; }, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.receiveWebhook(apiVersion, requestBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SalebotApi.receiveWebhook']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Обработать сохранённое событие Salebot локально
         * @param {string} id 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async replaySalebotWebhook(id: string, apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.replaySalebotWebhook(id, apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SalebotApi.replaySalebotWebhook']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * SalebotApi - factory interface
 * @export
 */
export const SalebotApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SalebotApiFp(configuration)
    return {
        /**
         * 
         * @summary Принять событие сообщения от Salebot
         * @param {SalebotApiReceiveWebhookRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        receiveWebhook(requestParameters: SalebotApiReceiveWebhookRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.receiveWebhook(requestParameters.apiVersion, requestParameters.requestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Обработать сохранённое событие Salebot локально
         * @param {SalebotApiReplaySalebotWebhookRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        replaySalebotWebhook(requestParameters: SalebotApiReplaySalebotWebhookRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.replaySalebotWebhook(requestParameters.id, requestParameters.apiVersion, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for receiveWebhook operation in SalebotApi.
 * @export
 * @interface SalebotApiReceiveWebhookRequest
 */
export interface SalebotApiReceiveWebhookRequest {
    /**
     * 
     * @type {string}
     * @memberof SalebotApiReceiveWebhook
     */
    readonly apiVersion?: string

    /**
     * 
     * @type {{ [key: string]: Array<any>; }}
     * @memberof SalebotApiReceiveWebhook
     */
    readonly requestBody?: { [key: string]: Array<any>; }
}

/**
 * Request parameters for replaySalebotWebhook operation in SalebotApi.
 * @export
 * @interface SalebotApiReplaySalebotWebhookRequest
 */
export interface SalebotApiReplaySalebotWebhookRequest {
    /**
     * 
     * @type {string}
     * @memberof SalebotApiReplaySalebotWebhook
     */
    readonly id: string

    /**
     * 
     * @type {string}
     * @memberof SalebotApiReplaySalebotWebhook
     */
    readonly apiVersion?: string
}

/**
 * SalebotApi - object-oriented interface
 * @export
 * @class SalebotApi
 * @extends {BaseAPI}
 */
export class SalebotApi extends BaseAPI {
    /**
     * 
     * @summary Принять событие сообщения от Salebot
     * @param {SalebotApiReceiveWebhookRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SalebotApi
     */
    public receiveWebhook(requestParameters: SalebotApiReceiveWebhookRequest = {}, options?: RawAxiosRequestConfig) {
        return SalebotApiFp(this.configuration).receiveWebhook(requestParameters.apiVersion, requestParameters.requestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Обработать сохранённое событие Salebot локально
     * @param {SalebotApiReplaySalebotWebhookRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SalebotApi
     */
    public replaySalebotWebhook(requestParameters: SalebotApiReplaySalebotWebhookRequest, options?: RawAxiosRequestConfig) {
        return SalebotApiFp(this.configuration).replaySalebotWebhook(requestParameters.id, requestParameters.apiVersion, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * SalebotDiagnosticsApi - axios parameter creator
 * @export
 */
export const SalebotDiagnosticsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Проверить отправку сообщения через Salebot
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendSalebotTestMessage: async (apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/help/test-salebot-message`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SalebotDiagnosticsApi - functional programming interface
 * @export
 */
export const SalebotDiagnosticsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SalebotDiagnosticsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Проверить отправку сообщения через Salebot
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sendSalebotTestMessage(apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sendSalebotTestMessage(apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SalebotDiagnosticsApi.sendSalebotTestMessage']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * SalebotDiagnosticsApi - factory interface
 * @export
 */
export const SalebotDiagnosticsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SalebotDiagnosticsApiFp(configuration)
    return {
        /**
         * 
         * @summary Проверить отправку сообщения через Salebot
         * @param {SalebotDiagnosticsApiSendSalebotTestMessageRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendSalebotTestMessage(requestParameters: SalebotDiagnosticsApiSendSalebotTestMessageRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.sendSalebotTestMessage(requestParameters.apiVersion, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for sendSalebotTestMessage operation in SalebotDiagnosticsApi.
 * @export
 * @interface SalebotDiagnosticsApiSendSalebotTestMessageRequest
 */
export interface SalebotDiagnosticsApiSendSalebotTestMessageRequest {
    /**
     * 
     * @type {string}
     * @memberof SalebotDiagnosticsApiSendSalebotTestMessage
     */
    readonly apiVersion?: string
}

/**
 * SalebotDiagnosticsApi - object-oriented interface
 * @export
 * @class SalebotDiagnosticsApi
 * @extends {BaseAPI}
 */
export class SalebotDiagnosticsApi extends BaseAPI {
    /**
     * 
     * @summary Проверить отправку сообщения через Salebot
     * @param {SalebotDiagnosticsApiSendSalebotTestMessageRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SalebotDiagnosticsApi
     */
    public sendSalebotTestMessage(requestParameters: SalebotDiagnosticsApiSendSalebotTestMessageRequest = {}, options?: RawAxiosRequestConfig) {
        return SalebotDiagnosticsApiFp(this.configuration).sendSalebotTestMessage(requestParameters.apiVersion, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * SalebotImportsApi - axios parameter creator
 * @export
 */
export const SalebotImportsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Запустить фоновый перенос истории
         * @param {string} [apiVersion] 
         * @param {StartSalebotImportRequest} [startSalebotImportRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminSalebotImportsRunsPost: async (apiVersion?: string, startSalebotImportRequest?: StartSalebotImportRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/admin/salebot-imports/runs`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(startSalebotImportRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Остановить дальнейший перенос истории
         * @param {string} runId 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminSalebotImportsRunsRunIdCancelPost: async (runId: string, apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'runId' is not null or undefined
            assertParamExists('apiV1AdminSalebotImportsRunsRunIdCancelPost', 'runId', runId)
            const localVarPath = `/api/v1/admin/salebot-imports/runs/{runId}/cancel`
                .replace(`{${"runId"}}`, encodeURIComponent(String(runId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Получить отчёт переноса истории
         * @param {string} runId 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminSalebotImportsRunsRunIdGet: async (runId: string, apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'runId' is not null or undefined
            assertParamExists('apiV1AdminSalebotImportsRunsRunIdGet', 'runId', runId)
            const localVarPath = `/api/v1/admin/salebot-imports/runs/{runId}`
                .replace(`{${"runId"}}`, encodeURIComponent(String(runId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Получить страницу замечаний переноса
         * @param {string} runId 
         * @param {number} [offset] 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminSalebotImportsRunsRunIdIssuesGet: async (runId: string, offset?: number, apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'runId' is not null or undefined
            assertParamExists('apiV1AdminSalebotImportsRunsRunIdIssuesGet', 'runId', runId)
            const localVarPath = `/api/v1/admin/salebot-imports/runs/{runId}/issues`
                .replace(`{${"runId"}}`, encodeURIComponent(String(runId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }


    
            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Продолжить перенос с сохранённой точки
         * @param {string} runId 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminSalebotImportsRunsRunIdResumePost: async (runId: string, apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'runId' is not null or undefined
            assertParamExists('apiV1AdminSalebotImportsRunsRunIdResumePost', 'runId', runId)
            const localVarPath = `/api/v1/admin/salebot-imports/runs/{runId}/resume`
                .replace(`{${"runId"}}`, encodeURIComponent(String(runId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SalebotImportsApi - functional programming interface
 * @export
 */
export const SalebotImportsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SalebotImportsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Запустить фоновый перенос истории
         * @param {string} [apiVersion] 
         * @param {StartSalebotImportRequest} [startSalebotImportRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1AdminSalebotImportsRunsPost(apiVersion?: string, startSalebotImportRequest?: StartSalebotImportRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SalebotImportRunResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1AdminSalebotImportsRunsPost(apiVersion, startSalebotImportRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SalebotImportsApi.apiV1AdminSalebotImportsRunsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Остановить дальнейший перенос истории
         * @param {string} runId 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1AdminSalebotImportsRunsRunIdCancelPost(runId: string, apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1AdminSalebotImportsRunsRunIdCancelPost(runId, apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SalebotImportsApi.apiV1AdminSalebotImportsRunsRunIdCancelPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Получить отчёт переноса истории
         * @param {string} runId 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1AdminSalebotImportsRunsRunIdGet(runId: string, apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SalebotImportRunResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1AdminSalebotImportsRunsRunIdGet(runId, apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SalebotImportsApi.apiV1AdminSalebotImportsRunsRunIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Получить страницу замечаний переноса
         * @param {string} runId 
         * @param {number} [offset] 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1AdminSalebotImportsRunsRunIdIssuesGet(runId: string, offset?: number, apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ChatMigrationIssueResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1AdminSalebotImportsRunsRunIdIssuesGet(runId, offset, apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SalebotImportsApi.apiV1AdminSalebotImportsRunsRunIdIssuesGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Продолжить перенос с сохранённой точки
         * @param {string} runId 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1AdminSalebotImportsRunsRunIdResumePost(runId: string, apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1AdminSalebotImportsRunsRunIdResumePost(runId, apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SalebotImportsApi.apiV1AdminSalebotImportsRunsRunIdResumePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * SalebotImportsApi - factory interface
 * @export
 */
export const SalebotImportsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SalebotImportsApiFp(configuration)
    return {
        /**
         * 
         * @summary Запустить фоновый перенос истории
         * @param {SalebotImportsApiApiV1AdminSalebotImportsRunsPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminSalebotImportsRunsPost(requestParameters: SalebotImportsApiApiV1AdminSalebotImportsRunsPostRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<SalebotImportRunResponse> {
            return localVarFp.apiV1AdminSalebotImportsRunsPost(requestParameters.apiVersion, requestParameters.startSalebotImportRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Остановить дальнейший перенос истории
         * @param {SalebotImportsApiApiV1AdminSalebotImportsRunsRunIdCancelPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminSalebotImportsRunsRunIdCancelPost(requestParameters: SalebotImportsApiApiV1AdminSalebotImportsRunsRunIdCancelPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiV1AdminSalebotImportsRunsRunIdCancelPost(requestParameters.runId, requestParameters.apiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Получить отчёт переноса истории
         * @param {SalebotImportsApiApiV1AdminSalebotImportsRunsRunIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminSalebotImportsRunsRunIdGet(requestParameters: SalebotImportsApiApiV1AdminSalebotImportsRunsRunIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<SalebotImportRunResponse> {
            return localVarFp.apiV1AdminSalebotImportsRunsRunIdGet(requestParameters.runId, requestParameters.apiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Получить страницу замечаний переноса
         * @param {SalebotImportsApiApiV1AdminSalebotImportsRunsRunIdIssuesGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminSalebotImportsRunsRunIdIssuesGet(requestParameters: SalebotImportsApiApiV1AdminSalebotImportsRunsRunIdIssuesGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<ChatMigrationIssueResponse>> {
            return localVarFp.apiV1AdminSalebotImportsRunsRunIdIssuesGet(requestParameters.runId, requestParameters.offset, requestParameters.apiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Продолжить перенос с сохранённой точки
         * @param {SalebotImportsApiApiV1AdminSalebotImportsRunsRunIdResumePostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminSalebotImportsRunsRunIdResumePost(requestParameters: SalebotImportsApiApiV1AdminSalebotImportsRunsRunIdResumePostRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiV1AdminSalebotImportsRunsRunIdResumePost(requestParameters.runId, requestParameters.apiVersion, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for apiV1AdminSalebotImportsRunsPost operation in SalebotImportsApi.
 * @export
 * @interface SalebotImportsApiApiV1AdminSalebotImportsRunsPostRequest
 */
export interface SalebotImportsApiApiV1AdminSalebotImportsRunsPostRequest {
    /**
     * 
     * @type {string}
     * @memberof SalebotImportsApiApiV1AdminSalebotImportsRunsPost
     */
    readonly apiVersion?: string

    /**
     * 
     * @type {StartSalebotImportRequest}
     * @memberof SalebotImportsApiApiV1AdminSalebotImportsRunsPost
     */
    readonly startSalebotImportRequest?: StartSalebotImportRequest
}

/**
 * Request parameters for apiV1AdminSalebotImportsRunsRunIdCancelPost operation in SalebotImportsApi.
 * @export
 * @interface SalebotImportsApiApiV1AdminSalebotImportsRunsRunIdCancelPostRequest
 */
export interface SalebotImportsApiApiV1AdminSalebotImportsRunsRunIdCancelPostRequest {
    /**
     * 
     * @type {string}
     * @memberof SalebotImportsApiApiV1AdminSalebotImportsRunsRunIdCancelPost
     */
    readonly runId: string

    /**
     * 
     * @type {string}
     * @memberof SalebotImportsApiApiV1AdminSalebotImportsRunsRunIdCancelPost
     */
    readonly apiVersion?: string
}

/**
 * Request parameters for apiV1AdminSalebotImportsRunsRunIdGet operation in SalebotImportsApi.
 * @export
 * @interface SalebotImportsApiApiV1AdminSalebotImportsRunsRunIdGetRequest
 */
export interface SalebotImportsApiApiV1AdminSalebotImportsRunsRunIdGetRequest {
    /**
     * 
     * @type {string}
     * @memberof SalebotImportsApiApiV1AdminSalebotImportsRunsRunIdGet
     */
    readonly runId: string

    /**
     * 
     * @type {string}
     * @memberof SalebotImportsApiApiV1AdminSalebotImportsRunsRunIdGet
     */
    readonly apiVersion?: string
}

/**
 * Request parameters for apiV1AdminSalebotImportsRunsRunIdIssuesGet operation in SalebotImportsApi.
 * @export
 * @interface SalebotImportsApiApiV1AdminSalebotImportsRunsRunIdIssuesGetRequest
 */
export interface SalebotImportsApiApiV1AdminSalebotImportsRunsRunIdIssuesGetRequest {
    /**
     * 
     * @type {string}
     * @memberof SalebotImportsApiApiV1AdminSalebotImportsRunsRunIdIssuesGet
     */
    readonly runId: string

    /**
     * 
     * @type {number}
     * @memberof SalebotImportsApiApiV1AdminSalebotImportsRunsRunIdIssuesGet
     */
    readonly offset?: number

    /**
     * 
     * @type {string}
     * @memberof SalebotImportsApiApiV1AdminSalebotImportsRunsRunIdIssuesGet
     */
    readonly apiVersion?: string
}

/**
 * Request parameters for apiV1AdminSalebotImportsRunsRunIdResumePost operation in SalebotImportsApi.
 * @export
 * @interface SalebotImportsApiApiV1AdminSalebotImportsRunsRunIdResumePostRequest
 */
export interface SalebotImportsApiApiV1AdminSalebotImportsRunsRunIdResumePostRequest {
    /**
     * 
     * @type {string}
     * @memberof SalebotImportsApiApiV1AdminSalebotImportsRunsRunIdResumePost
     */
    readonly runId: string

    /**
     * 
     * @type {string}
     * @memberof SalebotImportsApiApiV1AdminSalebotImportsRunsRunIdResumePost
     */
    readonly apiVersion?: string
}

/**
 * SalebotImportsApi - object-oriented interface
 * @export
 * @class SalebotImportsApi
 * @extends {BaseAPI}
 */
export class SalebotImportsApi extends BaseAPI {
    /**
     * 
     * @summary Запустить фоновый перенос истории
     * @param {SalebotImportsApiApiV1AdminSalebotImportsRunsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SalebotImportsApi
     */
    public apiV1AdminSalebotImportsRunsPost(requestParameters: SalebotImportsApiApiV1AdminSalebotImportsRunsPostRequest = {}, options?: RawAxiosRequestConfig) {
        return SalebotImportsApiFp(this.configuration).apiV1AdminSalebotImportsRunsPost(requestParameters.apiVersion, requestParameters.startSalebotImportRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Остановить дальнейший перенос истории
     * @param {SalebotImportsApiApiV1AdminSalebotImportsRunsRunIdCancelPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SalebotImportsApi
     */
    public apiV1AdminSalebotImportsRunsRunIdCancelPost(requestParameters: SalebotImportsApiApiV1AdminSalebotImportsRunsRunIdCancelPostRequest, options?: RawAxiosRequestConfig) {
        return SalebotImportsApiFp(this.configuration).apiV1AdminSalebotImportsRunsRunIdCancelPost(requestParameters.runId, requestParameters.apiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Получить отчёт переноса истории
     * @param {SalebotImportsApiApiV1AdminSalebotImportsRunsRunIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SalebotImportsApi
     */
    public apiV1AdminSalebotImportsRunsRunIdGet(requestParameters: SalebotImportsApiApiV1AdminSalebotImportsRunsRunIdGetRequest, options?: RawAxiosRequestConfig) {
        return SalebotImportsApiFp(this.configuration).apiV1AdminSalebotImportsRunsRunIdGet(requestParameters.runId, requestParameters.apiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Получить страницу замечаний переноса
     * @param {SalebotImportsApiApiV1AdminSalebotImportsRunsRunIdIssuesGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SalebotImportsApi
     */
    public apiV1AdminSalebotImportsRunsRunIdIssuesGet(requestParameters: SalebotImportsApiApiV1AdminSalebotImportsRunsRunIdIssuesGetRequest, options?: RawAxiosRequestConfig) {
        return SalebotImportsApiFp(this.configuration).apiV1AdminSalebotImportsRunsRunIdIssuesGet(requestParameters.runId, requestParameters.offset, requestParameters.apiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Продолжить перенос с сохранённой точки
     * @param {SalebotImportsApiApiV1AdminSalebotImportsRunsRunIdResumePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SalebotImportsApi
     */
    public apiV1AdminSalebotImportsRunsRunIdResumePost(requestParameters: SalebotImportsApiApiV1AdminSalebotImportsRunsRunIdResumePostRequest, options?: RawAxiosRequestConfig) {
        return SalebotImportsApiFp(this.configuration).apiV1AdminSalebotImportsRunsRunIdResumePost(requestParameters.runId, requestParameters.apiVersion, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * SchedulerApi - axios parameter creator
 * @export
 */
export const SchedulerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Получить настройки отдельной задачи
         * @param {string} jobKey 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCronJob: async (jobKey: string, apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'jobKey' is not null or undefined
            assertParamExists('getCronJob', 'jobKey', jobKey)
            const localVarPath = `/api/v1/scheduler/{jobKey}`
                .replace(`{${"jobKey"}}`, encodeURIComponent(String(jobKey)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Получить настройки фоновых задач
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCronJobs: async (apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/scheduler`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Выполнить выбранную фоновую задачу один раз
         * @param {string} jobKey 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        runCronJob: async (jobKey: string, apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'jobKey' is not null or undefined
            assertParamExists('runCronJob', 'jobKey', jobKey)
            const localVarPath = `/api/v1/scheduler/{jobKey}/run`
                .replace(`{${"jobKey"}}`, encodeURIComponent(String(jobKey)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Изменить настройки фоновой задачи
         * @param {string} jobKey 
         * @param {string} [apiVersion] 
         * @param {UpdateCronJobRequest} [updateCronJobRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCronJob: async (jobKey: string, apiVersion?: string, updateCronJobRequest?: UpdateCronJobRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'jobKey' is not null or undefined
            assertParamExists('updateCronJob', 'jobKey', jobKey)
            const localVarPath = `/api/v1/scheduler/{jobKey}`
                .replace(`{${"jobKey"}}`, encodeURIComponent(String(jobKey)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateCronJobRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SchedulerApi - functional programming interface
 * @export
 */
export const SchedulerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SchedulerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Получить настройки отдельной задачи
         * @param {string} jobKey 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCronJob(jobKey: string, apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CronJobResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCronJob(jobKey, apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SchedulerApi.getCronJob']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Получить настройки фоновых задач
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCronJobs(apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CronJobResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCronJobs(apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SchedulerApi.getCronJobs']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Выполнить выбранную фоновую задачу один раз
         * @param {string} jobKey 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async runCronJob(jobKey: string, apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.runCronJob(jobKey, apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SchedulerApi.runCronJob']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Изменить настройки фоновой задачи
         * @param {string} jobKey 
         * @param {string} [apiVersion] 
         * @param {UpdateCronJobRequest} [updateCronJobRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateCronJob(jobKey: string, apiVersion?: string, updateCronJobRequest?: UpdateCronJobRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CronJobResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateCronJob(jobKey, apiVersion, updateCronJobRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SchedulerApi.updateCronJob']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * SchedulerApi - factory interface
 * @export
 */
export const SchedulerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SchedulerApiFp(configuration)
    return {
        /**
         * 
         * @summary Получить настройки отдельной задачи
         * @param {SchedulerApiGetCronJobRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCronJob(requestParameters: SchedulerApiGetCronJobRequest, options?: RawAxiosRequestConfig): AxiosPromise<CronJobResponse> {
            return localVarFp.getCronJob(requestParameters.jobKey, requestParameters.apiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Получить настройки фоновых задач
         * @param {SchedulerApiGetCronJobsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCronJobs(requestParameters: SchedulerApiGetCronJobsRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<Array<CronJobResponse>> {
            return localVarFp.getCronJobs(requestParameters.apiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Выполнить выбранную фоновую задачу один раз
         * @param {SchedulerApiRunCronJobRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        runCronJob(requestParameters: SchedulerApiRunCronJobRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.runCronJob(requestParameters.jobKey, requestParameters.apiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Изменить настройки фоновой задачи
         * @param {SchedulerApiUpdateCronJobRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCronJob(requestParameters: SchedulerApiUpdateCronJobRequest, options?: RawAxiosRequestConfig): AxiosPromise<CronJobResponse> {
            return localVarFp.updateCronJob(requestParameters.jobKey, requestParameters.apiVersion, requestParameters.updateCronJobRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for getCronJob operation in SchedulerApi.
 * @export
 * @interface SchedulerApiGetCronJobRequest
 */
export interface SchedulerApiGetCronJobRequest {
    /**
     * 
     * @type {string}
     * @memberof SchedulerApiGetCronJob
     */
    readonly jobKey: string

    /**
     * 
     * @type {string}
     * @memberof SchedulerApiGetCronJob
     */
    readonly apiVersion?: string
}

/**
 * Request parameters for getCronJobs operation in SchedulerApi.
 * @export
 * @interface SchedulerApiGetCronJobsRequest
 */
export interface SchedulerApiGetCronJobsRequest {
    /**
     * 
     * @type {string}
     * @memberof SchedulerApiGetCronJobs
     */
    readonly apiVersion?: string
}

/**
 * Request parameters for runCronJob operation in SchedulerApi.
 * @export
 * @interface SchedulerApiRunCronJobRequest
 */
export interface SchedulerApiRunCronJobRequest {
    /**
     * 
     * @type {string}
     * @memberof SchedulerApiRunCronJob
     */
    readonly jobKey: string

    /**
     * 
     * @type {string}
     * @memberof SchedulerApiRunCronJob
     */
    readonly apiVersion?: string
}

/**
 * Request parameters for updateCronJob operation in SchedulerApi.
 * @export
 * @interface SchedulerApiUpdateCronJobRequest
 */
export interface SchedulerApiUpdateCronJobRequest {
    /**
     * 
     * @type {string}
     * @memberof SchedulerApiUpdateCronJob
     */
    readonly jobKey: string

    /**
     * 
     * @type {string}
     * @memberof SchedulerApiUpdateCronJob
     */
    readonly apiVersion?: string

    /**
     * 
     * @type {UpdateCronJobRequest}
     * @memberof SchedulerApiUpdateCronJob
     */
    readonly updateCronJobRequest?: UpdateCronJobRequest
}

/**
 * SchedulerApi - object-oriented interface
 * @export
 * @class SchedulerApi
 * @extends {BaseAPI}
 */
export class SchedulerApi extends BaseAPI {
    /**
     * 
     * @summary Получить настройки отдельной задачи
     * @param {SchedulerApiGetCronJobRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SchedulerApi
     */
    public getCronJob(requestParameters: SchedulerApiGetCronJobRequest, options?: RawAxiosRequestConfig) {
        return SchedulerApiFp(this.configuration).getCronJob(requestParameters.jobKey, requestParameters.apiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Получить настройки фоновых задач
     * @param {SchedulerApiGetCronJobsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SchedulerApi
     */
    public getCronJobs(requestParameters: SchedulerApiGetCronJobsRequest = {}, options?: RawAxiosRequestConfig) {
        return SchedulerApiFp(this.configuration).getCronJobs(requestParameters.apiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Выполнить выбранную фоновую задачу один раз
     * @param {SchedulerApiRunCronJobRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SchedulerApi
     */
    public runCronJob(requestParameters: SchedulerApiRunCronJobRequest, options?: RawAxiosRequestConfig) {
        return SchedulerApiFp(this.configuration).runCronJob(requestParameters.jobKey, requestParameters.apiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Изменить настройки фоновой задачи
     * @param {SchedulerApiUpdateCronJobRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SchedulerApi
     */
    public updateCronJob(requestParameters: SchedulerApiUpdateCronJobRequest, options?: RawAxiosRequestConfig) {
        return SchedulerApiFp(this.configuration).updateCronJob(requestParameters.jobKey, requestParameters.apiVersion, requestParameters.updateCronJobRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * SubscriptionApi - axios parameter creator
 * @export
 */
export const SubscriptionApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Получить активные к продаже абонементы для определенного типа животного
         * @param {ApiPetType} petType Тип животного
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SubscriptionGetAvailableSubscriptionsPetTypeGet: async (petType: ApiPetType, apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'petType' is not null or undefined
            assertParamExists('apiV1SubscriptionGetAvailableSubscriptionsPetTypeGet', 'petType', petType)
            const localVarPath = `/api/v1/subscription/get-available-subscriptions/{petType}`
                .replace(`{${"petType"}}`, encodeURIComponent(String(petType)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Получить абонементы клиента
         * @param {string} [apiVersion] 
         * @param {GetClientSubscriptionsRequest} [getClientSubscriptionsRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SubscriptionGetClientSubscriptionsPost: async (apiVersion?: string, getClientSubscriptionsRequest?: GetClientSubscriptionsRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/subscription/get-client-subscriptions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(getClientSubscriptionsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Удалить абонемент
         * @param {string} id 
         * @param {string} [apiVersion] 
         * @param {DeleteRequest} [deleteRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SubscriptionIdDelete: async (id: string, apiVersion?: string, deleteRequest?: DeleteRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiV1SubscriptionIdDelete', 'id', id)
            const localVarPath = `/api/v1/subscription/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(deleteRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Получить данные абонемента по ID
         * @param {string} id Идентификатор абонемента
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SubscriptionIdGet: async (id: string, apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiV1SubscriptionIdGet', 'id', id)
            const localVarPath = `/api/v1/subscription/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Создать абонемент
         * @param {string} [apiVersion] 
         * @param {CreateSubscriptionRequest} [createSubscriptionRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSubscription: async (apiVersion?: string, createSubscriptionRequest?: CreateSubscriptionRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/subscription/create-subscription`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createSubscriptionRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Получить абонементы
         * @param {ApiProductType} [productType] Тип продукта на который выпущен абонемент
         * @param {ApiPetType} [petType] Тип животного на который выпущен абонемент
         * @param {boolean} [isActive] 
         * @param {string} [searchQuery] Строка для поиска
         * @param {number} [takeCount] Размер страницы
         * @param {number} [skipCount] Кол-во пропущенных записей
         * @param {boolean} [ascending] Сортировка по возрастанию
         * @param {string} [ordering] Поле для сортировки
         * @param {boolean} [isDeleted] Удалённые записи
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSubscriptions: async (productType?: ApiProductType, petType?: ApiPetType, isActive?: boolean, searchQuery?: string, takeCount?: number, skipCount?: number, ascending?: boolean, ordering?: string, isDeleted?: boolean, apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/subscription/get-subscriptions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (productType !== undefined) {
                localVarQueryParameter['ProductType'] = productType;
            }

            if (petType !== undefined) {
                localVarQueryParameter['PetType'] = petType;
            }

            if (isActive !== undefined) {
                localVarQueryParameter['IsActive'] = isActive;
            }

            if (searchQuery !== undefined) {
                localVarQueryParameter['SearchQuery'] = searchQuery;
            }

            if (takeCount !== undefined) {
                localVarQueryParameter['TakeCount'] = takeCount;
            }

            if (skipCount !== undefined) {
                localVarQueryParameter['SkipCount'] = skipCount;
            }

            if (ascending !== undefined) {
                localVarQueryParameter['Ascending'] = ascending;
            }

            if (ordering !== undefined) {
                localVarQueryParameter['Ordering'] = ordering;
            }

            if (isDeleted !== undefined) {
                localVarQueryParameter['IsDeleted'] = isDeleted;
            }


    
            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Обновить данные абонемента
         * @param {string} id Идентификатор абонемента
         * @param {string} [apiVersion] 
         * @param {UpdateSubscriptionRequest} [updateSubscriptionRequest] Данные абонемента
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSubscription: async (id: string, apiVersion?: string, updateSubscriptionRequest?: UpdateSubscriptionRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateSubscription', 'id', id)
            const localVarPath = `/api/v1/subscription/update-subscription/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateSubscriptionRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SubscriptionApi - functional programming interface
 * @export
 */
export const SubscriptionApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SubscriptionApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Получить активные к продаже абонементы для определенного типа животного
         * @param {ApiPetType} petType Тип животного
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1SubscriptionGetAvailableSubscriptionsPetTypeGet(petType: ApiPetType, apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<FullInfoSubscriptionResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1SubscriptionGetAvailableSubscriptionsPetTypeGet(petType, apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SubscriptionApi.apiV1SubscriptionGetAvailableSubscriptionsPetTypeGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Получить абонементы клиента
         * @param {string} [apiVersion] 
         * @param {GetClientSubscriptionsRequest} [getClientSubscriptionsRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1SubscriptionGetClientSubscriptionsPost(apiVersion?: string, getClientSubscriptionsRequest?: GetClientSubscriptionsRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetClientSubscriptionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1SubscriptionGetClientSubscriptionsPost(apiVersion, getClientSubscriptionsRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SubscriptionApi.apiV1SubscriptionGetClientSubscriptionsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Удалить абонемент
         * @param {string} id 
         * @param {string} [apiVersion] 
         * @param {DeleteRequest} [deleteRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1SubscriptionIdDelete(id: string, apiVersion?: string, deleteRequest?: DeleteRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1SubscriptionIdDelete(id, apiVersion, deleteRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SubscriptionApi.apiV1SubscriptionIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Получить данные абонемента по ID
         * @param {string} id Идентификатор абонемента
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1SubscriptionIdGet(id: string, apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SubscriptionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1SubscriptionIdGet(id, apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SubscriptionApi.apiV1SubscriptionIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Создать абонемент
         * @param {string} [apiVersion] 
         * @param {CreateSubscriptionRequest} [createSubscriptionRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createSubscription(apiVersion?: string, createSubscriptionRequest?: CreateSubscriptionRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SubscriptionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createSubscription(apiVersion, createSubscriptionRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SubscriptionApi.createSubscription']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Получить абонементы
         * @param {ApiProductType} [productType] Тип продукта на который выпущен абонемент
         * @param {ApiPetType} [petType] Тип животного на который выпущен абонемент
         * @param {boolean} [isActive] 
         * @param {string} [searchQuery] Строка для поиска
         * @param {number} [takeCount] Размер страницы
         * @param {number} [skipCount] Кол-во пропущенных записей
         * @param {boolean} [ascending] Сортировка по возрастанию
         * @param {string} [ordering] Поле для сортировки
         * @param {boolean} [isDeleted] Удалённые записи
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSubscriptions(productType?: ApiProductType, petType?: ApiPetType, isActive?: boolean, searchQuery?: string, takeCount?: number, skipCount?: number, ascending?: boolean, ordering?: string, isDeleted?: boolean, apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetSubscriptionsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSubscriptions(productType, petType, isActive, searchQuery, takeCount, skipCount, ascending, ordering, isDeleted, apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SubscriptionApi.getSubscriptions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Обновить данные абонемента
         * @param {string} id Идентификатор абонемента
         * @param {string} [apiVersion] 
         * @param {UpdateSubscriptionRequest} [updateSubscriptionRequest] Данные абонемента
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateSubscription(id: string, apiVersion?: string, updateSubscriptionRequest?: UpdateSubscriptionRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SubscriptionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateSubscription(id, apiVersion, updateSubscriptionRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SubscriptionApi.updateSubscription']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * SubscriptionApi - factory interface
 * @export
 */
export const SubscriptionApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SubscriptionApiFp(configuration)
    return {
        /**
         * 
         * @summary Получить активные к продаже абонементы для определенного типа животного
         * @param {SubscriptionApiApiV1SubscriptionGetAvailableSubscriptionsPetTypeGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SubscriptionGetAvailableSubscriptionsPetTypeGet(requestParameters: SubscriptionApiApiV1SubscriptionGetAvailableSubscriptionsPetTypeGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<FullInfoSubscriptionResponse>> {
            return localVarFp.apiV1SubscriptionGetAvailableSubscriptionsPetTypeGet(requestParameters.petType, requestParameters.apiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Получить абонементы клиента
         * @param {SubscriptionApiApiV1SubscriptionGetClientSubscriptionsPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SubscriptionGetClientSubscriptionsPost(requestParameters: SubscriptionApiApiV1SubscriptionGetClientSubscriptionsPostRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<GetClientSubscriptionResponse> {
            return localVarFp.apiV1SubscriptionGetClientSubscriptionsPost(requestParameters.apiVersion, requestParameters.getClientSubscriptionsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Удалить абонемент
         * @param {SubscriptionApiApiV1SubscriptionIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SubscriptionIdDelete(requestParameters: SubscriptionApiApiV1SubscriptionIdDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiV1SubscriptionIdDelete(requestParameters.id, requestParameters.apiVersion, requestParameters.deleteRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Получить данные абонемента по ID
         * @param {SubscriptionApiApiV1SubscriptionIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SubscriptionIdGet(requestParameters: SubscriptionApiApiV1SubscriptionIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<SubscriptionResponse> {
            return localVarFp.apiV1SubscriptionIdGet(requestParameters.id, requestParameters.apiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Создать абонемент
         * @param {SubscriptionApiCreateSubscriptionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSubscription(requestParameters: SubscriptionApiCreateSubscriptionRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<SubscriptionResponse> {
            return localVarFp.createSubscription(requestParameters.apiVersion, requestParameters.createSubscriptionRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Получить абонементы
         * @param {SubscriptionApiGetSubscriptionsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSubscriptions(requestParameters: SubscriptionApiGetSubscriptionsRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<GetSubscriptionsResponse> {
            return localVarFp.getSubscriptions(requestParameters.productType, requestParameters.petType, requestParameters.isActive, requestParameters.searchQuery, requestParameters.takeCount, requestParameters.skipCount, requestParameters.ascending, requestParameters.ordering, requestParameters.isDeleted, requestParameters.apiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Обновить данные абонемента
         * @param {SubscriptionApiUpdateSubscriptionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSubscription(requestParameters: SubscriptionApiUpdateSubscriptionRequest, options?: RawAxiosRequestConfig): AxiosPromise<SubscriptionResponse> {
            return localVarFp.updateSubscription(requestParameters.id, requestParameters.apiVersion, requestParameters.updateSubscriptionRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for apiV1SubscriptionGetAvailableSubscriptionsPetTypeGet operation in SubscriptionApi.
 * @export
 * @interface SubscriptionApiApiV1SubscriptionGetAvailableSubscriptionsPetTypeGetRequest
 */
export interface SubscriptionApiApiV1SubscriptionGetAvailableSubscriptionsPetTypeGetRequest {
    /**
     * Тип животного
     * @type {ApiPetType}
     * @memberof SubscriptionApiApiV1SubscriptionGetAvailableSubscriptionsPetTypeGet
     */
    readonly petType: ApiPetType

    /**
     * 
     * @type {string}
     * @memberof SubscriptionApiApiV1SubscriptionGetAvailableSubscriptionsPetTypeGet
     */
    readonly apiVersion?: string
}

/**
 * Request parameters for apiV1SubscriptionGetClientSubscriptionsPost operation in SubscriptionApi.
 * @export
 * @interface SubscriptionApiApiV1SubscriptionGetClientSubscriptionsPostRequest
 */
export interface SubscriptionApiApiV1SubscriptionGetClientSubscriptionsPostRequest {
    /**
     * 
     * @type {string}
     * @memberof SubscriptionApiApiV1SubscriptionGetClientSubscriptionsPost
     */
    readonly apiVersion?: string

    /**
     * 
     * @type {GetClientSubscriptionsRequest}
     * @memberof SubscriptionApiApiV1SubscriptionGetClientSubscriptionsPost
     */
    readonly getClientSubscriptionsRequest?: GetClientSubscriptionsRequest
}

/**
 * Request parameters for apiV1SubscriptionIdDelete operation in SubscriptionApi.
 * @export
 * @interface SubscriptionApiApiV1SubscriptionIdDeleteRequest
 */
export interface SubscriptionApiApiV1SubscriptionIdDeleteRequest {
    /**
     * 
     * @type {string}
     * @memberof SubscriptionApiApiV1SubscriptionIdDelete
     */
    readonly id: string

    /**
     * 
     * @type {string}
     * @memberof SubscriptionApiApiV1SubscriptionIdDelete
     */
    readonly apiVersion?: string

    /**
     * 
     * @type {DeleteRequest}
     * @memberof SubscriptionApiApiV1SubscriptionIdDelete
     */
    readonly deleteRequest?: DeleteRequest
}

/**
 * Request parameters for apiV1SubscriptionIdGet operation in SubscriptionApi.
 * @export
 * @interface SubscriptionApiApiV1SubscriptionIdGetRequest
 */
export interface SubscriptionApiApiV1SubscriptionIdGetRequest {
    /**
     * Идентификатор абонемента
     * @type {string}
     * @memberof SubscriptionApiApiV1SubscriptionIdGet
     */
    readonly id: string

    /**
     * 
     * @type {string}
     * @memberof SubscriptionApiApiV1SubscriptionIdGet
     */
    readonly apiVersion?: string
}

/**
 * Request parameters for createSubscription operation in SubscriptionApi.
 * @export
 * @interface SubscriptionApiCreateSubscriptionRequest
 */
export interface SubscriptionApiCreateSubscriptionRequest {
    /**
     * 
     * @type {string}
     * @memberof SubscriptionApiCreateSubscription
     */
    readonly apiVersion?: string

    /**
     * 
     * @type {CreateSubscriptionRequest}
     * @memberof SubscriptionApiCreateSubscription
     */
    readonly createSubscriptionRequest?: CreateSubscriptionRequest
}

/**
 * Request parameters for getSubscriptions operation in SubscriptionApi.
 * @export
 * @interface SubscriptionApiGetSubscriptionsRequest
 */
export interface SubscriptionApiGetSubscriptionsRequest {
    /**
     * Тип продукта на который выпущен абонемент
     * @type {ApiProductType}
     * @memberof SubscriptionApiGetSubscriptions
     */
    readonly productType?: ApiProductType

    /**
     * Тип животного на который выпущен абонемент
     * @type {ApiPetType}
     * @memberof SubscriptionApiGetSubscriptions
     */
    readonly petType?: ApiPetType

    /**
     * 
     * @type {boolean}
     * @memberof SubscriptionApiGetSubscriptions
     */
    readonly isActive?: boolean

    /**
     * Строка для поиска
     * @type {string}
     * @memberof SubscriptionApiGetSubscriptions
     */
    readonly searchQuery?: string

    /**
     * Размер страницы
     * @type {number}
     * @memberof SubscriptionApiGetSubscriptions
     */
    readonly takeCount?: number

    /**
     * Кол-во пропущенных записей
     * @type {number}
     * @memberof SubscriptionApiGetSubscriptions
     */
    readonly skipCount?: number

    /**
     * Сортировка по возрастанию
     * @type {boolean}
     * @memberof SubscriptionApiGetSubscriptions
     */
    readonly ascending?: boolean

    /**
     * Поле для сортировки
     * @type {string}
     * @memberof SubscriptionApiGetSubscriptions
     */
    readonly ordering?: string

    /**
     * Удалённые записи
     * @type {boolean}
     * @memberof SubscriptionApiGetSubscriptions
     */
    readonly isDeleted?: boolean

    /**
     * 
     * @type {string}
     * @memberof SubscriptionApiGetSubscriptions
     */
    readonly apiVersion?: string
}

/**
 * Request parameters for updateSubscription operation in SubscriptionApi.
 * @export
 * @interface SubscriptionApiUpdateSubscriptionRequest
 */
export interface SubscriptionApiUpdateSubscriptionRequest {
    /**
     * Идентификатор абонемента
     * @type {string}
     * @memberof SubscriptionApiUpdateSubscription
     */
    readonly id: string

    /**
     * 
     * @type {string}
     * @memberof SubscriptionApiUpdateSubscription
     */
    readonly apiVersion?: string

    /**
     * Данные абонемента
     * @type {UpdateSubscriptionRequest}
     * @memberof SubscriptionApiUpdateSubscription
     */
    readonly updateSubscriptionRequest?: UpdateSubscriptionRequest
}

/**
 * SubscriptionApi - object-oriented interface
 * @export
 * @class SubscriptionApi
 * @extends {BaseAPI}
 */
export class SubscriptionApi extends BaseAPI {
    /**
     * 
     * @summary Получить активные к продаже абонементы для определенного типа животного
     * @param {SubscriptionApiApiV1SubscriptionGetAvailableSubscriptionsPetTypeGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SubscriptionApi
     */
    public apiV1SubscriptionGetAvailableSubscriptionsPetTypeGet(requestParameters: SubscriptionApiApiV1SubscriptionGetAvailableSubscriptionsPetTypeGetRequest, options?: RawAxiosRequestConfig) {
        return SubscriptionApiFp(this.configuration).apiV1SubscriptionGetAvailableSubscriptionsPetTypeGet(requestParameters.petType, requestParameters.apiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Получить абонементы клиента
     * @param {SubscriptionApiApiV1SubscriptionGetClientSubscriptionsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SubscriptionApi
     */
    public apiV1SubscriptionGetClientSubscriptionsPost(requestParameters: SubscriptionApiApiV1SubscriptionGetClientSubscriptionsPostRequest = {}, options?: RawAxiosRequestConfig) {
        return SubscriptionApiFp(this.configuration).apiV1SubscriptionGetClientSubscriptionsPost(requestParameters.apiVersion, requestParameters.getClientSubscriptionsRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Удалить абонемент
     * @param {SubscriptionApiApiV1SubscriptionIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SubscriptionApi
     */
    public apiV1SubscriptionIdDelete(requestParameters: SubscriptionApiApiV1SubscriptionIdDeleteRequest, options?: RawAxiosRequestConfig) {
        return SubscriptionApiFp(this.configuration).apiV1SubscriptionIdDelete(requestParameters.id, requestParameters.apiVersion, requestParameters.deleteRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Получить данные абонемента по ID
     * @param {SubscriptionApiApiV1SubscriptionIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SubscriptionApi
     */
    public apiV1SubscriptionIdGet(requestParameters: SubscriptionApiApiV1SubscriptionIdGetRequest, options?: RawAxiosRequestConfig) {
        return SubscriptionApiFp(this.configuration).apiV1SubscriptionIdGet(requestParameters.id, requestParameters.apiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Создать абонемент
     * @param {SubscriptionApiCreateSubscriptionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SubscriptionApi
     */
    public createSubscription(requestParameters: SubscriptionApiCreateSubscriptionRequest = {}, options?: RawAxiosRequestConfig) {
        return SubscriptionApiFp(this.configuration).createSubscription(requestParameters.apiVersion, requestParameters.createSubscriptionRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Получить абонементы
     * @param {SubscriptionApiGetSubscriptionsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SubscriptionApi
     */
    public getSubscriptions(requestParameters: SubscriptionApiGetSubscriptionsRequest = {}, options?: RawAxiosRequestConfig) {
        return SubscriptionApiFp(this.configuration).getSubscriptions(requestParameters.productType, requestParameters.petType, requestParameters.isActive, requestParameters.searchQuery, requestParameters.takeCount, requestParameters.skipCount, requestParameters.ascending, requestParameters.ordering, requestParameters.isDeleted, requestParameters.apiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Обновить данные абонемента
     * @param {SubscriptionApiUpdateSubscriptionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SubscriptionApi
     */
    public updateSubscription(requestParameters: SubscriptionApiUpdateSubscriptionRequest, options?: RawAxiosRequestConfig) {
        return SubscriptionApiFp(this.configuration).updateSubscription(requestParameters.id, requestParameters.apiVersion, requestParameters.updateSubscriptionRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * TagApi - axios parameter creator
 * @export
 */
export const TagApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Получить ссылку рекрутера для верификации исполнителя
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getExecutorRecruiter: async (apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/tags/executor-recruiter`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Получить тег по типу тега
         * @param {ApiTagType} [tagType] Тип тега
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTag: async (tagType?: ApiTagType, apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/tags`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (tagType !== undefined) {
                localVarQueryParameter['tagType'] = tagType;
            }


    
            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Получить все теги
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTags: async (apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/tags/get-tags`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Обновить значение тега
         * @param {string} id 
         * @param {string} [apiVersion] 
         * @param {UpdateTagRequest} [updateTagRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTag: async (id: string, apiVersion?: string, updateTagRequest?: UpdateTagRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateTag', 'id', id)
            const localVarPath = `/api/v1/tags/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateTagRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TagApi - functional programming interface
 * @export
 */
export const TagApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TagApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Получить ссылку рекрутера для верификации исполнителя
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getExecutorRecruiter(apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TagResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getExecutorRecruiter(apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TagApi.getExecutorRecruiter']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Получить тег по типу тега
         * @param {ApiTagType} [tagType] Тип тега
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTag(tagType?: ApiTagType, apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TagResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTag(tagType, apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TagApi.getTag']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Получить все теги
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTags(apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<TagResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTags(apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TagApi.getTags']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Обновить значение тега
         * @param {string} id 
         * @param {string} [apiVersion] 
         * @param {UpdateTagRequest} [updateTagRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateTag(id: string, apiVersion?: string, updateTagRequest?: UpdateTagRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TagResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateTag(id, apiVersion, updateTagRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TagApi.updateTag']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * TagApi - factory interface
 * @export
 */
export const TagApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TagApiFp(configuration)
    return {
        /**
         * 
         * @summary Получить ссылку рекрутера для верификации исполнителя
         * @param {TagApiGetExecutorRecruiterRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getExecutorRecruiter(requestParameters: TagApiGetExecutorRecruiterRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<TagResponse> {
            return localVarFp.getExecutorRecruiter(requestParameters.apiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Получить тег по типу тега
         * @param {TagApiGetTagRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTag(requestParameters: TagApiGetTagRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<TagResponse> {
            return localVarFp.getTag(requestParameters.tagType, requestParameters.apiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Получить все теги
         * @param {TagApiGetTagsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTags(requestParameters: TagApiGetTagsRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<Array<TagResponse>> {
            return localVarFp.getTags(requestParameters.apiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Обновить значение тега
         * @param {TagApiUpdateTagRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTag(requestParameters: TagApiUpdateTagRequest, options?: RawAxiosRequestConfig): AxiosPromise<TagResponse> {
            return localVarFp.updateTag(requestParameters.id, requestParameters.apiVersion, requestParameters.updateTagRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for getExecutorRecruiter operation in TagApi.
 * @export
 * @interface TagApiGetExecutorRecruiterRequest
 */
export interface TagApiGetExecutorRecruiterRequest {
    /**
     * 
     * @type {string}
     * @memberof TagApiGetExecutorRecruiter
     */
    readonly apiVersion?: string
}

/**
 * Request parameters for getTag operation in TagApi.
 * @export
 * @interface TagApiGetTagRequest
 */
export interface TagApiGetTagRequest {
    /**
     * Тип тега
     * @type {ApiTagType}
     * @memberof TagApiGetTag
     */
    readonly tagType?: ApiTagType

    /**
     * 
     * @type {string}
     * @memberof TagApiGetTag
     */
    readonly apiVersion?: string
}

/**
 * Request parameters for getTags operation in TagApi.
 * @export
 * @interface TagApiGetTagsRequest
 */
export interface TagApiGetTagsRequest {
    /**
     * 
     * @type {string}
     * @memberof TagApiGetTags
     */
    readonly apiVersion?: string
}

/**
 * Request parameters for updateTag operation in TagApi.
 * @export
 * @interface TagApiUpdateTagRequest
 */
export interface TagApiUpdateTagRequest {
    /**
     * 
     * @type {string}
     * @memberof TagApiUpdateTag
     */
    readonly id: string

    /**
     * 
     * @type {string}
     * @memberof TagApiUpdateTag
     */
    readonly apiVersion?: string

    /**
     * 
     * @type {UpdateTagRequest}
     * @memberof TagApiUpdateTag
     */
    readonly updateTagRequest?: UpdateTagRequest
}

/**
 * TagApi - object-oriented interface
 * @export
 * @class TagApi
 * @extends {BaseAPI}
 */
export class TagApi extends BaseAPI {
    /**
     * 
     * @summary Получить ссылку рекрутера для верификации исполнителя
     * @param {TagApiGetExecutorRecruiterRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TagApi
     */
    public getExecutorRecruiter(requestParameters: TagApiGetExecutorRecruiterRequest = {}, options?: RawAxiosRequestConfig) {
        return TagApiFp(this.configuration).getExecutorRecruiter(requestParameters.apiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Получить тег по типу тега
     * @param {TagApiGetTagRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TagApi
     */
    public getTag(requestParameters: TagApiGetTagRequest = {}, options?: RawAxiosRequestConfig) {
        return TagApiFp(this.configuration).getTag(requestParameters.tagType, requestParameters.apiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Получить все теги
     * @param {TagApiGetTagsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TagApi
     */
    public getTags(requestParameters: TagApiGetTagsRequest = {}, options?: RawAxiosRequestConfig) {
        return TagApiFp(this.configuration).getTags(requestParameters.apiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Обновить значение тега
     * @param {TagApiUpdateTagRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TagApi
     */
    public updateTag(requestParameters: TagApiUpdateTagRequest, options?: RawAxiosRequestConfig) {
        return TagApiFp(this.configuration).updateTag(requestParameters.id, requestParameters.apiVersion, requestParameters.updateTagRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * TelegramAssistantApi - axios parameter creator
 * @export
 */
export const TelegramAssistantApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Получить или сгенерировать телеграм ссылку для привязки аккаунта
         * @param {string} appUserId Идентификатор пользователя
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrGenerateTelegramLink: async (appUserId: string, apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'appUserId' is not null or undefined
            assertParamExists('getOrGenerateTelegramLink', 'appUserId', appUserId)
            const localVarPath = `/api/v1/telegram-assistant/get-or-generate-telegram-link/{appUserId}`
                .replace(`{${"appUserId"}}`, encodeURIComponent(String(appUserId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Обработать обновление Telegram-бота текущего окружения
         * @param {string} [xVoxTelegramProxySecret] 
         * @param {string} [apiVersion] 
         * @param {TelegramUpdateRequest} [telegramUpdateRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        handleUpdate: async (xVoxTelegramProxySecret?: string, apiVersion?: string, telegramUpdateRequest?: TelegramUpdateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/telegram-assistant`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            if (xVoxTelegramProxySecret != null) {
                localVarHeaderParameter['X-Vox-Telegram-Proxy-Secret'] = String(xVoxTelegramProxySecret);
            }
            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(telegramUpdateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary По сигналу прокси отправить ему текущую конфигурацию webhook
         * @param {string} [xVoxTelegramProxySecret] 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        requestWebhookSync: async (xVoxTelegramProxySecret?: string, apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/telegram-assistant/webhook-sync`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            if (xVoxTelegramProxySecret != null) {
                localVarHeaderParameter['X-Vox-Telegram-Proxy-Secret'] = String(xVoxTelegramProxySecret);
            }
            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Отвязать Телеграмм от аккаунта
         * @param {string} appUserId Идентификатор пользователя
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unlinkTelegram: async (appUserId: string, apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'appUserId' is not null or undefined
            assertParamExists('unlinkTelegram', 'appUserId', appUserId)
            const localVarPath = `/api/v1/telegram-assistant/unlink-telegram/{appUserId}`
                .replace(`{${"appUserId"}}`, encodeURIComponent(String(appUserId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TelegramAssistantApi - functional programming interface
 * @export
 */
export const TelegramAssistantApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TelegramAssistantApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Получить или сгенерировать телеграм ссылку для привязки аккаунта
         * @param {string} appUserId Идентификатор пользователя
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOrGenerateTelegramLink(appUserId: string, apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOrGenerateTelegramLink(appUserId, apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TelegramAssistantApi.getOrGenerateTelegramLink']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Обработать обновление Telegram-бота текущего окружения
         * @param {string} [xVoxTelegramProxySecret] 
         * @param {string} [apiVersion] 
         * @param {TelegramUpdateRequest} [telegramUpdateRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async handleUpdate(xVoxTelegramProxySecret?: string, apiVersion?: string, telegramUpdateRequest?: TelegramUpdateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.handleUpdate(xVoxTelegramProxySecret, apiVersion, telegramUpdateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TelegramAssistantApi.handleUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary По сигналу прокси отправить ему текущую конфигурацию webhook
         * @param {string} [xVoxTelegramProxySecret] 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async requestWebhookSync(xVoxTelegramProxySecret?: string, apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.requestWebhookSync(xVoxTelegramProxySecret, apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TelegramAssistantApi.requestWebhookSync']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Отвязать Телеграмм от аккаунта
         * @param {string} appUserId Идентификатор пользователя
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async unlinkTelegram(appUserId: string, apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.unlinkTelegram(appUserId, apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TelegramAssistantApi.unlinkTelegram']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * TelegramAssistantApi - factory interface
 * @export
 */
export const TelegramAssistantApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TelegramAssistantApiFp(configuration)
    return {
        /**
         * 
         * @summary Получить или сгенерировать телеграм ссылку для привязки аккаунта
         * @param {TelegramAssistantApiGetOrGenerateTelegramLinkRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrGenerateTelegramLink(requestParameters: TelegramAssistantApiGetOrGenerateTelegramLinkRequest, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.getOrGenerateTelegramLink(requestParameters.appUserId, requestParameters.apiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Обработать обновление Telegram-бота текущего окружения
         * @param {TelegramAssistantApiHandleUpdateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        handleUpdate(requestParameters: TelegramAssistantApiHandleUpdateRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.handleUpdate(requestParameters.xVoxTelegramProxySecret, requestParameters.apiVersion, requestParameters.telegramUpdateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary По сигналу прокси отправить ему текущую конфигурацию webhook
         * @param {TelegramAssistantApiRequestWebhookSyncRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        requestWebhookSync(requestParameters: TelegramAssistantApiRequestWebhookSyncRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.requestWebhookSync(requestParameters.xVoxTelegramProxySecret, requestParameters.apiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Отвязать Телеграмм от аккаунта
         * @param {TelegramAssistantApiUnlinkTelegramRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unlinkTelegram(requestParameters: TelegramAssistantApiUnlinkTelegramRequest, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.unlinkTelegram(requestParameters.appUserId, requestParameters.apiVersion, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for getOrGenerateTelegramLink operation in TelegramAssistantApi.
 * @export
 * @interface TelegramAssistantApiGetOrGenerateTelegramLinkRequest
 */
export interface TelegramAssistantApiGetOrGenerateTelegramLinkRequest {
    /**
     * Идентификатор пользователя
     * @type {string}
     * @memberof TelegramAssistantApiGetOrGenerateTelegramLink
     */
    readonly appUserId: string

    /**
     * 
     * @type {string}
     * @memberof TelegramAssistantApiGetOrGenerateTelegramLink
     */
    readonly apiVersion?: string
}

/**
 * Request parameters for handleUpdate operation in TelegramAssistantApi.
 * @export
 * @interface TelegramAssistantApiHandleUpdateRequest
 */
export interface TelegramAssistantApiHandleUpdateRequest {
    /**
     * 
     * @type {string}
     * @memberof TelegramAssistantApiHandleUpdate
     */
    readonly xVoxTelegramProxySecret?: string

    /**
     * 
     * @type {string}
     * @memberof TelegramAssistantApiHandleUpdate
     */
    readonly apiVersion?: string

    /**
     * 
     * @type {TelegramUpdateRequest}
     * @memberof TelegramAssistantApiHandleUpdate
     */
    readonly telegramUpdateRequest?: TelegramUpdateRequest
}

/**
 * Request parameters for requestWebhookSync operation in TelegramAssistantApi.
 * @export
 * @interface TelegramAssistantApiRequestWebhookSyncRequest
 */
export interface TelegramAssistantApiRequestWebhookSyncRequest {
    /**
     * 
     * @type {string}
     * @memberof TelegramAssistantApiRequestWebhookSync
     */
    readonly xVoxTelegramProxySecret?: string

    /**
     * 
     * @type {string}
     * @memberof TelegramAssistantApiRequestWebhookSync
     */
    readonly apiVersion?: string
}

/**
 * Request parameters for unlinkTelegram operation in TelegramAssistantApi.
 * @export
 * @interface TelegramAssistantApiUnlinkTelegramRequest
 */
export interface TelegramAssistantApiUnlinkTelegramRequest {
    /**
     * Идентификатор пользователя
     * @type {string}
     * @memberof TelegramAssistantApiUnlinkTelegram
     */
    readonly appUserId: string

    /**
     * 
     * @type {string}
     * @memberof TelegramAssistantApiUnlinkTelegram
     */
    readonly apiVersion?: string
}

/**
 * TelegramAssistantApi - object-oriented interface
 * @export
 * @class TelegramAssistantApi
 * @extends {BaseAPI}
 */
export class TelegramAssistantApi extends BaseAPI {
    /**
     * 
     * @summary Получить или сгенерировать телеграм ссылку для привязки аккаунта
     * @param {TelegramAssistantApiGetOrGenerateTelegramLinkRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TelegramAssistantApi
     */
    public getOrGenerateTelegramLink(requestParameters: TelegramAssistantApiGetOrGenerateTelegramLinkRequest, options?: RawAxiosRequestConfig) {
        return TelegramAssistantApiFp(this.configuration).getOrGenerateTelegramLink(requestParameters.appUserId, requestParameters.apiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Обработать обновление Telegram-бота текущего окружения
     * @param {TelegramAssistantApiHandleUpdateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TelegramAssistantApi
     */
    public handleUpdate(requestParameters: TelegramAssistantApiHandleUpdateRequest = {}, options?: RawAxiosRequestConfig) {
        return TelegramAssistantApiFp(this.configuration).handleUpdate(requestParameters.xVoxTelegramProxySecret, requestParameters.apiVersion, requestParameters.telegramUpdateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary По сигналу прокси отправить ему текущую конфигурацию webhook
     * @param {TelegramAssistantApiRequestWebhookSyncRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TelegramAssistantApi
     */
    public requestWebhookSync(requestParameters: TelegramAssistantApiRequestWebhookSyncRequest = {}, options?: RawAxiosRequestConfig) {
        return TelegramAssistantApiFp(this.configuration).requestWebhookSync(requestParameters.xVoxTelegramProxySecret, requestParameters.apiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Отвязать Телеграмм от аккаунта
     * @param {TelegramAssistantApiUnlinkTelegramRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TelegramAssistantApi
     */
    public unlinkTelegram(requestParameters: TelegramAssistantApiUnlinkTelegramRequest, options?: RawAxiosRequestConfig) {
        return TelegramAssistantApiFp(this.configuration).unlinkTelegram(requestParameters.appUserId, requestParameters.apiVersion, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * TelegramSettingsApi - axios parameter creator
 * @export
 */
export const TelegramSettingsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Получить настройки Telegram без токенов
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTelegramSettings: async (apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/telegram-settings/get-telegram-settings`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TelegramSettingsApi - functional programming interface
 * @export
 */
export const TelegramSettingsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TelegramSettingsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Получить настройки Telegram без токенов
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTelegramSettings(apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TelegramSettingsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTelegramSettings(apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TelegramSettingsApi.getTelegramSettings']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * TelegramSettingsApi - factory interface
 * @export
 */
export const TelegramSettingsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TelegramSettingsApiFp(configuration)
    return {
        /**
         * 
         * @summary Получить настройки Telegram без токенов
         * @param {TelegramSettingsApiGetTelegramSettingsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTelegramSettings(requestParameters: TelegramSettingsApiGetTelegramSettingsRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<TelegramSettingsResponse> {
            return localVarFp.getTelegramSettings(requestParameters.apiVersion, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for getTelegramSettings operation in TelegramSettingsApi.
 * @export
 * @interface TelegramSettingsApiGetTelegramSettingsRequest
 */
export interface TelegramSettingsApiGetTelegramSettingsRequest {
    /**
     * 
     * @type {string}
     * @memberof TelegramSettingsApiGetTelegramSettings
     */
    readonly apiVersion?: string
}

/**
 * TelegramSettingsApi - object-oriented interface
 * @export
 * @class TelegramSettingsApi
 * @extends {BaseAPI}
 */
export class TelegramSettingsApi extends BaseAPI {
    /**
     * 
     * @summary Получить настройки Telegram без токенов
     * @param {TelegramSettingsApiGetTelegramSettingsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TelegramSettingsApi
     */
    public getTelegramSettings(requestParameters: TelegramSettingsApiGetTelegramSettingsRequest = {}, options?: RawAxiosRequestConfig) {
        return TelegramSettingsApiFp(this.configuration).getTelegramSettings(requestParameters.apiVersion, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * TelegramSettingsAdminApi - axios parameter creator
 * @export
 */
export const TelegramSettingsAdminApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Получить токен выбранного бота
         * @param {number} [code] 
         * @param {ApiTelegramBot} [bot] Назначение бота Telegram
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBotToken: async (code?: number, bot?: ApiTelegramBot, apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/telegram-settings/bot-token`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (code !== undefined) {
                localVarQueryParameter['code'] = code;
            }

            if (bot !== undefined) {
                localVarQueryParameter['bot'] = bot;
            }


    
            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Сохранить настройки Telegram
         * @param {string} [apiVersion] 
         * @param {SaveTelegramSettingsRequest} [saveTelegramSettingsRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveTelegramSettings: async (apiVersion?: string, saveTelegramSettingsRequest?: SaveTelegramSettingsRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/telegram-settings/save`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(saveTelegramSettingsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Отправить проверочное сообщение выбранным ботом в чат
         * @param {string} [apiVersion] 
         * @param {SendTelegramTestMessageRequest} [sendTelegramTestMessageRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendTestMessage: async (apiVersion?: string, sendTelegramTestMessageRequest?: SendTelegramTestMessageRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/telegram-settings/test-message`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(sendTelegramTestMessageRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TelegramSettingsAdminApi - functional programming interface
 * @export
 */
export const TelegramSettingsAdminApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TelegramSettingsAdminApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Получить токен выбранного бота
         * @param {number} [code] 
         * @param {ApiTelegramBot} [bot] Назначение бота Telegram
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getBotToken(code?: number, bot?: ApiTelegramBot, apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TelegramBotTokenResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getBotToken(code, bot, apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TelegramSettingsAdminApi.getBotToken']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Сохранить настройки Telegram
         * @param {string} [apiVersion] 
         * @param {SaveTelegramSettingsRequest} [saveTelegramSettingsRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async saveTelegramSettings(apiVersion?: string, saveTelegramSettingsRequest?: SaveTelegramSettingsRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TelegramSettingsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.saveTelegramSettings(apiVersion, saveTelegramSettingsRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TelegramSettingsAdminApi.saveTelegramSettings']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Отправить проверочное сообщение выбранным ботом в чат
         * @param {string} [apiVersion] 
         * @param {SendTelegramTestMessageRequest} [sendTelegramTestMessageRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sendTestMessage(apiVersion?: string, sendTelegramTestMessageRequest?: SendTelegramTestMessageRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sendTestMessage(apiVersion, sendTelegramTestMessageRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TelegramSettingsAdminApi.sendTestMessage']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * TelegramSettingsAdminApi - factory interface
 * @export
 */
export const TelegramSettingsAdminApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TelegramSettingsAdminApiFp(configuration)
    return {
        /**
         * 
         * @summary Получить токен выбранного бота
         * @param {TelegramSettingsAdminApiGetBotTokenRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBotToken(requestParameters: TelegramSettingsAdminApiGetBotTokenRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<TelegramBotTokenResponse> {
            return localVarFp.getBotToken(requestParameters.code, requestParameters.bot, requestParameters.apiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Сохранить настройки Telegram
         * @param {TelegramSettingsAdminApiSaveTelegramSettingsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveTelegramSettings(requestParameters: TelegramSettingsAdminApiSaveTelegramSettingsRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<TelegramSettingsResponse> {
            return localVarFp.saveTelegramSettings(requestParameters.apiVersion, requestParameters.saveTelegramSettingsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Отправить проверочное сообщение выбранным ботом в чат
         * @param {TelegramSettingsAdminApiSendTestMessageRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendTestMessage(requestParameters: TelegramSettingsAdminApiSendTestMessageRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.sendTestMessage(requestParameters.apiVersion, requestParameters.sendTelegramTestMessageRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for getBotToken operation in TelegramSettingsAdminApi.
 * @export
 * @interface TelegramSettingsAdminApiGetBotTokenRequest
 */
export interface TelegramSettingsAdminApiGetBotTokenRequest {
    /**
     * 
     * @type {number}
     * @memberof TelegramSettingsAdminApiGetBotToken
     */
    readonly code?: number

    /**
     * Назначение бота Telegram
     * @type {ApiTelegramBot}
     * @memberof TelegramSettingsAdminApiGetBotToken
     */
    readonly bot?: ApiTelegramBot

    /**
     * 
     * @type {string}
     * @memberof TelegramSettingsAdminApiGetBotToken
     */
    readonly apiVersion?: string
}

/**
 * Request parameters for saveTelegramSettings operation in TelegramSettingsAdminApi.
 * @export
 * @interface TelegramSettingsAdminApiSaveTelegramSettingsRequest
 */
export interface TelegramSettingsAdminApiSaveTelegramSettingsRequest {
    /**
     * 
     * @type {string}
     * @memberof TelegramSettingsAdminApiSaveTelegramSettings
     */
    readonly apiVersion?: string

    /**
     * 
     * @type {SaveTelegramSettingsRequest}
     * @memberof TelegramSettingsAdminApiSaveTelegramSettings
     */
    readonly saveTelegramSettingsRequest?: SaveTelegramSettingsRequest
}

/**
 * Request parameters for sendTestMessage operation in TelegramSettingsAdminApi.
 * @export
 * @interface TelegramSettingsAdminApiSendTestMessageRequest
 */
export interface TelegramSettingsAdminApiSendTestMessageRequest {
    /**
     * 
     * @type {string}
     * @memberof TelegramSettingsAdminApiSendTestMessage
     */
    readonly apiVersion?: string

    /**
     * 
     * @type {SendTelegramTestMessageRequest}
     * @memberof TelegramSettingsAdminApiSendTestMessage
     */
    readonly sendTelegramTestMessageRequest?: SendTelegramTestMessageRequest
}

/**
 * TelegramSettingsAdminApi - object-oriented interface
 * @export
 * @class TelegramSettingsAdminApi
 * @extends {BaseAPI}
 */
export class TelegramSettingsAdminApi extends BaseAPI {
    /**
     * 
     * @summary Получить токен выбранного бота
     * @param {TelegramSettingsAdminApiGetBotTokenRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TelegramSettingsAdminApi
     */
    public getBotToken(requestParameters: TelegramSettingsAdminApiGetBotTokenRequest = {}, options?: RawAxiosRequestConfig) {
        return TelegramSettingsAdminApiFp(this.configuration).getBotToken(requestParameters.code, requestParameters.bot, requestParameters.apiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Сохранить настройки Telegram
     * @param {TelegramSettingsAdminApiSaveTelegramSettingsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TelegramSettingsAdminApi
     */
    public saveTelegramSettings(requestParameters: TelegramSettingsAdminApiSaveTelegramSettingsRequest = {}, options?: RawAxiosRequestConfig) {
        return TelegramSettingsAdminApiFp(this.configuration).saveTelegramSettings(requestParameters.apiVersion, requestParameters.saveTelegramSettingsRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Отправить проверочное сообщение выбранным ботом в чат
     * @param {TelegramSettingsAdminApiSendTestMessageRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TelegramSettingsAdminApi
     */
    public sendTestMessage(requestParameters: TelegramSettingsAdminApiSendTestMessageRequest = {}, options?: RawAxiosRequestConfig) {
        return TelegramSettingsAdminApiFp(this.configuration).sendTestMessage(requestParameters.apiVersion, requestParameters.sendTelegramTestMessageRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * TestApi - axios parameter creator
 * @export
 */
export const TestApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Создать новый тест.
         * @param {string} [apiVersion] 
         * @param {CreateTestRequest} [createTestRequest] Данные теста для создания.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTest: async (apiVersion?: string, createTestRequest?: CreateTestRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/tests`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createTestRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Создать новый тест вопросами и ответами.
         * @param {string} [apiVersion] 
         * @param {CreateTestQuestionAnswerRequest} [createTestQuestionAnswerRequest] Данные теста для создания.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTestQuestionsAnswers: async (apiVersion?: string, createTestQuestionAnswerRequest?: CreateTestQuestionAnswerRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/tests/question-answers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createTestQuestionAnswerRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Удалить тест.
         * @param {number} id Идентификатор теста для удаления.
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTest: async (id: number, apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteTest', 'id', id)
            const localVarPath = `/api/v1/tests/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Получить тест по идентификатору.
         * @param {number} testId Идентификатор теста.
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTestById: async (testId: number, apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'testId' is not null or undefined
            assertParamExists('getTestById', 'testId', testId)
            const localVarPath = `/api/v1/tests/testId/{testId}`
                .replace(`{${"testId"}}`, encodeURIComponent(String(testId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Получить тест для прохождения с вопросами и ответами по Id теста и исполнителя.
         * @param {number} [testId] 
         * @param {string} [executorId] 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTestByIdAndExecutorId: async (testId?: number, executorId?: string, apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/tests`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (testId !== undefined) {
                localVarQueryParameter['testId'] = testId;
            }

            if (executorId !== undefined) {
                localVarQueryParameter['executorId'] = executorId;
            }


    
            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Получить все тесты по ID урока с вопросами и ответами (без отметки верно).
         * @param {number} lessonId 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTestsByLessonId: async (lessonId: number, apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'lessonId' is not null or undefined
            assertParamExists('getTestsByLessonId', 'lessonId', lessonId)
            const localVarPath = `/api/v1/tests/lessonId/{lessonId}`
                .replace(`{${"lessonId"}}`, encodeURIComponent(String(lessonId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Обновить существующий тест.
         * @param {string} [apiVersion] 
         * @param {UpdateTestRequest} [updateTestRequest] Обновленные данные теста.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTest: async (apiVersion?: string, updateTestRequest?: UpdateTestRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/tests`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateTestRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TestApi - functional programming interface
 * @export
 */
export const TestApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TestApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Создать новый тест.
         * @param {string} [apiVersion] 
         * @param {CreateTestRequest} [createTestRequest] Данные теста для создания.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createTest(apiVersion?: string, createTestRequest?: CreateTestRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateTestResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createTest(apiVersion, createTestRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TestApi.createTest']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Создать новый тест вопросами и ответами.
         * @param {string} [apiVersion] 
         * @param {CreateTestQuestionAnswerRequest} [createTestQuestionAnswerRequest] Данные теста для создания.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createTestQuestionsAnswers(apiVersion?: string, createTestQuestionAnswerRequest?: CreateTestQuestionAnswerRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateTestQuestionAnswerResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createTestQuestionsAnswers(apiVersion, createTestQuestionAnswerRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TestApi.createTestQuestionsAnswers']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Удалить тест.
         * @param {number} id Идентификатор теста для удаления.
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteTest(id: number, apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteTest(id, apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TestApi.deleteTest']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Получить тест по идентификатору.
         * @param {number} testId Идентификатор теста.
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTestById(testId: number, apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetTestByIdResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTestById(testId, apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TestApi.getTestById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Получить тест для прохождения с вопросами и ответами по Id теста и исполнителя.
         * @param {number} [testId] 
         * @param {string} [executorId] 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTestByIdAndExecutorId(testId?: number, executorId?: string, apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetTestResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTestByIdAndExecutorId(testId, executorId, apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TestApi.getTestByIdAndExecutorId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Получить все тесты по ID урока с вопросами и ответами (без отметки верно).
         * @param {number} lessonId 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTestsByLessonId(lessonId: number, apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetTestResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTestsByLessonId(lessonId, apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TestApi.getTestsByLessonId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Обновить существующий тест.
         * @param {string} [apiVersion] 
         * @param {UpdateTestRequest} [updateTestRequest] Обновленные данные теста.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateTest(apiVersion?: string, updateTestRequest?: UpdateTestRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UpdateTestResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateTest(apiVersion, updateTestRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TestApi.updateTest']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * TestApi - factory interface
 * @export
 */
export const TestApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TestApiFp(configuration)
    return {
        /**
         * 
         * @summary Создать новый тест.
         * @param {TestApiCreateTestRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTest(requestParameters: TestApiCreateTestRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<CreateTestResponse> {
            return localVarFp.createTest(requestParameters.apiVersion, requestParameters.createTestRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Создать новый тест вопросами и ответами.
         * @param {TestApiCreateTestQuestionsAnswersRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTestQuestionsAnswers(requestParameters: TestApiCreateTestQuestionsAnswersRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<CreateTestQuestionAnswerResponse> {
            return localVarFp.createTestQuestionsAnswers(requestParameters.apiVersion, requestParameters.createTestQuestionAnswerRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Удалить тест.
         * @param {TestApiDeleteTestRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTest(requestParameters: TestApiDeleteTestRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteTest(requestParameters.id, requestParameters.apiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Получить тест по идентификатору.
         * @param {TestApiGetTestByIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTestById(requestParameters: TestApiGetTestByIdRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetTestByIdResponse> {
            return localVarFp.getTestById(requestParameters.testId, requestParameters.apiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Получить тест для прохождения с вопросами и ответами по Id теста и исполнителя.
         * @param {TestApiGetTestByIdAndExecutorIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTestByIdAndExecutorId(requestParameters: TestApiGetTestByIdAndExecutorIdRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<GetTestResponse> {
            return localVarFp.getTestByIdAndExecutorId(requestParameters.testId, requestParameters.executorId, requestParameters.apiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Получить все тесты по ID урока с вопросами и ответами (без отметки верно).
         * @param {TestApiGetTestsByLessonIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTestsByLessonId(requestParameters: TestApiGetTestsByLessonIdRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<GetTestResponse>> {
            return localVarFp.getTestsByLessonId(requestParameters.lessonId, requestParameters.apiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Обновить существующий тест.
         * @param {TestApiUpdateTestRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTest(requestParameters: TestApiUpdateTestRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<UpdateTestResponse> {
            return localVarFp.updateTest(requestParameters.apiVersion, requestParameters.updateTestRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for createTest operation in TestApi.
 * @export
 * @interface TestApiCreateTestRequest
 */
export interface TestApiCreateTestRequest {
    /**
     * 
     * @type {string}
     * @memberof TestApiCreateTest
     */
    readonly apiVersion?: string

    /**
     * Данные теста для создания.
     * @type {CreateTestRequest}
     * @memberof TestApiCreateTest
     */
    readonly createTestRequest?: CreateTestRequest
}

/**
 * Request parameters for createTestQuestionsAnswers operation in TestApi.
 * @export
 * @interface TestApiCreateTestQuestionsAnswersRequest
 */
export interface TestApiCreateTestQuestionsAnswersRequest {
    /**
     * 
     * @type {string}
     * @memberof TestApiCreateTestQuestionsAnswers
     */
    readonly apiVersion?: string

    /**
     * Данные теста для создания.
     * @type {CreateTestQuestionAnswerRequest}
     * @memberof TestApiCreateTestQuestionsAnswers
     */
    readonly createTestQuestionAnswerRequest?: CreateTestQuestionAnswerRequest
}

/**
 * Request parameters for deleteTest operation in TestApi.
 * @export
 * @interface TestApiDeleteTestRequest
 */
export interface TestApiDeleteTestRequest {
    /**
     * Идентификатор теста для удаления.
     * @type {number}
     * @memberof TestApiDeleteTest
     */
    readonly id: number

    /**
     * 
     * @type {string}
     * @memberof TestApiDeleteTest
     */
    readonly apiVersion?: string
}

/**
 * Request parameters for getTestById operation in TestApi.
 * @export
 * @interface TestApiGetTestByIdRequest
 */
export interface TestApiGetTestByIdRequest {
    /**
     * Идентификатор теста.
     * @type {number}
     * @memberof TestApiGetTestById
     */
    readonly testId: number

    /**
     * 
     * @type {string}
     * @memberof TestApiGetTestById
     */
    readonly apiVersion?: string
}

/**
 * Request parameters for getTestByIdAndExecutorId operation in TestApi.
 * @export
 * @interface TestApiGetTestByIdAndExecutorIdRequest
 */
export interface TestApiGetTestByIdAndExecutorIdRequest {
    /**
     * 
     * @type {number}
     * @memberof TestApiGetTestByIdAndExecutorId
     */
    readonly testId?: number

    /**
     * 
     * @type {string}
     * @memberof TestApiGetTestByIdAndExecutorId
     */
    readonly executorId?: string

    /**
     * 
     * @type {string}
     * @memberof TestApiGetTestByIdAndExecutorId
     */
    readonly apiVersion?: string
}

/**
 * Request parameters for getTestsByLessonId operation in TestApi.
 * @export
 * @interface TestApiGetTestsByLessonIdRequest
 */
export interface TestApiGetTestsByLessonIdRequest {
    /**
     * 
     * @type {number}
     * @memberof TestApiGetTestsByLessonId
     */
    readonly lessonId: number

    /**
     * 
     * @type {string}
     * @memberof TestApiGetTestsByLessonId
     */
    readonly apiVersion?: string
}

/**
 * Request parameters for updateTest operation in TestApi.
 * @export
 * @interface TestApiUpdateTestRequest
 */
export interface TestApiUpdateTestRequest {
    /**
     * 
     * @type {string}
     * @memberof TestApiUpdateTest
     */
    readonly apiVersion?: string

    /**
     * Обновленные данные теста.
     * @type {UpdateTestRequest}
     * @memberof TestApiUpdateTest
     */
    readonly updateTestRequest?: UpdateTestRequest
}

/**
 * TestApi - object-oriented interface
 * @export
 * @class TestApi
 * @extends {BaseAPI}
 */
export class TestApi extends BaseAPI {
    /**
     * 
     * @summary Создать новый тест.
     * @param {TestApiCreateTestRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestApi
     */
    public createTest(requestParameters: TestApiCreateTestRequest = {}, options?: RawAxiosRequestConfig) {
        return TestApiFp(this.configuration).createTest(requestParameters.apiVersion, requestParameters.createTestRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Создать новый тест вопросами и ответами.
     * @param {TestApiCreateTestQuestionsAnswersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestApi
     */
    public createTestQuestionsAnswers(requestParameters: TestApiCreateTestQuestionsAnswersRequest = {}, options?: RawAxiosRequestConfig) {
        return TestApiFp(this.configuration).createTestQuestionsAnswers(requestParameters.apiVersion, requestParameters.createTestQuestionAnswerRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Удалить тест.
     * @param {TestApiDeleteTestRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestApi
     */
    public deleteTest(requestParameters: TestApiDeleteTestRequest, options?: RawAxiosRequestConfig) {
        return TestApiFp(this.configuration).deleteTest(requestParameters.id, requestParameters.apiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Получить тест по идентификатору.
     * @param {TestApiGetTestByIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestApi
     */
    public getTestById(requestParameters: TestApiGetTestByIdRequest, options?: RawAxiosRequestConfig) {
        return TestApiFp(this.configuration).getTestById(requestParameters.testId, requestParameters.apiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Получить тест для прохождения с вопросами и ответами по Id теста и исполнителя.
     * @param {TestApiGetTestByIdAndExecutorIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestApi
     */
    public getTestByIdAndExecutorId(requestParameters: TestApiGetTestByIdAndExecutorIdRequest = {}, options?: RawAxiosRequestConfig) {
        return TestApiFp(this.configuration).getTestByIdAndExecutorId(requestParameters.testId, requestParameters.executorId, requestParameters.apiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Получить все тесты по ID урока с вопросами и ответами (без отметки верно).
     * @param {TestApiGetTestsByLessonIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestApi
     */
    public getTestsByLessonId(requestParameters: TestApiGetTestsByLessonIdRequest, options?: RawAxiosRequestConfig) {
        return TestApiFp(this.configuration).getTestsByLessonId(requestParameters.lessonId, requestParameters.apiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Обновить существующий тест.
     * @param {TestApiUpdateTestRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestApi
     */
    public updateTest(requestParameters: TestApiUpdateTestRequest = {}, options?: RawAxiosRequestConfig) {
        return TestApiFp(this.configuration).updateTest(requestParameters.apiVersion, requestParameters.updateTestRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * UserChatsApi - axios parameter creator
 * @export
 */
export const UserChatsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Подготовить переписки поддержки и помощника
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bootstrapUserChats: async (apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/chats/me/bootstrap`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Создать или найти личный диалог
         * @param {string} [apiVersion] 
         * @param {CreateUserChatRequest} [createUserChatRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createUserChat: async (apiVersion?: string, createUserChatRequest?: CreateUserChatRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/chats/me/direct`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createUserChatRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Получить собственные счётчики
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserChatCounters: async (apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/chats/me/counters`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Получить сообщения собственного диалога
         * @param {string} dialogId 
         * @param {number} [beforeSequence] Получить сообщения раньше указанного номера
         * @param {number} [limit] Размер страницы
         * @param {number} [afterSequence] 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserChatMessages: async (dialogId: string, beforeSequence?: number, limit?: number, afterSequence?: number, apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'dialogId' is not null or undefined
            assertParamExists('getUserChatMessages', 'dialogId', dialogId)
            const localVarPath = `/api/v1/chats/me/{dialogId}/messages`
                .replace(`{${"dialogId"}}`, encodeURIComponent(String(dialogId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (beforeSequence !== undefined) {
                localVarQueryParameter['BeforeSequence'] = beforeSequence;
            }

            if (limit !== undefined) {
                localVarQueryParameter['Limit'] = limit;
            }

            if (afterSequence !== undefined) {
                localVarQueryParameter['afterSequence'] = afterSequence;
            }


    
            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Получить доступ к собственным обновлениям
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserChatRealtime: async (apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/chats/me/realtime`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Получить согласованное состояние собственной переписки
         * @param {Array<string>} [appUserIds] Выбранные учётные записи собеседников
         * @param {boolean} [filterPeople] Ограничивать список выбранными собеседниками
         * @param {ApiUserRole} [companionRole] Роль собеседника среди пользователей приложения VOX
         * @param {Array<number>} [channels] Каналы связи
         * @param {string} [companionName] Слова имени или фамилии собеседника VOX либо Salebot
         * @param {string} [petName] Часть имени питомца собеседника
         * @param {boolean} [unreadOnly] Только непрочитанные диалоги
         * @param {number} [dialogLimit] Число показанных диалогов
         * @param {string} [dialogId] Выбранный диалог
         * @param {number} [oldestSequence] Первое показанное сообщение
         * @param {number} [beforeSequence] Граница загрузки старой истории
         * @param {number} [newestSequence] Последнее показанное сообщение
         * @param {number} [afterSequence] Граница следующей непрочитанной страницы приложения
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserChatSnapshot: async (appUserIds?: Array<string>, filterPeople?: boolean, companionRole?: ApiUserRole, channels?: Array<number>, companionName?: string, petName?: string, unreadOnly?: boolean, dialogLimit?: number, dialogId?: string, oldestSequence?: number, beforeSequence?: number, newestSequence?: number, afterSequence?: number, apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/chats/me/snapshot`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (appUserIds) {
                localVarQueryParameter['AppUserIds'] = appUserIds;
            }

            if (filterPeople !== undefined) {
                localVarQueryParameter['FilterPeople'] = filterPeople;
            }

            if (companionRole !== undefined) {
                localVarQueryParameter['CompanionRole'] = companionRole;
            }

            if (channels) {
                localVarQueryParameter['Channels'] = channels;
            }

            if (companionName !== undefined) {
                localVarQueryParameter['CompanionName'] = companionName;
            }

            if (petName !== undefined) {
                localVarQueryParameter['PetName'] = petName;
            }

            if (unreadOnly !== undefined) {
                localVarQueryParameter['UnreadOnly'] = unreadOnly;
            }

            if (dialogLimit !== undefined) {
                localVarQueryParameter['DialogLimit'] = dialogLimit;
            }

            if (dialogId !== undefined) {
                localVarQueryParameter['DialogId'] = dialogId;
            }

            if (oldestSequence !== undefined) {
                localVarQueryParameter['OldestSequence'] = oldestSequence;
            }

            if (beforeSequence !== undefined) {
                localVarQueryParameter['BeforeSequence'] = beforeSequence;
            }

            if (newestSequence !== undefined) {
                localVarQueryParameter['NewestSequence'] = newestSequence;
            }

            if (afterSequence !== undefined) {
                localVarQueryParameter['AfterSequence'] = afterSequence;
            }


    
            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Получить собственные диалоги
         * @param {boolean} [pinnedOnly] Показывать только общие закрепления операторов
         * @param {Array<string>} [appUserIds] Выбранные учётные записи собеседников
         * @param {boolean} [filterPeople] Ограничивать список выбранными собеседниками
         * @param {ApiUserRole} [companionRole] Роль собеседника среди пользователей приложения VOX
         * @param {Array<number>} [channels] Каналы связи
         * @param {string} [companionName] Слова имени или фамилии собеседника VOX либо Salebot
         * @param {string} [petName] Часть имени питомца собеседника
         * @param {boolean} [unreadOnly] Показывать только диалоги с непрочитанными сообщениями
         * @param {string} [dialogId] Идентификатор диалога
         * @param {number} [offset] Смещение страницы
         * @param {number} [limit] Размер страницы
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserChats: async (pinnedOnly?: boolean, appUserIds?: Array<string>, filterPeople?: boolean, companionRole?: ApiUserRole, channels?: Array<number>, companionName?: string, petName?: string, unreadOnly?: boolean, dialogId?: string, offset?: number, limit?: number, apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/chats/me`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (pinnedOnly !== undefined) {
                localVarQueryParameter['PinnedOnly'] = pinnedOnly;
            }

            if (appUserIds) {
                localVarQueryParameter['AppUserIds'] = appUserIds;
            }

            if (filterPeople !== undefined) {
                localVarQueryParameter['FilterPeople'] = filterPeople;
            }

            if (companionRole !== undefined) {
                localVarQueryParameter['CompanionRole'] = companionRole;
            }

            if (channels) {
                localVarQueryParameter['Channels'] = channels;
            }

            if (companionName !== undefined) {
                localVarQueryParameter['CompanionName'] = companionName;
            }

            if (petName !== undefined) {
                localVarQueryParameter['PetName'] = petName;
            }

            if (unreadOnly !== undefined) {
                localVarQueryParameter['UnreadOnly'] = unreadOnly;
            }

            if (dialogId !== undefined) {
                localVarQueryParameter['DialogId'] = dialogId;
            }

            if (offset !== undefined) {
                localVarQueryParameter['Offset'] = offset;
            }

            if (limit !== undefined) {
                localVarQueryParameter['Limit'] = limit;
            }


    
            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Получить собственный диалог поддержки
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserSupportChat: async (apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/chats/me/support`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Подтвердить прочтение показанных сообщений
         * @param {string} dialogId 
         * @param {string} [apiVersion] 
         * @param {MarkChatDialogReadRequest} [markChatDialogReadRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        markUserChatRead: async (dialogId: string, apiVersion?: string, markChatDialogReadRequest?: MarkChatDialogReadRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'dialogId' is not null or undefined
            assertParamExists('markUserChatRead', 'dialogId', dialogId)
            const localVarPath = `/api/v1/chats/me/{dialogId}/read`
                .replace(`{${"dialogId"}}`, encodeURIComponent(String(dialogId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(markChatDialogReadRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Найти собственный диалог по ссылке
         * @param {string} chatId 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resolveUserChat: async (chatId: string, apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'chatId' is not null or undefined
            assertParamExists('resolveUserChat', 'chatId', chatId)
            const localVarPath = `/api/v1/chats/me/{chatId}/resolve`
                .replace(`{${"chatId"}}`, encodeURIComponent(String(chatId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Отправить сообщение от текущего пользователя
         * @param {string} dialogId 
         * @param {string} [apiVersion] 
         * @param {SendChatDialogMessageRequest} [sendChatDialogMessageRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendUserChatMessage: async (dialogId: string, apiVersion?: string, sendChatDialogMessageRequest?: SendChatDialogMessageRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'dialogId' is not null or undefined
            assertParamExists('sendUserChatMessage', 'dialogId', dialogId)
            const localVarPath = `/api/v1/chats/me/{dialogId}/messages`
                .replace(`{${"dialogId"}}`, encodeURIComponent(String(dialogId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(sendChatDialogMessageRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UserChatsApi - functional programming interface
 * @export
 */
export const UserChatsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = UserChatsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Подготовить переписки поддержки и помощника
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async bootstrapUserChats(apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.bootstrapUserChats(apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserChatsApi.bootstrapUserChats']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Создать или найти личный диалог
         * @param {string} [apiVersion] 
         * @param {CreateUserChatRequest} [createUserChatRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createUserChat(apiVersion?: string, createUserChatRequest?: CreateUserChatRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ChatDialogResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createUserChat(apiVersion, createUserChatRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserChatsApi.createUserChat']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Получить собственные счётчики
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUserChatCounters(apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ChatDialogCountersResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUserChatCounters(apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserChatsApi.getUserChatCounters']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Получить сообщения собственного диалога
         * @param {string} dialogId 
         * @param {number} [beforeSequence] Получить сообщения раньше указанного номера
         * @param {number} [limit] Размер страницы
         * @param {number} [afterSequence] 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUserChatMessages(dialogId: string, beforeSequence?: number, limit?: number, afterSequence?: number, apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ChatDialogMessagePageResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUserChatMessages(dialogId, beforeSequence, limit, afterSequence, apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserChatsApi.getUserChatMessages']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Получить доступ к собственным обновлениям
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUserChatRealtime(apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ChatRealtimeResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUserChatRealtime(apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserChatsApi.getUserChatRealtime']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Получить согласованное состояние собственной переписки
         * @param {Array<string>} [appUserIds] Выбранные учётные записи собеседников
         * @param {boolean} [filterPeople] Ограничивать список выбранными собеседниками
         * @param {ApiUserRole} [companionRole] Роль собеседника среди пользователей приложения VOX
         * @param {Array<number>} [channels] Каналы связи
         * @param {string} [companionName] Слова имени или фамилии собеседника VOX либо Salebot
         * @param {string} [petName] Часть имени питомца собеседника
         * @param {boolean} [unreadOnly] Только непрочитанные диалоги
         * @param {number} [dialogLimit] Число показанных диалогов
         * @param {string} [dialogId] Выбранный диалог
         * @param {number} [oldestSequence] Первое показанное сообщение
         * @param {number} [beforeSequence] Граница загрузки старой истории
         * @param {number} [newestSequence] Последнее показанное сообщение
         * @param {number} [afterSequence] Граница следующей непрочитанной страницы приложения
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUserChatSnapshot(appUserIds?: Array<string>, filterPeople?: boolean, companionRole?: ApiUserRole, channels?: Array<number>, companionName?: string, petName?: string, unreadOnly?: boolean, dialogLimit?: number, dialogId?: string, oldestSequence?: number, beforeSequence?: number, newestSequence?: number, afterSequence?: number, apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ChatRealtimeSnapshotResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUserChatSnapshot(appUserIds, filterPeople, companionRole, channels, companionName, petName, unreadOnly, dialogLimit, dialogId, oldestSequence, beforeSequence, newestSequence, afterSequence, apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserChatsApi.getUserChatSnapshot']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Получить собственные диалоги
         * @param {boolean} [pinnedOnly] Показывать только общие закрепления операторов
         * @param {Array<string>} [appUserIds] Выбранные учётные записи собеседников
         * @param {boolean} [filterPeople] Ограничивать список выбранными собеседниками
         * @param {ApiUserRole} [companionRole] Роль собеседника среди пользователей приложения VOX
         * @param {Array<number>} [channels] Каналы связи
         * @param {string} [companionName] Слова имени или фамилии собеседника VOX либо Salebot
         * @param {string} [petName] Часть имени питомца собеседника
         * @param {boolean} [unreadOnly] Показывать только диалоги с непрочитанными сообщениями
         * @param {string} [dialogId] Идентификатор диалога
         * @param {number} [offset] Смещение страницы
         * @param {number} [limit] Размер страницы
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUserChats(pinnedOnly?: boolean, appUserIds?: Array<string>, filterPeople?: boolean, companionRole?: ApiUserRole, channels?: Array<number>, companionName?: string, petName?: string, unreadOnly?: boolean, dialogId?: string, offset?: number, limit?: number, apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ChatDialogPageResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUserChats(pinnedOnly, appUserIds, filterPeople, companionRole, channels, companionName, petName, unreadOnly, dialogId, offset, limit, apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserChatsApi.getUserChats']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Получить собственный диалог поддержки
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUserSupportChat(apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ChatDialogResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUserSupportChat(apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserChatsApi.getUserSupportChat']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Подтвердить прочтение показанных сообщений
         * @param {string} dialogId 
         * @param {string} [apiVersion] 
         * @param {MarkChatDialogReadRequest} [markChatDialogReadRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async markUserChatRead(dialogId: string, apiVersion?: string, markChatDialogReadRequest?: MarkChatDialogReadRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.markUserChatRead(dialogId, apiVersion, markChatDialogReadRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserChatsApi.markUserChatRead']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Найти собственный диалог по ссылке
         * @param {string} chatId 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async resolveUserChat(chatId: string, apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ChatDialogResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.resolveUserChat(chatId, apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserChatsApi.resolveUserChat']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Отправить сообщение от текущего пользователя
         * @param {string} dialogId 
         * @param {string} [apiVersion] 
         * @param {SendChatDialogMessageRequest} [sendChatDialogMessageRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sendUserChatMessage(dialogId: string, apiVersion?: string, sendChatDialogMessageRequest?: SendChatDialogMessageRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ChatDialogMessageResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sendUserChatMessage(dialogId, apiVersion, sendChatDialogMessageRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserChatsApi.sendUserChatMessage']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * UserChatsApi - factory interface
 * @export
 */
export const UserChatsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = UserChatsApiFp(configuration)
    return {
        /**
         * 
         * @summary Подготовить переписки поддержки и помощника
         * @param {UserChatsApiBootstrapUserChatsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bootstrapUserChats(requestParameters: UserChatsApiBootstrapUserChatsRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.bootstrapUserChats(requestParameters.apiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Создать или найти личный диалог
         * @param {UserChatsApiCreateUserChatRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createUserChat(requestParameters: UserChatsApiCreateUserChatRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<ChatDialogResponse> {
            return localVarFp.createUserChat(requestParameters.apiVersion, requestParameters.createUserChatRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Получить собственные счётчики
         * @param {UserChatsApiGetUserChatCountersRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserChatCounters(requestParameters: UserChatsApiGetUserChatCountersRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<ChatDialogCountersResponse> {
            return localVarFp.getUserChatCounters(requestParameters.apiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Получить сообщения собственного диалога
         * @param {UserChatsApiGetUserChatMessagesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserChatMessages(requestParameters: UserChatsApiGetUserChatMessagesRequest, options?: RawAxiosRequestConfig): AxiosPromise<ChatDialogMessagePageResponse> {
            return localVarFp.getUserChatMessages(requestParameters.dialogId, requestParameters.beforeSequence, requestParameters.limit, requestParameters.afterSequence, requestParameters.apiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Получить доступ к собственным обновлениям
         * @param {UserChatsApiGetUserChatRealtimeRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserChatRealtime(requestParameters: UserChatsApiGetUserChatRealtimeRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<ChatRealtimeResponse> {
            return localVarFp.getUserChatRealtime(requestParameters.apiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Получить согласованное состояние собственной переписки
         * @param {UserChatsApiGetUserChatSnapshotRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserChatSnapshot(requestParameters: UserChatsApiGetUserChatSnapshotRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<ChatRealtimeSnapshotResponse> {
            return localVarFp.getUserChatSnapshot(requestParameters.appUserIds, requestParameters.filterPeople, requestParameters.companionRole, requestParameters.channels, requestParameters.companionName, requestParameters.petName, requestParameters.unreadOnly, requestParameters.dialogLimit, requestParameters.dialogId, requestParameters.oldestSequence, requestParameters.beforeSequence, requestParameters.newestSequence, requestParameters.afterSequence, requestParameters.apiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Получить собственные диалоги
         * @param {UserChatsApiGetUserChatsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserChats(requestParameters: UserChatsApiGetUserChatsRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<ChatDialogPageResponse> {
            return localVarFp.getUserChats(requestParameters.pinnedOnly, requestParameters.appUserIds, requestParameters.filterPeople, requestParameters.companionRole, requestParameters.channels, requestParameters.companionName, requestParameters.petName, requestParameters.unreadOnly, requestParameters.dialogId, requestParameters.offset, requestParameters.limit, requestParameters.apiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Получить собственный диалог поддержки
         * @param {UserChatsApiGetUserSupportChatRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserSupportChat(requestParameters: UserChatsApiGetUserSupportChatRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<ChatDialogResponse> {
            return localVarFp.getUserSupportChat(requestParameters.apiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Подтвердить прочтение показанных сообщений
         * @param {UserChatsApiMarkUserChatReadRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        markUserChatRead(requestParameters: UserChatsApiMarkUserChatReadRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.markUserChatRead(requestParameters.dialogId, requestParameters.apiVersion, requestParameters.markChatDialogReadRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Найти собственный диалог по ссылке
         * @param {UserChatsApiResolveUserChatRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resolveUserChat(requestParameters: UserChatsApiResolveUserChatRequest, options?: RawAxiosRequestConfig): AxiosPromise<ChatDialogResponse> {
            return localVarFp.resolveUserChat(requestParameters.chatId, requestParameters.apiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Отправить сообщение от текущего пользователя
         * @param {UserChatsApiSendUserChatMessageRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendUserChatMessage(requestParameters: UserChatsApiSendUserChatMessageRequest, options?: RawAxiosRequestConfig): AxiosPromise<ChatDialogMessageResponse> {
            return localVarFp.sendUserChatMessage(requestParameters.dialogId, requestParameters.apiVersion, requestParameters.sendChatDialogMessageRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for bootstrapUserChats operation in UserChatsApi.
 * @export
 * @interface UserChatsApiBootstrapUserChatsRequest
 */
export interface UserChatsApiBootstrapUserChatsRequest {
    /**
     * 
     * @type {string}
     * @memberof UserChatsApiBootstrapUserChats
     */
    readonly apiVersion?: string
}

/**
 * Request parameters for createUserChat operation in UserChatsApi.
 * @export
 * @interface UserChatsApiCreateUserChatRequest
 */
export interface UserChatsApiCreateUserChatRequest {
    /**
     * 
     * @type {string}
     * @memberof UserChatsApiCreateUserChat
     */
    readonly apiVersion?: string

    /**
     * 
     * @type {CreateUserChatRequest}
     * @memberof UserChatsApiCreateUserChat
     */
    readonly createUserChatRequest?: CreateUserChatRequest
}

/**
 * Request parameters for getUserChatCounters operation in UserChatsApi.
 * @export
 * @interface UserChatsApiGetUserChatCountersRequest
 */
export interface UserChatsApiGetUserChatCountersRequest {
    /**
     * 
     * @type {string}
     * @memberof UserChatsApiGetUserChatCounters
     */
    readonly apiVersion?: string
}

/**
 * Request parameters for getUserChatMessages operation in UserChatsApi.
 * @export
 * @interface UserChatsApiGetUserChatMessagesRequest
 */
export interface UserChatsApiGetUserChatMessagesRequest {
    /**
     * 
     * @type {string}
     * @memberof UserChatsApiGetUserChatMessages
     */
    readonly dialogId: string

    /**
     * Получить сообщения раньше указанного номера
     * @type {number}
     * @memberof UserChatsApiGetUserChatMessages
     */
    readonly beforeSequence?: number

    /**
     * Размер страницы
     * @type {number}
     * @memberof UserChatsApiGetUserChatMessages
     */
    readonly limit?: number

    /**
     * 
     * @type {number}
     * @memberof UserChatsApiGetUserChatMessages
     */
    readonly afterSequence?: number

    /**
     * 
     * @type {string}
     * @memberof UserChatsApiGetUserChatMessages
     */
    readonly apiVersion?: string
}

/**
 * Request parameters for getUserChatRealtime operation in UserChatsApi.
 * @export
 * @interface UserChatsApiGetUserChatRealtimeRequest
 */
export interface UserChatsApiGetUserChatRealtimeRequest {
    /**
     * 
     * @type {string}
     * @memberof UserChatsApiGetUserChatRealtime
     */
    readonly apiVersion?: string
}

/**
 * Request parameters for getUserChatSnapshot operation in UserChatsApi.
 * @export
 * @interface UserChatsApiGetUserChatSnapshotRequest
 */
export interface UserChatsApiGetUserChatSnapshotRequest {
    /**
     * Выбранные учётные записи собеседников
     * @type {Array<string>}
     * @memberof UserChatsApiGetUserChatSnapshot
     */
    readonly appUserIds?: Array<string>

    /**
     * Ограничивать список выбранными собеседниками
     * @type {boolean}
     * @memberof UserChatsApiGetUserChatSnapshot
     */
    readonly filterPeople?: boolean

    /**
     * Роль собеседника среди пользователей приложения VOX
     * @type {ApiUserRole}
     * @memberof UserChatsApiGetUserChatSnapshot
     */
    readonly companionRole?: ApiUserRole

    /**
     * Каналы связи
     * @type {Array<number>}
     * @memberof UserChatsApiGetUserChatSnapshot
     */
    readonly channels?: Array<number>

    /**
     * Слова имени или фамилии собеседника VOX либо Salebot
     * @type {string}
     * @memberof UserChatsApiGetUserChatSnapshot
     */
    readonly companionName?: string

    /**
     * Часть имени питомца собеседника
     * @type {string}
     * @memberof UserChatsApiGetUserChatSnapshot
     */
    readonly petName?: string

    /**
     * Только непрочитанные диалоги
     * @type {boolean}
     * @memberof UserChatsApiGetUserChatSnapshot
     */
    readonly unreadOnly?: boolean

    /**
     * Число показанных диалогов
     * @type {number}
     * @memberof UserChatsApiGetUserChatSnapshot
     */
    readonly dialogLimit?: number

    /**
     * Выбранный диалог
     * @type {string}
     * @memberof UserChatsApiGetUserChatSnapshot
     */
    readonly dialogId?: string

    /**
     * Первое показанное сообщение
     * @type {number}
     * @memberof UserChatsApiGetUserChatSnapshot
     */
    readonly oldestSequence?: number

    /**
     * Граница загрузки старой истории
     * @type {number}
     * @memberof UserChatsApiGetUserChatSnapshot
     */
    readonly beforeSequence?: number

    /**
     * Последнее показанное сообщение
     * @type {number}
     * @memberof UserChatsApiGetUserChatSnapshot
     */
    readonly newestSequence?: number

    /**
     * Граница следующей непрочитанной страницы приложения
     * @type {number}
     * @memberof UserChatsApiGetUserChatSnapshot
     */
    readonly afterSequence?: number

    /**
     * 
     * @type {string}
     * @memberof UserChatsApiGetUserChatSnapshot
     */
    readonly apiVersion?: string
}

/**
 * Request parameters for getUserChats operation in UserChatsApi.
 * @export
 * @interface UserChatsApiGetUserChatsRequest
 */
export interface UserChatsApiGetUserChatsRequest {
    /**
     * Показывать только общие закрепления операторов
     * @type {boolean}
     * @memberof UserChatsApiGetUserChats
     */
    readonly pinnedOnly?: boolean

    /**
     * Выбранные учётные записи собеседников
     * @type {Array<string>}
     * @memberof UserChatsApiGetUserChats
     */
    readonly appUserIds?: Array<string>

    /**
     * Ограничивать список выбранными собеседниками
     * @type {boolean}
     * @memberof UserChatsApiGetUserChats
     */
    readonly filterPeople?: boolean

    /**
     * Роль собеседника среди пользователей приложения VOX
     * @type {ApiUserRole}
     * @memberof UserChatsApiGetUserChats
     */
    readonly companionRole?: ApiUserRole

    /**
     * Каналы связи
     * @type {Array<number>}
     * @memberof UserChatsApiGetUserChats
     */
    readonly channels?: Array<number>

    /**
     * Слова имени или фамилии собеседника VOX либо Salebot
     * @type {string}
     * @memberof UserChatsApiGetUserChats
     */
    readonly companionName?: string

    /**
     * Часть имени питомца собеседника
     * @type {string}
     * @memberof UserChatsApiGetUserChats
     */
    readonly petName?: string

    /**
     * Показывать только диалоги с непрочитанными сообщениями
     * @type {boolean}
     * @memberof UserChatsApiGetUserChats
     */
    readonly unreadOnly?: boolean

    /**
     * Идентификатор диалога
     * @type {string}
     * @memberof UserChatsApiGetUserChats
     */
    readonly dialogId?: string

    /**
     * Смещение страницы
     * @type {number}
     * @memberof UserChatsApiGetUserChats
     */
    readonly offset?: number

    /**
     * Размер страницы
     * @type {number}
     * @memberof UserChatsApiGetUserChats
     */
    readonly limit?: number

    /**
     * 
     * @type {string}
     * @memberof UserChatsApiGetUserChats
     */
    readonly apiVersion?: string
}

/**
 * Request parameters for getUserSupportChat operation in UserChatsApi.
 * @export
 * @interface UserChatsApiGetUserSupportChatRequest
 */
export interface UserChatsApiGetUserSupportChatRequest {
    /**
     * 
     * @type {string}
     * @memberof UserChatsApiGetUserSupportChat
     */
    readonly apiVersion?: string
}

/**
 * Request parameters for markUserChatRead operation in UserChatsApi.
 * @export
 * @interface UserChatsApiMarkUserChatReadRequest
 */
export interface UserChatsApiMarkUserChatReadRequest {
    /**
     * 
     * @type {string}
     * @memberof UserChatsApiMarkUserChatRead
     */
    readonly dialogId: string

    /**
     * 
     * @type {string}
     * @memberof UserChatsApiMarkUserChatRead
     */
    readonly apiVersion?: string

    /**
     * 
     * @type {MarkChatDialogReadRequest}
     * @memberof UserChatsApiMarkUserChatRead
     */
    readonly markChatDialogReadRequest?: MarkChatDialogReadRequest
}

/**
 * Request parameters for resolveUserChat operation in UserChatsApi.
 * @export
 * @interface UserChatsApiResolveUserChatRequest
 */
export interface UserChatsApiResolveUserChatRequest {
    /**
     * 
     * @type {string}
     * @memberof UserChatsApiResolveUserChat
     */
    readonly chatId: string

    /**
     * 
     * @type {string}
     * @memberof UserChatsApiResolveUserChat
     */
    readonly apiVersion?: string
}

/**
 * Request parameters for sendUserChatMessage operation in UserChatsApi.
 * @export
 * @interface UserChatsApiSendUserChatMessageRequest
 */
export interface UserChatsApiSendUserChatMessageRequest {
    /**
     * 
     * @type {string}
     * @memberof UserChatsApiSendUserChatMessage
     */
    readonly dialogId: string

    /**
     * 
     * @type {string}
     * @memberof UserChatsApiSendUserChatMessage
     */
    readonly apiVersion?: string

    /**
     * 
     * @type {SendChatDialogMessageRequest}
     * @memberof UserChatsApiSendUserChatMessage
     */
    readonly sendChatDialogMessageRequest?: SendChatDialogMessageRequest
}

/**
 * UserChatsApi - object-oriented interface
 * @export
 * @class UserChatsApi
 * @extends {BaseAPI}
 */
export class UserChatsApi extends BaseAPI {
    /**
     * 
     * @summary Подготовить переписки поддержки и помощника
     * @param {UserChatsApiBootstrapUserChatsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserChatsApi
     */
    public bootstrapUserChats(requestParameters: UserChatsApiBootstrapUserChatsRequest = {}, options?: RawAxiosRequestConfig) {
        return UserChatsApiFp(this.configuration).bootstrapUserChats(requestParameters.apiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Создать или найти личный диалог
     * @param {UserChatsApiCreateUserChatRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserChatsApi
     */
    public createUserChat(requestParameters: UserChatsApiCreateUserChatRequest = {}, options?: RawAxiosRequestConfig) {
        return UserChatsApiFp(this.configuration).createUserChat(requestParameters.apiVersion, requestParameters.createUserChatRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Получить собственные счётчики
     * @param {UserChatsApiGetUserChatCountersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserChatsApi
     */
    public getUserChatCounters(requestParameters: UserChatsApiGetUserChatCountersRequest = {}, options?: RawAxiosRequestConfig) {
        return UserChatsApiFp(this.configuration).getUserChatCounters(requestParameters.apiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Получить сообщения собственного диалога
     * @param {UserChatsApiGetUserChatMessagesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserChatsApi
     */
    public getUserChatMessages(requestParameters: UserChatsApiGetUserChatMessagesRequest, options?: RawAxiosRequestConfig) {
        return UserChatsApiFp(this.configuration).getUserChatMessages(requestParameters.dialogId, requestParameters.beforeSequence, requestParameters.limit, requestParameters.afterSequence, requestParameters.apiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Получить доступ к собственным обновлениям
     * @param {UserChatsApiGetUserChatRealtimeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserChatsApi
     */
    public getUserChatRealtime(requestParameters: UserChatsApiGetUserChatRealtimeRequest = {}, options?: RawAxiosRequestConfig) {
        return UserChatsApiFp(this.configuration).getUserChatRealtime(requestParameters.apiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Получить согласованное состояние собственной переписки
     * @param {UserChatsApiGetUserChatSnapshotRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserChatsApi
     */
    public getUserChatSnapshot(requestParameters: UserChatsApiGetUserChatSnapshotRequest = {}, options?: RawAxiosRequestConfig) {
        return UserChatsApiFp(this.configuration).getUserChatSnapshot(requestParameters.appUserIds, requestParameters.filterPeople, requestParameters.companionRole, requestParameters.channels, requestParameters.companionName, requestParameters.petName, requestParameters.unreadOnly, requestParameters.dialogLimit, requestParameters.dialogId, requestParameters.oldestSequence, requestParameters.beforeSequence, requestParameters.newestSequence, requestParameters.afterSequence, requestParameters.apiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Получить собственные диалоги
     * @param {UserChatsApiGetUserChatsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserChatsApi
     */
    public getUserChats(requestParameters: UserChatsApiGetUserChatsRequest = {}, options?: RawAxiosRequestConfig) {
        return UserChatsApiFp(this.configuration).getUserChats(requestParameters.pinnedOnly, requestParameters.appUserIds, requestParameters.filterPeople, requestParameters.companionRole, requestParameters.channels, requestParameters.companionName, requestParameters.petName, requestParameters.unreadOnly, requestParameters.dialogId, requestParameters.offset, requestParameters.limit, requestParameters.apiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Получить собственный диалог поддержки
     * @param {UserChatsApiGetUserSupportChatRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserChatsApi
     */
    public getUserSupportChat(requestParameters: UserChatsApiGetUserSupportChatRequest = {}, options?: RawAxiosRequestConfig) {
        return UserChatsApiFp(this.configuration).getUserSupportChat(requestParameters.apiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Подтвердить прочтение показанных сообщений
     * @param {UserChatsApiMarkUserChatReadRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserChatsApi
     */
    public markUserChatRead(requestParameters: UserChatsApiMarkUserChatReadRequest, options?: RawAxiosRequestConfig) {
        return UserChatsApiFp(this.configuration).markUserChatRead(requestParameters.dialogId, requestParameters.apiVersion, requestParameters.markChatDialogReadRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Найти собственный диалог по ссылке
     * @param {UserChatsApiResolveUserChatRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserChatsApi
     */
    public resolveUserChat(requestParameters: UserChatsApiResolveUserChatRequest, options?: RawAxiosRequestConfig) {
        return UserChatsApiFp(this.configuration).resolveUserChat(requestParameters.chatId, requestParameters.apiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Отправить сообщение от текущего пользователя
     * @param {UserChatsApiSendUserChatMessageRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserChatsApi
     */
    public sendUserChatMessage(requestParameters: UserChatsApiSendUserChatMessageRequest, options?: RawAxiosRequestConfig) {
        return UserChatsApiFp(this.configuration).sendUserChatMessage(requestParameters.dialogId, requestParameters.apiVersion, requestParameters.sendChatDialogMessageRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * UserDialogsApi - axios parameter creator
 * @export
 */
export const UserDialogsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Сохранить ответ текущего пользователя
         * @param {string} [apiVersion] 
         * @param {SubmitDialogAnswerRequest} [submitDialogAnswerRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DialogsAnswerPost: async (apiVersion?: string, submitDialogAnswerRequest?: SubmitDialogAnswerRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/dialogs/answer`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(submitDialogAnswerRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Получить следующий диалог текущего пользователя
         * @param {boolean} [supportsTextInput] Приложение поддерживает текстовую обратную связь
         * @param {string} [routeName] Маршрут показа диалога
         * @param {string} [routeEntityId] Объект на маршруте показа
         * @param {string} [appUserId] Идентификатор пользователя
         * @param {string} [orderId] Идентификатор заказа
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DialogsPendingGet: async (supportsTextInput?: boolean, routeName?: string, routeEntityId?: string, appUserId?: string, orderId?: string, apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/dialogs/pending`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (supportsTextInput !== undefined) {
                localVarQueryParameter['SupportsTextInput'] = supportsTextInput;
            }

            if (routeName !== undefined) {
                localVarQueryParameter['RouteName'] = routeName;
            }

            if (routeEntityId !== undefined) {
                localVarQueryParameter['RouteEntityId'] = routeEntityId;
            }

            if (appUserId !== undefined) {
                localVarQueryParameter['AppUserId'] = appUserId;
            }

            if (orderId !== undefined) {
                localVarQueryParameter['OrderId'] = orderId;
            }


    
            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UserDialogsApi - functional programming interface
 * @export
 */
export const UserDialogsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = UserDialogsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Сохранить ответ текущего пользователя
         * @param {string} [apiVersion] 
         * @param {SubmitDialogAnswerRequest} [submitDialogAnswerRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1DialogsAnswerPost(apiVersion?: string, submitDialogAnswerRequest?: SubmitDialogAnswerRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1DialogsAnswerPost(apiVersion, submitDialogAnswerRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserDialogsApi.apiV1DialogsAnswerPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Получить следующий диалог текущего пользователя
         * @param {boolean} [supportsTextInput] Приложение поддерживает текстовую обратную связь
         * @param {string} [routeName] Маршрут показа диалога
         * @param {string} [routeEntityId] Объект на маршруте показа
         * @param {string} [appUserId] Идентификатор пользователя
         * @param {string} [orderId] Идентификатор заказа
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1DialogsPendingGet(supportsTextInput?: boolean, routeName?: string, routeEntityId?: string, appUserId?: string, orderId?: string, apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PendingDialogsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1DialogsPendingGet(supportsTextInput, routeName, routeEntityId, appUserId, orderId, apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserDialogsApi.apiV1DialogsPendingGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * UserDialogsApi - factory interface
 * @export
 */
export const UserDialogsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = UserDialogsApiFp(configuration)
    return {
        /**
         * 
         * @summary Сохранить ответ текущего пользователя
         * @param {UserDialogsApiApiV1DialogsAnswerPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DialogsAnswerPost(requestParameters: UserDialogsApiApiV1DialogsAnswerPostRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiV1DialogsAnswerPost(requestParameters.apiVersion, requestParameters.submitDialogAnswerRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Получить следующий диалог текущего пользователя
         * @param {UserDialogsApiApiV1DialogsPendingGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DialogsPendingGet(requestParameters: UserDialogsApiApiV1DialogsPendingGetRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<PendingDialogsResponse> {
            return localVarFp.apiV1DialogsPendingGet(requestParameters.supportsTextInput, requestParameters.routeName, requestParameters.routeEntityId, requestParameters.appUserId, requestParameters.orderId, requestParameters.apiVersion, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for apiV1DialogsAnswerPost operation in UserDialogsApi.
 * @export
 * @interface UserDialogsApiApiV1DialogsAnswerPostRequest
 */
export interface UserDialogsApiApiV1DialogsAnswerPostRequest {
    /**
     * 
     * @type {string}
     * @memberof UserDialogsApiApiV1DialogsAnswerPost
     */
    readonly apiVersion?: string

    /**
     * 
     * @type {SubmitDialogAnswerRequest}
     * @memberof UserDialogsApiApiV1DialogsAnswerPost
     */
    readonly submitDialogAnswerRequest?: SubmitDialogAnswerRequest
}

/**
 * Request parameters for apiV1DialogsPendingGet operation in UserDialogsApi.
 * @export
 * @interface UserDialogsApiApiV1DialogsPendingGetRequest
 */
export interface UserDialogsApiApiV1DialogsPendingGetRequest {
    /**
     * Приложение поддерживает текстовую обратную связь
     * @type {boolean}
     * @memberof UserDialogsApiApiV1DialogsPendingGet
     */
    readonly supportsTextInput?: boolean

    /**
     * Маршрут показа диалога
     * @type {string}
     * @memberof UserDialogsApiApiV1DialogsPendingGet
     */
    readonly routeName?: string

    /**
     * Объект на маршруте показа
     * @type {string}
     * @memberof UserDialogsApiApiV1DialogsPendingGet
     */
    readonly routeEntityId?: string

    /**
     * Идентификатор пользователя
     * @type {string}
     * @memberof UserDialogsApiApiV1DialogsPendingGet
     */
    readonly appUserId?: string

    /**
     * Идентификатор заказа
     * @type {string}
     * @memberof UserDialogsApiApiV1DialogsPendingGet
     */
    readonly orderId?: string

    /**
     * 
     * @type {string}
     * @memberof UserDialogsApiApiV1DialogsPendingGet
     */
    readonly apiVersion?: string
}

/**
 * UserDialogsApi - object-oriented interface
 * @export
 * @class UserDialogsApi
 * @extends {BaseAPI}
 */
export class UserDialogsApi extends BaseAPI {
    /**
     * 
     * @summary Сохранить ответ текущего пользователя
     * @param {UserDialogsApiApiV1DialogsAnswerPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserDialogsApi
     */
    public apiV1DialogsAnswerPost(requestParameters: UserDialogsApiApiV1DialogsAnswerPostRequest = {}, options?: RawAxiosRequestConfig) {
        return UserDialogsApiFp(this.configuration).apiV1DialogsAnswerPost(requestParameters.apiVersion, requestParameters.submitDialogAnswerRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Получить следующий диалог текущего пользователя
     * @param {UserDialogsApiApiV1DialogsPendingGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserDialogsApi
     */
    public apiV1DialogsPendingGet(requestParameters: UserDialogsApiApiV1DialogsPendingGetRequest = {}, options?: RawAxiosRequestConfig) {
        return UserDialogsApiFp(this.configuration).apiV1DialogsPendingGet(requestParameters.supportsTextInput, requestParameters.routeName, requestParameters.routeEntityId, requestParameters.appUserId, requestParameters.orderId, requestParameters.apiVersion, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * VkAssistantApi - axios parameter creator
 * @export
 */
export const VkAssistantApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Получить или сгенерировать VK ссылку для привязки аккаунта
         * @param {string} appUserId Идентификатор пользователя
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrGenerateVkLink: async (appUserId: string, apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'appUserId' is not null or undefined
            assertParamExists('getOrGenerateVkLink', 'appUserId', appUserId)
            const localVarPath = `/api/v1/vk-assistant/get-or-generate-vk-link/{appUserId}`
                .replace(`{${"appUserId"}}`, encodeURIComponent(String(appUserId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Отвязать VK от аккаунта
         * @param {string} appUserId Идентификатор пользователя
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unlinkVk: async (appUserId: string, apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'appUserId' is not null or undefined
            assertParamExists('unlinkVk', 'appUserId', appUserId)
            const localVarPath = `/api/v1/vk-assistant/unlink-vk/{appUserId}`
                .replace(`{${"appUserId"}}`, encodeURIComponent(String(appUserId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * VkAssistantApi - functional programming interface
 * @export
 */
export const VkAssistantApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = VkAssistantApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Получить или сгенерировать VK ссылку для привязки аккаунта
         * @param {string} appUserId Идентификатор пользователя
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOrGenerateVkLink(appUserId: string, apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOrGenerateVkLink(appUserId, apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VkAssistantApi.getOrGenerateVkLink']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Отвязать VK от аккаунта
         * @param {string} appUserId Идентификатор пользователя
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async unlinkVk(appUserId: string, apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.unlinkVk(appUserId, apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VkAssistantApi.unlinkVk']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * VkAssistantApi - factory interface
 * @export
 */
export const VkAssistantApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = VkAssistantApiFp(configuration)
    return {
        /**
         * 
         * @summary Получить или сгенерировать VK ссылку для привязки аккаунта
         * @param {VkAssistantApiGetOrGenerateVkLinkRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrGenerateVkLink(requestParameters: VkAssistantApiGetOrGenerateVkLinkRequest, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.getOrGenerateVkLink(requestParameters.appUserId, requestParameters.apiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Отвязать VK от аккаунта
         * @param {VkAssistantApiUnlinkVkRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unlinkVk(requestParameters: VkAssistantApiUnlinkVkRequest, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.unlinkVk(requestParameters.appUserId, requestParameters.apiVersion, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for getOrGenerateVkLink operation in VkAssistantApi.
 * @export
 * @interface VkAssistantApiGetOrGenerateVkLinkRequest
 */
export interface VkAssistantApiGetOrGenerateVkLinkRequest {
    /**
     * Идентификатор пользователя
     * @type {string}
     * @memberof VkAssistantApiGetOrGenerateVkLink
     */
    readonly appUserId: string

    /**
     * 
     * @type {string}
     * @memberof VkAssistantApiGetOrGenerateVkLink
     */
    readonly apiVersion?: string
}

/**
 * Request parameters for unlinkVk operation in VkAssistantApi.
 * @export
 * @interface VkAssistantApiUnlinkVkRequest
 */
export interface VkAssistantApiUnlinkVkRequest {
    /**
     * Идентификатор пользователя
     * @type {string}
     * @memberof VkAssistantApiUnlinkVk
     */
    readonly appUserId: string

    /**
     * 
     * @type {string}
     * @memberof VkAssistantApiUnlinkVk
     */
    readonly apiVersion?: string
}

/**
 * VkAssistantApi - object-oriented interface
 * @export
 * @class VkAssistantApi
 * @extends {BaseAPI}
 */
export class VkAssistantApi extends BaseAPI {
    /**
     * 
     * @summary Получить или сгенерировать VK ссылку для привязки аккаунта
     * @param {VkAssistantApiGetOrGenerateVkLinkRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VkAssistantApi
     */
    public getOrGenerateVkLink(requestParameters: VkAssistantApiGetOrGenerateVkLinkRequest, options?: RawAxiosRequestConfig) {
        return VkAssistantApiFp(this.configuration).getOrGenerateVkLink(requestParameters.appUserId, requestParameters.apiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Отвязать VK от аккаунта
     * @param {VkAssistantApiUnlinkVkRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VkAssistantApi
     */
    public unlinkVk(requestParameters: VkAssistantApiUnlinkVkRequest, options?: RawAxiosRequestConfig) {
        return VkAssistantApiFp(this.configuration).unlinkVk(requestParameters.appUserId, requestParameters.apiVersion, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * VkCallbackApi - axios parameter creator
 * @export
 */
export const VkCallbackApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Метод для обработки входящих сообщений от Бота VK
         * @param {string} [apiVersion] 
         * @param {VkCallbackRequest} [vkCallbackRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        callback: async (apiVersion?: string, vkCallbackRequest?: VkCallbackRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/vk/callback`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(vkCallbackRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * VkCallbackApi - functional programming interface
 * @export
 */
export const VkCallbackApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = VkCallbackApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Метод для обработки входящих сообщений от Бота VK
         * @param {string} [apiVersion] 
         * @param {VkCallbackRequest} [vkCallbackRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async callback(apiVersion?: string, vkCallbackRequest?: VkCallbackRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.callback(apiVersion, vkCallbackRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VkCallbackApi.callback']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * VkCallbackApi - factory interface
 * @export
 */
export const VkCallbackApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = VkCallbackApiFp(configuration)
    return {
        /**
         * 
         * @summary Метод для обработки входящих сообщений от Бота VK
         * @param {VkCallbackApiCallbackRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        callback(requestParameters: VkCallbackApiCallbackRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.callback(requestParameters.apiVersion, requestParameters.vkCallbackRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for callback operation in VkCallbackApi.
 * @export
 * @interface VkCallbackApiCallbackRequest
 */
export interface VkCallbackApiCallbackRequest {
    /**
     * 
     * @type {string}
     * @memberof VkCallbackApiCallback
     */
    readonly apiVersion?: string

    /**
     * 
     * @type {VkCallbackRequest}
     * @memberof VkCallbackApiCallback
     */
    readonly vkCallbackRequest?: VkCallbackRequest
}

/**
 * VkCallbackApi - object-oriented interface
 * @export
 * @class VkCallbackApi
 * @extends {BaseAPI}
 */
export class VkCallbackApi extends BaseAPI {
    /**
     * 
     * @summary Метод для обработки входящих сообщений от Бота VK
     * @param {VkCallbackApiCallbackRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VkCallbackApi
     */
    public callback(requestParameters: VkCallbackApiCallbackRequest = {}, options?: RawAxiosRequestConfig) {
        return VkCallbackApiFp(this.configuration).callback(requestParameters.apiVersion, requestParameters.vkCallbackRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * VoxServiceApi - axios parameter creator
 * @export
 */
export const VoxServiceApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Создать карточку услуги
         * @param {string} [apiVersion] 
         * @param {SaveVoxServiceRequest} [saveVoxServiceRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createVoxServiceCard: async (apiVersion?: string, saveVoxServiceRequest?: SaveVoxServiceRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/vox-services/administration`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(saveVoxServiceRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Удалить карточку услуги
         * @param {string} id 
         * @param {string} [version] 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteVoxServiceCard: async (id: string, version?: string, apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteVoxServiceCard', 'id', id)
            const localVarPath = `/api/v1/vox-services/administration/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (version !== undefined) {
                localVarQueryParameter['version'] = version;
            }


    
            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Получить каталог карточек услуг для управления
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVoxServiceCatalog: async (apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/vox-services/administration`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Получить Vox продукты, на основе PetType
         * @param {string} [apiVersion] 
         * @param {GetVoxServicesByPetTypeRequest} [getVoxServicesByPetTypeRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVoxServicesByPetType: async (apiVersion?: string, getVoxServicesByPetTypeRequest?: GetVoxServicesByPetTypeRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/vox-services/get-vox-services-by-pet-type`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(getVoxServicesByPetTypeRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Изменить карточку услуги
         * @param {string} id 
         * @param {string} [apiVersion] 
         * @param {SaveVoxServiceRequest} [saveVoxServiceRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateVoxServiceCard: async (id: string, apiVersion?: string, saveVoxServiceRequest?: SaveVoxServiceRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateVoxServiceCard', 'id', id)
            const localVarPath = `/api/v1/vox-services/administration/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(saveVoxServiceRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * VoxServiceApi - functional programming interface
 * @export
 */
export const VoxServiceApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = VoxServiceApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Создать карточку услуги
         * @param {string} [apiVersion] 
         * @param {SaveVoxServiceRequest} [saveVoxServiceRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createVoxServiceCard(apiVersion?: string, saveVoxServiceRequest?: SaveVoxServiceRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createVoxServiceCard(apiVersion, saveVoxServiceRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VoxServiceApi.createVoxServiceCard']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Удалить карточку услуги
         * @param {string} id 
         * @param {string} [version] 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteVoxServiceCard(id: string, version?: string, apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteVoxServiceCard(id, version, apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VoxServiceApi.deleteVoxServiceCard']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Получить каталог карточек услуг для управления
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getVoxServiceCatalog(apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VoxServiceCatalogResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getVoxServiceCatalog(apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VoxServiceApi.getVoxServiceCatalog']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Получить Vox продукты, на основе PetType
         * @param {string} [apiVersion] 
         * @param {GetVoxServicesByPetTypeRequest} [getVoxServicesByPetTypeRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getVoxServicesByPetType(apiVersion?: string, getVoxServicesByPetTypeRequest?: GetVoxServicesByPetTypeRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<VoxServiceResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getVoxServicesByPetType(apiVersion, getVoxServicesByPetTypeRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VoxServiceApi.getVoxServicesByPetType']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Изменить карточку услуги
         * @param {string} id 
         * @param {string} [apiVersion] 
         * @param {SaveVoxServiceRequest} [saveVoxServiceRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateVoxServiceCard(id: string, apiVersion?: string, saveVoxServiceRequest?: SaveVoxServiceRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateVoxServiceCard(id, apiVersion, saveVoxServiceRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VoxServiceApi.updateVoxServiceCard']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * VoxServiceApi - factory interface
 * @export
 */
export const VoxServiceApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = VoxServiceApiFp(configuration)
    return {
        /**
         * 
         * @summary Создать карточку услуги
         * @param {VoxServiceApiCreateVoxServiceCardRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createVoxServiceCard(requestParameters: VoxServiceApiCreateVoxServiceCardRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.createVoxServiceCard(requestParameters.apiVersion, requestParameters.saveVoxServiceRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Удалить карточку услуги
         * @param {VoxServiceApiDeleteVoxServiceCardRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteVoxServiceCard(requestParameters: VoxServiceApiDeleteVoxServiceCardRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteVoxServiceCard(requestParameters.id, requestParameters.version, requestParameters.apiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Получить каталог карточек услуг для управления
         * @param {VoxServiceApiGetVoxServiceCatalogRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVoxServiceCatalog(requestParameters: VoxServiceApiGetVoxServiceCatalogRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<VoxServiceCatalogResponse> {
            return localVarFp.getVoxServiceCatalog(requestParameters.apiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Получить Vox продукты, на основе PetType
         * @param {VoxServiceApiGetVoxServicesByPetTypeRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVoxServicesByPetType(requestParameters: VoxServiceApiGetVoxServicesByPetTypeRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<Array<VoxServiceResponse>> {
            return localVarFp.getVoxServicesByPetType(requestParameters.apiVersion, requestParameters.getVoxServicesByPetTypeRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Изменить карточку услуги
         * @param {VoxServiceApiUpdateVoxServiceCardRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateVoxServiceCard(requestParameters: VoxServiceApiUpdateVoxServiceCardRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateVoxServiceCard(requestParameters.id, requestParameters.apiVersion, requestParameters.saveVoxServiceRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for createVoxServiceCard operation in VoxServiceApi.
 * @export
 * @interface VoxServiceApiCreateVoxServiceCardRequest
 */
export interface VoxServiceApiCreateVoxServiceCardRequest {
    /**
     * 
     * @type {string}
     * @memberof VoxServiceApiCreateVoxServiceCard
     */
    readonly apiVersion?: string

    /**
     * 
     * @type {SaveVoxServiceRequest}
     * @memberof VoxServiceApiCreateVoxServiceCard
     */
    readonly saveVoxServiceRequest?: SaveVoxServiceRequest
}

/**
 * Request parameters for deleteVoxServiceCard operation in VoxServiceApi.
 * @export
 * @interface VoxServiceApiDeleteVoxServiceCardRequest
 */
export interface VoxServiceApiDeleteVoxServiceCardRequest {
    /**
     * 
     * @type {string}
     * @memberof VoxServiceApiDeleteVoxServiceCard
     */
    readonly id: string

    /**
     * 
     * @type {string}
     * @memberof VoxServiceApiDeleteVoxServiceCard
     */
    readonly version?: string

    /**
     * 
     * @type {string}
     * @memberof VoxServiceApiDeleteVoxServiceCard
     */
    readonly apiVersion?: string
}

/**
 * Request parameters for getVoxServiceCatalog operation in VoxServiceApi.
 * @export
 * @interface VoxServiceApiGetVoxServiceCatalogRequest
 */
export interface VoxServiceApiGetVoxServiceCatalogRequest {
    /**
     * 
     * @type {string}
     * @memberof VoxServiceApiGetVoxServiceCatalog
     */
    readonly apiVersion?: string
}

/**
 * Request parameters for getVoxServicesByPetType operation in VoxServiceApi.
 * @export
 * @interface VoxServiceApiGetVoxServicesByPetTypeRequest
 */
export interface VoxServiceApiGetVoxServicesByPetTypeRequest {
    /**
     * 
     * @type {string}
     * @memberof VoxServiceApiGetVoxServicesByPetType
     */
    readonly apiVersion?: string

    /**
     * 
     * @type {GetVoxServicesByPetTypeRequest}
     * @memberof VoxServiceApiGetVoxServicesByPetType
     */
    readonly getVoxServicesByPetTypeRequest?: GetVoxServicesByPetTypeRequest
}

/**
 * Request parameters for updateVoxServiceCard operation in VoxServiceApi.
 * @export
 * @interface VoxServiceApiUpdateVoxServiceCardRequest
 */
export interface VoxServiceApiUpdateVoxServiceCardRequest {
    /**
     * 
     * @type {string}
     * @memberof VoxServiceApiUpdateVoxServiceCard
     */
    readonly id: string

    /**
     * 
     * @type {string}
     * @memberof VoxServiceApiUpdateVoxServiceCard
     */
    readonly apiVersion?: string

    /**
     * 
     * @type {SaveVoxServiceRequest}
     * @memberof VoxServiceApiUpdateVoxServiceCard
     */
    readonly saveVoxServiceRequest?: SaveVoxServiceRequest
}

/**
 * VoxServiceApi - object-oriented interface
 * @export
 * @class VoxServiceApi
 * @extends {BaseAPI}
 */
export class VoxServiceApi extends BaseAPI {
    /**
     * 
     * @summary Создать карточку услуги
     * @param {VoxServiceApiCreateVoxServiceCardRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VoxServiceApi
     */
    public createVoxServiceCard(requestParameters: VoxServiceApiCreateVoxServiceCardRequest = {}, options?: RawAxiosRequestConfig) {
        return VoxServiceApiFp(this.configuration).createVoxServiceCard(requestParameters.apiVersion, requestParameters.saveVoxServiceRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Удалить карточку услуги
     * @param {VoxServiceApiDeleteVoxServiceCardRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VoxServiceApi
     */
    public deleteVoxServiceCard(requestParameters: VoxServiceApiDeleteVoxServiceCardRequest, options?: RawAxiosRequestConfig) {
        return VoxServiceApiFp(this.configuration).deleteVoxServiceCard(requestParameters.id, requestParameters.version, requestParameters.apiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Получить каталог карточек услуг для управления
     * @param {VoxServiceApiGetVoxServiceCatalogRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VoxServiceApi
     */
    public getVoxServiceCatalog(requestParameters: VoxServiceApiGetVoxServiceCatalogRequest = {}, options?: RawAxiosRequestConfig) {
        return VoxServiceApiFp(this.configuration).getVoxServiceCatalog(requestParameters.apiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Получить Vox продукты, на основе PetType
     * @param {VoxServiceApiGetVoxServicesByPetTypeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VoxServiceApi
     */
    public getVoxServicesByPetType(requestParameters: VoxServiceApiGetVoxServicesByPetTypeRequest = {}, options?: RawAxiosRequestConfig) {
        return VoxServiceApiFp(this.configuration).getVoxServicesByPetType(requestParameters.apiVersion, requestParameters.getVoxServicesByPetTypeRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Изменить карточку услуги
     * @param {VoxServiceApiUpdateVoxServiceCardRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VoxServiceApi
     */
    public updateVoxServiceCard(requestParameters: VoxServiceApiUpdateVoxServiceCardRequest, options?: RawAxiosRequestConfig) {
        return VoxServiceApiFp(this.configuration).updateVoxServiceCard(requestParameters.id, requestParameters.apiVersion, requestParameters.saveVoxServiceRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * VoxSettingsApi - axios parameter creator
 * @export
 */
export const VoxSettingsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Получить разделы настроек VOX
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVoxSettings: async (apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/vox-settings`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Изменить документ раздела настроек
         * @param {string} [apiVersion] 
         * @param {UpdateVoxSettingRequest} [updateVoxSettingRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateVoxSettings: async (apiVersion?: string, updateVoxSettingRequest?: UpdateVoxSettingRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/vox-settings`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateVoxSettingRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * VoxSettingsApi - functional programming interface
 * @export
 */
export const VoxSettingsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = VoxSettingsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Получить разделы настроек VOX
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getVoxSettings(apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<VoxSettingsResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getVoxSettings(apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VoxSettingsApi.getVoxSettings']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Изменить документ раздела настроек
         * @param {string} [apiVersion] 
         * @param {UpdateVoxSettingRequest} [updateVoxSettingRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateVoxSettings(apiVersion?: string, updateVoxSettingRequest?: UpdateVoxSettingRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VoxSettingsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateVoxSettings(apiVersion, updateVoxSettingRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VoxSettingsApi.updateVoxSettings']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * VoxSettingsApi - factory interface
 * @export
 */
export const VoxSettingsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = VoxSettingsApiFp(configuration)
    return {
        /**
         * 
         * @summary Получить разделы настроек VOX
         * @param {VoxSettingsApiGetVoxSettingsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVoxSettings(requestParameters: VoxSettingsApiGetVoxSettingsRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<Array<VoxSettingsResponse>> {
            return localVarFp.getVoxSettings(requestParameters.apiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Изменить документ раздела настроек
         * @param {VoxSettingsApiUpdateVoxSettingsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateVoxSettings(requestParameters: VoxSettingsApiUpdateVoxSettingsRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<VoxSettingsResponse> {
            return localVarFp.updateVoxSettings(requestParameters.apiVersion, requestParameters.updateVoxSettingRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for getVoxSettings operation in VoxSettingsApi.
 * @export
 * @interface VoxSettingsApiGetVoxSettingsRequest
 */
export interface VoxSettingsApiGetVoxSettingsRequest {
    /**
     * 
     * @type {string}
     * @memberof VoxSettingsApiGetVoxSettings
     */
    readonly apiVersion?: string
}

/**
 * Request parameters for updateVoxSettings operation in VoxSettingsApi.
 * @export
 * @interface VoxSettingsApiUpdateVoxSettingsRequest
 */
export interface VoxSettingsApiUpdateVoxSettingsRequest {
    /**
     * 
     * @type {string}
     * @memberof VoxSettingsApiUpdateVoxSettings
     */
    readonly apiVersion?: string

    /**
     * 
     * @type {UpdateVoxSettingRequest}
     * @memberof VoxSettingsApiUpdateVoxSettings
     */
    readonly updateVoxSettingRequest?: UpdateVoxSettingRequest
}

/**
 * VoxSettingsApi - object-oriented interface
 * @export
 * @class VoxSettingsApi
 * @extends {BaseAPI}
 */
export class VoxSettingsApi extends BaseAPI {
    /**
     * 
     * @summary Получить разделы настроек VOX
     * @param {VoxSettingsApiGetVoxSettingsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VoxSettingsApi
     */
    public getVoxSettings(requestParameters: VoxSettingsApiGetVoxSettingsRequest = {}, options?: RawAxiosRequestConfig) {
        return VoxSettingsApiFp(this.configuration).getVoxSettings(requestParameters.apiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Изменить документ раздела настроек
     * @param {VoxSettingsApiUpdateVoxSettingsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VoxSettingsApi
     */
    public updateVoxSettings(requestParameters: VoxSettingsApiUpdateVoxSettingsRequest = {}, options?: RawAxiosRequestConfig) {
        return VoxSettingsApiFp(this.configuration).updateVoxSettings(requestParameters.apiVersion, requestParameters.updateVoxSettingRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * VoxVersionApi - axios parameter creator
 * @export
 */
export const VoxVersionApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Проверить актуальность версии мобильного приложения
         * @param {string} [apiVersion] 
         * @param {VersionCheckRequest} [versionCheckRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VoxVersionApiVersionCheckPost: async (apiVersion?: string, versionCheckRequest?: VersionCheckRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/vox-version/api/version/check`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            if (apiVersion != null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(versionCheckRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * VoxVersionApi - functional programming interface
 * @export
 */
export const VoxVersionApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = VoxVersionApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Проверить актуальность версии мобильного приложения
         * @param {string} [apiVersion] 
         * @param {VersionCheckRequest} [versionCheckRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1VoxVersionApiVersionCheckPost(apiVersion?: string, versionCheckRequest?: VersionCheckRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VersionCheckResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1VoxVersionApiVersionCheckPost(apiVersion, versionCheckRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VoxVersionApi.apiV1VoxVersionApiVersionCheckPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * VoxVersionApi - factory interface
 * @export
 */
export const VoxVersionApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = VoxVersionApiFp(configuration)
    return {
        /**
         * 
         * @summary Проверить актуальность версии мобильного приложения
         * @param {VoxVersionApiApiV1VoxVersionApiVersionCheckPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VoxVersionApiVersionCheckPost(requestParameters: VoxVersionApiApiV1VoxVersionApiVersionCheckPostRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<VersionCheckResponse> {
            return localVarFp.apiV1VoxVersionApiVersionCheckPost(requestParameters.apiVersion, requestParameters.versionCheckRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for apiV1VoxVersionApiVersionCheckPost operation in VoxVersionApi.
 * @export
 * @interface VoxVersionApiApiV1VoxVersionApiVersionCheckPostRequest
 */
export interface VoxVersionApiApiV1VoxVersionApiVersionCheckPostRequest {
    /**
     * 
     * @type {string}
     * @memberof VoxVersionApiApiV1VoxVersionApiVersionCheckPost
     */
    readonly apiVersion?: string

    /**
     * 
     * @type {VersionCheckRequest}
     * @memberof VoxVersionApiApiV1VoxVersionApiVersionCheckPost
     */
    readonly versionCheckRequest?: VersionCheckRequest
}

/**
 * VoxVersionApi - object-oriented interface
 * @export
 * @class VoxVersionApi
 * @extends {BaseAPI}
 */
export class VoxVersionApi extends BaseAPI {
    /**
     * 
     * @summary Проверить актуальность версии мобильного приложения
     * @param {VoxVersionApiApiV1VoxVersionApiVersionCheckPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VoxVersionApi
     */
    public apiV1VoxVersionApiVersionCheckPost(requestParameters: VoxVersionApiApiV1VoxVersionApiVersionCheckPostRequest = {}, options?: RawAxiosRequestConfig) {
        return VoxVersionApiFp(this.configuration).apiV1VoxVersionApiVersionCheckPost(requestParameters.apiVersion, requestParameters.versionCheckRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



